/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.12.7.0 (NJsonSchema v9.10.6.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsTenantAvailable(response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>Observable.throw(response_);
        });
    }

    protected processIsTenantAvailable(response: Response): Observable<IsTenantAvailableOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    register(input: RegisterInput): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegister(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegister(response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegister(response: Response): Observable<RegisterOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendPasswordResetCode(input: SendPasswordResetCodeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendPasswordResetCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendPasswordResetCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordInput): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetPassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetPassword(response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>Observable.throw(response_);
        });
    }

    protected processResetPassword(response: Response): Observable<ResetPasswordOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetPasswordOutput.fromJS(resultData200) : new ResetPasswordOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResetPasswordOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailActivationLink(input: SendEmailActivationLinkInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailActivationLink(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailActivationLink(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activateEmail(input: ActivateEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processActivateEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processActivateEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivateEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    impersonate(input: ImpersonateInput): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImpersonate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImpersonate(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processImpersonate(response: Response): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBackToImpersonator(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processBackToImpersonator(response: Response): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    switchToLinkedAccount(input: SwitchToLinkedAccountInput): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSwitchToLinkedAccount(response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(response_);
        });
    }

    protected processSwitchToLinkedAccount(response: Response): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SwitchToLinkedAccountOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ApplicaionNotificationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    notifySubscriberForSaleTransctionsInvoice(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicaionNotification/NotifySubscriberForSaleTransctionsInvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processNotifySubscriberForSaleTransctionsInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processNotifySubscriberForSaleTransctionsInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processNotifySubscriberForSaleTransctionsInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ApplicaionNotification/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ApprovalWorkflowsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfApprovalWorkflowListItem> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfApprovalWorkflowListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfApprovalWorkflowListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfApprovalWorkflowListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfApprovalWorkflowListItem.fromJS(resultData200) : new ListResultDtoOfApprovalWorkflowListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfApprovalWorkflowListItem>(<any>null);
    }

    /**
     * @transactionType (optional) 
     * @return Success
     */
    getForEdit(transactionType: TransactionType2): Observable<ApprovalWorkflowDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/GetForEdit?";
        if (transactionType !== undefined)
            url_ += "transactionType=" + encodeURIComponent("" + transactionType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetForEdit(response_);
                } catch (e) {
                    return <Observable<ApprovalWorkflowDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ApprovalWorkflowDto>><any>Observable.throw(response_);
        });
    }

    protected processGetForEdit(response: Response): Observable<ApprovalWorkflowDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ApprovalWorkflowDto.fromJS(resultData200) : new ApprovalWorkflowDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ApprovalWorkflowDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesForLookup(): Observable<ListResultDtoOfApprovalWorkflowRoleLookupDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/GetRolesForLookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesForLookup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesForLookup(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfApprovalWorkflowRoleLookupDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfApprovalWorkflowRoleLookupDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesForLookup(response: Response): Observable<ListResultDtoOfApprovalWorkflowRoleLookupDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfApprovalWorkflowRoleLookupDto.fromJS(resultData200) : new ListResultDtoOfApprovalWorkflowRoleLookupDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfApprovalWorkflowRoleLookupDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLanguagesForLookup(): Observable<ApprovalWorkflowLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/GetLanguagesForLookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguagesForLookup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguagesForLookup(response_);
                } catch (e) {
                    return <Observable<ApprovalWorkflowLanguagesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ApprovalWorkflowLanguagesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguagesForLookup(response: Response): Observable<ApprovalWorkflowLanguagesOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ApprovalWorkflowLanguagesOutput.fromJS(resultData200) : new ApprovalWorkflowLanguagesOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ApprovalWorkflowLanguagesOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    save(input: SaveApprovalWorkflowInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSave(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSave(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processSave(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @id (optional) 
     * @isEnable (optional) 
     * @return Success
     */
    setIsEnable(id: number, isEnable: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/SetIsEnable?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isEnable !== undefined)
            url_ += "isEnable=" + encodeURIComponent("" + isEnable) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetIsEnable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetIsEnable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetIsEnable(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalWorkflows/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class AreaServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedAreas(pageNumber: number, pageSize: number, searchKey: string, descending: boolean): Observable<PagedAreaList> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetPagedAreas?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedAreas(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedAreas(response_);
                } catch (e) {
                    return <Observable<PagedAreaList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedAreaList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedAreas(response: Response): Observable<PagedAreaList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedAreaList.fromJS(resultData200) : new PagedAreaList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedAreaList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateAreaInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Area/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateAreaInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Area/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @areaId (optional) 
     * @return Success
     */
    delete(areaId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Area/Delete?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @areaId (optional) 
     * @return Success
     */
    get(areaId: number): Observable<AreaDto> {
        let url_ = this.baseUrl + "/api/services/app/Area/Get?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<AreaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AreaDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<AreaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AreaDto.fromJS(resultData200) : new AreaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AreaDto>(<any>null);
    }

    /**
     * @regionId (optional) 
     * @return Success
     */
    getAreasByRegion(regionId: number): Observable<ListResultDtoOfAreaListItem> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAreasByRegion?";
        if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAreasByRegion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAreasByRegion(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAreasByRegion(response: Response): Observable<ListResultDtoOfAreaListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAreaListItem.fromJS(resultData200) : new ListResultDtoOfAreaListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAreaListItem>(<any>null);
    }

    /**
     * @storeGroupId (optional) 
     * @return Success
     */
    getAreasByStoreGroupId(storeGroupId: number): Observable<ListResultDtoOfAreaListItem> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAreasByStoreGroupId?";
        if (storeGroupId !== undefined)
            url_ += "storeGroupId=" + encodeURIComponent("" + storeGroupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAreasByStoreGroupId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAreasByStoreGroupId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAreasByStoreGroupId(response: Response): Observable<ListResultDtoOfAreaListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAreaListItem.fromJS(resultData200) : new ListResultDtoOfAreaListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAreaListItem>(<any>null);
    }

    /**
     * @storeGroupIds (optional) 
     * @return Success
     */
    getAreasByStoreGroupIds(storeGroupIds: number[]): Observable<ListResultDtoOfAreaListItem> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAreasByStoreGroupIds?";
        if (storeGroupIds !== undefined)
            storeGroupIds && storeGroupIds.forEach(item => { url_ += "storeGroupIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAreasByStoreGroupIds(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAreasByStoreGroupIds(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAreasByStoreGroupIds(response: Response): Observable<ListResultDtoOfAreaListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAreaListItem.fromJS(resultData200) : new ListResultDtoOfAreaListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAreaListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getAreas(): Observable<ListResultDtoOfAreaListItem> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAreas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAreas(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAreas(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAreaListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAreas(response: Response): Observable<ListResultDtoOfAreaListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAreaListItem.fromJS(resultData200) : new ListResultDtoOfAreaListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAreaListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class AttributesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAttribute(id: number): Observable<AttributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAttribute?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAttribute(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAttribute(response_);
                } catch (e) {
                    return <Observable<AttributeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AttributeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAttribute(response: Response): Observable<AttributeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AttributeDto.fromJS(resultData200) : new AttributeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AttributeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAttributes(): Observable<ListResultDtoOfAttributeListItem> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAttributes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAttributes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAttributes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAttributeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAttributeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAttributes(response: Response): Observable<ListResultDtoOfAttributeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAttributeListItem.fromJS(resultData200) : new ListResultDtoOfAttributeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAttributeListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createAttribute(input: CreateAttributeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/CreateAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateAttribute(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateAttribute(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateAttribute(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAttribute(input: UpdateAttributeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/UpdateAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAttribute(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAttribute(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAttribute(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteAttribute(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/DeleteAttribute?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAttribute(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAttribute(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAttribute(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment, endDate: moment.Moment, userName: string, serviceName: string, methodName: string, browserInfo: string, hasException: boolean, minExecutionDuration: number, maxExecutionDuration: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAuditLogs(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogs(response: Response): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAuditLogListDto.fromJS(resultData200) : new PagedResultDtoOfAuditLogListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment, endDate: moment.Moment, userName: string, serviceName: string, methodName: string, browserInfo: string, hasException: boolean, minExecutionDuration: number, maxExecutionDuration: number, sorting: string, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAuditLogsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    exportAuditLogsToExcel(startDate: moment.Moment, endDate: moment.Moment, userName: string, serviceName: string, methodName: string, browserInfo: string, hasException: boolean, minExecutionDuration: number, maxExecutionDuration: number, sorting: string, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/ExportAuditLogsToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportAuditLogsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportAuditLogsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportAuditLogsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class BatchRecipeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getBatchRecipe(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/GetBatchRecipe?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBatchRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBatchRecipe(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBatchRecipe(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBatchRecipes(): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/GetBatchRecipes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBatchRecipes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBatchRecipes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetBatchRecipes(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/GetCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateBatchRecipeInEditMode(input: UpdateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/UpdateBatchRecipeInEditMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateBatchRecipeInEditMode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateBatchRecipeInEditMode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateBatchRecipeInEditMode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateBatchRecipe(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/UpdateBatchRecipe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateBatchRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateBatchRecipe(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateBatchRecipe(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createBatchRecipe(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/CreateBatchRecipe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateBatchRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateBatchRecipe(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateBatchRecipe(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @rawMaterialId (optional) 
     * @return Success
     */
    getExpectedQuantity(storeId: number, rawMaterialId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/GetExpectedQuantity?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExpectedQuantity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExpectedQuantity(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetExpectedQuantity(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteBatchRecipe(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/DeleteBatchRecipe?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteBatchRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteBatchRecipe(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteBatchRecipe(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedBatchRecipe(pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/GetPagedBatchRecipe?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedBatchRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedBatchRecipe(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedBatchRecipe(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @id (optional) 
     * @quantity (optional) 
     * @return Success
     */
    updateQtyRawMatrial(id: number, quantity: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/UpdateQtyRawMatrial?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateQtyRawMatrial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateQtyRawMatrial(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateQtyRawMatrial(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BatchRecipe/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class BusinessCentralServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateBusinessCentralSettingInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    saleListData(input: SalesReportInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/SaleListData?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleListData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleListData(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleListData(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    refundSaleListData(input: SalesReportInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/RefundSaleListData?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRefundSaleListData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRefundSaleListData(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processRefundSaleListData(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    get(): Observable<BusinessCentralAuthDTO> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<BusinessCentralAuthDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<BusinessCentralAuthDTO>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<BusinessCentralAuthDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BusinessCentralAuthDTO.fromJS(resultData200) : new BusinessCentralAuthDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BusinessCentralAuthDTO>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: EditBusinessCentralInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadSales(input: SalesReportInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/UploadSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadSales(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadSales(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadSalesWithEndOfDay(input: SalesReportInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/UploadSalesWithEndOfDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadSalesWithEndOfDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadSalesWithEndOfDay(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadSalesWithEndOfDay(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storIds (optional) 
     * @regionId (optional) 
     * @saleTypesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @return Success
     */
    getStoresSummary(storIds: number[], regionId: number, saleTypesIds: number[], fromDate: moment.Moment, toDate: moment.Moment): Observable<ValueTupleOfInt32AndInt32> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/GetStoresSummary?";
        if (storIds !== undefined)
            storIds && storIds.forEach(item => { url_ += "StorIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (saleTypesIds !== undefined)
            saleTypesIds && saleTypesIds.forEach(item => { url_ += "SaleTypesIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresSummary(response_);
                } catch (e) {
                    return <Observable<ValueTupleOfInt32AndInt32>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValueTupleOfInt32AndInt32>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresSummary(response: Response): Observable<ValueTupleOfInt32AndInt32> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValueTupleOfInt32AndInt32.fromJS(resultData200) : new ValueTupleOfInt32AndInt32();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValueTupleOfInt32AndInt32>(<any>null);
    }

    /**
     * @return Success
     */
    checkCurrentTenantHasCustomBuisnessCenteralconfig(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/CheckCurrentTenantHasCustomBuisnessCenteralconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckCurrentTenantHasCustomBuisnessCenteralconfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckCurrentTenantHasCustomBuisnessCenteralconfig(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckCurrentTenantHasCustomBuisnessCenteralconfig(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BusinessCentral/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCaches(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCaches(response: Response): Observable<ListResultDtoOfCacheDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCacheDto.fromJS(resultData200) : new ListResultDtoOfCacheDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    clearCache(input: EntityDtoOfString): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCache(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearAllCaches(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearAllCaches(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CashierShiftsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    startMyShift(storeId: number): Observable<CashierShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/StartMyShift?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartMyShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartMyShift(response_);
                } catch (e) {
                    return <Observable<CashierShiftDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftDto>><any>Observable.throw(response_);
        });
    }

    protected processStartMyShift(response: Response): Observable<CashierShiftDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftDto.fromJS(resultData200) : new CashierShiftDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @loginTime (optional) 
     * @return Success
     */
    startShiftRetailWithEndOfDay(storeId: number, loginTime: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/StartShiftRetailWithEndOfDay?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (loginTime !== undefined)
            url_ += "loginTime=" + encodeURIComponent(loginTime ? "" + loginTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartShiftRetailWithEndOfDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartShiftRetailWithEndOfDay(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processStartShiftRetailWithEndOfDay(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @return Success
     */
    startShift(storeId: number, userId: number): Observable<CashierShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/StartShift?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartShift(response_);
                } catch (e) {
                    return <Observable<CashierShiftDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftDto>><any>Observable.throw(response_);
        });
    }

    protected processStartShift(response: Response): Observable<CashierShiftDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftDto.fromJS(resultData200) : new CashierShiftDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @dateTime (optional) 
     * @return Success
     */
    newStartMyShift(storeId: number, dateTime: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/NewStartMyShift?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processNewStartMyShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processNewStartMyShift(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processNewStartMyShift(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @dateTime (optional) 
     * @return Success
     */
    newStartShiftWithEndOfDay(storeId: number, dateTime: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/NewStartShiftWithEndOfDay?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processNewStartShiftWithEndOfDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processNewStartShiftWithEndOfDay(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processNewStartShiftWithEndOfDay(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @dateTimeLogin (optional) 
     * @return Success
     */
    startShiftFB(storeId: number, userId: number, dateTimeLogin: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/StartShiftFB?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (dateTimeLogin !== undefined)
            url_ += "dateTimeLogin=" + encodeURIComponent(dateTimeLogin ? "" + dateTimeLogin.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartShiftFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartShiftFB(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processStartShiftFB(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @dateTimeLogin (optional) 
     * @return Success
     */
    startShiftOnly(storeId: number, userId: number, dateTimeLogin: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/StartShiftOnly?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (dateTimeLogin !== undefined)
            url_ += "dateTimeLogin=" + encodeURIComponent(dateTimeLogin ? "" + dateTimeLogin.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartShiftOnly(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartShiftOnly(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processStartShiftOnly(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @dateTime (optional) 
     * @return Success
     */
    endOfMyDay(storeId: number, dateTime: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/EndOfMyDay?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEndOfMyDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEndOfMyDay(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processEndOfMyDay(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @dateNowLogin (optional) 
     * @currentUserId (optional) 
     * @supervisorShiftId (optional) 
     * @storeId (optional) 
     * @endOfDayId (optional) 
     * @endOfDayStartOfDayDate (optional) 
     * @endOfDayEndOfDayDate (optional) 
     * @endOfDayDate (optional) 
     * @return Success
     */
    createCashierShift(dateNowLogin: moment.Moment, currentUserId: number, supervisorShiftId: number, storeId: number, endOfDayId: number, endOfDayStartOfDayDate: moment.Moment, endOfDayEndOfDayDate: moment.Moment, endOfDayDate: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/CreateCashierShift?";
        if (dateNowLogin !== undefined)
            url_ += "dateNowLogin=" + encodeURIComponent(dateNowLogin ? "" + dateNowLogin.toJSON() : "") + "&"; 
        if (currentUserId !== undefined)
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&"; 
        if (supervisorShiftId !== undefined)
            url_ += "supervisorShiftId=" + encodeURIComponent("" + supervisorShiftId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (endOfDayId !== undefined)
            url_ += "endOfDayId=" + encodeURIComponent("" + endOfDayId) + "&"; 
        if (endOfDayStartOfDayDate !== undefined)
            url_ += "endOfDayStartOfDayDate=" + encodeURIComponent(endOfDayStartOfDayDate ? "" + endOfDayStartOfDayDate.toJSON() : "") + "&"; 
        if (endOfDayEndOfDayDate !== undefined)
            url_ += "endOfDayEndOfDayDate=" + encodeURIComponent(endOfDayEndOfDayDate ? "" + endOfDayEndOfDayDate.toJSON() : "") + "&"; 
        if (endOfDayDate !== undefined)
            url_ += "endOfDayDate=" + encodeURIComponent(endOfDayDate ? "" + endOfDayDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateCashierShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateCashierShift(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateCashierShift(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @startDay (optional) 
     * @end_DateTime_Day (optional) 
     * @dateNowLogin (optional) 
     * @isvalidShiftcashierWorkingHour (optional) 
     * @currentUserId (optional) 
     * @supervisorShiftId (optional) 
     * @storeId (optional) 
     * @endOfDayId (optional) 
     * @endOfDayStartOfDayDate (optional) 
     * @endOfDayEndOfDayDate (optional) 
     * @endOfDayDate (optional) 
     * @shift_OpenStore_Related_PrevId (optional) 
     * @return Success
     */
    validateExistOpenDay_ValidateExistCashier(startDay: moment.Moment, end_DateTime_Day: moment.Moment, dateNowLogin: moment.Moment, isvalidShiftcashierWorkingHour: boolean, currentUserId: number, supervisorShiftId: number, storeId: number, endOfDayId: number, endOfDayStartOfDayDate: moment.Moment, endOfDayEndOfDayDate: moment.Moment, endOfDayDate: moment.Moment, shift_OpenStore_Related_PrevId: number): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/ValidateExistOpenDay_ValidateExistCashier?";
        if (startDay !== undefined)
            url_ += "startDay=" + encodeURIComponent(startDay ? "" + startDay.toJSON() : "") + "&"; 
        if (end_DateTime_Day !== undefined)
            url_ += "end_DateTime_Day=" + encodeURIComponent(end_DateTime_Day ? "" + end_DateTime_Day.toJSON() : "") + "&"; 
        if (dateNowLogin !== undefined)
            url_ += "DateNowLogin=" + encodeURIComponent(dateNowLogin ? "" + dateNowLogin.toJSON() : "") + "&"; 
        if (isvalidShiftcashierWorkingHour !== undefined)
            url_ += "IsvalidShiftcashierWorkingHour=" + encodeURIComponent("" + isvalidShiftcashierWorkingHour) + "&"; 
        if (currentUserId !== undefined)
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&"; 
        if (supervisorShiftId !== undefined)
            url_ += "supervisorShiftId=" + encodeURIComponent("" + supervisorShiftId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (endOfDayId !== undefined)
            url_ += "endOfDayId=" + encodeURIComponent("" + endOfDayId) + "&"; 
        if (endOfDayStartOfDayDate !== undefined)
            url_ += "endOfDayStartOfDayDate=" + encodeURIComponent(endOfDayStartOfDayDate ? "" + endOfDayStartOfDayDate.toJSON() : "") + "&"; 
        if (endOfDayEndOfDayDate !== undefined)
            url_ += "endOfDayEndOfDayDate=" + encodeURIComponent(endOfDayEndOfDayDate ? "" + endOfDayEndOfDayDate.toJSON() : "") + "&"; 
        if (endOfDayDate !== undefined)
            url_ += "endOfDayDate=" + encodeURIComponent(endOfDayDate ? "" + endOfDayDate.toJSON() : "") + "&"; 
        if (shift_OpenStore_Related_PrevId !== undefined)
            url_ += "shift_OpenStore_Related_PrevId=" + encodeURIComponent("" + shift_OpenStore_Related_PrevId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processValidateExistOpenDay_ValidateExistCashier(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processValidateExistOpenDay_ValidateExistCashier(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processValidateExistOpenDay_ValidateExistCashier(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @startDay (optional) 
     * @end_DateTime_Day (optional) 
     * @dateNowLogin (optional) 
     * @isvalidShiftcashierWorkingHour (optional) 
     * @currentUserId (optional) 
     * @supervisorShiftId (optional) 
     * @storeId (optional) 
     * @endOfDayId (optional) 
     * @endOfDayStartOfDayDate (optional) 
     * @endOfDayEndOfDayDate (optional) 
     * @endOfDayDate (optional) 
     * @shift_OpenStore_Related_PrevId (optional) 
     * @isValidOpenDay (optional) 
     * @startOfDayTiming (optional) 
     * @endOfDayTiming (optional) 
     * @startDateWork_Day (optional) 
     * @return Success
     */
    createOpenDayandCashier(startDay: moment.Moment, end_DateTime_Day: moment.Moment, dateNowLogin: moment.Moment, isvalidShiftcashierWorkingHour: boolean, currentUserId: number, supervisorShiftId: number, storeId: number, endOfDayId: number, endOfDayStartOfDayDate: moment.Moment, endOfDayEndOfDayDate: moment.Moment, endOfDayDate: moment.Moment, shift_OpenStore_Related_PrevId: number, isValidOpenDay: boolean, startOfDayTiming: string, endOfDayTiming: string, startDateWork_Day: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/CreateOpenDayandCashier?";
        if (startDay !== undefined)
            url_ += "startDay=" + encodeURIComponent(startDay ? "" + startDay.toJSON() : "") + "&"; 
        if (end_DateTime_Day !== undefined)
            url_ += "end_DateTime_Day=" + encodeURIComponent(end_DateTime_Day ? "" + end_DateTime_Day.toJSON() : "") + "&"; 
        if (dateNowLogin !== undefined)
            url_ += "DateNowLogin=" + encodeURIComponent(dateNowLogin ? "" + dateNowLogin.toJSON() : "") + "&"; 
        if (isvalidShiftcashierWorkingHour !== undefined)
            url_ += "IsvalidShiftcashierWorkingHour=" + encodeURIComponent("" + isvalidShiftcashierWorkingHour) + "&"; 
        if (currentUserId !== undefined)
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&"; 
        if (supervisorShiftId !== undefined)
            url_ += "supervisorShiftId=" + encodeURIComponent("" + supervisorShiftId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (endOfDayId !== undefined)
            url_ += "endOfDayId=" + encodeURIComponent("" + endOfDayId) + "&"; 
        if (endOfDayStartOfDayDate !== undefined)
            url_ += "endOfDayStartOfDayDate=" + encodeURIComponent(endOfDayStartOfDayDate ? "" + endOfDayStartOfDayDate.toJSON() : "") + "&"; 
        if (endOfDayEndOfDayDate !== undefined)
            url_ += "endOfDayEndOfDayDate=" + encodeURIComponent(endOfDayEndOfDayDate ? "" + endOfDayEndOfDayDate.toJSON() : "") + "&"; 
        if (endOfDayDate !== undefined)
            url_ += "endOfDayDate=" + encodeURIComponent(endOfDayDate ? "" + endOfDayDate.toJSON() : "") + "&"; 
        if (shift_OpenStore_Related_PrevId !== undefined)
            url_ += "shift_OpenStore_Related_PrevId=" + encodeURIComponent("" + shift_OpenStore_Related_PrevId) + "&"; 
        if (isValidOpenDay !== undefined)
            url_ += "IsValidOpenDay=" + encodeURIComponent("" + isValidOpenDay) + "&"; 
        if (startOfDayTiming !== undefined)
            url_ += "StartOfDayTiming=" + encodeURIComponent("" + startOfDayTiming) + "&"; 
        if (endOfDayTiming !== undefined)
            url_ += "EndOfDayTiming=" + encodeURIComponent("" + endOfDayTiming) + "&"; 
        if (startDateWork_Day !== undefined)
            url_ += "startDateWork_Day=" + encodeURIComponent(startDateWork_Day ? "" + startDateWork_Day.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOpenDayandCashier(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOpenDayandCashier(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOpenDayandCashier(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @cashierShiftId (optional) 
     * @startDay (optional) 
     * @end_DateTime_Day (optional) 
     * @dateNowLogin (optional) 
     * @storeId (optional) 
     * @startOfDayTiming (optional) 
     * @endOfDayTiming (optional) 
     * @startDateWork_Day (optional) 
     * @return Success
     */
    createOpenDay(cashierShiftId: number, startDay: moment.Moment, end_DateTime_Day: moment.Moment, dateNowLogin: moment.Moment, storeId: number, startOfDayTiming: string, endOfDayTiming: string, startDateWork_Day: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/CreateOpenDay?";
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (startDay !== undefined)
            url_ += "startDay=" + encodeURIComponent(startDay ? "" + startDay.toJSON() : "") + "&"; 
        if (end_DateTime_Day !== undefined)
            url_ += "end_DateTime_Day=" + encodeURIComponent(end_DateTime_Day ? "" + end_DateTime_Day.toJSON() : "") + "&"; 
        if (dateNowLogin !== undefined)
            url_ += "DateNowLogin=" + encodeURIComponent(dateNowLogin ? "" + dateNowLogin.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (startOfDayTiming !== undefined)
            url_ += "StartOfDayTiming=" + encodeURIComponent("" + startOfDayTiming) + "&"; 
        if (endOfDayTiming !== undefined)
            url_ += "EndOfDayTiming=" + encodeURIComponent("" + endOfDayTiming) + "&"; 
        if (startDateWork_Day !== undefined)
            url_ += "startDateWork_Day=" + encodeURIComponent(startDateWork_Day ? "" + startDateWork_Day.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOpenDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOpenDay(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOpenDay(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @startDateWork (optional) 
     * @dateTime (optional) 
     * @timingStartShift (optional) 
     * @timingEndShift (optional) 
     * @return Success
     */
    checkShiftValidityForShift(startDateWork: moment.Moment, dateTime: moment.Moment, timingStartShift: string, timingEndShift: string): Observable<ValueTupleOfBooleanAndDateTimeAndDateTime> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/CheckShiftValidityForShift?";
        if (startDateWork !== undefined)
            url_ += "startDateWork=" + encodeURIComponent(startDateWork ? "" + startDateWork.toJSON() : "") + "&"; 
        if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&"; 
        if (timingStartShift !== undefined)
            url_ += "timingStartShift=" + encodeURIComponent("" + timingStartShift) + "&"; 
        if (timingEndShift !== undefined)
            url_ += "timingEndShift=" + encodeURIComponent("" + timingEndShift) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckShiftValidityForShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckShiftValidityForShift(response_);
                } catch (e) {
                    return <Observable<ValueTupleOfBooleanAndDateTimeAndDateTime>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValueTupleOfBooleanAndDateTimeAndDateTime>><any>Observable.throw(response_);
        });
    }

    protected processCheckShiftValidityForShift(response: Response): Observable<ValueTupleOfBooleanAndDateTimeAndDateTime> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValueTupleOfBooleanAndDateTimeAndDateTime.fromJS(resultData200) : new ValueTupleOfBooleanAndDateTimeAndDateTime();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValueTupleOfBooleanAndDateTimeAndDateTime>(<any>null);
    }

    /**
     * @startDateWork (optional) 
     * @dateTime (optional) 
     * @startOfDay (optional) 
     * @endOfDay (optional) 
     * @return Success
     */
    checkValidityForDay(startDateWork: moment.Moment, dateTime: moment.Moment, startOfDay: string, endOfDay: string): Observable<ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/CheckValidityForDay?";
        if (startDateWork !== undefined)
            url_ += "startDateWork=" + encodeURIComponent(startDateWork ? "" + startDateWork.toJSON() : "") + "&"; 
        if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&"; 
        if (startOfDay !== undefined)
            url_ += "startOfDay=" + encodeURIComponent("" + startOfDay) + "&"; 
        if (endOfDay !== undefined)
            url_ += "endOfDay=" + encodeURIComponent("" + endOfDay) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckValidityForDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckValidityForDay(response_);
                } catch (e) {
                    return <Observable<ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime>><any>Observable.throw(response_);
        });
    }

    protected processCheckValidityForDay(response: Response): Observable<ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime.fromJS(resultData200) : new ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime>(<any>null);
    }

    /**
     * @dateNowLogin (optional) 
     * @startTime (optional) 
     * @endTime (optional) 
     * @return Success
     */
    getToday(dateNowLogin: moment.Moment, startTime: string, endTime: string): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetToday?";
        if (dateNowLogin !== undefined)
            url_ += "DateNowLogin=" + encodeURIComponent(dateNowLogin ? "" + dateNowLogin.toJSON() : "") + "&"; 
        if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent("" + startTime) + "&"; 
        if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent("" + endTime) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetToday(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetToday(response_);
                } catch (e) {
                    return <Observable<moment.Moment>><any>Observable.throw(e);
                }
            } else
                return <Observable<moment.Moment>><any>Observable.throw(response_);
        });
    }

    protected processGetToday(response: Response): Observable<moment.Moment> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<moment.Moment>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @dateTime (optional) 
     * @return Success
     */
    endOfDay(storeId: number, userId: number, dateTime: moment.Moment): Observable<EndOfDayDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/EndOfDay?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEndOfDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEndOfDay(response_);
                } catch (e) {
                    return <Observable<EndOfDayDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayDto>><any>Observable.throw(response_);
        });
    }

    protected processEndOfDay(response: Response): Observable<EndOfDayDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayDto.fromJS(resultData200) : new EndOfDayDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayDto>(<any>null);
    }

    /**
     * @shiftId (optional) 
     * @return Success
     */
    xReport(shiftId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/XReport?";
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processXReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processXReport(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processXReport(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @shiftId (optional) 
     * @return Success
     */
    xReportMobile(shiftId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/XReportMobile?";
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processXReportMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processXReportMobile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processXReportMobile(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getOpenedCashierShift(storeId: number): Observable<CashierShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetOpenedCashierShift?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOpenedCashierShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOpenedCashierShift(response_);
                } catch (e) {
                    return <Observable<CashierShiftDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOpenedCashierShift(response: Response): Observable<CashierShiftDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftDto.fromJS(resultData200) : new CashierShiftDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getCashierShift(storeId: number): Observable<CashierShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetCashierShift?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCashierShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCashierShift(response_);
                } catch (e) {
                    return <Observable<CashierShiftDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCashierShift(response: Response): Observable<CashierShiftDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftDto.fromJS(resultData200) : new CashierShiftDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftDto>(<any>null);
    }

    /**
     * @shiftId (optional) 
     * @actualTransactionsValues (optional) 
     * @return Success
     */
    closeShift(shiftId: number, actualTransactionsValues: CasheirPaymentTransactionsValuesDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/CloseShift?";
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actualTransactionsValues);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloseShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloseShift(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloseShift(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @shiftId (optional) 
     * @storeId (optional) 
     * @actualTransactionsValues (optional) 
     * @return Success
     */
    closeShiftByStoreId(shiftId: number, storeId: number, actualTransactionsValues: CasheirPaymentTransactionsValuesDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/CloseShiftByStoreId?";
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actualTransactionsValues);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloseShiftByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloseShiftByStoreId(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloseShiftByStoreId(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getOpenedCahierShifts(storeId: number): Observable<ListResultDtoOfCashierShiftListItem> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetOpenedCahierShifts?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOpenedCahierShifts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOpenedCahierShifts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCashierShiftListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCashierShiftListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetOpenedCahierShifts(response: Response): Observable<ListResultDtoOfCashierShiftListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCashierShiftListItem.fromJS(resultData200) : new ListResultDtoOfCashierShiftListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCashierShiftListItem>(<any>null);
    }

    /**
     * @shiftId (optional) 
     * @return Success
     */
    getShift(shiftId: number): Observable<CashierShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetShift?";
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetShift(response_);
                } catch (e) {
                    return <Observable<CashierShiftDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftDto>><any>Observable.throw(response_);
        });
    }

    protected processGetShift(response: Response): Observable<CashierShiftDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftDto.fromJS(resultData200) : new CashierShiftDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getAllCasheirsByTenantId(tenantId: number): Observable<CashierDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetAllCasheirsByTenantId?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCasheirsByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCasheirsByTenantId(response_);
                } catch (e) {
                    return <Observable<CashierDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCasheirsByTenantId(response: Response): Observable<CashierDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CashierDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCasheirs(): Observable<CashierDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetAllCasheirs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCasheirs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCasheirs(response_);
                } catch (e) {
                    return <Observable<CashierDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCasheirs(response: Response): Observable<CashierDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CashierDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSalesMan(): Observable<SalesManDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetAllSalesMan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSalesMan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSalesMan(response_);
                } catch (e) {
                    return <Observable<SalesManDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesManDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSalesMan(response: Response): Observable<SalesManDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SalesManDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesManDto[]>(<any>null);
    }

    /**
     * @userId (optional) 
     * @return Success
     */
    getCasheirsById(userId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetCasheirsById?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCasheirsById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCasheirsById(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCasheirsById(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @cashierShiftSyncDto (optional) 
     * @return Success
     */
    xReportFB(cashierShiftSyncDto: CashierShiftSyncDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/XReportFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cashierShiftSyncDto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processXReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processXReportFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processXReportFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CashierShifts/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_);
                } catch (e) {
                    return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatFriendsWithSettings(response: Response): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserChatFriendsWithSettingsOutput.fromJS(resultData200) : new GetUserChatFriendsWithSettingsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserChatFriendsWithSettingsOutput>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @userId (optional) 
     * @minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number, userId: number, minMessageId: number): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserChatMessages(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatMessages(response: Response): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfChatMessageDto.fromJS(resultData200) : new ListResultDtoOfChatMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfChatMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(input: MarkAllUnreadMessagesOfUserAsReadInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ClubServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @clubInput (optional) 
     * @return Success
     */
    createClub(clubInput: ClubInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Club/CreateClub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clubInput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateClub(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateClub(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateClub(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteClub(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Club/DeleteClub?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteClub(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteClub(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteClub(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getClub(id: number): Observable<ClubInput> {
        let url_ = this.baseUrl + "/api/services/app/Club/GetClub?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClub(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClub(response_);
                } catch (e) {
                    return <Observable<ClubInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClubInput>><any>Observable.throw(response_);
        });
    }

    protected processGetClub(response: Response): Observable<ClubInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClubInput.fromJS(resultData200) : new ClubInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClubInput>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedClubs(pageNumber: number, pageSize: number): Observable<PagedClubList> {
        let url_ = this.baseUrl + "/api/services/app/Club/GetPagedClubs?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedClubs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedClubs(response_);
                } catch (e) {
                    return <Observable<PagedClubList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedClubList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedClubs(response: Response): Observable<PagedClubList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedClubList.fromJS(resultData200) : new PagedClubList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedClubList>(<any>null);
    }

    /**
     * @return Success
     */
    getAllClubs(): Observable<ListResultDtoOfClubDto> {
        let url_ = this.baseUrl + "/api/services/app/Club/GetAllClubs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllClubs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllClubs(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfClubDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfClubDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllClubs(response: Response): Observable<ListResultDtoOfClubDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfClubDto.fromJS(resultData200) : new ListResultDtoOfClubDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfClubDto>(<any>null);
    }

    /**
     * @clubInput (optional) 
     * @return Success
     */
    updateClub(clubInput: ClubInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Club/UpdateClub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clubInput);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateClub(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateClub(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateClub(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Club/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ClusterServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateClusterInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<ClusterDto> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<ClusterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClusterDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<ClusterDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClusterDto.fromJS(resultData200) : new ClusterDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClusterDto>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getClustersPage(pageNumber: number, pageSize: number): Observable<ClusterListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/GetClustersPage?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClustersPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClustersPage(response_);
                } catch (e) {
                    return <Observable<ClusterListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClusterListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetClustersPage(response: Response): Observable<ClusterListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClusterListResultDto.fromJS(resultData200) : new ClusterListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClusterListResultDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getClustersByTenantId(tenantId: number): Observable<ClusterListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/GetClustersByTenantId?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClustersByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClustersByTenantId(response_);
                } catch (e) {
                    return <Observable<ClusterListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClusterListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetClustersByTenantId(response: Response): Observable<ClusterListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ClusterListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClusterListItem[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateClusterInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Cluster/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CodingPatternSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCodingPatternSettings(): Observable<ListResultDtoOfCodingPatternSettingListItem> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/GetCodingPatternSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCodingPatternSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCodingPatternSettings(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCodingPatternSettingListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCodingPatternSettingListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetCodingPatternSettings(response: Response): Observable<ListResultDtoOfCodingPatternSettingListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCodingPatternSettingListItem.fromJS(resultData200) : new ListResultDtoOfCodingPatternSettingListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCodingPatternSettingListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getSalesCodingPatternSettings(): Observable<SalesCodingPatternSettingListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/GetSalesCodingPatternSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSalesCodingPatternSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSalesCodingPatternSettings(response_);
                } catch (e) {
                    return <Observable<SalesCodingPatternSettingListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesCodingPatternSettingListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetSalesCodingPatternSettings(response: Response): Observable<SalesCodingPatternSettingListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SalesCodingPatternSettingListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesCodingPatternSettingListItem[]>(<any>null);
    }

    /**
     * @patterns (optional) 
     * @return Success
     */
    createOrUpdateSalesCodingPatternSettings(patterns: SalesCodingPatternSettingListItem[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/CreateOrUpdateSalesCodingPatternSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patterns);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSalesCodingPatternSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSalesCodingPatternSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSalesCodingPatternSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCodingPatternSettings(input: ListResultDtoOfCodingPatternSettingListItem): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/UpdateCodingPatternSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCodingPatternSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCodingPatternSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCodingPatternSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @patternName (optional) 
     * @return Success
     */
    getPatternByName(patternName: string): Observable<CodingPatternSettingListItem> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/GetPatternByName?";
        if (patternName !== undefined)
            url_ += "patternName=" + encodeURIComponent("" + patternName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPatternByName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPatternByName(response_);
                } catch (e) {
                    return <Observable<CodingPatternSettingListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<CodingPatternSettingListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPatternByName(response: Response): Observable<CodingPatternSettingListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CodingPatternSettingListItem.fromJS(resultData200) : new CodingPatternSettingListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CodingPatternSettingListItem>(<any>null);
    }

    /**
     * @patternName (optional) 
     * @return Success
     */
    incrementPatternByName(patternName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/IncrementPatternByName?";
        if (patternName !== undefined)
            url_ += "patternName=" + encodeURIComponent("" + patternName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIncrementPatternByName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIncrementPatternByName(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processIncrementPatternByName(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @isRefund (optional) 
     * @return Success
     */
    getSalesCodePattern(storeId: number, isRefund: number): Observable<SalesCodingPatternSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/GetSalesCodePattern?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (isRefund !== undefined)
            url_ += "isRefund=" + encodeURIComponent("" + isRefund) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSalesCodePattern(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSalesCodePattern(response_);
                } catch (e) {
                    return <Observable<SalesCodingPatternSettingDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesCodingPatternSettingDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSalesCodePattern(response: Response): Observable<SalesCodingPatternSettingDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesCodingPatternSettingDto.fromJS(resultData200) : new SalesCodingPatternSettingDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesCodingPatternSettingDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CodingPatternSettings/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ComboGroupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateComboGroupInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfComboGroupListItem> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfComboGroupListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfComboGroupListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfComboGroupListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfComboGroupListItem.fromJS(resultData200) : new ListResultDtoOfComboGroupListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfComboGroupListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateComboGroupInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<ComboGroupDTO> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<ComboGroupDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComboGroupDTO>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<ComboGroupDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ComboGroupDTO.fromJS(resultData200) : new ComboGroupDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComboGroupDTO>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedComboGroups(pageNumber: number, pageSize: number): Observable<PagedComboGroupList> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/GetPagedComboGroups?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedComboGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedComboGroups(response_);
                } catch (e) {
                    return <Observable<PagedComboGroupList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedComboGroupList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedComboGroups(response: Response): Observable<PagedComboGroupList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedComboGroupList.fromJS(resultData200) : new PagedComboGroupList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedComboGroupList>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @compoId (optional) 
     * @return Success
     */
    deleteCompoImage(compoId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/DeleteCompoImage?";
        if (compoId !== undefined)
            url_ += "compoId=" + encodeURIComponent("" + compoId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteCompoImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteCompoImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteCompoImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ComboGroup/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ComboMealDefinitionsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateComboMealDefinition): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ComboMealDefinitions/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateComboMealDefinition): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboMealDefinitions/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboMealDefinitions/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<MenuItemDto> {
        let url_ = this.baseUrl + "/api/services/app/ComboMealDefinitions/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<MenuItemDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<MenuItemDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemDto.fromJS(resultData200) : new MenuItemDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfMenuItemListItem> {
        let url_ = this.baseUrl + "/api/services/app/ComboMealDefinitions/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMenuItemListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMenuItemListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfMenuItemListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMenuItemListItem.fromJS(resultData200) : new ListResultDtoOfMenuItemListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMenuItemListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    comboMealsDefinitionsPagedList(input: MenuItemInput, pageNumber: number, pageSize: number): Observable<PagedMenuItemList> {
        let url_ = this.baseUrl + "/api/services/app/ComboMealDefinitions/ComboMealsDefinitionsPagedList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComboMealsDefinitionsPagedList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComboMealsDefinitionsPagedList(response_);
                } catch (e) {
                    return <Observable<PagedMenuItemList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMenuItemList>><any>Observable.throw(response_);
        });
    }

    protected processComboMealsDefinitionsPagedList(response: Response): Observable<PagedMenuItemList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMenuItemList.fromJS(resultData200) : new PagedMenuItemList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMenuItemList>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ComboMealDefinitions/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ComboMealsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateComboMealPackage): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboMeals/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboMeals/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<ComboMealPackageDto> {
        let url_ = this.baseUrl + "/api/services/app/ComboMeals/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<ComboMealPackageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComboMealPackageDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<ComboMealPackageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ComboMealPackageDto.fromJS(resultData200) : new ComboMealPackageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComboMealPackageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfComboMealPackageListItem> {
        let url_ = this.baseUrl + "/api/services/app/ComboMeals/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfComboMealPackageListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfComboMealPackageListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfComboMealPackageListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfComboMealPackageListItem.fromJS(resultData200) : new ListResultDtoOfComboMealPackageListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfComboMealPackageListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedComboMeals(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedComboMealPackageList> {
        let url_ = this.baseUrl + "/api/services/app/ComboMeals/GetPagedComboMeals?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedComboMeals(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedComboMeals(response_);
                } catch (e) {
                    return <Observable<PagedComboMealPackageList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedComboMealPackageList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedComboMeals(response: Response): Observable<PagedComboMealPackageList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedComboMealPackageList.fromJS(resultData200) : new PagedComboMealPackageList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedComboMealPackageList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateComboMealPackage): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ComboMeals/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ComboMeals/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionsForCombobox(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForCombobox(response: Response): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200) : new ListResultDtoOfSubscribableEditionComboboxItemDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindUsersInput): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: Response): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDefaultEditionName(response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDefaultEditionName(response: Response): Observable<GetDefaultEditionNameOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDefaultEditionNameOutput.fromJS(resultData200) : new GetDefaultEditionNameOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDefaultEditionNameOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CoordinatorServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Coordinator/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CornerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<CornerDTO> {
        let url_ = this.baseUrl + "/api/services/app/Corner/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<CornerDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<CornerDTO>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<CornerDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CornerDTO.fromJS(resultData200) : new CornerDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CornerDTO>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @return Success
     */
    getAllByStoreId(storeIds: number[]): Observable<ListResultDtoOfCornerListItem> {
        let url_ = this.baseUrl + "/api/services/app/Corner/GetAllByStoreId?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllByStoreId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCornerListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCornerListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllByStoreId(response: Response): Observable<ListResultDtoOfCornerListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCornerListItem.fromJS(resultData200) : new ListResultDtoOfCornerListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCornerListItem>(<any>null);
    }

    /**
     * @cornerId (optional) 
     * @return Success
     */
    getCornerDevices(cornerId: number): Observable<CornerStoreDeviceInput> {
        let url_ = this.baseUrl + "/api/services/app/Corner/GetCornerDevices?";
        if (cornerId !== undefined)
            url_ += "cornerId=" + encodeURIComponent("" + cornerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCornerDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCornerDevices(response_);
                } catch (e) {
                    return <Observable<CornerStoreDeviceInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CornerStoreDeviceInput>><any>Observable.throw(response_);
        });
    }

    protected processGetCornerDevices(response: Response): Observable<CornerStoreDeviceInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CornerStoreDeviceInput.fromJS(resultData200) : new CornerStoreDeviceInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CornerStoreDeviceInput>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CornerListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Corner/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<CornerListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CornerListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<CornerListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CornerListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CornerListItem[]>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedCorners(pageNumber: number, pageSize: number): Observable<PagedCornerList> {
        let url_ = this.baseUrl + "/api/services/app/Corner/GetPagedCorners?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedCorners(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedCorners(response_);
                } catch (e) {
                    return <Observable<PagedCornerList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedCornerList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedCorners(response: Response): Observable<PagedCornerList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedCornerList.fromJS(resultData200) : new PagedCornerList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedCornerList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateCornerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Corner/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: EditCornerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Corner/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addOrUpdateCornerDevices(input: CornerStoreDeviceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Corner/AddOrUpdateCornerDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddOrUpdateCornerDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddOrUpdateCornerDevices(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddOrUpdateCornerDevices(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Corner/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Corner/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CornersServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getCorners(storeId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Corners/GetCorners?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCorners(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCorners(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetCorners(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @cornerId (optional) 
     * @return Success
     */
    getAllTablesAtStoreByCornerId(storeId: number, cornerId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Corners/GetAllTablesAtStoreByCornerId?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (cornerId !== undefined)
            url_ += "cornerId=" + encodeURIComponent("" + cornerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllTablesAtStoreByCornerId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllTablesAtStoreByCornerId(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAllTablesAtStoreByCornerId(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    addDiningTable(request: DiningTableDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Corners/AddDiningTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddDiningTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddDiningTable(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processAddDiningTable(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    changeDiningTable(request: ChangeDiningTableRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Corners/ChangeDiningTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeDiningTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeDiningTable(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processChangeDiningTable(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @tableId (optional) 
     * @return Success
     */
    getTableById(tableId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Corners/GetTableById?";
        if (tableId !== undefined)
            url_ += "tableId=" + encodeURIComponent("" + tableId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTableById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTableById(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetTableById(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    joinTables(request: DiningTableDto[]): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Corners/JoinTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processJoinTables(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processJoinTables(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processJoinTables(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    tablesHook(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Corners/TablesHook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTablesHook(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTablesHook(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processTablesHook(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Corners/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CountedStockServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportCountedStockForUpdate(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/ExportCountedStockForUpdate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCountedStockForUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCountedStockForUpdate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCountedStockForUpdate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @id (optional) 
     * @return Success
     */
    importCountedStockFromExcel(file: FileParameter, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/ImportCountedStockFromExcel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportCountedStockFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportCountedStockFromExcel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImportCountedStockFromExcel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getCountedStock(id: number): Observable<CountedStockDto> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/GetCountedStock?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountedStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountedStock(response_);
                } catch (e) {
                    return <Observable<CountedStockDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CountedStockDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCountedStock(response: Response): Observable<CountedStockDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountedStockDto.fromJS(resultData200) : new CountedStockDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CountedStockDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getCountedStockForClose(id: number): Observable<CountedStockDto> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/GetCountedStockForClose?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountedStockForClose(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountedStockForClose(response_);
                } catch (e) {
                    return <Observable<CountedStockDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CountedStockDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCountedStockForClose(response: Response): Observable<CountedStockDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountedStockDto.fromJS(resultData200) : new CountedStockDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CountedStockDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCountedStock(input: CountedStockDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/UpdateCountedStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCountedStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCountedStock(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCountedStock(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    closeCountedStock(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/CloseCountedStock?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloseCountedStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloseCountedStock(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloseCountedStock(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @stores (optional) 
     * @periodTypes (optional) 
     * @statuses (optional) 
     * @from (optional) 
     * @to (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedCountedStock(stores: number[], periodTypes: number[], statuses: number[], from: moment.Moment, to: moment.Moment, pageNumber: number, pageSize: number): Observable<PagedCountedStockList> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/GetPagedCountedStock?";
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (periodTypes !== undefined)
            periodTypes && periodTypes.forEach(item => { url_ += "PeriodTypes=" + encodeURIComponent("" + item) + "&"; });
        if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedCountedStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedCountedStock(response_);
                } catch (e) {
                    return <Observable<PagedCountedStockList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedCountedStockList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedCountedStock(response: Response): Observable<PagedCountedStockList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedCountedStockList.fromJS(resultData200) : new PagedCountedStockList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedCountedStockList>(<any>null);
    }

    /**
     * @countedStockId (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportCountedStock(countedStockId: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/ExportCountedStock?";
        if (countedStockId !== undefined)
            url_ += "countedStockId=" + encodeURIComponent("" + countedStockId) + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCountedStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCountedStock(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCountedStock(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @countedStockId (optional) 
     * @return Success
     */
    rollback(countedStockId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/Rollback?";
        if (countedStockId !== undefined)
            url_ += "countedStockId=" + encodeURIComponent("" + countedStockId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRollback(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRollback(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRollback(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CountedStock/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CountedStockRetailServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getCountedStockRetail(id: number): Observable<CountedStockRetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/GetCountedStockRetail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountedStockRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountedStockRetail(response_);
                } catch (e) {
                    return <Observable<CountedStockRetailDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CountedStockRetailDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCountedStockRetail(response: Response): Observable<CountedStockRetailDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountedStockRetailDto.fromJS(resultData200) : new CountedStockRetailDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CountedStockRetailDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCountedStocksRetail(): Observable<ListResultDtoOfCountedStockRetailListItem> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/GetCountedStocksRetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountedStocksRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountedStocksRetail(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCountedStockRetailListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCountedStockRetailListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetCountedStocksRetail(response: Response): Observable<ListResultDtoOfCountedStockRetailListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCountedStockRetailListItem.fromJS(resultData200) : new ListResultDtoOfCountedStockRetailListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCountedStockRetailListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCountedStockRetail(input: CreateCountedStockRetailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/CreateCountedStockRetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateCountedStockRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateCountedStockRetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateCountedStockRetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    reverseCounted(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/ReverseCounted?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReverseCounted(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReverseCounted(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processReverseCounted(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCountedStockRetail(input: UpdateCountedStockRetailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/UpdateCountedStockRetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCountedStockRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCountedStockRetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCountedStockRetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteCountedStockRetail(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/DeleteCountedStockRetail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteCountedStockRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteCountedStockRetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteCountedStockRetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedCountedStockRetail(pageNumber: number, pageSize: number): Observable<PagedCountedStockRetailList> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/GetPagedCountedStockRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedCountedStockRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedCountedStockRetail(response_);
                } catch (e) {
                    return <Observable<PagedCountedStockRetailList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedCountedStockRetailList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedCountedStockRetail(response: Response): Observable<PagedCountedStockRetailList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedCountedStockRetailList.fromJS(resultData200) : new PagedCountedStockRetailList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedCountedStockRetailList>(<any>null);
    }

    /**
     * @productId (optional) 
     * @unitofmeasureId (optional) 
     * @varintId (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getActualQtyByProduct(productId: number, unitofmeasureId: number, varintId: number, storeId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/GetActualQtyByProduct?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (unitofmeasureId !== undefined)
            url_ += "unitofmeasureId=" + encodeURIComponent("" + unitofmeasureId) + "&"; 
        if (varintId !== undefined)
            url_ += "varintId=" + encodeURIComponent("" + varintId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActualQtyByProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActualQtyByProduct(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetActualQtyByProduct(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CountedStockRetail/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CurrenciesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getCurrency(id: number): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetCurrency?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrency(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrency(response_);
                } catch (e) {
                    return <Observable<CurrencyDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CurrencyDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrency(response: Response): Observable<CurrencyDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrencyDto.fromJS(resultData200) : new CurrencyDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CurrencyDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrencies(): Observable<ListResultDtoOfCurrencyListItem> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrencies(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrencies(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCurrencyListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCurrencyListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrencies(response: Response): Observable<ListResultDtoOfCurrencyListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCurrencyListItem.fromJS(resultData200) : new ListResultDtoOfCurrencyListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCurrencyListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedCurrencies(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedCurrenciesList> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetPagedCurrencies?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedCurrencies(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedCurrencies(response_);
                } catch (e) {
                    return <Observable<PagedCurrenciesList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedCurrenciesList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedCurrencies(response: Response): Observable<PagedCurrenciesList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedCurrenciesList.fromJS(resultData200) : new PagedCurrenciesList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedCurrenciesList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCurrency(input: CreateCurrencyInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/CreateCurrency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateCurrency(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateCurrency(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateCurrency(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCurrency(input: UpdateCurrencyInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/UpdateCurrency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCurrency(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCurrency(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCurrency(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteCurrency(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/DeleteCurrency?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteCurrency(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteCurrency(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteCurrency(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    setDefaultCurrency(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/SetDefaultCurrency?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetDefaultCurrency(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetDefaultCurrency(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDefaultCurrency(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class CustomersServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getCustomer(id: string): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetCustomer?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCustomer(response_);
                } catch (e) {
                    return <Observable<CustomerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCustomer(response: Response): Observable<CustomerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerDto.fromJS(resultData200) : new CustomerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerDto>(<any>null);
    }

    /**
     * @customerNameOrPhone (optional) 
     * @documentType (optional) 
     * @return Success
     */
    customerReportRetail(customerNameOrPhone: string, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Customers/CustomerReportRetail?";
        if (customerNameOrPhone !== undefined)
            url_ += "CustomerNameOrPhone=" + encodeURIComponent("" + customerNameOrPhone) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCustomerReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCustomerReportRetail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processCustomerReportRetail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchText (optional) 
     * @return Success
     */
    getCustomers(searchText: string): Observable<ListResultDtoOfCustomerListItem> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetCustomers?";
        if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCustomers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCustomers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCustomerListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCustomerListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetCustomers(response: Response): Observable<ListResultDtoOfCustomerListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCustomerListItem.fromJS(resultData200) : new ListResultDtoOfCustomerListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCustomerListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCustomers(): Observable<ListResultDtoOfCustomerListItem> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetAllCustomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCustomers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCustomers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCustomerListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCustomerListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCustomers(response: Response): Observable<ListResultDtoOfCustomerListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCustomerListItem.fromJS(resultData200) : new ListResultDtoOfCustomerListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCustomerListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCustomersWithCellPhone(): Observable<ListResultDtoOfCustomerListItem> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetAllCustomersWithCellPhone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCustomersWithCellPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCustomersWithCellPhone(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCustomerListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCustomerListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCustomersWithCellPhone(response: Response): Observable<ListResultDtoOfCustomerListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCustomerListItem.fromJS(resultData200) : new ListResultDtoOfCustomerListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCustomerListItem>(<any>null);
    }

    /**
     * @searchText (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedCustomers(searchText: string, pageNumber: number, pageSize: number): Observable<PagedCustomerList> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetPagedCustomers?";
        if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedCustomers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedCustomers(response_);
                } catch (e) {
                    return <Observable<PagedCustomerList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedCustomerList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedCustomers(response: Response): Observable<PagedCustomerList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedCustomerList.fromJS(resultData200) : new PagedCustomerList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedCustomerList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCustomer(input: CreateCustomerInput): Observable<CustomerListItem> {
        let url_ = this.baseUrl + "/api/services/app/Customers/CreateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateCustomer(response_);
                } catch (e) {
                    return <Observable<CustomerListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerListItem>><any>Observable.throw(response_);
        });
    }

    protected processCreateCustomer(response: Response): Observable<CustomerListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerListItem.fromJS(resultData200) : new CustomerListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCustomerSync(input: CreateCustomerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/CreateCustomerSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateCustomerSync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateCustomerSync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateCustomerSync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetActiveLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActiveLanguages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActiveLanguages(response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetActiveLanguages(response: Response): Observable<GetLanguagesOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguagesOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCustomerBy(input: CreateCustomerInputBy): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/CreateCustomerBy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateCustomerBy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateCustomerBy(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateCustomerBy(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @inputaddress (optional) 
     * @return Success
     */
    addCustomerAddress(inputaddress: AddCustomerAddress): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Customers/AddCustomerAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputaddress);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddCustomerAddress(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddCustomerAddress(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processAddCustomerAddress(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @inputes (optional) 
     * @return Success
     */
    changeSelectedAddress(inputes: ChangeSelectedAddress): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/ChangeSelectedAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputes);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeSelectedAddress(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeSelectedAddress(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeSelectedAddress(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCustomer(input: UpdateCustomerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/UpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCustomer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCustomer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @customers (optional) 
     * @return Success
     */
    uploadCustomers(customers: CustomerSyncDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/UploadCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customers);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadCustomers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadCustomers(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadCustomers(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @addresses (optional) 
     * @return Success
     */
    uploadCustomerAddresse(addresses: CustomerAddressSyncDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/UploadCustomerAddresse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addresses);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadCustomerAddresse(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadCustomerAddresse(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadCustomerAddresse(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteCustomer(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/DeleteCustomer?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteCustomer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteCustomer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCustomersWithAddresses(): Observable<CustomerWithAddressesListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetAllCustomersWithAddresses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCustomersWithAddresses(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCustomersWithAddresses(response_);
                } catch (e) {
                    return <Observable<CustomerWithAddressesListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerWithAddressesListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCustomersWithAddresses(response: Response): Observable<CustomerWithAddressesListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CustomerWithAddressesListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerWithAddressesListItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DeliveryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @return Success
     */
    getPagedDeliveries(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedDeliveriesList> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetPagedDeliveries?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedDeliveries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedDeliveries(response_);
                } catch (e) {
                    return <Observable<PagedDeliveriesList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedDeliveriesList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedDeliveries(response: Response): Observable<PagedDeliveriesList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedDeliveriesList.fromJS(resultData200) : new PagedDeliveriesList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedDeliveriesList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDelivery(input: CreateDeliveryInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/CreateDelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDelivery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDelivery(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateDelivery(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteDelivery(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/DeleteDelivery?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteDelivery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteDelivery(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteDelivery(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getDelivery(id: number): Observable<DeliveryDto> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetDelivery?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDelivery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDelivery(response_);
                } catch (e) {
                    return <Observable<DeliveryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeliveryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDelivery(response: Response): Observable<DeliveryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeliveryDto.fromJS(resultData200) : new DeliveryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeliveryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDeliveries(): Observable<ListResultDtoOfDeliveryListItem> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetDeliveries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeliveries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeliveries(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeliveryListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeliveryListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetDeliveries(response: Response): Observable<ListResultDtoOfDeliveryListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeliveryListItem.fromJS(resultData200) : new ListResultDtoOfDeliveryListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeliveryListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDelivery(input: UpdateDeliveryInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/UpdateDelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDelivery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDelivery(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDelivery(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Delivery/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DeliveryStreetsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateDeliveryStreetInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<DeliveryStreetDto> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<DeliveryStreetDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeliveryStreetDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<DeliveryStreetDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeliveryStreetDto.fromJS(resultData200) : new DeliveryStreetDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeliveryStreetDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfDeliveryStreetListItem> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeliveryStreetListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeliveryStreetListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfDeliveryStreetListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeliveryStreetListItem.fromJS(resultData200) : new ListResultDtoOfDeliveryStreetListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeliveryStreetListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPageDeliveryStreetList(pageNumber: number, pageSize: number): Observable<PagedDeliveryStreetList> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/GetPageDeliveryStreetList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPageDeliveryStreetList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPageDeliveryStreetList(response_);
                } catch (e) {
                    return <Observable<PagedDeliveryStreetList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedDeliveryStreetList>><any>Observable.throw(response_);
        });
    }

    protected processGetPageDeliveryStreetList(response: Response): Observable<PagedDeliveryStreetList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedDeliveryStreetList.fromJS(resultData200) : new PagedDeliveryStreetList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedDeliveryStreetList>(<any>null);
    }

    /**
     * @deliveryZoneId (optional) 
     * @return Success
     */
    getStreetsByZoneId(deliveryZoneId: number): Observable<ListResultDtoOfDeliveryStreetListItem> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/GetStreetsByZoneId?";
        if (deliveryZoneId !== undefined)
            url_ += "deliveryZoneId=" + encodeURIComponent("" + deliveryZoneId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStreetsByZoneId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStreetsByZoneId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeliveryStreetListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeliveryStreetListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStreetsByZoneId(response: Response): Observable<ListResultDtoOfDeliveryStreetListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeliveryStreetListItem.fromJS(resultData200) : new ListResultDtoOfDeliveryStreetListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeliveryStreetListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateDeliveryStreetInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryStreets/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DeliveryZoneServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateDeliveryZoneInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryZone/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryZone/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<DeliveryZoneDto> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryZone/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<DeliveryZoneDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeliveryZoneDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<DeliveryZoneDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeliveryZoneDto.fromJS(resultData200) : new DeliveryZoneDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeliveryZoneDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfDeliveryZoneListItem> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryZone/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeliveryZoneListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeliveryZoneListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfDeliveryZoneListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeliveryZoneListItem.fromJS(resultData200) : new ListResultDtoOfDeliveryZoneListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeliveryZoneListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedDeliveryZone(pageNumber: number, pageSize: number): Observable<PagedDeliveryZoneList> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryZone/GetPagedDeliveryZone?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedDeliveryZone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedDeliveryZone(response_);
                } catch (e) {
                    return <Observable<PagedDeliveryZoneList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedDeliveryZoneList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedDeliveryZone(response: Response): Observable<PagedDeliveryZoneList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedDeliveryZoneList.fromJS(resultData200) : new PagedDeliveryZoneList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedDeliveryZoneList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateDeliveryZoneInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryZone/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DeliveryZone/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDate(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDate(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDateTime(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateTime(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment, endDate: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDateRange(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateRange(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCountries(response: Response): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @selectedCountries (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(selectedCountries: NameValueOfString[]): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedCountries);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetSelectedCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetSelectedCountries(response: Response): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetValue(response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<StringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetValue(response: Response): Observable<StringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StringOutput.fromJS(resultData200) : new StringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StringOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DeviceManagmentReportsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantIds (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getDeviceManagmentReport(tenantIds: number[], pageNumber: number, pageSize: number): Observable<OfflineDeviceTenantReportGroupPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/DeviceManagmentReports/GetDeviceManagmentReport?";
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceManagmentReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceManagmentReport(response_);
                } catch (e) {
                    return <Observable<OfflineDeviceTenantReportGroupPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OfflineDeviceTenantReportGroupPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceManagmentReport(response: Response): Observable<OfflineDeviceTenantReportGroupPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OfflineDeviceTenantReportGroupPagedDto.fromJS(resultData200) : new OfflineDeviceTenantReportGroupPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OfflineDeviceTenantReportGroupPagedDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportDeviceManagmentReport(input: OfflineDeviceInputDto, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DeviceManagmentReports/ExportDeviceManagmentReport?";
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportDeviceManagmentReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportDeviceManagmentReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportDeviceManagmentReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getKdsOperationSummaryReport(storeIds: number[], regionId: number, areaId: number, fromDate: moment.Moment, toDate: moment.Moment, pageNumber: number, pageSize: number): Observable<KdsOperationSummaryReportDtoPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/DeviceManagmentReports/GetKdsOperationSummaryReport?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKdsOperationSummaryReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKdsOperationSummaryReport(response_);
                } catch (e) {
                    return <Observable<KdsOperationSummaryReportDtoPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<KdsOperationSummaryReportDtoPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processGetKdsOperationSummaryReport(response: Response): Observable<KdsOperationSummaryReportDtoPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KdsOperationSummaryReportDtoPagedDto.fromJS(resultData200) : new KdsOperationSummaryReportDtoPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<KdsOperationSummaryReportDtoPagedDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportGetKdsOperationSummaryReport(input: KdsOperationSummaryReportInputDto, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DeviceManagmentReports/ExportGetKdsOperationSummaryReport?";
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportGetKdsOperationSummaryReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportGetKdsOperationSummaryReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportGetKdsOperationSummaryReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    kitchenItelligenceAndItemPerformanceReport(input: KdsKitchenIntelligenceAndItemPerformanceReportInputDto): Observable<KdsKitchenIntelligenceAndItemPerformanceReportPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/DeviceManagmentReports/KitchenItelligenceAndItemPerformanceReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processKitchenItelligenceAndItemPerformanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processKitchenItelligenceAndItemPerformanceReport(response_);
                } catch (e) {
                    return <Observable<KdsKitchenIntelligenceAndItemPerformanceReportPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<KdsKitchenIntelligenceAndItemPerformanceReportPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processKitchenItelligenceAndItemPerformanceReport(response: Response): Observable<KdsKitchenIntelligenceAndItemPerformanceReportPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KdsKitchenIntelligenceAndItemPerformanceReportPagedDto.fromJS(resultData200) : new KdsKitchenIntelligenceAndItemPerformanceReportPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<KdsKitchenIntelligenceAndItemPerformanceReportPagedDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportKitchenItelligenceAndItemPerformanceReport(input: KdsKitchenIntelligenceAndItemPerformanceReportInputDto, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DeviceManagmentReports/ExportKitchenItelligenceAndItemPerformanceReport?";
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportKitchenItelligenceAndItemPerformanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportKitchenItelligenceAndItemPerformanceReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportKitchenItelligenceAndItemPerformanceReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DeviceManagmentReports/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DeviceOrderServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @kdsOrderDetialDtos (optional) 
     * @return Success
     */
    uploadKdsOrdersDetails(kdsOrderDetialDtos: KdsOrderDetialDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeviceOrder/UploadKdsOrdersDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(kdsOrderDetialDtos);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadKdsOrdersDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadKdsOrdersDetails(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadKdsOrdersDetails(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DeviceOrder/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DevicesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getDevice(id: number): Observable<DeviceDto> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetDevice?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDevice(response_);
                } catch (e) {
                    return <Observable<DeviceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDevice(response: Response): Observable<DeviceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeviceDto.fromJS(resultData200) : new DeviceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDeviceTypesForChild(): Observable<DeviceTypeItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetDeviceTypesForChild";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceTypesForChild(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceTypesForChild(response_);
                } catch (e) {
                    return <Observable<DeviceTypeItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceTypeItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceTypesForChild(response: Response): Observable<DeviceTypeItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DeviceTypeItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceTypeItem[]>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getDeviceTypes(tenantId: number): Observable<DeviceTypeItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetDeviceTypes?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceTypes(response_);
                } catch (e) {
                    return <Observable<DeviceTypeItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceTypeItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceTypes(response: Response): Observable<DeviceTypeItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DeviceTypeItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceTypeItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDeviceTypesList(): Observable<DeviceTypeItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetDeviceTypesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceTypesList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceTypesList(response_);
                } catch (e) {
                    return <Observable<DeviceTypeItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceTypeItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceTypesList(response: Response): Observable<DeviceTypeItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DeviceTypeItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceTypeItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTableteDevices(): Observable<ListResultDtoOfDeviceListItem> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetTableteDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTableteDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTableteDevices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetTableteDevices(response: Response): Observable<ListResultDtoOfDeviceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeviceListItem.fromJS(resultData200) : new ListResultDtoOfDeviceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeviceListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getDevices(): Observable<ListResultDtoOfDeviceListItem> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDevices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetDevices(response: Response): Observable<ListResultDtoOfDeviceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeviceListItem.fromJS(resultData200) : new ListResultDtoOfDeviceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeviceListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getSelfServiceDevices(): Observable<ListResultDtoOfDeviceListItem> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetSelfServiceDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSelfServiceDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSelfServiceDevices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSelfServiceDevices(response: Response): Observable<ListResultDtoOfDeviceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeviceListItem.fromJS(resultData200) : new ListResultDtoOfDeviceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeviceListItem>(<any>null);
    }

    /**
     * @type (optional) 
     * @return Success
     */
    getDeviceByType(type: number): Observable<ListResultDtoOfDeviceListItem> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetDeviceByType?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceByType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceByType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceByType(response: Response): Observable<ListResultDtoOfDeviceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeviceListItem.fromJS(resultData200) : new ListResultDtoOfDeviceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeviceListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedDevices(pageNumber: number, pageSize: number): Observable<PagedDeviceList> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetPagedDevices?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedDevices(response_);
                } catch (e) {
                    return <Observable<PagedDeviceList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedDeviceList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedDevices(response: Response): Observable<PagedDeviceList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedDeviceList.fromJS(resultData200) : new PagedDeviceList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedDeviceList>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedDevicesByTenantId(pageNumber: number, pageSize: number): Observable<PagedDeviceList> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetPagedDevicesByTenantId?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedDevicesByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedDevicesByTenantId(response_);
                } catch (e) {
                    return <Observable<PagedDeviceList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedDeviceList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedDevicesByTenantId(response: Response): Observable<PagedDeviceList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedDeviceList.fromJS(resultData200) : new PagedDeviceList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedDeviceList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDevice(input: CreateDeviceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Devices/CreateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDevice(input: UpdateDeviceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Devices/UpdateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteDevice(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Devices/DeleteDevice?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getClustersForCurrentTenant(): Observable<ClusterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetClustersForCurrentTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClustersForCurrentTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClustersForCurrentTenant(response_);
                } catch (e) {
                    return <Observable<ClusterDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClusterDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetClustersForCurrentTenant(response: Response): Observable<ClusterDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ClusterDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClusterDto[]>(<any>null);
    }

    /**
     * @clusterId (optional) 
     * @return Success
     */
    getTenatSalesTypes(clusterId: number): Observable<SaleTypeListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetTenatSalesTypes?";
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenatSalesTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenatSalesTypes(response_);
                } catch (e) {
                    return <Observable<SaleTypeListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleTypeListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTenatSalesTypes(response: Response): Observable<SaleTypeListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SaleTypeListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleTypeListItem[]>(<any>null);
    }

    /**
     * @clusterId (optional) 
     * @return Success
     */
    getParentTenantDevicesByClusterId(clusterId: number): Observable<TenantDeviceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetParentTenantDevicesByClusterId?";
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetParentTenantDevicesByClusterId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetParentTenantDevicesByClusterId(response_);
                } catch (e) {
                    return <Observable<TenantDeviceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantDeviceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetParentTenantDevicesByClusterId(response: Response): Observable<TenantDeviceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantDeviceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantDeviceDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTenantDevice(input: TenatDeviceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Devices/CreateTenantDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTenantDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTenantDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTenantDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenantDevice(input: TenatDeviceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Devices/UpdateTenantDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenantDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenantDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenantDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Devices/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class DiscountTypesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getDiscountType(id: number): Observable<DiscountTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DiscountTypes/GetDiscountType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountType(response_);
                } catch (e) {
                    return <Observable<DiscountTypeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DiscountTypeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountType(response: Response): Observable<DiscountTypeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DiscountTypeDto.fromJS(resultData200) : new DiscountTypeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DiscountTypeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDiscountTypes(): Observable<ListResultDtoOfDiscountTypeListItem> {
        let url_ = this.baseUrl + "/api/services/app/DiscountTypes/GetDiscountTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountTypes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDiscountTypeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDiscountTypeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountTypes(response: Response): Observable<ListResultDtoOfDiscountTypeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDiscountTypeListItem.fromJS(resultData200) : new ListResultDtoOfDiscountTypeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDiscountTypeListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedDiscountTypes(pageNumber: number, pageSize: number): Observable<PagedDiscountTypesList> {
        let url_ = this.baseUrl + "/api/services/app/DiscountTypes/GetPagedDiscountTypes?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedDiscountTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedDiscountTypes(response_);
                } catch (e) {
                    return <Observable<PagedDiscountTypesList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedDiscountTypesList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedDiscountTypes(response: Response): Observable<PagedDiscountTypesList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedDiscountTypesList.fromJS(resultData200) : new PagedDiscountTypesList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedDiscountTypesList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDiscountType(input: CreateDiscountTypeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiscountTypes/CreateDiscountType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDiscountType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDiscountType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDiscountType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDiscountType(input: UpdateDiscountTypeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiscountTypes/UpdateDiscountType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDiscountType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDiscountType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDiscountType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteDiscountType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiscountTypes/DeleteDiscountType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteDiscountType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteDiscountType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteDiscountType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DiscountTypes/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditions(response: Response): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEditionListDto.fromJS(resultData200) : new ListResultDtoOfEditionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionForEdit(response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionForEdit(response: Response): Observable<GetEditionEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionEditOutput.fromJS(resultData200) : new GetEditionEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetEditionEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateEdition(input: CreateOrUpdateEditionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteEdition(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @selectedEditionId (optional) 
     * @addAllItem (optional) 
     * @onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number, addAllItem: boolean, onlyFreeItems: boolean): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&"; 
        if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&"; 
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionComboboxItems(response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionComboboxItems(response: Response): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SubscribableEditionComboboxItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class EInvoicesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EInvoices/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class EncryptionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @text (optional) 
     * @return Success
     */
    rncrypt(text: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Encryption/Rncrypt?";
        if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRncrypt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRncrypt(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processRncrypt(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @text (optional) 
     * @return Success
     */
    decrypt(text: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Encryption/Decrypt?";
        if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDecrypt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDecrypt(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processDecrypt(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Encryption/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class EndOfDayServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @endOfDayId (optional) 
     * @return Success
     */
    closeEndOfDayAsync(endOfDayId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EndOfDay/CloseEndOfDayAsync?";
        if (endOfDayId !== undefined)
            url_ += "endOfDayId=" + encodeURIComponent("" + endOfDayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloseEndOfDayAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloseEndOfDayAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloseEndOfDayAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    opendendOfDayPaged(input: EndOfDayInputReport, pageNumber: number, pageSize: number): Observable<PagedEndOfDayList> {
        let url_ = this.baseUrl + "/api/services/app/EndOfDay/OpendendOfDayPaged?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOpendendOfDayPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOpendendOfDayPaged(response_);
                } catch (e) {
                    return <Observable<PagedEndOfDayList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedEndOfDayList>><any>Observable.throw(response_);
        });
    }

    protected processOpendendOfDayPaged(response: Response): Observable<PagedEndOfDayList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedEndOfDayList.fromJS(resultData200) : new PagedEndOfDayList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedEndOfDayList>(<any>null);
    }

    /**
     * @endOfDayId (optional) 
     * @return Success
     */
    getEndOfDayInvoices(endOfDayId: number): Observable<EndOfDayInvoiceSummerDto> {
        let url_ = this.baseUrl + "/api/services/app/EndOfDay/GetEndOfDayInvoices?";
        if (endOfDayId !== undefined)
            url_ += "endOfDayId=" + encodeURIComponent("" + endOfDayId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEndOfDayInvoices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEndOfDayInvoices(response_);
                } catch (e) {
                    return <Observable<EndOfDayInvoiceSummerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EndOfDayInvoiceSummerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEndOfDayInvoices(response: Response): Observable<EndOfDayInvoiceSummerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EndOfDayInvoiceSummerDto.fromJS(resultData200) : new EndOfDayInvoiceSummerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EndOfDayInvoiceSummerDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    endOfDayReport(input: EndOfDayInputReport, pageNumber: number, pageSize: number): Observable<PagedEndOfDayList> {
        let url_ = this.baseUrl + "/api/services/app/EndOfDay/EndOfDayReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEndOfDayReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEndOfDayReport(response_);
                } catch (e) {
                    return <Observable<PagedEndOfDayList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedEndOfDayList>><any>Observable.throw(response_);
        });
    }

    protected processEndOfDayReport(response: Response): Observable<PagedEndOfDayList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedEndOfDayList.fromJS(resultData200) : new PagedEndOfDayList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedEndOfDayList>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @statuses (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportEndOfDayReport(from: moment.Moment, to: moment.Moment, tenantId: number, regionId: number, areaId: number, storeIds: number[], statuses: number[], documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EndOfDay/ExportEndOfDayReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportEndOfDayReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportEndOfDayReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportEndOfDayReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EndOfDay/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    registerClient(): Observable<void> {
        let url_ = this.baseUrl + "/register-client";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterClient(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterClient(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRegisterClient(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @data (optional) 
     * @tenantId (optional) 
     * @storeId (optional) 
     * @return Success
     */
    sendCreatedInvoice(data: QrMenaSaleTransactionDto, tenantId: string, storeId: string): Observable<void> {
        let url_ = this.baseUrl + "/send-created-invoice?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendCreatedInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendCreatedInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendCreatedInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @invoice (optional) 
     * @tenantId (optional) 
     * @storeId (optional) 
     * @return Success
     */
    sendWorkFlowInvoice(invoice: WorkFlowSaleTransactionDto, tenantId: string, storeId: string): Observable<void> {
        let url_ = this.baseUrl + "/send-work-flow-invoice?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendWorkFlowInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendWorkFlowInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendWorkFlowInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class FactoryResetServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @userName (optional) 
     * @password (optional) 
     * @resetData (optional) 
     * @return Success
     */
    getFactoryResetFn(userName: string, password: string, resetData: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FactoryReset/GetFactoryResetFn?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        if (resetData !== undefined)
            url_ += "resetData=" + encodeURIComponent("" + resetData) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFactoryResetFn(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFactoryResetFn(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetFactoryResetFn(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @userName (optional) 
     * @password (optional) 
     * @resetData (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getFactoryResetSalesFn(userName: string, password: string, resetData: boolean, storeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FactoryReset/GetFactoryResetSalesFn?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        if (resetData !== undefined)
            url_ += "resetData=" + encodeURIComponent("" + resetData) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFactoryResetSalesFn(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFactoryResetSalesFn(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetFactoryResetSalesFn(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @userName (optional) 
     * @password (optional) 
     * @resetData (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getFactoryResetTransactionsFn(userName: string, password: string, resetData: boolean, storeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FactoryReset/GetFactoryResetTransactionsFn?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        if (resetData !== undefined)
            url_ += "resetData=" + encodeURIComponent("" + resetData) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFactoryResetTransactionsFn(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFactoryResetTransactionsFn(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetFactoryResetTransactionsFn(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FactoryReset/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class FileNotificationServiceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserNotifications(): Observable<FileNotificationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileNotificationService/GetUserNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserNotifications(response_);
                } catch (e) {
                    return <Observable<FileNotificationsDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileNotificationsDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUserNotifications(response: Response): Observable<FileNotificationsDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FileNotificationsDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileNotificationsDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    updateNotificationShowedToUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileNotificationService/UpdateNotificationShowedToUser?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotificationShowedToUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotificationShowedToUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotificationShowedToUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FileNotificationService/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequest(input: CreateFriendshipRequestInput): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequest(response: Response): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(input: CreateFriendshipRequestByUserNameInput): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequestByUserName(response: Response): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blockUser(input: BlockUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unblockUser(input: UnblockUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnblockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnblockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnblockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    acceptFriendshipRequest(input: AcceptFriendshipRequestInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAcceptFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAcceptFriendshipRequest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class GroupsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createGroup(input: CreateGroupInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Groups/CreateGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateGroup(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateGroup(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGroupListItemWithoutPaged(): Observable<ListResultDtoOfGroupListItem> {
        let url_ = this.baseUrl + "/api/services/app/Groups/GetAllGroupListItemWithoutPaged";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllGroupListItemWithoutPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllGroupListItemWithoutPaged(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGroupListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGroupListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllGroupListItemWithoutPaged(response: Response): Observable<ListResultDtoOfGroupListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGroupListItem.fromJS(resultData200) : new ListResultDtoOfGroupListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGroupListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @return Success
     */
    getAllGroups(pageNumber: number): Observable<ListResultDtoOfGetGroupOutput> {
        let url_ = this.baseUrl + "/api/services/app/Groups/GetAllGroups?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllGroups(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetGroupOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetGroupOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAllGroups(response: Response): Observable<ListResultDtoOfGetGroupOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetGroupOutput.fromJS(resultData200) : new ListResultDtoOfGetGroupOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetGroupOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGroupsWithoutPaged(): Observable<ListResultDtoOfGetGroupOutput> {
        let url_ = this.baseUrl + "/api/services/app/Groups/GetAllGroupsWithoutPaged";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllGroupsWithoutPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllGroupsWithoutPaged(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetGroupOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetGroupOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAllGroupsWithoutPaged(response: Response): Observable<ListResultDtoOfGetGroupOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetGroupOutput.fromJS(resultData200) : new ListResultDtoOfGetGroupOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetGroupOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getGroupById(id: number): Observable<GetGroupOutput> {
        let url_ = this.baseUrl + "/api/services/app/Groups/GetGroupById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGroupById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGroupById(response_);
                } catch (e) {
                    return <Observable<GetGroupOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGroupOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetGroupById(response: Response): Observable<GetGroupOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetGroupOutput.fromJS(resultData200) : new GetGroupOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGroupOutput>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @return Success
     */
    getPagedGroups(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedGroupsList> {
        let url_ = this.baseUrl + "/api/services/app/Groups/GetPagedGroups?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedGroups(response_);
                } catch (e) {
                    return <Observable<PagedGroupsList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedGroupsList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedGroups(response: Response): Observable<PagedGroupsList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedGroupsList.fromJS(resultData200) : new PagedGroupsList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedGroupsList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateGroup(input: UpdateGroupInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Groups/UpdateGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteGroup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Groups/DeleteGroup?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Groups/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class HappyHourServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getHappyHour(): Observable<ListResultDtoOfHapptHourListItem> {
        let url_ = this.baseUrl + "/api/services/app/HappyHour/GetHappyHour";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHappyHour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHappyHour(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfHapptHourListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfHapptHourListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetHappyHour(response: Response): Observable<ListResultDtoOfHapptHourListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfHapptHourListItem.fromJS(resultData200) : new ListResultDtoOfHapptHourListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfHapptHourListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedHappyHour(pageNumber: number, pageSize: number): Observable<PagedHappyHourList> {
        let url_ = this.baseUrl + "/api/services/app/HappyHour/GetPagedHappyHour?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedHappyHour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedHappyHour(response_);
                } catch (e) {
                    return <Observable<PagedHappyHourList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedHappyHourList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedHappyHour(response: Response): Observable<PagedHappyHourList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedHappyHourList.fromJS(resultData200) : new PagedHappyHourList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedHappyHourList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getHappyHourById(id: number): Observable<HappyHourDto> {
        let url_ = this.baseUrl + "/api/services/app/HappyHour/GetHappyHourById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHappyHourById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHappyHourById(response_);
                } catch (e) {
                    return <Observable<HappyHourDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HappyHourDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHappyHourById(response: Response): Observable<HappyHourDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HappyHourDto.fromJS(resultData200) : new HappyHourDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HappyHourDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createHappyHour(input: CreateHappyHourInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HappyHour/CreateHappyHour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateHappyHour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateHappyHour(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateHappyHour(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteHappyHour(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HappyHour/DeleteHappyHour?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteHappyHour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteHappyHour(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteHappyHour(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatHappyHour(input: EditHappyHourInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HappyHour/UpdatHappyHour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatHappyHour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatHappyHour(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatHappyHour(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HappyHour/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @incomeStatisticsDateInterval (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getDashboardStatisticsData(incomeStatisticsDateInterval: IncomeStatisticsDateInterval, startDate: moment.Moment, endDate: moment.Moment): Observable<HostDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardStatisticsData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardStatisticsData(response_);
                } catch (e) {
                    return <Observable<HostDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardStatisticsData(response: Response): Observable<HostDashboardData> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostDashboardData.fromJS(resultData200) : new HostDashboardData();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HostDashboardData>(<any>null);
    }

    /**
     * @incomeStatisticsDateInterval (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: IncomeStatisticsDateInterval2, startDate: moment.Moment, endDate: moment.Moment): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIncomeStatistics(response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIncomeStatistics(response: Response): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIncomeStatisticsDataOutput.fromJS(resultData200) : new GetIncomeStatisticsDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment, endDate: moment.Moment): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionTenantStatistics(response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionTenantStatistics(response: Response): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionTenantStatisticsOutput.fromJS(resultData200) : new GetEditionTenantStatisticsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetEditionTenantStatisticsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: Response): Observable<HostSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostSettingsEditDto.fromJS(resultData200) : new HostSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HostSettingsEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: HostSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportCustomerDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCustomersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/GetCustomersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCustomersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCustomersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCustomersToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file Upload file.
     * @return Success
     */
    importCustomerFromExcel(file: any): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/ImportCustomerFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportCustomerFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportCustomerFromExcel(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processImportCustomerFromExcel(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getFoodCustomersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/GetFoodCustomersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFoodCustomersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFoodCustomersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFoodCustomersToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getupdateFoodCustomersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/GetupdateFoodCustomersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetupdateFoodCustomersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetupdateFoodCustomersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetupdateFoodCustomersToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    exportFoodCustomersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/ExportFoodCustomersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportFoodCustomersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportFoodCustomersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportFoodCustomersToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importFoodCustomerFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/ImportFoodCustomerFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportFoodCustomerFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportFoodCustomerFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportFoodCustomerFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importUpdateFoodCustomerFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/ImportUpdateFoodCustomerFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportUpdateFoodCustomerFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportUpdateFoodCustomerFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportUpdateFoodCustomerFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportCustomerData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProductsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportData/GetProductsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file Upload file.
     * @return Success
     */
    importFromExcel(file: any): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ImportData/ImportFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportFromExcel(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processImportFromExcel(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportInventoryOrderDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInventoryOrderToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportInventoryOrderData/GetInventoryOrderToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryOrderToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryOrderToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryOrderToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importInventoryOrderFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportInventoryOrderData/ImportInventoryOrderFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportInventoryOrderFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportInventoryOrderFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportInventoryOrderFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @receiveNumber (optional) 
     * @mainTransactionId (optional) 
     * @transactionType (optional) 
     * @return Success
     */
    receiveNumberUsed(receiveNumber: string, mainTransactionId: number, transactionType: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ImportInventoryOrderData/ReceiveNumberUsed?";
        if (receiveNumber !== undefined)
            url_ += "receiveNumber=" + encodeURIComponent("" + receiveNumber) + "&"; 
        if (mainTransactionId !== undefined)
            url_ += "mainTransactionId=" + encodeURIComponent("" + mainTransactionId) + "&"; 
        if (transactionType !== undefined)
            url_ += "transactionType=" + encodeURIComponent("" + transactionType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReceiveNumberUsed(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReceiveNumberUsed(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processReceiveNumberUsed(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @patternName (optional) 
     * @return Success
     */
    getPatternByName(patternName: string): Observable<CodingPatternSettingListItem> {
        let url_ = this.baseUrl + "/api/services/app/ImportInventoryOrderData/GetPatternByName?";
        if (patternName !== undefined)
            url_ += "patternName=" + encodeURIComponent("" + patternName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPatternByName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPatternByName(response_);
                } catch (e) {
                    return <Observable<CodingPatternSettingListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<CodingPatternSettingListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPatternByName(response: Response): Observable<CodingPatternSettingListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CodingPatternSettingListItem.fromJS(resultData200) : new CodingPatternSettingListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CodingPatternSettingListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportInventoryOrderData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportMainTransactionDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportPurshaseTemplate(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMainTransactionData/ExportPurshaseTemplate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPurshaseTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPurshaseTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPurshaseTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @id (optional) 
     * @return Success
     */
    importPurshaseDetailsFromExcel(file: FileParameter, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ImportMainTransactionData/ImportPurshaseDetailsFromExcel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportPurshaseDetailsFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportPurshaseDetailsFromExcel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImportPurshaseDetailsFromExcel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportOrderTemplate(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMainTransactionData/ExportOrderTemplate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportOrderTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportOrderTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportOrderTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @id (optional) 
     * @return Success
     */
    importOrderDetailsFromExcel(file: FileParameter, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ImportMainTransactionData/ImportOrderDetailsFromExcel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportOrderDetailsFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportOrderDetailsFromExcel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImportOrderDetailsFromExcel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportTransferTemplate(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMainTransactionData/ExportTransferTemplate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTransferTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTransferTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTransferTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @id (optional) 
     * @return Success
     */
    importTransferDetailsFromExcel(file: FileParameter, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ImportMainTransactionData/ImportTransferDetailsFromExcel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportTransferDetailsFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportTransferDetailsFromExcel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImportTransferDetailsFromExcel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportMainTransactionData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportMenuItemDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importMenuItemConfigFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/ImportMenuItemConfigFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportMenuItemConfigFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportMenuItemConfigFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportMenuItemConfigFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    menuItemConfigUpdateExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/MenuItemConfigUpdateExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMenuItemConfigUpdateExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMenuItemConfigUpdateExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processMenuItemConfigUpdateExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importMenuItemFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/ImportMenuItemFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportMenuItemFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportMenuItemFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportMenuItemFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMenuItemsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetMenuItemsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMenUItemsConfigeToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetMenUItemsConfigeToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenUItemsConfigeToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenUItemsConfigeToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenUItemsConfigeToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUpdateMenUItemsConfigesSheet(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetUpdateMenUItemsConfigesSheet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUpdateMenUItemsConfigesSheet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUpdateMenUItemsConfigesSheet(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUpdateMenUItemsConfigesSheet(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMenuItemsTemplate(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetMenuItemsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemsTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemsTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemsTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMenuItemsForUpdateTemplate(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetMenuItemsForUpdateTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemsForUpdateTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemsForUpdateTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemsForUpdateTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    exportMenuItemsTemplate(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/ExportMenuItemsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMenuItemsTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMenuItemsTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMenuItemsTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getStockOpeningTemplate(storeId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetStockOpeningTemplate?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStockOpeningTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStockOpeningTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStockOpeningTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecipyTemplate(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetRecipyTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecipyTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecipyTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecipyTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @menuItemId (optional) 
     * @lossFactor (optional) 
     * @recipeCode (optional) 
     * @excelFile (optional) 
     * @return Success
     */
    importRecipyFromExcel(id: number, menuItemId: number, lossFactor: number, recipeCode: string, excelFile: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/ImportRecipyFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (menuItemId !== null && menuItemId !== undefined)
            content_.append("MenuItemId", menuItemId.toString());
        if (lossFactor !== null && lossFactor !== undefined)
            content_.append("LossFactor", lossFactor.toString());
        if (recipeCode !== null && recipeCode !== undefined)
            content_.append("RecipeCode", recipeCode.toString());
        if (excelFile !== null && excelFile !== undefined)
            content_.append("ExcelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "ExcelFile");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportRecipyFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportRecipyFromExcel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImportRecipyFromExcel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @lotNumber (optional) 
     * @notes (optional) 
     * @file (optional) 
     * @date (optional) 
     * @return Success
     */
    importStockOpenningAdjustmentFromExcel(storeId: number, lotNumber: number, notes: string, file: FileParameter, date: moment.Moment): Observable<DetailTransaction[]> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/ImportStockOpenningAdjustmentFromExcel?";
        if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (storeId !== null && storeId !== undefined)
            content_.append("StoreId", storeId.toString());
        if (lotNumber !== null && lotNumber !== undefined)
            content_.append("LotNumber", lotNumber.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportStockOpenningAdjustmentFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportStockOpenningAdjustmentFromExcel(response_);
                } catch (e) {
                    return <Observable<DetailTransaction[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailTransaction[]>><any>Observable.throw(response_);
        });
    }

    protected processImportStockOpenningAdjustmentFromExcel(response: Response): Observable<DetailTransaction[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DetailTransaction.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailTransaction[]>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    updateMenuItemsFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/UpdateMenuItemsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMenuItemsFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMenuItemsFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMenuItemsFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportMenuItemWasteDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMenuItemWasteToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemWasteData/GetMenuItemWasteToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemWasteToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemWasteToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemWasteToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importMenuItemWasteFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemWasteData/ImportMenuItemWasteFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportMenuItemWasteFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportMenuItemWasteFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportMenuItemWasteFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportMenuItemWasteData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportPurchaseInvoiceOrderDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @vendorId (optional) 
     * @return Success
     */
    getPurchaseInvoiceOrderExcelTemplate(vendorId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportPurchaseInvoiceOrderData/GetPurchaseInvoiceOrderExcelTemplate?";
        if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoiceOrderExcelTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoiceOrderExcelTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoiceOrderExcelTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @contentType (optional) 
     * @contentDisposition (optional) 
     * @headers (optional) 
     * @length (optional) 
     * @name (optional) 
     * @fileName (optional) 
     * @vendorId (optional) 
     * @storeId (optional) 
     * @invoiceNumber (optional) 
     * @purchaseDate (optional) 
     * @discountTypeId (optional) 
     * @discountAmount (optional) 
     * @return Success
     */
    importPurchaseInvoiceOrderFromExcel(contentType: string, contentDisposition: string, headers: any, length: number, name: string, fileName: string, vendorId: number, storeId: number, invoiceNumber: string, purchaseDate: string, discountTypeId: number, discountAmount: number): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportPurchaseInvoiceOrderData/ImportPurchaseInvoiceOrderFromExcel?";
        if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (invoiceNumber !== undefined)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&"; 
        if (purchaseDate !== undefined)
            url_ += "purchaseDate=" + encodeURIComponent("" + purchaseDate) + "&"; 
        if (discountTypeId !== undefined)
            url_ += "discountTypeId=" + encodeURIComponent("" + discountTypeId) + "&"; 
        if (discountAmount !== undefined)
            url_ += "discountAmount=" + encodeURIComponent("" + discountAmount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length !== null && length !== undefined)
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportPurchaseInvoiceOrderFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportPurchaseInvoiceOrderFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportPurchaseInvoiceOrderFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportPurchaseInvoiceOrderData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportRawMaterialConfigDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importRawMaterialConfigFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialConfigData/ImportRawMaterialConfigFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportRawMaterialConfigFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportRawMaterialConfigFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportRawMaterialConfigFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    updateRawMaterialConfigFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialConfigData/UpdateRawMaterialConfigFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRawMaterialConfigFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateRawMaterialConfigFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRawMaterialConfigFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRawMaterialConfigsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialConfigData/GetRawMaterialConfigsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialConfigsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialConfigsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialConfigsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUpdateRawMaterialConfigsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialConfigData/GetUpdateRawMaterialConfigsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUpdateRawMaterialConfigsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUpdateRawMaterialConfigsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUpdateRawMaterialConfigsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    exportRawMaterialConfigsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialConfigData/ExportRawMaterialConfigsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportRawMaterialConfigsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportRawMaterialConfigsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportRawMaterialConfigsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialConfigData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportRawMaterialDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRawMaterialsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialData/GetRawMaterialsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUpdateRawMaterialsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialData/GetUpdateRawMaterialsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUpdateRawMaterialsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUpdateRawMaterialsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUpdateRawMaterialsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRawMaterialsDataToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialData/GetRawMaterialsDataToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialsDataToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialsDataToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialsDataToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importRawMaterialFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialData/ImportRawMaterialFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportRawMaterialFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportRawMaterialFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportRawMaterialFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    updateRawMaterialFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialData/UpdateRawMaterialFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRawMaterialFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateRawMaterialFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRawMaterialFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportRawMaterialWasteDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRawMaterialWasteToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialWasteData/GetRawMaterialWasteToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialWasteToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialWasteToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialWasteToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importRawMaterialWasteFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialWasteData/ImportRawMaterialWasteFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportRawMaterialWasteFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportRawMaterialWasteFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportRawMaterialWasteFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportRawMaterialWasteData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportRecipesDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @isUpdate (optional) 
     * @return Success
     */
    getRecipesToExcel(isUpdate: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportRecipesData/GetRecipesToExcel?";
        if (isUpdate !== undefined)
            url_ += "isUpdate=" + encodeURIComponent("" + isUpdate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecipesToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecipesToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecipesToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importRecipesFromExcel(file: FileParameter): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ImportRecipesData/ImportRecipesFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportRecipesFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportRecipesFromExcel(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processImportRecipesFromExcel(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportRecipesData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ImportVariantDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getVariantsTemplate(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportVariantData/GetVariantsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVariantsTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVariantsTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetVariantsTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importVariantFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportVariantData/ImportVariantFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportVariantFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportVariantFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportVariantFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getModifiersGroupAndOptionsTemplate(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportVariantData/GetModifiersGroupAndOptionsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetModifiersGroupAndOptionsTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetModifiersGroupAndOptionsTemplate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetModifiersGroupAndOptionsTemplate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file (optional) 
     * @return Success
     */
    importModifiersGroupAndOptionsFromExcel(file: FileParameter): Observable<ExcelUploadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ImportVariantData/ImportModifiersGroupAndOptionsFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportModifiersGroupAndOptionsFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportModifiersGroupAndOptionsFromExcel(response_);
                } catch (e) {
                    return <Observable<ExcelUploadResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelUploadResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processImportModifiersGroupAndOptionsFromExcel(response: Response): Observable<ExcelUploadResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExcelUploadResponseDto.fromJS(resultData200) : new ExcelUploadResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelUploadResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ImportVariantData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setup(input: InstallDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAppSettingsJson(response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAppSettingsJson(response: Response): Observable<AppSettingsJsonDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDatabase(response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>Observable.throw(response_);
        });
    }

    protected processCheckDatabase(response: Response): Observable<CheckDatabaseOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckDatabaseOutput.fromJS(resultData200) : new CheckDatabaseOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckDatabaseOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class InventoryOrdersServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInventoryOrder(input: CreateInventoryOrderInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/CreateInventoryOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInventoryOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInventoryOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactionType (optional) 
     * @return Success
     */
    insertTransactionType(transactionType: TransactionTypeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/InsertTransactionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionType);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTransactionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTransactionType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertTransactionType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getInventoryOrders(): Observable<ListResultDtoOfInventoryOrderListItem> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetInventoryOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryOrders(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryOrders(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInventoryOrderListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfInventoryOrderListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryOrders(response: Response): Observable<ListResultDtoOfInventoryOrderListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInventoryOrderListItem.fromJS(resultData200) : new ListResultDtoOfInventoryOrderListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfInventoryOrderListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getInventoryOrdersPending(): Observable<ListResultDtoOfInventoryOrderListItem> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetInventoryOrdersPending";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryOrdersPending(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryOrdersPending(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInventoryOrderListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfInventoryOrderListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryOrdersPending(response: Response): Observable<ListResultDtoOfInventoryOrderListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInventoryOrderListItem.fromJS(resultData200) : new ListResultDtoOfInventoryOrderListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfInventoryOrderListItem>(<any>null);
    }

    /**
     * @itemCode (optional) 
     * @recieptNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @status (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedInventoryOrderByStatus(itemCode: string, recieptNumber: string, from: moment.Moment, to: moment.Moment, status: number, pageNumber: number, pageSize: number): Observable<PagedInventoryOrderList> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetPagedInventoryOrderByStatus?";
        if (itemCode !== undefined)
            url_ += "ItemCode=" + encodeURIComponent("" + itemCode) + "&"; 
        if (recieptNumber !== undefined)
            url_ += "RecieptNumber=" + encodeURIComponent("" + recieptNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedInventoryOrderByStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedInventoryOrderByStatus(response_);
                } catch (e) {
                    return <Observable<PagedInventoryOrderList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedInventoryOrderList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedInventoryOrderByStatus(response: Response): Observable<PagedInventoryOrderList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedInventoryOrderList.fromJS(resultData200) : new PagedInventoryOrderList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedInventoryOrderList>(<any>null);
    }

    /**
     * @itemCode (optional) 
     * @recieptNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @status (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedInventoryOrder(itemCode: string, recieptNumber: string, from: moment.Moment, to: moment.Moment, status: number, pageNumber: number, pageSize: number): Observable<PagedInventoryOrderList> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetPagedInventoryOrder?";
        if (itemCode !== undefined)
            url_ += "ItemCode=" + encodeURIComponent("" + itemCode) + "&"; 
        if (recieptNumber !== undefined)
            url_ += "RecieptNumber=" + encodeURIComponent("" + recieptNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedInventoryOrder(response_);
                } catch (e) {
                    return <Observable<PagedInventoryOrderList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedInventoryOrderList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedInventoryOrder(response: Response): Observable<PagedInventoryOrderList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedInventoryOrderList.fromJS(resultData200) : new PagedInventoryOrderList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedInventoryOrderList>(<any>null);
    }

    /**
     * @id (optional) 
     * @detail (optional) 
     * @return Success
     */
    getInventoryOrder(id: number, detail: boolean): Observable<InventoryOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetInventoryOrder?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (detail !== undefined)
            url_ += "detail=" + encodeURIComponent("" + detail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryOrder(response_);
                } catch (e) {
                    return <Observable<InventoryOrderDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InventoryOrderDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryOrder(response: Response): Observable<InventoryOrderDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InventoryOrderDto.fromJS(resultData200) : new InventoryOrderDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InventoryOrderDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInventoryOrderById(id: number): Observable<InventoryOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetInventoryOrderById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryOrderById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryOrderById(response_);
                } catch (e) {
                    return <Observable<InventoryOrderDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InventoryOrderDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryOrderById(response: Response): Observable<InventoryOrderDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InventoryOrderDto.fromJS(resultData200) : new InventoryOrderDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InventoryOrderDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInventoryOrderDetailsById(id: number): Observable<InventoryOrderProductLotDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetInventoryOrderDetailsById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryOrderDetailsById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryOrderDetailsById(response_);
                } catch (e) {
                    return <Observable<InventoryOrderProductLotDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<InventoryOrderProductLotDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryOrderDetailsById(response: Response): Observable<InventoryOrderProductLotDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(InventoryOrderProductLotDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InventoryOrderProductLotDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    approveInventoryOrder(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/ApproveInventoryOrder?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processApproveInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processApproveInventoryOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processApproveInventoryOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    rejectInventoryOrder(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/RejectInventoryOrder?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRejectInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRejectInventoryOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRejectInventoryOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    editInventoryOrder(input: UpdateInventoryOrderInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/EditInventoryOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditInventoryOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEditInventoryOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    transactionTypeList(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/TransactionTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTransactionTypeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTransactionTypeList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransactionTypeList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InventoryOrders/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class InventoryReportsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreQuantitiesIssuedReport(input: StoreQuantitiesIssuedReportInput, pagenumber: number, pageSize: number): Observable<StoreQuantitiesIssuedReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreQuantitiesIssuedReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreQuantitiesIssuedReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreQuantitiesIssuedReport(response_);
                } catch (e) {
                    return <Observable<StoreQuantitiesIssuedReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreQuantitiesIssuedReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreQuantitiesIssuedReport(response: Response): Observable<StoreQuantitiesIssuedReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreQuantitiesIssuedReportPage.fromJS(resultData200) : new StoreQuantitiesIssuedReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreQuantitiesIssuedReportPage>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @materialIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStoreQuantitiesIssuedReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, materialIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportStoreQuantitiesIssuedReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStoreQuantitiesIssuedReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStoreQuantitiesIssuedReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStoreQuantitiesIssuedReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    storeOrderReportPage(input: StoreOrderReportInput, pagenumber: number, pageSize: number): Observable<StoreOrderReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/StoreOrderReportPage?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStoreOrderReportPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStoreOrderReportPage(response_);
                } catch (e) {
                    return <Observable<StoreOrderReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreOrderReportPage>><any>Observable.throw(response_);
        });
    }

    protected processStoreOrderReportPage(response: Response): Observable<StoreOrderReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreOrderReportPage.fromJS(resultData200) : new StoreOrderReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreOrderReportPage>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @storeId (optional) 
     * @destinationIds (optional) 
     * @supplierId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @materialIds (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreOrderReportDetail(tenantName: string, storeId: number, destinationIds: number[], supplierId: number, fromDate: moment.Moment, toDate: moment.Moment, materialIds: number[], pagenumber: number, pageSize: number): Observable<StoreOrderReportDetails> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreOrderReportDetail?";
        if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (destinationIds !== undefined)
            destinationIds && destinationIds.forEach(item => { url_ += "DestinationIds=" + encodeURIComponent("" + item) + "&"; });
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreOrderReportDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreOrderReportDetail(response_);
                } catch (e) {
                    return <Observable<StoreOrderReportDetails>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreOrderReportDetails>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreOrderReportDetail(response: Response): Observable<StoreOrderReportDetails> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreOrderReportDetails.fromJS(resultData200) : new StoreOrderReportDetails();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreOrderReportDetails>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @sourceStorId (optional) 
     * @storeId (optional) 
     * @date (optional) 
     * @materialId (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    storeOrderReportUserDetail(tenantName: string, sourceStorId: number, storeId: number, date: moment.Moment, materialId: number, pagenumber: number, pageSize: number): Observable<StoreReportUserDetail> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/StoreOrderReportUserDetail?";
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (sourceStorId !== undefined)
            url_ += "sourceStorId=" + encodeURIComponent("" + sourceStorId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStoreOrderReportUserDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStoreOrderReportUserDetail(response_);
                } catch (e) {
                    return <Observable<StoreReportUserDetail>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreReportUserDetail>><any>Observable.throw(response_);
        });
    }

    protected processStoreOrderReportUserDetail(response: Response): Observable<StoreReportUserDetail> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreReportUserDetail.fromJS(resultData200) : new StoreReportUserDetail();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreReportUserDetail>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @sourceStorId (optional) 
     * @storeId (optional) 
     * @date (optional) 
     * @materialId (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    storeTransferOutReportUserDetail(tenantName: string, sourceStorId: number, storeId: number, date: moment.Moment, materialId: number, pagenumber: number, pageSize: number): Observable<StoreReportUserDetail> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/StoreTransferOutReportUserDetail?";
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (sourceStorId !== undefined)
            url_ += "sourceStorId=" + encodeURIComponent("" + sourceStorId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStoreTransferOutReportUserDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStoreTransferOutReportUserDetail(response_);
                } catch (e) {
                    return <Observable<StoreReportUserDetail>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreReportUserDetail>><any>Observable.throw(response_);
        });
    }

    protected processStoreTransferOutReportUserDetail(response: Response): Observable<StoreReportUserDetail> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreReportUserDetail.fromJS(resultData200) : new StoreReportUserDetail();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreReportUserDetail>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @materialIds (optional) 
     * @isCSVFile (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreTransferOutReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, materialIds: number[], isCSVFile: boolean, pagenumber: number, pageSize: number): Observable<StoreTransferOutReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreTransferOutReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreTransferOutReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreTransferOutReport(response_);
                } catch (e) {
                    return <Observable<StoreTransferOutReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreTransferOutReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreTransferOutReport(response: Response): Observable<StoreTransferOutReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreTransferOutReportPage.fromJS(resultData200) : new StoreTransferOutReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreTransferOutReportPage>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @storeId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @materialIds (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreTransferOutReportDetails(tenantName: string, storeId: number, fromDate: moment.Moment, toDate: moment.Moment, materialIds: number[], pagenumber: number, pageSize: number): Observable<StoreTransferOutDetailReport> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreTransferOutReportDetails?";
        if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreTransferOutReportDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreTransferOutReportDetails(response_);
                } catch (e) {
                    return <Observable<StoreTransferOutDetailReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreTransferOutDetailReport>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreTransferOutReportDetails(response: Response): Observable<StoreTransferOutDetailReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreTransferOutDetailReport.fromJS(resultData200) : new StoreTransferOutDetailReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreTransferOutDetailReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    stockValuesReportFBWithCost(input: StockValuesReportFilter, pageNumber: number, pageSize: number): Observable<StockValuesPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/StockValuesReportFBWithCost?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStockValuesReportFBWithCost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStockValuesReportFBWithCost(response_);
                } catch (e) {
                    return <Observable<StockValuesPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StockValuesPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processStockValuesReportFBWithCost(response: Response): Observable<StockValuesPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StockValuesPagedDto.fromJS(resultData200) : new StockValuesPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StockValuesPagedDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @matrialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantsIds (optional) 
     * @isEndOfDay (optional) 
     * @showZeroTransactions (optional) 
     * @showMaterialName (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStockValuesReportFB(storeIds: number[], matrialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, tenantsIds: number[], isEndOfDay: boolean, showZeroTransactions: boolean, showMaterialName: boolean, regionId: number, areaId: number, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportStockValuesReportFB?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialIds !== undefined)
            matrialIds && matrialIds.forEach(item => { url_ += "MatrialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showZeroTransactions !== undefined)
            url_ += "ShowZeroTransactions=" + encodeURIComponent("" + showZeroTransactions) + "&"; 
        if (showMaterialName !== undefined)
            url_ += "ShowMaterialName=" + encodeURIComponent("" + showMaterialName) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockValuesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockValuesReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockValuesReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    materialStockTransactionReportWithPeriods(paramters: MaterialInentoryVarianceReportFilter, pagenumber: number, pagesize: number): Observable<MaterialStockTransactionWithPeriodsPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/MaterialStockTransactionReportWithPeriods?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMaterialStockTransactionReportWithPeriods(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMaterialStockTransactionReportWithPeriods(response_);
                } catch (e) {
                    return <Observable<MaterialStockTransactionWithPeriodsPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockTransactionWithPeriodsPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processMaterialStockTransactionReportWithPeriods(response: Response): Observable<MaterialStockTransactionWithPeriodsPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockTransactionWithPeriodsPagedDto.fromJS(resultData200) : new MaterialStockTransactionWithPeriodsPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockTransactionWithPeriodsPagedDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @matrialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantId (optional) 
     * @isEndOfDay (optional) 
     * @showZeroTransactions (optional) 
     * @showMaterialName (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportMaterialStockTransactionReportWithPeriods(storeIds: number[], matrialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, tenantId: number, isEndOfDay: boolean, showZeroTransactions: boolean, showMaterialName: boolean, regionId: number, areaId: number, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportMaterialStockTransactionReportWithPeriods?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialIds !== undefined)
            matrialIds && matrialIds.forEach(item => { url_ += "MatrialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showZeroTransactions !== undefined)
            url_ += "ShowZeroTransactions=" + encodeURIComponent("" + showZeroTransactions) + "&"; 
        if (showMaterialName !== undefined)
            url_ += "ShowMaterialName=" + encodeURIComponent("" + showMaterialName) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMaterialStockTransactionReportWithPeriods(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMaterialStockTransactionReportWithPeriods(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMaterialStockTransactionReportWithPeriods(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    materialStockTransactionReportWithPeriodsAndEndOfDay(paramters: MaterialInentoryVarianceReportFilterDto, pagenumber: number, pagesize: number): Observable<MaterialStockTransactionWithPeriodsPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/MaterialStockTransactionReportWithPeriodsAndEndOfDay?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMaterialStockTransactionReportWithPeriodsAndEndOfDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMaterialStockTransactionReportWithPeriodsAndEndOfDay(response_);
                } catch (e) {
                    return <Observable<MaterialStockTransactionWithPeriodsPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockTransactionWithPeriodsPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processMaterialStockTransactionReportWithPeriodsAndEndOfDay(response: Response): Observable<MaterialStockTransactionWithPeriodsPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockTransactionWithPeriodsPagedDto.fromJS(resultData200) : new MaterialStockTransactionWithPeriodsPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockTransactionWithPeriodsPagedDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @matrialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantsIds (optional) 
     * @isEndOfDay (optional) 
     * @showZeroTransactions (optional) 
     * @showMaterialName (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportMaterialStockTransactionReportWithPeriodsAndEndOfDay(storeIds: number[], matrialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, tenantsIds: number[], isEndOfDay: boolean, showZeroTransactions: boolean, showMaterialName: boolean, regionId: number, areaId: number, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportMaterialStockTransactionReportWithPeriodsAndEndOfDay?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialIds !== undefined)
            matrialIds && matrialIds.forEach(item => { url_ += "MatrialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showZeroTransactions !== undefined)
            url_ += "ShowZeroTransactions=" + encodeURIComponent("" + showZeroTransactions) + "&"; 
        if (showMaterialName !== undefined)
            url_ += "ShowMaterialName=" + encodeURIComponent("" + showMaterialName) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMaterialStockTransactionReportWithPeriodsAndEndOfDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMaterialStockTransactionReportWithPeriodsAndEndOfDay(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMaterialStockTransactionReportWithPeriodsAndEndOfDay(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    materialStockTransactionReportWithPeriodsWithCost(paramters: MaterialInentoryVarianceReportFilterDto, pagenumber: number, pagesize: number): Observable<MaterialStockTransactionWithPeriodsAndCostPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/MaterialStockTransactionReportWithPeriodsWithCost?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMaterialStockTransactionReportWithPeriodsWithCost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMaterialStockTransactionReportWithPeriodsWithCost(response_);
                } catch (e) {
                    return <Observable<MaterialStockTransactionWithPeriodsAndCostPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockTransactionWithPeriodsAndCostPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processMaterialStockTransactionReportWithPeriodsWithCost(response: Response): Observable<MaterialStockTransactionWithPeriodsAndCostPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockTransactionWithPeriodsAndCostPagedDto.fromJS(resultData200) : new MaterialStockTransactionWithPeriodsAndCostPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockTransactionWithPeriodsAndCostPagedDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @matrialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantsIds (optional) 
     * @isEndOfDay (optional) 
     * @showZeroTransactions (optional) 
     * @showMaterialName (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportMaterialStockTransactionReportWithPeriodsWithCost(storeIds: number[], matrialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, tenantsIds: number[], isEndOfDay: boolean, showZeroTransactions: boolean, showMaterialName: boolean, regionId: number, areaId: number, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportMaterialStockTransactionReportWithPeriodsWithCost?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialIds !== undefined)
            matrialIds && matrialIds.forEach(item => { url_ += "MatrialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showZeroTransactions !== undefined)
            url_ += "ShowZeroTransactions=" + encodeURIComponent("" + showZeroTransactions) + "&"; 
        if (showMaterialName !== undefined)
            url_ += "ShowMaterialName=" + encodeURIComponent("" + showMaterialName) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMaterialStockTransactionReportWithPeriodsWithCost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMaterialStockTransactionReportWithPeriodsWithCost(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMaterialStockTransactionReportWithPeriodsWithCost(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    materialStockTransactionReport(paramters: MaterialInentoryVarianceReportFilterDto, pagenumber: number, pagesize: number): Observable<MaterialStockTransactionWithPeriodsPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/MaterialStockTransactionReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMaterialStockTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMaterialStockTransactionReport(response_);
                } catch (e) {
                    return <Observable<MaterialStockTransactionWithPeriodsPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockTransactionWithPeriodsPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processMaterialStockTransactionReport(response: Response): Observable<MaterialStockTransactionWithPeriodsPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockTransactionWithPeriodsPagedDto.fromJS(resultData200) : new MaterialStockTransactionWithPeriodsPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockTransactionWithPeriodsPagedDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @matrialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantsIds (optional) 
     * @isEndOfDay (optional) 
     * @showZeroTransactions (optional) 
     * @showMaterialName (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportMaterialStockTransactionReport(storeIds: number[], matrialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, tenantsIds: number[], isEndOfDay: boolean, showZeroTransactions: boolean, showMaterialName: boolean, regionId: number, areaId: number, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportMaterialStockTransactionReport?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialIds !== undefined)
            matrialIds && matrialIds.forEach(item => { url_ += "MatrialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showZeroTransactions !== undefined)
            url_ += "ShowZeroTransactions=" + encodeURIComponent("" + showZeroTransactions) + "&"; 
        if (showMaterialName !== undefined)
            url_ += "ShowMaterialName=" + encodeURIComponent("" + showMaterialName) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMaterialStockTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMaterialStockTransactionReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMaterialStockTransactionReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @materialIds (optional) 
     * @isCSVFile (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreRawWasteReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, materialIds: number[], isCSVFile: boolean, pagenumber: number, pageSize: number): Observable<StoreRawWasteReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreRawWasteReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreRawWasteReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreRawWasteReport(response_);
                } catch (e) {
                    return <Observable<StoreRawWasteReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreRawWasteReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreRawWasteReport(response: Response): Observable<StoreRawWasteReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreRawWasteReportPage.fromJS(resultData200) : new StoreRawWasteReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreRawWasteReportPage>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @storeId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @materialIds (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreRawWasteDetailReport(tenantName: string, storeId: number, fromDate: moment.Moment, toDate: moment.Moment, materialIds: number[], pagenumber: number, pageSize: number): Observable<StoreRawWasteDetailReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreRawWasteDetailReport?";
        if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreRawWasteDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreRawWasteDetailReport(response_);
                } catch (e) {
                    return <Observable<StoreRawWasteDetailReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreRawWasteDetailReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreRawWasteDetailReport(response: Response): Observable<StoreRawWasteDetailReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreRawWasteDetailReportPage.fromJS(resultData200) : new StoreRawWasteDetailReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreRawWasteDetailReportPage>(<any>null);
    }

    /**
     * @storesIds (optional) 
     * @tenantsIds (optional) 
     * @materialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getBatchRecipeReport(storesIds: number[], tenantsIds: number[], materialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, pagenumber: number, pageSize: number): Observable<TenantBatchRecipePage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetBatchRecipeReport?";
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBatchRecipeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBatchRecipeReport(response_);
                } catch (e) {
                    return <Observable<TenantBatchRecipePage>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantBatchRecipePage>><any>Observable.throw(response_);
        });
    }

    protected processGetBatchRecipeReport(response: Response): Observable<TenantBatchRecipePage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantBatchRecipePage.fromJS(resultData200) : new TenantBatchRecipePage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantBatchRecipePage>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @storeId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @materialId (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreBatchDetailReport(tenantName: string, storeId: number, fromDate: moment.Moment, toDate: moment.Moment, materialId: number, pagenumber: number, pageSize: number): Observable<StoreBatchRecipDetailReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreBatchDetailReport?";
        if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (materialId !== undefined)
            url_ += "MaterialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreBatchDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreBatchDetailReport(response_);
                } catch (e) {
                    return <Observable<StoreBatchRecipDetailReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreBatchRecipDetailReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreBatchDetailReport(response: Response): Observable<StoreBatchRecipDetailReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreBatchRecipDetailReportPage.fromJS(resultData200) : new StoreBatchRecipDetailReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreBatchRecipDetailReportPage>(<any>null);
    }

    /**
     * @isCSVFile (optional) 
     * @storesIds (optional) 
     * @tenantsIds (optional) 
     * @materialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportBatchRecipeListReport(isCSVFile: boolean, storesIds: number[], tenantsIds: number[], materialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportBatchRecipeListReport?";
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportBatchRecipeListReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportBatchRecipeListReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportBatchRecipeListReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @storeId (optional) 
     * @date (optional) 
     * @materialId (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    storeRawWasteReportUserDetail(tenantName: string, storeId: number, date: moment.Moment, materialId: number, pagenumber: number, pageSize: number): Observable<StoreReportUserDetail> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/StoreRawWasteReportUserDetail?";
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStoreRawWasteReportUserDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStoreRawWasteReportUserDetail(response_);
                } catch (e) {
                    return <Observable<StoreReportUserDetail>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreReportUserDetail>><any>Observable.throw(response_);
        });
    }

    protected processStoreRawWasteReportUserDetail(response: Response): Observable<StoreReportUserDetail> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreReportUserDetail.fromJS(resultData200) : new StoreReportUserDetail();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreReportUserDetail>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @menuItemIds (optional) 
     * @isCSVFile (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreMenuItemWasteReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, menuItemIds: number[], isCSVFile: boolean, pagenumber: number, pageSize: number): Observable<StoreMenuItemWasteReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreMenuItemWasteReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreMenuItemWasteReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreMenuItemWasteReport(response_);
                } catch (e) {
                    return <Observable<StoreMenuItemWasteReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreMenuItemWasteReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreMenuItemWasteReport(response: Response): Observable<StoreMenuItemWasteReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreMenuItemWasteReportPage.fromJS(resultData200) : new StoreMenuItemWasteReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreMenuItemWasteReportPage>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @storeId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @materialIds (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreMenuItemWasteDetailReport(tenantName: string, storeId: number, fromDate: moment.Moment, toDate: moment.Moment, materialIds: number[], pagenumber: number, pageSize: number): Observable<StoreMenuItemWastDetailReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreMenuItemWasteDetailReport?";
        if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreMenuItemWasteDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreMenuItemWasteDetailReport(response_);
                } catch (e) {
                    return <Observable<StoreMenuItemWastDetailReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreMenuItemWastDetailReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreMenuItemWasteDetailReport(response: Response): Observable<StoreMenuItemWastDetailReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreMenuItemWastDetailReportPage.fromJS(resultData200) : new StoreMenuItemWastDetailReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreMenuItemWastDetailReportPage>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @menuItemIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStoreMenuItemWastListReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, menuItemIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportStoreMenuItemWastListReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStoreMenuItemWastListReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStoreMenuItemWastListReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStoreMenuItemWastListReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @materialIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportGetStoreTransferOutReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, materialIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportGetStoreTransferOutReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportGetStoreTransferOutReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportGetStoreTransferOutReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportGetStoreTransferOutReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @sourceIds (optional) 
     * @destinationIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @materialIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStoreOrderReport(tenantsIds: number[], regionId: number, areaId: number, sourceIds: number[], destinationIds: number[], fromDate: moment.Moment, toDate: moment.Moment, materialIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportStoreOrderReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(item => { url_ += "SourceIds=" + encodeURIComponent("" + item) + "&"; });
        if (destinationIds !== undefined)
            destinationIds && destinationIds.forEach(item => { url_ += "DestinationIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStoreOrderReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStoreOrderReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStoreOrderReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @materialIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStoreRawWasteListReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, materialIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportStoreRawWasteListReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStoreRawWasteListReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStoreRawWasteListReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStoreRawWasteListReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    storeReceiveReport(input: StoreReceiveReportInput, pagenumber: number, pageSize: number): Observable<StoreReceiveReportPage> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/StoreReceiveReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStoreReceiveReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStoreReceiveReport(response_);
                } catch (e) {
                    return <Observable<StoreReceiveReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreReceiveReportPage>><any>Observable.throw(response_);
        });
    }

    protected processStoreReceiveReport(response: Response): Observable<StoreReceiveReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreReceiveReportPage.fromJS(resultData200) : new StoreReceiveReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreReceiveReportPage>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @storeId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @status (optional) 
     * @materialIds (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getStoreReceiveReportDetail(tenantName: string, storeId: number, fromDate: moment.Moment, toDate: moment.Moment, status: number, materialIds: number[], pagenumber: number, pageSize: number): Observable<StoreReceiveReportDetails> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetStoreReceiveReportDetail?";
        if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreReceiveReportDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreReceiveReportDetail(response_);
                } catch (e) {
                    return <Observable<StoreReceiveReportDetails>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreReceiveReportDetails>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreReceiveReportDetail(response: Response): Observable<StoreReceiveReportDetails> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreReceiveReportDetails.fromJS(resultData200) : new StoreReceiveReportDetails();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreReceiveReportDetails>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    storeReceiveReportPaged(input: StoreReceiveReportInput, pagenumber: number, pageSize: number): Observable<StoreReceiveReportPaged> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/StoreReceiveReportPaged?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStoreReceiveReportPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStoreReceiveReportPaged(response_);
                } catch (e) {
                    return <Observable<StoreReceiveReportPaged>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreReceiveReportPaged>><any>Observable.throw(response_);
        });
    }

    protected processStoreReceiveReportPaged(response: Response): Observable<StoreReceiveReportPaged> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreReceiveReportPaged.fromJS(resultData200) : new StoreReceiveReportPaged();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreReceiveReportPaged>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @sourceIds (optional) 
     * @destinationIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @status (optional) 
     * @materialIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStoreReceiveReport(tenantsIds: number[], sourceIds: number[], destinationIds: number[], fromDate: moment.Moment, toDate: moment.Moment, regionId: number, areaId: number, status: number, materialIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/ExportStoreReceiveReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(item => { url_ += "SourceIds=" + encodeURIComponent("" + item) + "&"; });
        if (destinationIds !== undefined)
            destinationIds && destinationIds.forEach(item => { url_ += "DestinationIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStoreReceiveReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStoreReceiveReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStoreReceiveReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/inventoryReports/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class InventoryTransferServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInventoryTransfer(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/GetInventoryTransfer?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryTransfer(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryTransfer(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInventoryTransfers(): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/GetInventoryTransfers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryTransfers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryTransfers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryTransfers(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/GetCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStock(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/UpdateMaterialStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStock(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStock(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInventoryTransfer(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/CreateInventoryTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInventoryTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInventoryTransfer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInventoryTransfer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkMatrialsQuantites(input: CreateMainTransactionInput): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/CheckMatrialsQuantites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckMatrialsQuantites(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckMatrialsQuantites(response_);
                } catch (e) {
                    return <Observable<ResponseModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponseModel>><any>Observable.throw(response_);
        });
    }

    protected processCheckMatrialsQuantites(response: Response): Observable<ResponseModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponseModel.fromJS(resultData200) : new ResponseModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponseModel>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateInventoryTransfer(input: UpdateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/UpdateInventoryTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateInventoryTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateInventoryTransfer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateInventoryTransfer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @rawMaterialId (optional) 
     * @return Success
     */
    getExpectedQuantity(storeId: number, rawMaterialId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/GetExpectedQuantity?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExpectedQuantity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExpectedQuantity(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetExpectedQuantity(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteInventoryTransfer(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/DeleteInventoryTransfer?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteInventoryTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteInventoryTransfer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteInventoryTransfer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    pagedInventoryTransfer(input: MainTransactionInput, pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/PagedInventoryTransfer?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPagedInventoryTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPagedInventoryTransfer(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processPagedInventoryTransfer(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @to (optional) 
     * @from (optional) 
     * @documentType (optional) 
     * @transactionId (optional) 
     * @storeIds (optional) 
     * @destinationIds (optional) 
     * @status (optional) 
     * @documentNumber (optional) 
     * @invoiceNumber (optional) 
     * @return Success
     */
    exportMainTransactionTransferReport(to: moment.Moment, from: moment.Moment, documentType: number, transactionId: number, storeIds: number[], destinationIds: number[], status: number, documentNumber: string, invoiceNumber: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/ExportMainTransactionTransferReport?";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (transactionId !== undefined)
            url_ += "TransactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (destinationIds !== undefined)
            destinationIds && destinationIds.forEach(item => { url_ += "DestinationIds=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (documentNumber !== undefined)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&"; 
        if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMainTransactionTransferReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMainTransactionTransferReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMainTransactionTransferReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @documentNumber (optional) 
     * @mainTransactionId (optional) 
     * @return Success
     */
    documentNumberUsed(documentNumber: string, mainTransactionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/DocumentNumberUsed?";
        if (documentNumber !== undefined)
            url_ += "documentNumber=" + encodeURIComponent("" + documentNumber) + "&"; 
        if (mainTransactionId !== undefined)
            url_ += "mainTransactionId=" + encodeURIComponent("" + mainTransactionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDocumentNumberUsed(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDocumentNumberUsed(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processDocumentNumberUsed(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InventoryTransfer/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoiceInfo(response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InvoiceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoiceInfo(response: Response): Observable<InvoiceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InvoiceDto.fromJS(resultData200) : new InvoiceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InvoiceDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInvoice(input: CreateInvoiceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ItemsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @categoryId (optional) 
     * @return Success
     */
    getCategoryItems(categoryId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Items/GetCategoryItems?";
        if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCategoryItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCategoryItems(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetCategoryItems(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAllItems(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Items/GetAllItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllItems(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAllItems(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @search (optional) 
     * @return Success
     */
    itemsSearch(search: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Items/ItemsSearch?";
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processItemsSearch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processItemsSearch(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processItemsSearch(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Items/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class KIOSKWorkFlowServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getKIOSKWorkFlowPage(pageNumber: number, pageSize: number): Observable<KIOSKWorkFlowPageDto> {
        let url_ = this.baseUrl + "/api/services/app/KIOSKWorkFlow/GetKIOSKWorkFlowPage?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKIOSKWorkFlowPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKIOSKWorkFlowPage(response_);
                } catch (e) {
                    return <Observable<KIOSKWorkFlowPageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<KIOSKWorkFlowPageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetKIOSKWorkFlowPage(response: Response): Observable<KIOSKWorkFlowPageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KIOSKWorkFlowPageDto.fromJS(resultData200) : new KIOSKWorkFlowPageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<KIOSKWorkFlowPageDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<KIOSKWorkFlowDto> {
        let url_ = this.baseUrl + "/api/services/app/KIOSKWorkFlow/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<KIOSKWorkFlowDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<KIOSKWorkFlowDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<KIOSKWorkFlowDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KIOSKWorkFlowDto.fromJS(resultData200) : new KIOSKWorkFlowDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<KIOSKWorkFlowDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateKIOSKWorkFlowInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KIOSKWorkFlow/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateKIOSKWorkFlowInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KIOSKWorkFlow/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KIOSKWorkFlow/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/KIOSKWorkFlow/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguages(response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguages(response: Response): Observable<GetLanguagesOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguagesOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetActiveLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActiveLanguages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActiveLanguages(response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetActiveLanguages(response: Response): Observable<GetLanguagesOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguagesOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguageForEdit(response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageForEdit(response: Response): Observable<GetLanguageForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguageForEditOutput.fromJS(resultData200) : new GetLanguageForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLanguage(input: CreateOrUpdateLanguageInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteLanguage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setDefaultLanguage(input: SetDefaultLanguageInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetDefaultLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDefaultLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @sorting (optional) 
     * @baseLanguageName (optional) 
     * @targetValueFilter (optional) 
     * @filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number, skipCount: number, sorting: string, sourceName: string, baseLanguageName: string, targetLanguageName: string, targetValueFilter: string, filterText: string): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&"; 
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&"; 
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&"; 
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&"; 
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguageTexts(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageTexts(response: Response): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLanguageTextListDto.fromJS(resultData200) : new PagedResultDtoOfLanguageTextListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateLanguageText(input: UpdateLanguageTextInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateLanguageText(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateLanguageText(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class LevelsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedLevels(pageNumber: number, pageSize: number, searchKey: string, descending: boolean): Observable<PagedLevelsList> {
        let url_ = this.baseUrl + "/api/services/app/Levels/GetPagedLevels?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedLevels(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedLevels(response_);
                } catch (e) {
                    return <Observable<PagedLevelsList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedLevelsList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedLevels(response: Response): Observable<PagedLevelsList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedLevelsList.fromJS(resultData200) : new PagedLevelsList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedLevelsList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createLevel(input: CreateLevelInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Levels/CreateLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateLevel(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateLevel(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteLevel(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Levels/DeleteLevel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteLevel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLevel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getLevel(id: number): Observable<LevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Levels/GetLevel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLevel(response_);
                } catch (e) {
                    return <Observable<LevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLevel(response: Response): Observable<LevelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LevelDto.fromJS(resultData200) : new LevelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LevelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLevels(): Observable<ListResultDtoOfLevelListItem> {
        let url_ = this.baseUrl + "/api/services/app/Levels/GetLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLevels(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLevels(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLevelListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfLevelListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetLevels(response: Response): Observable<ListResultDtoOfLevelListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLevelListItem.fromJS(resultData200) : new ListResultDtoOfLevelListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfLevelListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getLevelsWithProductCategories(): Observable<ListResultDtoOfLevelItem> {
        let url_ = this.baseUrl + "/api/services/app/Levels/GetLevelsWithProductCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLevelsWithProductCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLevelsWithProductCategories(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLevelItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfLevelItem>><any>Observable.throw(response_);
        });
    }

    protected processGetLevelsWithProductCategories(response: Response): Observable<ListResultDtoOfLevelItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLevelItem.fromJS(resultData200) : new ListResultDtoOfLevelItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfLevelItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateLevel(input: UpdateLevelInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Levels/UpdateLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateLevel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateLevel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Levels/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @levelid (optional) 
     * @return Success
     */
    deleteLevelImage(levelid: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Levels/DeleteLevelImage?";
        if (levelid !== undefined)
            url_ += "levelid=" + encodeURIComponent("" + levelid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLevelImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteLevelImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLevelImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Levels/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class LoyalityAccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @accountInput (optional) 
     * @return Success
     */
    createAccount(accountInput: CreateAccountInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/CreateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountInput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteAccount(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/DeleteAccount?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAccount(id: string): Observable<UpdateAccountInput> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/GetAccount?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAccount(response_);
                } catch (e) {
                    return <Observable<UpdateAccountInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateAccountInput>><any>Observable.throw(response_);
        });
    }

    protected processGetAccount(response: Response): Observable<UpdateAccountInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateAccountInput.fromJS(resultData200) : new UpdateAccountInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateAccountInput>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedAccounts(pageNumber: number, pageSize: number): Observable<PagedAccountList> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/GetPagedAccounts?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedAccounts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedAccounts(response_);
                } catch (e) {
                    return <Observable<PagedAccountList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedAccountList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedAccounts(response: Response): Observable<PagedAccountList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedAccountList.fromJS(resultData200) : new PagedAccountList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedAccountList>(<any>null);
    }

    /**
     * @accountInput (optional) 
     * @return Success
     */
    updateAccount(accountInput: UpdateAccountInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/UpdateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountInput);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @accountId (optional) 
     * @return Success
     */
    getCurrentSchemaForAccount(accountId: string): Observable<SchemaDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/GetCurrentSchemaForAccount?";
        if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentSchemaForAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentSchemaForAccount(response_);
                } catch (e) {
                    return <Observable<SchemaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SchemaDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentSchemaForAccount(response: Response): Observable<SchemaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SchemaDto.fromJS(resultData200) : new SchemaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SchemaDto>(<any>null);
    }

    /**
     * @accountId (optional) 
     * @return Success
     */
    getAccountPoints(accountId: string): Observable<AccountPointDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/GetAccountPoints?";
        if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAccountPoints(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAccountPoints(response_);
                } catch (e) {
                    return <Observable<AccountPointDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AccountPointDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAccountPoints(response: Response): Observable<AccountPointDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccountPointDto.fromJS(resultData200) : new AccountPointDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AccountPointDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLoyaltyQrkeys(): Observable<LoyaltyQrKeysDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/GetLoyaltyQrkeys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLoyaltyQrkeys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLoyaltyQrkeys(response_);
                } catch (e) {
                    return <Observable<LoyaltyQrKeysDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LoyaltyQrKeysDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLoyaltyQrkeys(response: Response): Observable<LoyaltyQrKeysDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoyaltyQrKeysDto.fromJS(resultData200) : new LoyaltyQrKeysDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LoyaltyQrKeysDto>(<any>null);
    }

    /**
     * @loyaltyQrkey (optional) 
     * @return Success
     */
    updateLoyaltyQrkeys(loyaltyQrkey: LoyaltyQrKeysInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/UpdateLoyaltyQrkeys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loyaltyQrkey);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateLoyaltyQrkeys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateLoyaltyQrkeys(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateLoyaltyQrkeys(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/LoyalityAccount/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class MainTransactionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMainTransactionRetail(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMainTransactionRetail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransactionRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransactionRetail(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransactionRetail(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMainTransaction(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMainTransaction?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransaction(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransaction(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPurchaseInvoiceForRefund(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetPurchaseInvoiceForRefund?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoiceForRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoiceForRefund(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoiceForRefund(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMenuItemWast(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMenuItemWast?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemWast(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemWast(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemWast(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @receiveNumber (optional) 
     * @mainTransactionId (optional) 
     * @transactionType (optional) 
     * @return Success
     */
    receiveNumberUsed(receiveNumber: string, mainTransactionId: number, transactionType: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ReceiveNumberUsed?";
        if (receiveNumber !== undefined)
            url_ += "receiveNumber=" + encodeURIComponent("" + receiveNumber) + "&"; 
        if (mainTransactionId !== undefined)
            url_ += "mainTransactionId=" + encodeURIComponent("" + mainTransactionId) + "&"; 
        if (transactionType !== undefined)
            url_ += "transactionType=" + encodeURIComponent("" + transactionType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReceiveNumberUsed(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReceiveNumberUsed(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processReceiveNumberUsed(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMainTransactions(): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetAllMainTransactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMainTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMainTransactions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMainTransactions(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    pagedMainTransactions(input: MainTransactionInput, pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/PagedMainTransactions?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPagedMainTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPagedMainTransactions(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processPagedMainTransactions(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @transactionId (optional) 
     * @return Success
     */
    canEditOrDeleteTransaction(transactionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/CanEditOrDeleteTransaction?";
        if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCanEditOrDeleteTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCanEditOrDeleteTransaction(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCanEditOrDeleteTransaction(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMainTransactionHeader(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMainTransactionHeader?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransactionHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransactionHeader(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransactionHeader(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @transationId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedTransactionDetail(transationId: number, pageNumber: number, pageSize: number): Observable<PageDetailTransactionsList> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetPagedTransactionDetail?";
        if (transationId !== undefined)
            url_ += "transationId=" + encodeURIComponent("" + transationId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedTransactionDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedTransactionDetail(response_);
                } catch (e) {
                    return <Observable<PageDetailTransactionsList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PageDetailTransactionsList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedTransactionDetail(response: Response): Observable<PageDetailTransactionsList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PageDetailTransactionsList.fromJS(resultData200) : new PageDetailTransactionsList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PageDetailTransactionsList>(<any>null);
    }

    /**
     * @transationId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedStockAdjustmentDetail(transationId: number, pageNumber: number, pageSize: number): Observable<PageDetailTransactionsList> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetPagedStockAdjustmentDetail?";
        if (transationId !== undefined)
            url_ += "transationId=" + encodeURIComponent("" + transationId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedStockAdjustmentDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedStockAdjustmentDetail(response_);
                } catch (e) {
                    return <Observable<PageDetailTransactionsList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PageDetailTransactionsList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedStockAdjustmentDetail(response: Response): Observable<PageDetailTransactionsList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PageDetailTransactionsList.fromJS(resultData200) : new PageDetailTransactionsList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PageDetailTransactionsList>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @transactionId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getMainTransactionList(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean, transactionId: number, pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMainTransactionList?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransactionList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransactionList(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransactionList(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @input (optional) 
     * @transactionId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getMainTransactionIntegrationList(input: SalesReportInput, transactionId: number, pageNumber: number, pageSize: number): Observable<IntegrationPagedMainTransactionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMainTransactionIntegrationList?";
        if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransactionIntegrationList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransactionIntegrationList(response_);
                } catch (e) {
                    return <Observable<IntegrationPagedMainTransactionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<IntegrationPagedMainTransactionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransactionIntegrationList(response: Response): Observable<IntegrationPagedMainTransactionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IntegrationPagedMainTransactionListDto.fromJS(resultData200) : new IntegrationPagedMainTransactionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IntegrationPagedMainTransactionListDto>(<any>null);
    }

    /**
     * @status (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getAllMainTransactionsByStatus(status: number, pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetAllMainTransactionsByStatus?";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMainTransactionsByStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMainTransactionsByStatus(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMainTransactionsByStatus(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @return Success
     */
    getStockOpeningRetail(): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetStockOpeningRetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStockOpeningRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStockOpeningRetail(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStockOpeningRetail(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMainTransactionById(id: number): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMainTransactionById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransactionById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransactionById(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransactionById(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @transactionId (optional) 
     * @return Success
     */
    getMainTransactions(transactionId: number): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMainTransactions?";
        if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransactions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransactions(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @transactionId (optional) 
     * @return Success
     */
    getInventoryReceiveRevision(transactionId: number): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetInventoryReceiveRevision?";
        if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryReceiveRevision(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryReceiveRevision(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryReceiveRevision(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getInventoryReceiveRevisionAndPurshaseInvoices(input: InventoryRevisionInput): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetInventoryReceiveRevisionAndPurshaseInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryReceiveRevisionAndPurshaseInvoices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryReceiveRevisionAndPurshaseInvoices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryReceiveRevisionAndPurshaseInvoices(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getMaterials(): Observable<ListResultDtoOfMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMaterials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMaterials(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMaterials(response: Response): Observable<ListResultDtoOfMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMaterialListItem.fromJS(resultData200) : new ListResultDtoOfMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMaterialListItem>(<any>null);
    }

    /**
     * @fromStoreId (optional) 
     * @toStoreId (optional) 
     * @return Success
     */
    getRawMaterialsWithStockQtyByStoreId(fromStoreId: number, toStoreId: number): Observable<ListResultDtoOfMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetRawMaterialsWithStockQtyByStoreId?";
        if (fromStoreId !== undefined)
            url_ += "fromStoreId=" + encodeURIComponent("" + fromStoreId) + "&"; 
        if (toStoreId !== undefined)
            url_ += "toStoreId=" + encodeURIComponent("" + toStoreId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialsWithStockQtyByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialsWithStockQtyByStoreId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialsWithStockQtyByStoreId(response: Response): Observable<ListResultDtoOfMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMaterialListItem.fromJS(resultData200) : new ListResultDtoOfMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMaterialListItem>(<any>null);
    }

    /**
     * @fromStoreId (optional) 
     * @transactionDate (optional) 
     * @toStoreId (optional) 
     * @return Success
     */
    getRawMaterialsWithStockQty(fromStoreId: number, transactionDate: moment.Moment, toStoreId: number): Observable<MaterialListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetRawMaterialsWithStockQty?";
        if (fromStoreId !== undefined)
            url_ += "fromStoreId=" + encodeURIComponent("" + fromStoreId) + "&"; 
        if (transactionDate !== undefined)
            url_ += "transactionDate=" + encodeURIComponent(transactionDate ? "" + transactionDate.toJSON() : "") + "&"; 
        if (toStoreId !== undefined)
            url_ += "toStoreId=" + encodeURIComponent("" + toStoreId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialsWithStockQty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialsWithStockQty(response_);
                } catch (e) {
                    return <Observable<MaterialListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialsWithStockQty(response: Response): Observable<MaterialListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MaterialListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialListItem[]>(<any>null);
    }

    /**
     * @materialId (optional) 
     * @fromStoreId (optional) 
     * @transactionDate (optional) 
     * @toStoreId (optional) 
     * @return Success
     */
    getRawMaterialWithStockQty(materialId: number, fromStoreId: number, transactionDate: moment.Moment, toStoreId: number): Observable<MaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetRawMaterialWithStockQty?";
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (fromStoreId !== undefined)
            url_ += "fromStoreId=" + encodeURIComponent("" + fromStoreId) + "&"; 
        if (transactionDate !== undefined)
            url_ += "transactionDate=" + encodeURIComponent(transactionDate ? "" + transactionDate.toJSON() : "") + "&"; 
        if (toStoreId !== undefined)
            url_ += "toStoreId=" + encodeURIComponent("" + toStoreId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialWithStockQty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialWithStockQty(response_);
                } catch (e) {
                    return <Observable<MaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialWithStockQty(response: Response): Observable<MaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialListItem.fromJS(resultData200) : new MaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getMaterialsWithUnit(): Observable<ListResultDtoOfMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMaterialsWithUnit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMaterialsWithUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMaterialsWithUnit(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMaterialsWithUnit(response: Response): Observable<ListResultDtoOfMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMaterialListItem.fromJS(resultData200) : new ListResultDtoOfMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMaterialListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getProducts(): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProducts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProducts(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getProductsWithCode(): Observable<ProductListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetProductsWithCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductsWithCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductsWithCode(response_);
                } catch (e) {
                    return <Observable<ProductListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProductsWithCode(response: Response): Observable<ProductListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductListItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProductsOnlyWithCode(): Observable<ProductListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetProductsOnlyWithCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductsOnlyWithCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductsOnlyWithCode(response_);
                } catch (e) {
                    return <Observable<ProductListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProductsOnlyWithCode(response: Response): Observable<ProductListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductListItem[]>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @number (optional) 
     * @return Success
     */
    getProductsByProductCategoryId(productCategoryId: number, number: number): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetProductsByProductCategoryId?";
        if (productCategoryId !== undefined)
            url_ += "productCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductsByProductCategoryId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductsByProductCategoryId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductsByProductCategoryId(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @currentTransaction (optional) 
     * @return Success
     */
    getReceiveNumbers(currentTransaction: number): Observable<ListResultDtoOfReceiveNumberListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetReceiveNumbers?";
        if (currentTransaction !== undefined)
            url_ += "currentTransaction=" + encodeURIComponent("" + currentTransaction) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReceiveNumbers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReceiveNumbers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfReceiveNumberListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfReceiveNumberListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetReceiveNumbers(response: Response): Observable<ListResultDtoOfReceiveNumberListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfReceiveNumberListItem.fromJS(resultData200) : new ListResultDtoOfReceiveNumberListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfReceiveNumberListItem>(<any>null);
    }

    /**
     * @currentTransaction (optional) 
     * @return Success
     */
    getPurchaseInvoicesNumbers(currentTransaction: number): Observable<ListResultDtoOfReceiveNumberListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetPurchaseInvoicesNumbers?";
        if (currentTransaction !== undefined)
            url_ += "currentTransaction=" + encodeURIComponent("" + currentTransaction) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoicesNumbers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoicesNumbers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfReceiveNumberListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfReceiveNumberListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoicesNumbers(response: Response): Observable<ListResultDtoOfReceiveNumberListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfReceiveNumberListItem.fromJS(resultData200) : new ListResultDtoOfReceiveNumberListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfReceiveNumberListItem>(<any>null);
    }

    /**
     * @vendorId (optional) 
     * @return Success
     */
    getSupplierMaterials(vendorId: number): Observable<ListResultDtoOfMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetSupplierMaterials?";
        if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSupplierMaterials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSupplierMaterials(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSupplierMaterials(response: Response): Observable<ListResultDtoOfMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMaterialListItem.fromJS(resultData200) : new ListResultDtoOfMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMaterialListItem>(<any>null);
    }

    /**
     * @vendorId (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getSupplierMaterialsWithStockQtyByStoreId(vendorId: number, storeId: number): Observable<ListResultDtoOfMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetSupplierMaterialsWithStockQtyByStoreId?";
        if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSupplierMaterialsWithStockQtyByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSupplierMaterialsWithStockQtyByStoreId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSupplierMaterialsWithStockQtyByStoreId(response: Response): Observable<ListResultDtoOfMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMaterialListItem.fromJS(resultData200) : new ListResultDtoOfMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMaterialListItem>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getMaterialsByStoreId(storeId: number): Observable<ListResultDtoOfMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetMaterialsByStoreId?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMaterialsByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMaterialsByStoreId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMaterialsByStoreId(response: Response): Observable<ListResultDtoOfMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMaterialListItem.fromJS(resultData200) : new ListResultDtoOfMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMaterialListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStock(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStock(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStock(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @itemCost (optional) 
     * @prePrice (optional) 
     * @currentPrice (optional) 
     * @preQuantity (optional) 
     * @incomingQunatity (optional) 
     * @return Success
     */
    calPrice(itemCost: ItemCost, prePrice: number, currentPrice: number, preQuantity: number, incomingQunatity: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/CalPrice?";
        if (prePrice !== undefined)
            url_ += "PrePrice=" + encodeURIComponent("" + prePrice) + "&"; 
        if (currentPrice !== undefined)
            url_ += "currentPrice=" + encodeURIComponent("" + currentPrice) + "&"; 
        if (preQuantity !== undefined)
            url_ += "preQuantity=" + encodeURIComponent("" + preQuantity) + "&"; 
        if (incomingQunatity !== undefined)
            url_ += "incomingQunatity=" + encodeURIComponent("" + incomingQunatity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemCost);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCalPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCalPrice(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCalPrice(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockByInventoryOrder(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockByInventoryOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockByInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockByInventoryOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockByInventoryOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockByPurshaseInvoice(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockByPurshaseInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockByPurshaseInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockByPurshaseInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockByPurshaseInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockByPurchaseInvoiceRefund(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockByPurchaseInvoiceRefund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockByPurchaseInvoiceRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockByPurchaseInvoiceRefund(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockByPurchaseInvoiceRefund(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockByStockOpeningBalance(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockByStockOpeningBalance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockByStockOpeningBalance(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockByStockOpeningBalance(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockByStockOpeningBalance(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addProductLot(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/AddProductLot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddProductLot(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddProductLot(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddProductLot(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    prePairProductDetailTransactions(): Observable<DetailTransaction[]> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/prePairProductDetailTransactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrePairProductDetailTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrePairProductDetailTransactions(response_);
                } catch (e) {
                    return <Observable<DetailTransaction[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailTransaction[]>><any>Observable.throw(response_);
        });
    }

    protected processPrePairProductDetailTransactions(response: Response): Observable<DetailTransaction[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DetailTransaction.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailTransaction[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMainTransaction(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMainTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMainTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMainTransaction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMainTransaction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateInventoryRecive(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateInventoryRecive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateInventoryRecive(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateInventoryRecive(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateInventoryRecive(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactionDate (optional) 
     * @rawMaterialId (optional) 
     * @quantity (optional) 
     * @fromStoreId (optional) 
     * @return Success
     */
    upateRawWasteMaterialStock(transactionDate: moment.Moment, rawMaterialId: number, quantity: number, fromStoreId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpateRawWasteMaterialStock?";
        if (transactionDate !== undefined)
            url_ += "transactionDate=" + encodeURIComponent(transactionDate ? "" + transactionDate.toJSON() : "") + "&"; 
        if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&"; 
        if (fromStoreId !== undefined)
            url_ += "fromStoreId=" + encodeURIComponent("" + fromStoreId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpateRawWasteMaterialStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpateRawWasteMaterialStock(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpateRawWasteMaterialStock(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateInventoryMenueWaste(input: UpdateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateInventoryMenueWaste";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateInventoryMenueWaste(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateInventoryMenueWaste(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateInventoryMenueWaste(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateInventoryRawWaste(input: UpdateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateInventoryRawWaste";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateInventoryRawWaste(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateInventoryRawWaste(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateInventoryRawWaste(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMainTransaction(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/CreateMainTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMainTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMainTransaction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMainTransaction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    checkStockHasPeriodOpend(storeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/CheckStockHasPeriodOpend?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckStockHasPeriodOpend(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckStockHasPeriodOpend(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckStockHasPeriodOpend(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMainTransactionForBackgroundJob(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/CreateMainTransactionForBackgroundJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMainTransactionForBackgroundJob(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMainTransactionForBackgroundJob(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMainTransactionForBackgroundJob(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    stockOnHandMaterials(input: StockValuesReportInput, pagenumber: number, pagesize: number): Observable<StockOnHandPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/StockOnHandMaterials?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStockOnHandMaterials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStockOnHandMaterials(response_);
                } catch (e) {
                    return <Observable<StockOnHandPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StockOnHandPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processStockOnHandMaterials(response: Response): Observable<StockOnHandPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StockOnHandPagedDto.fromJS(resultData200) : new StockOnHandPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StockOnHandPagedDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStockOnHand(input: StockValuesReportInput, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ExportStockOnHand?";
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockOnHand(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockOnHand(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockOnHand(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @materialId (optional) 
     * @return Success
     */
    checkQuntityInventory(id: number, materialId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/CheckQuntityInventory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckQuntityInventory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckQuntityInventory(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCheckQuntityInventory(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @mainTransactionId (optional) 
     * @return Success
     */
    addMainTransaction(mainTransactionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/AddMainTransaction?";
        if (mainTransactionId !== undefined)
            url_ += "mainTransactionId=" + encodeURIComponent("" + mainTransactionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddMainTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddMainTransaction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddMainTransaction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    checkDeleteInventory(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/CheckDeleteInventory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDeleteInventory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDeleteInventory(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckDeleteInventory(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    approveMainTransaction(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ApproveMainTransaction?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processApproveMainTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processApproveMainTransaction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processApproveMainTransaction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockInventoryTransfer(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockInventoryTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockInventoryTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockInventoryTransfer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockInventoryTransfer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockByStockadjustment(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockByStockadjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockByStockadjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockByStockadjustment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockByStockadjustment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateBatchRecipe(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateBatchRecipe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateBatchRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateBatchRecipe(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateBatchRecipe(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockByInventoryTransfer(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockByInventoryTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockByInventoryTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockByInventoryTransfer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockByInventoryTransfer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockByInventoryOrderTransfer(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockByInventoryOrderTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockByInventoryOrderTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockByInventoryOrderTransfer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockByInventoryOrderTransfer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    disApproveMainTransaction(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/disApproveMainTransaction?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDisApproveMainTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDisApproveMainTransaction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDisApproveMainTransaction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @to (optional) 
     * @from (optional) 
     * @documentType (optional) 
     * @transactionId (optional) 
     * @storeIds (optional) 
     * @destinationIds (optional) 
     * @status (optional) 
     * @documentNumber (optional) 
     * @invoiceNumber (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedInventoryRawWaste(to: moment.Moment, from: moment.Moment, documentType: number, transactionId: number, storeIds: number[], destinationIds: number[], status: number, documentNumber: string, invoiceNumber: string, pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetPagedInventoryRawWaste?";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (transactionId !== undefined)
            url_ += "TransactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (destinationIds !== undefined)
            destinationIds && destinationIds.forEach(item => { url_ += "DestinationIds=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (documentNumber !== undefined)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&"; 
        if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedInventoryRawWaste(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedInventoryRawWaste(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedInventoryRawWaste(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    disApprovalInventoryReceive(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/DisApprovalInventoryReceive?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDisApprovalInventoryReceive(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDisApprovalInventoryReceive(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDisApprovalInventoryReceive(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockInventoryOrder(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockInventoryOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockInventoryOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockInventoryOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    approvalInventoryReceive(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ApprovalInventoryReceive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processApprovalInventoryReceive(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processApprovalInventoryReceive(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processApprovalInventoryReceive(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @to (optional) 
     * @from (optional) 
     * @documentType (optional) 
     * @transactionId (optional) 
     * @storeIds (optional) 
     * @destinationIds (optional) 
     * @status (optional) 
     * @documentNumber (optional) 
     * @invoiceNumber (optional) 
     * @return Success
     */
    exportMainTransactionReport(to: moment.Moment, from: moment.Moment, documentType: number, transactionId: number, storeIds: number[], destinationIds: number[], status: number, documentNumber: string, invoiceNumber: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ExportMainTransactionReport?";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (transactionId !== undefined)
            url_ += "TransactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (destinationIds !== undefined)
            destinationIds && destinationIds.forEach(item => { url_ += "DestinationIds=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (documentNumber !== undefined)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&"; 
        if (invoiceNumber !== undefined)
            url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMainTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMainTransactionReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMainTransactionReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportItemToExcel(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ExportItemToExcel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportItemToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportItemToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportItemToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportItemToPDF(id: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ExportItemToPDF?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportItemToPDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportItemToPDF(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportItemToPDF(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    exportEmptyStockOpeningAdjustmentToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ExportEmptyStockOpeningAdjustmentToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportEmptyStockOpeningAdjustmentToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportEmptyStockOpeningAdjustmentToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportEmptyStockOpeningAdjustmentToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    exportStockopeningadjustmentretail(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ExportStockopeningadjustmentretail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockopeningadjustmentretail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockopeningadjustmentretail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockopeningadjustmentretail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @transactionId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    menuItemWasteSearch(input: MainTransactionInput, transactionId: number, pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/MenuItemWasteSearch?";
        if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMenuItemWasteSearch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMenuItemWasteSearch(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processMenuItemWasteSearch(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @return Success
     */
    getProductsDateUpdateToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetProductsDateUpdateToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductsDateUpdateToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductsDateUpdateToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductsDateUpdateToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file Upload file.
     * @return Success
     */
    importDateUpdateFromExcel(file: any, storeId: string, lotNumber: string, date: string, notes: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ImportDateUpdateFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file);
        if (storeId === null || storeId === undefined)
            throw new Error("The parameter 'storeId' cannot be null.");
        else
            content_.append("storeId", storeId.toString());
        if (lotNumber === null || lotNumber === undefined)
            throw new Error("The parameter 'lotNumber' cannot be null.");
        else
            content_.append("lotNumber", lotNumber.toString());
        if (date === null || date === undefined)
            throw new Error("The parameter 'date' cannot be null.");
        else
            content_.append("date", date.toString());
        if (notes === null || notes === undefined)
            throw new Error("The parameter 'notes' cannot be null.");
        else
            content_.append("notes", notes.toString());

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportDateUpdateFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportDateUpdateFromExcel(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processImportDateUpdateFromExcel(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @contentType (optional) 
     * @contentDisposition (optional) 
     * @headers (optional) 
     * @length (optional) 
     * @name (optional) 
     * @fileName (optional) 
     * @storeId (optional) 
     * @lotNumber (optional) 
     * @date (optional) 
     * @notes (optional) 
     * @return Success
     */
    importDateUpdateFromExcel_OldVersion(contentType: string, contentDisposition: string, headers: any, length: number, name: string, fileName: string, storeId: string, lotNumber: string, date: string, notes: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/ImportDateUpdateFromExcel_OldVersion?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (lotNumber !== undefined)
            url_ += "lotNumber=" + encodeURIComponent("" + lotNumber) + "&"; 
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&"; 
        if (notes !== undefined)
            url_ += "notes=" + encodeURIComponent("" + notes) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length !== null && length !== undefined)
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportDateUpdateFromExcel_OldVersion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportDateUpdateFromExcel_OldVersion(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processImportDateUpdateFromExcel_OldVersion(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStockApprovedByInventoryOrder(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/UpdateMaterialStockApprovedByInventoryOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStockApprovedByInventoryOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStockApprovedByInventoryOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStockApprovedByInventoryOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MainTransaction/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class MainTransactionSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMainTransactionSetting(): Observable<MainTransactionSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/MainTransactionSettings/GetMainTransactionSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainTransactionSetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainTransactionSetting(response_);
                } catch (e) {
                    return <Observable<MainTransactionSettingsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionSettingsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMainTransactionSetting(response: Response): Observable<MainTransactionSettingsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionSettingsDto.fromJS(resultData200) : new MainTransactionSettingsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionSettingsDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMainTransactionSetting(input: CreateMainTransactionSettingsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransactionSettings/CreateMainTransactionSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMainTransactionSetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMainTransactionSetting(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMainTransactionSetting(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMainTransactionSetting(input: UpdateMainTransactionSettingsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainTransactionSettings/UpdateMainTransactionSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMainTransactionSetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMainTransactionSetting(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMainTransactionSetting(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MainTransactionSettings/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class MangementDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenatId (optional) 
     * @return Success
     */
    getDashboardStatsData(tenatId: number): Observable<MangementDashboardData[]> {
        let url_ = this.baseUrl + "/api/services/app/MangementDashboard/GetDashboardStatsData?";
        if (tenatId !== undefined)
            url_ += "tenatId=" + encodeURIComponent("" + tenatId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardStatsData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardStatsData(response_);
                } catch (e) {
                    return <Observable<MangementDashboardData[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MangementDashboardData[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardStatsData(response: Response): Observable<MangementDashboardData[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MangementDashboardData.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MangementDashboardData[]>(<any>null);
    }

    /**
     * @tenatId (optional) 
     * @return Success
     */
    getStoreClustersOverview(tenatId: number): Observable<StoreClustersOverview[]> {
        let url_ = this.baseUrl + "/api/services/app/MangementDashboard/GetStoreClustersOverview?";
        if (tenatId !== undefined)
            url_ += "tenatId=" + encodeURIComponent("" + tenatId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreClustersOverview(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreClustersOverview(response_);
                } catch (e) {
                    return <Observable<StoreClustersOverview[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreClustersOverview[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreClustersOverview(response: Response): Observable<StoreClustersOverview[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreClustersOverview.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreClustersOverview[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MangementDashboard/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class MenuItemServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @itemcode (optional) 
     * @itemid (optional) 
     * @return Success
     */
    checkItemCodeIsUnique(itemcode: string, itemid: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/CheckItemCodeIsUnique?";
        if (itemcode !== undefined)
            url_ += "itemcode=" + encodeURIComponent("" + itemcode) + "&"; 
        if (itemid !== undefined)
            url_ += "itemid=" + encodeURIComponent("" + itemid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckItemCodeIsUnique(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckItemCodeIsUnique(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckItemCodeIsUnique(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateMenuItemInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMenuItem(id: number): Observable<MenuItemListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetMenuItem?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItem(response_);
                } catch (e) {
                    return <Observable<MenuItemListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItem(response: Response): Observable<MenuItemListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MenuItemListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemListItem[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<MenuItemDto> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<MenuItemDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<MenuItemDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemDto.fromJS(resultData200) : new MenuItemDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfMenuItemListItem> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMenuItemListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMenuItemListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfMenuItemListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMenuItemListItem.fromJS(resultData200) : new ListResultDtoOfMenuItemListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMenuItemListItem>(<any>null);
    }

    /**
     * @return Success
     */
    refreshMenuItemsCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/RefreshMenuItemsCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRefreshMenuItemsCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRefreshMenuItemsCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRefreshMenuItemsCache(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllWithComboMeal(): Observable<ListResultDtoOfMenuItemListItem> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetAllWithComboMeal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllWithComboMeal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllWithComboMeal(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMenuItemListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMenuItemListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllWithComboMeal(response: Response): Observable<ListResultDtoOfMenuItemListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMenuItemListItem.fromJS(resultData200) : new ListResultDtoOfMenuItemListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMenuItemListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getAllWithUOM(): Observable<ListResultDtoOfMenuItemWithUOM> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetAllWithUOM";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllWithUOM(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllWithUOM(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMenuItemWithUOM>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMenuItemWithUOM>><any>Observable.throw(response_);
        });
    }

    protected processGetAllWithUOM(response: Response): Observable<ListResultDtoOfMenuItemWithUOM> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMenuItemWithUOM.fromJS(resultData200) : new ListResultDtoOfMenuItemWithUOM();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMenuItemWithUOM>(<any>null);
    }

    /**
     * @return Success
     */
    getAllNotUsedInRecipe(): Observable<MenuItemListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetAllNotUsedInRecipe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllNotUsedInRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllNotUsedInRecipe(response_);
                } catch (e) {
                    return <Observable<MenuItemListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllNotUsedInRecipe(response: Response): Observable<MenuItemListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MenuItemListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemListItem[]>(<any>null);
    }

    /**
     * @rawId (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getActualQtyByRawMaterial(rawId: number, storeId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetActualQtyByRawMaterial?";
        if (rawId !== undefined)
            url_ += "rawId=" + encodeURIComponent("" + rawId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActualQtyByRawMaterial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActualQtyByRawMaterial(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetActualQtyByRawMaterial(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getActualQty(menuItemId: number, storeId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetActualQty?";
        if (menuItemId !== undefined)
            url_ += "menuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActualQty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActualQty(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetActualQty(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateMenuItemInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @return Success
     */
    deleteImage(menuItemId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/DeleteImage?";
        if (menuItemId !== undefined)
            url_ += "menuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cloneMenuItem(input: CloneMenuItemDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/CloneMenuItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloneMenuItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloneMenuItem(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloneMenuItem(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @menuItemDto (optional) 
     * @return Success
     */
    updateMenuItemVariants(menuItemDto: MenuItemDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/UpdateMenuItemVariants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menuItemDto);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMenuItemVariants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMenuItemVariants(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMenuItemVariants(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedMenuItem(pageNumber: number, pageSize: number): Observable<PagedMenuItemList> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetPagedMenuItem?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedMenuItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedMenuItem(response_);
                } catch (e) {
                    return <Observable<PagedMenuItemList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMenuItemList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedMenuItem(response: Response): Observable<PagedMenuItemList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMenuItemList.fromJS(resultData200) : new PagedMenuItemList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMenuItemList>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    menuItemList(input: MenuItemInput, pageNumber: number, pageSize: number, descending: boolean): Observable<PagedMenuItemList> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/MenuItemList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMenuItemList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMenuItemList(response_);
                } catch (e) {
                    return <Observable<PagedMenuItemList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMenuItemList>><any>Observable.throw(response_);
        });
    }

    protected processMenuItemList(response: Response): Observable<PagedMenuItemList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMenuItemList.fromJS(resultData200) : new PagedMenuItemList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMenuItemList>(<any>null);
    }

    /**
     * @return Success
     */
    getMenuItemHasRecipe(): Observable<MenuItemListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetMenuItemHasRecipe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemHasRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemHasRecipe(response_);
                } catch (e) {
                    return <Observable<MenuItemListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemHasRecipe(response: Response): Observable<MenuItemListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MenuItemListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemListItem[]>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @return Success
     */
    getMenuItemUnits(menuItemId: number): Observable<UnitOfMeasureListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetMenuItemUnits?";
        if (menuItemId !== undefined)
            url_ += "menuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemUnits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemUnits(response_);
                } catch (e) {
                    return <Observable<UnitOfMeasureListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitOfMeasureListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemUnits(response: Response): Observable<UnitOfMeasureListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UnitOfMeasureListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitOfMeasureListItem[]>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @return Success
     */
    getMenuItemStoreGroupsTreeForEdit(menuItemId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetMenuItemStoreGroupsTreeForEdit?";
        if (menuItemId !== undefined)
            url_ += "menuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @configId (optional) 
     * @return Success
     */
    getMenuItemStoreGroups(menuItemId: number, configId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetMenuItemStoreGroups?";
        if (menuItemId !== undefined)
            url_ += "menuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemStoreGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemStoreGroups(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemStoreGroups(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MenuItem/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class MenuItemLinkServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMenuItemLink(id: number): Observable<MenuItemLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/MenuItemLink/GetMenuItemLink?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemLink(response_);
                } catch (e) {
                    return <Observable<MenuItemLinkDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemLinkDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemLink(response: Response): Observable<MenuItemLinkDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemLinkDto.fromJS(resultData200) : new MenuItemLinkDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemLinkDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMenuItemLinks(): Observable<ListResultDtoOfMenuItemLinkListItem> {
        let url_ = this.baseUrl + "/api/services/app/MenuItemLink/GetMenuItemLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemLinks(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemLinks(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMenuItemLinkListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMenuItemLinkListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemLinks(response: Response): Observable<ListResultDtoOfMenuItemLinkListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMenuItemLinkListItem.fromJS(resultData200) : new ListResultDtoOfMenuItemLinkListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMenuItemLinkListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMenuItemLink(input: CreateMenuItemLinkInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItemLink/CreateMenuItemLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMenuItemLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMenuItemLink(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMenuItemLink(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMenuItemLink(input: UpdateMenuItemLinkInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItemLink/UpdateMenuItemLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMenuItemLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMenuItemLink(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMenuItemLink(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteMenuItemLink(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MenuItemLink/DeleteMenuItemLink?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMenuItemLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMenuItemLink(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMenuItemLink(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedMenuItemLink(pageNumber: number, pageSize: number): Observable<PagedMenuItemLinkList> {
        let url_ = this.baseUrl + "/api/services/app/MenuItemLink/GetPagedMenuItemLink?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedMenuItemLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedMenuItemLink(response_);
                } catch (e) {
                    return <Observable<PagedMenuItemLinkList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMenuItemLinkList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedMenuItemLink(response: Response): Observable<PagedMenuItemLinkList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMenuItemLinkList.fromJS(resultData200) : new PagedMenuItemLinkList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMenuItemLinkList>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MenuItemLink/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class MobileAPIServicesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkInstall(input: CheckInstall_InputDto): Observable<CheckInstall_OutpotDto> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPIServices/CheckInstall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckInstall(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckInstall(response_);
                } catch (e) {
                    return <Observable<CheckInstall_OutpotDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckInstall_OutpotDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckInstall(response: Response): Observable<CheckInstall_OutpotDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckInstall_OutpotDto.fromJS(resultData200) : new CheckInstall_OutpotDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckInstall_OutpotDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getLanguageByTenant(tenantId: number): Observable<GetLanguage_OutpotDto> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPIServices/GetLanguageByTenant?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageByTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguageByTenant(response_);
                } catch (e) {
                    return <Observable<GetLanguage_OutpotDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguage_OutpotDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageByTenant(response: Response): Observable<GetLanguage_OutpotDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguage_OutpotDto.fromJS(resultData200) : new GetLanguage_OutpotDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguage_OutpotDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    login(input: Login_InputDto): Observable<Login_OutpotDto> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPIServices/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLogin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLogin(response_);
                } catch (e) {
                    return <Observable<Login_OutpotDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<Login_OutpotDto>><any>Observable.throw(response_);
        });
    }

    protected processLogin(response: Response): Observable<Login_OutpotDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Login_OutpotDto.fromJS(resultData200) : new Login_OutpotDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<Login_OutpotDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    startShiftAfterInitialBalance(input: InitalBalance_InputDto): Observable<CashierShiftMobile> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPIServices/StartShiftAfterInitialBalance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartShiftAfterInitialBalance(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartShiftAfterInitialBalance(response_);
                } catch (e) {
                    return <Observable<CashierShiftMobile>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftMobile>><any>Observable.throw(response_);
        });
    }

    protected processStartShiftAfterInitialBalance(response: Response): Observable<CashierShiftMobile> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftMobile.fromJS(resultData200) : new CashierShiftMobile();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftMobile>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPIServices/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ModulesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getModules(): Observable<ModuleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Modules/GetModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetModules(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetModules(response_);
                } catch (e) {
                    return <Observable<ModuleDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ModuleDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetModules(response: Response): Observable<ModuleDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ModuleDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ModuleDto[]>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @from (optional) 
     * @to (optional) 
     * @modulesIds (optional) 
     * @return Success
     */
    getModulesLogs(tenantId: number, pageNumber: number, pageSize: number, from: moment.Moment, to: moment.Moment, modulesIds: number[]): Observable<PagedModule> {
        let url_ = this.baseUrl + "/api/services/app/Modules/GetModulesLogs?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (modulesIds !== undefined)
            modulesIds && modulesIds.forEach(item => { url_ += "modulesIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetModulesLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetModulesLogs(response_);
                } catch (e) {
                    return <Observable<PagedModule>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedModule>><any>Observable.throw(response_);
        });
    }

    protected processGetModulesLogs(response: Response): Observable<PagedModule> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedModule.fromJS(resultData200) : new PagedModule();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedModule>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Modules/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class MsDynamicServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateMsDynamicInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    getSaleList(pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/GetSaleList?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleList(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleList(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    getRefundSaleList(pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/GetRefundSaleList?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRefundSaleList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRefundSaleList(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRefundSaleList(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    get(): Observable<MsDynamicDTOs> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<MsDynamicDTOs>><any>Observable.throw(e);
                }
            } else
                return <Observable<MsDynamicDTOs>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<MsDynamicDTOs> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MsDynamicDTOs.fromJS(resultData200) : new MsDynamicDTOs();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MsDynamicDTOs>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: EditMsDynamicInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @salesTransForUpload (optional) 
     * @return Success
     */
    uploadSales(salesTransForUpload: SalesTransactionUploadedInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/UploadSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(salesTransForUpload);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadSales(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadSales(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    testjob(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/Testjob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTestjob(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTestjob(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTestjob(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    salesTransactionUploadedLogs(input: LogHistoryInput, pageNumber: number, pageSize: number): Observable<LogHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/SalesTransactionUploadedLogs?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesTransactionUploadedLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesTransactionUploadedLogs(response_);
                } catch (e) {
                    return <Observable<LogHistoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LogHistoryDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesTransactionUploadedLogs(response: Response): Observable<LogHistoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LogHistoryDto.fromJS(resultData200) : new LogHistoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LogHistoryDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getTransactionReport(storeIds: number[], fromDate: moment.Moment, toDate: moment.Moment, pageNumber: number, pageSize: number): Observable<TransactionReportDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/GetTransactionReport?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionReport(response_);
                } catch (e) {
                    return <Observable<TransactionReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionReportDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionReport(response: Response): Observable<TransactionReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionReportDto.fromJS(resultData200) : new TransactionReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionReportDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MsDynamic/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @state (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: State, maxResultCount: number, skipCount: number): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserNotifications(response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserNotifications(response: Response): Observable<GetNotificationsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationsOutput.fromJS(resultData200) : new GetNotificationsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetAllNotificationsAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetAllNotificationsAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setNotificationAsRead(input: EntityDtoOfGuid): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetNotificationAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetNotificationAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotificationSettings(response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetNotificationSettings(response: Response): Observable<GetNotificationSettingsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationSettingsOutput.fromJS(resultData200) : new GetNotificationSettingsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotificationSettings(input: UpdateNotificationSettingsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotificationSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotificationSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class OfferServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getOffer(id: number): Observable<OfferDto> {
        let url_ = this.baseUrl + "/api/services/app/Offer/GetOffer?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOffer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOffer(response_);
                } catch (e) {
                    return <Observable<OfferDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OfferDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOffer(response: Response): Observable<OfferDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OfferDto.fromJS(resultData200) : new OfferDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OfferDto>(<any>null);
    }

    /**
     * @offerId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(offerId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Offer/GetStoreGroupsTreeForEdit?";
        if (offerId !== undefined)
            url_ += "OfferId=" + encodeURIComponent("" + offerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getOffers(pageNumber: number, pageSize: number): Observable<PagedOfferList> {
        let url_ = this.baseUrl + "/api/services/app/Offer/GetOffers?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOffers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOffers(response_);
                } catch (e) {
                    return <Observable<PagedOfferList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedOfferList>><any>Observable.throw(response_);
        });
    }

    protected processGetOffers(response: Response): Observable<PagedOfferList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedOfferList.fromJS(resultData200) : new PagedOfferList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedOfferList>(<any>null);
    }

    /**
     * @offerdto (optional) 
     * @return Success
     */
    createOffer(offerdto: OfferDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Offer/CreateOffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(offerdto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOffer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOffer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOffer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @offerdto (optional) 
     * @return Success
     */
    updateOffer(offerdto: OfferDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Offer/UpdateOffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(offerdto);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateOffer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateOffer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateOffer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteOffer(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Offer/DeleteOffer?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteOffer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteOffer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteOffer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Offer/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class OrdersServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @request (optional) 
     * @return Success
     */
    updateOrderStatus(request: OrderStatusRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Orders/UpdateOrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateOrderStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateOrderStatus(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processUpdateOrderStatus(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getOrderStatus(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrderStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrderStatus(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetOrderStatus(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class OrderWorkFlowServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateOrderWorkFlowInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<OrderWorkFlowDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<OrderWorkFlowDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrderWorkFlowDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<OrderWorkFlowDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrderWorkFlowDto.fromJS(resultData200) : new OrderWorkFlowDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrderWorkFlowDto>(<any>null);
    }

    /**
     * @workFlowType (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getOrderWorkFlowPage(workFlowType: WorkFlowType, pageNumber: number, pageSize: number): Observable<OrderWorkFlowPageDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/GetOrderWorkFlowPage?";
        if (workFlowType !== undefined)
            url_ += "workFlowType=" + encodeURIComponent("" + workFlowType) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrderWorkFlowPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrderWorkFlowPage(response_);
                } catch (e) {
                    return <Observable<OrderWorkFlowPageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrderWorkFlowPageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrderWorkFlowPage(response: Response): Observable<OrderWorkFlowPageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrderWorkFlowPageDto.fromJS(resultData200) : new OrderWorkFlowPageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrderWorkFlowPageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateOrderWorkFlowInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @type (optional) 
     * @return Success
     */
    getWorkFlowType(type: number): Observable<WorkFlowTypeItemDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/GetWorkFlowType?";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetWorkFlowType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetWorkFlowType(response_);
                } catch (e) {
                    return <Observable<WorkFlowTypeItemDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<WorkFlowTypeItemDto>><any>Observable.throw(response_);
        });
    }

    protected processGetWorkFlowType(response: Response): Observable<WorkFlowTypeItemDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? WorkFlowTypeItemDto.fromJS(resultData200) : new WorkFlowTypeItemDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<WorkFlowTypeItemDto>(<any>null);
    }

    /**
     * @workFlowType (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getWorflowDetial(workFlowType: WorkFlowType2, storeId: number): Observable<OrderWorkflowDeviceDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/GetWorflowDetial?";
        if (workFlowType !== undefined)
            url_ += "workFlowType=" + encodeURIComponent("" + workFlowType) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetWorflowDetial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetWorflowDetial(response_);
                } catch (e) {
                    return <Observable<OrderWorkflowDeviceDetailDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrderWorkflowDeviceDetailDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetWorflowDetial(response: Response): Observable<OrderWorkflowDeviceDetailDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(OrderWorkflowDeviceDetailDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrderWorkflowDeviceDetailDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrderWorkFlow/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrganizationUnits(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnits(response: Response): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrganizationUnitUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnitUsers(response: Response): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationUnitUserListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrganizationUnit(input: CreateOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateOrganizationUnit(input: UpdateOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    moveOrganizationUnit(input: MoveOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processMoveOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @userId (optional) 
     * @organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number, organizationUnitId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveUserFromOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(input: UsersToOrganizationUnitInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddUsersToOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindOrganizationUnitUsersInput): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: Response): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ParentTenantReportServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @menuItemsIds (optional) 
     * @tenants (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getTenantMenuItemsSales(regionId: number, areaId: number, storeIds: number[], menuItemsIds: number[], tenants: number[], fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, pagenumber: number, pageSize: number): Observable<TenantMenuItemSalePage> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/GetTenantMenuItemsSales?";
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (menuItemsIds !== undefined)
            menuItemsIds && menuItemsIds.forEach(item => { url_ += "MenuItemsIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenants !== undefined)
            tenants && tenants.forEach(item => { url_ += "Tenants=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantMenuItemsSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantMenuItemsSales(response_);
                } catch (e) {
                    return <Observable<TenantMenuItemSalePage>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantMenuItemSalePage>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantMenuItemsSales(response: Response): Observable<TenantMenuItemSalePage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantMenuItemSalePage.fromJS(resultData200) : new TenantMenuItemSalePage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantMenuItemSalePage>(<any>null);
    }

    /**
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @menuItemsIds (optional) 
     * @tenants (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTenantMenuItemsSales(regionId: number, areaId: number, storeIds: number[], menuItemsIds: number[], tenants: number[], fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/ExportTenantMenuItemsSales?";
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (menuItemsIds !== undefined)
            menuItemsIds && menuItemsIds.forEach(item => { url_ += "MenuItemsIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenants !== undefined)
            tenants && tenants.forEach(item => { url_ += "Tenants=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenantMenuItemsSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenantMenuItemsSales(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenantMenuItemsSales(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @menuItemsIds (optional) 
     * @tenants (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getTenantMenuItemsSalesSummary(regionId: number, areaId: number, storeIds: number[], menuItemsIds: number[], tenants: number[], fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, pagenumber: number, pageSize: number): Observable<TenantMenuItemSaleSummaryPage> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/GetTenantMenuItemsSalesSummary?";
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (menuItemsIds !== undefined)
            menuItemsIds && menuItemsIds.forEach(item => { url_ += "MenuItemsIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenants !== undefined)
            tenants && tenants.forEach(item => { url_ += "Tenants=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantMenuItemsSalesSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantMenuItemsSalesSummary(response_);
                } catch (e) {
                    return <Observable<TenantMenuItemSaleSummaryPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantMenuItemSaleSummaryPage>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantMenuItemsSalesSummary(response: Response): Observable<TenantMenuItemSaleSummaryPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantMenuItemSaleSummaryPage.fromJS(resultData200) : new TenantMenuItemSaleSummaryPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantMenuItemSaleSummaryPage>(<any>null);
    }

    /**
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @menuItemsIds (optional) 
     * @tenants (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTenantMenuItemsSalesSummary(regionId: number, areaId: number, storeIds: number[], menuItemsIds: number[], tenants: number[], fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/ExportTenantMenuItemsSalesSummary?";
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (menuItemsIds !== undefined)
            menuItemsIds && menuItemsIds.forEach(item => { url_ += "MenuItemsIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenants !== undefined)
            tenants && tenants.forEach(item => { url_ += "Tenants=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenantMenuItemsSalesSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenantMenuItemsSalesSummary(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenantMenuItemsSalesSummary(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @childTenantIds (optional) 
     * @storeIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @isCSVFile (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getTenantSaleDetails(childTenantIds: number[], storeIds: number[], from: moment.Moment, to: moment.Moment, isCSVFile: boolean, sorting: string, skipCount: number, maxResultCount: number, pageNumber: number, pageSize: number): Observable<TenantSaleDetailsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/GetTenantSaleDetails?";
        if (childTenantIds !== undefined)
            childTenantIds && childTenantIds.forEach(item => { url_ += "ChildTenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantSaleDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantSaleDetails(response_);
                } catch (e) {
                    return <Observable<TenantSaleDetailsResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantSaleDetailsResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantSaleDetails(response: Response): Observable<TenantSaleDetailsResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantSaleDetailsResultDto.fromJS(resultData200) : new TenantSaleDetailsResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantSaleDetailsResultDto>(<any>null);
    }

    /**
     * @childTenantIds (optional) 
     * @storeIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @isCSVFile (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTenantSaleDetails(childTenantIds: number[], storeIds: number[], from: moment.Moment, to: moment.Moment, isCSVFile: boolean, sorting: string, skipCount: number, maxResultCount: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/ExportTenantSaleDetails?";
        if (childTenantIds !== undefined)
            childTenantIds && childTenantIds.forEach(item => { url_ += "ChildTenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenantSaleDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenantSaleDetails(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenantSaleDetails(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    storesDayTotalSales(input: StoresDayTotalSalesInputDto, pageNumber: number, pageSize: number): Observable<StoresDayTotalSalesPagedResult> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/StoresDayTotalSales?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStoresDayTotalSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStoresDayTotalSales(response_);
                } catch (e) {
                    return <Observable<StoresDayTotalSalesPagedResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoresDayTotalSalesPagedResult>><any>Observable.throw(response_);
        });
    }

    protected processStoresDayTotalSales(response: Response): Observable<StoresDayTotalSalesPagedResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoresDayTotalSalesPagedResult.fromJS(resultData200) : new StoresDayTotalSalesPagedResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoresDayTotalSalesPagedResult>(<any>null);
    }

    /**
     * @tenantIds (optional) 
     * @storeIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStoresDayTotalSales(tenantIds: number[], storeIds: number[], regionId: number, areaId: number, from: moment.Moment, to: moment.Moment, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/ExportStoresDayTotalSales?";
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStoresDayTotalSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStoresDayTotalSales(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStoresDayTotalSales(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateTenantData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/UpdateTenantData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenantData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenantData(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenantData(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ParentTenantReport/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentInfo(response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentInfo(response: Response): Observable<PaymentInfoDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentInfoDto.fromJS(resultData200) : new PaymentInfoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentInfoDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPayment(input: CreatePaymentDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreatePayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    executePayment(input: ExecutePaymentDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExecutePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExecutePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExecutePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processExecutePayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentHistory(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentHistory(response: Response): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200) : new PagedResultDtoOfSubscriptionPaymentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PCsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPC(id: number): Observable<PCDto> {
        let url_ = this.baseUrl + "/api/services/app/PCs/GetPC?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPC(response_);
                } catch (e) {
                    return <Observable<PCDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PCDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPC(response: Response): Observable<PCDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PCDto.fromJS(resultData200) : new PCDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PCDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPCs(): Observable<ListResultDtoOfPCListItem> {
        let url_ = this.baseUrl + "/api/services/app/PCs/GetPCs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPCs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPCs(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPCListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPCListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPCs(response: Response): Observable<ListResultDtoOfPCListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPCListItem.fromJS(resultData200) : new ListResultDtoOfPCListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPCListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPCs(pageNumber: number, pageSize: number): Observable<PagedPCList> {
        let url_ = this.baseUrl + "/api/services/app/PCs/getPagedPCs?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPCs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPCs(response_);
                } catch (e) {
                    return <Observable<PagedPCList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPCList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPCs(response: Response): Observable<PagedPCList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPCList.fromJS(resultData200) : new PagedPCList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPCList>(<any>null);
    }

    /**
     * @return Success
     */
    getSaleTypes(): Observable<ListResultDtoOfSaleTypeListItem> {
        let url_ = this.baseUrl + "/api/services/app/PCs/GetSaleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleTypes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSaleTypeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSaleTypeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleTypes(response: Response): Observable<ListResultDtoOfSaleTypeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSaleTypeListItem.fromJS(resultData200) : new ListResultDtoOfSaleTypeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSaleTypeListItem>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getSaleTypesByStoreId(storeId: number): Observable<ListResultDtoOfSaleTypeListItem> {
        let url_ = this.baseUrl + "/api/services/app/PCs/getSaleTypesByStoreId?";
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleTypesByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleTypesByStoreId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSaleTypeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSaleTypeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleTypesByStoreId(response: Response): Observable<ListResultDtoOfSaleTypeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSaleTypeListItem.fromJS(resultData200) : new ListResultDtoOfSaleTypeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSaleTypeListItem>(<any>null);
    }

    /**
     * @deviceTypes (optional) 
     * @return Success
     */
    getPCDevices(deviceTypes: number[]): Observable<ListResultDtoOfPCDeviceListItem> {
        let url_ = this.baseUrl + "/api/services/app/PCs/GetPCDevices?";
        if (deviceTypes !== undefined)
            deviceTypes && deviceTypes.forEach(item => { url_ += "deviceTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPCDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPCDevices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPCDeviceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPCDeviceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPCDevices(response: Response): Observable<ListResultDtoOfPCDeviceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPCDeviceListItem.fromJS(resultData200) : new ListResultDtoOfPCDeviceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPCDeviceListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPC(input: CreatePCInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PCs/CreatePC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePC(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePC(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePC(input: UpdatePCInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PCs/UpdatePC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePC(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePC(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePC(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PCs/DeletePC?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePC(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePC(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPrintersAndKDSs(): Observable<ListResultDtoOfPCDeviceListItem> {
        let url_ = this.baseUrl + "/api/services/app/PCs/GetPrintersAndKDSs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPrintersAndKDSs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPrintersAndKDSs(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPCDeviceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPCDeviceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPrintersAndKDSs(response: Response): Observable<ListResultDtoOfPCDeviceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPCDeviceListItem.fromJS(resultData200) : new ListResultDtoOfPCDeviceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPCDeviceListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PCs/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PeriodServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreatePeriodInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Period/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<PeriodDto> {
        let url_ = this.baseUrl + "/api/services/app/Period/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<PeriodDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PeriodDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<PeriodDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PeriodDto.fromJS(resultData200) : new PeriodDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PeriodDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdatePeriodDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Period/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfPeriodListItem> {
        let url_ = this.baseUrl + "/api/services/app/Period/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPeriodListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPeriodListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfPeriodListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPeriodListItem.fromJS(resultData200) : new ListResultDtoOfPeriodListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPeriodListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedPeriodList(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedPeriodList> {
        let url_ = this.baseUrl + "/api/services/app/Period/GetPagedPeriodList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPeriodList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPeriodList(response_);
                } catch (e) {
                    return <Observable<PagedPeriodList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPeriodList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPeriodList(response: Response): Observable<PagedPeriodList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPeriodList.fromJS(resultData200) : new PagedPeriodList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPeriodList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Period/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Period/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllPermissions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPermissions(response: Response): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200) : new ListResultDtoOfFlatPermissionWithLevelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PluginScriptServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreatePluginScriptInput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PluginScript/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    get(input: PluginScriptInput): Observable<PluginScriptDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PluginScript/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<PluginScriptDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PluginScriptDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<PluginScriptDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PluginScriptDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PluginScriptDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PluginScript/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PluginSyncLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportToFile (optional) 
     * @return Success
     */
    pagedPluginSyncLogs(input: PluginSyncLogInput, pageNumber: number, pageSize: number, exportToFile: boolean): Observable<PagedPluginSyncLogsList> {
        let url_ = this.baseUrl + "/api/services/app/PluginSyncLog/PagedPluginSyncLogs?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportToFile !== undefined)
            url_ += "exportToFile=" + encodeURIComponent("" + exportToFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPagedPluginSyncLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPagedPluginSyncLogs(response_);
                } catch (e) {
                    return <Observable<PagedPluginSyncLogsList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPluginSyncLogsList>><any>Observable.throw(response_);
        });
    }

    protected processPagedPluginSyncLogs(response: Response): Observable<PagedPluginSyncLogsList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPluginSyncLogsList.fromJS(resultData200) : new PagedPluginSyncLogsList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPluginSyncLogsList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreatePluginSyncLogsInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PluginSyncLog/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @tenantIds (optional) 
     * @storeIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @assemblyVersion (optional) 
     * @assemblyFileVersion (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportPluginSyncLogs(tenantIds: number[], storeIds: number[], from: moment.Moment, to: moment.Moment, assemblyVersion: string, assemblyFileVersion: string, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PluginSyncLog/ExportPluginSyncLogs?";
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (assemblyVersion !== undefined)
            url_ += "AssemblyVersion=" + encodeURIComponent("" + assemblyVersion) + "&"; 
        if (assemblyFileVersion !== undefined)
            url_ += "AssemblyFileVersion=" + encodeURIComponent("" + assemblyFileVersion) + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPluginSyncLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPluginSyncLogs(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPluginSyncLogs(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PluginSyncLog/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PointsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPoint(id: number): Observable<PointDto> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetPoint?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPoint(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPoint(response_);
                } catch (e) {
                    return <Observable<PointDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PointDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPoint(response: Response): Observable<PointDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PointDto.fromJS(resultData200) : new PointDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PointDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPoints(): Observable<ListResultDtoOfPointListItem> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetPoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPoints(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPoints(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPointListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPointListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPoints(response: Response): Observable<ListResultDtoOfPointListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPointListItem.fromJS(resultData200) : new ListResultDtoOfPointListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPointListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPoints(pageNumber: number, pageSize: number): Observable<PagedPointList> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetPagedPoints?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPoints(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPoints(response_);
                } catch (e) {
                    return <Observable<PagedPointList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPointList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPoints(response: Response): Observable<PagedPointList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPointList.fromJS(resultData200) : new PagedPointList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPointList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPoint(input: CreatePointInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Points/CreatePoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePoint(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePoint(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePoint(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePoint(input: UpdatePointInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Points/UpdatePoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePoint(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePoint(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePoint(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePoint(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Points/DeletePoint?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePoint(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePoint(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePoint(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    variantsByProductId(id: number): Observable<VariantListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Points/VariantsByProductId?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVariantsByProductId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVariantsByProductId(response_);
                } catch (e) {
                    return <Observable<VariantListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<VariantListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processVariantsByProductId(response: Response): Observable<VariantListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(VariantListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<VariantListItem[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    unitOfMeasureByProductId(id: number): Observable<UnitOfMeasureListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Points/UnitOfMeasureByProductId?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnitOfMeasureByProductId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnitOfMeasureByProductId(response_);
                } catch (e) {
                    return <Observable<UnitOfMeasureListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitOfMeasureListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processUnitOfMeasureByProductId(response: Response): Observable<UnitOfMeasureListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UnitOfMeasureListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitOfMeasureListItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PosmenaNotificationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @file (optional) 
     * @userId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    notifyClientFileReady(file: FileDto, userId: number, tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PosmenaNotification/NotifyClientFileReady?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processNotifyClientFileReady(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processNotifyClientFileReady(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processNotifyClientFileReady(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @materials (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    notfiyClientMaterialsReachedReOrderLimit(materials: ReOrderMaterialDto[], tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PosmenaNotification/NotfiyClientMaterialsReachedReOrderLimit?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materials);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processNotfiyClientMaterialsReachedReOrderLimit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processNotfiyClientMaterialsReachedReOrderLimit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processNotfiyClientMaterialsReachedReOrderLimit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PosmenaNotification/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PosPresenceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @deviceId (optional) 
     * @return Success
     */
    getDeviceStatus(deviceId: string): Observable<DeviceStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/PosPresence/GetDeviceStatus?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceStatus(response_);
                } catch (e) {
                    return <Observable<DeviceStatusDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceStatusDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceStatus(response: Response): Observable<DeviceStatusDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeviceStatusDto.fromJS(resultData200) : new DeviceStatusDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceStatusDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    postCommand(input: EnqueueCommandInput): Observable<EnqueueCommandResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PosPresence/PostCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPostCommand(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPostCommand(response_);
                } catch (e) {
                    return <Observable<EnqueueCommandResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EnqueueCommandResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPostCommand(response: Response): Observable<EnqueueCommandResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EnqueueCommandResultDto.fromJS(resultData200) : new EnqueueCommandResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EnqueueCommandResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PosPresence/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PriceListServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPriceList(id: number): Observable<PriceListDTO> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetPriceList?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPriceList(response_);
                } catch (e) {
                    return <Observable<PriceListDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<PriceListDTO>><any>Observable.throw(response_);
        });
    }

    protected processGetPriceList(response: Response): Observable<PriceListDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PriceListDTO.fromJS(resultData200) : new PriceListDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PriceListDTO>(<any>null);
    }

    /**
     * @return Success
     */
    getPriceLists(): Observable<ListResultDtoOfPriceListListItem> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetPriceLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPriceLists(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPriceLists(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPriceListListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPriceListListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPriceLists(response: Response): Observable<ListResultDtoOfPriceListListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPriceListListItem.fromJS(resultData200) : new ListResultDtoOfPriceListListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPriceListListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedPriceList(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedPriceList> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetPagedPriceList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPriceList(response_);
                } catch (e) {
                    return <Observable<PagedPriceList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPriceList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPriceList(response: Response): Observable<PagedPriceList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPriceList.fromJS(resultData200) : new PagedPriceList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPriceList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPriceList(input: CreatePriceListDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/CreatePriceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePriceList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePriceList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePriceList(input: UpdatePriceListDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/UpdatePriceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePriceList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePriceList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePriceList(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/DeletePriceList?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePriceList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePriceList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PrimaryCategoriesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPrimaryCategory(id: number): Observable<PrimaryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/GetPrimaryCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPrimaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPrimaryCategory(response_);
                } catch (e) {
                    return <Observable<PrimaryCategoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PrimaryCategoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPrimaryCategory(response: Response): Observable<PrimaryCategoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PrimaryCategoryDto.fromJS(resultData200) : new PrimaryCategoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PrimaryCategoryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPrimaryCategories(): Observable<ListResultDtoOfPrimaryCategoryListItem> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/GetPrimaryCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPrimaryCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPrimaryCategories(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPrimaryCategoryListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPrimaryCategoryListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPrimaryCategories(response: Response): Observable<ListResultDtoOfPrimaryCategoryListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPrimaryCategoryListItem.fromJS(resultData200) : new ListResultDtoOfPrimaryCategoryListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPrimaryCategoryListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @return Success
     */
    getPagedPrimaryCategories(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedPrimaryCategoryList> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/GetPagedPrimaryCategories?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPrimaryCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPrimaryCategories(response_);
                } catch (e) {
                    return <Observable<PagedPrimaryCategoryList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPrimaryCategoryList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPrimaryCategories(response: Response): Observable<PagedPrimaryCategoryList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPrimaryCategoryList.fromJS(resultData200) : new PagedPrimaryCategoryList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPrimaryCategoryList>(<any>null);
    }

    /**
     * @return Success
     */
    generateCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPrimaryCategory(input: CreatePrimaryCategoryInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/CreatePrimaryCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePrimaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePrimaryCategory(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreatePrimaryCategory(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePrimaryCategory(input: UpdatePrimaryCategoryInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/UpdatePrimaryCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePrimaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePrimaryCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePrimaryCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePrimaryCategory(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/DeletePrimaryCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePrimaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePrimaryCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePrimaryCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PrimaryCategories/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ProductCategoriesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProductCategories(): Observable<ListResultDtoOfProductCategoryListItem> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetProductCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductCategories(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductCategoryListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductCategoryListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductCategories(response: Response): Observable<ListResultDtoOfProductCategoryListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductCategoryListItem.fromJS(resultData200) : new ListResultDtoOfProductCategoryListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductCategoryListItem>(<any>null);
    }

    /**
     * @return Success
     */
    refreshProductCategoriesCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/RefreshProductCategoriesCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRefreshProductCategoriesCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRefreshProductCategoriesCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRefreshProductCategoriesCache(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedProductCategories(pageNumber: number, pageSize: number, searchKey: string, descending: boolean): Observable<PagedProductCategoriesList> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetPagedProductCategories?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedProductCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedProductCategories(response_);
                } catch (e) {
                    return <Observable<PagedProductCategoriesList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedProductCategoriesList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedProductCategories(response: Response): Observable<PagedProductCategoriesList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedProductCategoriesList.fromJS(resultData200) : new PagedProductCategoriesList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedProductCategoriesList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductCategory(id: number): Observable<ProductCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetProductCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductCategory(response_);
                } catch (e) {
                    return <Observable<ProductCategoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCategoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductCategory(response: Response): Observable<ProductCategoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductCategoryDto.fromJS(resultData200) : new ProductCategoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCategoryDto>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(productCategoryId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetStoreGroupsTreeForEdit?";
        if (productCategoryId !== undefined)
            url_ += "ProductCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createProductCategory(input: CreateProductCategoryInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/CreateProductCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateProductCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateProductCategory(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateProductCategory(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProductCategory(input: UpdateProductCategoryInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/UpdateProductCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProductCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProductCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProductCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteProductCategory(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/DeleteProductCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteProductCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteProductCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteProductCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @categoryid (optional) 
     * @return Success
     */
    deleteCategoryImage(categoryid: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/DeleteCategoryImage?";
        if (categoryid !== undefined)
            url_ += "categoryid=" + encodeURIComponent("" + categoryid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteCategoryImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteCategoryImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteCategoryImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ProductsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductById(id: number): Observable<GetProductOutput> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductById(response_);
                } catch (e) {
                    return <Observable<GetProductOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProductOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProductById(response: Response): Observable<GetProductOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProductOutput.fromJS(resultData200) : new GetProductOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProductOutput>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @productCategoryId (optional) 
     * @search (optional) 
     * @return Success
     */
    getAllProducts(pageNumber: number, productCategoryId: number, search: string): Observable<ListResultDtoOfGetProductOutput> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllProducts?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (productCategoryId !== undefined)
            url_ += "productCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllProducts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAllProducts(response: Response): Observable<ListResultDtoOfGetProductOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductOutput.fromJS(resultData200) : new ListResultDtoOfGetProductOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductOutput>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @return Success
     */
    getAllProductsWithoutPaged(productCategoryId: number): Observable<ListResultDtoOfGetProductOutput> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllProductsWithoutPaged?";
        if (productCategoryId !== undefined)
            url_ += "productCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllProductsWithoutPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllProductsWithoutPaged(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAllProductsWithoutPaged(response: Response): Observable<ListResultDtoOfGetProductOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductOutput.fromJS(resultData200) : new ListResultDtoOfGetProductOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductOutput>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @return Success
     */
    getAllProductListItemWithoutPaged(productCategoryId: number): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllProductListItemWithoutPaged?";
        if (productCategoryId !== undefined)
            url_ += "productCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllProductListItemWithoutPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllProductListItemWithoutPaged(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllProductListItemWithoutPaged(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @vendorId (optional) 
     * @isService (optional) 
     * @return Success
     */
    getProducts(vendorId: number, isService: boolean): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProducts?";
        if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&"; 
        if (isService !== undefined)
            url_ += "IsService=" + encodeURIComponent("" + isService) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProducts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProducts(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProduct(id: number): Observable<ProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProduct?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProduct(response_);
                } catch (e) {
                    return <Observable<ProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProduct(response: Response): Observable<ProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductListItem.fromJS(resultData200) : new ProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @return Success
     */
    getPagedProducts(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedProductsList> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetPagedProducts?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedProducts(response_);
                } catch (e) {
                    return <Observable<PagedProductsList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedProductsList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedProducts(response: Response): Observable<PagedProductsList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedProductsList.fromJS(resultData200) : new PagedProductsList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedProductsList>(<any>null);
    }

    /**
     * @return Success
     */
    getNotServiceProducts(): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetNotServiceProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotServiceProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotServiceProducts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetNotServiceProducts(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @number (optional) 
     * @textSearch (optional) 
     * @return Success
     */
    getNumberOfNotServiceProducts(number: number, textSearch: string): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetNumberOfNotServiceProducts?";
        if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        if (textSearch !== undefined)
            url_ += "textSearch=" + encodeURIComponent("" + textSearch) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNumberOfNotServiceProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNumberOfNotServiceProducts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetNumberOfNotServiceProducts(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @number (optional) 
     * @textSearch (optional) 
     * @productIds (optional) 
     * @return Success
     */
    getNumberOfNotServiceProductsIncludedSelected(number: number, textSearch: string, productIds: number[]): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetNumberOfNotServiceProductsIncludedSelected?";
        if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        if (textSearch !== undefined)
            url_ += "textSearch=" + encodeURIComponent("" + textSearch) + "&"; 
        if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "productIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNumberOfNotServiceProductsIncludedSelected(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNumberOfNotServiceProductsIncludedSelected(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetNumberOfNotServiceProductsIncludedSelected(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @number (optional) 
     * @textSearch (optional) 
     * @productCategoryId (optional) 
     * @return Success
     */
    getNumberOfNotServiceProductsByProductId(number: number, textSearch: string, productCategoryId: number): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/getNumberOfNotServiceProductsByProductId?";
        if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        if (textSearch !== undefined)
            url_ += "textSearch=" + encodeURIComponent("" + textSearch) + "&"; 
        if (productCategoryId !== undefined)
            url_ += "productCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNumberOfNotServiceProductsByProductId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNumberOfNotServiceProductsByProductId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetNumberOfNotServiceProductsByProductId(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getNotServiceProductsHasPurchase(): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetNotServiceProductsHasPurchase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotServiceProductsHasPurchase(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotServiceProductsHasPurchase(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetNotServiceProductsHasPurchase(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @return Success
     */
    checkIfCategoryHasVatiant(productCategoryId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Products/CheckIfCategoryHasVatiant?";
        if (productCategoryId !== undefined)
            url_ += "productCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckIfCategoryHasVatiant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIfCategoryHasVatiant(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCheckIfCategoryHasVatiant(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createProduct(input: CreateProductInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Products/CreateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateProduct(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateProduct(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProduct(input: UpdateProductInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/UpdateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProduct(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProduct(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductUnitsOfMeasure(id: number): Observable<GetProductUnitsOfMeasureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductUnitsOfMeasure?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductUnitsOfMeasure(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductUnitsOfMeasure(response_);
                } catch (e) {
                    return <Observable<GetProductUnitsOfMeasureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProductUnitsOfMeasureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProductUnitsOfMeasure(response: Response): Observable<GetProductUnitsOfMeasureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProductUnitsOfMeasureOutput.fromJS(resultData200) : new GetProductUnitsOfMeasureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProductUnitsOfMeasureOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProductUnitsOfMeasure(input: UpdateProductUnitsOfMeasureInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/UpdateProductUnitsOfMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProductUnitsOfMeasure(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProductUnitsOfMeasure(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProductUnitsOfMeasure(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductVariants(id: number): Observable<GetProductVariantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductVariants?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductVariants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductVariants(response_);
                } catch (e) {
                    return <Observable<GetProductVariantsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProductVariantsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProductVariants(response: Response): Observable<GetProductVariantsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProductVariantsOutput.fromJS(resultData200) : new GetProductVariantsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProductVariantsOutput>(<any>null);
    }

    /**
     * @nums (optional) 
     * @return Success
     */
    containsDuplicate(nums: ProductVariantDto[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Products/ContainsDuplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nums);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processContainsDuplicate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processContainsDuplicate(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processContainsDuplicate(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProductVariants(input: UpdateProductVariantsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/UpdateProductVariants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProductVariants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProductVariants(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProductVariants(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductLimits(id: number): Observable<GetProductLimitsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductLimits?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductLimits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductLimits(response_);
                } catch (e) {
                    return <Observable<GetProductLimitsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProductLimitsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProductLimits(response: Response): Observable<GetProductLimitsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProductLimitsOutput.fromJS(resultData200) : new GetProductLimitsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProductLimitsOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProductLimits(input: UpdateProductLimitsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/UpdateProductLimits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProductLimits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProductLimits(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProductLimits(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @saleLimit (optional) 
     * @return Success
     */
    updateProductSaleLimits(saleLimit: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/UpdateProductSaleLimits?";
        if (saleLimit !== undefined)
            url_ += "SaleLimit=" + encodeURIComponent("" + saleLimit) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProductSaleLimits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProductSaleLimits(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProductSaleLimits(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteProduct(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/DeleteProduct?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteProduct(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteProduct(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @productId (optional) 
     * @return Success
     */
    getProductSerials(productId: number): Observable<ListResultDtoOfProductSerialItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductSerials?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductSerials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductSerials(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductSerialItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductSerialItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductSerials(response: Response): Observable<ListResultDtoOfProductSerialItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductSerialItem.fromJS(resultData200) : new ListResultDtoOfProductSerialItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductSerialItem>(<any>null);
    }

    /**
     * @productVariantId (optional) 
     * @return Success
     */
    getProductVariantSerials(productVariantId: number): Observable<ListResultDtoOfProductSerialItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductVariantSerials?";
        if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductVariantSerials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductVariantSerials(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductSerialItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductSerialItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductVariantSerials(response: Response): Observable<ListResultDtoOfProductSerialItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductSerialItem.fromJS(resultData200) : new ListResultDtoOfProductSerialItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductSerialItem>(<any>null);
    }

    /**
     * @productId (optional) 
     * @serial (optional) 
     * @return Success
     */
    getProductSerial(productId: number, serial: string): Observable<ProductSerialItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductSerial?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductSerial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductSerial(response_);
                } catch (e) {
                    return <Observable<ProductSerialItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductSerialItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductSerial(response: Response): Observable<ProductSerialItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductSerialItem.fromJS(resultData200) : new ProductSerialItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductSerialItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addProductSerial(input: AddProductSerialInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/AddProductSerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddProductSerial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddProductSerial(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddProductSerial(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @productId (optional) 
     * @serial (optional) 
     * @return Success
     */
    updateProductSerial(productId: number, serial: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/UpdateProductSerial?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProductSerial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProductSerial(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProductSerial(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteProductSerial(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/DeleteProductSerial?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteProductSerial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteProductSerial(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteProductSerial(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getManyProducts(): Observable<ListResultDtoOfProductListItem> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetManyProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetManyProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetManyProducts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetManyProducts(response: Response): Observable<ListResultDtoOfProductListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductListItem.fromJS(resultData200) : new ListResultDtoOfProductListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @productId (optional) 
     * @return Success
     */
    deleteImage(productId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/DeleteImage?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPrinter(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllPrinter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPrinter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllPrinter(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPrinter(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @productId (optional) 
     * @return Success
     */
    getAllProductStorePrices(productId: number): Observable<ProductStorePricesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllProductStorePrices?";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllProductStorePrices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllProductStorePrices(response_);
                } catch (e) {
                    return <Observable<ProductStorePricesDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductStorePricesDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllProductStorePrices(response: Response): Observable<ProductStorePricesDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductStorePricesDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductStorePricesDto[]>(<any>null);
    }

    /**
     * @productId (optional) 
     * @return Success
     */
    getAllUnitOfMeasureConversions(productId: number): Observable<UnitPricePricesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllUnitOfMeasureConversions?";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllUnitOfMeasureConversions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllUnitOfMeasureConversions(response_);
                } catch (e) {
                    return <Observable<UnitPricePricesDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitPricePricesDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllUnitOfMeasureConversions(response: Response): Observable<UnitPricePricesDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UnitPricePricesDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitPricePricesDto[]>(<any>null);
    }

    /**
     * @productId (optional) 
     * @productStorePrices (optional) 
     * @return Success
     */
    saveProductStorePrices(productId: number, productStorePrices: ProductStorePricesDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/SaveProductStorePrices?";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productStorePrices);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveProductStorePrices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveProductStorePrices(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveProductStorePrices(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ProductSalesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProductSales/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentUserProfileForEdit(response: Response): Observable<CurrentUserProfileEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentUserProfileEditDto.fromJS(resultData200) : new CurrentUserProfileEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateGoogleAuthenticatorKey(response: Response): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200) : new UpdateGoogleAuthenticatorKeyOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @return Success
     */
    sendVerificationSms(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendVerificationSms(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendVerificationSms(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    verifySmsCode(input: VerifySmsCodeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifySmsCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processVerifySmsCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCurrentUserProfile(input: CurrentUserProfileEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCurrentUserProfile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCurrentUserProfile(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangePassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangePassword(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangePassword(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProfilePicture(input: UpdateProfilePictureInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProfilePicture(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProfilePicture(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPasswordComplexitySetting(response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPasswordComplexitySetting(response: Response): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPasswordComplexitySettingOutput.fromJS(resultData200) : new GetPasswordComplexitySettingOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProfilePicture(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePicture(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @profilePictureId (optional) 
     * @userId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string, userId: number, tenantId: number): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFriendProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFriendProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFriendProfilePictureById(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePictureById(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeCalendarAsync(input: ChangeUserCalenderDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeCalendarAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeCalendarAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeCalendarAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeCalendarAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PromotionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPromotion(id: number): Observable<PromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPromotion?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPromotion(response_);
                } catch (e) {
                    return <Observable<PromotionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPromotion(response: Response): Observable<PromotionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionDto.fromJS(resultData200) : new PromotionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPromotions(): Observable<ListResultDtoOfPromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPromotions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPromotions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPromotions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPromotionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPromotionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPromotions(response: Response): Observable<ListResultDtoOfPromotionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPromotionDto.fromJS(resultData200) : new ListResultDtoOfPromotionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPromotionDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPromotionCode(id: number): Observable<PromotionCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPromotionCode?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPromotionCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPromotionCode(response_);
                } catch (e) {
                    return <Observable<PromotionCodeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionCodeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPromotionCode(response: Response): Observable<PromotionCodeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionCodeDto.fromJS(resultData200) : new PromotionCodeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionCodeDto>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPromotionList(pageNumber: number, pageSize: number): Observable<PagedPromotionList> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPagedPromotionList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPromotionList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPromotionList(response_);
                } catch (e) {
                    return <Observable<PagedPromotionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPromotionList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPromotionList(response: Response): Observable<PagedPromotionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPromotionList.fromJS(resultData200) : new PagedPromotionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPromotionList>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPromotionCodeList(pageNumber: number, pageSize: number): Observable<PagedPromotionCodeList> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPagedPromotionCodeList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPromotionCodeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPromotionCodeList(response_);
                } catch (e) {
                    return <Observable<PagedPromotionCodeList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPromotionCodeList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPromotionCodeList(response: Response): Observable<PagedPromotionCodeList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPromotionCodeList.fromJS(resultData200) : new PagedPromotionCodeList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPromotionCodeList>(<any>null);
    }

    /**
     * @promotiondto (optional) 
     * @return Success
     */
    createPromotion(promotiondto: PromotionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/CreatePromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotiondto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePromotion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePromotion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotionCodedto (optional) 
     * @return Success
     */
    createPromotionCode(promotionCodedto: PromotionCodeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/CreatePromotionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotionCodedto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePromotionCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePromotionCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePromotionCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotiondto (optional) 
     * @return Success
     */
    updatePromotion(promotiondto: PromotionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/UpdatePromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotiondto);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePromotion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePromotion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotionCodedto (optional) 
     * @return Success
     */
    updatePromotionCode(promotionCodedto: PromotionCodeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/UpdatePromotionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotionCodedto);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePromotionCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePromotionCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePromotionCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePromotion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/DeletePromotion?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePromotion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePromotion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePromotionCode(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/DeletePromotionCode?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePromotionCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePromotionCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePromotionCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotionId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(promotionId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetStoreGroupsTreeForEdit?";
        if (promotionId !== undefined)
            url_ += "promotionId=" + encodeURIComponent("" + promotionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PromotionFBServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPromotionFB(id: number): Observable<PromotionFBDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/GetPromotionFB?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPromotionFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPromotionFB(response_);
                } catch (e) {
                    return <Observable<PromotionFBDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionFBDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPromotionFB(response: Response): Observable<PromotionFBDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionFBDto.fromJS(resultData200) : new PromotionFBDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionFBDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPromotionsFB(): Observable<ListResultDtoOfPromotionFBDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/GetPromotionsFB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPromotionsFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPromotionsFB(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPromotionFBDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPromotionFBDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPromotionsFB(response: Response): Observable<ListResultDtoOfPromotionFBDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPromotionFBDto.fromJS(resultData200) : new ListResultDtoOfPromotionFBDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPromotionFBDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPromotionCodeFB(id: number): Observable<PromotionCodeFBDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/GetPromotionCodeFB?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPromotionCodeFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPromotionCodeFB(response_);
                } catch (e) {
                    return <Observable<PromotionCodeFBDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionCodeFBDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPromotionCodeFB(response: Response): Observable<PromotionCodeFBDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionCodeFBDto.fromJS(resultData200) : new PromotionCodeFBDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionCodeFBDto>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPromotionFBList(pageNumber: number, pageSize: number): Observable<PagedPromotionFBList> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/GetPagedPromotionFBList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPromotionFBList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPromotionFBList(response_);
                } catch (e) {
                    return <Observable<PagedPromotionFBList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPromotionFBList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPromotionFBList(response: Response): Observable<PagedPromotionFBList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPromotionFBList.fromJS(resultData200) : new PagedPromotionFBList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPromotionFBList>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPromotionCodeListFB(pageNumber: number, pageSize: number): Observable<PagedPromotionCodeFBList> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/GetPagedPromotionCodeListFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPromotionCodeListFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPromotionCodeListFB(response_);
                } catch (e) {
                    return <Observable<PagedPromotionCodeFBList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPromotionCodeFBList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPromotionCodeListFB(response: Response): Observable<PagedPromotionCodeFBList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPromotionCodeFBList.fromJS(resultData200) : new PagedPromotionCodeFBList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPromotionCodeFBList>(<any>null);
    }

    /**
     * @promotiondto (optional) 
     * @return Success
     */
    createPromotionFB(promotiondto: PromotionFBDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/CreatePromotionFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotiondto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePromotionFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePromotionFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePromotionFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotionCodedto (optional) 
     * @return Success
     */
    createPromotionCodeFB(promotionCodedto: PromotionCodeFBDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/CreatePromotionCodeFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotionCodedto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePromotionCodeFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePromotionCodeFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePromotionCodeFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotiondto (optional) 
     * @return Success
     */
    updatePromotionFB(promotiondto: PromotionFBDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/UpdatePromotionFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotiondto);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePromotionFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePromotionFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePromotionFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotionCodedto (optional) 
     * @return Success
     */
    updatePromotionCodeFB(promotionCodedto: PromotionCodeFBDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/UpdatePromotionCodeFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(promotionCodedto);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePromotionCodeFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePromotionCodeFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePromotionCodeFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePromotionFB(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/DeletePromotionFB?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePromotionFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePromotionFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePromotionFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePromotionCodeFB(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/DeletePromotionCodeFB?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePromotionCodeFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePromotionCodeFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePromotionCodeFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @promotionId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(promotionId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/GetStoreGroupsTreeForEdit?";
        if (promotionId !== undefined)
            url_ += "promotionId=" + encodeURIComponent("" + promotionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PromotionFB/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PurchaseInvoiceOrdersServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPurchaseInvoiceOrder(input: CreatePurchaseInvoiceOrderInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/CreatePurchaseInvoiceOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePurchaseInvoiceOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePurchaseInvoiceOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePurchaseInvoiceOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    submitPurchaseInvoiceOrder(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/SubmitPurchaseInvoiceOrder?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSubmitPurchaseInvoiceOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSubmitPurchaseInvoiceOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSubmitPurchaseInvoiceOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    takePurchaseInvoiceOrderApprovalAction(input: ApprovalActionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/TakePurchaseInvoiceOrderApprovalAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTakePurchaseInvoiceOrderApprovalAction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTakePurchaseInvoiceOrderApprovalAction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTakePurchaseInvoiceOrderApprovalAction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    editPurchaseInvoiceOrder(input: UpdatePurchaseInvoiceOrderInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/EditPurchaseInvoiceOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditPurchaseInvoiceOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditPurchaseInvoiceOrder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEditPurchaseInvoiceOrder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPurchaseInvoiceOrders(): Observable<ListResultDtoOfPurchaseInvoiceOrderListItem> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/GetPurchaseInvoiceOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoiceOrders(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoiceOrders(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPurchaseInvoiceOrderListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPurchaseInvoiceOrderListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoiceOrders(response: Response): Observable<ListResultDtoOfPurchaseInvoiceOrderListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPurchaseInvoiceOrderListItem.fromJS(resultData200) : new ListResultDtoOfPurchaseInvoiceOrderListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPurchaseInvoiceOrderListItem>(<any>null);
    }

    /**
     * @itemCode (optional) 
     * @recieptNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @onlyAwaitingMyAction (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPurchaseInvoiceOrders(itemCode: string, recieptNumber: string, from: moment.Moment, to: moment.Moment, onlyAwaitingMyAction: boolean, pageNumber: number, pageSize: number): Observable<PagedPurchaseInvoiceOrderList> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/GetPagedPurchaseInvoiceOrders?";
        if (itemCode !== undefined)
            url_ += "ItemCode=" + encodeURIComponent("" + itemCode) + "&"; 
        if (recieptNumber !== undefined)
            url_ += "RecieptNumber=" + encodeURIComponent("" + recieptNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (onlyAwaitingMyAction !== undefined)
            url_ += "OnlyAwaitingMyAction=" + encodeURIComponent("" + onlyAwaitingMyAction) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPurchaseInvoiceOrders(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPurchaseInvoiceOrders(response_);
                } catch (e) {
                    return <Observable<PagedPurchaseInvoiceOrderList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPurchaseInvoiceOrderList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPurchaseInvoiceOrders(response: Response): Observable<PagedPurchaseInvoiceOrderList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPurchaseInvoiceOrderList.fromJS(resultData200) : new PagedPurchaseInvoiceOrderList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPurchaseInvoiceOrderList>(<any>null);
    }

    /**
     * @actedSince (optional) 
     * @return Success
     */
    getPurchaseInvoiceOrderInboxSummary(actedSince: moment.Moment): Observable<ApprovalInboxSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/GetPurchaseInvoiceOrderInboxSummary?";
        if (actedSince !== undefined)
            url_ += "actedSince=" + encodeURIComponent(actedSince ? "" + actedSince.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoiceOrderInboxSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoiceOrderInboxSummary(response_);
                } catch (e) {
                    return <Observable<ApprovalInboxSummaryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ApprovalInboxSummaryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoiceOrderInboxSummary(response: Response): Observable<ApprovalInboxSummaryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ApprovalInboxSummaryDto.fromJS(resultData200) : new ApprovalInboxSummaryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ApprovalInboxSummaryDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @detail (optional) 
     * @return Success
     */
    getPurchaseInvoiceOrder(id: number, detail: boolean): Observable<PurchaseInvoiceOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/GetPurchaseInvoiceOrder?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (detail !== undefined)
            url_ += "detail=" + encodeURIComponent("" + detail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoiceOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoiceOrder(response_);
                } catch (e) {
                    return <Observable<PurchaseInvoiceOrderDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseInvoiceOrderDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoiceOrder(response: Response): Observable<PurchaseInvoiceOrderDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseInvoiceOrderDto.fromJS(resultData200) : new PurchaseInvoiceOrderDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseInvoiceOrderDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    convertToPurchaseInvoice(id: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/ConvertToPurchaseInvoice?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConvertToPurchaseInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConvertToPurchaseInvoice(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processConvertToPurchaseInvoice(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoiceOrders/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class PurchaseInvoicesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPurchaseInvoice(input: CreatePurchaseInvoiceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/CreatePurchaseInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePurchaseInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePurchaseInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePurchaseInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    submitPurchaseInvoice(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/SubmitPurchaseInvoice?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSubmitPurchaseInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSubmitPurchaseInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSubmitPurchaseInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    takePurchaseInvoiceApprovalAction(input: ApprovalActionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/TakePurchaseInvoiceApprovalAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTakePurchaseInvoiceApprovalAction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTakePurchaseInvoiceApprovalAction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTakePurchaseInvoiceApprovalAction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactionType (optional) 
     * @return Success
     */
    insertTransactionType(transactionType: TransactionTypeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/InsertTransactionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionType);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTransactionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTransactionType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertTransactionType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPurchaseInvoices(): Observable<ListResultDtoOfPurchaseInvoiceListItem> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetPurchaseInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPurchaseInvoiceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPurchaseInvoiceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoices(response: Response): Observable<ListResultDtoOfPurchaseInvoiceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPurchaseInvoiceListItem.fromJS(resultData200) : new ListResultDtoOfPurchaseInvoiceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPurchaseInvoiceListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getPurchaseBills(): Observable<ListResultDtoOfPurchaseBillsListItem> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetPurchaseBills";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseBills(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseBills(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPurchaseBillsListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPurchaseBillsListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseBills(response: Response): Observable<ListResultDtoOfPurchaseBillsListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPurchaseBillsListItem.fromJS(resultData200) : new ListResultDtoOfPurchaseBillsListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPurchaseBillsListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getPurchaseInvoicesNoHaveReturn(): Observable<ListResultDtoOfPurchaseInvoiceListItem> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetPurchaseInvoicesNoHaveReturn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoicesNoHaveReturn(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoicesNoHaveReturn(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPurchaseInvoiceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPurchaseInvoiceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoicesNoHaveReturn(response: Response): Observable<ListResultDtoOfPurchaseInvoiceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPurchaseInvoiceListItem.fromJS(resultData200) : new ListResultDtoOfPurchaseInvoiceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPurchaseInvoiceListItem>(<any>null);
    }

    /**
     * @itemCode (optional) 
     * @recieptNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @onlyAwaitingMyAction (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPurchaseIvoice(itemCode: string, recieptNumber: string, from: moment.Moment, to: moment.Moment, onlyAwaitingMyAction: boolean, pageNumber: number, pageSize: number): Observable<PagedPurchaseInvoiceList> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetPagedPurchaseIvoice?";
        if (itemCode !== undefined)
            url_ += "ItemCode=" + encodeURIComponent("" + itemCode) + "&"; 
        if (recieptNumber !== undefined)
            url_ += "RecieptNumber=" + encodeURIComponent("" + recieptNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (onlyAwaitingMyAction !== undefined)
            url_ += "OnlyAwaitingMyAction=" + encodeURIComponent("" + onlyAwaitingMyAction) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPurchaseIvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPurchaseIvoice(response_);
                } catch (e) {
                    return <Observable<PagedPurchaseInvoiceList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPurchaseInvoiceList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPurchaseIvoice(response: Response): Observable<PagedPurchaseInvoiceList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPurchaseInvoiceList.fromJS(resultData200) : new PagedPurchaseInvoiceList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPurchaseInvoiceList>(<any>null);
    }

    /**
     * @actedSince (optional) 
     * @return Success
     */
    getPurchaseInvoiceInboxSummary(actedSince: moment.Moment): Observable<ApprovalInboxSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetPurchaseInvoiceInboxSummary?";
        if (actedSince !== undefined)
            url_ += "actedSince=" + encodeURIComponent(actedSince ? "" + actedSince.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoiceInboxSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoiceInboxSummary(response_);
                } catch (e) {
                    return <Observable<ApprovalInboxSummaryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ApprovalInboxSummaryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoiceInboxSummary(response: Response): Observable<ApprovalInboxSummaryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ApprovalInboxSummaryDto.fromJS(resultData200) : new ApprovalInboxSummaryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ApprovalInboxSummaryDto>(<any>null);
    }

    /**
     * @itemCode (optional) 
     * @recieptNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @onlyAwaitingMyAction (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPurchaseIvoiceReturn(itemCode: string, recieptNumber: string, from: moment.Moment, to: moment.Moment, onlyAwaitingMyAction: boolean, pageNumber: number, pageSize: number): Observable<PagedPurchaseInvoiceList> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetPagedPurchaseIvoiceReturn?";
        if (itemCode !== undefined)
            url_ += "ItemCode=" + encodeURIComponent("" + itemCode) + "&"; 
        if (recieptNumber !== undefined)
            url_ += "RecieptNumber=" + encodeURIComponent("" + recieptNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (onlyAwaitingMyAction !== undefined)
            url_ += "OnlyAwaitingMyAction=" + encodeURIComponent("" + onlyAwaitingMyAction) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPurchaseIvoiceReturn(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPurchaseIvoiceReturn(response_);
                } catch (e) {
                    return <Observable<PagedPurchaseInvoiceList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPurchaseInvoiceList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPurchaseIvoiceReturn(response: Response): Observable<PagedPurchaseInvoiceList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPurchaseInvoiceList.fromJS(resultData200) : new PagedPurchaseInvoiceList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPurchaseInvoiceList>(<any>null);
    }

    /**
     * @id (optional) 
     * @detail (optional) 
     * @return Success
     */
    getPurchaseInvoice(id: number, detail: boolean): Observable<PurchaseInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetPurchaseInvoice?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (detail !== undefined)
            url_ += "detail=" + encodeURIComponent("" + detail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseInvoice(response_);
                } catch (e) {
                    return <Observable<PurchaseInvoiceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseInvoiceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseInvoice(response: Response): Observable<PurchaseInvoiceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseInvoiceDto.fromJS(resultData200) : new PurchaseInvoiceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseInvoiceDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    editPurchaseInvoice(input: UpdatePurchaseInvoiceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/EditPurchaseInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditPurchaseInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditPurchaseInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEditPurchaseInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    purchaseInvoiceReturns(input: UpdatePurchaseInvoiceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/PurchaseInvoiceReturns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseInvoiceReturns(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseInvoiceReturns(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseInvoiceReturns(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    transactionTypeList(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/TransactionTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTransactionTypeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTransactionTypeList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransactionTypeList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @productId (optional) 
     * @vendorId (optional) 
     * @return Success
     */
    getBestPurchasePrices(productId: number, vendorId: number): Observable<BestPurchasePricesDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetBestPurchasePrices?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBestPurchasePrices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBestPurchasePrices(response_);
                } catch (e) {
                    return <Observable<BestPurchasePricesDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<BestPurchasePricesDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBestPurchasePrices(response: Response): Observable<BestPurchasePricesDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BestPurchasePricesDto.fromJS(resultData200) : new BestPurchasePricesDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BestPurchasePricesDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseInvoices/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class QrMenaCategoriesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCategories(): Observable<QrMenaCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaCategories/GetCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCategories(response_);
                } catch (e) {
                    return <Observable<QrMenaCategoryDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<QrMenaCategoryDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCategories(response: Response): Observable<QrMenaCategoryDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(QrMenaCategoryDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<QrMenaCategoryDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaCategories/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class QrMenaMenuItemServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getMenuitemsList(storeId: number): Observable<QrMenaMenuItem[]> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaMenuItem/GetMenuitemsList?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuitemsList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuitemsList(response_);
                } catch (e) {
                    return <Observable<QrMenaMenuItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<QrMenaMenuItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuitemsList(response: Response): Observable<QrMenaMenuItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(QrMenaMenuItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<QrMenaMenuItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaMenuItem/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class QrMenaSaleTransactionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @invoice (optional) 
     * @return Success
     */
    qrMenaSaveDinInInvoice(invoice: QrMenaSaleTransactionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaSaleTransaction/QrMenaSaveDinInInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processQrMenaSaveDinInInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processQrMenaSaveDinInInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processQrMenaSaveDinInInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @invoice (optional) 
     * @return Success
     */
    qrMenaSaveDinInInvoiceHook(invoice: QrMenaSaleTransactionDto): Observable<QrMenaSaleTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaSaleTransaction/QrMenaSaveDinInInvoiceHook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processQrMenaSaveDinInInvoiceHook(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processQrMenaSaveDinInInvoiceHook(response_);
                } catch (e) {
                    return <Observable<QrMenaSaleTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<QrMenaSaleTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processQrMenaSaveDinInInvoiceHook(response: Response): Observable<QrMenaSaleTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? QrMenaSaleTransactionDto.fromJS(resultData200) : new QrMenaSaleTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<QrMenaSaleTransactionDto>(<any>null);
    }

    /**
     * @invoice (optional) 
     * @return Success
     */
    qrMenaUpdateDinInInvoice(invoice: QrMenaSaleTransactionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaSaleTransaction/QrMenaUpdateDinInInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processQrMenaUpdateDinInInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processQrMenaUpdateDinInInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processQrMenaUpdateDinInInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tableId (optional) 
     * @return Success
     */
    getTableInvoice(tableId: number): Observable<QrMenaSaleTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaSaleTransaction/GetTableInvoice?";
        if (tableId !== undefined)
            url_ += "tableId=" + encodeURIComponent("" + tableId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTableInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTableInvoice(response_);
                } catch (e) {
                    return <Observable<QrMenaSaleTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<QrMenaSaleTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTableInvoice(response: Response): Observable<QrMenaSaleTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? QrMenaSaleTransactionDto.fromJS(resultData200) : new QrMenaSaleTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<QrMenaSaleTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/QrMenaSaleTransaction/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RawMaterialServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @periodType (optional) 
     * @return Success
     */
    getAllAccordingToConfigs(storeId: number, periodType: number): Observable<RawMaterialListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetAllAccordingToConfigs?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (periodType !== undefined)
            url_ += "periodType=" + encodeURIComponent("" + periodType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllAccordingToConfigs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllAccordingToConfigs(response_);
                } catch (e) {
                    return <Observable<RawMaterialListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllAccordingToConfigs(response: Response): Observable<RawMaterialListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RawMaterialListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialListItem[]>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @rawMaterialId (optional) 
     * @return Success
     */
    getRawMaterialAccordingToConfigs(storeId: number, rawMaterialId: number): Observable<ValueTupleOfRawMaterialListItemAndPeriodType> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetRawMaterialAccordingToConfigs?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialAccordingToConfigs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialAccordingToConfigs(response_);
                } catch (e) {
                    return <Observable<ValueTupleOfRawMaterialListItemAndPeriodType>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValueTupleOfRawMaterialListItemAndPeriodType>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialAccordingToConfigs(response: Response): Observable<ValueTupleOfRawMaterialListItemAndPeriodType> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValueTupleOfRawMaterialListItemAndPeriodType.fromJS(resultData200) : new ValueTupleOfRawMaterialListItemAndPeriodType();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValueTupleOfRawMaterialListItemAndPeriodType>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateRawMaterialInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @suppliers (optional) 
     * @return Success
     */
    refreshRawMaterialsCache(suppliers: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/RefreshRawMaterialsCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suppliers);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRefreshRawMaterialsCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRefreshRawMaterialsCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRefreshRawMaterialsCache(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getRawMaterialDetailById(id: number): Observable<RawMaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetRawMaterialDetailById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialDetailById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialDetailById(response_);
                } catch (e) {
                    return <Observable<RawMaterialDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialDetailById(response: Response): Observable<RawMaterialDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RawMaterialDto.fromJS(resultData200) : new RawMaterialDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialDto>(<any>null);
    }

    /**
     * @code (optional) 
     * @id (optional) 
     * @return Success
     */
    isRawMaterialExist(code: string, id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/IsRawMaterialExist?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsRawMaterialExist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsRawMaterialExist(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsRawMaterialExist(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<RawMaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<RawMaterialDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<RawMaterialDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RawMaterialDto.fromJS(resultData200) : new RawMaterialDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRawMaterialBatch(): Observable<ListResultDtoOfRawMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetRawMaterialBatch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialBatch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialBatch(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialBatch(response: Response): Observable<ListResultDtoOfRawMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRawMaterialListItem.fromJS(resultData200) : new ListResultDtoOfRawMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRawMaterialListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getRawMaterialBatchWithUnit(): Observable<ListResultDtoOfRawMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetRawMaterialBatchWithUnit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialBatchWithUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialBatchWithUnit(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialBatchWithUnit(response: Response): Observable<ListResultDtoOfRawMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRawMaterialListItem.fromJS(resultData200) : new ListResultDtoOfRawMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRawMaterialListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfRawMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfRawMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRawMaterialListItem.fromJS(resultData200) : new ListResultDtoOfRawMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRawMaterialListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getBatchesMaterials(): Observable<ListResultDtoOfRawMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetBatchesMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBatchesMaterials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBatchesMaterials(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetBatchesMaterials(response: Response): Observable<ListResultDtoOfRawMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRawMaterialListItem.fromJS(resultData200) : new ListResultDtoOfRawMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRawMaterialListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @stockGroupId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedRawMaterial(input: string, stockGroupId: number, pageNumber: number, pageSize: number, descending: boolean): Observable<PagedRawMaterialList> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetPagedRawMaterial?";
        if (input !== undefined)
            url_ += "Input=" + encodeURIComponent("" + input) + "&"; 
        if (stockGroupId !== undefined)
            url_ += "stockGroupId=" + encodeURIComponent("" + stockGroupId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedRawMaterial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedRawMaterial(response_);
                } catch (e) {
                    return <Observable<PagedRawMaterialList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedRawMaterialList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedRawMaterial(response: Response): Observable<PagedRawMaterialList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedRawMaterialList.fromJS(resultData200) : new PagedRawMaterialList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedRawMaterialList>(<any>null);
    }

    /**
     * @id (optional) 
     * @periodType (optional) 
     * @return Success
     */
    getAllRawMaterialByStoreIdAndPeriodType(id: number, periodType: number): Observable<ListResultDtoOfRawMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetAllRawMaterialByStoreIdAndPeriodType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (periodType !== undefined)
            url_ += "periodType=" + encodeURIComponent("" + periodType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllRawMaterialByStoreIdAndPeriodType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllRawMaterialByStoreIdAndPeriodType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRawMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAllRawMaterialByStoreIdAndPeriodType(response: Response): Observable<ListResultDtoOfRawMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRawMaterialListItem.fromJS(resultData200) : new ListResultDtoOfRawMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRawMaterialListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateRawMaterialInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @rawMaterialId (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportRawMaterial(rawMaterialId: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/exportRawMaterial?";
        if (rawMaterialId !== undefined)
            url_ += "RawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportRawMaterial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportRawMaterial(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportRawMaterial(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @rawMaterialId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(rawMaterialId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetStoreGroupsTreeForEdit?";
        if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getRawMaterialsWithFactors(pageNumber: number, pageSize: number): Observable<RawMaterialResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetRawMaterialsWithFactors?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialsWithFactors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialsWithFactors(response_);
                } catch (e) {
                    return <Observable<RawMaterialResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialsWithFactors(response: Response): Observable<RawMaterialResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RawMaterialResultDto.fromJS(resultData200) : new RawMaterialResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterial/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RawMaterialConfigServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @searchKey (optional) 
     * @storeTypeIds (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedRawMaterialConfigList(searchKey: string, storeTypeIds: number[], pageNumber: number, pageSize: number): Observable<PagedRawMaterialConfigList> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/GetPagedRawMaterialConfigList?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (storeTypeIds !== undefined)
            storeTypeIds && storeTypeIds.forEach(item => { url_ += "StoreTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedRawMaterialConfigList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedRawMaterialConfigList(response_);
                } catch (e) {
                    return <Observable<PagedRawMaterialConfigList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedRawMaterialConfigList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedRawMaterialConfigList(response: Response): Observable<PagedRawMaterialConfigList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedRawMaterialConfigList.fromJS(resultData200) : new PagedRawMaterialConfigList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedRawMaterialConfigList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<RawMaterialConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<RawMaterialConfigDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialConfigDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<RawMaterialConfigDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RawMaterialConfigDto.fromJS(resultData200) : new RawMaterialConfigDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialConfigDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateRawMaterialConfigDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateRawMaterialConfigDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @rawMaterialConfigId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(rawMaterialConfigId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/GetStoreGroupsTreeForEdit?";
        if (rawMaterialConfigId !== undefined)
            url_ += "rawMaterialConfigId=" + encodeURIComponent("" + rawMaterialConfigId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @rawMaterialId (optional) 
     * @rawMaterialConfigId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEditByRawMaterialId(rawMaterialId: number, rawMaterialConfigId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/GetStoreGroupsTreeForEditByRawMaterialId?";
        if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        if (rawMaterialConfigId !== undefined)
            url_ += "rawMaterialConfigId=" + encodeURIComponent("" + rawMaterialConfigId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEditByRawMaterialId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEditByRawMaterialId(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEditByRawMaterialId(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RawMaterialConfig/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ReceiptCustomizationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getReceiptCustomization(id: number): Observable<ReceiptCustomizationDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/GetReceiptCustomization?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReceiptCustomization(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReceiptCustomization(response_);
                } catch (e) {
                    return <Observable<ReceiptCustomizationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReceiptCustomizationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetReceiptCustomization(response: Response): Observable<ReceiptCustomizationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReceiptCustomizationDto.fromJS(resultData200) : new ReceiptCustomizationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReceiptCustomizationDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @storeId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedReceiptCustomizations(tenantId: number, storeId: number, pageNumber: number, pageSize: number): Observable<PagedReceiptCustomizationList> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/GetPagedReceiptCustomizations?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedReceiptCustomizations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedReceiptCustomizations(response_);
                } catch (e) {
                    return <Observable<PagedReceiptCustomizationList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedReceiptCustomizationList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedReceiptCustomizations(response: Response): Observable<PagedReceiptCustomizationList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedReceiptCustomizationList.fromJS(resultData200) : new PagedReceiptCustomizationList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedReceiptCustomizationList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createReceiptCustomization(input: CreateReceiptCustomizationInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/CreateReceiptCustomization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateReceiptCustomization(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateReceiptCustomization(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateReceiptCustomization(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateReceiptCustomization(input: UpdateReceiptCustomizationInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/UpdateReceiptCustomization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateReceiptCustomization(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateReceiptCustomization(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateReceiptCustomization(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteReceiptCustomization(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/DeleteReceiptCustomization?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteReceiptCustomization(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteReceiptCustomization(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteReceiptCustomization(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    switchActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/SwitchActivate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSwitchActivate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSwitchActivate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSwitchActivate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    uploadFiles(id: number, file: FileParameter): Observable<CreateFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadFiles(response_);
                } catch (e) {
                    return <Observable<CreateFileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateFileDto>><any>Observable.throw(response_);
        });
    }

    protected processUploadFiles(response: Response): Observable<CreateFileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateFileDto.fromJS(resultData200) : new CreateFileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateFileDto>(<any>null);
    }

    /**
     * @themeId (optional) 
     * @return Success
     */
    deleteLogo(themeId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/DeleteLogo?";
        if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLogo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteLogo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLogo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptCustomization/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RecipeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateRecipeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<RecipeDto> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<RecipeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RecipeDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<RecipeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RecipeDto.fromJS(resultData200) : new RecipeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RecipeDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfRecipeListItem> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRecipeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRecipeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfRecipeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRecipeListItem.fromJS(resultData200) : new ListResultDtoOfRecipeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRecipeListItem>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @rawMaterialId (optional) 
     * @materialGroupId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedRecipeList(menuItemId: number, rawMaterialId: number, materialGroupId: number, pageNumber: number, pageSize: number): Observable<PagedRecipeListWithTotal> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/GetPagedRecipeList?";
        if (menuItemId !== undefined)
            url_ += "MenuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        if (rawMaterialId !== undefined)
            url_ += "RawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        if (materialGroupId !== undefined)
            url_ += "MaterialGroupId=" + encodeURIComponent("" + materialGroupId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedRecipeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedRecipeList(response_);
                } catch (e) {
                    return <Observable<PagedRecipeListWithTotal>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedRecipeListWithTotal>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedRecipeList(response: Response): Observable<PagedRecipeListWithTotal> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedRecipeListWithTotal.fromJS(resultData200) : new PagedRecipeListWithTotal();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedRecipeListWithTotal>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateRecipeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @recipeId (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportRecipe(recipeId: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/ExportRecipe?";
        if (recipeId !== undefined)
            url_ += "RecipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportRecipe(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportRecipe(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @documentType (optional) 
     * @return Success
     */
    exportRecipes(documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/ExportRecipes?";
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportRecipes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportRecipes(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportRecipes(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @recipeId (optional) 
     * @return Success
     */
    getRecipeStoreGroupsTreeForEdit(recipeId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/GetRecipeStoreGroupsTreeForEdit?";
        if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecipeStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecipeStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRecipeStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Recipe/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RefundServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @request (optional) 
     * @return Success
     */
    addInvoiceNotification(request: any): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Refund/AddInvoiceNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddInvoiceNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddInvoiceNotification(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processAddInvoiceNotification(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Refund/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RefundResonsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @refundReson (optional) 
     * @return Success
     */
    create(refundReson: RefundResonDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RefundResons/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(refundReson);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @refundReson (optional) 
     * @return Success
     */
    update(refundReson: RefundResonDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RefundResons/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(refundReson);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<RefundResonDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundResons/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<RefundResonDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RefundResonDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<RefundResonDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RefundResonDto.fromJS(resultData200) : new RefundResonDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RefundResonDto>(<any>null);
    }

    /**
     * @return Success
     */
    getResonsList(): Observable<RefundResonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RefundResons/GetResonsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetResonsList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetResonsList(response_);
                } catch (e) {
                    return <Observable<RefundResonDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<RefundResonDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetResonsList(response: Response): Observable<RefundResonDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RefundResonDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RefundResonDto[]>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getResonsPaged(pageNumber: number, pageSize: number): Observable<RefundResonList> {
        let url_ = this.baseUrl + "/api/services/app/RefundResons/GetResonsPaged?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetResonsPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetResonsPaged(response_);
                } catch (e) {
                    return <Observable<RefundResonList>><any>Observable.throw(e);
                }
            } else
                return <Observable<RefundResonList>><any>Observable.throw(response_);
        });
    }

    protected processGetResonsPaged(response: Response): Observable<RefundResonList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RefundResonList.fromJS(resultData200) : new RefundResonList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RefundResonList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RefundResons/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RefundResons/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RegionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedRegions(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedRegionsList> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetPagedRegions?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedRegions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedRegions(response_);
                } catch (e) {
                    return <Observable<PagedRegionsList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedRegionsList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedRegions(response: Response): Observable<PagedRegionsList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedRegionsList.fromJS(resultData200) : new PagedRegionsList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedRegionsList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getRegion(id: number): Observable<RegionDto> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetRegion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRegion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRegion(response_);
                } catch (e) {
                    return <Observable<RegionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRegion(response: Response): Observable<RegionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegionDto.fromJS(resultData200) : new RegionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegionDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createRegion(input: CreateRegionInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Region/CreateRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateRegion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateRegion(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateRegion(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateRegion(input: UpdateRegionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Region/UpdateRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRegion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateRegion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRegion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteRegion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Region/DeleteRegion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteRegion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteRegion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteRegion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRegions(): Observable<ListResultDtoOfRegionListItem> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRegions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRegions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRegions(response: Response): Observable<ListResultDtoOfRegionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRegionListItem.fromJS(resultData200) : new ListResultDtoOfRegionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRegionListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getRegionsForCurrentTenant(): Observable<ListResultDtoOfRegionListItem> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetRegionsForCurrentTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRegionsForCurrentTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRegionsForCurrentTenant(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRegionsForCurrentTenant(response: Response): Observable<ListResultDtoOfRegionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRegionListItem.fromJS(resultData200) : new ListResultDtoOfRegionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRegionListItem>(<any>null);
    }

    /**
     * @storeGroupId (optional) 
     * @return Success
     */
    getRegionsByStoreGroup(storeGroupId: number): Observable<ListResultDtoOfRegionListItem> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetRegionsByStoreGroup?";
        if (storeGroupId !== undefined)
            url_ += "storeGroupId=" + encodeURIComponent("" + storeGroupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRegionsByStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRegionsByStoreGroup(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRegionsByStoreGroup(response: Response): Observable<ListResultDtoOfRegionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRegionListItem.fromJS(resultData200) : new ListResultDtoOfRegionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRegionListItem>(<any>null);
    }

    /**
     * @storeGroupIds (optional) 
     * @return Success
     */
    getRegionsByStoreGroups(storeGroupIds: number[]): Observable<ListResultDtoOfRegionListItem> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetRegionsByStoreGroups?";
        if (storeGroupIds !== undefined)
            storeGroupIds && storeGroupIds.forEach(item => { url_ += "storeGroupIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRegionsByStoreGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRegionsByStoreGroups(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRegionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetRegionsByStoreGroups(response: Response): Observable<ListResultDtoOfRegionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRegionListItem.fromJS(resultData200) : new ListResultDtoOfRegionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRegionListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ReportGroupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateReportGroupInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<ReportGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGroup/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<ReportGroupDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReportGroupDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<ReportGroupDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReportGroupDto.fromJS(resultData200) : new ReportGroupDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReportGroupDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateReportGroupDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfReportGroupListItem> {
        let url_ = this.baseUrl + "/api/services/app/ReportGroup/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfReportGroupListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfReportGroupListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfReportGroupListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfReportGroupListItem.fromJS(resultData200) : new ListResultDtoOfReportGroupListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfReportGroupListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedReportGroupList(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedReportGroupList> {
        let url_ = this.baseUrl + "/api/services/app/ReportGroup/GetPagedReportGroupList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedReportGroupList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedReportGroupList(response_);
                } catch (e) {
                    return <Observable<PagedReportGroupList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedReportGroupList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedReportGroupList(response: Response): Observable<PagedReportGroupList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedReportGroupList.fromJS(resultData200) : new PagedReportGroupList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedReportGroupList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportGroup/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReportGroup/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ReportsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @saleTypeIds (optional) 
     * @productCategoriesIds (optional) 
     * @employeeIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTotalSalesCategoryByCashierFood(tenantId: number, regionId: number, areaId: number, storeIds: number[], from: moment.Moment, to: moment.Moment, saleTypeIds: number[], productCategoriesIds: number[], employeeIds: number[], documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesCategoryByCashierFood?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (productCategoriesIds !== undefined)
            productCategoriesIds && productCategoriesIds.forEach(item => { url_ += "ProductCategoriesIds=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "EmployeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesCategoryByCashierFood(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesCategoryByCashierFood(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesCategoryByCashierFood(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @fromStartedOn (optional) 
     * @toStartedOn (optional) 
     * @fromEndedOn (optional) 
     * @toEndedOn (optional) 
     * @supervisorIds (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSupervisorShiftReport(fromStartedOn: moment.Moment, toStartedOn: moment.Moment, fromEndedOn: moment.Moment, toEndedOn: moment.Moment, supervisorIds: number[], documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSupervisorShiftReport?";
        if (fromStartedOn !== undefined)
            url_ += "FromStartedOn=" + encodeURIComponent(fromStartedOn ? "" + fromStartedOn.toJSON() : "") + "&"; 
        if (toStartedOn !== undefined)
            url_ += "ToStartedOn=" + encodeURIComponent(toStartedOn ? "" + toStartedOn.toJSON() : "") + "&"; 
        if (fromEndedOn !== undefined)
            url_ += "FromEndedOn=" + encodeURIComponent(fromEndedOn ? "" + fromEndedOn.toJSON() : "") + "&"; 
        if (toEndedOn !== undefined)
            url_ += "ToEndedOn=" + encodeURIComponent(toEndedOn ? "" + toEndedOn.toJSON() : "") + "&"; 
        if (supervisorIds !== undefined)
            supervisorIds && supervisorIds.forEach(item => { url_ += "SupervisorIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSupervisorShiftReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSupervisorShiftReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSupervisorShiftReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @fromStartedOn (optional) 
     * @toStartedOn (optional) 
     * @fromEndedOn (optional) 
     * @toEndedOn (optional) 
     * @supervisorIds (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSupervisorShiftReportFB(fromStartedOn: moment.Moment, toStartedOn: moment.Moment, fromEndedOn: moment.Moment, toEndedOn: moment.Moment, supervisorIds: number[], documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSupervisorShiftReportFB?";
        if (fromStartedOn !== undefined)
            url_ += "FromStartedOn=" + encodeURIComponent(fromStartedOn ? "" + fromStartedOn.toJSON() : "") + "&"; 
        if (toStartedOn !== undefined)
            url_ += "ToStartedOn=" + encodeURIComponent(toStartedOn ? "" + toStartedOn.toJSON() : "") + "&"; 
        if (fromEndedOn !== undefined)
            url_ += "FromEndedOn=" + encodeURIComponent(fromEndedOn ? "" + fromEndedOn.toJSON() : "") + "&"; 
        if (toEndedOn !== undefined)
            url_ += "ToEndedOn=" + encodeURIComponent(toEndedOn ? "" + toEndedOn.toJSON() : "") + "&"; 
        if (supervisorIds !== undefined)
            supervisorIds && supervisorIds.forEach(item => { url_ += "SupervisorIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSupervisorShiftReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSupervisorShiftReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSupervisorShiftReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @supervisorShiftId (optional) 
     * @fromStartedOn (optional) 
     * @toStartedOn (optional) 
     * @fromEndedOn (optional) 
     * @toEndedOn (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCashierShiftReport(supervisorShiftId: number, fromStartedOn: moment.Moment, toStartedOn: moment.Moment, fromEndedOn: moment.Moment, toEndedOn: moment.Moment, cashierIds: number[], documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCashierShiftReport?";
        if (supervisorShiftId !== undefined)
            url_ += "SupervisorShiftId=" + encodeURIComponent("" + supervisorShiftId) + "&"; 
        if (fromStartedOn !== undefined)
            url_ += "FromStartedOn=" + encodeURIComponent(fromStartedOn ? "" + fromStartedOn.toJSON() : "") + "&"; 
        if (toStartedOn !== undefined)
            url_ += "ToStartedOn=" + encodeURIComponent(toStartedOn ? "" + toStartedOn.toJSON() : "") + "&"; 
        if (fromEndedOn !== undefined)
            url_ += "FromEndedOn=" + encodeURIComponent(fromEndedOn ? "" + fromEndedOn.toJSON() : "") + "&"; 
        if (toEndedOn !== undefined)
            url_ += "ToEndedOn=" + encodeURIComponent(toEndedOn ? "" + toEndedOn.toJSON() : "") + "&"; 
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCashierShiftReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCashierShiftReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCashierShiftReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @supervisorShiftId (optional) 
     * @fromStartedOn (optional) 
     * @toStartedOn (optional) 
     * @fromEndedOn (optional) 
     * @toEndedOn (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCashierShiftReportFB(supervisorShiftId: number, fromStartedOn: moment.Moment, toStartedOn: moment.Moment, fromEndedOn: moment.Moment, toEndedOn: moment.Moment, cashierIds: number[], documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCashierShiftReportFB?";
        if (supervisorShiftId !== undefined)
            url_ += "SupervisorShiftId=" + encodeURIComponent("" + supervisorShiftId) + "&"; 
        if (fromStartedOn !== undefined)
            url_ += "FromStartedOn=" + encodeURIComponent(fromStartedOn ? "" + fromStartedOn.toJSON() : "") + "&"; 
        if (toStartedOn !== undefined)
            url_ += "ToStartedOn=" + encodeURIComponent(toStartedOn ? "" + toStartedOn.toJSON() : "") + "&"; 
        if (fromEndedOn !== undefined)
            url_ += "FromEndedOn=" + encodeURIComponent(fromEndedOn ? "" + fromEndedOn.toJSON() : "") + "&"; 
        if (toEndedOn !== undefined)
            url_ += "ToEndedOn=" + encodeURIComponent(toEndedOn ? "" + toEndedOn.toJSON() : "") + "&"; 
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCashierShiftReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCashierShiftReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCashierShiftReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @lastDate (optional) 
     * @userId (optional) 
     * @moduleIds (optional) 
     * @exportSpecificModule (optional) 
     * @compressFile (optional) 
     * @return Success
     */
    syncAllTables(lastDate: moment.Moment, userId: number, moduleIds: number[], exportSpecificModule: boolean, compressFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SyncAllTables?";
        if (lastDate !== undefined)
            url_ += "LastDate=" + encodeURIComponent(lastDate ? "" + lastDate.toJSON() : "") + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (moduleIds !== undefined)
            moduleIds && moduleIds.forEach(item => { url_ += "ModuleIds=" + encodeURIComponent("" + item) + "&"; });
        if (exportSpecificModule !== undefined)
            url_ += "ExportSpecificModule=" + encodeURIComponent("" + exportSpecificModule) + "&"; 
        if (compressFile !== undefined)
            url_ += "CompressFile=" + encodeURIComponent("" + compressFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncAllTables(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncAllTables(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processSyncAllTables(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printBarcode(input: PrintProductBarcodeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PrintBarcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintBarcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintBarcode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPrintBarcode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportSystemSalesReport(input: SystemSalesReportInputDto, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSystemSalesReport?";
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSystemSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSystemSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSystemSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    systemSalesReport(input: SystemSalesReportInputDto): Observable<SystemSalesReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SystemSalesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSystemSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSystemSalesReport(response_);
                } catch (e) {
                    return <Observable<SystemSalesReportOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SystemSalesReportOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processSystemSalesReport(response: Response): Observable<SystemSalesReportOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SystemSalesReportOutputDto.fromJS(resultData200) : new SystemSalesReportOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SystemSalesReportOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportSystemSalesReportDetails(input: SystemSalesReportInputDto, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSystemSalesReportDetails?";
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSystemSalesReportDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSystemSalesReportDetails(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSystemSalesReportDetails(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    systemSalesReportDetails(input: SystemSalesReportInputDto): Observable<SystemSalesReportOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SystemSalesReportDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSystemSalesReportDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSystemSalesReportDetails(response_);
                } catch (e) {
                    return <Observable<SystemSalesReportOutputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SystemSalesReportOutputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSystemSalesReportDetails(response: Response): Observable<SystemSalesReportOutputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SystemSalesReportOutputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SystemSalesReportOutputDto[]>(<any>null);
    }

    /**
     * @childTenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @categoryIds (optional) 
     * @isCSVFile (optional) 
     * @categoryPagging (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportMenuItemSalesVSCostReport(childTenantId: number, regionId: number, areaId: number, storeIds: number[], from: moment.Moment, to: moment.Moment, categoryIds: number[], isCSVFile: boolean, categoryPagging: any[], sorting: string, skipCount: number, maxResultCount: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportMenuItemSalesVSCostReport?";
        if (childTenantId !== undefined)
            url_ += "ChildTenantId=" + encodeURIComponent("" + childTenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (categoryPagging !== undefined)
            categoryPagging && categoryPagging.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "CategoryPagging[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMenuItemSalesVSCostReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMenuItemSalesVSCostReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMenuItemSalesVSCostReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAppSettingsJson(response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAppSettingsJson(response: Response): Observable<AppSettingsJsonDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    menuItemSalesVSCost(input: MenuItemSalesVSCostInputDto): Observable<PagedMenuItemSalesVSCost> {
        let url_ = this.baseUrl + "/api/services/app/Reports/MenuItemSalesVSCost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMenuItemSalesVSCost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMenuItemSalesVSCost(response_);
                } catch (e) {
                    return <Observable<PagedMenuItemSalesVSCost>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMenuItemSalesVSCost>><any>Observable.throw(response_);
        });
    }

    protected processMenuItemSalesVSCost(response: Response): Observable<PagedMenuItemSalesVSCost> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMenuItemSalesVSCost.fromJS(resultData200) : new PagedMenuItemSalesVSCost();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMenuItemSalesVSCost>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    returnPurchaseReportBySupplierFB(input: PurchaseReportBySupplierFBInput, pagenumber: number, pagesize: number): Observable<PurchaseReportBySupplierDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ReturnPurchaseReportBySupplierFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReturnPurchaseReportBySupplierFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReturnPurchaseReportBySupplierFB(response_);
                } catch (e) {
                    return <Observable<PurchaseReportBySupplierDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportBySupplierDto>><any>Observable.throw(response_);
        });
    }

    protected processReturnPurchaseReportBySupplierFB(response: Response): Observable<PurchaseReportBySupplierDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportBySupplierDto.fromJS(resultData200) : new PurchaseReportBySupplierDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportBySupplierDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @supplierId (optional) 
     * @storeIds (optional) 
     * @rowMatrailIds (optional) 
     * @regionId (optional) 
     * @tenantId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @showAllDetails (optional) 
     * @return Success
     */
    exportReturnPurchasesBySupplierToFile(transactionTypeId: number, supplierId: number, storeIds: number[], rowMatrailIds: number[], regionId: number, tenantId: number, areaId: number, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, isCSVFile: boolean, showAllDetails: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportReturnPurchasesBySupplierToFile?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (rowMatrailIds !== undefined)
            rowMatrailIds && rowMatrailIds.forEach(item => { url_ += "RowMatrailIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (showAllDetails !== undefined)
            url_ += "ShowAllDetails=" + encodeURIComponent("" + showAllDetails) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportReturnPurchasesBySupplierToFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportReturnPurchasesBySupplierToFile(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportReturnPurchasesBySupplierToFile(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @i (optional) 
     * @return Success
     */
    dashboardCards(i: GlobalFilters): Observable<Dashboardcards> {
        let url_ = this.baseUrl + "/api/services/app/Reports/DashboardCards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDashboardCards(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDashboardCards(response_);
                } catch (e) {
                    return <Observable<Dashboardcards>><any>Observable.throw(e);
                }
            } else
                return <Observable<Dashboardcards>><any>Observable.throw(response_);
        });
    }

    protected processDashboardCards(response: Response): Observable<Dashboardcards> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Dashboardcards.fromJS(resultData200) : new Dashboardcards();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<Dashboardcards>(<any>null);
    }

    /**
     * @i (optional) 
     * @return Success
     */
    dashboardSalesPerformanceAndSalesDistribution(i: GlobalFilters): Observable<SalesPerformanceAndSalesDistribution> {
        let url_ = this.baseUrl + "/api/services/app/Reports/DashboardSalesPerformanceAndSalesDistribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(i);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDashboardSalesPerformanceAndSalesDistribution(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDashboardSalesPerformanceAndSalesDistribution(response_);
                } catch (e) {
                    return <Observable<SalesPerformanceAndSalesDistribution>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesPerformanceAndSalesDistribution>><any>Observable.throw(response_);
        });
    }

    protected processDashboardSalesPerformanceAndSalesDistribution(response: Response): Observable<SalesPerformanceAndSalesDistribution> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesPerformanceAndSalesDistribution.fromJS(resultData200) : new SalesPerformanceAndSalesDistribution();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesPerformanceAndSalesDistribution>(<any>null);
    }

    /**
     * @store_id (optional) 
     * @return Success
     */
    heatmapDetails(store_id: number): Observable<HeatmapDetails> {
        let url_ = this.baseUrl + "/api/services/app/Reports/HeatmapDetails?";
        if (store_id !== undefined)
            url_ += "store_id=" + encodeURIComponent("" + store_id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processHeatmapDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processHeatmapDetails(response_);
                } catch (e) {
                    return <Observable<HeatmapDetails>><any>Observable.throw(e);
                }
            } else
                return <Observable<HeatmapDetails>><any>Observable.throw(response_);
        });
    }

    protected processHeatmapDetails(response: Response): Observable<HeatmapDetails> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HeatmapDetails.fromJS(resultData200) : new HeatmapDetails();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HeatmapDetails>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    pathfinder(input: SalesSummaryInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportWithDetailsDto_Pathfinder> {
        let url_ = this.baseUrl + "/api/services/app/Reports/Pathfinder?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPathfinder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPathfinder(response_);
                } catch (e) {
                    return <Observable<SalesReportWithDetailsDto_Pathfinder>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportWithDetailsDto_Pathfinder>><any>Observable.throw(response_);
        });
    }

    protected processPathfinder(response: Response): Observable<SalesReportWithDetailsDto_Pathfinder> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportWithDetailsDto_Pathfinder.fromJS(resultData200) : new SalesReportWithDetailsDto_Pathfinder();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportWithDetailsDto_Pathfinder>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    pathfinderRetail(input: SalesSummaryInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportWithDetailsRetailDto_Pathfinder> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PathfinderRetail?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPathfinderRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPathfinderRetail(response_);
                } catch (e) {
                    return <Observable<SalesReportWithDetailsRetailDto_Pathfinder>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportWithDetailsRetailDto_Pathfinder>><any>Observable.throw(response_);
        });
    }

    protected processPathfinderRetail(response: Response): Observable<SalesReportWithDetailsRetailDto_Pathfinder> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportWithDetailsRetailDto_Pathfinder.fromJS(resultData200) : new SalesReportWithDetailsRetailDto_Pathfinder();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportWithDetailsRetailDto_Pathfinder>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportTotalSalesByTimeRetail(input: TotalSalesByTimeInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesByTimeRetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesByTimeRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesByTimeRetail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesByTimeRetail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    paymentMethodsRetailReport(input: PaymentMethodsInput, skipCount: number, maxResultCount: number): Observable<PaymentMethodsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PaymentMethodsRetailReport?";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentMethodsRetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentMethodsRetailReport(response_);
                } catch (e) {
                    return <Observable<PaymentMethodsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentMethodsReport>><any>Observable.throw(response_);
        });
    }

    protected processPaymentMethodsRetailReport(response: Response): Observable<PaymentMethodsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentMethodsReport.fromJS(resultData200) : new PaymentMethodsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentMethodsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportTenderTypesRetailReport(input: PaymentMethodsInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTenderTypesRetailReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenderTypesRetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenderTypesRetailReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenderTypesRetailReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportToFile (optional) 
     * @return Success
     */
    incomeAuditByDayReportRetail(input: IncomeAuditByDayReportInput, pageNumber: number, pageSize: number, exportToFile: boolean): Observable<IncomeAuditByDayReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/IncomeAuditByDayReportRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportToFile !== undefined)
            url_ += "exportToFile=" + encodeURIComponent("" + exportToFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIncomeAuditByDayReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIncomeAuditByDayReportRetail(response_);
                } catch (e) {
                    return <Observable<IncomeAuditByDayReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<IncomeAuditByDayReport>><any>Observable.throw(response_);
        });
    }

    protected processIncomeAuditByDayReportRetail(response: Response): Observable<IncomeAuditByDayReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IncomeAuditByDayReport.fromJS(resultData200) : new IncomeAuditByDayReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IncomeAuditByDayReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportIncomeAuditByDayReportRetail(input: IncomeAuditByDayReportInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportIncomeAuditByDayReportRetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportIncomeAuditByDayReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportIncomeAuditByDayReportRetail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportIncomeAuditByDayReportRetail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productByTimeReportRetail(input: ProductByTimeReportInputRetail, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsByTimeReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductByTimeReportRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductByTimeReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductByTimeReportRetail(response_);
                } catch (e) {
                    return <Observable<ProductsByTimeReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsByTimeReport>><any>Observable.throw(response_);
        });
    }

    protected processProductByTimeReportRetail(response: Response): Observable<ProductsByTimeReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsByTimeReport.fromJS(resultData200) : new ProductsByTimeReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsByTimeReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportProductSalesByTimeReportRetail(input: ProductByTimeReportInputRetail): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductSalesByTimeReportRetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductSalesByTimeReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductSalesByTimeReportRetail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductSalesByTimeReportRetail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    systemSalesReportRetail(input: SystemSalesReportInputDto): Observable<SystemSalesReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SystemSalesReportRetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSystemSalesReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSystemSalesReportRetail(response_);
                } catch (e) {
                    return <Observable<SystemSalesReportOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SystemSalesReportOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processSystemSalesReportRetail(response: Response): Observable<SystemSalesReportOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SystemSalesReportOutputDto.fromJS(resultData200) : new SystemSalesReportOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SystemSalesReportOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportSystemSalesReportRetail(input: SystemSalesReportInputDto, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSystemSalesReportRetail?";
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSystemSalesReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSystemSalesReportRetail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSystemSalesReportRetail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    comboMealsReportFB1(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ComboMealsReportFB1?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComboMealsReportFB1(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComboMealsReportFB1(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processComboMealsReportFB1(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    comboMealsReportFB(input: ComboMealsReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ComboMealsReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComboMealsReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComboMealsReportFB(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processComboMealsReportFB(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantsIds (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @showDetails (optional) 
     * @return Success
     */
    exportComboMealsReportFB(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantsIds: number[], regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean, showDetails: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportComboMealsReportFB?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (showDetails !== undefined)
            url_ += "ShowDetails=" + encodeURIComponent("" + showDetails) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportComboMealsReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportComboMealsReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportComboMealsReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getFastestAndSlowestOrdersReport(input: FastestAndSlowestOrdersReportInput, pageNumber: number, pageSize: number): Observable<FastestAndSlowestOrdersReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetFastestAndSlowestOrdersReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFastestAndSlowestOrdersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFastestAndSlowestOrdersReport(response_);
                } catch (e) {
                    return <Observable<FastestAndSlowestOrdersReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FastestAndSlowestOrdersReportDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFastestAndSlowestOrdersReport(response: Response): Observable<FastestAndSlowestOrdersReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FastestAndSlowestOrdersReportDto.fromJS(resultData200) : new FastestAndSlowestOrdersReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FastestAndSlowestOrdersReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportFastestAndSlowestOrdersReport(input: FastestAndSlowestOrdersReportInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportFastestAndSlowestOrdersReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportFastestAndSlowestOrdersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportFastestAndSlowestOrdersReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportFastestAndSlowestOrdersReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesCashierShiftReportFB(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesCashierShiftReportFB?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesCashierShiftReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesCashierShiftReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesCashierShiftReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @offerType (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportOfferDetailReport(from: moment.Moment, to: moment.Moment, offerType: OfferType, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportOfferDetailReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (offerType !== undefined)
            url_ += "OfferType=" + encodeURIComponent("" + offerType) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportOfferDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportOfferDetailReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportOfferDetailReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @showRefund (optional) 
     * @showDiscountOrPromotionOnly (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesReportFB(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantIds: number[], regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, showRefund: boolean, showDiscountOrPromotionOnly: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesReportFB?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showRefund !== undefined)
            url_ += "ShowRefund=" + encodeURIComponent("" + showRefund) + "&"; 
        if (showDiscountOrPromotionOnly !== undefined)
            url_ += "ShowDiscountOrPromotionOnly=" + encodeURIComponent("" + showDiscountOrPromotionOnly) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @showRefund (optional) 
     * @showDiscountOrPromotionOnly (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesSummaryReportFB(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantIds: number[], regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, showRefund: boolean, showDiscountOrPromotionOnly: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesSummaryReportFB?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showRefund !== undefined)
            url_ += "ShowRefund=" + encodeURIComponent("" + showRefund) + "&"; 
        if (showDiscountOrPromotionOnly !== undefined)
            url_ += "ShowDiscountOrPromotionOnly=" + encodeURIComponent("" + showDiscountOrPromotionOnly) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesSummaryReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesSummaryReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesSummaryReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantsIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @tenderTypes (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTenderTypesFABReport(from: moment.Moment, to: moment.Moment, employees: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantsIds: number[], regionId: number, areaId: number, storeIds: number[], tenderTypes: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTenderTypesFABReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenderTypesFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenderTypesFABReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenderTypesFABReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesSummaryReport(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesSummaryReport?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesSummaryReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesSummaryReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesSummaryReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getMaterialStockByStoreId(storeId: number): Observable<ListResultDtoOfMaterialStockDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetMaterialStockByStoreId?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMaterialStockByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMaterialStockByStoreId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMaterialStockDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMaterialStockDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMaterialStockByStoreId(response: Response): Observable<ListResultDtoOfMaterialStockDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMaterialStockDto.fromJS(resultData200) : new ListResultDtoOfMaterialStockDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMaterialStockDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportStockOnHand(storeId: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportStockOnHand?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockOnHand(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockOnHand(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockOnHand(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportReturnSalesReportFBNew(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportReturnSalesReportFBNew?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportReturnSalesReportFBNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportReturnSalesReportFBNew(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportReturnSalesReportFBNew(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @vendors (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportPurchaseReport(from: moment.Moment, to: moment.Moment, vendors: number[], documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPurchaseReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (vendors !== undefined)
            vendors && vendors.forEach(item => { url_ += "Vendors=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPurchaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPurchaseReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPurchaseReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @entityFromId (optional) 
     * @entityToId (optional) 
     * @supplierId (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportPurchaseReportFB(transactionTypeId: number, entityFromId: number, entityToId: number, supplierId: number, tenantId: number, regionId: number, areaId: number, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPurchaseReportFB?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (entityFromId !== undefined)
            url_ += "EntityFromId=" + encodeURIComponent("" + entityFromId) + "&"; 
        if (entityToId !== undefined)
            url_ += "EntityToId=" + encodeURIComponent("" + entityToId) + "&"; 
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPurchaseReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPurchaseReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPurchaseReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @entityFromId (optional) 
     * @entityToId (optional) 
     * @supplierId (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductCardReportFB(transactionTypeId: number, entityFromId: number, entityToId: number, supplierId: number, tenantId: number, regionId: number, areaId: number, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductCardReportFB?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (entityFromId !== undefined)
            url_ += "EntityFromId=" + encodeURIComponent("" + entityFromId) + "&"; 
        if (entityToId !== undefined)
            url_ += "EntityToId=" + encodeURIComponent("" + entityToId) + "&"; 
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductCardReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductCardReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductCardReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    exportBalanceReport(from: moment.Moment, to: moment.Moment, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean, sorting: string, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportBalanceReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportBalanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportBalanceReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportBalanceReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    exportBalanceReportFB(from: moment.Moment, to: moment.Moment, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean, sorting: string, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportBalanceReportFB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportBalanceReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportBalanceReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportBalanceReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @customerName (optional) 
     * @mobileNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @isCSVFile (optional) 
     * @sortNumber (optional) 
     * @return Success
     */
    exportcustomersBalanceReport(customerName: string, mobileNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, isCSVFile: boolean, sortNumber: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/exportcustomersBalanceReport?";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (sortNumber !== undefined)
            url_ += "sortNumber=" + encodeURIComponent("" + sortNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportcustomersBalanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportcustomersBalanceReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportcustomersBalanceReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @stores (optional) 
     * @rawMaterials (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportStockBalanceReport(stores: number[], rawMaterials: number[], documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportStockBalanceReport?";
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (rawMaterials !== undefined)
            rawMaterials && rawMaterials.forEach(item => { url_ += "RawMaterials=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockBalanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockBalanceReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockBalanceReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @stores (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesAndPurchaseReport(from: moment.Moment, to: moment.Moment, stores: number[], documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesAndPurchaseReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesAndPurchaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesAndPurchaseReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesAndPurchaseReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @entityFromId (optional) 
     * @entityToId (optional) 
     * @supplierId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @stores (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesAndPurchaseReportFB(transactionTypeId: number, entityFromId: number, entityToId: number, supplierId: number, from: moment.Moment, to: moment.Moment, stores: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesAndPurchaseReportFB?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (entityFromId !== undefined)
            url_ += "EntityFromId=" + encodeURIComponent("" + entityFromId) + "&"; 
        if (entityToId !== undefined)
            url_ += "EntityToId=" + encodeURIComponent("" + entityToId) + "&"; 
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesAndPurchaseReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesAndPurchaseReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesAndPurchaseReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @customers (optional) 
     * @referenceNumberORCode (optional) 
     * @storeIds (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportReturnSalesReport(from: moment.Moment, to: moment.Moment, customers: string[], referenceNumberORCode: string, storeIds: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportReturnSalesReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (customers !== undefined)
            customers && customers.forEach(item => { url_ += "Customers=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumberORCode !== undefined)
            url_ += "ReferenceNumberORCode=" + encodeURIComponent("" + referenceNumberORCode) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportReturnSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportReturnSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportReturnSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @customers (optional) 
     * @referenceNumberORCode (optional) 
     * @storeIds (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportReturnSalesReportFB(from: moment.Moment, to: moment.Moment, customers: string[], referenceNumberORCode: string, storeIds: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportReturnSalesReportFB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (customers !== undefined)
            customers && customers.forEach(item => { url_ += "Customers=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumberORCode !== undefined)
            url_ += "ReferenceNumberORCode=" + encodeURIComponent("" + referenceNumberORCode) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportReturnSalesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportReturnSalesReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportReturnSalesReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesCashiersReportFB(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesCashiersReportFB?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesCashiersReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesCashiersReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesCashiersReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @closeShiftMethod (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportShortOverReportFB(from: moment.Moment, to: moment.Moment, employees: number[], documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], showStoreName: boolean, closeShiftMethod: CloseShiftMethod, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportShortOverReportFB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (closeShiftMethod !== undefined)
            url_ += "CloseShiftMethod=" + encodeURIComponent("" + closeShiftMethod) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportShortOverReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportShortOverReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportShortOverReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesCashiersReport(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesCashiersReport?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesCashiersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesCashiersReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesCashiersReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesManReport(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesManReport?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesManReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesManReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesManReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @categories (optional) 
     * @referenceNumberORCode (optional) 
     * @showrawMaterialNumber (optional) 
     * @nameOrCode (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportStockValuesReport(products: number[], categories: number[], referenceNumberORCode: string, showrawMaterialNumber: boolean, nameOrCode: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportStockValuesReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumberORCode !== undefined)
            url_ += "ReferenceNumberORCode=" + encodeURIComponent("" + referenceNumberORCode) + "&"; 
        if (showrawMaterialNumber !== undefined)
            url_ += "ShowrawMaterialNumber=" + encodeURIComponent("" + showrawMaterialNumber) + "&"; 
        if (nameOrCode !== undefined)
            url_ += "NameOrCode=" + encodeURIComponent("" + nameOrCode) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockValuesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockValuesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockValuesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @matrialId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantId (optional) 
     * @isEndOfDay (optional) 
     * @showMaterialName (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportMaterialStockTransactionReport(storeId: number, matrialId: number, fromDate: moment.Moment, toDate: moment.Moment, tenantId: number, isEndOfDay: boolean, showMaterialName: boolean, regionId: number, areaId: number, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportMaterialStockTransactionReport?";
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (matrialId !== undefined)
            url_ += "MatrialId=" + encodeURIComponent("" + matrialId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showMaterialName !== undefined)
            url_ += "ShowMaterialName=" + encodeURIComponent("" + showMaterialName) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMaterialStockTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMaterialStockTransactionReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMaterialStockTransactionReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @categories (optional) 
     * @referenceNumberORCode (optional) 
     * @showrawMaterialNumber (optional) 
     * @nameOrCode (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportStockValuesQuantityReport(products: number[], categories: number[], referenceNumberORCode: string, showrawMaterialNumber: boolean, nameOrCode: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportStockValuesQuantityReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumberORCode !== undefined)
            url_ += "ReferenceNumberORCode=" + encodeURIComponent("" + referenceNumberORCode) + "&"; 
        if (showrawMaterialNumber !== undefined)
            url_ += "ShowrawMaterialNumber=" + encodeURIComponent("" + showrawMaterialNumber) + "&"; 
        if (nameOrCode !== undefined)
            url_ += "NameOrCode=" + encodeURIComponent("" + nameOrCode) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockValuesQuantityReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockValuesQuantityReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockValuesQuantityReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @categories (optional) 
     * @referenceNumberORCode (optional) 
     * @showrawMaterialNumber (optional) 
     * @nameOrCode (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportStockValuesQuantityReportFB(products: number[], categories: number[], referenceNumberORCode: string, showrawMaterialNumber: boolean, nameOrCode: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportStockValuesQuantityReportFB?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumberORCode !== undefined)
            url_ += "ReferenceNumberORCode=" + encodeURIComponent("" + referenceNumberORCode) + "&"; 
        if (showrawMaterialNumber !== undefined)
            url_ += "ShowrawMaterialNumber=" + encodeURIComponent("" + showrawMaterialNumber) + "&"; 
        if (nameOrCode !== undefined)
            url_ += "NameOrCode=" + encodeURIComponent("" + nameOrCode) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportStockValuesQuantityReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportStockValuesQuantityReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportStockValuesQuantityReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @stores (optional) 
     * @products (optional) 
     * @from (optional) 
     * @to (optional) 
     * @referenceNumberORCode (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductPurchaseReport(stores: number[], products: number[], from: moment.Moment, to: moment.Moment, referenceNumberORCode: string, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductPurchaseReport?";
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (referenceNumberORCode !== undefined)
            url_ += "ReferenceNumberORCode=" + encodeURIComponent("" + referenceNumberORCode) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductPurchaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductPurchaseReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductPurchaseReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @entityFromId (optional) 
     * @entityToId (optional) 
     * @supplierId (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductPurchaseReportFB(transactionTypeId: number, entityFromId: number, entityToId: number, supplierId: number, tenantId: number, regionId: number, areaId: number, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductPurchaseReportFB?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (entityFromId !== undefined)
            url_ += "EntityFromId=" + encodeURIComponent("" + entityFromId) + "&"; 
        if (entityToId !== undefined)
            url_ += "EntityToId=" + encodeURIComponent("" + entityToId) + "&"; 
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductPurchaseReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductPurchaseReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductPurchaseReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportLotReport(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportLotReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportLotReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportLotReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportLotReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportLotReportFB(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportLotReportFB?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportLotReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportLotReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportLotReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportOutOfStockReport(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportOutOfStockReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportOutOfStockReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportOutOfStockReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportOutOfStockReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportOutOfStockReportFB(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportOutOfStockReportFB?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportOutOfStockReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportOutOfStockReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportOutOfStockReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportrawMaterialNotUsed(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportrawMaterialNotUsed?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportrawMaterialNotUsed(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportrawMaterialNotUsed(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportrawMaterialNotUsed(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportrawMaterials(input: LotReportInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportrawMaterials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportrawMaterials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportrawMaterials(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportrawMaterials(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @stores (optional) 
     * @fromStores (optional) 
     * @toStores (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductCardReport(products: number[], stores: number[], fromStores: number[], toStores: number[], from: moment.Moment, to: moment.Moment, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductCardReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (fromStores !== undefined)
            fromStores && fromStores.forEach(item => { url_ += "FromStores=" + encodeURIComponent("" + item) + "&"; });
        if (toStores !== undefined)
            toStores && toStores.forEach(item => { url_ += "ToStores=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductCardReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductCardReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductCardReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @stores (optional) 
     * @fromStores (optional) 
     * @toStores (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTransfersReport(products: number[], stores: number[], fromStores: number[], toStores: number[], from: moment.Moment, to: moment.Moment, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTransfersReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (fromStores !== undefined)
            fromStores && fromStores.forEach(item => { url_ += "FromStores=" + encodeURIComponent("" + item) + "&"; });
        if (toStores !== undefined)
            toStores && toStores.forEach(item => { url_ += "ToStores=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTransfersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTransfersReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTransfersReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @stores (optional) 
     * @from (optional) 
     * @to (optional) 
     * @referenceNumber (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductMovementReport(products: number[], stores: number[], from: moment.Moment, to: moment.Moment, referenceNumber: string, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductMovementReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductMovementReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductMovementReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductMovementReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportOutOfStockDetailReport(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportOutOfStockDetailReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportOutOfStockDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportOutOfStockDetailReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportOutOfStockDetailReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportOutOfStockDetailReportFB(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportOutOfStockDetailReportFB?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportOutOfStockDetailReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportOutOfStockDetailReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportOutOfStockDetailReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductNotUsedReport(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductNotUsedReport?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductNotUsedReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductNotUsedReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductNotUsedReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @products (optional) 
     * @referenceNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductNotUsedReportFB(products: number[], referenceNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductNotUsedReportFB?";
        if (products !== undefined)
            products && products.forEach(item => { url_ += "Products=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductNotUsedReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductNotUsedReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductNotUsedReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @productsNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTrendingProductsReport(productsNumber: number, from: moment.Moment, to: moment.Moment, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTrendingProductsReport?";
        if (productsNumber !== undefined)
            url_ += "productsNumber=" + encodeURIComponent("" + productsNumber) + "&"; 
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTrendingProductsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTrendingProductsReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTrendingProductsReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @productsNumber (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTrendingProductsReportFB(from: moment.Moment, to: moment.Moment, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, productsNumber: number, storeIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTrendingProductsReportFB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (productsNumber !== undefined)
            url_ += "ProductsNumber=" + encodeURIComponent("" + productsNumber) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTrendingProductsReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTrendingProductsReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTrendingProductsReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @productsNumber (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTrendingRawMaterialReportFB(productsNumber: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTrendingRawMaterialReportFB?";
        if (productsNumber !== undefined)
            url_ += "productsNumber=" + encodeURIComponent("" + productsNumber) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTrendingRawMaterialReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTrendingRawMaterialReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTrendingRawMaterialReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @firstDate (optional) 
     * @secondDate (optional) 
     * @datePeriod (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isEndOfDay (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCompareSalesReport(firstDate: moment.Moment, secondDate: moment.Moment, datePeriod: DatePeriod, documentType: number, tenantId: number, regionId: number, areaId: number, isEndOfDay: boolean, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCompareSalesReport?";
        if (firstDate !== undefined)
            url_ += "FirstDate=" + encodeURIComponent(firstDate ? "" + firstDate.toJSON() : "") + "&"; 
        if (secondDate !== undefined)
            url_ += "SecondDate=" + encodeURIComponent(secondDate ? "" + secondDate.toJSON() : "") + "&"; 
        if (datePeriod !== undefined)
            url_ += "DatePeriod=" + encodeURIComponent("" + datePeriod) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCompareSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCompareSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCompareSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @firstDate (optional) 
     * @secondDate (optional) 
     * @datePeriod (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isEndOfDay (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCompareSalesReportFAB(firstDate: moment.Moment, secondDate: moment.Moment, datePeriod: DatePeriod2, documentType: number, tenantId: number, regionId: number, areaId: number, isEndOfDay: boolean, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCompareSalesReportFAB?";
        if (firstDate !== undefined)
            url_ += "FirstDate=" + encodeURIComponent(firstDate ? "" + firstDate.toJSON() : "") + "&"; 
        if (secondDate !== undefined)
            url_ += "SecondDate=" + encodeURIComponent(secondDate ? "" + secondDate.toJSON() : "") + "&"; 
        if (datePeriod !== undefined)
            url_ += "DatePeriod=" + encodeURIComponent("" + datePeriod) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCompareSalesReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCompareSalesReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCompareSalesReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @firstDateRangeStart (optional) 
     * @secondDateRangeStart (optional) 
     * @firstDateRangeEnd (optional) 
     * @secondDateRangeEnd (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCompareSalesPeriodByPeriodReport(firstDateRangeStart: moment.Moment, secondDateRangeStart: moment.Moment, firstDateRangeEnd: moment.Moment, secondDateRangeEnd: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCompareSalesPeriodByPeriodReport?";
        if (firstDateRangeStart !== undefined)
            url_ += "FirstDateRangeStart=" + encodeURIComponent(firstDateRangeStart ? "" + firstDateRangeStart.toJSON() : "") + "&"; 
        if (secondDateRangeStart !== undefined)
            url_ += "SecondDateRangeStart=" + encodeURIComponent(secondDateRangeStart ? "" + secondDateRangeStart.toJSON() : "") + "&"; 
        if (firstDateRangeEnd !== undefined)
            url_ += "FirstDateRangeEnd=" + encodeURIComponent(firstDateRangeEnd ? "" + firstDateRangeEnd.toJSON() : "") + "&"; 
        if (secondDateRangeEnd !== undefined)
            url_ += "SecondDateRangeEnd=" + encodeURIComponent(secondDateRangeEnd ? "" + secondDateRangeEnd.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "isEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCompareSalesPeriodByPeriodReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCompareSalesPeriodByPeriodReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCompareSalesPeriodByPeriodReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @firstDateRangeStart (optional) 
     * @secondDateRangeStart (optional) 
     * @firstDateRangeEnd (optional) 
     * @secondDateRangeEnd (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCompareSalesPeriodByPeriodReportFAB(firstDateRangeStart: moment.Moment, secondDateRangeStart: moment.Moment, firstDateRangeEnd: moment.Moment, secondDateRangeEnd: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCompareSalesPeriodByPeriodReportFAB?";
        if (firstDateRangeStart !== undefined)
            url_ += "FirstDateRangeStart=" + encodeURIComponent(firstDateRangeStart ? "" + firstDateRangeStart.toJSON() : "") + "&"; 
        if (secondDateRangeStart !== undefined)
            url_ += "SecondDateRangeStart=" + encodeURIComponent(secondDateRangeStart ? "" + secondDateRangeStart.toJSON() : "") + "&"; 
        if (firstDateRangeEnd !== undefined)
            url_ += "FirstDateRangeEnd=" + encodeURIComponent(firstDateRangeEnd ? "" + firstDateRangeEnd.toJSON() : "") + "&"; 
        if (secondDateRangeEnd !== undefined)
            url_ += "SecondDateRangeEnd=" + encodeURIComponent(secondDateRangeEnd ? "" + secondDateRangeEnd.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "isEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCompareSalesPeriodByPeriodReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCompareSalesPeriodByPeriodReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCompareSalesPeriodByPeriodReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @materialIds (optional) 
     * @firstDateRangeStart (optional) 
     * @firstDateRangeEnd (optional) 
     * @secondDateRangeStart (optional) 
     * @secondDateRangeEnd (optional) 
     * @isEndOfDay (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportComparePurchasePeriodByPeriodFAB(tenantId: number, regionId: number, areaId: number, storeIds: number[], materialIds: number[], firstDateRangeStart: moment.Moment, firstDateRangeEnd: moment.Moment, secondDateRangeStart: moment.Moment, secondDateRangeEnd: moment.Moment, isEndOfDay: boolean, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportComparePurchasePeriodByPeriodFAB?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (materialIds !== undefined)
            materialIds && materialIds.forEach(item => { url_ += "MaterialIds=" + encodeURIComponent("" + item) + "&"; });
        if (firstDateRangeStart !== undefined)
            url_ += "FirstDateRangeStart=" + encodeURIComponent(firstDateRangeStart ? "" + firstDateRangeStart.toJSON() : "") + "&"; 
        if (firstDateRangeEnd !== undefined)
            url_ += "FirstDateRangeEnd=" + encodeURIComponent(firstDateRangeEnd ? "" + firstDateRangeEnd.toJSON() : "") + "&"; 
        if (secondDateRangeStart !== undefined)
            url_ += "SecondDateRangeStart=" + encodeURIComponent(secondDateRangeStart ? "" + secondDateRangeStart.toJSON() : "") + "&"; 
        if (secondDateRangeEnd !== undefined)
            url_ += "SecondDateRangeEnd=" + encodeURIComponent(secondDateRangeEnd ? "" + secondDateRangeEnd.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportComparePurchasePeriodByPeriodFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportComparePurchasePeriodByPeriodFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportComparePurchasePeriodByPeriodFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @firstStock (optional) 
     * @secondStock (optional) 
     * @date (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCompareStocksSalesFABReport(firstStock: number, secondStock: number, date: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCompareStocksSalesFABReport?";
        if (firstStock !== undefined)
            url_ += "FirstStock=" + encodeURIComponent("" + firstStock) + "&"; 
        if (secondStock !== undefined)
            url_ += "SecondStock=" + encodeURIComponent("" + secondStock) + "&"; 
        if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "isEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCompareStocksSalesFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCompareStocksSalesFABReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCompareStocksSalesFABReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @firstStock (optional) 
     * @secondStock (optional) 
     * @date (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCompareStocksSalesReport(firstStock: number, secondStock: number, date: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCompareStocksSalesReport?";
        if (firstStock !== undefined)
            url_ += "FirstStock=" + encodeURIComponent("" + firstStock) + "&"; 
        if (secondStock !== undefined)
            url_ += "SecondStock=" + encodeURIComponent("" + secondStock) + "&"; 
        if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "isEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCompareStocksSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCompareStocksSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCompareStocksSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @firstStock (optional) 
     * @secondStock (optional) 
     * @firstDate (optional) 
     * @secondDate (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCompareStocksSalesReportDayByDayDate(firstStock: number, secondStock: number, firstDate: moment.Moment, secondDate: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCompareStocksSalesReportDayByDayDate?";
        if (firstStock !== undefined)
            url_ += "FirstStock=" + encodeURIComponent("" + firstStock) + "&"; 
        if (secondStock !== undefined)
            url_ += "SecondStock=" + encodeURIComponent("" + secondStock) + "&"; 
        if (firstDate !== undefined)
            url_ += "FirstDate=" + encodeURIComponent(firstDate ? "" + firstDate.toJSON() : "") + "&"; 
        if (secondDate !== undefined)
            url_ += "SecondDate=" + encodeURIComponent(secondDate ? "" + secondDate.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "isEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCompareStocksSalesReportDayByDayDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCompareStocksSalesReportDayByDayDate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCompareStocksSalesReportDayByDayDate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @firstDate (optional) 
     * @secondDate (optional) 
     * @storeIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportComparePurchaseReport(transactionTypeId: number, firstDate: moment.Moment, secondDate: moment.Moment, storeIds: number[], regionId: number, areaId: number, documentType: number, tenantId: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportComparePurchaseReport?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (firstDate !== undefined)
            url_ += "FirstDate=" + encodeURIComponent(firstDate ? "" + firstDate.toJSON() : "") + "&"; 
        if (secondDate !== undefined)
            url_ += "SecondDate=" + encodeURIComponent(secondDate ? "" + secondDate.toJSON() : "") + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportComparePurchaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportComparePurchaseReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportComparePurchaseReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @firstDate (optional) 
     * @secondDate (optional) 
     * @storeIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @documentType (optional) 
     * @tenantId (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportComparePurchaseReportFAB(transactionTypeId: number, firstDate: moment.Moment, secondDate: moment.Moment, storeIds: number[], regionId: number, areaId: number, documentType: number, tenantId: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportComparePurchaseReportFAB?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (firstDate !== undefined)
            url_ += "FirstDate=" + encodeURIComponent(firstDate ? "" + firstDate.toJSON() : "") + "&"; 
        if (secondDate !== undefined)
            url_ += "SecondDate=" + encodeURIComponent(secondDate ? "" + secondDate.toJSON() : "") + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportComparePurchaseReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportComparePurchaseReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportComparePurchaseReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @customerName (optional) 
     * @mobileNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCustomersSalesReport(customerName: string, mobileNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCustomersSalesReport?";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCustomersSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCustomersSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCustomersSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @customerName (optional) 
     * @mobileNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCustomersSalesReportFAB(customerName: string, mobileNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCustomersSalesReportFAB?";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCustomersSalesReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCustomersSalesReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCustomersSalesReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @tenderTypes (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTenderTypesReport(from: moment.Moment, to: moment.Moment, employees: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], tenderTypes: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTenderTypesReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenderTypesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenderTypesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenderTypesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantsIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @tenderTypes (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTenderTypesSummaryFABReport(from: moment.Moment, to: moment.Moment, employees: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantsIds: number[], regionId: number, areaId: number, storeIds: number[], tenderTypes: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTenderTypesSummaryFABReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenderTypesSummaryFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenderTypesSummaryFABReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenderTypesSummaryFABReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @timeFrom (optional) 
     * @timeTo (optional) 
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @tenderTypes (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTenderTypesByTimeFABReport(timeFrom: string, timeTo: string, from: moment.Moment, to: moment.Moment, employees: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], tenderTypes: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTenderTypesByTimeFABReport?";
        if (timeFrom !== undefined)
            url_ += "TimeFrom=" + encodeURIComponent("" + timeFrom) + "&"; 
        if (timeTo !== undefined)
            url_ += "TimeTo=" + encodeURIComponent("" + timeTo) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTenderTypesByTimeFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTenderTypesByTimeFABReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTenderTypesByTimeFABReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @tenderTypes (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCashierTenderTypesFABReport(from: moment.Moment, to: moment.Moment, employees: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], tenderTypes: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCashierTenderTypesFABReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCashierTenderTypesFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCashierTenderTypesFABReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCashierTenderTypesFABReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @tenderTypes (optional) 
     * @primaryCategories (optional) 
     * @productCategories (optional) 
     * @secondatyCategories (optional) 
     * @menuItems (optional) 
     * @referenceNumber (optional) 
     * @code (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTotalSalesReport(from: moment.Moment, to: moment.Moment, tenderTypes: number[], primaryCategories: number[], productCategories: number[], secondatyCategories: number[], menuItems: number[], referenceNumber: string, code: string, cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantIds: number[], regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (primaryCategories !== undefined)
            primaryCategories && primaryCategories.forEach(item => { url_ += "PrimaryCategories=" + encodeURIComponent("" + item) + "&"; });
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (secondatyCategories !== undefined)
            secondatyCategories && secondatyCategories.forEach(item => { url_ += "SecondatyCategories=" + encodeURIComponent("" + item) + "&"; });
        if (menuItems !== undefined)
            menuItems && menuItems.forEach(item => { url_ += "MenuItems=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @referenceNumber (optional) 
     * @customerIds (optional) 
     * @storeIds (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportPurchaseDetailReport(from: moment.Moment, to: moment.Moment, referenceNumber: string, customerIds: number[], storeIds: number[], documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPurchaseDetailReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPurchaseDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPurchaseDetailReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPurchaseDetailReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @tenderTypes (optional) 
     * @primaryCategories (optional) 
     * @productCategories (optional) 
     * @secondatyCategories (optional) 
     * @menuItems (optional) 
     * @referenceNumber (optional) 
     * @code (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTotalSalesReportFAB(from: moment.Moment, to: moment.Moment, tenderTypes: number[], primaryCategories: number[], productCategories: number[], secondatyCategories: number[], menuItems: number[], referenceNumber: string, code: string, cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantIds: number[], regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesReportFAB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (primaryCategories !== undefined)
            primaryCategories && primaryCategories.forEach(item => { url_ += "PrimaryCategories=" + encodeURIComponent("" + item) + "&"; });
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (secondatyCategories !== undefined)
            secondatyCategories && secondatyCategories.forEach(item => { url_ += "SecondatyCategories=" + encodeURIComponent("" + item) + "&"; });
        if (menuItems !== undefined)
            menuItems && menuItems.forEach(item => { url_ += "MenuItems=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @tenderTypes (optional) 
     * @primaryCategories (optional) 
     * @productCategories (optional) 
     * @secondatyCategories (optional) 
     * @menuItems (optional) 
     * @referenceNumber (optional) 
     * @code (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTotalSalesReportByStoresFAB(from: moment.Moment, to: moment.Moment, tenderTypes: number[], primaryCategories: number[], productCategories: number[], secondatyCategories: number[], menuItems: number[], referenceNumber: string, code: string, cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantIds: number[], regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesReportByStoresFAB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (primaryCategories !== undefined)
            primaryCategories && primaryCategories.forEach(item => { url_ += "PrimaryCategories=" + encodeURIComponent("" + item) + "&"; });
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (secondatyCategories !== undefined)
            secondatyCategories && secondatyCategories.forEach(item => { url_ += "SecondatyCategories=" + encodeURIComponent("" + item) + "&"; });
        if (menuItems !== undefined)
            menuItems && menuItems.forEach(item => { url_ += "MenuItems=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesReportByStoresFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesReportByStoresFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesReportByStoresFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductSalesReport(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductSalesReport?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductVendorsSalesReport(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductVendorsSalesReport?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductVendorsSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductVendorsSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductVendorsSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesmanDetailsReport(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesmanDetailsReport?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesmanDetailsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesmanDetailsReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesmanDetailsReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductSalesWithCombodetailsReportFAB(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductSalesWithCombodetailsReportFAB?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductSalesWithCombodetailsReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductSalesWithCombodetailsReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductSalesWithCombodetailsReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductSalesReportFAB(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductSalesReportFAB?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductSalesReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductSalesReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductSalesReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductSalesWithTobaccoTaxReportFAB(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductSalesWithTobaccoTaxReportFAB?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductSalesWithTobaccoTaxReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductSalesWithTobaccoTaxReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductSalesWithTobaccoTaxReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductCashierSalesReportFAB(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductCashierSalesReportFAB?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductCashierSalesReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductCashierSalesReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductCashierSalesReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @from (optional) 
     * @to (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @customerIds (optional) 
     * @isStoreDataInDetail (optional) 
     * @isCashierDataInDetail (optional) 
     * @isCustomerDataInDetail (optional) 
     * @isSupplierDataInDetail (optional) 
     * @storeIds (optional) 
     * @cashierIds (optional) 
     * @productInfo (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportsalesMovementReport(searchKey: string, from: moment.Moment, to: moment.Moment, referenceNumber: string, productCategories: number[], customerIds: string[], isStoreDataInDetail: boolean, isCashierDataInDetail: boolean, isCustomerDataInDetail: boolean, isSupplierDataInDetail: boolean, storeIds: number[], cashierIds: number[], productInfo: string, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportsalesMovementReport?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (isStoreDataInDetail !== undefined)
            url_ += "IsStoreDataInDetail=" + encodeURIComponent("" + isStoreDataInDetail) + "&"; 
        if (isCashierDataInDetail !== undefined)
            url_ += "IsCashierDataInDetail=" + encodeURIComponent("" + isCashierDataInDetail) + "&"; 
        if (isCustomerDataInDetail !== undefined)
            url_ += "IsCustomerDataInDetail=" + encodeURIComponent("" + isCustomerDataInDetail) + "&"; 
        if (isSupplierDataInDetail !== undefined)
            url_ += "IsSupplierDataInDetail=" + encodeURIComponent("" + isSupplierDataInDetail) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportsalesMovementReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportsalesMovementReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportsalesMovementReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @from (optional) 
     * @to (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @customerIds (optional) 
     * @isStoreDataInDetail (optional) 
     * @isCashierDataInDetail (optional) 
     * @isCustomerDataInDetail (optional) 
     * @isSupplierDataInDetail (optional) 
     * @storeIds (optional) 
     * @cashierIds (optional) 
     * @productInfo (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportPurchaseMovementReport(searchKey: string, from: moment.Moment, to: moment.Moment, referenceNumber: string, productCategories: number[], customerIds: number[], isStoreDataInDetail: boolean, isCashierDataInDetail: boolean, isCustomerDataInDetail: boolean, isSupplierDataInDetail: boolean, storeIds: number[], cashierIds: number[], productInfo: string, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPurchaseMovementReport?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (isStoreDataInDetail !== undefined)
            url_ += "IsStoreDataInDetail=" + encodeURIComponent("" + isStoreDataInDetail) + "&"; 
        if (isCashierDataInDetail !== undefined)
            url_ += "IsCashierDataInDetail=" + encodeURIComponent("" + isCashierDataInDetail) + "&"; 
        if (isCustomerDataInDetail !== undefined)
            url_ += "IsCustomerDataInDetail=" + encodeURIComponent("" + isCustomerDataInDetail) + "&"; 
        if (isSupplierDataInDetail !== undefined)
            url_ += "IsSupplierDataInDetail=" + encodeURIComponent("" + isSupplierDataInDetail) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPurchaseMovementReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPurchaseMovementReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPurchaseMovementReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductBaseReport(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductBaseReport?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductBaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductBaseReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductBaseReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @searchKey (optional) 
     * @menuItemIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @referenceNumber (optional) 
     * @productCategories (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @vendorIds (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @saleTypeIds (optional) 
     * @showStoreName (optional) 
     * @showPromotion (optional) 
     * @splitByStore (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductBaseReportFABAsync(searchKey: string, menuItemIds: number[], from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, referenceNumber: string, productCategories: number[], cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, vendorIds: number[], areaId: number, storeIds: number[], saleTypeIds: number[], showStoreName: boolean, showPromotion: boolean, splitByStore: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductBaseReportFABAsync?";
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showPromotion !== undefined)
            url_ += "ShowPromotion=" + encodeURIComponent("" + showPromotion) + "&"; 
        if (splitByStore !== undefined)
            url_ += "SplitByStore=" + encodeURIComponent("" + splitByStore) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductBaseReportFABAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductBaseReportFABAsync(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductBaseReportFABAsync(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @referenceNumber (optional) 
     * @code (optional) 
     * @from (optional) 
     * @to (optional) 
     * @vendorIds (optional) 
     * @employees (optional) 
     * @storeIds (optional) 
     * @documentType (optional) 
     * @endOfDayBusiness (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTotalSaleReport(referenceNumber: string, code: string, from: moment.Moment, to: moment.Moment, vendorIds: number[], employees: number[], storeIds: number[], documentType: number, endOfDayBusiness: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSaleReport?";
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSaleReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSaleReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSaleReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @vendorIds (optional) 
     * @storeId (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTotalPurchaseSaleReport(from: moment.Moment, to: moment.Moment, vendorIds: number[], storeId: number[], documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalPurchaseSaleReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeId !== undefined)
            storeId && storeId.forEach(item => { url_ += "StoreId=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalPurchaseSaleReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalPurchaseSaleReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalPurchaseSaleReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @entityFromId (optional) 
     * @entityToId (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTotalPurchaseSaleReportFAB(transactionTypeId: number, entityFromId: number, entityToId: number, tenantId: number, regionId: number, areaId: number, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalPurchaseSaleReportFAB?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (entityFromId !== undefined)
            url_ += "EntityFromId=" + encodeURIComponent("" + entityFromId) + "&"; 
        if (entityToId !== undefined)
            url_ += "EntityToId=" + encodeURIComponent("" + entityToId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalPurchaseSaleReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalPurchaseSaleReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalPurchaseSaleReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductsCategorieSalesReport(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductsCategorieSalesReport?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductsCategorieSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductsCategorieSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductsCategorieSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @timeFrom (optional) 
     * @timeTo (optional) 
     * @saleTypeIds (optional) 
     * @productCategoriesIds (optional) 
     * @documentType (optional) 
     * @showStoreName (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @includeRefunds (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    exportProductsCategorieSalesReportFAB(tenantsIds: number[], regionId: number, areaId: number, storeIds: number[], from: moment.Moment, to: moment.Moment, timeFrom: string, timeTo: string, saleTypeIds: number[], productCategoriesIds: number[], documentType: number, showStoreName: boolean, isEndOfDay: boolean, isCSVFile: boolean, includeRefunds: boolean, tenantId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductsCategorieSalesReportFAB?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (timeFrom !== undefined)
            url_ += "TimeFrom=" + encodeURIComponent("" + timeFrom) + "&"; 
        if (timeTo !== undefined)
            url_ += "TimeTo=" + encodeURIComponent("" + timeTo) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (productCategoriesIds !== undefined)
            productCategoriesIds && productCategoriesIds.forEach(item => { url_ += "ProductCategoriesIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (includeRefunds !== undefined)
            url_ += "IncludeRefunds=" + encodeURIComponent("" + includeRefunds) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductsCategorieSalesReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductsCategorieSalesReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductsCategorieSalesReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @productsNumber (optional) 
     * @return Success
     */
    trendingRawMaterialsReport(productsNumber: number): Observable<TrendingProductsReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TrendingRawMaterialsReport?";
        if (productsNumber !== undefined)
            url_ += "productsNumber=" + encodeURIComponent("" + productsNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrendingRawMaterialsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrendingRawMaterialsReport(response_);
                } catch (e) {
                    return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTrendingRawMaterialsReport(response: Response): Observable<TrendingProductsReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrendingProductsReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrendingProductsReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSales(input: CompareSalesInput): Observable<CompareSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSales(response_);
                } catch (e) {
                    return <Observable<CompareSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSales(response: Response): Observable<CompareSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesReport.fromJS(resultData200) : new CompareSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSalesFAB(input: CompareSalesInput): Observable<CompareSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSalesFAB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSalesFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSalesFAB(response_);
                } catch (e) {
                    return <Observable<CompareSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSalesFAB(response: Response): Observable<CompareSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesReport.fromJS(resultData200) : new CompareSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSalesPeriodByPeriod(input: CompareSalesPeriodByPeriodInput): Observable<CompareSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSalesPeriodByPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSalesPeriodByPeriod(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSalesPeriodByPeriod(response_);
                } catch (e) {
                    return <Observable<CompareSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSalesPeriodByPeriod(response: Response): Observable<CompareSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesReport.fromJS(resultData200) : new CompareSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSalesPeriodByPeriodFAB(input: CompareSalesPeriodByPeriodInput): Observable<CompareSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSalesPeriodByPeriodFAB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSalesPeriodByPeriodFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSalesPeriodByPeriodFAB(response_);
                } catch (e) {
                    return <Observable<CompareSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSalesPeriodByPeriodFAB(response: Response): Observable<CompareSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesReport.fromJS(resultData200) : new CompareSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    comparePurchasePeriodByPeriodFAB(input: ComparePurchasePeriodByPeriodInput, pageNumber: number, pageSize: number): Observable<ComparePurchaseReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ComparePurchasePeriodByPeriodFAB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComparePurchasePeriodByPeriodFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComparePurchasePeriodByPeriodFAB(response_);
                } catch (e) {
                    return <Observable<ComparePurchaseReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComparePurchaseReportDto>><any>Observable.throw(response_);
        });
    }

    protected processComparePurchasePeriodByPeriodFAB(response: Response): Observable<ComparePurchaseReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ComparePurchaseReportDto.fromJS(resultData200) : new ComparePurchaseReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComparePurchaseReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSalesBetweenStocksFixedDate(input: CompareSalesBetweenStocksFixedDateInput): Observable<CompareSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSalesBetweenStocksFixedDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSalesBetweenStocksFixedDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSalesBetweenStocksFixedDate(response_);
                } catch (e) {
                    return <Observable<CompareSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSalesBetweenStocksFixedDate(response: Response): Observable<CompareSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesReport.fromJS(resultData200) : new CompareSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSalesBetweenStocksFixedDateFAB(input: CompareSalesBetweenStocksFixedDateInput): Observable<CompareSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSalesBetweenStocksFixedDateFAB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSalesBetweenStocksFixedDateFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSalesBetweenStocksFixedDateFAB(response_);
                } catch (e) {
                    return <Observable<CompareSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSalesBetweenStocksFixedDateFAB(response: Response): Observable<CompareSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesReport.fromJS(resultData200) : new CompareSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    comparePurchaseDayByDay(input: ComparePurchaseDayByDayInput): Observable<ComparePurchaseReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ComparePurchaseDayByDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComparePurchaseDayByDay(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComparePurchaseDayByDay(response_);
                } catch (e) {
                    return <Observable<ComparePurchaseReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComparePurchaseReport>><any>Observable.throw(response_);
        });
    }

    protected processComparePurchaseDayByDay(response: Response): Observable<ComparePurchaseReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ComparePurchaseReport.fromJS(resultData200) : new ComparePurchaseReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComparePurchaseReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    comparePurchaseDayByDayFAB(input: ComparePurchaseDayByDayInput): Observable<ComparePurchaseReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ComparePurchaseDayByDayFAB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComparePurchaseDayByDayFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComparePurchaseDayByDayFAB(response_);
                } catch (e) {
                    return <Observable<ComparePurchaseReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComparePurchaseReport>><any>Observable.throw(response_);
        });
    }

    protected processComparePurchaseDayByDayFAB(response: Response): Observable<ComparePurchaseReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ComparePurchaseReport.fromJS(resultData200) : new ComparePurchaseReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComparePurchaseReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @sortNumber (optional) 
     * @return Success
     */
    customersReport(input: CustomersReportInput, pageNumber: number, pageSize: number, sortNumber: number): Observable<CustomerReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CustomersReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (sortNumber !== undefined)
            url_ += "sortNumber=" + encodeURIComponent("" + sortNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCustomersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCustomersReport(response_);
                } catch (e) {
                    return <Observable<CustomerReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerReport>><any>Observable.throw(response_);
        });
    }

    protected processCustomersReport(response: Response): Observable<CustomerReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerReport.fromJS(resultData200) : new CustomerReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @sortNumber (optional) 
     * @return Success
     */
    customersReportFAB(input: CustomersReportInput, pageNumber: number, pageSize: number, exportFile: boolean, sortNumber: number): Observable<CustomerReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CustomersReportFAB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        if (sortNumber !== undefined)
            url_ += "sortNumber=" + encodeURIComponent("" + sortNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCustomersReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCustomersReportFAB(response_);
                } catch (e) {
                    return <Observable<CustomerReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerReport>><any>Observable.throw(response_);
        });
    }

    protected processCustomersReportFAB(response: Response): Observable<CustomerReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerReport.fromJS(resultData200) : new CustomerReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @sortNumber (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    customersBalanceReport(input: CustomersReportInput, pageNumber: number, pageSize: number, sortNumber: number, exportToExcel: boolean): Observable<CustomerReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CustomersBalanceReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (sortNumber !== undefined)
            url_ += "sortNumber=" + encodeURIComponent("" + sortNumber) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCustomersBalanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCustomersBalanceReport(response_);
                } catch (e) {
                    return <Observable<CustomerReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerReport>><any>Observable.throw(response_);
        });
    }

    protected processCustomersBalanceReport(response: Response): Observable<CustomerReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerReport.fromJS(resultData200) : new CustomerReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @sortNumber (optional) 
     * @return Success
     */
    customersBalanceFABReport(input: CustomersReportInput, pageNumber: number, pageSize: number, sortNumber: number): Observable<CustomerReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CustomersBalanceFABReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (sortNumber !== undefined)
            url_ += "sortNumber=" + encodeURIComponent("" + sortNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCustomersBalanceFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCustomersBalanceFABReport(response_);
                } catch (e) {
                    return <Observable<CustomerReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerReport>><any>Observable.throw(response_);
        });
    }

    protected processCustomersBalanceFABReport(response: Response): Observable<CustomerReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerReport.fromJS(resultData200) : new CustomerReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerReport>(<any>null);
    }

    /**
     * @customerName (optional) 
     * @mobileNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCustomersBalanceFABReport(customerName: string, mobileNumber: string, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCustomersBalanceFABReport?";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (mobileNumber !== undefined)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCustomersBalanceFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCustomersBalanceFABReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCustomersBalanceFABReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @customerID (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getCustomerSales(customerID: string, pageNumber: number, pageSize: number, tenantId: number): Observable<CustomerSales> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCustomerSales?";
        if (customerID !== undefined)
            url_ += "customerID=" + encodeURIComponent("" + customerID) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCustomerSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCustomerSales(response_);
                } catch (e) {
                    return <Observable<CustomerSales>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerSales>><any>Observable.throw(response_);
        });
    }

    protected processGetCustomerSales(response: Response): Observable<CustomerSales> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerSales.fromJS(resultData200) : new CustomerSales();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerSales>(<any>null);
    }

    /**
     * @customerID (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getCustomerBalance(customerID: string, pageNumber: number, pageSize: number): Observable<CustomerSales> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCustomerBalance?";
        if (customerID !== undefined)
            url_ += "customerID=" + encodeURIComponent("" + customerID) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCustomerBalance(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCustomerBalance(response_);
                } catch (e) {
                    return <Observable<CustomerSales>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomerSales>><any>Observable.throw(response_);
        });
    }

    protected processGetCustomerBalance(response: Response): Observable<CustomerSales> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerSales.fromJS(resultData200) : new CustomerSales();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomerSales>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    paymentMethodsReport(input: PaymentMethodsInput): Observable<PaymentMethodsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PaymentMethodsReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentMethodsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentMethodsReport(response_);
                } catch (e) {
                    return <Observable<PaymentMethodsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentMethodsReport>><any>Observable.throw(response_);
        });
    }

    protected processPaymentMethodsReport(response: Response): Observable<PaymentMethodsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentMethodsReport.fromJS(resultData200) : new PaymentMethodsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentMethodsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    paymentMethodsFABReport(input: TenderMediaInput, pagenumber: number, pagesize: number): Observable<PaymentMethodsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PaymentMethodsFABReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentMethodsFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentMethodsFABReport(response_);
                } catch (e) {
                    return <Observable<PaymentMethodsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentMethodsReport>><any>Observable.throw(response_);
        });
    }

    protected processPaymentMethodsFABReport(response: Response): Observable<PaymentMethodsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentMethodsReport.fromJS(resultData200) : new PaymentMethodsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentMethodsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    paymentMethodsFABSummaryReport(input: TenderMediaInput, pagenumber: number, pagesize: number): Observable<PaymentMethodsSummaryReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PaymentMethodsFABSummaryReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentMethodsFABSummaryReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentMethodsFABSummaryReport(response_);
                } catch (e) {
                    return <Observable<PaymentMethodsSummaryReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentMethodsSummaryReport>><any>Observable.throw(response_);
        });
    }

    protected processPaymentMethodsFABSummaryReport(response: Response): Observable<PaymentMethodsSummaryReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentMethodsSummaryReport.fromJS(resultData200) : new PaymentMethodsSummaryReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentMethodsSummaryReport>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportIncomeAuditByDayReport(from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportIncomeAuditByDayReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportIncomeAuditByDayReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportIncomeAuditByDayReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportIncomeAuditByDayReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToFile (optional) 
     * @return Success
     */
    incomeAuditByDayReport(input: IncomeAuditByDayReportInput, pagenumber: number, pagesize: number, exportToFile: boolean): Observable<IncomeAuditByDayReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/IncomeAuditByDayReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToFile !== undefined)
            url_ += "exportToFile=" + encodeURIComponent("" + exportToFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIncomeAuditByDayReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIncomeAuditByDayReport(response_);
                } catch (e) {
                    return <Observable<IncomeAuditByDayReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<IncomeAuditByDayReport>><any>Observable.throw(response_);
        });
    }

    protected processIncomeAuditByDayReport(response: Response): Observable<IncomeAuditByDayReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IncomeAuditByDayReport.fromJS(resultData200) : new IncomeAuditByDayReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IncomeAuditByDayReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    paymentMethodsByTimeFABReport(input: PaymentMethodByTimeInput, pagenumber: number, pagesize: number): Observable<PaymentMethodsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PaymentMethodsByTimeFABReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentMethodsByTimeFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentMethodsByTimeFABReport(response_);
                } catch (e) {
                    return <Observable<PaymentMethodsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentMethodsReport>><any>Observable.throw(response_);
        });
    }

    protected processPaymentMethodsByTimeFABReport(response: Response): Observable<PaymentMethodsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentMethodsReport.fromJS(resultData200) : new PaymentMethodsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentMethodsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    paymentMethodsByCashierFABReport(input: PaymentMethodsInput, pagenumber: number, pagesize: number): Observable<PaymentMethodsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PaymentMethodsByCashierFABReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentMethodsByCashierFABReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentMethodsByCashierFABReport(response_);
                } catch (e) {
                    return <Observable<PaymentMethodsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentMethodsReport>><any>Observable.throw(response_);
        });
    }

    protected processPaymentMethodsByCashierFABReport(response: Response): Observable<PaymentMethodsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentMethodsReport.fromJS(resultData200) : new PaymentMethodsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentMethodsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    totalSales(input: TotalSalesInput): Observable<TotalSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSales(response_);
                } catch (e) {
                    return <Observable<TotalSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalSales(response: Response): Observable<TotalSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesReport.fromJS(resultData200) : new TotalSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    totalSalesFAB(input: TotalSalesInput): Observable<TotalSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSalesFAB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSalesFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSalesFAB(response_);
                } catch (e) {
                    return <Observable<TotalSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalSalesFAB(response: Response): Observable<TotalSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesReport.fromJS(resultData200) : new TotalSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @syncDate (optional) 
     * @return Success
     */
    totalSalesWithLastSyncFAB(input: TotalSalesInput, syncDate: moment.Moment): Observable<TotalSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSalesWithLastSyncFAB?";
        if (syncDate !== undefined)
            url_ += "SyncDate=" + encodeURIComponent(syncDate ? "" + syncDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSalesWithLastSyncFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSalesWithLastSyncFAB(response_);
                } catch (e) {
                    return <Observable<TotalSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalSalesWithLastSyncFAB(response: Response): Observable<TotalSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesReport.fromJS(resultData200) : new TotalSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesReport>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @tenderTypes (optional) 
     * @primaryCategories (optional) 
     * @productCategories (optional) 
     * @secondatyCategories (optional) 
     * @menuItems (optional) 
     * @referenceNumber (optional) 
     * @code (optional) 
     * @cashierIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @syncDate (optional) 
     * @return Success
     */
    exportTotalSalesWithLastSyncFAB(from: moment.Moment, to: moment.Moment, tenderTypes: number[], primaryCategories: number[], productCategories: number[], secondatyCategories: number[], menuItems: number[], referenceNumber: string, code: string, cashierIds: number[], documentType: number, isEndOfDay: boolean, tenantIds: number[], regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean, syncDate: moment.Moment): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesWithLastSyncFAB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (tenderTypes !== undefined)
            tenderTypes && tenderTypes.forEach(item => { url_ += "TenderTypes=" + encodeURIComponent("" + item) + "&"; });
        if (primaryCategories !== undefined)
            primaryCategories && primaryCategories.forEach(item => { url_ += "PrimaryCategories=" + encodeURIComponent("" + item) + "&"; });
        if (productCategories !== undefined)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (secondatyCategories !== undefined)
            secondatyCategories && secondatyCategories.forEach(item => { url_ += "SecondatyCategories=" + encodeURIComponent("" + item) + "&"; });
        if (menuItems !== undefined)
            menuItems && menuItems.forEach(item => { url_ += "MenuItems=" + encodeURIComponent("" + item) + "&"; });
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (syncDate !== undefined)
            url_ += "SyncDate=" + encodeURIComponent(syncDate ? "" + syncDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesWithLastSyncFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesWithLastSyncFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesWithLastSyncFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    totalSalesByStoresFAB(input: TotalSalesInput, pagenumber: number, pagesize: number): Observable<TotalSalesByStoreSummary> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSalesByStoresFAB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSalesByStoresFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSalesByStoresFAB(response_);
                } catch (e) {
                    return <Observable<TotalSalesByStoreSummary>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesByStoreSummary>><any>Observable.throw(response_);
        });
    }

    protected processTotalSalesByStoresFAB(response: Response): Observable<TotalSalesByStoreSummary> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesByStoreSummary.fromJS(resultData200) : new TotalSalesByStoreSummary();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesByStoreSummary>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @storeId (optional) 
     * @saleTypeId (optional) 
     * @return Success
     */
    costMenuItem(menuItemId: number, storeId: number, saleTypeId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CostMenuItem?";
        if (menuItemId !== undefined)
            url_ += "menuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (saleTypeId !== undefined)
            url_ += "saleTypeId=" + encodeURIComponent("" + saleTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCostMenuItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCostMenuItem(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCostMenuItem(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @productId (optional) 
     * @unitOfMeasureId (optional) 
     * @productVariantId (optional) 
     * @return Success
     */
    getTotalBuyCost(productId: number, unitOfMeasureId: number, productVariantId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetTotalBuyCost?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (unitOfMeasureId !== undefined)
            url_ += "unitOfMeasureId=" + encodeURIComponent("" + unitOfMeasureId) + "&"; 
        if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalBuyCost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalBuyCost(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalBuyCost(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    salesMovement(input: SalesMovementReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<SalesMovementReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesMovement?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesMovement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesMovement(response_);
                } catch (e) {
                    return <Observable<SalesMovementReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesMovementReport>><any>Observable.throw(response_);
        });
    }

    protected processSalesMovement(response: Response): Observable<SalesMovementReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesMovementReport.fromJS(resultData200) : new SalesMovementReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesMovementReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    supervisorShiftReport(input: SupervisorShiftReportInput, pageNumber: number, pagesize: number, exportToExcel: boolean): Observable<SupervisorShiftReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SupervisorShiftReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSupervisorShiftReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSupervisorShiftReport(response_);
                } catch (e) {
                    return <Observable<SupervisorShiftReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<SupervisorShiftReport>><any>Observable.throw(response_);
        });
    }

    protected processSupervisorShiftReport(response: Response): Observable<SupervisorShiftReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SupervisorShiftReport.fromJS(resultData200) : new SupervisorShiftReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SupervisorShiftReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    supervisorShiftReportFB(input: SupervisorShiftReportInput, pageNumber: number, pagesize: number, exportToExcel: boolean): Observable<SupervisorShiftReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SupervisorShiftReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSupervisorShiftReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSupervisorShiftReportFB(response_);
                } catch (e) {
                    return <Observable<SupervisorShiftReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<SupervisorShiftReport>><any>Observable.throw(response_);
        });
    }

    protected processSupervisorShiftReportFB(response: Response): Observable<SupervisorShiftReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SupervisorShiftReport.fromJS(resultData200) : new SupervisorShiftReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SupervisorShiftReport>(<any>null);
    }

    /**
     * @cashierShiftId (optional) 
     * @return Success
     */
    paymentTransactionsValuesReport(cashierShiftId: number): Observable<CasheirPaymentTransactionsValuesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PaymentTransactionsValuesReport?";
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentTransactionsValuesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentTransactionsValuesReport(response_);
                } catch (e) {
                    return <Observable<CasheirPaymentTransactionsValuesDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CasheirPaymentTransactionsValuesDto[]>><any>Observable.throw(response_);
        });
    }

    protected processPaymentTransactionsValuesReport(response: Response): Observable<CasheirPaymentTransactionsValuesDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CasheirPaymentTransactionsValuesDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CasheirPaymentTransactionsValuesDto[]>(<any>null);
    }

    /**
     * @cashierShiftId (optional) 
     * @return Success
     */
    masterCashInOutsReport(cashierShiftId: number): Observable<CasheirPaymentTransactionsValuesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/MasterCashInOutsReport?";
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMasterCashInOutsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMasterCashInOutsReport(response_);
                } catch (e) {
                    return <Observable<CasheirPaymentTransactionsValuesDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CasheirPaymentTransactionsValuesDto[]>><any>Observable.throw(response_);
        });
    }

    protected processMasterCashInOutsReport(response: Response): Observable<CasheirPaymentTransactionsValuesDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CasheirPaymentTransactionsValuesDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CasheirPaymentTransactionsValuesDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    cashierShiftReport(input: CashierShiftReportInput, pageNumber: number, pagesize: number, exportToExcel: boolean): Observable<CashierShiftReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CashierShiftReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCashierShiftReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCashierShiftReport(response_);
                } catch (e) {
                    return <Observable<CashierShiftReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftReport>><any>Observable.throw(response_);
        });
    }

    protected processCashierShiftReport(response: Response): Observable<CashierShiftReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftReport.fromJS(resultData200) : new CashierShiftReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    cashierShiftReportFB(input: CashierShiftReportInput, pageNumber: number, pagesize: number, exportToExcel: boolean): Observable<CashierShiftReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CashierShiftReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCashierShiftReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCashierShiftReportFB(response_);
                } catch (e) {
                    return <Observable<CashierShiftReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CashierShiftReport>><any>Observable.throw(response_);
        });
    }

    protected processCashierShiftReportFB(response: Response): Observable<CashierShiftReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CashierShiftReport.fromJS(resultData200) : new CashierShiftReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CashierShiftReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @exportFileWithComboMeal (optional) 
     * @return Success
     */
    productReportFB(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean, exportFileWithComboMeal: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        if (exportFileWithComboMeal !== undefined)
            url_ += "exportFileWithComboMeal=" + encodeURIComponent("" + exportFileWithComboMeal) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductReportFB(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductReportFB(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getRawMaterialsBelowReorder(input: RawMaterialsBelowReorderReportInput): Observable<RawMaterialBelowReorderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetRawMaterialsBelowReorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRawMaterialsBelowReorder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRawMaterialsBelowReorder(response_);
                } catch (e) {
                    return <Observable<RawMaterialBelowReorderDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialBelowReorderDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRawMaterialsBelowReorder(response: Response): Observable<RawMaterialBelowReorderDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RawMaterialBelowReorderDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialBelowReorderDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @exportFileWithComboMeal (optional) 
     * @return Success
     */
    productReportFBWithTobaccoTax(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean, exportFileWithComboMeal: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductReportFBWithTobaccoTax?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        if (exportFileWithComboMeal !== undefined)
            url_ += "exportFileWithComboMeal=" + encodeURIComponent("" + exportFileWithComboMeal) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductReportFBWithTobaccoTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductReportFBWithTobaccoTax(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductReportFBWithTobaccoTax(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @request (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    getKdsDeviceHealthReportAsync(request: KdsDeviceHealthReportRequest, pageNumber: number, pageSize: number, exportFile: boolean): Observable<KdsDeviceHealthReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetKdsDeviceHealthReportAsync?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKdsDeviceHealthReportAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKdsDeviceHealthReportAsync(response_);
                } catch (e) {
                    return <Observable<KdsDeviceHealthReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<KdsDeviceHealthReport>><any>Observable.throw(response_);
        });
    }

    protected processGetKdsDeviceHealthReportAsync(response: Response): Observable<KdsDeviceHealthReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KdsDeviceHealthReport.fromJS(resultData200) : new KdsDeviceHealthReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<KdsDeviceHealthReport>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @storeIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @clusterId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @langId (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportKdsDeviceHealthReport(tenantId: number, storeIds: string, regionId: number, areaId: number, clusterId: number, fromDate: moment.Moment, toDate: moment.Moment, langId: number, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportKdsDeviceHealthReport?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (storeIds !== undefined)
            url_ += "StoreIds=" + encodeURIComponent("" + storeIds) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (clusterId !== undefined)
            url_ += "ClusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (langId !== undefined)
            url_ += "LangId=" + encodeURIComponent("" + langId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportKdsDeviceHealthReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportKdsDeviceHealthReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportKdsDeviceHealthReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @dateFrom (optional) 
     * @dateTo (optional) 
     * @timeFrom (optional) 
     * @timeTo (optional) 
     * @menuItemIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportProductSalesByTimeReportFAB(tenantId: number, regionId: number, areaId: number, storeIds: number[], dateFrom: moment.Moment, dateTo: moment.Moment, timeFrom: string, timeTo: string, menuItemIds: number[], documentType: number, isEndOfDay: boolean, showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportProductSalesByTimeReportFAB?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (timeFrom !== undefined)
            url_ += "TimeFrom=" + encodeURIComponent("" + timeFrom) + "&"; 
        if (timeTo !== undefined)
            url_ += "TimeTo=" + encodeURIComponent("" + timeTo) + "&"; 
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportProductSalesByTimeReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportProductSalesByTimeReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportProductSalesByTimeReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productByTimeReportFB(input: ProductByTimeReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsByTimeReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductByTimeReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductByTimeReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductByTimeReportFB(response_);
                } catch (e) {
                    return <Observable<ProductsByTimeReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsByTimeReport>><any>Observable.throw(response_);
        });
    }

    protected processProductByTimeReportFB(response: Response): Observable<ProductsByTimeReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsByTimeReport.fromJS(resultData200) : new ProductsByTimeReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsByTimeReport>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @dateFrom (optional) 
     * @dateTo (optional) 
     * @timeFrom (optional) 
     * @timeTo (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportCategorySalesByTimeReportFAB(tenantId: number, regionId: number, areaId: number, storeIds: number[], dateFrom: moment.Moment, dateTo: moment.Moment, timeFrom: string, timeTo: string, categoryIds: number[], documentType: number, isEndOfDay: boolean, showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportCategorySalesByTimeReportFAB?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (timeFrom !== undefined)
            url_ += "TimeFrom=" + encodeURIComponent("" + timeFrom) + "&"; 
        if (timeTo !== undefined)
            url_ += "TimeTo=" + encodeURIComponent("" + timeTo) + "&"; 
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportCategorySalesByTimeReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportCategorySalesByTimeReportFAB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportCategorySalesByTimeReportFAB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    categoryByTimeReportFB(input: CategoryByTimeReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<CategoryByTimeReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CategoryByTimeReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCategoryByTimeReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCategoryByTimeReportFB(response_);
                } catch (e) {
                    return <Observable<CategoryByTimeReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CategoryByTimeReport>><any>Observable.throw(response_);
        });
    }

    protected processCategoryByTimeReportFB(response: Response): Observable<CategoryByTimeReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CategoryByTimeReport.fromJS(resultData200) : new CategoryByTimeReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CategoryByTimeReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productCashierReportFB(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductCashierReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductCashierReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductCashierReportFB(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductCashierReportFB(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productReportRetail(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductReportRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductReportRetail(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductReportRetail(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productVendorsReportRetail(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductVendorsReportRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductVendorsReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductVendorsReportRetail(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductVendorsReportRetail(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    salesmanDetailsReport(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesmanDetailsReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesmanDetailsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesmanDetailsReport(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processSalesmanDetailsReport(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    productReportAsync(input: ProductReportInput, pageNumber: number, pageSize: number): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductReportAsync?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductReportAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductReportAsync(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductReportAsync(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    productVendorsReportAsync(input: ProductReportInput, pageNumber: number, pageSize: number): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductVendorsReportAsync?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductVendorsReportAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductVendorsReportAsync(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductVendorsReportAsync(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportfile (optional) 
     * @return Success
     */
    productCategoriesSalesRetail(input: SalesReportInput, pageNumber: number, pageSize: number, exportfile: boolean): Observable<ProductCategoriesSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductCategoriesSalesRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportfile !== undefined)
            url_ += "exportfile=" + encodeURIComponent("" + exportfile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductCategoriesSalesRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductCategoriesSalesRetail(response_);
                } catch (e) {
                    return <Observable<ProductCategoriesSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCategoriesSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processProductCategoriesSalesRetail(response: Response): Observable<ProductCategoriesSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductCategoriesSalesReport.fromJS(resultData200) : new ProductCategoriesSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCategoriesSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productCategoriesSalesFood(input: ProductCategorySalesReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductCategoriesSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductCategoriesSalesFood?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductCategoriesSalesFood(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductCategoriesSalesFood(response_);
                } catch (e) {
                    return <Observable<ProductCategoriesSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCategoriesSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processProductCategoriesSalesFood(response: Response): Observable<ProductCategoriesSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductCategoriesSalesReport.fromJS(resultData200) : new ProductCategoriesSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCategoriesSalesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @tenantName (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    productCategoriesSalesFoodDetail(input: ProductCategorySalesReportInput, tenantName: string, pageNumber: number, pageSize: number): Observable<ProductsReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductCategoriesSalesFoodDetail?";
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductCategoriesSalesFoodDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductCategoriesSalesFoodDetail(response_);
                } catch (e) {
                    return <Observable<ProductsReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsReport>><any>Observable.throw(response_);
        });
    }

    protected processProductCategoriesSalesFoodDetail(response: Response): Observable<ProductsReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsReport.fromJS(resultData200) : new ProductsReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    totalSalesCategoryByCashierFood(input: TotalSalesCategoryByCashierReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<TotalSalesCategoryByCashierReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSalesCategoryByCashierFood?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSalesCategoryByCashierFood(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSalesCategoryByCashierFood(response_);
                } catch (e) {
                    return <Observable<TotalSalesCategoryByCashierReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesCategoryByCashierReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalSalesCategoryByCashierFood(response: Response): Observable<TotalSalesCategoryByCashierReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesCategoryByCashierReport.fromJS(resultData200) : new TotalSalesCategoryByCashierReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesCategoryByCashierReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productBaseReportRetail(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductBasicReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductBaseReportRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductBaseReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductBaseReportRetail(response_);
                } catch (e) {
                    return <Observable<ProductBasicReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductBasicReport>><any>Observable.throw(response_);
        });
    }

    protected processProductBaseReportRetail(response: Response): Observable<ProductBasicReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductBasicReport.fromJS(resultData200) : new ProductBasicReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductBasicReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    purchaseDatialReport(input: PurchaseDetailReportInput): Observable<PurchaseDetailReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchaseDatialReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseDatialReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseDatialReport(response_);
                } catch (e) {
                    return <Observable<PurchaseDetailReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseDetailReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseDatialReport(response: Response): Observable<PurchaseDetailReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PurchaseDetailReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseDetailReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    selectedPurchaseDatialReport(input: PurchaseDetailReportInput): Observable<PurchaseDetailReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SelectedPurchaseDatialReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSelectedPurchaseDatialReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSelectedPurchaseDatialReport(response_);
                } catch (e) {
                    return <Observable<PurchaseDetailReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseDetailReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSelectedPurchaseDatialReport(response: Response): Observable<PurchaseDetailReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PurchaseDetailReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseDetailReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productBaseReportFB(input: ProductReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<ProductBasicReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductBaseReportFB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductBaseReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductBaseReportFB(response_);
                } catch (e) {
                    return <Observable<ProductBasicReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductBasicReport>><any>Observable.throw(response_);
        });
    }

    protected processProductBaseReportFB(response: Response): Observable<ProductBasicReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductBasicReport.fromJS(resultData200) : new ProductBasicReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductBasicReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    baseProductReport(input: ProductReportInput, pageNumber: number, pageSize: number): Observable<ProductBasicReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/BaseProductReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBaseProductReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBaseProductReport(response_);
                } catch (e) {
                    return <Observable<ProductBasicReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductBasicReport>><any>Observable.throw(response_);
        });
    }

    protected processBaseProductReport(response: Response): Observable<ProductBasicReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductBasicReport.fromJS(resultData200) : new ProductBasicReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductBasicReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    totalSaleByVendorReportRetail(input: TotalSaleVendorReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<TotalSalesOfSupplierReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSaleByVendorReportRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSaleByVendorReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSaleByVendorReportRetail(response_);
                } catch (e) {
                    return <Observable<TotalSalesOfSupplierReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesOfSupplierReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalSaleByVendorReportRetail(response: Response): Observable<TotalSalesOfSupplierReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesOfSupplierReport.fromJS(resultData200) : new TotalSalesOfSupplierReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesOfSupplierReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    offerDetailReport(input: OfferDetailReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<PagedOfferList> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OfferDetailReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOfferDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOfferDetailReport(response_);
                } catch (e) {
                    return <Observable<PagedOfferList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedOfferList>><any>Observable.throw(response_);
        });
    }

    protected processOfferDetailReport(response: Response): Observable<PagedOfferList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedOfferList.fromJS(resultData200) : new PagedOfferList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedOfferList>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    totalSaleByVendorReport(input: TotalSaleVendorReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<TotalSalesOfSupplierReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSaleByVendorReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSaleByVendorReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSaleByVendorReport(response_);
                } catch (e) {
                    return <Observable<TotalSalesOfSupplierReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesOfSupplierReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalSaleByVendorReport(response: Response): Observable<TotalSalesOfSupplierReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesOfSupplierReport.fromJS(resultData200) : new TotalSalesOfSupplierReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesOfSupplierReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    totalPurchaseByVendorReportRetail(input: TotalPurchaseVendorReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<TotalPurchaseOfSupplierReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalPurchaseByVendorReportRetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalPurchaseByVendorReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalPurchaseByVendorReportRetail(response_);
                } catch (e) {
                    return <Observable<TotalPurchaseOfSupplierReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalPurchaseOfSupplierReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalPurchaseByVendorReportRetail(response: Response): Observable<TotalPurchaseOfSupplierReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalPurchaseOfSupplierReport.fromJS(resultData200) : new TotalPurchaseOfSupplierReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalPurchaseOfSupplierReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    totalPurchaseByVendorReportFAB(input: TotalPurchaseByVendorReportFABInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<TotalPurchaseOfSupplierReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalPurchaseByVendorReportFAB?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalPurchaseByVendorReportFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalPurchaseByVendorReportFAB(response_);
                } catch (e) {
                    return <Observable<TotalPurchaseOfSupplierReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalPurchaseOfSupplierReport>><any>Observable.throw(response_);
        });
    }

    protected processTotalPurchaseByVendorReportFAB(response: Response): Observable<TotalPurchaseOfSupplierReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalPurchaseOfSupplierReport.fromJS(resultData200) : new TotalPurchaseOfSupplierReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalPurchaseOfSupplierReport>(<any>null);
    }

    /**
     * @recipeReport (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    recipeReport(recipeReport: RecipeReportDto, pageNumber: number, pageSize: number): Observable<PagedRecipeListWithTotalReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/RecipeReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recipeReport);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecipeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecipeReport(response_);
                } catch (e) {
                    return <Observable<PagedRecipeListWithTotalReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedRecipeListWithTotalReportDto>><any>Observable.throw(response_);
        });
    }

    protected processRecipeReport(response: Response): Observable<PagedRecipeListWithTotalReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedRecipeListWithTotalReportDto.fromJS(resultData200) : new PagedRecipeListWithTotalReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedRecipeListWithTotalReportDto>(<any>null);
    }

    /**
     * @recipeId (optional) 
     * @storeId (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportRecipe(recipeId: number, storeId: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportRecipe?";
        if (recipeId !== undefined)
            url_ += "RecipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportRecipe(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportRecipe(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @rawMaterialId (optional) 
     * @materialGroupId (optional) 
     * @storeIds (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportAllRecipe(menuItemId: number, rawMaterialId: number, materialGroupId: number, storeIds: number[], tenantId: number, regionId: number, areaId: number, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportAllRecipe?";
        if (menuItemId !== undefined)
            url_ += "MenuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        if (rawMaterialId !== undefined)
            url_ += "RawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        if (materialGroupId !== undefined)
            url_ += "MaterialGroupId=" + encodeURIComponent("" + materialGroupId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportAllRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportAllRecipe(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportAllRecipe(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @recipeReport (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    materialRecipeReport(recipeReport: RawMaterialRecipeReportDto, pageNumber: number, pageSize: number): Observable<PagedRawMaterialRecipeListWithTotalReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/MaterialRecipeReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recipeReport);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMaterialRecipeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMaterialRecipeReport(response_);
                } catch (e) {
                    return <Observable<PagedRawMaterialRecipeListWithTotalReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedRawMaterialRecipeListWithTotalReportDto>><any>Observable.throw(response_);
        });
    }

    protected processMaterialRecipeReport(response: Response): Observable<PagedRawMaterialRecipeListWithTotalReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedRawMaterialRecipeListWithTotalReportDto.fromJS(resultData200) : new PagedRawMaterialRecipeListWithTotalReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedRawMaterialRecipeListWithTotalReportDto>(<any>null);
    }

    /**
     * @materialId (optional) 
     * @storeId (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportRawMateriaRecipe(materialId: number, storeId: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportRawMateriaRecipe?";
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportRawMateriaRecipe(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportRawMateriaRecipe(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportRawMateriaRecipe(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @materRecipeType (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportAllMaterialRecipeReport(storeIds: number[], tenantId: number, regionId: number, areaId: number, materRecipeType: MaterRecipeType, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportAllMaterialRecipeReport?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (materRecipeType !== undefined)
            url_ += "MaterRecipeType=" + encodeURIComponent("" + materRecipeType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportAllMaterialRecipeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportAllMaterialRecipeReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportAllMaterialRecipeReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    budgetDeficitReport(input: BudgetDeficitReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<BudgetDeficitPageList> {
        let url_ = this.baseUrl + "/api/services/app/Reports/BudgetDeficitReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBudgetDeficitReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBudgetDeficitReport(response_);
                } catch (e) {
                    return <Observable<BudgetDeficitPageList>><any>Observable.throw(e);
                }
            } else
                return <Observable<BudgetDeficitPageList>><any>Observable.throw(response_);
        });
    }

    protected processBudgetDeficitReport(response: Response): Observable<BudgetDeficitPageList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BudgetDeficitPageList.fromJS(resultData200) : new BudgetDeficitPageList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BudgetDeficitPageList>(<any>null);
    }

    /**
     * @return Success
     */
    getModules(): Observable<TupleOfStringAndStringAndInt32[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetModules(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetModules(response_);
                } catch (e) {
                    return <Observable<TupleOfStringAndStringAndInt32[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TupleOfStringAndStringAndInt32[]>><any>Observable.throw(response_);
        });
    }

    protected processGetModules(response: Response): Observable<TupleOfStringAndStringAndInt32[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TupleOfStringAndStringAndInt32.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TupleOfStringAndStringAndInt32[]>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @cashierIds (optional) 
     * @supervisorIds (optional) 
     * @storeIds (optional) 
     * @documentType (optional) 
     * @isCashier (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportBudgetDeficitReport(from: moment.Moment, to: moment.Moment, cashierIds: number[], supervisorIds: number[], storeIds: number[], documentType: number, isCashier: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportBudgetDeficitReport?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (cashierIds !== undefined)
            cashierIds && cashierIds.forEach(item => { url_ += "CashierIds=" + encodeURIComponent("" + item) + "&"; });
        if (supervisorIds !== undefined)
            supervisorIds && supervisorIds.forEach(item => { url_ += "SupervisorIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCashier !== undefined)
            url_ += "IsCashier=" + encodeURIComponent("" + isCashier) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportBudgetDeficitReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportBudgetDeficitReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportBudgetDeficitReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @storeIds (optional) 
     * @customerIds (optional) 
     * @vendorIds (optional) 
     * @showStore (optional) 
     * @showCashier (optional) 
     * @showCustomer (optional) 
     * @showTenderType (optional) 
     * @showTaxes (optional) 
     * @documentType (optional) 
     * @endOfDayBusiness (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportAccountStatementSaleReportRetail(from: moment.Moment, to: moment.Moment, employees: number[], storeIds: number[], customerIds: string[], vendorIds: number[], showStore: boolean, showCashier: boolean, showCustomer: boolean, showTenderType: boolean, showTaxes: boolean, documentType: number, endOfDayBusiness: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportAccountStatementSaleReportRetail?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStore !== undefined)
            url_ += "ShowStore=" + encodeURIComponent("" + showStore) + "&"; 
        if (showCashier !== undefined)
            url_ += "ShowCashier=" + encodeURIComponent("" + showCashier) + "&"; 
        if (showCustomer !== undefined)
            url_ += "ShowCustomer=" + encodeURIComponent("" + showCustomer) + "&"; 
        if (showTenderType !== undefined)
            url_ += "ShowTenderType=" + encodeURIComponent("" + showTenderType) + "&"; 
        if (showTaxes !== undefined)
            url_ += "ShowTaxes=" + encodeURIComponent("" + showTaxes) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportAccountStatementSaleReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportAccountStatementSaleReportRetail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportAccountStatementSaleReportRetail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @employees (optional) 
     * @storeIds (optional) 
     * @customerIds (optional) 
     * @vendorIds (optional) 
     * @showStore (optional) 
     * @showCashier (optional) 
     * @showCustomer (optional) 
     * @showTenderType (optional) 
     * @showTaxes (optional) 
     * @documentType (optional) 
     * @endOfDayBusiness (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportAccountStatementPurchaseReportRetail(from: moment.Moment, to: moment.Moment, employees: number[], storeIds: number[], customerIds: string[], vendorIds: number[], showStore: boolean, showCashier: boolean, showCustomer: boolean, showTenderType: boolean, showTaxes: boolean, documentType: number, endOfDayBusiness: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportAccountStatementPurchaseReportRetail?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (vendorIds !== undefined)
            vendorIds && vendorIds.forEach(item => { url_ += "VendorIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStore !== undefined)
            url_ += "ShowStore=" + encodeURIComponent("" + showStore) + "&"; 
        if (showCashier !== undefined)
            url_ += "ShowCashier=" + encodeURIComponent("" + showCashier) + "&"; 
        if (showCustomer !== undefined)
            url_ += "ShowCustomer=" + encodeURIComponent("" + showCustomer) + "&"; 
        if (showTenderType !== undefined)
            url_ += "ShowTenderType=" + encodeURIComponent("" + showTenderType) + "&"; 
        if (showTaxes !== undefined)
            url_ += "ShowTaxes=" + encodeURIComponent("" + showTaxes) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportAccountStatementPurchaseReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportAccountStatementPurchaseReportRetail(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportAccountStatementPurchaseReportRetail(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesReport(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesReport?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesDetailReport(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesDetailReport?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesDetailReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesDetailReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSelectedInvoice(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSelectedInvoice?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSelectedInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSelectedInvoice(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSelectedInvoice(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesCashierShiftReport(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantId: number, regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSalesCashierShiftReport?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesCashierShiftReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesCashierShiftReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesCashierShiftReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportDailySalesReport(input: DailySalesReportInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportDailySalesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportDailySalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportDailySalesReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportDailySalesReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    dailySalesReport(input: DailySalesReportInputDto): Observable<DailySalesReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/DailySalesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDailySalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDailySalesReport(response_);
                } catch (e) {
                    return <Observable<DailySalesReportOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DailySalesReportOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processDailySalesReport(response: Response): Observable<DailySalesReportOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DailySalesReportOutputDto.fromJS(resultData200) : new DailySalesReportOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DailySalesReportOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    getSaleWithDetails(input: SalesSummaryInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportWithDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSaleWithDetails?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleWithDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleWithDetails(response_);
                } catch (e) {
                    return <Observable<SalesReportWithDetailsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportWithDetailsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleWithDetails(response: Response): Observable<SalesReportWithDetailsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportWithDetailsDto.fromJS(resultData200) : new SalesReportWithDetailsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportWithDetailsDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    getSaleWithDetailsRetail(input: SalesSummaryInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportWithDetailsRetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSaleWithDetailsRetail?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleWithDetailsRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleWithDetailsRetail(response_);
                } catch (e) {
                    return <Observable<SalesReportWithDetailsRetailDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportWithDetailsRetailDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleWithDetailsRetail(response: Response): Observable<SalesReportWithDetailsRetailDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportWithDetailsRetailDto.fromJS(resultData200) : new SalesReportWithDetailsRetailDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportWithDetailsRetailDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    loyaltySalesDiscountReport(input: LoyaltyReportInput, pagenumber: number, pagesize: number): Observable<LoyaltySalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/LoyaltySalesDiscountReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLoyaltySalesDiscountReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLoyaltySalesDiscountReport(response_);
                } catch (e) {
                    return <Observable<LoyaltySalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LoyaltySalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processLoyaltySalesDiscountReport(response: Response): Observable<LoyaltySalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoyaltySalesReportDto.fromJS(resultData200) : new LoyaltySalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LoyaltySalesReportDto>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @from (optional) 
     * @to (optional) 
     * @customerNumber (optional) 
     * @employees (optional) 
     * @saleTypeIds (optional) 
     * @byShiftDate (optional) 
     * @documentType (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportLoyaltySalesDiscountReportFB(tenantsIds: number[], regionId: number, areaId: number, storeIds: number[], from: moment.Moment, to: moment.Moment, customerNumber: string, employees: number[], saleTypeIds: number[], byShiftDate: boolean, documentType: number, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportLoyaltySalesDiscountReportFB?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportLoyaltySalesDiscountReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportLoyaltySalesDiscountReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportLoyaltySalesDiscountReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportTotalSalesByTimeFB(input: TotalSalesByTimeInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesByTimeFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesByTimeFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesByTimeFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesByTimeFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @supplierId (optional) 
     * @storeIds (optional) 
     * @rowMatrailIds (optional) 
     * @regionId (optional) 
     * @tenantId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @showAllDetails (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPurchaseBySupplierFB(transactionTypeId: number, supplierId: number, storeIds: number[], rowMatrailIds: number[], regionId: number, tenantId: number, areaId: number, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, isCSVFile: boolean, showAllDetails: boolean, pageNumber: number, pageSize: number): Observable<PurchaseReportBySupplierDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetPurchaseBySupplierFB?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (rowMatrailIds !== undefined)
            rowMatrailIds && rowMatrailIds.forEach(item => { url_ += "RowMatrailIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (showAllDetails !== undefined)
            url_ += "ShowAllDetails=" + encodeURIComponent("" + showAllDetails) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseBySupplierFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseBySupplierFB(response_);
                } catch (e) {
                    return <Observable<PurchaseReportBySupplierDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportBySupplierDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseBySupplierFB(response: Response): Observable<PurchaseReportBySupplierDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportBySupplierDto.fromJS(resultData200) : new PurchaseReportBySupplierDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportBySupplierDto>(<any>null);
    }

    /**
     * @tenantName (optional) 
     * @mainTransactionId (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPurchaseBySupplierFB_Details(tenantName: string, mainTransactionId: number, pageNumber: number, pageSize: number): Observable<PurchaseReportBySupplierDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetPurchaseBySupplierFB_Details?";
        if (tenantName !== undefined)
            url_ += "TenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (mainTransactionId !== undefined)
            url_ += "MainTransactionId=" + encodeURIComponent("" + mainTransactionId) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPurchaseBySupplierFB_Details(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPurchaseBySupplierFB_Details(response_);
                } catch (e) {
                    return <Observable<PurchaseReportBySupplierDetailsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportBySupplierDetailsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPurchaseBySupplierFB_Details(response: Response): Observable<PurchaseReportBySupplierDetailsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportBySupplierDetailsDto.fromJS(resultData200) : new PurchaseReportBySupplierDetailsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportBySupplierDetailsDto>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @supplierId (optional) 
     * @storeIds (optional) 
     * @rowMatrailIds (optional) 
     * @regionId (optional) 
     * @tenantId (optional) 
     * @areaId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @showAllDetails (optional) 
     * @return Success
     */
    exportAllMainTransactionToFile(transactionTypeId: number, supplierId: number, storeIds: number[], rowMatrailIds: number[], regionId: number, tenantId: number, areaId: number, from: moment.Moment, to: moment.Moment, documentType: number, isEndOfDay: boolean, isCSVFile: boolean, showAllDetails: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportAllMainTransactionToFile?";
        if (transactionTypeId !== undefined)
            url_ += "TransactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (supplierId !== undefined)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (rowMatrailIds !== undefined)
            rowMatrailIds && rowMatrailIds.forEach(item => { url_ += "RowMatrailIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (showAllDetails !== undefined)
            url_ += "ShowAllDetails=" + encodeURIComponent("" + showAllDetails) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportAllMainTransactionToFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportAllMainTransactionToFile(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportAllMainTransactionToFile(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    salesAndPurchaseReport(input: TotalSalesAndPuechaseInput): Observable<SalesAndPurchaseReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesAndPurchaseReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesAndPurchaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesAndPurchaseReport(response_);
                } catch (e) {
                    return <Observable<SalesAndPurchaseReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesAndPurchaseReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesAndPurchaseReport(response: Response): Observable<SalesAndPurchaseReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesAndPurchaseReportDto.fromJS(resultData200) : new SalesAndPurchaseReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesAndPurchaseReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    salesAndPurchaseReportFB(input: TotalSalesAndPuechaseFBInput): Observable<SalesAndPurchaseReportFBDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesAndPurchaseReportFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesAndPurchaseReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesAndPurchaseReportFB(response_);
                } catch (e) {
                    return <Observable<SalesAndPurchaseReportFBDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesAndPurchaseReportFBDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesAndPurchaseReportFB(response: Response): Observable<SalesAndPurchaseReportFBDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesAndPurchaseReportFBDto.fromJS(resultData200) : new SalesAndPurchaseReportFBDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesAndPurchaseReportFBDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    returnSales(input: ReturnSalesReportInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<ReturnSalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ReturnSales?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReturnSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReturnSales(response_);
                } catch (e) {
                    return <Observable<ReturnSalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReturnSalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processReturnSales(response: Response): Observable<ReturnSalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReturnSalesReportDto.fromJS(resultData200) : new ReturnSalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReturnSalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    returnSalesFB(input: ReturnSalesReportInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<ReturnSalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ReturnSalesFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReturnSalesFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReturnSalesFB(response_);
                } catch (e) {
                    return <Observable<ReturnSalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReturnSalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processReturnSalesFB(response: Response): Observable<ReturnSalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReturnSalesReportDto.fromJS(resultData200) : new ReturnSalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReturnSalesReportDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getMenuItemNames(id: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetMenuItemNames?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemNames(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemNames(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemNames(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productPurchaseReport(input: ProductPurchaseReportInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<ProductPurchaseReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductPurchaseReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductPurchaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductPurchaseReport(response_);
                } catch (e) {
                    return <Observable<ProductPurchaseReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductPurchaseReportDto>><any>Observable.throw(response_);
        });
    }

    protected processProductPurchaseReport(response: Response): Observable<ProductPurchaseReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductPurchaseReportDto.fromJS(resultData200) : new ProductPurchaseReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductPurchaseReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    purchaseMovement(input: PurchaseMovementReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<PurchaseMovementReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchaseMovement?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseMovement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseMovement(response_);
                } catch (e) {
                    return <Observable<PurchaseMovementReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseMovementReport>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseMovement(response: Response): Observable<PurchaseMovementReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseMovementReport.fromJS(resultData200) : new PurchaseMovementReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseMovementReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    purchaseDetail(input: PurchaseDetailReportInput, pageNumber: number, pageSize: number, exportFile: boolean): Observable<PagedPurchaseInvoiceList> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchaseDetail?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseDetail(response_);
                } catch (e) {
                    return <Observable<PagedPurchaseInvoiceList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedPurchaseInvoiceList>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseDetail(response: Response): Observable<PagedPurchaseInvoiceList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedPurchaseInvoiceList.fromJS(resultData200) : new PagedPurchaseInvoiceList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedPurchaseInvoiceList>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    stockValuesReportFB(input: StockValuesReportInput, pagenumber: number, pagesize: number): Observable<MaterialStockListItem> {
        let url_ = this.baseUrl + "/api/services/app/Reports/StockValuesReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStockValuesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStockValuesReportFB(response_);
                } catch (e) {
                    return <Observable<MaterialStockListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockListItem>><any>Observable.throw(response_);
        });
    }

    protected processStockValuesReportFB(response: Response): Observable<MaterialStockListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockListItem.fromJS(resultData200) : new MaterialStockListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    lotreport(input: LotReportInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<LotReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/Lotreport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLotreport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLotreport(response_);
                } catch (e) {
                    return <Observable<LotReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LotReportDto>><any>Observable.throw(response_);
        });
    }

    protected processLotreport(response: Response): Observable<LotReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LotReportDto.fromJS(resultData200) : new LotReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LotReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    lotreportFB(input: LotReportInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<MaterialStockListItem> {
        let url_ = this.baseUrl + "/api/services/app/Reports/LotreportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLotreportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLotreportFB(response_);
                } catch (e) {
                    return <Observable<MaterialStockListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockListItem>><any>Observable.throw(response_);
        });
    }

    protected processLotreportFB(response: Response): Observable<MaterialStockListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockListItem.fromJS(resultData200) : new MaterialStockListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    stockValuesReport(input: StockValuesReportInput, pagenumber: number, pagesize: number): Observable<StockValuesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/StockValuesReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStockValuesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStockValuesReport(response_);
                } catch (e) {
                    return <Observable<StockValuesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StockValuesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processStockValuesReport(response: Response): Observable<StockValuesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StockValuesReportDto.fromJS(resultData200) : new StockValuesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StockValuesReportDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    materialStockTransactionReport(paramters: MaterialStockTransactionReportFilterDto, pagenumber: number, pagesize: number): Observable<MaterialStockTransactionPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/MaterialStockTransactionReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMaterialStockTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMaterialStockTransactionReport(response_);
                } catch (e) {
                    return <Observable<MaterialStockTransactionPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockTransactionPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processMaterialStockTransactionReport(response: Response): Observable<MaterialStockTransactionPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockTransactionPagedDto.fromJS(resultData200) : new MaterialStockTransactionPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockTransactionPagedDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    transferInOutTransactionReport(paramters: TransferInOutTransactionReportFilterDto, pagenumber: number, pagesize: number): Observable<TransferInOutTransactionPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TransferInOutTransactionReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTransferInOutTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTransferInOutTransactionReport(response_);
                } catch (e) {
                    return <Observable<TransferInOutTransactionPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransferInOutTransactionPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processTransferInOutTransactionReport(response: Response): Observable<TransferInOutTransactionPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransferInOutTransactionPagedDto.fromJS(resultData200) : new TransferInOutTransactionPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransferInOutTransactionPagedDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @matrialId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @documentType (optional) 
     * @showMaterialCode (optional) 
     * @showStoreCode (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportTransferInOutTransactionReport(tenantId: number, regionId: number, areaId: number, storeIds: number[], matrialId: number, fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, documentType: number, showMaterialCode: boolean, showStoreCode: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTransferInOutTransactionReport?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialId !== undefined)
            url_ += "MatrialId=" + encodeURIComponent("" + matrialId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (showMaterialCode !== undefined)
            url_ += "ShowMaterialCode=" + encodeURIComponent("" + showMaterialCode) + "&"; 
        if (showStoreCode !== undefined)
            url_ += "ShowStoreCode=" + encodeURIComponent("" + showStoreCode) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTransferInOutTransactionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTransferInOutTransactionReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTransferInOutTransactionReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    outOfStockDetailReport(input: LotReportInput, pagenumber: number, pagesize: number): Observable<LotReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OutOfStockDetailReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOutOfStockDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOutOfStockDetailReport(response_);
                } catch (e) {
                    return <Observable<LotReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LotReportDto>><any>Observable.throw(response_);
        });
    }

    protected processOutOfStockDetailReport(response: Response): Observable<LotReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LotReportDto.fromJS(resultData200) : new LotReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LotReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    outOfStockDetailReportFB(input: LotReportInput, pagenumber: number, pagesize: number): Observable<MaterialStockListItem> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OutOfStockDetailReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOutOfStockDetailReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOutOfStockDetailReportFB(response_);
                } catch (e) {
                    return <Observable<MaterialStockListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockListItem>><any>Observable.throw(response_);
        });
    }

    protected processOutOfStockDetailReportFB(response: Response): Observable<MaterialStockListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockListItem.fromJS(resultData200) : new MaterialStockListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    outOfStockReport(input: LotReportInput, pagenumber: number, pagesize: number): Observable<LotReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OutOfStockReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOutOfStockReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOutOfStockReport(response_);
                } catch (e) {
                    return <Observable<LotReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LotReportDto>><any>Observable.throw(response_);
        });
    }

    protected processOutOfStockReport(response: Response): Observable<LotReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LotReportDto.fromJS(resultData200) : new LotReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LotReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    outOfStockReportFB(input: LotReportInput, pagenumber: number, pagesize: number): Observable<MaterialStockListItem> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OutOfStockReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOutOfStockReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOutOfStockReportFB(response_);
                } catch (e) {
                    return <Observable<MaterialStockListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<MaterialStockListItem>><any>Observable.throw(response_);
        });
    }

    protected processOutOfStockReportFB(response: Response): Observable<MaterialStockListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MaterialStockListItem.fromJS(resultData200) : new MaterialStockListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MaterialStockListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    rawMaterialNotUsed(input: LotReportInput, pagenumber: number, pagesize: number): Observable<RawMaterialListItem> {
        let url_ = this.baseUrl + "/api/services/app/Reports/RawMaterialNotUsed?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRawMaterialNotUsed(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRawMaterialNotUsed(response_);
                } catch (e) {
                    return <Observable<RawMaterialListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialListItem>><any>Observable.throw(response_);
        });
    }

    protected processRawMaterialNotUsed(response: Response): Observable<RawMaterialListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RawMaterialListItem.fromJS(resultData200) : new RawMaterialListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialListItem>(<any>null);
    }

    /**
     * @return Success
     */
    rawMaterialsData(): Observable<RawMaterialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/RawMaterialsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRawMaterialsData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRawMaterialsData(response_);
                } catch (e) {
                    return <Observable<RawMaterialDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialDto[]>><any>Observable.throw(response_);
        });
    }

    protected processRawMaterialsData(response: Response): Observable<RawMaterialDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RawMaterialDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productCardReport(input: ProductCardInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<ProductCardReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductCardReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductCardReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductCardReport(response_);
                } catch (e) {
                    return <Observable<ProductCardReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCardReportDto>><any>Observable.throw(response_);
        });
    }

    protected processProductCardReport(response: Response): Observable<ProductCardReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductCardReportDto.fromJS(resultData200) : new ProductCardReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCardReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    transfersReport(input: ProductCardInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<ProductCardReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TransfersReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTransfersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTransfersReport(response_);
                } catch (e) {
                    return <Observable<ProductCardReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCardReportDto>><any>Observable.throw(response_);
        });
    }

    protected processTransfersReport(response: Response): Observable<ProductCardReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductCardReportDto.fromJS(resultData200) : new ProductCardReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCardReportDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    checkTransactionType(id: number): Observable<Anonymous> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CheckTransactionType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckTransactionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckTransactionType(response_);
                } catch (e) {
                    return <Observable<Anonymous>><any>Observable.throw(e);
                }
            } else
                return <Observable<Anonymous>><any>Observable.throw(response_);
        });
    }

    protected processCheckTransactionType(response: Response): Observable<Anonymous> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<Anonymous>(<any>null);
    }

    /**
     * @id (optional) 
     * @qty (optional) 
     * @return Success
     */
    checkTransactionQty(id: number, qty: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CheckTransactionQty?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (qty !== undefined)
            url_ += "qty=" + encodeURIComponent("" + qty) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckTransactionQty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckTransactionQty(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCheckTransactionQty(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportFile (optional) 
     * @return Success
     */
    productMovementReport(input: ProductMovementInput, pagenumber: number, pagesize: number, exportFile: boolean): Observable<ProductMovementReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductMovementReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportFile !== undefined)
            url_ += "exportFile=" + encodeURIComponent("" + exportFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductMovementReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductMovementReport(response_);
                } catch (e) {
                    return <Observable<ProductMovementReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductMovementReportDto>><any>Observable.throw(response_);
        });
    }

    protected processProductMovementReport(response: Response): Observable<ProductMovementReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductMovementReportDto.fromJS(resultData200) : new ProductMovementReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductMovementReportDto>(<any>null);
    }

    /**
     * @productId (optional) 
     * @storeId (optional) 
     * @unitOfMeasureId (optional) 
     * @productVariantId (optional) 
     * @currentStock (optional) 
     * @return Success
     */
    productMovementList(productId: number, storeId: number, unitOfMeasureId: number, productVariantId: number, currentStock: number): Observable<ProductCardReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductMovementList?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (unitOfMeasureId !== undefined)
            url_ += "unitOfMeasureId=" + encodeURIComponent("" + unitOfMeasureId) + "&"; 
        if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&"; 
        if (currentStock !== undefined)
            url_ += "currentStock=" + encodeURIComponent("" + currentStock) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductMovementList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductMovementList(response_);
                } catch (e) {
                    return <Observable<ProductCardReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCardReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processProductMovementList(response: Response): Observable<ProductCardReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductCardReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCardReportDto[]>(<any>null);
    }

    /**
     * @productId (optional) 
     * @storeId (optional) 
     * @unitOfMeasureId (optional) 
     * @productVariantId (optional) 
     * @currentStock (optional) 
     * @return Success
     */
    productTransaction(productId: number, storeId: number, unitOfMeasureId: number, productVariantId: number, currentStock: number): Observable<ProductCardReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/productTransaction?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (unitOfMeasureId !== undefined)
            url_ += "unitOfMeasureId=" + encodeURIComponent("" + unitOfMeasureId) + "&"; 
        if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&"; 
        if (currentStock !== undefined)
            url_ += "currentStock=" + encodeURIComponent("" + currentStock) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductTransaction(response_);
                } catch (e) {
                    return <Observable<ProductCardReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCardReportDto>><any>Observable.throw(response_);
        });
    }

    protected processProductTransaction(response: Response): Observable<ProductCardReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductCardReportDto.fromJS(resultData200) : new ProductCardReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCardReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    productNotUsedReportFB(input: LotReportInput, pagenumber: number, pagesize: number): Observable<MenuItemListItem> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductNotUsedReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductNotUsedReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductNotUsedReportFB(response_);
                } catch (e) {
                    return <Observable<MenuItemListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemListItem>><any>Observable.throw(response_);
        });
    }

    protected processProductNotUsedReportFB(response: Response): Observable<MenuItemListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemListItem.fromJS(resultData200) : new MenuItemListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    productNotUsedReport(input: LotReportInput, pagenumber: number, pagesize: number): Observable<LotReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductNotUsedReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductNotUsedReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductNotUsedReport(response_);
                } catch (e) {
                    return <Observable<LotReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LotReportDto>><any>Observable.throw(response_);
        });
    }

    protected processProductNotUsedReport(response: Response): Observable<LotReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LotReportDto.fromJS(resultData200) : new LotReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LotReportDto>(<any>null);
    }

    /**
     * @productsNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @return Success
     */
    trendingProductsReportRetail(productsNumber: number, from: moment.Moment, to: moment.Moment): Observable<TrendingProductsReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TrendingProductsReportRetail?";
        if (productsNumber !== undefined)
            url_ += "productsNumber=" + encodeURIComponent("" + productsNumber) + "&"; 
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrendingProductsReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrendingProductsReportRetail(response_);
                } catch (e) {
                    return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTrendingProductsReportRetail(response: Response): Observable<TrendingProductsReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrendingProductsReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrendingProductsReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    trendingProductsReportFood1(input: MenuItemTrendingInput): Observable<TrendingProductsReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TrendingProductsReportFood1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrendingProductsReportFood1(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrendingProductsReportFood1(response_);
                } catch (e) {
                    return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTrendingProductsReportFood1(response: Response): Observable<TrendingProductsReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrendingProductsReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrendingProductsReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    trendingProductsReportFood(input: MenuItemTrendingInput): Observable<TrendingProductsReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TrendingProductsReportFood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrendingProductsReportFood(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrendingProductsReportFood(response_);
                } catch (e) {
                    return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTrendingProductsReportFood(response: Response): Observable<TrendingProductsReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrendingProductsReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrendingProductsReportDto[]>(<any>null);
    }

    /**
     * @productsNumber (optional) 
     * @return Success
     */
    trendingRawMaterials(productsNumber: number): Observable<TrendingProductsReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TrendingRawMaterials?";
        if (productsNumber !== undefined)
            url_ += "productsNumber=" + encodeURIComponent("" + productsNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrendingRawMaterials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrendingRawMaterials(response_);
                } catch (e) {
                    return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTrendingRawMaterials(response: Response): Observable<TrendingProductsReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrendingProductsReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrendingProductsReportDto[]>(<any>null);
    }

    /**
     * @productsNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @return Success
     */
    trendingProductsReport(productsNumber: number, from: moment.Moment, to: moment.Moment): Observable<TrendingProductsReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TrendingProductsReport?";
        if (productsNumber !== undefined)
            url_ += "productsNumber=" + encodeURIComponent("" + productsNumber) + "&"; 
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrendingProductsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrendingProductsReport(response_);
                } catch (e) {
                    return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTrendingProductsReport(response: Response): Observable<TrendingProductsReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrendingProductsReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrendingProductsReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    trendingProductsReportFB(input: MenuItemTrendingInput): Observable<TrendingProductsReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TrendingProductsReportFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrendingProductsReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrendingProductsReportFB(response_);
                } catch (e) {
                    return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrendingProductsReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTrendingProductsReportFB(response: Response): Observable<TrendingProductsReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrendingProductsReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrendingProductsReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    kDSOrderLifecycleSamplesReport(input: KDSPerformaceInput, pagenumber: number, pageSize: number): Observable<KDSOrderLifecycleSamplesPage> {
        let url_ = this.baseUrl + "/api/services/app/Reports/KDSOrderLifecycleSamplesReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processKDSOrderLifecycleSamplesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processKDSOrderLifecycleSamplesReport(response_);
                } catch (e) {
                    return <Observable<KDSOrderLifecycleSamplesPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<KDSOrderLifecycleSamplesPage>><any>Observable.throw(response_);
        });
    }

    protected processKDSOrderLifecycleSamplesReport(response: Response): Observable<KDSOrderLifecycleSamplesPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KDSOrderLifecycleSamplesPage.fromJS(resultData200) : new KDSOrderLifecycleSamplesPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<KDSOrderLifecycleSamplesPage>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    kDSPerformaceReport(input: KDSPerformaceInput, pagenumber: number, pageSize: number): Observable<KDSPerformanceReportPage> {
        let url_ = this.baseUrl + "/api/services/app/Reports/KDSPerformaceReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processKDSPerformaceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processKDSPerformaceReport(response_);
                } catch (e) {
                    return <Observable<KDSPerformanceReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<KDSPerformanceReportPage>><any>Observable.throw(response_);
        });
    }

    protected processKDSPerformaceReport(response: Response): Observable<KDSPerformanceReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KDSPerformanceReportPage.fromJS(resultData200) : new KDSPerformanceReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<KDSPerformanceReportPage>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    totalSalesByModifiersReport(input: TotalSalesByModifiersReportInput, pagenumber: number, pageSize: number): Observable<TotalSalesByModifiersReportPage> {
        let url_ = this.baseUrl + "/api/services/app/Reports/TotalSalesByModifiersReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSalesByModifiersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSalesByModifiersReport(response_);
                } catch (e) {
                    return <Observable<TotalSalesByModifiersReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesByModifiersReportPage>><any>Observable.throw(response_);
        });
    }

    protected processTotalSalesByModifiersReport(response: Response): Observable<TotalSalesByModifiersReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesByModifiersReportPage.fromJS(resultData200) : new TotalSalesByModifiersReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesByModifiersReportPage>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isBusinessDate (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTotalSalesByModifiersReport(tenantsIds: number[], regionId: number, areaId: number, storeIds: number[], fromDate: moment.Moment, toDate: moment.Moment, isBusinessDate: boolean, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportTotalSalesByModifiersReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isBusinessDate !== undefined)
            url_ += "IsBusinessDate=" + encodeURIComponent("" + isBusinessDate) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesByModifiersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesByModifiersReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesByModifiersReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @promotionId (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportPromotionReport(fromDate: moment.Moment, toDate: moment.Moment, tenantId: number, regionId: number, areaId: number, storeIds: number[], promotionId: number, documentType: number, isEndOfDay: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPromotionReport?";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (promotionId !== undefined)
            url_ += "PromotionId=" + encodeURIComponent("" + promotionId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPromotionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPromotionReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPromotionReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @parameters (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    promotionReport(parameters: PromotionReportFilterDto, pageNumber: number, pageSize: number): Observable<PromotionPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PromotionReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPromotionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPromotionReport(response_);
                } catch (e) {
                    return <Observable<PromotionPagedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionPagedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPromotionReport(response: Response): Observable<PromotionPagedResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionPagedResultDto.fromJS(resultData200) : new PromotionPagedResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionPagedResultDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    promotionReportByTime(paramters: PromotionByTimeReportFilterDto, pagenumber: number, pagesize: number): Observable<PromotionByDatePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PromotionReportByTime?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPromotionReportByTime(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPromotionReportByTime(response_);
                } catch (e) {
                    return <Observable<PromotionByDatePagedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionByDatePagedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPromotionReportByTime(response: Response): Observable<PromotionByDatePagedResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionByDatePagedResultDto.fromJS(resultData200) : new PromotionByDatePagedResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionByDatePagedResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportPromotionByEmployeeReport(input: PromotionByEmployeeReportFilterDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPromotionByEmployeeReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPromotionByEmployeeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPromotionByEmployeeReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPromotionByEmployeeReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    promotionByEmployeeReport(paramters: PromotionByEmployeeReportFilterDto, pagenumber: number, pagesize: number): Observable<PromotionByEmployeePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PromotionByEmployeeReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPromotionByEmployeeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPromotionByEmployeeReport(response_);
                } catch (e) {
                    return <Observable<PromotionByEmployeePagedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionByEmployeePagedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPromotionByEmployeeReport(response: Response): Observable<PromotionByEmployeePagedResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionByEmployeePagedResultDto.fromJS(resultData200) : new PromotionByEmployeePagedResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionByEmployeePagedResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportPromotionBySaleTypeReport(input: PromotionBySaleTypeReportFilterDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPromotionBySaleTypeReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPromotionBySaleTypeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPromotionBySaleTypeReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPromotionBySaleTypeReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    promotionBySaleTypeReport(paramters: PromotionBySaleTypeReportFilterDto, pagenumber: number, pagesize: number): Observable<PromotionBySaleTypePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PromotionBySaleTypeReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPromotionBySaleTypeReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPromotionBySaleTypeReport(response_);
                } catch (e) {
                    return <Observable<PromotionBySaleTypePagedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionBySaleTypePagedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPromotionBySaleTypeReport(response: Response): Observable<PromotionBySaleTypePagedResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionBySaleTypePagedResultDto.fromJS(resultData200) : new PromotionBySaleTypePagedResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionBySaleTypePagedResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportPromotionDetailReport(input: PromotionDetailReportFilterDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPromotionDetailReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPromotionDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPromotionDetailReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPromotionDetailReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    promotionDetailReport(input: PromotionDetailReportFilterDto, pagenumber: number, pagesize: number): Observable<PromotionDetailPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PromotionDetailReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPromotionDetailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPromotionDetailReport(response_);
                } catch (e) {
                    return <Observable<PromotionDetailPagedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PromotionDetailPagedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPromotionDetailReport(response: Response): Observable<PromotionDetailPagedResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionDetailPagedResultDto.fromJS(resultData200) : new PromotionDetailPagedResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PromotionDetailPagedResultDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @matrialId (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @documentType (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportRawMaterialVariantReport(storeIds: number[], matrialId: number, fromDate: moment.Moment, toDate: moment.Moment, tenantId: number, regionId: number, areaId: number, documentType: number, showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportRawMaterialVariantReport?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialId !== undefined)
            url_ += "MatrialId=" + encodeURIComponent("" + matrialId) + "&"; 
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportRawMaterialVariantReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportRawMaterialVariantReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportRawMaterialVariantReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @paramters (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    rawMaterialVariantReport(paramters: RawMaterialVariantReportFilterDto, pagenumber: number, pagesize: number): Observable<RawMaterialVariantPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/RawMaterialVariantReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramters);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRawMaterialVariantReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRawMaterialVariantReport(response_);
                } catch (e) {
                    return <Observable<RawMaterialVariantPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RawMaterialVariantPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processRawMaterialVariantReport(response: Response): Observable<RawMaterialVariantPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RawMaterialVariantPagedDto.fromJS(resultData200) : new RawMaterialVariantPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RawMaterialVariantPagedDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    purchasingVsSalesQtyReport(input: PurchasingVsSalesQtyReportFilterDto, pageNumber: number, pageSize: number): Observable<PurchasingVsSalesQtyPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchasingVsSalesQtyReport?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchasingVsSalesQtyReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchasingVsSalesQtyReport(response_);
                } catch (e) {
                    return <Observable<PurchasingVsSalesQtyPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchasingVsSalesQtyPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processPurchasingVsSalesQtyReport(response: Response): Observable<PurchasingVsSalesQtyPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchasingVsSalesQtyPagedDto.fromJS(resultData200) : new PurchasingVsSalesQtyPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchasingVsSalesQtyPagedDto>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @matrialIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @documentType (optional) 
     * @showStoreName (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportPurchasingVsSalesQtyReport(storeIds: number[], matrialIds: number[], fromDate: moment.Moment, toDate: moment.Moment, tenantId: number, regionId: number, areaId: number, documentType: number, showStoreName: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportPurchasingVsSalesQtyReport?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (matrialIds !== undefined)
            matrialIds && matrialIds.forEach(item => { url_ += "MatrialIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportPurchasingVsSalesQtyReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportPurchasingVsSalesQtyReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportPurchasingVsSalesQtyReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    shortOverFB(input: ShortOverReportInput, pagenumber: number, pagesize: number): Observable<ShortOverReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ShortOverFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processShortOverFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processShortOverFB(response_);
                } catch (e) {
                    return <Observable<ShortOverReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ShortOverReportDto>><any>Observable.throw(response_);
        });
    }

    protected processShortOverFB(response: Response): Observable<ShortOverReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ShortOverReportDto.fromJS(resultData200) : new ShortOverReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ShortOverReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    shortOverDetailFB(input: ShortOverDetailsReportInput, pagenumber: number, pagesize: number): Observable<ShortOverDetailsPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ShortOverDetailFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processShortOverDetailFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processShortOverDetailFB(response_);
                } catch (e) {
                    return <Observable<ShortOverDetailsPagedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ShortOverDetailsPagedDto>><any>Observable.throw(response_);
        });
    }

    protected processShortOverDetailFB(response: Response): Observable<ShortOverDetailsPagedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ShortOverDetailsPagedDto.fromJS(resultData200) : new ShortOverDetailsPagedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ShortOverDetailsPagedDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportShortOverDetailFB(input: ShortOverDetailsReportInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportShortOverDetailFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportShortOverDetailFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportShortOverDetailFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportShortOverDetailFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    balanceReport(input: BalanceReportInput, pagenumber: number, pagesize: number): Observable<BalanceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/BalanceReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBalanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBalanceReport(response_);
                } catch (e) {
                    return <Observable<BalanceReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<BalanceReportDto>><any>Observable.throw(response_);
        });
    }

    protected processBalanceReport(response: Response): Observable<BalanceReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BalanceReportDto.fromJS(resultData200) : new BalanceReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BalanceReportDto>(<any>null);
    }

    /**
     * @return Success
     */
    setStoreIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SetStoreIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetStoreIds(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetStoreIds(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processSetStoreIds(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    balanceReportFB(input: BalanceReportInput): Observable<BalanceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/BalanceReportFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBalanceReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBalanceReportFB(response_);
                } catch (e) {
                    return <Observable<BalanceReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<BalanceReportDto>><any>Observable.throw(response_);
        });
    }

    protected processBalanceReportFB(response: Response): Observable<BalanceReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BalanceReportDto.fromJS(resultData200) : new BalanceReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BalanceReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    salesReport(input: SalesReportInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesReport(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesReport(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    electronicInvoices(input: SalesReportInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ElectronicInvoices?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processElectronicInvoices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processElectronicInvoices(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processElectronicInvoices(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    salesCashierShiftReport(input: SalesReportInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesCashierShiftReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesCashierShiftReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesCashierShiftReport(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesCashierShiftReport(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    salesCashierShiftReportFB(input: SalesReportInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesCashierShiftReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesCashierShiftReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesCashierShiftReportFB(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesCashierShiftReportFB(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    accountStatementSaleReportRetail(input: AccountStatementSaleReportInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<AccountStatementSaleReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/AccountStatementSaleReportRetail?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAccountStatementSaleReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAccountStatementSaleReportRetail(response_);
                } catch (e) {
                    return <Observable<AccountStatementSaleReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AccountStatementSaleReportDto>><any>Observable.throw(response_);
        });
    }

    protected processAccountStatementSaleReportRetail(response: Response): Observable<AccountStatementSaleReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccountStatementSaleReportDto.fromJS(resultData200) : new AccountStatementSaleReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AccountStatementSaleReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @exportToExcel (optional) 
     * @return Success
     */
    accountStatementPurchaseReportRetail(input: AccountStatementSaleReportInput, pagenumber: number, pagesize: number, exportToExcel: boolean): Observable<AccountStatementSaleReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/AccountStatementPurchaseReportRetail?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        if (exportToExcel !== undefined)
            url_ += "exportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAccountStatementPurchaseReportRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAccountStatementPurchaseReportRetail(response_);
                } catch (e) {
                    return <Observable<AccountStatementSaleReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AccountStatementSaleReportDto>><any>Observable.throw(response_);
        });
    }

    protected processAccountStatementPurchaseReportRetail(response: Response): Observable<AccountStatementSaleReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccountStatementSaleReportDto.fromJS(resultData200) : new AccountStatementSaleReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AccountStatementSaleReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    salesReportFB(input: SalesSummaryInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesReportFB(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesReportFB(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    returnSalesReportFB(input: SalesReturnReportInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ReturnSalesReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReturnSalesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReturnSalesReportFB(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processReturnSalesReportFB(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    salesCashiersReport(input: SalesReportInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesCashiersReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesCashiersReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesCashiersReport(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesCashiersReport(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    salesManReport(input: SalesReportInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesManReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesManReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesManReport(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesManReport(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    salesCashiersReportFB(input: SalesReturnReportInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesCashiersReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesCashiersReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesCashiersReportFB(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesCashiersReportFB(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @content (optional) 
     * @return Success
     */
    convertQRCodeToBase64StringAsync(content: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ConvertQRCodeToBase64StringAsync?";
        if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConvertQRCodeToBase64StringAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConvertQRCodeToBase64StringAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processConvertQRCodeToBase64StringAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    saleDetailsRetail(saleId: string, tenantId: number): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsRetail?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsRetail(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsRetail(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @no (optional) 
     * @return Success
     */
    getBarCode(no: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetBarCode?";
        if (no !== undefined)
            url_ += "No=" + encodeURIComponent("" + no) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBarCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBarCode(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBarCode(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @no (optional) 
     * @return Success
     */
    saleDetailsRetailByReciptNumber(no: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsRetailByReciptNumber?";
        if (no !== undefined)
            url_ += "No=" + encodeURIComponent("" + no) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsRetailByReciptNumber(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsRetailByReciptNumber(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsRetailByReciptNumber(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @return Success
     */
    saleDetailsRetailForAnyTenant(saleId: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsRetailForAnyTenant?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsRetailForAnyTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsRetailForAnyTenant(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsRetailForAnyTenant(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    saleDetailsFood(saleId: string, tenantId: number): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsFood?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsFood(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsFood(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsFood(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantName (optional) 
     * @return Success
     */
    saleDetailsFoodByTenantName(saleId: string, tenantName: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsFoodByTenantName?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsFoodByTenantName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsFoodByTenantName(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsFoodByTenantName(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    saleDetails(saleId: string, tenantId: number): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetails?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetails(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetails(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @isFood (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    exportReturnSaleToPDF(saleId: string, isFood: boolean, tenantId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportReturnSaleToPDF?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (isFood !== undefined)
            url_ += "IsFood=" + encodeURIComponent("" + isFood) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportReturnSaleToPDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportReturnSaleToPDF(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportReturnSaleToPDF(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantName (optional) 
     * @isFood (optional) 
     * @return Success
     */
    exportSaleToPDFByTenantName(saleId: string, tenantName: string, isFood: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSaleToPDFByTenantName?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (isFood !== undefined)
            url_ += "IsFood=" + encodeURIComponent("" + isFood) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSaleToPDFByTenantName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSaleToPDFByTenantName(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSaleToPDFByTenantName(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @isFood (optional) 
     * @return Success
     */
    exportSaleToPDF(saleId: string, isFood: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ExportSaleToPDF?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (isFood !== undefined)
            url_ += "IsFood=" + encodeURIComponent("" + isFood) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSaleToPDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSaleToPDF(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSaleToPDF(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @recieptNumber (optional) 
     * @return Success
     */
    saleDetailsByRecieptNumber(recieptNumber: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsByRecieptNumber?";
        if (recieptNumber !== undefined)
            url_ += "recieptNumber=" + encodeURIComponent("" + recieptNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsByRecieptNumber(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsByRecieptNumber(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsByRecieptNumber(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @return Success
     */
    saleDetailsEInvoice(saleId: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsEInvoice?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsEInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsEInvoice(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsEInvoice(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @offerId (optional) 
     * @return Success
     */
    offerDetailsRetail(offerId: number): Observable<OfferDetailReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OfferDetailsRetail?";
        if (offerId !== undefined)
            url_ += "OfferId=" + encodeURIComponent("" + offerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOfferDetailsRetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOfferDetailsRetail(response_);
                } catch (e) {
                    return <Observable<OfferDetailReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OfferDetailReportDto>><any>Observable.throw(response_);
        });
    }

    protected processOfferDetailsRetail(response: Response): Observable<OfferDetailReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OfferDetailReportDto.fromJS(resultData200) : new OfferDetailReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OfferDetailReportDto>(<any>null);
    }

    /**
     * @offerId (optional) 
     * @return Success
     */
    offerDetails(offerId: number): Observable<OfferDetailReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OfferDetails?";
        if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOfferDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOfferDetails(response_);
                } catch (e) {
                    return <Observable<OfferDetailReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OfferDetailReportDto>><any>Observable.throw(response_);
        });
    }

    protected processOfferDetails(response: Response): Observable<OfferDetailReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OfferDetailReportDto.fromJS(resultData200) : new OfferDetailReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OfferDetailReportDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    saleDetailsFB(saleId: string, tenantId: number): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsFB?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsFB(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsFB(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantName (optional) 
     * @return Success
     */
    saleDetailsFBByTenantName(saleId: string, tenantName: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsFBByTenantName?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsFBByTenantName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsFBByTenantName(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsFBByTenantName(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    returnSaleDetailsFB(saleId: string, tenantId: number): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ReturnSaleDetailsFB?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReturnSaleDetailsFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReturnSaleDetailsFB(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processReturnSaleDetailsFB(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @return Success
     */
    saleDetailsReport(): Observable<SaleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsReport(response_);
                } catch (e) {
                    return <Observable<SaleDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsReport(response: Response): Observable<SaleDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SaleDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    saleDetailsReportAsProduct(): Observable<SaleProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsReportAsProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsReportAsProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsReportAsProduct(response_);
                } catch (e) {
                    return <Observable<SaleProductDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleProductDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsReportAsProduct(response: Response): Observable<SaleProductDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SaleProductDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleProductDto[]>(<any>null);
    }

    /**
     * @cashierShiftId (optional) 
     * @input (optional) 
     * @return Success
     */
    saleCashierShiftDetailsReport(cashierShiftId: number, input: SalesReportInput): Observable<SaleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleCashierShiftDetailsReport?";
        if (cashierShiftId !== undefined)
            url_ += "cashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleCashierShiftDetailsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleCashierShiftDetailsReport(response_);
                } catch (e) {
                    return <Observable<SaleDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSaleCashierShiftDetailsReport(response: Response): Observable<SaleDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SaleDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    salesInvoiceById(input: SalesReportInput): Observable<PrintSelectedSaleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SalesInvoiceById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesInvoiceById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesInvoiceById(response_);
                } catch (e) {
                    return <Observable<PrintSelectedSaleDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PrintSelectedSaleDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSalesInvoiceById(response: Response): Observable<PrintSelectedSaleDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PrintSelectedSaleDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PrintSelectedSaleDto[]>(<any>null);
    }

    /**
     * @cashierShiftId (optional) 
     * @return Success
     */
    saleCashierShiftDetailsReportAsProduct(cashierShiftId: number): Observable<SaleProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleCashierShiftDetailsReportAsProduct?";
        if (cashierShiftId !== undefined)
            url_ += "cashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleCashierShiftDetailsReportAsProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleCashierShiftDetailsReportAsProduct(response_);
                } catch (e) {
                    return <Observable<SaleProductDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleProductDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSaleCashierShiftDetailsReportAsProduct(response: Response): Observable<SaleProductDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SaleProductDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleProductDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saleOfferDetailsReport(input: OfferDetailReportInput): Observable<OfferDetailReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleOfferDetailsReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleOfferDetailsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleOfferDetailsReport(response_);
                } catch (e) {
                    return <Observable<OfferDetailReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<OfferDetailReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSaleOfferDetailsReport(response: Response): Observable<OfferDetailReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(OfferDetailReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OfferDetailReportDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saleDetailsReportFB(input: SalesSummaryReportInput): Observable<SaleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/SaleDetailsReportFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsReportFB(response_);
                } catch (e) {
                    return <Observable<SaleDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsReportFB(response: Response): Observable<SaleDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SaleDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    purchaseReport(input: PurchaseReportInput, pagenumber: number, pagesize: number): Observable<PurchaseReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchaseReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseReport(response_);
                } catch (e) {
                    return <Observable<PurchaseReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportDto>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseReport(response: Response): Observable<PurchaseReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportDto.fromJS(resultData200) : new PurchaseReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    purchaseReportFB(input: PurchaseReportFBInput, pagenumber: number, pagesize: number): Observable<PurchaseReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchaseReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseReportFB(response_);
                } catch (e) {
                    return <Observable<PurchaseReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportDto>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseReportFB(response: Response): Observable<PurchaseReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportDto.fromJS(resultData200) : new PurchaseReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    purchaseReportBySupplierFB(input: PurchaseReportBySupplierFBInput, pagenumber: number, pagesize: number): Observable<PurchaseReportBySupplierDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchaseReportBySupplierFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseReportBySupplierFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseReportBySupplierFB(response_);
                } catch (e) {
                    return <Observable<PurchaseReportBySupplierDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportBySupplierDto>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseReportBySupplierFB(response: Response): Observable<PurchaseReportBySupplierDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportBySupplierDto.fromJS(resultData200) : new PurchaseReportBySupplierDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportBySupplierDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    purchaseReportBySupplierFB_Details(input: PurchaseReportBySupplierDetailsFBInput, pagenumber: number, pagesize: number): Observable<PurchaseReportBySupplierDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/PurchaseReportBySupplierFB_Details?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPurchaseReportBySupplierFB_Details(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPurchaseReportBySupplierFB_Details(response_);
                } catch (e) {
                    return <Observable<PurchaseReportBySupplierDetailsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportBySupplierDetailsDto>><any>Observable.throw(response_);
        });
    }

    protected processPurchaseReportBySupplierFB_Details(response: Response): Observable<PurchaseReportBySupplierDetailsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportBySupplierDetailsDto.fromJS(resultData200) : new PurchaseReportBySupplierDetailsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportBySupplierDetailsDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    productCardReportFB(input: PurchaseReportFBInput, pagenumber: number, pagesize: number): Observable<PurchaseReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/ProductCardReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductCardReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductCardReportFB(response_);
                } catch (e) {
                    return <Observable<PurchaseReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PurchaseReportDto>><any>Observable.throw(response_);
        });
    }

    protected processProductCardReportFB(response: Response): Observable<PurchaseReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseReportDto.fromJS(resultData200) : new PurchaseReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PurchaseReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    stockBalanceReport(input: StockBalanceReportInput, pagenumber: number, pagesize: number): Observable<StockBalanceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/StockBalanceReport?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStockBalanceReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStockBalanceReport(response_);
                } catch (e) {
                    return <Observable<StockBalanceReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StockBalanceReportDto>><any>Observable.throw(response_);
        });
    }

    protected processStockBalanceReport(response: Response): Observable<StockBalanceReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StockBalanceReportDto.fromJS(resultData200) : new StockBalanceReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StockBalanceReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSalesBetweenStocksdifferentDates(input: CompareSalesBetweenStocksDifferentDatesInput): Observable<CompareSalesBetweenStocksdifferentDatesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSalesBetweenStocksdifferentDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSalesBetweenStocksdifferentDates(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSalesBetweenStocksdifferentDates(response_);
                } catch (e) {
                    return <Observable<CompareSalesBetweenStocksdifferentDatesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesBetweenStocksdifferentDatesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSalesBetweenStocksdifferentDates(response: Response): Observable<CompareSalesBetweenStocksdifferentDatesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesBetweenStocksdifferentDatesReport.fromJS(resultData200) : new CompareSalesBetweenStocksdifferentDatesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesBetweenStocksdifferentDatesReport>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    compareSalesBetweenStocksdifferentDatesFAB(input: CompareSalesBetweenStocksDifferentDatesInput): Observable<CompareSalesBetweenStocksdifferentDatesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareSalesBetweenStocksdifferentDatesFAB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareSalesBetweenStocksdifferentDatesFAB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareSalesBetweenStocksdifferentDatesFAB(response_);
                } catch (e) {
                    return <Observable<CompareSalesBetweenStocksdifferentDatesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesBetweenStocksdifferentDatesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareSalesBetweenStocksdifferentDatesFAB(response: Response): Observable<CompareSalesBetweenStocksdifferentDatesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesBetweenStocksdifferentDatesReport.fromJS(resultData200) : new CompareSalesBetweenStocksdifferentDatesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesBetweenStocksdifferentDatesReport>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    compareEventsSales(model: CompareEventsSalesInput): Observable<CompareSalesReport> {
        let url_ = this.baseUrl + "/api/services/app/Reports/CompareEventsSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompareEventsSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompareEventsSales(response_);
                } catch (e) {
                    return <Observable<CompareSalesReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<CompareSalesReport>><any>Observable.throw(response_);
        });
    }

    protected processCompareEventsSales(response: Response): Observable<CompareSalesReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompareSalesReport.fromJS(resultData200) : new CompareSalesReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CompareSalesReport>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @permission (optional) 
     * @return Success
     */
    getRoles(permission: string): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoles(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRoles(response: Response): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllRoles(): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllRoles(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllRoles(response: Response): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoleForEdit(response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRoleForEdit(response: Response): Observable<GetRoleForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateRole(input: CreateOrUpdateRoleInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateRole(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteRole(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @grantedPermissionNames (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    updateRolePermissions(grantedPermissionNames: string[], tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/UpdateRolePermissions?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(grantedPermissionNames);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRolePermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateRolePermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRolePermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class RoleCheckerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @saleTypeId (optional) 
     * @return Success
     */
    getIsInRole(saleTypeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RoleChecker/GetIsInRole?";
        if (saleTypeId !== undefined)
            url_ += "SaleTypeId=" + encodeURIComponent("" + saleTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIsInRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIsInRole(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetIsInRole(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getIsSupervisor(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RoleChecker/GetIsSupervisor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIsSupervisor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIsSupervisor(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetIsSupervisor(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getIsAdmin(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RoleChecker/GetIsAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIsAdmin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIsAdmin(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetIsAdmin(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RoleChecker/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SalesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSalesBills(): Observable<ListResultDtoOfSaleListItem> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetSalesBills";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSalesBills(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSalesBills(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSaleListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSaleListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSalesBills(response: Response): Observable<ListResultDtoOfSaleListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSaleListItem.fromJS(resultData200) : new ListResultDtoOfSaleListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSaleListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SalesDeductorServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SalesDeductor/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SalesReportsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getTotalSalesByDayReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, isCSVFile: boolean, pagenumber: number, pageSize: number): Observable<TotalSalesByDayReportPage> {
        let url_ = this.baseUrl + "/api/services/app/SalesReports/GetTotalSalesByDayReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalSalesByDayReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalSalesByDayReport(response_);
                } catch (e) {
                    return <Observable<TotalSalesByDayReportPage>><any>Observable.throw(e);
                }
            } else
                return <Observable<TotalSalesByDayReportPage>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalSalesByDayReport(response: Response): Observable<TotalSalesByDayReportPage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TotalSalesByDayReportPage.fromJS(resultData200) : new TotalSalesByDayReportPage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TotalSalesByDayReportPage>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportTotalSalesByDayReport(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReports/ExportTotalSalesByDayReport?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesByDayReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesByDayReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesByDayReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @tenantsIds (optional) 
     * @storesIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportExcelTotalSalesByDayReportTemplate2(tenantsIds: number[], storesIds: number[], fromDate: moment.Moment, toDate: moment.Moment, isEndOfDay: boolean, isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReports/ExportExcelTotalSalesByDayReportTemplate2?";
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (storesIds !== undefined)
            storesIds && storesIds.forEach(item => { url_ += "StoresIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportExcelTotalSalesByDayReportTemplate2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportExcelTotalSalesByDayReportTemplate2(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportExcelTotalSalesByDayReportTemplate2(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @menuItemIds (optional) 
     * @tenantsIds (optional) 
     * @isCSVFile (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getMenuItemVariantsReport(menuItemIds: number[], tenantsIds: number[], isCSVFile: boolean, pagenumber: number, pageSize: number): Observable<MenuItemVariantReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalesReports/GetMenuItemVariantsReport?";
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemVariantsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemVariantsReport(response_);
                } catch (e) {
                    return <Observable<MenuItemVariantReportOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemVariantReportOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemVariantsReport(response: Response): Observable<MenuItemVariantReportOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemVariantReportOutput.fromJS(resultData200) : new MenuItemVariantReportOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemVariantReportOutput>(<any>null);
    }

    /**
     * @menuItemIds (optional) 
     * @tenantsIds (optional) 
     * @isCSVFile (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportMenuItemVariantsReport(menuItemIds: number[], tenantsIds: number[], isCSVFile: boolean, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReports/ExportMenuItemVariantsReport?";
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "MenuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (tenantsIds !== undefined)
            tenantsIds && tenantsIds.forEach(item => { url_ += "TenantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportMenuItemVariantsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportMenuItemVariantsReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportMenuItemVariantsReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SalesReports/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SalesReportsEnhancementsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportTotalSalesByTimeFB(input: TotalSalesByTimeInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/ExportTotalSalesByTimeFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportTotalSalesByTimeFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportTotalSalesByTimeFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportTotalSalesByTimeFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pagesize (optional) 
     * @return Success
     */
    salesReportFB(input: SalesSummaryInput, pagenumber: number, pagesize: number): Observable<SalesReportDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/SalesReportFB?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesReportFB(response_);
                } catch (e) {
                    return <Observable<SalesReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SalesReportDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesReportFB(response: Response): Observable<SalesReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SalesReportDto.fromJS(resultData200) : new SalesReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SalesReportDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    balanceReportFB(input: BalanceReportInput): Observable<BalanceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/BalanceReportFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBalanceReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBalanceReportFB(response_);
                } catch (e) {
                    return <Observable<BalanceReportDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<BalanceReportDto>><any>Observable.throw(response_);
        });
    }

    protected processBalanceReportFB(response: Response): Observable<BalanceReportDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BalanceReportDto.fromJS(resultData200) : new BalanceReportDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BalanceReportDto>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @documentType (optional) 
     * @isEndOfDay (optional) 
     * @tenantId (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @isCSVFile (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    exportBalanceReportFB(from: moment.Moment, to: moment.Moment, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, documentType: number, isEndOfDay: boolean, tenantId: number, regionId: number, areaId: number, storeIds: number[], isCSVFile: boolean, sorting: string, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/ExportBalanceReportFB?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportBalanceReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportBalanceReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportBalanceReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @showRefund (optional) 
     * @showDiscountOrPromotionOnly (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesSummaryReportFB(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantIds: number[], regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, showRefund: boolean, showDiscountOrPromotionOnly: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/ExportSalesSummaryReportFB?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showRefund !== undefined)
            url_ += "ShowRefund=" + encodeURIComponent("" + showRefund) + "&"; 
        if (showDiscountOrPromotionOnly !== undefined)
            url_ += "ShowDiscountOrPromotionOnly=" + encodeURIComponent("" + showDiscountOrPromotionOnly) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesSummaryReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesSummaryReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesSummaryReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantName (optional) 
     * @isFood (optional) 
     * @return Success
     */
    exportSaleToPDFByTenantName(saleId: string, tenantName: string, isFood: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/ExportSaleToPDFByTenantName?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        if (isFood !== undefined)
            url_ += "IsFood=" + encodeURIComponent("" + isFood) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSaleToPDFByTenantName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSaleToPDFByTenantName(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSaleToPDFByTenantName(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @isFood (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    exportReturnSaleToPDF(saleId: string, isFood: boolean, tenantId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/ExportReturnSaleToPDF?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (isFood !== undefined)
            url_ += "IsFood=" + encodeURIComponent("" + isFood) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportReturnSaleToPDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportReturnSaleToPDF(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportReturnSaleToPDF(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleTransactionId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @fromTime (optional) 
     * @toTime (optional) 
     * @orderNumber (optional) 
     * @customerNumber (optional) 
     * @productInfo (optional) 
     * @employees (optional) 
     * @exportToExcel (optional) 
     * @saleTypeIds (optional) 
     * @categoryIds (optional) 
     * @documentType (optional) 
     * @cashierShiftId (optional) 
     * @printInvoice (optional) 
     * @byShiftDate (optional) 
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @endOfDayBusiness (optional) 
     * @storeIds (optional) 
     * @showStoreName (optional) 
     * @showRefund (optional) 
     * @showDiscountOrPromotionOnly (optional) 
     * @isCSVFile (optional) 
     * @return Success
     */
    exportSalesReportFB(saleTransactionId: string, from: moment.Moment, to: moment.Moment, fromTime: string, toTime: string, orderNumber: string, customerNumber: string, productInfo: string, employees: number[], exportToExcel: string, saleTypeIds: number[], categoryIds: number[], documentType: number, cashierShiftId: number, printInvoice: boolean, byShiftDate: boolean, tenantIds: number[], regionId: number, areaId: number, endOfDayBusiness: boolean, storeIds: number[], showStoreName: boolean, showRefund: boolean, showDiscountOrPromotionOnly: boolean, isCSVFile: boolean): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/ExportSalesReportFB?";
        if (saleTransactionId !== undefined)
            url_ += "SaleTransactionId=" + encodeURIComponent("" + saleTransactionId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (fromTime !== undefined)
            url_ += "FromTime=" + encodeURIComponent("" + fromTime) + "&"; 
        if (toTime !== undefined)
            url_ += "ToTime=" + encodeURIComponent("" + toTime) + "&"; 
        if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        if (customerNumber !== undefined)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&"; 
        if (productInfo !== undefined)
            url_ += "ProductInfo=" + encodeURIComponent("" + productInfo) + "&"; 
        if (employees !== undefined)
            employees && employees.forEach(item => { url_ += "Employees=" + encodeURIComponent("" + item) + "&"; });
        if (exportToExcel !== undefined)
            url_ += "ExportToExcel=" + encodeURIComponent("" + exportToExcel) + "&"; 
        if (saleTypeIds !== undefined)
            saleTypeIds && saleTypeIds.forEach(item => { url_ += "SaleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (cashierShiftId !== undefined)
            url_ += "CashierShiftId=" + encodeURIComponent("" + cashierShiftId) + "&"; 
        if (printInvoice !== undefined)
            url_ += "PrintInvoice=" + encodeURIComponent("" + printInvoice) + "&"; 
        if (byShiftDate !== undefined)
            url_ += "ByShiftDate=" + encodeURIComponent("" + byShiftDate) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (endOfDayBusiness !== undefined)
            url_ += "EndOfDayBusiness=" + encodeURIComponent("" + endOfDayBusiness) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (showStoreName !== undefined)
            url_ += "ShowStoreName=" + encodeURIComponent("" + showStoreName) + "&"; 
        if (showRefund !== undefined)
            url_ += "ShowRefund=" + encodeURIComponent("" + showRefund) + "&"; 
        if (showDiscountOrPromotionOnly !== undefined)
            url_ += "ShowDiscountOrPromotionOnly=" + encodeURIComponent("" + showDiscountOrPromotionOnly) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSalesReportFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSalesReportFB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSalesReportFB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantName (optional) 
     * @return Success
     */
    saleDetailsFBByTenantName(saleId: string, tenantName: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/SaleDetailsFBByTenantName?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsFBByTenantName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsFBByTenantName(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsFBByTenantName(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @saleId (optional) 
     * @tenantName (optional) 
     * @return Success
     */
    saleDetailsFoodByTenantName(saleId: string, tenantName: string): Observable<SaleDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/SaleDetailsFoodByTenantName?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&"; 
        if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleDetailsFoodByTenantName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleDetailsFoodByTenantName(response_);
                } catch (e) {
                    return <Observable<SaleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleDto>><any>Observable.throw(response_);
        });
    }

    protected processSaleDetailsFoodByTenantName(response: Response): Observable<SaleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleDto.fromJS(resultData200) : new SaleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SalesReportsEnhancements/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SalesTransactionsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @receiptNumber (optional) 
     * @return Success
     */
    getInvoiceByReceiptNumber(receiptNumber: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetInvoiceByReceiptNumber?";
        if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoiceByReceiptNumber(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoiceByReceiptNumber(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoiceByReceiptNumber(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @receiptNumber (optional) 
     * @return Success
     */
    getInvoices(receiptNumber: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetInvoices?";
        if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoices(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoices(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @receiptNumber (optional) 
     * @shiftId (optional) 
     * @cashierId (optional) 
     * @return Success
     */
    getInvoicesShift(receiptNumber: string, shiftId: number, cashierId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetInvoicesShift?";
        if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        if (cashierId !== undefined)
            url_ += "cashierId=" + encodeURIComponent("" + cashierId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoicesShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoicesShift(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoicesShift(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInvoiceById(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetInvoiceById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoiceById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoiceById(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoiceById(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    addInvoice(request: any): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/AddInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddInvoice(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processAddInvoice(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getOriginalInvoiceById(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetOriginalInvoiceById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOriginalInvoiceById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOriginalInvoiceById(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetOriginalInvoiceById(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getLastZatcaInvoice(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetLastZatcaInvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLastZatcaInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLastZatcaInvoice(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetLastZatcaInvoice(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @status (optional) 
     * @saleTypeId (optional) 
     * @shiftId (optional) 
     * @return Success
     */
    getSaleByStatus(status: number, saleTypeId: number, shiftId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetSaleByStatus?";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (saleTypeId !== undefined)
            url_ += "saleTypeId=" + encodeURIComponent("" + saleTypeId) + "&"; 
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleByStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleByStatus(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleByStatus(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @status (optional) 
     * @saleType (optional) 
     * @return Success
     */
    getSaleByMultiStatus(status: string, saleType: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetSaleByMultiStatus?";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (saleType !== undefined)
            url_ += "saleType=" + encodeURIComponent("" + saleType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleByMultiStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleByMultiStatus(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleByMultiStatus(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteSaleTransactionDetail(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/DeleteSaleTransactionDetail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSaleTransactionDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSaleTransactionDetail(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSaleTransactionDetail(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @receiptNumber (optional) 
     * @shiftId (optional) 
     * @cashierId (optional) 
     * @return Success
     */
    getReturnInvoicesIds(receiptNumber: string, shiftId: number, cashierId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetReturnInvoicesIds?";
        if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        if (cashierId !== undefined)
            url_ += "cashierId=" + encodeURIComponent("" + cashierId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReturnInvoicesIds(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReturnInvoicesIds(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetReturnInvoicesIds(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    updateInvoiceStatus(request: UpdateInvoiceStatusRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/UpdateInvoiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateInvoiceStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateInvoiceStatus(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processUpdateInvoiceStatus(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInvoiceByTable(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetInvoiceByTable?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoiceByTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoiceByTable(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoiceByTable(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    getTmpInvoice(request: any[]): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetTmpInvoice?";
        if (request !== undefined)
            request && request.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "request[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTmpInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTmpInvoice(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetTmpInvoice(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    qRMenaAddInvoice(request: any): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/QRMenaAddInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processQRMenaAddInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processQRMenaAddInvoice(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processQRMenaAddInvoice(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    fireItem(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/FireItem?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFireItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFireItem(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processFireItem(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    prepareItem(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/PrepareItem?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrepareItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrepareItem(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processPrepareItem(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @request (optional) 
     * @return Success
     */
    prepareItemHook(request: PrepareItemHookRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/PrepareItemHook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrepareItemHook(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrepareItemHook(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processPrepareItemHook(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    maxOrder(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/MaxOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMaxOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMaxOrder(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMaxOrder(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SalesTransactions/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SaleTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getSaleType(id: number): Observable<SaleTypeDTO> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/GetSaleType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleType(response_);
                } catch (e) {
                    return <Observable<SaleTypeDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleTypeDTO>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleType(response: Response): Observable<SaleTypeDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaleTypeDTO.fromJS(resultData200) : new SaleTypeDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleTypeDTO>(<any>null);
    }

    /**
     * @return Success
     */
    getSaleTypes(): Observable<ListResultDtoOfSaleTypeListItem> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/GetSaleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSaleTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSaleTypes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSaleTypeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSaleTypeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSaleTypes(response: Response): Observable<ListResultDtoOfSaleTypeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSaleTypeListItem.fromJS(resultData200) : new ListResultDtoOfSaleTypeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSaleTypeListItem>(<any>null);
    }

    /**
     * @return Success
     */
    refreshSaleTypesCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/RefreshSaleTypesCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRefreshSaleTypesCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRefreshSaleTypesCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRefreshSaleTypesCache(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedSaleTypes(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedSaleTypeList> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/GetPagedSaleTypes?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedSaleTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedSaleTypes(response_);
                } catch (e) {
                    return <Observable<PagedSaleTypeList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedSaleTypeList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedSaleTypes(response: Response): Observable<PagedSaleTypeList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedSaleTypeList.fromJS(resultData200) : new PagedSaleTypeList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedSaleTypeList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSaleType(input: CreateSaleTypeInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/CreateSaleType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSaleType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSaleType(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateSaleType(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateSaleType(input: EditSaleTypeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/UpdateSaleType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSaleType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSaleType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSaleType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteSaleType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/DeleteSaleType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSaleType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSaleType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSaleType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @saleTypeId (optional) 
     * @return Success
     */
    deleteSaleTypeImage(saleTypeId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/DeleteSaleTypeImage?";
        if (saleTypeId !== undefined)
            url_ += "saleTypeId=" + encodeURIComponent("" + saleTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSaleTypeImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSaleTypeImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSaleTypeImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SaleType/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ScaleConfigurationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getScaleConfiguration(): Observable<ScaleConfigurationDTO> {
        let url_ = this.baseUrl + "/api/services/app/ScaleConfiguration/GetScaleConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetScaleConfiguration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetScaleConfiguration(response_);
                } catch (e) {
                    return <Observable<ScaleConfigurationDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ScaleConfigurationDTO>><any>Observable.throw(response_);
        });
    }

    protected processGetScaleConfiguration(response: Response): Observable<ScaleConfigurationDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ScaleConfigurationDTO.fromJS(resultData200) : new ScaleConfigurationDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ScaleConfigurationDTO>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    insertOrUpdateScaleConfiguration(model: ScaleConfigurationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScaleConfiguration/InsertOrUpdateScaleConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertOrUpdateScaleConfiguration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertOrUpdateScaleConfiguration(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertOrUpdateScaleConfiguration(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ScaleConfiguration/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SchemaServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @schemaInput (optional) 
     * @return Success
     */
    createSchema(schemaInput: SchemaInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Schema/CreateSchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schemaInput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSchema(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSchema(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSchema(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteSchema(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Schema/DeleteSchema?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSchema(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSchema(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSchema(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getSchema(id: number): Observable<SchemaInput> {
        let url_ = this.baseUrl + "/api/services/app/Schema/GetSchema?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSchema(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSchema(response_);
                } catch (e) {
                    return <Observable<SchemaInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<SchemaInput>><any>Observable.throw(response_);
        });
    }

    protected processGetSchema(response: Response): Observable<SchemaInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SchemaInput.fromJS(resultData200) : new SchemaInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SchemaInput>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getSchemas(pageNumber: number, pageSize: number): Observable<PagedSchemaList> {
        let url_ = this.baseUrl + "/api/services/app/Schema/GetSchemas?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSchemas(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSchemas(response_);
                } catch (e) {
                    return <Observable<PagedSchemaList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedSchemaList>><any>Observable.throw(response_);
        });
    }

    protected processGetSchemas(response: Response): Observable<PagedSchemaList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedSchemaList.fromJS(resultData200) : new PagedSchemaList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedSchemaList>(<any>null);
    }

    /**
     * @schemaInput (optional) 
     * @return Success
     */
    updateSchema(schemaInput: SchemaInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Schema/UpdateSchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schemaInput);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSchema(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSchema(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSchema(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Schema/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SecondaryCategoriesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getSecondaryCategory(id: number): Observable<SecondaryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/GetSecondaryCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSecondaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSecondaryCategory(response_);
                } catch (e) {
                    return <Observable<SecondaryCategoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SecondaryCategoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSecondaryCategory(response: Response): Observable<SecondaryCategoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SecondaryCategoryDto.fromJS(resultData200) : new SecondaryCategoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SecondaryCategoryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSecondaryCategories(): Observable<ListResultDtoOfSecondaryCategoryListItem> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/GetSecondaryCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSecondaryCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSecondaryCategories(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSecondaryCategoryListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSecondaryCategoryListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSecondaryCategories(response: Response): Observable<ListResultDtoOfSecondaryCategoryListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSecondaryCategoryListItem.fromJS(resultData200) : new ListResultDtoOfSecondaryCategoryListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSecondaryCategoryListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @return Success
     */
    getPagedSecondaryCategories(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedSecondaryCategoryList> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/GetPagedSecondaryCategories?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedSecondaryCategories(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedSecondaryCategories(response_);
                } catch (e) {
                    return <Observable<PagedSecondaryCategoryList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedSecondaryCategoryList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedSecondaryCategories(response: Response): Observable<PagedSecondaryCategoryList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedSecondaryCategoryList.fromJS(resultData200) : new PagedSecondaryCategoryList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedSecondaryCategoryList>(<any>null);
    }

    /**
     * @return Success
     */
    generateCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSecondaryCategory(input: CreateSecondaryCategoryInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/CreateSecondaryCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSecondaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSecondaryCategory(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateSecondaryCategory(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateSecondaryCategory(input: UpdateSecondaryCategoryInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/UpdateSecondaryCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSecondaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSecondaryCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSecondaryCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteSecondaryCategory(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/DeleteSecondaryCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSecondaryCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSecondaryCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSecondaryCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCategories/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ServiceChargeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateServiceChargeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCharge/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<ServiceChargeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCharge/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<ServiceChargeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ServiceChargeDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<ServiceChargeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceChargeDto.fromJS(resultData200) : new ServiceChargeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ServiceChargeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfServiceChargeListItem> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCharge/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfServiceChargeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfServiceChargeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfServiceChargeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfServiceChargeListItem.fromJS(resultData200) : new ListResultDtoOfServiceChargeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfServiceChargeListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedServiceCharges(pageNumber: number, pageSize: number): Observable<PagedServiceChargeList> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCharge/GetPagedServiceCharges?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedServiceCharges(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedServiceCharges(response_);
                } catch (e) {
                    return <Observable<PagedServiceChargeList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedServiceChargeList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedServiceCharges(response: Response): Observable<PagedServiceChargeList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedServiceChargeList.fromJS(resultData200) : new PagedServiceChargeList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedServiceChargeList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateServiceChargeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCharge/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCharge/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCharge/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentLoginInformations(response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentLoginInformations(response: Response): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUserSignInToken(response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserSignInToken(response: Response): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateUserSignInTokenOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentCalender(): Observable<CalenderCulture> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentCalender";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentCalender(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentCalender(response_);
                } catch (e) {
                    return <Observable<CalenderCulture>><any>Observable.throw(e);
                }
            } else
                return <Observable<CalenderCulture>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentCalender(response: Response): Observable<CalenderCulture> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CalenderCulture.fromJS(resultData200) : new CalenderCulture();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CalenderCulture>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCountriesZones(): Observable<CountryTimeZone[]> {
        let url_ = this.baseUrl + "/api/services/app/Settings/GetCountriesZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountriesZones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountriesZones(response_);
                } catch (e) {
                    return <Observable<CountryTimeZone[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CountryTimeZone[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCountriesZones(response: Response): Observable<CountryTimeZone[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CountryTimeZone.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CountryTimeZone[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Settings/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StockServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getStoreProducts(storeId: number): Observable<StoreProductsListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetStoreProducts?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreProducts(response_);
                } catch (e) {
                    return <Observable<StoreProductsListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductsListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreProducts(response: Response): Observable<StoreProductsListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreProductsListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductsListItem[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    productLots(input: GetProductLotInput): Observable<ProductLotListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/ProductLots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductLots(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductLots(response_);
                } catch (e) {
                    return <Observable<ProductLotListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductLotListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processProductLots(response: Response): Observable<ProductLotListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductLotListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductLotListItem[]>(<any>null);
    }

    /**
     * @lots (optional) 
     * @return Success
     */
    adjustStoreProductLot(lots: AdjustProductLotInput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stock/AdjustStoreProductLot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lots);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAdjustStoreProductLot(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAdjustStoreProductLot(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAdjustStoreProductLot(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StockAdjustmentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStockAdjustment(id: number): Observable<MainTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/GetStockAdjustment?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStockAdjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStockAdjustment(response_);
                } catch (e) {
                    return <Observable<MainTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MainTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStockAdjustment(response: Response): Observable<MainTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MainTransactionDto.fromJS(resultData200) : new MainTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MainTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getStockAdjustments(): Observable<ListResultDtoOfMainTransactionListItem> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/GetStockAdjustments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStockAdjustments(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStockAdjustments(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMainTransactionListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStockAdjustments(response: Response): Observable<ListResultDtoOfMainTransactionListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMainTransactionListItem.fromJS(resultData200) : new ListResultDtoOfMainTransactionListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMainTransactionListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/GetCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMaterialStock(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/UpdateMaterialStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMaterialStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMaterialStock(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMaterialStock(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createStockAdjustment(input: CreateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/CreateStockAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateStockAdjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateStockAdjustment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateStockAdjustment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateStockAdjustment(input: UpdateMainTransactionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/UpdateStockAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateStockAdjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateStockAdjustment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateStockAdjustment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @rawMaterialId (optional) 
     * @return Success
     */
    getExpectedQuantity(storeId: number, rawMaterialId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/GetExpectedQuantity?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (rawMaterialId !== undefined)
            url_ += "rawMaterialId=" + encodeURIComponent("" + rawMaterialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExpectedQuantity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExpectedQuantity(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetExpectedQuantity(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteStockAdjustment(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/DeleteStockAdjustment?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteStockAdjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteStockAdjustment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteStockAdjustment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedStockAdjustment(pageNumber: number, pageSize: number): Observable<PagedMainTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/GetPagedStockAdjustment?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedStockAdjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedStockAdjustment(response_);
                } catch (e) {
                    return <Observable<PagedMainTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedMainTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedStockAdjustment(response: Response): Observable<PagedMainTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedMainTransactionList.fromJS(resultData200) : new PagedMainTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedMainTransactionList>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StockAdjustment/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StockManagmentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getStoreMaterialsThatReachedToReOrdered(storeId: number): Observable<StoreReOrderMaterialInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/StockManagment/GetStoreMaterialsThatReachedToReOrdered?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreMaterialsThatReachedToReOrdered(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreMaterialsThatReachedToReOrdered(response_);
                } catch (e) {
                    return <Observable<StoreReOrderMaterialInfo[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreReOrderMaterialInfo[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreMaterialsThatReachedToReOrdered(response: Response): Observable<StoreReOrderMaterialInfo[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreReOrderMaterialInfo.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreReOrderMaterialInfo[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StockManagment/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StockPeriodServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateStockPeriodInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockPeriod/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateStockPeriodDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockPeriod/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockPeriod/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedPeriodList(pageNumber: number, pageSize: number): Observable<PagedStockPeriodList> {
        let url_ = this.baseUrl + "/api/services/app/StockPeriod/GetPagedPeriodList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedPeriodList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedPeriodList(response_);
                } catch (e) {
                    return <Observable<PagedStockPeriodList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedStockPeriodList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedPeriodList(response: Response): Observable<PagedStockPeriodList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedStockPeriodList.fromJS(resultData200) : new PagedStockPeriodList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedStockPeriodList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<StockPeriodDto> {
        let url_ = this.baseUrl + "/api/services/app/StockPeriod/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<StockPeriodDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StockPeriodDto>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<StockPeriodDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StockPeriodDto.fromJS(resultData200) : new StockPeriodDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StockPeriodDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInventoryClosingDates(id: number): Observable<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/services/app/StockPeriod/GetInventoryClosingDates?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryClosingDates(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryClosingDates(response_);
                } catch (e) {
                    return <Observable<moment.Moment[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<moment.Moment[]>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryClosingDates(response: Response): Observable<moment.Moment[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(moment(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<moment.Moment[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StockPeriod/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StoreGroupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createStoreGroup(input: CreateStoreGroupInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/CreateStoreGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateStoreGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateStoreGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteStoreGroup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/DeleteStoreGroup?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteStoreGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteStoreGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStoreGroup(id: number): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/GetStoreGroup?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroup(response_);
                } catch (e) {
                    return <Observable<StoreDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroup(response: Response): Observable<StoreDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreDto.fromJS(resultData200) : new StoreDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreDto>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getStoreGroups(descending: boolean): Observable<ListResultDtoOfStoreGroupListItem> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/GetStoreGroups?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroups(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreGroupListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreGroupListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroups(response: Response): Observable<ListResultDtoOfStoreGroupListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreGroupListItem.fromJS(resultData200) : new ListResultDtoOfStoreGroupListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreGroupListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateStoreGroup(input: UpdateStoreGroupInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/UpdateStoreGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateStoreGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateStoreGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storegroupId (optional) 
     * @return Success
     */
    getStoreGroupsWithoutChildren(storegroupId: number): Observable<ListResultDtoOfStoreGroupListItem> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/GetStoreGroupsWithoutChildren?";
        if (storegroupId !== undefined)
            url_ += "storegroupId=" + encodeURIComponent("" + storegroupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsWithoutChildren(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsWithoutChildren(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreGroupListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreGroupListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsWithoutChildren(response: Response): Observable<ListResultDtoOfStoreGroupListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreGroupListItem.fromJS(resultData200) : new ListResultDtoOfStoreGroupListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreGroupListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @out (optional) 
     * @return Success
     */
    getStoreGroupAndParents(id: number, out: any[]): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/GetStoreGroupAndParents?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (out !== undefined)
            out && out.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "Out[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupAndParents(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupAndParents(response_);
                } catch (e) {
                    return <Observable<StoreDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupAndParents(response: Response): Observable<StoreDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreDto[]>(<any>null);
    }

    /**
     * @ids (optional) 
     * @return Success
     */
    getAllStoresByStoreGroupId(ids: number[]): Observable<StoreListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/GetAllStoresByStoreGroupId?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllStoresByStoreGroupId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllStoresByStoreGroupId(response_);
                } catch (e) {
                    return <Observable<StoreListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllStoresByStoreGroupId(response: Response): Observable<StoreListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreListItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StoreGroup/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StoreMenuItemConfigServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateManyStoreMenuItemConfig(input: CreateMenuItemConfigDto): Observable<MenuItemConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/CreateUpdateManyStoreMenuItemConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateManyStoreMenuItemConfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateManyStoreMenuItemConfig(response_);
                } catch (e) {
                    return <Observable<MenuItemConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateManyStoreMenuItemConfig(response: Response): Observable<MenuItemConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MenuItemConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemConfigDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateStoreMenuItemConfig(input: MenuItemConfigDto): Observable<MenuItemConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/CreateUpdateStoreMenuItemConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateStoreMenuItemConfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateStoreMenuItemConfig(response_);
                } catch (e) {
                    return <Observable<MenuItemConfigDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemConfigDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateStoreMenuItemConfig(response: Response): Observable<MenuItemConfigDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemConfigDto.fromJS(resultData200) : new MenuItemConfigDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemConfigDto>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @storeId (optional) 
     * @effectiveDate (optional) 
     * @return Success
     */
    getMenuItemConfigDDL(menuItemId: number, storeId: number, effectiveDate: moment.Moment): Observable<StoreMenuItemConfigDDLDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetMenuItemConfigDDL?";
        if (menuItemId !== undefined)
            url_ += "MenuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (effectiveDate !== undefined)
            url_ += "EffectiveDate=" + encodeURIComponent(effectiveDate ? "" + effectiveDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMenuItemConfigDDL(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMenuItemConfigDDL(response_);
                } catch (e) {
                    return <Observable<StoreMenuItemConfigDDLDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreMenuItemConfigDDLDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMenuItemConfigDDL(response: Response): Observable<StoreMenuItemConfigDDLDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreMenuItemConfigDDLDto.fromJS(resultData200) : new StoreMenuItemConfigDDLDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreMenuItemConfigDDLDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllStoreMenuItemConfig(): Observable<MenuItemConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetAllStoreMenuItemConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllStoreMenuItemConfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllStoreMenuItemConfig(response_);
                } catch (e) {
                    return <Observable<MenuItemConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllStoreMenuItemConfig(response: Response): Observable<MenuItemConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MenuItemConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemConfigDto[]>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getAllStoreMenuItemConfigByStoreId(storeId: number): Observable<MenuItemConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetAllStoreMenuItemConfigByStoreId?";
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllStoreMenuItemConfigByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllStoreMenuItemConfigByStoreId(response_);
                } catch (e) {
                    return <Observable<MenuItemConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllStoreMenuItemConfigByStoreId(response: Response): Observable<MenuItemConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MenuItemConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemConfigDto[]>(<any>null);
    }

    /**
     * @menuItemIds (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedStoreMenuItemConfigList(menuItemIds: number[], pageNumber: number, pageSize: number): Observable<PagedStoreMenuItemConfigList> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetPagedStoreMenuItemConfigList?";
        if (menuItemIds !== undefined)
            menuItemIds && menuItemIds.forEach(item => { url_ += "menuItemIds=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedStoreMenuItemConfigList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedStoreMenuItemConfigList(response_);
                } catch (e) {
                    return <Observable<PagedStoreMenuItemConfigList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedStoreMenuItemConfigList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedStoreMenuItemConfigList(response: Response): Observable<PagedStoreMenuItemConfigList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedStoreMenuItemConfigList.fromJS(resultData200) : new PagedStoreMenuItemConfigList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedStoreMenuItemConfigList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStoreMenuItemConfigById(id: number): Observable<MenuItemConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetStoreMenuItemConfigById?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreMenuItemConfigById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreMenuItemConfigById(response_);
                } catch (e) {
                    return <Observable<MenuItemConfigDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemConfigDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreMenuItemConfigById(response: Response): Observable<MenuItemConfigDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemConfigDto.fromJS(resultData200) : new MenuItemConfigDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemConfigDto>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @storeId (optional) 
     * @effectiveDate (optional) 
     * @return Success
     */
    getStoreMenuItemConfigByMenuItemIdANDStoreId(menuItemId: number, storeId: number, effectiveDate: moment.Moment): Observable<MenuItemConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetStoreMenuItemConfigByMenuItemIdANDStoreId?";
        if (menuItemId !== undefined)
            url_ += "MenuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (effectiveDate !== undefined)
            url_ += "EffectiveDate=" + encodeURIComponent(effectiveDate ? "" + effectiveDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreMenuItemConfigByMenuItemIdANDStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreMenuItemConfigByMenuItemIdANDStoreId(response_);
                } catch (e) {
                    return <Observable<MenuItemConfigDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemConfigDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreMenuItemConfigByMenuItemIdANDStoreId(response: Response): Observable<MenuItemConfigDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MenuItemConfigDto.fromJS(resultData200) : new MenuItemConfigDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemConfigDto>(<any>null);
    }

    /**
     * @menuItemId (optional) 
     * @return Success
     */
    getAllStoreMenuItemConfigByMenuItem(menuItemId: number): Observable<MenuItemConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetAllStoreMenuItemConfigByMenuItem?";
        if (menuItemId !== undefined)
            url_ += "MenuItemId=" + encodeURIComponent("" + menuItemId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllStoreMenuItemConfigByMenuItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllStoreMenuItemConfigByMenuItem(response_);
                } catch (e) {
                    return <Observable<MenuItemConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MenuItemConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllStoreMenuItemConfigByMenuItem(response: Response): Observable<MenuItemConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MenuItemConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MenuItemConfigDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StoreMenuItemConfig/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StoreProductCategoryConfigServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateManyStoreProductCategoryConfig(input: CreateStoreProductCategoryConfigDto): Observable<StoreProductCategoryConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/CreateUpdateManyStoreProductCategoryConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateManyStoreProductCategoryConfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateManyStoreProductCategoryConfig(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateManyStoreProductCategoryConfig(response: Response): Observable<StoreProductCategoryConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreProductCategoryConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateStoreProductCategoryConfig(input: StoreProductCategoryConfigDto): Observable<StoreProductCategoryConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/CreateUpdateStoreProductCategoryConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateStoreProductCategoryConfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateStoreProductCategoryConfig(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateStoreProductCategoryConfig(response: Response): Observable<StoreProductCategoryConfigDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreProductCategoryConfigDto.fromJS(resultData200) : new StoreProductCategoryConfigDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDto>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @storeId (optional) 
     * @effectiveDate (optional) 
     * @return Success
     */
    getProductCategoryConfigDDL(productCategoryId: number, storeId: number, effectiveDate: moment.Moment): Observable<StoreProductCategoryConfigDDLDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetProductCategoryConfigDDL?";
        if (productCategoryId !== undefined)
            url_ += "ProductCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (effectiveDate !== undefined)
            url_ += "EffectiveDate=" + encodeURIComponent(effectiveDate ? "" + effectiveDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductCategoryConfigDDL(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductCategoryConfigDDL(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDDLDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDDLDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductCategoryConfigDDL(response: Response): Observable<StoreProductCategoryConfigDDLDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreProductCategoryConfigDDLDto.fromJS(resultData200) : new StoreProductCategoryConfigDDLDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDDLDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllStoreProductCategoryConfig(): Observable<StoreProductCategoryConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetAllStoreProductCategoryConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllStoreProductCategoryConfig(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllStoreProductCategoryConfig(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllStoreProductCategoryConfig(response: Response): Observable<StoreProductCategoryConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreProductCategoryConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDto[]>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getAllStoreProductCategoryConfigByStoreId(storeId: number): Observable<StoreProductCategoryConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetAllStoreProductCategoryConfigByStoreId?";
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllStoreProductCategoryConfigByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllStoreProductCategoryConfigByStoreId(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllStoreProductCategoryConfigByStoreId(response: Response): Observable<StoreProductCategoryConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreProductCategoryConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDto[]>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedStoreProductCategoryConfigList(pageNumber: number, pageSize: number): Observable<PagedStoreProductCategoryConfigList> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetPagedStoreProductCategoryConfigList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedStoreProductCategoryConfigList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedStoreProductCategoryConfigList(response_);
                } catch (e) {
                    return <Observable<PagedStoreProductCategoryConfigList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedStoreProductCategoryConfigList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedStoreProductCategoryConfigList(response: Response): Observable<PagedStoreProductCategoryConfigList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedStoreProductCategoryConfigList.fromJS(resultData200) : new PagedStoreProductCategoryConfigList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedStoreProductCategoryConfigList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStoreProductCategoryConfigById(id: number): Observable<StoreProductCategoryConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetStoreProductCategoryConfigById?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreProductCategoryConfigById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreProductCategoryConfigById(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreProductCategoryConfigById(response: Response): Observable<StoreProductCategoryConfigDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreProductCategoryConfigDto.fromJS(resultData200) : new StoreProductCategoryConfigDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDto>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @storeId (optional) 
     * @effectiveDate (optional) 
     * @return Success
     */
    getStoreProductCategoryConfigByProductCategoryIdANDStoreId(productCategoryId: number, storeId: number, effectiveDate: moment.Moment): Observable<StoreProductCategoryConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetStoreProductCategoryConfigByProductCategoryIdANDStoreId?";
        if (productCategoryId !== undefined)
            url_ += "ProductCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (effectiveDate !== undefined)
            url_ += "EffectiveDate=" + encodeURIComponent(effectiveDate ? "" + effectiveDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreProductCategoryConfigByProductCategoryIdANDStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreProductCategoryConfigByProductCategoryIdANDStoreId(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreProductCategoryConfigByProductCategoryIdANDStoreId(response: Response): Observable<StoreProductCategoryConfigDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreProductCategoryConfigDto.fromJS(resultData200) : new StoreProductCategoryConfigDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDto>(<any>null);
    }

    /**
     * @productCategoryId (optional) 
     * @return Success
     */
    getAllStoreProductCategoryConfigByProductCategory(productCategoryId: number): Observable<StoreProductCategoryConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetAllStoreProductCategoryConfigByProductCategory?";
        if (productCategoryId !== undefined)
            url_ += "ProductCategoryId=" + encodeURIComponent("" + productCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllStoreProductCategoryConfigByProductCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllStoreProductCategoryConfigByProductCategory(response_);
                } catch (e) {
                    return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreProductCategoryConfigDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllStoreProductCategoryConfigByProductCategory(response: Response): Observable<StoreProductCategoryConfigDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreProductCategoryConfigDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreProductCategoryConfigDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/StoreProductCategoryConfig/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class StoresServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantId (optional) 
     * @searchKey (optional) 
     * @storeTypeIds (optional) 
     * @return Success
     */
    getStoresByFilters(tenantId: number, searchKey: string, storeTypeIds: number[]): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresByFilters?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (storeTypeIds !== undefined)
            storeTypeIds && storeTypeIds.forEach(item => { url_ += "StoreTypeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresByFilters(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresByFilters(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresByFilters(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStore(id: number): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStore?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStore(response_);
                } catch (e) {
                    return <Observable<StoreDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStore(response: Response): Observable<StoreDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreDto.fromJS(resultData200) : new StoreDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreDto>(<any>null);
    }

    /**
     * @areaId (optional) 
     * @return Success
     */
    getStoresByAreaId(areaId: number): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresByAreaId?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresByAreaId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresByAreaId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresByAreaId(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @storeGroupId (optional) 
     * @return Success
     */
    getStoresByStoreGroupId(storeGroupId: number): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresByStoreGroupId?";
        if (storeGroupId !== undefined)
            url_ += "storeGroupId=" + encodeURIComponent("" + storeGroupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresByStoreGroupId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresByStoreGroupId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresByStoreGroupId(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getStoresByTenantId(tenantId: number): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresByTenantId?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresByTenantId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresByTenantId(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @storeGroupIds (optional) 
     * @return Success
     */
    getStoresByStoreGroupIds(storeGroupIds: number[]): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresByStoreGroupIds?";
        if (storeGroupIds !== undefined)
            storeGroupIds && storeGroupIds.forEach(item => { url_ += "storeGroupIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresByStoreGroupIds(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresByStoreGroupIds(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresByStoreGroupIds(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getStoresAfterCheckForParentChild(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresAfterCheckForParentChild";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresAfterCheckForParentChild(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresAfterCheckForParentChild(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresAfterCheckForParentChild(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getStores(descending: boolean): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStores?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStores(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStores(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getStoresForPosConfigurations(descending: boolean): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresForPosConfigurations?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresForPosConfigurations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresForPosConfigurations(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresForPosConfigurations(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getStoresForCurrentUser(descending: boolean): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresForCurrentUser?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresForCurrentUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresForCurrentUser(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresForCurrentUser(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    refreshUserStores(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/RefreshUserStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRefreshUserStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRefreshUserStores(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRefreshUserStores(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getStoreGroupes(descending: boolean): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoreGroupes?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupes(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStoreGroupesByRawMaterialId(id: number): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoreGroupesByRawMaterialId?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupesByRawMaterialId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupesByRawMaterialId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupesByRawMaterialId(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getUserStoreWithStoreGroups(descending: boolean): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetUserStoreWithStoreGroups?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserStoreWithStoreGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserStoreWithStoreGroups(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetUserStoreWithStoreGroups(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getALLStores(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetALLStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetALLStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetALLStores(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetALLStores(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @return Success
     */
    getStoresNameById(storeIds: number[]): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoresNameById?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoresNameById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoresNameById(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetStoresNameById(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getOpenedStores(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetOpenedStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOpenedStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOpenedStores(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetOpenedStores(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getSelectedStore(id: number): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetSelectedStore?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSelectedStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSelectedStore(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSelectedStore(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createStore(input: CreateStoreInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/CreateStore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateStore(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateStore(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateStore(input: UpdateStoreInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/UpdateStore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateStore(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateStore(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteStore(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/DeleteStore?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteStore(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteStore(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @openStoreDto (optional) 
     * @return Success
     */
    openStore(openStoreDto: OpenStoreDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/OpenStore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(openStoreDto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOpenStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOpenStore(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processOpenStore(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    closeStore(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/CloseStore?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloseStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloseStore(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloseStore(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addWorkingHoursRule(input: CreateWorkingHoursDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/AddWorkingHoursRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddWorkingHoursRule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddWorkingHoursRule(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddWorkingHoursRule(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @workinghourId (optional) 
     * @return Success
     */
    deleteWorkinghour(workinghourId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/DeleteWorkinghour?";
        if (workinghourId !== undefined)
            url_ += "workinghourId=" + encodeURIComponent("" + workinghourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteWorkinghour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteWorkinghour(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteWorkinghour(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateWorkingHoursRule(input: CreateWorkingHoursDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/UpdateWorkingHoursRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateWorkingHoursRule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateWorkingHoursRule(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateWorkingHoursRule(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStoreRules(id: number): Observable<ListResultDtoOfStoreWorkingHoursRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoreRules?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreRules(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreRules(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreWorkingHoursRuleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreWorkingHoursRuleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreRules(response: Response): Observable<ListResultDtoOfStoreWorkingHoursRuleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreWorkingHoursRuleDto.fromJS(resultData200) : new ListResultDtoOfStoreWorkingHoursRuleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreWorkingHoursRuleDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getStoreRule(id: number): Observable<StoreWorkingHoursWithMultipleShiftsDto> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoreRule?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreRule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreRule(response_);
                } catch (e) {
                    return <Observable<StoreWorkingHoursWithMultipleShiftsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreWorkingHoursWithMultipleShiftsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreRule(response: Response): Observable<StoreWorkingHoursWithMultipleShiftsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StoreWorkingHoursWithMultipleShiftsDto.fromJS(resultData200) : new StoreWorkingHoursWithMultipleShiftsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreWorkingHoursWithMultipleShiftsDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDays(): Observable<ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDays(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDays(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDays(response: Response): Observable<ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto.fromJS(resultData200) : new ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @return Success
     */
    addStoreSupervisor(storeId: number, userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/AddStoreSupervisor?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddStoreSupervisor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddStoreSupervisor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddStoreSupervisor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getStoreSupervisors(storeId: number): Observable<ListResultDtoOfSupervisorListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoreSupervisors?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreSupervisors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreSupervisors(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSupervisorListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSupervisorListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreSupervisors(response: Response): Observable<ListResultDtoOfSupervisorListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSupervisorListItem.fromJS(resultData200) : new ListResultDtoOfSupervisorListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSupervisorListItem>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @return Success
     */
    removeStoreSupervisor(storeId: number, userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/RemoveStoreSupervisor?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveStoreSupervisor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveStoreSupervisor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveStoreSupervisor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getSupervisors(): Observable<ListResultDtoOfSupervisorListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetSupervisors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSupervisors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSupervisors(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSupervisorListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSupervisorListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSupervisors(response: Response): Observable<ListResultDtoOfSupervisorListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSupervisorListItem.fromJS(resultData200) : new ListResultDtoOfSupervisorListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSupervisorListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getCashiers(): Observable<ListResultDtoOfCashierListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetCashiers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCashiers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCashiers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCashierListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCashierListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetCashiers(response: Response): Observable<ListResultDtoOfCashierListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCashierListItem.fromJS(resultData200) : new ListResultDtoOfCashierListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCashierListItem>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @return Success
     */
    addInventoryManager(storeId: number, userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/AddInventoryManager?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddInventoryManager(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddInventoryManager(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddInventoryManager(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getStoreInventoryManagers(storeId: number): Observable<ListResultDtoOfInventoryManagerListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetStoreInventoryManagers?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreInventoryManagers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreInventoryManagers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInventoryManagerListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfInventoryManagerListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreInventoryManagers(response: Response): Observable<ListResultDtoOfInventoryManagerListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInventoryManagerListItem.fromJS(resultData200) : new ListResultDtoOfInventoryManagerListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfInventoryManagerListItem>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @userId (optional) 
     * @return Success
     */
    removeInventoryManager(storeId: number, userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stores/RemoveInventoryManager?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveInventoryManager(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveInventoryManager(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveInventoryManager(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getInventoryManagers(): Observable<ListResultDtoOfInventoryManagerListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetInventoryManagers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInventoryManagers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInventoryManagers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInventoryManagerListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfInventoryManagerListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetInventoryManagers(response: Response): Observable<ListResultDtoOfInventoryManagerListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInventoryManagerListItem.fromJS(resultData200) : new ListResultDtoOfInventoryManagerListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfInventoryManagerListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getMyStores(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetMyStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyStores(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMyStores(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getMyStoresNotWhareHouse(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetMyStoresNotWhareHouse";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyStoresNotWhareHouse(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyStoresNotWhareHouse(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetMyStoresNotWhareHouse(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getUserStoresNotWhareHouse(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetUserStoresNotWhareHouse";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserStoresNotWhareHouse(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserStoresNotWhareHouse(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetUserStoresNotWhareHouse(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getWhareHouses(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetWhareHouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetWhareHouses(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetWhareHouses(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetWhareHouses(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getUserStores(): Observable<ListResultDtoOfStoreListItem> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetUserStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserStores(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetUserStores(response: Response): Observable<ListResultDtoOfStoreListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreListItem.fromJS(resultData200) : new ListResultDtoOfStoreListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getAllRules(): Observable<ListResultDtoOfStoreWorkingHoursRuleDto> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetAllRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllRules(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllRules(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStoreWorkingHoursRuleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStoreWorkingHoursRuleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllRules(response: Response): Observable<ListResultDtoOfStoreWorkingHoursRuleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStoreWorkingHoursRuleDto.fromJS(resultData200) : new ListResultDtoOfStoreWorkingHoursRuleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStoreWorkingHoursRuleDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Stores/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @upgradeEditionId (optional) 
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpgradeTenantToEquivalentEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpgradeTenantToEquivalentEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpgradeTenantToEquivalentEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SupervisorShiftsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    startMyShift(storeId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/StartMyShift?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartMyShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartMyShift(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartMyShift(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @shiftId (optional) 
     * @return Success
     */
    zReport(shiftId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/ZReport?";
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processZReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processZReport(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processZReport(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @shiftId (optional) 
     * @supervisorShiftPaymentTransactionValues (optional) 
     * @return Success
     */
    closeShift(shiftId: number, supervisorShiftPaymentTransactionValues: SupervisorShiftPaymentTransactionsDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/CloseShift?";
        if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supervisorShiftPaymentTransactionValues);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloseShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloseShift(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloseShift(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentStore(): Observable<SupervisorStoreDto> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/GetCurrentStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentStore(response_);
                } catch (e) {
                    return <Observable<SupervisorStoreDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SupervisorStoreDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentStore(response: Response): Observable<SupervisorStoreDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SupervisorStoreDto.fromJS(resultData200) : new SupervisorStoreDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SupervisorStoreDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMyShift(): Observable<SupervisorShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/GetMyShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyShift(response_);
                } catch (e) {
                    return <Observable<SupervisorShiftDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SupervisorShiftDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMyShift(response: Response): Observable<SupervisorShiftDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SupervisorShiftDto.fromJS(resultData200) : new SupervisorShiftDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SupervisorShiftDto>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getMyShiftByStoreId(storeId: number): Observable<SupervisorShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/GetMyShiftByStoreId?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyShiftByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyShiftByStoreId(response_);
                } catch (e) {
                    return <Observable<SupervisorShiftDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SupervisorShiftDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMyShiftByStoreId(response: Response): Observable<SupervisorShiftDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SupervisorShiftDto.fromJS(resultData200) : new SupervisorShiftDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SupervisorShiftDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMyShiftStore(): Observable<SupervisorShiftDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/GetAllMyShiftStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMyShiftStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMyShiftStore(response_);
                } catch (e) {
                    return <Observable<SupervisorShiftDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SupervisorShiftDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMyShiftStore(response: Response): Observable<SupervisorShiftDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SupervisorShiftDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SupervisorShiftDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    closeMyShift(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/CloseMyShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloseMyShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloseMyShift(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloseMyShift(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    checkOpenedCashierShift(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/checkOpenedCashierShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckOpenedCashierShift(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckOpenedCashierShift(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCheckOpenedCashierShift(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    checkOpenedCashierShiftByStoreId(storeId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/checkOpenedCashierShiftByStoreId?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckOpenedCashierShiftByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckOpenedCashierShiftByStoreId(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCheckOpenedCashierShiftByStoreId(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSupervisors(): Observable<SupervisorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/GetAllSupervisors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSupervisors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSupervisors(response_);
                } catch (e) {
                    return <Observable<SupervisorDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SupervisorDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSupervisors(response: Response): Observable<SupervisorDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SupervisorDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SupervisorDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SupervisorShifts/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class SynchronizationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeliveryStreetTranslationsTable(date: moment.Moment): Observable<SyncResultOfDeliveryStreetTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeliveryStreetTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeliveryStreetTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeliveryStreetTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeliveryStreetTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeliveryStreetTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeliveryStreetTranslationsTable(response: Response): Observable<SyncResultOfDeliveryStreetTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeliveryStreetTranslationRecord.fromJS(resultData200) : new SyncResultOfDeliveryStreetTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeliveryStreetTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncServiceChargeTable(date: moment.Moment): Observable<SyncResultOfServiceChargeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncServiceChargeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncServiceChargeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncServiceChargeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfServiceChargeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfServiceChargeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncServiceChargeTable(response: Response): Observable<SyncResultOfServiceChargeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfServiceChargeRecord.fromJS(resultData200) : new SyncResultOfServiceChargeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfServiceChargeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncServiceChargeTranslationsTable(date: moment.Moment): Observable<SyncResultOfServiceChargeTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncServiceChargeTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncServiceChargeTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncServiceChargeTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfServiceChargeTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfServiceChargeTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncServiceChargeTranslationsTable(response: Response): Observable<SyncResultOfServiceChargeTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfServiceChargeTranslationRecord.fromJS(resultData200) : new SyncResultOfServiceChargeTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfServiceChargeTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncServiceChargeSaleTypeTable(date: moment.Moment): Observable<SyncResultOfServiceChargeSaleTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncServiceChargeSaleTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncServiceChargeSaleTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncServiceChargeSaleTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfServiceChargeSaleTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfServiceChargeSaleTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncServiceChargeSaleTypeTable(response: Response): Observable<SyncResultOfServiceChargeSaleTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfServiceChargeSaleTypeRecord.fromJS(resultData200) : new SyncResultOfServiceChargeSaleTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfServiceChargeSaleTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncSaleTypePriceListTable(date: moment.Moment): Observable<SyncResultOfSaleTypePriceListRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSaleTypePriceListTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSaleTypePriceListTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSaleTypePriceListTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSaleTypePriceListRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSaleTypePriceListRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSaleTypePriceListTable(response: Response): Observable<SyncResultOfSaleTypePriceListRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSaleTypePriceListRecord.fromJS(resultData200) : new SyncResultOfSaleTypePriceListRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSaleTypePriceListRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreTable(date: moment.Moment): Observable<SyncResultOfStoreRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreTable(response: Response): Observable<SyncResultOfStoreRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreRecord.fromJS(resultData200) : new SyncResultOfStoreRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemPriceListTable(date: moment.Moment): Observable<SyncResultOfMenuItemPriceListRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemPriceListTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemPriceListTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemPriceListTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemPriceListRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemPriceListRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemPriceListTable(response: Response): Observable<SyncResultOfMenuItemPriceListRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemPriceListRecord.fromJS(resultData200) : new SyncResultOfMenuItemPriceListRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemPriceListRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemSaleTypeTable(date: moment.Moment): Observable<SyncResultOfMenuItemSaleTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemSaleTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemSaleTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemSaleTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemSaleTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemSaleTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemSaleTypeTable(response: Response): Observable<SyncResultOfMenuItemSaleTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemSaleTypeRecord.fromJS(resultData200) : new SyncResultOfMenuItemSaleTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemSaleTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemTable(date: moment.Moment): Observable<SyncResultOfMenuItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemTable(response: Response): Observable<SyncResultOfMenuItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemRecord.fromJS(resultData200) : new SyncResultOfMenuItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemTranslationTable(date: moment.Moment): Observable<SyncResultOfMenuItemTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemTranslationTable(response: Response): Observable<SyncResultOfMenuItemTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemTranslationRecord.fromJS(resultData200) : new SyncResultOfMenuItemTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncFilesFolder(date: moment.Moment): Observable<SyncResultOfFileRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncFilesFolder?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncFilesFolder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncFilesFolder(response_);
                } catch (e) {
                    return <Observable<SyncResultOfFileRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfFileRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncFilesFolder(response: Response): Observable<SyncResultOfFileRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfFileRecord.fromJS(resultData200) : new SyncResultOfFileRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfFileRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRawMaterialTable(date: moment.Moment): Observable<SyncResultOfRawMaterialRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRawMaterialTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRawMaterialTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRawMaterialTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRawMaterialRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRawMaterialRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRawMaterialTable(response: Response): Observable<SyncResultOfRawMaterialRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRawMaterialRecord.fromJS(resultData200) : new SyncResultOfRawMaterialRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRawMaterialRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRawMaterialTranslationTable(date: moment.Moment): Observable<SyncResultOfRawMaterialTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRawMaterialTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRawMaterialTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRawMaterialTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRawMaterialTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRawMaterialTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRawMaterialTranslationTable(response: Response): Observable<SyncResultOfRawMaterialTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRawMaterialTranslationRecord.fromJS(resultData200) : new SyncResultOfRawMaterialTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRawMaterialTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRawMaterialSupplierTable(date: moment.Moment): Observable<SyncResultOfRawMaterialSupplierRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRawMaterialSupplierTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRawMaterialSupplierTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRawMaterialSupplierTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRawMaterialSupplierRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRawMaterialSupplierRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRawMaterialSupplierTable(response: Response): Observable<SyncResultOfRawMaterialSupplierRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRawMaterialSupplierRecord.fromJS(resultData200) : new SyncResultOfRawMaterialSupplierRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRawMaterialSupplierRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRawMaterialDetailTable(date: moment.Moment): Observable<SyncResultOfRawMaterialDetailRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRawMaterialDetailTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRawMaterialDetailTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRawMaterialDetailTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRawMaterialDetailRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRawMaterialDetailRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRawMaterialDetailTable(response: Response): Observable<SyncResultOfRawMaterialDetailRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRawMaterialDetailRecord.fromJS(resultData200) : new SyncResultOfRawMaterialDetailRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRawMaterialDetailRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncDeviceTable(date: moment.Moment, storeId: number): Observable<SyncResultOfDeviceRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeviceTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeviceTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeviceTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeviceRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeviceRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeviceTable(response: Response): Observable<SyncResultOfDeviceRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeviceRecord.fromJS(resultData200) : new SyncResultOfDeviceRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeviceRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @clusterId (optional) 
     * @ip (optional) 
     * @return Success
     */
    syncDevicesByIPv1(date: moment.Moment, clusterId: number, ip: string): Observable<SyncResultOfDeviceRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDevicesByIPv1?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDevicesByIPv1(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDevicesByIPv1(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeviceRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeviceRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDevicesByIPv1(response: Response): Observable<SyncResultOfDeviceRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeviceRecord.fromJS(resultData200) : new SyncResultOfDeviceRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeviceRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @clusterId (optional) 
     * @ip (optional) 
     * @type (optional) 
     * @return Success
     */
    syncAssets(date: moment.Moment, clusterId: number, ip: string, type: number): Observable<SyncResultOfAssetRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncAssets?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&"; 
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncAssets(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncAssets(response_);
                } catch (e) {
                    return <Observable<SyncResultOfAssetRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfAssetRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncAssets(response: Response): Observable<SyncResultOfAssetRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfAssetRecord.fromJS(resultData200) : new SyncResultOfAssetRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfAssetRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeviceTableTable(date: moment.Moment): Observable<SyncResultOfDeviceTableRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeviceTableTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeviceTableTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeviceTableTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeviceTableRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeviceTableRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeviceTableTable(response: Response): Observable<SyncResultOfDeviceTableRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeviceTableRecord.fromJS(resultData200) : new SyncResultOfDeviceTableRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeviceTableRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeviceCategoryTable(date: moment.Moment): Observable<SyncResultOfDeviceCategoryRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeviceCategoryTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeviceCategoryTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeviceCategoryTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeviceCategoryRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeviceCategoryRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeviceCategoryTable(response: Response): Observable<SyncResultOfDeviceCategoryRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeviceCategoryRecord.fromJS(resultData200) : new SyncResultOfDeviceCategoryRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeviceCategoryRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreTranslationTable(date: moment.Moment): Observable<SyncResultOfStoreTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreTranslationTable(response: Response): Observable<SyncResultOfStoreTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreTranslationRecord.fromJS(resultData200) : new SyncResultOfStoreTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreDevicecsTable(date: moment.Moment): Observable<SyncResultOfStoreDevicecRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreDevicecsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreDevicecsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreDevicecsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreDevicecRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreDevicecRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreDevicecsTable(response: Response): Observable<SyncResultOfStoreDevicecRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreDevicecRecord.fromJS(resultData200) : new SyncResultOfStoreDevicecRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreDevicecRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemDeviceTable(date: moment.Moment): Observable<SyncResultOfMenuItemDeviceRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemDeviceTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemDeviceTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemDeviceTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemDeviceRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemDeviceRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemDeviceTable(response: Response): Observable<SyncResultOfMenuItemDeviceRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemDeviceRecord.fromJS(resultData200) : new SyncResultOfMenuItemDeviceRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemDeviceRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDevicePCTable(date: moment.Moment): Observable<SyncResultOfDevicePCRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDevicePCTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDevicePCTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDevicePCTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDevicePCRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDevicePCRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDevicePCTable(response: Response): Observable<SyncResultOfDevicePCRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDevicePCRecord.fromJS(resultData200) : new SyncResultOfDevicePCRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDevicePCRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPCTable(date: moment.Moment): Observable<SyncResultOfPCRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPCTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPCTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPCTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPCRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPCRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPCTable(response: Response): Observable<SyncResultOfPCRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPCRecord.fromJS(resultData200) : new SyncResultOfPCRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPCRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMaterialStockTable(date: moment.Moment): Observable<SyncResultOfMaterialStockRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMaterialStockTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMaterialStockTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMaterialStockTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMaterialStockRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMaterialStockRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMaterialStockTable(response: Response): Observable<SyncResultOfMaterialStockRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMaterialStockRecord.fromJS(resultData200) : new SyncResultOfMaterialStockRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMaterialStockRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDiscountTypeTable(date: moment.Moment): Observable<SyncResultOfDiscountTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDiscountTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDiscountTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDiscountTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDiscountTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDiscountTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDiscountTypeTable(response: Response): Observable<SyncResultOfDiscountTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDiscountTypeRecord.fromJS(resultData200) : new SyncResultOfDiscountTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDiscountTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDiscountTypeTranslationTable(date: moment.Moment): Observable<SyncResultOfDiscountTypeTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDiscountTypeTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDiscountTypeTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDiscountTypeTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDiscountTypeTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDiscountTypeTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDiscountTypeTranslationTable(response: Response): Observable<SyncResultOfDiscountTypeTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDiscountTypeTranslationRecord.fromJS(resultData200) : new SyncResultOfDiscountTypeTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDiscountTypeTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRecipeTable(date: moment.Moment): Observable<SyncResultOfRecipeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRecipeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRecipeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRecipeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRecipeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRecipeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRecipeTable(response: Response): Observable<SyncResultOfRecipeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRecipeRecord.fromJS(resultData200) : new SyncResultOfRecipeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRecipeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRecipeRawMaterialTable(date: moment.Moment): Observable<SyncResultOfRecipeRawMaterialRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRecipeRawMaterialTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRecipeRawMaterialTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRecipeRawMaterialTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRecipeRawMaterialRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRecipeRawMaterialRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRecipeRawMaterialTable(response: Response): Observable<SyncResultOfRecipeRawMaterialRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRecipeRawMaterialRecord.fromJS(resultData200) : new SyncResultOfRecipeRawMaterialRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRecipeRawMaterialRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRecipeSaleTypeTable(date: moment.Moment): Observable<SyncResultOfRecipeSaleTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRecipeSaleTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRecipeSaleTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRecipeSaleTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRecipeSaleTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRecipeSaleTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRecipeSaleTypeTable(response: Response): Observable<SyncResultOfRecipeSaleTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRecipeSaleTypeRecord.fromJS(resultData200) : new SyncResultOfRecipeSaleTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRecipeSaleTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncComboGroupTable(date: moment.Moment): Observable<SyncResultOfComboGroupRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncComboGroupTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncComboGroupTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncComboGroupTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboGroupRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboGroupRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncComboGroupTable(response: Response): Observable<SyncResultOfComboGroupRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboGroupRecord.fromJS(resultData200) : new SyncResultOfComboGroupRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboGroupRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncComboGroupDetailTable(date: moment.Moment): Observable<SyncResultOfComboGroupDetailRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncComboGroupDetailTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncComboGroupDetailTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncComboGroupDetailTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboGroupDetailRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboGroupDetailRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncComboGroupDetailTable(response: Response): Observable<SyncResultOfComboGroupDetailRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboGroupDetailRecord.fromJS(resultData200) : new SyncResultOfComboGroupDetailRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboGroupDetailRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPriceListComboGroupTable(date: moment.Moment): Observable<SyncResultOfPriceListComboGroupRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPriceListComboGroupTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPriceListComboGroupTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPriceListComboGroupTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPriceListComboGroupRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPriceListComboGroupRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPriceListComboGroupTable(response: Response): Observable<SyncResultOfPriceListComboGroupRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPriceListComboGroupRecord.fromJS(resultData200) : new SyncResultOfPriceListComboGroupRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPriceListComboGroupRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncSaleTypeComboGroupTable(date: moment.Moment): Observable<SyncResultOfSaleTypeComboGroupRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSaleTypeComboGroupTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSaleTypeComboGroupTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSaleTypeComboGroupTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSaleTypeComboGroupRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSaleTypeComboGroupRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSaleTypeComboGroupTable(response: Response): Observable<SyncResultOfSaleTypeComboGroupRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSaleTypeComboGroupRecord.fromJS(resultData200) : new SyncResultOfSaleTypeComboGroupRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSaleTypeComboGroupRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncComboGroupTranslationTable(date: moment.Moment): Observable<SyncResultOfComboGroupTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncComboGroupTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncComboGroupTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncComboGroupTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboGroupTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboGroupTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncComboGroupTranslationTable(response: Response): Observable<SyncResultOfComboGroupTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboGroupTranslationRecord.fromJS(resultData200) : new SyncResultOfComboGroupTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboGroupTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemVariantTable(date: moment.Moment): Observable<SyncResultOfMenuItemVariantRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemVariantTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemVariantTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemVariantTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemVariantRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemVariantRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemVariantTable(response: Response): Observable<SyncResultOfMenuItemVariantRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemVariantRecord.fromJS(resultData200) : new SyncResultOfMenuItemVariantRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemVariantRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemTaxTable(date: moment.Moment): Observable<SyncResultOfMenuItemTaxRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemTaxTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemTaxTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemTaxTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemTaxRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemTaxRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemTaxTable(response: Response): Observable<SyncResultOfMenuItemTaxRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemTaxRecord.fromJS(resultData200) : new SyncResultOfMenuItemTaxRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemTaxRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncVariantValuePriceListTable(date: moment.Moment): Observable<SyncResultOfVariantValuePriceListRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncVariantValuePriceListTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncVariantValuePriceListTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncVariantValuePriceListTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfVariantValuePriceListRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfVariantValuePriceListRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncVariantValuePriceListTable(response: Response): Observable<SyncResultOfVariantValuePriceListRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfVariantValuePriceListRecord.fromJS(resultData200) : new SyncResultOfVariantValuePriceListRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfVariantValuePriceListRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncUserTable(date: moment.Moment): Observable<SyncResultOfUserRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncUserTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUserTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUserTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfUserRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfUserRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncUserTable(response: Response): Observable<SyncResultOfUserRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfUserRecord.fromJS(resultData200) : new SyncResultOfUserRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfUserRecord>(<any>null);
    }

    /**
     * @return Success
     */
    changeLangSetting(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/ChangeLangSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeLangSetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeLangSetting(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processChangeLangSetting(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @userId (optional) 
     * @return Success
     */
    syncPermissionTable(userId: number): Observable<SyncResultOfPermissionRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPermissionTable?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPermissionTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPermissionTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPermissionRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPermissionRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPermissionTable(response: Response): Observable<SyncResultOfPermissionRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPermissionRecord.fromJS(resultData200) : new SyncResultOfPermissionRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPermissionRecord>(<any>null);
    }

    /**
     * @return Success
     */
    syncPluginPermission(): Observable<SyncResultOfPermissionRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPluginPermission";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPluginPermission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPluginPermission(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPermissionRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPermissionRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPluginPermission(response: Response): Observable<SyncResultOfPermissionRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPermissionRecord.fromJS(resultData200) : new SyncResultOfPermissionRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPermissionRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncUserRoleTable(date: moment.Moment): Observable<SyncResultOfUserRoleRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncUserRoleTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUserRoleTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUserRoleTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfUserRoleRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfUserRoleRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncUserRoleTable(response: Response): Observable<SyncResultOfUserRoleRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfUserRoleRecord.fromJS(resultData200) : new SyncResultOfUserRoleRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfUserRoleRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncRoleTable(date: moment.Moment): Observable<SyncResultOfRoleRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncRoleTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncRoleTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncRoleTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfRoleRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfRoleRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncRoleTable(response: Response): Observable<SyncResultOfRoleRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfRoleRecord.fromJS(resultData200) : new SyncResultOfRoleRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfRoleRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCodingPatternSettingsTable(date: moment.Moment): Observable<SyncResultOfCodingPatternSettingsRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCodingPatternSettingsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCodingPatternSettingsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCodingPatternSettingsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCodingPatternSettingsRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCodingPatternSettingsRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCodingPatternSettingsTable(response: Response): Observable<SyncResultOfCodingPatternSettingsRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCodingPatternSettingsRecord.fromJS(resultData200) : new SyncResultOfCodingPatternSettingsRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCodingPatternSettingsRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDiscountTypeCustomersTable(date: moment.Moment): Observable<SyncResultOfDiscountTypeCustomerRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDiscountTypeCustomersTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDiscountTypeCustomersTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDiscountTypeCustomersTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDiscountTypeCustomerRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDiscountTypeCustomerRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDiscountTypeCustomersTable(response: Response): Observable<SyncResultOfDiscountTypeCustomerRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDiscountTypeCustomerRecord.fromJS(resultData200) : new SyncResultOfDiscountTypeCustomerRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDiscountTypeCustomerRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemDiscountTypesTable(date: moment.Moment): Observable<SyncResultOfMenuItemDiscountTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemDiscountTypesTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemDiscountTypesTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemDiscountTypesTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemDiscountTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemDiscountTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemDiscountTypesTable(response: Response): Observable<SyncResultOfMenuItemDiscountTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemDiscountTypeRecord.fromJS(resultData200) : new SyncResultOfMenuItemDiscountTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemDiscountTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductCategoryComboGroupTable(date: moment.Moment): Observable<SyncResultOfProductCategoryComboGroupRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductCategoryComboGroupTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductCategoryComboGroupTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductCategoryComboGroupTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductCategoryComboGroupRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductCategoryComboGroupRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductCategoryComboGroupTable(response: Response): Observable<SyncResultOfProductCategoryComboGroupRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductCategoryComboGroupRecord.fromJS(resultData200) : new SyncResultOfProductCategoryComboGroupRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductCategoryComboGroupRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionTable(date: moment.Moment): Observable<SyncResultOfPromotionRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionTable(response: Response): Observable<SyncResultOfPromotionRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionRecord.fromJS(resultData200) : new SyncResultOfPromotionRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionStoreTable(date: moment.Moment): Observable<SyncResultOfPromotionStoreRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionStoreTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionStoreTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionStoreTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionStoreRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionStoreRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionStoreTable(response: Response): Observable<SyncResultOfPromotionStoreRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionStoreRecord.fromJS(resultData200) : new SyncResultOfPromotionStoreRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionStoreRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionCodeTable(date: moment.Moment): Observable<SyncResultOfPromotionCodeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionCodeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionCodeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionCodeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionCodeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionCodeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionCodeTable(response: Response): Observable<SyncResultOfPromotionCodeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionCodeRecord.fromJS(resultData200) : new SyncResultOfPromotionCodeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionCodeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionDetailsTable(date: moment.Moment): Observable<SyncResultOfPromotionDetailsRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionDetailsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionDetailsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionDetailsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionDetailsRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionDetailsRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionDetailsTable(response: Response): Observable<SyncResultOfPromotionDetailsRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionDetailsRecord.fromJS(resultData200) : new SyncResultOfPromotionDetailsRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionDetailsRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductStorePrices(date: moment.Moment): Observable<SyncResultOfProductStorePriceRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductStorePrices?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductStorePrices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductStorePrices(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductStorePriceRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductStorePriceRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductStorePrices(response: Response): Observable<SyncResultOfProductStorePriceRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductStorePriceRecord.fromJS(resultData200) : new SyncResultOfProductStorePriceRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductStorePriceRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncComboMealDefinitionsTable(date: moment.Moment): Observable<SyncResultOfComboMealDefinitionRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncComboMealDefinitionsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncComboMealDefinitionsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncComboMealDefinitionsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboMealDefinitionRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboMealDefinitionRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncComboMealDefinitionsTable(response: Response): Observable<SyncResultOfComboMealDefinitionRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboMealDefinitionRecord.fromJS(resultData200) : new SyncResultOfComboMealDefinitionRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboMealDefinitionRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    comboMealPackageItemPriceListTable(date: moment.Moment): Observable<SyncResultOfComboMealPackageItemPriceListRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/ComboMealPackageItemPriceListTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComboMealPackageItemPriceListTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComboMealPackageItemPriceListTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboMealPackageItemPriceListRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboMealPackageItemPriceListRecord>><any>Observable.throw(response_);
        });
    }

    protected processComboMealPackageItemPriceListTable(response: Response): Observable<SyncResultOfComboMealPackageItemPriceListRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboMealPackageItemPriceListRecord.fromJS(resultData200) : new SyncResultOfComboMealPackageItemPriceListRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboMealPackageItemPriceListRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    comboMealPackageItemsTable(date: moment.Moment): Observable<SyncResultOfComboMealPackageItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/ComboMealPackageItemsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComboMealPackageItemsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComboMealPackageItemsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboMealPackageItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboMealPackageItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processComboMealPackageItemsTable(response: Response): Observable<SyncResultOfComboMealPackageItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboMealPackageItemRecord.fromJS(resultData200) : new SyncResultOfComboMealPackageItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboMealPackageItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    comboMealPackagesTable(date: moment.Moment): Observable<SyncResultOfComboMealPackageRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/ComboMealPackagesTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComboMealPackagesTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComboMealPackagesTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboMealPackageRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboMealPackageRecord>><any>Observable.throw(response_);
        });
    }

    protected processComboMealPackagesTable(response: Response): Observable<SyncResultOfComboMealPackageRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboMealPackageRecord.fromJS(resultData200) : new SyncResultOfComboMealPackageRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboMealPackageRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    comboMealPackageTranslationsTable(date: moment.Moment): Observable<SyncResultOfComboMealPackageTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/ComboMealPackageTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processComboMealPackageTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processComboMealPackageTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfComboMealPackageTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfComboMealPackageTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processComboMealPackageTranslationsTable(response: Response): Observable<SyncResultOfComboMealPackageTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfComboMealPackageTranslationRecord.fromJS(resultData200) : new SyncResultOfComboMealPackageTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfComboMealPackageTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    saleTypeStoresTable(date: moment.Moment): Observable<SyncResultOfSaleTypeStoreRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SaleTypeStoresTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaleTypeStoresTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaleTypeStoresTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSaleTypeStoreRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSaleTypeStoreRecord>><any>Observable.throw(response_);
        });
    }

    protected processSaleTypeStoresTable(response: Response): Observable<SyncResultOfSaleTypeStoreRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSaleTypeStoreRecord.fromJS(resultData200) : new SyncResultOfSaleTypeStoreRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSaleTypeStoreRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionsFB(date: moment.Moment): Observable<SyncResultOfPromotionsFBRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionsFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionsFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionsFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionsFBRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionsFBRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionsFB(response: Response): Observable<SyncResultOfPromotionsFBRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionsFBRecord.fromJS(resultData200) : new SyncResultOfPromotionsFBRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionsFBRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionFBItem(date: moment.Moment): Observable<SyncResultOfPromotionFBItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionFBItem?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionFBItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionFBItem(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionFBItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionFBItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionFBItem(response: Response): Observable<SyncResultOfPromotionFBItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionFBItemRecord.fromJS(resultData200) : new SyncResultOfPromotionFBItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionFBItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionFBItemExcludedMenuItem(date: moment.Moment): Observable<SyncResultOfPromotionFBItemExcludedMenuItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionFBItemExcludedMenuItem?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionFBItemExcludedMenuItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionFBItemExcludedMenuItem(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionFBItemExcludedMenuItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionFBItemExcludedMenuItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionFBItemExcludedMenuItem(response: Response): Observable<SyncResultOfPromotionFBItemExcludedMenuItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionFBItemExcludedMenuItemRecord.fromJS(resultData200) : new SyncResultOfPromotionFBItemExcludedMenuItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionFBItemExcludedMenuItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionDetailsFB(date: moment.Moment): Observable<SyncResultOfPromotionDetailsFBRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionDetailsFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionDetailsFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionDetailsFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionDetailsFBRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionDetailsFBRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionDetailsFB(response: Response): Observable<SyncResultOfPromotionDetailsFBRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionDetailsFBRecord.fromJS(resultData200) : new SyncResultOfPromotionDetailsFBRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionDetailsFBRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionDetailsFBExcludedMenuItem(date: moment.Moment): Observable<SyncResultOfPromotionDetailsFBExcludedMenuItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionDetailsFBExcludedMenuItem?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionDetailsFBExcludedMenuItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionDetailsFBExcludedMenuItem(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionDetailsFBExcludedMenuItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionDetailsFBExcludedMenuItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionDetailsFBExcludedMenuItem(response: Response): Observable<SyncResultOfPromotionDetailsFBExcludedMenuItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionDetailsFBExcludedMenuItemRecord.fromJS(resultData200) : new SyncResultOfPromotionDetailsFBExcludedMenuItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionDetailsFBExcludedMenuItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionCodesFB(date: moment.Moment): Observable<SyncResultOfPromotionCodesFBRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionCodesFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionCodesFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionCodesFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionCodesFBRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionCodesFBRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionCodesFB(response: Response): Observable<SyncResultOfPromotionCodesFBRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionCodesFBRecord.fromJS(resultData200) : new SyncResultOfPromotionCodesFBRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionCodesFBRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionCodesFBSaleTypes(date: moment.Moment): Observable<SyncResultOfPromotionCodeSalesTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionCodesFBSaleTypes?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionCodesFBSaleTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionCodesFBSaleTypes(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionCodeSalesTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionCodeSalesTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionCodesFBSaleTypes(response: Response): Observable<SyncResultOfPromotionCodeSalesTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionCodeSalesTypeRecord.fromJS(resultData200) : new SyncResultOfPromotionCodeSalesTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionCodeSalesTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductCategoryLevelTable(date: moment.Moment): Observable<SyncResultOfProductCategoryLevelRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductCategoryLevelTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductCategoryLevelTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductCategoryLevelTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductCategoryLevelRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductCategoryLevelRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductCategoryLevelTable(response: Response): Observable<SyncResultOfProductCategoryLevelRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductCategoryLevelRecord.fromJS(resultData200) : new SyncResultOfProductCategoryLevelRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductCategoryLevelRecord>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    syncAllTables(input: ExportDataInput): Observable<ExportDataResult> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncAllTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncAllTables(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncAllTables(response_);
                } catch (e) {
                    return <Observable<ExportDataResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExportDataResult>><any>Observable.throw(response_);
        });
    }

    protected processSyncAllTables(response: Response): Observable<ExportDataResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExportDataResult.fromJS(resultData200) : new ExportDataResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExportDataResult>(<any>null);
    }

    /**
     * @dateConv (optional) 
     * @calendar (optional) 
     * @dateLangCulture (optional) 
     * @return Success
     */
    convertDateCalendar(dateConv: moment.Moment, calendar: string, dateLangCulture: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/ConvertDateCalendar?";
        if (dateConv !== undefined)
            url_ += "DateConv=" + encodeURIComponent(dateConv ? "" + dateConv.toJSON() : "") + "&"; 
        if (calendar !== undefined)
            url_ += "Calendar=" + encodeURIComponent("" + calendar) + "&"; 
        if (dateLangCulture !== undefined)
            url_ += "DateLangCulture=" + encodeURIComponent("" + dateLangCulture) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConvertDateCalendar(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConvertDateCalendar(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processConvertDateCalendar(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getModules(): Observable<TupleOfStringAndStringAndInt32[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetModules(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetModules(response_);
                } catch (e) {
                    return <Observable<TupleOfStringAndStringAndInt32[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TupleOfStringAndStringAndInt32[]>><any>Observable.throw(response_);
        });
    }

    protected processGetModules(response: Response): Observable<TupleOfStringAndStringAndInt32[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TupleOfStringAndStringAndInt32.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TupleOfStringAndStringAndInt32[]>(<any>null);
    }

    /**
     * @since (optional) 
     * @return Success
     */
    getChangedModules(since: moment.Moment): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetChangedModules?";
        if (since !== undefined)
            url_ += "since=" + encodeURIComponent(since ? "" + since.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetChangedModules(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetChangedModules(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetChangedModules(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @lastDate (optional) 
     * @userId (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getBulkSyncPackage(lastDate: moment.Moment, userId: number, storeId: number): Observable<BulkSyncPackage> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetBulkSyncPackage?";
        if (lastDate !== undefined)
            url_ += "LastDate=" + encodeURIComponent(lastDate ? "" + lastDate.toJSON() : "") + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBulkSyncPackage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBulkSyncPackage(response_);
                } catch (e) {
                    return <Observable<BulkSyncPackage>><any>Observable.throw(e);
                }
            } else
                return <Observable<BulkSyncPackage>><any>Observable.throw(response_);
        });
    }

    protected processGetBulkSyncPackage(response: Response): Observable<BulkSyncPackage> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BulkSyncPackage.fromJS(resultData200) : new BulkSyncPackage();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BulkSyncPackage>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    downloadBulkSync(input: BulkSyncInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/DownloadBulkSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadBulkSync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadBulkSync(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadBulkSync(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemTableFB_CallCenter(date: moment.Moment): Observable<SyncResultOfMenuItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemTableFB_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemTableFB_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemTableFB_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemTableFB_CallCenter(response: Response): Observable<SyncResultOfMenuItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemRecord.fromJS(resultData200) : new SyncResultOfMenuItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductCategoryTableFB_CallCenter(date: moment.Moment): Observable<SyncResultOfProductCategoryRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductCategoryTableFB_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductCategoryTableFB_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductCategoryTableFB_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductCategoryRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductCategoryRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductCategoryTableFB_CallCenter(response: Response): Observable<SyncResultOfProductCategoryRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductCategoryRecord.fromJS(resultData200) : new SyncResultOfProductCategoryRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductCategoryRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionsFBTable_CallCenter(date: moment.Moment): Observable<SyncResultOfPromotionsFBRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionsFBTable_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionsFBTable_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionsFBTable_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionsFBRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionsFBRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionsFBTable_CallCenter(response: Response): Observable<SyncResultOfPromotionsFBRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionsFBRecord.fromJS(resultData200) : new SyncResultOfPromotionsFBRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionsFBRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTablesTableFB_CallCenter(date: moment.Moment): Observable<SyncResultOfTableRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTablesTableFB_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTablesTableFB_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTablesTableFB_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTableRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTableRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTablesTableFB_CallCenter(response: Response): Observable<SyncResultOfTableRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTableRecord.fromJS(resultData200) : new SyncResultOfTableRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTableRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCornersTableFB_CallCenter(date: moment.Moment): Observable<SyncResultOfCornerRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCornersTableFB_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCornersTableFB_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCornersTableFB_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCornerRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCornerRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCornersTableFB_CallCenter(response: Response): Observable<SyncResultOfCornerRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCornerRecord.fromJS(resultData200) : new SyncResultOfCornerRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCornerRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCornersTranslationsTableFB_CallCenter(date: moment.Moment): Observable<SyncResultOfCornerTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCornersTranslationsTableFB_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCornersTranslationsTableFB_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCornersTranslationsTableFB_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCornerTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCornerTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCornersTranslationsTableFB_CallCenter(response: Response): Observable<SyncResultOfCornerTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCornerTranslationRecord.fromJS(resultData200) : new SyncResultOfCornerTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCornerTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncUserStores_CallCenter(date: moment.Moment): Observable<SyncResultOfUserStoresRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncUserStores_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUserStores_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUserStores_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfUserStoresRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfUserStoresRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncUserStores_CallCenter(response: Response): Observable<SyncResultOfUserStoresRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfUserStoresRecord.fromJS(resultData200) : new SyncResultOfUserStoresRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfUserStoresRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreShifts_CallCenter(date: moment.Moment): Observable<SyncResultOfStoreShiftsRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreShifts_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreShifts_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreShifts_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreShiftsRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreShiftsRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreShifts_CallCenter(response: Response): Observable<SyncResultOfStoreShiftsRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreShiftsRecord.fromJS(resultData200) : new SyncResultOfStoreShiftsRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreShiftsRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncSupervisorShifts_CallCenter(date: moment.Moment): Observable<SyncResultOfSupervisorShiftsRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSupervisorShifts_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSupervisorShifts_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSupervisorShifts_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSupervisorShiftsRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSupervisorShiftsRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSupervisorShifts_CallCenter(response: Response): Observable<SyncResultOfSupervisorShiftsRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSupervisorShiftsRecord.fromJS(resultData200) : new SyncResultOfSupervisorShiftsRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSupervisorShiftsRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPromotionFBAdditionalFreeItem_CallCenter(date: moment.Moment): Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionFBAdditionalFreeItem_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionFBAdditionalFreeItem_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionFBAdditionalFreeItem_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionFBAdditionalFreeItem_CallCenter(response: Response): Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionFBAdditionalFreeItemRecord.fromJS(resultData200) : new SyncResultOfPromotionFBAdditionalFreeItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionFBAdditionalFreeItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTenderTypeTableFB_CallCenter(date: moment.Moment): Observable<SyncResultOfTenderTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTenderTypeTableFB_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTenderTypeTableFB_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTenderTypeTableFB_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenderTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenderTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTenderTypeTableFB_CallCenter(response: Response): Observable<SyncResultOfTenderTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenderTypeRecord.fromJS(resultData200) : new SyncResultOfTenderTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenderTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreZones_CallCenter(date: moment.Moment): Observable<SyncResultOfStoreZoneRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreZones_CallCenter?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreZones_CallCenter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreZones_CallCenter(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreZoneRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreZoneRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreZones_CallCenter(response: Response): Observable<SyncResultOfStoreZoneRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreZoneRecord.fromJS(resultData200) : new SyncResultOfStoreZoneRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreZoneRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncMenuItemStoresTable(date: moment.Moment): Observable<SyncResultOfMenuItemStoreRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemStoresTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemStoresTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemStoresTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemStoreRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemStoreRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemStoresTable(response: Response): Observable<SyncResultOfMenuItemStoreRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemStoreRecord.fromJS(resultData200) : new SyncResultOfMenuItemStoreRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemStoreRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreProductCategoryConfigsTable(date: moment.Moment): Observable<SyncResultOfProductCategoryConfigRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreProductCategoryConfigsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreProductCategoryConfigsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreProductCategoryConfigsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductCategoryConfigRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductCategoryConfigRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreProductCategoryConfigsTable(response: Response): Observable<SyncResultOfProductCategoryConfigRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductCategoryConfigRecord.fromJS(resultData200) : new SyncResultOfProductCategoryConfigRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductCategoryConfigRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncMenuItemTableFB(date: moment.Moment, storeId: number): Observable<SyncResultOfMenuItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncMenuItemTableFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncMenuItemTableFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncMenuItemTableFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfMenuItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfMenuItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncMenuItemTableFB(response: Response): Observable<SyncResultOfMenuItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfMenuItemRecord.fromJS(resultData200) : new SyncResultOfMenuItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfMenuItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncProductCategoryTableFB(date: moment.Moment, storeId: number): Observable<SyncResultOfProductCategoryRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductCategoryTableFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductCategoryTableFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductCategoryTableFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductCategoryRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductCategoryRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductCategoryTableFB(response: Response): Observable<SyncResultOfProductCategoryRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductCategoryRecord.fromJS(resultData200) : new SyncResultOfProductCategoryRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductCategoryRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncPromotionsFBTable(date: moment.Moment, storeId: number): Observable<SyncResultOfPromotionsFBRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionsFBTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionsFBTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionsFBTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionsFBRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionsFBRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionsFBTable(response: Response): Observable<SyncResultOfPromotionsFBRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionsFBRecord.fromJS(resultData200) : new SyncResultOfPromotionsFBRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionsFBRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncTablesTableFB(date: moment.Moment, storeId: number): Observable<SyncResultOfTableRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTablesTableFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTablesTableFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTablesTableFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTableRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTableRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTablesTableFB(response: Response): Observable<SyncResultOfTableRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTableRecord.fromJS(resultData200) : new SyncResultOfTableRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTableRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncCornersTableFB(date: moment.Moment, storeId: number): Observable<SyncResultOfCornerRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCornersTableFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCornersTableFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCornersTableFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCornerRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCornerRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCornersTableFB(response: Response): Observable<SyncResultOfCornerRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCornerRecord.fromJS(resultData200) : new SyncResultOfCornerRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCornerRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncCornersTranslationsTableFB(date: moment.Moment, storeId: number): Observable<SyncResultOfCornerTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCornersTranslationsTableFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCornersTranslationsTableFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCornersTranslationsTableFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCornerTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCornerTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCornersTranslationsTableFB(response: Response): Observable<SyncResultOfCornerTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCornerTranslationRecord.fromJS(resultData200) : new SyncResultOfCornerTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCornerTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncUserStores(date: moment.Moment, storeId: number): Observable<SyncResultOfUserStoresRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncUserStores?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUserStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUserStores(response_);
                } catch (e) {
                    return <Observable<SyncResultOfUserStoresRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfUserStoresRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncUserStores(response: Response): Observable<SyncResultOfUserStoresRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfUserStoresRecord.fromJS(resultData200) : new SyncResultOfUserStoresRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfUserStoresRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncStoreShifts(date: moment.Moment, storeId: number): Observable<SyncResultOfStoreShiftsRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreShifts?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreShifts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreShifts(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreShiftsRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreShiftsRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreShifts(response: Response): Observable<SyncResultOfStoreShiftsRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreShiftsRecord.fromJS(resultData200) : new SyncResultOfStoreShiftsRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreShiftsRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncSupervisorShifts(date: moment.Moment, storeId: number): Observable<SyncResultOfSupervisorShiftsRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSupervisorShifts?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSupervisorShifts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSupervisorShifts(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSupervisorShiftsRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSupervisorShiftsRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSupervisorShifts(response: Response): Observable<SyncResultOfSupervisorShiftsRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSupervisorShiftsRecord.fromJS(resultData200) : new SyncResultOfSupervisorShiftsRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSupervisorShiftsRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncPromotionFBAdditionalFreeItem(date: moment.Moment, storeId: number): Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPromotionFBAdditionalFreeItem?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPromotionFBAdditionalFreeItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPromotionFBAdditionalFreeItem(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPromotionFBAdditionalFreeItem(response: Response): Observable<SyncResultOfPromotionFBAdditionalFreeItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPromotionFBAdditionalFreeItemRecord.fromJS(resultData200) : new SyncResultOfPromotionFBAdditionalFreeItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPromotionFBAdditionalFreeItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncTenderTypeTableFB(date: moment.Moment, storeId: number): Observable<SyncResultOfTenderTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTenderTypeTableFB?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTenderTypeTableFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTenderTypeTableFB(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenderTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenderTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTenderTypeTableFB(response: Response): Observable<SyncResultOfTenderTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenderTypeRecord.fromJS(resultData200) : new SyncResultOfTenderTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenderTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @clusterId (optional) 
     * @ipAddress (optional) 
     * @return Success
     */
    syncDevicesByIP(date: moment.Moment, clusterId: number, ipAddress: string): Observable<SyncResultOfTenantDeviceRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDevicesByIP?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (ipAddress !== undefined)
            url_ += "ipAddress=" + encodeURIComponent("" + ipAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDevicesByIP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDevicesByIP(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenantDeviceRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenantDeviceRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDevicesByIP(response: Response): Observable<SyncResultOfTenantDeviceRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenantDeviceRecord.fromJS(resultData200) : new SyncResultOfTenantDeviceRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenantDeviceRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncReportGroupTable(date: moment.Moment): Observable<SyncResultOfReportGroupRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncReportGroupTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncReportGroupTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncReportGroupTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfReportGroupRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfReportGroupRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncReportGroupTable(response: Response): Observable<SyncResultOfReportGroupRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfReportGroupRecord.fromJS(resultData200) : new SyncResultOfReportGroupRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfReportGroupRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncReportGroupTranslationTable(date: moment.Moment): Observable<SyncResultOfReportGroupTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncReportGroupTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncReportGroupTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncReportGroupTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfReportGroupTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfReportGroupTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncReportGroupTranslationTable(response: Response): Observable<SyncResultOfReportGroupTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfReportGroupTranslationRecord.fromJS(resultData200) : new SyncResultOfReportGroupTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfReportGroupTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @clusterId (optional) 
     * @ipAddress (optional) 
     * @return Success
     */
    syncChildDevicesByIP(date: moment.Moment, clusterId: number, ipAddress: string): Observable<SyncResultOfTenantDeviceRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncChildDevicesByIP?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (ipAddress !== undefined)
            url_ += "ipAddress=" + encodeURIComponent("" + ipAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncChildDevicesByIP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncChildDevicesByIP(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenantDeviceRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenantDeviceRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncChildDevicesByIP(response: Response): Observable<SyncResultOfTenantDeviceRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenantDeviceRecord.fromJS(resultData200) : new SyncResultOfTenantDeviceRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenantDeviceRecord>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    syncClusterByStoreIdAndTenantId(storeId: number, tenantId: number): Observable<ClusterRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncClusterByStoreIdAndTenantId?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncClusterByStoreIdAndTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncClusterByStoreIdAndTenantId(response_);
                } catch (e) {
                    return <Observable<ClusterRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClusterRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncClusterByStoreIdAndTenantId(response: Response): Observable<ClusterRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClusterRecord.fromJS(resultData200) : new ClusterRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClusterRecord>(<any>null);
    }

    /**
     * @clusterId (optional) 
     * @return Success
     */
    syncReceiptCustomizationByClusterId(clusterId: number): Observable<ReceiptCustomizationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncReceiptCustomizationByClusterId?";
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncReceiptCustomizationByClusterId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncReceiptCustomizationByClusterId(response_);
                } catch (e) {
                    return <Observable<ReceiptCustomizationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReceiptCustomizationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncReceiptCustomizationByClusterId(response: Response): Observable<ReceiptCustomizationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReceiptCustomizationRecord.fromJS(resultData200) : new ReceiptCustomizationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReceiptCustomizationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncUpSalesMenuItems(date: moment.Moment): Observable<SyncResultOfUpSalesMenuItemRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncUpSalesMenuItems?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUpSalesMenuItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUpSalesMenuItems(response_);
                } catch (e) {
                    return <Observable<SyncResultOfUpSalesMenuItemRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfUpSalesMenuItemRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncUpSalesMenuItems(response: Response): Observable<SyncResultOfUpSalesMenuItemRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfUpSalesMenuItemRecord.fromJS(resultData200) : new SyncResultOfUpSalesMenuItemRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfUpSalesMenuItemRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncAttributeTable(date: moment.Moment): Observable<SyncResultOfAttributeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncAttributeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncAttributeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncAttributeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfAttributeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfAttributeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncAttributeTable(response: Response): Observable<SyncResultOfAttributeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfAttributeRecord.fromJS(resultData200) : new SyncResultOfAttributeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfAttributeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncAttributeTranslationTable(date: moment.Moment): Observable<SyncResultOfAttributeTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncAttributeTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncAttributeTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncAttributeTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfAttributeTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfAttributeTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncAttributeTranslationTable(response: Response): Observable<SyncResultOfAttributeTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfAttributeTranslationRecord.fromJS(resultData200) : new SyncResultOfAttributeTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfAttributeTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPrimaryCategoryTable(date: moment.Moment): Observable<SyncResultOfPrimaryCategoryRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPrimaryCategoryTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPrimaryCategoryTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPrimaryCategoryTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPrimaryCategoryRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPrimaryCategoryRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPrimaryCategoryTable(response: Response): Observable<SyncResultOfPrimaryCategoryRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPrimaryCategoryRecord.fromJS(resultData200) : new SyncResultOfPrimaryCategoryRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPrimaryCategoryRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPrimaryCategoryTranslationTable(date: moment.Moment): Observable<SyncResultOfPrimaryCategoryTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPrimaryCategoryTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPrimaryCategoryTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPrimaryCategoryTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPrimaryCategoryTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPrimaryCategoryTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPrimaryCategoryTranslationTable(response: Response): Observable<SyncResultOfPrimaryCategoryTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPrimaryCategoryTranslationRecord.fromJS(resultData200) : new SyncResultOfPrimaryCategoryTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPrimaryCategoryTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncSecondaryCategoryTable(date: moment.Moment): Observable<SyncResultOfSecondaryCategoryRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSecondaryCategoryTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSecondaryCategoryTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSecondaryCategoryTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSecondaryCategoryRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSecondaryCategoryRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSecondaryCategoryTable(response: Response): Observable<SyncResultOfSecondaryCategoryRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSecondaryCategoryRecord.fromJS(resultData200) : new SyncResultOfSecondaryCategoryRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSecondaryCategoryRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncSecondaryCategoryTranslationTable(date: moment.Moment): Observable<SyncResultOfSecondaryCategoryTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSecondaryCategoryTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSecondaryCategoryTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSecondaryCategoryTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSecondaryCategoryTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSecondaryCategoryTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSecondaryCategoryTranslationTable(response: Response): Observable<SyncResultOfSecondaryCategoryTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSecondaryCategoryTranslationRecord.fromJS(resultData200) : new SyncResultOfSecondaryCategoryTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSecondaryCategoryTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductCategoryTable(date: moment.Moment): Observable<SyncResultOfProductCategoryRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductCategoryTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductCategoryTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductCategoryTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductCategoryRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductCategoryRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductCategoryTable(response: Response): Observable<SyncResultOfProductCategoryRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductCategoryRecord.fromJS(resultData200) : new SyncResultOfProductCategoryRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductCategoryRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductCategoryTranslationTable(date: moment.Moment): Observable<SyncResultOfProductCategoryTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductCategoryTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductCategoryTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductCategoryTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductCategoryTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductCategoryTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductCategoryTranslationTable(response: Response): Observable<SyncResultOfProductCategoryTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductCategoryTranslationRecord.fromJS(resultData200) : new SyncResultOfProductCategoryTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductCategoryTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductTable(date: moment.Moment): Observable<SyncResultOfProductRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductTable(response: Response): Observable<SyncResultOfProductRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductRecord.fromJS(resultData200) : new SyncResultOfProductRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncGroupTable(date: moment.Moment): Observable<SyncResultOfGroupRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncGroupTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncGroupTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncGroupTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfGroupRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfGroupRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncGroupTable(response: Response): Observable<SyncResultOfGroupRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfGroupRecord.fromJS(resultData200) : new SyncResultOfGroupRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfGroupRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreGroupConfigTable(date: moment.Moment): Observable<SyncResultOfStoreGroupConfigRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreGroupConfigTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreGroupConfigTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreGroupConfigTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreGroupConfigRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreGroupConfigRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreGroupConfigTable(response: Response): Observable<SyncResultOfStoreGroupConfigRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreGroupConfigRecord.fromJS(resultData200) : new SyncResultOfStoreGroupConfigRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreGroupConfigRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncGroupTranslationTable(date: moment.Moment): Observable<SyncResultOfGroupTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncGroupTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncGroupTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncGroupTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfGroupTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfGroupTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncGroupTranslationTable(response: Response): Observable<SyncResultOfGroupTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfGroupTranslationRecord.fromJS(resultData200) : new SyncResultOfGroupTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfGroupTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncLevelTable(date: moment.Moment): Observable<SyncResultOfLevelRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncLevelTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncLevelTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncLevelTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfLevelRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfLevelRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncLevelTable(response: Response): Observable<SyncResultOfLevelRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfLevelRecord.fromJS(resultData200) : new SyncResultOfLevelRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfLevelRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncLevelTranslationTable(date: moment.Moment): Observable<SyncResultOfLevelTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncLevelTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncLevelTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncLevelTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfLevelTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfLevelTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncLevelTranslationTable(response: Response): Observable<SyncResultOfLevelTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfLevelTranslationRecord.fromJS(resultData200) : new SyncResultOfLevelTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfLevelTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeliveryTable(date: moment.Moment): Observable<SyncResultOfDeliveryRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeliveryTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeliveryTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeliveryTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeliveryRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeliveryRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeliveryTable(response: Response): Observable<SyncResultOfDeliveryRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeliveryRecord.fromJS(resultData200) : new SyncResultOfDeliveryRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeliveryRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeliveryTranslationTable(date: moment.Moment): Observable<SyncResultOfDeliveryTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeliveryTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeliveryTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeliveryTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeliveryTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeliveryTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeliveryTranslationTable(response: Response): Observable<SyncResultOfDeliveryTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeliveryTranslationRecord.fromJS(resultData200) : new SyncResultOfDeliveryTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeliveryTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductTranslationTable(date: moment.Moment): Observable<SyncResultOfProductTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductTranslationTable(response: Response): Observable<SyncResultOfProductTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductTranslationRecord.fromJS(resultData200) : new SyncResultOfProductTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncLanguageTable(date: moment.Moment): Observable<SyncResultOfLanguageRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncLanguageTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncLanguageTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncLanguageTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfLanguageRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfLanguageRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncLanguageTable(response: Response): Observable<SyncResultOfLanguageRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfLanguageRecord.fromJS(resultData200) : new SyncResultOfLanguageRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfLanguageRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncVariantTable(date: moment.Moment): Observable<SyncResultOfVariantRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncVariantTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncVariantTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncVariantTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfVariantRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfVariantRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncVariantTable(response: Response): Observable<SyncResultOfVariantRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfVariantRecord.fromJS(resultData200) : new SyncResultOfVariantRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfVariantRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncVariantTranslationTable(date: moment.Moment): Observable<SyncResultOfVariantTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncVariantTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncVariantTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncVariantTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfVariantTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfVariantTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncVariantTranslationTable(response: Response): Observable<SyncResultOfVariantTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfVariantTranslationRecord.fromJS(resultData200) : new SyncResultOfVariantTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfVariantTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncVariantValueTable(date: moment.Moment): Observable<SyncResultOfVariantValueRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncVariantValueTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncVariantValueTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncVariantValueTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfVariantValueRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfVariantValueRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncVariantValueTable(response: Response): Observable<SyncResultOfVariantValueRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfVariantValueRecord.fromJS(resultData200) : new SyncResultOfVariantValueRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfVariantValueRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncVariantValueTranslationTable(date: moment.Moment): Observable<SyncResultOfVariantValueTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncVariantValueTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncVariantValueTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncVariantValueTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfVariantValueTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfVariantValueTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncVariantValueTranslationTable(response: Response): Observable<SyncResultOfVariantValueTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfVariantValueTranslationRecord.fromJS(resultData200) : new SyncResultOfVariantValueTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfVariantValueTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductVariantTable(date: moment.Moment): Observable<SyncResultOfProductVariantRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductVariantTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductVariantTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductVariantTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductVariantRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductVariantRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductVariantTable(response: Response): Observable<SyncResultOfProductVariantRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductVariantRecord.fromJS(resultData200) : new SyncResultOfProductVariantRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductVariantRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductVariantTranslationTable(date: moment.Moment): Observable<SyncResultOfProductVariantTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductVariantTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductVariantTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductVariantTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductVariantTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductVariantTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductVariantTranslationTable(response: Response): Observable<SyncResultOfProductVariantTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductVariantTranslationRecord.fromJS(resultData200) : new SyncResultOfProductVariantTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductVariantTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncVendorTable(date: moment.Moment): Observable<SyncResultOfVendorRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncVendorTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncVendorTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncVendorTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfVendorRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfVendorRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncVendorTable(response: Response): Observable<SyncResultOfVendorRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfVendorRecord.fromJS(resultData200) : new SyncResultOfVendorRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfVendorRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncVendorTranslationTable(date: moment.Moment): Observable<SyncResultOfVendorTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncVendorTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncVendorTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncVendorTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfVendorTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfVendorTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncVendorTranslationTable(response: Response): Observable<SyncResultOfVendorTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfVendorTranslationRecord.fromJS(resultData200) : new SyncResultOfVendorTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfVendorTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductVendorTable(date: moment.Moment): Observable<SyncResultOfProductVendorRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductVendorTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductVendorTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductVendorTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductVendorRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductVendorRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductVendorTable(response: Response): Observable<SyncResultOfProductVendorRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductVendorRecord.fromJS(resultData200) : new SyncResultOfProductVendorRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductVendorRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductAttributeTable(date: moment.Moment): Observable<SyncResultOfProductAttributeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductAttributeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductAttributeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductAttributeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductAttributeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductAttributeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductAttributeTable(response: Response): Observable<SyncResultOfProductAttributeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductAttributeRecord.fromJS(resultData200) : new SyncResultOfProductAttributeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductAttributeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncUnitOfMeasureTable(date: moment.Moment): Observable<SyncResultOfUnitOfMeasureRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncUnitOfMeasureTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUnitOfMeasureTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUnitOfMeasureTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfUnitOfMeasureRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfUnitOfMeasureRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncUnitOfMeasureTable(response: Response): Observable<SyncResultOfUnitOfMeasureRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfUnitOfMeasureRecord.fromJS(resultData200) : new SyncResultOfUnitOfMeasureRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfUnitOfMeasureRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncUnitOfMeasureTranslationTable(date: moment.Moment): Observable<SyncResultOfUnitOfMeasureTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncUnitOfMeasureTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUnitOfMeasureTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUnitOfMeasureTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfUnitOfMeasureTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfUnitOfMeasureTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncUnitOfMeasureTranslationTable(response: Response): Observable<SyncResultOfUnitOfMeasureTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfUnitOfMeasureTranslationRecord.fromJS(resultData200) : new SyncResultOfUnitOfMeasureTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfUnitOfMeasureTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductUnitOfMeasureConversionTable(date: moment.Moment): Observable<SyncResultOfProductUnitOfMeasureConversionRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductUnitOfMeasureConversionTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductUnitOfMeasureConversionTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductUnitOfMeasureConversionTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductUnitOfMeasureConversionRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductUnitOfMeasureConversionRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductUnitOfMeasureConversionTable(response: Response): Observable<SyncResultOfProductUnitOfMeasureConversionRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductUnitOfMeasureConversionRecord.fromJS(resultData200) : new SyncResultOfProductUnitOfMeasureConversionRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductUnitOfMeasureConversionRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTaxTable(date: moment.Moment): Observable<SyncResultOfTaxRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTaxTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTaxTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTaxTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTaxRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTaxRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTaxTable(response: Response): Observable<SyncResultOfTaxRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTaxRecord.fromJS(resultData200) : new SyncResultOfTaxRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTaxRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTaxTranslationTable(date: moment.Moment): Observable<SyncResultOfTaxTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTaxTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTaxTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTaxTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTaxTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTaxTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTaxTranslationTable(response: Response): Observable<SyncResultOfTaxTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTaxTranslationRecord.fromJS(resultData200) : new SyncResultOfTaxTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTaxTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductTaxTable(date: moment.Moment): Observable<SyncResultOfProductTaxRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductTaxTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductTaxTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductTaxTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductTaxRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductTaxRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductTaxTable(response: Response): Observable<SyncResultOfProductTaxRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductTaxRecord.fromJS(resultData200) : new SyncResultOfProductTaxRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductTaxRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @storeId (optional) 
     * @return Success
     */
    syncProductLotTable(date: moment.Moment, storeId: number): Observable<SyncResultOfProductLotRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductLotTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductLotTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductLotTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductLotRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductLotRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductLotTable(response: Response): Observable<SyncResultOfProductLotRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductLotRecord.fromJS(resultData200) : new SyncResultOfProductLotRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductLotRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCustomerTable(date: moment.Moment): Observable<SyncResultOfCustomerRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCustomerTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCustomerTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCustomerTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCustomerRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCustomerRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCustomerTable(response: Response): Observable<SyncResultOfCustomerRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCustomerRecord.fromJS(resultData200) : new SyncResultOfCustomerRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCustomerRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCustomerSaleTypeTable(date: moment.Moment): Observable<SyncResultOfCustomerSaleTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCustomerSaleTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCustomerSaleTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCustomerSaleTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCustomerSaleTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCustomerSaleTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCustomerSaleTypeTable(response: Response): Observable<SyncResultOfCustomerSaleTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCustomerSaleTypeRecord.fromJS(resultData200) : new SyncResultOfCustomerSaleTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCustomerSaleTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCustomerAddressTable(date: moment.Moment): Observable<SyncResultOfCustomerAddressRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCustomerAddressTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCustomerAddressTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCustomerAddressTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCustomerAddressRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCustomerAddressRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCustomerAddressTable(response: Response): Observable<SyncResultOfCustomerAddressRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCustomerAddressRecord.fromJS(resultData200) : new SyncResultOfCustomerAddressRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCustomerAddressRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncProductSerialTable(date: moment.Moment): Observable<SyncResultOfProductSerialRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncProductSerialTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncProductSerialTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncProductSerialTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfProductSerialRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfProductSerialRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncProductSerialTable(response: Response): Observable<SyncResultOfProductSerialRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfProductSerialRecord.fromJS(resultData200) : new SyncResultOfProductSerialRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfProductSerialRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCurrencyTable(date: moment.Moment): Observable<SyncResultOfCurrencyRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCurrencyTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCurrencyTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCurrencyTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCurrencyRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCurrencyRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCurrencyTable(response: Response): Observable<SyncResultOfCurrencyRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCurrencyRecord.fromJS(resultData200) : new SyncResultOfCurrencyRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCurrencyRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCurrencyTranslationTable(date: moment.Moment): Observable<SyncResultOfCurrencyTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCurrencyTranslationTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCurrencyTranslationTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCurrencyTranslationTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCurrencyTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCurrencyTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCurrencyTranslationTable(response: Response): Observable<SyncResultOfCurrencyTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCurrencyTranslationRecord.fromJS(resultData200) : new SyncResultOfCurrencyTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCurrencyTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTenderTypeTable(date: moment.Moment): Observable<SyncResultOfTenderTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTenderTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTenderTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTenderTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenderTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenderTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTenderTypeTable(response: Response): Observable<SyncResultOfTenderTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenderTypeRecord.fromJS(resultData200) : new SyncResultOfTenderTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenderTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreWorkingHoursRule(date: moment.Moment): Observable<SyncResultOfSyncStoreWorkingHoursRuleRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreWorkingHoursRule?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreWorkingHoursRule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreWorkingHoursRule(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSyncStoreWorkingHoursRuleRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSyncStoreWorkingHoursRuleRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreWorkingHoursRule(response: Response): Observable<SyncResultOfSyncStoreWorkingHoursRuleRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSyncStoreWorkingHoursRuleRecord.fromJS(resultData200) : new SyncResultOfSyncStoreWorkingHoursRuleRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSyncStoreWorkingHoursRuleRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreWorkingHour(date: moment.Moment): Observable<SyncResultOfStoreWorkingHourRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreWorkingHour?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreWorkingHour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreWorkingHour(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreWorkingHourRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreWorkingHourRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreWorkingHour(response: Response): Observable<SyncResultOfStoreWorkingHourRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreWorkingHourRecord.fromJS(resultData200) : new SyncResultOfStoreWorkingHourRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreWorkingHourRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDaysWorkingHours(date: moment.Moment): Observable<SyncResultOfDaysWorkingHourRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDaysWorkingHours?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDaysWorkingHours(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDaysWorkingHours(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDaysWorkingHourRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDaysWorkingHourRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDaysWorkingHours(response: Response): Observable<SyncResultOfDaysWorkingHourRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDaysWorkingHourRecord.fromJS(resultData200) : new SyncResultOfDaysWorkingHourRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDaysWorkingHourRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTenderTypeSaleTypeTable(date: moment.Moment): Observable<SyncResultOfTenderTypeSaleTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTenderTypeSaleTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTenderTypeSaleTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTenderTypeSaleTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenderTypeSaleTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenderTypeSaleTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTenderTypeSaleTypeTable(response: Response): Observable<SyncResultOfTenderTypeSaleTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenderTypeSaleTypeRecord.fromJS(resultData200) : new SyncResultOfTenderTypeSaleTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenderTypeSaleTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTenderTypeMasterTable(date: moment.Moment): Observable<SyncResultOfTenderTypeMasterDto> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTenderTypeMasterTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTenderTypeMasterTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTenderTypeMasterTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenderTypeMasterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenderTypeMasterDto>><any>Observable.throw(response_);
        });
    }

    protected processSyncTenderTypeMasterTable(response: Response): Observable<SyncResultOfTenderTypeMasterDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenderTypeMasterDto.fromJS(resultData200) : new SyncResultOfTenderTypeMasterDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenderTypeMasterDto>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTenderTypeMasterTranslationsTable(date: moment.Moment): Observable<SyncResultOfTenderTypeMasterTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTenderTypeMasterTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTenderTypeMasterTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTenderTypeMasterTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenderTypeMasterTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenderTypeMasterTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTenderTypeMasterTranslationsTable(response: Response): Observable<SyncResultOfTenderTypeMasterTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenderTypeMasterTranslationRecord.fromJS(resultData200) : new SyncResultOfTenderTypeMasterTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenderTypeMasterTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTenderTypeTranslationsTable(date: moment.Moment): Observable<SyncResultOfTenderTypeTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTenderTypeTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTenderTypeTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTenderTypeTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTenderTypeTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTenderTypeTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTenderTypeTranslationsTable(response: Response): Observable<SyncResultOfTenderTypeTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTenderTypeTranslationRecord.fromJS(resultData200) : new SyncResultOfTenderTypeTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTenderTypeTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncOfferTable(date: moment.Moment): Observable<SyncResultOfOfferRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncOfferTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncOfferTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncOfferTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfOfferRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfOfferRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncOfferTable(response: Response): Observable<SyncResultOfOfferRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfOfferRecord.fromJS(resultData200) : new SyncResultOfOfferRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfOfferRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncOfferStoreTable(date: moment.Moment): Observable<SyncResultOfOfferStoreRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncOfferStoreTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncOfferStoreTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncOfferStoreTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfOfferStoreRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfOfferStoreRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncOfferStoreTable(response: Response): Observable<SyncResultOfOfferStoreRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfOfferStoreRecord.fromJS(resultData200) : new SyncResultOfOfferStoreRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfOfferStoreRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncOfferIncludesTable(date: moment.Moment): Observable<SyncResultOfOfferIncludesRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncOfferIncludesTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncOfferIncludesTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncOfferIncludesTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfOfferIncludesRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfOfferIncludesRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncOfferIncludesTable(response: Response): Observable<SyncResultOfOfferIncludesRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfOfferIncludesRecord.fromJS(resultData200) : new SyncResultOfOfferIncludesRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfOfferIncludesRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncOfferDetailsTable(date: moment.Moment): Observable<SyncResultOfOfferDetailsRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncOfferDetailsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncOfferDetailsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncOfferDetailsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfOfferDetailsRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfOfferDetailsRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncOfferDetailsTable(response: Response): Observable<SyncResultOfOfferDetailsRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfOfferDetailsRecord.fromJS(resultData200) : new SyncResultOfOfferDetailsRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfOfferDetailsRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncOfferExcludesTable(date: moment.Moment): Observable<SyncResultOfOfferExcludeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncOfferExcludesTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncOfferExcludesTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncOfferExcludesTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfOfferExcludeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfOfferExcludeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncOfferExcludesTable(response: Response): Observable<SyncResultOfOfferExcludeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfOfferExcludeRecord.fromJS(resultData200) : new SyncResultOfOfferExcludeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfOfferExcludeRecord>(<any>null);
    }

    /**
     * @return Success
     */
    syncCustomProduct(): Observable<CustomProductRecord[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCustomProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCustomProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCustomProduct(response_);
                } catch (e) {
                    return <Observable<CustomProductRecord[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomProductRecord[]>><any>Observable.throw(response_);
        });
    }

    protected processSyncCustomProduct(response: Response): Observable<CustomProductRecord[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CustomProductRecord.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomProductRecord[]>(<any>null);
    }

    /**
     * @return Success
     */
    syncCustomProductTax(): Observable<CustomProductTaxRecord[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCustomProductTax";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCustomProductTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCustomProductTax(response_);
                } catch (e) {
                    return <Observable<CustomProductTaxRecord[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CustomProductTaxRecord[]>><any>Observable.throw(response_);
        });
    }

    protected processSyncCustomProductTax(response: Response): Observable<CustomProductTaxRecord[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CustomProductTaxRecord.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CustomProductTaxRecord[]>(<any>null);
    }

    /**
     * @return Success
     */
    syncScaleSettings(): Observable<ScaleConfigurationDTO> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncScaleSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncScaleSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncScaleSettings(response_);
                } catch (e) {
                    return <Observable<ScaleConfigurationDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ScaleConfigurationDTO>><any>Observable.throw(response_);
        });
    }

    protected processSyncScaleSettings(response: Response): Observable<ScaleConfigurationDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ScaleConfigurationDTO.fromJS(resultData200) : new ScaleConfigurationDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ScaleConfigurationDTO>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPriceListTable(date: moment.Moment): Observable<SyncResultOfPriceListRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPriceListTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPriceListTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPriceListTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPriceListRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPriceListRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPriceListTable(response: Response): Observable<SyncResultOfPriceListRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPriceListRecord.fromJS(resultData200) : new SyncResultOfPriceListRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPriceListRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncPriceListTranslationsTable(date: moment.Moment): Observable<SyncResultOfPriceListTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncPriceListTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPriceListTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPriceListTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfPriceListTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfPriceListTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncPriceListTranslationsTable(response: Response): Observable<SyncResultOfPriceListTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfPriceListTranslationRecord.fromJS(resultData200) : new SyncResultOfPriceListTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfPriceListTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncSaleTypeTable(date: moment.Moment): Observable<SyncResultOfSaleTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSaleTypeTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSaleTypeTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSaleTypeTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSaleTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSaleTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSaleTypeTable(response: Response): Observable<SyncResultOfSaleTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSaleTypeRecord.fromJS(resultData200) : new SyncResultOfSaleTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSaleTypeRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncSaleTypeTranslationsTable(date: moment.Moment): Observable<SyncResultOfSaleTypeTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSaleTypeTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSaleTypeTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSaleTypeTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSaleTypeTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSaleTypeTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSaleTypeTranslationsTable(response: Response): Observable<SyncResultOfSaleTypeTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSaleTypeTranslationRecord.fromJS(resultData200) : new SyncResultOfSaleTypeTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSaleTypeTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @clusterId (optional) 
     * @ipAddress (optional) 
     * @return Success
     */
    syncSaleTypeWithoutExclued(date: moment.Moment, clusterId: number, ipAddress: string): Observable<SyncResultOfSaleTypeRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSaleTypeWithoutExclued?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (ipAddress !== undefined)
            url_ += "IpAddress=" + encodeURIComponent("" + ipAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSaleTypeWithoutExclued(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSaleTypeWithoutExclued(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSaleTypeRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSaleTypeRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSaleTypeWithoutExclued(response: Response): Observable<SyncResultOfSaleTypeRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSaleTypeRecord.fromJS(resultData200) : new SyncResultOfSaleTypeRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSaleTypeRecord>(<any>null);
    }

    /**
     * @clusterId (optional) 
     * @ipAddress (optional) 
     * @return Success
     */
    syncSaleTypecTranslationsWithoutExclued(clusterId: number, ipAddress: string): Observable<SyncResultOfSaleTypeTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncSaleTypecTranslationsWithoutExclued?";
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (ipAddress !== undefined)
            url_ += "IpAddress=" + encodeURIComponent("" + ipAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSaleTypecTranslationsWithoutExclued(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSaleTypecTranslationsWithoutExclued(response_);
                } catch (e) {
                    return <Observable<SyncResultOfSaleTypeTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfSaleTypeTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncSaleTypecTranslationsWithoutExclued(response: Response): Observable<SyncResultOfSaleTypeTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfSaleTypeTranslationRecord.fromJS(resultData200) : new SyncResultOfSaleTypeTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfSaleTypeTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncTablesTable(date: moment.Moment): Observable<SyncResultOfTableRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncTablesTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncTablesTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncTablesTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfTableRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfTableRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncTablesTable(response: Response): Observable<SyncResultOfTableRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfTableRecord.fromJS(resultData200) : new SyncResultOfTableRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfTableRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCornersTable(date: moment.Moment): Observable<SyncResultOfCornerRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCornersTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCornersTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCornersTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCornerRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCornerRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCornersTable(response: Response): Observable<SyncResultOfCornerRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCornerRecord.fromJS(resultData200) : new SyncResultOfCornerRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCornerRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncCornersTranslationsTable(date: moment.Moment): Observable<SyncResultOfCornerTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncCornersTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCornersTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCornersTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfCornerTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfCornerTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncCornersTranslationsTable(response: Response): Observable<SyncResultOfCornerTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfCornerTranslationRecord.fromJS(resultData200) : new SyncResultOfCornerTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfCornerTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeliveryZoneTable(date: moment.Moment): Observable<SyncResultOfDeliveryZoneRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeliveryZoneTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeliveryZoneTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeliveryZoneTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeliveryZoneRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeliveryZoneRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeliveryZoneTable(response: Response): Observable<SyncResultOfDeliveryZoneRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeliveryZoneRecord.fromJS(resultData200) : new SyncResultOfDeliveryZoneRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeliveryZoneRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeliveryZoneTranslationsTable(date: moment.Moment): Observable<SyncResultOfDeliveryZoneTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeliveryZoneTranslationsTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeliveryZoneTranslationsTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeliveryZoneTranslationsTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeliveryZoneTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeliveryZoneTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeliveryZoneTranslationsTable(response: Response): Observable<SyncResultOfDeliveryZoneTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeliveryZoneTranslationRecord.fromJS(resultData200) : new SyncResultOfDeliveryZoneTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeliveryZoneTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncDeliveryStreetTable(date: moment.Moment): Observable<SyncResultOfDeliveryStreetRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncDeliveryStreetTable?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncDeliveryStreetTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncDeliveryStreetTable(response_);
                } catch (e) {
                    return <Observable<SyncResultOfDeliveryStreetRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfDeliveryStreetRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncDeliveryStreetTable(response: Response): Observable<SyncResultOfDeliveryStreetRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfDeliveryStreetRecord.fromJS(resultData200) : new SyncResultOfDeliveryStreetRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfDeliveryStreetRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncHappyHour(date: moment.Moment): Observable<SyncResultOfHappyHourRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncHappyHour?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncHappyHour(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncHappyHour(response_);
                } catch (e) {
                    return <Observable<SyncResultOfHappyHourRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfHappyHourRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncHappyHour(response: Response): Observable<SyncResultOfHappyHourRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfHappyHourRecord.fromJS(resultData200) : new SyncResultOfHappyHourRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfHappyHourRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncHappyHourTranslation(date: moment.Moment): Observable<SyncResultOfHappyHourTranslationRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncHappyHourTranslation?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncHappyHourTranslation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncHappyHourTranslation(response_);
                } catch (e) {
                    return <Observable<SyncResultOfHappyHourTranslationRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfHappyHourTranslationRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncHappyHourTranslation(response: Response): Observable<SyncResultOfHappyHourTranslationRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfHappyHourTranslationRecord.fromJS(resultData200) : new SyncResultOfHappyHourTranslationRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfHappyHourTranslationRecord>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    syncStoreHappyHours(date: moment.Moment): Observable<SyncResultOfStoreHappyHoursRecord> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/SyncStoreHappyHours?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncStoreHappyHours(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncStoreHappyHours(response_);
                } catch (e) {
                    return <Observable<SyncResultOfStoreHappyHoursRecord>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncResultOfStoreHappyHoursRecord>><any>Observable.throw(response_);
        });
    }

    protected processSyncStoreHappyHours(response: Response): Observable<SyncResultOfStoreHappyHoursRecord> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncResultOfStoreHappyHoursRecord.fromJS(resultData200) : new SyncResultOfStoreHappyHoursRecord();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncResultOfStoreHappyHoursRecord>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TableServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    get(id: number): Observable<TableDTO> {
        let url_ = this.baseUrl + "/api/services/app/Table/Get?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(response_);
                } catch (e) {
                    return <Observable<TableDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<TableDTO>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<TableDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TableDTO.fromJS(resultData200) : new TableDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TableDTO>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfTableDTO> {
        let url_ = this.baseUrl + "/api/services/app/Table/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTableDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTableDTO>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<ListResultDtoOfTableDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTableDTO.fromJS(resultData200) : new ListResultDtoOfTableDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTableDTO>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @cornerIds (optional) 
     * @return Success
     */
    getPagedTables(pageNumber: number, pageSize: number, searchKey: string, cornerIds: number[]): Observable<PagedTableList> {
        let url_ = this.baseUrl + "/api/services/app/Table/GetPagedTables?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (cornerIds !== undefined)
            cornerIds && cornerIds.forEach(item => { url_ += "CornerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedTables(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedTables(response_);
                } catch (e) {
                    return <Observable<PagedTableList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedTableList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedTables(response: Response): Observable<PagedTableList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedTableList.fromJS(resultData200) : new PagedTableList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedTableList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    create(input: CreateTableInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Table/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: EditTableInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Table/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Table/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Table/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TaxesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTax(id: number): Observable<TaxDto> {
        let url_ = this.baseUrl + "/api/services/app/Taxes/GetTax?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTax(response_);
                } catch (e) {
                    return <Observable<TaxDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TaxDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTax(response: Response): Observable<TaxDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TaxDto.fromJS(resultData200) : new TaxDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TaxDto>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getTaxes(descending: boolean): Observable<ListResultDtoOfTaxListItem> {
        let url_ = this.baseUrl + "/api/services/app/Taxes/GetTaxes?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaxes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaxes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTaxListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTaxListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetTaxes(response: Response): Observable<ListResultDtoOfTaxListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTaxListItem.fromJS(resultData200) : new ListResultDtoOfTaxListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTaxListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTax(input: CreateTaxInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Taxes/CreateTax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTax(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTax(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTax(input: UpdateTaxInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Taxes/UpdateTax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTax(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTax(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTax(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Taxes/DeleteTax?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTax(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTax(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Taxes/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getChildrenTenants(pageNumber: number, pageSize: number): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetChildrenTenants?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetChildrenTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetChildrenTenants(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetChildrenTenants(response: Response): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantsDDL(): Observable<TenantListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantsDDL";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantsDDL(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantsDDL(response_);
                } catch (e) {
                    return <Observable<TenantListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantsDDL(response: Response): Observable<TenantListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllChildrenTenants(): Observable<ParentChildTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAllChildrenTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllChildrenTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllChildrenTenants(response_);
                } catch (e) {
                    return <Observable<ParentChildTenantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ParentChildTenantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllChildrenTenants(response: Response): Observable<ParentChildTenantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ParentChildTenantListDto.fromJS(resultData200) : new ParentChildTenantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ParentChildTenantListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantStoreGroupLookup(): Observable<TenantListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantStoreGroupLookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantStoreGroupLookup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantStoreGroupLookup(response_);
                } catch (e) {
                    return <Observable<TenantListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantStoreGroupLookup(response: Response): Observable<TenantListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantStoreGroupList(): Observable<TenantListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantStoreGroupList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantStoreGroupList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantStoreGroupList(response_);
                } catch (e) {
                    return <Observable<TenantListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantStoreGroupList(response: Response): Observable<TenantListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantListDto[]>(<any>null);
    }

    /**
     * @regionId (optional) 
     * @return Success
     */
    getTenantStoreGroupListByRegionId(regionId: number): Observable<TenantListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantStoreGroupListByRegionId?";
        if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantStoreGroupListByRegionId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantStoreGroupListByRegionId(response_);
                } catch (e) {
                    return <Observable<TenantListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantStoreGroupListByRegionId(response: Response): Observable<TenantListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantListDto[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @subscriptionEndDateStart (optional) 
     * @subscriptionEndDateEnd (optional) 
     * @creationDateStart (optional) 
     * @creationDateEnd (optional) 
     * @editionId (optional) 
     * @editionIdSpecified (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string, subscriptionEndDateStart: moment.Moment, subscriptionEndDateEnd: moment.Moment, creationDateStart: moment.Moment, creationDateEnd: moment.Moment, editionId: number, editionIdSpecified: boolean, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&"; 
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&"; 
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&"; 
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&"; 
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&"; 
        if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenants(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenants(response: Response): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllTenants(): Observable<TenantListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAllTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllTenants(response_);
                } catch (e) {
                    return <Observable<TenantListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllTenants(response: Response): Observable<TenantListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentTenant(): Observable<TenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetCurrentTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentTenant(response_);
                } catch (e) {
                    return <Observable<TenantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentTenant(response: Response): Observable<TenantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantListDto.fromJS(resultData200) : new TenantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTenant(input: CreateTenantInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createStoreGroup(input: CreateTenantInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateStoreGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateStoreGroup(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateStoreGroup(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cloneTenant(input: EntityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CloneTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCloneTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCloneTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCloneTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    transactionTypeList(tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/TransactionTypeList?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTransactionTypeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTransactionTypeList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransactionTypeList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactionType (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    insertTransactionType(transactionType: TransactionTypeDto, tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/InsertTransactionType?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionType);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTransactionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTransactionType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertTransactionType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantForEdit(response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantForEdit(response: Response): Observable<TenantEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantEditDto.fromJS(resultData200) : new TenantEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenant(input: TenantEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTenant(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantFeaturesForEdit(response: Response): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTenantFeaturesEditOutput.fromJS(resultData200) : new GetTenantFeaturesEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenantFeatures(input: UpdateTenantFeaturesInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenantFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenantFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(input: EntityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetTenantSpecificFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetTenantSpecificFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockTenantAdmin(input: EntityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlockTenantAdmin(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockTenantAdmin(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getConnectionString(): Observable<ConnectionStringResponse> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetConnectionString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetConnectionString(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetConnectionString(response_);
                } catch (e) {
                    return <Observable<ConnectionStringResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<ConnectionStringResponse>><any>Observable.throw(response_);
        });
    }

    protected processGetConnectionString(response: Response): Observable<ConnectionStringResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConnectionStringResponse.fromJS(resultData200) : new ConnectionStringResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ConnectionStringResponse>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTenantPermissionsForEdit(id: number): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantPermissionsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantPermissionsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantPermissionsForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantPermissionsForEdit(response: Response): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenantPermissions(input: UpdateTenantPermissionsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenantPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenantPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenantPermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentTenantInfo(): Observable<TenantInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetCurrentTenantInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentTenantInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentTenantInfo(response_);
                } catch (e) {
                    return <Observable<TenantInfoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantInfoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentTenantInfo(response: Response): Observable<TenantInfoDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantInfoDto.fromJS(resultData200) : new TenantInfoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantInfoDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserType(): Observable<Anonymous2> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetUserType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserType(response_);
                } catch (e) {
                    return <Observable<Anonymous2>><any>Observable.throw(e);
                }
            } else
                return <Observable<Anonymous2>><any>Observable.throw(response_);
        });
    }

    protected processGetUserType(response: Response): Observable<Anonymous2> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<Anonymous2>(<any>null);
    }

    /**
     * @return Success
     */
    getUserEdition(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetUserEdition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserEdition(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetUserEdition(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentCurrency(): Observable<DetailedSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetCurrentCurrency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentCurrency(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentCurrency(response_);
                } catch (e) {
                    return <Observable<DetailedSummaryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailedSummaryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentCurrency(response: Response): Observable<DetailedSummaryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailedSummaryDto.fromJS(resultData200) : new DetailedSummaryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailedSummaryDto>(<any>null);
    }

    /**
     * @salesSummaryDatePeriod (optional) 
     * @periodCount (optional) 
     * @return Success
     */
    getAdminSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod, periodCount: number): Observable<DetailedSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAdminSalesSummary?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        if (periodCount !== undefined)
            url_ += "PeriodCount=" + encodeURIComponent("" + periodCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAdminSalesSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAdminSalesSummary(response_);
                } catch (e) {
                    return <Observable<DetailedSummaryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailedSummaryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAdminSalesSummary(response: Response): Observable<DetailedSummaryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailedSummaryDto.fromJS(resultData200) : new DetailedSummaryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailedSummaryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getYearlyPurchaseAndSales(): Observable<YearlyPurchaseAndsalesDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetYearlyPurchaseAndSales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetYearlyPurchaseAndSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetYearlyPurchaseAndSales(response_);
                } catch (e) {
                    return <Observable<YearlyPurchaseAndsalesDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<YearlyPurchaseAndsalesDto>><any>Observable.throw(response_);
        });
    }

    protected processGetYearlyPurchaseAndSales(response: Response): Observable<YearlyPurchaseAndsalesDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? YearlyPurchaseAndsalesDto.fromJS(resultData200) : new YearlyPurchaseAndsalesDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<YearlyPurchaseAndsalesDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProductsSummary(): Observable<ProductsSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProductsSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductsSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductsSummary(response_);
                } catch (e) {
                    return <Observable<ProductsSummaryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductsSummaryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductsSummary(response: Response): Observable<ProductsSummaryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProductsSummaryDto.fromJS(resultData200) : new ProductsSummaryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductsSummaryDto>(<any>null);
    }

    /**
     * @return Success
     */
    salesManDailySalesDashboard(): Observable<DailySalesDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/SalesManDailySalesDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSalesManDailySalesDashboard(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSalesManDailySalesDashboard(response_);
                } catch (e) {
                    return <Observable<DailySalesDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DailySalesDto>><any>Observable.throw(response_);
        });
    }

    protected processSalesManDailySalesDashboard(response: Response): Observable<DailySalesDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DailySalesDto.fromJS(resultData200) : new DailySalesDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DailySalesDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPieChartData(): Observable<PieChartSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetPieChartData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPieChartData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPieChartData(response_);
                } catch (e) {
                    return <Observable<PieChartSummaryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PieChartSummaryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPieChartData(response: Response): Observable<PieChartSummaryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PieChartSummaryDto.fromJS(resultData200) : new PieChartSummaryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PieChartSummaryDto>(<any>null);
    }

    /**
     * @return Success
     */
    topSellingProducts(): Observable<TopSellingProductsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/TopSellingProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTopSellingProducts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTopSellingProducts(response_);
                } catch (e) {
                    return <Observable<TopSellingProductsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TopSellingProductsDto>><any>Observable.throw(response_);
        });
    }

    protected processTopSellingProducts(response: Response): Observable<TopSellingProductsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TopSellingProductsDto.fromJS(resultData200) : new TopSellingProductsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TopSellingProductsDto>(<any>null);
    }

    /**
     * @return Success
     */
    stockExpiryAlert(): Observable<StoreExpiry[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/StockExpiryAlert";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStockExpiryAlert(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStockExpiryAlert(response_);
                } catch (e) {
                    return <Observable<StoreExpiry[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StoreExpiry[]>><any>Observable.throw(response_);
        });
    }

    protected processStockExpiryAlert(response: Response): Observable<StoreExpiry[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StoreExpiry.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StoreExpiry[]>(<any>null);
    }

    /**
     * @return Success
     */
    productCategory(): Observable<ProductCategories[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/ProductCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductCategory(response_);
                } catch (e) {
                    return <Observable<ProductCategories[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductCategories[]>><any>Observable.throw(response_);
        });
    }

    protected processProductCategory(response: Response): Observable<ProductCategories[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductCategories.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductCategories[]>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @storeId (optional) 
     * @cashierId (optional) 
     * @return Success
     */
    getDashboardAnalytics(startDate: moment.Moment, endDate: moment.Moment, storeId: number, cashierId: number): Observable<DashboardAnalyticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardAnalytics?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (cashierId !== undefined)
            url_ += "CashierId=" + encodeURIComponent("" + cashierId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardAnalytics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardAnalytics(response_);
                } catch (e) {
                    return <Observable<DashboardAnalyticsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DashboardAnalyticsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardAnalytics(response: Response): Observable<DashboardAnalyticsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DashboardAnalyticsOutput.fromJS(resultData200) : new DashboardAnalyticsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DashboardAnalyticsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    productsStockAlert(): Observable<ProductStockAlert[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/ProductsStockAlert";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProductsStockAlert(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProductsStockAlert(response_);
                } catch (e) {
                    return <Observable<ProductStockAlert[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductStockAlert[]>><any>Observable.throw(response_);
        });
    }

    protected processProductsStockAlert(response: Response): Observable<ProductStockAlert[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductStockAlert.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductStockAlert[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantDeviceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantId (optional) 
     * @clusterId (optional) 
     * @return Success
     */
    getTenatSalesTypes(tenantId: number, clusterId: number): Observable<SaleTypeListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetTenatSalesTypes?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenatSalesTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenatSalesTypes(response_);
                } catch (e) {
                    return <Observable<SaleTypeListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaleTypeListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTenatSalesTypes(response: Response): Observable<SaleTypeListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SaleTypeListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaleTypeListItem[]>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @deviceTypes (optional) 
     * @tenantIds (optional) 
     * @return Success
     */
    getPagedTenantDevices(pageNumber: number, pageSize: number, deviceTypes: number[], tenantIds: number[]): Observable<PagedTenantDeviceList> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetPagedTenantDevices?";
        if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (deviceTypes !== undefined)
            deviceTypes && deviceTypes.forEach(item => { url_ += "DeviceTypes=" + encodeURIComponent("" + item) + "&"; });
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedTenantDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedTenantDevices(response_);
                } catch (e) {
                    return <Observable<PagedTenantDeviceList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedTenantDeviceList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedTenantDevices(response: Response): Observable<PagedTenantDeviceList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedTenantDeviceList.fromJS(resultData200) : new PagedTenantDeviceList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedTenantDeviceList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDevice(input: TenatDeviceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/CreateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDevice(input: TenatDeviceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/UpdateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @deviceId (optional) 
     * @return Success
     */
    getDevice(deviceId: number): Observable<TenatDeviceInput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetDevice?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDevice(response_);
                } catch (e) {
                    return <Observable<TenatDeviceInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenatDeviceInput>><any>Observable.throw(response_);
        });
    }

    protected processGetDevice(response: Response): Observable<TenatDeviceInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenatDeviceInput.fromJS(resultData200) : new TenatDeviceInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenatDeviceInput>(<any>null);
    }

    /**
     * @deviceId (optional) 
     * @return Success
     */
    deleteDevice(deviceId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/DeleteDevice?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteDevice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteDevice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteDevice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getClusters(tenantId: number): Observable<ClusterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetClusters?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusters(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusters(response_);
                } catch (e) {
                    return <Observable<ClusterDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClusterDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetClusters(response: Response): Observable<ClusterDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ClusterDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClusterDto[]>(<any>null);
    }

    /**
     * @clusterId (optional) 
     * @deviceType (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getTenantDevicesByClusterId(clusterId: number, deviceType: number, tenantId: number): Observable<TenantDeviceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetTenantDevicesByClusterId?";
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (deviceType !== undefined)
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantDevicesByClusterId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantDevicesByClusterId(response_);
                } catch (e) {
                    return <Observable<TenantDeviceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantDeviceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantDevicesByClusterId(response: Response): Observable<TenantDeviceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantDeviceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantDeviceDto[]>(<any>null);
    }

    /**
     * @deviceType (optional) 
     * @clusterid (optional) 
     * @return Success
     */
    getClusterDevices(deviceType: number, clusterid: number): Observable<TenantDeviceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetClusterDevices?";
        if (deviceType !== undefined)
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&"; 
        if (clusterid !== undefined)
            url_ += "clusterid=" + encodeURIComponent("" + clusterid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterDevices(response_);
                } catch (e) {
                    return <Observable<TenantDeviceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantDeviceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterDevices(response: Response): Observable<TenantDeviceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantDeviceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantDeviceDto[]>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @clusterId (optional) 
     * @return Success
     */
    getParentTenantDevicesByClusterId(tenantId: number, clusterId: number): Observable<TenantDeviceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetParentTenantDevicesByClusterId?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetParentTenantDevicesByClusterId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetParentTenantDevicesByClusterId(response_);
                } catch (e) {
                    return <Observable<TenantDeviceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantDeviceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetParentTenantDevicesByClusterId(response: Response): Observable<TenantDeviceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantDeviceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantDeviceDto[]>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @clusterId (optional) 
     * @return Success
     */
    getParentTenantBuckupDevicesByClusterId(tenantId: number, clusterId: number): Observable<TenantDeviceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetParentTenantBuckupDevicesByClusterId?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetParentTenantBuckupDevicesByClusterId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetParentTenantBuckupDevicesByClusterId(response_);
                } catch (e) {
                    return <Observable<TenantDeviceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantDeviceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetParentTenantBuckupDevicesByClusterId(response: Response): Observable<TenantDeviceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TenantDeviceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantDeviceDto[]>(<any>null);
    }

    /**
     * @storeIds (optional) 
     * @return Success
     */
    getPCDevicesByCluster(storeIds: number[]): Observable<PCDeviceListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetPCDevicesByCluster?";
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPCDevicesByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPCDevicesByCluster(response_);
                } catch (e) {
                    return <Observable<PCDeviceListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PCDeviceListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPCDevicesByCluster(response: Response): Observable<PCDeviceListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PCDeviceListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PCDeviceListItem[]>(<any>null);
    }

    /**
     * @searchIput (optional) 
     * @return Success
     */
    getTenantDevices(searchIput: TenantDeviceSearchInput): Observable<PagedTenantDeviceGroupList> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetTenantDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchIput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantDevices(response_);
                } catch (e) {
                    return <Observable<PagedTenantDeviceGroupList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedTenantDeviceGroupList>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantDevices(response: Response): Observable<PagedTenantDeviceGroupList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedTenantDeviceGroupList.fromJS(resultData200) : new PagedTenantDeviceGroupList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedTenantDeviceGroupList>(<any>null);
    }

    /**
     * @searchIput (optional) 
     * @return Success
     */
    getTenantDevicesHistory(searchIput: TenantDeviceSearchInput): Observable<PagedTenantDeviceHistoryGroupList> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetTenantDevicesHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchIput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantDevicesHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantDevicesHistory(response_);
                } catch (e) {
                    return <Observable<PagedTenantDeviceHistoryGroupList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedTenantDeviceHistoryGroupList>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantDevicesHistory(response: Response): Observable<PagedTenantDeviceHistoryGroupList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedTenantDeviceHistoryGroupList.fromJS(resultData200) : new PagedTenantDeviceHistoryGroupList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedTenantDeviceHistoryGroupList>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @isUpdate (optional) 
     * @return Success
     */
    getPosAppByCluster(storeId: number, isUpdate: boolean): Observable<PCDeviceListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetPosAppByCluster?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (isUpdate !== undefined)
            url_ += "IsUpdate=" + encodeURIComponent("" + isUpdate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPosAppByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPosAppByCluster(response_);
                } catch (e) {
                    return <Observable<PCDeviceListItem[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PCDeviceListItem[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPosAppByCluster(response: Response): Observable<PCDeviceListItem[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PCDeviceListItem.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PCDeviceListItem[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDevicesForCurrntTenant(): Observable<ListResultDtoOfDeviceListItem> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetDevicesForCurrntTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDevicesForCurrntTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDevicesForCurrntTenant(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDeviceListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetDevicesForCurrntTenant(response: Response): Observable<ListResultDtoOfDeviceListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDeviceListItem.fromJS(resultData200) : new ListResultDtoOfDeviceListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDeviceListItem>(<any>null);
    }

    /**
     * @deviceId (optional) 
     * @return Success
     */
    resetMacAddress(deviceId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/ResetMacAddress?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetMacAddress(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetMacAddress(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetMacAddress(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDevice/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerTenant(input: RegisterTenantInput): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterTenant(response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegisterTenant(response: Response): Observable<RegisterTenantOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterTenantOutput.fromJS(resultData200) : new RegisterTenantOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionsForSelect(response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForSelect(response: Response): Observable<EditionsSelectOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionsSelectOutput.fromJS(resultData200) : new EditionsSelectOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditionsSelectOutput>(<any>null);
    }

    /**
     * @editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEdition(response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEdition(response: Response): Observable<EditionSelectDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionSelectDto.fromJS(resultData200) : new EditionSelectDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditionSelectDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantsDataSyncronizationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantsAsyncTables (optional) 
     * @return Success
     */
    startAsyncOne(tenantsAsyncTables: TenantsAsyncTables): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncOne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantsAsyncTables);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncOne(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncOne(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncOne(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    startAsyncAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncAll(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncAll(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    startAsyncDataForSpecificTenant(tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncDataForSpecificTenant?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncDataForSpecificTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncDataForSpecificTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncDataForSpecificTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    startAsyncDataForAllChildreenTenants(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncDataForAllChildreenTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncDataForAllChildreenTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncDataForAllChildreenTenants(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncDataForAllChildreenTenants(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    startAsyncDataForSpecificStoreGroup(tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncDataForSpecificStoreGroup?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncDataForSpecificStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncDataForSpecificStoreGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncDataForSpecificStoreGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    startAsyncAllStoreGroup(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncAllStoreGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncAllStoreGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncAllStoreGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncAllStoreGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    startAsyncDataForAllChildreenStoreGroups(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncDataForAllChildreenStoreGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncDataForAllChildreenStoreGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncDataForAllChildreenStoreGroups(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncDataForAllChildreenStoreGroups(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @syncPageInput (optional) 
     * @return Success
     */
    startAsyncDataForSpecificStoreGroups(syncPageInput: SyncPageInputDto): Observable<SyncronizationResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/StartAsyncDataForSpecificStoreGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncPageInput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStartAsyncDataForSpecificStoreGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStartAsyncDataForSpecificStoreGroups(response_);
                } catch (e) {
                    return <Observable<SyncronizationResponseDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncronizationResponseDto>><any>Observable.throw(response_);
        });
    }

    protected processStartAsyncDataForSpecificStoreGroups(response: Response): Observable<SyncronizationResponseDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SyncronizationResponseDto.fromJS(resultData200) : new SyncronizationResponseDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncronizationResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPagesToSync(): Observable<SyncPageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/GetPagesToSync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagesToSync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagesToSync(response_);
                } catch (e) {
                    return <Observable<SyncPageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SyncPageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPagesToSync(response: Response): Observable<SyncPageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SyncPageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SyncPageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantsDataSyncronization/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: Response): Observable<TenantSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantSettingsEditDto.fromJS(resultData200) : new TenantSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLogo(): Observable<LogoDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLogo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLogo(response_);
                } catch (e) {
                    return <Observable<LogoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LogoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLogo(response: Response): Observable<LogoDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LogoDto.fromJS(resultData200) : new LogoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LogoDto>(<any>null);
    }

    /**
     * @return Success
     */
    getZATCASettingsAsync(): Observable<TenantZATCASettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetZATCASettingsAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetZATCASettingsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetZATCASettingsAsync(response_);
                } catch (e) {
                    return <Observable<TenantZATCASettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantZATCASettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetZATCASettingsAsync(response: Response): Observable<TenantZATCASettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantZATCASettingsEditDto.fromJS(resultData200) : new TenantZATCASettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantZATCASettingsEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: TenantSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearLogo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearLogo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearLogo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearCustomCss(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCustomCss(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    issueSsoTicketAsync(): Observable<IssueSsoTicketOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/IssueSsoTicketAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIssueSsoTicketAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIssueSsoTicketAsync(response_);
                } catch (e) {
                    return <Observable<IssueSsoTicketOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<IssueSsoTicketOutput>><any>Observable.throw(response_);
        });
    }

    protected processIssueSsoTicketAsync(response: Response): Observable<IssueSsoTicketOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IssueSsoTicketOutput.fromJS(resultData200) : new IssueSsoTicketOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IssueSsoTicketOutput>(<any>null);
    }

    /**
     * @contentType (optional) 
     * @contentDisposition (optional) 
     * @headers (optional) 
     * @length (optional) 
     * @name (optional) 
     * @fileName (optional) 
     * @return Success
     */
    image(contentType: string, contentDisposition: string, headers: any, length: number, name: string, fileName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length !== null && length !== undefined)
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantsSyncEngineServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantsSyncEngine/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenantZatcaIntegrationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getTenantZatcaIntegrationByTenantId(tenantId: number): Observable<TenantZatcaIntegrationDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantZatcaIntegration/GetTenantZatcaIntegrationByTenantId?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantZatcaIntegrationByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantZatcaIntegrationByTenantId(response_);
                } catch (e) {
                    return <Observable<TenantZatcaIntegrationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantZatcaIntegrationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantZatcaIntegrationByTenantId(response: Response): Observable<TenantZatcaIntegrationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantZatcaIntegrationDto.fromJS(resultData200) : new TenantZatcaIntegrationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantZatcaIntegrationDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantZatcaIntegration(): Observable<TenantZatcaIntegrationDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantZatcaIntegration/GetTenantZatcaIntegration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantZatcaIntegration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantZatcaIntegration(response_);
                } catch (e) {
                    return <Observable<TenantZatcaIntegrationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantZatcaIntegrationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantZatcaIntegration(response: Response): Observable<TenantZatcaIntegrationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantZatcaIntegrationDto.fromJS(resultData200) : new TenantZatcaIntegrationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantZatcaIntegrationDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateTenantZatcaIntegration(input: TenantZatcaIntegrationDto): Observable<TenantZatcaIntegrationDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantZatcaIntegration/CreateUpdateTenantZatcaIntegration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateTenantZatcaIntegration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateTenantZatcaIntegration(response_);
                } catch (e) {
                    return <Observable<TenantZatcaIntegrationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantZatcaIntegrationDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateTenantZatcaIntegration(response: Response): Observable<TenantZatcaIntegrationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantZatcaIntegrationDto.fromJS(resultData200) : new TenantZatcaIntegrationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantZatcaIntegrationDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantZatcaIntegration/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenderTypeMastersServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTenderType(id: number): Observable<TenderTypeMasterDto> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypeMasters/GetTenderType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenderType(response_);
                } catch (e) {
                    return <Observable<TenderTypeMasterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenderTypeMasterDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenderType(response: Response): Observable<TenderTypeMasterDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenderTypeMasterDto.fromJS(resultData200) : new TenderTypeMasterDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenderTypeMasterDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTenderTypes(): Observable<ListResultDtoOfTenderTypeMasterListItem> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypeMasters/GetTenderTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenderTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenderTypes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTenderTypeMasterListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTenderTypeMasterListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetTenderTypes(response: Response): Observable<ListResultDtoOfTenderTypeMasterListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTenderTypeMasterListItem.fromJS(resultData200) : new ListResultDtoOfTenderTypeMasterListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTenderTypeMasterListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTenderType(input: CreateTenderTypeMasterInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypeMasters/CreateTenderType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTenderType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTenderType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenderType(input: UpdateTenderTypeMasterInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypeMasters/UpdateTenderType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenderType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenderType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTenderType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypeMasters/DeleteTenderType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTenderType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTenderType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypeMasters/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TenderTypesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTenderType(id: number): Observable<TenderTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypes/GetTenderType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenderType(response_);
                } catch (e) {
                    return <Observable<TenderTypeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenderTypeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenderType(response: Response): Observable<TenderTypeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenderTypeDto.fromJS(resultData200) : new TenderTypeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenderTypeDto>(<any>null);
    }

    /**
     * @descending (optional) 
     * @return Success
     */
    getTenderTypes(descending: boolean): Observable<ListResultDtoOfTenderTypeListItem> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypes/GetTenderTypes?";
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenderTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenderTypes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTenderTypeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTenderTypeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetTenderTypes(response: Response): Observable<ListResultDtoOfTenderTypeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTenderTypeListItem.fromJS(resultData200) : new ListResultDtoOfTenderTypeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTenderTypeListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTenderType(input: CreateTenderTypeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypes/CreateTenderType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTenderType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTenderType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenderType(input: UpdateTenderTypeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypes/UpdateTenderType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenderType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenderType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTenderType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypes/DeleteTenderType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTenderType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTenderType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTenderType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenderTypeId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(tenderTypeId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypes/GetStoreGroupsTreeForEdit?";
        if (tenderTypeId !== undefined)
            url_ += "TenderTypeId=" + encodeURIComponent("" + tenderTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenderTypes/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TerminalsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTerminal(id: number): Observable<TerminalDto> {
        let url_ = this.baseUrl + "/api/services/app/Terminals/GetTerminal?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTerminal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTerminal(response_);
                } catch (e) {
                    return <Observable<TerminalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TerminalDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTerminal(response: Response): Observable<TerminalDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TerminalDto.fromJS(resultData200) : new TerminalDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TerminalDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTerminals(): Observable<ListResultDtoOfTerminalListItem> {
        let url_ = this.baseUrl + "/api/services/app/Terminals/GetTerminals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTerminals(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTerminals(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTerminalListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTerminalListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetTerminals(response: Response): Observable<ListResultDtoOfTerminalListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTerminalListItem.fromJS(resultData200) : new ListResultDtoOfTerminalListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTerminalListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTerminal(input: CreateTerminalInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Terminals/CreateTerminal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTerminal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTerminal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTerminal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTerminal(input: UpdateTerminalInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Terminals/UpdateTerminal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTerminal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTerminal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTerminal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTerminal(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Terminals/DeleteTerminal?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTerminal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTerminal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTerminal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Terminals/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ThemeSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTheme(id: number): Observable<ThemeDto> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/GetTheme?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTheme(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTheme(response_);
                } catch (e) {
                    return <Observable<ThemeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ThemeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTheme(response: Response): Observable<ThemeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ThemeDto.fromJS(resultData200) : new ThemeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ThemeDto>(<any>null);
    }

    /**
     * @type (optional) 
     * @return Success
     */
    getThemesByType(type: number): Observable<ListResultDtoOfThemeListItem> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/GetThemesByType?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetThemesByType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetThemesByType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfThemeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfThemeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetThemesByType(response: Response): Observable<ListResultDtoOfThemeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfThemeListItem.fromJS(resultData200) : new ListResultDtoOfThemeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfThemeListItem>(<any>null);
    }

    /**
     * @type (optional) 
     * @tenantIds (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedThemes(type: number, tenantIds: number[], pageNumber: number, pageSize: number): Observable<PagedThemeList> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/GetPagedThemes?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "tenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedThemes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedThemes(response_);
                } catch (e) {
                    return <Observable<PagedThemeList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedThemeList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedThemes(response: Response): Observable<PagedThemeList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedThemeList.fromJS(resultData200) : new PagedThemeList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedThemeList>(<any>null);
    }

    /**
     * @type (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getAllThemes(type: number, tenantId: number): Observable<ThemeListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/GetAllThemes?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllThemes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllThemes(response_);
                } catch (e) {
                    return <Observable<ThemeListItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ThemeListItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllThemes(response: Response): Observable<ThemeListItemDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ThemeListItemDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ThemeListItemDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTheme(input: CreateThemeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/CreateTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTheme(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTheme(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTheme(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTheme(input: UpdateThemeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/UpdateTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTheme(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTheme(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTheme(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTheme(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/DeleteTheme?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTheme(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTheme(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTheme(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    switchActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/SwitchActivate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSwitchActivate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSwitchActivate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSwitchActivate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    uploadFiles(id: number, file: FileParameter): Observable<CreateFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadFiles(response_);
                } catch (e) {
                    return <Observable<CreateFileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateFileDto>><any>Observable.throw(response_);
        });
    }

    protected processUploadFiles(response: Response): Observable<CreateFileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateFileDto.fromJS(resultData200) : new CreateFileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateFileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteFile(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/DeleteFile?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFile(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @themeId (optional) 
     * @return Success
     */
    deleteAllFile(themeId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/DeleteAllFile?";
        if (themeId !== undefined)
            url_ += "themeId=" + encodeURIComponent("" + themeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAllFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAllFile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAllFile(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @deviceName (optional) 
     * @return Success
     */
    getDeviceThemesByDeviceName(deviceName: string): Observable<ThemeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/GetDeviceThemesByDeviceName?";
        if (deviceName !== undefined)
            url_ += "DeviceName=" + encodeURIComponent("" + deviceName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceThemesByDeviceName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceThemesByDeviceName(response_);
                } catch (e) {
                    return <Observable<ThemeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ThemeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceThemesByDeviceName(response: Response): Observable<ThemeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ThemeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ThemeDto[]>(<any>null);
    }

    /**
     * @ipAddress (optional) 
     * @clusterId (optional) 
     * @return Success
     */
    getDeviceThemesByClusterAndIpAddress(ipAddress: string, clusterId: number): Observable<ThemeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/GetDeviceThemesByClusterAndIpAddress?";
        if (ipAddress !== undefined)
            url_ += "ipAddress=" + encodeURIComponent("" + ipAddress) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDeviceThemesByClusterAndIpAddress(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceThemesByClusterAndIpAddress(response_);
                } catch (e) {
                    return <Observable<ThemeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ThemeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceThemesByClusterAndIpAddress(response: Response): Observable<ThemeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ThemeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ThemeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ThemeSettings/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ThirdPartyIntegrationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllNames(): Observable<ListResultDtoOfThirdPartyIntegrationNameDto> {
        let url_ = this.baseUrl + "/api/services/app/ThirdPartyIntegration/GetAllNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllNames(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllNames(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfThirdPartyIntegrationNameDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfThirdPartyIntegrationNameDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllNames(response: Response): Observable<ListResultDtoOfThirdPartyIntegrationNameDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfThirdPartyIntegrationNameDto.fromJS(resultData200) : new ListResultDtoOfThirdPartyIntegrationNameDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfThirdPartyIntegrationNameDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getByTenantId(tenantId: number): Observable<ListResultDtoOfThirdPartyIntegrationDto> {
        let url_ = this.baseUrl + "/api/services/app/ThirdPartyIntegration/GetByTenantId?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetByTenantId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfThirdPartyIntegrationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfThirdPartyIntegrationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetByTenantId(response: Response): Observable<ListResultDtoOfThirdPartyIntegrationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfThirdPartyIntegrationDto.fromJS(resultData200) : new ListResultDtoOfThirdPartyIntegrationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfThirdPartyIntegrationDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdate(input: CreateOrUpdateThirdPartyIntegrationInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThirdPartyIntegration/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ThirdPartyIntegration/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: DefaultTimezoneScope): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimezones(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezones(response: Response): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfNameValueDto.fromJS(resultData200) : new ListResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimezoneComboboxItems(response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezoneComboboxItems(response: Response): Observable<ComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComboboxItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAuthenticate(response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticate(response: Response): Observable<AuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AuthenticateResultModel>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticateByPinCode(model: AuthenticateModel): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateByPinCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticateByPinCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAuthenticateByPinCode(response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticateByPinCode(response: Response): Observable<AuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AuthenticateResultModel>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticateDevices(model: DeviceAuthModel): Observable<DeviceAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticateDevices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAuthenticateDevices(response_);
                } catch (e) {
                    return <Observable<DeviceAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticateDevices(response: Response): Observable<DeviceAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeviceAuthenticateResultModel.fromJS(resultData200) : new DeviceAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceAuthenticateResultModel>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticateDeviceByPinCode(model: DeviceAuthModel): Observable<DeviceAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateDeviceByPinCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticateDeviceByPinCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAuthenticateDeviceByPinCode(response_);
                } catch (e) {
                    return <Observable<DeviceAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticateDeviceByPinCode(response: Response): Observable<DeviceAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeviceAuthenticateResultModel.fromJS(resultData200) : new DeviceAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceAuthenticateResultModel>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @storeId (optional) 
     * @tenderTypeId (optional) 
     * @return Success
     */
    validateAuthentication(tenantId: number, storeId: number, tenderTypeId: number): Observable<ValueTupleOfBooleanAndString> {
        let url_ = this.baseUrl + "/api/TokenAuth/ValidateAuthentication?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        if (tenderTypeId !== undefined)
            url_ += "TenderTypeId=" + encodeURIComponent("" + tenderTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processValidateAuthentication(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processValidateAuthentication(response_);
                } catch (e) {
                    return <Observable<ValueTupleOfBooleanAndString>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValueTupleOfBooleanAndString>><any>Observable.throw(response_);
        });
    }

    protected processValidateAuthentication(response: Response): Observable<ValueTupleOfBooleanAndString> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValueTupleOfBooleanAndString.fromJS(resultData200) : new ValueTupleOfBooleanAndString();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValueTupleOfBooleanAndString>(<any>null);
    }

    /**
     * @ipAddress (optional) 
     * @clusterId (optional) 
     * @tenderTypeId (optional) 
     * @return Success
     */
    validateInstallationInfo(ipAddress: string, clusterId: number, tenderTypeId: number): Observable<ValidationResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/ValidateInstallationInfo?";
        if (ipAddress !== undefined)
            url_ += "IpAddress=" + encodeURIComponent("" + ipAddress) + "&"; 
        if (clusterId !== undefined)
            url_ += "ClusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (tenderTypeId !== undefined)
            url_ += "TenderTypeId=" + encodeURIComponent("" + tenderTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processValidateInstallationInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processValidateInstallationInfo(response_);
                } catch (e) {
                    return <Observable<ValidationResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValidationResult>><any>Observable.throw(response_);
        });
    }

    protected processValidateInstallationInfo(response: Response): Observable<ValidationResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValidationResult.fromJS(resultData200) : new ValidationResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValidationResult>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(model: SendTwoFactorAuthCodeModel): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTwoFactorAuthCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTwoFactorAuthCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImpersonatedAuthenticate(response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processImpersonatedAuthenticate(response: Response): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonatedAuthenticateResultModel.fromJS(resultData200) : new ImpersonatedAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLinkedAccountAuthenticate(response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processLinkedAccountAuthenticate(response: Response): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchedAccountAuthenticateResultModel.fromJS(resultData200) : new SwitchedAccountAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalAuthenticationProviders(response: Response): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExternalAuthenticate(response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processExternalAuthenticate(response: Response): Observable<ExternalAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @message (optional) 
     * @severity (optional) 
     * @return Success
     */
    testNotification(message: string, severity: string): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTestNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTestNotification(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTestNotification(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TransactionsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @sale (optional) 
     * @return Success
     */
    generateEInvoice(sale: TransactionDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GenerateEInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sale);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateEInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateEInvoice(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGenerateEInvoice(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @transactionIds (optional) 
     * @return Success
     */
    synTransactionsToEInvoice(transactionIds: string[]): Observable<TransactionResult[]> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/SynTransactionsToEInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionIds);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSynTransactionsToEInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSynTransactionsToEInvoice(response_);
                } catch (e) {
                    return <Observable<TransactionResult[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionResult[]>><any>Observable.throw(response_);
        });
    }

    protected processSynTransactionsToEInvoice(response: Response): Observable<TransactionResult[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TransactionResult.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionResult[]>(<any>null);
    }

    /**
     * @transactions (optional) 
     * @return Success
     */
    getQuantityProductLotFromBack(transactions: any[]): Observable<TransactionDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetQuantityProductLotFromBack?";
        if (transactions !== undefined)
            transactions && transactions.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "transactions[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetQuantityProductLotFromBack(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetQuantityProductLotFromBack(response_);
                } catch (e) {
                    return <Observable<TransactionDetailDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionDetailDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetQuantityProductLotFromBack(response: Response): Observable<TransactionDetailDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TransactionDetailDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionDetailDto[]>(<any>null);
    }

    /**
     * @transactions (optional) 
     * @return Success
     */
    getQuantityProductLot(transactions: any[]): Observable<TransactionDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetQuantityProductLot?";
        if (transactions !== undefined)
            transactions && transactions.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "transactions[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetQuantityProductLot(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetQuantityProductLot(response_);
                } catch (e) {
                    return <Observable<TransactionDetailDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionDetailDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetQuantityProductLot(response: Response): Observable<TransactionDetailDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TransactionDetailDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionDetailDto[]>(<any>null);
    }

    /**
     * @transaction (optional) 
     * @return Success
     */
    addTransactionFromBack(transaction: TransactionBackDto): Observable<ResponseDtoOfTransactionBackDto> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddTransactionFromBack";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transaction);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddTransactionFromBack(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddTransactionFromBack(response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfTransactionBackDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponseDtoOfTransactionBackDto>><any>Observable.throw(response_);
        });
    }

    protected processAddTransactionFromBack(response: Response): Observable<ResponseDtoOfTransactionBackDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponseDtoOfTransactionBackDto.fromJS(resultData200) : new ResponseDtoOfTransactionBackDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponseDtoOfTransactionBackDto>(<any>null);
    }

    /**
     * @transactions (optional) 
     * @return Success
     */
    addTransactions(transactions: TransactionDto[]): Observable<TransactionResult[]> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactions);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddTransactions(response_);
                } catch (e) {
                    return <Observable<TransactionResult[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionResult[]>><any>Observable.throw(response_);
        });
    }

    protected processAddTransactions(response: Response): Observable<TransactionResult[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TransactionResult.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionResult[]>(<any>null);
    }

    /**
     * @transaction (optional) 
     * @return Success
     */
    addTransaction(transaction: TransactionDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transaction);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddTransaction(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processAddTransaction(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @transactions (optional) 
     * @return Success
     */
    addZatcaSaleTransactions(transactions: TransactionDto): Observable<ZatcaTransactionResult> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddZatcaSaleTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactions);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddZatcaSaleTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddZatcaSaleTransactions(response_);
                } catch (e) {
                    return <Observable<ZatcaTransactionResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaTransactionResult>><any>Observable.throw(response_);
        });
    }

    protected processAddZatcaSaleTransactions(response: Response): Observable<ZatcaTransactionResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaTransactionResult.fromJS(resultData200) : new ZatcaTransactionResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaTransactionResult>(<any>null);
    }

    /**
     * @transaction (optional) 
     * @return Success
     */
    addZatcaTransaction(transaction: TransactionDto): Observable<ZatcaTransactionResult> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddZatcaTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transaction);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddZatcaTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddZatcaTransaction(response_);
                } catch (e) {
                    return <Observable<ZatcaTransactionResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaTransactionResult>><any>Observable.throw(response_);
        });
    }

    protected processAddZatcaTransaction(response: Response): Observable<ZatcaTransactionResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaTransactionResult.fromJS(resultData200) : new ZatcaTransactionResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaTransactionResult>(<any>null);
    }

    /**
     * @receiptNumber (optional) 
     * @return Success
     */
    syncSaleTransactionTable(receiptNumber: string): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/SyncSaleTransactionTable?";
        if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSaleTransactionTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSaleTransactionTable(response_);
                } catch (e) {
                    return <Observable<TransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processSyncSaleTransactionTable(response: Response): Observable<TransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionDto.fromJS(resultData200) : new TransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionDto>(<any>null);
    }

    /**
     * @transaction (optional) 
     * @return Success
     */
    addReturnedSaleTransaction(transaction: SaleTransactionSyncDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddReturnedSaleTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transaction);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddReturnedSaleTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddReturnedSaleTransaction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddReturnedSaleTransaction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactions (optional) 
     * @return Success
     */
    addSaleTransactions(transactions: SaleTransactionSyncDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddSaleTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactions);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddSaleTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddSaleTransactions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddSaleTransactions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactions (optional) 
     * @return Success
     */
    addSaleNotifications(transactions: SaleNotificationSyncDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddSaleNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactions);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddSaleNotifications(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddSaleNotifications(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddSaleNotifications(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transaction (optional) 
     * @return Success
     */
    addSaleTransactionTable(transaction: SalePaymentTransactionsSyncDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddSaleTransactionTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transaction);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddSaleTransactionTable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddSaleTransactionTable(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddSaleTransactionTable(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @salePayments (optional) 
     * @return Success
     */
    addSaleTransactionTables(salePayments: SalePaymentTransactionsSyncDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/AddSaleTransactionTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(salePayments);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddSaleTransactionTables(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddSaleTransactionTables(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddSaleTransactionTables(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @itemCode (optional) 
     * @recieptNumber (optional) 
     * @from (optional) 
     * @to (optional) 
     * @onlyAwaitingMyAction (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getTransactions(itemCode: string, recieptNumber: string, from: moment.Moment, to: moment.Moment, onlyAwaitingMyAction: boolean, pageNumber: number, pageSize: number): Observable<PagedTransactionList> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetTransactions?";
        if (itemCode !== undefined)
            url_ += "ItemCode=" + encodeURIComponent("" + itemCode) + "&"; 
        if (recieptNumber !== undefined)
            url_ += "RecieptNumber=" + encodeURIComponent("" + recieptNumber) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (onlyAwaitingMyAction !== undefined)
            url_ += "OnlyAwaitingMyAction=" + encodeURIComponent("" + onlyAwaitingMyAction) + "&"; 
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactions(response_);
                } catch (e) {
                    return <Observable<PagedTransactionList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedTransactionList>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactions(response: Response): Observable<PagedTransactionList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedTransactionList.fromJS(resultData200) : new PagedTransactionList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedTransactionList>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TransactionTemplateServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTransactionTemplate(): Observable<ListResultDtoOfTransactionTemplateListItem> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/GetTransactionTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionTemplate(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTransactionTemplateListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTransactionTemplateListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionTemplate(response: Response): Observable<ListResultDtoOfTransactionTemplateListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTransactionTemplateListItem.fromJS(resultData200) : new ListResultDtoOfTransactionTemplateListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTransactionTemplateListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTransactionTemplateById(id: number): Observable<TransactionTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/GetTransactionTemplateById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionTemplateById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionTemplateById(response_);
                } catch (e) {
                    return <Observable<TransactionTemplateDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionTemplateDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionTemplateById(response: Response): Observable<TransactionTemplateDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionTemplateDto.fromJS(resultData200) : new TransactionTemplateDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionTemplateDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @storeId (optional) 
     * @return Success
     */
    getTransactionTemplateWithStockQtyById(id: number, storeId: number): Observable<TransactionTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/GetTransactionTemplateWithStockQtyById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionTemplateWithStockQtyById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionTemplateWithStockQtyById(response_);
                } catch (e) {
                    return <Observable<TransactionTemplateDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionTemplateDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionTemplateWithStockQtyById(response: Response): Observable<TransactionTemplateDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionTemplateDto.fromJS(resultData200) : new TransactionTemplateDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionTemplateDto>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @return Success
     */
    getPagedTransactionTemplate(pageNumber: number, pageSize: number): Observable<PagedTransactionTemplateList> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/GetPagedTransactionTemplate?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedTransactionTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedTransactionTemplate(response_);
                } catch (e) {
                    return <Observable<PagedTransactionTemplateList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedTransactionTemplateList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedTransactionTemplate(response: Response): Observable<PagedTransactionTemplateList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedTransactionTemplateList.fromJS(resultData200) : new PagedTransactionTemplateList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedTransactionTemplateList>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTransactionTemplate(input: CreateTransactionTemplateInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/CreateTransactionTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTransactionTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTransactionTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTransactionTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTransactionTemplate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/DeleteTransactionTemplate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTransactionTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTransactionTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTransactionTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatTransactionTemplate(input: EditTransactionTemplateInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/UpdatTransactionTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatTransactionTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatTransactionTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatTransactionTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTemplate/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TransactionTypesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTransactionTypeRole(id: number): Observable<RoleTransactionTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetTransactionTypeRole?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionTypeRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionTypeRole(response_);
                } catch (e) {
                    return <Observable<RoleTransactionTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<RoleTransactionTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionTypeRole(response: Response): Observable<RoleTransactionTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RoleTransactionTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RoleTransactionTypeDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTransactionType(id: number): Observable<TransactionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetTransactionType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionType(response_);
                } catch (e) {
                    return <Observable<TransactionTypeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransactionTypeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionType(response: Response): Observable<TransactionTypeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionTypeDto.fromJS(resultData200) : new TransactionTypeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransactionTypeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTransactionTypes(): Observable<ListResultDtoOfTransactionTypeListItem> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetTransactionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionTypes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTransactionTypeListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTransactionTypeListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionTypes(response: Response): Observable<ListResultDtoOfTransactionTypeListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTransactionTypeListItem.fromJS(resultData200) : new ListResultDtoOfTransactionTypeListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTransactionTypeListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @underRevision (optional) 
     * @return Success
     */
    changeUnderRevision(id: number, underRevision: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/ChangeUnderRevision?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (underRevision !== undefined)
            url_ += "underRevision=" + encodeURIComponent("" + underRevision) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeUnderRevision(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeUnderRevision(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeUnderRevision(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @ids (optional) 
     * @return Success
     */
    changeTransactionRole(id: number, ids: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/ChangeTransactionRole?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeTransactionRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeTransactionRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeTransactionRole(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactionTypeId (optional) 
     * @status (optional) 
     * @return Success
     */
    updateStatusMainTransactionTypeByTransactionTypId(transactionTypeId: number, status: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/UpdateStatusMainTransactionTypeByTransactionTypId?";
        if (transactionTypeId !== undefined)
            url_ += "transactionTypeId=" + encodeURIComponent("" + transactionTypeId) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateStatusMainTransactionTypeByTransactionTypId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateStatusMainTransactionTypeByTransactionTypId(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateStatusMainTransactionTypeByTransactionTypId(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transactionType (optional) 
     * @return Success
     */
    insertTransactionType(transactionType: TransactionTypeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/InsertTransactionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionType);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTransactionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTransactionType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertTransactionType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    transactionTypeList(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/TransactionTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTransactionTypeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTransactionTypeList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransactionTypeList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class TransferMerchantdiseServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getStoreLotNumbers(storeId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/TransferMerchantdise/GetStoreLotNumbers?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreLotNumbers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreLotNumbers(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreLotNumbers(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @lotNumber (optional) 
     * @return Success
     */
    getStoreProductLots(storeId: number, lotNumber: string): Observable<ProductLotLDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/TransferMerchantdise/GetStoreProductLots?";
        if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        if (lotNumber !== undefined)
            url_ += "lotNumber=" + encodeURIComponent("" + lotNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreProductLots(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreProductLots(response_);
                } catch (e) {
                    return <Observable<ProductLotLDetails[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductLotLDetails[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreProductLots(response: Response): Observable<ProductLotLDetails[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductLotLDetails.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductLotLDetails[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    transferMerchantdise(input: TransferMerchantdiseInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransferMerchantdise/TransferMerchantdise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTransferMerchantdise(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTransferMerchantdise(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTransferMerchantdise(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TransferMerchantdise/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<UiCustomizationSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUiManagementSettings(response: Response): Observable<UiCustomizationSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UiCustomizationSettingsEditDto.fromJS(resultData200) : new UiCustomizationSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UiCustomizationSettingsEditDto>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateUiManagementSettings(settings: UiCustomizationSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUiManagementSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(settings: UiCustomizationSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDefaultUiManagementSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUseSystemDefaultSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUseSystemDefaultSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class UnitsOfMeasureServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUnitOfMeasure(id: number): Observable<UnitOfMeasureDto> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/GetUnitOfMeasure?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitOfMeasure(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitOfMeasure(response_);
                } catch (e) {
                    return <Observable<UnitOfMeasureDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitOfMeasureDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitOfMeasure(response: Response): Observable<UnitOfMeasureDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UnitOfMeasureDto.fromJS(resultData200) : new UnitOfMeasureDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitOfMeasureDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitsOfMeasure(): Observable<ListResultDtoOfUnitOfMeasureListItem> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/GetUnitsOfMeasure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitsOfMeasure(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitsOfMeasure(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUnitOfMeasureListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUnitOfMeasureListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitsOfMeasure(response: Response): Observable<ListResultDtoOfUnitOfMeasureListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUnitOfMeasureListItem.fromJS(resultData200) : new ListResultDtoOfUnitOfMeasureListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUnitOfMeasureListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @descending (optional) 
     * @return Success
     */
    getPagedUnitOfMeasureList(pageNumber: number, pageSize: number, descending: boolean): Observable<PagedUnitOfMeasureList> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/GetPagedUnitOfMeasureList?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedUnitOfMeasureList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedUnitOfMeasureList(response_);
                } catch (e) {
                    return <Observable<PagedUnitOfMeasureList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedUnitOfMeasureList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedUnitOfMeasureList(response: Response): Observable<PagedUnitOfMeasureList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedUnitOfMeasureList.fromJS(resultData200) : new PagedUnitOfMeasureList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedUnitOfMeasureList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUnitsOfMeasureByProductId(id: number): Observable<ListResultDtoOfUnitOfMeasureListItem> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/GetUnitsOfMeasureByProductId?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitsOfMeasureByProductId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitsOfMeasureByProductId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUnitOfMeasureListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUnitOfMeasureListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitsOfMeasureByProductId(response: Response): Observable<ListResultDtoOfUnitOfMeasureListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUnitOfMeasureListItem.fromJS(resultData200) : new ListResultDtoOfUnitOfMeasureListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUnitOfMeasureListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUnitsOfMeasureByProductIdHasPurchasesInvoices(id: number): Observable<ListResultDtoOfUnitOfMeasureListItem> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/GetUnitsOfMeasureByProductIdHasPurchasesInvoices?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitsOfMeasureByProductIdHasPurchasesInvoices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitsOfMeasureByProductIdHasPurchasesInvoices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUnitOfMeasureListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUnitOfMeasureListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitsOfMeasureByProductIdHasPurchasesInvoices(response: Response): Observable<ListResultDtoOfUnitOfMeasureListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUnitOfMeasureListItem.fromJS(resultData200) : new ListResultDtoOfUnitOfMeasureListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUnitOfMeasureListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUnitOfMeasure(input: CreateUnitOfMeasureInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/CreateUnitOfMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUnitOfMeasure(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUnitOfMeasure(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUnitOfMeasure(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUnitOfMeasure(input: UpdateUnitOfMeasureInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/UpdateUnitOfMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUnitOfMeasure(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUnitOfMeasure(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUnitOfMeasure(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteUnitOfMeasure(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/DeleteUnitOfMeasure?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteUnitOfMeasure(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteUnitOfMeasure(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUnitOfMeasure(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UnitsOfMeasure/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class UpdateImportDataServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProductsDateUpdateToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UpdateImportData/GetProductsDateUpdateToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductsDateUpdateToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductsDateUpdateToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductsDateUpdateToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @file Upload file.
     * @return Success
     */
    importDateUpdateFromExcel(file: any): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UpdateImportData/ImportDateUpdateFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImportDateUpdateFromExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImportDateUpdateFromExcel(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processImportDateUpdateFromExcel(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UpdateImportData/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @permission (optional) 
     * @role (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string, permission: string, role: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsers(response: Response): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserListDto.fromJS(resultData200) : new PagedResultDtoOfUserListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUsersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUsersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsersToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserForEdit(id: number): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserForEdit(response: Response): Observable<GetUserForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserForEditOutput.fromJS(resultData200) : new GetUserForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserForEditOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserPermissionsForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserPermissionsForEdit(response: Response): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(input: EntityDtoOfInt64): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetUserSpecificPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetUserSpecificPermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUserPermissions(input: UpdateUserPermissionsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUserPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserPermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateUser(input: CreateOrUpdateUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockUser(input: EntityDtoOfInt64): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    linkToUser(input: LinkToUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLinkToUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLinkToUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processLinkToUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number, skipCount: number, sorting: string): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLinkedUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLinkedUsers(response: Response): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLinkedUserDto.fromJS(resultData200) : new PagedResultDtoOfLinkedUserDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentlyUsedLinkedUsers(response: Response): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLinkedUserDto.fromJS(resultData200) : new ListResultDtoOfLinkedUserDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlinkUser(input: UnlinkUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlinkUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlinkUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class UserLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @pagenumber (optional) 
     * @pageSize (optional) 
     * @exportToFile (optional) 
     * @return Success
     */
    pagedUserLogs(input: UserLogInput, pagenumber: number, pageSize: number, exportToFile: boolean): Observable<PagedUserLogList> {
        let url_ = this.baseUrl + "/api/services/app/UserLog/PagedUserLogs?";
        if (pagenumber !== undefined)
            url_ += "pagenumber=" + encodeURIComponent("" + pagenumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (exportToFile !== undefined)
            url_ += "exportToFile=" + encodeURIComponent("" + exportToFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPagedUserLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPagedUserLogs(response_);
                } catch (e) {
                    return <Observable<PagedUserLogList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedUserLogList>><any>Observable.throw(response_);
        });
    }

    protected processPagedUserLogs(response: Response): Observable<PagedUserLogList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedUserLogList.fromJS(resultData200) : new PagedUserLogList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedUserLogList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserLog(id: number): Observable<UserLogDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLog/GetUserLog?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserLog(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserLog(response_);
                } catch (e) {
                    return <Observable<UserLogDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UserLogDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserLog(response: Response): Observable<UserLogDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserLogDto.fromJS(resultData200) : new UserLogDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UserLogDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportUserLogs(tenantId: number, from: moment.Moment, to: moment.Moment, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLog/ExportUserLogs?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportUserLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportUserLogs(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportUserLogs(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UserLog/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecentUserLoginAttempts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentUserLoginAttempts(response: Response): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200) : new ListResultDtoOfUserLoginAttemptDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class VariantsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getVariant(id: number): Observable<VariantDto> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetVariant?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVariant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVariant(response_);
                } catch (e) {
                    return <Observable<VariantDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<VariantDto>><any>Observable.throw(response_);
        });
    }

    protected processGetVariant(response: Response): Observable<VariantDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VariantDto.fromJS(resultData200) : new VariantDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<VariantDto>(<any>null);
    }

    /**
     * @return Success
     */
    getVariants(): Observable<ListResultDtoOfVariantListItem> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetVariants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVariants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVariants(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVariantListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVariantListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetVariants(response: Response): Observable<ListResultDtoOfVariantListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVariantListItem.fromJS(resultData200) : new ListResultDtoOfVariantListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVariantListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getVariantsValue(): Observable<ListResultDtoOfVariantValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetVariantsValue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVariantsValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVariantsValue(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVariantValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVariantValueDto>><any>Observable.throw(response_);
        });
    }

    protected processGetVariantsValue(response: Response): Observable<ListResultDtoOfVariantValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVariantValueDto.fromJS(resultData200) : new ListResultDtoOfVariantValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVariantValueDto>(<any>null);
    }

    /**
     * @variantId (optional) 
     * @return Success
     */
    getCategoryIdsByVariantsIds(variantId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetCategoryIdsByVariantsIds?";
        if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCategoryIdsByVariantsIds(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCategoryIdsByVariantsIds(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCategoryIdsByVariantsIds(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDistinctVariants(): Observable<ListResultDtoOfVariantListItem> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetDistinctVariants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDistinctVariants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDistinctVariants(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVariantListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVariantListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetDistinctVariants(response: Response): Observable<ListResultDtoOfVariantListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVariantListItem.fromJS(resultData200) : new ListResultDtoOfVariantListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVariantListItem>(<any>null);
    }

    /**
     * @categoryId (optional) 
     * @return Success
     */
    getVariantsByCategoryId(categoryId: number): Observable<ListResultDtoOfVariantListItem> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetVariantsByCategoryId?";
        if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVariantsByCategoryId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVariantsByCategoryId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVariantListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVariantListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetVariantsByCategoryId(response: Response): Observable<ListResultDtoOfVariantListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVariantListItem.fromJS(resultData200) : new ListResultDtoOfVariantListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVariantListItem>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createVariant(input: CreateVariantInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/CreateVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateVariant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateVariant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateVariant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createVariantFB(input: CreateVariantInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Variants/CreateVariantFB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateVariantFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateVariantFB(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateVariantFB(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @categoryId (optional) 
     * @variantId (optional) 
     * @menuItemsIds (optional) 
     * @return Success
     */
    updateMenuItemVariantFB(categoryId: number, variantId: number, menuItemsIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/UpdateMenuItemVariantFB?";
        if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menuItemsIds);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMenuItemVariantFB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMenuItemVariantFB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMenuItemVariantFB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @categoryId (optional) 
     * @variantId (optional) 
     * @return Success
     */
    updateMenuItemVariant(categoryId: number, variantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/UpdateMenuItemVariant?";
        if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMenuItemVariant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMenuItemVariant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMenuItemVariant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateVariantRetial(input: UpdateVariantInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/UpdateVariantRetial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateVariantRetial(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateVariantRetial(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateVariantRetial(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateVariant(input: UpdateVariantInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Variants/UpdateVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateVariant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateVariant(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processUpdateVariant(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @variantId (optional) 
     * @return Success
     */
    getVariantValues(variantId: number): Observable<ListResultDtoOfVariantValueListItem> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetVariantValues?";
        if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVariantValues(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVariantValues(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVariantValueListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVariantValueListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetVariantValues(response: Response): Observable<ListResultDtoOfVariantValueListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVariantValueListItem.fromJS(resultData200) : new ListResultDtoOfVariantValueListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVariantValueListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteVariant(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/DeleteVariant?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteVariant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteVariant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteVariant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductVariantsByProductId(id: number): Observable<ListResultDtoOfProductVariantListItem> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetProductVariantsByProductId?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductVariantsByProductId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductVariantsByProductId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductVariantListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductVariantListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductVariantsByProductId(response: Response): Observable<ListResultDtoOfProductVariantListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductVariantListItem.fromJS(resultData200) : new ListResultDtoOfProductVariantListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductVariantListItem>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProductVariantsByProductIdHasPurchasesInvoices(id: number): Observable<ListResultDtoOfProductVariantListItem> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetProductVariantsByProductIdHasPurchasesInvoices?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductVariantsByProductIdHasPurchasesInvoices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductVariantsByProductIdHasPurchasesInvoices(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductVariantListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductVariantListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductVariantsByProductIdHasPurchasesInvoices(response: Response): Observable<ListResultDtoOfProductVariantListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductVariantListItem.fromJS(resultData200) : new ListResultDtoOfProductVariantListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductVariantListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getProductVariants(): Observable<ListResultDtoOfProductVariantListItem> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetProductVariants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductVariants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductVariants(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductVariantListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProductVariantListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetProductVariants(response: Response): Observable<ListResultDtoOfProductVariantListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProductVariantListItem.fromJS(resultData200) : new ListResultDtoOfProductVariantListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProductVariantListItem>(<any>null);
    }

    /**
     * @variantCode (optional) 
     * @menuItems (optional) 
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @isModifier (optional) 
     * @return Success
     */
    getPagedVariantList(variantCode: string, menuItems: number[], pageNumber: number, pageSize: number, isModifier: boolean): Observable<PagedVariantList> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetPagedVariantList?";
        if (variantCode !== undefined)
            url_ += "VariantCode=" + encodeURIComponent("" + variantCode) + "&"; 
        if (menuItems !== undefined)
            menuItems && menuItems.forEach(item => { url_ += "MenuItems=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (isModifier !== undefined)
            url_ += "IsModifier=" + encodeURIComponent("" + isModifier) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedVariantList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedVariantList(response_);
                } catch (e) {
                    return <Observable<PagedVariantList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedVariantList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedVariantList(response: Response): Observable<PagedVariantList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedVariantList.fromJS(resultData200) : new PagedVariantList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedVariantList>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    image(id: number, file: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @variantId (optional) 
     * @return Success
     */
    deleteImage(variantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/DeleteImage?";
        if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @file (optional) 
     * @return Success
     */
    imageVariantValue(id: number, file: FileParameter): Observable<CreateFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Variants/ImageVariantValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImageVariantValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImageVariantValue(response_);
                } catch (e) {
                    return <Observable<CreateFileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateFileDto>><any>Observable.throw(response_);
        });
    }

    protected processImageVariantValue(response: Response): Observable<CreateFileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateFileDto.fromJS(resultData200) : new CreateFileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateFileDto>(<any>null);
    }

    /**
     * @variantValueId (optional) 
     * @return Success
     */
    deleteImageVariantValue(variantValueId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Variants/DeleteImageVariantValue?";
        if (variantValueId !== undefined)
            url_ += "variantValueId=" + encodeURIComponent("" + variantValueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteImageVariantValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteImageVariantValue(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteImageVariantValue(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Variants/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class VendorsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getVendor(id: number): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetVendor?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVendor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVendor(response_);
                } catch (e) {
                    return <Observable<VendorDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<VendorDto>><any>Observable.throw(response_);
        });
    }

    protected processGetVendor(response: Response): Observable<VendorDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VendorDto.fromJS(resultData200) : new VendorDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<VendorDto>(<any>null);
    }

    /**
     * @return Success
     */
    getVendors(): Observable<ListResultDtoOfVendorListItem> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetVendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVendors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVendors(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVendorListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVendorListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetVendors(response: Response): Observable<ListResultDtoOfVendorListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVendorListItem.fromJS(resultData200) : new ListResultDtoOfVendorListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVendorListItem>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getVendorsByStoreId(storeId: number): Observable<ListResultDtoOfVendorListItem> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetVendorsByStoreId?";
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVendorsByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVendorsByStoreId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVendorListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVendorListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetVendorsByStoreId(response: Response): Observable<ListResultDtoOfVendorListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVendorListItem.fromJS(resultData200) : new ListResultDtoOfVendorListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVendorListItem>(<any>null);
    }

    /**
     * @pageNumber (optional) 
     * @pageSize (optional) 
     * @searchKey (optional) 
     * @return Success
     */
    getPagedVendors(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedVendorList> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetPagedVendors?";
        if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPagedVendors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPagedVendors(response_);
                } catch (e) {
                    return <Observable<PagedVendorList>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedVendorList>><any>Observable.throw(response_);
        });
    }

    protected processGetPagedVendors(response: Response): Observable<PagedVendorList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedVendorList.fromJS(resultData200) : new PagedVendorList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedVendorList>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getSelectedVendors(id: number): Observable<ListResultDtoOfVendorListItem> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetSelectedVendors?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSelectedVendors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSelectedVendors(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVendorListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVendorListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetSelectedVendors(response: Response): Observable<ListResultDtoOfVendorListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVendorListItem.fromJS(resultData200) : new ListResultDtoOfVendorListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVendorListItem>(<any>null);
    }

    /**
     * @return Success
     */
    getVendorsAndStores(): Observable<ListResultDtoOfVendorsAndStoresListItem> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetVendorsAndStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVendorsAndStores(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVendorsAndStores(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVendorsAndStoresListItem>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfVendorsAndStoresListItem>><any>Observable.throw(response_);
        });
    }

    protected processGetVendorsAndStores(response: Response): Observable<ListResultDtoOfVendorsAndStoresListItem> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVendorsAndStoresListItem.fromJS(resultData200) : new ListResultDtoOfVendorsAndStoresListItem();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfVendorsAndStoresListItem>(<any>null);
    }

    /**
     * @return Success
     */
    generateCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createVendor(input: CreateVendorInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/CreateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateVendor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateVendor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateVendor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateVendor(input: UpdateVendorInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/UpdateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateVendor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateVendor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateVendor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteVendor(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/DeleteVendor?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteVendor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteVendor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteVendor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @vendorId (optional) 
     * @return Success
     */
    getStoreGroupsTreeForEdit(vendorId: number): Observable<GetStoreGroupsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetStoreGroupsTreeForEdit?";
        if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStoreGroupsTreeForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStoreGroupsTreeForEdit(response_);
                } catch (e) {
                    return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetStoreGroupsTreeForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetStoreGroupsTreeForEdit(response: Response): Observable<GetStoreGroupsTreeForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetStoreGroupsTreeForEditOutput.fromJS(resultData200) : new GetStoreGroupsTreeForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetStoreGroupsTreeForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Vendors/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLatestWebLogs(response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLatestWebLogs(response: Response): Observable<GetLatestWebLogsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLatestWebLogsOutput.fromJS(resultData200) : new GetLatestWebLogsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadWebLogs(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadWebLogs(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class WorkFlowTransctionsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @workFlowType (optional) 
     * @invoice (optional) 
     * @return Success
     */
    createInvoice(workFlowType: WorkFlowType3, invoice: WorkFlowSaleTransactionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkFlowTransctions/CreateInvoice?";
        if (workFlowType !== undefined)
            url_ += "workFlowType=" + encodeURIComponent("" + workFlowType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @invoiceId (optional) 
     * @return Success
     */
    updatWorkFlowTransactionSent(invoiceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkFlowTransctions/UpdatWorkFlowTransactionSent?";
        if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatWorkFlowTransactionSent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatWorkFlowTransactionSent(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatWorkFlowTransactionSent(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/WorkFlowTransctions/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ZatcaCertificateServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @certificate (optional) 
     * @return Success
     */
    createZatcaCertificate(certificate: ZatcaCertificate): Observable<ZatcaCertificate> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaCertificate/CreateZatcaCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(certificate);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateZatcaCertificate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateZatcaCertificate(response_);
                } catch (e) {
                    return <Observable<ZatcaCertificate>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaCertificate>><any>Observable.throw(response_);
        });
    }

    protected processCreateZatcaCertificate(response: Response): Observable<ZatcaCertificate> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaCertificate.fromJS(resultData200) : new ZatcaCertificate();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaCertificate>(<any>null);
    }

    /**
     * @processorId (optional) 
     * @return Success
     */
    getZatcaLastCertificateByProcessorId(processorId: string): Observable<ZatcaCertificate> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaCertificate/GetZatcaLastCertificateByProcessorId?";
        if (processorId !== undefined)
            url_ += "ProcessorId=" + encodeURIComponent("" + processorId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetZatcaLastCertificateByProcessorId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetZatcaLastCertificateByProcessorId(response_);
                } catch (e) {
                    return <Observable<ZatcaCertificate>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaCertificate>><any>Observable.throw(response_);
        });
    }

    protected processGetZatcaLastCertificateByProcessorId(response: Response): Observable<ZatcaCertificate> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaCertificate.fromJS(resultData200) : new ZatcaCertificate();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaCertificate>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getZatcaLastCertificateByStoreId(storeId: number): Observable<ZatcaCertificate> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaCertificate/GetZatcaLastCertificateByStoreId?";
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetZatcaLastCertificateByStoreId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetZatcaLastCertificateByStoreId(response_);
                } catch (e) {
                    return <Observable<ZatcaCertificate>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaCertificate>><any>Observable.throw(response_);
        });
    }

    protected processGetZatcaLastCertificateByStoreId(response: Response): Observable<ZatcaCertificate> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaCertificate.fromJS(resultData200) : new ZatcaCertificate();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaCertificate>(<any>null);
    }

    /**
     * @storeId (optional) 
     * @return Success
     */
    getAllProcessorId(storeId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaCertificate/GetAllProcessorId?";
        if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllProcessorId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllProcessorId(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllProcessorId(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @u (optional) 
     * @return Success
     */
    updateZatcaLastCertificate(u: ZatcaCertificateUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaCertificate/UpdateZatcaLastCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(u);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateZatcaLastCertificate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateZatcaLastCertificate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateZatcaLastCertificate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getZatcaCertificate(id: string): Observable<ZatcaCertificate> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaCertificate/GetZatcaCertificate?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetZatcaCertificate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetZatcaCertificate(response_);
                } catch (e) {
                    return <Observable<ZatcaCertificate>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaCertificate>><any>Observable.throw(response_);
        });
    }

    protected processGetZatcaCertificate(response: Response): Observable<ZatcaCertificate> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaCertificate.fromJS(resultData200) : new ZatcaCertificate();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaCertificate>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaCertificate/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ZatcaIntegrationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    checkIfModeCorrect(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/CheckIfModeCorrect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckIfModeCorrect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIfModeCorrect(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckIfModeCorrect(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @content (optional) 
     * @return Success
     */
    convertQRCOde2Base64String(content: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/ConvertQRCOde2Base64String?";
        if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConvertQRCOde2Base64String(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConvertQRCOde2Base64String(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processConvertQRCOde2Base64String(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @invoice (optional) 
     * @return Success
     */
    createSimplifiedInvoiceXML(invoice: CreateZatcaTransactionInput): Observable<ValueTupleOfResultAndInvoiceTypeCodeAndInt32> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/CreateSimplifiedInvoiceXML";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSimplifiedInvoiceXML(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSimplifiedInvoiceXML(response_);
                } catch (e) {
                    return <Observable<ValueTupleOfResultAndInvoiceTypeCodeAndInt32>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValueTupleOfResultAndInvoiceTypeCodeAndInt32>><any>Observable.throw(response_);
        });
    }

    protected processCreateSimplifiedInvoiceXML(response: Response): Observable<ValueTupleOfResultAndInvoiceTypeCodeAndInt32> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValueTupleOfResultAndInvoiceTypeCodeAndInt32.fromJS(resultData200) : new ValueTupleOfResultAndInvoiceTypeCodeAndInt32();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValueTupleOfResultAndInvoiceTypeCodeAndInt32>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    exportSaleToPDF(id: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/ExportSaleToPDF?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportSaleToPDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportSaleToPDF(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportSaleToPDF(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getById(id: string): Observable<ZatcaTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/GetById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetById(response_);
                } catch (e) {
                    return <Observable<ZatcaTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetById(response: Response): Observable<ZatcaTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaTransactionDto.fromJS(resultData200) : new ZatcaTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLastInvoice(): Observable<ZatcaTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/GetLastInvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLastInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLastInvoice(response_);
                } catch (e) {
                    return <Observable<ZatcaTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLastInvoice(response: Response): Observable<ZatcaTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaTransactionDto.fromJS(resultData200) : new ZatcaTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getZatcaTransactionList(): Observable<GetZatcaTransactionListOutput> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/GetZatcaTransactionList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetZatcaTransactionList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetZatcaTransactionList(response_);
                } catch (e) {
                    return <Observable<GetZatcaTransactionListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetZatcaTransactionListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetZatcaTransactionList(response: Response): Observable<GetZatcaTransactionListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetZatcaTransactionListOutput.fromJS(resultData200) : new GetZatcaTransactionListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetZatcaTransactionListOutput>(<any>null);
    }

    /**
     * @zatcaTransactionDto (optional) 
     * @return Success
     */
    reporting_ClearanceAPI(zatcaTransactionDto: ZatcaTransactionDto): Observable<ValueTupleOfStringAndBoolean> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/Reporting_ClearanceAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zatcaTransactionDto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReporting_ClearanceAPI(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReporting_ClearanceAPI(response_);
                } catch (e) {
                    return <Observable<ValueTupleOfStringAndBoolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValueTupleOfStringAndBoolean>><any>Observable.throw(response_);
        });
    }

    protected processReporting_ClearanceAPI(response: Response): Observable<ValueTupleOfStringAndBoolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValueTupleOfStringAndBoolean.fromJS(resultData200) : new ValueTupleOfStringAndBoolean();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValueTupleOfStringAndBoolean>(<any>null);
    }

    /**
     * @return Success
     */
    newReceiptID(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/NewReceiptID";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processNewReceiptID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processNewReceiptID(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processNewReceiptID(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @zATCATenantSettingsDto (optional) 
     * @return Success
     */
    generateCSIDAsync(zATCATenantSettingsDto: ZATCATenantSettingsDto): Observable<CertificateResponse> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/GenerateCSIDAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zATCATenantSettingsDto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateCSIDAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateCSIDAsync(response_);
                } catch (e) {
                    return <Observable<CertificateResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<CertificateResponse>><any>Observable.throw(response_);
        });
    }

    protected processGenerateCSIDAsync(response: Response): Observable<CertificateResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CertificateResponse.fromJS(resultData200) : new CertificateResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CertificateResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaIntegration/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ZatcaInvoiceArchiveServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadSignedXml(input: UploadZatcaXmlInput): Observable<UploadZatcaXmlOutput> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaInvoiceArchive/UploadSignedXml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadSignedXml(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadSignedXml(response_);
                } catch (e) {
                    return <Observable<UploadZatcaXmlOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadZatcaXmlOutput>><any>Observable.throw(response_);
        });
    }

    protected processUploadSignedXml(response: Response): Observable<UploadZatcaXmlOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UploadZatcaXmlOutput.fromJS(resultData200) : new UploadZatcaXmlOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadZatcaXmlOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaInvoiceArchive/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class ZatcaTransactionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllNotReportedZatcaTransaction(): Observable<ZatcaTransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaTransaction/GetAllNotReportedZatcaTransaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllNotReportedZatcaTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllNotReportedZatcaTransaction(response_);
                } catch (e) {
                    return <Observable<ZatcaTransactionDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaTransactionDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllNotReportedZatcaTransaction(response: Response): Observable<ZatcaTransactionDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ZatcaTransactionDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaTransactionDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    zatcaTransactionPagedList(input: PagedZatcaTransactionResultRequestDto): Observable<ZatcaTransactionPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaTransaction/ZatcaTransactionPagedList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processZatcaTransactionPagedList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processZatcaTransactionPagedList(response_);
                } catch (e) {
                    return <Observable<ZatcaTransactionPagedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ZatcaTransactionPagedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processZatcaTransactionPagedList(response: Response): Observable<ZatcaTransactionPagedResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZatcaTransactionPagedResultDto.fromJS(resultData200) : new ZatcaTransactionPagedResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ZatcaTransactionPagedResultDto>(<any>null);
    }

    /**
     * @tenantIds (optional) 
     * @regionId (optional) 
     * @areaId (optional) 
     * @storeIds (optional) 
     * @fromDate (optional) 
     * @toDate (optional) 
     * @zatcaTransactionStatus (optional) 
     * @zatcaReportingStatus (optional) 
     * @isEndOfDay (optional) 
     * @isCSVFile (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @documentType (optional) 
     * @return Success
     */
    exportZatcaTransactionsReport(tenantIds: number[], regionId: number, areaId: number, storeIds: number[], fromDate: moment.Moment, toDate: moment.Moment, zatcaTransactionStatus: number, zatcaReportingStatus: number, isEndOfDay: boolean, isCSVFile: boolean, sorting: string, skipCount: number, maxResultCount: number, documentType: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaTransaction/ExportZatcaTransactionsReport?";
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&"; 
        if (areaId !== undefined)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (zatcaTransactionStatus !== undefined)
            url_ += "ZatcaTransactionStatus=" + encodeURIComponent("" + zatcaTransactionStatus) + "&"; 
        if (zatcaReportingStatus !== undefined)
            url_ += "ZatcaReportingStatus=" + encodeURIComponent("" + zatcaReportingStatus) + "&"; 
        if (isEndOfDay !== undefined)
            url_ += "IsEndOfDay=" + encodeURIComponent("" + isEndOfDay) + "&"; 
        if (isCSVFile !== undefined)
            url_ += "IsCSVFile=" + encodeURIComponent("" + isCSVFile) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportZatcaTransactionsReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportZatcaTransactionsReport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportZatcaTransactionsReport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @zatcaTransactionId (optional) 
     * @return Success
     */
    reporting_ClearanceAPI(zatcaTransactionId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaTransaction/Reporting_ClearanceAPI?";
        if (zatcaTransactionId !== undefined)
            url_ += "ZatcaTransactionId=" + encodeURIComponent("" + zatcaTransactionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReporting_ClearanceAPI(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReporting_ClearanceAPI(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processReporting_ClearanceAPI(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @zatcaTransactionIds (optional) 
     * @return Success
     */
    reporting_ClearanceAPIALL(zatcaTransactionIds: string[]): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaTransaction/Reporting_ClearanceAPIALL";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zatcaTransactionIds);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReporting_ClearanceAPIALL(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReporting_ClearanceAPIALL(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processReporting_ClearanceAPIALL(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrnetLanguageId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ZatcaTransaction/GetCurrnetLanguageId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrnetLanguageId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrnetLanguageId(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrnetLanguageId(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState;
    tenantId: number;
    serverRootAddress: string;
    isParent: boolean;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
            this.isParent = data["isParent"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        data["isParent"] = this.isParent;
        return data; 
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState;
    tenantId: number;
    serverRootAddress: string;
    isParent: boolean;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId: number;
    resetCode: string;
    password: string;
    returnUrl: string;
    singleSignIn: string;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string;
    password: string;
    returnUrl: string;
    singleSignIn: string;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin: boolean;
    userName: string;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId: number;
    confirmationCode: string;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        return data; 
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId: number;
    userId: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IImpersonateInput {
    tenantId: number;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken: string;
    tenancyName: string;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IImpersonateOutput {
    impersonationToken: string;
    tenancyName: string;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId: number;
    targetUserId: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data; 
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken: string;
    tenancyName: string;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string;
    tenancyName: string;
}

export class ListResultDtoOfApprovalWorkflowListItem implements IListResultDtoOfApprovalWorkflowListItem {
    items: ApprovalWorkflowListItem[];

    constructor(data?: IListResultDtoOfApprovalWorkflowListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApprovalWorkflowListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfApprovalWorkflowListItem {
        let result = new ListResultDtoOfApprovalWorkflowListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfApprovalWorkflowListItem {
    items: ApprovalWorkflowListItem[];
}

export class ApprovalWorkflowListItem implements IApprovalWorkflowListItem {
    id: number;
    transactionType: ApprovalWorkflowListItemTransactionType;
    transactionTypeName: string;
    isConfigured: boolean;
    isEnable: boolean;
    stepsCount: number;

    constructor(data?: IApprovalWorkflowListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.transactionType = data["transactionType"];
            this.transactionTypeName = data["transactionTypeName"];
            this.isConfigured = data["isConfigured"];
            this.isEnable = data["isEnable"];
            this.stepsCount = data["stepsCount"];
        }
    }

    static fromJS(data: any): ApprovalWorkflowListItem {
        let result = new ApprovalWorkflowListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionType"] = this.transactionType;
        data["transactionTypeName"] = this.transactionTypeName;
        data["isConfigured"] = this.isConfigured;
        data["isEnable"] = this.isEnable;
        data["stepsCount"] = this.stepsCount;
        return data; 
    }
}

export interface IApprovalWorkflowListItem {
    id: number;
    transactionType: ApprovalWorkflowListItemTransactionType;
    transactionTypeName: string;
    isConfigured: boolean;
    isEnable: boolean;
    stepsCount: number;
}

export class ApprovalWorkflowDto implements IApprovalWorkflowDto {
    id: number;
    transactionType: ApprovalWorkflowDtoTransactionType;
    transactionTypeName: string;
    isEnable: boolean;
    steps: ApprovalWorkflowStepDto[];

    constructor(data?: IApprovalWorkflowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.transactionType = data["transactionType"];
            this.transactionTypeName = data["transactionTypeName"];
            this.isEnable = data["isEnable"];
            if (data["steps"] && data["steps"].constructor === Array) {
                this.steps = [];
                for (let item of data["steps"])
                    this.steps.push(ApprovalWorkflowStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalWorkflowDto {
        let result = new ApprovalWorkflowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionType"] = this.transactionType;
        data["transactionTypeName"] = this.transactionTypeName;
        data["isEnable"] = this.isEnable;
        if (this.steps && this.steps.constructor === Array) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApprovalWorkflowDto {
    id: number;
    transactionType: ApprovalWorkflowDtoTransactionType;
    transactionTypeName: string;
    isEnable: boolean;
    steps: ApprovalWorkflowStepDto[];
}

export class ApprovalWorkflowStepDto implements IApprovalWorkflowStepDto {
    id: number;
    stepOrder: number;
    roleIds: number[];
    roleNames: string[];
    isTransactionEditable: boolean;
    canReturn: boolean;
    canReject: boolean;
    isCommentRequiredOnReturn: boolean;
    isCommentRequiredOnReject: boolean;
    name: string;
    translations: ApprovalWorkflowStepTranslationDto[];

    constructor(data?: IApprovalWorkflowStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.stepOrder = data["stepOrder"];
            if (data["roleIds"] && data["roleIds"].constructor === Array) {
                this.roleIds = [];
                for (let item of data["roleIds"])
                    this.roleIds.push(item);
            }
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [];
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.isTransactionEditable = data["isTransactionEditable"];
            this.canReturn = data["canReturn"];
            this.canReject = data["canReject"];
            this.isCommentRequiredOnReturn = data["isCommentRequiredOnReturn"];
            this.isCommentRequiredOnReject = data["isCommentRequiredOnReject"];
            this.name = data["name"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ApprovalWorkflowStepTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalWorkflowStepDto {
        let result = new ApprovalWorkflowStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepOrder"] = this.stepOrder;
        if (this.roleIds && this.roleIds.constructor === Array) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["isTransactionEditable"] = this.isTransactionEditable;
        data["canReturn"] = this.canReturn;
        data["canReject"] = this.canReject;
        data["isCommentRequiredOnReturn"] = this.isCommentRequiredOnReturn;
        data["isCommentRequiredOnReject"] = this.isCommentRequiredOnReject;
        data["name"] = this.name;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApprovalWorkflowStepDto {
    id: number;
    stepOrder: number;
    roleIds: number[];
    roleNames: string[];
    isTransactionEditable: boolean;
    canReturn: boolean;
    canReject: boolean;
    isCommentRequiredOnReturn: boolean;
    isCommentRequiredOnReject: boolean;
    name: string;
    translations: ApprovalWorkflowStepTranslationDto[];
}

export class ApprovalWorkflowStepTranslationDto implements IApprovalWorkflowStepTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IApprovalWorkflowStepTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ApprovalWorkflowStepTranslationDto {
        let result = new ApprovalWorkflowStepTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IApprovalWorkflowStepTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfApprovalWorkflowRoleLookupDto implements IListResultDtoOfApprovalWorkflowRoleLookupDto {
    items: ApprovalWorkflowRoleLookupDto[];

    constructor(data?: IListResultDtoOfApprovalWorkflowRoleLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApprovalWorkflowRoleLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfApprovalWorkflowRoleLookupDto {
        let result = new ListResultDtoOfApprovalWorkflowRoleLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfApprovalWorkflowRoleLookupDto {
    items: ApprovalWorkflowRoleLookupDto[];
}

export class ApprovalWorkflowRoleLookupDto implements IApprovalWorkflowRoleLookupDto {
    id: number;
    displayName: string;

    constructor(data?: IApprovalWorkflowRoleLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ApprovalWorkflowRoleLookupDto {
        let result = new ApprovalWorkflowRoleLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IApprovalWorkflowRoleLookupDto {
    id: number;
    displayName: string;
}

export class ApprovalWorkflowLanguagesOutput implements IApprovalWorkflowLanguagesOutput {
    defaultLanguageId: number;
    items: ApprovalWorkflowLanguageLookupDto[];

    constructor(data?: IApprovalWorkflowLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageId = data["defaultLanguageId"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApprovalWorkflowLanguageLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalWorkflowLanguagesOutput {
        let result = new ApprovalWorkflowLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApprovalWorkflowLanguagesOutput {
    defaultLanguageId: number;
    items: ApprovalWorkflowLanguageLookupDto[];
}

export class ApprovalWorkflowLanguageLookupDto implements IApprovalWorkflowLanguageLookupDto {
    id: number;
    name: string;
    displayName: string;

    constructor(data?: IApprovalWorkflowLanguageLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ApprovalWorkflowLanguageLookupDto {
        let result = new ApprovalWorkflowLanguageLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IApprovalWorkflowLanguageLookupDto {
    id: number;
    name: string;
    displayName: string;
}

export class SaveApprovalWorkflowInput implements ISaveApprovalWorkflowInput {
    transactionType: SaveApprovalWorkflowInputTransactionType;
    isEnable: boolean;
    steps: ApprovalWorkflowStepDto[];

    constructor(data?: ISaveApprovalWorkflowInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionType = data["transactionType"];
            this.isEnable = data["isEnable"];
            if (data["steps"] && data["steps"].constructor === Array) {
                this.steps = [];
                for (let item of data["steps"])
                    this.steps.push(ApprovalWorkflowStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveApprovalWorkflowInput {
        let result = new SaveApprovalWorkflowInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionType"] = this.transactionType;
        data["isEnable"] = this.isEnable;
        if (this.steps && this.steps.constructor === Array) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaveApprovalWorkflowInput {
    transactionType: SaveApprovalWorkflowInputTransactionType;
    isEnable: boolean;
    steps: ApprovalWorkflowStepDto[];
}

export class PagedAreaList implements IPagedAreaList {
    currentPage: number;
    itemsCount: number;
    areas: AreaListItem[];

    constructor(data?: IPagedAreaList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["areas"] && data["areas"].constructor === Array) {
                this.areas = [];
                for (let item of data["areas"])
                    this.areas.push(AreaListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedAreaList {
        let result = new PagedAreaList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.areas && this.areas.constructor === Array) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedAreaList {
    currentPage: number;
    itemsCount: number;
    areas: AreaListItem[];
}

export class AreaListItem implements IAreaListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IAreaListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): AreaListItem {
        let result = new AreaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IAreaListItem {
    id: number;
    name: string;
    code: string;
}

export class CreateAreaInput implements ICreateAreaInput {
    regionId: number;
    code: string;
    translations: AreaTranslationDto[];
    storeGroupsIds: number[];

    constructor(data?: ICreateAreaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regionId = data["regionId"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AreaTranslationDto.fromJS(item));
            }
            if (data["storeGroupsIds"] && data["storeGroupsIds"].constructor === Array) {
                this.storeGroupsIds = [];
                for (let item of data["storeGroupsIds"])
                    this.storeGroupsIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAreaInput {
        let result = new CreateAreaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeGroupsIds && this.storeGroupsIds.constructor === Array) {
            data["storeGroupsIds"] = [];
            for (let item of this.storeGroupsIds)
                data["storeGroupsIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateAreaInput {
    regionId: number;
    code: string;
    translations: AreaTranslationDto[];
    storeGroupsIds: number[];
}

export class AreaTranslationDto implements IAreaTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IAreaTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): AreaTranslationDto {
        let result = new AreaTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IAreaTranslationDto {
    name: string;
    languageId: number;
}

export class UpdateAreaInput implements IUpdateAreaInput {
    id: number;
    code: string;
    regionId: number;
    storeGroupsIds: number[];
    translations: AreaTranslationDto[];

    constructor(data?: IUpdateAreaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.regionId = data["regionId"];
            if (data["storeGroupsIds"] && data["storeGroupsIds"].constructor === Array) {
                this.storeGroupsIds = [];
                for (let item of data["storeGroupsIds"])
                    this.storeGroupsIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AreaTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAreaInput {
        let result = new UpdateAreaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["regionId"] = this.regionId;
        if (this.storeGroupsIds && this.storeGroupsIds.constructor === Array) {
            data["storeGroupsIds"] = [];
            for (let item of this.storeGroupsIds)
                data["storeGroupsIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateAreaInput {
    id: number;
    code: string;
    regionId: number;
    storeGroupsIds: number[];
    translations: AreaTranslationDto[];
}

export class AreaDto implements IAreaDto {
    id: number;
    code: string;
    regionId: number;
    storeGroupsIds: number[];
    translations: AreaTranslationDto[];

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.regionId = data["regionId"];
            if (data["storeGroupsIds"] && data["storeGroupsIds"].constructor === Array) {
                this.storeGroupsIds = [];
                for (let item of data["storeGroupsIds"])
                    this.storeGroupsIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AreaTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AreaDto {
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["regionId"] = this.regionId;
        if (this.storeGroupsIds && this.storeGroupsIds.constructor === Array) {
            data["storeGroupsIds"] = [];
            for (let item of this.storeGroupsIds)
                data["storeGroupsIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAreaDto {
    id: number;
    code: string;
    regionId: number;
    storeGroupsIds: number[];
    translations: AreaTranslationDto[];
}

export class ListResultDtoOfAreaListItem implements IListResultDtoOfAreaListItem {
    items: AreaListItem[];

    constructor(data?: IListResultDtoOfAreaListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AreaListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAreaListItem {
        let result = new ListResultDtoOfAreaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAreaListItem {
    items: AreaListItem[];
}

export class AttributeDto implements IAttributeDto {
    translations: AttributeTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AttributeTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AttributeDto {
        let result = new AttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAttributeDto {
    translations: AttributeTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class AttributeTranslationDto implements IAttributeTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IAttributeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): AttributeTranslationDto {
        let result = new AttributeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IAttributeTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfAttributeListItem implements IListResultDtoOfAttributeListItem {
    items: AttributeListItem[];

    constructor(data?: IListResultDtoOfAttributeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AttributeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAttributeListItem {
        let result = new ListResultDtoOfAttributeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAttributeListItem {
    items: AttributeListItem[];
}

export class AttributeListItem implements IAttributeListItem {
    id: number;
    name: string;

    constructor(data?: IAttributeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): AttributeListItem {
        let result = new AttributeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IAttributeListItem {
    id: number;
    name: string;
}

export class CreateAttributeInput implements ICreateAttributeInput {
    translations: AttributeTranslationDto[];

    constructor(data?: ICreateAttributeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AttributeTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAttributeInput {
        let result = new CreateAttributeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateAttributeInput {
    translations: AttributeTranslationDto[];
}

export class UpdateAttributeInput implements IUpdateAttributeInput {
    id: number;
    translations: AttributeTranslationDto[];

    constructor(data?: IUpdateAttributeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AttributeTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAttributeInput {
        let result = new UpdateAttributeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateAttributeInput {
    id: number;
    translations: AttributeTranslationDto[];
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[];

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[];
}

export class AuditLogListDto implements IAuditLogListDto {
    userId: number;
    time: string;
    userName: string;
    impersonatorTenantId: number;
    impersonatorUserId: number;
    serviceName: string;
    methodName: string;
    parameters: string;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    exception: string;
    customData: string;
    id: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.time = data["time"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["time"] = this.time;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAuditLogListDto {
    userId: number;
    time: string;
    userName: string;
    impersonatorTenantId: number;
    impersonatorUserId: number;
    serviceName: string;
    methodName: string;
    parameters: string;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    exception: string;
    customData: string;
    id: number;
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
    message: StatusMessage[];
    mStream: MemoryStream;
    isInBackGround: boolean;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
            if (data["message"] && data["message"].constructor === Array) {
                this.message = [];
                for (let item of data["message"])
                    this.message.push(StatusMessage.fromJS(item));
            }
            this.mStream = data["mStream"] ? MemoryStream.fromJS(data["mStream"]) : <any>undefined;
            this.isInBackGround = data["isInBackGround"];
        }
    }

    static fromJS(data: any): FileDto {
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        if (this.message && this.message.constructor === Array) {
            data["message"] = [];
            for (let item of this.message)
                data["message"].push(item.toJSON());
        }
        data["mStream"] = this.mStream ? this.mStream.toJSON() : <any>undefined;
        data["isInBackGround"] = this.isInBackGround;
        return data; 
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
    message: StatusMessage[];
    mStream: MemoryStream;
    isInBackGround: boolean;
}

export class StatusMessage implements IStatusMessage {
    moduleId: number;
    statusId: number;

    constructor(data?: IStatusMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.moduleId = data["moduleId"];
            this.statusId = data["statusId"];
        }
    }

    static fromJS(data: any): StatusMessage {
        let result = new StatusMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["statusId"] = this.statusId;
        return data; 
    }
}

export interface IStatusMessage {
    moduleId: number;
    statusId: number;
}

export class MemoryStream implements IMemoryStream {
    canRead: boolean;
    canSeek: boolean;
    canWrite: boolean;
    capacity: number;
    length: number;
    position: number;
    canTimeout: boolean;
    readTimeout: number;
    writeTimeout: number;

    constructor(data?: IMemoryStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canRead = data["canRead"];
            this.canSeek = data["canSeek"];
            this.canWrite = data["canWrite"];
            this.capacity = data["capacity"];
            this.length = data["length"];
            this.position = data["position"];
            this.canTimeout = data["canTimeout"];
            this.readTimeout = data["readTimeout"];
            this.writeTimeout = data["writeTimeout"];
        }
    }

    static fromJS(data: any): MemoryStream {
        let result = new MemoryStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["capacity"] = this.capacity;
        data["length"] = this.length;
        data["position"] = this.position;
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }
}

export interface IMemoryStream {
    canRead: boolean;
    canSeek: boolean;
    canWrite: boolean;
    capacity: number;
    length: number;
    position: number;
    canTimeout: boolean;
    readTimeout: number;
    writeTimeout: number;
}

export class MainTransactionDto implements IMainTransactionDto {
    id: number;
    storeNumber: string;
    storeName: string;
    fromStoreName: string;
    toStoreName: string;
    supplierName: string;
    receiveNumber: string;
    textDate: string;
    notes: string;
    mainTransactionId: number;
    materialId: number;
    materialName: number;
    menuItemName: string;
    saleTypeName: string;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    approveDate: moment.Moment;
    deliveryDate: moment.Moment;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    lotNumber: number;
    transactionTypeId: number;
    isRevision: number;
    tenantId: number;
    saleTypeId: number;
    menuItemId: number;
    parentId: number;
    supplierId: number;
    transactionTemplateId: number;
    quantity: number;
    detailTransactions: DetailTransaction[];
    status: number;
    statusLocalized: string;
    netAfterVat: number;
    netBeforVat: number;
    totalVat: number;
    documentNumber: string;
    parentReceiveNumber: string;
    currencyId: number;
    currencyRate: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: IMainTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.fromStoreName = data["fromStoreName"];
            this.toStoreName = data["toStoreName"];
            this.supplierName = data["supplierName"];
            this.receiveNumber = data["receiveNumber"];
            this.textDate = data["textDate"];
            this.notes = data["notes"];
            this.mainTransactionId = data["mainTransactionId"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.menuItemName = data["menuItemName"];
            this.saleTypeName = data["saleTypeName"];
            this.fromStoreId = data["fromStoreId"];
            this.toStoreId = data["toStoreId"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.approveDate = data["approveDate"] ? moment(data["approveDate"].toString()) : <any>undefined;
            this.deliveryDate = data["deliveryDate"] ? moment(data["deliveryDate"].toString()) : <any>undefined;
            this.code = data["code"];
            this.fromStoreTpypeId = data["fromStoreTpypeId"];
            this.toStoreTpypeId = data["toStoreTpypeId"];
            this.lotNumber = data["lotNumber"];
            this.transactionTypeId = data["transactionTypeId"];
            this.isRevision = data["isRevision"];
            this.tenantId = data["tenantId"];
            this.saleTypeId = data["saleTypeId"];
            this.menuItemId = data["menuItemId"];
            this.parentId = data["parentId"];
            this.supplierId = data["supplierId"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.quantity = data["quantity"];
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransaction.fromJS(item));
            }
            this.status = data["status"];
            this.statusLocalized = data["statusLocalized"];
            this.netAfterVat = data["netAfterVat"];
            this.netBeforVat = data["netBeforVat"];
            this.totalVat = data["totalVat"];
            this.documentNumber = data["documentNumber"];
            this.parentReceiveNumber = data["parentReceiveNumber"];
            this.currencyId = data["currencyId"];
            this.currencyRate = data["currencyRate"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): MainTransactionDto {
        let result = new MainTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["fromStoreName"] = this.fromStoreName;
        data["toStoreName"] = this.toStoreName;
        data["supplierName"] = this.supplierName;
        data["receiveNumber"] = this.receiveNumber;
        data["textDate"] = this.textDate;
        data["notes"] = this.notes;
        data["mainTransactionId"] = this.mainTransactionId;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["menuItemName"] = this.menuItemName;
        data["saleTypeName"] = this.saleTypeName;
        data["fromStoreId"] = this.fromStoreId;
        data["toStoreId"] = this.toStoreId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["approveDate"] = this.approveDate ? this.approveDate.toISOString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["fromStoreTpypeId"] = this.fromStoreTpypeId;
        data["toStoreTpypeId"] = this.toStoreTpypeId;
        data["lotNumber"] = this.lotNumber;
        data["transactionTypeId"] = this.transactionTypeId;
        data["isRevision"] = this.isRevision;
        data["tenantId"] = this.tenantId;
        data["saleTypeId"] = this.saleTypeId;
        data["menuItemId"] = this.menuItemId;
        data["parentId"] = this.parentId;
        data["supplierId"] = this.supplierId;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["quantity"] = this.quantity;
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusLocalized"] = this.statusLocalized;
        data["netAfterVat"] = this.netAfterVat;
        data["netBeforVat"] = this.netBeforVat;
        data["totalVat"] = this.totalVat;
        data["documentNumber"] = this.documentNumber;
        data["parentReceiveNumber"] = this.parentReceiveNumber;
        data["currencyId"] = this.currencyId;
        data["currencyRate"] = this.currencyRate;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface IMainTransactionDto {
    id: number;
    storeNumber: string;
    storeName: string;
    fromStoreName: string;
    toStoreName: string;
    supplierName: string;
    receiveNumber: string;
    textDate: string;
    notes: string;
    mainTransactionId: number;
    materialId: number;
    materialName: number;
    menuItemName: string;
    saleTypeName: string;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    approveDate: moment.Moment;
    deliveryDate: moment.Moment;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    lotNumber: number;
    transactionTypeId: number;
    isRevision: number;
    tenantId: number;
    saleTypeId: number;
    menuItemId: number;
    parentId: number;
    supplierId: number;
    transactionTemplateId: number;
    quantity: number;
    detailTransactions: DetailTransaction[];
    status: number;
    statusLocalized: string;
    netAfterVat: number;
    netBeforVat: number;
    totalVat: number;
    documentNumber: string;
    parentReceiveNumber: string;
    currencyId: number;
    currencyRate: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class DetailTransaction implements IDetailTransaction {
    id: number;
    barCode: string;
    detailTransactionId: number;
    mainTransactionId: number;
    materialId: number;
    materialName: string;
    unitOfMeasureName: string;
    qty: number;
    price: number;
    originalQunatity: number;
    qtyReceive: number;
    lotNumber: number;
    restQunatity: number;
    discount: number;
    tax: number;
    notes: string;
    tenantId: number;
    addAndMinus: number;
    discountType: number;
    inventoryQuanity: number;
    purchaseQuantity: number;
    dueDate: moment.Moment;
    hasDueDate: boolean;
    rawMaterial: RawMaterialDto;
    productId: number;
    index: number;
    productName: string;
    productVariantName: string;
    product: ProductDto;
    products: GetProductOutput[];
    productList: ProductListItem[];
    productVariantId: number;
    unitOfMeasureId: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    fromStockQunatity: number;
    toStockQunatity: number;
    taxId: number;
    netAfterVat: number;
    itemCost: DetailTransactionItemCost;
    unitType: DetailTransactionUnitType;
    primarycategories: PrimaryCategoryListItem[];
    secondarycategories: SecondaryCategoryListItem[];
    productcategories: ProductCategoryListItem[];
    variants: VariantListItem[];
    unitsOfMeasures: UnitOfMeasureListItem[];

    constructor(data?: IDetailTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.barCode = data["barCode"];
            this.detailTransactionId = data["detailTransactionId"];
            this.mainTransactionId = data["mainTransactionId"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.qty = data["qty"];
            this.price = data["price"];
            this.originalQunatity = data["originalQunatity"];
            this.qtyReceive = data["qtyReceive"];
            this.lotNumber = data["lotNumber"];
            this.restQunatity = data["restQunatity"];
            this.discount = data["discount"];
            this.tax = data["tax"];
            this.notes = data["notes"];
            this.tenantId = data["tenantId"];
            this.addAndMinus = data["addAndMinus"];
            this.discountType = data["discountType"];
            this.inventoryQuanity = data["inventoryQuanity"];
            this.purchaseQuantity = data["purchaseQuantity"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.hasDueDate = data["hasDueDate"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterialDto.fromJS(data["rawMaterial"]) : <any>undefined;
            this.productId = data["productId"];
            this.index = data["index"];
            this.productName = data["productName"];
            this.productVariantName = data["productVariantName"];
            this.product = data["product"] ? ProductDto.fromJS(data["product"]) : <any>undefined;
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(GetProductOutput.fromJS(item));
            }
            if (data["productList"] && data["productList"].constructor === Array) {
                this.productList = [];
                for (let item of data["productList"])
                    this.productList.push(ProductListItem.fromJS(item));
            }
            this.productVariantId = data["productVariantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.productCategoryId = data["productCategoryId"];
            this.fromStockQunatity = data["fromStockQunatity"];
            this.toStockQunatity = data["toStockQunatity"];
            this.taxId = data["taxId"];
            this.netAfterVat = data["netAfterVat"];
            this.itemCost = data["itemCost"];
            this.unitType = data["unitType"];
            if (data["primarycategories"] && data["primarycategories"].constructor === Array) {
                this.primarycategories = [];
                for (let item of data["primarycategories"])
                    this.primarycategories.push(PrimaryCategoryListItem.fromJS(item));
            }
            if (data["secondarycategories"] && data["secondarycategories"].constructor === Array) {
                this.secondarycategories = [];
                for (let item of data["secondarycategories"])
                    this.secondarycategories.push(SecondaryCategoryListItem.fromJS(item));
            }
            if (data["productcategories"] && data["productcategories"].constructor === Array) {
                this.productcategories = [];
                for (let item of data["productcategories"])
                    this.productcategories.push(ProductCategoryListItem.fromJS(item));
            }
            if (data["variants"] && data["variants"].constructor === Array) {
                this.variants = [];
                for (let item of data["variants"])
                    this.variants.push(VariantListItem.fromJS(item));
            }
            if (data["unitsOfMeasures"] && data["unitsOfMeasures"].constructor === Array) {
                this.unitsOfMeasures = [];
                for (let item of data["unitsOfMeasures"])
                    this.unitsOfMeasures.push(UnitOfMeasureListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailTransaction {
        let result = new DetailTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["barCode"] = this.barCode;
        data["detailTransactionId"] = this.detailTransactionId;
        data["mainTransactionId"] = this.mainTransactionId;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["originalQunatity"] = this.originalQunatity;
        data["qtyReceive"] = this.qtyReceive;
        data["lotNumber"] = this.lotNumber;
        data["restQunatity"] = this.restQunatity;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["notes"] = this.notes;
        data["tenantId"] = this.tenantId;
        data["addAndMinus"] = this.addAndMinus;
        data["discountType"] = this.discountType;
        data["inventoryQuanity"] = this.inventoryQuanity;
        data["purchaseQuantity"] = this.purchaseQuantity;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["hasDueDate"] = this.hasDueDate;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["index"] = this.index;
        data["productName"] = this.productName;
        data["productVariantName"] = this.productVariantName;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.productList && this.productList.constructor === Array) {
            data["productList"] = [];
            for (let item of this.productList)
                data["productList"].push(item.toJSON());
        }
        data["productVariantId"] = this.productVariantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["productCategoryId"] = this.productCategoryId;
        data["fromStockQunatity"] = this.fromStockQunatity;
        data["toStockQunatity"] = this.toStockQunatity;
        data["taxId"] = this.taxId;
        data["netAfterVat"] = this.netAfterVat;
        data["itemCost"] = this.itemCost;
        data["unitType"] = this.unitType;
        if (this.primarycategories && this.primarycategories.constructor === Array) {
            data["primarycategories"] = [];
            for (let item of this.primarycategories)
                data["primarycategories"].push(item.toJSON());
        }
        if (this.secondarycategories && this.secondarycategories.constructor === Array) {
            data["secondarycategories"] = [];
            for (let item of this.secondarycategories)
                data["secondarycategories"].push(item.toJSON());
        }
        if (this.productcategories && this.productcategories.constructor === Array) {
            data["productcategories"] = [];
            for (let item of this.productcategories)
                data["productcategories"].push(item.toJSON());
        }
        if (this.variants && this.variants.constructor === Array) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        if (this.unitsOfMeasures && this.unitsOfMeasures.constructor === Array) {
            data["unitsOfMeasures"] = [];
            for (let item of this.unitsOfMeasures)
                data["unitsOfMeasures"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDetailTransaction {
    id: number;
    barCode: string;
    detailTransactionId: number;
    mainTransactionId: number;
    materialId: number;
    materialName: string;
    unitOfMeasureName: string;
    qty: number;
    price: number;
    originalQunatity: number;
    qtyReceive: number;
    lotNumber: number;
    restQunatity: number;
    discount: number;
    tax: number;
    notes: string;
    tenantId: number;
    addAndMinus: number;
    discountType: number;
    inventoryQuanity: number;
    purchaseQuantity: number;
    dueDate: moment.Moment;
    hasDueDate: boolean;
    rawMaterial: RawMaterialDto;
    productId: number;
    index: number;
    productName: string;
    productVariantName: string;
    product: ProductDto;
    products: GetProductOutput[];
    productList: ProductListItem[];
    productVariantId: number;
    unitOfMeasureId: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    fromStockQunatity: number;
    toStockQunatity: number;
    taxId: number;
    netAfterVat: number;
    itemCost: DetailTransactionItemCost;
    unitType: DetailTransactionUnitType;
    primarycategories: PrimaryCategoryListItem[];
    secondarycategories: SecondaryCategoryListItem[];
    productcategories: ProductCategoryListItem[];
    variants: VariantListItem[];
    unitsOfMeasures: UnitOfMeasureListItem[];
}

export class RawMaterialDto implements IRawMaterialDto {
    id: number;
    translations: RawMaterialTranslationDto[];
    materialGroupId: number;
    rawMaterialName: string;
    storeName: string;
    reOrderLevel: number;
    maxQuantity: number;
    barCode: string;
    sellingPrice: number;
    itemCost: RawMaterialDtoItemCost;
    periodId: number;
    suppliers: number[];
    hasDueDate: boolean;
    storeId: number;
    inventoryUnitOfMeasureId: number;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureId: number;
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureName: string;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    isRecipe: boolean;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    rawMaterialDetail: RawMaterialDetailDto[];
    rawMaterialComponent: RawMaterialDetailDto[];
    materialStocks: MaterialStockDto[];
    storeGroups: number[];

    constructor(data?: IRawMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RawMaterialTranslationDto.fromJS(item));
            }
            this.materialGroupId = data["materialGroupId"];
            this.rawMaterialName = data["rawMaterialName"];
            this.storeName = data["storeName"];
            this.reOrderLevel = data["reOrderLevel"];
            this.maxQuantity = data["maxQuantity"];
            this.barCode = data["barCode"];
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
            this.periodId = data["periodId"];
            if (data["suppliers"] && data["suppliers"].constructor === Array) {
                this.suppliers = [];
                for (let item of data["suppliers"])
                    this.suppliers.push(item);
            }
            this.hasDueDate = data["hasDueDate"];
            this.storeId = data["storeId"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.inventoryUnitOfMeasureName = data["inventoryUnitOfMeasureName"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.productUnitOfMeasureName = data["productUnitOfMeasureName"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.purchaseUnitOfMeasureName = data["purchaseUnitOfMeasureName"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.isRecipe = data["isRecipe"];
            this.reOrderQuantity = data["reOrderQuantity"];
            this.warningAlertQuantity = data["warningAlertQuantity"];
            if (data["rawMaterialDetail"] && data["rawMaterialDetail"].constructor === Array) {
                this.rawMaterialDetail = [];
                for (let item of data["rawMaterialDetail"])
                    this.rawMaterialDetail.push(RawMaterialDetailDto.fromJS(item));
            }
            if (data["rawMaterialComponent"] && data["rawMaterialComponent"].constructor === Array) {
                this.rawMaterialComponent = [];
                for (let item of data["rawMaterialComponent"])
                    this.rawMaterialComponent.push(RawMaterialDetailDto.fromJS(item));
            }
            if (data["materialStocks"] && data["materialStocks"].constructor === Array) {
                this.materialStocks = [];
                for (let item of data["materialStocks"])
                    this.materialStocks.push(MaterialStockDto.fromJS(item));
            }
            if (data["storeGroups"] && data["storeGroups"].constructor === Array) {
                this.storeGroups = [];
                for (let item of data["storeGroups"])
                    this.storeGroups.push(item);
            }
        }
    }

    static fromJS(data: any): RawMaterialDto {
        let result = new RawMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["materialGroupId"] = this.materialGroupId;
        data["rawMaterialName"] = this.rawMaterialName;
        data["storeName"] = this.storeName;
        data["reOrderLevel"] = this.reOrderLevel;
        data["maxQuantity"] = this.maxQuantity;
        data["barCode"] = this.barCode;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        data["periodId"] = this.periodId;
        if (this.suppliers && this.suppliers.constructor === Array) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        data["hasDueDate"] = this.hasDueDate;
        data["storeId"] = this.storeId;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["inventoryUnitOfMeasureName"] = this.inventoryUnitOfMeasureName;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["productUnitOfMeasureName"] = this.productUnitOfMeasureName;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["purchaseUnitOfMeasureName"] = this.purchaseUnitOfMeasureName;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["isRecipe"] = this.isRecipe;
        data["reOrderQuantity"] = this.reOrderQuantity;
        data["warningAlertQuantity"] = this.warningAlertQuantity;
        if (this.rawMaterialDetail && this.rawMaterialDetail.constructor === Array) {
            data["rawMaterialDetail"] = [];
            for (let item of this.rawMaterialDetail)
                data["rawMaterialDetail"].push(item.toJSON());
        }
        if (this.rawMaterialComponent && this.rawMaterialComponent.constructor === Array) {
            data["rawMaterialComponent"] = [];
            for (let item of this.rawMaterialComponent)
                data["rawMaterialComponent"].push(item.toJSON());
        }
        if (this.materialStocks && this.materialStocks.constructor === Array) {
            data["materialStocks"] = [];
            for (let item of this.materialStocks)
                data["materialStocks"].push(item.toJSON());
        }
        if (this.storeGroups && this.storeGroups.constructor === Array) {
            data["storeGroups"] = [];
            for (let item of this.storeGroups)
                data["storeGroups"].push(item);
        }
        return data; 
    }
}

export interface IRawMaterialDto {
    id: number;
    translations: RawMaterialTranslationDto[];
    materialGroupId: number;
    rawMaterialName: string;
    storeName: string;
    reOrderLevel: number;
    maxQuantity: number;
    barCode: string;
    sellingPrice: number;
    itemCost: RawMaterialDtoItemCost;
    periodId: number;
    suppliers: number[];
    hasDueDate: boolean;
    storeId: number;
    inventoryUnitOfMeasureId: number;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureId: number;
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureName: string;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    isRecipe: boolean;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    rawMaterialDetail: RawMaterialDetailDto[];
    rawMaterialComponent: RawMaterialDetailDto[];
    materialStocks: MaterialStockDto[];
    storeGroups: number[];
}

export class ProductDto implements IProductDto {
    productName: string;
    productLots: ProductLotDto[];

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productName = data["productName"];
            if (data["productLots"] && data["productLots"].constructor === Array) {
                this.productLots = [];
                for (let item of data["productLots"])
                    this.productLots.push(ProductLotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDto {
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        if (this.productLots && this.productLots.constructor === Array) {
            data["productLots"] = [];
            for (let item of this.productLots)
                data["productLots"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductDto {
    productName: string;
    productLots: ProductLotDto[];
}

export class GetProductOutput implements IGetProductOutput {
    id: number;
    code: string;
    name: string;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    cost: number;
    isPurchased: boolean;
    isHidden: boolean;
    isService: boolean;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    hasVariants: boolean;
    selectedTaxesIds: number[];
    selectedVendorsIds: number[];
    selectedAttributesIds: number[];
    translations: ProductTranslationDto[];
    variants: ProductVariantsDto;
    imageId: string;
    imageSrcUrl: string;

    constructor(data?: IGetProductOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.referenceNumber = data["referenceNumber"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.cost = data["cost"];
            this.isPurchased = data["isPurchased"];
            this.isHidden = data["isHidden"];
            this.isService = data["isService"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.productCategoryId = data["productCategoryId"];
            this.hasVariants = data["hasVariants"];
            if (data["selectedTaxesIds"] && data["selectedTaxesIds"].constructor === Array) {
                this.selectedTaxesIds = [];
                for (let item of data["selectedTaxesIds"])
                    this.selectedTaxesIds.push(item);
            }
            if (data["selectedVendorsIds"] && data["selectedVendorsIds"].constructor === Array) {
                this.selectedVendorsIds = [];
                for (let item of data["selectedVendorsIds"])
                    this.selectedVendorsIds.push(item);
            }
            if (data["selectedAttributesIds"] && data["selectedAttributesIds"].constructor === Array) {
                this.selectedAttributesIds = [];
                for (let item of data["selectedAttributesIds"])
                    this.selectedAttributesIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductTranslationDto.fromJS(item));
            }
            this.variants = data["variants"] ? ProductVariantsDto.fromJS(data["variants"]) : <any>undefined;
            this.imageId = data["imageId"];
            this.imageSrcUrl = data["imageSrcUrl"];
        }
    }

    static fromJS(data: any): GetProductOutput {
        let result = new GetProductOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["referenceNumber"] = this.referenceNumber;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["cost"] = this.cost;
        data["isPurchased"] = this.isPurchased;
        data["isHidden"] = this.isHidden;
        data["isService"] = this.isService;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["productCategoryId"] = this.productCategoryId;
        data["hasVariants"] = this.hasVariants;
        if (this.selectedTaxesIds && this.selectedTaxesIds.constructor === Array) {
            data["selectedTaxesIds"] = [];
            for (let item of this.selectedTaxesIds)
                data["selectedTaxesIds"].push(item);
        }
        if (this.selectedVendorsIds && this.selectedVendorsIds.constructor === Array) {
            data["selectedVendorsIds"] = [];
            for (let item of this.selectedVendorsIds)
                data["selectedVendorsIds"].push(item);
        }
        if (this.selectedAttributesIds && this.selectedAttributesIds.constructor === Array) {
            data["selectedAttributesIds"] = [];
            for (let item of this.selectedAttributesIds)
                data["selectedAttributesIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["variants"] = this.variants ? this.variants.toJSON() : <any>undefined;
        data["imageId"] = this.imageId;
        data["imageSrcUrl"] = this.imageSrcUrl;
        return data; 
    }
}

export interface IGetProductOutput {
    id: number;
    code: string;
    name: string;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    cost: number;
    isPurchased: boolean;
    isHidden: boolean;
    isService: boolean;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    hasVariants: boolean;
    selectedTaxesIds: number[];
    selectedVendorsIds: number[];
    selectedAttributesIds: number[];
    translations: ProductTranslationDto[];
    variants: ProductVariantsDto;
    imageId: string;
    imageSrcUrl: string;
}

export class ProductListItem implements IProductListItem {
    id: number;
    name: string;
    code: string;
    nameAndCode: string;
    isHidden: boolean;
    description: string;
    hasVariants: boolean;
    isService: boolean;
    isPurchased: boolean;
    purchaseLimit: number;
    saleLimit: number;
    price: number;
    taxValue: number;
    isVAT: boolean;
    imageId: string;
    imageSrcUrl: string;

    constructor(data?: IProductListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
            this.nameAndCode = data["nameAndCode"];
            this.isHidden = data["isHidden"];
            this.description = data["description"];
            this.hasVariants = data["hasVariants"];
            this.isService = data["isService"];
            this.isPurchased = data["isPurchased"];
            this.purchaseLimit = data["purchaseLimit"];
            this.saleLimit = data["saleLimit"];
            this.price = data["price"];
            this.taxValue = data["taxValue"];
            this.isVAT = data["isVAT"];
            this.imageId = data["imageId"];
            this.imageSrcUrl = data["imageSrcUrl"];
        }
    }

    static fromJS(data: any): ProductListItem {
        let result = new ProductListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["nameAndCode"] = this.nameAndCode;
        data["isHidden"] = this.isHidden;
        data["description"] = this.description;
        data["hasVariants"] = this.hasVariants;
        data["isService"] = this.isService;
        data["isPurchased"] = this.isPurchased;
        data["purchaseLimit"] = this.purchaseLimit;
        data["saleLimit"] = this.saleLimit;
        data["price"] = this.price;
        data["taxValue"] = this.taxValue;
        data["isVAT"] = this.isVAT;
        data["imageId"] = this.imageId;
        data["imageSrcUrl"] = this.imageSrcUrl;
        return data; 
    }
}

export interface IProductListItem {
    id: number;
    name: string;
    code: string;
    nameAndCode: string;
    isHidden: boolean;
    description: string;
    hasVariants: boolean;
    isService: boolean;
    isPurchased: boolean;
    purchaseLimit: number;
    saleLimit: number;
    price: number;
    taxValue: number;
    isVAT: boolean;
    imageId: string;
    imageSrcUrl: string;
}

export class PrimaryCategoryListItem implements IPrimaryCategoryListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IPrimaryCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): PrimaryCategoryListItem {
        let result = new PrimaryCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IPrimaryCategoryListItem {
    id: number;
    name: string;
    code: string;
}

export class SecondaryCategoryListItem implements ISecondaryCategoryListItem {
    id: number;
    name: string;
    primaryCategoryId: number;
    code: string;

    constructor(data?: ISecondaryCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): SecondaryCategoryListItem {
        let result = new SecondaryCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["code"] = this.code;
        return data; 
    }
}

export interface ISecondaryCategoryListItem {
    id: number;
    name: string;
    primaryCategoryId: number;
    code: string;
}

export class ProductCategoryListItem implements IProductCategoryListItem {
    id: number;
    name: string;
    code: string;
    secondaryCategoryId: number;

    constructor(data?: IProductCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
        }
    }

    static fromJS(data: any): ProductCategoryListItem {
        let result = new ProductCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        return data; 
    }
}

export interface IProductCategoryListItem {
    id: number;
    name: string;
    code: string;
    secondaryCategoryId: number;
}

export class VariantListItem implements IVariantListItem {
    id: number;
    code: string;
    name: string;

    constructor(data?: IVariantListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): VariantListItem {
        let result = new VariantListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data; 
    }
}

export interface IVariantListItem {
    id: number;
    code: string;
    name: string;
}

export class UnitOfMeasureListItem implements IUnitOfMeasureListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IUnitOfMeasureListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): UnitOfMeasureListItem {
        let result = new UnitOfMeasureListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IUnitOfMeasureListItem {
    id: number;
    name: string;
    code: string;
}

export class RawMaterialTranslationDto implements IRawMaterialTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IRawMaterialTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): RawMaterialTranslationDto {
        let result = new RawMaterialTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IRawMaterialTranslationDto {
    name: string;
    languageId: number;
}

export class RawMaterialDetailDto implements IRawMaterialDetailDto {
    id: number;
    rawMaterialId: number;
    quantity: number;
    rawMaterialComponentId: number;
    unitOfMeasureId: number;
    unitOfPurchaseMeasureId: number;
    unitOfProductMeasureId: number;
    lossFactor: number;
    rawMaterialName: string;
    rawMaterialComponentName: string;
    unitOfMeasureName: string;
    inventoryQuantity: number;
    rawMaterialSaleTypesIds: number[];
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureName: string;
    inventoryUnitOfMeasureName: string;
    barcode: string;

    constructor(data?: IRawMaterialDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rawMaterialId = data["rawMaterialId"];
            this.quantity = data["quantity"];
            this.rawMaterialComponentId = data["rawMaterialComponentId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfPurchaseMeasureId = data["unitOfPurchaseMeasureId"];
            this.unitOfProductMeasureId = data["unitOfProductMeasureId"];
            this.lossFactor = data["lossFactor"];
            this.rawMaterialName = data["rawMaterialName"];
            this.rawMaterialComponentName = data["rawMaterialComponentName"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.inventoryQuantity = data["inventoryQuantity"];
            if (data["rawMaterialSaleTypesIds"] && data["rawMaterialSaleTypesIds"].constructor === Array) {
                this.rawMaterialSaleTypesIds = [];
                for (let item of data["rawMaterialSaleTypesIds"])
                    this.rawMaterialSaleTypesIds.push(item);
            }
            this.productUnitOfMeasureName = data["productUnitOfMeasureName"];
            this.purchaseUnitOfMeasureName = data["purchaseUnitOfMeasureName"];
            this.inventoryUnitOfMeasureName = data["inventoryUnitOfMeasureName"];
            this.barcode = data["barcode"];
        }
    }

    static fromJS(data: any): RawMaterialDetailDto {
        let result = new RawMaterialDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rawMaterialId"] = this.rawMaterialId;
        data["quantity"] = this.quantity;
        data["rawMaterialComponentId"] = this.rawMaterialComponentId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfPurchaseMeasureId"] = this.unitOfPurchaseMeasureId;
        data["unitOfProductMeasureId"] = this.unitOfProductMeasureId;
        data["lossFactor"] = this.lossFactor;
        data["rawMaterialName"] = this.rawMaterialName;
        data["rawMaterialComponentName"] = this.rawMaterialComponentName;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["inventoryQuantity"] = this.inventoryQuantity;
        if (this.rawMaterialSaleTypesIds && this.rawMaterialSaleTypesIds.constructor === Array) {
            data["rawMaterialSaleTypesIds"] = [];
            for (let item of this.rawMaterialSaleTypesIds)
                data["rawMaterialSaleTypesIds"].push(item);
        }
        data["productUnitOfMeasureName"] = this.productUnitOfMeasureName;
        data["purchaseUnitOfMeasureName"] = this.purchaseUnitOfMeasureName;
        data["inventoryUnitOfMeasureName"] = this.inventoryUnitOfMeasureName;
        data["barcode"] = this.barcode;
        return data; 
    }
}

export interface IRawMaterialDetailDto {
    id: number;
    rawMaterialId: number;
    quantity: number;
    rawMaterialComponentId: number;
    unitOfMeasureId: number;
    unitOfPurchaseMeasureId: number;
    unitOfProductMeasureId: number;
    lossFactor: number;
    rawMaterialName: string;
    rawMaterialComponentName: string;
    unitOfMeasureName: string;
    inventoryQuantity: number;
    rawMaterialSaleTypesIds: number[];
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureName: string;
    inventoryUnitOfMeasureName: string;
    barcode: string;
}

export class MaterialStockDto implements IMaterialStockDto {
    id: number;
    storeNumber: string;
    storeName: string;
    categoryName: string;
    materialId: number;
    rawMaterialNumber: string;
    rawMaterialName: string;
    currencyName: string;
    storeId: number;
    regionId: number;
    areaId: number;
    qty: number;
    quantity: number;
    tenantId: number;
    qtyText: string;
    creationTime: moment.Moment;
    materialStockId: number;
    purchaseUnitOfMeasureQty: number;
    inventoryUnitOfMeasureQty: number;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureQty: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    price: number;
    sellingPrice: number;
    reOrderLevel: number;
    totalsales: number;
    totalpurchases: number;

    constructor(data?: IMaterialStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.categoryName = data["categoryName"];
            this.materialId = data["materialId"];
            this.rawMaterialNumber = data["rawMaterialNumber"];
            this.rawMaterialName = data["rawMaterialName"];
            this.currencyName = data["currencyName"];
            this.storeId = data["storeId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.qty = data["qty"];
            this.quantity = data["quantity"];
            this.tenantId = data["tenantId"];
            this.qtyText = data["qtyText"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.materialStockId = data["materialStockId"];
            this.purchaseUnitOfMeasureQty = data["purchaseUnitOfMeasureQty"];
            this.inventoryUnitOfMeasureQty = data["inventoryUnitOfMeasureQty"];
            this.inventoryUnitOfMeasureName = data["inventoryUnitOfMeasureName"];
            this.productUnitOfMeasureQty = data["productUnitOfMeasureQty"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.price = data["price"];
            this.sellingPrice = data["sellingPrice"];
            this.reOrderLevel = data["reOrderLevel"];
            this.totalsales = data["totalsales"];
            this.totalpurchases = data["totalpurchases"];
        }
    }

    static fromJS(data: any): MaterialStockDto {
        let result = new MaterialStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["categoryName"] = this.categoryName;
        data["materialId"] = this.materialId;
        data["rawMaterialNumber"] = this.rawMaterialNumber;
        data["rawMaterialName"] = this.rawMaterialName;
        data["currencyName"] = this.currencyName;
        data["storeId"] = this.storeId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["qty"] = this.qty;
        data["quantity"] = this.quantity;
        data["tenantId"] = this.tenantId;
        data["qtyText"] = this.qtyText;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["materialStockId"] = this.materialStockId;
        data["purchaseUnitOfMeasureQty"] = this.purchaseUnitOfMeasureQty;
        data["inventoryUnitOfMeasureQty"] = this.inventoryUnitOfMeasureQty;
        data["inventoryUnitOfMeasureName"] = this.inventoryUnitOfMeasureName;
        data["productUnitOfMeasureQty"] = this.productUnitOfMeasureQty;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["price"] = this.price;
        data["sellingPrice"] = this.sellingPrice;
        data["reOrderLevel"] = this.reOrderLevel;
        data["totalsales"] = this.totalsales;
        data["totalpurchases"] = this.totalpurchases;
        return data; 
    }
}

export interface IMaterialStockDto {
    id: number;
    storeNumber: string;
    storeName: string;
    categoryName: string;
    materialId: number;
    rawMaterialNumber: string;
    rawMaterialName: string;
    currencyName: string;
    storeId: number;
    regionId: number;
    areaId: number;
    qty: number;
    quantity: number;
    tenantId: number;
    qtyText: string;
    creationTime: moment.Moment;
    materialStockId: number;
    purchaseUnitOfMeasureQty: number;
    inventoryUnitOfMeasureQty: number;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureQty: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    price: number;
    sellingPrice: number;
    reOrderLevel: number;
    totalsales: number;
    totalpurchases: number;
}

export class ProductLotDto implements IProductLotDto {
    productLotId: number;
    storeId: number;
    storeName: string;
    code: string;
    productId: number;
    productName: string;
    productCode: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    quantityReturn: number;
    unitPurchasePrice: number;
    priceWithoutVat: number;
    productVariantId: number;
    productVariantName: string;
    remainingQuantity: number;
    editMode: boolean;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    vat: number;
    includeVAT: boolean;
    discountTypeId: number;
    discountAmount: number;
    totalCost: number;
    total: number;
    netCost: number;
    discount: number;
    productLotChildId: number;
    isReturn: boolean;

    constructor(data?: IProductLotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productLotId = data["productLotId"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.code = data["code"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productCode = data["productCode"];
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.quantity = data["quantity"];
            this.quantityReturn = data["quantityReturn"];
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.priceWithoutVat = data["priceWithoutVat"];
            this.productVariantId = data["productVariantId"];
            this.productVariantName = data["productVariantName"];
            this.remainingQuantity = data["remainingQuantity"];
            this.editMode = data["editMode"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.vat = data["vat"];
            this.includeVAT = data["includeVAT"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.totalCost = data["totalCost"];
            this.total = data["total"];
            this.netCost = data["netCost"];
            this.discount = data["discount"];
            this.productLotChildId = data["productLotChildId"];
            this.isReturn = data["isReturn"];
        }
    }

    static fromJS(data: any): ProductLotDto {
        let result = new ProductLotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLotId"] = this.productLotId;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["code"] = this.code;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["quantityReturn"] = this.quantityReturn;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["productVariantId"] = this.productVariantId;
        data["productVariantName"] = this.productVariantName;
        data["remainingQuantity"] = this.remainingQuantity;
        data["editMode"] = this.editMode;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["vat"] = this.vat;
        data["includeVAT"] = this.includeVAT;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["totalCost"] = this.totalCost;
        data["total"] = this.total;
        data["netCost"] = this.netCost;
        data["discount"] = this.discount;
        data["productLotChildId"] = this.productLotChildId;
        data["isReturn"] = this.isReturn;
        return data; 
    }
}

export interface IProductLotDto {
    productLotId: number;
    storeId: number;
    storeName: string;
    code: string;
    productId: number;
    productName: string;
    productCode: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    quantityReturn: number;
    unitPurchasePrice: number;
    priceWithoutVat: number;
    productVariantId: number;
    productVariantName: string;
    remainingQuantity: number;
    editMode: boolean;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    vat: number;
    includeVAT: boolean;
    discountTypeId: number;
    discountAmount: number;
    totalCost: number;
    total: number;
    netCost: number;
    discount: number;
    productLotChildId: number;
    isReturn: boolean;
}

export class ProductTranslationDto implements IProductTranslationDto {
    name: string;
    description: string;
    languageId: number;

    constructor(data?: IProductTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ProductTranslationDto {
        let result = new ProductTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IProductTranslationDto {
    name: string;
    description: string;
    languageId: number;
}

export class ProductVariantsDto implements IProductVariantsDto {
    selectedVariant1: SelectedVariantDto;
    selectedVariant2: SelectedVariantDto;
    selectedVariant3: SelectedVariantDto;

    constructor(data?: IProductVariantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.selectedVariant1 = data["selectedVariant1"] ? SelectedVariantDto.fromJS(data["selectedVariant1"]) : <any>undefined;
            this.selectedVariant2 = data["selectedVariant2"] ? SelectedVariantDto.fromJS(data["selectedVariant2"]) : <any>undefined;
            this.selectedVariant3 = data["selectedVariant3"] ? SelectedVariantDto.fromJS(data["selectedVariant3"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductVariantsDto {
        let result = new ProductVariantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedVariant1"] = this.selectedVariant1 ? this.selectedVariant1.toJSON() : <any>undefined;
        data["selectedVariant2"] = this.selectedVariant2 ? this.selectedVariant2.toJSON() : <any>undefined;
        data["selectedVariant3"] = this.selectedVariant3 ? this.selectedVariant3.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductVariantsDto {
    selectedVariant1: SelectedVariantDto;
    selectedVariant2: SelectedVariantDto;
    selectedVariant3: SelectedVariantDto;
}

export class SelectedVariantDto implements ISelectedVariantDto {
    variantId: number;
    variantName: string;
    selectedValuesIds: number[];

    constructor(data?: ISelectedVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variantId = data["variantId"];
            this.variantName = data["variantName"];
            if (data["selectedValuesIds"] && data["selectedValuesIds"].constructor === Array) {
                this.selectedValuesIds = [];
                for (let item of data["selectedValuesIds"])
                    this.selectedValuesIds.push(item);
            }
        }
    }

    static fromJS(data: any): SelectedVariantDto {
        let result = new SelectedVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        if (this.selectedValuesIds && this.selectedValuesIds.constructor === Array) {
            data["selectedValuesIds"] = [];
            for (let item of this.selectedValuesIds)
                data["selectedValuesIds"].push(item);
        }
        return data; 
    }
}

export interface ISelectedVariantDto {
    variantId: number;
    variantName: string;
    selectedValuesIds: number[];
}

export class ListResultDtoOfMainTransactionListItem implements IListResultDtoOfMainTransactionListItem {
    items: MainTransactionListItem[];

    constructor(data?: IListResultDtoOfMainTransactionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MainTransactionListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMainTransactionListItem {
        let result = new ListResultDtoOfMainTransactionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMainTransactionListItem {
    items: MainTransactionListItem[];
}

export class MainTransactionListItem implements IMainTransactionListItem {
    id: number;
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    storeName: string;
    date: moment.Moment;
    dateStockOpening: string;
    lotNumber: number;
    code: string;
    isRevision: number;
    fromStoreName: string;
    toStoreName: string;
    fromStoreCode: string;
    toStoreCode: string;
    supplierName: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    transactionTypeValue: number;
    receiveNumber: string;
    supplierId: number;
    transactionTemplateId: number;
    parentId: number;
    saleTypeId: number;
    menuItemId: number;
    tenantId: number;
    status: number;
    statusLocalized: string;
    statusOpening: string;
    detailTransactions: DetailTransaction[];
    userRoles: RoleTransactionTypeDto[];
    showButton: boolean;
    notes: string;
    documentNumber: string;
    totalCost: number;

    constructor(data?: IMainTransactionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.mainTransactionId = data["mainTransactionId"];
            this.fromStoreId = data["fromStoreId"];
            this.toStoreId = data["toStoreId"];
            this.storeName = data["storeName"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.dateStockOpening = data["dateStockOpening"];
            this.lotNumber = data["lotNumber"];
            this.code = data["code"];
            this.isRevision = data["isRevision"];
            this.fromStoreName = data["fromStoreName"];
            this.toStoreName = data["toStoreName"];
            this.fromStoreCode = data["fromStoreCode"];
            this.toStoreCode = data["toStoreCode"];
            this.supplierName = data["supplierName"];
            this.fromStoreTpypeId = data["fromStoreTpypeId"];
            this.toStoreTpypeId = data["toStoreTpypeId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.transactionTypeValue = data["transactionTypeValue"];
            this.receiveNumber = data["receiveNumber"];
            this.supplierId = data["supplierId"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.parentId = data["parentId"];
            this.saleTypeId = data["saleTypeId"];
            this.menuItemId = data["menuItemId"];
            this.tenantId = data["tenantId"];
            this.status = data["status"];
            this.statusLocalized = data["statusLocalized"];
            this.statusOpening = data["statusOpening"];
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransaction.fromJS(item));
            }
            if (data["userRoles"] && data["userRoles"].constructor === Array) {
                this.userRoles = [];
                for (let item of data["userRoles"])
                    this.userRoles.push(RoleTransactionTypeDto.fromJS(item));
            }
            this.showButton = data["showButton"];
            this.notes = data["notes"];
            this.documentNumber = data["documentNumber"];
            this.totalCost = data["totalCost"];
        }
    }

    static fromJS(data: any): MainTransactionListItem {
        let result = new MainTransactionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mainTransactionId"] = this.mainTransactionId;
        data["fromStoreId"] = this.fromStoreId;
        data["toStoreId"] = this.toStoreId;
        data["storeName"] = this.storeName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateStockOpening"] = this.dateStockOpening;
        data["lotNumber"] = this.lotNumber;
        data["code"] = this.code;
        data["isRevision"] = this.isRevision;
        data["fromStoreName"] = this.fromStoreName;
        data["toStoreName"] = this.toStoreName;
        data["fromStoreCode"] = this.fromStoreCode;
        data["toStoreCode"] = this.toStoreCode;
        data["supplierName"] = this.supplierName;
        data["fromStoreTpypeId"] = this.fromStoreTpypeId;
        data["toStoreTpypeId"] = this.toStoreTpypeId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionTypeValue"] = this.transactionTypeValue;
        data["receiveNumber"] = this.receiveNumber;
        data["supplierId"] = this.supplierId;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["parentId"] = this.parentId;
        data["saleTypeId"] = this.saleTypeId;
        data["menuItemId"] = this.menuItemId;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["statusLocalized"] = this.statusLocalized;
        data["statusOpening"] = this.statusOpening;
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        if (this.userRoles && this.userRoles.constructor === Array) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        data["showButton"] = this.showButton;
        data["notes"] = this.notes;
        data["documentNumber"] = this.documentNumber;
        data["totalCost"] = this.totalCost;
        return data; 
    }
}

export interface IMainTransactionListItem {
    id: number;
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    storeName: string;
    date: moment.Moment;
    dateStockOpening: string;
    lotNumber: number;
    code: string;
    isRevision: number;
    fromStoreName: string;
    toStoreName: string;
    fromStoreCode: string;
    toStoreCode: string;
    supplierName: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    transactionTypeValue: number;
    receiveNumber: string;
    supplierId: number;
    transactionTemplateId: number;
    parentId: number;
    saleTypeId: number;
    menuItemId: number;
    tenantId: number;
    status: number;
    statusLocalized: string;
    statusOpening: string;
    detailTransactions: DetailTransaction[];
    userRoles: RoleTransactionTypeDto[];
    showButton: boolean;
    notes: string;
    documentNumber: string;
    totalCost: number;
}

export class RoleTransactionTypeDto implements IRoleTransactionTypeDto {
    roleId: number;
    transactionTypeId: number;
    tenantId: number;

    constructor(data?: IRoleTransactionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): RoleTransactionTypeDto {
        let result = new RoleTransactionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IRoleTransactionTypeDto {
    roleId: number;
    transactionTypeId: number;
    tenantId: number;
}

export class UpdateMainTransactionInput implements IUpdateMainTransactionInput {
    id: number;
    mainTransactionId: number;
    rawMaterialId: number;
    quantity: number;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    notes: string;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    tenantId: number;
    saleTypeId: number;
    menuItemId: number;
    mainMaterialId: number;
    rawMatrialQuantity: number;

    constructor(data?: IUpdateMainTransactionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.mainTransactionId = data["mainTransactionId"];
            this.rawMaterialId = data["rawMaterialId"];
            this.quantity = data["quantity"];
            this.fromStoreId = data["fromStoreId"];
            this.toStoreId = data["toStoreId"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.code = data["code"];
            this.fromStoreTpypeId = data["fromStoreTpypeId"];
            this.toStoreTpypeId = data["toStoreTpypeId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.tenantId = data["tenantId"];
            this.saleTypeId = data["saleTypeId"];
            this.menuItemId = data["menuItemId"];
            this.mainMaterialId = data["mainMaterialId"];
            this.rawMatrialQuantity = data["rawMatrialQuantity"];
        }
    }

    static fromJS(data: any): UpdateMainTransactionInput {
        let result = new UpdateMainTransactionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mainTransactionId"] = this.mainTransactionId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["quantity"] = this.quantity;
        data["fromStoreId"] = this.fromStoreId;
        data["toStoreId"] = this.toStoreId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["code"] = this.code;
        data["fromStoreTpypeId"] = this.fromStoreTpypeId;
        data["toStoreTpypeId"] = this.toStoreTpypeId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["tenantId"] = this.tenantId;
        data["saleTypeId"] = this.saleTypeId;
        data["menuItemId"] = this.menuItemId;
        data["mainMaterialId"] = this.mainMaterialId;
        data["rawMatrialQuantity"] = this.rawMatrialQuantity;
        return data; 
    }
}

export interface IUpdateMainTransactionInput {
    id: number;
    mainTransactionId: number;
    rawMaterialId: number;
    quantity: number;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    notes: string;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    tenantId: number;
    saleTypeId: number;
    menuItemId: number;
    mainMaterialId: number;
    rawMatrialQuantity: number;
}

export class CreateMainTransactionInput implements ICreateMainTransactionInput {
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    notes: string;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    receiveNumber: string;
    supplierId: number;
    transactionTemplateId: number;
    lotNumber: number;
    parentId: number;
    saleTypeId: number;
    menuItemId: number;
    mainMaterialId: number;
    quantity: number;
    detailTransactions: DetailTransaction[];
    tenantId: number;
    rawMatrialQuantity: number;
    netAfterVat: number;
    netBeforVat: number;
    totalVat: number;
    documentNumber: string;
    currencyId: number;
    currencyRate: number;

    constructor(data?: ICreateMainTransactionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mainTransactionId = data["mainTransactionId"];
            this.fromStoreId = data["fromStoreId"];
            this.toStoreId = data["toStoreId"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.code = data["code"];
            this.fromStoreTpypeId = data["fromStoreTpypeId"];
            this.toStoreTpypeId = data["toStoreTpypeId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.receiveNumber = data["receiveNumber"];
            this.supplierId = data["supplierId"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.lotNumber = data["lotNumber"];
            this.parentId = data["parentId"];
            this.saleTypeId = data["saleTypeId"];
            this.menuItemId = data["menuItemId"];
            this.mainMaterialId = data["mainMaterialId"];
            this.quantity = data["quantity"];
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransaction.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.rawMatrialQuantity = data["rawMatrialQuantity"];
            this.netAfterVat = data["netAfterVat"];
            this.netBeforVat = data["netBeforVat"];
            this.totalVat = data["totalVat"];
            this.documentNumber = data["documentNumber"];
            this.currencyId = data["currencyId"];
            this.currencyRate = data["currencyRate"];
        }
    }

    static fromJS(data: any): CreateMainTransactionInput {
        let result = new CreateMainTransactionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainTransactionId"] = this.mainTransactionId;
        data["fromStoreId"] = this.fromStoreId;
        data["toStoreId"] = this.toStoreId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["code"] = this.code;
        data["fromStoreTpypeId"] = this.fromStoreTpypeId;
        data["toStoreTpypeId"] = this.toStoreTpypeId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["receiveNumber"] = this.receiveNumber;
        data["supplierId"] = this.supplierId;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["lotNumber"] = this.lotNumber;
        data["parentId"] = this.parentId;
        data["saleTypeId"] = this.saleTypeId;
        data["menuItemId"] = this.menuItemId;
        data["mainMaterialId"] = this.mainMaterialId;
        data["quantity"] = this.quantity;
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["rawMatrialQuantity"] = this.rawMatrialQuantity;
        data["netAfterVat"] = this.netAfterVat;
        data["netBeforVat"] = this.netBeforVat;
        data["totalVat"] = this.totalVat;
        data["documentNumber"] = this.documentNumber;
        data["currencyId"] = this.currencyId;
        data["currencyRate"] = this.currencyRate;
        return data; 
    }
}

export interface ICreateMainTransactionInput {
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    notes: string;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    receiveNumber: string;
    supplierId: number;
    transactionTemplateId: number;
    lotNumber: number;
    parentId: number;
    saleTypeId: number;
    menuItemId: number;
    mainMaterialId: number;
    quantity: number;
    detailTransactions: DetailTransaction[];
    tenantId: number;
    rawMatrialQuantity: number;
    netAfterVat: number;
    netBeforVat: number;
    totalVat: number;
    documentNumber: string;
    currencyId: number;
    currencyRate: number;
}

export class PagedMainTransactionList implements IPagedMainTransactionList {
    currentPage: number;
    itemsCount: number;
    mainTransactions: MainTransactionListItem[];

    constructor(data?: IPagedMainTransactionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["mainTransactions"] && data["mainTransactions"].constructor === Array) {
                this.mainTransactions = [];
                for (let item of data["mainTransactions"])
                    this.mainTransactions.push(MainTransactionListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedMainTransactionList {
        let result = new PagedMainTransactionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.mainTransactions && this.mainTransactions.constructor === Array) {
            data["mainTransactions"] = [];
            for (let item of this.mainTransactions)
                data["mainTransactions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedMainTransactionList {
    currentPage: number;
    itemsCount: number;
    mainTransactions: MainTransactionListItem[];
}

export class CreateBusinessCentralSettingInput implements ICreateBusinessCentralSettingInput {
    grantType: string;
    clientId: string;
    organizationUrl: string;
    scope: string;
    clientSecret: string;
    authUrl: string;
    salesOrderUrls: CreateSalesOrderUrlInput[];

    constructor(data?: ICreateBusinessCentralSettingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.grantType = data["grantType"];
            this.clientId = data["clientId"];
            this.organizationUrl = data["organizationUrl"];
            this.scope = data["scope"];
            this.clientSecret = data["clientSecret"];
            this.authUrl = data["authUrl"];
            if (data["salesOrderUrls"] && data["salesOrderUrls"].constructor === Array) {
                this.salesOrderUrls = [];
                for (let item of data["salesOrderUrls"])
                    this.salesOrderUrls.push(CreateSalesOrderUrlInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBusinessCentralSettingInput {
        let result = new CreateBusinessCentralSettingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["organizationUrl"] = this.organizationUrl;
        data["scope"] = this.scope;
        data["clientSecret"] = this.clientSecret;
        data["authUrl"] = this.authUrl;
        if (this.salesOrderUrls && this.salesOrderUrls.constructor === Array) {
            data["salesOrderUrls"] = [];
            for (let item of this.salesOrderUrls)
                data["salesOrderUrls"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateBusinessCentralSettingInput {
    grantType: string;
    clientId: string;
    organizationUrl: string;
    scope: string;
    clientSecret: string;
    authUrl: string;
    salesOrderUrls: CreateSalesOrderUrlInput[];
}

export class CreateSalesOrderUrlInput implements ICreateSalesOrderUrlInput {
    id: string;
    url: string;
    thirdPartyBusinessCentralId: string;
    areaId: number;
    encryptionKey: string;

    constructor(data?: ICreateSalesOrderUrlInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.url = data["url"];
            this.thirdPartyBusinessCentralId = data["thirdPartyBusinessCentralId"];
            this.areaId = data["areaId"];
            this.encryptionKey = data["encryptionKey"];
        }
    }

    static fromJS(data: any): CreateSalesOrderUrlInput {
        let result = new CreateSalesOrderUrlInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["thirdPartyBusinessCentralId"] = this.thirdPartyBusinessCentralId;
        data["areaId"] = this.areaId;
        data["encryptionKey"] = this.encryptionKey;
        return data; 
    }
}

export interface ICreateSalesOrderUrlInput {
    id: string;
    url: string;
    thirdPartyBusinessCentralId: string;
    areaId: number;
    encryptionKey: string;
}

export class SalesReportInput implements ISalesReportInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: ISalesReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTransactionId = data["saleTransactionId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.orderNumber = data["orderNumber"];
            this.customerNumber = data["customerNumber"];
            this.productInfo = data["productInfo"];
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            this.exportToExcel = data["exportToExcel"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.documentType = data["documentType"];
            this.cashierShiftId = data["cashierShiftId"];
            this.printInvoice = data["printInvoice"];
            this.byShiftDate = data["byShiftDate"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.endOfDayBusiness = data["endOfDayBusiness"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): SalesReportInput {
        let result = new SalesReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTransactionId"] = this.saleTransactionId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["orderNumber"] = this.orderNumber;
        data["customerNumber"] = this.customerNumber;
        data["productInfo"] = this.productInfo;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["exportToExcel"] = this.exportToExcel;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["cashierShiftId"] = this.cashierShiftId;
        data["printInvoice"] = this.printInvoice;
        data["byShiftDate"] = this.byShiftDate;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["endOfDayBusiness"] = this.endOfDayBusiness;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ISalesReportInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class SalesReportDto implements ISalesReportDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportDetailsDto[];

    constructor(data?: ISalesReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationGrandTotalIncludingVAT = data["summationGrandTotalIncludingVAT"];
            this.summationVAT = data["summationVAT"];
            this.summationDiscount = data["summationDiscount"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.templateType = data["templateType"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SalesReportDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportDto {
        let result = new SalesReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationGrandTotalIncludingVAT"] = this.summationGrandTotalIncludingVAT;
        data["summationVAT"] = this.summationVAT;
        data["summationDiscount"] = this.summationDiscount;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["templateType"] = this.templateType;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportDetailsDto[];
}

export class SalesReportDetailsDto implements ISalesReportDetailsDto {
    id: string;
    tenantName: string;
    date: string;
    saleDate: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    salesName: string;
    total: number;
    vat: number;
    grandTotal: number;
    discountValue: number;
    promotionValue: number;
    grandTotalIncluding: number;
    currency: string;
    templateType: string;
    cashierName1: string;
    currency1: string;
    transactionStatusText: string;
    selected: boolean;
    refRecieptNumber: string;
    tenderTypeName: string;

    constructor(data?: ISalesReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantName = data["tenantName"];
            this.date = data["date"];
            this.saleDate = data["saleDate"];
            this.time = data["time"];
            this.saleTypeName = data["saleTypeName"];
            this.orderNumber = data["orderNumber"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.cashierName = data["cashierName"];
            this.salesName = data["salesName"];
            this.total = data["total"];
            this.vat = data["vat"];
            this.grandTotal = data["grandTotal"];
            this.discountValue = data["discountValue"];
            this.promotionValue = data["promotionValue"];
            this.grandTotalIncluding = data["grandTotalIncluding"];
            this.currency = data["currency"];
            this.templateType = data["templateType"];
            this.cashierName1 = data["cashierName1"];
            this.currency1 = data["currency1"];
            this.transactionStatusText = data["transactionStatusText"];
            this.selected = data["selected"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.tenderTypeName = data["tenderTypeName"];
        }
    }

    static fromJS(data: any): SalesReportDetailsDto {
        let result = new SalesReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["date"] = this.date;
        data["saleDate"] = this.saleDate;
        data["time"] = this.time;
        data["saleTypeName"] = this.saleTypeName;
        data["orderNumber"] = this.orderNumber;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["cashierName"] = this.cashierName;
        data["salesName"] = this.salesName;
        data["total"] = this.total;
        data["vat"] = this.vat;
        data["grandTotal"] = this.grandTotal;
        data["discountValue"] = this.discountValue;
        data["promotionValue"] = this.promotionValue;
        data["grandTotalIncluding"] = this.grandTotalIncluding;
        data["currency"] = this.currency;
        data["templateType"] = this.templateType;
        data["cashierName1"] = this.cashierName1;
        data["currency1"] = this.currency1;
        data["transactionStatusText"] = this.transactionStatusText;
        data["selected"] = this.selected;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["tenderTypeName"] = this.tenderTypeName;
        return data; 
    }
}

export interface ISalesReportDetailsDto {
    id: string;
    tenantName: string;
    date: string;
    saleDate: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    salesName: string;
    total: number;
    vat: number;
    grandTotal: number;
    discountValue: number;
    promotionValue: number;
    grandTotalIncluding: number;
    currency: string;
    templateType: string;
    cashierName1: string;
    currency1: string;
    transactionStatusText: string;
    selected: boolean;
    refRecieptNumber: string;
    tenderTypeName: string;
}

export class BusinessCentralAuthDTO implements IBusinessCentralAuthDTO {
    id: string;
    grantType: string;
    clientId: string;
    scope: string;
    clientSecret: string;
    authUrl: string;
    salesOrderUrl: string;
    salesOrderUrls: CreateSalesOrderUrlInput[];

    constructor(data?: IBusinessCentralAuthDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.grantType = data["grantType"];
            this.clientId = data["clientId"];
            this.scope = data["scope"];
            this.clientSecret = data["clientSecret"];
            this.authUrl = data["authUrl"];
            this.salesOrderUrl = data["salesOrderUrl"];
            if (data["salesOrderUrls"] && data["salesOrderUrls"].constructor === Array) {
                this.salesOrderUrls = [];
                for (let item of data["salesOrderUrls"])
                    this.salesOrderUrls.push(CreateSalesOrderUrlInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessCentralAuthDTO {
        let result = new BusinessCentralAuthDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["scope"] = this.scope;
        data["clientSecret"] = this.clientSecret;
        data["authUrl"] = this.authUrl;
        data["salesOrderUrl"] = this.salesOrderUrl;
        if (this.salesOrderUrls && this.salesOrderUrls.constructor === Array) {
            data["salesOrderUrls"] = [];
            for (let item of this.salesOrderUrls)
                data["salesOrderUrls"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBusinessCentralAuthDTO {
    id: string;
    grantType: string;
    clientId: string;
    scope: string;
    clientSecret: string;
    authUrl: string;
    salesOrderUrl: string;
    salesOrderUrls: CreateSalesOrderUrlInput[];
}

export class EditBusinessCentralInput implements IEditBusinessCentralInput {
    id: string;
    grantType: string;
    clientId: string;
    organizationUrl: string;
    scope: string;
    clientSecret: string;
    authUrl: string;
    salesOrderUrls: CreateSalesOrderUrlInput[];

    constructor(data?: IEditBusinessCentralInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.grantType = data["grantType"];
            this.clientId = data["clientId"];
            this.organizationUrl = data["organizationUrl"];
            this.scope = data["scope"];
            this.clientSecret = data["clientSecret"];
            this.authUrl = data["authUrl"];
            if (data["salesOrderUrls"] && data["salesOrderUrls"].constructor === Array) {
                this.salesOrderUrls = [];
                for (let item of data["salesOrderUrls"])
                    this.salesOrderUrls.push(CreateSalesOrderUrlInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditBusinessCentralInput {
        let result = new EditBusinessCentralInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["organizationUrl"] = this.organizationUrl;
        data["scope"] = this.scope;
        data["clientSecret"] = this.clientSecret;
        data["authUrl"] = this.authUrl;
        if (this.salesOrderUrls && this.salesOrderUrls.constructor === Array) {
            data["salesOrderUrls"] = [];
            for (let item of this.salesOrderUrls)
                data["salesOrderUrls"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditBusinessCentralInput {
    id: string;
    grantType: string;
    clientId: string;
    organizationUrl: string;
    scope: string;
    clientSecret: string;
    authUrl: string;
    salesOrderUrls: CreateSalesOrderUrlInput[];
}

export class ValueTupleOfInt32AndInt32 implements IValueTupleOfInt32AndInt32 {
    item1: number;
    item2: number;

    constructor(data?: IValueTupleOfInt32AndInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfInt32AndInt32 {
        let result = new ValueTupleOfInt32AndInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data; 
    }
}

export interface IValueTupleOfInt32AndInt32 {
    item1: number;
    item2: number;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items: CacheDto[];

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[];
}

export class CacheDto implements ICacheDto {
    name: string;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICacheDto {
    name: string;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id: string;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfString {
    id: string;
}

export class CashierShiftDto implements ICashierShiftDto {
    id: number;
    cashierShiftPaymentTransactionValues: CasheirPaymentTransactionsValuesDto[];

    constructor(data?: ICashierShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["cashierShiftPaymentTransactionValues"] && data["cashierShiftPaymentTransactionValues"].constructor === Array) {
                this.cashierShiftPaymentTransactionValues = [];
                for (let item of data["cashierShiftPaymentTransactionValues"])
                    this.cashierShiftPaymentTransactionValues.push(CasheirPaymentTransactionsValuesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CashierShiftDto {
        let result = new CashierShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.cashierShiftPaymentTransactionValues && this.cashierShiftPaymentTransactionValues.constructor === Array) {
            data["cashierShiftPaymentTransactionValues"] = [];
            for (let item of this.cashierShiftPaymentTransactionValues)
                data["cashierShiftPaymentTransactionValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICashierShiftDto {
    id: number;
    cashierShiftPaymentTransactionValues: CasheirPaymentTransactionsValuesDto[];
}

export class CasheirPaymentTransactionsValuesDto implements ICasheirPaymentTransactionsValuesDto {
    id: string;
    currencyName: string;
    tenderTypeName: string;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierTransactionsValue: number;

    constructor(data?: ICasheirPaymentTransactionsValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.currencyName = data["currencyName"];
            this.tenderTypeName = data["tenderTypeName"];
            this.actualTransactionsValue = data["actualTransactionsValue"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.cashierTransactionsValue = data["cashierTransactionsValue"];
        }
    }

    static fromJS(data: any): CasheirPaymentTransactionsValuesDto {
        let result = new CasheirPaymentTransactionsValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currencyName"] = this.currencyName;
        data["tenderTypeName"] = this.tenderTypeName;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["cashierTransactionsValue"] = this.cashierTransactionsValue;
        return data; 
    }
}

export interface ICasheirPaymentTransactionsValuesDto {
    id: string;
    currencyName: string;
    tenderTypeName: string;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierTransactionsValue: number;
}

export class EndOfDayDto implements IEndOfDayDto {
    id: number;
    cashierShiftId: number;
    endOfDayID: number;
    startOfDayTiming: string;
    endOfDayTiming: string;
    date: moment.Moment;
    status: number;
    syncStatus: number;
    dayStatus: number;
    cashierStatus: number;
    isValid: boolean;
    canLogin: boolean;
    startOfDayDate: moment.Moment;
    endOfDayDate: moment.Moment;
    isActiveEndOfDay: boolean;
    actualStartedOn: moment.Moment;
    actualEndedOn: moment.Moment;

    constructor(data?: IEndOfDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.cashierShiftId = data["cashierShiftId"];
            this.endOfDayID = data["endOfDayID"];
            this.startOfDayTiming = data["startOfDayTiming"];
            this.endOfDayTiming = data["endOfDayTiming"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.status = data["status"];
            this.syncStatus = data["syncStatus"];
            this.dayStatus = data["dayStatus"];
            this.cashierStatus = data["cashierStatus"];
            this.isValid = data["isValid"];
            this.canLogin = data["canLogin"];
            this.startOfDayDate = data["startOfDayDate"] ? moment(data["startOfDayDate"].toString()) : <any>undefined;
            this.endOfDayDate = data["endOfDayDate"] ? moment(data["endOfDayDate"].toString()) : <any>undefined;
            this.isActiveEndOfDay = data["isActiveEndOfDay"];
            this.actualStartedOn = data["actualStartedOn"] ? moment(data["actualStartedOn"].toString()) : <any>undefined;
            this.actualEndedOn = data["actualEndedOn"] ? moment(data["actualEndedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EndOfDayDto {
        let result = new EndOfDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cashierShiftId"] = this.cashierShiftId;
        data["endOfDayID"] = this.endOfDayID;
        data["startOfDayTiming"] = this.startOfDayTiming;
        data["endOfDayTiming"] = this.endOfDayTiming;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["syncStatus"] = this.syncStatus;
        data["dayStatus"] = this.dayStatus;
        data["cashierStatus"] = this.cashierStatus;
        data["isValid"] = this.isValid;
        data["canLogin"] = this.canLogin;
        data["startOfDayDate"] = this.startOfDayDate ? this.startOfDayDate.toISOString() : <any>undefined;
        data["endOfDayDate"] = this.endOfDayDate ? this.endOfDayDate.toISOString() : <any>undefined;
        data["isActiveEndOfDay"] = this.isActiveEndOfDay;
        data["actualStartedOn"] = this.actualStartedOn ? this.actualStartedOn.toISOString() : <any>undefined;
        data["actualEndedOn"] = this.actualEndedOn ? this.actualEndedOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEndOfDayDto {
    id: number;
    cashierShiftId: number;
    endOfDayID: number;
    startOfDayTiming: string;
    endOfDayTiming: string;
    date: moment.Moment;
    status: number;
    syncStatus: number;
    dayStatus: number;
    cashierStatus: number;
    isValid: boolean;
    canLogin: boolean;
    startOfDayDate: moment.Moment;
    endOfDayDate: moment.Moment;
    isActiveEndOfDay: boolean;
    actualStartedOn: moment.Moment;
    actualEndedOn: moment.Moment;
}

export class ValueTupleOfBooleanAndDateTimeAndDateTime implements IValueTupleOfBooleanAndDateTimeAndDateTime {
    item1: boolean;
    item2: moment.Moment;
    item3: moment.Moment;

    constructor(data?: IValueTupleOfBooleanAndDateTimeAndDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"] ? moment(data["item2"].toString()) : <any>undefined;
            this.item3 = data["item3"] ? moment(data["item3"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValueTupleOfBooleanAndDateTimeAndDateTime {
        let result = new ValueTupleOfBooleanAndDateTimeAndDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2 ? this.item2.toISOString() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IValueTupleOfBooleanAndDateTimeAndDateTime {
    item1: boolean;
    item2: moment.Moment;
    item3: moment.Moment;
}

export class ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime implements IValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime {
    item1: boolean;
    item2: moment.Moment;
    item3: moment.Moment;

    constructor(data?: IValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"] ? moment(data["item2"].toString()) : <any>undefined;
            this.item3 = data["item3"] ? moment(data["item3"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime {
        let result = new ValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2 ? this.item2.toISOString() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IValueTupleOfBooleanAndNullableOfDateTimeAndNullableOfDateTime {
    item1: boolean;
    item2: moment.Moment;
    item3: moment.Moment;
}

export class ListResultDtoOfCashierShiftListItem implements IListResultDtoOfCashierShiftListItem {
    items: CashierShiftListItem[];

    constructor(data?: IListResultDtoOfCashierShiftListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CashierShiftListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCashierShiftListItem {
        let result = new ListResultDtoOfCashierShiftListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCashierShiftListItem {
    items: CashierShiftListItem[];
}

export class CashierShiftListItem implements ICashierShiftListItem {
    id: number;
    name: string;
    isPending: boolean;

    constructor(data?: ICashierShiftListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.isPending = data["isPending"];
        }
    }

    static fromJS(data: any): CashierShiftListItem {
        let result = new CashierShiftListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isPending"] = this.isPending;
        return data; 
    }
}

export interface ICashierShiftListItem {
    id: number;
    name: string;
    isPending: boolean;
}

export class CashierDto implements ICashierDto {
    id: number;
    name: string;
    userName: string;
    code: string;

    constructor(data?: ICashierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): CashierDto {
        let result = new CashierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["code"] = this.code;
        return data; 
    }
}

export interface ICashierDto {
    id: number;
    name: string;
    userName: string;
    code: string;
}

export class SalesManDto implements ISalesManDto {
    id: number;
    name: string;

    constructor(data?: ISalesManDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SalesManDto {
        let result = new SalesManDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ISalesManDto {
    id: number;
    name: string;
}

export class CashierShiftSyncDto implements ICashierShiftSyncDto {
    cashierShiftId: number;
    cashierShiftPaymentDto: CashierShiftPaymentSyncDto[];
    masterCashInOutSyncDto: MasterCashInOutSyncDto[];

    constructor(data?: ICashierShiftSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cashierShiftId = data["cashierShiftId"];
            if (data["cashierShiftPaymentDto"] && data["cashierShiftPaymentDto"].constructor === Array) {
                this.cashierShiftPaymentDto = [];
                for (let item of data["cashierShiftPaymentDto"])
                    this.cashierShiftPaymentDto.push(CashierShiftPaymentSyncDto.fromJS(item));
            }
            if (data["masterCashInOutSyncDto"] && data["masterCashInOutSyncDto"].constructor === Array) {
                this.masterCashInOutSyncDto = [];
                for (let item of data["masterCashInOutSyncDto"])
                    this.masterCashInOutSyncDto.push(MasterCashInOutSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CashierShiftSyncDto {
        let result = new CashierShiftSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierShiftId"] = this.cashierShiftId;
        if (this.cashierShiftPaymentDto && this.cashierShiftPaymentDto.constructor === Array) {
            data["cashierShiftPaymentDto"] = [];
            for (let item of this.cashierShiftPaymentDto)
                data["cashierShiftPaymentDto"].push(item.toJSON());
        }
        if (this.masterCashInOutSyncDto && this.masterCashInOutSyncDto.constructor === Array) {
            data["masterCashInOutSyncDto"] = [];
            for (let item of this.masterCashInOutSyncDto)
                data["masterCashInOutSyncDto"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICashierShiftSyncDto {
    cashierShiftId: number;
    cashierShiftPaymentDto: CashierShiftPaymentSyncDto[];
    masterCashInOutSyncDto: MasterCashInOutSyncDto[];
}

export class CashierShiftPaymentSyncDto implements ICashierShiftPaymentSyncDto {
    id: string;
    currencyId: number;
    tenderTypeId: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierTransactionsValue: number;
    cashierShiftId: number;

    constructor(data?: ICashierShiftPaymentSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.currencyId = data["currencyId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.actualTransactionsValue = data["actualTransactionsValue"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.cashierTransactionsValue = data["cashierTransactionsValue"];
            this.cashierShiftId = data["cashierShiftId"];
        }
    }

    static fromJS(data: any): CashierShiftPaymentSyncDto {
        let result = new CashierShiftPaymentSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currencyId"] = this.currencyId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["cashierTransactionsValue"] = this.cashierTransactionsValue;
        data["cashierShiftId"] = this.cashierShiftId;
        return data; 
    }
}

export interface ICashierShiftPaymentSyncDto {
    id: string;
    currencyId: number;
    tenderTypeId: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierTransactionsValue: number;
    cashierShiftId: number;
}

export class MasterCashInOutSyncDto implements IMasterCashInOutSyncDto {
    id: string;
    currencyId: number;
    tenderTypeMasterId: number;
    cashierTransactionsValue: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierShiftId: number;

    constructor(data?: IMasterCashInOutSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.currencyId = data["currencyId"];
            this.tenderTypeMasterId = data["tenderTypeMasterId"];
            this.cashierTransactionsValue = data["cashierTransactionsValue"];
            this.actualTransactionsValue = data["actualTransactionsValue"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.cashierShiftId = data["cashierShiftId"];
        }
    }

    static fromJS(data: any): MasterCashInOutSyncDto {
        let result = new MasterCashInOutSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currencyId"] = this.currencyId;
        data["tenderTypeMasterId"] = this.tenderTypeMasterId;
        data["cashierTransactionsValue"] = this.cashierTransactionsValue;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["cashierShiftId"] = this.cashierShiftId;
        return data; 
    }
}

export interface IMasterCashInOutSyncDto {
    id: string;
    currencyId: number;
    tenderTypeMasterId: number;
    cashierTransactionsValue: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierShiftId: number;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[];

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : <any>undefined;
            if (data["friends"] && data["friends"].constructor === Array) {
                this.friends = [];
                for (let item of data["friends"])
                    this.friends.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (this.friends && this.friends.constructor === Array) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[];
}

export class FriendDto implements IFriendDto {
    friendUserId: number;
    friendTenantId: number;
    friendUserName: string;
    friendTenancyName: string;
    friendProfilePictureId: string;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendDtoState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data; 
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number;
    friendUserName: string;
    friendTenancyName: string;
    friendProfilePictureId: string;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendDtoState;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[];

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[];
}

export class ChatMessageDto implements IChatMessageDto {
    userId: number;
    tenantId: number;
    targetUserId: number;
    targetTenantId: number;
    side: ChatMessageDtoSide;
    readState: ChatMessageDtoReadState;
    receiverReadState: ChatMessageDtoReceiverReadState;
    message: string;
    creationTime: moment.Moment;
    sharedMessageId: string;
    id: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number;
    targetUserId: number;
    targetTenantId: number;
    side: ChatMessageDtoSide;
    readState: ChatMessageDtoReadState;
    receiverReadState: ChatMessageDtoReceiverReadState;
    message: string;
    creationTime: moment.Moment;
    sharedMessageId: string;
    id: number;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number;
    userId: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number;
    userId: number;
}

export class ClubInput implements IClubInput {
    id: number;
    translations: ClubTranslationDto[];

    constructor(data?: IClubInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ClubTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClubInput {
        let result = new ClubInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IClubInput {
    id: number;
    translations: ClubTranslationDto[];
}

export class ClubTranslationDto implements IClubTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IClubTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ClubTranslationDto {
        let result = new ClubTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IClubTranslationDto {
    name: string;
    languageId: number;
}

export class PagedClubList implements IPagedClubList {
    currentPage: number;
    itemsCount: number;
    clubs: ClubDto[];

    constructor(data?: IPagedClubList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["clubs"] && data["clubs"].constructor === Array) {
                this.clubs = [];
                for (let item of data["clubs"])
                    this.clubs.push(ClubDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedClubList {
        let result = new PagedClubList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.clubs && this.clubs.constructor === Array) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedClubList {
    currentPage: number;
    itemsCount: number;
    clubs: ClubDto[];
}

export class ClubDto implements IClubDto {
    id: number;
    name: string;

    constructor(data?: IClubDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ClubDto {
        let result = new ClubDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IClubDto {
    id: number;
    name: string;
}

export class ListResultDtoOfClubDto implements IListResultDtoOfClubDto {
    items: ClubDto[];

    constructor(data?: IListResultDtoOfClubDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ClubDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfClubDto {
        let result = new ListResultDtoOfClubDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfClubDto {
    items: ClubDto[];
}

export class CreateClusterInput implements ICreateClusterInput {
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    translations: ClusterTranslationDto[];

    constructor(data?: ICreateClusterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.enableCoordinatore = data["enableCoordinatore"];
            this.enableCloudeFallback = data["enableCloudeFallback"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ClusterTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateClusterInput {
        let result = new CreateClusterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["enableCoordinatore"] = this.enableCoordinatore;
        data["enableCloudeFallback"] = this.enableCloudeFallback;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateClusterInput {
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    translations: ClusterTranslationDto[];
}

export class ClusterTranslationDto implements IClusterTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IClusterTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ClusterTranslationDto {
        let result = new ClusterTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IClusterTranslationDto {
    name: string;
    languageId: number;
}

export class ClusterDto implements IClusterDto {
    id: number;
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    translations: ClusterTranslationDto[];
    name: string;

    constructor(data?: IClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.enableCoordinatore = data["enableCoordinatore"];
            this.enableCloudeFallback = data["enableCloudeFallback"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ClusterTranslationDto.fromJS(item));
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ClusterDto {
        let result = new ClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["enableCoordinatore"] = this.enableCoordinatore;
        data["enableCloudeFallback"] = this.enableCloudeFallback;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IClusterDto {
    id: number;
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    translations: ClusterTranslationDto[];
    name: string;
}

export class ClusterListResultDto implements IClusterListResultDto {
    itemsCount: number;
    currentPage: number;
    items: ClusterListItem[];

    constructor(data?: IClusterListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemsCount = data["itemsCount"];
            this.currentPage = data["currentPage"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ClusterListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClusterListResultDto {
        let result = new ClusterListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemsCount"] = this.itemsCount;
        data["currentPage"] = this.currentPage;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IClusterListResultDto {
    itemsCount: number;
    currentPage: number;
    items: ClusterListItem[];
}

export class ClusterListItem implements IClusterListItem {
    id: number;
    tenantId: number;
    storeId: number;
    tenantName: string;
    storeName: string;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    name: string;

    constructor(data?: IClusterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.tenantName = data["tenantName"];
            this.storeName = data["storeName"];
            this.enableCoordinatore = data["enableCoordinatore"];
            this.enableCloudeFallback = data["enableCloudeFallback"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ClusterListItem {
        let result = new ClusterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["tenantName"] = this.tenantName;
        data["storeName"] = this.storeName;
        data["enableCoordinatore"] = this.enableCoordinatore;
        data["enableCloudeFallback"] = this.enableCloudeFallback;
        data["name"] = this.name;
        return data; 
    }
}

export interface IClusterListItem {
    id: number;
    tenantId: number;
    storeId: number;
    tenantName: string;
    storeName: string;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    name: string;
}

export class UpdateClusterInput implements IUpdateClusterInput {
    id: number;
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    translations: ClusterTranslationDto[];

    constructor(data?: IUpdateClusterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.enableCoordinatore = data["enableCoordinatore"];
            this.enableCloudeFallback = data["enableCloudeFallback"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ClusterTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClusterInput {
        let result = new UpdateClusterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["enableCoordinatore"] = this.enableCoordinatore;
        data["enableCloudeFallback"] = this.enableCloudeFallback;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateClusterInput {
    id: number;
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    translations: ClusterTranslationDto[];
}

export class ListResultDtoOfCodingPatternSettingListItem implements IListResultDtoOfCodingPatternSettingListItem {
    items: CodingPatternSettingListItem[];

    constructor(data?: IListResultDtoOfCodingPatternSettingListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CodingPatternSettingListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCodingPatternSettingListItem {
        let result = new ListResultDtoOfCodingPatternSettingListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCodingPatternSettingListItem {
    items: CodingPatternSettingListItem[];
}

export class CodingPatternSettingListItem implements ICodingPatternSettingListItem {
    id: number;
    isUsed: boolean;
    key: string;
    startValue: number;
    incrementvalue: number;
    lastGeneratedValue: number;
    prefix: string;
    suffix: string;

    constructor(data?: ICodingPatternSettingListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isUsed = data["isUsed"];
            this.key = data["key"];
            this.startValue = data["startValue"];
            this.incrementvalue = data["incrementvalue"];
            this.lastGeneratedValue = data["lastGeneratedValue"];
            this.prefix = data["prefix"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): CodingPatternSettingListItem {
        let result = new CodingPatternSettingListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isUsed"] = this.isUsed;
        data["key"] = this.key;
        data["startValue"] = this.startValue;
        data["incrementvalue"] = this.incrementvalue;
        data["lastGeneratedValue"] = this.lastGeneratedValue;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface ICodingPatternSettingListItem {
    id: number;
    isUsed: boolean;
    key: string;
    startValue: number;
    incrementvalue: number;
    lastGeneratedValue: number;
    prefix: string;
    suffix: string;
}

export class SalesCodingPatternSettingListItem implements ISalesCodingPatternSettingListItem {
    id: number;
    key: string;
    startValue: number;
    incrementvalue: number;
    prefix: string;
    suffix: string;
    storesIds: number[];

    constructor(data?: ISalesCodingPatternSettingListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.key = data["key"];
            this.startValue = data["startValue"];
            this.incrementvalue = data["incrementvalue"];
            this.prefix = data["prefix"];
            this.suffix = data["suffix"];
            if (data["storesIds"] && data["storesIds"].constructor === Array) {
                this.storesIds = [];
                for (let item of data["storesIds"])
                    this.storesIds.push(item);
            }
        }
    }

    static fromJS(data: any): SalesCodingPatternSettingListItem {
        let result = new SalesCodingPatternSettingListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["startValue"] = this.startValue;
        data["incrementvalue"] = this.incrementvalue;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        if (this.storesIds && this.storesIds.constructor === Array) {
            data["storesIds"] = [];
            for (let item of this.storesIds)
                data["storesIds"].push(item);
        }
        return data; 
    }
}

export interface ISalesCodingPatternSettingListItem {
    id: number;
    key: string;
    startValue: number;
    incrementvalue: number;
    prefix: string;
    suffix: string;
    storesIds: number[];
}

export class SalesCodingPatternSettingDto implements ISalesCodingPatternSettingDto {
    startValue: number;
    incrementvalue: number;
    prefix: string;
    suffix: string;
    lastGeneratedValue: string;

    constructor(data?: ISalesCodingPatternSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startValue = data["startValue"];
            this.incrementvalue = data["incrementvalue"];
            this.prefix = data["prefix"];
            this.suffix = data["suffix"];
            this.lastGeneratedValue = data["lastGeneratedValue"];
        }
    }

    static fromJS(data: any): SalesCodingPatternSettingDto {
        let result = new SalesCodingPatternSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startValue"] = this.startValue;
        data["incrementvalue"] = this.incrementvalue;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        data["lastGeneratedValue"] = this.lastGeneratedValue;
        return data; 
    }
}

export interface ISalesCodingPatternSettingDto {
    startValue: number;
    incrementvalue: number;
    prefix: string;
    suffix: string;
    lastGeneratedValue: string;
}

export class CreateComboGroupInput implements ICreateComboGroupInput {
    translations: ComboGroupTranslationDto[];
    priceListPrices: PriceListPriceDto[];
    saleTypes: number[];
    comboGroupDetails: ComboGroupDetailDto[];
    productCategoryIds: number[];

    constructor(data?: ICreateComboGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboGroupTranslationDto.fromJS(item));
            }
            if (data["priceListPrices"] && data["priceListPrices"].constructor === Array) {
                this.priceListPrices = [];
                for (let item of data["priceListPrices"])
                    this.priceListPrices.push(PriceListPriceDto.fromJS(item));
            }
            if (data["saleTypes"] && data["saleTypes"].constructor === Array) {
                this.saleTypes = [];
                for (let item of data["saleTypes"])
                    this.saleTypes.push(item);
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetailDto.fromJS(item));
            }
            if (data["productCategoryIds"] && data["productCategoryIds"].constructor === Array) {
                this.productCategoryIds = [];
                for (let item of data["productCategoryIds"])
                    this.productCategoryIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateComboGroupInput {
        let result = new CreateComboGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.priceListPrices && this.priceListPrices.constructor === Array) {
            data["priceListPrices"] = [];
            for (let item of this.priceListPrices)
                data["priceListPrices"].push(item.toJSON());
        }
        if (this.saleTypes && this.saleTypes.constructor === Array) {
            data["saleTypes"] = [];
            for (let item of this.saleTypes)
                data["saleTypes"].push(item);
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        if (this.productCategoryIds && this.productCategoryIds.constructor === Array) {
            data["productCategoryIds"] = [];
            for (let item of this.productCategoryIds)
                data["productCategoryIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateComboGroupInput {
    translations: ComboGroupTranslationDto[];
    priceListPrices: PriceListPriceDto[];
    saleTypes: number[];
    comboGroupDetails: ComboGroupDetailDto[];
    productCategoryIds: number[];
}

export class ComboGroupTranslationDto implements IComboGroupTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IComboGroupTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ComboGroupTranslationDto {
        let result = new ComboGroupTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IComboGroupTranslationDto {
    name: string;
    languageId: number;
}

export class PriceListPriceDto implements IPriceListPriceDto {
    priceListId: number;
    price: number;

    constructor(data?: IPriceListPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priceListId = data["priceListId"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): PriceListPriceDto {
        let result = new PriceListPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        return data; 
    }
}

export interface IPriceListPriceDto {
    priceListId: number;
    price: number;
}

export class ComboGroupDetailDto implements IComboGroupDetailDto {
    menuItem: string;
    menuItemId: number;
    itemCode: string;
    unitOfMeasure: string;
    unitOfMeasureId: number;

    constructor(data?: IComboGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItem = data["menuItem"];
            this.menuItemId = data["menuItemId"];
            this.itemCode = data["itemCode"];
            this.unitOfMeasure = data["unitOfMeasure"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
        }
    }

    static fromJS(data: any): ComboGroupDetailDto {
        let result = new ComboGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItem"] = this.menuItem;
        data["menuItemId"] = this.menuItemId;
        data["itemCode"] = this.itemCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        return data; 
    }
}

export interface IComboGroupDetailDto {
    menuItem: string;
    menuItemId: number;
    itemCode: string;
    unitOfMeasure: string;
    unitOfMeasureId: number;
}

export class ListResultDtoOfComboGroupListItem implements IListResultDtoOfComboGroupListItem {
    items: ComboGroupListItem[];

    constructor(data?: IListResultDtoOfComboGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ComboGroupListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfComboGroupListItem {
        let result = new ListResultDtoOfComboGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfComboGroupListItem {
    items: ComboGroupListItem[];
}

export class ComboGroupListItem implements IComboGroupListItem {
    id: number;
    name: string;

    constructor(data?: IComboGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ComboGroupListItem {
        let result = new ComboGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IComboGroupListItem {
    id: number;
    name: string;
}

export class UpdateComboGroupInput implements IUpdateComboGroupInput {
    id: number;
    translations: ComboGroupTranslationDto[];
    priceListPrices: PriceListPriceDto[];
    saleTypes: number[];
    comboGroupDetails: ComboGroupDetailDto[];
    productCategoryIds: number[];

    constructor(data?: IUpdateComboGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboGroupTranslationDto.fromJS(item));
            }
            if (data["priceListPrices"] && data["priceListPrices"].constructor === Array) {
                this.priceListPrices = [];
                for (let item of data["priceListPrices"])
                    this.priceListPrices.push(PriceListPriceDto.fromJS(item));
            }
            if (data["saleTypes"] && data["saleTypes"].constructor === Array) {
                this.saleTypes = [];
                for (let item of data["saleTypes"])
                    this.saleTypes.push(item);
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetailDto.fromJS(item));
            }
            if (data["productCategoryIds"] && data["productCategoryIds"].constructor === Array) {
                this.productCategoryIds = [];
                for (let item of data["productCategoryIds"])
                    this.productCategoryIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateComboGroupInput {
        let result = new UpdateComboGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.priceListPrices && this.priceListPrices.constructor === Array) {
            data["priceListPrices"] = [];
            for (let item of this.priceListPrices)
                data["priceListPrices"].push(item.toJSON());
        }
        if (this.saleTypes && this.saleTypes.constructor === Array) {
            data["saleTypes"] = [];
            for (let item of this.saleTypes)
                data["saleTypes"].push(item);
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        if (this.productCategoryIds && this.productCategoryIds.constructor === Array) {
            data["productCategoryIds"] = [];
            for (let item of this.productCategoryIds)
                data["productCategoryIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateComboGroupInput {
    id: number;
    translations: ComboGroupTranslationDto[];
    priceListPrices: PriceListPriceDto[];
    saleTypes: number[];
    comboGroupDetails: ComboGroupDetailDto[];
    productCategoryIds: number[];
}

export class ComboGroupDTO implements IComboGroupDTO {
    id: number;
    translations: ComboGroupTranslationDto[];
    priceListComboGroups: PriceListComboGroupDto[];
    saleTypeComboGroups: number[];
    productCategoryComboGroups: number[];
    comboGroupDetails: ComboGroupDetailDto[];
    imageSrcUrl: string;

    constructor(data?: IComboGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboGroupTranslationDto.fromJS(item));
            }
            if (data["priceListComboGroups"] && data["priceListComboGroups"].constructor === Array) {
                this.priceListComboGroups = [];
                for (let item of data["priceListComboGroups"])
                    this.priceListComboGroups.push(PriceListComboGroupDto.fromJS(item));
            }
            if (data["saleTypeComboGroups"] && data["saleTypeComboGroups"].constructor === Array) {
                this.saleTypeComboGroups = [];
                for (let item of data["saleTypeComboGroups"])
                    this.saleTypeComboGroups.push(item);
            }
            if (data["productCategoryComboGroups"] && data["productCategoryComboGroups"].constructor === Array) {
                this.productCategoryComboGroups = [];
                for (let item of data["productCategoryComboGroups"])
                    this.productCategoryComboGroups.push(item);
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetailDto.fromJS(item));
            }
            this.imageSrcUrl = data["imageSrcUrl"];
        }
    }

    static fromJS(data: any): ComboGroupDTO {
        let result = new ComboGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.priceListComboGroups && this.priceListComboGroups.constructor === Array) {
            data["priceListComboGroups"] = [];
            for (let item of this.priceListComboGroups)
                data["priceListComboGroups"].push(item.toJSON());
        }
        if (this.saleTypeComboGroups && this.saleTypeComboGroups.constructor === Array) {
            data["saleTypeComboGroups"] = [];
            for (let item of this.saleTypeComboGroups)
                data["saleTypeComboGroups"].push(item);
        }
        if (this.productCategoryComboGroups && this.productCategoryComboGroups.constructor === Array) {
            data["productCategoryComboGroups"] = [];
            for (let item of this.productCategoryComboGroups)
                data["productCategoryComboGroups"].push(item);
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        data["imageSrcUrl"] = this.imageSrcUrl;
        return data; 
    }
}

export interface IComboGroupDTO {
    id: number;
    translations: ComboGroupTranslationDto[];
    priceListComboGroups: PriceListComboGroupDto[];
    saleTypeComboGroups: number[];
    productCategoryComboGroups: number[];
    comboGroupDetails: ComboGroupDetailDto[];
    imageSrcUrl: string;
}

export class PriceListComboGroupDto implements IPriceListComboGroupDto {
    priceListId: number;
    price: number;
    priceListName: string;

    constructor(data?: IPriceListComboGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.priceListName = data["priceListName"];
        }
    }

    static fromJS(data: any): PriceListComboGroupDto {
        let result = new PriceListComboGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["priceListName"] = this.priceListName;
        return data; 
    }
}

export interface IPriceListComboGroupDto {
    priceListId: number;
    price: number;
    priceListName: string;
}

export class PagedComboGroupList implements IPagedComboGroupList {
    currentPage: number;
    itemsCount: number;
    comboGroups: ComboGroupListItem[];

    constructor(data?: IPagedComboGroupList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["comboGroups"] && data["comboGroups"].constructor === Array) {
                this.comboGroups = [];
                for (let item of data["comboGroups"])
                    this.comboGroups.push(ComboGroupListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedComboGroupList {
        let result = new PagedComboGroupList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.comboGroups && this.comboGroups.constructor === Array) {
            data["comboGroups"] = [];
            for (let item of this.comboGroups)
                data["comboGroups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedComboGroupList {
    currentPage: number;
    itemsCount: number;
    comboGroups: ComboGroupListItem[];
}

export class CreateComboMealDefinition implements ICreateComboMealDefinition {
    comboMealsPackgesDefinitions: ComboMealDefinitionDto[];
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];

    constructor(data?: ICreateComboMealDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["comboMealsPackgesDefinitions"] && data["comboMealsPackgesDefinitions"].constructor === Array) {
                this.comboMealsPackgesDefinitions = [];
                for (let item of data["comboMealsPackgesDefinitions"])
                    this.comboMealsPackgesDefinitions.push(ComboMealDefinitionDto.fromJS(item));
            }
            this.levelId = data["levelId"];
            this.productGroupId = data["productGroupId"];
            this.reportGroupId = data["reportGroupId"];
            this.deviceId = data["deviceId"];
            this.periodId = data["periodId"];
            this.allowDiscount = data["allowDiscount"];
            this.openPrice = data["openPrice"];
            this.sellable = data["sellable"];
            this.cost = data["cost"];
            this.itemCode = data["itemCode"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isHidden = data["isHidden"];
            this.hasTobaccoTax = data["hasTobaccoTax"];
            this.isComboMealDefinitionItem = data["isComboMealDefinitionItem"];
            this.isHoteSaleing = data["isHoteSaleing"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.numberOfCalories = data["numberOfCalories"];
            this.numberOfSteps = data["numberOfSteps"];
            this.allowDecimal = data["allowDecimal"];
            this.unitsOfMeasure = data["unitsOfMeasure"] ? ProductUnitsOfMeasureDto.fromJS(data["unitsOfMeasure"]) : <any>undefined;
            if (data["saleTypesIds"] && data["saleTypesIds"].constructor === Array) {
                this.saleTypesIds = [];
                for (let item of data["saleTypesIds"])
                    this.saleTypesIds.push(item);
            }
            if (data["taxIds"] && data["taxIds"].constructor === Array) {
                this.taxIds = [];
                for (let item of data["taxIds"])
                    this.taxIds.push(item);
            }
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            if (data["upSalesMenuItemIds"] && data["upSalesMenuItemIds"].constructor === Array) {
                this.upSalesMenuItemIds = [];
                for (let item of data["upSalesMenuItemIds"])
                    this.upSalesMenuItemIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemTranslationDto.fromJS(item));
            }
            if (data["menuItemPrices"] && data["menuItemPrices"].constructor === Array) {
                this.menuItemPrices = [];
                for (let item of data["menuItemPrices"])
                    this.menuItemPrices.push(MenuItemPriceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateComboMealDefinition {
        let result = new CreateComboMealDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.comboMealsPackgesDefinitions && this.comboMealsPackgesDefinitions.constructor === Array) {
            data["comboMealsPackgesDefinitions"] = [];
            for (let item of this.comboMealsPackgesDefinitions)
                data["comboMealsPackgesDefinitions"].push(item.toJSON());
        }
        data["levelId"] = this.levelId;
        data["productGroupId"] = this.productGroupId;
        data["reportGroupId"] = this.reportGroupId;
        data["deviceId"] = this.deviceId;
        data["periodId"] = this.periodId;
        data["allowDiscount"] = this.allowDiscount;
        data["openPrice"] = this.openPrice;
        data["sellable"] = this.sellable;
        data["cost"] = this.cost;
        data["itemCode"] = this.itemCode;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isHidden"] = this.isHidden;
        data["hasTobaccoTax"] = this.hasTobaccoTax;
        data["isComboMealDefinitionItem"] = this.isComboMealDefinitionItem;
        data["isHoteSaleing"] = this.isHoteSaleing;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["numberOfCalories"] = this.numberOfCalories;
        data["numberOfSteps"] = this.numberOfSteps;
        data["allowDecimal"] = this.allowDecimal;
        data["unitsOfMeasure"] = this.unitsOfMeasure ? this.unitsOfMeasure.toJSON() : <any>undefined;
        if (this.saleTypesIds && this.saleTypesIds.constructor === Array) {
            data["saleTypesIds"] = [];
            for (let item of this.saleTypesIds)
                data["saleTypesIds"].push(item);
        }
        if (this.taxIds && this.taxIds.constructor === Array) {
            data["taxIds"] = [];
            for (let item of this.taxIds)
                data["taxIds"].push(item);
        }
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        if (this.upSalesMenuItemIds && this.upSalesMenuItemIds.constructor === Array) {
            data["upSalesMenuItemIds"] = [];
            for (let item of this.upSalesMenuItemIds)
                data["upSalesMenuItemIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemPrices && this.menuItemPrices.constructor === Array) {
            data["menuItemPrices"] = [];
            for (let item of this.menuItemPrices)
                data["menuItemPrices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateComboMealDefinition {
    comboMealsPackgesDefinitions: ComboMealDefinitionDto[];
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];
}

export class ComboMealDefinitionDto implements IComboMealDefinitionDto {
    id: number;
    comboMealPackageId: number;
    menuItemId: number;
    order: number;

    constructor(data?: IComboMealDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.comboMealPackageId = data["comboMealPackageId"];
            this.menuItemId = data["menuItemId"];
            this.order = data["order"];
        }
    }

    static fromJS(data: any): ComboMealDefinitionDto {
        let result = new ComboMealDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comboMealPackageId"] = this.comboMealPackageId;
        data["menuItemId"] = this.menuItemId;
        data["order"] = this.order;
        return data; 
    }
}

export interface IComboMealDefinitionDto {
    id: number;
    comboMealPackageId: number;
    menuItemId: number;
    order: number;
}

export class ProductUnitsOfMeasureDto implements IProductUnitsOfMeasureDto {
    baseUnitOfMeasureId: number;
    alternateUnitsOfMeasure: UnitOfMeasureConversionDto[];

    constructor(data?: IProductUnitsOfMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseUnitOfMeasureId = data["baseUnitOfMeasureId"];
            if (data["alternateUnitsOfMeasure"] && data["alternateUnitsOfMeasure"].constructor === Array) {
                this.alternateUnitsOfMeasure = [];
                for (let item of data["alternateUnitsOfMeasure"])
                    this.alternateUnitsOfMeasure.push(UnitOfMeasureConversionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductUnitsOfMeasureDto {
        let result = new ProductUnitsOfMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseUnitOfMeasureId"] = this.baseUnitOfMeasureId;
        if (this.alternateUnitsOfMeasure && this.alternateUnitsOfMeasure.constructor === Array) {
            data["alternateUnitsOfMeasure"] = [];
            for (let item of this.alternateUnitsOfMeasure)
                data["alternateUnitsOfMeasure"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductUnitsOfMeasureDto {
    baseUnitOfMeasureId: number;
    alternateUnitsOfMeasure: UnitOfMeasureConversionDto[];
}

export class MenuItemTranslationDto implements IMenuItemTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IMenuItemTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): MenuItemTranslationDto {
        let result = new MenuItemTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IMenuItemTranslationDto {
    name: string;
    languageId: number;
}

export class MenuItemPriceListDto implements IMenuItemPriceListDto {
    priceListId: number;
    price: number;
    newPrice: number;
    name: string;
    unitOfMeasureId: number;
    factor: number;
    storeMenuItemConfigId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.newPrice = data["newPrice"];
            this.name = data["name"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.factor = data["factor"];
            this.storeMenuItemConfigId = data["storeMenuItemConfigId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemPriceListDto {
        let result = new MenuItemPriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["newPrice"] = this.newPrice;
        data["name"] = this.name;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["factor"] = this.factor;
        data["storeMenuItemConfigId"] = this.storeMenuItemConfigId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemPriceListDto {
    priceListId: number;
    price: number;
    newPrice: number;
    name: string;
    unitOfMeasureId: number;
    factor: number;
    storeMenuItemConfigId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UnitOfMeasureConversionDto implements IUnitOfMeasureConversionDto {
    alternateUnitOfMeasureId: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    conversionFactor: number;

    constructor(data?: IUnitOfMeasureConversionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alternateUnitOfMeasureId = data["alternateUnitOfMeasureId"];
            this.code = data["code"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.conversionFactor = data["conversionFactor"];
        }
    }

    static fromJS(data: any): UnitOfMeasureConversionDto {
        let result = new UnitOfMeasureConversionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternateUnitOfMeasureId"] = this.alternateUnitOfMeasureId;
        data["code"] = this.code;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["conversionFactor"] = this.conversionFactor;
        return data; 
    }
}

export interface IUnitOfMeasureConversionDto {
    alternateUnitOfMeasureId: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    conversionFactor: number;
}

export class UpdateComboMealDefinition implements IUpdateComboMealDefinition {
    id: number;
    comboMealsPackgesDefinitions: ComboMealDefinitionDto[];
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];

    constructor(data?: IUpdateComboMealDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["comboMealsPackgesDefinitions"] && data["comboMealsPackgesDefinitions"].constructor === Array) {
                this.comboMealsPackgesDefinitions = [];
                for (let item of data["comboMealsPackgesDefinitions"])
                    this.comboMealsPackgesDefinitions.push(ComboMealDefinitionDto.fromJS(item));
            }
            this.levelId = data["levelId"];
            this.productGroupId = data["productGroupId"];
            this.reportGroupId = data["reportGroupId"];
            this.deviceId = data["deviceId"];
            this.periodId = data["periodId"];
            this.allowDiscount = data["allowDiscount"];
            this.openPrice = data["openPrice"];
            this.sellable = data["sellable"];
            this.cost = data["cost"];
            this.itemCode = data["itemCode"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isHidden = data["isHidden"];
            this.hasTobaccoTax = data["hasTobaccoTax"];
            this.isComboMealDefinitionItem = data["isComboMealDefinitionItem"];
            this.isHoteSaleing = data["isHoteSaleing"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.numberOfCalories = data["numberOfCalories"];
            this.numberOfSteps = data["numberOfSteps"];
            this.allowDecimal = data["allowDecimal"];
            this.unitsOfMeasure = data["unitsOfMeasure"] ? ProductUnitsOfMeasureDto.fromJS(data["unitsOfMeasure"]) : <any>undefined;
            if (data["saleTypesIds"] && data["saleTypesIds"].constructor === Array) {
                this.saleTypesIds = [];
                for (let item of data["saleTypesIds"])
                    this.saleTypesIds.push(item);
            }
            if (data["taxIds"] && data["taxIds"].constructor === Array) {
                this.taxIds = [];
                for (let item of data["taxIds"])
                    this.taxIds.push(item);
            }
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            if (data["upSalesMenuItemIds"] && data["upSalesMenuItemIds"].constructor === Array) {
                this.upSalesMenuItemIds = [];
                for (let item of data["upSalesMenuItemIds"])
                    this.upSalesMenuItemIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemTranslationDto.fromJS(item));
            }
            if (data["menuItemPrices"] && data["menuItemPrices"].constructor === Array) {
                this.menuItemPrices = [];
                for (let item of data["menuItemPrices"])
                    this.menuItemPrices.push(MenuItemPriceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateComboMealDefinition {
        let result = new UpdateComboMealDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.comboMealsPackgesDefinitions && this.comboMealsPackgesDefinitions.constructor === Array) {
            data["comboMealsPackgesDefinitions"] = [];
            for (let item of this.comboMealsPackgesDefinitions)
                data["comboMealsPackgesDefinitions"].push(item.toJSON());
        }
        data["levelId"] = this.levelId;
        data["productGroupId"] = this.productGroupId;
        data["reportGroupId"] = this.reportGroupId;
        data["deviceId"] = this.deviceId;
        data["periodId"] = this.periodId;
        data["allowDiscount"] = this.allowDiscount;
        data["openPrice"] = this.openPrice;
        data["sellable"] = this.sellable;
        data["cost"] = this.cost;
        data["itemCode"] = this.itemCode;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isHidden"] = this.isHidden;
        data["hasTobaccoTax"] = this.hasTobaccoTax;
        data["isComboMealDefinitionItem"] = this.isComboMealDefinitionItem;
        data["isHoteSaleing"] = this.isHoteSaleing;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["numberOfCalories"] = this.numberOfCalories;
        data["numberOfSteps"] = this.numberOfSteps;
        data["allowDecimal"] = this.allowDecimal;
        data["unitsOfMeasure"] = this.unitsOfMeasure ? this.unitsOfMeasure.toJSON() : <any>undefined;
        if (this.saleTypesIds && this.saleTypesIds.constructor === Array) {
            data["saleTypesIds"] = [];
            for (let item of this.saleTypesIds)
                data["saleTypesIds"].push(item);
        }
        if (this.taxIds && this.taxIds.constructor === Array) {
            data["taxIds"] = [];
            for (let item of this.taxIds)
                data["taxIds"].push(item);
        }
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        if (this.upSalesMenuItemIds && this.upSalesMenuItemIds.constructor === Array) {
            data["upSalesMenuItemIds"] = [];
            for (let item of this.upSalesMenuItemIds)
                data["upSalesMenuItemIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemPrices && this.menuItemPrices.constructor === Array) {
            data["menuItemPrices"] = [];
            for (let item of this.menuItemPrices)
                data["menuItemPrices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateComboMealDefinition {
    id: number;
    comboMealsPackgesDefinitions: ComboMealDefinitionDto[];
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];
}

export class MenuItemDto implements IMenuItemDto {
    id: number;
    levelId: number;
    mainGroupId: number;
    reportGroupId: number;
    deviceId: number;
    imageId: string;
    periodId: number;
    materialGroupId: number;
    productCategoryId: number;
    isHidden: boolean;
    menuItemName: string;
    imageSrcUrl: string;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    barcode1: string;
    barcode2: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isComboMealDefinitionItem: boolean;
    hasTobaccoTax: boolean;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    createConfigs: boolean;
    storeIds: number[];
    upSalesMenuItemIds: number[];
    isHoteSaleing: boolean;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    menuItemPrices: MenuItemPriceListDto[];
    menuItemVariants: MenuItemVariantDto[];
    translations: MenuItemTranslationDto[];
    comboMealsPackgesDefinitions: ComboMealDefinitionDto[];

    constructor(data?: IMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.levelId = data["levelId"];
            this.mainGroupId = data["mainGroupId"];
            this.reportGroupId = data["reportGroupId"];
            this.deviceId = data["deviceId"];
            this.imageId = data["imageId"];
            this.periodId = data["periodId"];
            this.materialGroupId = data["materialGroupId"];
            this.productCategoryId = data["productCategoryId"];
            this.isHidden = data["isHidden"];
            this.menuItemName = data["menuItemName"];
            this.imageSrcUrl = data["imageSrcUrl"];
            this.allowDiscount = data["allowDiscount"];
            this.openPrice = data["openPrice"];
            this.sellable = data["sellable"];
            this.cost = data["cost"];
            this.itemCode = data["itemCode"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isComboMealDefinitionItem = data["isComboMealDefinitionItem"];
            this.hasTobaccoTax = data["hasTobaccoTax"];
            if (data["saleTypesIds"] && data["saleTypesIds"].constructor === Array) {
                this.saleTypesIds = [];
                for (let item of data["saleTypesIds"])
                    this.saleTypesIds.push(item);
            }
            if (data["taxIds"] && data["taxIds"].constructor === Array) {
                this.taxIds = [];
                for (let item of data["taxIds"])
                    this.taxIds.push(item);
            }
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            this.createConfigs = data["createConfigs"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["upSalesMenuItemIds"] && data["upSalesMenuItemIds"].constructor === Array) {
                this.upSalesMenuItemIds = [];
                for (let item of data["upSalesMenuItemIds"])
                    this.upSalesMenuItemIds.push(item);
            }
            this.isHoteSaleing = data["isHoteSaleing"];
            this.numberOfCalories = data["numberOfCalories"];
            this.numberOfSteps = data["numberOfSteps"];
            this.allowDecimal = data["allowDecimal"];
            if (data["menuItemPrices"] && data["menuItemPrices"].constructor === Array) {
                this.menuItemPrices = [];
                for (let item of data["menuItemPrices"])
                    this.menuItemPrices.push(MenuItemPriceListDto.fromJS(item));
            }
            if (data["menuItemVariants"] && data["menuItemVariants"].constructor === Array) {
                this.menuItemVariants = [];
                for (let item of data["menuItemVariants"])
                    this.menuItemVariants.push(MenuItemVariantDto.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemTranslationDto.fromJS(item));
            }
            if (data["comboMealsPackgesDefinitions"] && data["comboMealsPackgesDefinitions"].constructor === Array) {
                this.comboMealsPackgesDefinitions = [];
                for (let item of data["comboMealsPackgesDefinitions"])
                    this.comboMealsPackgesDefinitions.push(ComboMealDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemDto {
        let result = new MenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelId"] = this.levelId;
        data["mainGroupId"] = this.mainGroupId;
        data["reportGroupId"] = this.reportGroupId;
        data["deviceId"] = this.deviceId;
        data["imageId"] = this.imageId;
        data["periodId"] = this.periodId;
        data["materialGroupId"] = this.materialGroupId;
        data["productCategoryId"] = this.productCategoryId;
        data["isHidden"] = this.isHidden;
        data["menuItemName"] = this.menuItemName;
        data["imageSrcUrl"] = this.imageSrcUrl;
        data["allowDiscount"] = this.allowDiscount;
        data["openPrice"] = this.openPrice;
        data["sellable"] = this.sellable;
        data["cost"] = this.cost;
        data["itemCode"] = this.itemCode;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isComboMealDefinitionItem"] = this.isComboMealDefinitionItem;
        data["hasTobaccoTax"] = this.hasTobaccoTax;
        if (this.saleTypesIds && this.saleTypesIds.constructor === Array) {
            data["saleTypesIds"] = [];
            for (let item of this.saleTypesIds)
                data["saleTypesIds"].push(item);
        }
        if (this.taxIds && this.taxIds.constructor === Array) {
            data["taxIds"] = [];
            for (let item of this.taxIds)
                data["taxIds"].push(item);
        }
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        data["createConfigs"] = this.createConfigs;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.upSalesMenuItemIds && this.upSalesMenuItemIds.constructor === Array) {
            data["upSalesMenuItemIds"] = [];
            for (let item of this.upSalesMenuItemIds)
                data["upSalesMenuItemIds"].push(item);
        }
        data["isHoteSaleing"] = this.isHoteSaleing;
        data["numberOfCalories"] = this.numberOfCalories;
        data["numberOfSteps"] = this.numberOfSteps;
        data["allowDecimal"] = this.allowDecimal;
        if (this.menuItemPrices && this.menuItemPrices.constructor === Array) {
            data["menuItemPrices"] = [];
            for (let item of this.menuItemPrices)
                data["menuItemPrices"].push(item.toJSON());
        }
        if (this.menuItemVariants && this.menuItemVariants.constructor === Array) {
            data["menuItemVariants"] = [];
            for (let item of this.menuItemVariants)
                data["menuItemVariants"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.comboMealsPackgesDefinitions && this.comboMealsPackgesDefinitions.constructor === Array) {
            data["comboMealsPackgesDefinitions"] = [];
            for (let item of this.comboMealsPackgesDefinitions)
                data["comboMealsPackgesDefinitions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuItemDto {
    id: number;
    levelId: number;
    mainGroupId: number;
    reportGroupId: number;
    deviceId: number;
    imageId: string;
    periodId: number;
    materialGroupId: number;
    productCategoryId: number;
    isHidden: boolean;
    menuItemName: string;
    imageSrcUrl: string;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    barcode1: string;
    barcode2: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isComboMealDefinitionItem: boolean;
    hasTobaccoTax: boolean;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    createConfigs: boolean;
    storeIds: number[];
    upSalesMenuItemIds: number[];
    isHoteSaleing: boolean;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    menuItemPrices: MenuItemPriceListDto[];
    menuItemVariants: MenuItemVariantDto[];
    translations: MenuItemTranslationDto[];
    comboMealsPackgesDefinitions: ComboMealDefinitionDto[];
}

export class MenuItemVariantDto implements IMenuItemVariantDto {
    id: number;
    menuItemId: number;
    variantId: number;

    constructor(data?: IMenuItemVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemId = data["menuItemId"];
            this.variantId = data["variantId"];
        }
    }

    static fromJS(data: any): MenuItemVariantDto {
        let result = new MenuItemVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemId"] = this.menuItemId;
        data["variantId"] = this.variantId;
        return data; 
    }
}

export interface IMenuItemVariantDto {
    id: number;
    menuItemId: number;
    variantId: number;
}

export class ListResultDtoOfMenuItemListItem implements IListResultDtoOfMenuItemListItem {
    items: MenuItemListItem[];

    constructor(data?: IListResultDtoOfMenuItemListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MenuItemListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMenuItemListItem {
        let result = new ListResultDtoOfMenuItemListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMenuItemListItem {
    items: MenuItemListItem[];
}

export class MenuItemListItem implements IMenuItemListItem {
    id: number;
    productCategoryId: number;
    name: string;
    itemCode: string;
    barcode1: string;
    barcode2: string;
    itemsCount: number;
    currentPage: number;
    inventoryTotal: number;
    details: MenuItemDto[];

    constructor(data?: IMenuItemListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.productCategoryId = data["productCategoryId"];
            this.name = data["name"];
            this.itemCode = data["itemCode"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.itemsCount = data["itemsCount"];
            this.currentPage = data["currentPage"];
            this.inventoryTotal = data["inventoryTotal"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(MenuItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemListItem {
        let result = new MenuItemListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCategoryId"] = this.productCategoryId;
        data["name"] = this.name;
        data["itemCode"] = this.itemCode;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["itemsCount"] = this.itemsCount;
        data["currentPage"] = this.currentPage;
        data["inventoryTotal"] = this.inventoryTotal;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuItemListItem {
    id: number;
    productCategoryId: number;
    name: string;
    itemCode: string;
    barcode1: string;
    barcode2: string;
    itemsCount: number;
    currentPage: number;
    inventoryTotal: number;
    details: MenuItemDto[];
}

export class MenuItemInput implements IMenuItemInput {
    searchKey: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    referenceNumber: string;
    productCategories: number[];
    storeIds: number[];
    cashierIds: number[];
    documentType: number;
    includeDefinitions: boolean;

    constructor(data?: IMenuItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.searchKey = data["searchKey"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.referenceNumber = data["referenceNumber"];
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.includeDefinitions = data["includeDefinitions"];
        }
    }

    static fromJS(data: any): MenuItemInput {
        let result = new MenuItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchKey"] = this.searchKey;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["referenceNumber"] = this.referenceNumber;
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["includeDefinitions"] = this.includeDefinitions;
        return data; 
    }
}

export interface IMenuItemInput {
    searchKey: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    referenceNumber: string;
    productCategories: number[];
    storeIds: number[];
    cashierIds: number[];
    documentType: number;
    includeDefinitions: boolean;
}

export class PagedMenuItemList implements IPagedMenuItemList {
    currentPage: number;
    itemsCount: number;
    menuItemListItem: MenuItemListItem[];

    constructor(data?: IPagedMenuItemList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["menuItemListItem"] && data["menuItemListItem"].constructor === Array) {
                this.menuItemListItem = [];
                for (let item of data["menuItemListItem"])
                    this.menuItemListItem.push(MenuItemListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedMenuItemList {
        let result = new PagedMenuItemList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.menuItemListItem && this.menuItemListItem.constructor === Array) {
            data["menuItemListItem"] = [];
            for (let item of this.menuItemListItem)
                data["menuItemListItem"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedMenuItemList {
    currentPage: number;
    itemsCount: number;
    menuItemListItem: MenuItemListItem[];
}

export class CreateComboMealPackage implements ICreateComboMealPackage {
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslationDto[];
    items: ComboMealPackageItemDto[];

    constructor(data?: ICreateComboMealPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.quantity = data["quantity"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboMealPackageTranslationDto.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ComboMealPackageItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateComboMealPackage {
        let result = new CreateComboMealPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateComboMealPackage {
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslationDto[];
    items: ComboMealPackageItemDto[];
}

export class ComboMealPackageTranslationDto implements IComboMealPackageTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IComboMealPackageTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ComboMealPackageTranslationDto {
        let result = new ComboMealPackageTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IComboMealPackageTranslationDto {
    name: string;
    languageId: number;
}

export class ComboMealPackageItemDto implements IComboMealPackageItemDto {
    id: number;
    menuItemId: number;
    quantity: number;
    priceLists: ComboMealPackageItemPriceListDto[];

    constructor(data?: IComboMealPackageItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            if (data["priceLists"] && data["priceLists"].constructor === Array) {
                this.priceLists = [];
                for (let item of data["priceLists"])
                    this.priceLists.push(ComboMealPackageItemPriceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComboMealPackageItemDto {
        let result = new ComboMealPackageItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        if (this.priceLists && this.priceLists.constructor === Array) {
            data["priceLists"] = [];
            for (let item of this.priceLists)
                data["priceLists"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IComboMealPackageItemDto {
    id: number;
    menuItemId: number;
    quantity: number;
    priceLists: ComboMealPackageItemPriceListDto[];
}

export class ComboMealPackageItemPriceListDto implements IComboMealPackageItemPriceListDto {
    id: number;
    priceListId: number;
    unitOfMeasureId: number;
    price: number;
    comboMealPackageItemId: number;

    constructor(data?: IComboMealPackageItemPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.priceListId = data["priceListId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.price = data["price"];
            this.comboMealPackageItemId = data["comboMealPackageItemId"];
        }
    }

    static fromJS(data: any): ComboMealPackageItemPriceListDto {
        let result = new ComboMealPackageItemPriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priceListId"] = this.priceListId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["price"] = this.price;
        data["comboMealPackageItemId"] = this.comboMealPackageItemId;
        return data; 
    }
}

export interface IComboMealPackageItemPriceListDto {
    id: number;
    priceListId: number;
    unitOfMeasureId: number;
    price: number;
    comboMealPackageItemId: number;
}

export class ComboMealPackageDto implements IComboMealPackageDto {
    id: number;
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslationDto[];
    items: ComboMealPackageItemDto[];

    constructor(data?: IComboMealPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.quantity = data["quantity"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboMealPackageTranslationDto.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ComboMealPackageItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComboMealPackageDto {
        let result = new ComboMealPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IComboMealPackageDto {
    id: number;
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslationDto[];
    items: ComboMealPackageItemDto[];
}

export class ListResultDtoOfComboMealPackageListItem implements IListResultDtoOfComboMealPackageListItem {
    items: ComboMealPackageListItem[];

    constructor(data?: IListResultDtoOfComboMealPackageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ComboMealPackageListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfComboMealPackageListItem {
        let result = new ListResultDtoOfComboMealPackageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfComboMealPackageListItem {
    items: ComboMealPackageListItem[];
}

export class ComboMealPackageListItem implements IComboMealPackageListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IComboMealPackageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): ComboMealPackageListItem {
        let result = new ComboMealPackageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IComboMealPackageListItem {
    id: number;
    name: string;
    code: string;
}

export class PagedComboMealPackageList implements IPagedComboMealPackageList {
    currentPage: number;
    itemsCount: number;
    comboMealItems: ComboMealPackageListItem[];

    constructor(data?: IPagedComboMealPackageList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["comboMealItems"] && data["comboMealItems"].constructor === Array) {
                this.comboMealItems = [];
                for (let item of data["comboMealItems"])
                    this.comboMealItems.push(ComboMealPackageListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedComboMealPackageList {
        let result = new PagedComboMealPackageList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.comboMealItems && this.comboMealItems.constructor === Array) {
            data["comboMealItems"] = [];
            for (let item of this.comboMealItems)
                data["comboMealItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedComboMealPackageList {
    currentPage: number;
    itemsCount: number;
    comboMealItems: ComboMealPackageListItem[];
}

export class UpdateComboMealPackage implements IUpdateComboMealPackage {
    id: number;
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslationDto[];
    items: ComboMealPackageItemDto[];

    constructor(data?: IUpdateComboMealPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.quantity = data["quantity"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboMealPackageTranslationDto.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ComboMealPackageItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateComboMealPackage {
        let result = new UpdateComboMealPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateComboMealPackage {
    id: number;
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslationDto[];
    items: ComboMealPackageItemDto[];
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[];

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[];
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree: boolean;
    value: string;
    displayText: string;
    isSelected: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean;
    value: string;
    displayText: string;
    isSelected: boolean;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindUsersInput {
    tenantId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[];

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[];
}

export class NameValueDto implements INameValueDto {
    name: string;
    value: string;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name: string;
    value: string;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name: string;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string;
}

export class CornerDTO implements ICornerDTO {
    id: number;
    storeIds: number[];
    translations: CornerTranslationDto[];

    constructor(data?: ICornerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CornerTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CornerDTO {
        let result = new CornerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICornerDTO {
    id: number;
    storeIds: number[];
    translations: CornerTranslationDto[];
}

export class CornerTranslationDto implements ICornerTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ICornerTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): CornerTranslationDto {
        let result = new CornerTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ICornerTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfCornerListItem implements IListResultDtoOfCornerListItem {
    items: CornerListItem[];

    constructor(data?: IListResultDtoOfCornerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CornerListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCornerListItem {
        let result = new ListResultDtoOfCornerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCornerListItem {
    items: CornerListItem[];
}

export class CornerListItem implements ICornerListItem {
    id: number;
    name: string;

    constructor(data?: ICornerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CornerListItem {
        let result = new CornerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICornerListItem {
    id: number;
    name: string;
}

export class CornerStoreDeviceInput implements ICornerStoreDeviceInput {
    cornerId: number;
    storeDevices: StoreDevices[];

    constructor(data?: ICornerStoreDeviceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cornerId = data["cornerId"];
            if (data["storeDevices"] && data["storeDevices"].constructor === Array) {
                this.storeDevices = [];
                for (let item of data["storeDevices"])
                    this.storeDevices.push(StoreDevices.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CornerStoreDeviceInput {
        let result = new CornerStoreDeviceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cornerId"] = this.cornerId;
        if (this.storeDevices && this.storeDevices.constructor === Array) {
            data["storeDevices"] = [];
            for (let item of this.storeDevices)
                data["storeDevices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICornerStoreDeviceInput {
    cornerId: number;
    storeDevices: StoreDevices[];
}

export class StoreDevices implements IStoreDevices {
    storeId: number;
    devicesIds: number[];

    constructor(data?: IStoreDevices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            if (data["devicesIds"] && data["devicesIds"].constructor === Array) {
                this.devicesIds = [];
                for (let item of data["devicesIds"])
                    this.devicesIds.push(item);
            }
        }
    }

    static fromJS(data: any): StoreDevices {
        let result = new StoreDevices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        if (this.devicesIds && this.devicesIds.constructor === Array) {
            data["devicesIds"] = [];
            for (let item of this.devicesIds)
                data["devicesIds"].push(item);
        }
        return data; 
    }
}

export interface IStoreDevices {
    storeId: number;
    devicesIds: number[];
}

export class PagedCornerList implements IPagedCornerList {
    currentPage: number;
    itemsCount: number;
    corners: CornerListItem[];

    constructor(data?: IPagedCornerList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["corners"] && data["corners"].constructor === Array) {
                this.corners = [];
                for (let item of data["corners"])
                    this.corners.push(CornerListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedCornerList {
        let result = new PagedCornerList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.corners && this.corners.constructor === Array) {
            data["corners"] = [];
            for (let item of this.corners)
                data["corners"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedCornerList {
    currentPage: number;
    itemsCount: number;
    corners: CornerListItem[];
}

export class CreateCornerInput implements ICreateCornerInput {
    storeIds: number[];
    translations: CornerTranslationDto[];

    constructor(data?: ICreateCornerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CornerTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCornerInput {
        let result = new CreateCornerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateCornerInput {
    storeIds: number[];
    translations: CornerTranslationDto[];
}

export class EditCornerInput implements IEditCornerInput {
    id: number;
    storeIds: number[];
    translations: CornerTranslationDto[];

    constructor(data?: IEditCornerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CornerTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditCornerInput {
        let result = new EditCornerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditCornerInput {
    id: number;
    storeIds: number[];
    translations: CornerTranslationDto[];
}

export class DiningTableDto implements IDiningTableDto {
    id: string;
    tenantId: number;
    tableId: number;
    isSplit: boolean;
    saleTransactionId: string;

    constructor(data?: IDiningTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.tableId = data["tableId"];
            this.isSplit = data["isSplit"];
            this.saleTransactionId = data["saleTransactionId"];
        }
    }

    static fromJS(data: any): DiningTableDto {
        let result = new DiningTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tableId"] = this.tableId;
        data["isSplit"] = this.isSplit;
        data["saleTransactionId"] = this.saleTransactionId;
        return data; 
    }
}

export interface IDiningTableDto {
    id: string;
    tenantId: number;
    tableId: number;
    isSplit: boolean;
    saleTransactionId: string;
}

export class ChangeDiningTableRequest implements IChangeDiningTableRequest {
    saleTransactionsDiningTable: DiningTableDto[];
    removedTables: any[];

    constructor(data?: IChangeDiningTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["saleTransactionsDiningTable"] && data["saleTransactionsDiningTable"].constructor === Array) {
                this.saleTransactionsDiningTable = [];
                for (let item of data["saleTransactionsDiningTable"])
                    this.saleTransactionsDiningTable.push(DiningTableDto.fromJS(item));
            }
            if (data["removedTables"] && data["removedTables"].constructor === Array) {
                this.removedTables = [];
                for (let item of data["removedTables"])
                    this.removedTables.push(item);
            }
        }
    }

    static fromJS(data: any): ChangeDiningTableRequest {
        let result = new ChangeDiningTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.saleTransactionsDiningTable && this.saleTransactionsDiningTable.constructor === Array) {
            data["saleTransactionsDiningTable"] = [];
            for (let item of this.saleTransactionsDiningTable)
                data["saleTransactionsDiningTable"].push(item.toJSON());
        }
        if (this.removedTables && this.removedTables.constructor === Array) {
            data["removedTables"] = [];
            for (let item of this.removedTables)
                data["removedTables"].push(item);
        }
        return data; 
    }
}

export interface IChangeDiningTableRequest {
    saleTransactionsDiningTable: DiningTableDto[];
    removedTables: any[];
}

export class CountedStockDto implements ICountedStockDto {
    id: number;
    storeId: number;
    storeName: string;
    storeNumber: string;
    date: moment.Moment;
    dateStr: string;
    status: number;
    localizdStatus: string;
    periodType: number;
    localizdPeriodType: string;
    entryMaterialStocks: EntryMaterialStockDto[];

    constructor(data?: ICountedStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.storeNumber = data["storeNumber"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.dateStr = data["dateStr"];
            this.status = data["status"];
            this.localizdStatus = data["localizdStatus"];
            this.periodType = data["periodType"];
            this.localizdPeriodType = data["localizdPeriodType"];
            if (data["entryMaterialStocks"] && data["entryMaterialStocks"].constructor === Array) {
                this.entryMaterialStocks = [];
                for (let item of data["entryMaterialStocks"])
                    this.entryMaterialStocks.push(EntryMaterialStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountedStockDto {
        let result = new CountedStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["storeNumber"] = this.storeNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateStr"] = this.dateStr;
        data["status"] = this.status;
        data["localizdStatus"] = this.localizdStatus;
        data["periodType"] = this.periodType;
        data["localizdPeriodType"] = this.localizdPeriodType;
        if (this.entryMaterialStocks && this.entryMaterialStocks.constructor === Array) {
            data["entryMaterialStocks"] = [];
            for (let item of this.entryMaterialStocks)
                data["entryMaterialStocks"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICountedStockDto {
    id: number;
    storeId: number;
    storeName: string;
    storeNumber: string;
    date: moment.Moment;
    dateStr: string;
    status: number;
    localizdStatus: string;
    periodType: number;
    localizdPeriodType: string;
    entryMaterialStocks: EntryMaterialStockDto[];
}

export class EntryMaterialStockDto implements IEntryMaterialStockDto {
    materialId: number;
    rawMaterialName: string;
    rawMaterialCode: string;
    storeId: number;
    storeName: string;
    stockPeriodClosingDateId: number;
    unitOfMeasureName: string;
    qty: number;
    actualQty: number;
    finalQty: number;
    price: number;
    date: moment.Moment;
    included: boolean;
    expectedBalance: number;

    constructor(data?: IEntryMaterialStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialId = data["materialId"];
            this.rawMaterialName = data["rawMaterialName"];
            this.rawMaterialCode = data["rawMaterialCode"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.stockPeriodClosingDateId = data["stockPeriodClosingDateId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.qty = data["qty"];
            this.actualQty = data["actualQty"];
            this.finalQty = data["finalQty"];
            this.price = data["price"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.included = data["included"];
            this.expectedBalance = data["expectedBalance"];
        }
    }

    static fromJS(data: any): EntryMaterialStockDto {
        let result = new EntryMaterialStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["rawMaterialName"] = this.rawMaterialName;
        data["rawMaterialCode"] = this.rawMaterialCode;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["stockPeriodClosingDateId"] = this.stockPeriodClosingDateId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["qty"] = this.qty;
        data["actualQty"] = this.actualQty;
        data["finalQty"] = this.finalQty;
        data["price"] = this.price;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["included"] = this.included;
        data["expectedBalance"] = this.expectedBalance;
        return data; 
    }
}

export interface IEntryMaterialStockDto {
    materialId: number;
    rawMaterialName: string;
    rawMaterialCode: string;
    storeId: number;
    storeName: string;
    stockPeriodClosingDateId: number;
    unitOfMeasureName: string;
    qty: number;
    actualQty: number;
    finalQty: number;
    price: number;
    date: moment.Moment;
    included: boolean;
    expectedBalance: number;
}

export class PagedCountedStockList implements IPagedCountedStockList {
    currentPage: number;
    itemsCount: number;
    countedStocks: CountedStockListItem[];

    constructor(data?: IPagedCountedStockList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["countedStocks"] && data["countedStocks"].constructor === Array) {
                this.countedStocks = [];
                for (let item of data["countedStocks"])
                    this.countedStocks.push(CountedStockListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedCountedStockList {
        let result = new PagedCountedStockList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.countedStocks && this.countedStocks.constructor === Array) {
            data["countedStocks"] = [];
            for (let item of this.countedStocks)
                data["countedStocks"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedCountedStockList {
    currentPage: number;
    itemsCount: number;
    countedStocks: CountedStockListItem[];
}

export class CountedStockListItem implements ICountedStockListItem {
    id: number;
    storeId: number;
    storeName: string;
    storeNumber: string;
    date: moment.Moment;
    periodType: number;
    localizdPeriodType: string;
    status: number;
    localizdStatus: string;
    canDoEntryCountedStock: boolean;
    canDoInventoryClosing: boolean;

    constructor(data?: ICountedStockListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.storeNumber = data["storeNumber"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.periodType = data["periodType"];
            this.localizdPeriodType = data["localizdPeriodType"];
            this.status = data["status"];
            this.localizdStatus = data["localizdStatus"];
            this.canDoEntryCountedStock = data["canDoEntryCountedStock"];
            this.canDoInventoryClosing = data["canDoInventoryClosing"];
        }
    }

    static fromJS(data: any): CountedStockListItem {
        let result = new CountedStockListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["storeNumber"] = this.storeNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["periodType"] = this.periodType;
        data["localizdPeriodType"] = this.localizdPeriodType;
        data["status"] = this.status;
        data["localizdStatus"] = this.localizdStatus;
        data["canDoEntryCountedStock"] = this.canDoEntryCountedStock;
        data["canDoInventoryClosing"] = this.canDoInventoryClosing;
        return data; 
    }
}

export interface ICountedStockListItem {
    id: number;
    storeId: number;
    storeName: string;
    storeNumber: string;
    date: moment.Moment;
    periodType: number;
    localizdPeriodType: string;
    status: number;
    localizdStatus: string;
    canDoEntryCountedStock: boolean;
    canDoInventoryClosing: boolean;
}

export class CountedStockRetailDto implements ICountedStockRetailDto {
    storeId: number;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;
    storeName: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICountedStockRetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.countedStockRetailDate = data["countedStockRetailDate"] ? moment(data["countedStockRetailDate"].toString()) : <any>undefined;
            if (data["countedStockRetailDetails"] && data["countedStockRetailDetails"].constructor === Array) {
                this.countedStockRetailDetails = [];
                for (let item of data["countedStockRetailDetails"])
                    this.countedStockRetailDetails.push(CountedStockRetailDetailsDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
            this.storeName = data["storeName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CountedStockRetailDto {
        let result = new CountedStockRetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["countedStockRetailDate"] = this.countedStockRetailDate ? this.countedStockRetailDate.toISOString() : <any>undefined;
        if (this.countedStockRetailDetails && this.countedStockRetailDetails.constructor === Array) {
            data["countedStockRetailDetails"] = [];
            for (let item of this.countedStockRetailDetails)
                data["countedStockRetailDetails"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        data["storeName"] = this.storeName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICountedStockRetailDto {
    storeId: number;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;
    storeName: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CountedStockRetailDetailsDto implements ICountedStockRetailDetailsDto {
    id: number;
    tenantId: number;
    countedStockRetailId: number;
    expectedQuantity: number;
    inventoryQuantity: number;
    productId: number;
    productName: string;
    product: ProductDto;
    productVariantId: number;
    productVariantName: string;
    productVariant: ProductVariantDto;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    unitOfMeasure: UnitOfMeasureDto;
    notes: string;
    products: ProductListItem[];
    productVariants: ProductVariantListItem[];
    unitOfMeasures: UnitOfMeasureListItem[];

    constructor(data?: ICountedStockRetailDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.countedStockRetailId = data["countedStockRetailId"];
            this.expectedQuantity = data["expectedQuantity"];
            this.inventoryQuantity = data["inventoryQuantity"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.product = data["product"] ? ProductDto.fromJS(data["product"]) : <any>undefined;
            this.productVariantId = data["productVariantId"];
            this.productVariantName = data["productVariantName"];
            this.productVariant = data["productVariant"] ? ProductVariantDto.fromJS(data["productVariant"]) : <any>undefined;
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasureDto.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.notes = data["notes"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(ProductListItem.fromJS(item));
            }
            if (data["productVariants"] && data["productVariants"].constructor === Array) {
                this.productVariants = [];
                for (let item of data["productVariants"])
                    this.productVariants.push(ProductVariantListItem.fromJS(item));
            }
            if (data["unitOfMeasures"] && data["unitOfMeasures"].constructor === Array) {
                this.unitOfMeasures = [];
                for (let item of data["unitOfMeasures"])
                    this.unitOfMeasures.push(UnitOfMeasureListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountedStockRetailDetailsDto {
        let result = new CountedStockRetailDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["countedStockRetailId"] = this.countedStockRetailId;
        data["expectedQuantity"] = this.expectedQuantity;
        data["inventoryQuantity"] = this.inventoryQuantity;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productVariantId"] = this.productVariantId;
        data["productVariantName"] = this.productVariantName;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.productVariants && this.productVariants.constructor === Array) {
            data["productVariants"] = [];
            for (let item of this.productVariants)
                data["productVariants"].push(item.toJSON());
        }
        if (this.unitOfMeasures && this.unitOfMeasures.constructor === Array) {
            data["unitOfMeasures"] = [];
            for (let item of this.unitOfMeasures)
                data["unitOfMeasures"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICountedStockRetailDetailsDto {
    id: number;
    tenantId: number;
    countedStockRetailId: number;
    expectedQuantity: number;
    inventoryQuantity: number;
    productId: number;
    productName: string;
    product: ProductDto;
    productVariantId: number;
    productVariantName: string;
    productVariant: ProductVariantDto;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    unitOfMeasure: UnitOfMeasureDto;
    notes: string;
    products: ProductListItem[];
    productVariants: ProductVariantListItem[];
    unitOfMeasures: UnitOfMeasureListItem[];
}

export class ProductVariantDto implements IProductVariantDto {
    id: number;
    variantValue1Id: number;
    variantValue2Id: number;
    variantValue3Id: number;
    code: string;

    constructor(data?: IProductVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.variantValue1Id = data["variantValue1Id"];
            this.variantValue2Id = data["variantValue2Id"];
            this.variantValue3Id = data["variantValue3Id"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): ProductVariantDto {
        let result = new ProductVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["variantValue1Id"] = this.variantValue1Id;
        data["variantValue2Id"] = this.variantValue2Id;
        data["variantValue3Id"] = this.variantValue3Id;
        data["code"] = this.code;
        return data; 
    }
}

export interface IProductVariantDto {
    id: number;
    variantValue1Id: number;
    variantValue2Id: number;
    variantValue3Id: number;
    code: string;
}

export class UnitOfMeasureDto implements IUnitOfMeasureDto {
    code: string;
    translations: UnitOfMeasureTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUnitOfMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(UnitOfMeasureTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnitOfMeasureDto {
        let result = new UnitOfMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUnitOfMeasureDto {
    code: string;
    translations: UnitOfMeasureTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductVariantListItem implements IProductVariantListItem {
    id: number;
    code: string;
    name: string;

    constructor(data?: IProductVariantListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ProductVariantListItem {
        let result = new ProductVariantListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProductVariantListItem {
    id: number;
    code: string;
    name: string;
}

export class UnitOfMeasureTranslationDto implements IUnitOfMeasureTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IUnitOfMeasureTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): UnitOfMeasureTranslationDto {
        let result = new UnitOfMeasureTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IUnitOfMeasureTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfCountedStockRetailListItem implements IListResultDtoOfCountedStockRetailListItem {
    items: CountedStockRetailListItem[];

    constructor(data?: IListResultDtoOfCountedStockRetailListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CountedStockRetailListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCountedStockRetailListItem {
        let result = new ListResultDtoOfCountedStockRetailListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCountedStockRetailListItem {
    items: CountedStockRetailListItem[];
}

export class CountedStockRetailListItem implements ICountedStockRetailListItem {
    id: number;
    storeId: number;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;
    storeName: string;
    acutalQuantity: string;

    constructor(data?: ICountedStockRetailListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeId = data["storeId"];
            this.countedStockRetailDate = data["countedStockRetailDate"] ? moment(data["countedStockRetailDate"].toString()) : <any>undefined;
            if (data["countedStockRetailDetails"] && data["countedStockRetailDetails"].constructor === Array) {
                this.countedStockRetailDetails = [];
                for (let item of data["countedStockRetailDetails"])
                    this.countedStockRetailDetails.push(CountedStockRetailDetailsDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
            this.storeName = data["storeName"];
            this.acutalQuantity = data["acutalQuantity"];
        }
    }

    static fromJS(data: any): CountedStockRetailListItem {
        let result = new CountedStockRetailListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["countedStockRetailDate"] = this.countedStockRetailDate ? this.countedStockRetailDate.toISOString() : <any>undefined;
        if (this.countedStockRetailDetails && this.countedStockRetailDetails.constructor === Array) {
            data["countedStockRetailDetails"] = [];
            for (let item of this.countedStockRetailDetails)
                data["countedStockRetailDetails"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        data["storeName"] = this.storeName;
        data["acutalQuantity"] = this.acutalQuantity;
        return data; 
    }
}

export interface ICountedStockRetailListItem {
    id: number;
    storeId: number;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;
    storeName: string;
    acutalQuantity: string;
}

export class CreateCountedStockRetailInput implements ICreateCountedStockRetailInput {
    storeId: number;
    store: StoreDto;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;

    constructor(data?: ICreateCountedStockRetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.store = data["store"] ? StoreDto.fromJS(data["store"]) : <any>undefined;
            this.countedStockRetailDate = data["countedStockRetailDate"] ? moment(data["countedStockRetailDate"].toString()) : <any>undefined;
            if (data["countedStockRetailDetails"] && data["countedStockRetailDetails"].constructor === Array) {
                this.countedStockRetailDetails = [];
                for (let item of data["countedStockRetailDetails"])
                    this.countedStockRetailDetails.push(CountedStockRetailDetailsDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): CreateCountedStockRetailInput {
        let result = new CreateCountedStockRetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["countedStockRetailDate"] = this.countedStockRetailDate ? this.countedStockRetailDate.toISOString() : <any>undefined;
        if (this.countedStockRetailDetails && this.countedStockRetailDetails.constructor === Array) {
            data["countedStockRetailDetails"] = [];
            for (let item of this.countedStockRetailDetails)
                data["countedStockRetailDetails"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface ICreateCountedStockRetailInput {
    storeId: number;
    store: StoreDto;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;
}

export class StoreDto implements IStoreDto {
    currencyId: number;
    translations: StoreTranslationDto[];
    storeWorkingHoursRules: number[];
    inventoryManagers: number[];
    closeShiftByCashier: boolean;
    name: string;
    type: number;
    isClosed: boolean;
    currencyName: string;
    number: string;
    isWarehouse: boolean;
    isStoreGroup: boolean;
    storeGroupId: number;
    storeGroupParentId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(StoreTranslationDto.fromJS(item));
            }
            if (data["storeWorkingHoursRules"] && data["storeWorkingHoursRules"].constructor === Array) {
                this.storeWorkingHoursRules = [];
                for (let item of data["storeWorkingHoursRules"])
                    this.storeWorkingHoursRules.push(item);
            }
            if (data["inventoryManagers"] && data["inventoryManagers"].constructor === Array) {
                this.inventoryManagers = [];
                for (let item of data["inventoryManagers"])
                    this.inventoryManagers.push(item);
            }
            this.closeShiftByCashier = data["closeShiftByCashier"];
            this.name = data["name"];
            this.type = data["type"];
            this.isClosed = data["isClosed"];
            this.currencyName = data["currencyName"];
            this.number = data["number"];
            this.isWarehouse = data["isWarehouse"];
            this.isStoreGroup = data["isStoreGroup"];
            this.storeGroupId = data["storeGroupId"];
            this.storeGroupParentId = data["storeGroupParentId"];
            this.tenantStoreGroupId = data["tenantStoreGroupId"];
            this.areaId = data["areaId"];
            this.regionId = data["regionId"];
            this.contractBegining = data["contractBegining"] ? moment(data["contractBegining"].toString()) : <any>undefined;
            this.contractEnding = data["contractEnding"] ? moment(data["contractEnding"].toString()) : <any>undefined;
            this.alertPeriod = data["alertPeriod"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreDto {
        let result = new StoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeWorkingHoursRules && this.storeWorkingHoursRules.constructor === Array) {
            data["storeWorkingHoursRules"] = [];
            for (let item of this.storeWorkingHoursRules)
                data["storeWorkingHoursRules"].push(item);
        }
        if (this.inventoryManagers && this.inventoryManagers.constructor === Array) {
            data["inventoryManagers"] = [];
            for (let item of this.inventoryManagers)
                data["inventoryManagers"].push(item);
        }
        data["closeShiftByCashier"] = this.closeShiftByCashier;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isClosed"] = this.isClosed;
        data["currencyName"] = this.currencyName;
        data["number"] = this.number;
        data["isWarehouse"] = this.isWarehouse;
        data["isStoreGroup"] = this.isStoreGroup;
        data["storeGroupId"] = this.storeGroupId;
        data["storeGroupParentId"] = this.storeGroupParentId;
        data["tenantStoreGroupId"] = this.tenantStoreGroupId;
        data["areaId"] = this.areaId;
        data["regionId"] = this.regionId;
        data["contractBegining"] = this.contractBegining ? this.contractBegining.toISOString() : <any>undefined;
        data["contractEnding"] = this.contractEnding ? this.contractEnding.toISOString() : <any>undefined;
        data["alertPeriod"] = this.alertPeriod;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreDto {
    currencyId: number;
    translations: StoreTranslationDto[];
    storeWorkingHoursRules: number[];
    inventoryManagers: number[];
    closeShiftByCashier: boolean;
    name: string;
    type: number;
    isClosed: boolean;
    currencyName: string;
    number: string;
    isWarehouse: boolean;
    isStoreGroup: boolean;
    storeGroupId: number;
    storeGroupParentId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreTranslationDto implements IStoreTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IStoreTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): StoreTranslationDto {
        let result = new StoreTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IStoreTranslationDto {
    name: string;
    languageId: number;
}

export class UpdateCountedStockRetailInput implements IUpdateCountedStockRetailInput {
    id: number;
    store: StoreDto;
    storeId: number;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;

    constructor(data?: IUpdateCountedStockRetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.store = data["store"] ? StoreDto.fromJS(data["store"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.countedStockRetailDate = data["countedStockRetailDate"] ? moment(data["countedStockRetailDate"].toString()) : <any>undefined;
            if (data["countedStockRetailDetails"] && data["countedStockRetailDetails"].constructor === Array) {
                this.countedStockRetailDetails = [];
                for (let item of data["countedStockRetailDetails"])
                    this.countedStockRetailDetails.push(CountedStockRetailDetailsDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): UpdateCountedStockRetailInput {
        let result = new UpdateCountedStockRetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["countedStockRetailDate"] = this.countedStockRetailDate ? this.countedStockRetailDate.toISOString() : <any>undefined;
        if (this.countedStockRetailDetails && this.countedStockRetailDetails.constructor === Array) {
            data["countedStockRetailDetails"] = [];
            for (let item of this.countedStockRetailDetails)
                data["countedStockRetailDetails"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface IUpdateCountedStockRetailInput {
    id: number;
    store: StoreDto;
    storeId: number;
    countedStockRetailDate: moment.Moment;
    countedStockRetailDetails: CountedStockRetailDetailsDto[];
    tenantId: number;
    notes: string;
}

export class PagedCountedStockRetailList implements IPagedCountedStockRetailList {
    currentPage: number;
    itemsCount: number;
    countedStocksRetail: CountedStockRetailListItem[];

    constructor(data?: IPagedCountedStockRetailList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["countedStocksRetail"] && data["countedStocksRetail"].constructor === Array) {
                this.countedStocksRetail = [];
                for (let item of data["countedStocksRetail"])
                    this.countedStocksRetail.push(CountedStockRetailListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedCountedStockRetailList {
        let result = new PagedCountedStockRetailList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.countedStocksRetail && this.countedStocksRetail.constructor === Array) {
            data["countedStocksRetail"] = [];
            for (let item of this.countedStocksRetail)
                data["countedStocksRetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedCountedStockRetailList {
    currentPage: number;
    itemsCount: number;
    countedStocksRetail: CountedStockRetailListItem[];
}

export class CurrencyDto implements ICurrencyDto {
    translations: CurrencyTranslationDto[];
    rate: number;
    default: boolean;
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CurrencyTranslationDto.fromJS(item));
            }
            this.rate = data["rate"];
            this.default = data["default"];
            this.code = data["code"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CurrencyDto {
        let result = new CurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["rate"] = this.rate;
        data["default"] = this.default;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrencyDto {
    translations: CurrencyTranslationDto[];
    rate: number;
    default: boolean;
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CurrencyTranslationDto implements ICurrencyTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ICurrencyTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): CurrencyTranslationDto {
        let result = new CurrencyTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ICurrencyTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfCurrencyListItem implements IListResultDtoOfCurrencyListItem {
    items: CurrencyListItem[];

    constructor(data?: IListResultDtoOfCurrencyListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CurrencyListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCurrencyListItem {
        let result = new ListResultDtoOfCurrencyListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCurrencyListItem {
    items: CurrencyListItem[];
}

export class CurrencyListItem implements ICurrencyListItem {
    id: number;
    name: string;
    default: boolean;
    rate: number;
    code: string;

    constructor(data?: ICurrencyListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.default = data["default"];
            this.rate = data["rate"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): CurrencyListItem {
        let result = new CurrencyListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["default"] = this.default;
        data["rate"] = this.rate;
        data["code"] = this.code;
        return data; 
    }
}

export interface ICurrencyListItem {
    id: number;
    name: string;
    default: boolean;
    rate: number;
    code: string;
}

export class PagedCurrenciesList implements IPagedCurrenciesList {
    currentPage: number;
    itemsCount: number;
    currencies: CurrencyListItem[];

    constructor(data?: IPagedCurrenciesList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["currencies"] && data["currencies"].constructor === Array) {
                this.currencies = [];
                for (let item of data["currencies"])
                    this.currencies.push(CurrencyListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedCurrenciesList {
        let result = new PagedCurrenciesList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.currencies && this.currencies.constructor === Array) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedCurrenciesList {
    currentPage: number;
    itemsCount: number;
    currencies: CurrencyListItem[];
}

export class CreateCurrencyInput implements ICreateCurrencyInput {
    code: string;
    translations: CurrencyTranslationDto[];
    rate: number;

    constructor(data?: ICreateCurrencyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CurrencyTranslationDto.fromJS(item));
            }
            this.rate = data["rate"];
        }
    }

    static fromJS(data: any): CreateCurrencyInput {
        let result = new CreateCurrencyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["rate"] = this.rate;
        return data; 
    }
}

export interface ICreateCurrencyInput {
    code: string;
    translations: CurrencyTranslationDto[];
    rate: number;
}

export class UpdateCurrencyInput implements IUpdateCurrencyInput {
    id: number;
    rate: number;
    code: string;
    translations: CurrencyTranslationDto[];

    constructor(data?: IUpdateCurrencyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rate = data["rate"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CurrencyTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCurrencyInput {
        let result = new UpdateCurrencyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rate"] = this.rate;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateCurrencyInput {
    id: number;
    rate: number;
    code: string;
    translations: CurrencyTranslationDto[];
}

export class CustomerDto implements ICustomerDto {
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    note: string;
    cellPhone: string;
    fax: string;
    postalCode: string;
    email: string;
    email2: string;
    governorate: string;
    blockNo: string;
    website: string;
    taxNumber: string;
    commericalNumber: string;
    buildingNumber: string;
    identificationSchemeID: string;
    area: string;
    discountPrcnt: number;
    customerAddress: CustomerAddressInput[];
    customerSaleTypes: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerType = data["customerType"];
            this.id = data["id"];
            this.code = data["code"];
            this.cardNumber = data["cardNumber"];
            this.contactName = data["contactName"];
            this.address = data["address"];
            this.city = data["city"];
            this.country = data["country"];
            this.phone = data["phone"];
            this.note = data["note"];
            this.cellPhone = data["cellPhone"];
            this.fax = data["fax"];
            this.postalCode = data["postalCode"];
            this.email = data["email"];
            this.email2 = data["email2"];
            this.governorate = data["governorate"];
            this.blockNo = data["blockNo"];
            this.website = data["website"];
            this.taxNumber = data["taxNumber"];
            this.commericalNumber = data["commericalNumber"];
            this.buildingNumber = data["buildingNumber"];
            this.identificationSchemeID = data["identificationSchemeID"];
            this.area = data["area"];
            this.discountPrcnt = data["discountPrcnt"];
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddressInput.fromJS(item));
            }
            if (data["customerSaleTypes"] && data["customerSaleTypes"].constructor === Array) {
                this.customerSaleTypes = [];
                for (let item of data["customerSaleTypes"])
                    this.customerSaleTypes.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerDto {
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerType"] = this.customerType;
        data["id"] = this.id;
        data["code"] = this.code;
        data["cardNumber"] = this.cardNumber;
        data["contactName"] = this.contactName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["note"] = this.note;
        data["cellPhone"] = this.cellPhone;
        data["fax"] = this.fax;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["governorate"] = this.governorate;
        data["blockNo"] = this.blockNo;
        data["website"] = this.website;
        data["taxNumber"] = this.taxNumber;
        data["commericalNumber"] = this.commericalNumber;
        data["buildingNumber"] = this.buildingNumber;
        data["identificationSchemeID"] = this.identificationSchemeID;
        data["area"] = this.area;
        data["discountPrcnt"] = this.discountPrcnt;
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        if (this.customerSaleTypes && this.customerSaleTypes.constructor === Array) {
            data["customerSaleTypes"] = [];
            for (let item of this.customerSaleTypes)
                data["customerSaleTypes"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICustomerDto {
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    note: string;
    cellPhone: string;
    fax: string;
    postalCode: string;
    email: string;
    email2: string;
    governorate: string;
    blockNo: string;
    website: string;
    taxNumber: string;
    commericalNumber: string;
    buildingNumber: string;
    identificationSchemeID: string;
    area: string;
    discountPrcnt: number;
    customerAddress: CustomerAddressInput[];
    customerSaleTypes: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
}

export class CustomerAddressInput implements ICustomerAddressInput {
    id: number;
    deliveryZoneId: number;
    customerName: string;
    deliveryZoneText: string;
    deliveryStreetId: number;
    deliveryStreetText: string;
    address: string;
    link: string;
    city: string;
    zoneName: string;
    streetName: string;
    deliveryStreetList: DeliveryStreetListItem[];
    isSelected: boolean;

    constructor(data?: ICustomerAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.customerName = data["customerName"];
            this.deliveryZoneText = data["deliveryZoneText"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.deliveryStreetText = data["deliveryStreetText"];
            this.address = data["address"];
            this.link = data["link"];
            this.city = data["city"];
            this.zoneName = data["zoneName"];
            this.streetName = data["streetName"];
            if (data["deliveryStreetList"] && data["deliveryStreetList"].constructor === Array) {
                this.deliveryStreetList = [];
                for (let item of data["deliveryStreetList"])
                    this.deliveryStreetList.push(DeliveryStreetListItem.fromJS(item));
            }
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): CustomerAddressInput {
        let result = new CustomerAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["customerName"] = this.customerName;
        data["deliveryZoneText"] = this.deliveryZoneText;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["deliveryStreetText"] = this.deliveryStreetText;
        data["address"] = this.address;
        data["link"] = this.link;
        data["city"] = this.city;
        data["zoneName"] = this.zoneName;
        data["streetName"] = this.streetName;
        if (this.deliveryStreetList && this.deliveryStreetList.constructor === Array) {
            data["deliveryStreetList"] = [];
            for (let item of this.deliveryStreetList)
                data["deliveryStreetList"].push(item.toJSON());
        }
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ICustomerAddressInput {
    id: number;
    deliveryZoneId: number;
    customerName: string;
    deliveryZoneText: string;
    deliveryStreetId: number;
    deliveryStreetText: string;
    address: string;
    link: string;
    city: string;
    zoneName: string;
    streetName: string;
    deliveryStreetList: DeliveryStreetListItem[];
    isSelected: boolean;
}

export class DeliveryStreetListItem implements IDeliveryStreetListItem {
    id: number;
    name: string;

    constructor(data?: IDeliveryStreetListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): DeliveryStreetListItem {
        let result = new DeliveryStreetListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IDeliveryStreetListItem {
    id: number;
    name: string;
}

export class ListResultDtoOfCustomerListItem implements IListResultDtoOfCustomerListItem {
    items: CustomerListItem[];

    constructor(data?: IListResultDtoOfCustomerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CustomerListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCustomerListItem {
        let result = new ListResultDtoOfCustomerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCustomerListItem {
    items: CustomerListItem[];
}

export class CustomerListItem implements ICustomerListItem {
    id: string;
    fullName: string;
    cellPhone: string;
    code: string;

    constructor(data?: ICustomerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.fullName = data["fullName"];
            this.cellPhone = data["cellPhone"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): CustomerListItem {
        let result = new CustomerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["cellPhone"] = this.cellPhone;
        data["code"] = this.code;
        return data; 
    }
}

export interface ICustomerListItem {
    id: string;
    fullName: string;
    cellPhone: string;
    code: string;
}

export class PagedCustomerList implements IPagedCustomerList {
    currentPage: number;
    itemsCount: number;
    customers: CustomerListItem[];

    constructor(data?: IPagedCustomerList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["customers"] && data["customers"].constructor === Array) {
                this.customers = [];
                for (let item of data["customers"])
                    this.customers.push(CustomerListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedCustomerList {
        let result = new PagedCustomerList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.customers && this.customers.constructor === Array) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedCustomerList {
    currentPage: number;
    itemsCount: number;
    customers: CustomerListItem[];
}

export class CreateCustomerInput implements ICreateCustomerInput {
    customerAddress: CustomerAddressInput[];
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    note: string;
    website: string;
    taxNumber: string;
    governorate: string;
    blockNo: string;
    commericalNumber: string;
    identificationSchemeId: string;
    buildingNumber: string;
    area: string;
    discountPrcnt: number;
    customerSaleTypes: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;

    constructor(data?: ICreateCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddressInput.fromJS(item));
            }
            this.customerType = data["customerType"];
            this.id = data["id"];
            this.code = data["code"];
            this.cardNumber = data["cardNumber"];
            this.contactName = data["contactName"];
            this.address = data["address"];
            this.city = data["city"];
            this.country = data["country"];
            this.phone = data["phone"];
            this.cellPhone = data["cellPhone"];
            this.fax = data["fax"];
            this.currency = data["currency"];
            this.postalCode = data["postalCode"];
            this.email = data["email"];
            this.email2 = data["email2"];
            this.note = data["note"];
            this.website = data["website"];
            this.taxNumber = data["taxNumber"];
            this.governorate = data["governorate"];
            this.blockNo = data["blockNo"];
            this.commericalNumber = data["commericalNumber"];
            this.identificationSchemeId = data["identificationSchemeId"];
            this.buildingNumber = data["buildingNumber"];
            this.area = data["area"];
            this.discountPrcnt = data["discountPrcnt"];
            if (data["customerSaleTypes"] && data["customerSaleTypes"].constructor === Array) {
                this.customerSaleTypes = [];
                for (let item of data["customerSaleTypes"])
                    this.customerSaleTypes.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCustomerInput {
        let result = new CreateCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        data["customerType"] = this.customerType;
        data["id"] = this.id;
        data["code"] = this.code;
        data["cardNumber"] = this.cardNumber;
        data["contactName"] = this.contactName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["fax"] = this.fax;
        data["currency"] = this.currency;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["note"] = this.note;
        data["website"] = this.website;
        data["taxNumber"] = this.taxNumber;
        data["governorate"] = this.governorate;
        data["blockNo"] = this.blockNo;
        data["commericalNumber"] = this.commericalNumber;
        data["identificationSchemeId"] = this.identificationSchemeId;
        data["buildingNumber"] = this.buildingNumber;
        data["area"] = this.area;
        data["discountPrcnt"] = this.discountPrcnt;
        if (this.customerSaleTypes && this.customerSaleTypes.constructor === Array) {
            data["customerSaleTypes"] = [];
            for (let item of this.customerSaleTypes)
                data["customerSaleTypes"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICreateCustomerInput {
    customerAddress: CustomerAddressInput[];
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    note: string;
    website: string;
    taxNumber: string;
    governorate: string;
    blockNo: string;
    commericalNumber: string;
    identificationSchemeId: string;
    buildingNumber: string;
    area: string;
    discountPrcnt: number;
    customerSaleTypes: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName: string;
    defaultLanguageId: number;
    items: ApplicationLanguageListDto[];

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            this.defaultLanguageId = data["defaultLanguageId"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string;
    defaultLanguageId: number;
    items: ApplicationLanguageListDto[];
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreateCustomerInputBy implements ICreateCustomerInputBy {
    customerAddress: CustomerAddressInput[];
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    note: string;
    website: string;
    taxNumber: string;
    governorate: string;
    blockNo: string;
    commericalNumber: string;
    identificationSchemeId: string;
    buildingNumber: string;
    area: string;
    customerSaleTypes: number[];

    constructor(data?: ICreateCustomerInputBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddressInput.fromJS(item));
            }
            this.customerType = data["customerType"];
            this.id = data["id"];
            this.code = data["code"];
            this.cardNumber = data["cardNumber"];
            this.contactName = data["contactName"];
            this.address = data["address"];
            this.city = data["city"];
            this.country = data["country"];
            this.phone = data["phone"];
            this.cellPhone = data["cellPhone"];
            this.fax = data["fax"];
            this.currency = data["currency"];
            this.postalCode = data["postalCode"];
            this.email = data["email"];
            this.email2 = data["email2"];
            this.note = data["note"];
            this.website = data["website"];
            this.taxNumber = data["taxNumber"];
            this.governorate = data["governorate"];
            this.blockNo = data["blockNo"];
            this.commericalNumber = data["commericalNumber"];
            this.identificationSchemeId = data["identificationSchemeId"];
            this.buildingNumber = data["buildingNumber"];
            this.area = data["area"];
            if (data["customerSaleTypes"] && data["customerSaleTypes"].constructor === Array) {
                this.customerSaleTypes = [];
                for (let item of data["customerSaleTypes"])
                    this.customerSaleTypes.push(item);
            }
        }
    }

    static fromJS(data: any): CreateCustomerInputBy {
        let result = new CreateCustomerInputBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        data["customerType"] = this.customerType;
        data["id"] = this.id;
        data["code"] = this.code;
        data["cardNumber"] = this.cardNumber;
        data["contactName"] = this.contactName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["fax"] = this.fax;
        data["currency"] = this.currency;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["note"] = this.note;
        data["website"] = this.website;
        data["taxNumber"] = this.taxNumber;
        data["governorate"] = this.governorate;
        data["blockNo"] = this.blockNo;
        data["commericalNumber"] = this.commericalNumber;
        data["identificationSchemeId"] = this.identificationSchemeId;
        data["buildingNumber"] = this.buildingNumber;
        data["area"] = this.area;
        if (this.customerSaleTypes && this.customerSaleTypes.constructor === Array) {
            data["customerSaleTypes"] = [];
            for (let item of this.customerSaleTypes)
                data["customerSaleTypes"].push(item);
        }
        return data; 
    }
}

export interface ICreateCustomerInputBy {
    customerAddress: CustomerAddressInput[];
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    note: string;
    website: string;
    taxNumber: string;
    governorate: string;
    blockNo: string;
    commericalNumber: string;
    identificationSchemeId: string;
    buildingNumber: string;
    area: string;
    customerSaleTypes: number[];
}

export class AddCustomerAddress implements IAddCustomerAddress {
    id: number;
    customerId: string;
    deliveryZoneId: number;
    deliveryStreetId: number;
    address: string;
    link: string;
    city: string;
    zoneName: string;
    streetName: string;
    isSelected: boolean;

    constructor(data?: IAddCustomerAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.customerId = data["customerId"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.address = data["address"];
            this.link = data["link"];
            this.city = data["city"];
            this.zoneName = data["zoneName"];
            this.streetName = data["streetName"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): AddCustomerAddress {
        let result = new AddCustomerAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["address"] = this.address;
        data["link"] = this.link;
        data["city"] = this.city;
        data["zoneName"] = this.zoneName;
        data["streetName"] = this.streetName;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IAddCustomerAddress {
    id: number;
    customerId: string;
    deliveryZoneId: number;
    deliveryStreetId: number;
    address: string;
    link: string;
    city: string;
    zoneName: string;
    streetName: string;
    isSelected: boolean;
}

export class ChangeSelectedAddress implements IChangeSelectedAddress {
    addressId: number;
    customerId: string;

    constructor(data?: IChangeSelectedAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addressId = data["addressId"];
            this.customerId = data["customerId"];
        }
    }

    static fromJS(data: any): ChangeSelectedAddress {
        let result = new ChangeSelectedAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IChangeSelectedAddress {
    addressId: number;
    customerId: string;
}

export class UpdateCustomerInput implements IUpdateCustomerInput {
    customerAddress: CustomerAddressInput[];
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    governorate: string;
    blockNo: string;
    cellPhone: string;
    fax: string;
    note: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    website: string;
    taxNumber: string;
    commericalNumber: string;
    buildingNumber: string;
    identificationSchemeID: string;
    area: string;
    discountPrcnt: number;
    customerSaleTypes: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;

    constructor(data?: IUpdateCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddressInput.fromJS(item));
            }
            this.customerType = data["customerType"];
            this.id = data["id"];
            this.code = data["code"];
            this.cardNumber = data["cardNumber"];
            this.contactName = data["contactName"];
            this.address = data["address"];
            this.city = data["city"];
            this.country = data["country"];
            this.phone = data["phone"];
            this.governorate = data["governorate"];
            this.blockNo = data["blockNo"];
            this.cellPhone = data["cellPhone"];
            this.fax = data["fax"];
            this.note = data["note"];
            this.currency = data["currency"];
            this.postalCode = data["postalCode"];
            this.email = data["email"];
            this.email2 = data["email2"];
            this.website = data["website"];
            this.taxNumber = data["taxNumber"];
            this.commericalNumber = data["commericalNumber"];
            this.buildingNumber = data["buildingNumber"];
            this.identificationSchemeID = data["identificationSchemeID"];
            this.area = data["area"];
            this.discountPrcnt = data["discountPrcnt"];
            if (data["customerSaleTypes"] && data["customerSaleTypes"].constructor === Array) {
                this.customerSaleTypes = [];
                for (let item of data["customerSaleTypes"])
                    this.customerSaleTypes.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerInput {
        let result = new UpdateCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        data["customerType"] = this.customerType;
        data["id"] = this.id;
        data["code"] = this.code;
        data["cardNumber"] = this.cardNumber;
        data["contactName"] = this.contactName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["governorate"] = this.governorate;
        data["blockNo"] = this.blockNo;
        data["cellPhone"] = this.cellPhone;
        data["fax"] = this.fax;
        data["note"] = this.note;
        data["currency"] = this.currency;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["website"] = this.website;
        data["taxNumber"] = this.taxNumber;
        data["commericalNumber"] = this.commericalNumber;
        data["buildingNumber"] = this.buildingNumber;
        data["identificationSchemeID"] = this.identificationSchemeID;
        data["area"] = this.area;
        data["discountPrcnt"] = this.discountPrcnt;
        if (this.customerSaleTypes && this.customerSaleTypes.constructor === Array) {
            data["customerSaleTypes"] = [];
            for (let item of this.customerSaleTypes)
                data["customerSaleTypes"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerInput {
    customerAddress: CustomerAddressInput[];
    customerType: number;
    id: string;
    code: string;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    governorate: string;
    blockNo: string;
    cellPhone: string;
    fax: string;
    note: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    website: string;
    taxNumber: string;
    commericalNumber: string;
    buildingNumber: string;
    identificationSchemeID: string;
    area: string;
    discountPrcnt: number;
    customerSaleTypes: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
}

export class CustomerSyncDto implements ICustomerSyncDto {
    id: string;
    cardNumber: string;
    cellPhone: string;
    city: string;
    contactName: string;
    country: string;
    currency: number;
    email: string;
    email2: string;
    fax: string;
    phone: string;
    postalCode: string;
    tenantId: number;
    website: string;
    accountId: string;
    customerAddresses: CustomerAddressSyncDto[];
    customerSaleTypes: number[];
    commericalNumber: string;
    taxNumber: string;
    customerType: number;
    note: string;
    streetName: string;
    zoneName: string;
    buildingNumber: string;
    identificationSchemeID: string;
    area: string;
    governorate: string;
    blockNo: string;
    code: string;

    constructor(data?: ICustomerSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.cardNumber = data["cardNumber"];
            this.cellPhone = data["cellPhone"];
            this.city = data["city"];
            this.contactName = data["contactName"];
            this.country = data["country"];
            this.currency = data["currency"];
            this.email = data["email"];
            this.email2 = data["email2"];
            this.fax = data["fax"];
            this.phone = data["phone"];
            this.postalCode = data["postalCode"];
            this.tenantId = data["tenantId"];
            this.website = data["website"];
            this.accountId = data["accountId"];
            if (data["customerAddresses"] && data["customerAddresses"].constructor === Array) {
                this.customerAddresses = [];
                for (let item of data["customerAddresses"])
                    this.customerAddresses.push(CustomerAddressSyncDto.fromJS(item));
            }
            if (data["customerSaleTypes"] && data["customerSaleTypes"].constructor === Array) {
                this.customerSaleTypes = [];
                for (let item of data["customerSaleTypes"])
                    this.customerSaleTypes.push(item);
            }
            this.commericalNumber = data["commericalNumber"];
            this.taxNumber = data["taxNumber"];
            this.customerType = data["customerType"];
            this.note = data["note"];
            this.streetName = data["streetName"];
            this.zoneName = data["zoneName"];
            this.buildingNumber = data["buildingNumber"];
            this.identificationSchemeID = data["identificationSchemeID"];
            this.area = data["area"];
            this.governorate = data["governorate"];
            this.blockNo = data["blockNo"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): CustomerSyncDto {
        let result = new CustomerSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardNumber"] = this.cardNumber;
        data["cellPhone"] = this.cellPhone;
        data["city"] = this.city;
        data["contactName"] = this.contactName;
        data["country"] = this.country;
        data["currency"] = this.currency;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["fax"] = this.fax;
        data["phone"] = this.phone;
        data["postalCode"] = this.postalCode;
        data["tenantId"] = this.tenantId;
        data["website"] = this.website;
        data["accountId"] = this.accountId;
        if (this.customerAddresses && this.customerAddresses.constructor === Array) {
            data["customerAddresses"] = [];
            for (let item of this.customerAddresses)
                data["customerAddresses"].push(item.toJSON());
        }
        if (this.customerSaleTypes && this.customerSaleTypes.constructor === Array) {
            data["customerSaleTypes"] = [];
            for (let item of this.customerSaleTypes)
                data["customerSaleTypes"].push(item);
        }
        data["commericalNumber"] = this.commericalNumber;
        data["taxNumber"] = this.taxNumber;
        data["customerType"] = this.customerType;
        data["note"] = this.note;
        data["streetName"] = this.streetName;
        data["zoneName"] = this.zoneName;
        data["buildingNumber"] = this.buildingNumber;
        data["identificationSchemeID"] = this.identificationSchemeID;
        data["area"] = this.area;
        data["governorate"] = this.governorate;
        data["blockNo"] = this.blockNo;
        data["code"] = this.code;
        return data; 
    }
}

export interface ICustomerSyncDto {
    id: string;
    cardNumber: string;
    cellPhone: string;
    city: string;
    contactName: string;
    country: string;
    currency: number;
    email: string;
    email2: string;
    fax: string;
    phone: string;
    postalCode: string;
    tenantId: number;
    website: string;
    accountId: string;
    customerAddresses: CustomerAddressSyncDto[];
    customerSaleTypes: number[];
    commericalNumber: string;
    taxNumber: string;
    customerType: number;
    note: string;
    streetName: string;
    zoneName: string;
    buildingNumber: string;
    identificationSchemeID: string;
    area: string;
    governorate: string;
    blockNo: string;
    code: string;
}

export class CustomerAddressSyncDto implements ICustomerAddressSyncDto {
    id: number;
    city: string;
    customerId: string;
    address: string;
    link: string;
    deliveryZoneId: number;
    zoneName: string;
    zoneNameId: number;
    deliveryStreetId: number;
    streetName: string;
    streetNameId: number;
    isSelected: boolean;

    constructor(data?: ICustomerAddressSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.city = data["city"];
            this.customerId = data["customerId"];
            this.address = data["address"];
            this.link = data["link"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.zoneName = data["zoneName"];
            this.zoneNameId = data["zoneNameId"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.streetName = data["streetName"];
            this.streetNameId = data["streetNameId"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): CustomerAddressSyncDto {
        let result = new CustomerAddressSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["city"] = this.city;
        data["customerId"] = this.customerId;
        data["address"] = this.address;
        data["link"] = this.link;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["zoneName"] = this.zoneName;
        data["zoneNameId"] = this.zoneNameId;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["streetName"] = this.streetName;
        data["streetNameId"] = this.streetNameId;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ICustomerAddressSyncDto {
    id: number;
    city: string;
    customerId: string;
    address: string;
    link: string;
    deliveryZoneId: number;
    zoneName: string;
    zoneNameId: number;
    deliveryStreetId: number;
    streetName: string;
    streetNameId: number;
    isSelected: boolean;
}

export class CustomerWithAddressesListItem implements ICustomerWithAddressesListItem {
    id: string;
    fullName: string;
    cellPhone: string;
    code: string;
    discountPrcnt: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    customerAddress: CustomerAddressSyncDto[];

    constructor(data?: ICustomerWithAddressesListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.fullName = data["fullName"];
            this.cellPhone = data["cellPhone"];
            this.code = data["code"];
            this.discountPrcnt = data["discountPrcnt"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddressSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerWithAddressesListItem {
        let result = new CustomerWithAddressesListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["cellPhone"] = this.cellPhone;
        data["code"] = this.code;
        data["discountPrcnt"] = this.discountPrcnt;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerWithAddressesListItem {
    id: string;
    fullName: string;
    cellPhone: string;
    code: string;
    discountPrcnt: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    customerAddress: CustomerAddressSyncDto[];
}

export class PagedDeliveriesList implements IPagedDeliveriesList {
    currentPage: number;
    itemsCount: number;
    deliveries: DeliveryListItem[];

    constructor(data?: IPagedDeliveriesList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["deliveries"] && data["deliveries"].constructor === Array) {
                this.deliveries = [];
                for (let item of data["deliveries"])
                    this.deliveries.push(DeliveryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedDeliveriesList {
        let result = new PagedDeliveriesList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.deliveries && this.deliveries.constructor === Array) {
            data["deliveries"] = [];
            for (let item of this.deliveries)
                data["deliveries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedDeliveriesList {
    currentPage: number;
    itemsCount: number;
    deliveries: DeliveryListItem[];
}

export class DeliveryListItem implements IDeliveryListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IDeliveryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): DeliveryListItem {
        let result = new DeliveryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IDeliveryListItem {
    id: number;
    name: string;
    code: string;
}

export class CreateDeliveryInput implements ICreateDeliveryInput {
    code: string;
    translations: DeliveryTranslationDto[];

    constructor(data?: ICreateDeliveryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDeliveryInput {
        let result = new CreateDeliveryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateDeliveryInput {
    code: string;
    translations: DeliveryTranslationDto[];
}

export class DeliveryTranslationDto implements IDeliveryTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IDeliveryTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): DeliveryTranslationDto {
        let result = new DeliveryTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IDeliveryTranslationDto {
    name: string;
    languageId: number;
}

export class DeliveryDto implements IDeliveryDto {
    code: string;
    translations: DeliveryTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryDto {
        let result = new DeliveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryDto {
    code: string;
    translations: DeliveryTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfDeliveryListItem implements IListResultDtoOfDeliveryListItem {
    items: DeliveryListItem[];

    constructor(data?: IListResultDtoOfDeliveryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DeliveryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDeliveryListItem {
        let result = new ListResultDtoOfDeliveryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDeliveryListItem {
    items: DeliveryListItem[];
}

export class UpdateDeliveryInput implements IUpdateDeliveryInput {
    id: number;
    code: string;
    translations: DeliveryTranslationDto[];

    constructor(data?: IUpdateDeliveryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDeliveryInput {
        let result = new UpdateDeliveryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateDeliveryInput {
    id: number;
    code: string;
    translations: DeliveryTranslationDto[];
}

export class CreateDeliveryStreetInput implements ICreateDeliveryStreetInput {
    translations: DeliveryStreetTranslationDto[];
    deliveryZoneId: number;

    constructor(data?: ICreateDeliveryStreetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryStreetTranslationDto.fromJS(item));
            }
            this.deliveryZoneId = data["deliveryZoneId"];
        }
    }

    static fromJS(data: any): CreateDeliveryStreetInput {
        let result = new CreateDeliveryStreetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["deliveryZoneId"] = this.deliveryZoneId;
        return data; 
    }
}

export interface ICreateDeliveryStreetInput {
    translations: DeliveryStreetTranslationDto[];
    deliveryZoneId: number;
}

export class DeliveryStreetTranslationDto implements IDeliveryStreetTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IDeliveryStreetTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): DeliveryStreetTranslationDto {
        let result = new DeliveryStreetTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IDeliveryStreetTranslationDto {
    name: string;
    languageId: number;
}

export class DeliveryStreetDto implements IDeliveryStreetDto {
    id: number;
    translations: DeliveryStreetTranslationDto[];
    deliveryZoneId: number;

    constructor(data?: IDeliveryStreetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryStreetTranslationDto.fromJS(item));
            }
            this.deliveryZoneId = data["deliveryZoneId"];
        }
    }

    static fromJS(data: any): DeliveryStreetDto {
        let result = new DeliveryStreetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["deliveryZoneId"] = this.deliveryZoneId;
        return data; 
    }
}

export interface IDeliveryStreetDto {
    id: number;
    translations: DeliveryStreetTranslationDto[];
    deliveryZoneId: number;
}

export class ListResultDtoOfDeliveryStreetListItem implements IListResultDtoOfDeliveryStreetListItem {
    items: DeliveryStreetListItem[];

    constructor(data?: IListResultDtoOfDeliveryStreetListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DeliveryStreetListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDeliveryStreetListItem {
        let result = new ListResultDtoOfDeliveryStreetListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDeliveryStreetListItem {
    items: DeliveryStreetListItem[];
}

export class PagedDeliveryStreetList implements IPagedDeliveryStreetList {
    currentPage: number;
    itemsCount: number;
    deliveryStreets: DeliveryStreetListItem[];

    constructor(data?: IPagedDeliveryStreetList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["deliveryStreets"] && data["deliveryStreets"].constructor === Array) {
                this.deliveryStreets = [];
                for (let item of data["deliveryStreets"])
                    this.deliveryStreets.push(DeliveryStreetListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedDeliveryStreetList {
        let result = new PagedDeliveryStreetList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.deliveryStreets && this.deliveryStreets.constructor === Array) {
            data["deliveryStreets"] = [];
            for (let item of this.deliveryStreets)
                data["deliveryStreets"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedDeliveryStreetList {
    currentPage: number;
    itemsCount: number;
    deliveryStreets: DeliveryStreetListItem[];
}

export class UpdateDeliveryStreetInput implements IUpdateDeliveryStreetInput {
    id: number;
    translations: DeliveryStreetTranslationDto[];
    deliveryZoneId: number;

    constructor(data?: IUpdateDeliveryStreetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryStreetTranslationDto.fromJS(item));
            }
            this.deliveryZoneId = data["deliveryZoneId"];
        }
    }

    static fromJS(data: any): UpdateDeliveryStreetInput {
        let result = new UpdateDeliveryStreetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["deliveryZoneId"] = this.deliveryZoneId;
        return data; 
    }
}

export interface IUpdateDeliveryStreetInput {
    id: number;
    translations: DeliveryStreetTranslationDto[];
    deliveryZoneId: number;
}

export class CreateDeliveryZoneInput implements ICreateDeliveryZoneInput {
    translations: DeliveryZoneTranslationDto[];
    storeIds: number[];

    constructor(data?: ICreateDeliveryZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryZoneTranslationDto.fromJS(item));
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeliveryZoneInput {
        let result = new CreateDeliveryZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateDeliveryZoneInput {
    translations: DeliveryZoneTranslationDto[];
    storeIds: number[];
}

export class DeliveryZoneTranslationDto implements IDeliveryZoneTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IDeliveryZoneTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): DeliveryZoneTranslationDto {
        let result = new DeliveryZoneTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IDeliveryZoneTranslationDto {
    name: string;
    languageId: number;
}

export class DeliveryZoneDto implements IDeliveryZoneDto {
    translations: DeliveryZoneTranslationDto[];
    id: number;
    storeIds: number[];

    constructor(data?: IDeliveryZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryZoneTranslationDto.fromJS(item));
            }
            this.id = data["id"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): DeliveryZoneDto {
        let result = new DeliveryZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["id"] = this.id;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IDeliveryZoneDto {
    translations: DeliveryZoneTranslationDto[];
    id: number;
    storeIds: number[];
}

export class ListResultDtoOfDeliveryZoneListItem implements IListResultDtoOfDeliveryZoneListItem {
    items: DeliveryZoneListItem[];

    constructor(data?: IListResultDtoOfDeliveryZoneListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DeliveryZoneListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDeliveryZoneListItem {
        let result = new ListResultDtoOfDeliveryZoneListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDeliveryZoneListItem {
    items: DeliveryZoneListItem[];
}

export class DeliveryZoneListItem implements IDeliveryZoneListItem {
    id: number;
    name: string;

    constructor(data?: IDeliveryZoneListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): DeliveryZoneListItem {
        let result = new DeliveryZoneListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IDeliveryZoneListItem {
    id: number;
    name: string;
}

export class PagedDeliveryZoneList implements IPagedDeliveryZoneList {
    currentPage: number;
    itemsCount: number;
    deliveryZones: DeliveryZoneListItem[];

    constructor(data?: IPagedDeliveryZoneList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["deliveryZones"] && data["deliveryZones"].constructor === Array) {
                this.deliveryZones = [];
                for (let item of data["deliveryZones"])
                    this.deliveryZones.push(DeliveryZoneListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedDeliveryZoneList {
        let result = new PagedDeliveryZoneList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.deliveryZones && this.deliveryZones.constructor === Array) {
            data["deliveryZones"] = [];
            for (let item of this.deliveryZones)
                data["deliveryZones"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedDeliveryZoneList {
    currentPage: number;
    itemsCount: number;
    deliveryZones: DeliveryZoneListItem[];
}

export class UpdateDeliveryZoneInput implements IUpdateDeliveryZoneInput {
    id: number;
    translations: DeliveryZoneTranslationDto[];
    storeIds: number[];

    constructor(data?: IUpdateDeliveryZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryZoneTranslationDto.fromJS(item));
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDeliveryZoneInput {
        let result = new UpdateDeliveryZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateDeliveryZoneInput {
    id: number;
    translations: DeliveryZoneTranslationDto[];
    storeIds: number[];
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString: string;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data; 
    }
}

export interface IDateToStringOutput {
    dateString: string;
}

export class NameValueOfString implements INameValueOfString {
    name: string;
    value: string;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfString {
    name: string;
    value: string;
}

export class StringOutput implements IStringOutput {
    output: string;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.output = data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data; 
    }
}

export interface IStringOutput {
    output: string;
}

export class OfflineDeviceTenantReportGroupPagedDto implements IOfflineDeviceTenantReportGroupPagedDto {
    currentPage: number;
    itemsCount: number;
    items: OfflineDeviceTenantReportGroupDto[];

    constructor(data?: IOfflineDeviceTenantReportGroupPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OfflineDeviceTenantReportGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfflineDeviceTenantReportGroupPagedDto {
        let result = new OfflineDeviceTenantReportGroupPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOfflineDeviceTenantReportGroupPagedDto {
    currentPage: number;
    itemsCount: number;
    items: OfflineDeviceTenantReportGroupDto[];
}

export class OfflineDeviceTenantReportGroupDto implements IOfflineDeviceTenantReportGroupDto {
    tenantName: string;
    offlineDevices: OfflineDeviceDto[];

    constructor(data?: IOfflineDeviceTenantReportGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["offlineDevices"] && data["offlineDevices"].constructor === Array) {
                this.offlineDevices = [];
                for (let item of data["offlineDevices"])
                    this.offlineDevices.push(OfflineDeviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfflineDeviceTenantReportGroupDto {
        let result = new OfflineDeviceTenantReportGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.offlineDevices && this.offlineDevices.constructor === Array) {
            data["offlineDevices"] = [];
            for (let item of this.offlineDevices)
                data["offlineDevices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOfflineDeviceTenantReportGroupDto {
    tenantName: string;
    offlineDevices: OfflineDeviceDto[];
}

export class OfflineDeviceDto implements IOfflineDeviceDto {
    storeId: number;
    deviceName: string;
    ipAddress: string;
    lastOnline: moment.Moment;
    offlinePeriod: number;
    tenantName: string;
    storeName: string;

    constructor(data?: IOfflineDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.deviceName = data["deviceName"];
            this.ipAddress = data["ipAddress"];
            this.lastOnline = data["lastOnline"] ? moment(data["lastOnline"].toString()) : <any>undefined;
            this.offlinePeriod = data["offlinePeriod"];
            this.tenantName = data["tenantName"];
            this.storeName = data["storeName"];
        }
    }

    static fromJS(data: any): OfflineDeviceDto {
        let result = new OfflineDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["deviceName"] = this.deviceName;
        data["ipAddress"] = this.ipAddress;
        data["lastOnline"] = this.lastOnline ? this.lastOnline.toISOString() : <any>undefined;
        data["offlinePeriod"] = this.offlinePeriod;
        data["tenantName"] = this.tenantName;
        data["storeName"] = this.storeName;
        return data; 
    }
}

export interface IOfflineDeviceDto {
    storeId: number;
    deviceName: string;
    ipAddress: string;
    lastOnline: moment.Moment;
    offlinePeriod: number;
    tenantName: string;
    storeName: string;
}

export class OfflineDeviceInputDto implements IOfflineDeviceInputDto {
    tenantIds: number[];
    pageNumber: number;
    pageSize: number;

    constructor(data?: IOfflineDeviceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
            this.pageNumber = data["pageNumber"];
            this.pageSize = data["pageSize"];
        }
    }

    static fromJS(data: any): OfflineDeviceInputDto {
        let result = new OfflineDeviceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export interface IOfflineDeviceInputDto {
    tenantIds: number[];
    pageNumber: number;
    pageSize: number;
}

export class KdsOperationSummaryReportDtoPagedDto implements IKdsOperationSummaryReportDtoPagedDto {
    currentPage: number;
    itemsCount: number;
    totalOrders: number;
    averagePrep: string;
    delayedOrders: number;
    delayedOrdersPercent: number;
    topDelayStation: string;
    topDelayStationPercent: number;
    items: KdsOperationSummaryReportDto[];

    constructor(data?: IKdsOperationSummaryReportDtoPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.totalOrders = data["totalOrders"];
            this.averagePrep = data["averagePrep"];
            this.delayedOrders = data["delayedOrders"];
            this.delayedOrdersPercent = data["delayedOrdersPercent"];
            this.topDelayStation = data["topDelayStation"];
            this.topDelayStationPercent = data["topDelayStationPercent"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(KdsOperationSummaryReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KdsOperationSummaryReportDtoPagedDto {
        let result = new KdsOperationSummaryReportDtoPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["totalOrders"] = this.totalOrders;
        data["averagePrep"] = this.averagePrep;
        data["delayedOrders"] = this.delayedOrders;
        data["delayedOrdersPercent"] = this.delayedOrdersPercent;
        data["topDelayStation"] = this.topDelayStation;
        data["topDelayStationPercent"] = this.topDelayStationPercent;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IKdsOperationSummaryReportDtoPagedDto {
    currentPage: number;
    itemsCount: number;
    totalOrders: number;
    averagePrep: string;
    delayedOrders: number;
    delayedOrdersPercent: number;
    topDelayStation: string;
    topDelayStationPercent: number;
    items: KdsOperationSummaryReportDto[];
}

export class KdsOperationSummaryReportDto implements IKdsOperationSummaryReportDto {
    storeName: string;
    ordersCount: number;
    completedCount: number;
    canceledCount: number;
    averagePrep: number;
    onTime: number;
    delayed: number;
    topDelaySource: string;
    actionInsight: string;
    averagePrepAsTime: string;

    constructor(data?: IKdsOperationSummaryReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            this.ordersCount = data["ordersCount"];
            this.completedCount = data["completedCount"];
            this.canceledCount = data["canceledCount"];
            this.averagePrep = data["averagePrep"];
            this.onTime = data["onTime"];
            this.delayed = data["delayed"];
            this.topDelaySource = data["topDelaySource"];
            this.actionInsight = data["actionInsight"];
            this.averagePrepAsTime = data["averagePrepAsTime"];
        }
    }

    static fromJS(data: any): KdsOperationSummaryReportDto {
        let result = new KdsOperationSummaryReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["ordersCount"] = this.ordersCount;
        data["completedCount"] = this.completedCount;
        data["canceledCount"] = this.canceledCount;
        data["averagePrep"] = this.averagePrep;
        data["onTime"] = this.onTime;
        data["delayed"] = this.delayed;
        data["topDelaySource"] = this.topDelaySource;
        data["actionInsight"] = this.actionInsight;
        data["averagePrepAsTime"] = this.averagePrepAsTime;
        return data; 
    }
}

export interface IKdsOperationSummaryReportDto {
    storeName: string;
    ordersCount: number;
    completedCount: number;
    canceledCount: number;
    averagePrep: number;
    onTime: number;
    delayed: number;
    topDelaySource: string;
    actionInsight: string;
    averagePrepAsTime: string;
}

export class KdsOperationSummaryReportInputDto implements IKdsOperationSummaryReportInputDto {
    storeIds: number[];
    regionId: number;
    areaId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    pageNumber: number;
    pageSize: number;

    constructor(data?: IKdsOperationSummaryReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.pageNumber = data["pageNumber"];
            this.pageSize = data["pageSize"];
        }
    }

    static fromJS(data: any): KdsOperationSummaryReportInputDto {
        let result = new KdsOperationSummaryReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export interface IKdsOperationSummaryReportInputDto {
    storeIds: number[];
    regionId: number;
    areaId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    pageNumber: number;
    pageSize: number;
}

export class KdsKitchenIntelligenceAndItemPerformanceReportInputDto implements IKdsKitchenIntelligenceAndItemPerformanceReportInputDto {
    menuItemsIds: number[];
    pageNumber: number;
    pageSize: number;

    constructor(data?: IKdsKitchenIntelligenceAndItemPerformanceReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["menuItemsIds"] && data["menuItemsIds"].constructor === Array) {
                this.menuItemsIds = [];
                for (let item of data["menuItemsIds"])
                    this.menuItemsIds.push(item);
            }
            this.pageNumber = data["pageNumber"];
            this.pageSize = data["pageSize"];
        }
    }

    static fromJS(data: any): KdsKitchenIntelligenceAndItemPerformanceReportInputDto {
        let result = new KdsKitchenIntelligenceAndItemPerformanceReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.menuItemsIds && this.menuItemsIds.constructor === Array) {
            data["menuItemsIds"] = [];
            for (let item of this.menuItemsIds)
                data["menuItemsIds"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export interface IKdsKitchenIntelligenceAndItemPerformanceReportInputDto {
    menuItemsIds: number[];
    pageNumber: number;
    pageSize: number;
}

export class KdsKitchenIntelligenceAndItemPerformanceReportPagedDto implements IKdsKitchenIntelligenceAndItemPerformanceReportPagedDto {
    currentPage: number;
    itemsCount: number;
    topItem: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    slowestItme: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    mostDelyed: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    bestSLAItem: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    items: KdsKitchenIntelligenceAndItemPerformanceReportDto[];

    constructor(data?: IKdsKitchenIntelligenceAndItemPerformanceReportPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.topItem = data["topItem"] ? KdsKitchenIntelligenceAndItemPerformanceSummaryDto.fromJS(data["topItem"]) : <any>undefined;
            this.slowestItme = data["slowestItme"] ? KdsKitchenIntelligenceAndItemPerformanceSummaryDto.fromJS(data["slowestItme"]) : <any>undefined;
            this.mostDelyed = data["mostDelyed"] ? KdsKitchenIntelligenceAndItemPerformanceSummaryDto.fromJS(data["mostDelyed"]) : <any>undefined;
            this.bestSLAItem = data["bestSLAItem"] ? KdsKitchenIntelligenceAndItemPerformanceSummaryDto.fromJS(data["bestSLAItem"]) : <any>undefined;
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(KdsKitchenIntelligenceAndItemPerformanceReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KdsKitchenIntelligenceAndItemPerformanceReportPagedDto {
        let result = new KdsKitchenIntelligenceAndItemPerformanceReportPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["topItem"] = this.topItem ? this.topItem.toJSON() : <any>undefined;
        data["slowestItme"] = this.slowestItme ? this.slowestItme.toJSON() : <any>undefined;
        data["mostDelyed"] = this.mostDelyed ? this.mostDelyed.toJSON() : <any>undefined;
        data["bestSLAItem"] = this.bestSLAItem ? this.bestSLAItem.toJSON() : <any>undefined;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IKdsKitchenIntelligenceAndItemPerformanceReportPagedDto {
    currentPage: number;
    itemsCount: number;
    topItem: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    slowestItme: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    mostDelyed: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    bestSLAItem: KdsKitchenIntelligenceAndItemPerformanceSummaryDto;
    items: KdsKitchenIntelligenceAndItemPerformanceReportDto[];
}

export class KdsKitchenIntelligenceAndItemPerformanceSummaryDto implements IKdsKitchenIntelligenceAndItemPerformanceSummaryDto {
    itemName: string;
    description: string;

    constructor(data?: IKdsKitchenIntelligenceAndItemPerformanceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemName = data["itemName"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): KdsKitchenIntelligenceAndItemPerformanceSummaryDto {
        let result = new KdsKitchenIntelligenceAndItemPerformanceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        return data; 
    }
}

export interface IKdsKitchenIntelligenceAndItemPerformanceSummaryDto {
    itemName: string;
    description: string;
}

export class KdsKitchenIntelligenceAndItemPerformanceReportDto implements IKdsKitchenIntelligenceAndItemPerformanceReportDto {
    itemName: string;
    categoryName: string;
    qunatity: number;
    averagePrep: number;
    targetTime: number;
    onTime: number;
    averagePrepAsTime: string;
    targetTimeAsTime: string;
    delayedCount: number;
    deviceName: string;

    constructor(data?: IKdsKitchenIntelligenceAndItemPerformanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemName = data["itemName"];
            this.categoryName = data["categoryName"];
            this.qunatity = data["qunatity"];
            this.averagePrep = data["averagePrep"];
            this.targetTime = data["targetTime"];
            this.onTime = data["onTime"];
            this.averagePrepAsTime = data["averagePrepAsTime"];
            this.targetTimeAsTime = data["targetTimeAsTime"];
            this.delayedCount = data["delayedCount"];
            this.deviceName = data["deviceName"];
        }
    }

    static fromJS(data: any): KdsKitchenIntelligenceAndItemPerformanceReportDto {
        let result = new KdsKitchenIntelligenceAndItemPerformanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["categoryName"] = this.categoryName;
        data["qunatity"] = this.qunatity;
        data["averagePrep"] = this.averagePrep;
        data["targetTime"] = this.targetTime;
        data["onTime"] = this.onTime;
        data["averagePrepAsTime"] = this.averagePrepAsTime;
        data["targetTimeAsTime"] = this.targetTimeAsTime;
        data["delayedCount"] = this.delayedCount;
        data["deviceName"] = this.deviceName;
        return data; 
    }
}

export interface IKdsKitchenIntelligenceAndItemPerformanceReportDto {
    itemName: string;
    categoryName: string;
    qunatity: number;
    averagePrep: number;
    targetTime: number;
    onTime: number;
    averagePrepAsTime: string;
    targetTimeAsTime: string;
    delayedCount: number;
    deviceName: string;
}

export class KdsOrderDetialDto implements IKdsOrderDetialDto {
    deviceId: number;
    deviceName: string;
    saleTransactionDetialId: string;
    saleTransactionId: string;
    menuItemId: number;
    unitOfMeasureId: number;
    deviceType: number;
    shiftId: number;
    preperingTime: number;

    constructor(data?: IKdsOrderDetialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.saleTransactionDetialId = data["saleTransactionDetialId"];
            this.saleTransactionId = data["saleTransactionId"];
            this.menuItemId = data["menuItemId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.deviceType = data["deviceType"];
            this.shiftId = data["shiftId"];
            this.preperingTime = data["preperingTime"];
        }
    }

    static fromJS(data: any): KdsOrderDetialDto {
        let result = new KdsOrderDetialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["saleTransactionDetialId"] = this.saleTransactionDetialId;
        data["saleTransactionId"] = this.saleTransactionId;
        data["menuItemId"] = this.menuItemId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["deviceType"] = this.deviceType;
        data["shiftId"] = this.shiftId;
        data["preperingTime"] = this.preperingTime;
        return data; 
    }
}

export interface IKdsOrderDetialDto {
    deviceId: number;
    deviceName: string;
    saleTransactionDetialId: string;
    saleTransactionId: string;
    menuItemId: number;
    unitOfMeasureId: number;
    deviceType: number;
    shiftId: number;
    preperingTime: number;
}

export class DeviceDto implements IDeviceDto {
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    tenantId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    pcIds: number[];
    categoryIds: number[];
    tablesIds: number[];
    storeIds: number[];
    languageId: number;
    tableNumberAvilable: number;
    backupDevice: DeviceDto;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    addressIp: string;
    isCentral: boolean;
    saleTypeIds: number[];
    coordinatorId: string;
    coordinatorIp: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.machineName = data["machineName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.connectorTypeId = data["connectorTypeId"];
            this.tenantId = data["tenantId"];
            this.assigningAuthenticationObj = data["assigningAuthenticationObj"];
            this.addPicture = data["addPicture"];
            this.changColorFont = data["changColorFont"];
            if (data["pcIds"] && data["pcIds"].constructor === Array) {
                this.pcIds = [];
                for (let item of data["pcIds"])
                    this.pcIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            if (data["tablesIds"] && data["tablesIds"].constructor === Array) {
                this.tablesIds = [];
                for (let item of data["tablesIds"])
                    this.tablesIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.languageId = data["languageId"];
            this.tableNumberAvilable = data["tableNumberAvilable"];
            this.backupDevice = data["backupDevice"] ? DeviceDto.fromJS(data["backupDevice"]) : <any>undefined;
            this.backupDeviceId = data["backupDeviceId"];
            this.kdsId = data["kdsId"];
            this.kdsIp = data["kdsIp"];
            this.addressIp = data["addressIp"];
            this.isCentral = data["isCentral"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            this.coordinatorId = data["coordinatorId"];
            this.coordinatorIp = data["coordinatorIp"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceDto {
        let result = new DeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["machineName"] = this.machineName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["connectorTypeId"] = this.connectorTypeId;
        data["tenantId"] = this.tenantId;
        data["assigningAuthenticationObj"] = this.assigningAuthenticationObj;
        data["addPicture"] = this.addPicture;
        data["changColorFont"] = this.changColorFont;
        if (this.pcIds && this.pcIds.constructor === Array) {
            data["pcIds"] = [];
            for (let item of this.pcIds)
                data["pcIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (this.tablesIds && this.tablesIds.constructor === Array) {
            data["tablesIds"] = [];
            for (let item of this.tablesIds)
                data["tablesIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["languageId"] = this.languageId;
        data["tableNumberAvilable"] = this.tableNumberAvilable;
        data["backupDevice"] = this.backupDevice ? this.backupDevice.toJSON() : <any>undefined;
        data["backupDeviceId"] = this.backupDeviceId;
        data["kdsId"] = this.kdsId;
        data["kdsIp"] = this.kdsIp;
        data["addressIp"] = this.addressIp;
        data["isCentral"] = this.isCentral;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        data["coordinatorId"] = this.coordinatorId;
        data["coordinatorIp"] = this.coordinatorIp;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeviceDto {
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    tenantId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    pcIds: number[];
    categoryIds: number[];
    tablesIds: number[];
    storeIds: number[];
    languageId: number;
    tableNumberAvilable: number;
    backupDevice: DeviceDto;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    addressIp: string;
    isCentral: boolean;
    saleTypeIds: number[];
    coordinatorId: string;
    coordinatorIp: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeviceTypeItem implements IDeviceTypeItem {
    name: string;
    value: number;

    constructor(data?: IDeviceTypeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): DeviceTypeItem {
        let result = new DeviceTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IDeviceTypeItem {
    name: string;
    value: number;
}

export class ListResultDtoOfDeviceListItem implements IListResultDtoOfDeviceListItem {
    items: DeviceListItem[];

    constructor(data?: IListResultDtoOfDeviceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DeviceListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDeviceListItem {
        let result = new ListResultDtoOfDeviceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDeviceListItem {
    items: DeviceListItem[];
}

export class DeviceListItem implements IDeviceListItem {
    id: number;
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    storeIds: number[];
    tenantId: number;
    canDoEdit: boolean;
    isTenantDevice: boolean;

    constructor(data?: IDeviceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.deviceId = data["deviceId"];
            this.machineName = data["machineName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.connectorTypeId = data["connectorTypeId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.tenantId = data["tenantId"];
            this.canDoEdit = data["canDoEdit"];
            this.isTenantDevice = data["isTenantDevice"];
        }
    }

    static fromJS(data: any): DeviceListItem {
        let result = new DeviceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceId"] = this.deviceId;
        data["machineName"] = this.machineName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["connectorTypeId"] = this.connectorTypeId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["tenantId"] = this.tenantId;
        data["canDoEdit"] = this.canDoEdit;
        data["isTenantDevice"] = this.isTenantDevice;
        return data; 
    }
}

export interface IDeviceListItem {
    id: number;
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    storeIds: number[];
    tenantId: number;
    canDoEdit: boolean;
    isTenantDevice: boolean;
}

export class PagedDeviceList implements IPagedDeviceList {
    currentPage: number;
    itemsCount: number;
    devices: DeviceListItem[];

    constructor(data?: IPagedDeviceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["devices"] && data["devices"].constructor === Array) {
                this.devices = [];
                for (let item of data["devices"])
                    this.devices.push(DeviceListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedDeviceList {
        let result = new PagedDeviceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.devices && this.devices.constructor === Array) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedDeviceList {
    currentPage: number;
    itemsCount: number;
    devices: DeviceListItem[];
}

export class CreateDeviceInput implements ICreateDeviceInput {
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    tenantId: number;
    pcIds: number[];
    tableIds: number[];
    categoryIds: number[];
    storeIds: number[];
    languageId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    tableNumberAvilable: number;
    backupDevice: DeviceDto;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    coordinatorId: string;
    coordinatorIp: string;
    addressIp: string;
    isCentral: boolean;
    saleTypeIds: number[];

    constructor(data?: ICreateDeviceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.machineName = data["machineName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.connectorTypeId = data["connectorTypeId"];
            this.tenantId = data["tenantId"];
            if (data["pcIds"] && data["pcIds"].constructor === Array) {
                this.pcIds = [];
                for (let item of data["pcIds"])
                    this.pcIds.push(item);
            }
            if (data["tableIds"] && data["tableIds"].constructor === Array) {
                this.tableIds = [];
                for (let item of data["tableIds"])
                    this.tableIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.languageId = data["languageId"];
            this.assigningAuthenticationObj = data["assigningAuthenticationObj"];
            this.addPicture = data["addPicture"];
            this.changColorFont = data["changColorFont"];
            this.tableNumberAvilable = data["tableNumberAvilable"];
            this.backupDevice = data["backupDevice"] ? DeviceDto.fromJS(data["backupDevice"]) : <any>undefined;
            this.backupDeviceId = data["backupDeviceId"];
            this.kdsId = data["kdsId"];
            this.kdsIp = data["kdsIp"];
            this.coordinatorId = data["coordinatorId"];
            this.coordinatorIp = data["coordinatorIp"];
            this.addressIp = data["addressIp"];
            this.isCentral = data["isCentral"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeviceInput {
        let result = new CreateDeviceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["machineName"] = this.machineName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["connectorTypeId"] = this.connectorTypeId;
        data["tenantId"] = this.tenantId;
        if (this.pcIds && this.pcIds.constructor === Array) {
            data["pcIds"] = [];
            for (let item of this.pcIds)
                data["pcIds"].push(item);
        }
        if (this.tableIds && this.tableIds.constructor === Array) {
            data["tableIds"] = [];
            for (let item of this.tableIds)
                data["tableIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["languageId"] = this.languageId;
        data["assigningAuthenticationObj"] = this.assigningAuthenticationObj;
        data["addPicture"] = this.addPicture;
        data["changColorFont"] = this.changColorFont;
        data["tableNumberAvilable"] = this.tableNumberAvilable;
        data["backupDevice"] = this.backupDevice ? this.backupDevice.toJSON() : <any>undefined;
        data["backupDeviceId"] = this.backupDeviceId;
        data["kdsId"] = this.kdsId;
        data["kdsIp"] = this.kdsIp;
        data["coordinatorId"] = this.coordinatorId;
        data["coordinatorIp"] = this.coordinatorIp;
        data["addressIp"] = this.addressIp;
        data["isCentral"] = this.isCentral;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateDeviceInput {
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    tenantId: number;
    pcIds: number[];
    tableIds: number[];
    categoryIds: number[];
    storeIds: number[];
    languageId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    tableNumberAvilable: number;
    backupDevice: DeviceDto;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    coordinatorId: string;
    coordinatorIp: string;
    addressIp: string;
    isCentral: boolean;
    saleTypeIds: number[];
}

export class UpdateDeviceInput implements IUpdateDeviceInput {
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    tenantId: number;
    pcIds: number[];
    categoryIds: number[];
    storeIds: number[];
    tableIds: number[];
    languageId: number;
    tableNumberAvilable: number;
    backupDevice: DeviceDto;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    addressIp: string;
    isCentral: boolean;
    saleTypeIds: number[];
    coordinatorId: string;
    coordinatorIp: string;

    constructor(data?: IUpdateDeviceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.machineName = data["machineName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.connectorTypeId = data["connectorTypeId"];
            this.assigningAuthenticationObj = data["assigningAuthenticationObj"];
            this.addPicture = data["addPicture"];
            this.changColorFont = data["changColorFont"];
            this.tenantId = data["tenantId"];
            if (data["pcIds"] && data["pcIds"].constructor === Array) {
                this.pcIds = [];
                for (let item of data["pcIds"])
                    this.pcIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["tableIds"] && data["tableIds"].constructor === Array) {
                this.tableIds = [];
                for (let item of data["tableIds"])
                    this.tableIds.push(item);
            }
            this.languageId = data["languageId"];
            this.tableNumberAvilable = data["tableNumberAvilable"];
            this.backupDevice = data["backupDevice"] ? DeviceDto.fromJS(data["backupDevice"]) : <any>undefined;
            this.backupDeviceId = data["backupDeviceId"];
            this.kdsId = data["kdsId"];
            this.kdsIp = data["kdsIp"];
            this.addressIp = data["addressIp"];
            this.isCentral = data["isCentral"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            this.coordinatorId = data["coordinatorId"];
            this.coordinatorIp = data["coordinatorIp"];
        }
    }

    static fromJS(data: any): UpdateDeviceInput {
        let result = new UpdateDeviceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["machineName"] = this.machineName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["connectorTypeId"] = this.connectorTypeId;
        data["assigningAuthenticationObj"] = this.assigningAuthenticationObj;
        data["addPicture"] = this.addPicture;
        data["changColorFont"] = this.changColorFont;
        data["tenantId"] = this.tenantId;
        if (this.pcIds && this.pcIds.constructor === Array) {
            data["pcIds"] = [];
            for (let item of this.pcIds)
                data["pcIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.tableIds && this.tableIds.constructor === Array) {
            data["tableIds"] = [];
            for (let item of this.tableIds)
                data["tableIds"].push(item);
        }
        data["languageId"] = this.languageId;
        data["tableNumberAvilable"] = this.tableNumberAvilable;
        data["backupDevice"] = this.backupDevice ? this.backupDevice.toJSON() : <any>undefined;
        data["backupDeviceId"] = this.backupDeviceId;
        data["kdsId"] = this.kdsId;
        data["kdsIp"] = this.kdsIp;
        data["addressIp"] = this.addressIp;
        data["isCentral"] = this.isCentral;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        data["coordinatorId"] = this.coordinatorId;
        data["coordinatorIp"] = this.coordinatorIp;
        return data; 
    }
}

export interface IUpdateDeviceInput {
    deviceId: number;
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    tenantId: number;
    pcIds: number[];
    categoryIds: number[];
    storeIds: number[];
    tableIds: number[];
    languageId: number;
    tableNumberAvilable: number;
    backupDevice: DeviceDto;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    addressIp: string;
    isCentral: boolean;
    saleTypeIds: number[];
    coordinatorId: string;
    coordinatorIp: string;
}

export class SaleTypeListItem implements ISaleTypeListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: ISaleTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): SaleTypeListItem {
        let result = new SaleTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface ISaleTypeListItem {
    id: number;
    name: string;
    code: string;
}

export class TenantDeviceDto implements ITenantDeviceDto {
    id: number;
    deviceName: string;
    deviceType: string;
    ipAddress: string;
    isCoordinator: boolean;
    clusterName: string;
    isActive: boolean;
    tenantName: string;
    macAddress: string;
    portNumber: string;
    presenceState: TenantDeviceDtoPresenceState;
    statusText: string;

    constructor(data?: ITenantDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.deviceName = data["deviceName"];
            this.deviceType = data["deviceType"];
            this.ipAddress = data["ipAddress"];
            this.isCoordinator = data["isCoordinator"];
            this.clusterName = data["clusterName"];
            this.isActive = data["isActive"];
            this.tenantName = data["tenantName"];
            this.macAddress = data["macAddress"];
            this.portNumber = data["portNumber"];
            this.presenceState = data["presenceState"];
            this.statusText = data["statusText"];
        }
    }

    static fromJS(data: any): TenantDeviceDto {
        let result = new TenantDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceName"] = this.deviceName;
        data["deviceType"] = this.deviceType;
        data["ipAddress"] = this.ipAddress;
        data["isCoordinator"] = this.isCoordinator;
        data["clusterName"] = this.clusterName;
        data["isActive"] = this.isActive;
        data["tenantName"] = this.tenantName;
        data["macAddress"] = this.macAddress;
        data["portNumber"] = this.portNumber;
        data["presenceState"] = this.presenceState;
        data["statusText"] = this.statusText;
        return data; 
    }
}

export interface ITenantDeviceDto {
    id: number;
    deviceName: string;
    deviceType: string;
    ipAddress: string;
    isCoordinator: boolean;
    clusterName: string;
    isActive: boolean;
    tenantName: string;
    macAddress: string;
    portNumber: string;
    presenceState: TenantDeviceDtoPresenceState;
    statusText: string;
}

export class TenatDeviceInput implements ITenatDeviceInput {
    id: number;
    tenantId: number;
    clusterId: number;
    isCoordinator: boolean;
    ipAddress: string;
    deviceType: number;
    salesTypes: number[];
    deviceName: string;
    isActive: boolean;
    parentDeviceIds: number[];
    childDeviceIds: number[];
    backupDeviceId: number;
    portNumber: string;

    constructor(data?: ITenatDeviceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.clusterId = data["clusterId"];
            this.isCoordinator = data["isCoordinator"];
            this.ipAddress = data["ipAddress"];
            this.deviceType = data["deviceType"];
            if (data["salesTypes"] && data["salesTypes"].constructor === Array) {
                this.salesTypes = [];
                for (let item of data["salesTypes"])
                    this.salesTypes.push(item);
            }
            this.deviceName = data["deviceName"];
            this.isActive = data["isActive"];
            if (data["parentDeviceIds"] && data["parentDeviceIds"].constructor === Array) {
                this.parentDeviceIds = [];
                for (let item of data["parentDeviceIds"])
                    this.parentDeviceIds.push(item);
            }
            if (data["childDeviceIds"] && data["childDeviceIds"].constructor === Array) {
                this.childDeviceIds = [];
                for (let item of data["childDeviceIds"])
                    this.childDeviceIds.push(item);
            }
            this.backupDeviceId = data["backupDeviceId"];
            this.portNumber = data["portNumber"];
        }
    }

    static fromJS(data: any): TenatDeviceInput {
        let result = new TenatDeviceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["clusterId"] = this.clusterId;
        data["isCoordinator"] = this.isCoordinator;
        data["ipAddress"] = this.ipAddress;
        data["deviceType"] = this.deviceType;
        if (this.salesTypes && this.salesTypes.constructor === Array) {
            data["salesTypes"] = [];
            for (let item of this.salesTypes)
                data["salesTypes"].push(item);
        }
        data["deviceName"] = this.deviceName;
        data["isActive"] = this.isActive;
        if (this.parentDeviceIds && this.parentDeviceIds.constructor === Array) {
            data["parentDeviceIds"] = [];
            for (let item of this.parentDeviceIds)
                data["parentDeviceIds"].push(item);
        }
        if (this.childDeviceIds && this.childDeviceIds.constructor === Array) {
            data["childDeviceIds"] = [];
            for (let item of this.childDeviceIds)
                data["childDeviceIds"].push(item);
        }
        data["backupDeviceId"] = this.backupDeviceId;
        data["portNumber"] = this.portNumber;
        return data; 
    }
}

export interface ITenatDeviceInput {
    id: number;
    tenantId: number;
    clusterId: number;
    isCoordinator: boolean;
    ipAddress: string;
    deviceType: number;
    salesTypes: number[];
    deviceName: string;
    isActive: boolean;
    parentDeviceIds: number[];
    childDeviceIds: number[];
    backupDeviceId: number;
    portNumber: string;
}

export class DiscountTypeDto implements IDiscountTypeDto {
    translations: DiscountTypeTranslationDto[];
    menuItemIds: number[];
    customerIds: string[];
    typeId: number;
    amount: number;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDiscountTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DiscountTypeTranslationDto.fromJS(item));
            }
            if (data["menuItemIds"] && data["menuItemIds"].constructor === Array) {
                this.menuItemIds = [];
                for (let item of data["menuItemIds"])
                    this.menuItemIds.push(item);
            }
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [];
                for (let item of data["customerIds"])
                    this.customerIds.push(item);
            }
            this.typeId = data["typeId"];
            this.amount = data["amount"];
            this.isOnSpecificItem = data["isOnSpecificItem"];
            this.isOnTotalReceipt = data["isOnTotalReceipt"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DiscountTypeDto {
        let result = new DiscountTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemIds && this.menuItemIds.constructor === Array) {
            data["menuItemIds"] = [];
            for (let item of this.menuItemIds)
                data["menuItemIds"].push(item);
        }
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["typeId"] = this.typeId;
        data["amount"] = this.amount;
        data["isOnSpecificItem"] = this.isOnSpecificItem;
        data["isOnTotalReceipt"] = this.isOnTotalReceipt;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDiscountTypeDto {
    translations: DiscountTypeTranslationDto[];
    menuItemIds: number[];
    customerIds: string[];
    typeId: number;
    amount: number;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DiscountTypeTranslationDto implements IDiscountTypeTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IDiscountTypeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): DiscountTypeTranslationDto {
        let result = new DiscountTypeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IDiscountTypeTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfDiscountTypeListItem implements IListResultDtoOfDiscountTypeListItem {
    items: DiscountTypeListItem[];

    constructor(data?: IListResultDtoOfDiscountTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DiscountTypeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDiscountTypeListItem {
        let result = new ListResultDtoOfDiscountTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDiscountTypeListItem {
    items: DiscountTypeListItem[];
}

export class DiscountTypeListItem implements IDiscountTypeListItem {
    id: number;
    name: string;
    typeId: number;
    typeName: string;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    amount: number;
    tenantId: number;

    constructor(data?: IDiscountTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.isOnSpecificItem = data["isOnSpecificItem"];
            this.isOnTotalReceipt = data["isOnTotalReceipt"];
            this.amount = data["amount"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): DiscountTypeListItem {
        let result = new DiscountTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["isOnSpecificItem"] = this.isOnSpecificItem;
        data["isOnTotalReceipt"] = this.isOnTotalReceipt;
        data["amount"] = this.amount;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IDiscountTypeListItem {
    id: number;
    name: string;
    typeId: number;
    typeName: string;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    amount: number;
    tenantId: number;
}

export class PagedDiscountTypesList implements IPagedDiscountTypesList {
    currentPage: number;
    itemsCount: number;
    discountTypes: DiscountTypeListItem[];

    constructor(data?: IPagedDiscountTypesList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["discountTypes"] && data["discountTypes"].constructor === Array) {
                this.discountTypes = [];
                for (let item of data["discountTypes"])
                    this.discountTypes.push(DiscountTypeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedDiscountTypesList {
        let result = new PagedDiscountTypesList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.discountTypes && this.discountTypes.constructor === Array) {
            data["discountTypes"] = [];
            for (let item of this.discountTypes)
                data["discountTypes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedDiscountTypesList {
    currentPage: number;
    itemsCount: number;
    discountTypes: DiscountTypeListItem[];
}

export class CreateDiscountTypeInput implements ICreateDiscountTypeInput {
    translations: DiscountTypeTranslationDto[];
    menuItemIds: number[];
    customerIds: string[];
    typeId: number;
    amount: number;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;

    constructor(data?: ICreateDiscountTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DiscountTypeTranslationDto.fromJS(item));
            }
            if (data["menuItemIds"] && data["menuItemIds"].constructor === Array) {
                this.menuItemIds = [];
                for (let item of data["menuItemIds"])
                    this.menuItemIds.push(item);
            }
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [];
                for (let item of data["customerIds"])
                    this.customerIds.push(item);
            }
            this.typeId = data["typeId"];
            this.amount = data["amount"];
            this.isOnSpecificItem = data["isOnSpecificItem"];
            this.isOnTotalReceipt = data["isOnTotalReceipt"];
        }
    }

    static fromJS(data: any): CreateDiscountTypeInput {
        let result = new CreateDiscountTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemIds && this.menuItemIds.constructor === Array) {
            data["menuItemIds"] = [];
            for (let item of this.menuItemIds)
                data["menuItemIds"].push(item);
        }
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["typeId"] = this.typeId;
        data["amount"] = this.amount;
        data["isOnSpecificItem"] = this.isOnSpecificItem;
        data["isOnTotalReceipt"] = this.isOnTotalReceipt;
        return data; 
    }
}

export interface ICreateDiscountTypeInput {
    translations: DiscountTypeTranslationDto[];
    menuItemIds: number[];
    customerIds: string[];
    typeId: number;
    amount: number;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
}

export class UpdateDiscountTypeInput implements IUpdateDiscountTypeInput {
    id: number;
    translations: DiscountTypeTranslationDto[];
    menuItemIds: number[];
    customerIds: string[];
    typeId: number;
    amount: number;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;

    constructor(data?: IUpdateDiscountTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DiscountTypeTranslationDto.fromJS(item));
            }
            if (data["menuItemIds"] && data["menuItemIds"].constructor === Array) {
                this.menuItemIds = [];
                for (let item of data["menuItemIds"])
                    this.menuItemIds.push(item);
            }
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [];
                for (let item of data["customerIds"])
                    this.customerIds.push(item);
            }
            this.typeId = data["typeId"];
            this.amount = data["amount"];
            this.isOnSpecificItem = data["isOnSpecificItem"];
            this.isOnTotalReceipt = data["isOnTotalReceipt"];
        }
    }

    static fromJS(data: any): UpdateDiscountTypeInput {
        let result = new UpdateDiscountTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemIds && this.menuItemIds.constructor === Array) {
            data["menuItemIds"] = [];
            for (let item of this.menuItemIds)
                data["menuItemIds"].push(item);
        }
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["typeId"] = this.typeId;
        data["amount"] = this.amount;
        data["isOnSpecificItem"] = this.isOnSpecificItem;
        data["isOnTotalReceipt"] = this.isOnTotalReceipt;
        return data; 
    }
}

export interface IUpdateDiscountTypeInput {
    id: number;
    translations: DiscountTypeTranslationDto[];
    menuItemIds: number[];
    customerIds: string[];
    typeId: number;
    amount: number;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items: EditionListDto[];

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[];
}

export class EditionListDto implements IEditionListDto {
    name: string;
    displayName: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionListDto {
    name: string;
    displayName: string;
    creationTime: moment.Moment;
    id: number;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];
}

export class EditionEditDto implements IEditionEditDto {
    id: number;
    displayName: string;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    expiringEditionId: number;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionEditDto {
    id: number;
    displayName: string;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    expiringEditionId: number;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFlatFeatureDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: FeatureInputTypeDto;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFeatureInputTypeDto {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class IValueValidator implements IIValueValidator {
    name: string;
    attributes: { [key: string] : any; };

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data; 
    }
}

export interface IIValueValidator {
    name: string;
    attributes: { [key: string] : any; };
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[];

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[];
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value: string;
    displayText: string;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface ILocalizableComboboxItemDto {
    value: string;
    displayText: string;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition: EditionEditDto = new EditionEditDto();
    featureValues: NameValueDto[] = [];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class EndOfDayInputReport implements IEndOfDayInputReport {
    from: moment.Moment;
    to: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    statuses: number[];
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IEndOfDayInputReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["statuses"] && data["statuses"].constructor === Array) {
                this.statuses = [];
                for (let item of data["statuses"])
                    this.statuses.push(item);
            }
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): EndOfDayInputReport {
        let result = new EndOfDayInputReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.statuses && this.statuses.constructor === Array) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IEndOfDayInputReport {
    from: moment.Moment;
    to: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    statuses: number[];
    documentType: number;
    isCSVFile: boolean;
}

export class PagedEndOfDayList implements IPagedEndOfDayList {
    currentPage: number;
    itemsCount: number;
    petyCashSummation: number;
    totalSalesSummation: number;
    totalSalesReturnsSummation: number;
    endOfDays: EndOfDayInfoDto[];

    constructor(data?: IPagedEndOfDayList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.petyCashSummation = data["petyCashSummation"];
            this.totalSalesSummation = data["totalSalesSummation"];
            this.totalSalesReturnsSummation = data["totalSalesReturnsSummation"];
            if (data["endOfDays"] && data["endOfDays"].constructor === Array) {
                this.endOfDays = [];
                for (let item of data["endOfDays"])
                    this.endOfDays.push(EndOfDayInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedEndOfDayList {
        let result = new PagedEndOfDayList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["petyCashSummation"] = this.petyCashSummation;
        data["totalSalesSummation"] = this.totalSalesSummation;
        data["totalSalesReturnsSummation"] = this.totalSalesReturnsSummation;
        if (this.endOfDays && this.endOfDays.constructor === Array) {
            data["endOfDays"] = [];
            for (let item of this.endOfDays)
                data["endOfDays"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedEndOfDayList {
    currentPage: number;
    itemsCount: number;
    petyCashSummation: number;
    totalSalesSummation: number;
    totalSalesReturnsSummation: number;
    endOfDays: EndOfDayInfoDto[];
}

export class EndOfDayInfoDto implements IEndOfDayInfoDto {
    id: number;
    storeName: string;
    startOfDayTiming: string;
    endOfDayTiming: string;
    date: string;
    startOfDayDate: string;
    endOfDayDate: string;
    petyCash: number;
    totalSalesValue: number;
    totalSalesReturns: number;
    totalVat: number;
    totalIncome: number;
    status: EndOfDayInfoDtoStatus;

    constructor(data?: IEndOfDayInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeName = data["storeName"];
            this.startOfDayTiming = data["startOfDayTiming"];
            this.endOfDayTiming = data["endOfDayTiming"];
            this.date = data["date"];
            this.startOfDayDate = data["startOfDayDate"];
            this.endOfDayDate = data["endOfDayDate"];
            this.petyCash = data["petyCash"];
            this.totalSalesValue = data["totalSalesValue"];
            this.totalSalesReturns = data["totalSalesReturns"];
            this.totalVat = data["totalVat"];
            this.totalIncome = data["totalIncome"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): EndOfDayInfoDto {
        let result = new EndOfDayInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeName"] = this.storeName;
        data["startOfDayTiming"] = this.startOfDayTiming;
        data["endOfDayTiming"] = this.endOfDayTiming;
        data["date"] = this.date;
        data["startOfDayDate"] = this.startOfDayDate;
        data["endOfDayDate"] = this.endOfDayDate;
        data["petyCash"] = this.petyCash;
        data["totalSalesValue"] = this.totalSalesValue;
        data["totalSalesReturns"] = this.totalSalesReturns;
        data["totalVat"] = this.totalVat;
        data["totalIncome"] = this.totalIncome;
        data["status"] = this.status;
        return data; 
    }
}

export interface IEndOfDayInfoDto {
    id: number;
    storeName: string;
    startOfDayTiming: string;
    endOfDayTiming: string;
    date: string;
    startOfDayDate: string;
    endOfDayDate: string;
    petyCash: number;
    totalSalesValue: number;
    totalSalesReturns: number;
    totalVat: number;
    totalIncome: number;
    status: EndOfDayInfoDtoStatus;
}

export class EndOfDayInvoiceSummerDto implements IEndOfDayInvoiceSummerDto {
    invoices: EndOfDayInvoiceDto[];
    returns: EndOfDayInvoiceDto[];

    constructor(data?: IEndOfDayInvoiceSummerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["invoices"] && data["invoices"].constructor === Array) {
                this.invoices = [];
                for (let item of data["invoices"])
                    this.invoices.push(EndOfDayInvoiceDto.fromJS(item));
            }
            if (data["returns"] && data["returns"].constructor === Array) {
                this.returns = [];
                for (let item of data["returns"])
                    this.returns.push(EndOfDayInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EndOfDayInvoiceSummerDto {
        let result = new EndOfDayInvoiceSummerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.invoices && this.invoices.constructor === Array) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (this.returns && this.returns.constructor === Array) {
            data["returns"] = [];
            for (let item of this.returns)
                data["returns"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEndOfDayInvoiceSummerDto {
    invoices: EndOfDayInvoiceDto[];
    returns: EndOfDayInvoiceDto[];
}

export class EndOfDayInvoiceDto implements IEndOfDayInvoiceDto {
    recieptNumber: string;
    subTotal: number;
    vat: number;
    total: number;

    constructor(data?: IEndOfDayInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.recieptNumber = data["recieptNumber"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): EndOfDayInvoiceDto {
        let result = new EndOfDayInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recieptNumber"] = this.recieptNumber;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        return data; 
    }
}

export interface IEndOfDayInvoiceDto {
    recieptNumber: string;
    subTotal: number;
    vat: number;
    total: number;
}

export class QrMenaSaleTransactionDto implements IQrMenaSaleTransactionDto {
    id: string;
    saleId: string;
    saleTypeId: number;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    status: number;
    notes: string;
    date: moment.Moment;
    terminalId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    happyHourId: number;
    templateType: number;
    additionalAllowns: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    storeId: number;
    detailSaleTransaction: QrMenaSaleTransactionDetialDto[];
    qrMenaSaleTransactionsDiningTables: QrMenaSaleTransactionsDiningTableDto[];

    constructor(data?: IQrMenaSaleTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleId = data["saleId"];
            this.saleTypeId = data["saleTypeId"];
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.salesManId = data["salesManId"];
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.cashierId = data["cashierId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.status = data["status"];
            this.notes = data["notes"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.terminalId = data["terminalId"];
            this.discount = data["discount"];
            this.discountType = data["discountType"];
            this.discountValue = data["discountValue"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.happyHourId = data["happyHourId"];
            this.templateType = data["templateType"];
            this.additionalAllowns = data["additionalAllowns"];
            this.endOfDayId = data["endOfDayId"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            this.storeId = data["storeId"];
            if (data["detailSaleTransaction"] && data["detailSaleTransaction"].constructor === Array) {
                this.detailSaleTransaction = [];
                for (let item of data["detailSaleTransaction"])
                    this.detailSaleTransaction.push(QrMenaSaleTransactionDetialDto.fromJS(item));
            }
            if (data["qrMenaSaleTransactionsDiningTables"] && data["qrMenaSaleTransactionsDiningTables"].constructor === Array) {
                this.qrMenaSaleTransactionsDiningTables = [];
                for (let item of data["qrMenaSaleTransactionsDiningTables"])
                    this.qrMenaSaleTransactionsDiningTables.push(QrMenaSaleTransactionsDiningTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QrMenaSaleTransactionDto {
        let result = new QrMenaSaleTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleId"] = this.saleId;
        data["saleTypeId"] = this.saleTypeId;
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["salesManId"] = this.salesManId;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["cashierId"] = this.cashierId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["terminalId"] = this.terminalId;
        data["discount"] = this.discount;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["happyHourId"] = this.happyHourId;
        data["templateType"] = this.templateType;
        data["additionalAllowns"] = this.additionalAllowns;
        data["endOfDayId"] = this.endOfDayId;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        data["storeId"] = this.storeId;
        if (this.detailSaleTransaction && this.detailSaleTransaction.constructor === Array) {
            data["detailSaleTransaction"] = [];
            for (let item of this.detailSaleTransaction)
                data["detailSaleTransaction"].push(item.toJSON());
        }
        if (this.qrMenaSaleTransactionsDiningTables && this.qrMenaSaleTransactionsDiningTables.constructor === Array) {
            data["qrMenaSaleTransactionsDiningTables"] = [];
            for (let item of this.qrMenaSaleTransactionsDiningTables)
                data["qrMenaSaleTransactionsDiningTables"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQrMenaSaleTransactionDto {
    id: string;
    saleId: string;
    saleTypeId: number;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    status: number;
    notes: string;
    date: moment.Moment;
    terminalId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    happyHourId: number;
    templateType: number;
    additionalAllowns: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    storeId: number;
    detailSaleTransaction: QrMenaSaleTransactionDetialDto[];
    qrMenaSaleTransactionsDiningTables: QrMenaSaleTransactionsDiningTableDto[];
}

export class QrMenaSaleTransactionDetialDto implements IQrMenaSaleTransactionDetialDto {
    id: string;
    saleTransactionId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    additionalAllowns: number;
    allownsReason: string;
    loyaltyDiscount: number;

    constructor(data?: IQrMenaSaleTransactionDetialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionId = data["saleTransactionId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.notes = data["notes"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.tenantId = data["tenantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.offerId = data["offerId"];
            this.additionalAllowns = data["additionalAllowns"];
            this.allownsReason = data["allownsReason"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
        }
    }

    static fromJS(data: any): QrMenaSaleTransactionDetialDto {
        let result = new QrMenaSaleTransactionDetialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionId"] = this.saleTransactionId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["notes"] = this.notes;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["tenantId"] = this.tenantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["offerId"] = this.offerId;
        data["additionalAllowns"] = this.additionalAllowns;
        data["allownsReason"] = this.allownsReason;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        return data; 
    }
}

export interface IQrMenaSaleTransactionDetialDto {
    id: string;
    saleTransactionId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    additionalAllowns: number;
    allownsReason: string;
    loyaltyDiscount: number;
}

export class QrMenaSaleTransactionsDiningTableDto implements IQrMenaSaleTransactionsDiningTableDto {
    id: string;
    qrMenaSaleTransactionId: string;
    tableId: number;
    numberOfSeats: number;
    isSplit: boolean;

    constructor(data?: IQrMenaSaleTransactionsDiningTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.qrMenaSaleTransactionId = data["qrMenaSaleTransactionId"];
            this.tableId = data["tableId"];
            this.numberOfSeats = data["numberOfSeats"];
            this.isSplit = data["isSplit"];
        }
    }

    static fromJS(data: any): QrMenaSaleTransactionsDiningTableDto {
        let result = new QrMenaSaleTransactionsDiningTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qrMenaSaleTransactionId"] = this.qrMenaSaleTransactionId;
        data["tableId"] = this.tableId;
        data["numberOfSeats"] = this.numberOfSeats;
        data["isSplit"] = this.isSplit;
        return data; 
    }
}

export interface IQrMenaSaleTransactionsDiningTableDto {
    id: string;
    qrMenaSaleTransactionId: string;
    tableId: number;
    numberOfSeats: number;
    isSplit: boolean;
}

export class WorkFlowSaleTransactionDto implements IWorkFlowSaleTransactionDto {
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    saleTypeId: number;
    salesManId: number;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    terminalId: number;
    promotionId: number;
    additionalAllowns: number;
    version: number;
    saleTransactionDetails: WorkFlowSaleTransactionDetailDto[];
    saleTransactionAddresses: WorkFlowSaleTransactionAddressDto[];
    date: moment.Moment;
    tenantId: number;
    notes: string;
    discount: number;
    discountType: number;
    discountValue: number;
    happyHourId: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    storeId: number;
    priceListId: number;
    status: number;
    templateType: number;
    promotionCodeId: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;

    constructor(data?: IWorkFlowSaleTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.saleTypeId = data["saleTypeId"];
            this.salesManId = data["salesManId"];
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.cashierId = data["cashierId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.terminalId = data["terminalId"];
            this.promotionId = data["promotionId"];
            this.additionalAllowns = data["additionalAllowns"];
            this.version = data["version"];
            if (data["saleTransactionDetails"] && data["saleTransactionDetails"].constructor === Array) {
                this.saleTransactionDetails = [];
                for (let item of data["saleTransactionDetails"])
                    this.saleTransactionDetails.push(WorkFlowSaleTransactionDetailDto.fromJS(item));
            }
            if (data["saleTransactionAddresses"] && data["saleTransactionAddresses"].constructor === Array) {
                this.saleTransactionAddresses = [];
                for (let item of data["saleTransactionAddresses"])
                    this.saleTransactionAddresses.push(WorkFlowSaleTransactionAddressDto.fromJS(item));
            }
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
            this.discount = data["discount"];
            this.discountType = data["discountType"];
            this.discountValue = data["discountValue"];
            this.happyHourId = data["happyHourId"];
            this.endOfDayId = data["endOfDayId"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            this.storeId = data["storeId"];
            this.priceListId = data["priceListId"];
            this.status = data["status"];
            this.templateType = data["templateType"];
            this.promotionCodeId = data["promotionCodeId"];
            this.createdDeviceId = data["createdDeviceId"];
            this.lastModficationDeviceId = data["lastModficationDeviceId"];
        }
    }

    static fromJS(data: any): WorkFlowSaleTransactionDto {
        let result = new WorkFlowSaleTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["saleTypeId"] = this.saleTypeId;
        data["salesManId"] = this.salesManId;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["cashierId"] = this.cashierId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["terminalId"] = this.terminalId;
        data["promotionId"] = this.promotionId;
        data["additionalAllowns"] = this.additionalAllowns;
        data["version"] = this.version;
        if (this.saleTransactionDetails && this.saleTransactionDetails.constructor === Array) {
            data["saleTransactionDetails"] = [];
            for (let item of this.saleTransactionDetails)
                data["saleTransactionDetails"].push(item.toJSON());
        }
        if (this.saleTransactionAddresses && this.saleTransactionAddresses.constructor === Array) {
            data["saleTransactionAddresses"] = [];
            for (let item of this.saleTransactionAddresses)
                data["saleTransactionAddresses"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        data["discount"] = this.discount;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["happyHourId"] = this.happyHourId;
        data["endOfDayId"] = this.endOfDayId;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        data["storeId"] = this.storeId;
        data["priceListId"] = this.priceListId;
        data["status"] = this.status;
        data["templateType"] = this.templateType;
        data["promotionCodeId"] = this.promotionCodeId;
        data["createdDeviceId"] = this.createdDeviceId;
        data["lastModficationDeviceId"] = this.lastModficationDeviceId;
        return data; 
    }
}

export interface IWorkFlowSaleTransactionDto {
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    saleTypeId: number;
    salesManId: number;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    terminalId: number;
    promotionId: number;
    additionalAllowns: number;
    version: number;
    saleTransactionDetails: WorkFlowSaleTransactionDetailDto[];
    saleTransactionAddresses: WorkFlowSaleTransactionAddressDto[];
    date: moment.Moment;
    tenantId: number;
    notes: string;
    discount: number;
    discountType: number;
    discountValue: number;
    happyHourId: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    storeId: number;
    priceListId: number;
    status: number;
    templateType: number;
    promotionCodeId: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
}

export class WorkFlowSaleTransactionDetailDto implements IWorkFlowSaleTransactionDetailDto {
    id: string;
    saleTransactionId: string;
    productLotId: number;
    productId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    additionalAllowns: number;
    allownsReason: string;
    loyaltyDiscount: number;
    saleTransactionDetailVarients: WorkFlowSaleTransactionDetailVarientDto[];
    saleTransactionDetailsComboMealsItems: WorkFlowSaleTransactionDetailsComboMealsItemDto[];
    saleTransactionsDetialsPromotionItems: WorkFlowSaleTransactionsDetialsPromotionItemDto[];

    constructor(data?: IWorkFlowSaleTransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionId = data["saleTransactionId"];
            this.productLotId = data["productLotId"];
            this.productId = data["productId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.notes = data["notes"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.tenantId = data["tenantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.offerId = data["offerId"];
            this.additionalAllowns = data["additionalAllowns"];
            this.allownsReason = data["allownsReason"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            if (data["saleTransactionDetailVarients"] && data["saleTransactionDetailVarients"].constructor === Array) {
                this.saleTransactionDetailVarients = [];
                for (let item of data["saleTransactionDetailVarients"])
                    this.saleTransactionDetailVarients.push(WorkFlowSaleTransactionDetailVarientDto.fromJS(item));
            }
            if (data["saleTransactionDetailsComboMealsItems"] && data["saleTransactionDetailsComboMealsItems"].constructor === Array) {
                this.saleTransactionDetailsComboMealsItems = [];
                for (let item of data["saleTransactionDetailsComboMealsItems"])
                    this.saleTransactionDetailsComboMealsItems.push(WorkFlowSaleTransactionDetailsComboMealsItemDto.fromJS(item));
            }
            if (data["saleTransactionsDetialsPromotionItems"] && data["saleTransactionsDetialsPromotionItems"].constructor === Array) {
                this.saleTransactionsDetialsPromotionItems = [];
                for (let item of data["saleTransactionsDetialsPromotionItems"])
                    this.saleTransactionsDetialsPromotionItems.push(WorkFlowSaleTransactionsDetialsPromotionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkFlowSaleTransactionDetailDto {
        let result = new WorkFlowSaleTransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionId"] = this.saleTransactionId;
        data["productLotId"] = this.productLotId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["notes"] = this.notes;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["tenantId"] = this.tenantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["offerId"] = this.offerId;
        data["additionalAllowns"] = this.additionalAllowns;
        data["allownsReason"] = this.allownsReason;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        if (this.saleTransactionDetailVarients && this.saleTransactionDetailVarients.constructor === Array) {
            data["saleTransactionDetailVarients"] = [];
            for (let item of this.saleTransactionDetailVarients)
                data["saleTransactionDetailVarients"].push(item.toJSON());
        }
        if (this.saleTransactionDetailsComboMealsItems && this.saleTransactionDetailsComboMealsItems.constructor === Array) {
            data["saleTransactionDetailsComboMealsItems"] = [];
            for (let item of this.saleTransactionDetailsComboMealsItems)
                data["saleTransactionDetailsComboMealsItems"].push(item.toJSON());
        }
        if (this.saleTransactionsDetialsPromotionItems && this.saleTransactionsDetialsPromotionItems.constructor === Array) {
            data["saleTransactionsDetialsPromotionItems"] = [];
            for (let item of this.saleTransactionsDetialsPromotionItems)
                data["saleTransactionsDetialsPromotionItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkFlowSaleTransactionDetailDto {
    id: string;
    saleTransactionId: string;
    productLotId: number;
    productId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    additionalAllowns: number;
    allownsReason: string;
    loyaltyDiscount: number;
    saleTransactionDetailVarients: WorkFlowSaleTransactionDetailVarientDto[];
    saleTransactionDetailsComboMealsItems: WorkFlowSaleTransactionDetailsComboMealsItemDto[];
    saleTransactionsDetialsPromotionItems: WorkFlowSaleTransactionsDetialsPromotionItemDto[];
}

export class WorkFlowSaleTransactionAddressDto implements IWorkFlowSaleTransactionAddressDto {
    id: string;
    saleTransactionId: string;
    city: string;
    link: string;
    address: string;
    deliveryStreetId: number;
    deliveryZoneId: number;

    constructor(data?: IWorkFlowSaleTransactionAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionId = data["saleTransactionId"];
            this.city = data["city"];
            this.link = data["link"];
            this.address = data["address"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.deliveryZoneId = data["deliveryZoneId"];
        }
    }

    static fromJS(data: any): WorkFlowSaleTransactionAddressDto {
        let result = new WorkFlowSaleTransactionAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionId"] = this.saleTransactionId;
        data["city"] = this.city;
        data["link"] = this.link;
        data["address"] = this.address;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["deliveryZoneId"] = this.deliveryZoneId;
        return data; 
    }
}

export interface IWorkFlowSaleTransactionAddressDto {
    id: string;
    saleTransactionId: string;
    city: string;
    link: string;
    address: string;
    deliveryStreetId: number;
    deliveryZoneId: number;
}

export class WorkFlowSaleTransactionDetailVarientDto implements IWorkFlowSaleTransactionDetailVarientDto {
    id: number;
    saleTransactionDetailId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;

    constructor(data?: IWorkFlowSaleTransactionDetailVarientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.variantId = data["variantId"];
            this.variantValueId = data["variantValueId"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.quantity = data["quantity"];
            this.freeQty = data["freeQty"];
        }
    }

    static fromJS(data: any): WorkFlowSaleTransactionDetailVarientDto {
        let result = new WorkFlowSaleTransactionDetailVarientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["variantId"] = this.variantId;
        data["variantValueId"] = this.variantValueId;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["quantity"] = this.quantity;
        data["freeQty"] = this.freeQty;
        return data; 
    }
}

export interface IWorkFlowSaleTransactionDetailVarientDto {
    id: number;
    saleTransactionDetailId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
}

export class WorkFlowSaleTransactionDetailsComboMealsItemDto implements IWorkFlowSaleTransactionDetailsComboMealsItemDto {
    id: string;
    tenantId: number;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;

    constructor(data?: IWorkFlowSaleTransactionDetailsComboMealsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): WorkFlowSaleTransactionDetailsComboMealsItemDto {
        let result = new WorkFlowSaleTransactionDetailsComboMealsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        return data; 
    }
}

export interface IWorkFlowSaleTransactionDetailsComboMealsItemDto {
    id: string;
    tenantId: number;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
}

export class WorkFlowSaleTransactionsDetialsPromotionItemDto implements IWorkFlowSaleTransactionsDetialsPromotionItemDto {
    id: string;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;

    constructor(data?: IWorkFlowSaleTransactionsDetialsPromotionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludeVat = data["priceIncludeVat"];
        }
    }

    static fromJS(data: any): WorkFlowSaleTransactionsDetialsPromotionItemDto {
        let result = new WorkFlowSaleTransactionsDetialsPromotionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludeVat"] = this.priceIncludeVat;
        return data; 
    }
}

export interface IWorkFlowSaleTransactionsDetialsPromotionItemDto {
    id: string;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
}

export class FileNotificationsDto implements IFileNotificationsDto {
    id: number;
    fileName: string;
    fileType: string;
    fileToken: string;

    constructor(data?: IFileNotificationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): FileNotificationsDto {
        let result = new FileNotificationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IFileNotificationsDto {
    id: number;
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string;
}

export class BlockUserInput implements IBlockUserInput {
    userId: number;
    tenantId: number;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId: number;
    tenantId: number;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number;
}

export class CreateGroupInput implements ICreateGroupInput {
    id: number;
    productIds: number[];
    storeIds: number[];
    translations: GroupTranslationDto[];

    constructor(data?: ICreateGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["productIds"] && data["productIds"].constructor === Array) {
                this.productIds = [];
                for (let item of data["productIds"])
                    this.productIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(GroupTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateGroupInput {
        let result = new CreateGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.productIds && this.productIds.constructor === Array) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateGroupInput {
    id: number;
    productIds: number[];
    storeIds: number[];
    translations: GroupTranslationDto[];
}

export class GroupTranslationDto implements IGroupTranslationDto {
    name: string;
    description: string;
    languageId: number;

    constructor(data?: IGroupTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): GroupTranslationDto {
        let result = new GroupTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IGroupTranslationDto {
    name: string;
    description: string;
    languageId: number;
}

export class ListResultDtoOfGroupListItem implements IListResultDtoOfGroupListItem {
    items: GroupListItem[];

    constructor(data?: IListResultDtoOfGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GroupListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGroupListItem {
        let result = new ListResultDtoOfGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGroupListItem {
    items: GroupListItem[];
}

export class GroupListItem implements IGroupListItem {
    id: number;
    name: string;

    constructor(data?: IGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GroupListItem {
        let result = new GroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IGroupListItem {
    id: number;
    name: string;
}

export class ListResultDtoOfGetGroupOutput implements IListResultDtoOfGetGroupOutput {
    items: GetGroupOutput[];

    constructor(data?: IListResultDtoOfGetGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGroupOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetGroupOutput {
        let result = new ListResultDtoOfGetGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetGroupOutput {
    items: GetGroupOutput[];
}

export class GetGroupOutput implements IGetGroupOutput {
    id: number;
    productIds: number[];
    storeIds: number[];
    translations: GroupTranslationDto[];

    constructor(data?: IGetGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["productIds"] && data["productIds"].constructor === Array) {
                this.productIds = [];
                for (let item of data["productIds"])
                    this.productIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(GroupTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGroupOutput {
        let result = new GetGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.productIds && this.productIds.constructor === Array) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetGroupOutput {
    id: number;
    productIds: number[];
    storeIds: number[];
    translations: GroupTranslationDto[];
}

export class PagedGroupsList implements IPagedGroupsList {
    currentPage: number;
    itemsCount: number;
    groups: GroupListItem[];

    constructor(data?: IPagedGroupsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["groups"] && data["groups"].constructor === Array) {
                this.groups = [];
                for (let item of data["groups"])
                    this.groups.push(GroupListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedGroupsList {
        let result = new PagedGroupsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.groups && this.groups.constructor === Array) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedGroupsList {
    currentPage: number;
    itemsCount: number;
    groups: GroupListItem[];
}

export class UpdateGroupInput implements IUpdateGroupInput {
    id: number;
    productIds: number[];
    storeIds: number[];
    translations: GroupTranslationDto[];

    constructor(data?: IUpdateGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["productIds"] && data["productIds"].constructor === Array) {
                this.productIds = [];
                for (let item of data["productIds"])
                    this.productIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(GroupTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateGroupInput {
        let result = new UpdateGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.productIds && this.productIds.constructor === Array) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateGroupInput {
    id: number;
    productIds: number[];
    storeIds: number[];
    translations: GroupTranslationDto[];
}

export class ListResultDtoOfHapptHourListItem implements IListResultDtoOfHapptHourListItem {
    items: HapptHourListItem[];

    constructor(data?: IListResultDtoOfHapptHourListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HapptHourListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfHapptHourListItem {
        let result = new ListResultDtoOfHapptHourListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfHapptHourListItem {
    items: HapptHourListItem[];
}

export class HapptHourListItem implements IHapptHourListItem {
    id: number;
    happyHourName: string;
    typeId: number;
    typeName: string;
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    discountValue: number;
    discountTypeFlag: boolean;
    tenantId: number;

    constructor(data?: IHapptHourListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.happyHourName = data["happyHourName"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            this.discountValue = data["discountValue"];
            this.discountTypeFlag = data["discountTypeFlag"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): HapptHourListItem {
        let result = new HapptHourListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["happyHourName"] = this.happyHourName;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["discountValue"] = this.discountValue;
        data["discountTypeFlag"] = this.discountTypeFlag;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IHapptHourListItem {
    id: number;
    happyHourName: string;
    typeId: number;
    typeName: string;
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    discountValue: number;
    discountTypeFlag: boolean;
    tenantId: number;
}

export class PagedHappyHourList implements IPagedHappyHourList {
    currentPage: number;
    itemsCount: number;
    happHours: HapptHourListItem[];

    constructor(data?: IPagedHappyHourList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["happHours"] && data["happHours"].constructor === Array) {
                this.happHours = [];
                for (let item of data["happHours"])
                    this.happHours.push(HapptHourListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedHappyHourList {
        let result = new PagedHappyHourList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.happHours && this.happHours.constructor === Array) {
            data["happHours"] = [];
            for (let item of this.happHours)
                data["happHours"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedHappyHourList {
    currentPage: number;
    itemsCount: number;
    happHours: HapptHourListItem[];
}

export class HappyHourDto implements IHappyHourDto {
    translations: HappyHourTranslationDto[];
    typeId: number;
    happyHourName: string;
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    discountTypeFlag: boolean;
    discountValue: number;
    storeIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IHappyHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(HappyHourTranslationDto.fromJS(item));
            }
            this.typeId = data["typeId"];
            this.happyHourName = data["happyHourName"];
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            this.discountTypeFlag = data["discountTypeFlag"];
            this.discountValue = data["discountValue"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HappyHourDto {
        let result = new HappyHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["typeId"] = this.typeId;
        data["happyHourName"] = this.happyHourName;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["discountTypeFlag"] = this.discountTypeFlag;
        data["discountValue"] = this.discountValue;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHappyHourDto {
    translations: HappyHourTranslationDto[];
    typeId: number;
    happyHourName: string;
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    discountTypeFlag: boolean;
    discountValue: number;
    storeIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class HappyHourTranslationDto implements IHappyHourTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IHappyHourTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): HappyHourTranslationDto {
        let result = new HappyHourTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IHappyHourTranslationDto {
    name: string;
    languageId: number;
}

export class CreateHappyHourInput implements ICreateHappyHourInput {
    translations: HappyHourTranslationDto[];
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    typeId: number;
    discountTypeFlag: boolean;
    discountValue: number;
    storeIds: number[];

    constructor(data?: ICreateHappyHourInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(HappyHourTranslationDto.fromJS(item));
            }
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            this.typeId = data["typeId"];
            this.discountTypeFlag = data["discountTypeFlag"];
            this.discountValue = data["discountValue"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateHappyHourInput {
        let result = new CreateHappyHourInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["typeId"] = this.typeId;
        data["discountTypeFlag"] = this.discountTypeFlag;
        data["discountValue"] = this.discountValue;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateHappyHourInput {
    translations: HappyHourTranslationDto[];
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    typeId: number;
    discountTypeFlag: boolean;
    discountValue: number;
    storeIds: number[];
}

export class EditHappyHourInput implements IEditHappyHourInput {
    translations: HappyHourTranslationDto[];
    typeId: number;
    id: number;
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    discountTypeFlag: boolean;
    discountValue: number;
    storeIds: number[];

    constructor(data?: IEditHappyHourInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(HappyHourTranslationDto.fromJS(item));
            }
            this.typeId = data["typeId"];
            this.id = data["id"];
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            this.discountTypeFlag = data["discountTypeFlag"];
            this.discountValue = data["discountValue"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): EditHappyHourInput {
        let result = new EditHappyHourInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["typeId"] = this.typeId;
        data["id"] = this.id;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["discountTypeFlag"] = this.discountTypeFlag;
        data["discountValue"] = this.discountValue;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IEditHappyHourInput {
    translations: HappyHourTranslationDto[];
    typeId: number;
    id: number;
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    discountTypeFlag: boolean;
    discountValue: number;
    storeIds: number[];
}

export class HostDashboardData implements IHostDashboardData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
    incomeStatistics: IncomeStastistic[];
    editionStatistics: TenantEdition[];
    expiringTenants: ExpiringTenant[];
    recentTenants: RecentTenant[];
    maxExpiringTenantsShownCount: number;
    maxRecentTenantsShownCount: number;
    subscriptionEndAlertDayCount: number;
    recentTenantsDayCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
    tenantCreationStartDate: moment.Moment;

    constructor(data?: IHostDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
            if (data["expiringTenants"] && data["expiringTenants"].constructor === Array) {
                this.expiringTenants = [];
                for (let item of data["expiringTenants"])
                    this.expiringTenants.push(ExpiringTenant.fromJS(item));
            }
            if (data["recentTenants"] && data["recentTenants"].constructor === Array) {
                this.recentTenants = [];
                for (let item of data["recentTenants"])
                    this.recentTenants.push(RecentTenant.fromJS(item));
            }
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : <any>undefined;
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HostDashboardData {
        let result = new HostDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        if (this.expiringTenants && this.expiringTenants.constructor === Array) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        if (this.recentTenants && this.recentTenants.constructor === Array) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHostDashboardData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
    incomeStatistics: IncomeStastistic[];
    editionStatistics: TenantEdition[];
    expiringTenants: ExpiringTenant[];
    recentTenants: RecentTenant[];
    maxExpiringTenantsShownCount: number;
    maxRecentTenantsShownCount: number;
    subscriptionEndAlertDayCount: number;
    recentTenantsDayCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
    tenantCreationStartDate: moment.Moment;
}

export class IncomeStastistic implements IIncomeStastistic {
    label: string;
    date: moment.Moment;
    amount: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IIncomeStastistic {
    label: string;
    date: moment.Moment;
    amount: number;
}

export class TenantEdition implements ITenantEdition {
    label: string;
    value: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITenantEdition {
    label: string;
    value: number;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName: string;
    remainingDayCount: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data; 
    }
}

export interface IExpiringTenant {
    tenantName: string;
    remainingDayCount: number;
}

export class RecentTenant implements IRecentTenant {
    id: number;
    name: string;
    creationTime: moment.Moment;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRecentTenant {
    id: number;
    name: string;
    creationTime: moment.Moment;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[];

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[];
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[];

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[];
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general: GeneralSettingsEditDto = new GeneralSettingsEditDto();
    userManagement: HostUserManagementSettingsEditDto = new HostUserManagementSettingsEditDto();
    email: EmailSettingsEditDto = new EmailSettingsEditDto();
    tenantManagement: TenantManagementSettingsEditDto = new TenantManagementSettingsEditDto();
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: HostBillingSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone: string;
    timezoneForComparison: string;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data; 
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string;
    timezoneForComparison: string;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        return data; 
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress: string;
    defaultFromDisplayName: string;
    smtpHost: string;
    smtpPort: number;
    smtpUserName: string;
    smtpPassword: string;
    smtpDomain: string;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data; 
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string;
    defaultFromDisplayName: string;
    smtpHost: string;
    smtpPort: number;
    smtpUserName: string;
    smtpPassword: string;
    smtpDomain: string;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data; 
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName: string;
    address: string;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data; 
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string;
    address: string;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data; 
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data; 
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class ExcelUploadResponseDto implements IExcelUploadResponseDto {
    errors: ExcelUploadedErrorMessage[];
    isHasErrors: boolean;
    errorFile: FileDto;

    constructor(data?: IExcelUploadResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(ExcelUploadedErrorMessage.fromJS(item));
            }
            this.isHasErrors = data["isHasErrors"];
            this.errorFile = data["errorFile"] ? FileDto.fromJS(data["errorFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExcelUploadResponseDto {
        let result = new ExcelUploadResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isHasErrors"] = this.isHasErrors;
        data["errorFile"] = this.errorFile ? this.errorFile.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IExcelUploadResponseDto {
    errors: ExcelUploadedErrorMessage[];
    isHasErrors: boolean;
    errorFile: FileDto;
}

export class ExcelUploadedErrorMessage implements IExcelUploadedErrorMessage {
    rawNumber: number;
    sheetName: string;
    messageContent: string;

    constructor(data?: IExcelUploadedErrorMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawNumber = data["rawNumber"];
            this.sheetName = data["sheetName"];
            this.messageContent = data["messageContent"];
        }
    }

    static fromJS(data: any): ExcelUploadedErrorMessage {
        let result = new ExcelUploadedErrorMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawNumber"] = this.rawNumber;
        data["sheetName"] = this.sheetName;
        data["messageContent"] = this.messageContent;
        return data; 
    }
}

export interface IExcelUploadedErrorMessage {
    rawNumber: number;
    sheetName: string;
    messageContent: string;
}

export class InstallDto implements IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : <any>undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    connectionString: string;
    webSiteUrl: string;
    serverSiteUrl: string;
    languages: NameValue[];

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (let item of data["languages"])
                    this.languages.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppSettingsJsonDto {
    connectionString: string;
    webSiteUrl: string;
    serverSiteUrl: string;
    languages: NameValue[];
}

export class NameValue implements INameValue {
    name: string;
    value: string;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValue {
    name: string;
    value: string;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data; 
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class CreateInventoryOrderInput implements ICreateInventoryOrderInput {
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: InventoryOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    status: number;

    constructor(data?: ICreateInventoryOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceNumber = data["invoiceNumber"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.vendorId = data["vendorId"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(InventoryOrderProductLotDto.fromJS(item));
            }
            this.code = data["code"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CreateInventoryOrderInput {
        let result = new CreateInventoryOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["vendorId"] = this.vendorId;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICreateInventoryOrderInput {
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: InventoryOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    status: number;
}

export class InventoryOrderProductLotDto implements IInventoryOrderProductLotDto {
    productLotId: number;
    storeId: number;
    storeName: string;
    code: string;
    productId: number;
    productName: string;
    productCode: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    unitPurchasePrice: number;
    priceWithoutVat: number;
    productVariantId: number;
    productVariantName: string;
    remainingQuantity: number;
    editMode: boolean;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    vat: number;
    includeVAT: boolean;
    discountTypeId: number;
    discountAmount: number;
    totalCost: number;
    total: number;
    netCost: number;
    discount: number;

    constructor(data?: IInventoryOrderProductLotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productLotId = data["productLotId"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.code = data["code"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productCode = data["productCode"];
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.quantity = data["quantity"];
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.priceWithoutVat = data["priceWithoutVat"];
            this.productVariantId = data["productVariantId"];
            this.productVariantName = data["productVariantName"];
            this.remainingQuantity = data["remainingQuantity"];
            this.editMode = data["editMode"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.vat = data["vat"];
            this.includeVAT = data["includeVAT"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.totalCost = data["totalCost"];
            this.total = data["total"];
            this.netCost = data["netCost"];
            this.discount = data["discount"];
        }
    }

    static fromJS(data: any): InventoryOrderProductLotDto {
        let result = new InventoryOrderProductLotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLotId"] = this.productLotId;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["code"] = this.code;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["productVariantId"] = this.productVariantId;
        data["productVariantName"] = this.productVariantName;
        data["remainingQuantity"] = this.remainingQuantity;
        data["editMode"] = this.editMode;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["vat"] = this.vat;
        data["includeVAT"] = this.includeVAT;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["totalCost"] = this.totalCost;
        data["total"] = this.total;
        data["netCost"] = this.netCost;
        data["discount"] = this.discount;
        return data; 
    }
}

export interface IInventoryOrderProductLotDto {
    productLotId: number;
    storeId: number;
    storeName: string;
    code: string;
    productId: number;
    productName: string;
    productCode: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    unitPurchasePrice: number;
    priceWithoutVat: number;
    productVariantId: number;
    productVariantName: string;
    remainingQuantity: number;
    editMode: boolean;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    vat: number;
    includeVAT: boolean;
    discountTypeId: number;
    discountAmount: number;
    totalCost: number;
    total: number;
    netCost: number;
    discount: number;
}

export class TransactionTypeDto implements ITransactionTypeDto {
    transactionTypeId: number;
    tenantId: number;
    value: number;
    roleId: number[];
    translations: TransactionTypeTranslationDto[];

    constructor(data?: ITransactionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeId = data["transactionTypeId"];
            this.tenantId = data["tenantId"];
            this.value = data["value"];
            if (data["roleId"] && data["roleId"].constructor === Array) {
                this.roleId = [];
                for (let item of data["roleId"])
                    this.roleId.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TransactionTypeTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionTypeDto {
        let result = new TransactionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["tenantId"] = this.tenantId;
        data["value"] = this.value;
        if (this.roleId && this.roleId.constructor === Array) {
            data["roleId"] = [];
            for (let item of this.roleId)
                data["roleId"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransactionTypeDto {
    transactionTypeId: number;
    tenantId: number;
    value: number;
    roleId: number[];
    translations: TransactionTypeTranslationDto[];
}

export class TransactionTypeTranslationDto implements ITransactionTypeTranslationDto {
    transactionTypeId: number;
    value: number;
    transactionType: TransactionTypeDto;
    name: string;
    languageId: number;

    constructor(data?: ITransactionTypeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeId = data["transactionTypeId"];
            this.value = data["value"];
            this.transactionType = data["transactionType"] ? TransactionTypeDto.fromJS(data["transactionType"]) : <any>undefined;
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): TransactionTypeTranslationDto {
        let result = new TransactionTypeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["value"] = this.value;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ITransactionTypeTranslationDto {
    transactionTypeId: number;
    value: number;
    transactionType: TransactionTypeDto;
    name: string;
    languageId: number;
}

export class ListResultDtoOfInventoryOrderListItem implements IListResultDtoOfInventoryOrderListItem {
    items: InventoryOrderListItem[];

    constructor(data?: IListResultDtoOfInventoryOrderListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(InventoryOrderListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInventoryOrderListItem {
        let result = new ListResultDtoOfInventoryOrderListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfInventoryOrderListItem {
    items: InventoryOrderListItem[];
}

export class InventoryOrderListItem implements IInventoryOrderListItem {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    discountTypeId: number;
    discountAmount: number;
    vendorId: number;
    vendorName: string;
    status: number;

    constructor(data?: IInventoryOrderListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.code = data["code"];
            this.purchaseDate = data["purchaseDate"];
            this.storeName = data["storeName"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.vendorId = data["vendorId"];
            this.vendorName = data["vendorName"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): InventoryOrderListItem {
        let result = new InventoryOrderListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["purchaseDate"] = this.purchaseDate;
        data["storeName"] = this.storeName;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["status"] = this.status;
        return data; 
    }
}

export interface IInventoryOrderListItem {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    discountTypeId: number;
    discountAmount: number;
    vendorId: number;
    vendorName: string;
    status: number;
}

export class PagedInventoryOrderList implements IPagedInventoryOrderList {
    currentPage: number;
    itemsCount: number;
    invoices: InventoryOrderListItem[];

    constructor(data?: IPagedInventoryOrderList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["invoices"] && data["invoices"].constructor === Array) {
                this.invoices = [];
                for (let item of data["invoices"])
                    this.invoices.push(InventoryOrderListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedInventoryOrderList {
        let result = new PagedInventoryOrderList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.invoices && this.invoices.constructor === Array) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedInventoryOrderList {
    currentPage: number;
    itemsCount: number;
    invoices: InventoryOrderListItem[];
}

export class InventoryOrderDto implements IInventoryOrderDto {
    id: number;
    invoiceNumber: string;
    code: string;
    productCode: string;
    purchaseDate: string;
    storeName: string;
    store: StoreDto;
    vendorId: number;
    vendorName: string;
    currencyName: string;
    purchaseTotal: number;
    discountTypeId: number;
    status: number;
    discountAmount: number;
    productLots: InventoryOrderProductLotDto[];

    constructor(data?: IInventoryOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.code = data["code"];
            this.productCode = data["productCode"];
            this.purchaseDate = data["purchaseDate"];
            this.storeName = data["storeName"];
            this.store = data["store"] ? StoreDto.fromJS(data["store"]) : <any>undefined;
            this.vendorId = data["vendorId"];
            this.vendorName = data["vendorName"];
            this.currencyName = data["currencyName"];
            this.purchaseTotal = data["purchaseTotal"];
            this.discountTypeId = data["discountTypeId"];
            this.status = data["status"];
            this.discountAmount = data["discountAmount"];
            if (data["productLots"] && data["productLots"].constructor === Array) {
                this.productLots = [];
                for (let item of data["productLots"])
                    this.productLots.push(InventoryOrderProductLotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InventoryOrderDto {
        let result = new InventoryOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["productCode"] = this.productCode;
        data["purchaseDate"] = this.purchaseDate;
        data["storeName"] = this.storeName;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["currencyName"] = this.currencyName;
        data["purchaseTotal"] = this.purchaseTotal;
        data["discountTypeId"] = this.discountTypeId;
        data["status"] = this.status;
        data["discountAmount"] = this.discountAmount;
        if (this.productLots && this.productLots.constructor === Array) {
            data["productLots"] = [];
            for (let item of this.productLots)
                data["productLots"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInventoryOrderDto {
    id: number;
    invoiceNumber: string;
    code: string;
    productCode: string;
    purchaseDate: string;
    storeName: string;
    store: StoreDto;
    vendorId: number;
    vendorName: string;
    currencyName: string;
    purchaseTotal: number;
    discountTypeId: number;
    status: number;
    discountAmount: number;
    productLots: InventoryOrderProductLotDto[];
}

export class UpdateInventoryOrderInput implements IUpdateInventoryOrderInput {
    id: number;
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: InventoryOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    status: number;

    constructor(data?: IUpdateInventoryOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.vendorId = data["vendorId"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(InventoryOrderProductLotDto.fromJS(item));
            }
            this.code = data["code"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): UpdateInventoryOrderInput {
        let result = new UpdateInventoryOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["vendorId"] = this.vendorId;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUpdateInventoryOrderInput {
    id: number;
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: InventoryOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    status: number;
}

export class StoreQuantitiesIssuedReportInput implements IStoreQuantitiesIssuedReportInput {
    tenantsIds: number[];
    storesIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    regionId: number;
    areaId: number;
    materialIds: number[];
    isCSVFile: boolean;

    constructor(data?: IStoreQuantitiesIssuedReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            if (data["storesIds"] && data["storesIds"].constructor === Array) {
                this.storesIds = [];
                for (let item of data["storesIds"])
                    this.storesIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["materialIds"] && data["materialIds"].constructor === Array) {
                this.materialIds = [];
                for (let item of data["materialIds"])
                    this.materialIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): StoreQuantitiesIssuedReportInput {
        let result = new StoreQuantitiesIssuedReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        if (this.storesIds && this.storesIds.constructor === Array) {
            data["storesIds"] = [];
            for (let item of this.storesIds)
                data["storesIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.materialIds && this.materialIds.constructor === Array) {
            data["materialIds"] = [];
            for (let item of this.materialIds)
                data["materialIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IStoreQuantitiesIssuedReportInput {
    tenantsIds: number[];
    storesIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    regionId: number;
    areaId: number;
    materialIds: number[];
    isCSVFile: boolean;
}

export class StoreQuantitiesIssuedReportPage implements IStoreQuantitiesIssuedReportPage {
    data: StoreQuantitiesIssuedListItemGrouped[];
    totalCount: number;
    pageNumber: number;
    totalOrderQty: number;
    totalTransferQty: number;
    totalReturnQty: number;
    totalWasteQty: number;

    constructor(data?: IStoreQuantitiesIssuedReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreQuantitiesIssuedListItemGrouped.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalOrderQty = data["totalOrderQty"];
            this.totalTransferQty = data["totalTransferQty"];
            this.totalReturnQty = data["totalReturnQty"];
            this.totalWasteQty = data["totalWasteQty"];
        }
    }

    static fromJS(data: any): StoreQuantitiesIssuedReportPage {
        let result = new StoreQuantitiesIssuedReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalOrderQty"] = this.totalOrderQty;
        data["totalTransferQty"] = this.totalTransferQty;
        data["totalReturnQty"] = this.totalReturnQty;
        data["totalWasteQty"] = this.totalWasteQty;
        return data; 
    }
}

export interface IStoreQuantitiesIssuedReportPage {
    data: StoreQuantitiesIssuedListItemGrouped[];
    totalCount: number;
    pageNumber: number;
    totalOrderQty: number;
    totalTransferQty: number;
    totalReturnQty: number;
    totalWasteQty: number;
}

export class StoreQuantitiesIssuedListItemGrouped implements IStoreQuantitiesIssuedListItemGrouped {
    storeName: string;
    storesData: StoreQuantitiesIssuedListItem[];
    totalOrderQtyPerStore: number;
    totalTransferQtyPerStore: number;
    totalReturnQtyPerStore: number;
    totalWasteQtyPerStore: number;
    isSupplier: boolean;
    storeNumber: string;
    receiveNumber: string;

    constructor(data?: IStoreQuantitiesIssuedListItemGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            if (data["storesData"] && data["storesData"].constructor === Array) {
                this.storesData = [];
                for (let item of data["storesData"])
                    this.storesData.push(StoreQuantitiesIssuedListItem.fromJS(item));
            }
            this.totalOrderQtyPerStore = data["totalOrderQtyPerStore"];
            this.totalTransferQtyPerStore = data["totalTransferQtyPerStore"];
            this.totalReturnQtyPerStore = data["totalReturnQtyPerStore"];
            this.totalWasteQtyPerStore = data["totalWasteQtyPerStore"];
            this.isSupplier = data["isSupplier"];
            this.storeNumber = data["storeNumber"];
            this.receiveNumber = data["receiveNumber"];
        }
    }

    static fromJS(data: any): StoreQuantitiesIssuedListItemGrouped {
        let result = new StoreQuantitiesIssuedListItemGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        if (this.storesData && this.storesData.constructor === Array) {
            data["storesData"] = [];
            for (let item of this.storesData)
                data["storesData"].push(item.toJSON());
        }
        data["totalOrderQtyPerStore"] = this.totalOrderQtyPerStore;
        data["totalTransferQtyPerStore"] = this.totalTransferQtyPerStore;
        data["totalReturnQtyPerStore"] = this.totalReturnQtyPerStore;
        data["totalWasteQtyPerStore"] = this.totalWasteQtyPerStore;
        data["isSupplier"] = this.isSupplier;
        data["storeNumber"] = this.storeNumber;
        data["receiveNumber"] = this.receiveNumber;
        return data; 
    }
}

export interface IStoreQuantitiesIssuedListItemGrouped {
    storeName: string;
    storesData: StoreQuantitiesIssuedListItem[];
    totalOrderQtyPerStore: number;
    totalTransferQtyPerStore: number;
    totalReturnQtyPerStore: number;
    totalWasteQtyPerStore: number;
    isSupplier: boolean;
    storeNumber: string;
    receiveNumber: string;
}

export class StoreQuantitiesIssuedListItem implements IStoreQuantitiesIssuedListItem {
    receiveNumber: string;
    tenantName: string;
    storeCode: string;
    storeId: number;
    storeName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    sourceStoreName: string;
    rawMaterialName: string;
    materialId: number;
    orderQty: number;
    transferQty: number;
    returnQty: number;
    wasteQty: number;
    date: moment.Moment;
    isSupplier: boolean;
    isSourceSupplier: boolean;
    dateAsString: string;

    constructor(data?: IStoreQuantitiesIssuedListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNumber = data["receiveNumber"];
            this.tenantName = data["tenantName"];
            this.storeCode = data["storeCode"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.sourceStoreCode = data["sourceStoreCode"];
            this.sourceStorId = data["sourceStorId"];
            this.sourceStoreName = data["sourceStoreName"];
            this.rawMaterialName = data["rawMaterialName"];
            this.materialId = data["materialId"];
            this.orderQty = data["orderQty"];
            this.transferQty = data["transferQty"];
            this.returnQty = data["returnQty"];
            this.wasteQty = data["wasteQty"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.isSupplier = data["isSupplier"];
            this.isSourceSupplier = data["isSourceSupplier"];
            this.dateAsString = data["dateAsString"];
        }
    }

    static fromJS(data: any): StoreQuantitiesIssuedListItem {
        let result = new StoreQuantitiesIssuedListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNumber"] = this.receiveNumber;
        data["tenantName"] = this.tenantName;
        data["storeCode"] = this.storeCode;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["sourceStorId"] = this.sourceStorId;
        data["sourceStoreName"] = this.sourceStoreName;
        data["rawMaterialName"] = this.rawMaterialName;
        data["materialId"] = this.materialId;
        data["orderQty"] = this.orderQty;
        data["transferQty"] = this.transferQty;
        data["returnQty"] = this.returnQty;
        data["wasteQty"] = this.wasteQty;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isSupplier"] = this.isSupplier;
        data["isSourceSupplier"] = this.isSourceSupplier;
        data["dateAsString"] = this.dateAsString;
        return data; 
    }
}

export interface IStoreQuantitiesIssuedListItem {
    receiveNumber: string;
    tenantName: string;
    storeCode: string;
    storeId: number;
    storeName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    sourceStoreName: string;
    rawMaterialName: string;
    materialId: number;
    orderQty: number;
    transferQty: number;
    returnQty: number;
    wasteQty: number;
    date: moment.Moment;
    isSupplier: boolean;
    isSourceSupplier: boolean;
    dateAsString: string;
}

export class StoreOrderReportInput implements IStoreOrderReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    sourceIds: number[];
    destinationIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    materialIds: number[];
    isCSVFile: boolean;

    constructor(data?: IStoreOrderReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["sourceIds"] && data["sourceIds"].constructor === Array) {
                this.sourceIds = [];
                for (let item of data["sourceIds"])
                    this.sourceIds.push(item);
            }
            if (data["destinationIds"] && data["destinationIds"].constructor === Array) {
                this.destinationIds = [];
                for (let item of data["destinationIds"])
                    this.destinationIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            if (data["materialIds"] && data["materialIds"].constructor === Array) {
                this.materialIds = [];
                for (let item of data["materialIds"])
                    this.materialIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): StoreOrderReportInput {
        let result = new StoreOrderReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.sourceIds && this.sourceIds.constructor === Array) {
            data["sourceIds"] = [];
            for (let item of this.sourceIds)
                data["sourceIds"].push(item);
        }
        if (this.destinationIds && this.destinationIds.constructor === Array) {
            data["destinationIds"] = [];
            for (let item of this.destinationIds)
                data["destinationIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (this.materialIds && this.materialIds.constructor === Array) {
            data["materialIds"] = [];
            for (let item of this.materialIds)
                data["materialIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IStoreOrderReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    sourceIds: number[];
    destinationIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    materialIds: number[];
    isCSVFile: boolean;
}

export class StoreOrderReportPage implements IStoreOrderReportPage {
    data: StoreOrderReportListItemGroupedPage[];
    totalCount: number;
    pageNumber: number;
    totalOrderQty: number;
    totalOrderCost: number;

    constructor(data?: IStoreOrderReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreOrderReportListItemGroupedPage.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalOrderQty = data["totalOrderQty"];
            this.totalOrderCost = data["totalOrderCost"];
        }
    }

    static fromJS(data: any): StoreOrderReportPage {
        let result = new StoreOrderReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalOrderQty"] = this.totalOrderQty;
        data["totalOrderCost"] = this.totalOrderCost;
        return data; 
    }
}

export interface IStoreOrderReportPage {
    data: StoreOrderReportListItemGroupedPage[];
    totalCount: number;
    pageNumber: number;
    totalOrderQty: number;
    totalOrderCost: number;
}

export class StoreOrderReportListItemGroupedPage implements IStoreOrderReportListItemGroupedPage {
    tenantName: string;
    storesData: StoreOrderReportListItemPage[];

    constructor(data?: IStoreOrderReportListItemGroupedPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["storesData"] && data["storesData"].constructor === Array) {
                this.storesData = [];
                for (let item of data["storesData"])
                    this.storesData.push(StoreOrderReportListItemPage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreOrderReportListItemGroupedPage {
        let result = new StoreOrderReportListItemGroupedPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.storesData && this.storesData.constructor === Array) {
            data["storesData"] = [];
            for (let item of this.storesData)
                data["storesData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreOrderReportListItemGroupedPage {
    tenantName: string;
    storesData: StoreOrderReportListItemPage[];
}

export class StoreOrderReportListItemPage implements IStoreOrderReportListItemPage {
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    puCost: number;
    orderQty: number;
    totalCost: number;

    constructor(data?: IStoreOrderReportListItemPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSupplier = data["isSupplier"];
            this.sourceStoreName = data["sourceStoreName"];
            this.sourceStoreCode = data["sourceStoreCode"];
            this.sourceStorId = data["sourceStorId"];
            this.puCost = data["puCost"];
            this.orderQty = data["orderQty"];
            this.totalCost = data["totalCost"];
        }
    }

    static fromJS(data: any): StoreOrderReportListItemPage {
        let result = new StoreOrderReportListItemPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSupplier"] = this.isSupplier;
        data["sourceStoreName"] = this.sourceStoreName;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["sourceStorId"] = this.sourceStorId;
        data["puCost"] = this.puCost;
        data["orderQty"] = this.orderQty;
        data["totalCost"] = this.totalCost;
        return data; 
    }
}

export interface IStoreOrderReportListItemPage {
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    puCost: number;
    orderQty: number;
    totalCost: number;
}

export class StoreOrderReportDetails implements IStoreOrderReportDetails {
    data: StoreOrderReportListItem[];
    totalCount: number;
    pageNumber: number;

    constructor(data?: IStoreOrderReportDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreOrderReportListItem.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
        }
    }

    static fromJS(data: any): StoreOrderReportDetails {
        let result = new StoreOrderReportDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        return data; 
    }
}

export interface IStoreOrderReportDetails {
    data: StoreOrderReportListItem[];
    totalCount: number;
    pageNumber: number;
}

export class StoreOrderReportListItem implements IStoreOrderReportListItem {
    tenantName: string;
    fromStore: string;
    storeCode: string;
    storeName: string;
    rawMaterialName: string;
    puCost: number;
    orderQty: number;
    recipeQty: number;
    totalCost: number;
    date: moment.Moment;
    materialId: number;
    storeId: number;
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    receiveNumber: string;
    uomName: string;
    reviewDate: moment.Moment;
    dateAsString: string;
    reviewDateAsString: string;

    constructor(data?: IStoreOrderReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.fromStore = data["fromStore"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.rawMaterialName = data["rawMaterialName"];
            this.puCost = data["puCost"];
            this.orderQty = data["orderQty"];
            this.recipeQty = data["recipeQty"];
            this.totalCost = data["totalCost"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.materialId = data["materialId"];
            this.storeId = data["storeId"];
            this.isSupplier = data["isSupplier"];
            this.sourceStoreName = data["sourceStoreName"];
            this.sourceStoreCode = data["sourceStoreCode"];
            this.sourceStorId = data["sourceStorId"];
            this.receiveNumber = data["receiveNumber"];
            this.uomName = data["uomName"];
            this.reviewDate = data["reviewDate"] ? moment(data["reviewDate"].toString()) : <any>undefined;
            this.dateAsString = data["dateAsString"];
            this.reviewDateAsString = data["reviewDateAsString"];
        }
    }

    static fromJS(data: any): StoreOrderReportListItem {
        let result = new StoreOrderReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["fromStore"] = this.fromStore;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["rawMaterialName"] = this.rawMaterialName;
        data["puCost"] = this.puCost;
        data["orderQty"] = this.orderQty;
        data["recipeQty"] = this.recipeQty;
        data["totalCost"] = this.totalCost;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["materialId"] = this.materialId;
        data["storeId"] = this.storeId;
        data["isSupplier"] = this.isSupplier;
        data["sourceStoreName"] = this.sourceStoreName;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["sourceStorId"] = this.sourceStorId;
        data["receiveNumber"] = this.receiveNumber;
        data["uomName"] = this.uomName;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : <any>undefined;
        data["dateAsString"] = this.dateAsString;
        data["reviewDateAsString"] = this.reviewDateAsString;
        return data; 
    }
}

export interface IStoreOrderReportListItem {
    tenantName: string;
    fromStore: string;
    storeCode: string;
    storeName: string;
    rawMaterialName: string;
    puCost: number;
    orderQty: number;
    recipeQty: number;
    totalCost: number;
    date: moment.Moment;
    materialId: number;
    storeId: number;
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    receiveNumber: string;
    uomName: string;
    reviewDate: moment.Moment;
    dateAsString: string;
    reviewDateAsString: string;
}

export class StoreReportUserDetail implements IStoreReportUserDetail {
    data: StoreReportUserDetailListItem[];
    totalCount: number;
    pageNumber: number;

    constructor(data?: IStoreReportUserDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreReportUserDetailListItem.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
        }
    }

    static fromJS(data: any): StoreReportUserDetail {
        let result = new StoreReportUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        return data; 
    }
}

export interface IStoreReportUserDetail {
    data: StoreReportUserDetailListItem[];
    totalCount: number;
    pageNumber: number;
}

export class StoreReportUserDetailListItem implements IStoreReportUserDetailListItem {
    receiveNumber: string;
    createdBy: string;

    constructor(data?: IStoreReportUserDetailListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNumber = data["receiveNumber"];
            this.createdBy = data["createdBy"];
        }
    }

    static fromJS(data: any): StoreReportUserDetailListItem {
        let result = new StoreReportUserDetailListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNumber"] = this.receiveNumber;
        data["createdBy"] = this.createdBy;
        return data; 
    }
}

export interface IStoreReportUserDetailListItem {
    receiveNumber: string;
    createdBy: string;
}

export class StoreTransferOutReportPage implements IStoreTransferOutReportPage {
    data: StoreTransferOutReportTenantGrouped[];
    totalCount: number;
    pageNumber: number;
    totalTransferQty: number;
    totalPurchaseCost: number;
    totalPurchaseQty: number;
    totalRecipeQty: number;
    totalCost: number;

    constructor(data?: IStoreTransferOutReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreTransferOutReportTenantGrouped.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalTransferQty = data["totalTransferQty"];
            this.totalPurchaseCost = data["totalPurchaseCost"];
            this.totalPurchaseQty = data["totalPurchaseQty"];
            this.totalRecipeQty = data["totalRecipeQty"];
            this.totalCost = data["totalCost"];
        }
    }

    static fromJS(data: any): StoreTransferOutReportPage {
        let result = new StoreTransferOutReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalTransferQty"] = this.totalTransferQty;
        data["totalPurchaseCost"] = this.totalPurchaseCost;
        data["totalPurchaseQty"] = this.totalPurchaseQty;
        data["totalRecipeQty"] = this.totalRecipeQty;
        data["totalCost"] = this.totalCost;
        return data; 
    }
}

export interface IStoreTransferOutReportPage {
    data: StoreTransferOutReportTenantGrouped[];
    totalCount: number;
    pageNumber: number;
    totalTransferQty: number;
    totalPurchaseCost: number;
    totalPurchaseQty: number;
    totalRecipeQty: number;
    totalCost: number;
}

export class StoreTransferOutReportTenantGrouped implements IStoreTransferOutReportTenantGrouped {
    tenantName: string;
    gropedStores: StoreTransferOutReportGrouped[];

    constructor(data?: IStoreTransferOutReportTenantGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["gropedStores"] && data["gropedStores"].constructor === Array) {
                this.gropedStores = [];
                for (let item of data["gropedStores"])
                    this.gropedStores.push(StoreTransferOutReportGrouped.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreTransferOutReportTenantGrouped {
        let result = new StoreTransferOutReportTenantGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.gropedStores && this.gropedStores.constructor === Array) {
            data["gropedStores"] = [];
            for (let item of this.gropedStores)
                data["gropedStores"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreTransferOutReportTenantGrouped {
    tenantName: string;
    gropedStores: StoreTransferOutReportGrouped[];
}

export class StoreTransferOutReportGrouped implements IStoreTransferOutReportGrouped {
    fromStoreId: number;
    fromStoreCode: string;
    fromStore: string;
    totalTransferQty: number;
    totalPurchaseCost: number;
    totalPurchaseQty: number;
    totalRecipeQty: number;
    totalCost: number;

    constructor(data?: IStoreTransferOutReportGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromStoreId = data["fromStoreId"];
            this.fromStoreCode = data["fromStoreCode"];
            this.fromStore = data["fromStore"];
            this.totalTransferQty = data["totalTransferQty"];
            this.totalPurchaseCost = data["totalPurchaseCost"];
            this.totalPurchaseQty = data["totalPurchaseQty"];
            this.totalRecipeQty = data["totalRecipeQty"];
            this.totalCost = data["totalCost"];
        }
    }

    static fromJS(data: any): StoreTransferOutReportGrouped {
        let result = new StoreTransferOutReportGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromStoreId"] = this.fromStoreId;
        data["fromStoreCode"] = this.fromStoreCode;
        data["fromStore"] = this.fromStore;
        data["totalTransferQty"] = this.totalTransferQty;
        data["totalPurchaseCost"] = this.totalPurchaseCost;
        data["totalPurchaseQty"] = this.totalPurchaseQty;
        data["totalRecipeQty"] = this.totalRecipeQty;
        data["totalCost"] = this.totalCost;
        return data; 
    }
}

export interface IStoreTransferOutReportGrouped {
    fromStoreId: number;
    fromStoreCode: string;
    fromStore: string;
    totalTransferQty: number;
    totalPurchaseCost: number;
    totalPurchaseQty: number;
    totalRecipeQty: number;
    totalCost: number;
}

export class StoreTransferOutDetailReport implements IStoreTransferOutDetailReport {
    data: StoreTransferOutReportListItem[];
    totalCount: number;
    pageNumber: number;

    constructor(data?: IStoreTransferOutDetailReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreTransferOutReportListItem.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
        }
    }

    static fromJS(data: any): StoreTransferOutDetailReport {
        let result = new StoreTransferOutDetailReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        return data; 
    }
}

export interface IStoreTransferOutDetailReport {
    data: StoreTransferOutReportListItem[];
    totalCount: number;
    pageNumber: number;
}

export class StoreTransferOutReportListItem implements IStoreTransferOutReportListItem {
    tenantName: string;
    fromStoreCode: string;
    fromStore: string;
    storeCode: string;
    storeName: string;
    rawMaterialName: string;
    puCost: number;
    transferQty: number;
    purchaseQty: number;
    recipeQty: number;
    totalCost: number;
    date: moment.Moment;
    dateAsString: string;
    materialId: number;
    storeId: number;
    fromStoreId: number;
    uomName: string;

    constructor(data?: IStoreTransferOutReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.fromStoreCode = data["fromStoreCode"];
            this.fromStore = data["fromStore"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.rawMaterialName = data["rawMaterialName"];
            this.puCost = data["puCost"];
            this.transferQty = data["transferQty"];
            this.purchaseQty = data["purchaseQty"];
            this.recipeQty = data["recipeQty"];
            this.totalCost = data["totalCost"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.dateAsString = data["dateAsString"];
            this.materialId = data["materialId"];
            this.storeId = data["storeId"];
            this.fromStoreId = data["fromStoreId"];
            this.uomName = data["uomName"];
        }
    }

    static fromJS(data: any): StoreTransferOutReportListItem {
        let result = new StoreTransferOutReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["fromStoreCode"] = this.fromStoreCode;
        data["fromStore"] = this.fromStore;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["rawMaterialName"] = this.rawMaterialName;
        data["puCost"] = this.puCost;
        data["transferQty"] = this.transferQty;
        data["purchaseQty"] = this.purchaseQty;
        data["recipeQty"] = this.recipeQty;
        data["totalCost"] = this.totalCost;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateAsString"] = this.dateAsString;
        data["materialId"] = this.materialId;
        data["storeId"] = this.storeId;
        data["fromStoreId"] = this.fromStoreId;
        data["uomName"] = this.uomName;
        return data; 
    }
}

export interface IStoreTransferOutReportListItem {
    tenantName: string;
    fromStoreCode: string;
    fromStore: string;
    storeCode: string;
    storeName: string;
    rawMaterialName: string;
    puCost: number;
    transferQty: number;
    purchaseQty: number;
    recipeQty: number;
    totalCost: number;
    date: moment.Moment;
    dateAsString: string;
    materialId: number;
    storeId: number;
    fromStoreId: number;
    uomName: string;
}

export class StockValuesReportFilter implements IStockValuesReportFilter {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantsIds: number[];
    isEndOfDay: boolean;
    showZeroTransactions: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
    documentType: number;

    constructor(data?: IStockValuesReportFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["matrialIds"] && data["matrialIds"].constructor === Array) {
                this.matrialIds = [];
                for (let item of data["matrialIds"])
                    this.matrialIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.isEndOfDay = data["isEndOfDay"];
            this.showZeroTransactions = data["showZeroTransactions"];
            this.showMaterialName = data["showMaterialName"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.isCSVFile = data["isCSVFile"];
            this.documentType = data["documentType"];
        }
    }

    static fromJS(data: any): StockValuesReportFilter {
        let result = new StockValuesReportFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.matrialIds && this.matrialIds.constructor === Array) {
            data["matrialIds"] = [];
            for (let item of this.matrialIds)
                data["matrialIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["isEndOfDay"] = this.isEndOfDay;
        data["showZeroTransactions"] = this.showZeroTransactions;
        data["showMaterialName"] = this.showMaterialName;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["isCSVFile"] = this.isCSVFile;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IStockValuesReportFilter {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantsIds: number[];
    isEndOfDay: boolean;
    showZeroTransactions: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
    documentType: number;
}

export class StockValuesPagedDto implements IStockValuesPagedDto {
    currentPage: number;
    itemsCount: number;
    items: TenantStockValues[];

    constructor(data?: IStockValuesPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantStockValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockValuesPagedDto {
        let result = new StockValuesPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockValuesPagedDto {
    currentPage: number;
    itemsCount: number;
    items: TenantStockValues[];
}

export class TenantStockValues implements ITenantStockValues {
    tenantName: string;
    storeStockValuesRecords: StoreStockValues[];

    constructor(data?: ITenantStockValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["storeStockValuesRecords"] && data["storeStockValuesRecords"].constructor === Array) {
                this.storeStockValuesRecords = [];
                for (let item of data["storeStockValuesRecords"])
                    this.storeStockValuesRecords.push(StoreStockValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantStockValues {
        let result = new TenantStockValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.storeStockValuesRecords && this.storeStockValuesRecords.constructor === Array) {
            data["storeStockValuesRecords"] = [];
            for (let item of this.storeStockValuesRecords)
                data["storeStockValuesRecords"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantStockValues {
    tenantName: string;
    storeStockValuesRecords: StoreStockValues[];
}

export class StoreStockValues implements IStoreStockValues {
    storeName: string;
    storeCode: string;
    items: ItemStockValues[];

    constructor(data?: IStoreStockValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ItemStockValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreStockValues {
        let result = new StoreStockValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreStockValues {
    storeName: string;
    storeCode: string;
    items: ItemStockValues[];
}

export class ItemStockValues implements IItemStockValues {
    materialId: number;
    materialCode: string;
    materialName: string;
    actualQuantity: string;
    expectedQuantity: string;
    expectedBalance: number;
    actualTotalValue: number;
    expectedTotalValue: number;
    uomName: string;
    totalCost: number;
    unitCost: number;

    constructor(data?: IItemStockValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialId = data["materialId"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.actualQuantity = data["actualQuantity"];
            this.expectedQuantity = data["expectedQuantity"];
            this.expectedBalance = data["expectedBalance"];
            this.actualTotalValue = data["actualTotalValue"];
            this.expectedTotalValue = data["expectedTotalValue"];
            this.uomName = data["uomName"];
            this.totalCost = data["totalCost"];
            this.unitCost = data["unitCost"];
        }
    }

    static fromJS(data: any): ItemStockValues {
        let result = new ItemStockValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["actualQuantity"] = this.actualQuantity;
        data["expectedQuantity"] = this.expectedQuantity;
        data["expectedBalance"] = this.expectedBalance;
        data["actualTotalValue"] = this.actualTotalValue;
        data["expectedTotalValue"] = this.expectedTotalValue;
        data["uomName"] = this.uomName;
        data["totalCost"] = this.totalCost;
        data["unitCost"] = this.unitCost;
        return data; 
    }
}

export interface IItemStockValues {
    materialId: number;
    materialCode: string;
    materialName: string;
    actualQuantity: string;
    expectedQuantity: string;
    expectedBalance: number;
    actualTotalValue: number;
    expectedTotalValue: number;
    uomName: string;
    totalCost: number;
    unitCost: number;
}

export class MaterialInentoryVarianceReportFilter implements IMaterialInentoryVarianceReportFilter {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    isEndOfDay: boolean;
    showZeroTransactions: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
    documentType: number;

    constructor(data?: IMaterialInentoryVarianceReportFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["matrialIds"] && data["matrialIds"].constructor === Array) {
                this.matrialIds = [];
                for (let item of data["matrialIds"])
                    this.matrialIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isEndOfDay = data["isEndOfDay"];
            this.showZeroTransactions = data["showZeroTransactions"];
            this.showMaterialName = data["showMaterialName"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.isCSVFile = data["isCSVFile"];
            this.documentType = data["documentType"];
        }
    }

    static fromJS(data: any): MaterialInentoryVarianceReportFilter {
        let result = new MaterialInentoryVarianceReportFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.matrialIds && this.matrialIds.constructor === Array) {
            data["matrialIds"] = [];
            for (let item of this.matrialIds)
                data["matrialIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isEndOfDay"] = this.isEndOfDay;
        data["showZeroTransactions"] = this.showZeroTransactions;
        data["showMaterialName"] = this.showMaterialName;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["isCSVFile"] = this.isCSVFile;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IMaterialInentoryVarianceReportFilter {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    isEndOfDay: boolean;
    showZeroTransactions: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
    documentType: number;
}

export class MaterialStockTransactionWithPeriodsPagedDto implements IMaterialStockTransactionWithPeriodsPagedDto {
    currentPage: number;
    itemsCount: number;
    items: TenantInventoryVariance[];

    constructor(data?: IMaterialStockTransactionWithPeriodsPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantInventoryVariance.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialStockTransactionWithPeriodsPagedDto {
        let result = new MaterialStockTransactionWithPeriodsPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMaterialStockTransactionWithPeriodsPagedDto {
    currentPage: number;
    itemsCount: number;
    items: TenantInventoryVariance[];
}

export class TenantInventoryVariance implements ITenantInventoryVariance {
    tenantName: string;
    storeInventoryVaraincesRecords: StoreInventoryVaraince[];

    constructor(data?: ITenantInventoryVariance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["storeInventoryVaraincesRecords"] && data["storeInventoryVaraincesRecords"].constructor === Array) {
                this.storeInventoryVaraincesRecords = [];
                for (let item of data["storeInventoryVaraincesRecords"])
                    this.storeInventoryVaraincesRecords.push(StoreInventoryVaraince.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantInventoryVariance {
        let result = new TenantInventoryVariance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.storeInventoryVaraincesRecords && this.storeInventoryVaraincesRecords.constructor === Array) {
            data["storeInventoryVaraincesRecords"] = [];
            for (let item of this.storeInventoryVaraincesRecords)
                data["storeInventoryVaraincesRecords"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantInventoryVariance {
    tenantName: string;
    storeInventoryVaraincesRecords: StoreInventoryVaraince[];
}

export class StoreInventoryVaraince implements IStoreInventoryVaraince {
    storeName: string;
    storeCode: string;
    items: ItemInventoryVaraince[];

    constructor(data?: IStoreInventoryVaraince) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ItemInventoryVaraince.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreInventoryVaraince {
        let result = new StoreInventoryVaraince();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreInventoryVaraince {
    storeName: string;
    storeCode: string;
    items: ItemInventoryVaraince[];
}

export class ItemInventoryVaraince implements IItemInventoryVaraince {
    materialId: number;
    materialCode: string;
    materialName: string;
    inventoryUnit: string;
    stockOpeningQunatity: string;
    inventoryReciveQunatity: number;
    inventoryRawWast: number;
    stockAdjustmentQuantity: number;
    transferOutQuantity: number;
    transferInQuantity: number;
    inventoryOrderQuantity: number;
    batchRecipeQuantity: number;
    purshaseQuantity: number;
    returnPurchaseQuantity: number;
    menuItemWasteQuantity: number;
    saleQuantity: number;
    cost: number;
    variantQuantity: string;
    actualQuantity: string;
    expectedQuantity: string;
    uomName: string;
    expectedBalance: number;

    constructor(data?: IItemInventoryVaraince) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialId = data["materialId"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.inventoryUnit = data["inventoryUnit"];
            this.stockOpeningQunatity = data["stockOpeningQunatity"];
            this.inventoryReciveQunatity = data["inventoryReciveQunatity"];
            this.inventoryRawWast = data["inventoryRawWast"];
            this.stockAdjustmentQuantity = data["stockAdjustmentQuantity"];
            this.transferOutQuantity = data["transferOutQuantity"];
            this.transferInQuantity = data["transferInQuantity"];
            this.inventoryOrderQuantity = data["inventoryOrderQuantity"];
            this.batchRecipeQuantity = data["batchRecipeQuantity"];
            this.purshaseQuantity = data["purshaseQuantity"];
            this.returnPurchaseQuantity = data["returnPurchaseQuantity"];
            this.menuItemWasteQuantity = data["menuItemWasteQuantity"];
            this.saleQuantity = data["saleQuantity"];
            this.cost = data["cost"];
            this.variantQuantity = data["variantQuantity"];
            this.actualQuantity = data["actualQuantity"];
            this.expectedQuantity = data["expectedQuantity"];
            this.uomName = data["uomName"];
            this.expectedBalance = data["expectedBalance"];
        }
    }

    static fromJS(data: any): ItemInventoryVaraince {
        let result = new ItemInventoryVaraince();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["inventoryUnit"] = this.inventoryUnit;
        data["stockOpeningQunatity"] = this.stockOpeningQunatity;
        data["inventoryReciveQunatity"] = this.inventoryReciveQunatity;
        data["inventoryRawWast"] = this.inventoryRawWast;
        data["stockAdjustmentQuantity"] = this.stockAdjustmentQuantity;
        data["transferOutQuantity"] = this.transferOutQuantity;
        data["transferInQuantity"] = this.transferInQuantity;
        data["inventoryOrderQuantity"] = this.inventoryOrderQuantity;
        data["batchRecipeQuantity"] = this.batchRecipeQuantity;
        data["purshaseQuantity"] = this.purshaseQuantity;
        data["returnPurchaseQuantity"] = this.returnPurchaseQuantity;
        data["menuItemWasteQuantity"] = this.menuItemWasteQuantity;
        data["saleQuantity"] = this.saleQuantity;
        data["cost"] = this.cost;
        data["variantQuantity"] = this.variantQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["expectedQuantity"] = this.expectedQuantity;
        data["uomName"] = this.uomName;
        data["expectedBalance"] = this.expectedBalance;
        return data; 
    }
}

export interface IItemInventoryVaraince {
    materialId: number;
    materialCode: string;
    materialName: string;
    inventoryUnit: string;
    stockOpeningQunatity: string;
    inventoryReciveQunatity: number;
    inventoryRawWast: number;
    stockAdjustmentQuantity: number;
    transferOutQuantity: number;
    transferInQuantity: number;
    inventoryOrderQuantity: number;
    batchRecipeQuantity: number;
    purshaseQuantity: number;
    returnPurchaseQuantity: number;
    menuItemWasteQuantity: number;
    saleQuantity: number;
    cost: number;
    variantQuantity: string;
    actualQuantity: string;
    expectedQuantity: string;
    uomName: string;
    expectedBalance: number;
}

export class MaterialInentoryVarianceReportFilterDto implements IMaterialInentoryVarianceReportFilterDto {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantsIds: number[];
    isEndOfDay: boolean;
    showZeroTransactions: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;

    constructor(data?: IMaterialInentoryVarianceReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["matrialIds"] && data["matrialIds"].constructor === Array) {
                this.matrialIds = [];
                for (let item of data["matrialIds"])
                    this.matrialIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.isEndOfDay = data["isEndOfDay"];
            this.showZeroTransactions = data["showZeroTransactions"];
            this.showMaterialName = data["showMaterialName"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): MaterialInentoryVarianceReportFilterDto {
        let result = new MaterialInentoryVarianceReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.matrialIds && this.matrialIds.constructor === Array) {
            data["matrialIds"] = [];
            for (let item of this.matrialIds)
                data["matrialIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["isEndOfDay"] = this.isEndOfDay;
        data["showZeroTransactions"] = this.showZeroTransactions;
        data["showMaterialName"] = this.showMaterialName;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IMaterialInentoryVarianceReportFilterDto {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantsIds: number[];
    isEndOfDay: boolean;
    showZeroTransactions: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
}

export class MaterialStockTransactionWithPeriodsAndCostPagedDto implements IMaterialStockTransactionWithPeriodsAndCostPagedDto {
    currentPage: number;
    itemsCount: number;
    items: TenantInventoryVarianceWithCost[];

    constructor(data?: IMaterialStockTransactionWithPeriodsAndCostPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantInventoryVarianceWithCost.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialStockTransactionWithPeriodsAndCostPagedDto {
        let result = new MaterialStockTransactionWithPeriodsAndCostPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMaterialStockTransactionWithPeriodsAndCostPagedDto {
    currentPage: number;
    itemsCount: number;
    items: TenantInventoryVarianceWithCost[];
}

export class TenantInventoryVarianceWithCost implements ITenantInventoryVarianceWithCost {
    tenantName: string;
    storeInventoryVaraincesRecords: StoreInventoryVarainceWithCost[];

    constructor(data?: ITenantInventoryVarianceWithCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["storeInventoryVaraincesRecords"] && data["storeInventoryVaraincesRecords"].constructor === Array) {
                this.storeInventoryVaraincesRecords = [];
                for (let item of data["storeInventoryVaraincesRecords"])
                    this.storeInventoryVaraincesRecords.push(StoreInventoryVarainceWithCost.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantInventoryVarianceWithCost {
        let result = new TenantInventoryVarianceWithCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.storeInventoryVaraincesRecords && this.storeInventoryVaraincesRecords.constructor === Array) {
            data["storeInventoryVaraincesRecords"] = [];
            for (let item of this.storeInventoryVaraincesRecords)
                data["storeInventoryVaraincesRecords"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantInventoryVarianceWithCost {
    tenantName: string;
    storeInventoryVaraincesRecords: StoreInventoryVarainceWithCost[];
}

export class StoreInventoryVarainceWithCost implements IStoreInventoryVarainceWithCost {
    storeName: string;
    storeCode: string;
    items: ItemInventoryVarainceWithCost[];

    constructor(data?: IStoreInventoryVarainceWithCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ItemInventoryVarainceWithCost.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreInventoryVarainceWithCost {
        let result = new StoreInventoryVarainceWithCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreInventoryVarainceWithCost {
    storeName: string;
    storeCode: string;
    items: ItemInventoryVarainceWithCost[];
}

export class ItemInventoryVarainceWithCost implements IItemInventoryVarainceWithCost {
    currentCost: number;
    totalCost: number;
    materialId: number;
    materialCode: string;
    materialName: string;
    inventoryUnit: string;
    stockOpeningQunatity: string;
    inventoryReciveQunatity: number;
    inventoryRawWast: number;
    stockAdjustmentQuantity: number;
    transferOutQuantity: number;
    transferInQuantity: number;
    inventoryOrderQuantity: number;
    batchRecipeQuantity: number;
    purshaseQuantity: number;
    returnPurchaseQuantity: number;
    menuItemWasteQuantity: number;
    saleQuantity: number;
    cost: number;
    variantQuantity: string;
    actualQuantity: string;
    expectedQuantity: string;
    uomName: string;
    expectedBalance: number;

    constructor(data?: IItemInventoryVarainceWithCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentCost = data["currentCost"];
            this.totalCost = data["totalCost"];
            this.materialId = data["materialId"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.inventoryUnit = data["inventoryUnit"];
            this.stockOpeningQunatity = data["stockOpeningQunatity"];
            this.inventoryReciveQunatity = data["inventoryReciveQunatity"];
            this.inventoryRawWast = data["inventoryRawWast"];
            this.stockAdjustmentQuantity = data["stockAdjustmentQuantity"];
            this.transferOutQuantity = data["transferOutQuantity"];
            this.transferInQuantity = data["transferInQuantity"];
            this.inventoryOrderQuantity = data["inventoryOrderQuantity"];
            this.batchRecipeQuantity = data["batchRecipeQuantity"];
            this.purshaseQuantity = data["purshaseQuantity"];
            this.returnPurchaseQuantity = data["returnPurchaseQuantity"];
            this.menuItemWasteQuantity = data["menuItemWasteQuantity"];
            this.saleQuantity = data["saleQuantity"];
            this.cost = data["cost"];
            this.variantQuantity = data["variantQuantity"];
            this.actualQuantity = data["actualQuantity"];
            this.expectedQuantity = data["expectedQuantity"];
            this.uomName = data["uomName"];
            this.expectedBalance = data["expectedBalance"];
        }
    }

    static fromJS(data: any): ItemInventoryVarainceWithCost {
        let result = new ItemInventoryVarainceWithCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentCost"] = this.currentCost;
        data["totalCost"] = this.totalCost;
        data["materialId"] = this.materialId;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["inventoryUnit"] = this.inventoryUnit;
        data["stockOpeningQunatity"] = this.stockOpeningQunatity;
        data["inventoryReciveQunatity"] = this.inventoryReciveQunatity;
        data["inventoryRawWast"] = this.inventoryRawWast;
        data["stockAdjustmentQuantity"] = this.stockAdjustmentQuantity;
        data["transferOutQuantity"] = this.transferOutQuantity;
        data["transferInQuantity"] = this.transferInQuantity;
        data["inventoryOrderQuantity"] = this.inventoryOrderQuantity;
        data["batchRecipeQuantity"] = this.batchRecipeQuantity;
        data["purshaseQuantity"] = this.purshaseQuantity;
        data["returnPurchaseQuantity"] = this.returnPurchaseQuantity;
        data["menuItemWasteQuantity"] = this.menuItemWasteQuantity;
        data["saleQuantity"] = this.saleQuantity;
        data["cost"] = this.cost;
        data["variantQuantity"] = this.variantQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["expectedQuantity"] = this.expectedQuantity;
        data["uomName"] = this.uomName;
        data["expectedBalance"] = this.expectedBalance;
        return data; 
    }
}

export interface IItemInventoryVarainceWithCost {
    currentCost: number;
    totalCost: number;
    materialId: number;
    materialCode: string;
    materialName: string;
    inventoryUnit: string;
    stockOpeningQunatity: string;
    inventoryReciveQunatity: number;
    inventoryRawWast: number;
    stockAdjustmentQuantity: number;
    transferOutQuantity: number;
    transferInQuantity: number;
    inventoryOrderQuantity: number;
    batchRecipeQuantity: number;
    purshaseQuantity: number;
    returnPurchaseQuantity: number;
    menuItemWasteQuantity: number;
    saleQuantity: number;
    cost: number;
    variantQuantity: string;
    actualQuantity: string;
    expectedQuantity: string;
    uomName: string;
    expectedBalance: number;
}

export class StoreRawWasteReportPage implements IStoreRawWasteReportPage {
    totalCount: number;
    totalRawWaste: number;
    totalCost: number;
    pageNumber: number;
    data: StoreRawWasteReportTenantGrouped[];

    constructor(data?: IStoreRawWasteReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.totalRawWaste = data["totalRawWaste"];
            this.totalCost = data["totalCost"];
            this.pageNumber = data["pageNumber"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreRawWasteReportTenantGrouped.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreRawWasteReportPage {
        let result = new StoreRawWasteReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["totalRawWaste"] = this.totalRawWaste;
        data["totalCost"] = this.totalCost;
        data["pageNumber"] = this.pageNumber;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreRawWasteReportPage {
    totalCount: number;
    totalRawWaste: number;
    totalCost: number;
    pageNumber: number;
    data: StoreRawWasteReportTenantGrouped[];
}

export class StoreRawWasteReportTenantGrouped implements IStoreRawWasteReportTenantGrouped {
    tenantName: string;
    gropedStores: StoreRawWasteReportListItemGrouped[];

    constructor(data?: IStoreRawWasteReportTenantGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["gropedStores"] && data["gropedStores"].constructor === Array) {
                this.gropedStores = [];
                for (let item of data["gropedStores"])
                    this.gropedStores.push(StoreRawWasteReportListItemGrouped.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreRawWasteReportTenantGrouped {
        let result = new StoreRawWasteReportTenantGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.gropedStores && this.gropedStores.constructor === Array) {
            data["gropedStores"] = [];
            for (let item of this.gropedStores)
                data["gropedStores"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreRawWasteReportTenantGrouped {
    tenantName: string;
    gropedStores: StoreRawWasteReportListItemGrouped[];
}

export class StoreRawWasteReportListItemGrouped implements IStoreRawWasteReportListItemGrouped {
    storeCode: string;
    storeName: string;
    storeid: number;
    totalCost: number;
    totalWasteQty: number;

    constructor(data?: IStoreRawWasteReportListItemGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.storeid = data["storeid"];
            this.totalCost = data["totalCost"];
            this.totalWasteQty = data["totalWasteQty"];
        }
    }

    static fromJS(data: any): StoreRawWasteReportListItemGrouped {
        let result = new StoreRawWasteReportListItemGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["storeid"] = this.storeid;
        data["totalCost"] = this.totalCost;
        data["totalWasteQty"] = this.totalWasteQty;
        return data; 
    }
}

export interface IStoreRawWasteReportListItemGrouped {
    storeCode: string;
    storeName: string;
    storeid: number;
    totalCost: number;
    totalWasteQty: number;
}

export class StoreRawWasteDetailReportPage implements IStoreRawWasteDetailReportPage {
    totalCount: number;
    pageNumber: number;
    data: StoreRawWasteReportListItem[];

    constructor(data?: IStoreRawWasteDetailReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreRawWasteReportListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreRawWasteDetailReportPage {
        let result = new StoreRawWasteDetailReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreRawWasteDetailReportPage {
    totalCount: number;
    pageNumber: number;
    data: StoreRawWasteReportListItem[];
}

export class StoreRawWasteReportListItem implements IStoreRawWasteReportListItem {
    date: moment.Moment;
    materialId: number;
    rawMaterialName: string;
    price: number;
    wasteQuantity: number;
    totalCost: number;
    uomName: string;
    notes: string;

    constructor(data?: IStoreRawWasteReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.materialId = data["materialId"];
            this.rawMaterialName = data["rawMaterialName"];
            this.price = data["price"];
            this.wasteQuantity = data["wasteQuantity"];
            this.totalCost = data["totalCost"];
            this.uomName = data["uomName"];
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): StoreRawWasteReportListItem {
        let result = new StoreRawWasteReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["materialId"] = this.materialId;
        data["rawMaterialName"] = this.rawMaterialName;
        data["price"] = this.price;
        data["wasteQuantity"] = this.wasteQuantity;
        data["totalCost"] = this.totalCost;
        data["uomName"] = this.uomName;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface IStoreRawWasteReportListItem {
    date: moment.Moment;
    materialId: number;
    rawMaterialName: string;
    price: number;
    wasteQuantity: number;
    totalCost: number;
    uomName: string;
    notes: string;
}

export class TenantBatchRecipePage implements ITenantBatchRecipePage {
    totalCount: number;
    pageNumber: number;
    data: TenantBatchRecipe[];

    constructor(data?: ITenantBatchRecipePage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(TenantBatchRecipe.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantBatchRecipePage {
        let result = new TenantBatchRecipePage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantBatchRecipePage {
    totalCount: number;
    pageNumber: number;
    data: TenantBatchRecipe[];
}

export class TenantBatchRecipe implements ITenantBatchRecipe {
    tenantName: string;
    storeBatchRecipes: StoreBatchRecipe[];

    constructor(data?: ITenantBatchRecipe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["storeBatchRecipes"] && data["storeBatchRecipes"].constructor === Array) {
                this.storeBatchRecipes = [];
                for (let item of data["storeBatchRecipes"])
                    this.storeBatchRecipes.push(StoreBatchRecipe.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantBatchRecipe {
        let result = new TenantBatchRecipe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.storeBatchRecipes && this.storeBatchRecipes.constructor === Array) {
            data["storeBatchRecipes"] = [];
            for (let item of this.storeBatchRecipes)
                data["storeBatchRecipes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantBatchRecipe {
    tenantName: string;
    storeBatchRecipes: StoreBatchRecipe[];
}

export class StoreBatchRecipe implements IStoreBatchRecipe {
    storeId: number;
    storeCode: string;
    storeName: string;
    batches: BatchRecipeReport[];

    constructor(data?: IStoreBatchRecipe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            if (data["batches"] && data["batches"].constructor === Array) {
                this.batches = [];
                for (let item of data["batches"])
                    this.batches.push(BatchRecipeReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreBatchRecipe {
        let result = new StoreBatchRecipe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        if (this.batches && this.batches.constructor === Array) {
            data["batches"] = [];
            for (let item of this.batches)
                data["batches"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreBatchRecipe {
    storeId: number;
    storeCode: string;
    storeName: string;
    batches: BatchRecipeReport[];
}

export class BatchRecipeReport implements IBatchRecipeReport {
    tenantName: string;
    storeId: number;
    storeCode: string;
    storeName: string;
    materialId: number;
    itemCode: string;
    materialName: string;
    producedQty: number;
    batchCount: number;

    constructor(data?: IBatchRecipeReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.storeId = data["storeId"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.materialId = data["materialId"];
            this.itemCode = data["itemCode"];
            this.materialName = data["materialName"];
            this.producedQty = data["producedQty"];
            this.batchCount = data["batchCount"];
        }
    }

    static fromJS(data: any): BatchRecipeReport {
        let result = new BatchRecipeReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["storeId"] = this.storeId;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["materialId"] = this.materialId;
        data["itemCode"] = this.itemCode;
        data["materialName"] = this.materialName;
        data["producedQty"] = this.producedQty;
        data["batchCount"] = this.batchCount;
        return data; 
    }
}

export interface IBatchRecipeReport {
    tenantName: string;
    storeId: number;
    storeCode: string;
    storeName: string;
    materialId: number;
    itemCode: string;
    materialName: string;
    producedQty: number;
    batchCount: number;
}

export class StoreBatchRecipDetailReportPage implements IStoreBatchRecipDetailReportPage {
    totalCount: number;
    pageNumber: number;
    data: StoreBatchRecipDetailItem[];

    constructor(data?: IStoreBatchRecipDetailReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreBatchRecipDetailItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreBatchRecipDetailReportPage {
        let result = new StoreBatchRecipDetailReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreBatchRecipDetailReportPage {
    totalCount: number;
    pageNumber: number;
    data: StoreBatchRecipDetailItem[];
}

export class StoreBatchRecipDetailItem implements IStoreBatchRecipDetailItem {
    itemCode: string;
    itemName: string;
    quantityUsed: number;
    recipeUnit: string;
    inventoryUnit: string;

    constructor(data?: IStoreBatchRecipDetailItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.quantityUsed = data["quantityUsed"];
            this.recipeUnit = data["recipeUnit"];
            this.inventoryUnit = data["inventoryUnit"];
        }
    }

    static fromJS(data: any): StoreBatchRecipDetailItem {
        let result = new StoreBatchRecipDetailItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["quantityUsed"] = this.quantityUsed;
        data["recipeUnit"] = this.recipeUnit;
        data["inventoryUnit"] = this.inventoryUnit;
        return data; 
    }
}

export interface IStoreBatchRecipDetailItem {
    itemCode: string;
    itemName: string;
    quantityUsed: number;
    recipeUnit: string;
    inventoryUnit: string;
}

export class StoreMenuItemWasteReportPage implements IStoreMenuItemWasteReportPage {
    totalCount: number;
    totalRawWaste: number;
    totalCost: number;
    pageNumber: number;
    data: StoreMenItemWasteReportTenantGrouped[];

    constructor(data?: IStoreMenuItemWasteReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.totalRawWaste = data["totalRawWaste"];
            this.totalCost = data["totalCost"];
            this.pageNumber = data["pageNumber"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreMenItemWasteReportTenantGrouped.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreMenuItemWasteReportPage {
        let result = new StoreMenuItemWasteReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["totalRawWaste"] = this.totalRawWaste;
        data["totalCost"] = this.totalCost;
        data["pageNumber"] = this.pageNumber;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreMenuItemWasteReportPage {
    totalCount: number;
    totalRawWaste: number;
    totalCost: number;
    pageNumber: number;
    data: StoreMenItemWasteReportTenantGrouped[];
}

export class StoreMenItemWasteReportTenantGrouped implements IStoreMenItemWasteReportTenantGrouped {
    tenantName: string;
    gropedStores: StoreMenuItemWasteReportListItemGrouped[];

    constructor(data?: IStoreMenItemWasteReportTenantGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["gropedStores"] && data["gropedStores"].constructor === Array) {
                this.gropedStores = [];
                for (let item of data["gropedStores"])
                    this.gropedStores.push(StoreMenuItemWasteReportListItemGrouped.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreMenItemWasteReportTenantGrouped {
        let result = new StoreMenItemWasteReportTenantGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.gropedStores && this.gropedStores.constructor === Array) {
            data["gropedStores"] = [];
            for (let item of this.gropedStores)
                data["gropedStores"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreMenItemWasteReportTenantGrouped {
    tenantName: string;
    gropedStores: StoreMenuItemWasteReportListItemGrouped[];
}

export class StoreMenuItemWasteReportListItemGrouped implements IStoreMenuItemWasteReportListItemGrouped {
    storeCode: string;
    storeName: string;
    storeid: number;
    totalCost: number;
    totalWasteQty: number;

    constructor(data?: IStoreMenuItemWasteReportListItemGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.storeid = data["storeid"];
            this.totalCost = data["totalCost"];
            this.totalWasteQty = data["totalWasteQty"];
        }
    }

    static fromJS(data: any): StoreMenuItemWasteReportListItemGrouped {
        let result = new StoreMenuItemWasteReportListItemGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["storeid"] = this.storeid;
        data["totalCost"] = this.totalCost;
        data["totalWasteQty"] = this.totalWasteQty;
        return data; 
    }
}

export interface IStoreMenuItemWasteReportListItemGrouped {
    storeCode: string;
    storeName: string;
    storeid: number;
    totalCost: number;
    totalWasteQty: number;
}

export class StoreMenuItemWastDetailReportPage implements IStoreMenuItemWastDetailReportPage {
    totalCount: number;
    pageNumber: number;
    data: StoreMenuItemWastReportListItem[];

    constructor(data?: IStoreMenuItemWastDetailReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreMenuItemWastReportListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreMenuItemWastDetailReportPage {
        let result = new StoreMenuItemWastDetailReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreMenuItemWastDetailReportPage {
    totalCount: number;
    pageNumber: number;
    data: StoreMenuItemWastReportListItem[];
}

export class StoreMenuItemWastReportListItem implements IStoreMenuItemWastReportListItem {
    date: string;
    menuItemId: number;
    menuItemName: string;
    price: number;
    wasteQuantity: number;
    totalCost: number;
    notes: string;

    constructor(data?: IStoreMenuItemWastReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.menuItemId = data["menuItemId"];
            this.menuItemName = data["menuItemName"];
            this.price = data["price"];
            this.wasteQuantity = data["wasteQuantity"];
            this.totalCost = data["totalCost"];
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): StoreMenuItemWastReportListItem {
        let result = new StoreMenuItemWastReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["menuItemId"] = this.menuItemId;
        data["menuItemName"] = this.menuItemName;
        data["price"] = this.price;
        data["wasteQuantity"] = this.wasteQuantity;
        data["totalCost"] = this.totalCost;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface IStoreMenuItemWastReportListItem {
    date: string;
    menuItemId: number;
    menuItemName: string;
    price: number;
    wasteQuantity: number;
    totalCost: number;
    notes: string;
}

export class StoreReceiveReportInput implements IStoreReceiveReportInput {
    tenantsIds: number[];
    sourceIds: number[];
    destinationIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    regionId: number;
    areaId: number;
    status: number;
    materialIds: number[];
    isCSVFile: boolean;

    constructor(data?: IStoreReceiveReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            if (data["sourceIds"] && data["sourceIds"].constructor === Array) {
                this.sourceIds = [];
                for (let item of data["sourceIds"])
                    this.sourceIds.push(item);
            }
            if (data["destinationIds"] && data["destinationIds"].constructor === Array) {
                this.destinationIds = [];
                for (let item of data["destinationIds"])
                    this.destinationIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.status = data["status"];
            if (data["materialIds"] && data["materialIds"].constructor === Array) {
                this.materialIds = [];
                for (let item of data["materialIds"])
                    this.materialIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): StoreReceiveReportInput {
        let result = new StoreReceiveReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        if (this.sourceIds && this.sourceIds.constructor === Array) {
            data["sourceIds"] = [];
            for (let item of this.sourceIds)
                data["sourceIds"].push(item);
        }
        if (this.destinationIds && this.destinationIds.constructor === Array) {
            data["destinationIds"] = [];
            for (let item of this.destinationIds)
                data["destinationIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["status"] = this.status;
        if (this.materialIds && this.materialIds.constructor === Array) {
            data["materialIds"] = [];
            for (let item of this.materialIds)
                data["materialIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IStoreReceiveReportInput {
    tenantsIds: number[];
    sourceIds: number[];
    destinationIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    regionId: number;
    areaId: number;
    status: number;
    materialIds: number[];
    isCSVFile: boolean;
}

export class StoreReceiveReportPage implements IStoreReceiveReportPage {
    data: StoreReceiveReportListItemGrouped[];
    totalCount: number;
    pageNumber: number;
    totalReceiveQty: number;
    totalReceiveCost: number;

    constructor(data?: IStoreReceiveReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreReceiveReportListItemGrouped.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalReceiveQty = data["totalReceiveQty"];
            this.totalReceiveCost = data["totalReceiveCost"];
        }
    }

    static fromJS(data: any): StoreReceiveReportPage {
        let result = new StoreReceiveReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalReceiveQty"] = this.totalReceiveQty;
        data["totalReceiveCost"] = this.totalReceiveCost;
        return data; 
    }
}

export interface IStoreReceiveReportPage {
    data: StoreReceiveReportListItemGrouped[];
    totalCount: number;
    pageNumber: number;
    totalReceiveQty: number;
    totalReceiveCost: number;
}

export class StoreReceiveReportListItemGrouped implements IStoreReceiveReportListItemGrouped {
    storeName: string;
    storesData: StoreReceiveReportListItem[];
    totalReceiveQty: number;
    totalReceiveCost: number;
    isSupplier: boolean;
    storeNumber: string;

    constructor(data?: IStoreReceiveReportListItemGrouped) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            if (data["storesData"] && data["storesData"].constructor === Array) {
                this.storesData = [];
                for (let item of data["storesData"])
                    this.storesData.push(StoreReceiveReportListItem.fromJS(item));
            }
            this.totalReceiveQty = data["totalReceiveQty"];
            this.totalReceiveCost = data["totalReceiveCost"];
            this.isSupplier = data["isSupplier"];
            this.storeNumber = data["storeNumber"];
        }
    }

    static fromJS(data: any): StoreReceiveReportListItemGrouped {
        let result = new StoreReceiveReportListItemGrouped();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        if (this.storesData && this.storesData.constructor === Array) {
            data["storesData"] = [];
            for (let item of this.storesData)
                data["storesData"].push(item.toJSON());
        }
        data["totalReceiveQty"] = this.totalReceiveQty;
        data["totalReceiveCost"] = this.totalReceiveCost;
        data["isSupplier"] = this.isSupplier;
        data["storeNumber"] = this.storeNumber;
        return data; 
    }
}

export interface IStoreReceiveReportListItemGrouped {
    storeName: string;
    storesData: StoreReceiveReportListItem[];
    totalReceiveQty: number;
    totalReceiveCost: number;
    isSupplier: boolean;
    storeNumber: string;
}

export class StoreReceiveReportListItem implements IStoreReceiveReportListItem {
    tenantName: string;
    fromStore: string;
    storeCode: string;
    storeName: string;
    rawMaterialName: string;
    puCost: number;
    receiveQty: number;
    unit: string;
    recipeQty: number;
    totalCost: number;
    date: moment.Moment;
    materialId: number;
    storeId: number;
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    received: boolean;
    receiveNumber: string;
    dateAsString: string;

    constructor(data?: IStoreReceiveReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.fromStore = data["fromStore"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.rawMaterialName = data["rawMaterialName"];
            this.puCost = data["puCost"];
            this.receiveQty = data["receiveQty"];
            this.unit = data["unit"];
            this.recipeQty = data["recipeQty"];
            this.totalCost = data["totalCost"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.materialId = data["materialId"];
            this.storeId = data["storeId"];
            this.isSupplier = data["isSupplier"];
            this.sourceStoreName = data["sourceStoreName"];
            this.sourceStoreCode = data["sourceStoreCode"];
            this.sourceStorId = data["sourceStorId"];
            this.received = data["received"];
            this.receiveNumber = data["receiveNumber"];
            this.dateAsString = data["dateAsString"];
        }
    }

    static fromJS(data: any): StoreReceiveReportListItem {
        let result = new StoreReceiveReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["fromStore"] = this.fromStore;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["rawMaterialName"] = this.rawMaterialName;
        data["puCost"] = this.puCost;
        data["receiveQty"] = this.receiveQty;
        data["unit"] = this.unit;
        data["recipeQty"] = this.recipeQty;
        data["totalCost"] = this.totalCost;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["materialId"] = this.materialId;
        data["storeId"] = this.storeId;
        data["isSupplier"] = this.isSupplier;
        data["sourceStoreName"] = this.sourceStoreName;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["sourceStorId"] = this.sourceStorId;
        data["received"] = this.received;
        data["receiveNumber"] = this.receiveNumber;
        data["dateAsString"] = this.dateAsString;
        return data; 
    }
}

export interface IStoreReceiveReportListItem {
    tenantName: string;
    fromStore: string;
    storeCode: string;
    storeName: string;
    rawMaterialName: string;
    puCost: number;
    receiveQty: number;
    unit: string;
    recipeQty: number;
    totalCost: number;
    date: moment.Moment;
    materialId: number;
    storeId: number;
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    received: boolean;
    receiveNumber: string;
    dateAsString: string;
}

export class StoreReceiveReportDetails implements IStoreReceiveReportDetails {
    data: StoreReceiveReportListItemDetail[];
    totalCount: number;
    pageNumber: number;

    constructor(data?: IStoreReceiveReportDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreReceiveReportListItemDetail.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
        }
    }

    static fromJS(data: any): StoreReceiveReportDetails {
        let result = new StoreReceiveReportDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        return data; 
    }
}

export interface IStoreReceiveReportDetails {
    data: StoreReceiveReportListItemDetail[];
    totalCount: number;
    pageNumber: number;
}

export class StoreReceiveReportListItemDetail implements IStoreReceiveReportListItemDetail {
    rawMaterialName: string;
    puCost: number;
    receiveQty: number;
    unitName: string;
    totalCost: number;
    date: moment.Moment;
    materialId: number;
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    received: boolean;
    receiveNumber: string;
    dateAsString: string;

    constructor(data?: IStoreReceiveReportListItemDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawMaterialName = data["rawMaterialName"];
            this.puCost = data["puCost"];
            this.receiveQty = data["receiveQty"];
            this.unitName = data["unitName"];
            this.totalCost = data["totalCost"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.materialId = data["materialId"];
            this.isSupplier = data["isSupplier"];
            this.sourceStoreName = data["sourceStoreName"];
            this.sourceStoreCode = data["sourceStoreCode"];
            this.sourceStorId = data["sourceStorId"];
            this.received = data["received"];
            this.receiveNumber = data["receiveNumber"];
            this.dateAsString = data["dateAsString"];
        }
    }

    static fromJS(data: any): StoreReceiveReportListItemDetail {
        let result = new StoreReceiveReportListItemDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialName"] = this.rawMaterialName;
        data["puCost"] = this.puCost;
        data["receiveQty"] = this.receiveQty;
        data["unitName"] = this.unitName;
        data["totalCost"] = this.totalCost;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["materialId"] = this.materialId;
        data["isSupplier"] = this.isSupplier;
        data["sourceStoreName"] = this.sourceStoreName;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["sourceStorId"] = this.sourceStorId;
        data["received"] = this.received;
        data["receiveNumber"] = this.receiveNumber;
        data["dateAsString"] = this.dateAsString;
        return data; 
    }
}

export interface IStoreReceiveReportListItemDetail {
    rawMaterialName: string;
    puCost: number;
    receiveQty: number;
    unitName: string;
    totalCost: number;
    date: moment.Moment;
    materialId: number;
    isSupplier: boolean;
    sourceStoreName: string;
    sourceStoreCode: string;
    sourceStorId: number;
    received: boolean;
    receiveNumber: string;
    dateAsString: string;
}

export class StoreReceiveReportPaged implements IStoreReceiveReportPaged {
    data: StoreReciveReportListItemGroupedPage[];
    totalCount: number;
    pageNumber: number;
    totalReceiveQty: number;
    totalReceiveCost: number;

    constructor(data?: IStoreReceiveReportPaged) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(StoreReciveReportListItemGroupedPage.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalReceiveQty = data["totalReceiveQty"];
            this.totalReceiveCost = data["totalReceiveCost"];
        }
    }

    static fromJS(data: any): StoreReceiveReportPaged {
        let result = new StoreReceiveReportPaged();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalReceiveQty"] = this.totalReceiveQty;
        data["totalReceiveCost"] = this.totalReceiveCost;
        return data; 
    }
}

export interface IStoreReceiveReportPaged {
    data: StoreReciveReportListItemGroupedPage[];
    totalCount: number;
    pageNumber: number;
    totalReceiveQty: number;
    totalReceiveCost: number;
}

export class StoreReciveReportListItemGroupedPage implements IStoreReciveReportListItemGroupedPage {
    tenantName: string;
    storesData: StoreReceiveReportListItemPage[];

    constructor(data?: IStoreReciveReportListItemGroupedPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["storesData"] && data["storesData"].constructor === Array) {
                this.storesData = [];
                for (let item of data["storesData"])
                    this.storesData.push(StoreReceiveReportListItemPage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreReciveReportListItemGroupedPage {
        let result = new StoreReciveReportListItemGroupedPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.storesData && this.storesData.constructor === Array) {
            data["storesData"] = [];
            for (let item of this.storesData)
                data["storesData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreReciveReportListItemGroupedPage {
    tenantName: string;
    storesData: StoreReceiveReportListItemPage[];
}

export class StoreReceiveReportListItemPage implements IStoreReceiveReportListItemPage {
    storeCode: string;
    storeName: string;
    puCost: number;
    receiveQty: number;
    totalCost: number;
    storeId: number;

    constructor(data?: IStoreReceiveReportListItemPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.puCost = data["puCost"];
            this.receiveQty = data["receiveQty"];
            this.totalCost = data["totalCost"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): StoreReceiveReportListItemPage {
        let result = new StoreReceiveReportListItemPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["puCost"] = this.puCost;
        data["receiveQty"] = this.receiveQty;
        data["totalCost"] = this.totalCost;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IStoreReceiveReportListItemPage {
    storeCode: string;
    storeName: string;
    puCost: number;
    receiveQty: number;
    totalCost: number;
    storeId: number;
}

export class ResponseModel implements IResponseModel {
    isSuccess: boolean;
    message: string;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ResponseModel {
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data; 
    }
}

export interface IResponseModel {
    isSuccess: boolean;
    message: string;
}

export class MainTransactionInput implements IMainTransactionInput {
    to: moment.Moment;
    from: moment.Moment;
    documentType: number;
    transactionId: number;
    storeIds: number[];
    destinationIds: number[];
    status: number;
    documentNumber: string;
    invoiceNumber: string;

    constructor(data?: IMainTransactionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.transactionId = data["transactionId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["destinationIds"] && data["destinationIds"].constructor === Array) {
                this.destinationIds = [];
                for (let item of data["destinationIds"])
                    this.destinationIds.push(item);
            }
            this.status = data["status"];
            this.documentNumber = data["documentNumber"];
            this.invoiceNumber = data["invoiceNumber"];
        }
    }

    static fromJS(data: any): MainTransactionInput {
        let result = new MainTransactionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["transactionId"] = this.transactionId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.destinationIds && this.destinationIds.constructor === Array) {
            data["destinationIds"] = [];
            for (let item of this.destinationIds)
                data["destinationIds"].push(item);
        }
        data["status"] = this.status;
        data["documentNumber"] = this.documentNumber;
        data["invoiceNumber"] = this.invoiceNumber;
        return data; 
    }
}

export interface IMainTransactionInput {
    to: moment.Moment;
    from: moment.Moment;
    documentType: number;
    transactionId: number;
    storeIds: number[];
    destinationIds: number[];
    status: number;
    documentNumber: string;
    invoiceNumber: string;
}

export class InvoiceDto implements IInvoiceDto {
    amount: number;
    editionDisplayName: string;
    invoiceNo: string;
    invoiceDate: moment.Moment;
    tenantLegalName: string;
    tenantAddress: string[];
    tenantTaxNo: string;
    hostLegalName: string;
    hostAddress: string[];

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (data["tenantAddress"] && data["tenantAddress"].constructor === Array) {
                this.tenantAddress = [];
                for (let item of data["tenantAddress"])
                    this.tenantAddress.push(item);
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (data["hostAddress"] && data["hostAddress"].constructor === Array) {
                this.hostAddress = [];
                for (let item of data["hostAddress"])
                    this.hostAddress.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (this.tenantAddress && this.tenantAddress.constructor === Array) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (this.hostAddress && this.hostAddress.constructor === Array) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data; 
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string;
    invoiceNo: string;
    invoiceDate: moment.Moment;
    tenantLegalName: string;
    tenantAddress: string[];
    tenantTaxNo: string;
    hostLegalName: string;
    hostAddress: string[];
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data; 
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class KIOSKWorkFlowPageDto implements IKIOSKWorkFlowPageDto {
    currentPage: number;
    itemsCount: number;
    workFlows: WorkFlowInfoDto[];

    constructor(data?: IKIOSKWorkFlowPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["workFlows"] && data["workFlows"].constructor === Array) {
                this.workFlows = [];
                for (let item of data["workFlows"])
                    this.workFlows.push(WorkFlowInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KIOSKWorkFlowPageDto {
        let result = new KIOSKWorkFlowPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.workFlows && this.workFlows.constructor === Array) {
            data["workFlows"] = [];
            for (let item of this.workFlows)
                data["workFlows"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IKIOSKWorkFlowPageDto {
    currentPage: number;
    itemsCount: number;
    workFlows: WorkFlowInfoDto[];
}

export class WorkFlowInfoDto implements IWorkFlowInfoDto {
    id: number;
    storeCode: string;
    storeName: string;
    numberOfSteps: number;

    constructor(data?: IWorkFlowInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.numberOfSteps = data["numberOfSteps"];
        }
    }

    static fromJS(data: any): WorkFlowInfoDto {
        let result = new WorkFlowInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["numberOfSteps"] = this.numberOfSteps;
        return data; 
    }
}

export interface IWorkFlowInfoDto {
    id: number;
    storeCode: string;
    storeName: string;
    numberOfSteps: number;
}

export class KIOSKWorkFlowDto implements IKIOSKWorkFlowDto {
    id: number;
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    kioskWorkFlowDetails: KIOSKWorkFlowDetailDto[];

    constructor(data?: IKIOSKWorkFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeId = data["storeId"];
            this.workFlowTypeId = data["workFlowTypeId"];
            this.deviceId = data["deviceId"];
            if (data["kioskWorkFlowDetails"] && data["kioskWorkFlowDetails"].constructor === Array) {
                this.kioskWorkFlowDetails = [];
                for (let item of data["kioskWorkFlowDetails"])
                    this.kioskWorkFlowDetails.push(KIOSKWorkFlowDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KIOSKWorkFlowDto {
        let result = new KIOSKWorkFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["workFlowTypeId"] = this.workFlowTypeId;
        data["deviceId"] = this.deviceId;
        if (this.kioskWorkFlowDetails && this.kioskWorkFlowDetails.constructor === Array) {
            data["kioskWorkFlowDetails"] = [];
            for (let item of this.kioskWorkFlowDetails)
                data["kioskWorkFlowDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IKIOSKWorkFlowDto {
    id: number;
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    kioskWorkFlowDetails: KIOSKWorkFlowDetailDto[];
}

export class KIOSKWorkFlowDetailDto implements IKIOSKWorkFlowDetailDto {
    id: number;
    workFlowStepId: number;
    kioskWorkFlowId: number;
    isActive: boolean;
    stepName: string;
    cashierId: number;
    kioskWorkFlowDetialDevices: number[];

    constructor(data?: IKIOSKWorkFlowDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.workFlowStepId = data["workFlowStepId"];
            this.kioskWorkFlowId = data["kioskWorkFlowId"];
            this.isActive = data["isActive"];
            this.stepName = data["stepName"];
            this.cashierId = data["cashierId"];
            if (data["kioskWorkFlowDetialDevices"] && data["kioskWorkFlowDetialDevices"].constructor === Array) {
                this.kioskWorkFlowDetialDevices = [];
                for (let item of data["kioskWorkFlowDetialDevices"])
                    this.kioskWorkFlowDetialDevices.push(item);
            }
        }
    }

    static fromJS(data: any): KIOSKWorkFlowDetailDto {
        let result = new KIOSKWorkFlowDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workFlowStepId"] = this.workFlowStepId;
        data["kioskWorkFlowId"] = this.kioskWorkFlowId;
        data["isActive"] = this.isActive;
        data["stepName"] = this.stepName;
        data["cashierId"] = this.cashierId;
        if (this.kioskWorkFlowDetialDevices && this.kioskWorkFlowDetialDevices.constructor === Array) {
            data["kioskWorkFlowDetialDevices"] = [];
            for (let item of this.kioskWorkFlowDetialDevices)
                data["kioskWorkFlowDetialDevices"].push(item);
        }
        return data; 
    }
}

export interface IKIOSKWorkFlowDetailDto {
    id: number;
    workFlowStepId: number;
    kioskWorkFlowId: number;
    isActive: boolean;
    stepName: string;
    cashierId: number;
    kioskWorkFlowDetialDevices: number[];
}

export class CreateKIOSKWorkFlowInput implements ICreateKIOSKWorkFlowInput {
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    kioskWorkFlowDetails: KIOSKWorkFlowDetailDto[];

    constructor(data?: ICreateKIOSKWorkFlowInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.workFlowTypeId = data["workFlowTypeId"];
            this.deviceId = data["deviceId"];
            if (data["kioskWorkFlowDetails"] && data["kioskWorkFlowDetails"].constructor === Array) {
                this.kioskWorkFlowDetails = [];
                for (let item of data["kioskWorkFlowDetails"])
                    this.kioskWorkFlowDetails.push(KIOSKWorkFlowDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKIOSKWorkFlowInput {
        let result = new CreateKIOSKWorkFlowInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["workFlowTypeId"] = this.workFlowTypeId;
        data["deviceId"] = this.deviceId;
        if (this.kioskWorkFlowDetails && this.kioskWorkFlowDetails.constructor === Array) {
            data["kioskWorkFlowDetails"] = [];
            for (let item of this.kioskWorkFlowDetails)
                data["kioskWorkFlowDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateKIOSKWorkFlowInput {
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    kioskWorkFlowDetails: KIOSKWorkFlowDetailDto[];
}

export class UpdateKIOSKWorkFlowInput implements IUpdateKIOSKWorkFlowInput {
    id: number;
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    kioskWorkFlowDetails: KIOSKWorkFlowDetailDto[];

    constructor(data?: IUpdateKIOSKWorkFlowInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeId = data["storeId"];
            this.workFlowTypeId = data["workFlowTypeId"];
            this.deviceId = data["deviceId"];
            if (data["kioskWorkFlowDetails"] && data["kioskWorkFlowDetails"].constructor === Array) {
                this.kioskWorkFlowDetails = [];
                for (let item of data["kioskWorkFlowDetails"])
                    this.kioskWorkFlowDetails.push(KIOSKWorkFlowDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateKIOSKWorkFlowInput {
        let result = new UpdateKIOSKWorkFlowInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["workFlowTypeId"] = this.workFlowTypeId;
        data["deviceId"] = this.deviceId;
        if (this.kioskWorkFlowDetails && this.kioskWorkFlowDetails.constructor === Array) {
            data["kioskWorkFlowDetails"] = [];
            for (let item of this.kioskWorkFlowDetails)
                data["kioskWorkFlowDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateKIOSKWorkFlowInput {
    id: number;
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    kioskWorkFlowDetails: KIOSKWorkFlowDetailDto[];
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[];
    flags: ComboboxItemDto[];

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : <any>undefined;
            if (data["languageNames"] && data["languageNames"].constructor === Array) {
                this.languageNames = [];
                for (let item of data["languageNames"])
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (data["flags"] && data["flags"].constructor === Array) {
                this.flags = [];
                for (let item of data["flags"])
                    this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (this.languageNames && this.languageNames.constructor === Array) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (this.flags && this.flags.constructor === Array) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[];
    flags: ComboboxItemDto[];
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id: number;
    name: string;
    icon: string;
    isEnabled: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface IApplicationLanguageEditDto {
    id: number;
    name: string;
    icon: string;
    isEnabled: boolean;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string;
    displayText: string;
    isSelected: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IComboboxItemDto {
    value: string;
    displayText: string;
    isSelected: boolean;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto = new ApplicationLanguageEditDto();

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[];

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[];
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key: string;
    baseValue: string;
    targetValue: string;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data; 
    }
}

export interface ILanguageTextListDto {
    key: string;
    baseValue: string;
    targetValue: string;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class PagedLevelsList implements IPagedLevelsList {
    currentPage: number;
    itemsCount: number;
    levels: LevelListItem[];

    constructor(data?: IPagedLevelsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["levels"] && data["levels"].constructor === Array) {
                this.levels = [];
                for (let item of data["levels"])
                    this.levels.push(LevelListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedLevelsList {
        let result = new PagedLevelsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.levels && this.levels.constructor === Array) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedLevelsList {
    currentPage: number;
    itemsCount: number;
    levels: LevelListItem[];
}

export class LevelListItem implements ILevelListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: ILevelListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): LevelListItem {
        let result = new LevelListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface ILevelListItem {
    id: number;
    name: string;
    code: string;
}

export class CreateLevelInput implements ICreateLevelInput {
    code: string;
    translations: LevelTranslationDto[];
    categoriesId: number[];

    constructor(data?: ICreateLevelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(LevelTranslationDto.fromJS(item));
            }
            if (data["categoriesId"] && data["categoriesId"].constructor === Array) {
                this.categoriesId = [];
                for (let item of data["categoriesId"])
                    this.categoriesId.push(item);
            }
        }
    }

    static fromJS(data: any): CreateLevelInput {
        let result = new CreateLevelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.categoriesId && this.categoriesId.constructor === Array) {
            data["categoriesId"] = [];
            for (let item of this.categoriesId)
                data["categoriesId"].push(item);
        }
        return data; 
    }
}

export interface ICreateLevelInput {
    code: string;
    translations: LevelTranslationDto[];
    categoriesId: number[];
}

export class LevelTranslationDto implements ILevelTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ILevelTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): LevelTranslationDto {
        let result = new LevelTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ILevelTranslationDto {
    name: string;
    languageId: number;
}

export class LevelDto implements ILevelDto {
    code: string;
    translations: LevelTranslationDto[];
    imageSrcUrl: string;
    categoriesId: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ILevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(LevelTranslationDto.fromJS(item));
            }
            this.imageSrcUrl = data["imageSrcUrl"];
            if (data["categoriesId"] && data["categoriesId"].constructor === Array) {
                this.categoriesId = [];
                for (let item of data["categoriesId"])
                    this.categoriesId.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LevelDto {
        let result = new LevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["imageSrcUrl"] = this.imageSrcUrl;
        if (this.categoriesId && this.categoriesId.constructor === Array) {
            data["categoriesId"] = [];
            for (let item of this.categoriesId)
                data["categoriesId"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILevelDto {
    code: string;
    translations: LevelTranslationDto[];
    imageSrcUrl: string;
    categoriesId: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfLevelListItem implements IListResultDtoOfLevelListItem {
    items: LevelListItem[];

    constructor(data?: IListResultDtoOfLevelListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LevelListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLevelListItem {
        let result = new ListResultDtoOfLevelListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLevelListItem {
    items: LevelListItem[];
}

export class ListResultDtoOfLevelItem implements IListResultDtoOfLevelItem {
    items: LevelItem[];

    constructor(data?: IListResultDtoOfLevelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LevelItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLevelItem {
        let result = new ListResultDtoOfLevelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLevelItem {
    items: LevelItem[];
}

export class LevelItem implements ILevelItem {
    id: number;
    name: string;
    code: string;
    productCategoriesIds: number[];

    constructor(data?: ILevelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
            if (data["productCategoriesIds"] && data["productCategoriesIds"].constructor === Array) {
                this.productCategoriesIds = [];
                for (let item of data["productCategoriesIds"])
                    this.productCategoriesIds.push(item);
            }
        }
    }

    static fromJS(data: any): LevelItem {
        let result = new LevelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        if (this.productCategoriesIds && this.productCategoriesIds.constructor === Array) {
            data["productCategoriesIds"] = [];
            for (let item of this.productCategoriesIds)
                data["productCategoriesIds"].push(item);
        }
        return data; 
    }
}

export interface ILevelItem {
    id: number;
    name: string;
    code: string;
    productCategoriesIds: number[];
}

export class UpdateLevelInput implements IUpdateLevelInput {
    categoriesId: number[];
    id: number;
    code: string;
    translations: LevelTranslationDto[];

    constructor(data?: IUpdateLevelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categoriesId"] && data["categoriesId"].constructor === Array) {
                this.categoriesId = [];
                for (let item of data["categoriesId"])
                    this.categoriesId.push(item);
            }
            this.id = data["id"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(LevelTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateLevelInput {
        let result = new UpdateLevelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categoriesId && this.categoriesId.constructor === Array) {
            data["categoriesId"] = [];
            for (let item of this.categoriesId)
                data["categoriesId"].push(item);
        }
        data["id"] = this.id;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateLevelInput {
    categoriesId: number[];
    id: number;
    code: string;
    translations: LevelTranslationDto[];
}

export class CreateAccountInput implements ICreateAccountInput {
    accountName: string;
    customers: CustomerListItem[];

    constructor(data?: ICreateAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountName = data["accountName"];
            if (data["customers"] && data["customers"].constructor === Array) {
                this.customers = [];
                for (let item of data["customers"])
                    this.customers.push(CustomerListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAccountInput {
        let result = new CreateAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        if (this.customers && this.customers.constructor === Array) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateAccountInput {
    accountName: string;
    customers: CustomerListItem[];
}

export class UpdateAccountInput implements IUpdateAccountInput {
    id: string;
    accountName: string;
    customers: CustomerListItem[];

    constructor(data?: IUpdateAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.accountName = data["accountName"];
            if (data["customers"] && data["customers"].constructor === Array) {
                this.customers = [];
                for (let item of data["customers"])
                    this.customers.push(CustomerListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAccountInput {
        let result = new UpdateAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        if (this.customers && this.customers.constructor === Array) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateAccountInput {
    id: string;
    accountName: string;
    customers: CustomerListItem[];
}

export class PagedAccountList implements IPagedAccountList {
    currentPage: number;
    itemsCount: number;
    accounts: AccountDto[];

    constructor(data?: IPagedAccountList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["accounts"] && data["accounts"].constructor === Array) {
                this.accounts = [];
                for (let item of data["accounts"])
                    this.accounts.push(AccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedAccountList {
        let result = new PagedAccountList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.accounts && this.accounts.constructor === Array) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedAccountList {
    currentPage: number;
    itemsCount: number;
    accounts: AccountDto[];
}

export class AccountDto implements IAccountDto {
    id: string;
    accountName: string;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.accountName = data["accountName"];
        }
    }

    static fromJS(data: any): AccountDto {
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        return data; 
    }
}

export interface IAccountDto {
    id: string;
    accountName: string;
}

export class SchemaDto implements ISchemaDto {
    id: number;
    name: string;
    clubName: string;
    clubId: number;
    minPoints: number;
    maxPoints: number;
    pointUser: number;
    moneySystem: number;
    moneyUser: number;
    pointSystem: number;
    pointExpirationDays: number;
    activeDays: number;

    constructor(data?: ISchemaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.clubName = data["clubName"];
            this.clubId = data["clubId"];
            this.minPoints = data["minPoints"];
            this.maxPoints = data["maxPoints"];
            this.pointUser = data["pointUser"];
            this.moneySystem = data["moneySystem"];
            this.moneyUser = data["moneyUser"];
            this.pointSystem = data["pointSystem"];
            this.pointExpirationDays = data["pointExpirationDays"];
            this.activeDays = data["activeDays"];
        }
    }

    static fromJS(data: any): SchemaDto {
        let result = new SchemaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["clubName"] = this.clubName;
        data["clubId"] = this.clubId;
        data["minPoints"] = this.minPoints;
        data["maxPoints"] = this.maxPoints;
        data["pointUser"] = this.pointUser;
        data["moneySystem"] = this.moneySystem;
        data["moneyUser"] = this.moneyUser;
        data["pointSystem"] = this.pointSystem;
        data["pointExpirationDays"] = this.pointExpirationDays;
        data["activeDays"] = this.activeDays;
        return data; 
    }
}

export interface ISchemaDto {
    id: number;
    name: string;
    clubName: string;
    clubId: number;
    minPoints: number;
    maxPoints: number;
    pointUser: number;
    moneySystem: number;
    moneyUser: number;
    pointSystem: number;
    pointExpirationDays: number;
    activeDays: number;
}

export class AccountPointDto implements IAccountPointDto {
    id: string;
    points: number;

    constructor(data?: IAccountPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.points = data["points"];
        }
    }

    static fromJS(data: any): AccountPointDto {
        let result = new AccountPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["points"] = this.points;
        return data; 
    }
}

export interface IAccountPointDto {
    id: string;
    points: number;
}

export class LoyaltyQrKeysDto implements ILoyaltyQrKeysDto {
    thirdPartyIntegrationId: number;
    aesKey: string;
    aesIv: string;

    constructor(data?: ILoyaltyQrKeysDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.thirdPartyIntegrationId = data["thirdPartyIntegrationId"];
            this.aesKey = data["aesKey"];
            this.aesIv = data["aesIv"];
        }
    }

    static fromJS(data: any): LoyaltyQrKeysDto {
        let result = new LoyaltyQrKeysDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thirdPartyIntegrationId"] = this.thirdPartyIntegrationId;
        data["aesKey"] = this.aesKey;
        data["aesIv"] = this.aesIv;
        return data; 
    }
}

export interface ILoyaltyQrKeysDto {
    thirdPartyIntegrationId: number;
    aesKey: string;
    aesIv: string;
}

export class LoyaltyQrKeysInput implements ILoyaltyQrKeysInput {
    thirdPartyIntegrationId: number;
    aesKey: string;
    aesIv: string;

    constructor(data?: ILoyaltyQrKeysInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.thirdPartyIntegrationId = data["thirdPartyIntegrationId"];
            this.aesKey = data["aesKey"];
            this.aesIv = data["aesIv"];
        }
    }

    static fromJS(data: any): LoyaltyQrKeysInput {
        let result = new LoyaltyQrKeysInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thirdPartyIntegrationId"] = this.thirdPartyIntegrationId;
        data["aesKey"] = this.aesKey;
        data["aesIv"] = this.aesIv;
        return data; 
    }
}

export interface ILoyaltyQrKeysInput {
    thirdPartyIntegrationId: number;
    aesKey: string;
    aesIv: string;
}

export class PageDetailTransactionsList implements IPageDetailTransactionsList {
    currentPage: number;
    itemsCount: number;
    detailTransactions: DetailTransaction[];

    constructor(data?: IPageDetailTransactionsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageDetailTransactionsList {
        let result = new PageDetailTransactionsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPageDetailTransactionsList {
    currentPage: number;
    itemsCount: number;
    detailTransactions: DetailTransaction[];
}

export class IntegrationPagedMainTransactionListDto implements IIntegrationPagedMainTransactionListDto {
    currentPage: number;
    itemsCount: number;
    mainTransactions: MainTransactionItemIntegrationDto[];

    constructor(data?: IIntegrationPagedMainTransactionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["mainTransactions"] && data["mainTransactions"].constructor === Array) {
                this.mainTransactions = [];
                for (let item of data["mainTransactions"])
                    this.mainTransactions.push(MainTransactionItemIntegrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntegrationPagedMainTransactionListDto {
        let result = new IntegrationPagedMainTransactionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.mainTransactions && this.mainTransactions.constructor === Array) {
            data["mainTransactions"] = [];
            for (let item of this.mainTransactions)
                data["mainTransactions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIntegrationPagedMainTransactionListDto {
    currentPage: number;
    itemsCount: number;
    mainTransactions: MainTransactionItemIntegrationDto[];
}

export class MainTransactionItemIntegrationDto implements IMainTransactionItemIntegrationDto {
    id: number;
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    fromStoreName: string;
    toStoreName: string;
    fromStoreCode: string;
    toStoreCode: string;
    date: moment.Moment;
    dateStockOpening: string;
    code: string;
    isRevision: number;
    supplierId: number;
    transactionTypeId: number;
    transactionTypeLocalized: string;
    transactionTypeValue: number;
    receiveNumber: string;
    transactionTemplateId: number;
    parentId: number;
    saleTypeId: number;
    menuItemId: number;
    tenantId: number;
    status: number;
    statusLocalized: string;
    totalCost: number;
    notes: string;
    documentNumber: string;
    detailTransactions: DetailTransactionIntegrationDto[];

    constructor(data?: IMainTransactionItemIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.mainTransactionId = data["mainTransactionId"];
            this.fromStoreId = data["fromStoreId"];
            this.toStoreId = data["toStoreId"];
            this.fromStoreName = data["fromStoreName"];
            this.toStoreName = data["toStoreName"];
            this.fromStoreCode = data["fromStoreCode"];
            this.toStoreCode = data["toStoreCode"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.dateStockOpening = data["dateStockOpening"];
            this.code = data["code"];
            this.isRevision = data["isRevision"];
            this.supplierId = data["supplierId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.transactionTypeLocalized = data["transactionTypeLocalized"];
            this.transactionTypeValue = data["transactionTypeValue"];
            this.receiveNumber = data["receiveNumber"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.parentId = data["parentId"];
            this.saleTypeId = data["saleTypeId"];
            this.menuItemId = data["menuItemId"];
            this.tenantId = data["tenantId"];
            this.status = data["status"];
            this.statusLocalized = data["statusLocalized"];
            this.totalCost = data["totalCost"];
            this.notes = data["notes"];
            this.documentNumber = data["documentNumber"];
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransactionIntegrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MainTransactionItemIntegrationDto {
        let result = new MainTransactionItemIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mainTransactionId"] = this.mainTransactionId;
        data["fromStoreId"] = this.fromStoreId;
        data["toStoreId"] = this.toStoreId;
        data["fromStoreName"] = this.fromStoreName;
        data["toStoreName"] = this.toStoreName;
        data["fromStoreCode"] = this.fromStoreCode;
        data["toStoreCode"] = this.toStoreCode;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateStockOpening"] = this.dateStockOpening;
        data["code"] = this.code;
        data["isRevision"] = this.isRevision;
        data["supplierId"] = this.supplierId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionTypeLocalized"] = this.transactionTypeLocalized;
        data["transactionTypeValue"] = this.transactionTypeValue;
        data["receiveNumber"] = this.receiveNumber;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["parentId"] = this.parentId;
        data["saleTypeId"] = this.saleTypeId;
        data["menuItemId"] = this.menuItemId;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["statusLocalized"] = this.statusLocalized;
        data["totalCost"] = this.totalCost;
        data["notes"] = this.notes;
        data["documentNumber"] = this.documentNumber;
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMainTransactionItemIntegrationDto {
    id: number;
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    fromStoreName: string;
    toStoreName: string;
    fromStoreCode: string;
    toStoreCode: string;
    date: moment.Moment;
    dateStockOpening: string;
    code: string;
    isRevision: number;
    supplierId: number;
    transactionTypeId: number;
    transactionTypeLocalized: string;
    transactionTypeValue: number;
    receiveNumber: string;
    transactionTemplateId: number;
    parentId: number;
    saleTypeId: number;
    menuItemId: number;
    tenantId: number;
    status: number;
    statusLocalized: string;
    totalCost: number;
    notes: string;
    documentNumber: string;
    detailTransactions: DetailTransactionIntegrationDto[];
}

export class DetailTransactionIntegrationDto implements IDetailTransactionIntegrationDto {
    id: number;
    transactionId: number;
    mainTransactionId: number;
    materialBarCode: string;
    materialId: number;
    materialName: string;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    qty: number;
    price: number;
    qtyReceive: number;
    restQunatity: number;
    discount: number;
    tax: number;
    notes: string;
    dueDate: moment.Moment;
    taxId: number;
    netAfterVat: number;
    itemCost: DetailTransactionIntegrationDtoItemCost;
    unitType: DetailTransactionIntegrationDtoUnitType;

    constructor(data?: IDetailTransactionIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.transactionId = data["transactionId"];
            this.mainTransactionId = data["mainTransactionId"];
            this.materialBarCode = data["materialBarCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.qty = data["qty"];
            this.price = data["price"];
            this.qtyReceive = data["qtyReceive"];
            this.restQunatity = data["restQunatity"];
            this.discount = data["discount"];
            this.tax = data["tax"];
            this.notes = data["notes"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.taxId = data["taxId"];
            this.netAfterVat = data["netAfterVat"];
            this.itemCost = data["itemCost"];
            this.unitType = data["unitType"];
        }
    }

    static fromJS(data: any): DetailTransactionIntegrationDto {
        let result = new DetailTransactionIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionId"] = this.transactionId;
        data["mainTransactionId"] = this.mainTransactionId;
        data["materialBarCode"] = this.materialBarCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["qtyReceive"] = this.qtyReceive;
        data["restQunatity"] = this.restQunatity;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["notes"] = this.notes;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["taxId"] = this.taxId;
        data["netAfterVat"] = this.netAfterVat;
        data["itemCost"] = this.itemCost;
        data["unitType"] = this.unitType;
        return data; 
    }
}

export interface IDetailTransactionIntegrationDto {
    id: number;
    transactionId: number;
    mainTransactionId: number;
    materialBarCode: string;
    materialId: number;
    materialName: string;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    qty: number;
    price: number;
    qtyReceive: number;
    restQunatity: number;
    discount: number;
    tax: number;
    notes: string;
    dueDate: moment.Moment;
    taxId: number;
    netAfterVat: number;
    itemCost: DetailTransactionIntegrationDtoItemCost;
    unitType: DetailTransactionIntegrationDtoUnitType;
}

export class InventoryRevisionInput implements IInventoryRevisionInput {
    to: moment.Moment;
    from: moment.Moment;
    fromStore: number;
    toStore: number;

    constructor(data?: IInventoryRevisionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.fromStore = data["fromStore"];
            this.toStore = data["toStore"];
        }
    }

    static fromJS(data: any): InventoryRevisionInput {
        let result = new InventoryRevisionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["fromStore"] = this.fromStore;
        data["toStore"] = this.toStore;
        return data; 
    }
}

export interface IInventoryRevisionInput {
    to: moment.Moment;
    from: moment.Moment;
    fromStore: number;
    toStore: number;
}

export class ListResultDtoOfMaterialListItem implements IListResultDtoOfMaterialListItem {
    items: MaterialListItem[];

    constructor(data?: IListResultDtoOfMaterialListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MaterialListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMaterialListItem {
        let result = new ListResultDtoOfMaterialListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMaterialListItem {
    items: MaterialListItem[];
}

export class MaterialListItem implements IMaterialListItem {
    id: number;
    name: string;
    hasDueDate: boolean;
    sellingPrice: number;
    reOrderLevel: number;
    stockQtyFrom: number;
    stockQtyTo: number;
    barCode: string;
    materialGroupName: string;
    periodName: string;
    itemCost: MaterialListItemItemCost;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureName: string;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    purchaseUnitOfMeasureId: number;

    constructor(data?: IMaterialListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.hasDueDate = data["hasDueDate"];
            this.sellingPrice = data["sellingPrice"];
            this.reOrderLevel = data["reOrderLevel"];
            this.stockQtyFrom = data["stockQtyFrom"];
            this.stockQtyTo = data["stockQtyTo"];
            this.barCode = data["barCode"];
            this.materialGroupName = data["materialGroupName"];
            this.periodName = data["periodName"];
            this.itemCost = data["itemCost"];
            this.inventoryUnitOfMeasureName = data["inventoryUnitOfMeasureName"];
            this.productUnitOfMeasureName = data["productUnitOfMeasureName"];
            this.purchaseUnitOfMeasureName = data["purchaseUnitOfMeasureName"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
        }
    }

    static fromJS(data: any): MaterialListItem {
        let result = new MaterialListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hasDueDate"] = this.hasDueDate;
        data["sellingPrice"] = this.sellingPrice;
        data["reOrderLevel"] = this.reOrderLevel;
        data["stockQtyFrom"] = this.stockQtyFrom;
        data["stockQtyTo"] = this.stockQtyTo;
        data["barCode"] = this.barCode;
        data["materialGroupName"] = this.materialGroupName;
        data["periodName"] = this.periodName;
        data["itemCost"] = this.itemCost;
        data["inventoryUnitOfMeasureName"] = this.inventoryUnitOfMeasureName;
        data["productUnitOfMeasureName"] = this.productUnitOfMeasureName;
        data["purchaseUnitOfMeasureName"] = this.purchaseUnitOfMeasureName;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        return data; 
    }
}

export interface IMaterialListItem {
    id: number;
    name: string;
    hasDueDate: boolean;
    sellingPrice: number;
    reOrderLevel: number;
    stockQtyFrom: number;
    stockQtyTo: number;
    barCode: string;
    materialGroupName: string;
    periodName: string;
    itemCost: MaterialListItemItemCost;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureName: string;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    purchaseUnitOfMeasureId: number;
}

export class ListResultDtoOfProductListItem implements IListResultDtoOfProductListItem {
    items: ProductListItem[];

    constructor(data?: IListResultDtoOfProductListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProductListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProductListItem {
        let result = new ListResultDtoOfProductListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProductListItem {
    items: ProductListItem[];
}

export class ListResultDtoOfReceiveNumberListItem implements IListResultDtoOfReceiveNumberListItem {
    items: ReceiveNumberListItem[];

    constructor(data?: IListResultDtoOfReceiveNumberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReceiveNumberListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfReceiveNumberListItem {
        let result = new ListResultDtoOfReceiveNumberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfReceiveNumberListItem {
    items: ReceiveNumberListItem[];
}

export class ReceiveNumberListItem implements IReceiveNumberListItem {
    id: number;
    receiveNumber: string;

    constructor(data?: IReceiveNumberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.receiveNumber = data["receiveNumber"];
        }
    }

    static fromJS(data: any): ReceiveNumberListItem {
        let result = new ReceiveNumberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receiveNumber"] = this.receiveNumber;
        return data; 
    }
}

export interface IReceiveNumberListItem {
    id: number;
    receiveNumber: string;
}

export class StockValuesReportInput implements IStockValuesReportInput {
    products: number[];
    categories: number[];
    referenceNumberORCode: string;
    showrawMaterialNumber: boolean;
    nameOrCode: string;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: IStockValuesReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(item);
            }
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(item);
            }
            this.referenceNumberORCode = data["referenceNumberORCode"];
            this.showrawMaterialNumber = data["showrawMaterialNumber"];
            this.nameOrCode = data["nameOrCode"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): StockValuesReportInput {
        let result = new StockValuesReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        data["referenceNumberORCode"] = this.referenceNumberORCode;
        data["showrawMaterialNumber"] = this.showrawMaterialNumber;
        data["nameOrCode"] = this.nameOrCode;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IStockValuesReportInput {
    products: number[];
    categories: number[];
    referenceNumberORCode: string;
    showrawMaterialNumber: boolean;
    nameOrCode: string;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
}

export class StockOnHandPagedDto implements IStockOnHandPagedDto {
    currentPage: number;
    itemsCount: number;
    totalExpectedQuantity: number;
    items: MaterialStockDto[];

    constructor(data?: IStockOnHandPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.totalExpectedQuantity = data["totalExpectedQuantity"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MaterialStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockOnHandPagedDto {
        let result = new StockOnHandPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["totalExpectedQuantity"] = this.totalExpectedQuantity;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockOnHandPagedDto {
    currentPage: number;
    itemsCount: number;
    totalExpectedQuantity: number;
    items: MaterialStockDto[];
}

export class MainTransactionSettingsDto implements IMainTransactionSettingsDto {
    mainTransactionSettingsId: number;
    tenantId: number;
    stockOpeningBalanceDelete: number;
    inventoryReceiveDelete: number;
    inventoryOrderDelete: number;
    inventoryRawWasteDelete: number;
    menuItemWasteDelete: number;
    stockadjustmentDelete: number;
    inventoryTransferDelete: number;
    batchRecipeDelete: number;
    isStockType: boolean;
    isCreditType: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMainTransactionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mainTransactionSettingsId = data["mainTransactionSettingsId"];
            this.tenantId = data["tenantId"];
            this.stockOpeningBalanceDelete = data["stockOpeningBalanceDelete"];
            this.inventoryReceiveDelete = data["inventoryReceiveDelete"];
            this.inventoryOrderDelete = data["inventoryOrderDelete"];
            this.inventoryRawWasteDelete = data["inventoryRawWasteDelete"];
            this.menuItemWasteDelete = data["menuItemWasteDelete"];
            this.stockadjustmentDelete = data["stockadjustmentDelete"];
            this.inventoryTransferDelete = data["inventoryTransferDelete"];
            this.batchRecipeDelete = data["batchRecipeDelete"];
            this.isStockType = data["isStockType"];
            this.isCreditType = data["isCreditType"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MainTransactionSettingsDto {
        let result = new MainTransactionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainTransactionSettingsId"] = this.mainTransactionSettingsId;
        data["tenantId"] = this.tenantId;
        data["stockOpeningBalanceDelete"] = this.stockOpeningBalanceDelete;
        data["inventoryReceiveDelete"] = this.inventoryReceiveDelete;
        data["inventoryOrderDelete"] = this.inventoryOrderDelete;
        data["inventoryRawWasteDelete"] = this.inventoryRawWasteDelete;
        data["menuItemWasteDelete"] = this.menuItemWasteDelete;
        data["stockadjustmentDelete"] = this.stockadjustmentDelete;
        data["inventoryTransferDelete"] = this.inventoryTransferDelete;
        data["batchRecipeDelete"] = this.batchRecipeDelete;
        data["isStockType"] = this.isStockType;
        data["isCreditType"] = this.isCreditType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMainTransactionSettingsDto {
    mainTransactionSettingsId: number;
    tenantId: number;
    stockOpeningBalanceDelete: number;
    inventoryReceiveDelete: number;
    inventoryOrderDelete: number;
    inventoryRawWasteDelete: number;
    menuItemWasteDelete: number;
    stockadjustmentDelete: number;
    inventoryTransferDelete: number;
    batchRecipeDelete: number;
    isStockType: boolean;
    isCreditType: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreateMainTransactionSettingsInput implements ICreateMainTransactionSettingsInput {
    tenantId: number;
    stockOpeningBalanceDelete: number;
    inventoryReceiveDelete: number;
    inventoryOrderDelete: number;
    inventoryRawWasteDelete: number;
    menuItemWasteDelete: number;
    stockadjustmentDelete: number;
    inventoryTransferDelete: number;
    batchRecipeDelete: number;
    isStockType: boolean;
    isCreditType: boolean;

    constructor(data?: ICreateMainTransactionSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.stockOpeningBalanceDelete = data["stockOpeningBalanceDelete"];
            this.inventoryReceiveDelete = data["inventoryReceiveDelete"];
            this.inventoryOrderDelete = data["inventoryOrderDelete"];
            this.inventoryRawWasteDelete = data["inventoryRawWasteDelete"];
            this.menuItemWasteDelete = data["menuItemWasteDelete"];
            this.stockadjustmentDelete = data["stockadjustmentDelete"];
            this.inventoryTransferDelete = data["inventoryTransferDelete"];
            this.batchRecipeDelete = data["batchRecipeDelete"];
            this.isStockType = data["isStockType"];
            this.isCreditType = data["isCreditType"];
        }
    }

    static fromJS(data: any): CreateMainTransactionSettingsInput {
        let result = new CreateMainTransactionSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["stockOpeningBalanceDelete"] = this.stockOpeningBalanceDelete;
        data["inventoryReceiveDelete"] = this.inventoryReceiveDelete;
        data["inventoryOrderDelete"] = this.inventoryOrderDelete;
        data["inventoryRawWasteDelete"] = this.inventoryRawWasteDelete;
        data["menuItemWasteDelete"] = this.menuItemWasteDelete;
        data["stockadjustmentDelete"] = this.stockadjustmentDelete;
        data["inventoryTransferDelete"] = this.inventoryTransferDelete;
        data["batchRecipeDelete"] = this.batchRecipeDelete;
        data["isStockType"] = this.isStockType;
        data["isCreditType"] = this.isCreditType;
        return data; 
    }
}

export interface ICreateMainTransactionSettingsInput {
    tenantId: number;
    stockOpeningBalanceDelete: number;
    inventoryReceiveDelete: number;
    inventoryOrderDelete: number;
    inventoryRawWasteDelete: number;
    menuItemWasteDelete: number;
    stockadjustmentDelete: number;
    inventoryTransferDelete: number;
    batchRecipeDelete: number;
    isStockType: boolean;
    isCreditType: boolean;
}

export class UpdateMainTransactionSettingsInput implements IUpdateMainTransactionSettingsInput {
    mainTransactionSettingsId: number;
    tenantId: number;
    stockOpeningBalanceDelete: number;
    inventoryReceiveDelete: number;
    inventoryOrderDelete: number;
    inventoryRawWasteDelete: number;
    menuItemWasteDelete: number;
    stockadjustmentDelete: number;
    inventoryTransferDelete: number;
    batchRecipeDelete: number;
    isStockType: boolean;
    isCreditType: boolean;

    constructor(data?: IUpdateMainTransactionSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mainTransactionSettingsId = data["mainTransactionSettingsId"];
            this.tenantId = data["tenantId"];
            this.stockOpeningBalanceDelete = data["stockOpeningBalanceDelete"];
            this.inventoryReceiveDelete = data["inventoryReceiveDelete"];
            this.inventoryOrderDelete = data["inventoryOrderDelete"];
            this.inventoryRawWasteDelete = data["inventoryRawWasteDelete"];
            this.menuItemWasteDelete = data["menuItemWasteDelete"];
            this.stockadjustmentDelete = data["stockadjustmentDelete"];
            this.inventoryTransferDelete = data["inventoryTransferDelete"];
            this.batchRecipeDelete = data["batchRecipeDelete"];
            this.isStockType = data["isStockType"];
            this.isCreditType = data["isCreditType"];
        }
    }

    static fromJS(data: any): UpdateMainTransactionSettingsInput {
        let result = new UpdateMainTransactionSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainTransactionSettingsId"] = this.mainTransactionSettingsId;
        data["tenantId"] = this.tenantId;
        data["stockOpeningBalanceDelete"] = this.stockOpeningBalanceDelete;
        data["inventoryReceiveDelete"] = this.inventoryReceiveDelete;
        data["inventoryOrderDelete"] = this.inventoryOrderDelete;
        data["inventoryRawWasteDelete"] = this.inventoryRawWasteDelete;
        data["menuItemWasteDelete"] = this.menuItemWasteDelete;
        data["stockadjustmentDelete"] = this.stockadjustmentDelete;
        data["inventoryTransferDelete"] = this.inventoryTransferDelete;
        data["batchRecipeDelete"] = this.batchRecipeDelete;
        data["isStockType"] = this.isStockType;
        data["isCreditType"] = this.isCreditType;
        return data; 
    }
}

export interface IUpdateMainTransactionSettingsInput {
    mainTransactionSettingsId: number;
    tenantId: number;
    stockOpeningBalanceDelete: number;
    inventoryReceiveDelete: number;
    inventoryOrderDelete: number;
    inventoryRawWasteDelete: number;
    menuItemWasteDelete: number;
    stockadjustmentDelete: number;
    inventoryTransferDelete: number;
    batchRecipeDelete: number;
    isStockType: boolean;
    isCreditType: boolean;
}

export class MangementDashboardData implements IMangementDashboardData {
    title: string;
    value: number;
    subtitle: string;
    iconClass: string;
    iconBg: string;

    constructor(data?: IMangementDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.value = data["value"];
            this.subtitle = data["subtitle"];
            this.iconClass = data["iconClass"];
            this.iconBg = data["iconBg"];
        }
    }

    static fromJS(data: any): MangementDashboardData {
        let result = new MangementDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["value"] = this.value;
        data["subtitle"] = this.subtitle;
        data["iconClass"] = this.iconClass;
        data["iconBg"] = this.iconBg;
        return data; 
    }
}

export interface IMangementDashboardData {
    title: string;
    value: number;
    subtitle: string;
    iconClass: string;
    iconBg: string;
}

export class StoreClustersOverview implements IStoreClustersOverview {
    store: string;
    cluster: string;
    coordinatorText: string;
    coordinatorBadge: string;
    devicesText: string;
    licenseText: string;
    licenseBadge: string;
    status: string;

    constructor(data?: IStoreClustersOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.store = data["store"];
            this.cluster = data["cluster"];
            this.coordinatorText = data["coordinatorText"];
            this.coordinatorBadge = data["coordinatorBadge"];
            this.devicesText = data["devicesText"];
            this.licenseText = data["licenseText"];
            this.licenseBadge = data["licenseBadge"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): StoreClustersOverview {
        let result = new StoreClustersOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["store"] = this.store;
        data["cluster"] = this.cluster;
        data["coordinatorText"] = this.coordinatorText;
        data["coordinatorBadge"] = this.coordinatorBadge;
        data["devicesText"] = this.devicesText;
        data["licenseText"] = this.licenseText;
        data["licenseBadge"] = this.licenseBadge;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStoreClustersOverview {
    store: string;
    cluster: string;
    coordinatorText: string;
    coordinatorBadge: string;
    devicesText: string;
    licenseText: string;
    licenseBadge: string;
    status: string;
}

export class CreateMenuItemInput implements ICreateMenuItemInput {
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];

    constructor(data?: ICreateMenuItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.levelId = data["levelId"];
            this.productGroupId = data["productGroupId"];
            this.reportGroupId = data["reportGroupId"];
            this.deviceId = data["deviceId"];
            this.periodId = data["periodId"];
            this.allowDiscount = data["allowDiscount"];
            this.openPrice = data["openPrice"];
            this.sellable = data["sellable"];
            this.cost = data["cost"];
            this.itemCode = data["itemCode"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isHidden = data["isHidden"];
            this.hasTobaccoTax = data["hasTobaccoTax"];
            this.isComboMealDefinitionItem = data["isComboMealDefinitionItem"];
            this.isHoteSaleing = data["isHoteSaleing"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.numberOfCalories = data["numberOfCalories"];
            this.numberOfSteps = data["numberOfSteps"];
            this.allowDecimal = data["allowDecimal"];
            this.unitsOfMeasure = data["unitsOfMeasure"] ? ProductUnitsOfMeasureDto.fromJS(data["unitsOfMeasure"]) : <any>undefined;
            if (data["saleTypesIds"] && data["saleTypesIds"].constructor === Array) {
                this.saleTypesIds = [];
                for (let item of data["saleTypesIds"])
                    this.saleTypesIds.push(item);
            }
            if (data["taxIds"] && data["taxIds"].constructor === Array) {
                this.taxIds = [];
                for (let item of data["taxIds"])
                    this.taxIds.push(item);
            }
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            if (data["upSalesMenuItemIds"] && data["upSalesMenuItemIds"].constructor === Array) {
                this.upSalesMenuItemIds = [];
                for (let item of data["upSalesMenuItemIds"])
                    this.upSalesMenuItemIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemTranslationDto.fromJS(item));
            }
            if (data["menuItemPrices"] && data["menuItemPrices"].constructor === Array) {
                this.menuItemPrices = [];
                for (let item of data["menuItemPrices"])
                    this.menuItemPrices.push(MenuItemPriceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMenuItemInput {
        let result = new CreateMenuItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelId"] = this.levelId;
        data["productGroupId"] = this.productGroupId;
        data["reportGroupId"] = this.reportGroupId;
        data["deviceId"] = this.deviceId;
        data["periodId"] = this.periodId;
        data["allowDiscount"] = this.allowDiscount;
        data["openPrice"] = this.openPrice;
        data["sellable"] = this.sellable;
        data["cost"] = this.cost;
        data["itemCode"] = this.itemCode;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isHidden"] = this.isHidden;
        data["hasTobaccoTax"] = this.hasTobaccoTax;
        data["isComboMealDefinitionItem"] = this.isComboMealDefinitionItem;
        data["isHoteSaleing"] = this.isHoteSaleing;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["numberOfCalories"] = this.numberOfCalories;
        data["numberOfSteps"] = this.numberOfSteps;
        data["allowDecimal"] = this.allowDecimal;
        data["unitsOfMeasure"] = this.unitsOfMeasure ? this.unitsOfMeasure.toJSON() : <any>undefined;
        if (this.saleTypesIds && this.saleTypesIds.constructor === Array) {
            data["saleTypesIds"] = [];
            for (let item of this.saleTypesIds)
                data["saleTypesIds"].push(item);
        }
        if (this.taxIds && this.taxIds.constructor === Array) {
            data["taxIds"] = [];
            for (let item of this.taxIds)
                data["taxIds"].push(item);
        }
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        if (this.upSalesMenuItemIds && this.upSalesMenuItemIds.constructor === Array) {
            data["upSalesMenuItemIds"] = [];
            for (let item of this.upSalesMenuItemIds)
                data["upSalesMenuItemIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemPrices && this.menuItemPrices.constructor === Array) {
            data["menuItemPrices"] = [];
            for (let item of this.menuItemPrices)
                data["menuItemPrices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateMenuItemInput {
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];
}

export class ListResultDtoOfMenuItemWithUOM implements IListResultDtoOfMenuItemWithUOM {
    items: MenuItemWithUOM[];

    constructor(data?: IListResultDtoOfMenuItemWithUOM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MenuItemWithUOM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMenuItemWithUOM {
        let result = new ListResultDtoOfMenuItemWithUOM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMenuItemWithUOM {
    items: MenuItemWithUOM[];
}

export class MenuItemWithUOM implements IMenuItemWithUOM {
    menuItemId: number;
    menuItem: string;
    itemCode: string;
    isHoteSaleing: boolean;
    unitOfMeasures: UnitOfMeasureListDto[];

    constructor(data?: IMenuItemWithUOM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"];
            this.itemCode = data["itemCode"];
            this.isHoteSaleing = data["isHoteSaleing"];
            if (data["unitOfMeasures"] && data["unitOfMeasures"].constructor === Array) {
                this.unitOfMeasures = [];
                for (let item of data["unitOfMeasures"])
                    this.unitOfMeasures.push(UnitOfMeasureListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemWithUOM {
        let result = new MenuItemWithUOM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem;
        data["itemCode"] = this.itemCode;
        data["isHoteSaleing"] = this.isHoteSaleing;
        if (this.unitOfMeasures && this.unitOfMeasures.constructor === Array) {
            data["unitOfMeasures"] = [];
            for (let item of this.unitOfMeasures)
                data["unitOfMeasures"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuItemWithUOM {
    menuItemId: number;
    menuItem: string;
    itemCode: string;
    isHoteSaleing: boolean;
    unitOfMeasures: UnitOfMeasureListDto[];
}

export class UnitOfMeasureListDto implements IUnitOfMeasureListDto {
    id: number;
    name: string;

    constructor(data?: IUnitOfMeasureListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): UnitOfMeasureListDto {
        let result = new UnitOfMeasureListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUnitOfMeasureListDto {
    id: number;
    name: string;
}

export class UpdateMenuItemInput implements IUpdateMenuItemInput {
    id: number;
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];

    constructor(data?: IUpdateMenuItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.levelId = data["levelId"];
            this.productGroupId = data["productGroupId"];
            this.reportGroupId = data["reportGroupId"];
            this.deviceId = data["deviceId"];
            this.periodId = data["periodId"];
            this.allowDiscount = data["allowDiscount"];
            this.openPrice = data["openPrice"];
            this.sellable = data["sellable"];
            this.cost = data["cost"];
            this.itemCode = data["itemCode"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isHidden = data["isHidden"];
            this.hasTobaccoTax = data["hasTobaccoTax"];
            this.isComboMealDefinitionItem = data["isComboMealDefinitionItem"];
            this.isHoteSaleing = data["isHoteSaleing"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.numberOfCalories = data["numberOfCalories"];
            this.numberOfSteps = data["numberOfSteps"];
            this.allowDecimal = data["allowDecimal"];
            this.unitsOfMeasure = data["unitsOfMeasure"] ? ProductUnitsOfMeasureDto.fromJS(data["unitsOfMeasure"]) : <any>undefined;
            if (data["saleTypesIds"] && data["saleTypesIds"].constructor === Array) {
                this.saleTypesIds = [];
                for (let item of data["saleTypesIds"])
                    this.saleTypesIds.push(item);
            }
            if (data["taxIds"] && data["taxIds"].constructor === Array) {
                this.taxIds = [];
                for (let item of data["taxIds"])
                    this.taxIds.push(item);
            }
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            if (data["upSalesMenuItemIds"] && data["upSalesMenuItemIds"].constructor === Array) {
                this.upSalesMenuItemIds = [];
                for (let item of data["upSalesMenuItemIds"])
                    this.upSalesMenuItemIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemTranslationDto.fromJS(item));
            }
            if (data["menuItemPrices"] && data["menuItemPrices"].constructor === Array) {
                this.menuItemPrices = [];
                for (let item of data["menuItemPrices"])
                    this.menuItemPrices.push(MenuItemPriceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMenuItemInput {
        let result = new UpdateMenuItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelId"] = this.levelId;
        data["productGroupId"] = this.productGroupId;
        data["reportGroupId"] = this.reportGroupId;
        data["deviceId"] = this.deviceId;
        data["periodId"] = this.periodId;
        data["allowDiscount"] = this.allowDiscount;
        data["openPrice"] = this.openPrice;
        data["sellable"] = this.sellable;
        data["cost"] = this.cost;
        data["itemCode"] = this.itemCode;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isHidden"] = this.isHidden;
        data["hasTobaccoTax"] = this.hasTobaccoTax;
        data["isComboMealDefinitionItem"] = this.isComboMealDefinitionItem;
        data["isHoteSaleing"] = this.isHoteSaleing;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["numberOfCalories"] = this.numberOfCalories;
        data["numberOfSteps"] = this.numberOfSteps;
        data["allowDecimal"] = this.allowDecimal;
        data["unitsOfMeasure"] = this.unitsOfMeasure ? this.unitsOfMeasure.toJSON() : <any>undefined;
        if (this.saleTypesIds && this.saleTypesIds.constructor === Array) {
            data["saleTypesIds"] = [];
            for (let item of this.saleTypesIds)
                data["saleTypesIds"].push(item);
        }
        if (this.taxIds && this.taxIds.constructor === Array) {
            data["taxIds"] = [];
            for (let item of this.taxIds)
                data["taxIds"].push(item);
        }
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        if (this.upSalesMenuItemIds && this.upSalesMenuItemIds.constructor === Array) {
            data["upSalesMenuItemIds"] = [];
            for (let item of this.upSalesMenuItemIds)
                data["upSalesMenuItemIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemPrices && this.menuItemPrices.constructor === Array) {
            data["menuItemPrices"] = [];
            for (let item of this.menuItemPrices)
                data["menuItemPrices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateMenuItemInput {
    id: number;
    levelId: number;
    productGroupId: number;
    reportGroupId: number;
    deviceId: number;
    periodId: number;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isComboMealDefinitionItem: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    saleTypesIds: number[];
    taxIds: number[];
    printerIds: number[];
    comboGroupIds: number[];
    upSalesMenuItemIds: number[];
    storeIds: number[];
    translations: MenuItemTranslationDto[];
    menuItemPrices: MenuItemPriceListDto[];
}

export class CloneMenuItemDto implements ICloneMenuItemDto {
    id: number;
    translations: MenuItemTranslationDto[];
    itemCode: string;

    constructor(data?: ICloneMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemTranslationDto.fromJS(item));
            }
            this.itemCode = data["itemCode"];
        }
    }

    static fromJS(data: any): CloneMenuItemDto {
        let result = new CloneMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["itemCode"] = this.itemCode;
        return data; 
    }
}

export interface ICloneMenuItemDto {
    id: number;
    translations: MenuItemTranslationDto[];
    itemCode: string;
}

export class GetStoreGroupsTreeForEditOutput implements IGetStoreGroupsTreeForEditOutput {
    storeGroups: FlatStoreGroupDto[];
    grantedStoreGroupIds: number[];

    constructor(data?: IGetStoreGroupsTreeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeGroups"] && data["storeGroups"].constructor === Array) {
                this.storeGroups = [];
                for (let item of data["storeGroups"])
                    this.storeGroups.push(FlatStoreGroupDto.fromJS(item));
            }
            if (data["grantedStoreGroupIds"] && data["grantedStoreGroupIds"].constructor === Array) {
                this.grantedStoreGroupIds = [];
                for (let item of data["grantedStoreGroupIds"])
                    this.grantedStoreGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): GetStoreGroupsTreeForEditOutput {
        let result = new GetStoreGroupsTreeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeGroups && this.storeGroups.constructor === Array) {
            data["storeGroups"] = [];
            for (let item of this.storeGroups)
                data["storeGroups"].push(item.toJSON());
        }
        if (this.grantedStoreGroupIds && this.grantedStoreGroupIds.constructor === Array) {
            data["grantedStoreGroupIds"] = [];
            for (let item of this.grantedStoreGroupIds)
                data["grantedStoreGroupIds"].push(item);
        }
        return data; 
    }
}

export interface IGetStoreGroupsTreeForEditOutput {
    storeGroups: FlatStoreGroupDto[];
    grantedStoreGroupIds: number[];
}

export class FlatStoreGroupDto implements IFlatStoreGroupDto {
    parentId: number;
    id: number;
    displayName: string;
    isStoreGroup: boolean;

    constructor(data?: IFlatStoreGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isStoreGroup = data["isStoreGroup"];
        }
    }

    static fromJS(data: any): FlatStoreGroupDto {
        let result = new FlatStoreGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isStoreGroup"] = this.isStoreGroup;
        return data; 
    }
}

export interface IFlatStoreGroupDto {
    parentId: number;
    id: number;
    displayName: string;
    isStoreGroup: boolean;
}

export class MenuItemLinkDto implements IMenuItemLinkDto {
    recipeName: string;
    rawMaterialName: string;
    rawMaterialId: number;
    recipeId: number;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.recipeName = data["recipeName"];
            this.rawMaterialName = data["rawMaterialName"];
            this.rawMaterialId = data["rawMaterialId"];
            this.recipeId = data["recipeId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemLinkTranslationDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemLinkDto {
        let result = new MenuItemLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeName"] = this.recipeName;
        data["rawMaterialName"] = this.rawMaterialName;
        data["rawMaterialId"] = this.rawMaterialId;
        data["recipeId"] = this.recipeId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemLinkDto {
    recipeName: string;
    rawMaterialName: string;
    rawMaterialId: number;
    recipeId: number;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemLinkTranslationDto implements IMenuItemLinkTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IMenuItemLinkTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): MenuItemLinkTranslationDto {
        let result = new MenuItemLinkTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IMenuItemLinkTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfMenuItemLinkListItem implements IListResultDtoOfMenuItemLinkListItem {
    items: MenuItemLinkListItem[];

    constructor(data?: IListResultDtoOfMenuItemLinkListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MenuItemLinkListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMenuItemLinkListItem {
        let result = new ListResultDtoOfMenuItemLinkListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMenuItemLinkListItem {
    items: MenuItemLinkListItem[];
}

export class MenuItemLinkListItem implements IMenuItemLinkListItem {
    id: number;
    recipeName: string;
    rawMaterialName: string;
    rawMaterialId: number;
    recipeId: number;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;

    constructor(data?: IMenuItemLinkListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.recipeName = data["recipeName"];
            this.rawMaterialName = data["rawMaterialName"];
            this.rawMaterialId = data["rawMaterialId"];
            this.recipeId = data["recipeId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemLinkTranslationDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): MenuItemLinkListItem {
        let result = new MenuItemLinkListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeName"] = this.recipeName;
        data["rawMaterialName"] = this.rawMaterialName;
        data["rawMaterialId"] = this.rawMaterialId;
        data["recipeId"] = this.recipeId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IMenuItemLinkListItem {
    id: number;
    recipeName: string;
    rawMaterialName: string;
    rawMaterialId: number;
    recipeId: number;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;
}

export class CreateMenuItemLinkInput implements ICreateMenuItemLinkInput {
    rawMaterialId: number;
    rawMaterial: RawMaterialDto;
    recipeId: number;
    recipe: RecipeDto;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;

    constructor(data?: ICreateMenuItemLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterialDto.fromJS(data["rawMaterial"]) : <any>undefined;
            this.recipeId = data["recipeId"];
            this.recipe = data["recipe"] ? RecipeDto.fromJS(data["recipe"]) : <any>undefined;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemLinkTranslationDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateMenuItemLinkInput {
        let result = new CreateMenuItemLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["recipeId"] = this.recipeId;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : <any>undefined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICreateMenuItemLinkInput {
    rawMaterialId: number;
    rawMaterial: RawMaterialDto;
    recipeId: number;
    recipe: RecipeDto;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;
}

export class RecipeDto implements IRecipeDto {
    id: number;
    menuItemId: number;
    menuItemName: string;
    lossFactor: number;
    recipeCode: string;
    translations: RecipeTranslationDto[];
    storeIds: number[];
    recipeRawMaterials: RecipeRawMaterialDto[];

    constructor(data?: IRecipeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemId = data["menuItemId"];
            this.menuItemName = data["menuItemName"];
            this.lossFactor = data["lossFactor"];
            this.recipeCode = data["recipeCode"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RecipeTranslationDto.fromJS(item));
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["recipeRawMaterials"] && data["recipeRawMaterials"].constructor === Array) {
                this.recipeRawMaterials = [];
                for (let item of data["recipeRawMaterials"])
                    this.recipeRawMaterials.push(RecipeRawMaterialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipeDto {
        let result = new RecipeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemId"] = this.menuItemId;
        data["menuItemName"] = this.menuItemName;
        data["lossFactor"] = this.lossFactor;
        data["recipeCode"] = this.recipeCode;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.recipeRawMaterials && this.recipeRawMaterials.constructor === Array) {
            data["recipeRawMaterials"] = [];
            for (let item of this.recipeRawMaterials)
                data["recipeRawMaterials"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRecipeDto {
    id: number;
    menuItemId: number;
    menuItemName: string;
    lossFactor: number;
    recipeCode: string;
    translations: RecipeTranslationDto[];
    storeIds: number[];
    recipeRawMaterials: RecipeRawMaterialDto[];
}

export class RecipeTranslationDto implements IRecipeTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IRecipeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): RecipeTranslationDto {
        let result = new RecipeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IRecipeTranslationDto {
    name: string;
    languageId: number;
}

export class RecipeRawMaterialDto implements IRecipeRawMaterialDto {
    rawMaterialId: number;
    rawMaterialCode: string;
    rawMaterialName: string;
    quantity: number;
    unit: string;
    lossFactor: number;
    sellingPrice: number;
    saleTypes: string;
    recipeRawMaterialSaleTypesIds: number[];

    constructor(data?: IRecipeRawMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterialCode = data["rawMaterialCode"];
            this.rawMaterialName = data["rawMaterialName"];
            this.quantity = data["quantity"];
            this.unit = data["unit"];
            this.lossFactor = data["lossFactor"];
            this.sellingPrice = data["sellingPrice"];
            this.saleTypes = data["saleTypes"];
            if (data["recipeRawMaterialSaleTypesIds"] && data["recipeRawMaterialSaleTypesIds"].constructor === Array) {
                this.recipeRawMaterialSaleTypesIds = [];
                for (let item of data["recipeRawMaterialSaleTypesIds"])
                    this.recipeRawMaterialSaleTypesIds.push(item);
            }
        }
    }

    static fromJS(data: any): RecipeRawMaterialDto {
        let result = new RecipeRawMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterialCode"] = this.rawMaterialCode;
        data["rawMaterialName"] = this.rawMaterialName;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["lossFactor"] = this.lossFactor;
        data["sellingPrice"] = this.sellingPrice;
        data["saleTypes"] = this.saleTypes;
        if (this.recipeRawMaterialSaleTypesIds && this.recipeRawMaterialSaleTypesIds.constructor === Array) {
            data["recipeRawMaterialSaleTypesIds"] = [];
            for (let item of this.recipeRawMaterialSaleTypesIds)
                data["recipeRawMaterialSaleTypesIds"].push(item);
        }
        return data; 
    }
}

export interface IRecipeRawMaterialDto {
    rawMaterialId: number;
    rawMaterialCode: string;
    rawMaterialName: string;
    quantity: number;
    unit: string;
    lossFactor: number;
    sellingPrice: number;
    saleTypes: string;
    recipeRawMaterialSaleTypesIds: number[];
}

export class UpdateMenuItemLinkInput implements IUpdateMenuItemLinkInput {
    id: number;
    rawMaterialId: number;
    rawMaterial: RawMaterialDto;
    recipeId: number;
    recipe: RecipeDto;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;

    constructor(data?: IUpdateMenuItemLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterialDto.fromJS(data["rawMaterial"]) : <any>undefined;
            this.recipeId = data["recipeId"];
            this.recipe = data["recipe"] ? RecipeDto.fromJS(data["recipe"]) : <any>undefined;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemLinkTranslationDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UpdateMenuItemLinkInput {
        let result = new UpdateMenuItemLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["recipeId"] = this.recipeId;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : <any>undefined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IUpdateMenuItemLinkInput {
    id: number;
    rawMaterialId: number;
    rawMaterial: RawMaterialDto;
    recipeId: number;
    recipe: RecipeDto;
    translations: MenuItemLinkTranslationDto[];
    tenantId: number;
}

export class PagedMenuItemLinkList implements IPagedMenuItemLinkList {
    currentPage: number;
    itemsCount: number;
    menuItemLinks: MenuItemLinkListItem[];

    constructor(data?: IPagedMenuItemLinkList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["menuItemLinks"] && data["menuItemLinks"].constructor === Array) {
                this.menuItemLinks = [];
                for (let item of data["menuItemLinks"])
                    this.menuItemLinks.push(MenuItemLinkListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedMenuItemLinkList {
        let result = new PagedMenuItemLinkList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.menuItemLinks && this.menuItemLinks.constructor === Array) {
            data["menuItemLinks"] = [];
            for (let item of this.menuItemLinks)
                data["menuItemLinks"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedMenuItemLinkList {
    currentPage: number;
    itemsCount: number;
    menuItemLinks: MenuItemLinkListItem[];
}

export class CheckInstall_InputDto implements ICheckInstall_InputDto {
    tenantId: number;
    tenderTypeId: number;
    storeId: number;

    constructor(data?: ICheckInstall_InputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): CheckInstall_InputDto {
        let result = new CheckInstall_InputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface ICheckInstall_InputDto {
    tenantId: number;
    tenderTypeId: number;
    storeId: number;
}

export class CheckInstall_OutpotDto implements ICheckInstall_OutpotDto {
    isExc: boolean;
    excMessage: string;
    checkInstallResponse: CheckInstallResponse;

    constructor(data?: ICheckInstall_OutpotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isExc = data["isExc"];
            this.excMessage = data["excMessage"];
            this.checkInstallResponse = data["checkInstallResponse"] ? CheckInstallResponse.fromJS(data["checkInstallResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckInstall_OutpotDto {
        let result = new CheckInstall_OutpotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExc"] = this.isExc;
        data["excMessage"] = this.excMessage;
        data["checkInstallResponse"] = this.checkInstallResponse ? this.checkInstallResponse.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICheckInstall_OutpotDto {
    isExc: boolean;
    excMessage: string;
    checkInstallResponse: CheckInstallResponse;
}

export class CheckInstallResponse implements ICheckInstallResponse {
    infoMessage: CheckInstallResponseInfoMessage;
    isMatch: boolean;

    constructor(data?: ICheckInstallResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.infoMessage = data["infoMessage"];
            this.isMatch = data["isMatch"];
        }
    }

    static fromJS(data: any): CheckInstallResponse {
        let result = new CheckInstallResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infoMessage"] = this.infoMessage;
        data["isMatch"] = this.isMatch;
        return data; 
    }
}

export interface ICheckInstallResponse {
    infoMessage: CheckInstallResponseInfoMessage;
    isMatch: boolean;
}

export class GetLanguage_OutpotDto implements IGetLanguage_OutpotDto {
    isExc: boolean;
    excMessage: string;
    languagesResponse: LanguagesResponse[];

    constructor(data?: IGetLanguage_OutpotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isExc = data["isExc"];
            this.excMessage = data["excMessage"];
            if (data["languagesResponse"] && data["languagesResponse"].constructor === Array) {
                this.languagesResponse = [];
                for (let item of data["languagesResponse"])
                    this.languagesResponse.push(LanguagesResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguage_OutpotDto {
        let result = new GetLanguage_OutpotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExc"] = this.isExc;
        data["excMessage"] = this.excMessage;
        if (this.languagesResponse && this.languagesResponse.constructor === Array) {
            data["languagesResponse"] = [];
            for (let item of this.languagesResponse)
                data["languagesResponse"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguage_OutpotDto {
    isExc: boolean;
    excMessage: string;
    languagesResponse: LanguagesResponse[];
}

export class LanguagesResponse implements ILanguagesResponse {
    languageId: number;
    languageName: string;

    constructor(data?: ILanguagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageId = data["languageId"];
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): LanguagesResponse {
        let result = new LanguagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface ILanguagesResponse {
    languageId: number;
    languageName: string;
}

export class Login_InputDto implements ILogin_InputDto {
    tenantId: number;
    userName: string;
    password: string;
    storeId: number;
    userType: Login_InputDtoUserType;

    constructor(data?: ILogin_InputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userName = data["userName"];
            this.password = data["password"];
            this.storeId = data["storeId"];
            this.userType = data["userType"];
        }
    }

    static fromJS(data: any): Login_InputDto {
        let result = new Login_InputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["storeId"] = this.storeId;
        data["userType"] = this.userType;
        return data; 
    }
}

export interface ILogin_InputDto {
    tenantId: number;
    userName: string;
    password: string;
    storeId: number;
    userType: Login_InputDtoUserType;
}

export class Login_OutpotDto implements ILogin_OutpotDto {
    userResponse: UserResponse;
    isExc: boolean;
    excMessage: string;

    constructor(data?: ILogin_OutpotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userResponse = data["userResponse"] ? UserResponse.fromJS(data["userResponse"]) : <any>undefined;
            this.isExc = data["isExc"];
            this.excMessage = data["excMessage"];
        }
    }

    static fromJS(data: any): Login_OutpotDto {
        let result = new Login_OutpotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userResponse"] = this.userResponse ? this.userResponse.toJSON() : <any>undefined;
        data["isExc"] = this.isExc;
        data["excMessage"] = this.excMessage;
        return data; 
    }
}

export interface ILogin_OutpotDto {
    userResponse: UserResponse;
    isExc: boolean;
    excMessage: string;
}

export class UserResponse implements IUserResponse {
    user: UserListDto;
    infoMessage: UserResponseInfoMessage;
    currencyId: number;
    currencyNames: LanguagesResponse[];
    shift: CashierShiftMobile;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.infoMessage = data["infoMessage"];
            this.currencyId = data["currencyId"];
            if (data["currencyNames"] && data["currencyNames"].constructor === Array) {
                this.currencyNames = [];
                for (let item of data["currencyNames"])
                    this.currencyNames.push(LanguagesResponse.fromJS(item));
            }
            this.shift = data["shift"] ? CashierShiftMobile.fromJS(data["shift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserResponse {
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["infoMessage"] = this.infoMessage;
        data["currencyId"] = this.currencyId;
        if (this.currencyNames && this.currencyNames.constructor === Array) {
            data["currencyNames"] = [];
            for (let item of this.currencyNames)
                data["currencyNames"].push(item.toJSON());
        }
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserResponse {
    user: UserListDto;
    infoMessage: UserResponseInfoMessage;
    currencyId: number;
    currencyNames: LanguagesResponse[];
    shift: CashierShiftMobile;
}

export class UserListDto implements IUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    profilePictureId: string;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[];
    lastLoginTime: moment.Moment;
    isActive: boolean;
    creationTime: moment.Moment;
    signInToken: string;
    code: string;
    id: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserListRoleDto.fromJS(item));
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.signInToken = data["signInToken"];
            this.code = data["code"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["signInToken"] = this.signInToken;
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    profilePictureId: string;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[];
    lastLoginTime: moment.Moment;
    isActive: boolean;
    creationTime: moment.Moment;
    signInToken: string;
    code: string;
    id: number;
}

export class CashierShiftMobile implements ICashierShiftMobile {
    shiftStart: moment.Moment;
    status: CashierShiftMobileStatus;
    id: number;

    constructor(data?: ICashierShiftMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shiftStart = data["shiftStart"] ? moment(data["shiftStart"].toString()) : <any>undefined;
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CashierShiftMobile {
        let result = new CashierShiftMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftStart"] = this.shiftStart ? this.shiftStart.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICashierShiftMobile {
    shiftStart: moment.Moment;
    status: CashierShiftMobileStatus;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId: number;
    roleName: string;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string;
}

export class InitalBalance_InputDto implements IInitalBalance_InputDto {
    tenantId: number;
    userId: number;
    storeId: number;

    constructor(data?: IInitalBalance_InputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): InitalBalance_InputDto {
        let result = new InitalBalance_InputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IInitalBalance_InputDto {
    tenantId: number;
    userId: number;
    storeId: number;
}

export class ModuleDto implements IModuleDto {
    id: number;
    tableName: string;
    moduleLogsExceptions: ModuleLogsExceptionDto[];

    constructor(data?: IModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tableName = data["tableName"];
            if (data["moduleLogsExceptions"] && data["moduleLogsExceptions"].constructor === Array) {
                this.moduleLogsExceptions = [];
                for (let item of data["moduleLogsExceptions"])
                    this.moduleLogsExceptions.push(ModuleLogsExceptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModuleDto {
        let result = new ModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tableName"] = this.tableName;
        if (this.moduleLogsExceptions && this.moduleLogsExceptions.constructor === Array) {
            data["moduleLogsExceptions"] = [];
            for (let item of this.moduleLogsExceptions)
                data["moduleLogsExceptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IModuleDto {
    id: number;
    tableName: string;
    moduleLogsExceptions: ModuleLogsExceptionDto[];
}

export class ModuleLogsExceptionDto implements IModuleLogsExceptionDto {
    exceptionTime: moment.Moment;
    exceptionMessage: string;
    moduleId: number;

    constructor(data?: IModuleLogsExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exceptionTime = data["exceptionTime"] ? moment(data["exceptionTime"].toString()) : <any>undefined;
            this.exceptionMessage = data["exceptionMessage"];
            this.moduleId = data["moduleId"];
        }
    }

    static fromJS(data: any): ModuleLogsExceptionDto {
        let result = new ModuleLogsExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionTime"] = this.exceptionTime ? this.exceptionTime.toISOString() : <any>undefined;
        data["exceptionMessage"] = this.exceptionMessage;
        data["moduleId"] = this.moduleId;
        return data; 
    }
}

export interface IModuleLogsExceptionDto {
    exceptionTime: moment.Moment;
    exceptionMessage: string;
    moduleId: number;
}

export class PagedModule implements IPagedModule {
    currentPage: number;
    itemsCount: number;
    items: ModuleDto[];

    constructor(data?: IPagedModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedModule {
        let result = new PagedModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedModule {
    currentPage: number;
    itemsCount: number;
    items: ModuleDto[];
}

export class CreateMsDynamicInput implements ICreateMsDynamicInput {
    grantType: string;
    clientId: string;
    organizationUrl: string;
    clientSecret: string;
    salesUrl: string;
    tenantId: number;
    isAutomaticSync: boolean;
    loginUrl: string;
    reUploadInterval: number;
    reUploadEnabled: boolean;

    constructor(data?: ICreateMsDynamicInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.grantType = data["grantType"];
            this.clientId = data["clientId"];
            this.organizationUrl = data["organizationUrl"];
            this.clientSecret = data["clientSecret"];
            this.salesUrl = data["salesUrl"];
            this.tenantId = data["tenantId"];
            this.isAutomaticSync = data["isAutomaticSync"];
            this.loginUrl = data["loginUrl"];
            this.reUploadInterval = data["reUploadInterval"];
            this.reUploadEnabled = data["reUploadEnabled"];
        }
    }

    static fromJS(data: any): CreateMsDynamicInput {
        let result = new CreateMsDynamicInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["organizationUrl"] = this.organizationUrl;
        data["clientSecret"] = this.clientSecret;
        data["salesUrl"] = this.salesUrl;
        data["tenantId"] = this.tenantId;
        data["isAutomaticSync"] = this.isAutomaticSync;
        data["loginUrl"] = this.loginUrl;
        data["reUploadInterval"] = this.reUploadInterval;
        data["reUploadEnabled"] = this.reUploadEnabled;
        return data; 
    }
}

export interface ICreateMsDynamicInput {
    grantType: string;
    clientId: string;
    organizationUrl: string;
    clientSecret: string;
    salesUrl: string;
    tenantId: number;
    isAutomaticSync: boolean;
    loginUrl: string;
    reUploadInterval: number;
    reUploadEnabled: boolean;
}

export class MsDynamicDTOs implements IMsDynamicDTOs {
    id: string;
    grantType: string;
    clientId: string;
    organizationUrl: string;
    clientSecret: string;
    salesUrl: string;
    tenantId: number;
    loginUrl: string;
    isAutomaticSync: boolean;
    reUploadInterval: number;
    reUploadEnabled: boolean;

    constructor(data?: IMsDynamicDTOs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.grantType = data["grantType"];
            this.clientId = data["clientId"];
            this.organizationUrl = data["organizationUrl"];
            this.clientSecret = data["clientSecret"];
            this.salesUrl = data["salesUrl"];
            this.tenantId = data["tenantId"];
            this.loginUrl = data["loginUrl"];
            this.isAutomaticSync = data["isAutomaticSync"];
            this.reUploadInterval = data["reUploadInterval"];
            this.reUploadEnabled = data["reUploadEnabled"];
        }
    }

    static fromJS(data: any): MsDynamicDTOs {
        let result = new MsDynamicDTOs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["organizationUrl"] = this.organizationUrl;
        data["clientSecret"] = this.clientSecret;
        data["salesUrl"] = this.salesUrl;
        data["tenantId"] = this.tenantId;
        data["loginUrl"] = this.loginUrl;
        data["isAutomaticSync"] = this.isAutomaticSync;
        data["reUploadInterval"] = this.reUploadInterval;
        data["reUploadEnabled"] = this.reUploadEnabled;
        return data; 
    }
}

export interface IMsDynamicDTOs {
    id: string;
    grantType: string;
    clientId: string;
    organizationUrl: string;
    clientSecret: string;
    salesUrl: string;
    tenantId: number;
    loginUrl: string;
    isAutomaticSync: boolean;
    reUploadInterval: number;
    reUploadEnabled: boolean;
}

export class EditMsDynamicInput implements IEditMsDynamicInput {
    id: string;
    grantType: string;
    clientId: string;
    organizationUrl: string;
    clientSecret: string;
    salesUrl: string;
    tenantId: number;
    isAutomaticSync: boolean;
    loginUrl: string;
    reUploadInterval: number;
    reUploadEnabled: boolean;

    constructor(data?: IEditMsDynamicInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.grantType = data["grantType"];
            this.clientId = data["clientId"];
            this.organizationUrl = data["organizationUrl"];
            this.clientSecret = data["clientSecret"];
            this.salesUrl = data["salesUrl"];
            this.tenantId = data["tenantId"];
            this.isAutomaticSync = data["isAutomaticSync"];
            this.loginUrl = data["loginUrl"];
            this.reUploadInterval = data["reUploadInterval"];
            this.reUploadEnabled = data["reUploadEnabled"];
        }
    }

    static fromJS(data: any): EditMsDynamicInput {
        let result = new EditMsDynamicInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["organizationUrl"] = this.organizationUrl;
        data["clientSecret"] = this.clientSecret;
        data["salesUrl"] = this.salesUrl;
        data["tenantId"] = this.tenantId;
        data["isAutomaticSync"] = this.isAutomaticSync;
        data["loginUrl"] = this.loginUrl;
        data["reUploadInterval"] = this.reUploadInterval;
        data["reUploadEnabled"] = this.reUploadEnabled;
        return data; 
    }
}

export interface IEditMsDynamicInput {
    id: string;
    grantType: string;
    clientId: string;
    organizationUrl: string;
    clientSecret: string;
    salesUrl: string;
    tenantId: number;
    isAutomaticSync: boolean;
    loginUrl: string;
    reUploadInterval: number;
    reUploadEnabled: boolean;
}

export class SalesTransactionUploadedInput implements ISalesTransactionUploadedInput {
    salesIds: string[];
    transType: number;

    constructor(data?: ISalesTransactionUploadedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["salesIds"] && data["salesIds"].constructor === Array) {
                this.salesIds = [];
                for (let item of data["salesIds"])
                    this.salesIds.push(item);
            }
            this.transType = data["transType"];
        }
    }

    static fromJS(data: any): SalesTransactionUploadedInput {
        let result = new SalesTransactionUploadedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.salesIds && this.salesIds.constructor === Array) {
            data["salesIds"] = [];
            for (let item of this.salesIds)
                data["salesIds"].push(item);
        }
        data["transType"] = this.transType;
        return data; 
    }
}

export interface ISalesTransactionUploadedInput {
    salesIds: string[];
    transType: number;
}

export class LogHistoryInput implements ILogHistoryInput {
    to: moment.Moment;
    from: moment.Moment;
    status: number;
    storeCodes: string[];

    constructor(data?: ILogHistoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.status = data["status"];
            if (data["storeCodes"] && data["storeCodes"].constructor === Array) {
                this.storeCodes = [];
                for (let item of data["storeCodes"])
                    this.storeCodes.push(item);
            }
        }
    }

    static fromJS(data: any): LogHistoryInput {
        let result = new LogHistoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (this.storeCodes && this.storeCodes.constructor === Array) {
            data["storeCodes"] = [];
            for (let item of this.storeCodes)
                data["storeCodes"].push(item);
        }
        return data; 
    }
}

export interface ILogHistoryInput {
    to: moment.Moment;
    from: moment.Moment;
    status: number;
    storeCodes: string[];
}

export class LogHistoryDto implements ILogHistoryDto {
    pageCount: number;
    currentPage: number;
    details: SalesTransactionUploadedLogsDto[];

    constructor(data?: ILogHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SalesTransactionUploadedLogsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogHistoryDto {
        let result = new LogHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILogHistoryDto {
    pageCount: number;
    currentPage: number;
    details: SalesTransactionUploadedLogsDto[];
}

export class SalesTransactionUploadedLogsDto implements ISalesTransactionUploadedLogsDto {
    reciptId: string;
    statusCode: number;
    store: string;
    creationTime: moment.Moment;
    responseMessage: string;

    constructor(data?: ISalesTransactionUploadedLogsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reciptId = data["reciptId"];
            this.statusCode = data["statusCode"];
            this.store = data["store"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.responseMessage = data["responseMessage"];
        }
    }

    static fromJS(data: any): SalesTransactionUploadedLogsDto {
        let result = new SalesTransactionUploadedLogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reciptId"] = this.reciptId;
        data["statusCode"] = this.statusCode;
        data["store"] = this.store;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["responseMessage"] = this.responseMessage;
        return data; 
    }
}

export interface ISalesTransactionUploadedLogsDto {
    reciptId: string;
    statusCode: number;
    store: string;
    creationTime: moment.Moment;
    responseMessage: string;
}

export class TransactionReportDto implements ITransactionReportDto {
    currentPage: number;
    pageCount: number;
    totalCount: number;
    details: TransactionReportItemDto[];

    constructor(data?: ITransactionReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.pageCount = data["pageCount"];
            this.totalCount = data["totalCount"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(TransactionReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionReportDto {
        let result = new TransactionReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["totalCount"] = this.totalCount;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransactionReportDto {
    currentPage: number;
    pageCount: number;
    totalCount: number;
    details: TransactionReportItemDto[];
}

export class TransactionReportItemDto implements ITransactionReportItemDto {
    transactionId: string;
    receiptNumber: string;
    timeUpload: moment.Moment;
    user: string;
    storeName: string;

    constructor(data?: ITransactionReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionId = data["transactionId"];
            this.receiptNumber = data["receiptNumber"];
            this.timeUpload = data["timeUpload"] ? moment(data["timeUpload"].toString()) : <any>undefined;
            this.user = data["user"];
            this.storeName = data["storeName"];
        }
    }

    static fromJS(data: any): TransactionReportItemDto {
        let result = new TransactionReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["receiptNumber"] = this.receiptNumber;
        data["timeUpload"] = this.timeUpload ? this.timeUpload.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["storeName"] = this.storeName;
        return data; 
    }
}

export interface ITransactionReportItemDto {
    transactionId: string;
    receiptNumber: string;
    timeUpload: moment.Moment;
    user: string;
    storeName: string;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[];

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[];
}

export class UserNotification implements IUserNotification {
    tenantId: number;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserNotification {
    tenantId: number;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class TenantNotification implements ITenantNotification {
    tenantId: number;
    notificationName: string;
    data: NotificationData;
    entityType: string;
    entityTypeName: string;
    entityId: any;
    severity: TenantNotificationSeverity;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : <any>undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            if (data["entityId"]) {
                this.entityId = {};
                for (let key in data["entityId"]) {
                    if (data["entityId"].hasOwnProperty(key))
                        this.entityId[key] = data["entityId"][key];
                }
            }
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        if (this.entityId) {
            data["entityId"] = {};
            for (let key in this.entityId) {
                if (this.entityId.hasOwnProperty(key))
                    data["entityId"][key] = this.entityId[key];
            }
        }
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantNotification {
    tenantId: number;
    notificationName: string;
    data: NotificationData;
    entityType: string;
    entityTypeName: string;
    entityId: any;
    severity: TenantNotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class NotificationData implements INotificationData {
    type: string;
    properties: { [key: string] : any; };

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (let key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface INotificationData {
    type: string;
    properties: { [key: string] : any; };
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[];

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[];
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName: string;
    description: string;
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string;
    description: string;
    name: string;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[];

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[];
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class OfferDto implements IOfferDto {
    from: moment.Moment;
    to: moment.Moment;
    discountPercent: number;
    discountAmmount: number;
    primaryCategoryIdList: number[];
    secondaryCategoryIdList: number[];
    productCategoryIdList: number[];
    productIdList: number[];
    isExclude: boolean;
    isInclude: boolean;
    offerType: OfferDtoOfferType;
    offerTypeText: string;
    itemText: string;
    itemType: OfferDtoItemType;
    itemCode: string;
    offerDetails: OfferDetailDto[];
    offerExcludes: OfferExcludeDto[];
    offerIncludes: OfferIncludeDto[];
    offerIncludeIds: number[];
    itemId: number;
    numberOfItems: number;
    numberOfFreeItems: number;
    value: number;
    storeIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.discountPercent = data["discountPercent"];
            this.discountAmmount = data["discountAmmount"];
            if (data["primaryCategoryIdList"] && data["primaryCategoryIdList"].constructor === Array) {
                this.primaryCategoryIdList = [];
                for (let item of data["primaryCategoryIdList"])
                    this.primaryCategoryIdList.push(item);
            }
            if (data["secondaryCategoryIdList"] && data["secondaryCategoryIdList"].constructor === Array) {
                this.secondaryCategoryIdList = [];
                for (let item of data["secondaryCategoryIdList"])
                    this.secondaryCategoryIdList.push(item);
            }
            if (data["productCategoryIdList"] && data["productCategoryIdList"].constructor === Array) {
                this.productCategoryIdList = [];
                for (let item of data["productCategoryIdList"])
                    this.productCategoryIdList.push(item);
            }
            if (data["productIdList"] && data["productIdList"].constructor === Array) {
                this.productIdList = [];
                for (let item of data["productIdList"])
                    this.productIdList.push(item);
            }
            this.isExclude = data["isExclude"];
            this.isInclude = data["isInclude"];
            this.offerType = data["offerType"];
            this.offerTypeText = data["offerTypeText"];
            this.itemText = data["itemText"];
            this.itemType = data["itemType"];
            this.itemCode = data["itemCode"];
            if (data["offerDetails"] && data["offerDetails"].constructor === Array) {
                this.offerDetails = [];
                for (let item of data["offerDetails"])
                    this.offerDetails.push(OfferDetailDto.fromJS(item));
            }
            if (data["offerExcludes"] && data["offerExcludes"].constructor === Array) {
                this.offerExcludes = [];
                for (let item of data["offerExcludes"])
                    this.offerExcludes.push(OfferExcludeDto.fromJS(item));
            }
            if (data["offerIncludes"] && data["offerIncludes"].constructor === Array) {
                this.offerIncludes = [];
                for (let item of data["offerIncludes"])
                    this.offerIncludes.push(OfferIncludeDto.fromJS(item));
            }
            if (data["offerIncludeIds"] && data["offerIncludeIds"].constructor === Array) {
                this.offerIncludeIds = [];
                for (let item of data["offerIncludeIds"])
                    this.offerIncludeIds.push(item);
            }
            this.itemId = data["itemId"];
            this.numberOfItems = data["numberOfItems"];
            this.numberOfFreeItems = data["numberOfFreeItems"];
            this.value = data["value"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferDto {
        let result = new OfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["discountPercent"] = this.discountPercent;
        data["discountAmmount"] = this.discountAmmount;
        if (this.primaryCategoryIdList && this.primaryCategoryIdList.constructor === Array) {
            data["primaryCategoryIdList"] = [];
            for (let item of this.primaryCategoryIdList)
                data["primaryCategoryIdList"].push(item);
        }
        if (this.secondaryCategoryIdList && this.secondaryCategoryIdList.constructor === Array) {
            data["secondaryCategoryIdList"] = [];
            for (let item of this.secondaryCategoryIdList)
                data["secondaryCategoryIdList"].push(item);
        }
        if (this.productCategoryIdList && this.productCategoryIdList.constructor === Array) {
            data["productCategoryIdList"] = [];
            for (let item of this.productCategoryIdList)
                data["productCategoryIdList"].push(item);
        }
        if (this.productIdList && this.productIdList.constructor === Array) {
            data["productIdList"] = [];
            for (let item of this.productIdList)
                data["productIdList"].push(item);
        }
        data["isExclude"] = this.isExclude;
        data["isInclude"] = this.isInclude;
        data["offerType"] = this.offerType;
        data["offerTypeText"] = this.offerTypeText;
        data["itemText"] = this.itemText;
        data["itemType"] = this.itemType;
        data["itemCode"] = this.itemCode;
        if (this.offerDetails && this.offerDetails.constructor === Array) {
            data["offerDetails"] = [];
            for (let item of this.offerDetails)
                data["offerDetails"].push(item.toJSON());
        }
        if (this.offerExcludes && this.offerExcludes.constructor === Array) {
            data["offerExcludes"] = [];
            for (let item of this.offerExcludes)
                data["offerExcludes"].push(item.toJSON());
        }
        if (this.offerIncludes && this.offerIncludes.constructor === Array) {
            data["offerIncludes"] = [];
            for (let item of this.offerIncludes)
                data["offerIncludes"].push(item.toJSON());
        }
        if (this.offerIncludeIds && this.offerIncludeIds.constructor === Array) {
            data["offerIncludeIds"] = [];
            for (let item of this.offerIncludeIds)
                data["offerIncludeIds"].push(item);
        }
        data["itemId"] = this.itemId;
        data["numberOfItems"] = this.numberOfItems;
        data["numberOfFreeItems"] = this.numberOfFreeItems;
        data["value"] = this.value;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferDto {
    from: moment.Moment;
    to: moment.Moment;
    discountPercent: number;
    discountAmmount: number;
    primaryCategoryIdList: number[];
    secondaryCategoryIdList: number[];
    productCategoryIdList: number[];
    productIdList: number[];
    isExclude: boolean;
    isInclude: boolean;
    offerType: OfferDtoOfferType;
    offerTypeText: string;
    itemText: string;
    itemType: OfferDtoItemType;
    itemCode: string;
    offerDetails: OfferDetailDto[];
    offerExcludes: OfferExcludeDto[];
    offerIncludes: OfferIncludeDto[];
    offerIncludeIds: number[];
    itemId: number;
    numberOfItems: number;
    numberOfFreeItems: number;
    value: number;
    storeIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferDetailDto implements IOfferDetailDto {
    id: number;
    itemCode: string;
    itemId: number;
    minQuantity: number;
    maxQuantity: number;
    offerId: number;

    constructor(data?: IOfferDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemCode = data["itemCode"];
            this.itemId = data["itemId"];
            this.minQuantity = data["minQuantity"];
            this.maxQuantity = data["maxQuantity"];
            this.offerId = data["offerId"];
        }
    }

    static fromJS(data: any): OfferDetailDto {
        let result = new OfferDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemCode"] = this.itemCode;
        data["itemId"] = this.itemId;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["offerId"] = this.offerId;
        return data; 
    }
}

export interface IOfferDetailDto {
    id: number;
    itemCode: string;
    itemId: number;
    minQuantity: number;
    maxQuantity: number;
    offerId: number;
}

export class OfferExcludeDto implements IOfferExcludeDto {
    id: number;
    itemCode: string;
    itemId: number;
    itemType: OfferExcludeDtoItemType;
    offerId: number;

    constructor(data?: IOfferExcludeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemCode = data["itemCode"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.offerId = data["offerId"];
        }
    }

    static fromJS(data: any): OfferExcludeDto {
        let result = new OfferExcludeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemCode"] = this.itemCode;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["offerId"] = this.offerId;
        return data; 
    }
}

export interface IOfferExcludeDto {
    id: number;
    itemCode: string;
    itemId: number;
    itemType: OfferExcludeDtoItemType;
    offerId: number;
}

export class OfferIncludeDto implements IOfferIncludeDto {
    itemId: number;
    offerId: number;

    constructor(data?: IOfferIncludeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
            this.offerId = data["offerId"];
        }
    }

    static fromJS(data: any): OfferIncludeDto {
        let result = new OfferIncludeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["offerId"] = this.offerId;
        return data; 
    }
}

export interface IOfferIncludeDto {
    itemId: number;
    offerId: number;
}

export class PagedOfferList implements IPagedOfferList {
    currentPage: number;
    itemsCount: number;
    offers: OfferDto[];

    constructor(data?: IPagedOfferList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["offers"] && data["offers"].constructor === Array) {
                this.offers = [];
                for (let item of data["offers"])
                    this.offers.push(OfferDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedOfferList {
        let result = new PagedOfferList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.offers && this.offers.constructor === Array) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedOfferList {
    currentPage: number;
    itemsCount: number;
    offers: OfferDto[];
}

export class OrderStatusRequest implements IOrderStatusRequest {
    id: string;
    status: number;
    reciptnumber: string;

    constructor(data?: IOrderStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status = data["status"];
            this.reciptnumber = data["reciptnumber"];
        }
    }

    static fromJS(data: any): OrderStatusRequest {
        let result = new OrderStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["reciptnumber"] = this.reciptnumber;
        return data; 
    }
}

export interface IOrderStatusRequest {
    id: string;
    status: number;
    reciptnumber: string;
}

export class CreateOrderWorkFlowInput implements ICreateOrderWorkFlowInput {
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    orderWorkFlowDetails: OrderWorkFlowDetailDto[];

    constructor(data?: ICreateOrderWorkFlowInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.workFlowTypeId = data["workFlowTypeId"];
            this.deviceId = data["deviceId"];
            if (data["orderWorkFlowDetails"] && data["orderWorkFlowDetails"].constructor === Array) {
                this.orderWorkFlowDetails = [];
                for (let item of data["orderWorkFlowDetails"])
                    this.orderWorkFlowDetails.push(OrderWorkFlowDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrderWorkFlowInput {
        let result = new CreateOrderWorkFlowInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["workFlowTypeId"] = this.workFlowTypeId;
        data["deviceId"] = this.deviceId;
        if (this.orderWorkFlowDetails && this.orderWorkFlowDetails.constructor === Array) {
            data["orderWorkFlowDetails"] = [];
            for (let item of this.orderWorkFlowDetails)
                data["orderWorkFlowDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrderWorkFlowInput {
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    orderWorkFlowDetails: OrderWorkFlowDetailDto[];
}

export class OrderWorkFlowDetailDto implements IOrderWorkFlowDetailDto {
    id: number;
    workFlowStepId: number;
    orderWorkFlowId: number;
    isActive: boolean;
    stepName: string;
    defaultPinCode: string;
    workFlowDetialDevices: number[];

    constructor(data?: IOrderWorkFlowDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.workFlowStepId = data["workFlowStepId"];
            this.orderWorkFlowId = data["orderWorkFlowId"];
            this.isActive = data["isActive"];
            this.stepName = data["stepName"];
            this.defaultPinCode = data["defaultPinCode"];
            if (data["workFlowDetialDevices"] && data["workFlowDetialDevices"].constructor === Array) {
                this.workFlowDetialDevices = [];
                for (let item of data["workFlowDetialDevices"])
                    this.workFlowDetialDevices.push(item);
            }
        }
    }

    static fromJS(data: any): OrderWorkFlowDetailDto {
        let result = new OrderWorkFlowDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workFlowStepId"] = this.workFlowStepId;
        data["orderWorkFlowId"] = this.orderWorkFlowId;
        data["isActive"] = this.isActive;
        data["stepName"] = this.stepName;
        data["defaultPinCode"] = this.defaultPinCode;
        if (this.workFlowDetialDevices && this.workFlowDetialDevices.constructor === Array) {
            data["workFlowDetialDevices"] = [];
            for (let item of this.workFlowDetialDevices)
                data["workFlowDetialDevices"].push(item);
        }
        return data; 
    }
}

export interface IOrderWorkFlowDetailDto {
    id: number;
    workFlowStepId: number;
    orderWorkFlowId: number;
    isActive: boolean;
    stepName: string;
    defaultPinCode: string;
    workFlowDetialDevices: number[];
}

export class OrderWorkFlowDto implements IOrderWorkFlowDto {
    id: number;
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    orderWorkFlowDetails: OrderWorkFlowDetailDto[];

    constructor(data?: IOrderWorkFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeId = data["storeId"];
            this.workFlowTypeId = data["workFlowTypeId"];
            this.deviceId = data["deviceId"];
            if (data["orderWorkFlowDetails"] && data["orderWorkFlowDetails"].constructor === Array) {
                this.orderWorkFlowDetails = [];
                for (let item of data["orderWorkFlowDetails"])
                    this.orderWorkFlowDetails.push(OrderWorkFlowDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderWorkFlowDto {
        let result = new OrderWorkFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["workFlowTypeId"] = this.workFlowTypeId;
        data["deviceId"] = this.deviceId;
        if (this.orderWorkFlowDetails && this.orderWorkFlowDetails.constructor === Array) {
            data["orderWorkFlowDetails"] = [];
            for (let item of this.orderWorkFlowDetails)
                data["orderWorkFlowDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderWorkFlowDto {
    id: number;
    storeId: number;
    workFlowTypeId: number;
    deviceId: number;
    orderWorkFlowDetails: OrderWorkFlowDetailDto[];
}

export class OrderWorkFlowPageDto implements IOrderWorkFlowPageDto {
    currentPage: number;
    itemsCount: number;
    workFlows: WorkFlowInfoDto[];

    constructor(data?: IOrderWorkFlowPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["workFlows"] && data["workFlows"].constructor === Array) {
                this.workFlows = [];
                for (let item of data["workFlows"])
                    this.workFlows.push(WorkFlowInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderWorkFlowPageDto {
        let result = new OrderWorkFlowPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.workFlows && this.workFlows.constructor === Array) {
            data["workFlows"] = [];
            for (let item of this.workFlows)
                data["workFlows"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderWorkFlowPageDto {
    currentPage: number;
    itemsCount: number;
    workFlows: WorkFlowInfoDto[];
}

export class UpdateOrderWorkFlowInput implements IUpdateOrderWorkFlowInput {
    id: number;
    storeId: number;
    deviceId: number;
    orderWorkFlowDetails: UpdateOrderWorkFlowDetailDto[];

    constructor(data?: IUpdateOrderWorkFlowInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeId = data["storeId"];
            this.deviceId = data["deviceId"];
            if (data["orderWorkFlowDetails"] && data["orderWorkFlowDetails"].constructor === Array) {
                this.orderWorkFlowDetails = [];
                for (let item of data["orderWorkFlowDetails"])
                    this.orderWorkFlowDetails.push(UpdateOrderWorkFlowDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateOrderWorkFlowInput {
        let result = new UpdateOrderWorkFlowInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["deviceId"] = this.deviceId;
        if (this.orderWorkFlowDetails && this.orderWorkFlowDetails.constructor === Array) {
            data["orderWorkFlowDetails"] = [];
            for (let item of this.orderWorkFlowDetails)
                data["orderWorkFlowDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateOrderWorkFlowInput {
    id: number;
    storeId: number;
    deviceId: number;
    orderWorkFlowDetails: UpdateOrderWorkFlowDetailDto[];
}

export class UpdateOrderWorkFlowDetailDto implements IUpdateOrderWorkFlowDetailDto {
    id: number;
    isActive: boolean;
    defaultPinCode: string;
    workFlowStepId: number;
    workFlowDetialDevices: number[];

    constructor(data?: IUpdateOrderWorkFlowDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.defaultPinCode = data["defaultPinCode"];
            this.workFlowStepId = data["workFlowStepId"];
            if (data["workFlowDetialDevices"] && data["workFlowDetialDevices"].constructor === Array) {
                this.workFlowDetialDevices = [];
                for (let item of data["workFlowDetialDevices"])
                    this.workFlowDetialDevices.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateOrderWorkFlowDetailDto {
        let result = new UpdateOrderWorkFlowDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["defaultPinCode"] = this.defaultPinCode;
        data["workFlowStepId"] = this.workFlowStepId;
        if (this.workFlowDetialDevices && this.workFlowDetialDevices.constructor === Array) {
            data["workFlowDetialDevices"] = [];
            for (let item of this.workFlowDetialDevices)
                data["workFlowDetialDevices"].push(item);
        }
        return data; 
    }
}

export interface IUpdateOrderWorkFlowDetailDto {
    id: number;
    isActive: boolean;
    defaultPinCode: string;
    workFlowStepId: number;
    workFlowDetialDevices: number[];
}

export class WorkFlowTypeItemDto implements IWorkFlowTypeItemDto {
    workFlowTypeId: number;
    type: WorkFlowTypeItemDtoType;
    steps: WorkFlowStepItemDto[];

    constructor(data?: IWorkFlowTypeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workFlowTypeId = data["workFlowTypeId"];
            this.type = data["type"];
            if (data["steps"] && data["steps"].constructor === Array) {
                this.steps = [];
                for (let item of data["steps"])
                    this.steps.push(WorkFlowStepItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkFlowTypeItemDto {
        let result = new WorkFlowTypeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFlowTypeId"] = this.workFlowTypeId;
        data["type"] = this.type;
        if (this.steps && this.steps.constructor === Array) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkFlowTypeItemDto {
    workFlowTypeId: number;
    type: WorkFlowTypeItemDtoType;
    steps: WorkFlowStepItemDto[];
}

export class WorkFlowStepItemDto implements IWorkFlowStepItemDto {
    workFlowStepId: number;
    stepName: string;
    deviceType: number;
    stepNumber: number;
    isMultipleDevice: boolean;
    isActive: boolean;

    constructor(data?: IWorkFlowStepItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workFlowStepId = data["workFlowStepId"];
            this.stepName = data["stepName"];
            this.deviceType = data["deviceType"];
            this.stepNumber = data["stepNumber"];
            this.isMultipleDevice = data["isMultipleDevice"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): WorkFlowStepItemDto {
        let result = new WorkFlowStepItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFlowStepId"] = this.workFlowStepId;
        data["stepName"] = this.stepName;
        data["deviceType"] = this.deviceType;
        data["stepNumber"] = this.stepNumber;
        data["isMultipleDevice"] = this.isMultipleDevice;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IWorkFlowStepItemDto {
    workFlowStepId: number;
    stepName: string;
    deviceType: number;
    stepNumber: number;
    isMultipleDevice: boolean;
    isActive: boolean;
}

export class OrderWorkflowDeviceDetailDto implements IOrderWorkflowDeviceDetailDto {
    stepNumber: number;
    defaultPinCode: string;
    ipAddress: string;
    portNumber: string;
    deviceType: number;

    constructor(data?: IOrderWorkflowDeviceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stepNumber = data["stepNumber"];
            this.defaultPinCode = data["defaultPinCode"];
            this.ipAddress = data["ipAddress"];
            this.portNumber = data["portNumber"];
            this.deviceType = data["deviceType"];
        }
    }

    static fromJS(data: any): OrderWorkflowDeviceDetailDto {
        let result = new OrderWorkflowDeviceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepNumber"] = this.stepNumber;
        data["defaultPinCode"] = this.defaultPinCode;
        data["ipAddress"] = this.ipAddress;
        data["portNumber"] = this.portNumber;
        data["deviceType"] = this.deviceType;
        return data; 
    }
}

export interface IOrderWorkflowDeviceDetailDto {
    stepNumber: number;
    defaultPinCode: string;
    ipAddress: string;
    portNumber: string;
    deviceType: number;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[];

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[];
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId: number;
    code: string;
    displayName: string;
    memberCount: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitDto {
    parentId: number;
    code: string;
    displayName: string;
    memberCount: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[];

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[];
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    addedTime: moment.Moment;
    id: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    addedTime: moment.Moment;
    id: number;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId: number;
    displayName: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number;
    displayName: string;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id: number;
    newParentId: number;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data; 
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds: number[];
    organizationUnitId: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["userIds"] && data["userIds"].constructor === Array) {
                this.userIds = [];
                for (let item of data["userIds"])
                    this.userIds.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.userIds && this.userIds.constructor === Array) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data; 
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[];
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;
}

export class TenantMenuItemSalePage implements ITenantMenuItemSalePage {
    summation: number;
    data: TenantMenuItemSaleDto[];
    totalCounts: number;
    pageNumber: number;
    totalQuanityt: number;

    constructor(data?: ITenantMenuItemSalePage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.summation = data["summation"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(TenantMenuItemSaleDto.fromJS(item));
            }
            this.totalCounts = data["totalCounts"];
            this.pageNumber = data["pageNumber"];
            this.totalQuanityt = data["totalQuanityt"];
        }
    }

    static fromJS(data: any): TenantMenuItemSalePage {
        let result = new TenantMenuItemSalePage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summation"] = this.summation;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCounts"] = this.totalCounts;
        data["pageNumber"] = this.pageNumber;
        data["totalQuanityt"] = this.totalQuanityt;
        return data; 
    }
}

export interface ITenantMenuItemSalePage {
    summation: number;
    data: TenantMenuItemSaleDto[];
    totalCounts: number;
    pageNumber: number;
    totalQuanityt: number;
}

export class TenantMenuItemSaleDto implements ITenantMenuItemSaleDto {
    tenant: string;
    storeNumber: string;
    storeName: string;
    recieptNumber: string;
    time: string;
    itemCode: string;
    itemName: string;
    quantity: number;
    price: number;
    netAmount: number;

    constructor(data?: ITenantMenuItemSaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenant = data["tenant"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.recieptNumber = data["recieptNumber"];
            this.time = data["time"];
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.netAmount = data["netAmount"];
        }
    }

    static fromJS(data: any): TenantMenuItemSaleDto {
        let result = new TenantMenuItemSaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["recieptNumber"] = this.recieptNumber;
        data["time"] = this.time;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["netAmount"] = this.netAmount;
        return data; 
    }
}

export interface ITenantMenuItemSaleDto {
    tenant: string;
    storeNumber: string;
    storeName: string;
    recieptNumber: string;
    time: string;
    itemCode: string;
    itemName: string;
    quantity: number;
    price: number;
    netAmount: number;
}

export class TenantMenuItemSaleSummaryPage implements ITenantMenuItemSaleSummaryPage {
    summation: number;
    data: TenantMenuItemSaleSummaryDto[];
    totalCounts: number;
    pageNumber: number;
    totalQuantity: number;

    constructor(data?: ITenantMenuItemSaleSummaryPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.summation = data["summation"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(TenantMenuItemSaleSummaryDto.fromJS(item));
            }
            this.totalCounts = data["totalCounts"];
            this.pageNumber = data["pageNumber"];
            this.totalQuantity = data["totalQuantity"];
        }
    }

    static fromJS(data: any): TenantMenuItemSaleSummaryPage {
        let result = new TenantMenuItemSaleSummaryPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summation"] = this.summation;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCounts"] = this.totalCounts;
        data["pageNumber"] = this.pageNumber;
        data["totalQuantity"] = this.totalQuantity;
        return data; 
    }
}

export interface ITenantMenuItemSaleSummaryPage {
    summation: number;
    data: TenantMenuItemSaleSummaryDto[];
    totalCounts: number;
    pageNumber: number;
    totalQuantity: number;
}

export class TenantMenuItemSaleSummaryDto implements ITenantMenuItemSaleSummaryDto {
    tenant: string;
    storeNumber: string;
    storeName: string;
    itemCode: string;
    itemName: string;
    quantity: number;
    price: number;
    netAmount: number;

    constructor(data?: ITenantMenuItemSaleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenant = data["tenant"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.netAmount = data["netAmount"];
        }
    }

    static fromJS(data: any): TenantMenuItemSaleSummaryDto {
        let result = new TenantMenuItemSaleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["netAmount"] = this.netAmount;
        return data; 
    }
}

export interface ITenantMenuItemSaleSummaryDto {
    tenant: string;
    storeNumber: string;
    storeName: string;
    itemCode: string;
    itemName: string;
    quantity: number;
    price: number;
    netAmount: number;
}

export class TenantSaleDetailsResultDto implements ITenantSaleDetailsResultDto {
    items: TenantSaleTransactionDto[];
    totalCount: number;
    pageNumber: number;
    totalSummation: number;
    totalQty: number;
    totalDiscount: number;

    constructor(data?: ITenantSaleDetailsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantSaleTransactionDto.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalSummation = data["totalSummation"];
            this.totalQty = data["totalQty"];
            this.totalDiscount = data["totalDiscount"];
        }
    }

    static fromJS(data: any): TenantSaleDetailsResultDto {
        let result = new TenantSaleDetailsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalSummation"] = this.totalSummation;
        data["totalQty"] = this.totalQty;
        data["totalDiscount"] = this.totalDiscount;
        return data; 
    }
}

export interface ITenantSaleDetailsResultDto {
    items: TenantSaleTransactionDto[];
    totalCount: number;
    pageNumber: number;
    totalSummation: number;
    totalQty: number;
    totalDiscount: number;
}

export class TenantSaleTransactionDto implements ITenantSaleTransactionDto {
    tenantName: string;
    storeNumber: string;
    storeName: string;
    recieptNumber: string;
    itemCode: string;
    itemName: string;
    date: string;
    price: number;
    quantity: number;
    total: number;

    constructor(data?: ITenantSaleTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.recieptNumber = data["recieptNumber"];
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.date = data["date"];
            this.price = data["price"];
            this.quantity = data["quantity"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): TenantSaleTransactionDto {
        let result = new TenantSaleTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["recieptNumber"] = this.recieptNumber;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["date"] = this.date;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        return data; 
    }
}

export interface ITenantSaleTransactionDto {
    tenantName: string;
    storeNumber: string;
    storeName: string;
    recieptNumber: string;
    itemCode: string;
    itemName: string;
    date: string;
    price: number;
    quantity: number;
    total: number;
}

export class StoresDayTotalSalesInputDto implements IStoresDayTotalSalesInputDto {
    tenantIds: number[];
    storeIds: number[];
    regionId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    isCSVFile: boolean;

    constructor(data?: IStoresDayTotalSalesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): StoresDayTotalSalesInputDto {
        let result = new StoresDayTotalSalesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IStoresDayTotalSalesInputDto {
    tenantIds: number[];
    storeIds: number[];
    regionId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    isCSVFile: boolean;
}

export class StoresDayTotalSalesPagedResult implements IStoresDayTotalSalesPagedResult {
    items: StoresDayTotalSalesDto[];
    totalCount: number;
    pageNumber: number;

    constructor(data?: IStoresDayTotalSalesPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(StoresDayTotalSalesDto.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
        }
    }

    static fromJS(data: any): StoresDayTotalSalesPagedResult {
        let result = new StoresDayTotalSalesPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        return data; 
    }
}

export interface IStoresDayTotalSalesPagedResult {
    items: StoresDayTotalSalesDto[];
    totalCount: number;
    pageNumber: number;
}

export class StoresDayTotalSalesDto implements IStoresDayTotalSalesDto {
    tenantName: string;
    storeNumber: string;
    storeName: string;
    total: number;
    totalVat: number;
    totalSales: number;
    busiDate: moment.Moment;

    constructor(data?: IStoresDayTotalSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.total = data["total"];
            this.totalVat = data["totalVat"];
            this.totalSales = data["totalSales"];
            this.busiDate = data["busiDate"] ? moment(data["busiDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StoresDayTotalSalesDto {
        let result = new StoresDayTotalSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["total"] = this.total;
        data["totalVat"] = this.totalVat;
        data["totalSales"] = this.totalSales;
        data["busiDate"] = this.busiDate ? this.busiDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStoresDayTotalSalesDto {
    tenantName: string;
    storeNumber: string;
    storeName: string;
    total: number;
    totalVat: number;
    totalSales: number;
    busiDate: moment.Moment;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data; 
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export class EditionSelectDto implements IEditionSelectDto {
    id: number;
    name: string;
    displayName: string;
    expiringEditionId: number;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    isFree: boolean;
    additionalData: AdditionalData;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string;
    displayName: string;
    expiringEditionId: number;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    isFree: boolean;
    additionalData: AdditionalData;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId: number;
    editionPaymentType: CreatePaymentDtoEditionPaymentType;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        return data; 
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: CreatePaymentDtoEditionPaymentType;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType;
}

export class ExecutePaymentDto implements IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType;
    editionId: number;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType;
    additionalData: { [key: string] : string; };

    constructor(data?: IExecutePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.editionPaymentType = data["editionPaymentType"];
            this.editionId = data["editionId"];
            this.paymentPeriodType = data["paymentPeriodType"];
            if (data["additionalData"]) {
                this.additionalData = {};
                for (let key in data["additionalData"]) {
                    if (data["additionalData"].hasOwnProperty(key))
                        this.additionalData[key] = data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecutePaymentDto {
        let result = new ExecutePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["editionPaymentType"] = this.editionPaymentType;
        data["editionId"] = this.editionId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    data["additionalData"][key] = this.additionalData[key];
            }
        }
        return data; 
    }
}

export interface IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType;
    editionId: number;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType;
    additionalData: { [key: string] : string; };
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[];

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[];
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway: string;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string;
    paymentId: string;
    payerId: string;
    status: string;
    editionDisplayName: string;
    tenantId: number;
    invoiceNo: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string;
    paymentId: string;
    payerId: string;
    status: string;
    editionDisplayName: string;
    tenantId: number;
    invoiceNo: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PCDto implements IPCDto {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    ipAddress: string;
    tenantId: number;
    printerIds: number[];
    cashDrawerIds: number[];
    magneticCardIds: number[];
    deviceMaskIds: number[];
    categoryIds: number[];
    tablesIds: number[];
    storeIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPCDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pcId = data["pcId"];
            this.machineName = data["machineName"];
            this.saleTypeId = data["saleTypeId"];
            this.ipAddress = data["ipAddress"];
            this.tenantId = data["tenantId"];
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["cashDrawerIds"] && data["cashDrawerIds"].constructor === Array) {
                this.cashDrawerIds = [];
                for (let item of data["cashDrawerIds"])
                    this.cashDrawerIds.push(item);
            }
            if (data["magneticCardIds"] && data["magneticCardIds"].constructor === Array) {
                this.magneticCardIds = [];
                for (let item of data["magneticCardIds"])
                    this.magneticCardIds.push(item);
            }
            if (data["deviceMaskIds"] && data["deviceMaskIds"].constructor === Array) {
                this.deviceMaskIds = [];
                for (let item of data["deviceMaskIds"])
                    this.deviceMaskIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            if (data["tablesIds"] && data["tablesIds"].constructor === Array) {
                this.tablesIds = [];
                for (let item of data["tablesIds"])
                    this.tablesIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PCDto {
        let result = new PCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcId"] = this.pcId;
        data["machineName"] = this.machineName;
        data["saleTypeId"] = this.saleTypeId;
        data["ipAddress"] = this.ipAddress;
        data["tenantId"] = this.tenantId;
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.cashDrawerIds && this.cashDrawerIds.constructor === Array) {
            data["cashDrawerIds"] = [];
            for (let item of this.cashDrawerIds)
                data["cashDrawerIds"].push(item);
        }
        if (this.magneticCardIds && this.magneticCardIds.constructor === Array) {
            data["magneticCardIds"] = [];
            for (let item of this.magneticCardIds)
                data["magneticCardIds"].push(item);
        }
        if (this.deviceMaskIds && this.deviceMaskIds.constructor === Array) {
            data["deviceMaskIds"] = [];
            for (let item of this.deviceMaskIds)
                data["deviceMaskIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (this.tablesIds && this.tablesIds.constructor === Array) {
            data["tablesIds"] = [];
            for (let item of this.tablesIds)
                data["tablesIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPCDto {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    ipAddress: string;
    tenantId: number;
    printerIds: number[];
    cashDrawerIds: number[];
    magneticCardIds: number[];
    deviceMaskIds: number[];
    categoryIds: number[];
    tablesIds: number[];
    storeIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfPCListItem implements IListResultDtoOfPCListItem {
    items: PCListItem[];

    constructor(data?: IListResultDtoOfPCListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PCListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPCListItem {
        let result = new ListResultDtoOfPCListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPCListItem {
    items: PCListItem[];
}

export class PCListItem implements IPCListItem {
    id: number;
    machineName: string;
    saleTypeId: number;
    ipAddress: string;
    tenantId: number;

    constructor(data?: IPCListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.machineName = data["machineName"];
            this.saleTypeId = data["saleTypeId"];
            this.ipAddress = data["ipAddress"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): PCListItem {
        let result = new PCListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["machineName"] = this.machineName;
        data["saleTypeId"] = this.saleTypeId;
        data["ipAddress"] = this.ipAddress;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IPCListItem {
    id: number;
    machineName: string;
    saleTypeId: number;
    ipAddress: string;
    tenantId: number;
}

export class PagedPCList implements IPagedPCList {
    currentPage: number;
    itemsCount: number;
    pCs: PCListItem[];

    constructor(data?: IPagedPCList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["pCs"] && data["pCs"].constructor === Array) {
                this.pCs = [];
                for (let item of data["pCs"])
                    this.pCs.push(PCListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPCList {
        let result = new PagedPCList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.pCs && this.pCs.constructor === Array) {
            data["pCs"] = [];
            for (let item of this.pCs)
                data["pCs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPCList {
    currentPage: number;
    itemsCount: number;
    pCs: PCListItem[];
}

export class ListResultDtoOfSaleTypeListItem implements IListResultDtoOfSaleTypeListItem {
    items: SaleTypeListItem[];

    constructor(data?: IListResultDtoOfSaleTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SaleTypeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSaleTypeListItem {
        let result = new ListResultDtoOfSaleTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSaleTypeListItem {
    items: SaleTypeListItem[];
}

export class ListResultDtoOfPCDeviceListItem implements IListResultDtoOfPCDeviceListItem {
    items: PCDeviceListItem[];

    constructor(data?: IListResultDtoOfPCDeviceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PCDeviceListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPCDeviceListItem {
        let result = new ListResultDtoOfPCDeviceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPCDeviceListItem {
    items: PCDeviceListItem[];
}

export class PCDeviceListItem implements IPCDeviceListItem {
    id: number;
    name: string;

    constructor(data?: IPCDeviceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): PCDeviceListItem {
        let result = new PCDeviceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IPCDeviceListItem {
    id: number;
    name: string;
}

export class CreatePCInput implements ICreatePCInput {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    pcDeviceIds: number[];
    ipAddress: string;
    tenantId: number;
    tableIds: number[];
    categoryIds: number[];
    storeIds: number[];

    constructor(data?: ICreatePCInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pcId = data["pcId"];
            this.machineName = data["machineName"];
            this.saleTypeId = data["saleTypeId"];
            if (data["pcDeviceIds"] && data["pcDeviceIds"].constructor === Array) {
                this.pcDeviceIds = [];
                for (let item of data["pcDeviceIds"])
                    this.pcDeviceIds.push(item);
            }
            this.ipAddress = data["ipAddress"];
            this.tenantId = data["tenantId"];
            if (data["tableIds"] && data["tableIds"].constructor === Array) {
                this.tableIds = [];
                for (let item of data["tableIds"])
                    this.tableIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePCInput {
        let result = new CreatePCInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcId"] = this.pcId;
        data["machineName"] = this.machineName;
        data["saleTypeId"] = this.saleTypeId;
        if (this.pcDeviceIds && this.pcDeviceIds.constructor === Array) {
            data["pcDeviceIds"] = [];
            for (let item of this.pcDeviceIds)
                data["pcDeviceIds"].push(item);
        }
        data["ipAddress"] = this.ipAddress;
        data["tenantId"] = this.tenantId;
        if (this.tableIds && this.tableIds.constructor === Array) {
            data["tableIds"] = [];
            for (let item of this.tableIds)
                data["tableIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreatePCInput {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    pcDeviceIds: number[];
    ipAddress: string;
    tenantId: number;
    tableIds: number[];
    categoryIds: number[];
    storeIds: number[];
}

export class UpdatePCInput implements IUpdatePCInput {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    pcDeviceIds: number[];
    ipAddress: string;
    tenantId: number;
    tableIds: number[];
    categoryIds: number[];
    storeIds: number[];

    constructor(data?: IUpdatePCInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pcId = data["pcId"];
            this.machineName = data["machineName"];
            this.saleTypeId = data["saleTypeId"];
            if (data["pcDeviceIds"] && data["pcDeviceIds"].constructor === Array) {
                this.pcDeviceIds = [];
                for (let item of data["pcDeviceIds"])
                    this.pcDeviceIds.push(item);
            }
            this.ipAddress = data["ipAddress"];
            this.tenantId = data["tenantId"];
            if (data["tableIds"] && data["tableIds"].constructor === Array) {
                this.tableIds = [];
                for (let item of data["tableIds"])
                    this.tableIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdatePCInput {
        let result = new UpdatePCInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcId"] = this.pcId;
        data["machineName"] = this.machineName;
        data["saleTypeId"] = this.saleTypeId;
        if (this.pcDeviceIds && this.pcDeviceIds.constructor === Array) {
            data["pcDeviceIds"] = [];
            for (let item of this.pcDeviceIds)
                data["pcDeviceIds"].push(item);
        }
        data["ipAddress"] = this.ipAddress;
        data["tenantId"] = this.tenantId;
        if (this.tableIds && this.tableIds.constructor === Array) {
            data["tableIds"] = [];
            for (let item of this.tableIds)
                data["tableIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdatePCInput {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    pcDeviceIds: number[];
    ipAddress: string;
    tenantId: number;
    tableIds: number[];
    categoryIds: number[];
    storeIds: number[];
}

export class CreatePeriodInput implements ICreatePeriodInput {
    translations: PeriodTranslationDto[];
    periodType: number;
    code: string;

    constructor(data?: ICreatePeriodInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PeriodTranslationDto.fromJS(item));
            }
            this.periodType = data["periodType"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): CreatePeriodInput {
        let result = new CreatePeriodInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["periodType"] = this.periodType;
        data["code"] = this.code;
        return data; 
    }
}

export interface ICreatePeriodInput {
    translations: PeriodTranslationDto[];
    periodType: number;
    code: string;
}

export class PeriodTranslationDto implements IPeriodTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IPeriodTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): PeriodTranslationDto {
        let result = new PeriodTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IPeriodTranslationDto {
    name: string;
    languageId: number;
}

export class PeriodDto implements IPeriodDto {
    id: number;
    tenantId: number;
    periodType: number;
    code: string;
    translations: PeriodTranslationDto[];

    constructor(data?: IPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.periodType = data["periodType"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PeriodTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PeriodDto {
        let result = new PeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["periodType"] = this.periodType;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPeriodDto {
    id: number;
    tenantId: number;
    periodType: number;
    code: string;
    translations: PeriodTranslationDto[];
}

export class UpdatePeriodDto implements IUpdatePeriodDto {
    id: number;
    translations: PeriodTranslationDto[];
    periodType: number;
    code: string;

    constructor(data?: IUpdatePeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PeriodTranslationDto.fromJS(item));
            }
            this.periodType = data["periodType"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): UpdatePeriodDto {
        let result = new UpdatePeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["periodType"] = this.periodType;
        data["code"] = this.code;
        return data; 
    }
}

export interface IUpdatePeriodDto {
    id: number;
    translations: PeriodTranslationDto[];
    periodType: number;
    code: string;
}

export class ListResultDtoOfPeriodListItem implements IListResultDtoOfPeriodListItem {
    items: PeriodListItem[];

    constructor(data?: IListResultDtoOfPeriodListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PeriodListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPeriodListItem {
        let result = new ListResultDtoOfPeriodListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPeriodListItem {
    items: PeriodListItem[];
}

export class PeriodListItem implements IPeriodListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IPeriodListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): PeriodListItem {
        let result = new PeriodListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IPeriodListItem {
    id: number;
    name: string;
    code: string;
}

export class PagedPeriodList implements IPagedPeriodList {
    currentPage: number;
    itemsCount: number;
    periods: PeriodListItem[];

    constructor(data?: IPagedPeriodList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["periods"] && data["periods"].constructor === Array) {
                this.periods = [];
                for (let item of data["periods"])
                    this.periods.push(PeriodListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPeriodList {
        let result = new PagedPeriodList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.periods && this.periods.constructor === Array) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPeriodList {
    currentPage: number;
    itemsCount: number;
    periods: PeriodListItem[];
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[];

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[];
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level: number;
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
    hasAddPermission: boolean;
    addPermissionValue: boolean;
    hasEditPermission: boolean;
    editPermissionValue: boolean;
    hasDeletePermission: boolean;
    deletePermissionValue: boolean;
    hasImportFilePermission: boolean;
    importFilePermissionValue: boolean;
    hasExportFilePermission: boolean;
    exportFilePermissionValue: boolean;
    hasViewPermission: boolean;
    viewPermissionValue: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
            this.hasAddPermission = data["hasAddPermission"];
            this.addPermissionValue = data["addPermissionValue"];
            this.hasEditPermission = data["hasEditPermission"];
            this.editPermissionValue = data["editPermissionValue"];
            this.hasDeletePermission = data["hasDeletePermission"];
            this.deletePermissionValue = data["deletePermissionValue"];
            this.hasImportFilePermission = data["hasImportFilePermission"];
            this.importFilePermissionValue = data["importFilePermissionValue"];
            this.hasExportFilePermission = data["hasExportFilePermission"];
            this.exportFilePermissionValue = data["exportFilePermissionValue"];
            this.hasViewPermission = data["hasViewPermission"];
            this.viewPermissionValue = data["viewPermissionValue"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        data["hasAddPermission"] = this.hasAddPermission;
        data["addPermissionValue"] = this.addPermissionValue;
        data["hasEditPermission"] = this.hasEditPermission;
        data["editPermissionValue"] = this.editPermissionValue;
        data["hasDeletePermission"] = this.hasDeletePermission;
        data["deletePermissionValue"] = this.deletePermissionValue;
        data["hasImportFilePermission"] = this.hasImportFilePermission;
        data["importFilePermissionValue"] = this.importFilePermissionValue;
        data["hasExportFilePermission"] = this.hasExportFilePermission;
        data["exportFilePermissionValue"] = this.exportFilePermissionValue;
        data["hasViewPermission"] = this.hasViewPermission;
        data["viewPermissionValue"] = this.viewPermissionValue;
        return data; 
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
    hasAddPermission: boolean;
    addPermissionValue: boolean;
    hasEditPermission: boolean;
    editPermissionValue: boolean;
    hasDeletePermission: boolean;
    deletePermissionValue: boolean;
    hasImportFilePermission: boolean;
    importFilePermissionValue: boolean;
    hasExportFilePermission: boolean;
    exportFilePermissionValue: boolean;
    hasViewPermission: boolean;
    viewPermissionValue: boolean;
}

export class CreatePluginScriptInput implements ICreatePluginScriptInput {
    tenantId: number;
    machineName: string;
    storeId: number;
    scriptId: number;
    executionTime: moment.Moment;
    errorMessage: string;
    version: string;

    constructor(data?: ICreatePluginScriptInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.machineName = data["machineName"];
            this.storeId = data["storeId"];
            this.scriptId = data["scriptId"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.errorMessage = data["errorMessage"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): CreatePluginScriptInput {
        let result = new CreatePluginScriptInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["machineName"] = this.machineName;
        data["storeId"] = this.storeId;
        data["scriptId"] = this.scriptId;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["version"] = this.version;
        return data; 
    }
}

export interface ICreatePluginScriptInput {
    tenantId: number;
    machineName: string;
    storeId: number;
    scriptId: number;
    executionTime: moment.Moment;
    errorMessage: string;
    version: string;
}

export class PluginScriptInput implements IPluginScriptInput {
    tenantId: number;
    storeId: number;
    machineName: string;
    version: string;

    constructor(data?: IPluginScriptInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.machineName = data["machineName"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): PluginScriptInput {
        let result = new PluginScriptInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["machineName"] = this.machineName;
        data["version"] = this.version;
        return data; 
    }
}

export interface IPluginScriptInput {
    tenantId: number;
    storeId: number;
    machineName: string;
    version: string;
}

export class PluginScriptDto implements IPluginScriptDto {
    id: number;
    scriptStr: string;

    constructor(data?: IPluginScriptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.scriptStr = data["scriptStr"];
        }
    }

    static fromJS(data: any): PluginScriptDto {
        let result = new PluginScriptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scriptStr"] = this.scriptStr;
        return data; 
    }
}

export interface IPluginScriptDto {
    id: number;
    scriptStr: string;
}

export class PluginSyncLogInput implements IPluginSyncLogInput {
    tenantIds: number[];
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    assemblyVersion: string;
    assemblyFileVersion: string;

    constructor(data?: IPluginSyncLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.assemblyVersion = data["assemblyVersion"];
            this.assemblyFileVersion = data["assemblyFileVersion"];
        }
    }

    static fromJS(data: any): PluginSyncLogInput {
        let result = new PluginSyncLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["assemblyVersion"] = this.assemblyVersion;
        data["assemblyFileVersion"] = this.assemblyFileVersion;
        return data; 
    }
}

export interface IPluginSyncLogInput {
    tenantIds: number[];
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    assemblyVersion: string;
    assemblyFileVersion: string;
}

export class PagedPluginSyncLogsList implements IPagedPluginSyncLogsList {
    currentPage: number;
    itemsCount: number;
    logs: PluginSyncLogListItem[];

    constructor(data?: IPagedPluginSyncLogsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["logs"] && data["logs"].constructor === Array) {
                this.logs = [];
                for (let item of data["logs"])
                    this.logs.push(PluginSyncLogListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPluginSyncLogsList {
        let result = new PagedPluginSyncLogsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.logs && this.logs.constructor === Array) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPluginSyncLogsList {
    currentPage: number;
    itemsCount: number;
    logs: PluginSyncLogListItem[];
}

export class PluginSyncLogListItem implements IPluginSyncLogListItem {
    id: number;
    tenantName: string;
    userName: string;
    storeCode: string;
    storeName: string;
    assemblyVersion: string;
    assemblyFileVersion: string;
    date: moment.Moment;

    constructor(data?: IPluginSyncLogListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantName = data["tenantName"];
            this.userName = data["userName"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.assemblyVersion = data["assemblyVersion"];
            this.assemblyFileVersion = data["assemblyFileVersion"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PluginSyncLogListItem {
        let result = new PluginSyncLogListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["userName"] = this.userName;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["assemblyVersion"] = this.assemblyVersion;
        data["assemblyFileVersion"] = this.assemblyFileVersion;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPluginSyncLogListItem {
    id: number;
    tenantName: string;
    userName: string;
    storeCode: string;
    storeName: string;
    assemblyVersion: string;
    assemblyFileVersion: string;
    date: moment.Moment;
}

export class CreatePluginSyncLogsInput implements ICreatePluginSyncLogsInput {
    userId: number;
    storeId: number;
    date: moment.Moment;
    assemblyVersion: string;
    assemblyFileVersion: string;

    constructor(data?: ICreatePluginSyncLogsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.storeId = data["storeId"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.assemblyVersion = data["assemblyVersion"];
            this.assemblyFileVersion = data["assemblyFileVersion"];
        }
    }

    static fromJS(data: any): CreatePluginSyncLogsInput {
        let result = new CreatePluginSyncLogsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["storeId"] = this.storeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["assemblyVersion"] = this.assemblyVersion;
        data["assemblyFileVersion"] = this.assemblyFileVersion;
        return data; 
    }
}

export interface ICreatePluginSyncLogsInput {
    userId: number;
    storeId: number;
    date: moment.Moment;
    assemblyVersion: string;
    assemblyFileVersion: string;
}

export class PointDto implements IPointDto {
    productPoints: number;
    customerPoints: number;
    productId: number;
    productUnitOfMeasureConversionId: number;
    productVariantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productPoints = data["productPoints"];
            this.customerPoints = data["customerPoints"];
            this.productId = data["productId"];
            this.productUnitOfMeasureConversionId = data["productUnitOfMeasureConversionId"];
            this.productVariantId = data["productVariantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PointDto {
        let result = new PointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productPoints"] = this.productPoints;
        data["customerPoints"] = this.customerPoints;
        data["productId"] = this.productId;
        data["productUnitOfMeasureConversionId"] = this.productUnitOfMeasureConversionId;
        data["productVariantId"] = this.productVariantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPointDto {
    productPoints: number;
    customerPoints: number;
    productId: number;
    productUnitOfMeasureConversionId: number;
    productVariantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfPointListItem implements IListResultDtoOfPointListItem {
    items: PointListItem[];

    constructor(data?: IListResultDtoOfPointListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PointListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPointListItem {
        let result = new ListResultDtoOfPointListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPointListItem {
    items: PointListItem[];
}

export class PointListItem implements IPointListItem {
    id: number;
    productPoints: number;
    customerPoints: number;
    productName: string;
    unitOfMeasureName: string;
    variantName: string;

    constructor(data?: IPointListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.productPoints = data["productPoints"];
            this.customerPoints = data["customerPoints"];
            this.productName = data["productName"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.variantName = data["variantName"];
        }
    }

    static fromJS(data: any): PointListItem {
        let result = new PointListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productPoints"] = this.productPoints;
        data["customerPoints"] = this.customerPoints;
        data["productName"] = this.productName;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["variantName"] = this.variantName;
        return data; 
    }
}

export interface IPointListItem {
    id: number;
    productPoints: number;
    customerPoints: number;
    productName: string;
    unitOfMeasureName: string;
    variantName: string;
}

export class PagedPointList implements IPagedPointList {
    currentPage: number;
    itemsCount: number;
    points: PointListItem[];

    constructor(data?: IPagedPointList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["points"] && data["points"].constructor === Array) {
                this.points = [];
                for (let item of data["points"])
                    this.points.push(PointListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPointList {
        let result = new PagedPointList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.points && this.points.constructor === Array) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPointList {
    currentPage: number;
    itemsCount: number;
    points: PointListItem[];
}

export class CreatePointInput implements ICreatePointInput {
    productPoints: number;
    customerPoints: number;
    productId: number;
    productUnitOfMeasureConversionId: number;
    productVariantId: number;

    constructor(data?: ICreatePointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productPoints = data["productPoints"];
            this.customerPoints = data["customerPoints"];
            this.productId = data["productId"];
            this.productUnitOfMeasureConversionId = data["productUnitOfMeasureConversionId"];
            this.productVariantId = data["productVariantId"];
        }
    }

    static fromJS(data: any): CreatePointInput {
        let result = new CreatePointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productPoints"] = this.productPoints;
        data["customerPoints"] = this.customerPoints;
        data["productId"] = this.productId;
        data["productUnitOfMeasureConversionId"] = this.productUnitOfMeasureConversionId;
        data["productVariantId"] = this.productVariantId;
        return data; 
    }
}

export interface ICreatePointInput {
    productPoints: number;
    customerPoints: number;
    productId: number;
    productUnitOfMeasureConversionId: number;
    productVariantId: number;
}

export class UpdatePointInput implements IUpdatePointInput {
    id: number;
    productPoints: number;
    customerPoints: number;
    productId: number;
    productUnitOfMeasureConversionId: number;
    productVariantId: number;

    constructor(data?: IUpdatePointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.productPoints = data["productPoints"];
            this.customerPoints = data["customerPoints"];
            this.productId = data["productId"];
            this.productUnitOfMeasureConversionId = data["productUnitOfMeasureConversionId"];
            this.productVariantId = data["productVariantId"];
        }
    }

    static fromJS(data: any): UpdatePointInput {
        let result = new UpdatePointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productPoints"] = this.productPoints;
        data["customerPoints"] = this.customerPoints;
        data["productId"] = this.productId;
        data["productUnitOfMeasureConversionId"] = this.productUnitOfMeasureConversionId;
        data["productVariantId"] = this.productVariantId;
        return data; 
    }
}

export interface IUpdatePointInput {
    id: number;
    productPoints: number;
    customerPoints: number;
    productId: number;
    productUnitOfMeasureConversionId: number;
    productVariantId: number;
}

export class ReOrderMaterialDto implements IReOrderMaterialDto {
    materialsCount: number;
    storeId: number;
    storeNumber: string;
    storeName: string;

    constructor(data?: IReOrderMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialsCount = data["materialsCount"];
            this.storeId = data["storeId"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
        }
    }

    static fromJS(data: any): ReOrderMaterialDto {
        let result = new ReOrderMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialsCount"] = this.materialsCount;
        data["storeId"] = this.storeId;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        return data; 
    }
}

export interface IReOrderMaterialDto {
    materialsCount: number;
    storeId: number;
    storeNumber: string;
    storeName: string;
}

export class DeviceStatusDto implements IDeviceStatusDto {
    deviceId: string;
    isOnline: boolean;
    exists: boolean;
    lastSeenUtc: moment.Moment;
    platform: string;
    appVersion: string;
    siteId: string;
    storeId: string;

    constructor(data?: IDeviceStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.isOnline = data["isOnline"];
            this.exists = data["exists"];
            this.lastSeenUtc = data["lastSeenUtc"] ? moment(data["lastSeenUtc"].toString()) : <any>undefined;
            this.platform = data["platform"];
            this.appVersion = data["appVersion"];
            this.siteId = data["siteId"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): DeviceStatusDto {
        let result = new DeviceStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["isOnline"] = this.isOnline;
        data["exists"] = this.exists;
        data["lastSeenUtc"] = this.lastSeenUtc ? this.lastSeenUtc.toISOString() : <any>undefined;
        data["platform"] = this.platform;
        data["appVersion"] = this.appVersion;
        data["siteId"] = this.siteId;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IDeviceStatusDto {
    deviceId: string;
    isOnline: boolean;
    exists: boolean;
    lastSeenUtc: moment.Moment;
    platform: string;
    appVersion: string;
    siteId: string;
    storeId: string;
}

export class EnqueueCommandInput implements IEnqueueCommandInput {
    targetType: string;
    targetId: string;
    type: string;
    payload: string;
    expiresAtUtc: moment.Moment;
    requestedBy: string;

    constructor(data?: IEnqueueCommandInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetType = data["targetType"];
            this.targetId = data["targetId"];
            this.type = data["type"];
            this.payload = data["payload"];
            this.expiresAtUtc = data["expiresAtUtc"] ? moment(data["expiresAtUtc"].toString()) : <any>undefined;
            this.requestedBy = data["requestedBy"];
        }
    }

    static fromJS(data: any): EnqueueCommandInput {
        let result = new EnqueueCommandInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetType"] = this.targetType;
        data["targetId"] = this.targetId;
        data["type"] = this.type;
        data["payload"] = this.payload;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toISOString() : <any>undefined;
        data["requestedBy"] = this.requestedBy;
        return data; 
    }
}

export interface IEnqueueCommandInput {
    targetType: string;
    targetId: string;
    type: string;
    payload: string;
    expiresAtUtc: moment.Moment;
    requestedBy: string;
}

export class EnqueueCommandResultDto implements IEnqueueCommandResultDto {
    commandId: string;
    status: string;

    constructor(data?: IEnqueueCommandResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commandId = data["commandId"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): EnqueueCommandResultDto {
        let result = new EnqueueCommandResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandId"] = this.commandId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IEnqueueCommandResultDto {
    commandId: string;
    status: string;
}

export class PriceListDTO implements IPriceListDTO {
    code: string;
    translations: PriceListTranslationDTO[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPriceListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PriceListTranslationDTO.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PriceListDTO {
        let result = new PriceListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPriceListDTO {
    code: string;
    translations: PriceListTranslationDTO[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PriceListTranslationDTO implements IPriceListTranslationDTO {
    name: string;
    languageId: number;

    constructor(data?: IPriceListTranslationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): PriceListTranslationDTO {
        let result = new PriceListTranslationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IPriceListTranslationDTO {
    name: string;
    languageId: number;
}

export class ListResultDtoOfPriceListListItem implements IListResultDtoOfPriceListListItem {
    items: PriceListListItem[];

    constructor(data?: IListResultDtoOfPriceListListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PriceListListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPriceListListItem {
        let result = new ListResultDtoOfPriceListListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPriceListListItem {
    items: PriceListListItem[];
}

export class PriceListListItem implements IPriceListListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IPriceListListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): PriceListListItem {
        let result = new PriceListListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IPriceListListItem {
    id: number;
    name: string;
    code: string;
}

export class PagedPriceList implements IPagedPriceList {
    currentPage: number;
    itemsCount: number;
    prices: PriceListListItem[];

    constructor(data?: IPagedPriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["prices"] && data["prices"].constructor === Array) {
                this.prices = [];
                for (let item of data["prices"])
                    this.prices.push(PriceListListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPriceList {
        let result = new PagedPriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.prices && this.prices.constructor === Array) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPriceList {
    currentPage: number;
    itemsCount: number;
    prices: PriceListListItem[];
}

export class CreatePriceListDTO implements ICreatePriceListDTO {
    code: string;
    translations: PriceListTranslationDTO[];

    constructor(data?: ICreatePriceListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PriceListTranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePriceListDTO {
        let result = new CreatePriceListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreatePriceListDTO {
    code: string;
    translations: PriceListTranslationDTO[];
}

export class UpdatePriceListDTO implements IUpdatePriceListDTO {
    id: number;
    code: string;
    translations: PriceListTranslationDTO[];

    constructor(data?: IUpdatePriceListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PriceListTranslationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePriceListDTO {
        let result = new UpdatePriceListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePriceListDTO {
    id: number;
    code: string;
    translations: PriceListTranslationDTO[];
}

export class PrimaryCategoryDto implements IPrimaryCategoryDto {
    code: string;
    translations: PrimaryCategoryTranslationDto[];
    imageId: string;
    imageSrcUrl: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrimaryCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PrimaryCategoryTranslationDto.fromJS(item));
            }
            this.imageId = data["imageId"];
            this.imageSrcUrl = data["imageSrcUrl"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrimaryCategoryDto {
        let result = new PrimaryCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["imageId"] = this.imageId;
        data["imageSrcUrl"] = this.imageSrcUrl;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrimaryCategoryDto {
    code: string;
    translations: PrimaryCategoryTranslationDto[];
    imageId: string;
    imageSrcUrl: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PrimaryCategoryTranslationDto implements IPrimaryCategoryTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IPrimaryCategoryTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): PrimaryCategoryTranslationDto {
        let result = new PrimaryCategoryTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IPrimaryCategoryTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfPrimaryCategoryListItem implements IListResultDtoOfPrimaryCategoryListItem {
    items: PrimaryCategoryListItem[];

    constructor(data?: IListResultDtoOfPrimaryCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PrimaryCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPrimaryCategoryListItem {
        let result = new ListResultDtoOfPrimaryCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPrimaryCategoryListItem {
    items: PrimaryCategoryListItem[];
}

export class PagedPrimaryCategoryList implements IPagedPrimaryCategoryList {
    currentPage: number;
    itemsCount: number;
    primaryCategories: PrimaryCategoryListItem[];

    constructor(data?: IPagedPrimaryCategoryList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["primaryCategories"] && data["primaryCategories"].constructor === Array) {
                this.primaryCategories = [];
                for (let item of data["primaryCategories"])
                    this.primaryCategories.push(PrimaryCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPrimaryCategoryList {
        let result = new PagedPrimaryCategoryList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.primaryCategories && this.primaryCategories.constructor === Array) {
            data["primaryCategories"] = [];
            for (let item of this.primaryCategories)
                data["primaryCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPrimaryCategoryList {
    currentPage: number;
    itemsCount: number;
    primaryCategories: PrimaryCategoryListItem[];
}

export class CreatePrimaryCategoryInput implements ICreatePrimaryCategoryInput {
    code: string;
    translations: PrimaryCategoryTranslationDto[];

    constructor(data?: ICreatePrimaryCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PrimaryCategoryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePrimaryCategoryInput {
        let result = new CreatePrimaryCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreatePrimaryCategoryInput {
    code: string;
    translations: PrimaryCategoryTranslationDto[];
}

export class UpdatePrimaryCategoryInput implements IUpdatePrimaryCategoryInput {
    id: number;
    code: string;
    translations: PrimaryCategoryTranslationDto[];

    constructor(data?: IUpdatePrimaryCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PrimaryCategoryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePrimaryCategoryInput {
        let result = new UpdatePrimaryCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePrimaryCategoryInput {
    id: number;
    code: string;
    translations: PrimaryCategoryTranslationDto[];
}

export class ListResultDtoOfProductCategoryListItem implements IListResultDtoOfProductCategoryListItem {
    items: ProductCategoryListItem[];

    constructor(data?: IListResultDtoOfProductCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProductCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProductCategoryListItem {
        let result = new ListResultDtoOfProductCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProductCategoryListItem {
    items: ProductCategoryListItem[];
}

export class PagedProductCategoriesList implements IPagedProductCategoriesList {
    currentPage: number;
    itemsCount: number;
    productCategories: ProductCategoryListItem[];

    constructor(data?: IPagedProductCategoriesList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(ProductCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedProductCategoriesList {
        let result = new PagedProductCategoriesList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedProductCategoriesList {
    currentPage: number;
    itemsCount: number;
    productCategories: ProductCategoryListItem[];
}

export class ProductCategoryDto implements IProductCategoryDto {
    secondaryCategoryId: number;
    parentCategoryId: number;
    code: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    translations: ProductCategoryTranslationDto[];
    storeIds: number[];
    imageSrcUrl: string;
    printerIds: number[];
    levelsId: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.parentCategoryId = data["parentCategoryId"];
            this.code = data["code"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductCategoryTranslationDto.fromJS(item));
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.imageSrcUrl = data["imageSrcUrl"];
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["levelsId"] && data["levelsId"].constructor === Array) {
                this.levelsId = [];
                for (let item of data["levelsId"])
                    this.levelsId.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryDto {
        let result = new ProductCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["parentCategoryId"] = this.parentCategoryId;
        data["code"] = this.code;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["imageSrcUrl"] = this.imageSrcUrl;
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.levelsId && this.levelsId.constructor === Array) {
            data["levelsId"] = [];
            for (let item of this.levelsId)
                data["levelsId"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryDto {
    secondaryCategoryId: number;
    parentCategoryId: number;
    code: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    translations: ProductCategoryTranslationDto[];
    storeIds: number[];
    imageSrcUrl: string;
    printerIds: number[];
    levelsId: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategoryTranslationDto implements IProductCategoryTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IProductCategoryTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ProductCategoryTranslationDto {
        let result = new ProductCategoryTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IProductCategoryTranslationDto {
    name: string;
    languageId: number;
}

export class CreateProductCategoryInput implements ICreateProductCategoryInput {
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    secondaryCategoryId: number;
    parentCategoryId: number;
    printerIds: number[];
    storeIds: number[];
    code: string;
    translations: ProductCategoryTranslationDto[];

    constructor(data?: ICreateProductCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.parentCategoryId = data["parentCategoryId"];
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductCategoryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProductCategoryInput {
        let result = new CreateProductCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["parentCategoryId"] = this.parentCategoryId;
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateProductCategoryInput {
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    secondaryCategoryId: number;
    parentCategoryId: number;
    printerIds: number[];
    storeIds: number[];
    code: string;
    translations: ProductCategoryTranslationDto[];
}

export class UpdateProductCategoryInput implements IUpdateProductCategoryInput {
    id: number;
    parentCategoryId: number;
    secondaryCategoryId: number;
    printerIds: number[];
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    storeIds: number[];
    code: string;
    translations: ProductCategoryTranslationDto[];

    constructor(data?: IUpdateProductCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.parentCategoryId = data["parentCategoryId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductCategoryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProductCategoryInput {
        let result = new UpdateProductCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentCategoryId"] = this.parentCategoryId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateProductCategoryInput {
    id: number;
    parentCategoryId: number;
    secondaryCategoryId: number;
    printerIds: number[];
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    storeIds: number[];
    code: string;
    translations: ProductCategoryTranslationDto[];
}

export class ListResultDtoOfGetProductOutput implements IListResultDtoOfGetProductOutput {
    items: GetProductOutput[];

    constructor(data?: IListResultDtoOfGetProductOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProductOutput {
        let result = new ListResultDtoOfGetProductOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProductOutput {
    items: GetProductOutput[];
}

export class PagedProductsList implements IPagedProductsList {
    currentPage: number;
    itemsCount: number;
    products: ProductListItem[];

    constructor(data?: IPagedProductsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(ProductListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedProductsList {
        let result = new PagedProductsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedProductsList {
    currentPage: number;
    itemsCount: number;
    products: ProductListItem[];
}

export class CreateProductInput implements ICreateProductInput {
    code: string;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    cost: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    hasVariants: boolean;
    isService: boolean;
    isHidden: boolean;
    selectedVendorsIds: number[];
    selectedTaxesIds: number[];
    selectedAttributesIds: number[];
    translations: ProductTranslationDto[];
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    variants: ProductVariantsDto;

    constructor(data?: ICreateProductInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.referenceNumber = data["referenceNumber"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.cost = data["cost"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.productCategoryId = data["productCategoryId"];
            this.hasVariants = data["hasVariants"];
            this.isService = data["isService"];
            this.isHidden = data["isHidden"];
            if (data["selectedVendorsIds"] && data["selectedVendorsIds"].constructor === Array) {
                this.selectedVendorsIds = [];
                for (let item of data["selectedVendorsIds"])
                    this.selectedVendorsIds.push(item);
            }
            if (data["selectedTaxesIds"] && data["selectedTaxesIds"].constructor === Array) {
                this.selectedTaxesIds = [];
                for (let item of data["selectedTaxesIds"])
                    this.selectedTaxesIds.push(item);
            }
            if (data["selectedAttributesIds"] && data["selectedAttributesIds"].constructor === Array) {
                this.selectedAttributesIds = [];
                for (let item of data["selectedAttributesIds"])
                    this.selectedAttributesIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductTranslationDto.fromJS(item));
            }
            this.unitsOfMeasure = data["unitsOfMeasure"] ? ProductUnitsOfMeasureDto.fromJS(data["unitsOfMeasure"]) : <any>undefined;
            this.variants = data["variants"] ? ProductVariantsDto.fromJS(data["variants"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateProductInput {
        let result = new CreateProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["referenceNumber"] = this.referenceNumber;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["cost"] = this.cost;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["productCategoryId"] = this.productCategoryId;
        data["hasVariants"] = this.hasVariants;
        data["isService"] = this.isService;
        data["isHidden"] = this.isHidden;
        if (this.selectedVendorsIds && this.selectedVendorsIds.constructor === Array) {
            data["selectedVendorsIds"] = [];
            for (let item of this.selectedVendorsIds)
                data["selectedVendorsIds"].push(item);
        }
        if (this.selectedTaxesIds && this.selectedTaxesIds.constructor === Array) {
            data["selectedTaxesIds"] = [];
            for (let item of this.selectedTaxesIds)
                data["selectedTaxesIds"].push(item);
        }
        if (this.selectedAttributesIds && this.selectedAttributesIds.constructor === Array) {
            data["selectedAttributesIds"] = [];
            for (let item of this.selectedAttributesIds)
                data["selectedAttributesIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["unitsOfMeasure"] = this.unitsOfMeasure ? this.unitsOfMeasure.toJSON() : <any>undefined;
        data["variants"] = this.variants ? this.variants.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateProductInput {
    code: string;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    cost: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    hasVariants: boolean;
    isService: boolean;
    isHidden: boolean;
    selectedVendorsIds: number[];
    selectedTaxesIds: number[];
    selectedAttributesIds: number[];
    translations: ProductTranslationDto[];
    unitsOfMeasure: ProductUnitsOfMeasureDto;
    variants: ProductVariantsDto;
}

export class UpdateProductInput implements IUpdateProductInput {
    id: number;
    code: string;
    cost: number;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    hasVariants: boolean;
    isHidden: boolean;
    isService: boolean;
    selectedTaxesIds: number[];
    selectedVendorsIds: number[];
    selectedAttributesIds: number[];
    translations: ProductTranslationDto[];
    variants: ProductVariantsDto;

    constructor(data?: IUpdateProductInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.cost = data["cost"];
            this.referenceNumber = data["referenceNumber"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.productCategoryId = data["productCategoryId"];
            this.hasVariants = data["hasVariants"];
            this.isHidden = data["isHidden"];
            this.isService = data["isService"];
            if (data["selectedTaxesIds"] && data["selectedTaxesIds"].constructor === Array) {
                this.selectedTaxesIds = [];
                for (let item of data["selectedTaxesIds"])
                    this.selectedTaxesIds.push(item);
            }
            if (data["selectedVendorsIds"] && data["selectedVendorsIds"].constructor === Array) {
                this.selectedVendorsIds = [];
                for (let item of data["selectedVendorsIds"])
                    this.selectedVendorsIds.push(item);
            }
            if (data["selectedAttributesIds"] && data["selectedAttributesIds"].constructor === Array) {
                this.selectedAttributesIds = [];
                for (let item of data["selectedAttributesIds"])
                    this.selectedAttributesIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductTranslationDto.fromJS(item));
            }
            this.variants = data["variants"] ? ProductVariantsDto.fromJS(data["variants"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateProductInput {
        let result = new UpdateProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["cost"] = this.cost;
        data["referenceNumber"] = this.referenceNumber;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["productCategoryId"] = this.productCategoryId;
        data["hasVariants"] = this.hasVariants;
        data["isHidden"] = this.isHidden;
        data["isService"] = this.isService;
        if (this.selectedTaxesIds && this.selectedTaxesIds.constructor === Array) {
            data["selectedTaxesIds"] = [];
            for (let item of this.selectedTaxesIds)
                data["selectedTaxesIds"].push(item);
        }
        if (this.selectedVendorsIds && this.selectedVendorsIds.constructor === Array) {
            data["selectedVendorsIds"] = [];
            for (let item of this.selectedVendorsIds)
                data["selectedVendorsIds"].push(item);
        }
        if (this.selectedAttributesIds && this.selectedAttributesIds.constructor === Array) {
            data["selectedAttributesIds"] = [];
            for (let item of this.selectedAttributesIds)
                data["selectedAttributesIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["variants"] = this.variants ? this.variants.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateProductInput {
    id: number;
    code: string;
    cost: number;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    hasVariants: boolean;
    isHidden: boolean;
    isService: boolean;
    selectedTaxesIds: number[];
    selectedVendorsIds: number[];
    selectedAttributesIds: number[];
    translations: ProductTranslationDto[];
    variants: ProductVariantsDto;
}

export class GetProductUnitsOfMeasureOutput implements IGetProductUnitsOfMeasureOutput {
    productId: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    hasVAT: boolean;
    vatValue: number;
    baseUnitOfMeasureId: number;
    alternateUnitsOfMeasure: UnitOfMeasureConversionDto[];

    constructor(data?: IGetProductUnitsOfMeasureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.code = data["code"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.hasVAT = data["hasVAT"];
            this.vatValue = data["vatValue"];
            this.baseUnitOfMeasureId = data["baseUnitOfMeasureId"];
            if (data["alternateUnitsOfMeasure"] && data["alternateUnitsOfMeasure"].constructor === Array) {
                this.alternateUnitsOfMeasure = [];
                for (let item of data["alternateUnitsOfMeasure"])
                    this.alternateUnitsOfMeasure.push(UnitOfMeasureConversionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductUnitsOfMeasureOutput {
        let result = new GetProductUnitsOfMeasureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["code"] = this.code;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["hasVAT"] = this.hasVAT;
        data["vatValue"] = this.vatValue;
        data["baseUnitOfMeasureId"] = this.baseUnitOfMeasureId;
        if (this.alternateUnitsOfMeasure && this.alternateUnitsOfMeasure.constructor === Array) {
            data["alternateUnitsOfMeasure"] = [];
            for (let item of this.alternateUnitsOfMeasure)
                data["alternateUnitsOfMeasure"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetProductUnitsOfMeasureOutput {
    productId: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    hasVAT: boolean;
    vatValue: number;
    baseUnitOfMeasureId: number;
    alternateUnitsOfMeasure: UnitOfMeasureConversionDto[];
}

export class UpdateProductUnitsOfMeasureInput implements IUpdateProductUnitsOfMeasureInput {
    productId: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    hasVAT: boolean;
    vatValue: number;
    baseUnitOfMeasureId: number;
    alternateUnitsOfMeasure: UnitOfMeasureConversionDto[];

    constructor(data?: IUpdateProductUnitsOfMeasureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.code = data["code"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.hasVAT = data["hasVAT"];
            this.vatValue = data["vatValue"];
            this.baseUnitOfMeasureId = data["baseUnitOfMeasureId"];
            if (data["alternateUnitsOfMeasure"] && data["alternateUnitsOfMeasure"].constructor === Array) {
                this.alternateUnitsOfMeasure = [];
                for (let item of data["alternateUnitsOfMeasure"])
                    this.alternateUnitsOfMeasure.push(UnitOfMeasureConversionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProductUnitsOfMeasureInput {
        let result = new UpdateProductUnitsOfMeasureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["code"] = this.code;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["hasVAT"] = this.hasVAT;
        data["vatValue"] = this.vatValue;
        data["baseUnitOfMeasureId"] = this.baseUnitOfMeasureId;
        if (this.alternateUnitsOfMeasure && this.alternateUnitsOfMeasure.constructor === Array) {
            data["alternateUnitsOfMeasure"] = [];
            for (let item of this.alternateUnitsOfMeasure)
                data["alternateUnitsOfMeasure"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateProductUnitsOfMeasureInput {
    productId: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    hasVAT: boolean;
    vatValue: number;
    baseUnitOfMeasureId: number;
    alternateUnitsOfMeasure: UnitOfMeasureConversionDto[];
}

export class GetProductVariantsOutput implements IGetProductVariantsOutput {
    productId: number;
    variants: ProductVariantDto[];

    constructor(data?: IGetProductVariantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            if (data["variants"] && data["variants"].constructor === Array) {
                this.variants = [];
                for (let item of data["variants"])
                    this.variants.push(ProductVariantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductVariantsOutput {
        let result = new GetProductVariantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        if (this.variants && this.variants.constructor === Array) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetProductVariantsOutput {
    productId: number;
    variants: ProductVariantDto[];
}

export class UpdateProductVariantsInput implements IUpdateProductVariantsInput {
    productId: number;
    variants: ProductVariantDto[];

    constructor(data?: IUpdateProductVariantsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            if (data["variants"] && data["variants"].constructor === Array) {
                this.variants = [];
                for (let item of data["variants"])
                    this.variants.push(ProductVariantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProductVariantsInput {
        let result = new UpdateProductVariantsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        if (this.variants && this.variants.constructor === Array) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateProductVariantsInput {
    productId: number;
    variants: ProductVariantDto[];
}

export class GetProductLimitsOutput implements IGetProductLimitsOutput {
    productId: number;
    purchaseLimit: number;
    saleLimit: number;

    constructor(data?: IGetProductLimitsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.purchaseLimit = data["purchaseLimit"];
            this.saleLimit = data["saleLimit"];
        }
    }

    static fromJS(data: any): GetProductLimitsOutput {
        let result = new GetProductLimitsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["purchaseLimit"] = this.purchaseLimit;
        data["saleLimit"] = this.saleLimit;
        return data; 
    }
}

export interface IGetProductLimitsOutput {
    productId: number;
    purchaseLimit: number;
    saleLimit: number;
}

export class UpdateProductLimitsInput implements IUpdateProductLimitsInput {
    productId: number;
    purchaseLimit: number;
    saleLimit: number;

    constructor(data?: IUpdateProductLimitsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.purchaseLimit = data["purchaseLimit"];
            this.saleLimit = data["saleLimit"];
        }
    }

    static fromJS(data: any): UpdateProductLimitsInput {
        let result = new UpdateProductLimitsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["purchaseLimit"] = this.purchaseLimit;
        data["saleLimit"] = this.saleLimit;
        return data; 
    }
}

export interface IUpdateProductLimitsInput {
    productId: number;
    purchaseLimit: number;
    saleLimit: number;
}

export class ListResultDtoOfProductSerialItem implements IListResultDtoOfProductSerialItem {
    items: ProductSerialItem[];

    constructor(data?: IListResultDtoOfProductSerialItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProductSerialItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProductSerialItem {
        let result = new ListResultDtoOfProductSerialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProductSerialItem {
    items: ProductSerialItem[];
}

export class ProductSerialItem implements IProductSerialItem {
    id: number;
    serial: string;
    isSold: boolean;

    constructor(data?: IProductSerialItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.serial = data["serial"];
            this.isSold = data["isSold"];
        }
    }

    static fromJS(data: any): ProductSerialItem {
        let result = new ProductSerialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serial"] = this.serial;
        data["isSold"] = this.isSold;
        return data; 
    }
}

export interface IProductSerialItem {
    id: number;
    serial: string;
    isSold: boolean;
}

export class AddProductSerialInput implements IAddProductSerialInput {
    serial: string;
    productId: number;
    productVariantId: number;

    constructor(data?: IAddProductSerialInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.productId = data["productId"];
            this.productVariantId = data["productVariantId"];
        }
    }

    static fromJS(data: any): AddProductSerialInput {
        let result = new AddProductSerialInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["productId"] = this.productId;
        data["productVariantId"] = this.productVariantId;
        return data; 
    }
}

export interface IAddProductSerialInput {
    serial: string;
    productId: number;
    productVariantId: number;
}

export class ProductStorePricesDto implements IProductStorePricesDto {
    storeId: number;
    storeName: string;
    unitPrice: UnitPricePricesDto[];

    constructor(data?: IProductStorePricesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            if (data["unitPrice"] && data["unitPrice"].constructor === Array) {
                this.unitPrice = [];
                for (let item of data["unitPrice"])
                    this.unitPrice.push(UnitPricePricesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductStorePricesDto {
        let result = new ProductStorePricesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        if (this.unitPrice && this.unitPrice.constructor === Array) {
            data["unitPrice"] = [];
            for (let item of this.unitPrice)
                data["unitPrice"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductStorePricesDto {
    storeId: number;
    storeName: string;
    unitPrice: UnitPricePricesDto[];
}

export class UnitPricePricesDto implements IUnitPricePricesDto {
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    price: number;

    constructor(data?: IUnitPricePricesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): UnitPricePricesDto {
        let result = new UnitPricePricesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["price"] = this.price;
        return data; 
    }
}

export interface IUnitPricePricesDto {
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    price: number;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    timezone: string;
    qrCodeSetupImageUrl: string;
    isGoogleAuthenticatorEnabled: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    timezone: string;
    qrCodeSetupImageUrl: string;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data; 
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code: string;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data; 
    }
}

export interface IVerifySmsCodeInputDto {
    code: string;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture: string;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangeUserCalenderDto implements IChangeUserCalenderDto {
    calenderName: string;

    constructor(data?: IChangeUserCalenderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calenderName = data["calenderName"];
        }
    }

    static fromJS(data: any): ChangeUserCalenderDto {
        let result = new ChangeUserCalenderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calenderName"] = this.calenderName;
        return data; 
    }
}

export interface IChangeUserCalenderDto {
    calenderName: string;
}

export class PromotionDto implements IPromotionDto {
    tenantId: number;
    promotionType: PromotionDtoPromotionType;
    name: string;
    promotionTypeText: string;
    itemId: number;
    itemType: PromotionDtoItemType;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionDtoValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    isUsed: boolean;
    validForDays: number;
    promotionDetails: PromotionDetailsDto[];
    storeIds: number[];
    promotionCodes: PromotionCodeDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.promotionType = data["promotionType"];
            this.name = data["name"];
            this.promotionTypeText = data["promotionTypeText"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.highestValue = data["highestValue"];
            this.lowestValue = data["lowestValue"];
            this.value = data["value"];
            this.valueType = data["valueType"];
            this.isTotalInvoice = data["isTotalInvoice"];
            this.isNextInvoice = data["isNextInvoice"];
            this.invoiceAmount = data["invoiceAmount"];
            this.isUsed = data["isUsed"];
            this.validForDays = data["validForDays"];
            if (data["promotionDetails"] && data["promotionDetails"].constructor === Array) {
                this.promotionDetails = [];
                for (let item of data["promotionDetails"])
                    this.promotionDetails.push(PromotionDetailsDto.fromJS(item));
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["promotionCodes"] && data["promotionCodes"].constructor === Array) {
                this.promotionCodes = [];
                for (let item of data["promotionCodes"])
                    this.promotionCodes.push(PromotionCodeDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionDto {
        let result = new PromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["promotionType"] = this.promotionType;
        data["name"] = this.name;
        data["promotionTypeText"] = this.promotionTypeText;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["highestValue"] = this.highestValue;
        data["lowestValue"] = this.lowestValue;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["isTotalInvoice"] = this.isTotalInvoice;
        data["isNextInvoice"] = this.isNextInvoice;
        data["invoiceAmount"] = this.invoiceAmount;
        data["isUsed"] = this.isUsed;
        data["validForDays"] = this.validForDays;
        if (this.promotionDetails && this.promotionDetails.constructor === Array) {
            data["promotionDetails"] = [];
            for (let item of this.promotionDetails)
                data["promotionDetails"].push(item.toJSON());
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.promotionCodes && this.promotionCodes.constructor === Array) {
            data["promotionCodes"] = [];
            for (let item of this.promotionCodes)
                data["promotionCodes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionDto {
    tenantId: number;
    promotionType: PromotionDtoPromotionType;
    name: string;
    promotionTypeText: string;
    itemId: number;
    itemType: PromotionDtoItemType;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionDtoValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    isUsed: boolean;
    validForDays: number;
    promotionDetails: PromotionDetailsDto[];
    storeIds: number[];
    promotionCodes: PromotionCodeDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionDetailsDto implements IPromotionDetailsDto {
    id: number;
    itemId: number;
    itemType: PromotionDetailsDtoItemType;
    quantity: number;
    promotionId: number;
    isExcluded: boolean;
    primarycategories: PrimaryCategoryListItem[];
    secondarycategories: SecondaryCategoryListItem[];
    productcategories: ProductCategoryListItem[];
    products: GetProductOutput[];
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    productId: number;

    constructor(data?: IPromotionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.promotionId = data["promotionId"];
            this.isExcluded = data["isExcluded"];
            if (data["primarycategories"] && data["primarycategories"].constructor === Array) {
                this.primarycategories = [];
                for (let item of data["primarycategories"])
                    this.primarycategories.push(PrimaryCategoryListItem.fromJS(item));
            }
            if (data["secondarycategories"] && data["secondarycategories"].constructor === Array) {
                this.secondarycategories = [];
                for (let item of data["secondarycategories"])
                    this.secondarycategories.push(SecondaryCategoryListItem.fromJS(item));
            }
            if (data["productcategories"] && data["productcategories"].constructor === Array) {
                this.productcategories = [];
                for (let item of data["productcategories"])
                    this.productcategories.push(ProductCategoryListItem.fromJS(item));
            }
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(GetProductOutput.fromJS(item));
            }
            this.primaryCategoryId = data["primaryCategoryId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.productCategoryId = data["productCategoryId"];
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): PromotionDetailsDto {
        let result = new PromotionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["promotionId"] = this.promotionId;
        data["isExcluded"] = this.isExcluded;
        if (this.primarycategories && this.primarycategories.constructor === Array) {
            data["primarycategories"] = [];
            for (let item of this.primarycategories)
                data["primarycategories"].push(item.toJSON());
        }
        if (this.secondarycategories && this.secondarycategories.constructor === Array) {
            data["secondarycategories"] = [];
            for (let item of this.secondarycategories)
                data["secondarycategories"].push(item.toJSON());
        }
        if (this.productcategories && this.productcategories.constructor === Array) {
            data["productcategories"] = [];
            for (let item of this.productcategories)
                data["productcategories"].push(item.toJSON());
        }
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["productCategoryId"] = this.productCategoryId;
        data["productId"] = this.productId;
        return data; 
    }
}

export interface IPromotionDetailsDto {
    id: number;
    itemId: number;
    itemType: PromotionDetailsDtoItemType;
    quantity: number;
    promotionId: number;
    isExcluded: boolean;
    primarycategories: PrimaryCategoryListItem[];
    secondarycategories: SecondaryCategoryListItem[];
    productcategories: ProductCategoryListItem[];
    products: GetProductOutput[];
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    productId: number;
}

export class PromotionCodeDto implements IPromotionCodeDto {
    code: string;
    name: string;
    tenantId: number;
    promotionId: number;
    isTiming: boolean;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    fromTime: string;
    toTime: string;
    multi: boolean;
    canEdit: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.promotionId = data["promotionId"];
            this.isTiming = data["isTiming"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.multi = data["multi"];
            this.canEdit = data["canEdit"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionCodeDto {
        let result = new PromotionCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["promotionId"] = this.promotionId;
        data["isTiming"] = this.isTiming;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["multi"] = this.multi;
        data["canEdit"] = this.canEdit;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionCodeDto {
    code: string;
    name: string;
    tenantId: number;
    promotionId: number;
    isTiming: boolean;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    fromTime: string;
    toTime: string;
    multi: boolean;
    canEdit: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfPromotionDto implements IListResultDtoOfPromotionDto {
    items: PromotionDto[];

    constructor(data?: IListResultDtoOfPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PromotionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPromotionDto {
        let result = new ListResultDtoOfPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPromotionDto {
    items: PromotionDto[];
}

export class PagedPromotionList implements IPagedPromotionList {
    currentPage: number;
    itemsCount: number;
    promotions: PromotionDto[];

    constructor(data?: IPagedPromotionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["promotions"] && data["promotions"].constructor === Array) {
                this.promotions = [];
                for (let item of data["promotions"])
                    this.promotions.push(PromotionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPromotionList {
        let result = new PagedPromotionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.promotions && this.promotions.constructor === Array) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPromotionList {
    currentPage: number;
    itemsCount: number;
    promotions: PromotionDto[];
}

export class PagedPromotionCodeList implements IPagedPromotionCodeList {
    currentPage: number;
    itemsCount: number;
    promotions: PromotionCodeDto[];

    constructor(data?: IPagedPromotionCodeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["promotions"] && data["promotions"].constructor === Array) {
                this.promotions = [];
                for (let item of data["promotions"])
                    this.promotions.push(PromotionCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPromotionCodeList {
        let result = new PagedPromotionCodeList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.promotions && this.promotions.constructor === Array) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPromotionCodeList {
    currentPage: number;
    itemsCount: number;
    promotions: PromotionCodeDto[];
}

export class PromotionFBDto implements IPromotionFBDto {
    promotionType: PromotionFBDtoPromotionType;
    templateType: PromotionFBDtoTemplateType;
    name: string;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionFBDtoValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    validForDays: number;
    promotionTypeText: string;
    isUsed: boolean;
    includeVat: boolean;
    promotioncConditions: PromotionDetailsFBDto[];
    promotioncAdditionalFreeItems: PromotionFBAdditionalFreeItemDto[];
    storeIds: number[];
    menuItems: PromotionFBItemDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promotionType = data["promotionType"];
            this.templateType = data["templateType"];
            this.name = data["name"];
            this.highestValue = data["highestValue"];
            this.lowestValue = data["lowestValue"];
            this.value = data["value"];
            this.valueType = data["valueType"];
            this.isTotalInvoice = data["isTotalInvoice"];
            this.isNextInvoice = data["isNextInvoice"];
            this.invoiceAmount = data["invoiceAmount"];
            this.validForDays = data["validForDays"];
            this.promotionTypeText = data["promotionTypeText"];
            this.isUsed = data["isUsed"];
            this.includeVat = data["includeVat"];
            if (data["promotioncConditions"] && data["promotioncConditions"].constructor === Array) {
                this.promotioncConditions = [];
                for (let item of data["promotioncConditions"])
                    this.promotioncConditions.push(PromotionDetailsFBDto.fromJS(item));
            }
            if (data["promotioncAdditionalFreeItems"] && data["promotioncAdditionalFreeItems"].constructor === Array) {
                this.promotioncAdditionalFreeItems = [];
                for (let item of data["promotioncAdditionalFreeItems"])
                    this.promotioncAdditionalFreeItems.push(PromotionFBAdditionalFreeItemDto.fromJS(item));
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["menuItems"] && data["menuItems"].constructor === Array) {
                this.menuItems = [];
                for (let item of data["menuItems"])
                    this.menuItems.push(PromotionFBItemDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBDto {
        let result = new PromotionFBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionType"] = this.promotionType;
        data["templateType"] = this.templateType;
        data["name"] = this.name;
        data["highestValue"] = this.highestValue;
        data["lowestValue"] = this.lowestValue;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["isTotalInvoice"] = this.isTotalInvoice;
        data["isNextInvoice"] = this.isNextInvoice;
        data["invoiceAmount"] = this.invoiceAmount;
        data["validForDays"] = this.validForDays;
        data["promotionTypeText"] = this.promotionTypeText;
        data["isUsed"] = this.isUsed;
        data["includeVat"] = this.includeVat;
        if (this.promotioncConditions && this.promotioncConditions.constructor === Array) {
            data["promotioncConditions"] = [];
            for (let item of this.promotioncConditions)
                data["promotioncConditions"].push(item.toJSON());
        }
        if (this.promotioncAdditionalFreeItems && this.promotioncAdditionalFreeItems.constructor === Array) {
            data["promotioncAdditionalFreeItems"] = [];
            for (let item of this.promotioncAdditionalFreeItems)
                data["promotioncAdditionalFreeItems"].push(item.toJSON());
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.menuItems && this.menuItems.constructor === Array) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBDto {
    promotionType: PromotionFBDtoPromotionType;
    templateType: PromotionFBDtoTemplateType;
    name: string;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionFBDtoValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    validForDays: number;
    promotionTypeText: string;
    isUsed: boolean;
    includeVat: boolean;
    promotioncConditions: PromotionDetailsFBDto[];
    promotioncAdditionalFreeItems: PromotionFBAdditionalFreeItemDto[];
    storeIds: number[];
    menuItems: PromotionFBItemDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionDetailsFBDto implements IPromotionDetailsFBDto {
    id: number;
    itemId: number;
    itemType: PromotionDetailsFBDtoItemType;
    quantity: number;
    promotionId: number;
    excludedMenuItems: number[];
    productCategoryId: number;
    menuItemId: number;
    whre: string;
    menuItemListItem: MenuItemListItem[];
    productcategories: ProductCategoryListItem[];

    constructor(data?: IPromotionDetailsFBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.promotionId = data["promotionId"];
            if (data["excludedMenuItems"] && data["excludedMenuItems"].constructor === Array) {
                this.excludedMenuItems = [];
                for (let item of data["excludedMenuItems"])
                    this.excludedMenuItems.push(item);
            }
            this.productCategoryId = data["productCategoryId"];
            this.menuItemId = data["menuItemId"];
            this.whre = data["whre"];
            if (data["menuItemListItem"] && data["menuItemListItem"].constructor === Array) {
                this.menuItemListItem = [];
                for (let item of data["menuItemListItem"])
                    this.menuItemListItem.push(MenuItemListItem.fromJS(item));
            }
            if (data["productcategories"] && data["productcategories"].constructor === Array) {
                this.productcategories = [];
                for (let item of data["productcategories"])
                    this.productcategories.push(ProductCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionDetailsFBDto {
        let result = new PromotionDetailsFBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["promotionId"] = this.promotionId;
        if (this.excludedMenuItems && this.excludedMenuItems.constructor === Array) {
            data["excludedMenuItems"] = [];
            for (let item of this.excludedMenuItems)
                data["excludedMenuItems"].push(item);
        }
        data["productCategoryId"] = this.productCategoryId;
        data["menuItemId"] = this.menuItemId;
        data["whre"] = this.whre;
        if (this.menuItemListItem && this.menuItemListItem.constructor === Array) {
            data["menuItemListItem"] = [];
            for (let item of this.menuItemListItem)
                data["menuItemListItem"].push(item.toJSON());
        }
        if (this.productcategories && this.productcategories.constructor === Array) {
            data["productcategories"] = [];
            for (let item of this.productcategories)
                data["productcategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionDetailsFBDto {
    id: number;
    itemId: number;
    itemType: PromotionDetailsFBDtoItemType;
    quantity: number;
    promotionId: number;
    excludedMenuItems: number[];
    productCategoryId: number;
    menuItemId: number;
    whre: string;
    menuItemListItem: MenuItemListItem[];
    productcategories: ProductCategoryListItem[];
}

export class PromotionFBAdditionalFreeItemDto implements IPromotionFBAdditionalFreeItemDto {
    id: number;
    itemId: number;
    itemType: PromotionFBAdditionalFreeItemDtoItemType;
    quantity: number;
    promotionId: number;
    price: number;
    productCategoryId: number;
    menuItemId: number;
    excludedMenuItems: number[];
    menuItemListItem: MenuItemListItem[];
    productcategories: ProductCategoryListItem[];

    constructor(data?: IPromotionFBAdditionalFreeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.promotionId = data["promotionId"];
            this.price = data["price"];
            this.productCategoryId = data["productCategoryId"];
            this.menuItemId = data["menuItemId"];
            if (data["excludedMenuItems"] && data["excludedMenuItems"].constructor === Array) {
                this.excludedMenuItems = [];
                for (let item of data["excludedMenuItems"])
                    this.excludedMenuItems.push(item);
            }
            if (data["menuItemListItem"] && data["menuItemListItem"].constructor === Array) {
                this.menuItemListItem = [];
                for (let item of data["menuItemListItem"])
                    this.menuItemListItem.push(MenuItemListItem.fromJS(item));
            }
            if (data["productcategories"] && data["productcategories"].constructor === Array) {
                this.productcategories = [];
                for (let item of data["productcategories"])
                    this.productcategories.push(ProductCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionFBAdditionalFreeItemDto {
        let result = new PromotionFBAdditionalFreeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["promotionId"] = this.promotionId;
        data["price"] = this.price;
        data["productCategoryId"] = this.productCategoryId;
        data["menuItemId"] = this.menuItemId;
        if (this.excludedMenuItems && this.excludedMenuItems.constructor === Array) {
            data["excludedMenuItems"] = [];
            for (let item of this.excludedMenuItems)
                data["excludedMenuItems"].push(item);
        }
        if (this.menuItemListItem && this.menuItemListItem.constructor === Array) {
            data["menuItemListItem"] = [];
            for (let item of this.menuItemListItem)
                data["menuItemListItem"].push(item.toJSON());
        }
        if (this.productcategories && this.productcategories.constructor === Array) {
            data["productcategories"] = [];
            for (let item of this.productcategories)
                data["productcategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionFBAdditionalFreeItemDto {
    id: number;
    itemId: number;
    itemType: PromotionFBAdditionalFreeItemDtoItemType;
    quantity: number;
    promotionId: number;
    price: number;
    productCategoryId: number;
    menuItemId: number;
    excludedMenuItems: number[];
    menuItemListItem: MenuItemListItem[];
    productcategories: ProductCategoryListItem[];
}

export class PromotionFBItemDto implements IPromotionFBItemDto {
    id: number;
    itemId: number;
    itemType: PromotionFBItemDtoItemType;
    promotionId: number;
    excludedMenuItems: number[];
    productCategoryId: number;
    menuItemId: number;
    menuItemListItem: MenuItemListItem[];
    productcategories: ProductCategoryListItem[];

    constructor(data?: IPromotionFBItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.promotionId = data["promotionId"];
            if (data["excludedMenuItems"] && data["excludedMenuItems"].constructor === Array) {
                this.excludedMenuItems = [];
                for (let item of data["excludedMenuItems"])
                    this.excludedMenuItems.push(item);
            }
            this.productCategoryId = data["productCategoryId"];
            this.menuItemId = data["menuItemId"];
            if (data["menuItemListItem"] && data["menuItemListItem"].constructor === Array) {
                this.menuItemListItem = [];
                for (let item of data["menuItemListItem"])
                    this.menuItemListItem.push(MenuItemListItem.fromJS(item));
            }
            if (data["productcategories"] && data["productcategories"].constructor === Array) {
                this.productcategories = [];
                for (let item of data["productcategories"])
                    this.productcategories.push(ProductCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionFBItemDto {
        let result = new PromotionFBItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["promotionId"] = this.promotionId;
        if (this.excludedMenuItems && this.excludedMenuItems.constructor === Array) {
            data["excludedMenuItems"] = [];
            for (let item of this.excludedMenuItems)
                data["excludedMenuItems"].push(item);
        }
        data["productCategoryId"] = this.productCategoryId;
        data["menuItemId"] = this.menuItemId;
        if (this.menuItemListItem && this.menuItemListItem.constructor === Array) {
            data["menuItemListItem"] = [];
            for (let item of this.menuItemListItem)
                data["menuItemListItem"].push(item.toJSON());
        }
        if (this.productcategories && this.productcategories.constructor === Array) {
            data["productcategories"] = [];
            for (let item of this.productcategories)
                data["productcategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionFBItemDto {
    id: number;
    itemId: number;
    itemType: PromotionFBItemDtoItemType;
    promotionId: number;
    excludedMenuItems: number[];
    productCategoryId: number;
    menuItemId: number;
    menuItemListItem: MenuItemListItem[];
    productcategories: ProductCategoryListItem[];
}

export class ListResultDtoOfPromotionFBDto implements IListResultDtoOfPromotionFBDto {
    items: PromotionFBDto[];

    constructor(data?: IListResultDtoOfPromotionFBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PromotionFBDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPromotionFBDto {
        let result = new ListResultDtoOfPromotionFBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPromotionFBDto {
    items: PromotionFBDto[];
}

export class PromotionCodeFBDto implements IPromotionCodeFBDto {
    code: string;
    promotionName: string;
    promotionFBId: number;
    isTiming: boolean;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isActive: boolean;
    canEdit: boolean;
    iDuplicateQunatity: boolean;
    saleTypesIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionCodeFBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.promotionName = data["promotionName"];
            this.promotionFBId = data["promotionFBId"];
            this.isTiming = data["isTiming"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.multi = data["multi"];
            this.isActive = data["isActive"];
            this.canEdit = data["canEdit"];
            this.iDuplicateQunatity = data["iDuplicateQunatity"];
            if (data["saleTypesIds"] && data["saleTypesIds"].constructor === Array) {
                this.saleTypesIds = [];
                for (let item of data["saleTypesIds"])
                    this.saleTypesIds.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionCodeFBDto {
        let result = new PromotionCodeFBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["promotionName"] = this.promotionName;
        data["promotionFBId"] = this.promotionFBId;
        data["isTiming"] = this.isTiming;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["multi"] = this.multi;
        data["isActive"] = this.isActive;
        data["canEdit"] = this.canEdit;
        data["iDuplicateQunatity"] = this.iDuplicateQunatity;
        if (this.saleTypesIds && this.saleTypesIds.constructor === Array) {
            data["saleTypesIds"] = [];
            for (let item of this.saleTypesIds)
                data["saleTypesIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionCodeFBDto {
    code: string;
    promotionName: string;
    promotionFBId: number;
    isTiming: boolean;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isActive: boolean;
    canEdit: boolean;
    iDuplicateQunatity: boolean;
    saleTypesIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedPromotionFBList implements IPagedPromotionFBList {
    currentPage: number;
    itemsCount: number;
    promotionsFB: PromotionFBDto[];

    constructor(data?: IPagedPromotionFBList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["promotionsFB"] && data["promotionsFB"].constructor === Array) {
                this.promotionsFB = [];
                for (let item of data["promotionsFB"])
                    this.promotionsFB.push(PromotionFBDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPromotionFBList {
        let result = new PagedPromotionFBList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.promotionsFB && this.promotionsFB.constructor === Array) {
            data["promotionsFB"] = [];
            for (let item of this.promotionsFB)
                data["promotionsFB"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPromotionFBList {
    currentPage: number;
    itemsCount: number;
    promotionsFB: PromotionFBDto[];
}

export class PagedPromotionCodeFBList implements IPagedPromotionCodeFBList {
    currentPage: number;
    itemsCount: number;
    promotionsFB: PromotionCodeFBDto[];

    constructor(data?: IPagedPromotionCodeFBList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["promotionsFB"] && data["promotionsFB"].constructor === Array) {
                this.promotionsFB = [];
                for (let item of data["promotionsFB"])
                    this.promotionsFB.push(PromotionCodeFBDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPromotionCodeFBList {
        let result = new PagedPromotionCodeFBList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.promotionsFB && this.promotionsFB.constructor === Array) {
            data["promotionsFB"] = [];
            for (let item of this.promotionsFB)
                data["promotionsFB"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPromotionCodeFBList {
    currentPage: number;
    itemsCount: number;
    promotionsFB: PromotionCodeFBDto[];
}

export class CreatePurchaseInvoiceOrderInput implements ICreatePurchaseInvoiceOrderInput {
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: PurchaseInvoiceOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    saveAsDraft: boolean;

    constructor(data?: ICreatePurchaseInvoiceOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceNumber = data["invoiceNumber"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.vendorId = data["vendorId"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(PurchaseInvoiceOrderProductLotDto.fromJS(item));
            }
            this.code = data["code"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.saveAsDraft = data["saveAsDraft"];
        }
    }

    static fromJS(data: any): CreatePurchaseInvoiceOrderInput {
        let result = new CreatePurchaseInvoiceOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["vendorId"] = this.vendorId;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["saveAsDraft"] = this.saveAsDraft;
        return data; 
    }
}

export interface ICreatePurchaseInvoiceOrderInput {
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: PurchaseInvoiceOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    saveAsDraft: boolean;
}

export class PurchaseInvoiceOrderProductLotDto implements IPurchaseInvoiceOrderProductLotDto {
    productLotId: number;
    storeId: number;
    storeName: string;
    code: string;
    productId: number;
    productName: string;
    productCode: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    unitPurchasePrice: number;
    priceWithoutVat: number;
    productVariantId: number;
    productVariantName: string;
    remainingQuantity: number;
    editMode: boolean;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    vat: number;
    includeVAT: boolean;
    discountTypeId: number;
    discountAmount: number;
    totalCost: number;
    total: number;
    netCost: number;
    discount: number;

    constructor(data?: IPurchaseInvoiceOrderProductLotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productLotId = data["productLotId"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.code = data["code"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productCode = data["productCode"];
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.quantity = data["quantity"];
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.priceWithoutVat = data["priceWithoutVat"];
            this.productVariantId = data["productVariantId"];
            this.productVariantName = data["productVariantName"];
            this.remainingQuantity = data["remainingQuantity"];
            this.editMode = data["editMode"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.vat = data["vat"];
            this.includeVAT = data["includeVAT"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.totalCost = data["totalCost"];
            this.total = data["total"];
            this.netCost = data["netCost"];
            this.discount = data["discount"];
        }
    }

    static fromJS(data: any): PurchaseInvoiceOrderProductLotDto {
        let result = new PurchaseInvoiceOrderProductLotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLotId"] = this.productLotId;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["code"] = this.code;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["productVariantId"] = this.productVariantId;
        data["productVariantName"] = this.productVariantName;
        data["remainingQuantity"] = this.remainingQuantity;
        data["editMode"] = this.editMode;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["vat"] = this.vat;
        data["includeVAT"] = this.includeVAT;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["totalCost"] = this.totalCost;
        data["total"] = this.total;
        data["netCost"] = this.netCost;
        data["discount"] = this.discount;
        return data; 
    }
}

export interface IPurchaseInvoiceOrderProductLotDto {
    productLotId: number;
    storeId: number;
    storeName: string;
    code: string;
    productId: number;
    productName: string;
    productCode: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    unitPurchasePrice: number;
    priceWithoutVat: number;
    productVariantId: number;
    productVariantName: string;
    remainingQuantity: number;
    editMode: boolean;
    unitOfMeasureId: number;
    unitOfMeasureName: string;
    vat: number;
    includeVAT: boolean;
    discountTypeId: number;
    discountAmount: number;
    totalCost: number;
    total: number;
    netCost: number;
    discount: number;
}

export class ApprovalActionInput implements IApprovalActionInput {
    transactionId: number;
    taskId: number;
    action: number;
    comment: string;

    constructor(data?: IApprovalActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionId = data["transactionId"];
            this.taskId = data["taskId"];
            this.action = data["action"];
            this.comment = data["comment"];
        }
    }

    static fromJS(data: any): ApprovalActionInput {
        let result = new ApprovalActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["taskId"] = this.taskId;
        data["action"] = this.action;
        data["comment"] = this.comment;
        return data; 
    }
}

export interface IApprovalActionInput {
    transactionId: number;
    taskId: number;
    action: number;
    comment: string;
}

export class UpdatePurchaseInvoiceOrderInput implements IUpdatePurchaseInvoiceOrderInput {
    id: number;
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: PurchaseInvoiceOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    saveAsDraft: boolean;

    constructor(data?: IUpdatePurchaseInvoiceOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.vendorId = data["vendorId"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(PurchaseInvoiceOrderProductLotDto.fromJS(item));
            }
            this.code = data["code"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.saveAsDraft = data["saveAsDraft"];
        }
    }

    static fromJS(data: any): UpdatePurchaseInvoiceOrderInput {
        let result = new UpdatePurchaseInvoiceOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["vendorId"] = this.vendorId;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["saveAsDraft"] = this.saveAsDraft;
        return data; 
    }
}

export interface IUpdatePurchaseInvoiceOrderInput {
    id: number;
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: PurchaseInvoiceOrderProductLotDto[];
    code: string;
    discountTypeId: number;
    discountAmount: number;
    saveAsDraft: boolean;
}

export class ListResultDtoOfPurchaseInvoiceOrderListItem implements IListResultDtoOfPurchaseInvoiceOrderListItem {
    items: PurchaseInvoiceOrderListItem[];

    constructor(data?: IListResultDtoOfPurchaseInvoiceOrderListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PurchaseInvoiceOrderListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPurchaseInvoiceOrderListItem {
        let result = new ListResultDtoOfPurchaseInvoiceOrderListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPurchaseInvoiceOrderListItem {
    items: PurchaseInvoiceOrderListItem[];
}

export class PurchaseInvoiceOrderListItem implements IPurchaseInvoiceOrderListItem {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    discountTypeId: number;
    discountAmount: number;
    vendorId: number;
    vendorName: string;
    convertedPurchaseInvoiceId: number;
    total: number;
    submittedByName: string;
    approvalStatus: number;
    currentStepName: string;
    waitingSince: moment.Moment;
    canTakeAction: boolean;
    canEdit: boolean;
    canSubmit: boolean;
    canConvert: boolean;

    constructor(data?: IPurchaseInvoiceOrderListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.code = data["code"];
            this.purchaseDate = data["purchaseDate"];
            this.storeName = data["storeName"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.vendorId = data["vendorId"];
            this.vendorName = data["vendorName"];
            this.convertedPurchaseInvoiceId = data["convertedPurchaseInvoiceId"];
            this.total = data["total"];
            this.submittedByName = data["submittedByName"];
            this.approvalStatus = data["approvalStatus"];
            this.currentStepName = data["currentStepName"];
            this.waitingSince = data["waitingSince"] ? moment(data["waitingSince"].toString()) : <any>undefined;
            this.canTakeAction = data["canTakeAction"];
            this.canEdit = data["canEdit"];
            this.canSubmit = data["canSubmit"];
            this.canConvert = data["canConvert"];
        }
    }

    static fromJS(data: any): PurchaseInvoiceOrderListItem {
        let result = new PurchaseInvoiceOrderListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["purchaseDate"] = this.purchaseDate;
        data["storeName"] = this.storeName;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["convertedPurchaseInvoiceId"] = this.convertedPurchaseInvoiceId;
        data["total"] = this.total;
        data["submittedByName"] = this.submittedByName;
        data["approvalStatus"] = this.approvalStatus;
        data["currentStepName"] = this.currentStepName;
        data["waitingSince"] = this.waitingSince ? this.waitingSince.toISOString() : <any>undefined;
        data["canTakeAction"] = this.canTakeAction;
        data["canEdit"] = this.canEdit;
        data["canSubmit"] = this.canSubmit;
        data["canConvert"] = this.canConvert;
        return data; 
    }
}

export interface IPurchaseInvoiceOrderListItem {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    discountTypeId: number;
    discountAmount: number;
    vendorId: number;
    vendorName: string;
    convertedPurchaseInvoiceId: number;
    total: number;
    submittedByName: string;
    approvalStatus: number;
    currentStepName: string;
    waitingSince: moment.Moment;
    canTakeAction: boolean;
    canEdit: boolean;
    canSubmit: boolean;
    canConvert: boolean;
}

export class PagedPurchaseInvoiceOrderList implements IPagedPurchaseInvoiceOrderList {
    currentPage: number;
    itemsCount: number;
    orders: PurchaseInvoiceOrderListItem[];

    constructor(data?: IPagedPurchaseInvoiceOrderList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [];
                for (let item of data["orders"])
                    this.orders.push(PurchaseInvoiceOrderListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPurchaseInvoiceOrderList {
        let result = new PagedPurchaseInvoiceOrderList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPurchaseInvoiceOrderList {
    currentPage: number;
    itemsCount: number;
    orders: PurchaseInvoiceOrderListItem[];
}

export class ApprovalInboxSummaryDto implements IApprovalInboxSummaryDto {
    totalCount: number;
    awaitingCount: number;
    overdueCount: number;
    overdueAfterHours: number;
    approvedCount: number;
    returnedCount: number;

    constructor(data?: IApprovalInboxSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.awaitingCount = data["awaitingCount"];
            this.overdueCount = data["overdueCount"];
            this.overdueAfterHours = data["overdueAfterHours"];
            this.approvedCount = data["approvedCount"];
            this.returnedCount = data["returnedCount"];
        }
    }

    static fromJS(data: any): ApprovalInboxSummaryDto {
        let result = new ApprovalInboxSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["awaitingCount"] = this.awaitingCount;
        data["overdueCount"] = this.overdueCount;
        data["overdueAfterHours"] = this.overdueAfterHours;
        data["approvedCount"] = this.approvedCount;
        data["returnedCount"] = this.returnedCount;
        return data; 
    }
}

export interface IApprovalInboxSummaryDto {
    totalCount: number;
    awaitingCount: number;
    overdueCount: number;
    overdueAfterHours: number;
    approvedCount: number;
    returnedCount: number;
}

export class PurchaseInvoiceOrderDto implements IPurchaseInvoiceOrderDto {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    vendorId: number;
    vendorName: string;
    currencyName: string;
    purchaseTotal: number;
    discountTypeId: number;
    discountAmount: number;
    convertedPurchaseInvoiceId: number;
    productLots: PurchaseInvoiceOrderProductLotDto[];
    approval: ApprovalStateDto;
    canConvert: boolean;

    constructor(data?: IPurchaseInvoiceOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.code = data["code"];
            this.purchaseDate = data["purchaseDate"];
            this.storeName = data["storeName"];
            this.vendorId = data["vendorId"];
            this.vendorName = data["vendorName"];
            this.currencyName = data["currencyName"];
            this.purchaseTotal = data["purchaseTotal"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.convertedPurchaseInvoiceId = data["convertedPurchaseInvoiceId"];
            if (data["productLots"] && data["productLots"].constructor === Array) {
                this.productLots = [];
                for (let item of data["productLots"])
                    this.productLots.push(PurchaseInvoiceOrderProductLotDto.fromJS(item));
            }
            this.approval = data["approval"] ? ApprovalStateDto.fromJS(data["approval"]) : <any>undefined;
            this.canConvert = data["canConvert"];
        }
    }

    static fromJS(data: any): PurchaseInvoiceOrderDto {
        let result = new PurchaseInvoiceOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["purchaseDate"] = this.purchaseDate;
        data["storeName"] = this.storeName;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["currencyName"] = this.currencyName;
        data["purchaseTotal"] = this.purchaseTotal;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["convertedPurchaseInvoiceId"] = this.convertedPurchaseInvoiceId;
        if (this.productLots && this.productLots.constructor === Array) {
            data["productLots"] = [];
            for (let item of this.productLots)
                data["productLots"].push(item.toJSON());
        }
        data["approval"] = this.approval ? this.approval.toJSON() : <any>undefined;
        data["canConvert"] = this.canConvert;
        return data; 
    }
}

export interface IPurchaseInvoiceOrderDto {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    vendorId: number;
    vendorName: string;
    currencyName: string;
    purchaseTotal: number;
    discountTypeId: number;
    discountAmount: number;
    convertedPurchaseInvoiceId: number;
    productLots: PurchaseInvoiceOrderProductLotDto[];
    approval: ApprovalStateDto;
    canConvert: boolean;
}

export class ApprovalStateDto implements IApprovalStateDto {
    status: number;
    currentStepName: string;
    currentTaskId: number;
    currentStepOrder: number;
    waitingSince: moment.Moment;
    canTakeAction: boolean;
    canReturn: boolean;
    canReject: boolean;
    isCommentRequiredOnReturn: boolean;
    isCommentRequiredOnReject: boolean;
    canEdit: boolean;
    canSubmit: boolean;
    tasks: ApprovalWorkflowTaskDto[];

    constructor(data?: IApprovalStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.currentStepName = data["currentStepName"];
            this.currentTaskId = data["currentTaskId"];
            this.currentStepOrder = data["currentStepOrder"];
            this.waitingSince = data["waitingSince"] ? moment(data["waitingSince"].toString()) : <any>undefined;
            this.canTakeAction = data["canTakeAction"];
            this.canReturn = data["canReturn"];
            this.canReject = data["canReject"];
            this.isCommentRequiredOnReturn = data["isCommentRequiredOnReturn"];
            this.isCommentRequiredOnReject = data["isCommentRequiredOnReject"];
            this.canEdit = data["canEdit"];
            this.canSubmit = data["canSubmit"];
            if (data["tasks"] && data["tasks"].constructor === Array) {
                this.tasks = [];
                for (let item of data["tasks"])
                    this.tasks.push(ApprovalWorkflowTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalStateDto {
        let result = new ApprovalStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["currentStepName"] = this.currentStepName;
        data["currentTaskId"] = this.currentTaskId;
        data["currentStepOrder"] = this.currentStepOrder;
        data["waitingSince"] = this.waitingSince ? this.waitingSince.toISOString() : <any>undefined;
        data["canTakeAction"] = this.canTakeAction;
        data["canReturn"] = this.canReturn;
        data["canReject"] = this.canReject;
        data["isCommentRequiredOnReturn"] = this.isCommentRequiredOnReturn;
        data["isCommentRequiredOnReject"] = this.isCommentRequiredOnReject;
        data["canEdit"] = this.canEdit;
        data["canSubmit"] = this.canSubmit;
        if (this.tasks && this.tasks.constructor === Array) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApprovalStateDto {
    status: number;
    currentStepName: string;
    currentTaskId: number;
    currentStepOrder: number;
    waitingSince: moment.Moment;
    canTakeAction: boolean;
    canReturn: boolean;
    canReject: boolean;
    isCommentRequiredOnReturn: boolean;
    isCommentRequiredOnReject: boolean;
    canEdit: boolean;
    canSubmit: boolean;
    tasks: ApprovalWorkflowTaskDto[];
}

export class ApprovalWorkflowTaskDto implements IApprovalWorkflowTaskDto {
    id: number;
    stepOrder: number;
    stepName: string;
    assignedRoles: string;
    isActive: boolean;
    action: number;
    actionUserName: string;
    actionTime: moment.Moment;
    comment: string;
    creationTime: moment.Moment;
    creatorUserName: string;

    constructor(data?: IApprovalWorkflowTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.stepOrder = data["stepOrder"];
            this.stepName = data["stepName"];
            this.assignedRoles = data["assignedRoles"];
            this.isActive = data["isActive"];
            this.action = data["action"];
            this.actionUserName = data["actionUserName"];
            this.actionTime = data["actionTime"] ? moment(data["actionTime"].toString()) : <any>undefined;
            this.comment = data["comment"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserName = data["creatorUserName"];
        }
    }

    static fromJS(data: any): ApprovalWorkflowTaskDto {
        let result = new ApprovalWorkflowTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepOrder"] = this.stepOrder;
        data["stepName"] = this.stepName;
        data["assignedRoles"] = this.assignedRoles;
        data["isActive"] = this.isActive;
        data["action"] = this.action;
        data["actionUserName"] = this.actionUserName;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserName"] = this.creatorUserName;
        return data; 
    }
}

export interface IApprovalWorkflowTaskDto {
    id: number;
    stepOrder: number;
    stepName: string;
    assignedRoles: string;
    isActive: boolean;
    action: number;
    actionUserName: string;
    actionTime: moment.Moment;
    comment: string;
    creationTime: moment.Moment;
    creatorUserName: string;
}

export class CreatePurchaseInvoiceInput implements ICreatePurchaseInvoiceInput {
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: ProductLotDto[];
    code: string;
    discountTypeId: number;
    paymentMethod: number;
    discountAmount: number;
    saveAsDraft: boolean;

    constructor(data?: ICreatePurchaseInvoiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceNumber = data["invoiceNumber"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.vendorId = data["vendorId"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(ProductLotDto.fromJS(item));
            }
            this.code = data["code"];
            this.discountTypeId = data["discountTypeId"];
            this.paymentMethod = data["paymentMethod"];
            this.discountAmount = data["discountAmount"];
            this.saveAsDraft = data["saveAsDraft"];
        }
    }

    static fromJS(data: any): CreatePurchaseInvoiceInput {
        let result = new CreatePurchaseInvoiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["vendorId"] = this.vendorId;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["discountTypeId"] = this.discountTypeId;
        data["paymentMethod"] = this.paymentMethod;
        data["discountAmount"] = this.discountAmount;
        data["saveAsDraft"] = this.saveAsDraft;
        return data; 
    }
}

export interface ICreatePurchaseInvoiceInput {
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: ProductLotDto[];
    code: string;
    discountTypeId: number;
    paymentMethod: number;
    discountAmount: number;
    saveAsDraft: boolean;
}

export class ListResultDtoOfPurchaseInvoiceListItem implements IListResultDtoOfPurchaseInvoiceListItem {
    items: PurchaseInvoiceListItem[];

    constructor(data?: IListResultDtoOfPurchaseInvoiceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PurchaseInvoiceListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPurchaseInvoiceListItem {
        let result = new ListResultDtoOfPurchaseInvoiceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPurchaseInvoiceListItem {
    items: PurchaseInvoiceListItem[];
}

export class PurchaseInvoiceListItem implements IPurchaseInvoiceListItem {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    discountTypeId: number;
    discountAmount: number;
    vendorId: number;
    vendorName: string;
    total: number;
    submittedByName: string;
    approvalStatus: number;
    currentStepName: string;
    waitingSince: moment.Moment;
    canTakeAction: boolean;
    canEdit: boolean;
    canSubmit: boolean;

    constructor(data?: IPurchaseInvoiceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.code = data["code"];
            this.purchaseDate = data["purchaseDate"];
            this.storeName = data["storeName"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.vendorId = data["vendorId"];
            this.vendorName = data["vendorName"];
            this.total = data["total"];
            this.submittedByName = data["submittedByName"];
            this.approvalStatus = data["approvalStatus"];
            this.currentStepName = data["currentStepName"];
            this.waitingSince = data["waitingSince"] ? moment(data["waitingSince"].toString()) : <any>undefined;
            this.canTakeAction = data["canTakeAction"];
            this.canEdit = data["canEdit"];
            this.canSubmit = data["canSubmit"];
        }
    }

    static fromJS(data: any): PurchaseInvoiceListItem {
        let result = new PurchaseInvoiceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["purchaseDate"] = this.purchaseDate;
        data["storeName"] = this.storeName;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["total"] = this.total;
        data["submittedByName"] = this.submittedByName;
        data["approvalStatus"] = this.approvalStatus;
        data["currentStepName"] = this.currentStepName;
        data["waitingSince"] = this.waitingSince ? this.waitingSince.toISOString() : <any>undefined;
        data["canTakeAction"] = this.canTakeAction;
        data["canEdit"] = this.canEdit;
        data["canSubmit"] = this.canSubmit;
        return data; 
    }
}

export interface IPurchaseInvoiceListItem {
    id: number;
    invoiceNumber: string;
    code: string;
    purchaseDate: string;
    storeName: string;
    discountTypeId: number;
    discountAmount: number;
    vendorId: number;
    vendorName: string;
    total: number;
    submittedByName: string;
    approvalStatus: number;
    currentStepName: string;
    waitingSince: moment.Moment;
    canTakeAction: boolean;
    canEdit: boolean;
    canSubmit: boolean;
}

export class ListResultDtoOfPurchaseBillsListItem implements IListResultDtoOfPurchaseBillsListItem {
    items: PurchaseBillsListItem[];

    constructor(data?: IListResultDtoOfPurchaseBillsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PurchaseBillsListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPurchaseBillsListItem {
        let result = new ListResultDtoOfPurchaseBillsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPurchaseBillsListItem {
    items: PurchaseBillsListItem[];
}

export class PurchaseBillsListItem implements IPurchaseBillsListItem {
    billsSuppliersNumber: string;
    dueDate: moment.Moment;
    isDeleted: boolean;
    total: number;
    officeId: number;
    suppliersId: number;
    userId: number;
    todayDate: moment.Moment;
    definitionOfCurrenciesId: number;
    totalCharacters: string;
    companyId: number;
    documentType: string;
    exchangeRate: number;
    nationalCompanyNumber: string;
    saleTaxNumber: string;
    address: string;
    email: string;
    legalCompanyName: string;
    phoneNumber: string;
    totalFinal: number;
    commodityServices: number;
    purchaseOrderId: number;
    warehouseEntryVoucherId: number;

    constructor(data?: IPurchaseBillsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billsSuppliersNumber = data["billsSuppliersNumber"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.total = data["total"];
            this.officeId = data["officeId"];
            this.suppliersId = data["suppliersId"];
            this.userId = data["userId"];
            this.todayDate = data["todayDate"] ? moment(data["todayDate"].toString()) : <any>undefined;
            this.definitionOfCurrenciesId = data["definitionOfCurrenciesId"];
            this.totalCharacters = data["totalCharacters"];
            this.companyId = data["companyId"];
            this.documentType = data["documentType"];
            this.exchangeRate = data["exchangeRate"];
            this.nationalCompanyNumber = data["nationalCompanyNumber"];
            this.saleTaxNumber = data["saleTaxNumber"];
            this.address = data["address"];
            this.email = data["email"];
            this.legalCompanyName = data["legalCompanyName"];
            this.phoneNumber = data["phoneNumber"];
            this.totalFinal = data["totalFinal"];
            this.commodityServices = data["commodityServices"];
            this.purchaseOrderId = data["purchaseOrderId"];
            this.warehouseEntryVoucherId = data["warehouseEntryVoucherId"];
        }
    }

    static fromJS(data: any): PurchaseBillsListItem {
        let result = new PurchaseBillsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billsSuppliersNumber"] = this.billsSuppliersNumber;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["total"] = this.total;
        data["officeId"] = this.officeId;
        data["suppliersId"] = this.suppliersId;
        data["userId"] = this.userId;
        data["todayDate"] = this.todayDate ? this.todayDate.toISOString() : <any>undefined;
        data["definitionOfCurrenciesId"] = this.definitionOfCurrenciesId;
        data["totalCharacters"] = this.totalCharacters;
        data["companyId"] = this.companyId;
        data["documentType"] = this.documentType;
        data["exchangeRate"] = this.exchangeRate;
        data["nationalCompanyNumber"] = this.nationalCompanyNumber;
        data["saleTaxNumber"] = this.saleTaxNumber;
        data["address"] = this.address;
        data["email"] = this.email;
        data["legalCompanyName"] = this.legalCompanyName;
        data["phoneNumber"] = this.phoneNumber;
        data["totalFinal"] = this.totalFinal;
        data["commodityServices"] = this.commodityServices;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["warehouseEntryVoucherId"] = this.warehouseEntryVoucherId;
        return data; 
    }
}

export interface IPurchaseBillsListItem {
    billsSuppliersNumber: string;
    dueDate: moment.Moment;
    isDeleted: boolean;
    total: number;
    officeId: number;
    suppliersId: number;
    userId: number;
    todayDate: moment.Moment;
    definitionOfCurrenciesId: number;
    totalCharacters: string;
    companyId: number;
    documentType: string;
    exchangeRate: number;
    nationalCompanyNumber: string;
    saleTaxNumber: string;
    address: string;
    email: string;
    legalCompanyName: string;
    phoneNumber: string;
    totalFinal: number;
    commodityServices: number;
    purchaseOrderId: number;
    warehouseEntryVoucherId: number;
}

export class PagedPurchaseInvoiceList implements IPagedPurchaseInvoiceList {
    currentPage: number;
    itemsCount: number;
    invoices: PurchaseInvoiceListItem[];

    constructor(data?: IPagedPurchaseInvoiceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["invoices"] && data["invoices"].constructor === Array) {
                this.invoices = [];
                for (let item of data["invoices"])
                    this.invoices.push(PurchaseInvoiceListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedPurchaseInvoiceList {
        let result = new PagedPurchaseInvoiceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.invoices && this.invoices.constructor === Array) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedPurchaseInvoiceList {
    currentPage: number;
    itemsCount: number;
    invoices: PurchaseInvoiceListItem[];
}

export class PurchaseInvoiceDto implements IPurchaseInvoiceDto {
    id: number;
    invoiceNumber: string;
    code: string;
    productCode: string;
    purchaseDate: string;
    storeName: string;
    store: StoreDto;
    vendorId: number;
    vendorName: string;
    currencyName: string;
    purchaseTotal: number;
    discountTypeId: number;
    discountAmount: number;
    productLots: ProductLotDto[];
    approval: ApprovalStateDto;

    constructor(data?: IPurchaseInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.code = data["code"];
            this.productCode = data["productCode"];
            this.purchaseDate = data["purchaseDate"];
            this.storeName = data["storeName"];
            this.store = data["store"] ? StoreDto.fromJS(data["store"]) : <any>undefined;
            this.vendorId = data["vendorId"];
            this.vendorName = data["vendorName"];
            this.currencyName = data["currencyName"];
            this.purchaseTotal = data["purchaseTotal"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            if (data["productLots"] && data["productLots"].constructor === Array) {
                this.productLots = [];
                for (let item of data["productLots"])
                    this.productLots.push(ProductLotDto.fromJS(item));
            }
            this.approval = data["approval"] ? ApprovalStateDto.fromJS(data["approval"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PurchaseInvoiceDto {
        let result = new PurchaseInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["productCode"] = this.productCode;
        data["purchaseDate"] = this.purchaseDate;
        data["storeName"] = this.storeName;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["currencyName"] = this.currencyName;
        data["purchaseTotal"] = this.purchaseTotal;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        if (this.productLots && this.productLots.constructor === Array) {
            data["productLots"] = [];
            for (let item of this.productLots)
                data["productLots"].push(item.toJSON());
        }
        data["approval"] = this.approval ? this.approval.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPurchaseInvoiceDto {
    id: number;
    invoiceNumber: string;
    code: string;
    productCode: string;
    purchaseDate: string;
    storeName: string;
    store: StoreDto;
    vendorId: number;
    vendorName: string;
    currencyName: string;
    purchaseTotal: number;
    discountTypeId: number;
    discountAmount: number;
    productLots: ProductLotDto[];
    approval: ApprovalStateDto;
}

export class UpdatePurchaseInvoiceInput implements IUpdatePurchaseInvoiceInput {
    id: number;
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: ProductLotDto[];
    code: string;
    discountTypeId: number;
    paymentMethod: number;
    discountAmount: number;
    saveAsDraft: boolean;

    constructor(data?: IUpdatePurchaseInvoiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.invoiceNumber = data["invoiceNumber"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.vendorId = data["vendorId"];
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(ProductLotDto.fromJS(item));
            }
            this.code = data["code"];
            this.discountTypeId = data["discountTypeId"];
            this.paymentMethod = data["paymentMethod"];
            this.discountAmount = data["discountAmount"];
            this.saveAsDraft = data["saveAsDraft"];
        }
    }

    static fromJS(data: any): UpdatePurchaseInvoiceInput {
        let result = new UpdatePurchaseInvoiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["vendorId"] = this.vendorId;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["discountTypeId"] = this.discountTypeId;
        data["paymentMethod"] = this.paymentMethod;
        data["discountAmount"] = this.discountAmount;
        data["saveAsDraft"] = this.saveAsDraft;
        return data; 
    }
}

export interface IUpdatePurchaseInvoiceInput {
    id: number;
    invoiceNumber: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    products: ProductLotDto[];
    code: string;
    discountTypeId: number;
    paymentMethod: number;
    discountAmount: number;
    saveAsDraft: boolean;
}

export class BestPurchasePricesDto implements IBestPurchasePricesDto {
    bestOverall: BestPurchasePriceItemDto;
    bestFromVendor: BestPurchasePriceItemDto;

    constructor(data?: IBestPurchasePricesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bestOverall = data["bestOverall"] ? BestPurchasePriceItemDto.fromJS(data["bestOverall"]) : <any>undefined;
            this.bestFromVendor = data["bestFromVendor"] ? BestPurchasePriceItemDto.fromJS(data["bestFromVendor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BestPurchasePricesDto {
        let result = new BestPurchasePricesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bestOverall"] = this.bestOverall ? this.bestOverall.toJSON() : <any>undefined;
        data["bestFromVendor"] = this.bestFromVendor ? this.bestFromVendor.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBestPurchasePricesDto {
    bestOverall: BestPurchasePriceItemDto;
    bestFromVendor: BestPurchasePriceItemDto;
}

export class BestPurchasePriceItemDto implements IBestPurchasePriceItemDto {
    unitPurchasePrice: number;
    vendorId: number;
    vendorName: string;
    purchaseDate: moment.Moment;
    invoiceNumber: string;
    purchaseInvoiceId: number;

    constructor(data?: IBestPurchasePriceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.vendorId = data["vendorId"];
            this.vendorName = data["vendorName"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.invoiceNumber = data["invoiceNumber"];
            this.purchaseInvoiceId = data["purchaseInvoiceId"];
        }
    }

    static fromJS(data: any): BestPurchasePriceItemDto {
        let result = new BestPurchasePriceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseInvoiceId"] = this.purchaseInvoiceId;
        return data; 
    }
}

export interface IBestPurchasePriceItemDto {
    unitPurchasePrice: number;
    vendorId: number;
    vendorName: string;
    purchaseDate: moment.Moment;
    invoiceNumber: string;
    purchaseInvoiceId: number;
}

export class QrMenaCategoryDto implements IQrMenaCategoryDto {
    categoryId: number;
    code: string;
    categoryName: string;
    imageUrl: string;

    constructor(data?: IQrMenaCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.code = data["code"];
            this.categoryName = data["categoryName"];
            this.imageUrl = data["imageUrl"];
        }
    }

    static fromJS(data: any): QrMenaCategoryDto {
        let result = new QrMenaCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["code"] = this.code;
        data["categoryName"] = this.categoryName;
        data["imageUrl"] = this.imageUrl;
        return data; 
    }
}

export interface IQrMenaCategoryDto {
    categoryId: number;
    code: string;
    categoryName: string;
    imageUrl: string;
}

export class QrMenaMenuItem implements IQrMenaMenuItem {
    menuItemId: number;
    price: number;
    name: string;
    categoryId: number;
    imageUrl: string;
    unitId: number;
    unitName: string;

    constructor(data?: IQrMenaMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.price = data["price"];
            this.name = data["name"];
            this.categoryId = data["categoryId"];
            this.imageUrl = data["imageUrl"];
            this.unitId = data["unitId"];
            this.unitName = data["unitName"];
        }
    }

    static fromJS(data: any): QrMenaMenuItem {
        let result = new QrMenaMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["price"] = this.price;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["imageUrl"] = this.imageUrl;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        return data; 
    }
}

export interface IQrMenaMenuItem {
    menuItemId: number;
    price: number;
    name: string;
    categoryId: number;
    imageUrl: string;
    unitId: number;
    unitName: string;
}

export class RawMaterialListItem implements IRawMaterialListItem {
    id: number;
    name: string;
    barCode: string;
    inventoryUnitOfMeasureName: string;
    inventoryQuantity: number;
    recipeUnitOfMeasureName: string;
    isRecipy: boolean;
    hasDetails: boolean;
    details: RawMaterialDto[];
    currentPage: number;
    itemsCount: number;
    sellingPrice: number;
    itemCost: RawMaterialListItemItemCost;

    constructor(data?: IRawMaterialListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.barCode = data["barCode"];
            this.inventoryUnitOfMeasureName = data["inventoryUnitOfMeasureName"];
            this.inventoryQuantity = data["inventoryQuantity"];
            this.recipeUnitOfMeasureName = data["recipeUnitOfMeasureName"];
            this.isRecipy = data["isRecipy"];
            this.hasDetails = data["hasDetails"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(RawMaterialDto.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
        }
    }

    static fromJS(data: any): RawMaterialListItem {
        let result = new RawMaterialListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["barCode"] = this.barCode;
        data["inventoryUnitOfMeasureName"] = this.inventoryUnitOfMeasureName;
        data["inventoryQuantity"] = this.inventoryQuantity;
        data["recipeUnitOfMeasureName"] = this.recipeUnitOfMeasureName;
        data["isRecipy"] = this.isRecipy;
        data["hasDetails"] = this.hasDetails;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        return data; 
    }
}

export interface IRawMaterialListItem {
    id: number;
    name: string;
    barCode: string;
    inventoryUnitOfMeasureName: string;
    inventoryQuantity: number;
    recipeUnitOfMeasureName: string;
    isRecipy: boolean;
    hasDetails: boolean;
    details: RawMaterialDto[];
    currentPage: number;
    itemsCount: number;
    sellingPrice: number;
    itemCost: RawMaterialListItemItemCost;
}

export class ValueTupleOfRawMaterialListItemAndPeriodType implements IValueTupleOfRawMaterialListItemAndPeriodType {
    item1: RawMaterialListItem;
    item2: ValueTupleOfRawMaterialListItemAndPeriodTypeItem2;

    constructor(data?: IValueTupleOfRawMaterialListItemAndPeriodType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"] ? RawMaterialListItem.fromJS(data["item1"]) : <any>undefined;
            this.item2 = data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfRawMaterialListItemAndPeriodType {
        let result = new ValueTupleOfRawMaterialListItemAndPeriodType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2;
        return data; 
    }
}

export interface IValueTupleOfRawMaterialListItemAndPeriodType {
    item1: RawMaterialListItem;
    item2: ValueTupleOfRawMaterialListItemAndPeriodTypeItem2;
}

export class CreateRawMaterialInput implements ICreateRawMaterialInput {
    id: number;
    translations: RawMaterialTranslationDto[];
    materialGroupId: number;
    periodId: number;
    suppliersIds: number[];
    reorderLevel: number;
    maxQuantity: number;
    itemCost: CreateRawMaterialInputItemCost;
    barcode: string;
    sellingPrice: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    hasDueDate: boolean;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    isRecipe: boolean;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    rawMaterialDetail: RawMaterialDetailDto[];
    rawMaterialComponent: RawMaterialDetailDto[];
    storeGroupIds: number[];

    constructor(data?: ICreateRawMaterialInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RawMaterialTranslationDto.fromJS(item));
            }
            this.materialGroupId = data["materialGroupId"];
            this.periodId = data["periodId"];
            if (data["suppliersIds"] && data["suppliersIds"].constructor === Array) {
                this.suppliersIds = [];
                for (let item of data["suppliersIds"])
                    this.suppliersIds.push(item);
            }
            this.reorderLevel = data["reorderLevel"];
            this.maxQuantity = data["maxQuantity"];
            this.itemCost = data["itemCost"];
            this.barcode = data["barcode"];
            this.sellingPrice = data["sellingPrice"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.hasDueDate = data["hasDueDate"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.isRecipe = data["isRecipe"];
            this.reOrderQuantity = data["reOrderQuantity"];
            this.warningAlertQuantity = data["warningAlertQuantity"];
            if (data["rawMaterialDetail"] && data["rawMaterialDetail"].constructor === Array) {
                this.rawMaterialDetail = [];
                for (let item of data["rawMaterialDetail"])
                    this.rawMaterialDetail.push(RawMaterialDetailDto.fromJS(item));
            }
            if (data["rawMaterialComponent"] && data["rawMaterialComponent"].constructor === Array) {
                this.rawMaterialComponent = [];
                for (let item of data["rawMaterialComponent"])
                    this.rawMaterialComponent.push(RawMaterialDetailDto.fromJS(item));
            }
            if (data["storeGroupIds"] && data["storeGroupIds"].constructor === Array) {
                this.storeGroupIds = [];
                for (let item of data["storeGroupIds"])
                    this.storeGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRawMaterialInput {
        let result = new CreateRawMaterialInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["materialGroupId"] = this.materialGroupId;
        data["periodId"] = this.periodId;
        if (this.suppliersIds && this.suppliersIds.constructor === Array) {
            data["suppliersIds"] = [];
            for (let item of this.suppliersIds)
                data["suppliersIds"].push(item);
        }
        data["reorderLevel"] = this.reorderLevel;
        data["maxQuantity"] = this.maxQuantity;
        data["itemCost"] = this.itemCost;
        data["barcode"] = this.barcode;
        data["sellingPrice"] = this.sellingPrice;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["hasDueDate"] = this.hasDueDate;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["isRecipe"] = this.isRecipe;
        data["reOrderQuantity"] = this.reOrderQuantity;
        data["warningAlertQuantity"] = this.warningAlertQuantity;
        if (this.rawMaterialDetail && this.rawMaterialDetail.constructor === Array) {
            data["rawMaterialDetail"] = [];
            for (let item of this.rawMaterialDetail)
                data["rawMaterialDetail"].push(item.toJSON());
        }
        if (this.rawMaterialComponent && this.rawMaterialComponent.constructor === Array) {
            data["rawMaterialComponent"] = [];
            for (let item of this.rawMaterialComponent)
                data["rawMaterialComponent"].push(item.toJSON());
        }
        if (this.storeGroupIds && this.storeGroupIds.constructor === Array) {
            data["storeGroupIds"] = [];
            for (let item of this.storeGroupIds)
                data["storeGroupIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateRawMaterialInput {
    id: number;
    translations: RawMaterialTranslationDto[];
    materialGroupId: number;
    periodId: number;
    suppliersIds: number[];
    reorderLevel: number;
    maxQuantity: number;
    itemCost: CreateRawMaterialInputItemCost;
    barcode: string;
    sellingPrice: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    hasDueDate: boolean;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    isRecipe: boolean;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    rawMaterialDetail: RawMaterialDetailDto[];
    rawMaterialComponent: RawMaterialDetailDto[];
    storeGroupIds: number[];
}

export class ListResultDtoOfRawMaterialListItem implements IListResultDtoOfRawMaterialListItem {
    items: RawMaterialListItem[];

    constructor(data?: IListResultDtoOfRawMaterialListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RawMaterialListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRawMaterialListItem {
        let result = new ListResultDtoOfRawMaterialListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRawMaterialListItem {
    items: RawMaterialListItem[];
}

export class PagedRawMaterialList implements IPagedRawMaterialList {
    currentPage: number;
    itemsCount: number;
    rawMaterialListItem: RawMaterialListItem[];

    constructor(data?: IPagedRawMaterialList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["rawMaterialListItem"] && data["rawMaterialListItem"].constructor === Array) {
                this.rawMaterialListItem = [];
                for (let item of data["rawMaterialListItem"])
                    this.rawMaterialListItem.push(RawMaterialListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedRawMaterialList {
        let result = new PagedRawMaterialList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.rawMaterialListItem && this.rawMaterialListItem.constructor === Array) {
            data["rawMaterialListItem"] = [];
            for (let item of this.rawMaterialListItem)
                data["rawMaterialListItem"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedRawMaterialList {
    currentPage: number;
    itemsCount: number;
    rawMaterialListItem: RawMaterialListItem[];
}

export class UpdateRawMaterialInput implements IUpdateRawMaterialInput {
    id: number;
    translations: RawMaterialTranslationDto[];
    materialGroupId: number;
    periodId: number;
    suppliersIds: number[];
    reorderLevel: number;
    maxQuantity: number;
    itemCost: UpdateRawMaterialInputItemCost;
    barcode: string;
    sellingPrice: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    hasDueDate: boolean;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    isRecipe: boolean;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    rawMaterialDetail: RawMaterialDetailDto[];
    rawMaterialComponent: RawMaterialDetailDto[];
    storeGroupIds: number[];

    constructor(data?: IUpdateRawMaterialInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RawMaterialTranslationDto.fromJS(item));
            }
            this.materialGroupId = data["materialGroupId"];
            this.periodId = data["periodId"];
            if (data["suppliersIds"] && data["suppliersIds"].constructor === Array) {
                this.suppliersIds = [];
                for (let item of data["suppliersIds"])
                    this.suppliersIds.push(item);
            }
            this.reorderLevel = data["reorderLevel"];
            this.maxQuantity = data["maxQuantity"];
            this.itemCost = data["itemCost"];
            this.barcode = data["barcode"];
            this.sellingPrice = data["sellingPrice"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.hasDueDate = data["hasDueDate"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.isRecipe = data["isRecipe"];
            this.reOrderQuantity = data["reOrderQuantity"];
            this.warningAlertQuantity = data["warningAlertQuantity"];
            if (data["rawMaterialDetail"] && data["rawMaterialDetail"].constructor === Array) {
                this.rawMaterialDetail = [];
                for (let item of data["rawMaterialDetail"])
                    this.rawMaterialDetail.push(RawMaterialDetailDto.fromJS(item));
            }
            if (data["rawMaterialComponent"] && data["rawMaterialComponent"].constructor === Array) {
                this.rawMaterialComponent = [];
                for (let item of data["rawMaterialComponent"])
                    this.rawMaterialComponent.push(RawMaterialDetailDto.fromJS(item));
            }
            if (data["storeGroupIds"] && data["storeGroupIds"].constructor === Array) {
                this.storeGroupIds = [];
                for (let item of data["storeGroupIds"])
                    this.storeGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRawMaterialInput {
        let result = new UpdateRawMaterialInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["materialGroupId"] = this.materialGroupId;
        data["periodId"] = this.periodId;
        if (this.suppliersIds && this.suppliersIds.constructor === Array) {
            data["suppliersIds"] = [];
            for (let item of this.suppliersIds)
                data["suppliersIds"].push(item);
        }
        data["reorderLevel"] = this.reorderLevel;
        data["maxQuantity"] = this.maxQuantity;
        data["itemCost"] = this.itemCost;
        data["barcode"] = this.barcode;
        data["sellingPrice"] = this.sellingPrice;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["hasDueDate"] = this.hasDueDate;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["isRecipe"] = this.isRecipe;
        data["reOrderQuantity"] = this.reOrderQuantity;
        data["warningAlertQuantity"] = this.warningAlertQuantity;
        if (this.rawMaterialDetail && this.rawMaterialDetail.constructor === Array) {
            data["rawMaterialDetail"] = [];
            for (let item of this.rawMaterialDetail)
                data["rawMaterialDetail"].push(item.toJSON());
        }
        if (this.rawMaterialComponent && this.rawMaterialComponent.constructor === Array) {
            data["rawMaterialComponent"] = [];
            for (let item of this.rawMaterialComponent)
                data["rawMaterialComponent"].push(item.toJSON());
        }
        if (this.storeGroupIds && this.storeGroupIds.constructor === Array) {
            data["storeGroupIds"] = [];
            for (let item of this.storeGroupIds)
                data["storeGroupIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateRawMaterialInput {
    id: number;
    translations: RawMaterialTranslationDto[];
    materialGroupId: number;
    periodId: number;
    suppliersIds: number[];
    reorderLevel: number;
    maxQuantity: number;
    itemCost: UpdateRawMaterialInputItemCost;
    barcode: string;
    sellingPrice: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    hasDueDate: boolean;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    isRecipe: boolean;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    rawMaterialDetail: RawMaterialDetailDto[];
    rawMaterialComponent: RawMaterialDetailDto[];
    storeGroupIds: number[];
}

export class RawMaterialResultDto implements IRawMaterialResultDto {
    currentPage: number;
    itemsCount: number;
    items: RawMaterialListItemDto[];

    constructor(data?: IRawMaterialResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RawMaterialListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawMaterialResultDto {
        let result = new RawMaterialResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRawMaterialResultDto {
    currentPage: number;
    itemsCount: number;
    items: RawMaterialListItemDto[];
}

export class RawMaterialListItemDto implements IRawMaterialListItemDto {
    id: number;
    name: string;
    barCode: string;
    purchaseUnitOfMeasureName: string;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;

    constructor(data?: IRawMaterialListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.barCode = data["barCode"];
            this.purchaseUnitOfMeasureName = data["purchaseUnitOfMeasureName"];
            this.inventoryUnitOfMeasureName = data["inventoryUnitOfMeasureName"];
            this.productUnitOfMeasureName = data["productUnitOfMeasureName"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
        }
    }

    static fromJS(data: any): RawMaterialListItemDto {
        let result = new RawMaterialListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["barCode"] = this.barCode;
        data["purchaseUnitOfMeasureName"] = this.purchaseUnitOfMeasureName;
        data["inventoryUnitOfMeasureName"] = this.inventoryUnitOfMeasureName;
        data["productUnitOfMeasureName"] = this.productUnitOfMeasureName;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        return data; 
    }
}

export interface IRawMaterialListItemDto {
    id: number;
    name: string;
    barCode: string;
    purchaseUnitOfMeasureName: string;
    inventoryUnitOfMeasureName: string;
    productUnitOfMeasureName: string;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
}

export class PagedRawMaterialConfigList implements IPagedRawMaterialConfigList {
    currentPage: number;
    itemsCount: number;
    items: RawMaterialConfigListDto[];

    constructor(data?: IPagedRawMaterialConfigList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RawMaterialConfigListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedRawMaterialConfigList {
        let result = new PagedRawMaterialConfigList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedRawMaterialConfigList {
    currentPage: number;
    itemsCount: number;
    items: RawMaterialConfigListDto[];
}

export class RawMaterialConfigListDto implements IRawMaterialConfigListDto {
    id: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    rawMaterialCode: string;
    rawMaterialName: string;
    storeTypesNames: string;

    constructor(data?: IRawMaterialConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isHidden = data["isHidden"];
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.rawMaterialCode = data["rawMaterialCode"];
            this.rawMaterialName = data["rawMaterialName"];
            this.storeTypesNames = data["storeTypesNames"];
        }
    }

    static fromJS(data: any): RawMaterialConfigListDto {
        let result = new RawMaterialConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isHidden"] = this.isHidden;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["rawMaterialCode"] = this.rawMaterialCode;
        data["rawMaterialName"] = this.rawMaterialName;
        data["storeTypesNames"] = this.storeTypesNames;
        return data; 
    }
}

export interface IRawMaterialConfigListDto {
    id: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    rawMaterialCode: string;
    rawMaterialName: string;
    storeTypesNames: string;
}

export class RawMaterialConfigDto implements IRawMaterialConfigDto {
    id: number;
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: number;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    storeIds: number[];

    constructor(data?: IRawMaterialConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rawMaterialId = data["rawMaterialId"];
            this.periodId = data["periodId"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.isHidden = data["isHidden"];
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
            this.isRecipe = data["isRecipe"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): RawMaterialConfigDto {
        let result = new RawMaterialConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rawMaterialId"] = this.rawMaterialId;
        data["periodId"] = this.periodId;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["isHidden"] = this.isHidden;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        data["isRecipe"] = this.isRecipe;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IRawMaterialConfigDto {
    id: number;
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: number;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    storeIds: number[];
}

export class CreateRawMaterialConfigDto implements ICreateRawMaterialConfigDto {
    storeIds: number[];
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: number;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;

    constructor(data?: ICreateRawMaterialConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.rawMaterialId = data["rawMaterialId"];
            this.periodId = data["periodId"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.isHidden = data["isHidden"];
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
            this.isRecipe = data["isRecipe"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
        }
    }

    static fromJS(data: any): CreateRawMaterialConfigDto {
        let result = new CreateRawMaterialConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["rawMaterialId"] = this.rawMaterialId;
        data["periodId"] = this.periodId;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["isHidden"] = this.isHidden;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        data["isRecipe"] = this.isRecipe;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        return data; 
    }
}

export interface ICreateRawMaterialConfigDto {
    storeIds: number[];
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: number;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
}

export class UpdateRawMaterialConfigDto implements IUpdateRawMaterialConfigDto {
    id: number;
    storeIds: number[];
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: number;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;

    constructor(data?: IUpdateRawMaterialConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.rawMaterialId = data["rawMaterialId"];
            this.periodId = data["periodId"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.isHidden = data["isHidden"];
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
            this.isRecipe = data["isRecipe"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
        }
    }

    static fromJS(data: any): UpdateRawMaterialConfigDto {
        let result = new UpdateRawMaterialConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["rawMaterialId"] = this.rawMaterialId;
        data["periodId"] = this.periodId;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["isHidden"] = this.isHidden;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        data["isRecipe"] = this.isRecipe;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        return data; 
    }
}

export interface IUpdateRawMaterialConfigDto {
    id: number;
    storeIds: number[];
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: number;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
}

export class ReceiptCustomizationDto implements IReceiptCustomizationDto {
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IReceiptCustomizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.printerType = data["printerType"];
            this.taxNumber = data["taxNumber"];
            this.phoneNumber = data["phoneNumber"];
            this.sellerName = data["sellerName"];
            this.hideFreeModifiers = data["hideFreeModifiers"];
            this.hideAllModifiers = data["hideAllModifiers"];
            this.headerTextAr = data["headerTextAr"];
            this.headerTextEn = data["headerTextEn"];
            this.headerFontSize = data["headerFontSize"];
            this.headerFontFamily = data["headerFontFamily"];
            this.headerIsBold = data["headerIsBold"];
            this.bodyFontSize = data["bodyFontSize"];
            this.bodyFontFamily = data["bodyFontFamily"];
            this.bodyIsBold = data["bodyIsBold"];
            this.grandTotalFontSize = data["grandTotalFontSize"];
            this.grandTotalFontFamily = data["grandTotalFontFamily"];
            this.grandTotalIsBold = data["grandTotalIsBold"];
            this.grandTotalShowKitchen = data["grandTotalShowKitchen"];
            this.paymentFontSize = data["paymentFontSize"];
            this.paymentFontFamily = data["paymentFontFamily"];
            this.paymentIsBold = data["paymentIsBold"];
            this.paymentShowKitchen = data["paymentShowKitchen"];
            this.invoiceNumberFontSize = data["invoiceNumberFontSize"];
            this.invoiceNumberFontFamily = data["invoiceNumberFontFamily"];
            this.invoiceNumberIsBold = data["invoiceNumberIsBold"];
            this.priceFontSize = data["priceFontSize"];
            this.priceFontFamily = data["priceFontFamily"];
            this.priceIsBold = data["priceIsBold"];
            this.totalFontSize = data["totalFontSize"];
            this.totalFontFamily = data["totalFontFamily"];
            this.totalIsBold = data["totalIsBold"];
            this.footerTextAr = data["footerTextAr"];
            this.footerTextEn = data["footerTextEn"];
            this.footerFontSize = data["footerFontSize"];
            this.footerFontFamily = data["footerFontFamily"];
            this.footerIsBold = data["footerIsBold"];
            this.isActive = data["isActive"];
            this.logo = data["logo"];
            this.kitchenPrenterLanguage = data["kitchenPrenterLanguage"];
            this.kitchenPrintEnglishAndArabic = data["kitchenPrintEnglishAndArabic"];
            this.kitchenShowQRCode = data["kitchenShowQRCode"];
            this.kitchenShowLogo = data["kitchenShowLogo"];
            this.kitchenPrintingCount = data["kitchenPrintingCount"];
            this.cashierPrenterLanguage = data["cashierPrenterLanguage"];
            this.cashierPrintEnglishAndArabic = data["cashierPrintEnglishAndArabic"];
            this.cashierShowQRCode = data["cashierShowQRCode"];
            this.cashierSalePrintingCount = data["cashierSalePrintingCount"];
            this.cashierRefundPrintingCount = data["cashierRefundPrintingCount"];
            this.controlPrenterLanguage = data["controlPrenterLanguage"];
            this.controlPrintEnglishAndArabic = data["controlPrintEnglishAndArabic"];
            this.controlShowQRCode = data["controlShowQRCode"];
            this.controlPrintingCount = data["controlPrintingCount"];
            this.orderControlPrenterLanguage = data["orderControlPrenterLanguage"];
            this.orderControlShowQRCode = data["orderControlShowQRCode"];
            this.orderControlPrintingCount = data["orderControlPrintingCount"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReceiptCustomizationDto {
        let result = new ReceiptCustomizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["printerType"] = this.printerType;
        data["taxNumber"] = this.taxNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["sellerName"] = this.sellerName;
        data["hideFreeModifiers"] = this.hideFreeModifiers;
        data["hideAllModifiers"] = this.hideAllModifiers;
        data["headerTextAr"] = this.headerTextAr;
        data["headerTextEn"] = this.headerTextEn;
        data["headerFontSize"] = this.headerFontSize;
        data["headerFontFamily"] = this.headerFontFamily;
        data["headerIsBold"] = this.headerIsBold;
        data["bodyFontSize"] = this.bodyFontSize;
        data["bodyFontFamily"] = this.bodyFontFamily;
        data["bodyIsBold"] = this.bodyIsBold;
        data["grandTotalFontSize"] = this.grandTotalFontSize;
        data["grandTotalFontFamily"] = this.grandTotalFontFamily;
        data["grandTotalIsBold"] = this.grandTotalIsBold;
        data["grandTotalShowKitchen"] = this.grandTotalShowKitchen;
        data["paymentFontSize"] = this.paymentFontSize;
        data["paymentFontFamily"] = this.paymentFontFamily;
        data["paymentIsBold"] = this.paymentIsBold;
        data["paymentShowKitchen"] = this.paymentShowKitchen;
        data["invoiceNumberFontSize"] = this.invoiceNumberFontSize;
        data["invoiceNumberFontFamily"] = this.invoiceNumberFontFamily;
        data["invoiceNumberIsBold"] = this.invoiceNumberIsBold;
        data["priceFontSize"] = this.priceFontSize;
        data["priceFontFamily"] = this.priceFontFamily;
        data["priceIsBold"] = this.priceIsBold;
        data["totalFontSize"] = this.totalFontSize;
        data["totalFontFamily"] = this.totalFontFamily;
        data["totalIsBold"] = this.totalIsBold;
        data["footerTextAr"] = this.footerTextAr;
        data["footerTextEn"] = this.footerTextEn;
        data["footerFontSize"] = this.footerFontSize;
        data["footerFontFamily"] = this.footerFontFamily;
        data["footerIsBold"] = this.footerIsBold;
        data["isActive"] = this.isActive;
        data["logo"] = this.logo;
        data["kitchenPrenterLanguage"] = this.kitchenPrenterLanguage;
        data["kitchenPrintEnglishAndArabic"] = this.kitchenPrintEnglishAndArabic;
        data["kitchenShowQRCode"] = this.kitchenShowQRCode;
        data["kitchenShowLogo"] = this.kitchenShowLogo;
        data["kitchenPrintingCount"] = this.kitchenPrintingCount;
        data["cashierPrenterLanguage"] = this.cashierPrenterLanguage;
        data["cashierPrintEnglishAndArabic"] = this.cashierPrintEnglishAndArabic;
        data["cashierShowQRCode"] = this.cashierShowQRCode;
        data["cashierSalePrintingCount"] = this.cashierSalePrintingCount;
        data["cashierRefundPrintingCount"] = this.cashierRefundPrintingCount;
        data["controlPrenterLanguage"] = this.controlPrenterLanguage;
        data["controlPrintEnglishAndArabic"] = this.controlPrintEnglishAndArabic;
        data["controlShowQRCode"] = this.controlShowQRCode;
        data["controlPrintingCount"] = this.controlPrintingCount;
        data["orderControlPrenterLanguage"] = this.orderControlPrenterLanguage;
        data["orderControlShowQRCode"] = this.orderControlShowQRCode;
        data["orderControlPrintingCount"] = this.orderControlPrintingCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReceiptCustomizationDto {
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedReceiptCustomizationList implements IPagedReceiptCustomizationList {
    currentPage: number;
    itemsCount: number;
    receipts: ReceiptCustomizationListItem[];

    constructor(data?: IPagedReceiptCustomizationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["receipts"] && data["receipts"].constructor === Array) {
                this.receipts = [];
                for (let item of data["receipts"])
                    this.receipts.push(ReceiptCustomizationListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedReceiptCustomizationList {
        let result = new PagedReceiptCustomizationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.receipts && this.receipts.constructor === Array) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedReceiptCustomizationList {
    currentPage: number;
    itemsCount: number;
    receipts: ReceiptCustomizationListItem[];
}

export class ReceiptCustomizationListItem implements IReceiptCustomizationListItem {
    id: number;
    tenantId: number;
    storeId: number;
    headerText: string;
    footerText: string;
    isActive: boolean;
    tenantName: string;

    constructor(data?: IReceiptCustomizationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.headerText = data["headerText"];
            this.footerText = data["footerText"];
            this.isActive = data["isActive"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): ReceiptCustomizationListItem {
        let result = new ReceiptCustomizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["headerText"] = this.headerText;
        data["footerText"] = this.footerText;
        data["isActive"] = this.isActive;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface IReceiptCustomizationListItem {
    id: number;
    tenantId: number;
    storeId: number;
    headerText: string;
    footerText: string;
    isActive: boolean;
    tenantName: string;
}

export class CreateReceiptCustomizationInput implements ICreateReceiptCustomizationInput {
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;

    constructor(data?: ICreateReceiptCustomizationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.printerType = data["printerType"];
            this.taxNumber = data["taxNumber"];
            this.phoneNumber = data["phoneNumber"];
            this.sellerName = data["sellerName"];
            this.hideFreeModifiers = data["hideFreeModifiers"];
            this.hideAllModifiers = data["hideAllModifiers"];
            this.headerTextAr = data["headerTextAr"];
            this.headerTextEn = data["headerTextEn"];
            this.headerFontSize = data["headerFontSize"];
            this.headerFontFamily = data["headerFontFamily"];
            this.headerIsBold = data["headerIsBold"];
            this.bodyFontSize = data["bodyFontSize"];
            this.bodyFontFamily = data["bodyFontFamily"];
            this.bodyIsBold = data["bodyIsBold"];
            this.grandTotalFontSize = data["grandTotalFontSize"];
            this.grandTotalFontFamily = data["grandTotalFontFamily"];
            this.grandTotalIsBold = data["grandTotalIsBold"];
            this.grandTotalShowKitchen = data["grandTotalShowKitchen"];
            this.paymentFontSize = data["paymentFontSize"];
            this.paymentFontFamily = data["paymentFontFamily"];
            this.paymentIsBold = data["paymentIsBold"];
            this.paymentShowKitchen = data["paymentShowKitchen"];
            this.invoiceNumberFontSize = data["invoiceNumberFontSize"];
            this.invoiceNumberFontFamily = data["invoiceNumberFontFamily"];
            this.invoiceNumberIsBold = data["invoiceNumberIsBold"];
            this.priceFontSize = data["priceFontSize"];
            this.priceFontFamily = data["priceFontFamily"];
            this.priceIsBold = data["priceIsBold"];
            this.totalFontSize = data["totalFontSize"];
            this.totalFontFamily = data["totalFontFamily"];
            this.totalIsBold = data["totalIsBold"];
            this.footerTextAr = data["footerTextAr"];
            this.footerTextEn = data["footerTextEn"];
            this.footerFontSize = data["footerFontSize"];
            this.footerFontFamily = data["footerFontFamily"];
            this.footerIsBold = data["footerIsBold"];
            this.isActive = data["isActive"];
            this.logo = data["logo"];
            this.kitchenPrenterLanguage = data["kitchenPrenterLanguage"];
            this.kitchenPrintEnglishAndArabic = data["kitchenPrintEnglishAndArabic"];
            this.kitchenShowQRCode = data["kitchenShowQRCode"];
            this.kitchenShowLogo = data["kitchenShowLogo"];
            this.kitchenPrintingCount = data["kitchenPrintingCount"];
            this.cashierPrenterLanguage = data["cashierPrenterLanguage"];
            this.cashierPrintEnglishAndArabic = data["cashierPrintEnglishAndArabic"];
            this.cashierShowQRCode = data["cashierShowQRCode"];
            this.cashierSalePrintingCount = data["cashierSalePrintingCount"];
            this.cashierRefundPrintingCount = data["cashierRefundPrintingCount"];
            this.controlPrenterLanguage = data["controlPrenterLanguage"];
            this.controlPrintEnglishAndArabic = data["controlPrintEnglishAndArabic"];
            this.controlShowQRCode = data["controlShowQRCode"];
            this.controlPrintingCount = data["controlPrintingCount"];
            this.orderControlPrenterLanguage = data["orderControlPrenterLanguage"];
            this.orderControlShowQRCode = data["orderControlShowQRCode"];
            this.orderControlPrintingCount = data["orderControlPrintingCount"];
        }
    }

    static fromJS(data: any): CreateReceiptCustomizationInput {
        let result = new CreateReceiptCustomizationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["printerType"] = this.printerType;
        data["taxNumber"] = this.taxNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["sellerName"] = this.sellerName;
        data["hideFreeModifiers"] = this.hideFreeModifiers;
        data["hideAllModifiers"] = this.hideAllModifiers;
        data["headerTextAr"] = this.headerTextAr;
        data["headerTextEn"] = this.headerTextEn;
        data["headerFontSize"] = this.headerFontSize;
        data["headerFontFamily"] = this.headerFontFamily;
        data["headerIsBold"] = this.headerIsBold;
        data["bodyFontSize"] = this.bodyFontSize;
        data["bodyFontFamily"] = this.bodyFontFamily;
        data["bodyIsBold"] = this.bodyIsBold;
        data["grandTotalFontSize"] = this.grandTotalFontSize;
        data["grandTotalFontFamily"] = this.grandTotalFontFamily;
        data["grandTotalIsBold"] = this.grandTotalIsBold;
        data["grandTotalShowKitchen"] = this.grandTotalShowKitchen;
        data["paymentFontSize"] = this.paymentFontSize;
        data["paymentFontFamily"] = this.paymentFontFamily;
        data["paymentIsBold"] = this.paymentIsBold;
        data["paymentShowKitchen"] = this.paymentShowKitchen;
        data["invoiceNumberFontSize"] = this.invoiceNumberFontSize;
        data["invoiceNumberFontFamily"] = this.invoiceNumberFontFamily;
        data["invoiceNumberIsBold"] = this.invoiceNumberIsBold;
        data["priceFontSize"] = this.priceFontSize;
        data["priceFontFamily"] = this.priceFontFamily;
        data["priceIsBold"] = this.priceIsBold;
        data["totalFontSize"] = this.totalFontSize;
        data["totalFontFamily"] = this.totalFontFamily;
        data["totalIsBold"] = this.totalIsBold;
        data["footerTextAr"] = this.footerTextAr;
        data["footerTextEn"] = this.footerTextEn;
        data["footerFontSize"] = this.footerFontSize;
        data["footerFontFamily"] = this.footerFontFamily;
        data["footerIsBold"] = this.footerIsBold;
        data["isActive"] = this.isActive;
        data["logo"] = this.logo;
        data["kitchenPrenterLanguage"] = this.kitchenPrenterLanguage;
        data["kitchenPrintEnglishAndArabic"] = this.kitchenPrintEnglishAndArabic;
        data["kitchenShowQRCode"] = this.kitchenShowQRCode;
        data["kitchenShowLogo"] = this.kitchenShowLogo;
        data["kitchenPrintingCount"] = this.kitchenPrintingCount;
        data["cashierPrenterLanguage"] = this.cashierPrenterLanguage;
        data["cashierPrintEnglishAndArabic"] = this.cashierPrintEnglishAndArabic;
        data["cashierShowQRCode"] = this.cashierShowQRCode;
        data["cashierSalePrintingCount"] = this.cashierSalePrintingCount;
        data["cashierRefundPrintingCount"] = this.cashierRefundPrintingCount;
        data["controlPrenterLanguage"] = this.controlPrenterLanguage;
        data["controlPrintEnglishAndArabic"] = this.controlPrintEnglishAndArabic;
        data["controlShowQRCode"] = this.controlShowQRCode;
        data["controlPrintingCount"] = this.controlPrintingCount;
        data["orderControlPrenterLanguage"] = this.orderControlPrenterLanguage;
        data["orderControlShowQRCode"] = this.orderControlShowQRCode;
        data["orderControlPrintingCount"] = this.orderControlPrintingCount;
        return data; 
    }
}

export interface ICreateReceiptCustomizationInput {
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;
}

export class UpdateReceiptCustomizationInput implements IUpdateReceiptCustomizationInput {
    id: number;
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;

    constructor(data?: IUpdateReceiptCustomizationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.printerType = data["printerType"];
            this.taxNumber = data["taxNumber"];
            this.phoneNumber = data["phoneNumber"];
            this.sellerName = data["sellerName"];
            this.hideFreeModifiers = data["hideFreeModifiers"];
            this.hideAllModifiers = data["hideAllModifiers"];
            this.headerTextAr = data["headerTextAr"];
            this.headerTextEn = data["headerTextEn"];
            this.headerFontSize = data["headerFontSize"];
            this.headerFontFamily = data["headerFontFamily"];
            this.headerIsBold = data["headerIsBold"];
            this.bodyFontSize = data["bodyFontSize"];
            this.bodyFontFamily = data["bodyFontFamily"];
            this.bodyIsBold = data["bodyIsBold"];
            this.grandTotalFontSize = data["grandTotalFontSize"];
            this.grandTotalFontFamily = data["grandTotalFontFamily"];
            this.grandTotalIsBold = data["grandTotalIsBold"];
            this.grandTotalShowKitchen = data["grandTotalShowKitchen"];
            this.paymentFontSize = data["paymentFontSize"];
            this.paymentFontFamily = data["paymentFontFamily"];
            this.paymentIsBold = data["paymentIsBold"];
            this.paymentShowKitchen = data["paymentShowKitchen"];
            this.invoiceNumberFontSize = data["invoiceNumberFontSize"];
            this.invoiceNumberFontFamily = data["invoiceNumberFontFamily"];
            this.invoiceNumberIsBold = data["invoiceNumberIsBold"];
            this.priceFontSize = data["priceFontSize"];
            this.priceFontFamily = data["priceFontFamily"];
            this.priceIsBold = data["priceIsBold"];
            this.totalFontSize = data["totalFontSize"];
            this.totalFontFamily = data["totalFontFamily"];
            this.totalIsBold = data["totalIsBold"];
            this.footerTextAr = data["footerTextAr"];
            this.footerTextEn = data["footerTextEn"];
            this.footerFontSize = data["footerFontSize"];
            this.footerFontFamily = data["footerFontFamily"];
            this.footerIsBold = data["footerIsBold"];
            this.isActive = data["isActive"];
            this.logo = data["logo"];
            this.kitchenPrenterLanguage = data["kitchenPrenterLanguage"];
            this.kitchenPrintEnglishAndArabic = data["kitchenPrintEnglishAndArabic"];
            this.kitchenShowQRCode = data["kitchenShowQRCode"];
            this.kitchenShowLogo = data["kitchenShowLogo"];
            this.kitchenPrintingCount = data["kitchenPrintingCount"];
            this.cashierPrenterLanguage = data["cashierPrenterLanguage"];
            this.cashierPrintEnglishAndArabic = data["cashierPrintEnglishAndArabic"];
            this.cashierShowQRCode = data["cashierShowQRCode"];
            this.cashierSalePrintingCount = data["cashierSalePrintingCount"];
            this.cashierRefundPrintingCount = data["cashierRefundPrintingCount"];
            this.controlPrenterLanguage = data["controlPrenterLanguage"];
            this.controlPrintEnglishAndArabic = data["controlPrintEnglishAndArabic"];
            this.controlShowQRCode = data["controlShowQRCode"];
            this.controlPrintingCount = data["controlPrintingCount"];
            this.orderControlPrenterLanguage = data["orderControlPrenterLanguage"];
            this.orderControlShowQRCode = data["orderControlShowQRCode"];
            this.orderControlPrintingCount = data["orderControlPrintingCount"];
        }
    }

    static fromJS(data: any): UpdateReceiptCustomizationInput {
        let result = new UpdateReceiptCustomizationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["printerType"] = this.printerType;
        data["taxNumber"] = this.taxNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["sellerName"] = this.sellerName;
        data["hideFreeModifiers"] = this.hideFreeModifiers;
        data["hideAllModifiers"] = this.hideAllModifiers;
        data["headerTextAr"] = this.headerTextAr;
        data["headerTextEn"] = this.headerTextEn;
        data["headerFontSize"] = this.headerFontSize;
        data["headerFontFamily"] = this.headerFontFamily;
        data["headerIsBold"] = this.headerIsBold;
        data["bodyFontSize"] = this.bodyFontSize;
        data["bodyFontFamily"] = this.bodyFontFamily;
        data["bodyIsBold"] = this.bodyIsBold;
        data["grandTotalFontSize"] = this.grandTotalFontSize;
        data["grandTotalFontFamily"] = this.grandTotalFontFamily;
        data["grandTotalIsBold"] = this.grandTotalIsBold;
        data["grandTotalShowKitchen"] = this.grandTotalShowKitchen;
        data["paymentFontSize"] = this.paymentFontSize;
        data["paymentFontFamily"] = this.paymentFontFamily;
        data["paymentIsBold"] = this.paymentIsBold;
        data["paymentShowKitchen"] = this.paymentShowKitchen;
        data["invoiceNumberFontSize"] = this.invoiceNumberFontSize;
        data["invoiceNumberFontFamily"] = this.invoiceNumberFontFamily;
        data["invoiceNumberIsBold"] = this.invoiceNumberIsBold;
        data["priceFontSize"] = this.priceFontSize;
        data["priceFontFamily"] = this.priceFontFamily;
        data["priceIsBold"] = this.priceIsBold;
        data["totalFontSize"] = this.totalFontSize;
        data["totalFontFamily"] = this.totalFontFamily;
        data["totalIsBold"] = this.totalIsBold;
        data["footerTextAr"] = this.footerTextAr;
        data["footerTextEn"] = this.footerTextEn;
        data["footerFontSize"] = this.footerFontSize;
        data["footerFontFamily"] = this.footerFontFamily;
        data["footerIsBold"] = this.footerIsBold;
        data["isActive"] = this.isActive;
        data["logo"] = this.logo;
        data["kitchenPrenterLanguage"] = this.kitchenPrenterLanguage;
        data["kitchenPrintEnglishAndArabic"] = this.kitchenPrintEnglishAndArabic;
        data["kitchenShowQRCode"] = this.kitchenShowQRCode;
        data["kitchenShowLogo"] = this.kitchenShowLogo;
        data["kitchenPrintingCount"] = this.kitchenPrintingCount;
        data["cashierPrenterLanguage"] = this.cashierPrenterLanguage;
        data["cashierPrintEnglishAndArabic"] = this.cashierPrintEnglishAndArabic;
        data["cashierShowQRCode"] = this.cashierShowQRCode;
        data["cashierSalePrintingCount"] = this.cashierSalePrintingCount;
        data["cashierRefundPrintingCount"] = this.cashierRefundPrintingCount;
        data["controlPrenterLanguage"] = this.controlPrenterLanguage;
        data["controlPrintEnglishAndArabic"] = this.controlPrintEnglishAndArabic;
        data["controlShowQRCode"] = this.controlShowQRCode;
        data["controlPrintingCount"] = this.controlPrintingCount;
        data["orderControlPrenterLanguage"] = this.orderControlPrenterLanguage;
        data["orderControlShowQRCode"] = this.orderControlShowQRCode;
        data["orderControlPrintingCount"] = this.orderControlPrintingCount;
        return data; 
    }
}

export interface IUpdateReceiptCustomizationInput {
    id: number;
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;
}

export class CreateFileDto implements ICreateFileDto {
    id: string;
    filePath: string;

    constructor(data?: ICreateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.filePath = data["filePath"];
        }
    }

    static fromJS(data: any): CreateFileDto {
        let result = new CreateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filePath"] = this.filePath;
        return data; 
    }
}

export interface ICreateFileDto {
    id: string;
    filePath: string;
}

export class CreateRecipeInput implements ICreateRecipeInput {
    translations: RecipeTranslationDto[];
    recipeRawMaterials: RecipeRawMaterialDto[];
    menuItemId: number;
    lossFactor: number;
    recipeCode: string;
    storeIds: number[];

    constructor(data?: ICreateRecipeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RecipeTranslationDto.fromJS(item));
            }
            if (data["recipeRawMaterials"] && data["recipeRawMaterials"].constructor === Array) {
                this.recipeRawMaterials = [];
                for (let item of data["recipeRawMaterials"])
                    this.recipeRawMaterials.push(RecipeRawMaterialDto.fromJS(item));
            }
            this.menuItemId = data["menuItemId"];
            this.lossFactor = data["lossFactor"];
            this.recipeCode = data["recipeCode"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRecipeInput {
        let result = new CreateRecipeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.recipeRawMaterials && this.recipeRawMaterials.constructor === Array) {
            data["recipeRawMaterials"] = [];
            for (let item of this.recipeRawMaterials)
                data["recipeRawMaterials"].push(item.toJSON());
        }
        data["menuItemId"] = this.menuItemId;
        data["lossFactor"] = this.lossFactor;
        data["recipeCode"] = this.recipeCode;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateRecipeInput {
    translations: RecipeTranslationDto[];
    recipeRawMaterials: RecipeRawMaterialDto[];
    menuItemId: number;
    lossFactor: number;
    recipeCode: string;
    storeIds: number[];
}

export class ListResultDtoOfRecipeListItem implements IListResultDtoOfRecipeListItem {
    items: RecipeListItem[];

    constructor(data?: IListResultDtoOfRecipeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RecipeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRecipeListItem {
        let result = new ListResultDtoOfRecipeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRecipeListItem {
    items: RecipeListItem[];
}

export class RecipeListItem implements IRecipeListItem {
    id: number;
    menuItemName: string;
    menuItemId: number;
    menuItemCode: string;
    recipeCode: string;
    lossFactor: number;
    storeNames: string;
    recipeRawMaterials: RecipeRawMaterialDto[];

    constructor(data?: IRecipeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemName = data["menuItemName"];
            this.menuItemId = data["menuItemId"];
            this.menuItemCode = data["menuItemCode"];
            this.recipeCode = data["recipeCode"];
            this.lossFactor = data["lossFactor"];
            this.storeNames = data["storeNames"];
            if (data["recipeRawMaterials"] && data["recipeRawMaterials"].constructor === Array) {
                this.recipeRawMaterials = [];
                for (let item of data["recipeRawMaterials"])
                    this.recipeRawMaterials.push(RecipeRawMaterialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipeListItem {
        let result = new RecipeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemName"] = this.menuItemName;
        data["menuItemId"] = this.menuItemId;
        data["menuItemCode"] = this.menuItemCode;
        data["recipeCode"] = this.recipeCode;
        data["lossFactor"] = this.lossFactor;
        data["storeNames"] = this.storeNames;
        if (this.recipeRawMaterials && this.recipeRawMaterials.constructor === Array) {
            data["recipeRawMaterials"] = [];
            for (let item of this.recipeRawMaterials)
                data["recipeRawMaterials"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRecipeListItem {
    id: number;
    menuItemName: string;
    menuItemId: number;
    menuItemCode: string;
    recipeCode: string;
    lossFactor: number;
    storeNames: string;
    recipeRawMaterials: RecipeRawMaterialDto[];
}

export class PagedRecipeListWithTotal implements IPagedRecipeListWithTotal {
    currentPage: number;
    itemsCount: number;
    recipes: RecipeListItemWithTotal[];

    constructor(data?: IPagedRecipeListWithTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["recipes"] && data["recipes"].constructor === Array) {
                this.recipes = [];
                for (let item of data["recipes"])
                    this.recipes.push(RecipeListItemWithTotal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedRecipeListWithTotal {
        let result = new PagedRecipeListWithTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.recipes && this.recipes.constructor === Array) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedRecipeListWithTotal {
    currentPage: number;
    itemsCount: number;
    recipes: RecipeListItemWithTotal[];
}

export class RecipeListItemWithTotal implements IRecipeListItemWithTotal {
    id: number;
    menuItemName: string;
    menuItemCode: string;
    recipeCode: string;
    lossFactor: number;
    total: number;
    recipeRawMaterials: RecipeRawMaterialDto[];

    constructor(data?: IRecipeListItemWithTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemName = data["menuItemName"];
            this.menuItemCode = data["menuItemCode"];
            this.recipeCode = data["recipeCode"];
            this.lossFactor = data["lossFactor"];
            this.total = data["total"];
            if (data["recipeRawMaterials"] && data["recipeRawMaterials"].constructor === Array) {
                this.recipeRawMaterials = [];
                for (let item of data["recipeRawMaterials"])
                    this.recipeRawMaterials.push(RecipeRawMaterialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipeListItemWithTotal {
        let result = new RecipeListItemWithTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemName"] = this.menuItemName;
        data["menuItemCode"] = this.menuItemCode;
        data["recipeCode"] = this.recipeCode;
        data["lossFactor"] = this.lossFactor;
        data["total"] = this.total;
        if (this.recipeRawMaterials && this.recipeRawMaterials.constructor === Array) {
            data["recipeRawMaterials"] = [];
            for (let item of this.recipeRawMaterials)
                data["recipeRawMaterials"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRecipeListItemWithTotal {
    id: number;
    menuItemName: string;
    menuItemCode: string;
    recipeCode: string;
    lossFactor: number;
    total: number;
    recipeRawMaterials: RecipeRawMaterialDto[];
}

export class UpdateRecipeInput implements IUpdateRecipeInput {
    id: number;
    translations: RecipeTranslationDto[];
    recipeRawMaterials: RecipeRawMaterialDto[];
    menuItemId: number;
    lossFactor: number;
    recipeCode: string;
    storeIds: number[];

    constructor(data?: IUpdateRecipeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RecipeTranslationDto.fromJS(item));
            }
            if (data["recipeRawMaterials"] && data["recipeRawMaterials"].constructor === Array) {
                this.recipeRawMaterials = [];
                for (let item of data["recipeRawMaterials"])
                    this.recipeRawMaterials.push(RecipeRawMaterialDto.fromJS(item));
            }
            this.menuItemId = data["menuItemId"];
            this.lossFactor = data["lossFactor"];
            this.recipeCode = data["recipeCode"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRecipeInput {
        let result = new UpdateRecipeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.recipeRawMaterials && this.recipeRawMaterials.constructor === Array) {
            data["recipeRawMaterials"] = [];
            for (let item of this.recipeRawMaterials)
                data["recipeRawMaterials"].push(item.toJSON());
        }
        data["menuItemId"] = this.menuItemId;
        data["lossFactor"] = this.lossFactor;
        data["recipeCode"] = this.recipeCode;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateRecipeInput {
    id: number;
    translations: RecipeTranslationDto[];
    recipeRawMaterials: RecipeRawMaterialDto[];
    menuItemId: number;
    lossFactor: number;
    recipeCode: string;
    storeIds: number[];
}

export class RefundResonDto implements IRefundResonDto {
    id: number;
    code: string;
    description: string;

    constructor(data?: IRefundResonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): RefundResonDto {
        let result = new RefundResonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IRefundResonDto {
    id: number;
    code: string;
    description: string;
}

export class RefundResonList implements IRefundResonList {
    currentPage: number;
    itemsCount: number;
    refundResonListItem: RefundResonDto[];

    constructor(data?: IRefundResonList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["refundResonListItem"] && data["refundResonListItem"].constructor === Array) {
                this.refundResonListItem = [];
                for (let item of data["refundResonListItem"])
                    this.refundResonListItem.push(RefundResonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RefundResonList {
        let result = new RefundResonList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.refundResonListItem && this.refundResonListItem.constructor === Array) {
            data["refundResonListItem"] = [];
            for (let item of this.refundResonListItem)
                data["refundResonListItem"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRefundResonList {
    currentPage: number;
    itemsCount: number;
    refundResonListItem: RefundResonDto[];
}

export class PagedRegionsList implements IPagedRegionsList {
    currentPage: number;
    itemsCount: number;
    regions: RegionListItem[];

    constructor(data?: IPagedRegionsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["regions"] && data["regions"].constructor === Array) {
                this.regions = [];
                for (let item of data["regions"])
                    this.regions.push(RegionListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedRegionsList {
        let result = new PagedRegionsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.regions && this.regions.constructor === Array) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedRegionsList {
    currentPage: number;
    itemsCount: number;
    regions: RegionListItem[];
}

export class RegionListItem implements IRegionListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IRegionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): RegionListItem {
        let result = new RegionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IRegionListItem {
    id: number;
    name: string;
    code: string;
}

export class RegionDto implements IRegionDto {
    code: string;
    translations: RegionTranslationDto[];
    regionStoreGroupIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RegionTranslationDto.fromJS(item));
            }
            if (data["regionStoreGroupIds"] && data["regionStoreGroupIds"].constructor === Array) {
                this.regionStoreGroupIds = [];
                for (let item of data["regionStoreGroupIds"])
                    this.regionStoreGroupIds.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionDto {
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.regionStoreGroupIds && this.regionStoreGroupIds.constructor === Array) {
            data["regionStoreGroupIds"] = [];
            for (let item of this.regionStoreGroupIds)
                data["regionStoreGroupIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegionDto {
    code: string;
    translations: RegionTranslationDto[];
    regionStoreGroupIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RegionTranslationDto implements IRegionTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IRegionTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): RegionTranslationDto {
        let result = new RegionTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IRegionTranslationDto {
    name: string;
    languageId: number;
}

export class CreateRegionInput implements ICreateRegionInput {
    code: string;
    translations: RegionTranslationDto[];
    regionStoreGroupIds: number[];

    constructor(data?: ICreateRegionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RegionTranslationDto.fromJS(item));
            }
            if (data["regionStoreGroupIds"] && data["regionStoreGroupIds"].constructor === Array) {
                this.regionStoreGroupIds = [];
                for (let item of data["regionStoreGroupIds"])
                    this.regionStoreGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRegionInput {
        let result = new CreateRegionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.regionStoreGroupIds && this.regionStoreGroupIds.constructor === Array) {
            data["regionStoreGroupIds"] = [];
            for (let item of this.regionStoreGroupIds)
                data["regionStoreGroupIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateRegionInput {
    code: string;
    translations: RegionTranslationDto[];
    regionStoreGroupIds: number[];
}

export class UpdateRegionInput implements IUpdateRegionInput {
    id: number;
    code: string;
    translations: RegionTranslationDto[];
    regionStoreGroupIds: number[];

    constructor(data?: IUpdateRegionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RegionTranslationDto.fromJS(item));
            }
            if (data["regionStoreGroupIds"] && data["regionStoreGroupIds"].constructor === Array) {
                this.regionStoreGroupIds = [];
                for (let item of data["regionStoreGroupIds"])
                    this.regionStoreGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRegionInput {
        let result = new UpdateRegionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.regionStoreGroupIds && this.regionStoreGroupIds.constructor === Array) {
            data["regionStoreGroupIds"] = [];
            for (let item of this.regionStoreGroupIds)
                data["regionStoreGroupIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateRegionInput {
    id: number;
    code: string;
    translations: RegionTranslationDto[];
    regionStoreGroupIds: number[];
}

export class ListResultDtoOfRegionListItem implements IListResultDtoOfRegionListItem {
    items: RegionListItem[];

    constructor(data?: IListResultDtoOfRegionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RegionListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRegionListItem {
        let result = new ListResultDtoOfRegionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRegionListItem {
    items: RegionListItem[];
}

export class CreateReportGroupInput implements ICreateReportGroupInput {
    code: string;
    translations: ReportGroupTranslationDto[];
    numberOfDays: number;

    constructor(data?: ICreateReportGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ReportGroupTranslationDto.fromJS(item));
            }
            this.numberOfDays = data["numberOfDays"];
        }
    }

    static fromJS(data: any): CreateReportGroupInput {
        let result = new CreateReportGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["numberOfDays"] = this.numberOfDays;
        return data; 
    }
}

export interface ICreateReportGroupInput {
    code: string;
    translations: ReportGroupTranslationDto[];
    numberOfDays: number;
}

export class ReportGroupTranslationDto implements IReportGroupTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IReportGroupTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ReportGroupTranslationDto {
        let result = new ReportGroupTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IReportGroupTranslationDto {
    name: string;
    languageId: number;
}

export class ReportGroupDto implements IReportGroupDto {
    id: number;
    tenantId: number;
    numberOfDays: number;
    code: string;
    translations: ReportGroupTranslationDto[];

    constructor(data?: IReportGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.numberOfDays = data["numberOfDays"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ReportGroupTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportGroupDto {
        let result = new ReportGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["numberOfDays"] = this.numberOfDays;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IReportGroupDto {
    id: number;
    tenantId: number;
    numberOfDays: number;
    code: string;
    translations: ReportGroupTranslationDto[];
}

export class UpdateReportGroupDto implements IUpdateReportGroupDto {
    id: number;
    code: string;
    translations: ReportGroupTranslationDto[];
    numberOfDays: number;

    constructor(data?: IUpdateReportGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ReportGroupTranslationDto.fromJS(item));
            }
            this.numberOfDays = data["numberOfDays"];
        }
    }

    static fromJS(data: any): UpdateReportGroupDto {
        let result = new UpdateReportGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["numberOfDays"] = this.numberOfDays;
        return data; 
    }
}

export interface IUpdateReportGroupDto {
    id: number;
    code: string;
    translations: ReportGroupTranslationDto[];
    numberOfDays: number;
}

export class ListResultDtoOfReportGroupListItem implements IListResultDtoOfReportGroupListItem {
    items: ReportGroupListItem[];

    constructor(data?: IListResultDtoOfReportGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReportGroupListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfReportGroupListItem {
        let result = new ListResultDtoOfReportGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfReportGroupListItem {
    items: ReportGroupListItem[];
}

export class ReportGroupListItem implements IReportGroupListItem {
    id: number;
    name: string;
    code: string;

    constructor(data?: IReportGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): ReportGroupListItem {
        let result = new ReportGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface IReportGroupListItem {
    id: number;
    name: string;
    code: string;
}

export class PagedReportGroupList implements IPagedReportGroupList {
    currentPage: number;
    itemsCount: number;
    reportGroups: ReportGroupListItem[];

    constructor(data?: IPagedReportGroupList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["reportGroups"] && data["reportGroups"].constructor === Array) {
                this.reportGroups = [];
                for (let item of data["reportGroups"])
                    this.reportGroups.push(ReportGroupListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedReportGroupList {
        let result = new PagedReportGroupList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.reportGroups && this.reportGroups.constructor === Array) {
            data["reportGroups"] = [];
            for (let item of this.reportGroups)
                data["reportGroups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedReportGroupList {
    currentPage: number;
    itemsCount: number;
    reportGroups: ReportGroupListItem[];
}

export class PrintProductBarcodeInput implements IPrintProductBarcodeInput {
    width: number;
    height: number;
    numberOfPrint: number;
    languageId: number;
    showCode: boolean;
    showName: boolean;
    showBarcode: boolean;
    showStore: boolean;
    showPrice: boolean;
    productName: string;
    storeName: string;
    productCode: string;
    productPrice: string;
    productId: number;
    printerName: string;

    constructor(data?: IPrintProductBarcodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.width = data["width"];
            this.height = data["height"];
            this.numberOfPrint = data["numberOfPrint"];
            this.languageId = data["languageId"];
            this.showCode = data["showCode"];
            this.showName = data["showName"];
            this.showBarcode = data["showBarcode"];
            this.showStore = data["showStore"];
            this.showPrice = data["showPrice"];
            this.productName = data["productName"];
            this.storeName = data["storeName"];
            this.productCode = data["productCode"];
            this.productPrice = data["productPrice"];
            this.productId = data["productId"];
            this.printerName = data["printerName"];
        }
    }

    static fromJS(data: any): PrintProductBarcodeInput {
        let result = new PrintProductBarcodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        data["numberOfPrint"] = this.numberOfPrint;
        data["languageId"] = this.languageId;
        data["showCode"] = this.showCode;
        data["showName"] = this.showName;
        data["showBarcode"] = this.showBarcode;
        data["showStore"] = this.showStore;
        data["showPrice"] = this.showPrice;
        data["productName"] = this.productName;
        data["storeName"] = this.storeName;
        data["productCode"] = this.productCode;
        data["productPrice"] = this.productPrice;
        data["productId"] = this.productId;
        data["printerName"] = this.printerName;
        return data; 
    }
}

export interface IPrintProductBarcodeInput {
    width: number;
    height: number;
    numberOfPrint: number;
    languageId: number;
    showCode: boolean;
    showName: boolean;
    showBarcode: boolean;
    showStore: boolean;
    showPrice: boolean;
    productName: string;
    storeName: string;
    productCode: string;
    productPrice: string;
    productId: number;
    printerName: string;
}

export class SystemSalesReportInputDto implements ISystemSalesReportInputDto {
    childTenantId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isEndOfDay: boolean;
    areaId: number;
    regionId: number;
    isCSVFile: boolean;

    constructor(data?: ISystemSalesReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.childTenantId = data["childTenantId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.isEndOfDay = data["isEndOfDay"];
            this.areaId = data["areaId"];
            this.regionId = data["regionId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): SystemSalesReportInputDto {
        let result = new SystemSalesReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childTenantId"] = this.childTenantId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["isEndOfDay"] = this.isEndOfDay;
        data["areaId"] = this.areaId;
        data["regionId"] = this.regionId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ISystemSalesReportInputDto {
    childTenantId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isEndOfDay: boolean;
    areaId: number;
    regionId: number;
    isCSVFile: boolean;
}

export class SystemSalesReportOutputDto implements ISystemSalesReportOutputDto {
    storeName: string;
    userName: string;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    subTotale: number;
    vat: number;
    grandTotale: number;
    personsPerShift: number;
    returnValue: number;
    returnCount: number;
    discountValue: number;
    discountCount: number;
    promotionDetails: EntityDetailDtoOfInt32[];
    saleTypeDetails: EntityDetailDtoOfInt32[];
    tenderTypeDetails: EntityDetailDtoOfInt32[];
    categoryDetails: EntityDetailDtoOfInt32[];

    constructor(data?: ISystemSalesReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            this.userName = data["userName"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.subTotale = data["subTotale"];
            this.vat = data["vat"];
            this.grandTotale = data["grandTotale"];
            this.personsPerShift = data["personsPerShift"];
            this.returnValue = data["returnValue"];
            this.returnCount = data["returnCount"];
            this.discountValue = data["discountValue"];
            this.discountCount = data["discountCount"];
            if (data["promotionDetails"] && data["promotionDetails"].constructor === Array) {
                this.promotionDetails = [];
                for (let item of data["promotionDetails"])
                    this.promotionDetails.push(EntityDetailDtoOfInt32.fromJS(item));
            }
            if (data["saleTypeDetails"] && data["saleTypeDetails"].constructor === Array) {
                this.saleTypeDetails = [];
                for (let item of data["saleTypeDetails"])
                    this.saleTypeDetails.push(EntityDetailDtoOfInt32.fromJS(item));
            }
            if (data["tenderTypeDetails"] && data["tenderTypeDetails"].constructor === Array) {
                this.tenderTypeDetails = [];
                for (let item of data["tenderTypeDetails"])
                    this.tenderTypeDetails.push(EntityDetailDtoOfInt32.fromJS(item));
            }
            if (data["categoryDetails"] && data["categoryDetails"].constructor === Array) {
                this.categoryDetails = [];
                for (let item of data["categoryDetails"])
                    this.categoryDetails.push(EntityDetailDtoOfInt32.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemSalesReportOutputDto {
        let result = new SystemSalesReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["userName"] = this.userName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["subTotale"] = this.subTotale;
        data["vat"] = this.vat;
        data["grandTotale"] = this.grandTotale;
        data["personsPerShift"] = this.personsPerShift;
        data["returnValue"] = this.returnValue;
        data["returnCount"] = this.returnCount;
        data["discountValue"] = this.discountValue;
        data["discountCount"] = this.discountCount;
        if (this.promotionDetails && this.promotionDetails.constructor === Array) {
            data["promotionDetails"] = [];
            for (let item of this.promotionDetails)
                data["promotionDetails"].push(item.toJSON());
        }
        if (this.saleTypeDetails && this.saleTypeDetails.constructor === Array) {
            data["saleTypeDetails"] = [];
            for (let item of this.saleTypeDetails)
                data["saleTypeDetails"].push(item.toJSON());
        }
        if (this.tenderTypeDetails && this.tenderTypeDetails.constructor === Array) {
            data["tenderTypeDetails"] = [];
            for (let item of this.tenderTypeDetails)
                data["tenderTypeDetails"].push(item.toJSON());
        }
        if (this.categoryDetails && this.categoryDetails.constructor === Array) {
            data["categoryDetails"] = [];
            for (let item of this.categoryDetails)
                data["categoryDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISystemSalesReportOutputDto {
    storeName: string;
    userName: string;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    subTotale: number;
    vat: number;
    grandTotale: number;
    personsPerShift: number;
    returnValue: number;
    returnCount: number;
    discountValue: number;
    discountCount: number;
    promotionDetails: EntityDetailDtoOfInt32[];
    saleTypeDetails: EntityDetailDtoOfInt32[];
    tenderTypeDetails: EntityDetailDtoOfInt32[];
    categoryDetails: EntityDetailDtoOfInt32[];
}

export class EntityDetailDtoOfInt32 implements IEntityDetailDtoOfInt32 {
    entityId: number;
    entityName: string;
    entityValue: number;
    entityCount: number;

    constructor(data?: IEntityDetailDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityId = data["entityId"];
            this.entityName = data["entityName"];
            this.entityValue = data["entityValue"];
            this.entityCount = data["entityCount"];
        }
    }

    static fromJS(data: any): EntityDetailDtoOfInt32 {
        let result = new EntityDetailDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["entityValue"] = this.entityValue;
        data["entityCount"] = this.entityCount;
        return data; 
    }
}

export interface IEntityDetailDtoOfInt32 {
    entityId: number;
    entityName: string;
    entityValue: number;
    entityCount: number;
}

export class MenuResultRequestDto implements IMenuResultRequestDto {
    categoryId: number;
    sorting: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IMenuResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): MenuResultRequestDto {
        let result = new MenuResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface IMenuResultRequestDto {
    categoryId: number;
    sorting: string;
    skipCount: number;
    maxResultCount: number;
}

export class MenuItemSalesVSCostInputDto implements IMenuItemSalesVSCostInputDto {
    childTenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    categoryIds: number[];
    isCSVFile: boolean;
    categoryPagging: MenuResultRequestDto[];
    sorting: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IMenuItemSalesVSCostInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.childTenantId = data["childTenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
            if (data["categoryPagging"] && data["categoryPagging"].constructor === Array) {
                this.categoryPagging = [];
                for (let item of data["categoryPagging"])
                    this.categoryPagging.push(MenuResultRequestDto.fromJS(item));
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): MenuItemSalesVSCostInputDto {
        let result = new MenuItemSalesVSCostInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childTenantId"] = this.childTenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        if (this.categoryPagging && this.categoryPagging.constructor === Array) {
            data["categoryPagging"] = [];
            for (let item of this.categoryPagging)
                data["categoryPagging"].push(item.toJSON());
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface IMenuItemSalesVSCostInputDto {
    childTenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    categoryIds: number[];
    isCSVFile: boolean;
    categoryPagging: MenuResultRequestDto[];
    sorting: string;
    skipCount: number;
    maxResultCount: number;
}

export class PagedMenuItemSalesVSCost implements IPagedMenuItemSalesVSCost {
    totalQty: number;
    totalCost: number;
    totalCount: number;
    items: MenuItemSalesVSCostOutputDto[];

    constructor(data?: IPagedMenuItemSalesVSCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalQty = data["totalQty"];
            this.totalCost = data["totalCost"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MenuItemSalesVSCostOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedMenuItemSalesVSCost {
        let result = new PagedMenuItemSalesVSCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalQty"] = this.totalQty;
        data["totalCost"] = this.totalCost;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedMenuItemSalesVSCost {
    totalQty: number;
    totalCost: number;
    totalCount: number;
    items: MenuItemSalesVSCostOutputDto[];
}

export class MenuItemSalesVSCostOutputDto implements IMenuItemSalesVSCostOutputDto {
    category: string;
    categoryId: number;
    totalQty: number;
    totalCost: number;
    menuItemDetails: MYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto;

    constructor(data?: IMenuItemSalesVSCostOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.categoryId = data["categoryId"];
            this.totalQty = data["totalQty"];
            this.totalCost = data["totalCost"];
            this.menuItemDetails = data["menuItemDetails"] ? MYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto.fromJS(data["menuItemDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MenuItemSalesVSCostOutputDto {
        let result = new MenuItemSalesVSCostOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryId"] = this.categoryId;
        data["totalQty"] = this.totalQty;
        data["totalCost"] = this.totalCost;
        data["menuItemDetails"] = this.menuItemDetails ? this.menuItemDetails.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMenuItemSalesVSCostOutputDto {
    category: string;
    categoryId: number;
    totalQty: number;
    totalCost: number;
    menuItemDetails: MYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto;
}

export class MYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto implements IMYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto {
    currentPage: number;
    totalCount: number;
    items: MenuItemSalesVSCostMenuItemDetailsDto[];

    constructor(data?: IMYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MenuItemSalesVSCostMenuItemDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto {
        let result = new MYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMYPagedResultDtoOfMenuItemSalesVSCostMenuItemDetailsDto {
    currentPage: number;
    totalCount: number;
    items: MenuItemSalesVSCostMenuItemDetailsDto[];
}

export class MenuItemSalesVSCostMenuItemDetailsDto implements IMenuItemSalesVSCostMenuItemDetailsDto {
    menuItem: string;
    saleType: string;
    store: string;
    unitPrice: number;
    unitCost: number;
    soldQuantity: number;
    totalSales: number;
    totalCost: number;
    profit: number;
    margin: number;

    constructor(data?: IMenuItemSalesVSCostMenuItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItem = data["menuItem"];
            this.saleType = data["saleType"];
            this.store = data["store"];
            this.unitPrice = data["unitPrice"];
            this.unitCost = data["unitCost"];
            this.soldQuantity = data["soldQuantity"];
            this.totalSales = data["totalSales"];
            this.totalCost = data["totalCost"];
            this.profit = data["profit"];
            this.margin = data["margin"];
        }
    }

    static fromJS(data: any): MenuItemSalesVSCostMenuItemDetailsDto {
        let result = new MenuItemSalesVSCostMenuItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItem"] = this.menuItem;
        data["saleType"] = this.saleType;
        data["store"] = this.store;
        data["unitPrice"] = this.unitPrice;
        data["unitCost"] = this.unitCost;
        data["soldQuantity"] = this.soldQuantity;
        data["totalSales"] = this.totalSales;
        data["totalCost"] = this.totalCost;
        data["profit"] = this.profit;
        data["margin"] = this.margin;
        return data; 
    }
}

export interface IMenuItemSalesVSCostMenuItemDetailsDto {
    menuItem: string;
    saleType: string;
    store: string;
    unitPrice: number;
    unitCost: number;
    soldQuantity: number;
    totalSales: number;
    totalCost: number;
    profit: number;
    margin: number;
}

export class PurchaseReportBySupplierFBInput implements IPurchaseReportBySupplierFBInput {
    transactionTypeId: number;
    supplierId: number;
    storeIds: number[];
    rowMatrailIds: number[];
    regionId: number;
    tenantId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
    showAllDetails: boolean;

    constructor(data?: IPurchaseReportBySupplierFBInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeId = data["transactionTypeId"];
            this.supplierId = data["supplierId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["rowMatrailIds"] && data["rowMatrailIds"].constructor === Array) {
                this.rowMatrailIds = [];
                for (let item of data["rowMatrailIds"])
                    this.rowMatrailIds.push(item);
            }
            this.regionId = data["regionId"];
            this.tenantId = data["tenantId"];
            this.areaId = data["areaId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
            this.showAllDetails = data["showAllDetails"];
        }
    }

    static fromJS(data: any): PurchaseReportBySupplierFBInput {
        let result = new PurchaseReportBySupplierFBInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["supplierId"] = this.supplierId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.rowMatrailIds && this.rowMatrailIds.constructor === Array) {
            data["rowMatrailIds"] = [];
            for (let item of this.rowMatrailIds)
                data["rowMatrailIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["tenantId"] = this.tenantId;
        data["areaId"] = this.areaId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        data["showAllDetails"] = this.showAllDetails;
        return data; 
    }
}

export interface IPurchaseReportBySupplierFBInput {
    transactionTypeId: number;
    supplierId: number;
    storeIds: number[];
    rowMatrailIds: number[];
    regionId: number;
    tenantId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
    showAllDetails: boolean;
}

export class PurchaseReportBySupplierDto implements IPurchaseReportBySupplierDto {
    supplierGroups: SupplierPurchaseGroupDto[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;

    constructor(data?: IPurchaseReportBySupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["supplierGroups"] && data["supplierGroups"].constructor === Array) {
                this.supplierGroups = [];
                for (let item of data["supplierGroups"])
                    this.supplierGroups.push(SupplierPurchaseGroupDto.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): PurchaseReportBySupplierDto {
        let result = new PurchaseReportBySupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.supplierGroups && this.supplierGroups.constructor === Array) {
            data["supplierGroups"] = [];
            for (let item of this.supplierGroups)
                data["supplierGroups"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IPurchaseReportBySupplierDto {
    supplierGroups: SupplierPurchaseGroupDto[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;
}

export class SupplierPurchaseGroupDto implements ISupplierPurchaseGroupDto {
    supplierId: number;
    supplierName: string;
    supplierTotal: number;
    purchases: PurshaseBySupplierReportDto[];

    constructor(data?: ISupplierPurchaseGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supplierId = data["supplierId"];
            this.supplierName = data["supplierName"];
            this.supplierTotal = data["supplierTotal"];
            if (data["purchases"] && data["purchases"].constructor === Array) {
                this.purchases = [];
                for (let item of data["purchases"])
                    this.purchases.push(PurshaseBySupplierReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplierPurchaseGroupDto {
        let result = new SupplierPurchaseGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["supplierTotal"] = this.supplierTotal;
        if (this.purchases && this.purchases.constructor === Array) {
            data["purchases"] = [];
            for (let item of this.purchases)
                data["purchases"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISupplierPurchaseGroupDto {
    supplierId: number;
    supplierName: string;
    supplierTotal: number;
    purchases: PurshaseBySupplierReportDto[];
}

export class PurshaseBySupplierReportDto implements IPurshaseBySupplierReportDto {
    id: number;
    supplierId: number;
    storeId: number;
    supplierName: string;
    documentNumber: string;
    receiveNumber: string;
    date: moment.Moment;
    total: number;
    notes: string;
    storeCode: string;
    storeName: string;
    tenantName: string;
    currencyName: string;
    showDetail: boolean;
    detailTransactions: DetailTransactionReciveReportDto[];

    constructor(data?: IPurshaseBySupplierReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.supplierId = data["supplierId"];
            this.storeId = data["storeId"];
            this.supplierName = data["supplierName"];
            this.documentNumber = data["documentNumber"];
            this.receiveNumber = data["receiveNumber"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.total = data["total"];
            this.notes = data["notes"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.tenantName = data["tenantName"];
            this.currencyName = data["currencyName"];
            this.showDetail = data["showDetail"];
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransactionReciveReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurshaseBySupplierReportDto {
        let result = new PurshaseBySupplierReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["storeId"] = this.storeId;
        data["supplierName"] = this.supplierName;
        data["documentNumber"] = this.documentNumber;
        data["receiveNumber"] = this.receiveNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["notes"] = this.notes;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["tenantName"] = this.tenantName;
        data["currencyName"] = this.currencyName;
        data["showDetail"] = this.showDetail;
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPurshaseBySupplierReportDto {
    id: number;
    supplierId: number;
    storeId: number;
    supplierName: string;
    documentNumber: string;
    receiveNumber: string;
    date: moment.Moment;
    total: number;
    notes: string;
    storeCode: string;
    storeName: string;
    tenantName: string;
    currencyName: string;
    showDetail: boolean;
    detailTransactions: DetailTransactionReciveReportDto[];
}

export class DetailTransactionReciveReportDto implements IDetailTransactionReciveReportDto {
    barCode: string;
    materialName: string;
    unitOfMeasureName: string;
    qty: number;
    qtyReceive: number;
    price: number;
    netAfterVat: number;
    priceWithoutTax: number;
    tax: number;
    dueDate: moment.Moment;
    notes: string;

    constructor(data?: IDetailTransactionReciveReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.materialName = data["materialName"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.qty = data["qty"];
            this.qtyReceive = data["qtyReceive"];
            this.price = data["price"];
            this.netAfterVat = data["netAfterVat"];
            this.priceWithoutTax = data["priceWithoutTax"];
            this.tax = data["tax"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): DetailTransactionReciveReportDto {
        let result = new DetailTransactionReciveReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["materialName"] = this.materialName;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["qty"] = this.qty;
        data["qtyReceive"] = this.qtyReceive;
        data["price"] = this.price;
        data["netAfterVat"] = this.netAfterVat;
        data["priceWithoutTax"] = this.priceWithoutTax;
        data["tax"] = this.tax;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface IDetailTransactionReciveReportDto {
    barCode: string;
    materialName: string;
    unitOfMeasureName: string;
    qty: number;
    qtyReceive: number;
    price: number;
    netAfterVat: number;
    priceWithoutTax: number;
    tax: number;
    dueDate: moment.Moment;
    notes: string;
}

export class GlobalFilters implements IGlobalFilters {
    tenant_id: number;
    region_id: number;
    area_id: number;
    store_type: number;
    store_id: number;
    start_date: moment.Moment;
    end_date: moment.Moment;

    constructor(data?: IGlobalFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenant_id = data["tenant_id"];
            this.region_id = data["region_id"];
            this.area_id = data["area_id"];
            this.store_type = data["store_type"];
            this.store_id = data["store_id"];
            this.start_date = data["start_date"] ? moment(data["start_date"].toString()) : <any>undefined;
            this.end_date = data["end_date"] ? moment(data["end_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GlobalFilters {
        let result = new GlobalFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant_id"] = this.tenant_id;
        data["region_id"] = this.region_id;
        data["area_id"] = this.area_id;
        data["store_type"] = this.store_type;
        data["store_id"] = this.store_id;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        data["end_date"] = this.end_date ? this.end_date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGlobalFilters {
    tenant_id: number;
    region_id: number;
    area_id: number;
    store_type: number;
    store_id: number;
    start_date: moment.Moment;
    end_date: moment.Moment;
}

export class Dashboardcards implements IDashboardcards {
    new_customers: number;
    average_order_value: number;
    profitability_pct: number;
    discounts_amount: number;
    promotions_amount: number;
    returns_voids_amount: number;
    peak_hours: string;
    payments_amount: number;

    constructor(data?: IDashboardcards) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.new_customers = data["new_customers"];
            this.average_order_value = data["average_order_value"];
            this.profitability_pct = data["profitability_pct"];
            this.discounts_amount = data["discounts_amount"];
            this.promotions_amount = data["promotions_amount"];
            this.returns_voids_amount = data["returns_voids_amount"];
            this.peak_hours = data["peak_hours"];
            this.payments_amount = data["payments_amount"];
        }
    }

    static fromJS(data: any): Dashboardcards {
        let result = new Dashboardcards();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["new_customers"] = this.new_customers;
        data["average_order_value"] = this.average_order_value;
        data["profitability_pct"] = this.profitability_pct;
        data["discounts_amount"] = this.discounts_amount;
        data["promotions_amount"] = this.promotions_amount;
        data["returns_voids_amount"] = this.returns_voids_amount;
        data["peak_hours"] = this.peak_hours;
        data["payments_amount"] = this.payments_amount;
        return data; 
    }
}

export interface IDashboardcards {
    new_customers: number;
    average_order_value: number;
    profitability_pct: number;
    discounts_amount: number;
    promotions_amount: number;
    returns_voids_amount: number;
    peak_hours: string;
    payments_amount: number;
}

export class SalesPerformanceAndSalesDistribution implements ISalesPerformanceAndSalesDistribution {
    time_series: TimeSerie[];
    by_store_type: StoreTypeSerie[];

    constructor(data?: ISalesPerformanceAndSalesDistribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["time_series"] && data["time_series"].constructor === Array) {
                this.time_series = [];
                for (let item of data["time_series"])
                    this.time_series.push(TimeSerie.fromJS(item));
            }
            if (data["by_store_type"] && data["by_store_type"].constructor === Array) {
                this.by_store_type = [];
                for (let item of data["by_store_type"])
                    this.by_store_type.push(StoreTypeSerie.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesPerformanceAndSalesDistribution {
        let result = new SalesPerformanceAndSalesDistribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.time_series && this.time_series.constructor === Array) {
            data["time_series"] = [];
            for (let item of this.time_series)
                data["time_series"].push(item.toJSON());
        }
        if (this.by_store_type && this.by_store_type.constructor === Array) {
            data["by_store_type"] = [];
            for (let item of this.by_store_type)
                data["by_store_type"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesPerformanceAndSalesDistribution {
    time_series: TimeSerie[];
    by_store_type: StoreTypeSerie[];
}

export class TimeSerie implements ITimeSerie {
    date: string;
    sales_amount: number;
    transactions_count: number;

    constructor(data?: ITimeSerie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.sales_amount = data["sales_amount"];
            this.transactions_count = data["transactions_count"];
        }
    }

    static fromJS(data: any): TimeSerie {
        let result = new TimeSerie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["sales_amount"] = this.sales_amount;
        data["transactions_count"] = this.transactions_count;
        return data; 
    }
}

export interface ITimeSerie {
    date: string;
    sales_amount: number;
    transactions_count: number;
}

export class StoreTypeSerie implements IStoreTypeSerie {
    store_type: string;
    sales_amount: number;

    constructor(data?: IStoreTypeSerie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.store_type = data["store_type"];
            this.sales_amount = data["sales_amount"];
        }
    }

    static fromJS(data: any): StoreTypeSerie {
        let result = new StoreTypeSerie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["store_type"] = this.store_type;
        data["sales_amount"] = this.sales_amount;
        return data; 
    }
}

export interface IStoreTypeSerie {
    store_type: string;
    sales_amount: number;
}

export class HeatmapDetails implements IHeatmapDetails {
    store_id: number;
    store_Longitude: number;
    store_Latitude: number;
    store_name: string;
    average_order_value: number;
    total_transactions: number;
    payments: Paymentpercentage[];
    sales_performance: TimeSerie[];

    constructor(data?: IHeatmapDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.store_id = data["store_id"];
            this.store_Longitude = data["store_Longitude"];
            this.store_Latitude = data["store_Latitude"];
            this.store_name = data["store_name"];
            this.average_order_value = data["average_order_value"];
            this.total_transactions = data["total_transactions"];
            if (data["payments"] && data["payments"].constructor === Array) {
                this.payments = [];
                for (let item of data["payments"])
                    this.payments.push(Paymentpercentage.fromJS(item));
            }
            if (data["sales_performance"] && data["sales_performance"].constructor === Array) {
                this.sales_performance = [];
                for (let item of data["sales_performance"])
                    this.sales_performance.push(TimeSerie.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HeatmapDetails {
        let result = new HeatmapDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["store_id"] = this.store_id;
        data["store_Longitude"] = this.store_Longitude;
        data["store_Latitude"] = this.store_Latitude;
        data["store_name"] = this.store_name;
        data["average_order_value"] = this.average_order_value;
        data["total_transactions"] = this.total_transactions;
        if (this.payments && this.payments.constructor === Array) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (this.sales_performance && this.sales_performance.constructor === Array) {
            data["sales_performance"] = [];
            for (let item of this.sales_performance)
                data["sales_performance"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IHeatmapDetails {
    store_id: number;
    store_Longitude: number;
    store_Latitude: number;
    store_name: string;
    average_order_value: number;
    total_transactions: number;
    payments: Paymentpercentage[];
    sales_performance: TimeSerie[];
}

export class Paymentpercentage implements IPaymentpercentage {
    method: string;
    amount: number;
    percentage: number;

    constructor(data?: IPaymentpercentage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.method = data["method"];
            this.amount = data["amount"];
            this.percentage = data["percentage"];
        }
    }

    static fromJS(data: any): Paymentpercentage {
        let result = new Paymentpercentage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        data["amount"] = this.amount;
        data["percentage"] = this.percentage;
        return data; 
    }
}

export interface IPaymentpercentage {
    method: string;
    amount: number;
    percentage: number;
}

export class SalesSummaryInput implements ISalesSummaryInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantIds: number[];
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    showRefund: boolean;
    showDiscountOrPromotionOnly: boolean;
    isCSVFile: boolean;

    constructor(data?: ISalesSummaryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTransactionId = data["saleTransactionId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.orderNumber = data["orderNumber"];
            this.customerNumber = data["customerNumber"];
            this.productInfo = data["productInfo"];
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            this.exportToExcel = data["exportToExcel"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.documentType = data["documentType"];
            this.cashierShiftId = data["cashierShiftId"];
            this.printInvoice = data["printInvoice"];
            this.byShiftDate = data["byShiftDate"];
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.endOfDayBusiness = data["endOfDayBusiness"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.showRefund = data["showRefund"];
            this.showDiscountOrPromotionOnly = data["showDiscountOrPromotionOnly"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): SalesSummaryInput {
        let result = new SalesSummaryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTransactionId"] = this.saleTransactionId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["orderNumber"] = this.orderNumber;
        data["customerNumber"] = this.customerNumber;
        data["productInfo"] = this.productInfo;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["exportToExcel"] = this.exportToExcel;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["cashierShiftId"] = this.cashierShiftId;
        data["printInvoice"] = this.printInvoice;
        data["byShiftDate"] = this.byShiftDate;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["endOfDayBusiness"] = this.endOfDayBusiness;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["showRefund"] = this.showRefund;
        data["showDiscountOrPromotionOnly"] = this.showDiscountOrPromotionOnly;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ISalesSummaryInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantIds: number[];
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    showRefund: boolean;
    showDiscountOrPromotionOnly: boolean;
    isCSVFile: boolean;
}

export class SalesReportWithDetailsDto_Pathfinder implements ISalesReportWithDetailsDto_Pathfinder {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsDto_Pathfinder[];

    constructor(data?: ISalesReportWithDetailsDto_Pathfinder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationGrandTotalIncludingVAT = data["summationGrandTotalIncludingVAT"];
            this.summationVAT = data["summationVAT"];
            this.summationDiscount = data["summationDiscount"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.templateType = data["templateType"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SalesReportWithDetailsDetailsDto_Pathfinder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsDto_Pathfinder {
        let result = new SalesReportWithDetailsDto_Pathfinder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationGrandTotalIncludingVAT"] = this.summationGrandTotalIncludingVAT;
        data["summationVAT"] = this.summationVAT;
        data["summationDiscount"] = this.summationDiscount;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["templateType"] = this.templateType;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsDto_Pathfinder {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsDto_Pathfinder[];
}

export class SalesReportWithDetailsDetailsDto_Pathfinder implements ISalesReportWithDetailsDetailsDto_Pathfinder {
    locatioN_CODE: string;
    terminaL_ID: string;
    shifT_NO: string;
    id: string;
    tenantName: string;
    date: string;
    businesS_DT: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    bC_EXCH: string;
    tenderTypeName: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOut_Pathfinder[];
    invoicePayments: InvoicePaymentOut_Pathfinder[];

    constructor(data?: ISalesReportWithDetailsDetailsDto_Pathfinder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locatioN_CODE = data["locatioN_CODE"];
            this.terminaL_ID = data["terminaL_ID"];
            this.shifT_NO = data["shifT_NO"];
            this.id = data["id"];
            this.tenantName = data["tenantName"];
            this.date = data["date"];
            this.businesS_DT = data["businesS_DT"];
            this.time = data["time"];
            this.saleTypeName = data["saleTypeName"];
            this.orderNumber = data["orderNumber"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.cashierName = data["cashierName"];
            this.total = data["total"];
            this.discountValue = data["discountValue"];
            this.promotionValue = data["promotionValue"];
            this.grandTotal = data["grandTotal"];
            this.vat = data["vat"];
            this.currency = data["currency"];
            this.bC_EXCH = data["bC_EXCH"];
            this.tenderTypeName = data["tenderTypeName"];
            this.isRefund = data["isRefund"];
            if (data["invoiceLines"] && data["invoiceLines"].constructor === Array) {
                this.invoiceLines = [];
                for (let item of data["invoiceLines"])
                    this.invoiceLines.push(InvoiceLineOut_Pathfinder.fromJS(item));
            }
            if (data["invoicePayments"] && data["invoicePayments"].constructor === Array) {
                this.invoicePayments = [];
                for (let item of data["invoicePayments"])
                    this.invoicePayments.push(InvoicePaymentOut_Pathfinder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsDetailsDto_Pathfinder {
        let result = new SalesReportWithDetailsDetailsDto_Pathfinder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locatioN_CODE"] = this.locatioN_CODE;
        data["terminaL_ID"] = this.terminaL_ID;
        data["shifT_NO"] = this.shifT_NO;
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["date"] = this.date;
        data["businesS_DT"] = this.businesS_DT;
        data["time"] = this.time;
        data["saleTypeName"] = this.saleTypeName;
        data["orderNumber"] = this.orderNumber;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["cashierName"] = this.cashierName;
        data["total"] = this.total;
        data["discountValue"] = this.discountValue;
        data["promotionValue"] = this.promotionValue;
        data["grandTotal"] = this.grandTotal;
        data["vat"] = this.vat;
        data["currency"] = this.currency;
        data["bC_EXCH"] = this.bC_EXCH;
        data["tenderTypeName"] = this.tenderTypeName;
        data["isRefund"] = this.isRefund;
        if (this.invoiceLines && this.invoiceLines.constructor === Array) {
            data["invoiceLines"] = [];
            for (let item of this.invoiceLines)
                data["invoiceLines"].push(item.toJSON());
        }
        if (this.invoicePayments && this.invoicePayments.constructor === Array) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsDetailsDto_Pathfinder {
    locatioN_CODE: string;
    terminaL_ID: string;
    shifT_NO: string;
    id: string;
    tenantName: string;
    date: string;
    businesS_DT: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    bC_EXCH: string;
    tenderTypeName: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOut_Pathfinder[];
    invoicePayments: InvoicePaymentOut_Pathfinder[];
}

export class InvoiceLineOut_Pathfinder implements IInvoiceLineOut_Pathfinder {
    invoiceId: string;
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    menuItemId: number;
    menuItemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;
    oP_CUR: string;
    bC_EXCH: string;

    constructor(data?: IInvoiceLineOut_Pathfinder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceId = data["invoiceId"];
            this.isRefund = data["isRefund"];
            this.lineId = data["lineId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionValue = data["promotionValue"];
            this.discount = data["discount"];
            this.notes = data["notes"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.menuItemId = data["menuItemId"];
            this.menuItemName = data["menuItemName"];
            this.itemCode = data["itemCode"];
            this.productCategoryId = data["productCategoryId"];
            this.productCategoryName = data["productCategoryName"];
            this.taxType = data["taxType"];
            this.oP_CUR = data["oP_CUR"];
            this.bC_EXCH = data["bC_EXCH"];
        }
    }

    static fromJS(data: any): InvoiceLineOut_Pathfinder {
        let result = new InvoiceLineOut_Pathfinder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["isRefund"] = this.isRefund;
        data["lineId"] = this.lineId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionValue"] = this.promotionValue;
        data["discount"] = this.discount;
        data["notes"] = this.notes;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["menuItemId"] = this.menuItemId;
        data["menuItemName"] = this.menuItemName;
        data["itemCode"] = this.itemCode;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        data["taxType"] = this.taxType;
        data["oP_CUR"] = this.oP_CUR;
        data["bC_EXCH"] = this.bC_EXCH;
        return data; 
    }
}

export interface IInvoiceLineOut_Pathfinder {
    invoiceId: string;
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    menuItemId: number;
    menuItemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;
    oP_CUR: string;
    bC_EXCH: string;
}

export class InvoicePaymentOut_Pathfinder implements IInvoicePaymentOut_Pathfinder {
    invoiceId: string;
    isRefund: boolean;
    paymentId: string;
    tenderTypeName: string;
    value: number;
    currencY_CODE: string;
    exchangE_RATE: string;
    oP_CUR: string;
    bC_EXCH: string;

    constructor(data?: IInvoicePaymentOut_Pathfinder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceId = data["invoiceId"];
            this.isRefund = data["isRefund"];
            this.paymentId = data["paymentId"];
            this.tenderTypeName = data["tenderTypeName"];
            this.value = data["value"];
            this.currencY_CODE = data["currencY_CODE"];
            this.exchangE_RATE = data["exchangE_RATE"];
            this.oP_CUR = data["oP_CUR"];
            this.bC_EXCH = data["bC_EXCH"];
        }
    }

    static fromJS(data: any): InvoicePaymentOut_Pathfinder {
        let result = new InvoicePaymentOut_Pathfinder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["isRefund"] = this.isRefund;
        data["paymentId"] = this.paymentId;
        data["tenderTypeName"] = this.tenderTypeName;
        data["value"] = this.value;
        data["currencY_CODE"] = this.currencY_CODE;
        data["exchangE_RATE"] = this.exchangE_RATE;
        data["oP_CUR"] = this.oP_CUR;
        data["bC_EXCH"] = this.bC_EXCH;
        return data; 
    }
}

export interface IInvoicePaymentOut_Pathfinder {
    invoiceId: string;
    isRefund: boolean;
    paymentId: string;
    tenderTypeName: string;
    value: number;
    currencY_CODE: string;
    exchangE_RATE: string;
    oP_CUR: string;
    bC_EXCH: string;
}

export class SalesReportWithDetailsRetailDto_Pathfinder implements ISalesReportWithDetailsRetailDto_Pathfinder {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsRetailDto_Pathfinder[];

    constructor(data?: ISalesReportWithDetailsRetailDto_Pathfinder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationGrandTotalIncludingVAT = data["summationGrandTotalIncludingVAT"];
            this.summationVAT = data["summationVAT"];
            this.summationDiscount = data["summationDiscount"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.templateType = data["templateType"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SalesReportWithDetailsDetailsRetailDto_Pathfinder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsRetailDto_Pathfinder {
        let result = new SalesReportWithDetailsRetailDto_Pathfinder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationGrandTotalIncludingVAT"] = this.summationGrandTotalIncludingVAT;
        data["summationVAT"] = this.summationVAT;
        data["summationDiscount"] = this.summationDiscount;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["templateType"] = this.templateType;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsRetailDto_Pathfinder {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsRetailDto_Pathfinder[];
}

export class SalesReportWithDetailsDetailsRetailDto_Pathfinder implements ISalesReportWithDetailsDetailsRetailDto_Pathfinder {
    locatioN_CODE: string;
    terminaL_ID: string;
    shifT_NO: string;
    id: string;
    tenantName: string;
    date: string;
    businesS_DT: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    bC_EXCH: string;
    tenderTypeName: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOutRetail_Pathfinder[];
    invoicePayments: InvoicePaymentOut_Pathfinder[];

    constructor(data?: ISalesReportWithDetailsDetailsRetailDto_Pathfinder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locatioN_CODE = data["locatioN_CODE"];
            this.terminaL_ID = data["terminaL_ID"];
            this.shifT_NO = data["shifT_NO"];
            this.id = data["id"];
            this.tenantName = data["tenantName"];
            this.date = data["date"];
            this.businesS_DT = data["businesS_DT"];
            this.time = data["time"];
            this.saleTypeName = data["saleTypeName"];
            this.orderNumber = data["orderNumber"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.cashierName = data["cashierName"];
            this.total = data["total"];
            this.discountValue = data["discountValue"];
            this.promotionValue = data["promotionValue"];
            this.grandTotal = data["grandTotal"];
            this.vat = data["vat"];
            this.currency = data["currency"];
            this.bC_EXCH = data["bC_EXCH"];
            this.tenderTypeName = data["tenderTypeName"];
            this.isRefund = data["isRefund"];
            if (data["invoiceLines"] && data["invoiceLines"].constructor === Array) {
                this.invoiceLines = [];
                for (let item of data["invoiceLines"])
                    this.invoiceLines.push(InvoiceLineOutRetail_Pathfinder.fromJS(item));
            }
            if (data["invoicePayments"] && data["invoicePayments"].constructor === Array) {
                this.invoicePayments = [];
                for (let item of data["invoicePayments"])
                    this.invoicePayments.push(InvoicePaymentOut_Pathfinder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsDetailsRetailDto_Pathfinder {
        let result = new SalesReportWithDetailsDetailsRetailDto_Pathfinder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locatioN_CODE"] = this.locatioN_CODE;
        data["terminaL_ID"] = this.terminaL_ID;
        data["shifT_NO"] = this.shifT_NO;
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["date"] = this.date;
        data["businesS_DT"] = this.businesS_DT;
        data["time"] = this.time;
        data["saleTypeName"] = this.saleTypeName;
        data["orderNumber"] = this.orderNumber;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["cashierName"] = this.cashierName;
        data["total"] = this.total;
        data["discountValue"] = this.discountValue;
        data["promotionValue"] = this.promotionValue;
        data["grandTotal"] = this.grandTotal;
        data["vat"] = this.vat;
        data["currency"] = this.currency;
        data["bC_EXCH"] = this.bC_EXCH;
        data["tenderTypeName"] = this.tenderTypeName;
        data["isRefund"] = this.isRefund;
        if (this.invoiceLines && this.invoiceLines.constructor === Array) {
            data["invoiceLines"] = [];
            for (let item of this.invoiceLines)
                data["invoiceLines"].push(item.toJSON());
        }
        if (this.invoicePayments && this.invoicePayments.constructor === Array) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsDetailsRetailDto_Pathfinder {
    locatioN_CODE: string;
    terminaL_ID: string;
    shifT_NO: string;
    id: string;
    tenantName: string;
    date: string;
    businesS_DT: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    bC_EXCH: string;
    tenderTypeName: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOutRetail_Pathfinder[];
    invoicePayments: InvoicePaymentOut_Pathfinder[];
}

export class InvoiceLineOutRetail_Pathfinder implements IInvoiceLineOutRetail_Pathfinder {
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    itemId: number;
    itemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;
    oP_CUR: string;
    bC_EXCH: string;

    constructor(data?: IInvoiceLineOutRetail_Pathfinder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isRefund = data["isRefund"];
            this.lineId = data["lineId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionValue = data["promotionValue"];
            this.discount = data["discount"];
            this.notes = data["notes"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.itemId = data["itemId"];
            this.itemName = data["itemName"];
            this.itemCode = data["itemCode"];
            this.productCategoryId = data["productCategoryId"];
            this.productCategoryName = data["productCategoryName"];
            this.taxType = data["taxType"];
            this.oP_CUR = data["oP_CUR"];
            this.bC_EXCH = data["bC_EXCH"];
        }
    }

    static fromJS(data: any): InvoiceLineOutRetail_Pathfinder {
        let result = new InvoiceLineOutRetail_Pathfinder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRefund"] = this.isRefund;
        data["lineId"] = this.lineId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionValue"] = this.promotionValue;
        data["discount"] = this.discount;
        data["notes"] = this.notes;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["itemCode"] = this.itemCode;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        data["taxType"] = this.taxType;
        data["oP_CUR"] = this.oP_CUR;
        data["bC_EXCH"] = this.bC_EXCH;
        return data; 
    }
}

export interface IInvoiceLineOutRetail_Pathfinder {
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    itemId: number;
    itemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;
    oP_CUR: string;
    bC_EXCH: string;
}

export class TotalSalesByTimeInput implements ITotalSalesByTimeInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: ITotalSalesByTimeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalSalesByTimeInput {
        let result = new TotalSalesByTimeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalSalesByTimeInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class PaymentMethodsInput implements IPaymentMethodsInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    tenderTypes: number[];
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: IPaymentMethodsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["tenderTypes"] && data["tenderTypes"].constructor === Array) {
                this.tenderTypes = [];
                for (let item of data["tenderTypes"])
                    this.tenderTypes.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PaymentMethodsInput {
        let result = new PaymentMethodsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.tenderTypes && this.tenderTypes.constructor === Array) {
            data["tenderTypes"] = [];
            for (let item of this.tenderTypes)
                data["tenderTypes"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPaymentMethodsInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    tenderTypes: number[];
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class PaymentMethodsReport implements IPaymentMethodsReport {
    summationGrandTotal: number;
    summationCount: number;
    currency: string;
    data: PaymentMethodsDetails[];
    currentPage: number;
    pageCount: number;

    constructor(data?: IPaymentMethodsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationCount = data["summationCount"];
            this.currency = data["currency"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(PaymentMethodsDetails.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.pageCount = data["pageCount"];
        }
    }

    static fromJS(data: any): PaymentMethodsReport {
        let result = new PaymentMethodsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationCount"] = this.summationCount;
        data["currency"] = this.currency;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export interface IPaymentMethodsReport {
    summationGrandTotal: number;
    summationCount: number;
    currency: string;
    data: PaymentMethodsDetails[];
    currentPage: number;
    pageCount: number;
}

export class PaymentMethodsDetails implements IPaymentMethodsDetails {
    vat: number;
    totalIncludeVAT: number;
    cost: number;
    date: string;
    time: string;
    cashierCode: string;
    cashierName: string;
    storeCode: string;
    storeName: string;
    tenderTypeCode: string;
    paymentMethodName: string;
    count: number;
    value: number;
    currency: string;
    tenantName: string;

    constructor(data?: IPaymentMethodsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vat = data["vat"];
            this.totalIncludeVAT = data["totalIncludeVAT"];
            this.cost = data["cost"];
            this.date = data["date"];
            this.time = data["time"];
            this.cashierCode = data["cashierCode"];
            this.cashierName = data["cashierName"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.tenderTypeCode = data["tenderTypeCode"];
            this.paymentMethodName = data["paymentMethodName"];
            this.count = data["count"];
            this.value = data["value"];
            this.currency = data["currency"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): PaymentMethodsDetails {
        let result = new PaymentMethodsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vat"] = this.vat;
        data["totalIncludeVAT"] = this.totalIncludeVAT;
        data["cost"] = this.cost;
        data["date"] = this.date;
        data["time"] = this.time;
        data["cashierCode"] = this.cashierCode;
        data["cashierName"] = this.cashierName;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["tenderTypeCode"] = this.tenderTypeCode;
        data["paymentMethodName"] = this.paymentMethodName;
        data["count"] = this.count;
        data["value"] = this.value;
        data["currency"] = this.currency;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface IPaymentMethodsDetails {
    vat: number;
    totalIncludeVAT: number;
    cost: number;
    date: string;
    time: string;
    cashierCode: string;
    cashierName: string;
    storeCode: string;
    storeName: string;
    tenderTypeCode: string;
    paymentMethodName: string;
    count: number;
    value: number;
    currency: string;
    tenantName: string;
}

export class IncomeAuditByDayReportInput implements IIncomeAuditByDayReportInput {
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: IIncomeAuditByDayReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): IncomeAuditByDayReportInput {
        let result = new IncomeAuditByDayReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IIncomeAuditByDayReportInput {
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class IncomeAuditByDayReport implements IIncomeAuditByDayReport {
    summationGrandTotal: PaymentMethodDetails[];
    currency: string;
    currentPage: number;
    pageCount: number;
    allPaymentMethods: string[];
    items: IncomeAuditByDayDetails[];

    constructor(data?: IIncomeAuditByDayReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["summationGrandTotal"] && data["summationGrandTotal"].constructor === Array) {
                this.summationGrandTotal = [];
                for (let item of data["summationGrandTotal"])
                    this.summationGrandTotal.push(PaymentMethodDetails.fromJS(item));
            }
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.pageCount = data["pageCount"];
            if (data["allPaymentMethods"] && data["allPaymentMethods"].constructor === Array) {
                this.allPaymentMethods = [];
                for (let item of data["allPaymentMethods"])
                    this.allPaymentMethods.push(item);
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IncomeAuditByDayDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomeAuditByDayReport {
        let result = new IncomeAuditByDayReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.summationGrandTotal && this.summationGrandTotal.constructor === Array) {
            data["summationGrandTotal"] = [];
            for (let item of this.summationGrandTotal)
                data["summationGrandTotal"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        if (this.allPaymentMethods && this.allPaymentMethods.constructor === Array) {
            data["allPaymentMethods"] = [];
            for (let item of this.allPaymentMethods)
                data["allPaymentMethods"].push(item);
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIncomeAuditByDayReport {
    summationGrandTotal: PaymentMethodDetails[];
    currency: string;
    currentPage: number;
    pageCount: number;
    allPaymentMethods: string[];
    items: IncomeAuditByDayDetails[];
}

export class PaymentMethodDetails implements IPaymentMethodDetails {
    paymentMethodName: string;
    value: number;

    constructor(data?: IPaymentMethodDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentMethodName = data["paymentMethodName"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): PaymentMethodDetails {
        let result = new PaymentMethodDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodName"] = this.paymentMethodName;
        data["value"] = this.value;
        return data; 
    }
}

export interface IPaymentMethodDetails {
    paymentMethodName: string;
    value: number;
}

export class IncomeAuditByDayDetails implements IIncomeAuditByDayDetails {
    storeCode: string;
    storeName: string;
    paymentMethodsTotal: PaymentMethodDetails[];
    details: IncomeAuditByDayItemDetails[];

    constructor(data?: IIncomeAuditByDayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            if (data["paymentMethodsTotal"] && data["paymentMethodsTotal"].constructor === Array) {
                this.paymentMethodsTotal = [];
                for (let item of data["paymentMethodsTotal"])
                    this.paymentMethodsTotal.push(PaymentMethodDetails.fromJS(item));
            }
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(IncomeAuditByDayItemDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomeAuditByDayDetails {
        let result = new IncomeAuditByDayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        if (this.paymentMethodsTotal && this.paymentMethodsTotal.constructor === Array) {
            data["paymentMethodsTotal"] = [];
            for (let item of this.paymentMethodsTotal)
                data["paymentMethodsTotal"].push(item.toJSON());
        }
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIncomeAuditByDayDetails {
    storeCode: string;
    storeName: string;
    paymentMethodsTotal: PaymentMethodDetails[];
    details: IncomeAuditByDayItemDetails[];
}

export class IncomeAuditByDayItemDetails implements IIncomeAuditByDayItemDetails {
    date: string;
    paymentMethods: PaymentMethodDetails[];

    constructor(data?: IIncomeAuditByDayItemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(PaymentMethodDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomeAuditByDayItemDetails {
        let result = new IncomeAuditByDayItemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIncomeAuditByDayItemDetails {
    date: string;
    paymentMethods: PaymentMethodDetails[];
}

export class ProductByTimeReportInputRetail implements IProductByTimeReportInputRetail {
    storeIds: number[];
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    timeFrom: string;
    timeTo: string;
    productIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IProductByTimeReportInputRetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = data["dateTo"] ? moment(data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            if (data["productIds"] && data["productIds"].constructor === Array) {
                this.productIds = [];
                for (let item of data["productIds"])
                    this.productIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ProductByTimeReportInputRetail {
        let result = new ProductByTimeReportInputRetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        if (this.productIds && this.productIds.constructor === Array) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IProductByTimeReportInputRetail {
    storeIds: number[];
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    timeFrom: string;
    timeTo: string;
    productIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class ProductsByTimeReport implements IProductsByTimeReport {
    pageCount: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    summationTotalCost: number;
    totalDiscount: number;
    currentPage: number;
    checkDiscount: boolean;
    discountValue: number;
    items: ProductSalesDetailsByTime[];

    constructor(data?: IProductsByTimeReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationTotalSell = data["summationTotalSell"];
            this.currency = data["currency"];
            this.summationTotalVAT = data["summationTotalVAT"];
            this.summationTotalSellIncludeVAT = data["summationTotalSellIncludeVAT"];
            this.summationTotalCount = data["summationTotalCount"];
            this.summationTotalCost = data["summationTotalCost"];
            this.totalDiscount = data["totalDiscount"];
            this.currentPage = data["currentPage"];
            this.checkDiscount = data["checkDiscount"];
            this.discountValue = data["discountValue"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProductSalesDetailsByTime.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductsByTimeReport {
        let result = new ProductsByTimeReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationTotalSell"] = this.summationTotalSell;
        data["currency"] = this.currency;
        data["summationTotalVAT"] = this.summationTotalVAT;
        data["summationTotalSellIncludeVAT"] = this.summationTotalSellIncludeVAT;
        data["summationTotalCount"] = this.summationTotalCount;
        data["summationTotalCost"] = this.summationTotalCost;
        data["totalDiscount"] = this.totalDiscount;
        data["currentPage"] = this.currentPage;
        data["checkDiscount"] = this.checkDiscount;
        data["discountValue"] = this.discountValue;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductsByTimeReport {
    pageCount: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    summationTotalCost: number;
    totalDiscount: number;
    currentPage: number;
    checkDiscount: boolean;
    discountValue: number;
    items: ProductSalesDetailsByTime[];
}

export class ProductSalesDetailsByTime implements IProductSalesDetailsByTime {
    productName: string;
    productCode: string;
    time: string;
    totalCount: number;
    totalSell: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    totalCost: number;
    currency: string;
    storeName: string;
    storeCode: string;
    saleTypeId: number;

    constructor(data?: IProductSalesDetailsByTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productName = data["productName"];
            this.productCode = data["productCode"];
            this.time = data["time"];
            this.totalCount = data["totalCount"];
            this.totalSell = data["totalSell"];
            this.totalVAT = data["totalVAT"];
            this.totalSellIncludeVAT = data["totalSellIncludeVAT"];
            this.totalCost = data["totalCost"];
            this.currency = data["currency"];
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
            this.saleTypeId = data["saleTypeId"];
        }
    }

    static fromJS(data: any): ProductSalesDetailsByTime {
        let result = new ProductSalesDetailsByTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["time"] = this.time;
        data["totalCount"] = this.totalCount;
        data["totalSell"] = this.totalSell;
        data["totalVAT"] = this.totalVAT;
        data["totalSellIncludeVAT"] = this.totalSellIncludeVAT;
        data["totalCost"] = this.totalCost;
        data["currency"] = this.currency;
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        data["saleTypeId"] = this.saleTypeId;
        return data; 
    }
}

export interface IProductSalesDetailsByTime {
    productName: string;
    productCode: string;
    time: string;
    totalCount: number;
    totalSell: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    totalCost: number;
    currency: string;
    storeName: string;
    storeCode: string;
    saleTypeId: number;
}

export class ProductReportInput implements IProductReportInput {
    searchKey: string;
    menuItemIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    referenceNumber: string;
    productCategories: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    vendorIds: number[];
    areaId: number;
    storeIds: number[];
    saleTypeIds: number[];
    showStoreName: boolean;
    showPromotion: boolean;
    splitByStore: boolean;
    isCSVFile: boolean;

    constructor(data?: IProductReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.searchKey = data["searchKey"];
            if (data["menuItemIds"] && data["menuItemIds"].constructor === Array) {
                this.menuItemIds = [];
                for (let item of data["menuItemIds"])
                    this.menuItemIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.referenceNumber = data["referenceNumber"];
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            if (data["vendorIds"] && data["vendorIds"].constructor === Array) {
                this.vendorIds = [];
                for (let item of data["vendorIds"])
                    this.vendorIds.push(item);
            }
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.showPromotion = data["showPromotion"];
            this.splitByStore = data["splitByStore"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ProductReportInput {
        let result = new ProductReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchKey"] = this.searchKey;
        if (this.menuItemIds && this.menuItemIds.constructor === Array) {
            data["menuItemIds"] = [];
            for (let item of this.menuItemIds)
                data["menuItemIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["referenceNumber"] = this.referenceNumber;
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        if (this.vendorIds && this.vendorIds.constructor === Array) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["showPromotion"] = this.showPromotion;
        data["splitByStore"] = this.splitByStore;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IProductReportInput {
    searchKey: string;
    menuItemIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    referenceNumber: string;
    productCategories: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    vendorIds: number[];
    areaId: number;
    storeIds: number[];
    saleTypeIds: number[];
    showStoreName: boolean;
    showPromotion: boolean;
    splitByStore: boolean;
    isCSVFile: boolean;
}

export class ProductsReport implements IProductsReport {
    itemsByMenuItem: ProductSalesDetailDto[];
    itemsByStore: GroupDetails[];
    pageCount: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    summationTotalCost: number;
    totalDiscount: number;
    summationCount: number;
    currentPage: number;
    checkDiscount: boolean;
    discountValue: number;

    constructor(data?: IProductsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["itemsByMenuItem"] && data["itemsByMenuItem"].constructor === Array) {
                this.itemsByMenuItem = [];
                for (let item of data["itemsByMenuItem"])
                    this.itemsByMenuItem.push(ProductSalesDetailDto.fromJS(item));
            }
            if (data["itemsByStore"] && data["itemsByStore"].constructor === Array) {
                this.itemsByStore = [];
                for (let item of data["itemsByStore"])
                    this.itemsByStore.push(GroupDetails.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.summationTotalSell = data["summationTotalSell"];
            this.currency = data["currency"];
            this.summationTotalVAT = data["summationTotalVAT"];
            this.summationTotalSellIncludeVAT = data["summationTotalSellIncludeVAT"];
            this.summationTotalCount = data["summationTotalCount"];
            this.summationTotalCost = data["summationTotalCost"];
            this.totalDiscount = data["totalDiscount"];
            this.summationCount = data["summationCount"];
            this.currentPage = data["currentPage"];
            this.checkDiscount = data["checkDiscount"];
            this.discountValue = data["discountValue"];
        }
    }

    static fromJS(data: any): ProductsReport {
        let result = new ProductsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.itemsByMenuItem && this.itemsByMenuItem.constructor === Array) {
            data["itemsByMenuItem"] = [];
            for (let item of this.itemsByMenuItem)
                data["itemsByMenuItem"].push(item.toJSON());
        }
        if (this.itemsByStore && this.itemsByStore.constructor === Array) {
            data["itemsByStore"] = [];
            for (let item of this.itemsByStore)
                data["itemsByStore"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["summationTotalSell"] = this.summationTotalSell;
        data["currency"] = this.currency;
        data["summationTotalVAT"] = this.summationTotalVAT;
        data["summationTotalSellIncludeVAT"] = this.summationTotalSellIncludeVAT;
        data["summationTotalCount"] = this.summationTotalCount;
        data["summationTotalCost"] = this.summationTotalCost;
        data["totalDiscount"] = this.totalDiscount;
        data["summationCount"] = this.summationCount;
        data["currentPage"] = this.currentPage;
        data["checkDiscount"] = this.checkDiscount;
        data["discountValue"] = this.discountValue;
        return data; 
    }
}

export interface IProductsReport {
    itemsByMenuItem: ProductSalesDetailDto[];
    itemsByStore: GroupDetails[];
    pageCount: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    summationTotalCost: number;
    totalDiscount: number;
    summationCount: number;
    currentPage: number;
    checkDiscount: boolean;
    discountValue: number;
}

export class ProductSalesDetailDto implements IProductSalesDetailDto {
    saleTypeName: string;
    storeName: string;
    storeCode: string;
    categoryName: string;
    salesDate: string;
    productId: number;
    productCode: string;
    productName: string;
    salesManName: string;
    referenceNumber: string;
    vendorName: string;
    totalCount: number;
    totalSell: number;
    discountValue: number;
    totalVAT: number;
    promotionValue: number;
    promotionCodeId: number;
    promotionCode: string;
    promotionId: number;
    totalSellIncludeVAT: number;
    totalCost: number;
    quantity: number;
    currency: string;
    tenantName: string;
    menuItemId: number;
    storeId: number;
    saleTypeId: number;
    detailMenuItems: ComoboMealsItem[];
    isShowDetail: boolean;
    cashierName: string;
    additionalAllowns: number;

    constructor(data?: IProductSalesDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTypeName = data["saleTypeName"];
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
            this.categoryName = data["categoryName"];
            this.salesDate = data["salesDate"];
            this.productId = data["productId"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.salesManName = data["salesManName"];
            this.referenceNumber = data["referenceNumber"];
            this.vendorName = data["vendorName"];
            this.totalCount = data["totalCount"];
            this.totalSell = data["totalSell"];
            this.discountValue = data["discountValue"];
            this.totalVAT = data["totalVAT"];
            this.promotionValue = data["promotionValue"];
            this.promotionCodeId = data["promotionCodeId"];
            this.promotionCode = data["promotionCode"];
            this.promotionId = data["promotionId"];
            this.totalSellIncludeVAT = data["totalSellIncludeVAT"];
            this.totalCost = data["totalCost"];
            this.quantity = data["quantity"];
            this.currency = data["currency"];
            this.tenantName = data["tenantName"];
            this.menuItemId = data["menuItemId"];
            this.storeId = data["storeId"];
            this.saleTypeId = data["saleTypeId"];
            if (data["detailMenuItems"] && data["detailMenuItems"].constructor === Array) {
                this.detailMenuItems = [];
                for (let item of data["detailMenuItems"])
                    this.detailMenuItems.push(ComoboMealsItem.fromJS(item));
            }
            this.isShowDetail = data["isShowDetail"];
            this.cashierName = data["cashierName"];
            this.additionalAllowns = data["additionalAllowns"];
        }
    }

    static fromJS(data: any): ProductSalesDetailDto {
        let result = new ProductSalesDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTypeName"] = this.saleTypeName;
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        data["categoryName"] = this.categoryName;
        data["salesDate"] = this.salesDate;
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["salesManName"] = this.salesManName;
        data["referenceNumber"] = this.referenceNumber;
        data["vendorName"] = this.vendorName;
        data["totalCount"] = this.totalCount;
        data["totalSell"] = this.totalSell;
        data["discountValue"] = this.discountValue;
        data["totalVAT"] = this.totalVAT;
        data["promotionValue"] = this.promotionValue;
        data["promotionCodeId"] = this.promotionCodeId;
        data["promotionCode"] = this.promotionCode;
        data["promotionId"] = this.promotionId;
        data["totalSellIncludeVAT"] = this.totalSellIncludeVAT;
        data["totalCost"] = this.totalCost;
        data["quantity"] = this.quantity;
        data["currency"] = this.currency;
        data["tenantName"] = this.tenantName;
        data["menuItemId"] = this.menuItemId;
        data["storeId"] = this.storeId;
        data["saleTypeId"] = this.saleTypeId;
        if (this.detailMenuItems && this.detailMenuItems.constructor === Array) {
            data["detailMenuItems"] = [];
            for (let item of this.detailMenuItems)
                data["detailMenuItems"].push(item.toJSON());
        }
        data["isShowDetail"] = this.isShowDetail;
        data["cashierName"] = this.cashierName;
        data["additionalAllowns"] = this.additionalAllowns;
        return data; 
    }
}

export interface IProductSalesDetailDto {
    saleTypeName: string;
    storeName: string;
    storeCode: string;
    categoryName: string;
    salesDate: string;
    productId: number;
    productCode: string;
    productName: string;
    salesManName: string;
    referenceNumber: string;
    vendorName: string;
    totalCount: number;
    totalSell: number;
    discountValue: number;
    totalVAT: number;
    promotionValue: number;
    promotionCodeId: number;
    promotionCode: string;
    promotionId: number;
    totalSellIncludeVAT: number;
    totalCost: number;
    quantity: number;
    currency: string;
    tenantName: string;
    menuItemId: number;
    storeId: number;
    saleTypeId: number;
    detailMenuItems: ComoboMealsItem[];
    isShowDetail: boolean;
    cashierName: string;
    additionalAllowns: number;
}

export class GroupDetails implements IGroupDetails {
    storeId: number;
    storeName: string;
    storeCode: string;
    details: ProductSalesDetailDto[];

    constructor(data?: IGroupDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ProductSalesDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupDetails {
        let result = new GroupDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupDetails {
    storeId: number;
    storeName: string;
    storeCode: string;
    details: ProductSalesDetailDto[];
}

export class ComoboMealsItem implements IComoboMealsItem {
    tenantName: string;
    parentMenuItemId: number;
    storeId: number;
    saleTypeId: number;
    menuItemCode: string;
    menuItemName: string;
    price: number;
    quantity: number;
    total: number;
    menuItemId: number;

    constructor(data?: IComoboMealsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.parentMenuItemId = data["parentMenuItemId"];
            this.storeId = data["storeId"];
            this.saleTypeId = data["saleTypeId"];
            this.menuItemCode = data["menuItemCode"];
            this.menuItemName = data["menuItemName"];
            this.price = data["price"];
            this.quantity = data["quantity"];
            this.total = data["total"];
            this.menuItemId = data["menuItemId"];
        }
    }

    static fromJS(data: any): ComoboMealsItem {
        let result = new ComoboMealsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["parentMenuItemId"] = this.parentMenuItemId;
        data["storeId"] = this.storeId;
        data["saleTypeId"] = this.saleTypeId;
        data["menuItemCode"] = this.menuItemCode;
        data["menuItemName"] = this.menuItemName;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["menuItemId"] = this.menuItemId;
        return data; 
    }
}

export interface IComoboMealsItem {
    tenantName: string;
    parentMenuItemId: number;
    storeId: number;
    saleTypeId: number;
    menuItemCode: string;
    menuItemName: string;
    price: number;
    quantity: number;
    total: number;
    menuItemId: number;
}

export class ComboMealsReportInput implements IComboMealsReportInput {
    searchKey: string;
    menuItemIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    referenceNumber: string;
    productCategories: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantsIds: number[];
    regionId: number;
    vendorIds: number[];
    areaId: number;
    storeIds: number[];
    saleTypeIds: number[];
    showStoreName: boolean;
    showPromotion: boolean;
    splitByStore: boolean;
    isCSVFile: boolean;
    showDetails: boolean;

    constructor(data?: IComboMealsReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.searchKey = data["searchKey"];
            if (data["menuItemIds"] && data["menuItemIds"].constructor === Array) {
                this.menuItemIds = [];
                for (let item of data["menuItemIds"])
                    this.menuItemIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.referenceNumber = data["referenceNumber"];
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.regionId = data["regionId"];
            if (data["vendorIds"] && data["vendorIds"].constructor === Array) {
                this.vendorIds = [];
                for (let item of data["vendorIds"])
                    this.vendorIds.push(item);
            }
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.showPromotion = data["showPromotion"];
            this.splitByStore = data["splitByStore"];
            this.isCSVFile = data["isCSVFile"];
            this.showDetails = data["showDetails"];
        }
    }

    static fromJS(data: any): ComboMealsReportInput {
        let result = new ComboMealsReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchKey"] = this.searchKey;
        if (this.menuItemIds && this.menuItemIds.constructor === Array) {
            data["menuItemIds"] = [];
            for (let item of this.menuItemIds)
                data["menuItemIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["referenceNumber"] = this.referenceNumber;
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["regionId"] = this.regionId;
        if (this.vendorIds && this.vendorIds.constructor === Array) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["showPromotion"] = this.showPromotion;
        data["splitByStore"] = this.splitByStore;
        data["isCSVFile"] = this.isCSVFile;
        data["showDetails"] = this.showDetails;
        return data; 
    }
}

export interface IComboMealsReportInput {
    searchKey: string;
    menuItemIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    referenceNumber: string;
    productCategories: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantsIds: number[];
    regionId: number;
    vendorIds: number[];
    areaId: number;
    storeIds: number[];
    saleTypeIds: number[];
    showStoreName: boolean;
    showPromotion: boolean;
    splitByStore: boolean;
    isCSVFile: boolean;
    showDetails: boolean;
}

export class FastestAndSlowestOrdersReportInput implements IFastestAndSlowestOrdersReportInput {
    from: moment.Moment;
    to: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    documentType: number;
    isCSVFile: boolean;
    isEndOfDay: boolean;

    constructor(data?: IFastestAndSlowestOrdersReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
            this.isEndOfDay = data["isEndOfDay"];
        }
    }

    static fromJS(data: any): FastestAndSlowestOrdersReportInput {
        let result = new FastestAndSlowestOrdersReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        data["isEndOfDay"] = this.isEndOfDay;
        return data; 
    }
}

export interface IFastestAndSlowestOrdersReportInput {
    from: moment.Moment;
    to: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    documentType: number;
    isCSVFile: boolean;
    isEndOfDay: boolean;
}

export class FastestAndSlowestOrdersReportDto implements IFastestAndSlowestOrdersReportDto {
    pageCount: number;
    currentPage: number;
    details: FastestAndSlowestOrdersDetialsDto[];

    constructor(data?: IFastestAndSlowestOrdersReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(FastestAndSlowestOrdersDetialsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FastestAndSlowestOrdersReportDto {
        let result = new FastestAndSlowestOrdersReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFastestAndSlowestOrdersReportDto {
    pageCount: number;
    currentPage: number;
    details: FastestAndSlowestOrdersDetialsDto[];
}

export class FastestAndSlowestOrdersDetialsDto implements IFastestAndSlowestOrdersDetialsDto {
    rank: string;
    orderNumber: string;
    storeName: string;
    totalPrep: string;
    stationPattern: string;
    reason: string;
    date: string;

    constructor(data?: IFastestAndSlowestOrdersDetialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rank = data["rank"];
            this.orderNumber = data["orderNumber"];
            this.storeName = data["storeName"];
            this.totalPrep = data["totalPrep"];
            this.stationPattern = data["stationPattern"];
            this.reason = data["reason"];
            this.date = data["date"];
        }
    }

    static fromJS(data: any): FastestAndSlowestOrdersDetialsDto {
        let result = new FastestAndSlowestOrdersDetialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["orderNumber"] = this.orderNumber;
        data["storeName"] = this.storeName;
        data["totalPrep"] = this.totalPrep;
        data["stationPattern"] = this.stationPattern;
        data["reason"] = this.reason;
        data["date"] = this.date;
        return data; 
    }
}

export interface IFastestAndSlowestOrdersDetialsDto {
    rank: string;
    orderNumber: string;
    storeName: string;
    totalPrep: string;
    stationPattern: string;
    reason: string;
    date: string;
}

export class ListResultDtoOfMaterialStockDto implements IListResultDtoOfMaterialStockDto {
    items: MaterialStockDto[];

    constructor(data?: IListResultDtoOfMaterialStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MaterialStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMaterialStockDto {
        let result = new ListResultDtoOfMaterialStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMaterialStockDto {
    items: MaterialStockDto[];
}

export class LotReportInput implements ILotReportInput {
    products: number[];
    referenceNumber: string;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: ILotReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(item);
            }
            this.referenceNumber = data["referenceNumber"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): LotReportInput {
        let result = new LotReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        data["referenceNumber"] = this.referenceNumber;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ILotReportInput {
    products: number[];
    referenceNumber: string;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
}

export class TrendingProductsReportDto implements ITrendingProductsReportDto {
    name: string;
    count: number;
    total: number;
    totalVAT: number;
    totalSales: number;
    materialId: number;

    constructor(data?: ITrendingProductsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.count = data["count"];
            this.total = data["total"];
            this.totalVAT = data["totalVAT"];
            this.totalSales = data["totalSales"];
            this.materialId = data["materialId"];
        }
    }

    static fromJS(data: any): TrendingProductsReportDto {
        let result = new TrendingProductsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        data["total"] = this.total;
        data["totalVAT"] = this.totalVAT;
        data["totalSales"] = this.totalSales;
        data["materialId"] = this.materialId;
        return data; 
    }
}

export interface ITrendingProductsReportDto {
    name: string;
    count: number;
    total: number;
    totalVAT: number;
    totalSales: number;
    materialId: number;
}

export class CompareSalesInput implements ICompareSalesInput {
    firstDate: moment.Moment;
    secondDate: moment.Moment;
    datePeriod: CompareSalesInputDatePeriod;
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    isEndOfDay: boolean;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: ICompareSalesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstDate = data["firstDate"] ? moment(data["firstDate"].toString()) : <any>undefined;
            this.secondDate = data["secondDate"] ? moment(data["secondDate"].toString()) : <any>undefined;
            this.datePeriod = data["datePeriod"];
            this.documentType = data["documentType"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.isEndOfDay = data["isEndOfDay"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): CompareSalesInput {
        let result = new CompareSalesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstDate"] = this.firstDate ? this.firstDate.toISOString() : <any>undefined;
        data["secondDate"] = this.secondDate ? this.secondDate.toISOString() : <any>undefined;
        data["datePeriod"] = this.datePeriod;
        data["documentType"] = this.documentType;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["isEndOfDay"] = this.isEndOfDay;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ICompareSalesInput {
    firstDate: moment.Moment;
    secondDate: moment.Moment;
    datePeriod: CompareSalesInputDatePeriod;
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    isEndOfDay: boolean;
    storeIds: number[];
    isCSVFile: boolean;
}

export class CompareSalesReport implements ICompareSalesReport {
    first: CompareSalesDetailsReport;
    second: CompareSalesDetailsReport;

    constructor(data?: ICompareSalesReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.first = data["first"] ? CompareSalesDetailsReport.fromJS(data["first"]) : <any>undefined;
            this.second = data["second"] ? CompareSalesDetailsReport.fromJS(data["second"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompareSalesReport {
        let result = new CompareSalesReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["first"] = this.first ? this.first.toJSON() : <any>undefined;
        data["second"] = this.second ? this.second.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompareSalesReport {
    first: CompareSalesDetailsReport;
    second: CompareSalesDetailsReport;
}

export class CompareSalesDetailsReport implements ICompareSalesDetailsReport {
    totalSales: number;
    totalReturn: number;
    netSales: number;
    date: string;

    constructor(data?: ICompareSalesDetailsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.totalReturn = data["totalReturn"];
            this.netSales = data["netSales"];
            this.date = data["date"];
        }
    }

    static fromJS(data: any): CompareSalesDetailsReport {
        let result = new CompareSalesDetailsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["totalReturn"] = this.totalReturn;
        data["netSales"] = this.netSales;
        data["date"] = this.date;
        return data; 
    }
}

export interface ICompareSalesDetailsReport {
    totalSales: number;
    totalReturn: number;
    netSales: number;
    date: string;
}

export class CompareSalesPeriodByPeriodInput implements ICompareSalesPeriodByPeriodInput {
    firstDateRangeStart: moment.Moment;
    secondDateRangeStart: moment.Moment;
    firstDateRangeEnd: moment.Moment;
    secondDateRangeEnd: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: ICompareSalesPeriodByPeriodInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstDateRangeStart = data["firstDateRangeStart"] ? moment(data["firstDateRangeStart"].toString()) : <any>undefined;
            this.secondDateRangeStart = data["secondDateRangeStart"] ? moment(data["secondDateRangeStart"].toString()) : <any>undefined;
            this.firstDateRangeEnd = data["firstDateRangeEnd"] ? moment(data["firstDateRangeEnd"].toString()) : <any>undefined;
            this.secondDateRangeEnd = data["secondDateRangeEnd"] ? moment(data["secondDateRangeEnd"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): CompareSalesPeriodByPeriodInput {
        let result = new CompareSalesPeriodByPeriodInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstDateRangeStart"] = this.firstDateRangeStart ? this.firstDateRangeStart.toISOString() : <any>undefined;
        data["secondDateRangeStart"] = this.secondDateRangeStart ? this.secondDateRangeStart.toISOString() : <any>undefined;
        data["firstDateRangeEnd"] = this.firstDateRangeEnd ? this.firstDateRangeEnd.toISOString() : <any>undefined;
        data["secondDateRangeEnd"] = this.secondDateRangeEnd ? this.secondDateRangeEnd.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ICompareSalesPeriodByPeriodInput {
    firstDateRangeStart: moment.Moment;
    secondDateRangeStart: moment.Moment;
    firstDateRangeEnd: moment.Moment;
    secondDateRangeEnd: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
}

export class ComparePurchasePeriodByPeriodInput implements IComparePurchasePeriodByPeriodInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    materialIds: number[];
    firstDateRangeStart: moment.Moment;
    firstDateRangeEnd: moment.Moment;
    secondDateRangeStart: moment.Moment;
    secondDateRangeEnd: moment.Moment;
    isEndOfDay: boolean;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IComparePurchasePeriodByPeriodInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["materialIds"] && data["materialIds"].constructor === Array) {
                this.materialIds = [];
                for (let item of data["materialIds"])
                    this.materialIds.push(item);
            }
            this.firstDateRangeStart = data["firstDateRangeStart"] ? moment(data["firstDateRangeStart"].toString()) : <any>undefined;
            this.firstDateRangeEnd = data["firstDateRangeEnd"] ? moment(data["firstDateRangeEnd"].toString()) : <any>undefined;
            this.secondDateRangeStart = data["secondDateRangeStart"] ? moment(data["secondDateRangeStart"].toString()) : <any>undefined;
            this.secondDateRangeEnd = data["secondDateRangeEnd"] ? moment(data["secondDateRangeEnd"].toString()) : <any>undefined;
            this.isEndOfDay = data["isEndOfDay"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ComparePurchasePeriodByPeriodInput {
        let result = new ComparePurchasePeriodByPeriodInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.materialIds && this.materialIds.constructor === Array) {
            data["materialIds"] = [];
            for (let item of this.materialIds)
                data["materialIds"].push(item);
        }
        data["firstDateRangeStart"] = this.firstDateRangeStart ? this.firstDateRangeStart.toISOString() : <any>undefined;
        data["firstDateRangeEnd"] = this.firstDateRangeEnd ? this.firstDateRangeEnd.toISOString() : <any>undefined;
        data["secondDateRangeStart"] = this.secondDateRangeStart ? this.secondDateRangeStart.toISOString() : <any>undefined;
        data["secondDateRangeEnd"] = this.secondDateRangeEnd ? this.secondDateRangeEnd.toISOString() : <any>undefined;
        data["isEndOfDay"] = this.isEndOfDay;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IComparePurchasePeriodByPeriodInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    materialIds: number[];
    firstDateRangeStart: moment.Moment;
    firstDateRangeEnd: moment.Moment;
    secondDateRangeStart: moment.Moment;
    secondDateRangeEnd: moment.Moment;
    isEndOfDay: boolean;
    documentType: number;
    isCSVFile: boolean;
}

export class ComparePurchaseReportDto implements IComparePurchaseReportDto {
    items: ComparePurchaseReportItem[];
    currentPage: number;
    pageCount: number;

    constructor(data?: IComparePurchaseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ComparePurchaseReportItem.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.pageCount = data["pageCount"];
        }
    }

    static fromJS(data: any): ComparePurchaseReportDto {
        let result = new ComparePurchaseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export interface IComparePurchaseReportDto {
    items: ComparePurchaseReportItem[];
    currentPage: number;
    pageCount: number;
}

export class ComparePurchaseReportItem implements IComparePurchaseReportItem {
    materialId: number;
    materialName: string;
    storeId: number;
    storeName: string;
    firstTotalQty: number;
    firstPrice: number;
    secondTotalQty: number;
    secondPrice: number;
    diffrence: number;

    constructor(data?: IComparePurchaseReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.firstTotalQty = data["firstTotalQty"];
            this.firstPrice = data["firstPrice"];
            this.secondTotalQty = data["secondTotalQty"];
            this.secondPrice = data["secondPrice"];
            this.diffrence = data["diffrence"];
        }
    }

    static fromJS(data: any): ComparePurchaseReportItem {
        let result = new ComparePurchaseReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["firstTotalQty"] = this.firstTotalQty;
        data["firstPrice"] = this.firstPrice;
        data["secondTotalQty"] = this.secondTotalQty;
        data["secondPrice"] = this.secondPrice;
        data["diffrence"] = this.diffrence;
        return data; 
    }
}

export interface IComparePurchaseReportItem {
    materialId: number;
    materialName: string;
    storeId: number;
    storeName: string;
    firstTotalQty: number;
    firstPrice: number;
    secondTotalQty: number;
    secondPrice: number;
    diffrence: number;
}

export class CompareSalesBetweenStocksFixedDateInput implements ICompareSalesBetweenStocksFixedDateInput {
    firstStock: number;
    secondStock: number;
    date: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    isCSVFile: boolean;

    constructor(data?: ICompareSalesBetweenStocksFixedDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstStock = data["firstStock"];
            this.secondStock = data["secondStock"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): CompareSalesBetweenStocksFixedDateInput {
        let result = new CompareSalesBetweenStocksFixedDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstStock"] = this.firstStock;
        data["secondStock"] = this.secondStock;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ICompareSalesBetweenStocksFixedDateInput {
    firstStock: number;
    secondStock: number;
    date: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    isCSVFile: boolean;
}

export class ComparePurchaseDayByDayInput implements IComparePurchaseDayByDayInput {
    transactionTypeId: number;
    firstDate: moment.Moment;
    secondDate: moment.Moment;
    storeIds: number[];
    regionId: number;
    areaId: number;
    documentType: number;
    tenantId: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IComparePurchaseDayByDayInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeId = data["transactionTypeId"];
            this.firstDate = data["firstDate"] ? moment(data["firstDate"].toString()) : <any>undefined;
            this.secondDate = data["secondDate"] ? moment(data["secondDate"].toString()) : <any>undefined;
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.documentType = data["documentType"];
            this.tenantId = data["tenantId"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ComparePurchaseDayByDayInput {
        let result = new ComparePurchaseDayByDayInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["firstDate"] = this.firstDate ? this.firstDate.toISOString() : <any>undefined;
        data["secondDate"] = this.secondDate ? this.secondDate.toISOString() : <any>undefined;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["documentType"] = this.documentType;
        data["tenantId"] = this.tenantId;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IComparePurchaseDayByDayInput {
    transactionTypeId: number;
    firstDate: moment.Moment;
    secondDate: moment.Moment;
    storeIds: number[];
    regionId: number;
    areaId: number;
    documentType: number;
    tenantId: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class ComparePurchaseReport implements IComparePurchaseReport {
    firstDate: ComparePurchaseReportDetails;
    secondDate: ComparePurchaseReportDetails;
    storeName: string;

    constructor(data?: IComparePurchaseReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstDate = data["firstDate"] ? ComparePurchaseReportDetails.fromJS(data["firstDate"]) : <any>undefined;
            this.secondDate = data["secondDate"] ? ComparePurchaseReportDetails.fromJS(data["secondDate"]) : <any>undefined;
            this.storeName = data["storeName"];
        }
    }

    static fromJS(data: any): ComparePurchaseReport {
        let result = new ComparePurchaseReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstDate"] = this.firstDate ? this.firstDate.toJSON() : <any>undefined;
        data["secondDate"] = this.secondDate ? this.secondDate.toJSON() : <any>undefined;
        data["storeName"] = this.storeName;
        return data; 
    }
}

export interface IComparePurchaseReport {
    firstDate: ComparePurchaseReportDetails;
    secondDate: ComparePurchaseReportDetails;
    storeName: string;
}

export class ComparePurchaseReportDetails implements IComparePurchaseReportDetails {
    totalPurchase: number;
    date: string;
    showDate: moment.Moment;

    constructor(data?: IComparePurchaseReportDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPurchase = data["totalPurchase"];
            this.date = data["date"];
            this.showDate = data["showDate"] ? moment(data["showDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ComparePurchaseReportDetails {
        let result = new ComparePurchaseReportDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPurchase"] = this.totalPurchase;
        data["date"] = this.date;
        data["showDate"] = this.showDate ? this.showDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IComparePurchaseReportDetails {
    totalPurchase: number;
    date: string;
    showDate: moment.Moment;
}

export class CustomersReportInput implements ICustomersReportInput {
    customerName: string;
    mobileNumber: string;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    isCSVFile: boolean;

    constructor(data?: ICustomersReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.mobileNumber = data["mobileNumber"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): CustomersReportInput {
        let result = new CustomersReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["mobileNumber"] = this.mobileNumber;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ICustomersReportInput {
    customerName: string;
    mobileNumber: string;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    isCSVFile: boolean;
}

export class CustomerReport implements ICustomerReport {
    pageCount: number;
    currentPage: number;
    summationTotal: number;
    summationVAT: number;
    summationGrandTotal: number;
    summationOrdersCount: number;
    summationGrandTotalPoints: number;
    summationGrandTotalDiscounts: number;
    data: CustomerReportDTO[];

    constructor(data?: ICustomerReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationTotal = data["summationTotal"];
            this.summationVAT = data["summationVAT"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationOrdersCount = data["summationOrdersCount"];
            this.summationGrandTotalPoints = data["summationGrandTotalPoints"];
            this.summationGrandTotalDiscounts = data["summationGrandTotalDiscounts"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(CustomerReportDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerReport {
        let result = new CustomerReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationTotal"] = this.summationTotal;
        data["summationVAT"] = this.summationVAT;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationOrdersCount"] = this.summationOrdersCount;
        data["summationGrandTotalPoints"] = this.summationGrandTotalPoints;
        data["summationGrandTotalDiscounts"] = this.summationGrandTotalDiscounts;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerReport {
    pageCount: number;
    currentPage: number;
    summationTotal: number;
    summationVAT: number;
    summationGrandTotal: number;
    summationOrdersCount: number;
    summationGrandTotalPoints: number;
    summationGrandTotalDiscounts: number;
    data: CustomerReportDTO[];
}

export class CustomerReportDTO implements ICustomerReportDTO {
    customerName: string;
    customerPhone: string;
    customerCardNumber: string;
    subTotalOrdersValue: number;
    totalVATOrdersValue: number;
    totalOrdersValue: number;
    totalDiscountsValue: number;
    totalPointsValue: number;
    customerID: string;
    totalOrdersCount: number;
    customerSalesDTO: CustomerSalesDTO[];

    constructor(data?: ICustomerReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.customerPhone = data["customerPhone"];
            this.customerCardNumber = data["customerCardNumber"];
            this.subTotalOrdersValue = data["subTotalOrdersValue"];
            this.totalVATOrdersValue = data["totalVATOrdersValue"];
            this.totalOrdersValue = data["totalOrdersValue"];
            this.totalDiscountsValue = data["totalDiscountsValue"];
            this.totalPointsValue = data["totalPointsValue"];
            this.customerID = data["customerID"];
            this.totalOrdersCount = data["totalOrdersCount"];
            if (data["customerSalesDTO"] && data["customerSalesDTO"].constructor === Array) {
                this.customerSalesDTO = [];
                for (let item of data["customerSalesDTO"])
                    this.customerSalesDTO.push(CustomerSalesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerReportDTO {
        let result = new CustomerReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["customerPhone"] = this.customerPhone;
        data["customerCardNumber"] = this.customerCardNumber;
        data["subTotalOrdersValue"] = this.subTotalOrdersValue;
        data["totalVATOrdersValue"] = this.totalVATOrdersValue;
        data["totalOrdersValue"] = this.totalOrdersValue;
        data["totalDiscountsValue"] = this.totalDiscountsValue;
        data["totalPointsValue"] = this.totalPointsValue;
        data["customerID"] = this.customerID;
        data["totalOrdersCount"] = this.totalOrdersCount;
        if (this.customerSalesDTO && this.customerSalesDTO.constructor === Array) {
            data["customerSalesDTO"] = [];
            for (let item of this.customerSalesDTO)
                data["customerSalesDTO"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerReportDTO {
    customerName: string;
    customerPhone: string;
    customerCardNumber: string;
    subTotalOrdersValue: number;
    totalVATOrdersValue: number;
    totalOrdersValue: number;
    totalDiscountsValue: number;
    totalPointsValue: number;
    customerID: string;
    totalOrdersCount: number;
    customerSalesDTO: CustomerSalesDTO[];
}

export class CustomerSalesDTO implements ICustomerSalesDTO {
    receiptNumber: string;
    receiptID: string;
    date: string;
    total: number;
    status: CustomerSalesDTOStatus;

    constructor(data?: ICustomerSalesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptNumber = data["receiptNumber"];
            this.receiptID = data["receiptID"];
            this.date = data["date"];
            this.total = data["total"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CustomerSalesDTO {
        let result = new CustomerSalesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptNumber"] = this.receiptNumber;
        data["receiptID"] = this.receiptID;
        data["date"] = this.date;
        data["total"] = this.total;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICustomerSalesDTO {
    receiptNumber: string;
    receiptID: string;
    date: string;
    total: number;
    status: CustomerSalesDTOStatus;
}

export class CustomerSales implements ICustomerSales {
    pageCount: number;
    currentPage: number;
    data: CustomerSalesDTO[];

    constructor(data?: ICustomerSales) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(CustomerSalesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerSales {
        let result = new CustomerSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerSales {
    pageCount: number;
    currentPage: number;
    data: CustomerSalesDTO[];
}

export class TenderMediaInput implements ITenderMediaInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    tenderTypes: number[];
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: ITenderMediaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["tenderTypes"] && data["tenderTypes"].constructor === Array) {
                this.tenderTypes = [];
                for (let item of data["tenderTypes"])
                    this.tenderTypes.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TenderMediaInput {
        let result = new TenderMediaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.tenderTypes && this.tenderTypes.constructor === Array) {
            data["tenderTypes"] = [];
            for (let item of this.tenderTypes)
                data["tenderTypes"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITenderMediaInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    tenderTypes: number[];
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class PaymentMethodsSummaryReport implements IPaymentMethodsSummaryReport {
    summationGrandTotal: number;
    summationCount: number;
    currency: string;
    data: PaymentMethodsSummaryDetails[];
    currentPage: number;
    pageCount: number;

    constructor(data?: IPaymentMethodsSummaryReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationCount = data["summationCount"];
            this.currency = data["currency"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(PaymentMethodsSummaryDetails.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.pageCount = data["pageCount"];
        }
    }

    static fromJS(data: any): PaymentMethodsSummaryReport {
        let result = new PaymentMethodsSummaryReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationCount"] = this.summationCount;
        data["currency"] = this.currency;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export interface IPaymentMethodsSummaryReport {
    summationGrandTotal: number;
    summationCount: number;
    currency: string;
    data: PaymentMethodsSummaryDetails[];
    currentPage: number;
    pageCount: number;
}

export class PaymentMethodsSummaryDetails implements IPaymentMethodsSummaryDetails {
    tenantName: string;
    storeCode: string;
    storeName: string;
    count: number;
    value: number;
    storeData: PaymentMethodsSummaryStoreData[];

    constructor(data?: IPaymentMethodsSummaryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.count = data["count"];
            this.value = data["value"];
            if (data["storeData"] && data["storeData"].constructor === Array) {
                this.storeData = [];
                for (let item of data["storeData"])
                    this.storeData.push(PaymentMethodsSummaryStoreData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentMethodsSummaryDetails {
        let result = new PaymentMethodsSummaryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["count"] = this.count;
        data["value"] = this.value;
        if (this.storeData && this.storeData.constructor === Array) {
            data["storeData"] = [];
            for (let item of this.storeData)
                data["storeData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPaymentMethodsSummaryDetails {
    tenantName: string;
    storeCode: string;
    storeName: string;
    count: number;
    value: number;
    storeData: PaymentMethodsSummaryStoreData[];
}

export class PaymentMethodsSummaryStoreData implements IPaymentMethodsSummaryStoreData {
    tenderTypeCode: string;
    paymentMethodName: string;
    count: number;
    value: number;
    currency: string;

    constructor(data?: IPaymentMethodsSummaryStoreData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeCode = data["tenderTypeCode"];
            this.paymentMethodName = data["paymentMethodName"];
            this.count = data["count"];
            this.value = data["value"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): PaymentMethodsSummaryStoreData {
        let result = new PaymentMethodsSummaryStoreData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeCode"] = this.tenderTypeCode;
        data["paymentMethodName"] = this.paymentMethodName;
        data["count"] = this.count;
        data["value"] = this.value;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IPaymentMethodsSummaryStoreData {
    tenderTypeCode: string;
    paymentMethodName: string;
    count: number;
    value: number;
    currency: string;
}

export class PaymentMethodByTimeInput implements IPaymentMethodByTimeInput {
    timeFrom: string;
    timeTo: string;
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    tenderTypes: number[];
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: IPaymentMethodByTimeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["tenderTypes"] && data["tenderTypes"].constructor === Array) {
                this.tenderTypes = [];
                for (let item of data["tenderTypes"])
                    this.tenderTypes.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PaymentMethodByTimeInput {
        let result = new PaymentMethodByTimeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.tenderTypes && this.tenderTypes.constructor === Array) {
            data["tenderTypes"] = [];
            for (let item of this.tenderTypes)
                data["tenderTypes"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPaymentMethodByTimeInput {
    timeFrom: string;
    timeTo: string;
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    tenderTypes: number[];
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class TotalSalesInput implements ITotalSalesInput {
    from: moment.Moment;
    to: moment.Moment;
    tenderTypes: number[];
    primaryCategories: number[];
    productCategories: number[];
    secondatyCategories: number[];
    menuItems: number[];
    referenceNumber: string;
    code: string;
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: ITotalSalesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["tenderTypes"] && data["tenderTypes"].constructor === Array) {
                this.tenderTypes = [];
                for (let item of data["tenderTypes"])
                    this.tenderTypes.push(item);
            }
            if (data["primaryCategories"] && data["primaryCategories"].constructor === Array) {
                this.primaryCategories = [];
                for (let item of data["primaryCategories"])
                    this.primaryCategories.push(item);
            }
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(item);
            }
            if (data["secondatyCategories"] && data["secondatyCategories"].constructor === Array) {
                this.secondatyCategories = [];
                for (let item of data["secondatyCategories"])
                    this.secondatyCategories.push(item);
            }
            if (data["menuItems"] && data["menuItems"].constructor === Array) {
                this.menuItems = [];
                for (let item of data["menuItems"])
                    this.menuItems.push(item);
            }
            this.referenceNumber = data["referenceNumber"];
            this.code = data["code"];
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalSalesInput {
        let result = new TotalSalesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.tenderTypes && this.tenderTypes.constructor === Array) {
            data["tenderTypes"] = [];
            for (let item of this.tenderTypes)
                data["tenderTypes"].push(item);
        }
        if (this.primaryCategories && this.primaryCategories.constructor === Array) {
            data["primaryCategories"] = [];
            for (let item of this.primaryCategories)
                data["primaryCategories"].push(item);
        }
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item);
        }
        if (this.secondatyCategories && this.secondatyCategories.constructor === Array) {
            data["secondatyCategories"] = [];
            for (let item of this.secondatyCategories)
                data["secondatyCategories"].push(item);
        }
        if (this.menuItems && this.menuItems.constructor === Array) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item);
        }
        data["referenceNumber"] = this.referenceNumber;
        data["code"] = this.code;
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalSalesInput {
    from: moment.Moment;
    to: moment.Moment;
    tenderTypes: number[];
    primaryCategories: number[];
    productCategories: number[];
    secondatyCategories: number[];
    menuItems: number[];
    referenceNumber: string;
    code: string;
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
}

export class TotalSalesReport implements ITotalSalesReport {
    totalSales: number;
    totalTax: number;
    totaldiscount: number;
    totalSalesIncludingTax: number;
    totalCost: number;
    totalTransactions: number;
    currency: string;

    constructor(data?: ITotalSalesReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.totalTax = data["totalTax"];
            this.totaldiscount = data["totaldiscount"];
            this.totalSalesIncludingTax = data["totalSalesIncludingTax"];
            this.totalCost = data["totalCost"];
            this.totalTransactions = data["totalTransactions"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): TotalSalesReport {
        let result = new TotalSalesReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["totalTax"] = this.totalTax;
        data["totaldiscount"] = this.totaldiscount;
        data["totalSalesIncludingTax"] = this.totalSalesIncludingTax;
        data["totalCost"] = this.totalCost;
        data["totalTransactions"] = this.totalTransactions;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface ITotalSalesReport {
    totalSales: number;
    totalTax: number;
    totaldiscount: number;
    totalSalesIncludingTax: number;
    totalCost: number;
    totalTransactions: number;
    currency: string;
}

export class TotalSalesByStoreSummary implements ITotalSalesByStoreSummary {
    pageCount: number;
    totalSales: number;
    totalTax: number;
    toTalSalesIncludingTax: number;
    returnTotalSales: number;
    returnTotalTax: number;
    returnToTalSalesIncludingTax: number;
    totalNetSale: number;
    reports: TenantGroup[];

    constructor(data?: ITotalSalesByStoreSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.totalSales = data["totalSales"];
            this.totalTax = data["totalTax"];
            this.toTalSalesIncludingTax = data["toTalSalesIncludingTax"];
            this.returnTotalSales = data["returnTotalSales"];
            this.returnTotalTax = data["returnTotalTax"];
            this.returnToTalSalesIncludingTax = data["returnToTalSalesIncludingTax"];
            this.totalNetSale = data["totalNetSale"];
            if (data["reports"] && data["reports"].constructor === Array) {
                this.reports = [];
                for (let item of data["reports"])
                    this.reports.push(TenantGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TotalSalesByStoreSummary {
        let result = new TotalSalesByStoreSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["totalSales"] = this.totalSales;
        data["totalTax"] = this.totalTax;
        data["toTalSalesIncludingTax"] = this.toTalSalesIncludingTax;
        data["returnTotalSales"] = this.returnTotalSales;
        data["returnTotalTax"] = this.returnTotalTax;
        data["returnToTalSalesIncludingTax"] = this.returnToTalSalesIncludingTax;
        data["totalNetSale"] = this.totalNetSale;
        if (this.reports && this.reports.constructor === Array) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITotalSalesByStoreSummary {
    pageCount: number;
    totalSales: number;
    totalTax: number;
    toTalSalesIncludingTax: number;
    returnTotalSales: number;
    returnTotalTax: number;
    returnToTalSalesIncludingTax: number;
    totalNetSale: number;
    reports: TenantGroup[];
}

export class TenantGroup implements ITenantGroup {
    tenantId: number;
    tenantName: string;
    stores: TotalSalesByStoreReport[];

    constructor(data?: ITenantGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(TotalSalesByStoreReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantGroup {
        let result = new TenantGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantGroup {
    tenantId: number;
    tenantName: string;
    stores: TotalSalesByStoreReport[];
}

export class TotalSalesByStoreReport implements ITotalSalesByStoreReport {
    tenantId: number;
    storeId: number;
    storeName: string;
    currency: string;
    totalSales: number;
    totalTax: number;
    toTalSalesIncludingTax: number;
    returnTotalSales: number;
    returnTotalTax: number;
    returnToTalSalesIncludingTax: number;
    totalNetSale: number;
    totalCost: number;

    constructor(data?: ITotalSalesByStoreReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.currency = data["currency"];
            this.totalSales = data["totalSales"];
            this.totalTax = data["totalTax"];
            this.toTalSalesIncludingTax = data["toTalSalesIncludingTax"];
            this.returnTotalSales = data["returnTotalSales"];
            this.returnTotalTax = data["returnTotalTax"];
            this.returnToTalSalesIncludingTax = data["returnToTalSalesIncludingTax"];
            this.totalNetSale = data["totalNetSale"];
            this.totalCost = data["totalCost"];
        }
    }

    static fromJS(data: any): TotalSalesByStoreReport {
        let result = new TotalSalesByStoreReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["currency"] = this.currency;
        data["totalSales"] = this.totalSales;
        data["totalTax"] = this.totalTax;
        data["toTalSalesIncludingTax"] = this.toTalSalesIncludingTax;
        data["returnTotalSales"] = this.returnTotalSales;
        data["returnTotalTax"] = this.returnTotalTax;
        data["returnToTalSalesIncludingTax"] = this.returnToTalSalesIncludingTax;
        data["totalNetSale"] = this.totalNetSale;
        data["totalCost"] = this.totalCost;
        return data; 
    }
}

export interface ITotalSalesByStoreReport {
    tenantId: number;
    storeId: number;
    storeName: string;
    currency: string;
    totalSales: number;
    totalTax: number;
    toTalSalesIncludingTax: number;
    returnTotalSales: number;
    returnTotalTax: number;
    returnToTalSalesIncludingTax: number;
    totalNetSale: number;
    totalCost: number;
}

export class SalesMovementReportInput implements ISalesMovementReportInput {
    searchKey: string;
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    productCategories: number[];
    customerIds: string[];
    isStoreDataInDetail: boolean;
    isCashierDataInDetail: boolean;
    isCustomerDataInDetail: boolean;
    isSupplierDataInDetail: boolean;
    storeIds: number[];
    cashierIds: number[];
    productInfo: string;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: ISalesMovementReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.searchKey = data["searchKey"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.referenceNumber = data["referenceNumber"];
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(item);
            }
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [];
                for (let item of data["customerIds"])
                    this.customerIds.push(item);
            }
            this.isStoreDataInDetail = data["isStoreDataInDetail"];
            this.isCashierDataInDetail = data["isCashierDataInDetail"];
            this.isCustomerDataInDetail = data["isCustomerDataInDetail"];
            this.isSupplierDataInDetail = data["isSupplierDataInDetail"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.productInfo = data["productInfo"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): SalesMovementReportInput {
        let result = new SalesMovementReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchKey"] = this.searchKey;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item);
        }
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["isStoreDataInDetail"] = this.isStoreDataInDetail;
        data["isCashierDataInDetail"] = this.isCashierDataInDetail;
        data["isCustomerDataInDetail"] = this.isCustomerDataInDetail;
        data["isSupplierDataInDetail"] = this.isSupplierDataInDetail;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["productInfo"] = this.productInfo;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ISalesMovementReportInput {
    searchKey: string;
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    productCategories: number[];
    customerIds: string[];
    isStoreDataInDetail: boolean;
    isCashierDataInDetail: boolean;
    isCustomerDataInDetail: boolean;
    isSupplierDataInDetail: boolean;
    storeIds: number[];
    cashierIds: number[];
    productInfo: string;
    documentType: number;
    isCSVFile: boolean;
}

export class SalesMovementReport implements ISalesMovementReport {
    details: SalesMovementDetailDto[];
    currentPage: number;
    itemsCount: number;
    summationTotalCount: number;

    constructor(data?: ISalesMovementReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SalesMovementDetailDto.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.summationTotalCount = data["summationTotalCount"];
        }
    }

    static fromJS(data: any): SalesMovementReport {
        let result = new SalesMovementReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["summationTotalCount"] = this.summationTotalCount;
        return data; 
    }
}

export interface ISalesMovementReport {
    details: SalesMovementDetailDto[];
    currentPage: number;
    itemsCount: number;
    summationTotalCount: number;
}

export class SalesMovementDetailDto implements ISalesMovementDetailDto {
    textDate: string;
    productName: string;
    serial: string;
    storeName: string;
    cashierName: string;
    customerName: string;
    quantity: number;

    constructor(data?: ISalesMovementDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.textDate = data["textDate"];
            this.productName = data["productName"];
            this.serial = data["serial"];
            this.storeName = data["storeName"];
            this.cashierName = data["cashierName"];
            this.customerName = data["customerName"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): SalesMovementDetailDto {
        let result = new SalesMovementDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textDate"] = this.textDate;
        data["productName"] = this.productName;
        data["serial"] = this.serial;
        data["storeName"] = this.storeName;
        data["cashierName"] = this.cashierName;
        data["customerName"] = this.customerName;
        data["quantity"] = this.quantity;
        return data; 
    }
}

export interface ISalesMovementDetailDto {
    textDate: string;
    productName: string;
    serial: string;
    storeName: string;
    cashierName: string;
    customerName: string;
    quantity: number;
}

export class SupervisorShiftReportInput implements ISupervisorShiftReportInput {
    fromStartedOn: moment.Moment;
    toStartedOn: moment.Moment;
    fromEndedOn: moment.Moment;
    toEndedOn: moment.Moment;
    supervisorIds: number[];
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: ISupervisorShiftReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromStartedOn = data["fromStartedOn"] ? moment(data["fromStartedOn"].toString()) : <any>undefined;
            this.toStartedOn = data["toStartedOn"] ? moment(data["toStartedOn"].toString()) : <any>undefined;
            this.fromEndedOn = data["fromEndedOn"] ? moment(data["fromEndedOn"].toString()) : <any>undefined;
            this.toEndedOn = data["toEndedOn"] ? moment(data["toEndedOn"].toString()) : <any>undefined;
            if (data["supervisorIds"] && data["supervisorIds"].constructor === Array) {
                this.supervisorIds = [];
                for (let item of data["supervisorIds"])
                    this.supervisorIds.push(item);
            }
            this.documentType = data["documentType"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): SupervisorShiftReportInput {
        let result = new SupervisorShiftReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromStartedOn"] = this.fromStartedOn ? this.fromStartedOn.toISOString() : <any>undefined;
        data["toStartedOn"] = this.toStartedOn ? this.toStartedOn.toISOString() : <any>undefined;
        data["fromEndedOn"] = this.fromEndedOn ? this.fromEndedOn.toISOString() : <any>undefined;
        data["toEndedOn"] = this.toEndedOn ? this.toEndedOn.toISOString() : <any>undefined;
        if (this.supervisorIds && this.supervisorIds.constructor === Array) {
            data["supervisorIds"] = [];
            for (let item of this.supervisorIds)
                data["supervisorIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ISupervisorShiftReportInput {
    fromStartedOn: moment.Moment;
    toStartedOn: moment.Moment;
    fromEndedOn: moment.Moment;
    toEndedOn: moment.Moment;
    supervisorIds: number[];
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
}

export class SupervisorShiftReport implements ISupervisorShiftReport {
    details: SupervisorShiftDetailsDto[];
    currentPage: number;
    pageCount: number;
    summationValue: number;
    summationActual: number;

    constructor(data?: ISupervisorShiftReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SupervisorShiftDetailsDto.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.pageCount = data["pageCount"];
            this.summationValue = data["summationValue"];
            this.summationActual = data["summationActual"];
        }
    }

    static fromJS(data: any): SupervisorShiftReport {
        let result = new SupervisorShiftReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["summationValue"] = this.summationValue;
        data["summationActual"] = this.summationActual;
        return data; 
    }
}

export interface ISupervisorShiftReport {
    details: SupervisorShiftDetailsDto[];
    currentPage: number;
    pageCount: number;
    summationValue: number;
    summationActual: number;
}

export class SupervisorShiftDetailsDto implements ISupervisorShiftDetailsDto {
    supervisorShiftId: number;
    storeNameText: string;
    status: SupervisorShiftDetailsDtoStatus;
    startedBy: string;
    startedById: number;
    startedOnText: string;
    startedOn: moment.Moment;
    endedBy: string;
    endedById: number;
    endedOn: moment.Moment;
    endedOnText: string;
    totalTransactionsValueText: number;
    actualTransactionsValueText: number;
    supervisorBalance: number;
    storeId: number;
    regionId: number;
    areaId: number;
    creationTime: moment.Moment;

    constructor(data?: ISupervisorShiftDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supervisorShiftId = data["supervisorShiftId"];
            this.storeNameText = data["storeNameText"];
            this.status = data["status"];
            this.startedBy = data["startedBy"];
            this.startedById = data["startedById"];
            this.startedOnText = data["startedOnText"];
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedBy = data["endedBy"];
            this.endedById = data["endedById"];
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.endedOnText = data["endedOnText"];
            this.totalTransactionsValueText = data["totalTransactionsValueText"];
            this.actualTransactionsValueText = data["actualTransactionsValueText"];
            this.supervisorBalance = data["supervisorBalance"];
            this.storeId = data["storeId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SupervisorShiftDetailsDto {
        let result = new SupervisorShiftDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supervisorShiftId"] = this.supervisorShiftId;
        data["storeNameText"] = this.storeNameText;
        data["status"] = this.status;
        data["startedBy"] = this.startedBy;
        data["startedById"] = this.startedById;
        data["startedOnText"] = this.startedOnText;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedBy"] = this.endedBy;
        data["endedById"] = this.endedById;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["endedOnText"] = this.endedOnText;
        data["totalTransactionsValueText"] = this.totalTransactionsValueText;
        data["actualTransactionsValueText"] = this.actualTransactionsValueText;
        data["supervisorBalance"] = this.supervisorBalance;
        data["storeId"] = this.storeId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISupervisorShiftDetailsDto {
    supervisorShiftId: number;
    storeNameText: string;
    status: SupervisorShiftDetailsDtoStatus;
    startedBy: string;
    startedById: number;
    startedOnText: string;
    startedOn: moment.Moment;
    endedBy: string;
    endedById: number;
    endedOn: moment.Moment;
    endedOnText: string;
    totalTransactionsValueText: number;
    actualTransactionsValueText: number;
    supervisorBalance: number;
    storeId: number;
    regionId: number;
    areaId: number;
    creationTime: moment.Moment;
}

export class CashierShiftReportInput implements ICashierShiftReportInput {
    supervisorShiftId: number;
    fromStartedOn: moment.Moment;
    toStartedOn: moment.Moment;
    fromEndedOn: moment.Moment;
    toEndedOn: moment.Moment;
    cashierIds: number[];
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: ICashierShiftReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supervisorShiftId = data["supervisorShiftId"];
            this.fromStartedOn = data["fromStartedOn"] ? moment(data["fromStartedOn"].toString()) : <any>undefined;
            this.toStartedOn = data["toStartedOn"] ? moment(data["toStartedOn"].toString()) : <any>undefined;
            this.fromEndedOn = data["fromEndedOn"] ? moment(data["fromEndedOn"].toString()) : <any>undefined;
            this.toEndedOn = data["toEndedOn"] ? moment(data["toEndedOn"].toString()) : <any>undefined;
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): CashierShiftReportInput {
        let result = new CashierShiftReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supervisorShiftId"] = this.supervisorShiftId;
        data["fromStartedOn"] = this.fromStartedOn ? this.fromStartedOn.toISOString() : <any>undefined;
        data["toStartedOn"] = this.toStartedOn ? this.toStartedOn.toISOString() : <any>undefined;
        data["fromEndedOn"] = this.fromEndedOn ? this.fromEndedOn.toISOString() : <any>undefined;
        data["toEndedOn"] = this.toEndedOn ? this.toEndedOn.toISOString() : <any>undefined;
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ICashierShiftReportInput {
    supervisorShiftId: number;
    fromStartedOn: moment.Moment;
    toStartedOn: moment.Moment;
    fromEndedOn: moment.Moment;
    toEndedOn: moment.Moment;
    cashierIds: number[];
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
}

export class CashierShiftReport implements ICashierShiftReport {
    details: CashierShiftDetailDto[];
    currentPage: number;
    pageCount: number;
    summationValue: number;
    summationActual: number;
    summationCashier: number;

    constructor(data?: ICashierShiftReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(CashierShiftDetailDto.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.pageCount = data["pageCount"];
            this.summationValue = data["summationValue"];
            this.summationActual = data["summationActual"];
            this.summationCashier = data["summationCashier"];
        }
    }

    static fromJS(data: any): CashierShiftReport {
        let result = new CashierShiftReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageCount"] = this.pageCount;
        data["summationValue"] = this.summationValue;
        data["summationActual"] = this.summationActual;
        data["summationCashier"] = this.summationCashier;
        return data; 
    }
}

export interface ICashierShiftReport {
    details: CashierShiftDetailDto[];
    currentPage: number;
    pageCount: number;
    summationValue: number;
    summationActual: number;
    summationCashier: number;
}

export class CashierShiftDetailDto implements ICashierShiftDetailDto {
    supervisorShiftId: number;
    storeNameText: string;
    status: CashierShiftDetailDtoStatus;
    startedBy: string;
    startedById: number;
    startedOnText: string;
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    endedBy: string;
    endedById: number;
    endedOnText: string;
    creationTime: moment.Moment;
    cashierShiftId: number;
    storeId: number;
    regionId: number;
    areaId: number;
    totalTransactionsValueText: number;
    actualTransactionsValueText: number;
    cashierTransactionsValueText: number;
    cashierBalance: number;

    constructor(data?: ICashierShiftDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supervisorShiftId = data["supervisorShiftId"];
            this.storeNameText = data["storeNameText"];
            this.status = data["status"];
            this.startedBy = data["startedBy"];
            this.startedById = data["startedById"];
            this.startedOnText = data["startedOnText"];
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.endedBy = data["endedBy"];
            this.endedById = data["endedById"];
            this.endedOnText = data["endedOnText"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.cashierShiftId = data["cashierShiftId"];
            this.storeId = data["storeId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.totalTransactionsValueText = data["totalTransactionsValueText"];
            this.actualTransactionsValueText = data["actualTransactionsValueText"];
            this.cashierTransactionsValueText = data["cashierTransactionsValueText"];
            this.cashierBalance = data["cashierBalance"];
        }
    }

    static fromJS(data: any): CashierShiftDetailDto {
        let result = new CashierShiftDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supervisorShiftId"] = this.supervisorShiftId;
        data["storeNameText"] = this.storeNameText;
        data["status"] = this.status;
        data["startedBy"] = this.startedBy;
        data["startedById"] = this.startedById;
        data["startedOnText"] = this.startedOnText;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["endedBy"] = this.endedBy;
        data["endedById"] = this.endedById;
        data["endedOnText"] = this.endedOnText;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["cashierShiftId"] = this.cashierShiftId;
        data["storeId"] = this.storeId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["totalTransactionsValueText"] = this.totalTransactionsValueText;
        data["actualTransactionsValueText"] = this.actualTransactionsValueText;
        data["cashierTransactionsValueText"] = this.cashierTransactionsValueText;
        data["cashierBalance"] = this.cashierBalance;
        return data; 
    }
}

export interface ICashierShiftDetailDto {
    supervisorShiftId: number;
    storeNameText: string;
    status: CashierShiftDetailDtoStatus;
    startedBy: string;
    startedById: number;
    startedOnText: string;
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    endedBy: string;
    endedById: number;
    endedOnText: string;
    creationTime: moment.Moment;
    cashierShiftId: number;
    storeId: number;
    regionId: number;
    areaId: number;
    totalTransactionsValueText: number;
    actualTransactionsValueText: number;
    cashierTransactionsValueText: number;
    cashierBalance: number;
}

export class RawMaterialsBelowReorderReportInput implements IRawMaterialsBelowReorderReportInput {
    date: moment.Moment;
    tenantId: number;
    storeId: number;

    constructor(data?: IRawMaterialsBelowReorderReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): RawMaterialsBelowReorderReportInput {
        let result = new RawMaterialsBelowReorderReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IRawMaterialsBelowReorderReportInput {
    date: moment.Moment;
    tenantId: number;
    storeId: number;
}

export class RawMaterialBelowReorderDto implements IRawMaterialBelowReorderDto {
    id: number;
    barCode: string;
    tenantId: number;
    reOrderQuantity: number;
    totalQty: number;

    constructor(data?: IRawMaterialBelowReorderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.barCode = data["barCode"];
            this.tenantId = data["tenantId"];
            this.reOrderQuantity = data["reOrderQuantity"];
            this.totalQty = data["totalQty"];
        }
    }

    static fromJS(data: any): RawMaterialBelowReorderDto {
        let result = new RawMaterialBelowReorderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["barCode"] = this.barCode;
        data["tenantId"] = this.tenantId;
        data["reOrderQuantity"] = this.reOrderQuantity;
        data["totalQty"] = this.totalQty;
        return data; 
    }
}

export interface IRawMaterialBelowReorderDto {
    id: number;
    barCode: string;
    tenantId: number;
    reOrderQuantity: number;
    totalQty: number;
}

export class KdsDeviceHealthReportRequest implements IKdsDeviceHealthReportRequest {
    tenantId: number;
    storeIds: string;
    regionId: number;
    areaId: number;
    clusterId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    langId: number;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IKdsDeviceHealthReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeIds = data["storeIds"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.clusterId = data["clusterId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.langId = data["langId"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): KdsDeviceHealthReportRequest {
        let result = new KdsDeviceHealthReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeIds"] = this.storeIds;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["clusterId"] = this.clusterId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["langId"] = this.langId;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IKdsDeviceHealthReportRequest {
    tenantId: number;
    storeIds: string;
    regionId: number;
    areaId: number;
    clusterId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    langId: number;
    documentType: number;
    isCSVFile: boolean;
}

export class KdsDeviceHealthReport implements IKdsDeviceHealthReport {
    summary: KdsSummaryKpis;
    devices: KdsDeviceHealth[];

    constructor(data?: IKdsDeviceHealthReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.summary = data["summary"] ? KdsSummaryKpis.fromJS(data["summary"]) : <any>undefined;
            if (data["devices"] && data["devices"].constructor === Array) {
                this.devices = [];
                for (let item of data["devices"])
                    this.devices.push(KdsDeviceHealth.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KdsDeviceHealthReport {
        let result = new KdsDeviceHealthReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (this.devices && this.devices.constructor === Array) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IKdsDeviceHealthReport {
    summary: KdsSummaryKpis;
    devices: KdsDeviceHealth[];
}

export class KdsSummaryKpis implements IKdsSummaryKpis {
    totalAndroidDevices: number;
    onlineUptimePct: number;
    poEConnectedCount: number;
    offlineIncidents: number;

    constructor(data?: IKdsSummaryKpis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalAndroidDevices = data["totalAndroidDevices"];
            this.onlineUptimePct = data["onlineUptimePct"];
            this.poEConnectedCount = data["poEConnectedCount"];
            this.offlineIncidents = data["offlineIncidents"];
        }
    }

    static fromJS(data: any): KdsSummaryKpis {
        let result = new KdsSummaryKpis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAndroidDevices"] = this.totalAndroidDevices;
        data["onlineUptimePct"] = this.onlineUptimePct;
        data["poEConnectedCount"] = this.poEConnectedCount;
        data["offlineIncidents"] = this.offlineIncidents;
        return data; 
    }
}

export interface IKdsSummaryKpis {
    totalAndroidDevices: number;
    onlineUptimePct: number;
    poEConnectedCount: number;
    offlineIncidents: number;
}

export class KdsDeviceHealth implements IKdsDeviceHealth {
    store: string;
    station: string;
    deviceId: string;
    connection: string;
    appVersion: string;
    lastActive: moment.Moment;
    status: string;

    constructor(data?: IKdsDeviceHealth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.store = data["store"];
            this.station = data["station"];
            this.deviceId = data["deviceId"];
            this.connection = data["connection"];
            this.appVersion = data["appVersion"];
            this.lastActive = data["lastActive"] ? moment(data["lastActive"].toString()) : <any>undefined;
            this.status = data["status"];
        }
    }

    static fromJS(data: any): KdsDeviceHealth {
        let result = new KdsDeviceHealth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["store"] = this.store;
        data["station"] = this.station;
        data["deviceId"] = this.deviceId;
        data["connection"] = this.connection;
        data["appVersion"] = this.appVersion;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IKdsDeviceHealth {
    store: string;
    station: string;
    deviceId: string;
    connection: string;
    appVersion: string;
    lastActive: moment.Moment;
    status: string;
}

export class ProductByTimeReportInput implements IProductByTimeReportInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    timeFrom: string;
    timeTo: string;
    menuItemIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: IProductByTimeReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = data["dateTo"] ? moment(data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            if (data["menuItemIds"] && data["menuItemIds"].constructor === Array) {
                this.menuItemIds = [];
                for (let item of data["menuItemIds"])
                    this.menuItemIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ProductByTimeReportInput {
        let result = new ProductByTimeReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        if (this.menuItemIds && this.menuItemIds.constructor === Array) {
            data["menuItemIds"] = [];
            for (let item of this.menuItemIds)
                data["menuItemIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IProductByTimeReportInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    timeFrom: string;
    timeTo: string;
    menuItemIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class CategoryByTimeReportInput implements ICategoryByTimeReportInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    timeFrom: string;
    timeTo: string;
    categoryIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: ICategoryByTimeReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = data["dateTo"] ? moment(data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): CategoryByTimeReportInput {
        let result = new CategoryByTimeReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ICategoryByTimeReportInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    dateFrom: moment.Moment;
    dateTo: moment.Moment;
    timeFrom: string;
    timeTo: string;
    categoryIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class CategoryByTimeReport implements ICategoryByTimeReport {
    pageCount: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    totalDiscount: number;
    currentPage: number;
    checkDiscount: boolean;
    discountValue: number;
    items: CategorySalesDetailsByTime[];

    constructor(data?: ICategoryByTimeReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationTotalSell = data["summationTotalSell"];
            this.currency = data["currency"];
            this.summationTotalVAT = data["summationTotalVAT"];
            this.summationTotalSellIncludeVAT = data["summationTotalSellIncludeVAT"];
            this.summationTotalCount = data["summationTotalCount"];
            this.totalDiscount = data["totalDiscount"];
            this.currentPage = data["currentPage"];
            this.checkDiscount = data["checkDiscount"];
            this.discountValue = data["discountValue"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CategorySalesDetailsByTime.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryByTimeReport {
        let result = new CategoryByTimeReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationTotalSell"] = this.summationTotalSell;
        data["currency"] = this.currency;
        data["summationTotalVAT"] = this.summationTotalVAT;
        data["summationTotalSellIncludeVAT"] = this.summationTotalSellIncludeVAT;
        data["summationTotalCount"] = this.summationTotalCount;
        data["totalDiscount"] = this.totalDiscount;
        data["currentPage"] = this.currentPage;
        data["checkDiscount"] = this.checkDiscount;
        data["discountValue"] = this.discountValue;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICategoryByTimeReport {
    pageCount: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    totalDiscount: number;
    currentPage: number;
    checkDiscount: boolean;
    discountValue: number;
    items: CategorySalesDetailsByTime[];
}

export class CategorySalesDetailsByTime implements ICategorySalesDetailsByTime {
    categoryName: string;
    categoryCode: string;
    time: string;
    totalCount: number;
    totalSell: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    currency: string;
    storeName: string;
    storeCode: string;

    constructor(data?: ICategorySalesDetailsByTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryName = data["categoryName"];
            this.categoryCode = data["categoryCode"];
            this.time = data["time"];
            this.totalCount = data["totalCount"];
            this.totalSell = data["totalSell"];
            this.totalVAT = data["totalVAT"];
            this.totalSellIncludeVAT = data["totalSellIncludeVAT"];
            this.currency = data["currency"];
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
        }
    }

    static fromJS(data: any): CategorySalesDetailsByTime {
        let result = new CategorySalesDetailsByTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["categoryCode"] = this.categoryCode;
        data["time"] = this.time;
        data["totalCount"] = this.totalCount;
        data["totalSell"] = this.totalSell;
        data["totalVAT"] = this.totalVAT;
        data["totalSellIncludeVAT"] = this.totalSellIncludeVAT;
        data["currency"] = this.currency;
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        return data; 
    }
}

export interface ICategorySalesDetailsByTime {
    categoryName: string;
    categoryCode: string;
    time: string;
    totalCount: number;
    totalSell: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    currency: string;
    storeName: string;
    storeCode: string;
}

export class ProductCategoriesSalesReport implements IProductCategoriesSalesReport {
    details: ProductCategoriesSalesDetails[];
    pageCount: number;
    currentPage: number;
    currency: string;
    summationTotalSell: number;
    summationTotalVAT: number;
    totalDiscount: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    discountValue: number;
    checkDiscount: boolean;

    constructor(data?: IProductCategoriesSalesReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ProductCategoriesSalesDetails.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.currency = data["currency"];
            this.summationTotalSell = data["summationTotalSell"];
            this.summationTotalVAT = data["summationTotalVAT"];
            this.totalDiscount = data["totalDiscount"];
            this.summationTotalSellIncludeVAT = data["summationTotalSellIncludeVAT"];
            this.summationTotalCount = data["summationTotalCount"];
            this.discountValue = data["discountValue"];
            this.checkDiscount = data["checkDiscount"];
        }
    }

    static fromJS(data: any): ProductCategoriesSalesReport {
        let result = new ProductCategoriesSalesReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["currency"] = this.currency;
        data["summationTotalSell"] = this.summationTotalSell;
        data["summationTotalVAT"] = this.summationTotalVAT;
        data["totalDiscount"] = this.totalDiscount;
        data["summationTotalSellIncludeVAT"] = this.summationTotalSellIncludeVAT;
        data["summationTotalCount"] = this.summationTotalCount;
        data["discountValue"] = this.discountValue;
        data["checkDiscount"] = this.checkDiscount;
        return data; 
    }
}

export interface IProductCategoriesSalesReport {
    details: ProductCategoriesSalesDetails[];
    pageCount: number;
    currentPage: number;
    currency: string;
    summationTotalSell: number;
    summationTotalVAT: number;
    totalDiscount: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    discountValue: number;
    checkDiscount: boolean;
}

export class ProductCategoriesSalesDetails implements IProductCategoriesSalesDetails {
    tenantName: string;
    storeId: number;
    storeCode: string;
    storeName: string;
    categoryId: number;
    categoryCode: string;
    categoryName: string;
    totalCount: number;
    totalSales: number;
    totalVAT: number;
    totalSalesIncludeVAT: number;
    totalCost: number;
    currency: string;
    cashierName: string;

    constructor(data?: IProductCategoriesSalesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.storeId = data["storeId"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.categoryId = data["categoryId"];
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
            this.totalCount = data["totalCount"];
            this.totalSales = data["totalSales"];
            this.totalVAT = data["totalVAT"];
            this.totalSalesIncludeVAT = data["totalSalesIncludeVAT"];
            this.totalCost = data["totalCost"];
            this.currency = data["currency"];
            this.cashierName = data["cashierName"];
        }
    }

    static fromJS(data: any): ProductCategoriesSalesDetails {
        let result = new ProductCategoriesSalesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["storeId"] = this.storeId;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["categoryId"] = this.categoryId;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["totalCount"] = this.totalCount;
        data["totalSales"] = this.totalSales;
        data["totalVAT"] = this.totalVAT;
        data["totalSalesIncludeVAT"] = this.totalSalesIncludeVAT;
        data["totalCost"] = this.totalCost;
        data["currency"] = this.currency;
        data["cashierName"] = this.cashierName;
        return data; 
    }
}

export interface IProductCategoriesSalesDetails {
    tenantName: string;
    storeId: number;
    storeCode: string;
    storeName: string;
    categoryId: number;
    categoryCode: string;
    categoryName: string;
    totalCount: number;
    totalSales: number;
    totalVAT: number;
    totalSalesIncludeVAT: number;
    totalCost: number;
    currency: string;
    cashierName: string;
}

export class ProductCategorySalesReportInput implements IProductCategorySalesReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    timeFrom: string;
    timeTo: string;
    saleTypeIds: number[];
    productCategoriesIds: number[];
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;
    includeRefunds: boolean;
    tenantId: number;

    constructor(data?: IProductCategorySalesReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            if (data["productCategoriesIds"] && data["productCategoriesIds"].constructor === Array) {
                this.productCategoriesIds = [];
                for (let item of data["productCategoriesIds"])
                    this.productCategoriesIds.push(item);
            }
            this.documentType = data["documentType"];
            this.showStoreName = data["showStoreName"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
            this.includeRefunds = data["includeRefunds"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): ProductCategorySalesReportInput {
        let result = new ProductCategorySalesReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        if (this.productCategoriesIds && this.productCategoriesIds.constructor === Array) {
            data["productCategoriesIds"] = [];
            for (let item of this.productCategoriesIds)
                data["productCategoriesIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["showStoreName"] = this.showStoreName;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        data["includeRefunds"] = this.includeRefunds;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IProductCategorySalesReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    timeFrom: string;
    timeTo: string;
    saleTypeIds: number[];
    productCategoriesIds: number[];
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;
    includeRefunds: boolean;
    tenantId: number;
}

export class TotalSalesCategoryByCashierReportInput implements ITotalSalesCategoryByCashierReportInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    saleTypeIds: number[];
    productCategoriesIds: number[];
    employeeIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: ITotalSalesCategoryByCashierReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            if (data["productCategoriesIds"] && data["productCategoriesIds"].constructor === Array) {
                this.productCategoriesIds = [];
                for (let item of data["productCategoriesIds"])
                    this.productCategoriesIds.push(item);
            }
            if (data["employeeIds"] && data["employeeIds"].constructor === Array) {
                this.employeeIds = [];
                for (let item of data["employeeIds"])
                    this.employeeIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalSalesCategoryByCashierReportInput {
        let result = new TotalSalesCategoryByCashierReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        if (this.productCategoriesIds && this.productCategoriesIds.constructor === Array) {
            data["productCategoriesIds"] = [];
            for (let item of this.productCategoriesIds)
                data["productCategoriesIds"].push(item);
        }
        if (this.employeeIds && this.employeeIds.constructor === Array) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalSalesCategoryByCashierReportInput {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    saleTypeIds: number[];
    productCategoriesIds: number[];
    employeeIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class TotalSalesCategoryByCashierReport implements ITotalSalesCategoryByCashierReport {
    details: TotalSalesCategoryByCashierDetails[];
    pageCount: number;
    currentPage: number;
    currency: string;
    summationTotalSell: number;
    summationTotalVAT: number;
    totalDiscount: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    discountValue: number;
    checkDiscount: boolean;

    constructor(data?: ITotalSalesCategoryByCashierReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(TotalSalesCategoryByCashierDetails.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.currency = data["currency"];
            this.summationTotalSell = data["summationTotalSell"];
            this.summationTotalVAT = data["summationTotalVAT"];
            this.totalDiscount = data["totalDiscount"];
            this.summationTotalSellIncludeVAT = data["summationTotalSellIncludeVAT"];
            this.summationTotalCount = data["summationTotalCount"];
            this.discountValue = data["discountValue"];
            this.checkDiscount = data["checkDiscount"];
        }
    }

    static fromJS(data: any): TotalSalesCategoryByCashierReport {
        let result = new TotalSalesCategoryByCashierReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["currency"] = this.currency;
        data["summationTotalSell"] = this.summationTotalSell;
        data["summationTotalVAT"] = this.summationTotalVAT;
        data["totalDiscount"] = this.totalDiscount;
        data["summationTotalSellIncludeVAT"] = this.summationTotalSellIncludeVAT;
        data["summationTotalCount"] = this.summationTotalCount;
        data["discountValue"] = this.discountValue;
        data["checkDiscount"] = this.checkDiscount;
        return data; 
    }
}

export interface ITotalSalesCategoryByCashierReport {
    details: TotalSalesCategoryByCashierDetails[];
    pageCount: number;
    currentPage: number;
    currency: string;
    summationTotalSell: number;
    summationTotalVAT: number;
    totalDiscount: number;
    summationTotalSellIncludeVAT: number;
    summationTotalCount: number;
    discountValue: number;
    checkDiscount: boolean;
}

export class TotalSalesCategoryByCashierDetails implements ITotalSalesCategoryByCashierDetails {
    categoryCode: string;
    categoryName: string;
    storeName: string;
    storeCode: string;
    cashierName: string;
    cashierCode: string;
    totalCount: number;
    totalSales: number;
    totalVAT: number;
    totalSalesIncludeVAT: number;
    totalCost: number;
    currency: string;

    constructor(data?: ITotalSalesCategoryByCashierDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
            this.storeName = data["storeName"];
            this.storeCode = data["storeCode"];
            this.cashierName = data["cashierName"];
            this.cashierCode = data["cashierCode"];
            this.totalCount = data["totalCount"];
            this.totalSales = data["totalSales"];
            this.totalVAT = data["totalVAT"];
            this.totalSalesIncludeVAT = data["totalSalesIncludeVAT"];
            this.totalCost = data["totalCost"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): TotalSalesCategoryByCashierDetails {
        let result = new TotalSalesCategoryByCashierDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        data["cashierName"] = this.cashierName;
        data["cashierCode"] = this.cashierCode;
        data["totalCount"] = this.totalCount;
        data["totalSales"] = this.totalSales;
        data["totalVAT"] = this.totalVAT;
        data["totalSalesIncludeVAT"] = this.totalSalesIncludeVAT;
        data["totalCost"] = this.totalCost;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface ITotalSalesCategoryByCashierDetails {
    categoryCode: string;
    categoryName: string;
    storeName: string;
    storeCode: string;
    cashierName: string;
    cashierCode: string;
    totalCount: number;
    totalSales: number;
    totalVAT: number;
    totalSalesIncludeVAT: number;
    totalCost: number;
    currency: string;
}

export class ProductBasicReport implements IProductBasicReport {
    details: ProductBasicDetails[];
    pageCount: number;
    currentPage: number;
    summationTotalSell: number;
    summationTotalVAT: number;
    summationTotalCount: number;
    summationTotalSellIncludeVAT: number;
    totalDiscount: number;
    discountValue: number;
    checkDiscount: boolean;
    currency: string;
    isRetailEdition: boolean;

    constructor(data?: IProductBasicReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ProductBasicDetails.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationTotalSell = data["summationTotalSell"];
            this.summationTotalVAT = data["summationTotalVAT"];
            this.summationTotalCount = data["summationTotalCount"];
            this.summationTotalSellIncludeVAT = data["summationTotalSellIncludeVAT"];
            this.totalDiscount = data["totalDiscount"];
            this.discountValue = data["discountValue"];
            this.checkDiscount = data["checkDiscount"];
            this.currency = data["currency"];
            this.isRetailEdition = data["isRetailEdition"];
        }
    }

    static fromJS(data: any): ProductBasicReport {
        let result = new ProductBasicReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationTotalSell"] = this.summationTotalSell;
        data["summationTotalVAT"] = this.summationTotalVAT;
        data["summationTotalCount"] = this.summationTotalCount;
        data["summationTotalSellIncludeVAT"] = this.summationTotalSellIncludeVAT;
        data["totalDiscount"] = this.totalDiscount;
        data["discountValue"] = this.discountValue;
        data["checkDiscount"] = this.checkDiscount;
        data["currency"] = this.currency;
        data["isRetailEdition"] = this.isRetailEdition;
        return data; 
    }
}

export interface IProductBasicReport {
    details: ProductBasicDetails[];
    pageCount: number;
    currentPage: number;
    summationTotalSell: number;
    summationTotalVAT: number;
    summationTotalCount: number;
    summationTotalSellIncludeVAT: number;
    totalDiscount: number;
    discountValue: number;
    checkDiscount: boolean;
    currency: string;
    isRetailEdition: boolean;
}

export class ProductBasicDetails implements IProductBasicDetails {
    productCode: string;
    productName: string;
    referenceNumber: string;
    totalCount: number;
    uomSold: string;
    uomBase: string;
    totalCost: number;
    totalSell: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    quantityBase: number;
    currency: string;

    constructor(data?: IProductBasicDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.referenceNumber = data["referenceNumber"];
            this.totalCount = data["totalCount"];
            this.uomSold = data["uomSold"];
            this.uomBase = data["uomBase"];
            this.totalCost = data["totalCost"];
            this.totalSell = data["totalSell"];
            this.totalVAT = data["totalVAT"];
            this.totalSellIncludeVAT = data["totalSellIncludeVAT"];
            this.quantityBase = data["quantityBase"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): ProductBasicDetails {
        let result = new ProductBasicDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["referenceNumber"] = this.referenceNumber;
        data["totalCount"] = this.totalCount;
        data["uomSold"] = this.uomSold;
        data["uomBase"] = this.uomBase;
        data["totalCost"] = this.totalCost;
        data["totalSell"] = this.totalSell;
        data["totalVAT"] = this.totalVAT;
        data["totalSellIncludeVAT"] = this.totalSellIncludeVAT;
        data["quantityBase"] = this.quantityBase;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IProductBasicDetails {
    productCode: string;
    productName: string;
    referenceNumber: string;
    totalCount: number;
    uomSold: string;
    uomBase: string;
    totalCost: number;
    totalSell: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    quantityBase: number;
    currency: string;
}

export class PurchaseDetailReportInput implements IPurchaseDetailReportInput {
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    customerIds: number[];
    storeIds: number[];
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IPurchaseDetailReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.referenceNumber = data["referenceNumber"];
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [];
                for (let item of data["customerIds"])
                    this.customerIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PurchaseDetailReportInput {
        let result = new PurchaseDetailReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPurchaseDetailReportInput {
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    customerIds: number[];
    storeIds: number[];
    documentType: number;
    isCSVFile: boolean;
}

export class PurchaseDetailReportDto implements IPurchaseDetailReportDto {
    purchaseDate: string;
    vendor: string;
    invoiceNumber: string;
    barCode: string;
    productName: string;
    lotNumber: string;
    expirationDate: string;
    unitOfMeasureName: string;
    quantity: string;
    unitPurchasePrice: string;
    totalCost: string;
    discount: string;
    netCost: string;
    vat: string;
    total: string;

    constructor(data?: IPurchaseDetailReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.purchaseDate = data["purchaseDate"];
            this.vendor = data["vendor"];
            this.invoiceNumber = data["invoiceNumber"];
            this.barCode = data["barCode"];
            this.productName = data["productName"];
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.quantity = data["quantity"];
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.totalCost = data["totalCost"];
            this.discount = data["discount"];
            this.netCost = data["netCost"];
            this.vat = data["vat"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PurchaseDetailReportDto {
        let result = new PurchaseDetailReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseDate"] = this.purchaseDate;
        data["vendor"] = this.vendor;
        data["invoiceNumber"] = this.invoiceNumber;
        data["barCode"] = this.barCode;
        data["productName"] = this.productName;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["quantity"] = this.quantity;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["totalCost"] = this.totalCost;
        data["discount"] = this.discount;
        data["netCost"] = this.netCost;
        data["vat"] = this.vat;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPurchaseDetailReportDto {
    purchaseDate: string;
    vendor: string;
    invoiceNumber: string;
    barCode: string;
    productName: string;
    lotNumber: string;
    expirationDate: string;
    unitOfMeasureName: string;
    quantity: string;
    unitPurchasePrice: string;
    totalCost: string;
    discount: string;
    netCost: string;
    vat: string;
    total: string;
}

export class TotalSaleVendorReportInput implements ITotalSaleVendorReportInput {
    referenceNumber: string;
    code: string;
    from: moment.Moment;
    to: moment.Moment;
    vendorIds: number[];
    employees: number[];
    storeIds: number[];
    documentType: number;
    endOfDayBusiness: boolean;
    isCSVFile: boolean;

    constructor(data?: ITotalSaleVendorReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referenceNumber = data["referenceNumber"];
            this.code = data["code"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["vendorIds"] && data["vendorIds"].constructor === Array) {
                this.vendorIds = [];
                for (let item of data["vendorIds"])
                    this.vendorIds.push(item);
            }
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.documentType = data["documentType"];
            this.endOfDayBusiness = data["endOfDayBusiness"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalSaleVendorReportInput {
        let result = new TotalSaleVendorReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNumber"] = this.referenceNumber;
        data["code"] = this.code;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.vendorIds && this.vendorIds.constructor === Array) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["endOfDayBusiness"] = this.endOfDayBusiness;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalSaleVendorReportInput {
    referenceNumber: string;
    code: string;
    from: moment.Moment;
    to: moment.Moment;
    vendorIds: number[];
    employees: number[];
    storeIds: number[];
    documentType: number;
    endOfDayBusiness: boolean;
    isCSVFile: boolean;
}

export class TotalSalesOfSupplierReport implements ITotalSalesOfSupplierReport {
    details: TotalSalesOfSupplierDetails[];
    pageCount: number;
    currentPage: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    discountValue: number;
    checkDiscount: boolean;

    constructor(data?: ITotalSalesOfSupplierReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(TotalSalesOfSupplierDetails.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationTotalSell = data["summationTotalSell"];
            this.currency = data["currency"];
            this.summationTotalVAT = data["summationTotalVAT"];
            this.summationTotalSellIncludeVAT = data["summationTotalSellIncludeVAT"];
            this.discountValue = data["discountValue"];
            this.checkDiscount = data["checkDiscount"];
        }
    }

    static fromJS(data: any): TotalSalesOfSupplierReport {
        let result = new TotalSalesOfSupplierReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationTotalSell"] = this.summationTotalSell;
        data["currency"] = this.currency;
        data["summationTotalVAT"] = this.summationTotalVAT;
        data["summationTotalSellIncludeVAT"] = this.summationTotalSellIncludeVAT;
        data["discountValue"] = this.discountValue;
        data["checkDiscount"] = this.checkDiscount;
        return data; 
    }
}

export interface ITotalSalesOfSupplierReport {
    details: TotalSalesOfSupplierDetails[];
    pageCount: number;
    currentPage: number;
    summationTotalSell: number;
    currency: string;
    summationTotalVAT: number;
    summationTotalSellIncludeVAT: number;
    discountValue: number;
    checkDiscount: boolean;
}

export class TotalSalesOfSupplierDetails implements ITotalSalesOfSupplierDetails {
    vendorCode: string;
    vendorName: string;
    totalSell: number;
    vat: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    currency: string;

    constructor(data?: ITotalSalesOfSupplierDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorCode = data["vendorCode"];
            this.vendorName = data["vendorName"];
            this.totalSell = data["totalSell"];
            this.vat = data["vat"];
            this.totalVAT = data["totalVAT"];
            this.totalSellIncludeVAT = data["totalSellIncludeVAT"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): TotalSalesOfSupplierDetails {
        let result = new TotalSalesOfSupplierDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorCode"] = this.vendorCode;
        data["vendorName"] = this.vendorName;
        data["totalSell"] = this.totalSell;
        data["vat"] = this.vat;
        data["totalVAT"] = this.totalVAT;
        data["totalSellIncludeVAT"] = this.totalSellIncludeVAT;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface ITotalSalesOfSupplierDetails {
    vendorCode: string;
    vendorName: string;
    totalSell: number;
    vat: number;
    totalVAT: number;
    totalSellIncludeVAT: number;
    currency: string;
}

export class OfferDetailReportInput implements IOfferDetailReportInput {
    from: moment.Moment;
    to: moment.Moment;
    offerType: OfferDetailReportInputOfferType;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IOfferDetailReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.offerType = data["offerType"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): OfferDetailReportInput {
        let result = new OfferDetailReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["offerType"] = this.offerType;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IOfferDetailReportInput {
    from: moment.Moment;
    to: moment.Moment;
    offerType: OfferDetailReportInputOfferType;
    documentType: number;
    isCSVFile: boolean;
}

export class TotalPurchaseVendorReportInput implements ITotalPurchaseVendorReportInput {
    from: moment.Moment;
    to: moment.Moment;
    vendorIds: number[];
    storeId: number[];
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: ITotalPurchaseVendorReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["vendorIds"] && data["vendorIds"].constructor === Array) {
                this.vendorIds = [];
                for (let item of data["vendorIds"])
                    this.vendorIds.push(item);
            }
            if (data["storeId"] && data["storeId"].constructor === Array) {
                this.storeId = [];
                for (let item of data["storeId"])
                    this.storeId.push(item);
            }
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalPurchaseVendorReportInput {
        let result = new TotalPurchaseVendorReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.vendorIds && this.vendorIds.constructor === Array) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (this.storeId && this.storeId.constructor === Array) {
            data["storeId"] = [];
            for (let item of this.storeId)
                data["storeId"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalPurchaseVendorReportInput {
    from: moment.Moment;
    to: moment.Moment;
    vendorIds: number[];
    storeId: number[];
    documentType: number;
    isCSVFile: boolean;
}

export class TotalPurchaseOfSupplierReport implements ITotalPurchaseOfSupplierReport {
    details: TotalPurchaseOfSupplierDetails[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;

    constructor(data?: ITotalPurchaseOfSupplierReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(TotalPurchaseOfSupplierDetails.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): TotalPurchaseOfSupplierReport {
        let result = new TotalPurchaseOfSupplierReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface ITotalPurchaseOfSupplierReport {
    details: TotalPurchaseOfSupplierDetails[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;
}

export class TotalPurchaseOfSupplierDetails implements ITotalPurchaseOfSupplierDetails {
    vendorCode: string;
    vendorName: string;
    totalCost: number;
    currency: string;

    constructor(data?: ITotalPurchaseOfSupplierDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorCode = data["vendorCode"];
            this.vendorName = data["vendorName"];
            this.totalCost = data["totalCost"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): TotalPurchaseOfSupplierDetails {
        let result = new TotalPurchaseOfSupplierDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorCode"] = this.vendorCode;
        data["vendorName"] = this.vendorName;
        data["totalCost"] = this.totalCost;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface ITotalPurchaseOfSupplierDetails {
    vendorCode: string;
    vendorName: string;
    totalCost: number;
    currency: string;
}

export class TotalPurchaseByVendorReportFABInput implements ITotalPurchaseByVendorReportFABInput {
    transactionTypeId: number;
    entityFromId: number;
    entityToId: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: ITotalPurchaseByVendorReportFABInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeId = data["transactionTypeId"];
            this.entityFromId = data["entityFromId"];
            this.entityToId = data["entityToId"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalPurchaseByVendorReportFABInput {
        let result = new TotalPurchaseByVendorReportFABInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["entityFromId"] = this.entityFromId;
        data["entityToId"] = this.entityToId;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalPurchaseByVendorReportFABInput {
    transactionTypeId: number;
    entityFromId: number;
    entityToId: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class RecipeReportDto implements IRecipeReportDto {
    menuItemId: number;
    rawMaterialId: number;
    materialGroupId: number;
    storeIds: number[];
    tenantId: number;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;

    constructor(data?: IRecipeReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.rawMaterialId = data["rawMaterialId"];
            this.materialGroupId = data["materialGroupId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): RecipeReportDto {
        let result = new RecipeReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["materialGroupId"] = this.materialGroupId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IRecipeReportDto {
    menuItemId: number;
    rawMaterialId: number;
    materialGroupId: number;
    storeIds: number[];
    tenantId: number;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
}

export class PagedRecipeListWithTotalReportDto implements IPagedRecipeListWithTotalReportDto {
    currentPage: number;
    itemsCount: number;
    recipes: RecipeListItemWithTotalReportDto[];

    constructor(data?: IPagedRecipeListWithTotalReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["recipes"] && data["recipes"].constructor === Array) {
                this.recipes = [];
                for (let item of data["recipes"])
                    this.recipes.push(RecipeListItemWithTotalReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedRecipeListWithTotalReportDto {
        let result = new PagedRecipeListWithTotalReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.recipes && this.recipes.constructor === Array) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedRecipeListWithTotalReportDto {
    currentPage: number;
    itemsCount: number;
    recipes: RecipeListItemWithTotalReportDto[];
}

export class RecipeListItemWithTotalReportDto implements IRecipeListItemWithTotalReportDto {
    id: number;
    menuItemName: string;
    menuItemCode: string;
    recipeCode: string;
    lossFactor: number;
    total: number;
    storeId: number;
    storeName: string;
    recipeRawMaterials: RecipeRawMaterialReportDto[];

    constructor(data?: IRecipeListItemWithTotalReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemName = data["menuItemName"];
            this.menuItemCode = data["menuItemCode"];
            this.recipeCode = data["recipeCode"];
            this.lossFactor = data["lossFactor"];
            this.total = data["total"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            if (data["recipeRawMaterials"] && data["recipeRawMaterials"].constructor === Array) {
                this.recipeRawMaterials = [];
                for (let item of data["recipeRawMaterials"])
                    this.recipeRawMaterials.push(RecipeRawMaterialReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecipeListItemWithTotalReportDto {
        let result = new RecipeListItemWithTotalReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemName"] = this.menuItemName;
        data["menuItemCode"] = this.menuItemCode;
        data["recipeCode"] = this.recipeCode;
        data["lossFactor"] = this.lossFactor;
        data["total"] = this.total;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        if (this.recipeRawMaterials && this.recipeRawMaterials.constructor === Array) {
            data["recipeRawMaterials"] = [];
            for (let item of this.recipeRawMaterials)
                data["recipeRawMaterials"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRecipeListItemWithTotalReportDto {
    id: number;
    menuItemName: string;
    menuItemCode: string;
    recipeCode: string;
    lossFactor: number;
    total: number;
    storeId: number;
    storeName: string;
    recipeRawMaterials: RecipeRawMaterialReportDto[];
}

export class RecipeRawMaterialReportDto implements IRecipeRawMaterialReportDto {
    rawMaterialId: number;
    rawMaterialCode: string;
    rawMaterialName: string;
    quantity: number;
    unitFactor: number;
    unit: string;
    lossFactor: number;
    sellingPrice: number;
    recipeMaterialTotalCost: number;

    constructor(data?: IRecipeRawMaterialReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterialCode = data["rawMaterialCode"];
            this.rawMaterialName = data["rawMaterialName"];
            this.quantity = data["quantity"];
            this.unitFactor = data["unitFactor"];
            this.unit = data["unit"];
            this.lossFactor = data["lossFactor"];
            this.sellingPrice = data["sellingPrice"];
            this.recipeMaterialTotalCost = data["recipeMaterialTotalCost"];
        }
    }

    static fromJS(data: any): RecipeRawMaterialReportDto {
        let result = new RecipeRawMaterialReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterialCode"] = this.rawMaterialCode;
        data["rawMaterialName"] = this.rawMaterialName;
        data["quantity"] = this.quantity;
        data["unitFactor"] = this.unitFactor;
        data["unit"] = this.unit;
        data["lossFactor"] = this.lossFactor;
        data["sellingPrice"] = this.sellingPrice;
        data["recipeMaterialTotalCost"] = this.recipeMaterialTotalCost;
        return data; 
    }
}

export interface IRecipeRawMaterialReportDto {
    rawMaterialId: number;
    rawMaterialCode: string;
    rawMaterialName: string;
    quantity: number;
    unitFactor: number;
    unit: string;
    lossFactor: number;
    sellingPrice: number;
    recipeMaterialTotalCost: number;
}

export class RawMaterialRecipeReportDto implements IRawMaterialRecipeReportDto {
    storeIds: number[];
    tenantId: number;
    regionId: number;
    areaId: number;
    materRecipeType: RawMaterialRecipeReportDtoMaterRecipeType;
    isCSVFile: boolean;

    constructor(data?: IRawMaterialRecipeReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.materRecipeType = data["materRecipeType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): RawMaterialRecipeReportDto {
        let result = new RawMaterialRecipeReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["materRecipeType"] = this.materRecipeType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IRawMaterialRecipeReportDto {
    storeIds: number[];
    tenantId: number;
    regionId: number;
    areaId: number;
    materRecipeType: RawMaterialRecipeReportDtoMaterRecipeType;
    isCSVFile: boolean;
}

export class PagedRawMaterialRecipeListWithTotalReportDto implements IPagedRawMaterialRecipeListWithTotalReportDto {
    currentPage: number;
    itemsCount: number;
    materials: RawRecipeListItemWithTotalReportDto[];

    constructor(data?: IPagedRawMaterialRecipeListWithTotalReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["materials"] && data["materials"].constructor === Array) {
                this.materials = [];
                for (let item of data["materials"])
                    this.materials.push(RawRecipeListItemWithTotalReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedRawMaterialRecipeListWithTotalReportDto {
        let result = new PagedRawMaterialRecipeListWithTotalReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.materials && this.materials.constructor === Array) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedRawMaterialRecipeListWithTotalReportDto {
    currentPage: number;
    itemsCount: number;
    materials: RawRecipeListItemWithTotalReportDto[];
}

export class RawRecipeListItemWithTotalReportDto implements IRawRecipeListItemWithTotalReportDto {
    id: number;
    materialName: string;
    itemBarcode: string;
    total: number;
    storeId: number;
    storeName: string;
    showDetails: boolean;
    ingrdiants: RecipeRawMaterialDetialReportDto[];

    constructor(data?: IRawRecipeListItemWithTotalReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.materialName = data["materialName"];
            this.itemBarcode = data["itemBarcode"];
            this.total = data["total"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.showDetails = data["showDetails"];
            if (data["ingrdiants"] && data["ingrdiants"].constructor === Array) {
                this.ingrdiants = [];
                for (let item of data["ingrdiants"])
                    this.ingrdiants.push(RecipeRawMaterialDetialReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawRecipeListItemWithTotalReportDto {
        let result = new RawRecipeListItemWithTotalReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialName"] = this.materialName;
        data["itemBarcode"] = this.itemBarcode;
        data["total"] = this.total;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["showDetails"] = this.showDetails;
        if (this.ingrdiants && this.ingrdiants.constructor === Array) {
            data["ingrdiants"] = [];
            for (let item of this.ingrdiants)
                data["ingrdiants"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRawRecipeListItemWithTotalReportDto {
    id: number;
    materialName: string;
    itemBarcode: string;
    total: number;
    storeId: number;
    storeName: string;
    showDetails: boolean;
    ingrdiants: RecipeRawMaterialDetialReportDto[];
}

export class RecipeRawMaterialDetialReportDto implements IRecipeRawMaterialDetialReportDto {
    rawMaterialId: number;
    rawMaterialCode: string;
    rawMaterialName: string;
    quantity: number;
    unitFactor: number;
    unit: string;
    lossFactor: number;
    sellingPrice: number;
    isRecipeOrBatch: boolean;
    recipeMaterialTotalCost: number;

    constructor(data?: IRecipeRawMaterialDetialReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterialCode = data["rawMaterialCode"];
            this.rawMaterialName = data["rawMaterialName"];
            this.quantity = data["quantity"];
            this.unitFactor = data["unitFactor"];
            this.unit = data["unit"];
            this.lossFactor = data["lossFactor"];
            this.sellingPrice = data["sellingPrice"];
            this.isRecipeOrBatch = data["isRecipeOrBatch"];
            this.recipeMaterialTotalCost = data["recipeMaterialTotalCost"];
        }
    }

    static fromJS(data: any): RecipeRawMaterialDetialReportDto {
        let result = new RecipeRawMaterialDetialReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterialCode"] = this.rawMaterialCode;
        data["rawMaterialName"] = this.rawMaterialName;
        data["quantity"] = this.quantity;
        data["unitFactor"] = this.unitFactor;
        data["unit"] = this.unit;
        data["lossFactor"] = this.lossFactor;
        data["sellingPrice"] = this.sellingPrice;
        data["isRecipeOrBatch"] = this.isRecipeOrBatch;
        data["recipeMaterialTotalCost"] = this.recipeMaterialTotalCost;
        return data; 
    }
}

export interface IRecipeRawMaterialDetialReportDto {
    rawMaterialId: number;
    rawMaterialCode: string;
    rawMaterialName: string;
    quantity: number;
    unitFactor: number;
    unit: string;
    lossFactor: number;
    sellingPrice: number;
    isRecipeOrBatch: boolean;
    recipeMaterialTotalCost: number;
}

export class BudgetDeficitReportInput implements IBudgetDeficitReportInput {
    from: moment.Moment;
    to: moment.Moment;
    cashierIds: number[];
    supervisorIds: number[];
    storeIds: number[];
    documentType: number;
    isCashier: boolean;
    isCSVFile: boolean;

    constructor(data?: IBudgetDeficitReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            if (data["supervisorIds"] && data["supervisorIds"].constructor === Array) {
                this.supervisorIds = [];
                for (let item of data["supervisorIds"])
                    this.supervisorIds.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isCashier = data["isCashier"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): BudgetDeficitReportInput {
        let result = new BudgetDeficitReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        if (this.supervisorIds && this.supervisorIds.constructor === Array) {
            data["supervisorIds"] = [];
            for (let item of this.supervisorIds)
                data["supervisorIds"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isCashier"] = this.isCashier;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IBudgetDeficitReportInput {
    from: moment.Moment;
    to: moment.Moment;
    cashierIds: number[];
    supervisorIds: number[];
    storeIds: number[];
    documentType: number;
    isCashier: boolean;
    isCSVFile: boolean;
}

export class BudgetDeficitPageList implements IBudgetDeficitPageList {
    currentPage: number;
    itemsCount: number;
    details: BudgetDeficitReportDto[];

    constructor(data?: IBudgetDeficitPageList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(BudgetDeficitReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetDeficitPageList {
        let result = new BudgetDeficitPageList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBudgetDeficitPageList {
    currentPage: number;
    itemsCount: number;
    details: BudgetDeficitReportDto[];
}

export class BudgetDeficitReportDto implements IBudgetDeficitReportDto {
    cashierName: string;
    supervisorName: string;
    storeName: string;
    estmiteValue: number;
    realValue: number;
    balanceValue: number;

    constructor(data?: IBudgetDeficitReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cashierName = data["cashierName"];
            this.supervisorName = data["supervisorName"];
            this.storeName = data["storeName"];
            this.estmiteValue = data["estmiteValue"];
            this.realValue = data["realValue"];
            this.balanceValue = data["balanceValue"];
        }
    }

    static fromJS(data: any): BudgetDeficitReportDto {
        let result = new BudgetDeficitReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierName"] = this.cashierName;
        data["supervisorName"] = this.supervisorName;
        data["storeName"] = this.storeName;
        data["estmiteValue"] = this.estmiteValue;
        data["realValue"] = this.realValue;
        data["balanceValue"] = this.balanceValue;
        return data; 
    }
}

export interface IBudgetDeficitReportDto {
    cashierName: string;
    supervisorName: string;
    storeName: string;
    estmiteValue: number;
    realValue: number;
    balanceValue: number;
}

export class TupleOfStringAndStringAndInt32 implements ITupleOfStringAndStringAndInt32 {
    item1: string;
    item2: string;
    item3: number;

    constructor(data?: ITupleOfStringAndStringAndInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"];
            this.item3 = data["item3"];
        }
    }

    static fromJS(data: any): TupleOfStringAndStringAndInt32 {
        let result = new TupleOfStringAndStringAndInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        data["item3"] = this.item3;
        return data; 
    }
}

export interface ITupleOfStringAndStringAndInt32 {
    item1: string;
    item2: string;
    item3: number;
}

export class DailySalesReportInputDto implements IDailySalesReportInputDto {
    from: moment.Moment;
    to: moment.Moment;
    storeId: number;
    endOfDayBusiness: boolean;
    pagenumber: number;
    pagesize: number;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IDailySalesReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.storeId = data["storeId"];
            this.endOfDayBusiness = data["endOfDayBusiness"];
            this.pagenumber = data["pagenumber"];
            this.pagesize = data["pagesize"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): DailySalesReportInputDto {
        let result = new DailySalesReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["storeId"] = this.storeId;
        data["endOfDayBusiness"] = this.endOfDayBusiness;
        data["pagenumber"] = this.pagenumber;
        data["pagesize"] = this.pagesize;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IDailySalesReportInputDto {
    from: moment.Moment;
    to: moment.Moment;
    storeId: number;
    endOfDayBusiness: boolean;
    pagenumber: number;
    pagesize: number;
    documentType: number;
    isCSVFile: boolean;
}

export class DailySalesReportOutputDto implements IDailySalesReportOutputDto {
    pageCount: number;
    summationTotal: number;
    summationGrandTotal: number;
    summationInvoiceCount: number;
    currentPage: number;
    details: DailySalesReportDetailsDto[];

    constructor(data?: IDailySalesReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationTotal = data["summationTotal"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationInvoiceCount = data["summationInvoiceCount"];
            this.currentPage = data["currentPage"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(DailySalesReportDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailySalesReportOutputDto {
        let result = new DailySalesReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationTotal"] = this.summationTotal;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationInvoiceCount"] = this.summationInvoiceCount;
        data["currentPage"] = this.currentPage;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDailySalesReportOutputDto {
    pageCount: number;
    summationTotal: number;
    summationGrandTotal: number;
    summationInvoiceCount: number;
    currentPage: number;
    details: DailySalesReportDetailsDto[];
}

export class DailySalesReportDetailsDto implements IDailySalesReportDetailsDto {
    date: moment.Moment;
    invoiceCount: number;
    total: number;
    grandTotal: number;

    constructor(data?: IDailySalesReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.invoiceCount = data["invoiceCount"];
            this.total = data["total"];
            this.grandTotal = data["grandTotal"];
        }
    }

    static fromJS(data: any): DailySalesReportDetailsDto {
        let result = new DailySalesReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["invoiceCount"] = this.invoiceCount;
        data["total"] = this.total;
        data["grandTotal"] = this.grandTotal;
        return data; 
    }
}

export interface IDailySalesReportDetailsDto {
    date: moment.Moment;
    invoiceCount: number;
    total: number;
    grandTotal: number;
}

export class SalesReportWithDetailsDto implements ISalesReportWithDetailsDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsDto[];

    constructor(data?: ISalesReportWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationGrandTotalIncludingVAT = data["summationGrandTotalIncludingVAT"];
            this.summationVAT = data["summationVAT"];
            this.summationDiscount = data["summationDiscount"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.templateType = data["templateType"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SalesReportWithDetailsDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsDto {
        let result = new SalesReportWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationGrandTotalIncludingVAT"] = this.summationGrandTotalIncludingVAT;
        data["summationVAT"] = this.summationVAT;
        data["summationDiscount"] = this.summationDiscount;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["templateType"] = this.templateType;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsDto[];
}

export class SalesReportWithDetailsDetailsDto implements ISalesReportWithDetailsDetailsDto {
    id: string;
    tenantName: string;
    date: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    tenderTypeName: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOut[];
    invoicePayments: InvoicePaymentOut[];

    constructor(data?: ISalesReportWithDetailsDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantName = data["tenantName"];
            this.date = data["date"];
            this.time = data["time"];
            this.saleTypeName = data["saleTypeName"];
            this.orderNumber = data["orderNumber"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.cashierName = data["cashierName"];
            this.total = data["total"];
            this.discountValue = data["discountValue"];
            this.promotionValue = data["promotionValue"];
            this.grandTotal = data["grandTotal"];
            this.vat = data["vat"];
            this.currency = data["currency"];
            this.tenderTypeName = data["tenderTypeName"];
            this.isRefund = data["isRefund"];
            if (data["invoiceLines"] && data["invoiceLines"].constructor === Array) {
                this.invoiceLines = [];
                for (let item of data["invoiceLines"])
                    this.invoiceLines.push(InvoiceLineOut.fromJS(item));
            }
            if (data["invoicePayments"] && data["invoicePayments"].constructor === Array) {
                this.invoicePayments = [];
                for (let item of data["invoicePayments"])
                    this.invoicePayments.push(InvoicePaymentOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsDetailsDto {
        let result = new SalesReportWithDetailsDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["date"] = this.date;
        data["time"] = this.time;
        data["saleTypeName"] = this.saleTypeName;
        data["orderNumber"] = this.orderNumber;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["cashierName"] = this.cashierName;
        data["total"] = this.total;
        data["discountValue"] = this.discountValue;
        data["promotionValue"] = this.promotionValue;
        data["grandTotal"] = this.grandTotal;
        data["vat"] = this.vat;
        data["currency"] = this.currency;
        data["tenderTypeName"] = this.tenderTypeName;
        data["isRefund"] = this.isRefund;
        if (this.invoiceLines && this.invoiceLines.constructor === Array) {
            data["invoiceLines"] = [];
            for (let item of this.invoiceLines)
                data["invoiceLines"].push(item.toJSON());
        }
        if (this.invoicePayments && this.invoicePayments.constructor === Array) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsDetailsDto {
    id: string;
    tenantName: string;
    date: string;
    time: string;
    saleTypeName: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    tenderTypeName: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOut[];
    invoicePayments: InvoicePaymentOut[];
}

export class InvoiceLineOut implements IInvoiceLineOut {
    invoiceId: string;
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    menuItemId: number;
    menuItemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;
    comboItems: SaleTransactionDetailsComboMealsItemSDto[];
    variants: SaleTransactionDetailVarientDto[];
    promotionItems: SaleTransactionsDetialsPromotionItemDto[];

    constructor(data?: IInvoiceLineOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceId = data["invoiceId"];
            this.isRefund = data["isRefund"];
            this.lineId = data["lineId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionValue = data["promotionValue"];
            this.discount = data["discount"];
            this.notes = data["notes"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.menuItemId = data["menuItemId"];
            this.menuItemName = data["menuItemName"];
            this.itemCode = data["itemCode"];
            this.productCategoryId = data["productCategoryId"];
            this.productCategoryName = data["productCategoryName"];
            this.taxType = data["taxType"];
            if (data["comboItems"] && data["comboItems"].constructor === Array) {
                this.comboItems = [];
                for (let item of data["comboItems"])
                    this.comboItems.push(SaleTransactionDetailsComboMealsItemSDto.fromJS(item));
            }
            if (data["variants"] && data["variants"].constructor === Array) {
                this.variants = [];
                for (let item of data["variants"])
                    this.variants.push(SaleTransactionDetailVarientDto.fromJS(item));
            }
            if (data["promotionItems"] && data["promotionItems"].constructor === Array) {
                this.promotionItems = [];
                for (let item of data["promotionItems"])
                    this.promotionItems.push(SaleTransactionsDetialsPromotionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceLineOut {
        let result = new InvoiceLineOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["isRefund"] = this.isRefund;
        data["lineId"] = this.lineId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionValue"] = this.promotionValue;
        data["discount"] = this.discount;
        data["notes"] = this.notes;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["menuItemId"] = this.menuItemId;
        data["menuItemName"] = this.menuItemName;
        data["itemCode"] = this.itemCode;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        data["taxType"] = this.taxType;
        if (this.comboItems && this.comboItems.constructor === Array) {
            data["comboItems"] = [];
            for (let item of this.comboItems)
                data["comboItems"].push(item.toJSON());
        }
        if (this.variants && this.variants.constructor === Array) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        if (this.promotionItems && this.promotionItems.constructor === Array) {
            data["promotionItems"] = [];
            for (let item of this.promotionItems)
                data["promotionItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInvoiceLineOut {
    invoiceId: string;
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    menuItemId: number;
    menuItemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;
    comboItems: SaleTransactionDetailsComboMealsItemSDto[];
    variants: SaleTransactionDetailVarientDto[];
    promotionItems: SaleTransactionsDetialsPromotionItemDto[];
}

export class InvoicePaymentOut implements IInvoicePaymentOut {
    invoiceId: string;
    isRefund: boolean;
    paymentId: string;
    tenderTypeName: string;
    value: number;

    constructor(data?: IInvoicePaymentOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceId = data["invoiceId"];
            this.isRefund = data["isRefund"];
            this.paymentId = data["paymentId"];
            this.tenderTypeName = data["tenderTypeName"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): InvoicePaymentOut {
        let result = new InvoicePaymentOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["isRefund"] = this.isRefund;
        data["paymentId"] = this.paymentId;
        data["tenderTypeName"] = this.tenderTypeName;
        data["value"] = this.value;
        return data; 
    }
}

export interface IInvoicePaymentOut {
    invoiceId: string;
    isRefund: boolean;
    paymentId: string;
    tenderTypeName: string;
    value: number;
}

export class SaleTransactionDetailsComboMealsItemSDto implements ISaleTransactionDetailsComboMealsItemSDto {
    id: string;
    menuItemId: number;
    quantity: number;
    lineId: string;
    price: number;
    tenantId: number;

    constructor(data?: ISaleTransactionDetailsComboMealsItemSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.lineId = data["lineId"];
            this.price = data["price"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): SaleTransactionDetailsComboMealsItemSDto {
        let result = new SaleTransactionDetailsComboMealsItemSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["lineId"] = this.lineId;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ISaleTransactionDetailsComboMealsItemSDto {
    id: string;
    menuItemId: number;
    quantity: number;
    lineId: string;
    price: number;
    tenantId: number;
}

export class SaleTransactionDetailVarientDto implements ISaleTransactionDetailVarientDto {
    tenantId: number;
    lineId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;

    constructor(data?: ISaleTransactionDetailVarientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.lineId = data["lineId"];
            this.variantId = data["variantId"];
            this.variantValueId = data["variantValueId"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.quantity = data["quantity"];
            this.freeQty = data["freeQty"];
        }
    }

    static fromJS(data: any): SaleTransactionDetailVarientDto {
        let result = new SaleTransactionDetailVarientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["lineId"] = this.lineId;
        data["variantId"] = this.variantId;
        data["variantValueId"] = this.variantValueId;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["quantity"] = this.quantity;
        data["freeQty"] = this.freeQty;
        return data; 
    }
}

export interface ISaleTransactionDetailVarientDto {
    tenantId: number;
    lineId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
}

export class SaleTransactionsDetialsPromotionItemDto implements ISaleTransactionsDetialsPromotionItemDto {
    id: string;
    lineId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;

    constructor(data?: ISaleTransactionsDetialsPromotionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.lineId = data["lineId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludeVat = data["priceIncludeVat"];
        }
    }

    static fromJS(data: any): SaleTransactionsDetialsPromotionItemDto {
        let result = new SaleTransactionsDetialsPromotionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineId"] = this.lineId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludeVat"] = this.priceIncludeVat;
        return data; 
    }
}

export interface ISaleTransactionsDetialsPromotionItemDto {
    id: string;
    lineId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
}

export class SalesReportWithDetailsRetailDto implements ISalesReportWithDetailsRetailDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsDtoRetail[];

    constructor(data?: ISalesReportWithDetailsRetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationGrandTotalIncludingVAT = data["summationGrandTotalIncludingVAT"];
            this.summationVAT = data["summationVAT"];
            this.summationDiscount = data["summationDiscount"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.templateType = data["templateType"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(SalesReportWithDetailsDetailsDtoRetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsRetailDto {
        let result = new SalesReportWithDetailsRetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationGrandTotalIncludingVAT"] = this.summationGrandTotalIncludingVAT;
        data["summationVAT"] = this.summationVAT;
        data["summationDiscount"] = this.summationDiscount;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["templateType"] = this.templateType;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsRetailDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    templateType: number;
    details: SalesReportWithDetailsDetailsDtoRetail[];
}

export class SalesReportWithDetailsDetailsDtoRetail implements ISalesReportWithDetailsDetailsDtoRetail {
    id: string;
    date: string;
    time: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOutRetail[];
    invoicePayments: InvoicePaymentOut[];

    constructor(data?: ISalesReportWithDetailsDetailsDtoRetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.date = data["date"];
            this.time = data["time"];
            this.orderNumber = data["orderNumber"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.cashierName = data["cashierName"];
            this.total = data["total"];
            this.discountValue = data["discountValue"];
            this.promotionValue = data["promotionValue"];
            this.grandTotal = data["grandTotal"];
            this.vat = data["vat"];
            this.currency = data["currency"];
            this.isRefund = data["isRefund"];
            if (data["invoiceLines"] && data["invoiceLines"].constructor === Array) {
                this.invoiceLines = [];
                for (let item of data["invoiceLines"])
                    this.invoiceLines.push(InvoiceLineOutRetail.fromJS(item));
            }
            if (data["invoicePayments"] && data["invoicePayments"].constructor === Array) {
                this.invoicePayments = [];
                for (let item of data["invoicePayments"])
                    this.invoicePayments.push(InvoicePaymentOut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesReportWithDetailsDetailsDtoRetail {
        let result = new SalesReportWithDetailsDetailsDtoRetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["time"] = this.time;
        data["orderNumber"] = this.orderNumber;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["cashierName"] = this.cashierName;
        data["total"] = this.total;
        data["discountValue"] = this.discountValue;
        data["promotionValue"] = this.promotionValue;
        data["grandTotal"] = this.grandTotal;
        data["vat"] = this.vat;
        data["currency"] = this.currency;
        data["isRefund"] = this.isRefund;
        if (this.invoiceLines && this.invoiceLines.constructor === Array) {
            data["invoiceLines"] = [];
            for (let item of this.invoiceLines)
                data["invoiceLines"].push(item.toJSON());
        }
        if (this.invoicePayments && this.invoicePayments.constructor === Array) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesReportWithDetailsDetailsDtoRetail {
    id: string;
    date: string;
    time: string;
    orderNumber: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    total: number;
    discountValue: number;
    promotionValue: number;
    grandTotal: number;
    vat: number;
    currency: string;
    isRefund: boolean;
    invoiceLines: InvoiceLineOutRetail[];
    invoicePayments: InvoicePaymentOut[];
}

export class InvoiceLineOutRetail implements IInvoiceLineOutRetail {
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    itemId: number;
    itemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;

    constructor(data?: IInvoiceLineOutRetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isRefund = data["isRefund"];
            this.lineId = data["lineId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionValue = data["promotionValue"];
            this.discount = data["discount"];
            this.notes = data["notes"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.itemId = data["itemId"];
            this.itemName = data["itemName"];
            this.itemCode = data["itemCode"];
            this.productCategoryId = data["productCategoryId"];
            this.productCategoryName = data["productCategoryName"];
            this.taxType = data["taxType"];
        }
    }

    static fromJS(data: any): InvoiceLineOutRetail {
        let result = new InvoiceLineOutRetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRefund"] = this.isRefund;
        data["lineId"] = this.lineId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionValue"] = this.promotionValue;
        data["discount"] = this.discount;
        data["notes"] = this.notes;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["itemCode"] = this.itemCode;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        data["taxType"] = this.taxType;
        return data; 
    }
}

export interface IInvoiceLineOutRetail {
    isRefund: boolean;
    lineId: string;
    quantity: number;
    price: number;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionAmount: number;
    promotionValue: number;
    discount: number;
    notes: string;
    priceIncludeVAT: number;
    itemId: number;
    itemName: string;
    itemCode: string;
    productCategoryId: number;
    productCategoryName: string;
    taxType: string;
}

export class LoyaltyReportInput implements ILoyaltyReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    customerNumber: string;
    employees: number[];
    saleTypeIds: number[];
    byShiftDate: boolean;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: ILoyaltyReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.customerNumber = data["customerNumber"];
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            this.byShiftDate = data["byShiftDate"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): LoyaltyReportInput {
        let result = new LoyaltyReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["customerNumber"] = this.customerNumber;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        data["byShiftDate"] = this.byShiftDate;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ILoyaltyReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    from: moment.Moment;
    to: moment.Moment;
    customerNumber: string;
    employees: number[];
    saleTypeIds: number[];
    byShiftDate: boolean;
    documentType: number;
    isCSVFile: boolean;
}

export class LoyaltySalesReportDto implements ILoyaltySalesReportDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    items: GroupedLoyaltySalesDetialReportDto[];
    report: LoyaltyLineDto[];

    constructor(data?: ILoyaltySalesReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationGrandTotalIncludingVAT = data["summationGrandTotalIncludingVAT"];
            this.summationVAT = data["summationVAT"];
            this.summationDiscount = data["summationDiscount"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GroupedLoyaltySalesDetialReportDto.fromJS(item));
            }
            if (data["report"] && data["report"].constructor === Array) {
                this.report = [];
                for (let item of data["report"])
                    this.report.push(LoyaltyLineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoyaltySalesReportDto {
        let result = new LoyaltySalesReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationGrandTotalIncludingVAT"] = this.summationGrandTotalIncludingVAT;
        data["summationVAT"] = this.summationVAT;
        data["summationDiscount"] = this.summationDiscount;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (this.report && this.report.constructor === Array) {
            data["report"] = [];
            for (let item of this.report)
                data["report"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILoyaltySalesReportDto {
    pageCount: number;
    summationGrandTotal: number;
    summationGrandTotalIncludingVAT: number;
    summationVAT: number;
    summationDiscount: number;
    currency: string;
    currentPage: number;
    items: GroupedLoyaltySalesDetialReportDto[];
    report: LoyaltyLineDto[];
}

export class GroupedLoyaltySalesDetialReportDto implements IGroupedLoyaltySalesDetialReportDto {
    storeId: number;
    storeNumber: string;
    storeName: string;
    total: number;
    details: GroupedTenderTypeLoyaltySalesDetialReportDto[];

    constructor(data?: IGroupedLoyaltySalesDetialReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.total = data["total"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(GroupedTenderTypeLoyaltySalesDetialReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedLoyaltySalesDetialReportDto {
        let result = new GroupedLoyaltySalesDetialReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["total"] = this.total;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupedLoyaltySalesDetialReportDto {
    storeId: number;
    storeNumber: string;
    storeName: string;
    total: number;
    details: GroupedTenderTypeLoyaltySalesDetialReportDto[];
}

export class LoyaltyLineDto implements ILoyaltyLineDto {
    storeCode: string;
    id: string;
    date: moment.Moment;
    saleTypeName: string;
    recipeNumber: string;
    storeId: number;
    storeName: string;
    customerName: string;
    cashierName: string;
    tenderTypeName: string;
    value: number;
    tenantName: string;

    constructor(data?: ILoyaltyLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.id = data["id"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.saleTypeName = data["saleTypeName"];
            this.recipeNumber = data["recipeNumber"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.cashierName = data["cashierName"];
            this.tenderTypeName = data["tenderTypeName"];
            this.value = data["value"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): LoyaltyLineDto {
        let result = new LoyaltyLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["saleTypeName"] = this.saleTypeName;
        data["recipeNumber"] = this.recipeNumber;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["cashierName"] = this.cashierName;
        data["tenderTypeName"] = this.tenderTypeName;
        data["value"] = this.value;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface ILoyaltyLineDto {
    storeCode: string;
    id: string;
    date: moment.Moment;
    saleTypeName: string;
    recipeNumber: string;
    storeId: number;
    storeName: string;
    customerName: string;
    cashierName: string;
    tenderTypeName: string;
    value: number;
    tenantName: string;
}

export class GroupedTenderTypeLoyaltySalesDetialReportDto implements IGroupedTenderTypeLoyaltySalesDetialReportDto {
    tenderTypeName: string;
    total: number;
    details: LoyaltySalesDetialReportDto[];

    constructor(data?: IGroupedTenderTypeLoyaltySalesDetialReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeName = data["tenderTypeName"];
            this.total = data["total"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(LoyaltySalesDetialReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedTenderTypeLoyaltySalesDetialReportDto {
        let result = new GroupedTenderTypeLoyaltySalesDetialReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeName"] = this.tenderTypeName;
        data["total"] = this.total;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupedTenderTypeLoyaltySalesDetialReportDto {
    tenderTypeName: string;
    total: number;
    details: LoyaltySalesDetialReportDto[];
}

export class LoyaltySalesDetialReportDto implements ILoyaltySalesDetialReportDto {
    id: string;
    date: string;
    time: string;
    orderNumber: string;
    customerName: string;
    saleTypeName: string;
    cashierName: string;
    tenantName: string;
    loyalty: number;

    constructor(data?: ILoyaltySalesDetialReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.date = data["date"];
            this.time = data["time"];
            this.orderNumber = data["orderNumber"];
            this.customerName = data["customerName"];
            this.saleTypeName = data["saleTypeName"];
            this.cashierName = data["cashierName"];
            this.tenantName = data["tenantName"];
            this.loyalty = data["loyalty"];
        }
    }

    static fromJS(data: any): LoyaltySalesDetialReportDto {
        let result = new LoyaltySalesDetialReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["time"] = this.time;
        data["orderNumber"] = this.orderNumber;
        data["customerName"] = this.customerName;
        data["saleTypeName"] = this.saleTypeName;
        data["cashierName"] = this.cashierName;
        data["tenantName"] = this.tenantName;
        data["loyalty"] = this.loyalty;
        return data; 
    }
}

export interface ILoyaltySalesDetialReportDto {
    id: string;
    date: string;
    time: string;
    orderNumber: string;
    customerName: string;
    saleTypeName: string;
    cashierName: string;
    tenantName: string;
    loyalty: number;
}

export class PurchaseReportBySupplierDetailsDto implements IPurchaseReportBySupplierDetailsDto {
    detailTransactions: DetailTransactionReciveReportDto[];
    totalCount: number;
    pageNumber: number;

    constructor(data?: IPurchaseReportBySupplierDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransactionReciveReportDto.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
        }
    }

    static fromJS(data: any): PurchaseReportBySupplierDetailsDto {
        let result = new PurchaseReportBySupplierDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        return data; 
    }
}

export interface IPurchaseReportBySupplierDetailsDto {
    detailTransactions: DetailTransactionReciveReportDto[];
    totalCount: number;
    pageNumber: number;
}

export class TotalSalesAndPuechaseInput implements ITotalSalesAndPuechaseInput {
    from: moment.Moment;
    to: moment.Moment;
    stores: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: ITotalSalesAndPuechaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalSalesAndPuechaseInput {
        let result = new TotalSalesAndPuechaseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalSalesAndPuechaseInput {
    from: moment.Moment;
    to: moment.Moment;
    stores: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class SalesAndPurchaseReportDto implements ISalesAndPurchaseReportDto {
    totalPurchase: number;
    purchaseIncludingTax: number;
    purchaseDue: number;
    sales: number;
    salesIncludingTax: number;
    salesPurchase: number;
    dueAmount: number;

    constructor(data?: ISalesAndPurchaseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPurchase = data["totalPurchase"];
            this.purchaseIncludingTax = data["purchaseIncludingTax"];
            this.purchaseDue = data["purchaseDue"];
            this.sales = data["sales"];
            this.salesIncludingTax = data["salesIncludingTax"];
            this.salesPurchase = data["salesPurchase"];
            this.dueAmount = data["dueAmount"];
        }
    }

    static fromJS(data: any): SalesAndPurchaseReportDto {
        let result = new SalesAndPurchaseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPurchase"] = this.totalPurchase;
        data["purchaseIncludingTax"] = this.purchaseIncludingTax;
        data["purchaseDue"] = this.purchaseDue;
        data["sales"] = this.sales;
        data["salesIncludingTax"] = this.salesIncludingTax;
        data["salesPurchase"] = this.salesPurchase;
        data["dueAmount"] = this.dueAmount;
        return data; 
    }
}

export interface ISalesAndPurchaseReportDto {
    totalPurchase: number;
    purchaseIncludingTax: number;
    purchaseDue: number;
    sales: number;
    salesIncludingTax: number;
    salesPurchase: number;
    dueAmount: number;
}

export class TotalSalesAndPuechaseFBInput implements ITotalSalesAndPuechaseFBInput {
    transactionTypeId: number;
    entityFromId: number;
    entityToId: number;
    supplierId: number;
    from: moment.Moment;
    to: moment.Moment;
    stores: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;

    constructor(data?: ITotalSalesAndPuechaseFBInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeId = data["transactionTypeId"];
            this.entityFromId = data["entityFromId"];
            this.entityToId = data["entityToId"];
            this.supplierId = data["supplierId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TotalSalesAndPuechaseFBInput {
        let result = new TotalSalesAndPuechaseFBInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["entityFromId"] = this.entityFromId;
        data["entityToId"] = this.entityToId;
        data["supplierId"] = this.supplierId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITotalSalesAndPuechaseFBInput {
    transactionTypeId: number;
    entityFromId: number;
    entityToId: number;
    supplierId: number;
    from: moment.Moment;
    to: moment.Moment;
    stores: number[];
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
}

export class SalesAndPurchaseReportFBDto implements ISalesAndPurchaseReportFBDto {
    totalPurchaseStockOpeningBalance: number;
    purchaseIncludingTaxStockOpeningBalance: number;
    totalPurchaseInventoryOrder: number;
    purchaseIncludingTaxInventoryOrder: number;
    totalPurchaseInventoryReceive: number;
    purchaseIncludingTaxInventoryReceive: number;
    totalPurchaseInventoryRawWaste: number;
    purchaseIncludingTaxInventoryRawWaste: number;
    totalPurchaseMenuItemWaste: number;
    purchaseIncludingTaxMenuItemWaste: number;
    totalPurchaseStockadjustment: number;
    purchaseIncludingTaxStockadjustment: number;
    totalPurchaseInventoryTransfer: number;
    purchaseIncludingTaxInventoryTransfer: number;
    totalPurchaseBatchRecipe: number;
    purchaseIncludingTaxBatchRecipe: number;
    vat: number;
    purchaseDue: number;
    sales: number;
    salesIncludingTax: number;
    salesPurchase: number;
    dueAmount: number;

    constructor(data?: ISalesAndPurchaseReportFBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPurchaseStockOpeningBalance = data["totalPurchaseStockOpeningBalance"];
            this.purchaseIncludingTaxStockOpeningBalance = data["purchaseIncludingTaxStockOpeningBalance"];
            this.totalPurchaseInventoryOrder = data["totalPurchaseInventoryOrder"];
            this.purchaseIncludingTaxInventoryOrder = data["purchaseIncludingTaxInventoryOrder"];
            this.totalPurchaseInventoryReceive = data["totalPurchaseInventoryReceive"];
            this.purchaseIncludingTaxInventoryReceive = data["purchaseIncludingTaxInventoryReceive"];
            this.totalPurchaseInventoryRawWaste = data["totalPurchaseInventoryRawWaste"];
            this.purchaseIncludingTaxInventoryRawWaste = data["purchaseIncludingTaxInventoryRawWaste"];
            this.totalPurchaseMenuItemWaste = data["totalPurchaseMenuItemWaste"];
            this.purchaseIncludingTaxMenuItemWaste = data["purchaseIncludingTaxMenuItemWaste"];
            this.totalPurchaseStockadjustment = data["totalPurchaseStockadjustment"];
            this.purchaseIncludingTaxStockadjustment = data["purchaseIncludingTaxStockadjustment"];
            this.totalPurchaseInventoryTransfer = data["totalPurchaseInventoryTransfer"];
            this.purchaseIncludingTaxInventoryTransfer = data["purchaseIncludingTaxInventoryTransfer"];
            this.totalPurchaseBatchRecipe = data["totalPurchaseBatchRecipe"];
            this.purchaseIncludingTaxBatchRecipe = data["purchaseIncludingTaxBatchRecipe"];
            this.vat = data["vat"];
            this.purchaseDue = data["purchaseDue"];
            this.sales = data["sales"];
            this.salesIncludingTax = data["salesIncludingTax"];
            this.salesPurchase = data["salesPurchase"];
            this.dueAmount = data["dueAmount"];
        }
    }

    static fromJS(data: any): SalesAndPurchaseReportFBDto {
        let result = new SalesAndPurchaseReportFBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPurchaseStockOpeningBalance"] = this.totalPurchaseStockOpeningBalance;
        data["purchaseIncludingTaxStockOpeningBalance"] = this.purchaseIncludingTaxStockOpeningBalance;
        data["totalPurchaseInventoryOrder"] = this.totalPurchaseInventoryOrder;
        data["purchaseIncludingTaxInventoryOrder"] = this.purchaseIncludingTaxInventoryOrder;
        data["totalPurchaseInventoryReceive"] = this.totalPurchaseInventoryReceive;
        data["purchaseIncludingTaxInventoryReceive"] = this.purchaseIncludingTaxInventoryReceive;
        data["totalPurchaseInventoryRawWaste"] = this.totalPurchaseInventoryRawWaste;
        data["purchaseIncludingTaxInventoryRawWaste"] = this.purchaseIncludingTaxInventoryRawWaste;
        data["totalPurchaseMenuItemWaste"] = this.totalPurchaseMenuItemWaste;
        data["purchaseIncludingTaxMenuItemWaste"] = this.purchaseIncludingTaxMenuItemWaste;
        data["totalPurchaseStockadjustment"] = this.totalPurchaseStockadjustment;
        data["purchaseIncludingTaxStockadjustment"] = this.purchaseIncludingTaxStockadjustment;
        data["totalPurchaseInventoryTransfer"] = this.totalPurchaseInventoryTransfer;
        data["purchaseIncludingTaxInventoryTransfer"] = this.purchaseIncludingTaxInventoryTransfer;
        data["totalPurchaseBatchRecipe"] = this.totalPurchaseBatchRecipe;
        data["purchaseIncludingTaxBatchRecipe"] = this.purchaseIncludingTaxBatchRecipe;
        data["vat"] = this.vat;
        data["purchaseDue"] = this.purchaseDue;
        data["sales"] = this.sales;
        data["salesIncludingTax"] = this.salesIncludingTax;
        data["salesPurchase"] = this.salesPurchase;
        data["dueAmount"] = this.dueAmount;
        return data; 
    }
}

export interface ISalesAndPurchaseReportFBDto {
    totalPurchaseStockOpeningBalance: number;
    purchaseIncludingTaxStockOpeningBalance: number;
    totalPurchaseInventoryOrder: number;
    purchaseIncludingTaxInventoryOrder: number;
    totalPurchaseInventoryReceive: number;
    purchaseIncludingTaxInventoryReceive: number;
    totalPurchaseInventoryRawWaste: number;
    purchaseIncludingTaxInventoryRawWaste: number;
    totalPurchaseMenuItemWaste: number;
    purchaseIncludingTaxMenuItemWaste: number;
    totalPurchaseStockadjustment: number;
    purchaseIncludingTaxStockadjustment: number;
    totalPurchaseInventoryTransfer: number;
    purchaseIncludingTaxInventoryTransfer: number;
    totalPurchaseBatchRecipe: number;
    purchaseIncludingTaxBatchRecipe: number;
    vat: number;
    purchaseDue: number;
    sales: number;
    salesIncludingTax: number;
    salesPurchase: number;
    dueAmount: number;
}

export class ReturnSalesReportInput implements IReturnSalesReportInput {
    from: moment.Moment;
    to: moment.Moment;
    customers: string[];
    referenceNumberORCode: string;
    storeIds: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IReturnSalesReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["customers"] && data["customers"].constructor === Array) {
                this.customers = [];
                for (let item of data["customers"])
                    this.customers.push(item);
            }
            this.referenceNumberORCode = data["referenceNumberORCode"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ReturnSalesReportInput {
        let result = new ReturnSalesReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.customers && this.customers.constructor === Array) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item);
        }
        data["referenceNumberORCode"] = this.referenceNumberORCode;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IReturnSalesReportInput {
    from: moment.Moment;
    to: moment.Moment;
    customers: string[];
    referenceNumberORCode: string;
    storeIds: number[];
    cashierIds: number[];
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class ReturnSalesReportDto implements IReturnSalesReportDto {
    details: ReturnSalesReportDetailsDto[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;

    constructor(data?: IReturnSalesReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ReturnSalesReportDetailsDto.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationGrandTotal = data["summationGrandTotal"];
        }
    }

    static fromJS(data: any): ReturnSalesReportDto {
        let result = new ReturnSalesReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationGrandTotal"] = this.summationGrandTotal;
        return data; 
    }
}

export interface IReturnSalesReportDto {
    details: ReturnSalesReportDetailsDto[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
}

export class ReturnSalesReportDetailsDto implements IReturnSalesReportDetailsDto {
    date: string;
    orderNumber: string;
    customerName: string;
    returnedProducts: string[];
    returnedProductsText: string;
    moneyReturned: number;
    returnedBy: string;

    constructor(data?: IReturnSalesReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.orderNumber = data["orderNumber"];
            this.customerName = data["customerName"];
            if (data["returnedProducts"] && data["returnedProducts"].constructor === Array) {
                this.returnedProducts = [];
                for (let item of data["returnedProducts"])
                    this.returnedProducts.push(item);
            }
            this.returnedProductsText = data["returnedProductsText"];
            this.moneyReturned = data["moneyReturned"];
            this.returnedBy = data["returnedBy"];
        }
    }

    static fromJS(data: any): ReturnSalesReportDetailsDto {
        let result = new ReturnSalesReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["orderNumber"] = this.orderNumber;
        data["customerName"] = this.customerName;
        if (this.returnedProducts && this.returnedProducts.constructor === Array) {
            data["returnedProducts"] = [];
            for (let item of this.returnedProducts)
                data["returnedProducts"].push(item);
        }
        data["returnedProductsText"] = this.returnedProductsText;
        data["moneyReturned"] = this.moneyReturned;
        data["returnedBy"] = this.returnedBy;
        return data; 
    }
}

export interface IReturnSalesReportDetailsDto {
    date: string;
    orderNumber: string;
    customerName: string;
    returnedProducts: string[];
    returnedProductsText: string;
    moneyReturned: number;
    returnedBy: string;
}

export class ProductPurchaseReportInput implements IProductPurchaseReportInput {
    stores: number[];
    products: number[];
    from: moment.Moment;
    to: moment.Moment;
    referenceNumberORCode: string;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IProductPurchaseReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(item);
            }
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.referenceNumberORCode = data["referenceNumberORCode"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ProductPurchaseReportInput {
        let result = new ProductPurchaseReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["referenceNumberORCode"] = this.referenceNumberORCode;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IProductPurchaseReportInput {
    stores: number[];
    products: number[];
    from: moment.Moment;
    to: moment.Moment;
    referenceNumberORCode: string;
    documentType: number;
    isCSVFile: boolean;
}

export class ProductPurchaseReportDto implements IProductPurchaseReportDto {
    pageCount: number;
    itemsCount: number;
    currentPage: number;
    inventoryStock: number;
    totalBuyingCostStock: number;
    totalUnitPurchasePrice: number;
    currency: string;
    details: ProductPurchaseReportDetailsDto[];

    constructor(data?: IProductPurchaseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.itemsCount = data["itemsCount"];
            this.currentPage = data["currentPage"];
            this.inventoryStock = data["inventoryStock"];
            this.totalBuyingCostStock = data["totalBuyingCostStock"];
            this.totalUnitPurchasePrice = data["totalUnitPurchasePrice"];
            this.currency = data["currency"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ProductPurchaseReportDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductPurchaseReportDto {
        let result = new ProductPurchaseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["itemsCount"] = this.itemsCount;
        data["currentPage"] = this.currentPage;
        data["inventoryStock"] = this.inventoryStock;
        data["totalBuyingCostStock"] = this.totalBuyingCostStock;
        data["totalUnitPurchasePrice"] = this.totalUnitPurchasePrice;
        data["currency"] = this.currency;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductPurchaseReportDto {
    pageCount: number;
    itemsCount: number;
    currentPage: number;
    inventoryStock: number;
    totalBuyingCostStock: number;
    totalUnitPurchasePrice: number;
    currency: string;
    details: ProductPurchaseReportDetailsDto[];
}

export class ProductPurchaseReportDetailsDto implements IProductPurchaseReportDetailsDto {
    barCode: string;
    productName: string;
    referenceNumber: string;
    inventory: string;
    unitPurchasePrice: number;
    stockName: string;
    inventoryUOM: string;
    totalBuyingCost: string;
    totalBuyingCostCurrency: string;
    totalSellingCost: string;
    totalSellingCostCurrency: string;
    inventoryNum: number;
    totalBuyingCostNum: number;
    currency: string;
    date: moment.Moment;

    constructor(data?: IProductPurchaseReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.productName = data["productName"];
            this.referenceNumber = data["referenceNumber"];
            this.inventory = data["inventory"];
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.stockName = data["stockName"];
            this.inventoryUOM = data["inventoryUOM"];
            this.totalBuyingCost = data["totalBuyingCost"];
            this.totalBuyingCostCurrency = data["totalBuyingCostCurrency"];
            this.totalSellingCost = data["totalSellingCost"];
            this.totalSellingCostCurrency = data["totalSellingCostCurrency"];
            this.inventoryNum = data["inventoryNum"];
            this.totalBuyingCostNum = data["totalBuyingCostNum"];
            this.currency = data["currency"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductPurchaseReportDetailsDto {
        let result = new ProductPurchaseReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["productName"] = this.productName;
        data["referenceNumber"] = this.referenceNumber;
        data["inventory"] = this.inventory;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["stockName"] = this.stockName;
        data["inventoryUOM"] = this.inventoryUOM;
        data["totalBuyingCost"] = this.totalBuyingCost;
        data["totalBuyingCostCurrency"] = this.totalBuyingCostCurrency;
        data["totalSellingCost"] = this.totalSellingCost;
        data["totalSellingCostCurrency"] = this.totalSellingCostCurrency;
        data["inventoryNum"] = this.inventoryNum;
        data["totalBuyingCostNum"] = this.totalBuyingCostNum;
        data["currency"] = this.currency;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IProductPurchaseReportDetailsDto {
    barCode: string;
    productName: string;
    referenceNumber: string;
    inventory: string;
    unitPurchasePrice: number;
    stockName: string;
    inventoryUOM: string;
    totalBuyingCost: string;
    totalBuyingCostCurrency: string;
    totalSellingCost: string;
    totalSellingCostCurrency: string;
    inventoryNum: number;
    totalBuyingCostNum: number;
    currency: string;
    date: moment.Moment;
}

export class PurchaseMovementReportInput implements IPurchaseMovementReportInput {
    searchKey: string;
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    productCategories: number[];
    customerIds: number[];
    isStoreDataInDetail: boolean;
    isCashierDataInDetail: boolean;
    isCustomerDataInDetail: boolean;
    isSupplierDataInDetail: boolean;
    storeIds: number[];
    cashierIds: number[];
    productInfo: string;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IPurchaseMovementReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.searchKey = data["searchKey"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.referenceNumber = data["referenceNumber"];
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(item);
            }
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [];
                for (let item of data["customerIds"])
                    this.customerIds.push(item);
            }
            this.isStoreDataInDetail = data["isStoreDataInDetail"];
            this.isCashierDataInDetail = data["isCashierDataInDetail"];
            this.isCustomerDataInDetail = data["isCustomerDataInDetail"];
            this.isSupplierDataInDetail = data["isSupplierDataInDetail"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["cashierIds"] && data["cashierIds"].constructor === Array) {
                this.cashierIds = [];
                for (let item of data["cashierIds"])
                    this.cashierIds.push(item);
            }
            this.productInfo = data["productInfo"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PurchaseMovementReportInput {
        let result = new PurchaseMovementReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchKey"] = this.searchKey;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item);
        }
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["isStoreDataInDetail"] = this.isStoreDataInDetail;
        data["isCashierDataInDetail"] = this.isCashierDataInDetail;
        data["isCustomerDataInDetail"] = this.isCustomerDataInDetail;
        data["isSupplierDataInDetail"] = this.isSupplierDataInDetail;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.cashierIds && this.cashierIds.constructor === Array) {
            data["cashierIds"] = [];
            for (let item of this.cashierIds)
                data["cashierIds"].push(item);
        }
        data["productInfo"] = this.productInfo;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPurchaseMovementReportInput {
    searchKey: string;
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    productCategories: number[];
    customerIds: number[];
    isStoreDataInDetail: boolean;
    isCashierDataInDetail: boolean;
    isCustomerDataInDetail: boolean;
    isSupplierDataInDetail: boolean;
    storeIds: number[];
    cashierIds: number[];
    productInfo: string;
    documentType: number;
    isCSVFile: boolean;
}

export class PurchaseMovementReport implements IPurchaseMovementReport {
    details: PurchasemovementDetailDto[];
    currentPage: number;
    itemsCount: number;
    summationTotalCount: number;

    constructor(data?: IPurchaseMovementReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(PurchasemovementDetailDto.fromJS(item));
            }
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.summationTotalCount = data["summationTotalCount"];
        }
    }

    static fromJS(data: any): PurchaseMovementReport {
        let result = new PurchaseMovementReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["summationTotalCount"] = this.summationTotalCount;
        return data; 
    }
}

export interface IPurchaseMovementReport {
    details: PurchasemovementDetailDto[];
    currentPage: number;
    itemsCount: number;
    summationTotalCount: number;
}

export class PurchasemovementDetailDto implements IPurchasemovementDetailDto {
    textDate: string;
    productName: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    serial: string;
    quantity: number;

    constructor(data?: IPurchasemovementDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.textDate = data["textDate"];
            this.productName = data["productName"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.cashierName = data["cashierName"];
            this.serial = data["serial"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): PurchasemovementDetailDto {
        let result = new PurchasemovementDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textDate"] = this.textDate;
        data["productName"] = this.productName;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["cashierName"] = this.cashierName;
        data["serial"] = this.serial;
        data["quantity"] = this.quantity;
        return data; 
    }
}

export interface IPurchasemovementDetailDto {
    textDate: string;
    productName: string;
    storeName: string;
    customerName: string;
    cashierName: string;
    serial: string;
    quantity: number;
}

export class MaterialStockListItem implements IMaterialStockListItem {
    itemsCount: number;
    currentPage: number;
    inventoryTotal: number;
    purchaseQtySummation: number;
    inventoryQtySummation: number;
    productQtySummation: number;
    priceSummation: number;
    sellingPriceSummation: number;
    details: MaterialStockDto[];

    constructor(data?: IMaterialStockListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemsCount = data["itemsCount"];
            this.currentPage = data["currentPage"];
            this.inventoryTotal = data["inventoryTotal"];
            this.purchaseQtySummation = data["purchaseQtySummation"];
            this.inventoryQtySummation = data["inventoryQtySummation"];
            this.productQtySummation = data["productQtySummation"];
            this.priceSummation = data["priceSummation"];
            this.sellingPriceSummation = data["sellingPriceSummation"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(MaterialStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialStockListItem {
        let result = new MaterialStockListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemsCount"] = this.itemsCount;
        data["currentPage"] = this.currentPage;
        data["inventoryTotal"] = this.inventoryTotal;
        data["purchaseQtySummation"] = this.purchaseQtySummation;
        data["inventoryQtySummation"] = this.inventoryQtySummation;
        data["productQtySummation"] = this.productQtySummation;
        data["priceSummation"] = this.priceSummation;
        data["sellingPriceSummation"] = this.sellingPriceSummation;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMaterialStockListItem {
    itemsCount: number;
    currentPage: number;
    inventoryTotal: number;
    purchaseQtySummation: number;
    inventoryQtySummation: number;
    productQtySummation: number;
    priceSummation: number;
    sellingPriceSummation: number;
    details: MaterialStockDto[];
}

export class LotReportDto implements ILotReportDto {
    pageCount: number;
    currentPage: number;
    details: LotReportDetialsDto[];

    constructor(data?: ILotReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(LotReportDetialsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LotReportDto {
        let result = new LotReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILotReportDto {
    pageCount: number;
    currentPage: number;
    details: LotReportDetialsDto[];
}

export class LotReportDetialsDto implements ILotReportDetialsDto {
    barCode: string;
    productName: string;
    referenceNumber: string;
    lotNumber: string;
    expiryDate: string;
    currentStock: string;
    storeName: string;
    quantity: number;
    purchaseLimit: number;
    unitOfMeasureName: string;
    productVariantName: string;
    baseQuantity: number;
    productId: number;

    constructor(data?: ILotReportDetialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.productName = data["productName"];
            this.referenceNumber = data["referenceNumber"];
            this.lotNumber = data["lotNumber"];
            this.expiryDate = data["expiryDate"];
            this.currentStock = data["currentStock"];
            this.storeName = data["storeName"];
            this.quantity = data["quantity"];
            this.purchaseLimit = data["purchaseLimit"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.productVariantName = data["productVariantName"];
            this.baseQuantity = data["baseQuantity"];
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): LotReportDetialsDto {
        let result = new LotReportDetialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["productName"] = this.productName;
        data["referenceNumber"] = this.referenceNumber;
        data["lotNumber"] = this.lotNumber;
        data["expiryDate"] = this.expiryDate;
        data["currentStock"] = this.currentStock;
        data["storeName"] = this.storeName;
        data["quantity"] = this.quantity;
        data["purchaseLimit"] = this.purchaseLimit;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["productVariantName"] = this.productVariantName;
        data["baseQuantity"] = this.baseQuantity;
        data["productId"] = this.productId;
        return data; 
    }
}

export interface ILotReportDetialsDto {
    barCode: string;
    productName: string;
    referenceNumber: string;
    lotNumber: string;
    expiryDate: string;
    currentStock: string;
    storeName: string;
    quantity: number;
    purchaseLimit: number;
    unitOfMeasureName: string;
    productVariantName: string;
    baseQuantity: number;
    productId: number;
}

export class StockValuesReportDto implements IStockValuesReportDto {
    pageCount: number;
    itemsCount: number;
    currentPage: number;
    inventoryStock: number;
    totalBuyingCostStock: number;
    totalSellingCostStock: number;
    details: StockValuesReportDetailsDto[];

    constructor(data?: IStockValuesReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.itemsCount = data["itemsCount"];
            this.currentPage = data["currentPage"];
            this.inventoryStock = data["inventoryStock"];
            this.totalBuyingCostStock = data["totalBuyingCostStock"];
            this.totalSellingCostStock = data["totalSellingCostStock"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(StockValuesReportDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockValuesReportDto {
        let result = new StockValuesReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["itemsCount"] = this.itemsCount;
        data["currentPage"] = this.currentPage;
        data["inventoryStock"] = this.inventoryStock;
        data["totalBuyingCostStock"] = this.totalBuyingCostStock;
        data["totalSellingCostStock"] = this.totalSellingCostStock;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockValuesReportDto {
    pageCount: number;
    itemsCount: number;
    currentPage: number;
    inventoryStock: number;
    totalBuyingCostStock: number;
    totalSellingCostStock: number;
    details: StockValuesReportDetailsDto[];
}

export class StockValuesReportDetailsDto implements IStockValuesReportDetailsDto {
    stockName: string;
    barCode: string;
    referenceNumber: string;
    productName: string;
    inventory: string;
    inventoryStock: number;
    inventoryUOM: string;
    totalBuyingCost: string;
    cost: string;
    totalBuyingCostStock: number;
    totalBuyingCostCurrency: string;
    totalSellingCost: string;
    totalSellingCostStock: number;
    price: string;
    totalSellingCostCurrency: string;
    date: moment.Moment;
    variantCode: string;
    uomCode: string;
    productCode: string;

    constructor(data?: IStockValuesReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockName = data["stockName"];
            this.barCode = data["barCode"];
            this.referenceNumber = data["referenceNumber"];
            this.productName = data["productName"];
            this.inventory = data["inventory"];
            this.inventoryStock = data["inventoryStock"];
            this.inventoryUOM = data["inventoryUOM"];
            this.totalBuyingCost = data["totalBuyingCost"];
            this.cost = data["cost"];
            this.totalBuyingCostStock = data["totalBuyingCostStock"];
            this.totalBuyingCostCurrency = data["totalBuyingCostCurrency"];
            this.totalSellingCost = data["totalSellingCost"];
            this.totalSellingCostStock = data["totalSellingCostStock"];
            this.price = data["price"];
            this.totalSellingCostCurrency = data["totalSellingCostCurrency"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.variantCode = data["variantCode"];
            this.uomCode = data["uomCode"];
            this.productCode = data["productCode"];
        }
    }

    static fromJS(data: any): StockValuesReportDetailsDto {
        let result = new StockValuesReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockName"] = this.stockName;
        data["barCode"] = this.barCode;
        data["referenceNumber"] = this.referenceNumber;
        data["productName"] = this.productName;
        data["inventory"] = this.inventory;
        data["inventoryStock"] = this.inventoryStock;
        data["inventoryUOM"] = this.inventoryUOM;
        data["totalBuyingCost"] = this.totalBuyingCost;
        data["cost"] = this.cost;
        data["totalBuyingCostStock"] = this.totalBuyingCostStock;
        data["totalBuyingCostCurrency"] = this.totalBuyingCostCurrency;
        data["totalSellingCost"] = this.totalSellingCost;
        data["totalSellingCostStock"] = this.totalSellingCostStock;
        data["price"] = this.price;
        data["totalSellingCostCurrency"] = this.totalSellingCostCurrency;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["variantCode"] = this.variantCode;
        data["uomCode"] = this.uomCode;
        data["productCode"] = this.productCode;
        return data; 
    }
}

export interface IStockValuesReportDetailsDto {
    stockName: string;
    barCode: string;
    referenceNumber: string;
    productName: string;
    inventory: string;
    inventoryStock: number;
    inventoryUOM: string;
    totalBuyingCost: string;
    cost: string;
    totalBuyingCostStock: number;
    totalBuyingCostCurrency: string;
    totalSellingCost: string;
    totalSellingCostStock: number;
    price: string;
    totalSellingCostCurrency: string;
    date: moment.Moment;
    variantCode: string;
    uomCode: string;
    productCode: string;
}

export class MaterialStockTransactionReportFilterDto implements IMaterialStockTransactionReportFilterDto {
    storeId: number;
    matrialId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    isEndOfDay: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;

    constructor(data?: IMaterialStockTransactionReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.matrialId = data["matrialId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isEndOfDay = data["isEndOfDay"];
            this.showMaterialName = data["showMaterialName"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): MaterialStockTransactionReportFilterDto {
        let result = new MaterialStockTransactionReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["matrialId"] = this.matrialId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isEndOfDay"] = this.isEndOfDay;
        data["showMaterialName"] = this.showMaterialName;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IMaterialStockTransactionReportFilterDto {
    storeId: number;
    matrialId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    isEndOfDay: boolean;
    showMaterialName: boolean;
    regionId: number;
    areaId: number;
    isCSVFile: boolean;
}

export class MaterialStockTransactionPagedDto implements IMaterialStockTransactionPagedDto {
    currentPage: number;
    itemsCount: number;
    items: MaterialStockTransactionDto[];

    constructor(data?: IMaterialStockTransactionPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MaterialStockTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialStockTransactionPagedDto {
        let result = new MaterialStockTransactionPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMaterialStockTransactionPagedDto {
    currentPage: number;
    itemsCount: number;
    items: MaterialStockTransactionDto[];
}

export class MaterialStockTransactionDto implements IMaterialStockTransactionDto {
    materialId: number;
    materialCode: string;
    materialName: string;
    stockOpeningQunatity: number;
    inventoryReciveQunatity: number;
    inventoryRawWast: number;
    stockAdjustmentQuantity: number;
    transferOutQuantity: number;
    transferInQuantity: number;
    inventoryOrderQuantity: number;
    batchRecipeQuantity: number;
    purshaseQuantity: number;
    returnPurchaseQuantity: number;
    menuItemWasteQuantity: number;
    saleQuantity: number;
    variantQuantity: number;
    stockBalance: number;

    constructor(data?: IMaterialStockTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialId = data["materialId"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.stockOpeningQunatity = data["stockOpeningQunatity"];
            this.inventoryReciveQunatity = data["inventoryReciveQunatity"];
            this.inventoryRawWast = data["inventoryRawWast"];
            this.stockAdjustmentQuantity = data["stockAdjustmentQuantity"];
            this.transferOutQuantity = data["transferOutQuantity"];
            this.transferInQuantity = data["transferInQuantity"];
            this.inventoryOrderQuantity = data["inventoryOrderQuantity"];
            this.batchRecipeQuantity = data["batchRecipeQuantity"];
            this.purshaseQuantity = data["purshaseQuantity"];
            this.returnPurchaseQuantity = data["returnPurchaseQuantity"];
            this.menuItemWasteQuantity = data["menuItemWasteQuantity"];
            this.saleQuantity = data["saleQuantity"];
            this.variantQuantity = data["variantQuantity"];
            this.stockBalance = data["stockBalance"];
        }
    }

    static fromJS(data: any): MaterialStockTransactionDto {
        let result = new MaterialStockTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["stockOpeningQunatity"] = this.stockOpeningQunatity;
        data["inventoryReciveQunatity"] = this.inventoryReciveQunatity;
        data["inventoryRawWast"] = this.inventoryRawWast;
        data["stockAdjustmentQuantity"] = this.stockAdjustmentQuantity;
        data["transferOutQuantity"] = this.transferOutQuantity;
        data["transferInQuantity"] = this.transferInQuantity;
        data["inventoryOrderQuantity"] = this.inventoryOrderQuantity;
        data["batchRecipeQuantity"] = this.batchRecipeQuantity;
        data["purshaseQuantity"] = this.purshaseQuantity;
        data["returnPurchaseQuantity"] = this.returnPurchaseQuantity;
        data["menuItemWasteQuantity"] = this.menuItemWasteQuantity;
        data["saleQuantity"] = this.saleQuantity;
        data["variantQuantity"] = this.variantQuantity;
        data["stockBalance"] = this.stockBalance;
        return data; 
    }
}

export interface IMaterialStockTransactionDto {
    materialId: number;
    materialCode: string;
    materialName: string;
    stockOpeningQunatity: number;
    inventoryReciveQunatity: number;
    inventoryRawWast: number;
    stockAdjustmentQuantity: number;
    transferOutQuantity: number;
    transferInQuantity: number;
    inventoryOrderQuantity: number;
    batchRecipeQuantity: number;
    purshaseQuantity: number;
    returnPurchaseQuantity: number;
    menuItemWasteQuantity: number;
    saleQuantity: number;
    variantQuantity: number;
    stockBalance: number;
}

export class TransferInOutTransactionReportFilterDto implements ITransferInOutTransactionReportFilterDto {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    matrialId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isEndOfDay: boolean;
    documentType: number;
    showMaterialCode: boolean;
    showStoreCode: boolean;
    isCSVFile: boolean;

    constructor(data?: ITransferInOutTransactionReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.matrialId = data["matrialId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.isEndOfDay = data["isEndOfDay"];
            this.documentType = data["documentType"];
            this.showMaterialCode = data["showMaterialCode"];
            this.showStoreCode = data["showStoreCode"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): TransferInOutTransactionReportFilterDto {
        let result = new TransferInOutTransactionReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["matrialId"] = this.matrialId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["isEndOfDay"] = this.isEndOfDay;
        data["documentType"] = this.documentType;
        data["showMaterialCode"] = this.showMaterialCode;
        data["showStoreCode"] = this.showStoreCode;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ITransferInOutTransactionReportFilterDto {
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    matrialId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isEndOfDay: boolean;
    documentType: number;
    showMaterialCode: boolean;
    showStoreCode: boolean;
    isCSVFile: boolean;
}

export class TransferInOutTransactionPagedDto implements ITransferInOutTransactionPagedDto {
    currentPage: number;
    itemsCount: number;
    totalQty: number;
    items: TransferInOutTransactionDto[];

    constructor(data?: ITransferInOutTransactionPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.totalQty = data["totalQty"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TransferInOutTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferInOutTransactionPagedDto {
        let result = new TransferInOutTransactionPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["totalQty"] = this.totalQty;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransferInOutTransactionPagedDto {
    currentPage: number;
    itemsCount: number;
    totalQty: number;
    items: TransferInOutTransactionDto[];
}

export class TransferInOutTransactionDto implements ITransferInOutTransactionDto {
    date: string;
    fromStoreCode: string;
    fromStoreName: string;
    toStoreCode: string;
    toStoreName: string;
    materialCode: string;
    materialName: string;
    quantity: number;
    unitName: string;
    documentNumber: string;
    user: string;
    note: string;

    constructor(data?: ITransferInOutTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.fromStoreCode = data["fromStoreCode"];
            this.fromStoreName = data["fromStoreName"];
            this.toStoreCode = data["toStoreCode"];
            this.toStoreName = data["toStoreName"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.quantity = data["quantity"];
            this.unitName = data["unitName"];
            this.documentNumber = data["documentNumber"];
            this.user = data["user"];
            this.note = data["note"];
        }
    }

    static fromJS(data: any): TransferInOutTransactionDto {
        let result = new TransferInOutTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["fromStoreCode"] = this.fromStoreCode;
        data["fromStoreName"] = this.fromStoreName;
        data["toStoreCode"] = this.toStoreCode;
        data["toStoreName"] = this.toStoreName;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["quantity"] = this.quantity;
        data["unitName"] = this.unitName;
        data["documentNumber"] = this.documentNumber;
        data["user"] = this.user;
        data["note"] = this.note;
        return data; 
    }
}

export interface ITransferInOutTransactionDto {
    date: string;
    fromStoreCode: string;
    fromStoreName: string;
    toStoreCode: string;
    toStoreName: string;
    materialCode: string;
    materialName: string;
    quantity: number;
    unitName: string;
    documentNumber: string;
    user: string;
    note: string;
}

export class ProductCardInput implements IProductCardInput {
    products: number[];
    stores: number[];
    fromStores: number[];
    toStores: number[];
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IProductCardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(item);
            }
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(item);
            }
            if (data["fromStores"] && data["fromStores"].constructor === Array) {
                this.fromStores = [];
                for (let item of data["fromStores"])
                    this.fromStores.push(item);
            }
            if (data["toStores"] && data["toStores"].constructor === Array) {
                this.toStores = [];
                for (let item of data["toStores"])
                    this.toStores.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ProductCardInput {
        let result = new ProductCardInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        if (this.fromStores && this.fromStores.constructor === Array) {
            data["fromStores"] = [];
            for (let item of this.fromStores)
                data["fromStores"].push(item);
        }
        if (this.toStores && this.toStores.constructor === Array) {
            data["toStores"] = [];
            for (let item of this.toStores)
                data["toStores"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IProductCardInput {
    products: number[];
    stores: number[];
    fromStores: number[];
    toStores: number[];
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isCSVFile: boolean;
}

export class ProductCardReportDto implements IProductCardReportDto {
    pageCount: number;
    currentPage: number;
    total: number;
    productCards: ProductCardDto[];
    countOpeningBalance: number;
    qtyOpeningBalance: number;
    countPurchase: number;
    qtyPurchase: number;
    countSale: number;
    qtySale: number;
    countReturn: number;
    qtyReturn: number;
    countTransfer: number;
    qtyTransfer: number;
    countCountedStocks: number;
    qtyCountedStocks: number;
    storeId: number;
    productId: number;

    constructor(data?: IProductCardReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.total = data["total"];
            if (data["productCards"] && data["productCards"].constructor === Array) {
                this.productCards = [];
                for (let item of data["productCards"])
                    this.productCards.push(ProductCardDto.fromJS(item));
            }
            this.countOpeningBalance = data["countOpeningBalance"];
            this.qtyOpeningBalance = data["qtyOpeningBalance"];
            this.countPurchase = data["countPurchase"];
            this.qtyPurchase = data["qtyPurchase"];
            this.countSale = data["countSale"];
            this.qtySale = data["qtySale"];
            this.countReturn = data["countReturn"];
            this.qtyReturn = data["qtyReturn"];
            this.countTransfer = data["countTransfer"];
            this.qtyTransfer = data["qtyTransfer"];
            this.countCountedStocks = data["countCountedStocks"];
            this.qtyCountedStocks = data["qtyCountedStocks"];
            this.storeId = data["storeId"];
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): ProductCardReportDto {
        let result = new ProductCardReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["total"] = this.total;
        if (this.productCards && this.productCards.constructor === Array) {
            data["productCards"] = [];
            for (let item of this.productCards)
                data["productCards"].push(item.toJSON());
        }
        data["countOpeningBalance"] = this.countOpeningBalance;
        data["qtyOpeningBalance"] = this.qtyOpeningBalance;
        data["countPurchase"] = this.countPurchase;
        data["qtyPurchase"] = this.qtyPurchase;
        data["countSale"] = this.countSale;
        data["qtySale"] = this.qtySale;
        data["countReturn"] = this.countReturn;
        data["qtyReturn"] = this.qtyReturn;
        data["countTransfer"] = this.countTransfer;
        data["qtyTransfer"] = this.qtyTransfer;
        data["countCountedStocks"] = this.countCountedStocks;
        data["qtyCountedStocks"] = this.qtyCountedStocks;
        data["storeId"] = this.storeId;
        data["productId"] = this.productId;
        return data; 
    }
}

export interface IProductCardReportDto {
    pageCount: number;
    currentPage: number;
    total: number;
    productCards: ProductCardDto[];
    countOpeningBalance: number;
    qtyOpeningBalance: number;
    countPurchase: number;
    qtyPurchase: number;
    countSale: number;
    qtySale: number;
    countReturn: number;
    qtyReturn: number;
    countTransfer: number;
    qtyTransfer: number;
    countCountedStocks: number;
    qtyCountedStocks: number;
    storeId: number;
    productId: number;
}

export class ProductCardDto implements IProductCardDto {
    productName: string;
    storeName: string;
    userName: string;
    fromStoreName: string;
    toStoreName: string;
    quantity: number;
    operationType: ProductCardDtoOperationType;
    operationDate: moment.Moment;
    productId: number;
    storeId: number;
    variant: string;
    unit: string;
    operationDateText: string;

    constructor(data?: IProductCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productName = data["productName"];
            this.storeName = data["storeName"];
            this.userName = data["userName"];
            this.fromStoreName = data["fromStoreName"];
            this.toStoreName = data["toStoreName"];
            this.quantity = data["quantity"];
            this.operationType = data["operationType"];
            this.operationDate = data["operationDate"] ? moment(data["operationDate"].toString()) : <any>undefined;
            this.productId = data["productId"];
            this.storeId = data["storeId"];
            this.variant = data["variant"];
            this.unit = data["unit"];
            this.operationDateText = data["operationDateText"];
        }
    }

    static fromJS(data: any): ProductCardDto {
        let result = new ProductCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["storeName"] = this.storeName;
        data["userName"] = this.userName;
        data["fromStoreName"] = this.fromStoreName;
        data["toStoreName"] = this.toStoreName;
        data["quantity"] = this.quantity;
        data["operationType"] = this.operationType;
        data["operationDate"] = this.operationDate ? this.operationDate.toISOString() : <any>undefined;
        data["productId"] = this.productId;
        data["storeId"] = this.storeId;
        data["variant"] = this.variant;
        data["unit"] = this.unit;
        data["operationDateText"] = this.operationDateText;
        return data; 
    }
}

export interface IProductCardDto {
    productName: string;
    storeName: string;
    userName: string;
    fromStoreName: string;
    toStoreName: string;
    quantity: number;
    operationType: ProductCardDtoOperationType;
    operationDate: moment.Moment;
    productId: number;
    storeId: number;
    variant: string;
    unit: string;
    operationDateText: string;
}

export class ProductMovementInput implements IProductMovementInput {
    products: number[];
    stores: number[];
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IProductMovementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(item);
            }
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(item);
            }
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.referenceNumber = data["referenceNumber"];
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ProductMovementInput {
        let result = new ProductMovementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IProductMovementInput {
    products: number[];
    stores: number[];
    from: moment.Moment;
    to: moment.Moment;
    referenceNumber: string;
    documentType: number;
    isCSVFile: boolean;
}

export class ProductMovementReportDto implements IProductMovementReportDto {
    pageCount: number;
    currentPage: number;
    total: number;
    productMovements: ProductMovementDto[];

    constructor(data?: IProductMovementReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.total = data["total"];
            if (data["productMovements"] && data["productMovements"].constructor === Array) {
                this.productMovements = [];
                for (let item of data["productMovements"])
                    this.productMovements.push(ProductMovementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMovementReportDto {
        let result = new ProductMovementReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["total"] = this.total;
        if (this.productMovements && this.productMovements.constructor === Array) {
            data["productMovements"] = [];
            for (let item of this.productMovements)
                data["productMovements"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductMovementReportDto {
    pageCount: number;
    currentPage: number;
    total: number;
    productMovements: ProductMovementDto[];
}

export class ProductMovementDto implements IProductMovementDto {
    productName: string;
    storeName: string;
    barCode: string;
    referenceNumber: string;
    expiryDate: string;
    currentStock: string;
    operationDate: moment.Moment;
    operationType: ProductMovementDtoOperationType;
    productId: number;
    storeId: number;
    quantity: number;
    productVariantId: number;
    unitOfMeasureId: number;
    operationDateText: string;
    productTransaction: ProductCardReportDto[];

    constructor(data?: IProductMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productName = data["productName"];
            this.storeName = data["storeName"];
            this.barCode = data["barCode"];
            this.referenceNumber = data["referenceNumber"];
            this.expiryDate = data["expiryDate"];
            this.currentStock = data["currentStock"];
            this.operationDate = data["operationDate"] ? moment(data["operationDate"].toString()) : <any>undefined;
            this.operationType = data["operationType"];
            this.productId = data["productId"];
            this.storeId = data["storeId"];
            this.quantity = data["quantity"];
            this.productVariantId = data["productVariantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.operationDateText = data["operationDateText"];
            if (data["productTransaction"] && data["productTransaction"].constructor === Array) {
                this.productTransaction = [];
                for (let item of data["productTransaction"])
                    this.productTransaction.push(ProductCardReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMovementDto {
        let result = new ProductMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["storeName"] = this.storeName;
        data["barCode"] = this.barCode;
        data["referenceNumber"] = this.referenceNumber;
        data["expiryDate"] = this.expiryDate;
        data["currentStock"] = this.currentStock;
        data["operationDate"] = this.operationDate ? this.operationDate.toISOString() : <any>undefined;
        data["operationType"] = this.operationType;
        data["productId"] = this.productId;
        data["storeId"] = this.storeId;
        data["quantity"] = this.quantity;
        data["productVariantId"] = this.productVariantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["operationDateText"] = this.operationDateText;
        if (this.productTransaction && this.productTransaction.constructor === Array) {
            data["productTransaction"] = [];
            for (let item of this.productTransaction)
                data["productTransaction"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductMovementDto {
    productName: string;
    storeName: string;
    barCode: string;
    referenceNumber: string;
    expiryDate: string;
    currentStock: string;
    operationDate: moment.Moment;
    operationType: ProductMovementDtoOperationType;
    productId: number;
    storeId: number;
    quantity: number;
    productVariantId: number;
    unitOfMeasureId: number;
    operationDateText: string;
    productTransaction: ProductCardReportDto[];
}

export class MenuItemTrendingInput implements IMenuItemTrendingInput {
    from: moment.Moment;
    to: moment.Moment;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    productsNumber: number;
    storeIds: number[];
    isCSVFile: boolean;

    constructor(data?: IMenuItemTrendingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.productsNumber = data["productsNumber"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): MenuItemTrendingInput {
        let result = new MenuItemTrendingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["productsNumber"] = this.productsNumber;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IMenuItemTrendingInput {
    from: moment.Moment;
    to: moment.Moment;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    productsNumber: number;
    storeIds: number[];
    isCSVFile: boolean;
}

export class KDSPerformaceInput implements IKDSPerformaceInput {
    tenants: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isEndOfDay: boolean;

    constructor(data?: IKDSPerformaceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenants"] && data["tenants"].constructor === Array) {
                this.tenants = [];
                for (let item of data["tenants"])
                    this.tenants.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.isEndOfDay = data["isEndOfDay"];
        }
    }

    static fromJS(data: any): KDSPerformaceInput {
        let result = new KDSPerformaceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenants && this.tenants.constructor === Array) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["isEndOfDay"] = this.isEndOfDay;
        return data; 
    }
}

export interface IKDSPerformaceInput {
    tenants: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isEndOfDay: boolean;
}

export class KDSOrderLifecycleSamplesPage implements IKDSOrderLifecycleSamplesPage {
    data: KDSOrderLifecycleSamplesRowDto[];
    pageNumber: number;
    totalCounts: number;

    constructor(data?: IKDSOrderLifecycleSamplesPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(KDSOrderLifecycleSamplesRowDto.fromJS(item));
            }
            this.pageNumber = data["pageNumber"];
            this.totalCounts = data["totalCounts"];
        }
    }

    static fromJS(data: any): KDSOrderLifecycleSamplesPage {
        let result = new KDSOrderLifecycleSamplesPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalCounts"] = this.totalCounts;
        return data; 
    }
}

export interface IKDSOrderLifecycleSamplesPage {
    data: KDSOrderLifecycleSamplesRowDto[];
    pageNumber: number;
    totalCounts: number;
}

export class KDSOrderLifecycleSamplesRowDto implements IKDSOrderLifecycleSamplesRowDto {
    tenantName: string;
    orderId: string;
    orderNo: string;
    branch: string;
    orderType: string;
    received: string;
    stations: { [key: string] : string; };
    total: string;
    status: string;

    constructor(data?: IKDSOrderLifecycleSamplesRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.orderId = data["orderId"];
            this.orderNo = data["orderNo"];
            this.branch = data["branch"];
            this.orderType = data["orderType"];
            this.received = data["received"];
            if (data["stations"]) {
                this.stations = {};
                for (let key in data["stations"]) {
                    if (data["stations"].hasOwnProperty(key))
                        this.stations[key] = data["stations"][key];
                }
            }
            this.total = data["total"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): KDSOrderLifecycleSamplesRowDto {
        let result = new KDSOrderLifecycleSamplesRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["orderId"] = this.orderId;
        data["orderNo"] = this.orderNo;
        data["branch"] = this.branch;
        data["orderType"] = this.orderType;
        data["received"] = this.received;
        if (this.stations) {
            data["stations"] = {};
            for (let key in this.stations) {
                if (this.stations.hasOwnProperty(key))
                    data["stations"][key] = this.stations[key];
            }
        }
        data["total"] = this.total;
        data["status"] = this.status;
        return data; 
    }
}

export interface IKDSOrderLifecycleSamplesRowDto {
    tenantName: string;
    orderId: string;
    orderNo: string;
    branch: string;
    orderType: string;
    received: string;
    stations: { [key: string] : string; };
    total: string;
    status: string;
}

export class KDSPerformanceReportPage implements IKDSPerformanceReportPage {
    cards: KDSPerformanceReportCardsDto;
    data: KDSPerformanceReportDto[];
    pageNumber: number;
    totalCounts: number;

    constructor(data?: IKDSPerformanceReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cards = data["cards"] ? KDSPerformanceReportCardsDto.fromJS(data["cards"]) : <any>undefined;
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(KDSPerformanceReportDto.fromJS(item));
            }
            this.pageNumber = data["pageNumber"];
            this.totalCounts = data["totalCounts"];
        }
    }

    static fromJS(data: any): KDSPerformanceReportPage {
        let result = new KDSPerformanceReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cards"] = this.cards ? this.cards.toJSON() : <any>undefined;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalCounts"] = this.totalCounts;
        return data; 
    }
}

export interface IKDSPerformanceReportPage {
    cards: KDSPerformanceReportCardsDto;
    data: KDSPerformanceReportDto[];
    pageNumber: number;
    totalCounts: number;
}

export class KDSPerformanceReportCardsDto implements IKDSPerformanceReportCardsDto {
    stationsMonitored: number;
    stationsNames: string;
    highestLoadStation: string;
    highestLoadItems: number;
    slowestStation: string;
    slowestStationAvgTime: string;
    mostDelaysStation: string;
    mostDelaysCount: number;
    expeditorAvgTime: string;
    expeditorTargetTime: string;

    constructor(data?: IKDSPerformanceReportCardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stationsMonitored = data["stationsMonitored"];
            this.stationsNames = data["stationsNames"];
            this.highestLoadStation = data["highestLoadStation"];
            this.highestLoadItems = data["highestLoadItems"];
            this.slowestStation = data["slowestStation"];
            this.slowestStationAvgTime = data["slowestStationAvgTime"];
            this.mostDelaysStation = data["mostDelaysStation"];
            this.mostDelaysCount = data["mostDelaysCount"];
            this.expeditorAvgTime = data["expeditorAvgTime"];
            this.expeditorTargetTime = data["expeditorTargetTime"];
        }
    }

    static fromJS(data: any): KDSPerformanceReportCardsDto {
        let result = new KDSPerformanceReportCardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stationsMonitored"] = this.stationsMonitored;
        data["stationsNames"] = this.stationsNames;
        data["highestLoadStation"] = this.highestLoadStation;
        data["highestLoadItems"] = this.highestLoadItems;
        data["slowestStation"] = this.slowestStation;
        data["slowestStationAvgTime"] = this.slowestStationAvgTime;
        data["mostDelaysStation"] = this.mostDelaysStation;
        data["mostDelaysCount"] = this.mostDelaysCount;
        data["expeditorAvgTime"] = this.expeditorAvgTime;
        data["expeditorTargetTime"] = this.expeditorTargetTime;
        return data; 
    }
}

export interface IKDSPerformanceReportCardsDto {
    stationsMonitored: number;
    stationsNames: string;
    highestLoadStation: string;
    highestLoadItems: number;
    slowestStation: string;
    slowestStationAvgTime: string;
    mostDelaysStation: string;
    mostDelaysCount: number;
    expeditorAvgTime: string;
    expeditorTargetTime: string;
}

export class KDSPerformanceReportDto implements IKDSPerformanceReportDto {
    tenantName: string;
    kdsName: string;
    itemsOrders: number;
    targetTime: string;
    avgTime: string;
    onTime: number;
    delayedTasks: number;

    constructor(data?: IKDSPerformanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.kdsName = data["kdsName"];
            this.itemsOrders = data["itemsOrders"];
            this.targetTime = data["targetTime"];
            this.avgTime = data["avgTime"];
            this.onTime = data["onTime"];
            this.delayedTasks = data["delayedTasks"];
        }
    }

    static fromJS(data: any): KDSPerformanceReportDto {
        let result = new KDSPerformanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["kdsName"] = this.kdsName;
        data["itemsOrders"] = this.itemsOrders;
        data["targetTime"] = this.targetTime;
        data["avgTime"] = this.avgTime;
        data["onTime"] = this.onTime;
        data["delayedTasks"] = this.delayedTasks;
        return data; 
    }
}

export interface IKDSPerformanceReportDto {
    tenantName: string;
    kdsName: string;
    itemsOrders: number;
    targetTime: string;
    avgTime: string;
    onTime: number;
    delayedTasks: number;
}

export class TotalSalesByModifiersReportInput implements ITotalSalesByModifiersReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isBusinessDate: boolean;
    isCSVFile: boolean;
    documentType: number;

    constructor(data?: ITotalSalesByModifiersReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantsIds"] && data["tenantsIds"].constructor === Array) {
                this.tenantsIds = [];
                for (let item of data["tenantsIds"])
                    this.tenantsIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.isBusinessDate = data["isBusinessDate"];
            this.isCSVFile = data["isCSVFile"];
            this.documentType = data["documentType"];
        }
    }

    static fromJS(data: any): TotalSalesByModifiersReportInput {
        let result = new TotalSalesByModifiersReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantsIds && this.tenantsIds.constructor === Array) {
            data["tenantsIds"] = [];
            for (let item of this.tenantsIds)
                data["tenantsIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["isBusinessDate"] = this.isBusinessDate;
        data["isCSVFile"] = this.isCSVFile;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface ITotalSalesByModifiersReportInput {
    tenantsIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isBusinessDate: boolean;
    isCSVFile: boolean;
    documentType: number;
}

export class TotalSalesByModifiersReportPage implements ITotalSalesByModifiersReportPage {
    items: TotalSalesByModifiersReportListItem[];
    totalCount: number;
    pageNumber: number;
    totalModifierCount: number;
    totalPriceBeforeVat: number;
    totalPriceAfterVat: number;
    totalVat: number;

    constructor(data?: ITotalSalesByModifiersReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TotalSalesByModifiersReportListItem.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalModifierCount = data["totalModifierCount"];
            this.totalPriceBeforeVat = data["totalPriceBeforeVat"];
            this.totalPriceAfterVat = data["totalPriceAfterVat"];
            this.totalVat = data["totalVat"];
        }
    }

    static fromJS(data: any): TotalSalesByModifiersReportPage {
        let result = new TotalSalesByModifiersReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalModifierCount"] = this.totalModifierCount;
        data["totalPriceBeforeVat"] = this.totalPriceBeforeVat;
        data["totalPriceAfterVat"] = this.totalPriceAfterVat;
        data["totalVat"] = this.totalVat;
        return data; 
    }
}

export interface ITotalSalesByModifiersReportPage {
    items: TotalSalesByModifiersReportListItem[];
    totalCount: number;
    pageNumber: number;
    totalModifierCount: number;
    totalPriceBeforeVat: number;
    totalPriceAfterVat: number;
    totalVat: number;
}

export class TotalSalesByModifiersReportListItem implements ITotalSalesByModifiersReportListItem {
    tenantName: string;
    storeId: number;
    storeCode: string;
    storeName: string;
    modifierId: number;
    modifierCode: string;
    modifierName: string;
    totalCount: number;
    priceBeforeVat: number;
    priceAfterVat: number;
    vat: number;

    constructor(data?: ITotalSalesByModifiersReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.storeId = data["storeId"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.modifierId = data["modifierId"];
            this.modifierCode = data["modifierCode"];
            this.modifierName = data["modifierName"];
            this.totalCount = data["totalCount"];
            this.priceBeforeVat = data["priceBeforeVat"];
            this.priceAfterVat = data["priceAfterVat"];
            this.vat = data["vat"];
        }
    }

    static fromJS(data: any): TotalSalesByModifiersReportListItem {
        let result = new TotalSalesByModifiersReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["storeId"] = this.storeId;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["modifierId"] = this.modifierId;
        data["modifierCode"] = this.modifierCode;
        data["modifierName"] = this.modifierName;
        data["totalCount"] = this.totalCount;
        data["priceBeforeVat"] = this.priceBeforeVat;
        data["priceAfterVat"] = this.priceAfterVat;
        data["vat"] = this.vat;
        return data; 
    }
}

export interface ITotalSalesByModifiersReportListItem {
    tenantName: string;
    storeId: number;
    storeCode: string;
    storeName: string;
    modifierId: number;
    modifierCode: string;
    modifierName: string;
    totalCount: number;
    priceBeforeVat: number;
    priceAfterVat: number;
    vat: number;
}

export class PromotionReportFilterDto implements IPromotionReportFilterDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IPromotionReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.promotionId = data["promotionId"];
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PromotionReportFilterDto {
        let result = new PromotionReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["promotionId"] = this.promotionId;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPromotionReportFilterDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class PromotionPagedResultDto implements IPromotionPagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionListDto[];

    constructor(data?: IPromotionPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.totalTimesUsed = data["totalTimesUsed"];
            this.totalQuantity = data["totalQuantity"];
            this.totalDeducted = data["totalDeducted"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PromotionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionPagedResultDto {
        let result = new PromotionPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["totalTimesUsed"] = this.totalTimesUsed;
        data["totalQuantity"] = this.totalQuantity;
        data["totalDeducted"] = this.totalDeducted;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionPagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionListDto[];
}

export class PromotionListDto implements IPromotionListDto {
    date: moment.Moment;
    promotionName: string;
    timesUsed: number;
    quantity: number;
    totalDeducted: number;
    currency: string;
    tenderType: string;
    detailMenuItems: PromotionItemDto[];
    isShowDetail: boolean;

    constructor(data?: IPromotionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.promotionName = data["promotionName"];
            this.timesUsed = data["timesUsed"];
            this.quantity = data["quantity"];
            this.totalDeducted = data["totalDeducted"];
            this.currency = data["currency"];
            this.tenderType = data["tenderType"];
            if (data["detailMenuItems"] && data["detailMenuItems"].constructor === Array) {
                this.detailMenuItems = [];
                for (let item of data["detailMenuItems"])
                    this.detailMenuItems.push(PromotionItemDto.fromJS(item));
            }
            this.isShowDetail = data["isShowDetail"];
        }
    }

    static fromJS(data: any): PromotionListDto {
        let result = new PromotionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["promotionName"] = this.promotionName;
        data["timesUsed"] = this.timesUsed;
        data["quantity"] = this.quantity;
        data["totalDeducted"] = this.totalDeducted;
        data["currency"] = this.currency;
        data["tenderType"] = this.tenderType;
        if (this.detailMenuItems && this.detailMenuItems.constructor === Array) {
            data["detailMenuItems"] = [];
            for (let item of this.detailMenuItems)
                data["detailMenuItems"].push(item.toJSON());
        }
        data["isShowDetail"] = this.isShowDetail;
        return data; 
    }
}

export interface IPromotionListDto {
    date: moment.Moment;
    promotionName: string;
    timesUsed: number;
    quantity: number;
    totalDeducted: number;
    currency: string;
    tenderType: string;
    detailMenuItems: PromotionItemDto[];
    isShowDetail: boolean;
}

export class PromotionItemDto implements IPromotionItemDto {
    menuItemCode: string;
    menuItemName: string;
    price: number;
    quantity: number;
    menuItemId: number;

    constructor(data?: IPromotionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemCode = data["menuItemCode"];
            this.menuItemName = data["menuItemName"];
            this.price = data["price"];
            this.quantity = data["quantity"];
            this.menuItemId = data["menuItemId"];
        }
    }

    static fromJS(data: any): PromotionItemDto {
        let result = new PromotionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemCode"] = this.menuItemCode;
        data["menuItemName"] = this.menuItemName;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["menuItemId"] = this.menuItemId;
        return data; 
    }
}

export interface IPromotionItemDto {
    menuItemCode: string;
    menuItemName: string;
    price: number;
    quantity: number;
    menuItemId: number;
}

export class PromotionByTimeReportFilterDto implements IPromotionByTimeReportFilterDto {
    timeUnits: PromotionByTimeReportFilterDtoTimeUnits;
    timeCount: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IPromotionByTimeReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeUnits = data["timeUnits"];
            this.timeCount = data["timeCount"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.promotionId = data["promotionId"];
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PromotionByTimeReportFilterDto {
        let result = new PromotionByTimeReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeUnits"] = this.timeUnits;
        data["timeCount"] = this.timeCount;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["promotionId"] = this.promotionId;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPromotionByTimeReportFilterDto {
    timeUnits: PromotionByTimeReportFilterDtoTimeUnits;
    timeCount: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class PromotionByDatePagedResultDto implements IPromotionByDatePagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionByDateListDto[];

    constructor(data?: IPromotionByDatePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.totalTimesUsed = data["totalTimesUsed"];
            this.totalQuantity = data["totalQuantity"];
            this.totalDeducted = data["totalDeducted"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PromotionByDateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionByDatePagedResultDto {
        let result = new PromotionByDatePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["totalTimesUsed"] = this.totalTimesUsed;
        data["totalQuantity"] = this.totalQuantity;
        data["totalDeducted"] = this.totalDeducted;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionByDatePagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionByDateListDto[];
}

export class PromotionByDateListDto implements IPromotionByDateListDto {
    from: moment.Moment;
    to: moment.Moment;
    promotionListDtos: PromotionListDto[];

    constructor(data?: IPromotionByDateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["promotionListDtos"] && data["promotionListDtos"].constructor === Array) {
                this.promotionListDtos = [];
                for (let item of data["promotionListDtos"])
                    this.promotionListDtos.push(PromotionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionByDateListDto {
        let result = new PromotionByDateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.promotionListDtos && this.promotionListDtos.constructor === Array) {
            data["promotionListDtos"] = [];
            for (let item of this.promotionListDtos)
                data["promotionListDtos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionByDateListDto {
    from: moment.Moment;
    to: moment.Moment;
    promotionListDtos: PromotionListDto[];
}

export class PromotionByEmployeeReportFilterDto implements IPromotionByEmployeeReportFilterDto {
    employeeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IPromotionByEmployeeReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["employeeIds"] && data["employeeIds"].constructor === Array) {
                this.employeeIds = [];
                for (let item of data["employeeIds"])
                    this.employeeIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.promotionId = data["promotionId"];
            this.documentType = data["documentType"];
            this.showStoreName = data["showStoreName"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PromotionByEmployeeReportFilterDto {
        let result = new PromotionByEmployeeReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.employeeIds && this.employeeIds.constructor === Array) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["promotionId"] = this.promotionId;
        data["documentType"] = this.documentType;
        data["showStoreName"] = this.showStoreName;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPromotionByEmployeeReportFilterDto {
    employeeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class PromotionByEmployeePagedResultDto implements IPromotionByEmployeePagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionByEmployeeListDto[];

    constructor(data?: IPromotionByEmployeePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.totalTimesUsed = data["totalTimesUsed"];
            this.totalQuantity = data["totalQuantity"];
            this.totalDeducted = data["totalDeducted"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PromotionByEmployeeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionByEmployeePagedResultDto {
        let result = new PromotionByEmployeePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["totalTimesUsed"] = this.totalTimesUsed;
        data["totalQuantity"] = this.totalQuantity;
        data["totalDeducted"] = this.totalDeducted;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionByEmployeePagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionByEmployeeListDto[];
}

export class PromotionByEmployeeListDto implements IPromotionByEmployeeListDto {
    storeCode: string;
    storeName: string;
    employeeName: string;
    promotionName: string;
    timesUsed: number;
    quantity: number;
    totalDeducted: number;
    currency: string;
    details: ItemListDto[];

    constructor(data?: IPromotionByEmployeeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.employeeName = data["employeeName"];
            this.promotionName = data["promotionName"];
            this.timesUsed = data["timesUsed"];
            this.quantity = data["quantity"];
            this.totalDeducted = data["totalDeducted"];
            this.currency = data["currency"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionByEmployeeListDto {
        let result = new PromotionByEmployeeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["employeeName"] = this.employeeName;
        data["promotionName"] = this.promotionName;
        data["timesUsed"] = this.timesUsed;
        data["quantity"] = this.quantity;
        data["totalDeducted"] = this.totalDeducted;
        data["currency"] = this.currency;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionByEmployeeListDto {
    storeCode: string;
    storeName: string;
    employeeName: string;
    promotionName: string;
    timesUsed: number;
    quantity: number;
    totalDeducted: number;
    currency: string;
    details: ItemListDto[];
}

export class ItemListDto implements IItemListDto {
    itemName: string;
    quantity: number;
    totalDeducted: number;
    currency: string;

    constructor(data?: IItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemName = data["itemName"];
            this.quantity = data["quantity"];
            this.totalDeducted = data["totalDeducted"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): ItemListDto {
        let result = new ItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["quantity"] = this.quantity;
        data["totalDeducted"] = this.totalDeducted;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IItemListDto {
    itemName: string;
    quantity: number;
    totalDeducted: number;
    currency: string;
}

export class PromotionBySaleTypeReportFilterDto implements IPromotionBySaleTypeReportFilterDto {
    saleTypeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IPromotionBySaleTypeReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.promotionId = data["promotionId"];
            this.documentType = data["documentType"];
            this.showStoreName = data["showStoreName"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PromotionBySaleTypeReportFilterDto {
        let result = new PromotionBySaleTypeReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["promotionId"] = this.promotionId;
        data["documentType"] = this.documentType;
        data["showStoreName"] = this.showStoreName;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPromotionBySaleTypeReportFilterDto {
    saleTypeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class PromotionBySaleTypePagedResultDto implements IPromotionBySaleTypePagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionBySaleTypeListDto[];

    constructor(data?: IPromotionBySaleTypePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.totalTimesUsed = data["totalTimesUsed"];
            this.totalQuantity = data["totalQuantity"];
            this.totalDeducted = data["totalDeducted"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PromotionBySaleTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionBySaleTypePagedResultDto {
        let result = new PromotionBySaleTypePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["totalTimesUsed"] = this.totalTimesUsed;
        data["totalQuantity"] = this.totalQuantity;
        data["totalDeducted"] = this.totalDeducted;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionBySaleTypePagedResultDto {
    currentPage: number;
    itemsCount: number;
    totalTimesUsed: number;
    totalQuantity: number;
    totalDeducted: number;
    items: PromotionBySaleTypeListDto[];
}

export class PromotionBySaleTypeListDto implements IPromotionBySaleTypeListDto {
    storeCode: string;
    storeName: string;
    saleTypeName: string;
    promotionName: string;
    timesUsed: number;
    quantity: number;
    totalDeducted: number;
    currency: string;
    details: ItemListDto[];

    constructor(data?: IPromotionBySaleTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.saleTypeName = data["saleTypeName"];
            this.promotionName = data["promotionName"];
            this.timesUsed = data["timesUsed"];
            this.quantity = data["quantity"];
            this.totalDeducted = data["totalDeducted"];
            this.currency = data["currency"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionBySaleTypeListDto {
        let result = new PromotionBySaleTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["saleTypeName"] = this.saleTypeName;
        data["promotionName"] = this.promotionName;
        data["timesUsed"] = this.timesUsed;
        data["quantity"] = this.quantity;
        data["totalDeducted"] = this.totalDeducted;
        data["currency"] = this.currency;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionBySaleTypeListDto {
    storeCode: string;
    storeName: string;
    saleTypeName: string;
    promotionName: string;
    timesUsed: number;
    quantity: number;
    totalDeducted: number;
    currency: string;
    details: ItemListDto[];
}

export class PromotionDetailReportFilterDto implements IPromotionDetailReportFilterDto {
    saleTypeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IPromotionDetailReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.promotionId = data["promotionId"];
            this.documentType = data["documentType"];
            this.showStoreName = data["showStoreName"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PromotionDetailReportFilterDto {
        let result = new PromotionDetailReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["promotionId"] = this.promotionId;
        data["documentType"] = this.documentType;
        data["showStoreName"] = this.showStoreName;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPromotionDetailReportFilterDto {
    saleTypeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    promotionId: number;
    documentType: number;
    showStoreName: boolean;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class PromotionDetailPagedResultDto implements IPromotionDetailPagedResultDto {
    currentPage: number;
    itemsCount: number;
    total: number;
    totalVat: number;
    totalQty: number;
    items: TenantPromotionDetailListDto[];

    constructor(data?: IPromotionDetailPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            this.total = data["total"];
            this.totalVat = data["totalVat"];
            this.totalQty = data["totalQty"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantPromotionDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionDetailPagedResultDto {
        let result = new PromotionDetailPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        data["total"] = this.total;
        data["totalVat"] = this.totalVat;
        data["totalQty"] = this.totalQty;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionDetailPagedResultDto {
    currentPage: number;
    itemsCount: number;
    total: number;
    totalVat: number;
    totalQty: number;
    items: TenantPromotionDetailListDto[];
}

export class TenantPromotionDetailListDto implements ITenantPromotionDetailListDto {
    tenantId: number;
    tenantName: string;
    totalVat: number;
    total: number;
    totalQty: number;
    data: PromotionDetailListDto[];

    constructor(data?: ITenantPromotionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.totalVat = data["totalVat"];
            this.total = data["total"];
            this.totalQty = data["totalQty"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(PromotionDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantPromotionDetailListDto {
        let result = new TenantPromotionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["totalVat"] = this.totalVat;
        data["total"] = this.total;
        data["totalQty"] = this.totalQty;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantPromotionDetailListDto {
    tenantId: number;
    tenantName: string;
    totalVat: number;
    total: number;
    totalQty: number;
    data: PromotionDetailListDto[];
}

export class PromotionDetailListDto implements IPromotionDetailListDto {
    storeCode: string;
    storeName: string;
    saleTypeName: string;
    promotionName: string;
    price: number;
    vat: number;
    total: number;
    cost: number;
    currency: string;
    timesUsed: number;
    promotionCodeId: number;
    saleTypeId: number;
    storeId: number;
    totalQty: number;
    tenantId: number;
    tenantName: string;
    details: ItemDetailListDto[];

    constructor(data?: IPromotionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.saleTypeName = data["saleTypeName"];
            this.promotionName = data["promotionName"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.cost = data["cost"];
            this.currency = data["currency"];
            this.timesUsed = data["timesUsed"];
            this.promotionCodeId = data["promotionCodeId"];
            this.saleTypeId = data["saleTypeId"];
            this.storeId = data["storeId"];
            this.totalQty = data["totalQty"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ItemDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionDetailListDto {
        let result = new PromotionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["saleTypeName"] = this.saleTypeName;
        data["promotionName"] = this.promotionName;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["cost"] = this.cost;
        data["currency"] = this.currency;
        data["timesUsed"] = this.timesUsed;
        data["promotionCodeId"] = this.promotionCodeId;
        data["saleTypeId"] = this.saleTypeId;
        data["storeId"] = this.storeId;
        data["totalQty"] = this.totalQty;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPromotionDetailListDto {
    storeCode: string;
    storeName: string;
    saleTypeName: string;
    promotionName: string;
    price: number;
    vat: number;
    total: number;
    cost: number;
    currency: string;
    timesUsed: number;
    promotionCodeId: number;
    saleTypeId: number;
    storeId: number;
    totalQty: number;
    tenantId: number;
    tenantName: string;
    details: ItemDetailListDto[];
}

export class ItemDetailListDto implements IItemDetailListDto {
    itemCode: string;
    itemName: string;
    price: number;
    quantity: number;
    total: number;
    vat: number;
    promotionCodeId: number;
    saleTypeId: number;
    storeId: number;
    menuItemId: number;
    tenantId: number;
    tenantName: string;

    constructor(data?: IItemDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.price = data["price"];
            this.quantity = data["quantity"];
            this.total = data["total"];
            this.vat = data["vat"];
            this.promotionCodeId = data["promotionCodeId"];
            this.saleTypeId = data["saleTypeId"];
            this.storeId = data["storeId"];
            this.menuItemId = data["menuItemId"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): ItemDetailListDto {
        let result = new ItemDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["vat"] = this.vat;
        data["promotionCodeId"] = this.promotionCodeId;
        data["saleTypeId"] = this.saleTypeId;
        data["storeId"] = this.storeId;
        data["menuItemId"] = this.menuItemId;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface IItemDetailListDto {
    itemCode: string;
    itemName: string;
    price: number;
    quantity: number;
    total: number;
    vat: number;
    promotionCodeId: number;
    saleTypeId: number;
    storeId: number;
    menuItemId: number;
    tenantId: number;
    tenantName: string;
}

export class RawMaterialVariantReportFilterDto implements IRawMaterialVariantReportFilterDto {
    storeIds: number[];
    matrialId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    documentType: number;
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: IRawMaterialVariantReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.matrialId = data["matrialId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.documentType = data["documentType"];
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): RawMaterialVariantReportFilterDto {
        let result = new RawMaterialVariantReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["matrialId"] = this.matrialId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["documentType"] = this.documentType;
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IRawMaterialVariantReportFilterDto {
    storeIds: number[];
    matrialId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    documentType: number;
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class RawMaterialVariantPagedDto implements IRawMaterialVariantPagedDto {
    currentPage: number;
    itemsCount: number;
    items: RawMaterialVariantDto[];

    constructor(data?: IRawMaterialVariantPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RawMaterialVariantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawMaterialVariantPagedDto {
        let result = new RawMaterialVariantPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRawMaterialVariantPagedDto {
    currentPage: number;
    itemsCount: number;
    items: RawMaterialVariantDto[];
}

export class RawMaterialVariantDto implements IRawMaterialVariantDto {
    date: moment.Moment;
    storeCode: string;
    storeName: string;
    materialCode: string;
    materialName: string;
    inventoryUnitOfMeasureName: string;
    actualStock: number;
    countedStock: number;
    variant: number;

    constructor(data?: IRawMaterialVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.inventoryUnitOfMeasureName = data["inventoryUnitOfMeasureName"];
            this.actualStock = data["actualStock"];
            this.countedStock = data["countedStock"];
            this.variant = data["variant"];
        }
    }

    static fromJS(data: any): RawMaterialVariantDto {
        let result = new RawMaterialVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["inventoryUnitOfMeasureName"] = this.inventoryUnitOfMeasureName;
        data["actualStock"] = this.actualStock;
        data["countedStock"] = this.countedStock;
        data["variant"] = this.variant;
        return data; 
    }
}

export interface IRawMaterialVariantDto {
    date: moment.Moment;
    storeCode: string;
    storeName: string;
    materialCode: string;
    materialName: string;
    inventoryUnitOfMeasureName: string;
    actualStock: number;
    countedStock: number;
    variant: number;
}

export class PurchasingVsSalesQtyReportFilterDto implements IPurchasingVsSalesQtyReportFilterDto {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    documentType: number;
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: IPurchasingVsSalesQtyReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["matrialIds"] && data["matrialIds"].constructor === Array) {
                this.matrialIds = [];
                for (let item of data["matrialIds"])
                    this.matrialIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.documentType = data["documentType"];
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PurchasingVsSalesQtyReportFilterDto {
        let result = new PurchasingVsSalesQtyReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.matrialIds && this.matrialIds.constructor === Array) {
            data["matrialIds"] = [];
            for (let item of this.matrialIds)
                data["matrialIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["documentType"] = this.documentType;
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPurchasingVsSalesQtyReportFilterDto {
    storeIds: number[];
    matrialIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    tenantId: number;
    regionId: number;
    areaId: number;
    documentType: number;
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class PurchasingVsSalesQtyPagedDto implements IPurchasingVsSalesQtyPagedDto {
    currentPage: number;
    itemsCount: number;
    items: PurchasingVsSalesQtyGroupDto[];

    constructor(data?: IPurchasingVsSalesQtyPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PurchasingVsSalesQtyGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchasingVsSalesQtyPagedDto {
        let result = new PurchasingVsSalesQtyPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPurchasingVsSalesQtyPagedDto {
    currentPage: number;
    itemsCount: number;
    items: PurchasingVsSalesQtyGroupDto[];
}

export class PurchasingVsSalesQtyGroupDto implements IPurchasingVsSalesQtyGroupDto {
    tenantName: string;
    storesData: PurchasingVsSalesQtyDto[];

    constructor(data?: IPurchasingVsSalesQtyGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["storesData"] && data["storesData"].constructor === Array) {
                this.storesData = [];
                for (let item of data["storesData"])
                    this.storesData.push(PurchasingVsSalesQtyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchasingVsSalesQtyGroupDto {
        let result = new PurchasingVsSalesQtyGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.storesData && this.storesData.constructor === Array) {
            data["storesData"] = [];
            for (let item of this.storesData)
                data["storesData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPurchasingVsSalesQtyGroupDto {
    tenantName: string;
    storesData: PurchasingVsSalesQtyDto[];
}

export class PurchasingVsSalesQtyDto implements IPurchasingVsSalesQtyDto {
    tenantName: string;
    storeCode: string;
    storeName: string;
    materialCode: string;
    materialName: string;
    purchaseQty: number;
    saleQty: number;
    diffrance: number;

    constructor(data?: IPurchasingVsSalesQtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.purchaseQty = data["purchaseQty"];
            this.saleQty = data["saleQty"];
            this.diffrance = data["diffrance"];
        }
    }

    static fromJS(data: any): PurchasingVsSalesQtyDto {
        let result = new PurchasingVsSalesQtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["purchaseQty"] = this.purchaseQty;
        data["saleQty"] = this.saleQty;
        data["diffrance"] = this.diffrance;
        return data; 
    }
}

export interface IPurchasingVsSalesQtyDto {
    tenantName: string;
    storeCode: string;
    storeName: string;
    materialCode: string;
    materialName: string;
    purchaseQty: number;
    saleQty: number;
    diffrance: number;
}

export class ShortOverReportInput implements IShortOverReportInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    showStoreName: boolean;
    closeShiftMethod: ShortOverReportInputCloseShiftMethod;
    isCSVFile: boolean;

    constructor(data?: IShortOverReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            this.documentType = data["documentType"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.closeShiftMethod = data["closeShiftMethod"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ShortOverReportInput {
        let result = new ShortOverReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["documentType"] = this.documentType;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["closeShiftMethod"] = this.closeShiftMethod;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IShortOverReportInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    documentType: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    showStoreName: boolean;
    closeShiftMethod: ShortOverReportInputCloseShiftMethod;
    isCSVFile: boolean;
}

export class ShortOverReportDto implements IShortOverReportDto {
    pageCount: number;
    summationShortOver: number;
    currency: string;
    currentPage: number;
    shortOverSummation: number;
    details: ShortOverReportDetailsDto[];

    constructor(data?: IShortOverReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationShortOver = data["summationShortOver"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.shortOverSummation = data["shortOverSummation"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ShortOverReportDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShortOverReportDto {
        let result = new ShortOverReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationShortOver"] = this.summationShortOver;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["shortOverSummation"] = this.shortOverSummation;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShortOverReportDto {
    pageCount: number;
    summationShortOver: number;
    currency: string;
    currentPage: number;
    shortOverSummation: number;
    details: ShortOverReportDetailsDto[];
}

export class ShortOverReportDetailsDto implements IShortOverReportDetailsDto {
    cashierShiftId: number;
    storeNumber: string;
    storeName: string;
    cashierCode: string;
    cashierName: string;
    shortOver: number;
    startedOn: string;
    endedOn: string;

    constructor(data?: IShortOverReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cashierShiftId = data["cashierShiftId"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.cashierCode = data["cashierCode"];
            this.cashierName = data["cashierName"];
            this.shortOver = data["shortOver"];
            this.startedOn = data["startedOn"];
            this.endedOn = data["endedOn"];
        }
    }

    static fromJS(data: any): ShortOverReportDetailsDto {
        let result = new ShortOverReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierShiftId"] = this.cashierShiftId;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["cashierCode"] = this.cashierCode;
        data["cashierName"] = this.cashierName;
        data["shortOver"] = this.shortOver;
        data["startedOn"] = this.startedOn;
        data["endedOn"] = this.endedOn;
        return data; 
    }
}

export interface IShortOverReportDetailsDto {
    cashierShiftId: number;
    storeNumber: string;
    storeName: string;
    cashierCode: string;
    cashierName: string;
    shortOver: number;
    startedOn: string;
    endedOn: string;
}

export class ShortOverDetailsReportInput implements IShortOverDetailsReportInput {
    tenantId: number;
    cashierShiftId: number;
    closeShiftMethod: ShortOverDetailsReportInputCloseShiftMethod;
    documentType: number;
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: IShortOverDetailsReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.closeShiftMethod = data["closeShiftMethod"];
            this.documentType = data["documentType"];
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): ShortOverDetailsReportInput {
        let result = new ShortOverDetailsReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["closeShiftMethod"] = this.closeShiftMethod;
        data["documentType"] = this.documentType;
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IShortOverDetailsReportInput {
    tenantId: number;
    cashierShiftId: number;
    closeShiftMethod: ShortOverDetailsReportInputCloseShiftMethod;
    documentType: number;
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class ShortOverDetailsPagedDto implements IShortOverDetailsPagedDto {
    pageCount: number;
    currentPage: number;
    items: ShortOverDetailsListDto[];

    constructor(data?: IShortOverDetailsPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ShortOverDetailsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShortOverDetailsPagedDto {
        let result = new ShortOverDetailsPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShortOverDetailsPagedDto {
    pageCount: number;
    currentPage: number;
    items: ShortOverDetailsListDto[];
}

export class ShortOverDetailsListDto implements IShortOverDetailsListDto {
    tenderTypeCode: string;
    tenderTypeName: string;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    shortOver: number;

    constructor(data?: IShortOverDetailsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeCode = data["tenderTypeCode"];
            this.tenderTypeName = data["tenderTypeName"];
            this.actualTransactionsValue = data["actualTransactionsValue"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.shortOver = data["shortOver"];
        }
    }

    static fromJS(data: any): ShortOverDetailsListDto {
        let result = new ShortOverDetailsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeCode"] = this.tenderTypeCode;
        data["tenderTypeName"] = this.tenderTypeName;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["shortOver"] = this.shortOver;
        return data; 
    }
}

export interface IShortOverDetailsListDto {
    tenderTypeCode: string;
    tenderTypeName: string;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    shortOver: number;
}

export class BalanceReportInput implements IBalanceReportInput {
    from: moment.Moment;
    to: moment.Moment;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
    sorting: string;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IBalanceReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.orderNumber = data["orderNumber"];
            this.customerNumber = data["customerNumber"];
            this.productInfo = data["productInfo"];
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            this.exportToExcel = data["exportToExcel"];
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.isCSVFile = data["isCSVFile"];
            this.sorting = data["sorting"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    }

    static fromJS(data: any): BalanceReportInput {
        let result = new BalanceReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["orderNumber"] = this.orderNumber;
        data["customerNumber"] = this.customerNumber;
        data["productInfo"] = this.productInfo;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["exportToExcel"] = this.exportToExcel;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["isCSVFile"] = this.isCSVFile;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface IBalanceReportInput {
    from: moment.Moment;
    to: moment.Moment;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    storeIds: number[];
    isCSVFile: boolean;
    sorting: string;
    maxResultCount: number;
    skipCount: number;
}

export class BalanceReportDto implements IBalanceReportDto {
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;
    details: BalanceReportDetailsDto[];

    constructor(data?: IBalanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.currency = data["currency"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(BalanceReportDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BalanceReportDto {
        let result = new BalanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["currency"] = this.currency;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBalanceReportDto {
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;
    details: BalanceReportDetailsDto[];
}

export class BalanceReportDetailsDto implements IBalanceReportDetailsDto {
    id: string;
    date: string;
    recieptNumber: string;
    storeName: string;
    customerName: string;
    total: number;
    currency: string;
    cashierName: string;

    constructor(data?: IBalanceReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.date = data["date"];
            this.recieptNumber = data["recieptNumber"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.total = data["total"];
            this.currency = data["currency"];
            this.cashierName = data["cashierName"];
        }
    }

    static fromJS(data: any): BalanceReportDetailsDto {
        let result = new BalanceReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["recieptNumber"] = this.recieptNumber;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["total"] = this.total;
        data["currency"] = this.currency;
        data["cashierName"] = this.cashierName;
        return data; 
    }
}

export interface IBalanceReportDetailsDto {
    id: string;
    date: string;
    recieptNumber: string;
    storeName: string;
    customerName: string;
    total: number;
    currency: string;
    cashierName: string;
}

export class AccountStatementSaleReportInput implements IAccountStatementSaleReportInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    storeIds: number[];
    customerIds: string[];
    vendorIds: number[];
    showStore: boolean;
    showCashier: boolean;
    showCustomer: boolean;
    showTenderType: boolean;
    showTaxes: boolean;
    documentType: number;
    endOfDayBusiness: boolean;
    isCSVFile: boolean;

    constructor(data?: IAccountStatementSaleReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["customerIds"] && data["customerIds"].constructor === Array) {
                this.customerIds = [];
                for (let item of data["customerIds"])
                    this.customerIds.push(item);
            }
            if (data["vendorIds"] && data["vendorIds"].constructor === Array) {
                this.vendorIds = [];
                for (let item of data["vendorIds"])
                    this.vendorIds.push(item);
            }
            this.showStore = data["showStore"];
            this.showCashier = data["showCashier"];
            this.showCustomer = data["showCustomer"];
            this.showTenderType = data["showTenderType"];
            this.showTaxes = data["showTaxes"];
            this.documentType = data["documentType"];
            this.endOfDayBusiness = data["endOfDayBusiness"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): AccountStatementSaleReportInput {
        let result = new AccountStatementSaleReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.customerIds && this.customerIds.constructor === Array) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        if (this.vendorIds && this.vendorIds.constructor === Array) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["showStore"] = this.showStore;
        data["showCashier"] = this.showCashier;
        data["showCustomer"] = this.showCustomer;
        data["showTenderType"] = this.showTenderType;
        data["showTaxes"] = this.showTaxes;
        data["documentType"] = this.documentType;
        data["endOfDayBusiness"] = this.endOfDayBusiness;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IAccountStatementSaleReportInput {
    from: moment.Moment;
    to: moment.Moment;
    employees: number[];
    storeIds: number[];
    customerIds: string[];
    vendorIds: number[];
    showStore: boolean;
    showCashier: boolean;
    showCustomer: boolean;
    showTenderType: boolean;
    showTaxes: boolean;
    documentType: number;
    endOfDayBusiness: boolean;
    isCSVFile: boolean;
}

export class AccountStatementSaleReportDto implements IAccountStatementSaleReportDto {
    pageCount: number;
    summationGrandTotal: number;
    summationSubTotal: number;
    summationTaxes: number;
    currency: string;
    currentPage: number;
    showStore: boolean;
    showCashier: boolean;
    showCustomer: boolean;
    showTenderType: boolean;
    showTaxes: boolean;
    collabsCount: number;
    details: AccountStatementSaleReportDetailsDto[];

    constructor(data?: IAccountStatementSaleReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageCount = data["pageCount"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.summationSubTotal = data["summationSubTotal"];
            this.summationTaxes = data["summationTaxes"];
            this.currency = data["currency"];
            this.currentPage = data["currentPage"];
            this.showStore = data["showStore"];
            this.showCashier = data["showCashier"];
            this.showCustomer = data["showCustomer"];
            this.showTenderType = data["showTenderType"];
            this.showTaxes = data["showTaxes"];
            this.collabsCount = data["collabsCount"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(AccountStatementSaleReportDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountStatementSaleReportDto {
        let result = new AccountStatementSaleReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["summationSubTotal"] = this.summationSubTotal;
        data["summationTaxes"] = this.summationTaxes;
        data["currency"] = this.currency;
        data["currentPage"] = this.currentPage;
        data["showStore"] = this.showStore;
        data["showCashier"] = this.showCashier;
        data["showCustomer"] = this.showCustomer;
        data["showTenderType"] = this.showTenderType;
        data["showTaxes"] = this.showTaxes;
        data["collabsCount"] = this.collabsCount;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAccountStatementSaleReportDto {
    pageCount: number;
    summationGrandTotal: number;
    summationSubTotal: number;
    summationTaxes: number;
    currency: string;
    currentPage: number;
    showStore: boolean;
    showCashier: boolean;
    showCustomer: boolean;
    showTenderType: boolean;
    showTaxes: boolean;
    collabsCount: number;
    details: AccountStatementSaleReportDetailsDto[];
}

export class AccountStatementSaleReportDetailsDto implements IAccountStatementSaleReportDetailsDto {
    storeName: string;
    cashierName: string;
    customerName: string;
    date: string;
    tenderNames: string;
    subTotal: number;
    taxes: number;
    tax: number;
    grandTotal: number;
    currency: string;

    constructor(data?: IAccountStatementSaleReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeName = data["storeName"];
            this.cashierName = data["cashierName"];
            this.customerName = data["customerName"];
            this.date = data["date"];
            this.tenderNames = data["tenderNames"];
            this.subTotal = data["subTotal"];
            this.taxes = data["taxes"];
            this.tax = data["tax"];
            this.grandTotal = data["grandTotal"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): AccountStatementSaleReportDetailsDto {
        let result = new AccountStatementSaleReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["cashierName"] = this.cashierName;
        data["customerName"] = this.customerName;
        data["date"] = this.date;
        data["tenderNames"] = this.tenderNames;
        data["subTotal"] = this.subTotal;
        data["taxes"] = this.taxes;
        data["tax"] = this.tax;
        data["grandTotal"] = this.grandTotal;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IAccountStatementSaleReportDetailsDto {
    storeName: string;
    cashierName: string;
    customerName: string;
    date: string;
    tenderNames: string;
    subTotal: number;
    taxes: number;
    tax: number;
    grandTotal: number;
    currency: string;
}

export class SalesReturnReportInput implements ISalesReturnReportInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    isCSVFile: boolean;

    constructor(data?: ISalesReturnReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTransactionId = data["saleTransactionId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.orderNumber = data["orderNumber"];
            this.customerNumber = data["customerNumber"];
            this.productInfo = data["productInfo"];
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            this.exportToExcel = data["exportToExcel"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.documentType = data["documentType"];
            this.cashierShiftId = data["cashierShiftId"];
            this.printInvoice = data["printInvoice"];
            this.byShiftDate = data["byShiftDate"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.endOfDayBusiness = data["endOfDayBusiness"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): SalesReturnReportInput {
        let result = new SalesReturnReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTransactionId"] = this.saleTransactionId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["orderNumber"] = this.orderNumber;
        data["customerNumber"] = this.customerNumber;
        data["productInfo"] = this.productInfo;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["exportToExcel"] = this.exportToExcel;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["cashierShiftId"] = this.cashierShiftId;
        data["printInvoice"] = this.printInvoice;
        data["byShiftDate"] = this.byShiftDate;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["endOfDayBusiness"] = this.endOfDayBusiness;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ISalesReturnReportInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    isCSVFile: boolean;
}

export class SaleDto implements ISaleDto {
    date: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    barCode: string;
    qrCode: string;
    currency: string;
    reciptNumber: string;
    notes: string;
    saleTotal: number;
    grandTotal: number;
    vat: number;
    discount: number;
    loyaltyDiscount: number;
    id: string;
    isRetail: boolean;
    creationTime: moment.Moment;
    templateType: SaleDtoTemplateType;
    saleDetails: SaleDetailDto[];
    salePaymentTransactions: SalePaymentTransactionDTO[];
    zatcaTransaction: ZatcaTransactionDto[];

    constructor(data?: ISaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.storeNumber = data["storeNumber"];
            this.storeName = data["storeName"];
            this.customerName = data["customerName"];
            this.barCode = data["barCode"];
            this.qrCode = data["qrCode"];
            this.currency = data["currency"];
            this.reciptNumber = data["reciptNumber"];
            this.notes = data["notes"];
            this.saleTotal = data["saleTotal"];
            this.grandTotal = data["grandTotal"];
            this.vat = data["vat"];
            this.discount = data["discount"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            this.id = data["id"];
            this.isRetail = data["isRetail"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.templateType = data["templateType"];
            if (data["saleDetails"] && data["saleDetails"].constructor === Array) {
                this.saleDetails = [];
                for (let item of data["saleDetails"])
                    this.saleDetails.push(SaleDetailDto.fromJS(item));
            }
            if (data["salePaymentTransactions"] && data["salePaymentTransactions"].constructor === Array) {
                this.salePaymentTransactions = [];
                for (let item of data["salePaymentTransactions"])
                    this.salePaymentTransactions.push(SalePaymentTransactionDTO.fromJS(item));
            }
            if (data["zatcaTransaction"] && data["zatcaTransaction"].constructor === Array) {
                this.zatcaTransaction = [];
                for (let item of data["zatcaTransaction"])
                    this.zatcaTransaction.push(ZatcaTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaleDto {
        let result = new SaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["storeNumber"] = this.storeNumber;
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["barCode"] = this.barCode;
        data["qrCode"] = this.qrCode;
        data["currency"] = this.currency;
        data["reciptNumber"] = this.reciptNumber;
        data["notes"] = this.notes;
        data["saleTotal"] = this.saleTotal;
        data["grandTotal"] = this.grandTotal;
        data["vat"] = this.vat;
        data["discount"] = this.discount;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        data["id"] = this.id;
        data["isRetail"] = this.isRetail;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["templateType"] = this.templateType;
        if (this.saleDetails && this.saleDetails.constructor === Array) {
            data["saleDetails"] = [];
            for (let item of this.saleDetails)
                data["saleDetails"].push(item.toJSON());
        }
        if (this.salePaymentTransactions && this.salePaymentTransactions.constructor === Array) {
            data["salePaymentTransactions"] = [];
            for (let item of this.salePaymentTransactions)
                data["salePaymentTransactions"].push(item.toJSON());
        }
        if (this.zatcaTransaction && this.zatcaTransaction.constructor === Array) {
            data["zatcaTransaction"] = [];
            for (let item of this.zatcaTransaction)
                data["zatcaTransaction"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaleDto {
    date: string;
    storeNumber: string;
    storeName: string;
    customerName: string;
    barCode: string;
    qrCode: string;
    currency: string;
    reciptNumber: string;
    notes: string;
    saleTotal: number;
    grandTotal: number;
    vat: number;
    discount: number;
    loyaltyDiscount: number;
    id: string;
    isRetail: boolean;
    creationTime: moment.Moment;
    templateType: SaleDtoTemplateType;
    saleDetails: SaleDetailDto[];
    salePaymentTransactions: SalePaymentTransactionDTO[];
    zatcaTransaction: ZatcaTransactionDto[];
}

export class SaleDetailDto implements ISaleDetailDto {
    name: string;
    code: string;
    referenceNumber: string;
    offer: string;
    serials: string;
    price: number;
    vat: number;
    priceIncludeVAT: number;
    quantity: number;
    currency: string;
    unitOfMeasureName: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    discount: string;
    loyaltyDiscount: number;
    notes: string;
    netSales: string;
    total: string;

    constructor(data?: ISaleDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.code = data["code"];
            this.referenceNumber = data["referenceNumber"];
            this.offer = data["offer"];
            this.serials = data["serials"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.quantity = data["quantity"];
            this.currency = data["currency"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.discount = data["discount"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            this.notes = data["notes"];
            this.netSales = data["netSales"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): SaleDetailDto {
        let result = new SaleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["referenceNumber"] = this.referenceNumber;
        data["offer"] = this.offer;
        data["serials"] = this.serials;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["quantity"] = this.quantity;
        data["currency"] = this.currency;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["discount"] = this.discount;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        data["notes"] = this.notes;
        data["netSales"] = this.netSales;
        data["total"] = this.total;
        return data; 
    }
}

export interface ISaleDetailDto {
    name: string;
    code: string;
    referenceNumber: string;
    offer: string;
    serials: string;
    price: number;
    vat: number;
    priceIncludeVAT: number;
    quantity: number;
    currency: string;
    unitOfMeasureName: string;
    lotNumber: string;
    expirationDate: moment.Moment;
    discount: string;
    loyaltyDiscount: number;
    notes: string;
    netSales: string;
    total: string;
}

export class SalePaymentTransactionDTO implements ISalePaymentTransactionDTO {
    tenderTypeName: string;
    value: number;

    constructor(data?: ISalePaymentTransactionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeName = data["tenderTypeName"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): SalePaymentTransactionDTO {
        let result = new SalePaymentTransactionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeName"] = this.tenderTypeName;
        data["value"] = this.value;
        return data; 
    }
}

export interface ISalePaymentTransactionDTO {
    tenderTypeName: string;
    value: number;
}

export class ZatcaTransactionDto implements IZatcaTransactionDto {
    qrCode: string;
    uuid: string;
    invoiceHash: string;
    tenantId: number;
    encodedInvoice: string;
    icvuuid: number;
    invoiceTypeCode: string;
    recieptNumber: string;
    statusId: number;
    notValidReason: string;
    reportingStatusId: number;
    reportingStatus: string;
    zatcaCertificateId: string;
    saleTransaction: TransactionDto;
    tenantName: string;
    date: moment.Moment;
    id: string;

    constructor(data?: IZatcaTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCode = data["qrCode"];
            this.uuid = data["uuid"];
            this.invoiceHash = data["invoiceHash"];
            this.tenantId = data["tenantId"];
            this.encodedInvoice = data["encodedInvoice"];
            this.icvuuid = data["icvuuid"];
            this.invoiceTypeCode = data["invoiceTypeCode"];
            this.recieptNumber = data["recieptNumber"];
            this.statusId = data["statusId"];
            this.notValidReason = data["notValidReason"];
            this.reportingStatusId = data["reportingStatusId"];
            this.reportingStatus = data["reportingStatus"];
            this.zatcaCertificateId = data["zatcaCertificateId"];
            this.saleTransaction = data["saleTransaction"] ? TransactionDto.fromJS(data["saleTransaction"]) : <any>undefined;
            this.tenantName = data["tenantName"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ZatcaTransactionDto {
        let result = new ZatcaTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        data["uuid"] = this.uuid;
        data["invoiceHash"] = this.invoiceHash;
        data["tenantId"] = this.tenantId;
        data["encodedInvoice"] = this.encodedInvoice;
        data["icvuuid"] = this.icvuuid;
        data["invoiceTypeCode"] = this.invoiceTypeCode;
        data["recieptNumber"] = this.recieptNumber;
        data["statusId"] = this.statusId;
        data["notValidReason"] = this.notValidReason;
        data["reportingStatusId"] = this.reportingStatusId;
        data["reportingStatus"] = this.reportingStatus;
        data["zatcaCertificateId"] = this.zatcaCertificateId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["tenantName"] = this.tenantName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IZatcaTransactionDto {
    qrCode: string;
    uuid: string;
    invoiceHash: string;
    tenantId: number;
    encodedInvoice: string;
    icvuuid: number;
    invoiceTypeCode: string;
    recieptNumber: string;
    statusId: number;
    notValidReason: string;
    reportingStatusId: number;
    reportingStatus: string;
    zatcaCertificateId: string;
    saleTransaction: TransactionDto;
    tenantName: string;
    date: moment.Moment;
    id: string;
}

export class TransactionDto implements ITransactionDto {
    saleId: string;
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    isReturned: boolean;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    storeId: number;
    isCertificate: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionId: number;
    version: number;
    saleDetails: TransactionDetailDto[];
    salePaymentTransactions: SalePaymentTransactionsDto[];
    posResponseN90: POSResponseN90SyncDto[];
    posResponseA90: POSResponseA90SyncDto[];
    saleOffers: TransactionOfferDto[];
    zatcaIntegrationInvoices: ZatcaTransactionDto[];
    status: TransactionDtoStatus;
    notes: string;
    date: moment.Moment;
    discount: number;
    discountValue: number;
    discountType: number;
    templateType: TransactionDtoTemplateType;
    paymentMethod: number;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleId = data["saleId"];
            this.id = data["id"];
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.salesManId = data["salesManId"];
            this.isReturned = data["isReturned"];
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.cashierId = data["cashierId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.storeId = data["storeId"];
            this.isCertificate = data["isCertificate"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionId = data["promotionId"];
            this.version = data["version"];
            if (data["saleDetails"] && data["saleDetails"].constructor === Array) {
                this.saleDetails = [];
                for (let item of data["saleDetails"])
                    this.saleDetails.push(TransactionDetailDto.fromJS(item));
            }
            if (data["salePaymentTransactions"] && data["salePaymentTransactions"].constructor === Array) {
                this.salePaymentTransactions = [];
                for (let item of data["salePaymentTransactions"])
                    this.salePaymentTransactions.push(SalePaymentTransactionsDto.fromJS(item));
            }
            if (data["posResponseN90"] && data["posResponseN90"].constructor === Array) {
                this.posResponseN90 = [];
                for (let item of data["posResponseN90"])
                    this.posResponseN90.push(POSResponseN90SyncDto.fromJS(item));
            }
            if (data["posResponseA90"] && data["posResponseA90"].constructor === Array) {
                this.posResponseA90 = [];
                for (let item of data["posResponseA90"])
                    this.posResponseA90.push(POSResponseA90SyncDto.fromJS(item));
            }
            if (data["saleOffers"] && data["saleOffers"].constructor === Array) {
                this.saleOffers = [];
                for (let item of data["saleOffers"])
                    this.saleOffers.push(TransactionOfferDto.fromJS(item));
            }
            if (data["zatcaIntegrationInvoices"] && data["zatcaIntegrationInvoices"].constructor === Array) {
                this.zatcaIntegrationInvoices = [];
                for (let item of data["zatcaIntegrationInvoices"])
                    this.zatcaIntegrationInvoices.push(ZatcaTransactionDto.fromJS(item));
            }
            this.status = data["status"];
            this.notes = data["notes"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.discountType = data["discountType"];
            this.templateType = data["templateType"];
            this.paymentMethod = data["paymentMethod"];
        }
    }

    static fromJS(data: any): TransactionDto {
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleId"] = this.saleId;
        data["id"] = this.id;
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["salesManId"] = this.salesManId;
        data["isReturned"] = this.isReturned;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["cashierId"] = this.cashierId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["storeId"] = this.storeId;
        data["isCertificate"] = this.isCertificate;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionId"] = this.promotionId;
        data["version"] = this.version;
        if (this.saleDetails && this.saleDetails.constructor === Array) {
            data["saleDetails"] = [];
            for (let item of this.saleDetails)
                data["saleDetails"].push(item.toJSON());
        }
        if (this.salePaymentTransactions && this.salePaymentTransactions.constructor === Array) {
            data["salePaymentTransactions"] = [];
            for (let item of this.salePaymentTransactions)
                data["salePaymentTransactions"].push(item.toJSON());
        }
        if (this.posResponseN90 && this.posResponseN90.constructor === Array) {
            data["posResponseN90"] = [];
            for (let item of this.posResponseN90)
                data["posResponseN90"].push(item.toJSON());
        }
        if (this.posResponseA90 && this.posResponseA90.constructor === Array) {
            data["posResponseA90"] = [];
            for (let item of this.posResponseA90)
                data["posResponseA90"].push(item.toJSON());
        }
        if (this.saleOffers && this.saleOffers.constructor === Array) {
            data["saleOffers"] = [];
            for (let item of this.saleOffers)
                data["saleOffers"].push(item.toJSON());
        }
        if (this.zatcaIntegrationInvoices && this.zatcaIntegrationInvoices.constructor === Array) {
            data["zatcaIntegrationInvoices"] = [];
            for (let item of this.zatcaIntegrationInvoices)
                data["zatcaIntegrationInvoices"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["discountType"] = this.discountType;
        data["templateType"] = this.templateType;
        data["paymentMethod"] = this.paymentMethod;
        return data; 
    }
}

export interface ITransactionDto {
    saleId: string;
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    isReturned: boolean;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    storeId: number;
    isCertificate: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionId: number;
    version: number;
    saleDetails: TransactionDetailDto[];
    salePaymentTransactions: SalePaymentTransactionsDto[];
    posResponseN90: POSResponseN90SyncDto[];
    posResponseA90: POSResponseA90SyncDto[];
    saleOffers: TransactionOfferDto[];
    zatcaIntegrationInvoices: ZatcaTransactionDto[];
    status: TransactionDtoStatus;
    notes: string;
    date: moment.Moment;
    discount: number;
    discountValue: number;
    discountType: number;
    templateType: TransactionDtoTemplateType;
    paymentMethod: number;
}

export class TransactionDetailDto implements ITransactionDetailDto {
    productLotId: number;
    productVariantId: number;
    productId: number;
    quantity: number;
    price: number;
    discount: number;
    discountValue: number;
    notes: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    vat: number;
    vatBeforeDiscount: number;
    priceIncludeVAT: number;
    unitOfMeasureId: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionCodeId: number;
    serials: TransactionDetailSerialDto[];
    offerId: number;
    offertype: TransactionDetailDtoOffertype;
    unitOfMeasureName: string;
    productVariantName: string;
    productName: string;
    includeVAT: boolean;
    discountTypeId: boolean;

    constructor(data?: ITransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productLotId = data["productLotId"];
            this.productVariantId = data["productVariantId"];
            this.productId = data["productId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.notes = data["notes"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionCodeId = data["promotionCodeId"];
            if (data["serials"] && data["serials"].constructor === Array) {
                this.serials = [];
                for (let item of data["serials"])
                    this.serials.push(TransactionDetailSerialDto.fromJS(item));
            }
            this.offerId = data["offerId"];
            this.offertype = data["offertype"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.productVariantName = data["productVariantName"];
            this.productName = data["productName"];
            this.includeVAT = data["includeVAT"];
            this.discountTypeId = data["discountTypeId"];
        }
    }

    static fromJS(data: any): TransactionDetailDto {
        let result = new TransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLotId"] = this.productLotId;
        data["productVariantId"] = this.productVariantId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["notes"] = this.notes;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionCodeId"] = this.promotionCodeId;
        if (this.serials && this.serials.constructor === Array) {
            data["serials"] = [];
            for (let item of this.serials)
                data["serials"].push(item.toJSON());
        }
        data["offerId"] = this.offerId;
        data["offertype"] = this.offertype;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["productVariantName"] = this.productVariantName;
        data["productName"] = this.productName;
        data["includeVAT"] = this.includeVAT;
        data["discountTypeId"] = this.discountTypeId;
        return data; 
    }
}

export interface ITransactionDetailDto {
    productLotId: number;
    productVariantId: number;
    productId: number;
    quantity: number;
    price: number;
    discount: number;
    discountValue: number;
    notes: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    vat: number;
    vatBeforeDiscount: number;
    priceIncludeVAT: number;
    unitOfMeasureId: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionCodeId: number;
    serials: TransactionDetailSerialDto[];
    offerId: number;
    offertype: TransactionDetailDtoOffertype;
    unitOfMeasureName: string;
    productVariantName: string;
    productName: string;
    includeVAT: boolean;
    discountTypeId: boolean;
}

export class SalePaymentTransactionsDto implements ISalePaymentTransactionsDto {
    currencyId: number;
    tenderTypeId: number;
    value: number;
    saleTransactionId: string;
    creatorUserId: number;
    creationTime: moment.Moment;

    constructor(data?: ISalePaymentTransactionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.value = data["value"];
            this.saleTransactionId = data["saleTransactionId"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SalePaymentTransactionsDto {
        let result = new SalePaymentTransactionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["value"] = this.value;
        data["saleTransactionId"] = this.saleTransactionId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISalePaymentTransactionsDto {
    currencyId: number;
    tenderTypeId: number;
    value: number;
    saleTransactionId: string;
    creatorUserId: number;
    creationTime: moment.Moment;
}

export class POSResponseN90SyncDto implements IPOSResponseN90SyncDto {
    id: string;
    ret: string;
    bankId: string;
    merchantID: string;
    terminalID: string;
    mcc: string;
    stan: string;
    version: string;
    rrn: string;
    pan: string;
    cardExpiryDate: string;
    additionalData: string;
    retailerRetailerNameEng: string;
    retailerRetailerNameArb: string;
    retaileraddress_eng_1: string;
    retaileraddress_eng_2: string;
    retaileraddress_arb_1: string;
    retaileraddress_arb_2: string;
    retailerdownload_phone: string;
    performanceStartDateTime: string;
    performanceEndDateTime: string;
    cardSchemeID: string;
    cardSchemeArabic: string;
    cardSchemeEnglish: string;
    applicationLabelArabic: string;
    applicationLabelEnglish: string;
    transactionTypeArabic: string;
    transactionTypeEnglish: string;
    amountsArabicCurrency: string;
    amountsEnglishCurrency: string;
    amountArabicName: string;
    amountEnglishName: string;
    amountValue: number;
    resultArabic: string;
    resultEnglish: string;
    approvalCodeArabic: string;
    approvalCodeEnglish: string;
    approvalCodeCode: string;
    emvTagsPosEntryMode: string;
    emvTagsResponseCode: string;
    emvTagsTerminalStatusCode: string;
    emvTagsAID: string;
    emvTagsTVR: string;
    emvTagsTSI: string;
    emvTagsCVR: string;
    emvTagsACI: string;
    emvTagsAC: string;
    qrCodeData: string;
    campaignText: string;
    saleTransactionId: string;

    constructor(data?: IPOSResponseN90SyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.ret = data["ret"];
            this.bankId = data["bankId"];
            this.merchantID = data["merchantID"];
            this.terminalID = data["terminalID"];
            this.mcc = data["mcc"];
            this.stan = data["stan"];
            this.version = data["version"];
            this.rrn = data["rrn"];
            this.pan = data["pan"];
            this.cardExpiryDate = data["cardExpiryDate"];
            this.additionalData = data["additionalData"];
            this.retailerRetailerNameEng = data["retailerRetailerNameEng"];
            this.retailerRetailerNameArb = data["retailerRetailerNameArb"];
            this.retaileraddress_eng_1 = data["retaileraddress_eng_1"];
            this.retaileraddress_eng_2 = data["retaileraddress_eng_2"];
            this.retaileraddress_arb_1 = data["retaileraddress_arb_1"];
            this.retaileraddress_arb_2 = data["retaileraddress_arb_2"];
            this.retailerdownload_phone = data["retailerdownload_phone"];
            this.performanceStartDateTime = data["performanceStartDateTime"];
            this.performanceEndDateTime = data["performanceEndDateTime"];
            this.cardSchemeID = data["cardSchemeID"];
            this.cardSchemeArabic = data["cardSchemeArabic"];
            this.cardSchemeEnglish = data["cardSchemeEnglish"];
            this.applicationLabelArabic = data["applicationLabelArabic"];
            this.applicationLabelEnglish = data["applicationLabelEnglish"];
            this.transactionTypeArabic = data["transactionTypeArabic"];
            this.transactionTypeEnglish = data["transactionTypeEnglish"];
            this.amountsArabicCurrency = data["amountsArabicCurrency"];
            this.amountsEnglishCurrency = data["amountsEnglishCurrency"];
            this.amountArabicName = data["amountArabicName"];
            this.amountEnglishName = data["amountEnglishName"];
            this.amountValue = data["amountValue"];
            this.resultArabic = data["resultArabic"];
            this.resultEnglish = data["resultEnglish"];
            this.approvalCodeArabic = data["approvalCodeArabic"];
            this.approvalCodeEnglish = data["approvalCodeEnglish"];
            this.approvalCodeCode = data["approvalCodeCode"];
            this.emvTagsPosEntryMode = data["emvTagsPosEntryMode"];
            this.emvTagsResponseCode = data["emvTagsResponseCode"];
            this.emvTagsTerminalStatusCode = data["emvTagsTerminalStatusCode"];
            this.emvTagsAID = data["emvTagsAID"];
            this.emvTagsTVR = data["emvTagsTVR"];
            this.emvTagsTSI = data["emvTagsTSI"];
            this.emvTagsCVR = data["emvTagsCVR"];
            this.emvTagsACI = data["emvTagsACI"];
            this.emvTagsAC = data["emvTagsAC"];
            this.qrCodeData = data["qrCodeData"];
            this.campaignText = data["campaignText"];
            this.saleTransactionId = data["saleTransactionId"];
        }
    }

    static fromJS(data: any): POSResponseN90SyncDto {
        let result = new POSResponseN90SyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ret"] = this.ret;
        data["bankId"] = this.bankId;
        data["merchantID"] = this.merchantID;
        data["terminalID"] = this.terminalID;
        data["mcc"] = this.mcc;
        data["stan"] = this.stan;
        data["version"] = this.version;
        data["rrn"] = this.rrn;
        data["pan"] = this.pan;
        data["cardExpiryDate"] = this.cardExpiryDate;
        data["additionalData"] = this.additionalData;
        data["retailerRetailerNameEng"] = this.retailerRetailerNameEng;
        data["retailerRetailerNameArb"] = this.retailerRetailerNameArb;
        data["retaileraddress_eng_1"] = this.retaileraddress_eng_1;
        data["retaileraddress_eng_2"] = this.retaileraddress_eng_2;
        data["retaileraddress_arb_1"] = this.retaileraddress_arb_1;
        data["retaileraddress_arb_2"] = this.retaileraddress_arb_2;
        data["retailerdownload_phone"] = this.retailerdownload_phone;
        data["performanceStartDateTime"] = this.performanceStartDateTime;
        data["performanceEndDateTime"] = this.performanceEndDateTime;
        data["cardSchemeID"] = this.cardSchemeID;
        data["cardSchemeArabic"] = this.cardSchemeArabic;
        data["cardSchemeEnglish"] = this.cardSchemeEnglish;
        data["applicationLabelArabic"] = this.applicationLabelArabic;
        data["applicationLabelEnglish"] = this.applicationLabelEnglish;
        data["transactionTypeArabic"] = this.transactionTypeArabic;
        data["transactionTypeEnglish"] = this.transactionTypeEnglish;
        data["amountsArabicCurrency"] = this.amountsArabicCurrency;
        data["amountsEnglishCurrency"] = this.amountsEnglishCurrency;
        data["amountArabicName"] = this.amountArabicName;
        data["amountEnglishName"] = this.amountEnglishName;
        data["amountValue"] = this.amountValue;
        data["resultArabic"] = this.resultArabic;
        data["resultEnglish"] = this.resultEnglish;
        data["approvalCodeArabic"] = this.approvalCodeArabic;
        data["approvalCodeEnglish"] = this.approvalCodeEnglish;
        data["approvalCodeCode"] = this.approvalCodeCode;
        data["emvTagsPosEntryMode"] = this.emvTagsPosEntryMode;
        data["emvTagsResponseCode"] = this.emvTagsResponseCode;
        data["emvTagsTerminalStatusCode"] = this.emvTagsTerminalStatusCode;
        data["emvTagsAID"] = this.emvTagsAID;
        data["emvTagsTVR"] = this.emvTagsTVR;
        data["emvTagsTSI"] = this.emvTagsTSI;
        data["emvTagsCVR"] = this.emvTagsCVR;
        data["emvTagsACI"] = this.emvTagsACI;
        data["emvTagsAC"] = this.emvTagsAC;
        data["qrCodeData"] = this.qrCodeData;
        data["campaignText"] = this.campaignText;
        data["saleTransactionId"] = this.saleTransactionId;
        return data; 
    }
}

export interface IPOSResponseN90SyncDto {
    id: string;
    ret: string;
    bankId: string;
    merchantID: string;
    terminalID: string;
    mcc: string;
    stan: string;
    version: string;
    rrn: string;
    pan: string;
    cardExpiryDate: string;
    additionalData: string;
    retailerRetailerNameEng: string;
    retailerRetailerNameArb: string;
    retaileraddress_eng_1: string;
    retaileraddress_eng_2: string;
    retaileraddress_arb_1: string;
    retaileraddress_arb_2: string;
    retailerdownload_phone: string;
    performanceStartDateTime: string;
    performanceEndDateTime: string;
    cardSchemeID: string;
    cardSchemeArabic: string;
    cardSchemeEnglish: string;
    applicationLabelArabic: string;
    applicationLabelEnglish: string;
    transactionTypeArabic: string;
    transactionTypeEnglish: string;
    amountsArabicCurrency: string;
    amountsEnglishCurrency: string;
    amountArabicName: string;
    amountEnglishName: string;
    amountValue: number;
    resultArabic: string;
    resultEnglish: string;
    approvalCodeArabic: string;
    approvalCodeEnglish: string;
    approvalCodeCode: string;
    emvTagsPosEntryMode: string;
    emvTagsResponseCode: string;
    emvTagsTerminalStatusCode: string;
    emvTagsAID: string;
    emvTagsTVR: string;
    emvTagsTSI: string;
    emvTagsCVR: string;
    emvTagsACI: string;
    emvTagsAC: string;
    qrCodeData: string;
    campaignText: string;
    saleTransactionId: string;
}

export class POSResponseA90SyncDto implements IPOSResponseA90SyncDto {
    id: string;
    ret: string;
    bufferLength: string;
    ecrNo: string;
    receiptNo: string;
    amount: string;
    rspCode: string;
    cardnumber_PAN: string;
    expiryDate: string;
    cardType: string;
    approvalNo: string;
    transDate: string;
    transTime: string;
    rrn: string;
    tid: string;
    merchantNameAr: string;
    merchantNameEn: string;
    addressAr: string;
    addressEn: string;
    cityAr: string;
    cityEn: string;
    startdate: string;
    startTime: string;
    idData: string;
    cardTypeAr: string;
    cardTypeEn: string;
    txnTypeAr: string;
    txnTypeEn: string;
    txnTypeTxtAr: string;
    txAmntAr: string;
    txAmntAr2: string;
    txAmntEn: string;
    txnTypeTxtEn: string;
    txnAmount: string;
    rspDataAra: string;
    rspDataEn: string;
    rspTxtDataAr: string;
    rspTxtDataEn: string;
    sign1Ar: string;
    sign1En: string;
    sign: string;
    sign2Ar: string;
    sign2En: string;
    authCodeAr: string;
    authCodeEn: string;
    authCodeTxtAr: string;
    authCodeTxtEn: string;
    endDate: string;
    endTime: string;
    retailerAr: string;
    retailerEn: string;
    footer1Ar: string;
    footer1En: string;
    footer2Ar: string;
    footer2En: string;
    emvData: string;
    campaignAr: string;
    campaignEn: string;
    saleTransactionId: string;

    constructor(data?: IPOSResponseA90SyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.ret = data["ret"];
            this.bufferLength = data["bufferLength"];
            this.ecrNo = data["ecrNo"];
            this.receiptNo = data["receiptNo"];
            this.amount = data["amount"];
            this.rspCode = data["rspCode"];
            this.cardnumber_PAN = data["cardnumber_PAN"];
            this.expiryDate = data["expiryDate"];
            this.cardType = data["cardType"];
            this.approvalNo = data["approvalNo"];
            this.transDate = data["transDate"];
            this.transTime = data["transTime"];
            this.rrn = data["rrn"];
            this.tid = data["tid"];
            this.merchantNameAr = data["merchantNameAr"];
            this.merchantNameEn = data["merchantNameEn"];
            this.addressAr = data["addressAr"];
            this.addressEn = data["addressEn"];
            this.cityAr = data["cityAr"];
            this.cityEn = data["cityEn"];
            this.startdate = data["startdate"];
            this.startTime = data["startTime"];
            this.idData = data["idData"];
            this.cardTypeAr = data["cardTypeAr"];
            this.cardTypeEn = data["cardTypeEn"];
            this.txnTypeAr = data["txnTypeAr"];
            this.txnTypeEn = data["txnTypeEn"];
            this.txnTypeTxtAr = data["txnTypeTxtAr"];
            this.txAmntAr = data["txAmntAr"];
            this.txAmntAr2 = data["txAmntAr2"];
            this.txAmntEn = data["txAmntEn"];
            this.txnTypeTxtEn = data["txnTypeTxtEn"];
            this.txnAmount = data["txnAmount"];
            this.rspDataAra = data["rspDataAra"];
            this.rspDataEn = data["rspDataEn"];
            this.rspTxtDataAr = data["rspTxtDataAr"];
            this.rspTxtDataEn = data["rspTxtDataEn"];
            this.sign1Ar = data["sign1Ar"];
            this.sign1En = data["sign1En"];
            this.sign = data["sign"];
            this.sign2Ar = data["sign2Ar"];
            this.sign2En = data["sign2En"];
            this.authCodeAr = data["authCodeAr"];
            this.authCodeEn = data["authCodeEn"];
            this.authCodeTxtAr = data["authCodeTxtAr"];
            this.authCodeTxtEn = data["authCodeTxtEn"];
            this.endDate = data["endDate"];
            this.endTime = data["endTime"];
            this.retailerAr = data["retailerAr"];
            this.retailerEn = data["retailerEn"];
            this.footer1Ar = data["footer1Ar"];
            this.footer1En = data["footer1En"];
            this.footer2Ar = data["footer2Ar"];
            this.footer2En = data["footer2En"];
            this.emvData = data["emvData"];
            this.campaignAr = data["campaignAr"];
            this.campaignEn = data["campaignEn"];
            this.saleTransactionId = data["saleTransactionId"];
        }
    }

    static fromJS(data: any): POSResponseA90SyncDto {
        let result = new POSResponseA90SyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ret"] = this.ret;
        data["bufferLength"] = this.bufferLength;
        data["ecrNo"] = this.ecrNo;
        data["receiptNo"] = this.receiptNo;
        data["amount"] = this.amount;
        data["rspCode"] = this.rspCode;
        data["cardnumber_PAN"] = this.cardnumber_PAN;
        data["expiryDate"] = this.expiryDate;
        data["cardType"] = this.cardType;
        data["approvalNo"] = this.approvalNo;
        data["transDate"] = this.transDate;
        data["transTime"] = this.transTime;
        data["rrn"] = this.rrn;
        data["tid"] = this.tid;
        data["merchantNameAr"] = this.merchantNameAr;
        data["merchantNameEn"] = this.merchantNameEn;
        data["addressAr"] = this.addressAr;
        data["addressEn"] = this.addressEn;
        data["cityAr"] = this.cityAr;
        data["cityEn"] = this.cityEn;
        data["startdate"] = this.startdate;
        data["startTime"] = this.startTime;
        data["idData"] = this.idData;
        data["cardTypeAr"] = this.cardTypeAr;
        data["cardTypeEn"] = this.cardTypeEn;
        data["txnTypeAr"] = this.txnTypeAr;
        data["txnTypeEn"] = this.txnTypeEn;
        data["txnTypeTxtAr"] = this.txnTypeTxtAr;
        data["txAmntAr"] = this.txAmntAr;
        data["txAmntAr2"] = this.txAmntAr2;
        data["txAmntEn"] = this.txAmntEn;
        data["txnTypeTxtEn"] = this.txnTypeTxtEn;
        data["txnAmount"] = this.txnAmount;
        data["rspDataAra"] = this.rspDataAra;
        data["rspDataEn"] = this.rspDataEn;
        data["rspTxtDataAr"] = this.rspTxtDataAr;
        data["rspTxtDataEn"] = this.rspTxtDataEn;
        data["sign1Ar"] = this.sign1Ar;
        data["sign1En"] = this.sign1En;
        data["sign"] = this.sign;
        data["sign2Ar"] = this.sign2Ar;
        data["sign2En"] = this.sign2En;
        data["authCodeAr"] = this.authCodeAr;
        data["authCodeEn"] = this.authCodeEn;
        data["authCodeTxtAr"] = this.authCodeTxtAr;
        data["authCodeTxtEn"] = this.authCodeTxtEn;
        data["endDate"] = this.endDate;
        data["endTime"] = this.endTime;
        data["retailerAr"] = this.retailerAr;
        data["retailerEn"] = this.retailerEn;
        data["footer1Ar"] = this.footer1Ar;
        data["footer1En"] = this.footer1En;
        data["footer2Ar"] = this.footer2Ar;
        data["footer2En"] = this.footer2En;
        data["emvData"] = this.emvData;
        data["campaignAr"] = this.campaignAr;
        data["campaignEn"] = this.campaignEn;
        data["saleTransactionId"] = this.saleTransactionId;
        return data; 
    }
}

export interface IPOSResponseA90SyncDto {
    id: string;
    ret: string;
    bufferLength: string;
    ecrNo: string;
    receiptNo: string;
    amount: string;
    rspCode: string;
    cardnumber_PAN: string;
    expiryDate: string;
    cardType: string;
    approvalNo: string;
    transDate: string;
    transTime: string;
    rrn: string;
    tid: string;
    merchantNameAr: string;
    merchantNameEn: string;
    addressAr: string;
    addressEn: string;
    cityAr: string;
    cityEn: string;
    startdate: string;
    startTime: string;
    idData: string;
    cardTypeAr: string;
    cardTypeEn: string;
    txnTypeAr: string;
    txnTypeEn: string;
    txnTypeTxtAr: string;
    txAmntAr: string;
    txAmntAr2: string;
    txAmntEn: string;
    txnTypeTxtEn: string;
    txnAmount: string;
    rspDataAra: string;
    rspDataEn: string;
    rspTxtDataAr: string;
    rspTxtDataEn: string;
    sign1Ar: string;
    sign1En: string;
    sign: string;
    sign2Ar: string;
    sign2En: string;
    authCodeAr: string;
    authCodeEn: string;
    authCodeTxtAr: string;
    authCodeTxtEn: string;
    endDate: string;
    endTime: string;
    retailerAr: string;
    retailerEn: string;
    footer1Ar: string;
    footer1En: string;
    footer2Ar: string;
    footer2En: string;
    emvData: string;
    campaignAr: string;
    campaignEn: string;
    saleTransactionId: string;
}

export class TransactionOfferDto implements ITransactionOfferDto {
    offerId: number;
    price: number;
    saleTransactionId: string;
    creatorUserId: number;
    creationTime: moment.Moment;

    constructor(data?: ITransactionOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.offerId = data["offerId"];
            this.price = data["price"];
            this.saleTransactionId = data["saleTransactionId"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionOfferDto {
        let result = new TransactionOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["price"] = this.price;
        data["saleTransactionId"] = this.saleTransactionId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ITransactionOfferDto {
    offerId: number;
    price: number;
    saleTransactionId: string;
    creatorUserId: number;
    creationTime: moment.Moment;
}

export class TransactionDetailSerialDto implements ITransactionDetailSerialDto {
    id: string;
    saleTransactionDetailId: string;
    serialId: number;

    constructor(data?: ITransactionDetailSerialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.serialId = data["serialId"];
        }
    }

    static fromJS(data: any): TransactionDetailSerialDto {
        let result = new TransactionDetailSerialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["serialId"] = this.serialId;
        return data; 
    }
}

export interface ITransactionDetailSerialDto {
    id: string;
    saleTransactionDetailId: string;
    serialId: number;
}

export class OfferDetailReportDto implements IOfferDetailReportDto {
    from: moment.Moment;
    to: moment.Moment;
    startDate: string;
    endDate: string;
    discountPercent: number;
    discountAmmount: number;
    discount: string;
    offerTypeValue: OfferDetailReportDtoOfferTypeValue;
    offerType: string;
    itemText: string;
    itemType: OfferDetailReportDtoItemType;
    itemTypeString: string;
    barCode: string;
    itemId: number;
    saleOfferDetails: SaleOfferDetail[];

    constructor(data?: IOfferDetailReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.startDate = data["startDate"];
            this.endDate = data["endDate"];
            this.discountPercent = data["discountPercent"];
            this.discountAmmount = data["discountAmmount"];
            this.discount = data["discount"];
            this.offerTypeValue = data["offerTypeValue"];
            this.offerType = data["offerType"];
            this.itemText = data["itemText"];
            this.itemType = data["itemType"];
            this.itemTypeString = data["itemTypeString"];
            this.barCode = data["barCode"];
            this.itemId = data["itemId"];
            if (data["saleOfferDetails"] && data["saleOfferDetails"].constructor === Array) {
                this.saleOfferDetails = [];
                for (let item of data["saleOfferDetails"])
                    this.saleOfferDetails.push(SaleOfferDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfferDetailReportDto {
        let result = new OfferDetailReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["discountPercent"] = this.discountPercent;
        data["discountAmmount"] = this.discountAmmount;
        data["discount"] = this.discount;
        data["offerTypeValue"] = this.offerTypeValue;
        data["offerType"] = this.offerType;
        data["itemText"] = this.itemText;
        data["itemType"] = this.itemType;
        data["itemTypeString"] = this.itemTypeString;
        data["barCode"] = this.barCode;
        data["itemId"] = this.itemId;
        if (this.saleOfferDetails && this.saleOfferDetails.constructor === Array) {
            data["saleOfferDetails"] = [];
            for (let item of this.saleOfferDetails)
                data["saleOfferDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOfferDetailReportDto {
    from: moment.Moment;
    to: moment.Moment;
    startDate: string;
    endDate: string;
    discountPercent: number;
    discountAmmount: number;
    discount: string;
    offerTypeValue: OfferDetailReportDtoOfferTypeValue;
    offerType: string;
    itemText: string;
    itemType: OfferDetailReportDtoItemType;
    itemTypeString: string;
    barCode: string;
    itemId: number;
    saleOfferDetails: SaleOfferDetail[];
}

export class SaleOfferDetail implements ISaleOfferDetail {
    refernceNumber: string;
    reciptDate: moment.Moment;
    saleDate: string;
    currency: string;
    value: string;

    constructor(data?: ISaleOfferDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.refernceNumber = data["refernceNumber"];
            this.reciptDate = data["reciptDate"] ? moment(data["reciptDate"].toString()) : <any>undefined;
            this.saleDate = data["saleDate"];
            this.currency = data["currency"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): SaleOfferDetail {
        let result = new SaleOfferDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refernceNumber"] = this.refernceNumber;
        data["reciptDate"] = this.reciptDate ? this.reciptDate.toISOString() : <any>undefined;
        data["saleDate"] = this.saleDate;
        data["currency"] = this.currency;
        data["value"] = this.value;
        return data; 
    }
}

export interface ISaleOfferDetail {
    refernceNumber: string;
    reciptDate: moment.Moment;
    saleDate: string;
    currency: string;
    value: string;
}

export class SaleProductDto implements ISaleProductDto {
    date: string;
    customerName: string;
    recieptNumber: string;
    code: string;
    name: string;
    lotNumber: number;
    expirationDate: string;
    unitOfMeasureName: string;
    quantity: number;
    price: number;
    grossSales: number;
    discount: string;
    netSales: string;
    vat: string;
    total: string;

    constructor(data?: ISaleProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.customerName = data["customerName"];
            this.recieptNumber = data["recieptNumber"];
            this.code = data["code"];
            this.name = data["name"];
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.grossSales = data["grossSales"];
            this.discount = data["discount"];
            this.netSales = data["netSales"];
            this.vat = data["vat"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): SaleProductDto {
        let result = new SaleProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["customerName"] = this.customerName;
        data["recieptNumber"] = this.recieptNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["grossSales"] = this.grossSales;
        data["discount"] = this.discount;
        data["netSales"] = this.netSales;
        data["vat"] = this.vat;
        data["total"] = this.total;
        return data; 
    }
}

export interface ISaleProductDto {
    date: string;
    customerName: string;
    recieptNumber: string;
    code: string;
    name: string;
    lotNumber: number;
    expirationDate: string;
    unitOfMeasureName: string;
    quantity: number;
    price: number;
    grossSales: number;
    discount: string;
    netSales: string;
    vat: string;
    total: string;
}

export class PrintSelectedSaleDto implements IPrintSelectedSaleDto {
    date: string;
    storeName: string;
    companyName: string;
    customerName: string;
    currency: string;
    reciptNumber: string;
    notes: string;
    saleTotal: number;
    id: string;
    isRetail: boolean;
    creationTime: moment.Moment;
    saleDetails: SaleDetailDto[];
    salePaymentTransactions: SalePaymentTransactionDTO[];

    constructor(data?: IPrintSelectedSaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.storeName = data["storeName"];
            this.companyName = data["companyName"];
            this.customerName = data["customerName"];
            this.currency = data["currency"];
            this.reciptNumber = data["reciptNumber"];
            this.notes = data["notes"];
            this.saleTotal = data["saleTotal"];
            this.id = data["id"];
            this.isRetail = data["isRetail"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            if (data["saleDetails"] && data["saleDetails"].constructor === Array) {
                this.saleDetails = [];
                for (let item of data["saleDetails"])
                    this.saleDetails.push(SaleDetailDto.fromJS(item));
            }
            if (data["salePaymentTransactions"] && data["salePaymentTransactions"].constructor === Array) {
                this.salePaymentTransactions = [];
                for (let item of data["salePaymentTransactions"])
                    this.salePaymentTransactions.push(SalePaymentTransactionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrintSelectedSaleDto {
        let result = new PrintSelectedSaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["storeName"] = this.storeName;
        data["companyName"] = this.companyName;
        data["customerName"] = this.customerName;
        data["currency"] = this.currency;
        data["reciptNumber"] = this.reciptNumber;
        data["notes"] = this.notes;
        data["saleTotal"] = this.saleTotal;
        data["id"] = this.id;
        data["isRetail"] = this.isRetail;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (this.saleDetails && this.saleDetails.constructor === Array) {
            data["saleDetails"] = [];
            for (let item of this.saleDetails)
                data["saleDetails"].push(item.toJSON());
        }
        if (this.salePaymentTransactions && this.salePaymentTransactions.constructor === Array) {
            data["salePaymentTransactions"] = [];
            for (let item of this.salePaymentTransactions)
                data["salePaymentTransactions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPrintSelectedSaleDto {
    date: string;
    storeName: string;
    companyName: string;
    customerName: string;
    currency: string;
    reciptNumber: string;
    notes: string;
    saleTotal: number;
    id: string;
    isRetail: boolean;
    creationTime: moment.Moment;
    saleDetails: SaleDetailDto[];
    salePaymentTransactions: SalePaymentTransactionDTO[];
}

export class SalesSummaryReportInput implements ISalesSummaryReportInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    showRefund: boolean;

    constructor(data?: ISalesSummaryReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTransactionId = data["saleTransactionId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.orderNumber = data["orderNumber"];
            this.customerNumber = data["customerNumber"];
            this.productInfo = data["productInfo"];
            if (data["employees"] && data["employees"].constructor === Array) {
                this.employees = [];
                for (let item of data["employees"])
                    this.employees.push(item);
            }
            this.exportToExcel = data["exportToExcel"];
            if (data["saleTypeIds"] && data["saleTypeIds"].constructor === Array) {
                this.saleTypeIds = [];
                for (let item of data["saleTypeIds"])
                    this.saleTypeIds.push(item);
            }
            if (data["categoryIds"] && data["categoryIds"].constructor === Array) {
                this.categoryIds = [];
                for (let item of data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.documentType = data["documentType"];
            this.cashierShiftId = data["cashierShiftId"];
            this.printInvoice = data["printInvoice"];
            this.byShiftDate = data["byShiftDate"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.endOfDayBusiness = data["endOfDayBusiness"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.showStoreName = data["showStoreName"];
            this.showRefund = data["showRefund"];
        }
    }

    static fromJS(data: any): SalesSummaryReportInput {
        let result = new SalesSummaryReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTransactionId"] = this.saleTransactionId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["orderNumber"] = this.orderNumber;
        data["customerNumber"] = this.customerNumber;
        data["productInfo"] = this.productInfo;
        if (this.employees && this.employees.constructor === Array) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["exportToExcel"] = this.exportToExcel;
        if (this.saleTypeIds && this.saleTypeIds.constructor === Array) {
            data["saleTypeIds"] = [];
            for (let item of this.saleTypeIds)
                data["saleTypeIds"].push(item);
        }
        if (this.categoryIds && this.categoryIds.constructor === Array) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["documentType"] = this.documentType;
        data["cashierShiftId"] = this.cashierShiftId;
        data["printInvoice"] = this.printInvoice;
        data["byShiftDate"] = this.byShiftDate;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["endOfDayBusiness"] = this.endOfDayBusiness;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["showStoreName"] = this.showStoreName;
        data["showRefund"] = this.showRefund;
        return data; 
    }
}

export interface ISalesSummaryReportInput {
    saleTransactionId: string;
    from: moment.Moment;
    to: moment.Moment;
    fromTime: string;
    toTime: string;
    orderNumber: string;
    customerNumber: string;
    productInfo: string;
    employees: number[];
    exportToExcel: string;
    saleTypeIds: number[];
    categoryIds: number[];
    documentType: number;
    cashierShiftId: number;
    printInvoice: boolean;
    byShiftDate: boolean;
    tenantId: number;
    regionId: number;
    areaId: number;
    endOfDayBusiness: boolean;
    storeIds: number[];
    showStoreName: boolean;
    showRefund: boolean;
}

export class PurchaseReportInput implements IPurchaseReportInput {
    from: moment.Moment;
    to: moment.Moment;
    vendors: number[];
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IPurchaseReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["vendors"] && data["vendors"].constructor === Array) {
                this.vendors = [];
                for (let item of data["vendors"])
                    this.vendors.push(item);
            }
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PurchaseReportInput {
        let result = new PurchaseReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.vendors && this.vendors.constructor === Array) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPurchaseReportInput {
    from: moment.Moment;
    to: moment.Moment;
    vendors: number[];
    documentType: number;
    isCSVFile: boolean;
}

export class PurchaseReportDto implements IPurchaseReportDto {
    details: PurchaseReportDetailsDto[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;

    constructor(data?: IPurchaseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(PurchaseReportDetailsDto.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
            this.summationGrandTotal = data["summationGrandTotal"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): PurchaseReportDto {
        let result = new PurchaseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        data["summationGrandTotal"] = this.summationGrandTotal;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IPurchaseReportDto {
    details: PurchaseReportDetailsDto[];
    pageCount: number;
    currentPage: number;
    summationGrandTotal: number;
    currency: string;
}

export class PurchaseReportDetailsDto implements IPurchaseReportDetailsDto {
    transactionTypeName: string;
    vendorCode: string;
    vendorName: string;
    storeName: string;
    totalCost: number;
    currency: string;
    date: string;
    purchaseNumber: string;
    discount: string;
    grandTotal: number;
    paid: number;

    constructor(data?: IPurchaseReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeName = data["transactionTypeName"];
            this.vendorCode = data["vendorCode"];
            this.vendorName = data["vendorName"];
            this.storeName = data["storeName"];
            this.totalCost = data["totalCost"];
            this.currency = data["currency"];
            this.date = data["date"];
            this.purchaseNumber = data["purchaseNumber"];
            this.discount = data["discount"];
            this.grandTotal = data["grandTotal"];
            this.paid = data["paid"];
        }
    }

    static fromJS(data: any): PurchaseReportDetailsDto {
        let result = new PurchaseReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeName"] = this.transactionTypeName;
        data["vendorCode"] = this.vendorCode;
        data["vendorName"] = this.vendorName;
        data["storeName"] = this.storeName;
        data["totalCost"] = this.totalCost;
        data["currency"] = this.currency;
        data["date"] = this.date;
        data["purchaseNumber"] = this.purchaseNumber;
        data["discount"] = this.discount;
        data["grandTotal"] = this.grandTotal;
        data["paid"] = this.paid;
        return data; 
    }
}

export interface IPurchaseReportDetailsDto {
    transactionTypeName: string;
    vendorCode: string;
    vendorName: string;
    storeName: string;
    totalCost: number;
    currency: string;
    date: string;
    purchaseNumber: string;
    discount: string;
    grandTotal: number;
    paid: number;
}

export class PurchaseReportFBInput implements IPurchaseReportFBInput {
    transactionTypeId: number;
    entityFromId: number;
    entityToId: number;
    supplierId: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;

    constructor(data?: IPurchaseReportFBInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTypeId = data["transactionTypeId"];
            this.entityFromId = data["entityFromId"];
            this.entityToId = data["entityToId"];
            this.supplierId = data["supplierId"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): PurchaseReportFBInput {
        let result = new PurchaseReportFBInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTypeId"] = this.transactionTypeId;
        data["entityFromId"] = this.entityFromId;
        data["entityToId"] = this.entityToId;
        data["supplierId"] = this.supplierId;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IPurchaseReportFBInput {
    transactionTypeId: number;
    entityFromId: number;
    entityToId: number;
    supplierId: number;
    tenantId: number;
    regionId: number;
    areaId: number;
    from: moment.Moment;
    to: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
}

export class PurchaseReportBySupplierDetailsFBInput implements IPurchaseReportBySupplierDetailsFBInput {
    tenantName: string;
    mainTransactionId: number;

    constructor(data?: IPurchaseReportBySupplierDetailsFBInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.mainTransactionId = data["mainTransactionId"];
        }
    }

    static fromJS(data: any): PurchaseReportBySupplierDetailsFBInput {
        let result = new PurchaseReportBySupplierDetailsFBInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["mainTransactionId"] = this.mainTransactionId;
        return data; 
    }
}

export interface IPurchaseReportBySupplierDetailsFBInput {
    tenantName: string;
    mainTransactionId: number;
}

export class StockBalanceReportInput implements IStockBalanceReportInput {
    stores: number[];
    rawMaterials: number[];
    documentType: number;
    isCSVFile: boolean;

    constructor(data?: IStockBalanceReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(item);
            }
            if (data["rawMaterials"] && data["rawMaterials"].constructor === Array) {
                this.rawMaterials = [];
                for (let item of data["rawMaterials"])
                    this.rawMaterials.push(item);
            }
            this.documentType = data["documentType"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): StockBalanceReportInput {
        let result = new StockBalanceReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        if (this.rawMaterials && this.rawMaterials.constructor === Array) {
            data["rawMaterials"] = [];
            for (let item of this.rawMaterials)
                data["rawMaterials"].push(item);
        }
        data["documentType"] = this.documentType;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface IStockBalanceReportInput {
    stores: number[];
    rawMaterials: number[];
    documentType: number;
    isCSVFile: boolean;
}

export class StockBalanceReportDto implements IStockBalanceReportDto {
    details: StockBalanceReportDetailsDto[];
    pageCount: number;
    currentPage: number;

    constructor(data?: IStockBalanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(StockBalanceReportDetailsDto.fromJS(item));
            }
            this.pageCount = data["pageCount"];
            this.currentPage = data["currentPage"];
        }
    }

    static fromJS(data: any): StockBalanceReportDto {
        let result = new StockBalanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["pageCount"] = this.pageCount;
        data["currentPage"] = this.currentPage;
        return data; 
    }
}

export interface IStockBalanceReportDto {
    details: StockBalanceReportDetailsDto[];
    pageCount: number;
    currentPage: number;
}

export class StockBalanceReportDetailsDto implements IStockBalanceReportDetailsDto {
    materialName: string;
    storeName: string;
    qty: number;
    price: number;
    total: number;

    constructor(data?: IStockBalanceReportDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialName = data["materialName"];
            this.storeName = data["storeName"];
            this.qty = data["qty"];
            this.price = data["price"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): StockBalanceReportDetailsDto {
        let result = new StockBalanceReportDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialName"] = this.materialName;
        data["storeName"] = this.storeName;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["total"] = this.total;
        return data; 
    }
}

export interface IStockBalanceReportDetailsDto {
    materialName: string;
    storeName: string;
    qty: number;
    price: number;
    total: number;
}

export class CompareSalesBetweenStocksDifferentDatesInput implements ICompareSalesBetweenStocksDifferentDatesInput {
    firstStock: number;
    secondStock: number;
    firstDate: moment.Moment;
    secondDate: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    isCSVFile: boolean;

    constructor(data?: ICompareSalesBetweenStocksDifferentDatesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstStock = data["firstStock"];
            this.secondStock = data["secondStock"];
            this.firstDate = data["firstDate"] ? moment(data["firstDate"].toString()) : <any>undefined;
            this.secondDate = data["secondDate"] ? moment(data["secondDate"].toString()) : <any>undefined;
            this.documentType = data["documentType"];
            this.isEndOfDay = data["isEndOfDay"];
            this.tenantId = data["tenantId"];
            this.isCSVFile = data["isCSVFile"];
        }
    }

    static fromJS(data: any): CompareSalesBetweenStocksDifferentDatesInput {
        let result = new CompareSalesBetweenStocksDifferentDatesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstStock"] = this.firstStock;
        data["secondStock"] = this.secondStock;
        data["firstDate"] = this.firstDate ? this.firstDate.toISOString() : <any>undefined;
        data["secondDate"] = this.secondDate ? this.secondDate.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["isEndOfDay"] = this.isEndOfDay;
        data["tenantId"] = this.tenantId;
        data["isCSVFile"] = this.isCSVFile;
        return data; 
    }
}

export interface ICompareSalesBetweenStocksDifferentDatesInput {
    firstStock: number;
    secondStock: number;
    firstDate: moment.Moment;
    secondDate: moment.Moment;
    documentType: number;
    isEndOfDay: boolean;
    tenantId: number;
    isCSVFile: boolean;
}

export class CompareSalesBetweenStocksdifferentDatesReport implements ICompareSalesBetweenStocksdifferentDatesReport {
    firstStockName: string;
    secondStockName: string;
    firstStock: CompareSalesReport;
    secondStock: CompareSalesReport;

    constructor(data?: ICompareSalesBetweenStocksdifferentDatesReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstStockName = data["firstStockName"];
            this.secondStockName = data["secondStockName"];
            this.firstStock = data["firstStock"] ? CompareSalesReport.fromJS(data["firstStock"]) : <any>undefined;
            this.secondStock = data["secondStock"] ? CompareSalesReport.fromJS(data["secondStock"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompareSalesBetweenStocksdifferentDatesReport {
        let result = new CompareSalesBetweenStocksdifferentDatesReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstStockName"] = this.firstStockName;
        data["secondStockName"] = this.secondStockName;
        data["firstStock"] = this.firstStock ? this.firstStock.toJSON() : <any>undefined;
        data["secondStock"] = this.secondStock ? this.secondStock.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompareSalesBetweenStocksdifferentDatesReport {
    firstStockName: string;
    secondStockName: string;
    firstStock: CompareSalesReport;
    secondStock: CompareSalesReport;
}

export class CompareEventsSalesInput implements ICompareEventsSalesInput {
    firstEvent: CompareEventsSalesDetailsInput;
    secondEvent: CompareEventsSalesDetailsInput;

    constructor(data?: ICompareEventsSalesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstEvent = data["firstEvent"] ? CompareEventsSalesDetailsInput.fromJS(data["firstEvent"]) : <any>undefined;
            this.secondEvent = data["secondEvent"] ? CompareEventsSalesDetailsInput.fromJS(data["secondEvent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompareEventsSalesInput {
        let result = new CompareEventsSalesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstEvent"] = this.firstEvent ? this.firstEvent.toJSON() : <any>undefined;
        data["secondEvent"] = this.secondEvent ? this.secondEvent.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompareEventsSalesInput {
    firstEvent: CompareEventsSalesDetailsInput;
    secondEvent: CompareEventsSalesDetailsInput;
}

export class CompareEventsSalesDetailsInput implements ICompareEventsSalesDetailsInput {
    from: moment.Moment;
    to: moment.Moment;

    constructor(data?: ICompareEventsSalesDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompareEventsSalesDetailsInput {
        let result = new CompareEventsSalesDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICompareEventsSalesDetailsInput {
    from: moment.Moment;
    to: moment.Moment;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[];

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[];
}

export class RoleListDto implements IRoleListDto {
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleListDto {
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    displayName: string;
    isDefault: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IRoleEditDto {
    id: number;
    displayName: string;
    isDefault: boolean;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
    hasAddPermission: boolean;
    addPermissionValue: boolean;
    hasEditPermission: boolean;
    editPermissionValue: boolean;
    hasDeletePermission: boolean;
    deletePermissionValue: boolean;
    hasImportFilePermission: boolean;
    importFilePermissionValue: boolean;
    hasExportFilePermission: boolean;
    exportFilePermissionValue: boolean;
    hasViewPermission: boolean;
    viewPermissionValue: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
            this.hasAddPermission = data["hasAddPermission"];
            this.addPermissionValue = data["addPermissionValue"];
            this.hasEditPermission = data["hasEditPermission"];
            this.editPermissionValue = data["editPermissionValue"];
            this.hasDeletePermission = data["hasDeletePermission"];
            this.deletePermissionValue = data["deletePermissionValue"];
            this.hasImportFilePermission = data["hasImportFilePermission"];
            this.importFilePermissionValue = data["importFilePermissionValue"];
            this.hasExportFilePermission = data["hasExportFilePermission"];
            this.exportFilePermissionValue = data["exportFilePermissionValue"];
            this.hasViewPermission = data["hasViewPermission"];
            this.viewPermissionValue = data["viewPermissionValue"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        data["hasAddPermission"] = this.hasAddPermission;
        data["addPermissionValue"] = this.addPermissionValue;
        data["hasEditPermission"] = this.hasEditPermission;
        data["editPermissionValue"] = this.editPermissionValue;
        data["hasDeletePermission"] = this.hasDeletePermission;
        data["deletePermissionValue"] = this.deletePermissionValue;
        data["hasImportFilePermission"] = this.hasImportFilePermission;
        data["importFilePermissionValue"] = this.importFilePermissionValue;
        data["hasExportFilePermission"] = this.hasExportFilePermission;
        data["exportFilePermissionValue"] = this.exportFilePermissionValue;
        data["hasViewPermission"] = this.hasViewPermission;
        data["viewPermissionValue"] = this.viewPermissionValue;
        return data; 
    }
}

export interface IFlatPermissionDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
    hasAddPermission: boolean;
    addPermissionValue: boolean;
    hasEditPermission: boolean;
    editPermissionValue: boolean;
    hasDeletePermission: boolean;
    deletePermissionValue: boolean;
    hasImportFilePermission: boolean;
    importFilePermissionValue: boolean;
    hasExportFilePermission: boolean;
    exportFilePermissionValue: boolean;
    hasViewPermission: boolean;
    viewPermissionValue: boolean;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role: RoleEditDto = new RoleEditDto();
    grantedPermissionNames: string[] = [];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class ListResultDtoOfSaleListItem implements IListResultDtoOfSaleListItem {
    items: SaleListItem[];

    constructor(data?: IListResultDtoOfSaleListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SaleListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSaleListItem {
        let result = new ListResultDtoOfSaleListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSaleListItem {
    items: SaleListItem[];
}

export class SaleListItem implements ISaleListItem {
    billsNumber: string;
    dueDate: moment.Moment;
    isDeleted: boolean;
    total: number;
    officeId: number;
    customerId: string;
    userId: number;
    todayDate: moment.Moment;
    definitionOfCurrenciesId: number;
    totalCharacters: string;
    companyId: number;
    documentType: string;
    exchangeRate: number;
    nationalCompanyNumber: string;
    saleTaxNumber: string;
    address: string;
    email: string;
    legalCompanyName: string;
    phoneNumber: string;
    totalFinal: number;
    commodityServices: number;
    sellOrderId: number;
    warehouseReceiptId: number;
    qualityAssuranceId: number;
    totalQualityAssurance: number;

    constructor(data?: ISaleListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billsNumber = data["billsNumber"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.total = data["total"];
            this.officeId = data["officeId"];
            this.customerId = data["customerId"];
            this.userId = data["userId"];
            this.todayDate = data["todayDate"] ? moment(data["todayDate"].toString()) : <any>undefined;
            this.definitionOfCurrenciesId = data["definitionOfCurrenciesId"];
            this.totalCharacters = data["totalCharacters"];
            this.companyId = data["companyId"];
            this.documentType = data["documentType"];
            this.exchangeRate = data["exchangeRate"];
            this.nationalCompanyNumber = data["nationalCompanyNumber"];
            this.saleTaxNumber = data["saleTaxNumber"];
            this.address = data["address"];
            this.email = data["email"];
            this.legalCompanyName = data["legalCompanyName"];
            this.phoneNumber = data["phoneNumber"];
            this.totalFinal = data["totalFinal"];
            this.commodityServices = data["commodityServices"];
            this.sellOrderId = data["sellOrderId"];
            this.warehouseReceiptId = data["warehouseReceiptId"];
            this.qualityAssuranceId = data["qualityAssuranceId"];
            this.totalQualityAssurance = data["totalQualityAssurance"];
        }
    }

    static fromJS(data: any): SaleListItem {
        let result = new SaleListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billsNumber"] = this.billsNumber;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["total"] = this.total;
        data["officeId"] = this.officeId;
        data["customerId"] = this.customerId;
        data["userId"] = this.userId;
        data["todayDate"] = this.todayDate ? this.todayDate.toISOString() : <any>undefined;
        data["definitionOfCurrenciesId"] = this.definitionOfCurrenciesId;
        data["totalCharacters"] = this.totalCharacters;
        data["companyId"] = this.companyId;
        data["documentType"] = this.documentType;
        data["exchangeRate"] = this.exchangeRate;
        data["nationalCompanyNumber"] = this.nationalCompanyNumber;
        data["saleTaxNumber"] = this.saleTaxNumber;
        data["address"] = this.address;
        data["email"] = this.email;
        data["legalCompanyName"] = this.legalCompanyName;
        data["phoneNumber"] = this.phoneNumber;
        data["totalFinal"] = this.totalFinal;
        data["commodityServices"] = this.commodityServices;
        data["sellOrderId"] = this.sellOrderId;
        data["warehouseReceiptId"] = this.warehouseReceiptId;
        data["qualityAssuranceId"] = this.qualityAssuranceId;
        data["totalQualityAssurance"] = this.totalQualityAssurance;
        return data; 
    }
}

export interface ISaleListItem {
    billsNumber: string;
    dueDate: moment.Moment;
    isDeleted: boolean;
    total: number;
    officeId: number;
    customerId: string;
    userId: number;
    todayDate: moment.Moment;
    definitionOfCurrenciesId: number;
    totalCharacters: string;
    companyId: number;
    documentType: string;
    exchangeRate: number;
    nationalCompanyNumber: string;
    saleTaxNumber: string;
    address: string;
    email: string;
    legalCompanyName: string;
    phoneNumber: string;
    totalFinal: number;
    commodityServices: number;
    sellOrderId: number;
    warehouseReceiptId: number;
    qualityAssuranceId: number;
    totalQualityAssurance: number;
}

export class TotalSalesByDayReportPage implements ITotalSalesByDayReportPage {
    totalCount: number;
    pageNumber: number;
    totalNetSales: number;
    data: TotalSalesByDayReportListItem[];

    constructor(data?: ITotalSalesByDayReportPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.pageNumber = data["pageNumber"];
            this.totalNetSales = data["totalNetSales"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(TotalSalesByDayReportListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TotalSalesByDayReportPage {
        let result = new TotalSalesByDayReportPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["totalNetSales"] = this.totalNetSales;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITotalSalesByDayReportPage {
    totalCount: number;
    pageNumber: number;
    totalNetSales: number;
    data: TotalSalesByDayReportListItem[];
}

export class TotalSalesByDayReportListItem implements ITotalSalesByDayReportListItem {
    tenantName: string;
    date: moment.Moment;
    dateAsString: string;
    storeCode: string;
    storeName: string;
    netSales: number;
    checkCount: number;
    checkAverage: number;

    constructor(data?: ITotalSalesByDayReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.dateAsString = data["dateAsString"];
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.netSales = data["netSales"];
            this.checkCount = data["checkCount"];
            this.checkAverage = data["checkAverage"];
        }
    }

    static fromJS(data: any): TotalSalesByDayReportListItem {
        let result = new TotalSalesByDayReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateAsString"] = this.dateAsString;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["netSales"] = this.netSales;
        data["checkCount"] = this.checkCount;
        data["checkAverage"] = this.checkAverage;
        return data; 
    }
}

export interface ITotalSalesByDayReportListItem {
    tenantName: string;
    date: moment.Moment;
    dateAsString: string;
    storeCode: string;
    storeName: string;
    netSales: number;
    checkCount: number;
    checkAverage: number;
}

export class MenuItemVariantReportOutput implements IMenuItemVariantReportOutput {
    pageNumber: number;
    totalCount: number;
    items: TenantMenuItemVariantGroup[];

    constructor(data?: IMenuItemVariantReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageNumber = data["pageNumber"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantMenuItemVariantGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemVariantReportOutput {
        let result = new MenuItemVariantReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuItemVariantReportOutput {
    pageNumber: number;
    totalCount: number;
    items: TenantMenuItemVariantGroup[];
}

export class TenantMenuItemVariantGroup implements ITenantMenuItemVariantGroup {
    tenantName: string;
    menuItemVariants: MenuItemVariantGroup[];

    constructor(data?: ITenantMenuItemVariantGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            if (data["menuItemVariants"] && data["menuItemVariants"].constructor === Array) {
                this.menuItemVariants = [];
                for (let item of data["menuItemVariants"])
                    this.menuItemVariants.push(MenuItemVariantGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantMenuItemVariantGroup {
        let result = new TenantMenuItemVariantGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (this.menuItemVariants && this.menuItemVariants.constructor === Array) {
            data["menuItemVariants"] = [];
            for (let item of this.menuItemVariants)
                data["menuItemVariants"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantMenuItemVariantGroup {
    tenantName: string;
    menuItemVariants: MenuItemVariantGroup[];
}

export class MenuItemVariantGroup implements IMenuItemVariantGroup {
    itemCode: string;
    menuItemName: string;
    variantCode: string;
    variantName: string;
    varaints: MenuitemVariantValueItem[];

    constructor(data?: IMenuItemVariantGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.menuItemName = data["menuItemName"];
            this.variantCode = data["variantCode"];
            this.variantName = data["variantName"];
            if (data["varaints"] && data["varaints"].constructor === Array) {
                this.varaints = [];
                for (let item of data["varaints"])
                    this.varaints.push(MenuitemVariantValueItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemVariantGroup {
        let result = new MenuItemVariantGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["menuItemName"] = this.menuItemName;
        data["variantCode"] = this.variantCode;
        data["variantName"] = this.variantName;
        if (this.varaints && this.varaints.constructor === Array) {
            data["varaints"] = [];
            for (let item of this.varaints)
                data["varaints"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuItemVariantGroup {
    itemCode: string;
    menuItemName: string;
    variantCode: string;
    variantName: string;
    varaints: MenuitemVariantValueItem[];
}

export class MenuitemVariantValueItem implements IMenuitemVariantValueItem {
    barcode: string;
    rawMaterialName: string;
    quantity: number;

    constructor(data?: IMenuitemVariantValueItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barcode = data["barcode"];
            this.rawMaterialName = data["rawMaterialName"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): MenuitemVariantValueItem {
        let result = new MenuitemVariantValueItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["rawMaterialName"] = this.rawMaterialName;
        data["quantity"] = this.quantity;
        return data; 
    }
}

export interface IMenuitemVariantValueItem {
    barcode: string;
    rawMaterialName: string;
    quantity: number;
}

export class UpdateInvoiceStatusRequest implements IUpdateInvoiceStatusRequest {
    orderid: string;
    status: number;
    itemId: string;
    cashierShiftId: number;

    constructor(data?: IUpdateInvoiceStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderid = data["orderid"];
            this.status = data["status"];
            this.itemId = data["itemId"];
            this.cashierShiftId = data["cashierShiftId"];
        }
    }

    static fromJS(data: any): UpdateInvoiceStatusRequest {
        let result = new UpdateInvoiceStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderid"] = this.orderid;
        data["status"] = this.status;
        data["itemId"] = this.itemId;
        data["cashierShiftId"] = this.cashierShiftId;
        return data; 
    }
}

export interface IUpdateInvoiceStatusRequest {
    orderid: string;
    status: number;
    itemId: string;
    cashierShiftId: number;
}

export class PrepareItemHookRequest implements IPrepareItemHookRequest {
    id: string;

    constructor(data?: IPrepareItemHookRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrepareItemHookRequest {
        let result = new PrepareItemHookRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrepareItemHookRequest {
    id: string;
}

export class SaleTypeDTO implements ISaleTypeDTO {
    saleNatural: SaleTypeDTOSaleNatural;
    translations: SaleTypeTranslationDTO[];
    pricLists: number[];
    roles: number[];
    storeIds: number[];
    saleTypeName: string;
    code: string;
    imageSrcUrl: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleNatural = data["saleNatural"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SaleTypeTranslationDTO.fromJS(item));
            }
            if (data["pricLists"] && data["pricLists"].constructor === Array) {
                this.pricLists = [];
                for (let item of data["pricLists"])
                    this.pricLists.push(item);
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.saleTypeName = data["saleTypeName"];
            this.code = data["code"];
            this.imageSrcUrl = data["imageSrcUrl"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeDTO {
        let result = new SaleTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleNatural"] = this.saleNatural;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.pricLists && this.pricLists.constructor === Array) {
            data["pricLists"] = [];
            for (let item of this.pricLists)
                data["pricLists"].push(item);
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["saleTypeName"] = this.saleTypeName;
        data["code"] = this.code;
        data["imageSrcUrl"] = this.imageSrcUrl;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeDTO {
    saleNatural: SaleTypeDTOSaleNatural;
    translations: SaleTypeTranslationDTO[];
    pricLists: number[];
    roles: number[];
    storeIds: number[];
    saleTypeName: string;
    code: string;
    imageSrcUrl: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTypeTranslationDTO implements ISaleTypeTranslationDTO {
    name: string;
    languageId: number;

    constructor(data?: ISaleTypeTranslationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): SaleTypeTranslationDTO {
        let result = new SaleTypeTranslationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ISaleTypeTranslationDTO {
    name: string;
    languageId: number;
}

export class PagedSaleTypeList implements IPagedSaleTypeList {
    currentPage: number;
    itemsCount: number;
    saleTypes: SaleTypeListItem[];

    constructor(data?: IPagedSaleTypeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["saleTypes"] && data["saleTypes"].constructor === Array) {
                this.saleTypes = [];
                for (let item of data["saleTypes"])
                    this.saleTypes.push(SaleTypeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedSaleTypeList {
        let result = new PagedSaleTypeList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.saleTypes && this.saleTypes.constructor === Array) {
            data["saleTypes"] = [];
            for (let item of this.saleTypes)
                data["saleTypes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedSaleTypeList {
    currentPage: number;
    itemsCount: number;
    saleTypes: SaleTypeListItem[];
}

export class CreateSaleTypeInput implements ICreateSaleTypeInput {
    code: string;
    saleNatural: CreateSaleTypeInputSaleNatural;
    translations: SaleTypeTranslationDTO[];
    priceLists: number[];
    roles: number[];
    storeIds: number[];

    constructor(data?: ICreateSaleTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.saleNatural = data["saleNatural"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SaleTypeTranslationDTO.fromJS(item));
            }
            if (data["priceLists"] && data["priceLists"].constructor === Array) {
                this.priceLists = [];
                for (let item of data["priceLists"])
                    this.priceLists.push(item);
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSaleTypeInput {
        let result = new CreateSaleTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["saleNatural"] = this.saleNatural;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.priceLists && this.priceLists.constructor === Array) {
            data["priceLists"] = [];
            for (let item of this.priceLists)
                data["priceLists"].push(item);
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateSaleTypeInput {
    code: string;
    saleNatural: CreateSaleTypeInputSaleNatural;
    translations: SaleTypeTranslationDTO[];
    priceLists: number[];
    roles: number[];
    storeIds: number[];
}

export class EditSaleTypeInput implements IEditSaleTypeInput {
    id: number;
    code: string;
    saleNatural: EditSaleTypeInputSaleNatural;
    translations: SaleTypeTranslationDTO[];
    priceLists: number[];
    roles: number[];
    storeIds: number[];

    constructor(data?: IEditSaleTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.saleNatural = data["saleNatural"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SaleTypeTranslationDTO.fromJS(item));
            }
            if (data["priceLists"] && data["priceLists"].constructor === Array) {
                this.priceLists = [];
                for (let item of data["priceLists"])
                    this.priceLists.push(item);
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): EditSaleTypeInput {
        let result = new EditSaleTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["saleNatural"] = this.saleNatural;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.priceLists && this.priceLists.constructor === Array) {
            data["priceLists"] = [];
            for (let item of this.priceLists)
                data["priceLists"].push(item);
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IEditSaleTypeInput {
    id: number;
    code: string;
    saleNatural: EditSaleTypeInputSaleNatural;
    translations: SaleTypeTranslationDTO[];
    priceLists: number[];
    roles: number[];
    storeIds: number[];
}

export class ScaleConfigurationDTO implements IScaleConfigurationDTO {
    scalePrefix: string;
    weightPrefix: string;
    pricePrefix: string;
    weightOrPriceLength: number;

    constructor(data?: IScaleConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scalePrefix = data["scalePrefix"];
            this.weightPrefix = data["weightPrefix"];
            this.pricePrefix = data["pricePrefix"];
            this.weightOrPriceLength = data["weightOrPriceLength"];
        }
    }

    static fromJS(data: any): ScaleConfigurationDTO {
        let result = new ScaleConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scalePrefix"] = this.scalePrefix;
        data["weightPrefix"] = this.weightPrefix;
        data["pricePrefix"] = this.pricePrefix;
        data["weightOrPriceLength"] = this.weightOrPriceLength;
        return data; 
    }
}

export interface IScaleConfigurationDTO {
    scalePrefix: string;
    weightPrefix: string;
    pricePrefix: string;
    weightOrPriceLength: number;
}

export class SchemaInput implements ISchemaInput {
    id: number;
    clubId: number;
    minPoints: number;
    maxPoints: number;
    pointUser: number;
    moneySystem: number;
    moneyUser: number;
    pointSystem: number;
    pointExpirationDays: number;
    activeDays: number;
    translations: SchemaTranslationDto[];

    constructor(data?: ISchemaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.clubId = data["clubId"];
            this.minPoints = data["minPoints"];
            this.maxPoints = data["maxPoints"];
            this.pointUser = data["pointUser"];
            this.moneySystem = data["moneySystem"];
            this.moneyUser = data["moneyUser"];
            this.pointSystem = data["pointSystem"];
            this.pointExpirationDays = data["pointExpirationDays"];
            this.activeDays = data["activeDays"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SchemaTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaInput {
        let result = new SchemaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clubId"] = this.clubId;
        data["minPoints"] = this.minPoints;
        data["maxPoints"] = this.maxPoints;
        data["pointUser"] = this.pointUser;
        data["moneySystem"] = this.moneySystem;
        data["moneyUser"] = this.moneyUser;
        data["pointSystem"] = this.pointSystem;
        data["pointExpirationDays"] = this.pointExpirationDays;
        data["activeDays"] = this.activeDays;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISchemaInput {
    id: number;
    clubId: number;
    minPoints: number;
    maxPoints: number;
    pointUser: number;
    moneySystem: number;
    moneyUser: number;
    pointSystem: number;
    pointExpirationDays: number;
    activeDays: number;
    translations: SchemaTranslationDto[];
}

export class SchemaTranslationDto implements ISchemaTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ISchemaTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): SchemaTranslationDto {
        let result = new SchemaTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ISchemaTranslationDto {
    name: string;
    languageId: number;
}

export class PagedSchemaList implements IPagedSchemaList {
    currentPage: number;
    itemsCount: number;
    schemas: SchemaDto[];

    constructor(data?: IPagedSchemaList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["schemas"] && data["schemas"].constructor === Array) {
                this.schemas = [];
                for (let item of data["schemas"])
                    this.schemas.push(SchemaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedSchemaList {
        let result = new PagedSchemaList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.schemas && this.schemas.constructor === Array) {
            data["schemas"] = [];
            for (let item of this.schemas)
                data["schemas"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedSchemaList {
    currentPage: number;
    itemsCount: number;
    schemas: SchemaDto[];
}

export class SecondaryCategoryDto implements ISecondaryCategoryDto {
    primaryCategoryId: number;
    code: string;
    translations: SecondaryCategoryTranslationDto[];
    imageId: string;
    imageSrcUrl: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISecondaryCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.primaryCategoryId = data["primaryCategoryId"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SecondaryCategoryTranslationDto.fromJS(item));
            }
            this.imageId = data["imageId"];
            this.imageSrcUrl = data["imageSrcUrl"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCategoryDto {
        let result = new SecondaryCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["imageId"] = this.imageId;
        data["imageSrcUrl"] = this.imageSrcUrl;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISecondaryCategoryDto {
    primaryCategoryId: number;
    code: string;
    translations: SecondaryCategoryTranslationDto[];
    imageId: string;
    imageSrcUrl: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SecondaryCategoryTranslationDto implements ISecondaryCategoryTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ISecondaryCategoryTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): SecondaryCategoryTranslationDto {
        let result = new SecondaryCategoryTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ISecondaryCategoryTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfSecondaryCategoryListItem implements IListResultDtoOfSecondaryCategoryListItem {
    items: SecondaryCategoryListItem[];

    constructor(data?: IListResultDtoOfSecondaryCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SecondaryCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSecondaryCategoryListItem {
        let result = new ListResultDtoOfSecondaryCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSecondaryCategoryListItem {
    items: SecondaryCategoryListItem[];
}

export class PagedSecondaryCategoryList implements IPagedSecondaryCategoryList {
    currentPage: number;
    itemsCount: number;
    secondaryCategories: SecondaryCategoryListItem[];

    constructor(data?: IPagedSecondaryCategoryList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["secondaryCategories"] && data["secondaryCategories"].constructor === Array) {
                this.secondaryCategories = [];
                for (let item of data["secondaryCategories"])
                    this.secondaryCategories.push(SecondaryCategoryListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedSecondaryCategoryList {
        let result = new PagedSecondaryCategoryList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.secondaryCategories && this.secondaryCategories.constructor === Array) {
            data["secondaryCategories"] = [];
            for (let item of this.secondaryCategories)
                data["secondaryCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedSecondaryCategoryList {
    currentPage: number;
    itemsCount: number;
    secondaryCategories: SecondaryCategoryListItem[];
}

export class CreateSecondaryCategoryInput implements ICreateSecondaryCategoryInput {
    primaryCategoryId: number;
    code: string;
    translations: SecondaryCategoryTranslationDto[];

    constructor(data?: ICreateSecondaryCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.primaryCategoryId = data["primaryCategoryId"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SecondaryCategoryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSecondaryCategoryInput {
        let result = new CreateSecondaryCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateSecondaryCategoryInput {
    primaryCategoryId: number;
    code: string;
    translations: SecondaryCategoryTranslationDto[];
}

export class UpdateSecondaryCategoryInput implements IUpdateSecondaryCategoryInput {
    id: number;
    primaryCategoryId: number;
    code: string;
    translations: SecondaryCategoryTranslationDto[];

    constructor(data?: IUpdateSecondaryCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SecondaryCategoryTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSecondaryCategoryInput {
        let result = new UpdateSecondaryCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateSecondaryCategoryInput {
    id: number;
    primaryCategoryId: number;
    code: string;
    translations: SecondaryCategoryTranslationDto[];
}

export class CreateServiceChargeInput implements ICreateServiceChargeInput {
    translations: ServiceChargeTranslationDto[];
    saleTypes: number[];
    amount: number;
    isPrecentage: boolean;

    constructor(data?: ICreateServiceChargeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ServiceChargeTranslationDto.fromJS(item));
            }
            if (data["saleTypes"] && data["saleTypes"].constructor === Array) {
                this.saleTypes = [];
                for (let item of data["saleTypes"])
                    this.saleTypes.push(item);
            }
            this.amount = data["amount"];
            this.isPrecentage = data["isPrecentage"];
        }
    }

    static fromJS(data: any): CreateServiceChargeInput {
        let result = new CreateServiceChargeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.saleTypes && this.saleTypes.constructor === Array) {
            data["saleTypes"] = [];
            for (let item of this.saleTypes)
                data["saleTypes"].push(item);
        }
        data["amount"] = this.amount;
        data["isPrecentage"] = this.isPrecentage;
        return data; 
    }
}

export interface ICreateServiceChargeInput {
    translations: ServiceChargeTranslationDto[];
    saleTypes: number[];
    amount: number;
    isPrecentage: boolean;
}

export class ServiceChargeTranslationDto implements IServiceChargeTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IServiceChargeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ServiceChargeTranslationDto {
        let result = new ServiceChargeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IServiceChargeTranslationDto {
    name: string;
    languageId: number;
}

export class ServiceChargeDto implements IServiceChargeDto {
    id: number;
    translations: ServiceChargeTranslationDto[];
    saleTypes: number[];
    amount: number;
    isPercentage: boolean;

    constructor(data?: IServiceChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ServiceChargeTranslationDto.fromJS(item));
            }
            if (data["saleTypes"] && data["saleTypes"].constructor === Array) {
                this.saleTypes = [];
                for (let item of data["saleTypes"])
                    this.saleTypes.push(item);
            }
            this.amount = data["amount"];
            this.isPercentage = data["isPercentage"];
        }
    }

    static fromJS(data: any): ServiceChargeDto {
        let result = new ServiceChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.saleTypes && this.saleTypes.constructor === Array) {
            data["saleTypes"] = [];
            for (let item of this.saleTypes)
                data["saleTypes"].push(item);
        }
        data["amount"] = this.amount;
        data["isPercentage"] = this.isPercentage;
        return data; 
    }
}

export interface IServiceChargeDto {
    id: number;
    translations: ServiceChargeTranslationDto[];
    saleTypes: number[];
    amount: number;
    isPercentage: boolean;
}

export class ListResultDtoOfServiceChargeListItem implements IListResultDtoOfServiceChargeListItem {
    items: ServiceChargeListItem[];

    constructor(data?: IListResultDtoOfServiceChargeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ServiceChargeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfServiceChargeListItem {
        let result = new ListResultDtoOfServiceChargeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfServiceChargeListItem {
    items: ServiceChargeListItem[];
}

export class ServiceChargeListItem implements IServiceChargeListItem {
    name: string;
    id: number;

    constructor(data?: IServiceChargeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceChargeListItem {
        let result = new ServiceChargeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceChargeListItem {
    name: string;
    id: number;
}

export class PagedServiceChargeList implements IPagedServiceChargeList {
    currentPage: number;
    itemsCount: number;
    serviceCharges: ServiceChargeListItem[];

    constructor(data?: IPagedServiceChargeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["serviceCharges"] && data["serviceCharges"].constructor === Array) {
                this.serviceCharges = [];
                for (let item of data["serviceCharges"])
                    this.serviceCharges.push(ServiceChargeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServiceChargeList {
        let result = new PagedServiceChargeList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.serviceCharges && this.serviceCharges.constructor === Array) {
            data["serviceCharges"] = [];
            for (let item of this.serviceCharges)
                data["serviceCharges"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedServiceChargeList {
    currentPage: number;
    itemsCount: number;
    serviceCharges: ServiceChargeListItem[];
}

export class UpdateServiceChargeInput implements IUpdateServiceChargeInput {
    id: number;
    translations: ServiceChargeTranslationDto[];
    saleTypes: number[];
    amount: number;
    isPrecentage: boolean;

    constructor(data?: IUpdateServiceChargeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ServiceChargeTranslationDto.fromJS(item));
            }
            if (data["saleTypes"] && data["saleTypes"].constructor === Array) {
                this.saleTypes = [];
                for (let item of data["saleTypes"])
                    this.saleTypes.push(item);
            }
            this.amount = data["amount"];
            this.isPrecentage = data["isPrecentage"];
        }
    }

    static fromJS(data: any): UpdateServiceChargeInput {
        let result = new UpdateServiceChargeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.saleTypes && this.saleTypes.constructor === Array) {
            data["saleTypes"] = [];
            for (let item of this.saleTypes)
                data["saleTypes"].push(item);
        }
        data["amount"] = this.amount;
        data["isPrecentage"] = this.isPrecentage;
        return data; 
    }
}

export interface IUpdateServiceChargeInput {
    id: number;
    translations: ServiceChargeTranslationDto[];
    saleTypes: number[];
    amount: number;
    isPrecentage: boolean;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLoginInfoDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string;
    name: string;
    logoId: string;
    logoFileType: string;
    customCssId: string;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType;
    subscriptionDateString: string;
    creationTimeString: string;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string;
    name: string;
    logoId: string;
    logoFileType: string;
    customCssId: string;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType;
    subscriptionDateString: string;
    creationTimeString: string;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string;
    releaseDate: moment.Moment;
    features: { [key: string] : boolean; };

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            if (data["features"]) {
                this.features = {};
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }
}

export interface IApplicationInfoDto {
    version: string;
    releaseDate: moment.Moment;
    features: { [key: string] : boolean; };
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName: string;
    trialDayCount: number;
    monthlyPrice: number;
    annualPrice: number;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionInfoDto {
    displayName: string;
    trialDayCount: number;
    monthlyPrice: number;
    annualPrice: number;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken: string;
    encodedUserId: string;
    encodedTenantId: string;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data; 
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string;
    encodedUserId: string;
    encodedTenantId: string;
}

export class CalenderCulture implements ICalenderCulture {
    currentCalender: string;

    constructor(data?: ICalenderCulture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentCalender = data["currentCalender"];
        }
    }

    static fromJS(data: any): CalenderCulture {
        let result = new CalenderCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentCalender"] = this.currentCalender;
        return data; 
    }
}

export interface ICalenderCulture {
    currentCalender: string;
}

export class CountryTimeZone implements ICountryTimeZone {
    countryCode: string;
    countryName: string;
    timeZoneId: string;
    isHidden: boolean;

    constructor(data?: ICountryTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryCode = data["countryCode"];
            this.countryName = data["countryName"];
            this.timeZoneId = data["timeZoneId"];
            this.isHidden = data["isHidden"];
        }
    }

    static fromJS(data: any): CountryTimeZone {
        let result = new CountryTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["timeZoneId"] = this.timeZoneId;
        data["isHidden"] = this.isHidden;
        return data; 
    }
}

export interface ICountryTimeZone {
    countryCode: string;
    countryName: string;
    timeZoneId: string;
    isHidden: boolean;
}

export class StoreProductsListItem implements IStoreProductsListItem {
    productId: number;
    varaiantId: number;
    name: string;

    constructor(data?: IStoreProductsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.varaiantId = data["varaiantId"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): StoreProductsListItem {
        let result = new StoreProductsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["varaiantId"] = this.varaiantId;
        data["name"] = this.name;
        return data; 
    }
}

export interface IStoreProductsListItem {
    productId: number;
    varaiantId: number;
    name: string;
}

export class GetProductLotInput implements IGetProductLotInput {
    productId: number;
    variantId: number;
    storeId: number;

    constructor(data?: IGetProductLotInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.variantId = data["variantId"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): GetProductLotInput {
        let result = new GetProductLotInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IGetProductLotInput {
    productId: number;
    variantId: number;
    storeId: number;
}

export class ProductLotListItem implements IProductLotListItem {
    lotId: number;
    lotName: string;
    unitOfMeasureName: string;
    validQuantity: number;
    adjustedQuantity: number;

    constructor(data?: IProductLotListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lotId = data["lotId"];
            this.lotName = data["lotName"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.validQuantity = data["validQuantity"];
            this.adjustedQuantity = data["adjustedQuantity"];
        }
    }

    static fromJS(data: any): ProductLotListItem {
        let result = new ProductLotListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotId"] = this.lotId;
        data["lotName"] = this.lotName;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["validQuantity"] = this.validQuantity;
        data["adjustedQuantity"] = this.adjustedQuantity;
        return data; 
    }
}

export interface IProductLotListItem {
    lotId: number;
    lotName: string;
    unitOfMeasureName: string;
    validQuantity: number;
    adjustedQuantity: number;
}

export class AdjustProductLotInput implements IAdjustProductLotInput {
    productLotId: number;
    adjustedValue: number;

    constructor(data?: IAdjustProductLotInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productLotId = data["productLotId"];
            this.adjustedValue = data["adjustedValue"];
        }
    }

    static fromJS(data: any): AdjustProductLotInput {
        let result = new AdjustProductLotInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLotId"] = this.productLotId;
        data["adjustedValue"] = this.adjustedValue;
        return data; 
    }
}

export interface IAdjustProductLotInput {
    productLotId: number;
    adjustedValue: number;
}

export class StoreReOrderMaterialInfo implements IStoreReOrderMaterialInfo {
    materialId: number;
    materialName: string;
    totalQty: number;

    constructor(data?: IStoreReOrderMaterialInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.totalQty = data["totalQty"];
        }
    }

    static fromJS(data: any): StoreReOrderMaterialInfo {
        let result = new StoreReOrderMaterialInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["totalQty"] = this.totalQty;
        return data; 
    }
}

export interface IStoreReOrderMaterialInfo {
    materialId: number;
    materialName: string;
    totalQty: number;
}

export class CreateStockPeriodInput implements ICreateStockPeriodInput {
    tenantId: number;
    periodType: number;
    from: moment.Moment;
    to: moment.Moment;
    storeIds: number[];

    constructor(data?: ICreateStockPeriodInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.periodType = data["periodType"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateStockPeriodInput {
        let result = new CreateStockPeriodInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["periodType"] = this.periodType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateStockPeriodInput {
    tenantId: number;
    periodType: number;
    from: moment.Moment;
    to: moment.Moment;
    storeIds: number[];
}

export class UpdateStockPeriodDto implements IUpdateStockPeriodDto {
    id: number;
    tenantId: number;
    periodType: number;
    from: moment.Moment;
    to: moment.Moment;
    storeIds: number[];

    constructor(data?: IUpdateStockPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.periodType = data["periodType"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateStockPeriodDto {
        let result = new UpdateStockPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["periodType"] = this.periodType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateStockPeriodDto {
    id: number;
    tenantId: number;
    periodType: number;
    from: moment.Moment;
    to: moment.Moment;
    storeIds: number[];
}

export class PagedStockPeriodList implements IPagedStockPeriodList {
    currentPage: number;
    itemsCount: number;
    stockPeriods: StockPeriodListItem[];

    constructor(data?: IPagedStockPeriodList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["stockPeriods"] && data["stockPeriods"].constructor === Array) {
                this.stockPeriods = [];
                for (let item of data["stockPeriods"])
                    this.stockPeriods.push(StockPeriodListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedStockPeriodList {
        let result = new PagedStockPeriodList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.stockPeriods && this.stockPeriods.constructor === Array) {
            data["stockPeriods"] = [];
            for (let item of this.stockPeriods)
                data["stockPeriods"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedStockPeriodList {
    currentPage: number;
    itemsCount: number;
    stockPeriods: StockPeriodListItem[];
}

export class StockPeriodListItem implements IStockPeriodListItem {
    id: number;
    periodType: string;
    from: moment.Moment;
    to: moment.Moment;

    constructor(data?: IStockPeriodListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.periodType = data["periodType"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StockPeriodListItem {
        let result = new StockPeriodListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["periodType"] = this.periodType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStockPeriodListItem {
    id: number;
    periodType: string;
    from: moment.Moment;
    to: moment.Moment;
}

export class StockPeriodDto implements IStockPeriodDto {
    id: number;
    periodType: number;
    localizedPeriodType: string;
    from: moment.Moment;
    to: moment.Moment;
    storeIds: number[];

    constructor(data?: IStockPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.periodType = data["periodType"];
            this.localizedPeriodType = data["localizedPeriodType"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): StockPeriodDto {
        let result = new StockPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["periodType"] = this.periodType;
        data["localizedPeriodType"] = this.localizedPeriodType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IStockPeriodDto {
    id: number;
    periodType: number;
    localizedPeriodType: string;
    from: moment.Moment;
    to: moment.Moment;
    storeIds: number[];
}

export class CreateStoreGroupInput implements ICreateStoreGroupInput {
    translations: StoreTranslationDto[];
    number: string;
    isStoreGroup: boolean;

    constructor(data?: ICreateStoreGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(StoreTranslationDto.fromJS(item));
            }
            this.number = data["number"];
            this.isStoreGroup = data["isStoreGroup"];
        }
    }

    static fromJS(data: any): CreateStoreGroupInput {
        let result = new CreateStoreGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["number"] = this.number;
        data["isStoreGroup"] = this.isStoreGroup;
        return data; 
    }
}

export interface ICreateStoreGroupInput {
    translations: StoreTranslationDto[];
    number: string;
    isStoreGroup: boolean;
}

export class ListResultDtoOfStoreGroupListItem implements IListResultDtoOfStoreGroupListItem {
    items: StoreGroupListItem[];

    constructor(data?: IListResultDtoOfStoreGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(StoreGroupListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfStoreGroupListItem {
        let result = new ListResultDtoOfStoreGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfStoreGroupListItem {
    items: StoreGroupListItem[];
}

export class StoreGroupListItem implements IStoreGroupListItem {
    id: number;
    storeCode: string;
    name: string;

    constructor(data?: IStoreGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.storeCode = data["storeCode"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): StoreGroupListItem {
        let result = new StoreGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeCode"] = this.storeCode;
        data["name"] = this.name;
        return data; 
    }
}

export interface IStoreGroupListItem {
    id: number;
    storeCode: string;
    name: string;
}

export class UpdateStoreGroupInput implements IUpdateStoreGroupInput {
    id: number;
    number: string;
    isStoreGroup: boolean;
    translations: StoreTranslationDto[];

    constructor(data?: IUpdateStoreGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.number = data["number"];
            this.isStoreGroup = data["isStoreGroup"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(StoreTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStoreGroupInput {
        let result = new UpdateStoreGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["isStoreGroup"] = this.isStoreGroup;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateStoreGroupInput {
    id: number;
    number: string;
    isStoreGroup: boolean;
    translations: StoreTranslationDto[];
}

export class StoreListItem implements IStoreListItem {
    id: number;
    name: string;
    storeCode: string;
    type: number;
    isClosed: boolean;
    currencyName: string;
    isStoreGroup: boolean;
    hasZatcaCertificates: boolean;
    storeGroupId: number;
    startSale: moment.Moment;
    startTransaction: moment.Moment;
    store_Longitude: number;
    store_Latitude: number;

    constructor(data?: IStoreListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.storeCode = data["storeCode"];
            this.type = data["type"];
            this.isClosed = data["isClosed"];
            this.currencyName = data["currencyName"];
            this.isStoreGroup = data["isStoreGroup"];
            this.hasZatcaCertificates = data["hasZatcaCertificates"];
            this.storeGroupId = data["storeGroupId"];
            this.startSale = data["startSale"] ? moment(data["startSale"].toString()) : <any>undefined;
            this.startTransaction = data["startTransaction"] ? moment(data["startTransaction"].toString()) : <any>undefined;
            this.store_Longitude = data["store_Longitude"];
            this.store_Latitude = data["store_Latitude"];
        }
    }

    static fromJS(data: any): StoreListItem {
        let result = new StoreListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeCode"] = this.storeCode;
        data["type"] = this.type;
        data["isClosed"] = this.isClosed;
        data["currencyName"] = this.currencyName;
        data["isStoreGroup"] = this.isStoreGroup;
        data["hasZatcaCertificates"] = this.hasZatcaCertificates;
        data["storeGroupId"] = this.storeGroupId;
        data["startSale"] = this.startSale ? this.startSale.toISOString() : <any>undefined;
        data["startTransaction"] = this.startTransaction ? this.startTransaction.toISOString() : <any>undefined;
        data["store_Longitude"] = this.store_Longitude;
        data["store_Latitude"] = this.store_Latitude;
        return data; 
    }
}

export interface IStoreListItem {
    id: number;
    name: string;
    storeCode: string;
    type: number;
    isClosed: boolean;
    currencyName: string;
    isStoreGroup: boolean;
    hasZatcaCertificates: boolean;
    storeGroupId: number;
    startSale: moment.Moment;
    startTransaction: moment.Moment;
    store_Longitude: number;
    store_Latitude: number;
}

export class CreateMenuItemConfigDto implements ICreateMenuItemConfigDto {
    id: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    printerIds: number[];
    comboGroupIds: number[];
    menuItemId: number;
    storeIds: number[];
    menuItemPrices: MenuItemPriceListDto[];

    constructor(data?: ICreateMenuItemConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.oldeEffectiveDate = data["oldeEffectiveDate"] ? moment(data["oldeEffectiveDate"].toString()) : <any>undefined;
            this.openPrice = data["openPrice"];
            this.allowDiscount = data["allowDiscount"];
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            this.menuItemId = data["menuItemId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["menuItemPrices"] && data["menuItemPrices"].constructor === Array) {
                this.menuItemPrices = [];
                for (let item of data["menuItemPrices"])
                    this.menuItemPrices.push(MenuItemPriceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMenuItemConfigDto {
        let result = new CreateMenuItemConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["oldeEffectiveDate"] = this.oldeEffectiveDate ? this.oldeEffectiveDate.toISOString() : <any>undefined;
        data["openPrice"] = this.openPrice;
        data["allowDiscount"] = this.allowDiscount;
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        data["menuItemId"] = this.menuItemId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.menuItemPrices && this.menuItemPrices.constructor === Array) {
            data["menuItemPrices"] = [];
            for (let item of this.menuItemPrices)
                data["menuItemPrices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateMenuItemConfigDto {
    id: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    printerIds: number[];
    comboGroupIds: number[];
    menuItemId: number;
    storeIds: number[];
    menuItemPrices: MenuItemPriceListDto[];
}

export class MenuItemConfigDto implements IMenuItemConfigDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    printerIds: number[];
    comboGroupIds: number[];
    menuItemId: number;
    menuItemName: string;
    storeIds: number[];
    storeNames: string;
    menuItemPriceLists: MenuItemPriceListDto[];
    menuItemDevices: MenuItemDeviceRecord[];
    comboGroupDetails: ComboGroupDetailRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.oldeEffectiveDate = data["oldeEffectiveDate"] ? moment(data["oldeEffectiveDate"].toString()) : <any>undefined;
            this.openPrice = data["openPrice"];
            this.allowDiscount = data["allowDiscount"];
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            this.menuItemId = data["menuItemId"];
            this.menuItemName = data["menuItemName"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.storeNames = data["storeNames"];
            if (data["menuItemPriceLists"] && data["menuItemPriceLists"].constructor === Array) {
                this.menuItemPriceLists = [];
                for (let item of data["menuItemPriceLists"])
                    this.menuItemPriceLists.push(MenuItemPriceListDto.fromJS(item));
            }
            if (data["menuItemDevices"] && data["menuItemDevices"].constructor === Array) {
                this.menuItemDevices = [];
                for (let item of data["menuItemDevices"])
                    this.menuItemDevices.push(MenuItemDeviceRecord.fromJS(item));
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetailRecord.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemConfigDto {
        let result = new MenuItemConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["oldeEffectiveDate"] = this.oldeEffectiveDate ? this.oldeEffectiveDate.toISOString() : <any>undefined;
        data["openPrice"] = this.openPrice;
        data["allowDiscount"] = this.allowDiscount;
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        data["menuItemId"] = this.menuItemId;
        data["menuItemName"] = this.menuItemName;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["storeNames"] = this.storeNames;
        if (this.menuItemPriceLists && this.menuItemPriceLists.constructor === Array) {
            data["menuItemPriceLists"] = [];
            for (let item of this.menuItemPriceLists)
                data["menuItemPriceLists"].push(item.toJSON());
        }
        if (this.menuItemDevices && this.menuItemDevices.constructor === Array) {
            data["menuItemDevices"] = [];
            for (let item of this.menuItemDevices)
                data["menuItemDevices"].push(item.toJSON());
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemConfigDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    printerIds: number[];
    comboGroupIds: number[];
    menuItemId: number;
    menuItemName: string;
    storeIds: number[];
    storeNames: string;
    menuItemPriceLists: MenuItemPriceListDto[];
    menuItemDevices: MenuItemDeviceRecord[];
    comboGroupDetails: ComboGroupDetailRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemDeviceRecord implements IMenuItemDeviceRecord {
    tenantDeviceId: number;
    deviceId: number;
    menuItemId: number;
    tenantId: number;
    menuItemConfigId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantDeviceId = data["tenantDeviceId"];
            this.deviceId = data["deviceId"];
            this.menuItemId = data["menuItemId"];
            this.tenantId = data["tenantId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemDeviceRecord {
        let result = new MenuItemDeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantDeviceId"] = this.tenantDeviceId;
        data["deviceId"] = this.deviceId;
        data["menuItemId"] = this.menuItemId;
        data["tenantId"] = this.tenantId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemDeviceRecord {
    tenantDeviceId: number;
    deviceId: number;
    menuItemId: number;
    tenantId: number;
    menuItemConfigId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboGroupDetailRecord implements IComboGroupDetailRecord {
    comboGroupId: number;
    menuItemId: number;
    menuItemConfigId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboGroupDetailRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboGroupId = data["comboGroupId"];
            this.menuItemId = data["menuItemId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboGroupDetailRecord {
        let result = new ComboGroupDetailRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboGroupId"] = this.comboGroupId;
        data["menuItemId"] = this.menuItemId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboGroupDetailRecord {
    comboGroupId: number;
    menuItemId: number;
    menuItemConfigId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreMenuItemConfigDDLDto implements IStoreMenuItemConfigDDLDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    printerIds: number[];
    comboGroupIds: number[];
    menuItemPriceLists: MenuItemPriceListDto[];
    menuItemSaleTypes: MenuItemSaleTypeDto[];

    constructor(data?: IStoreMenuItemConfigDDLDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.openPrice = data["openPrice"];
            this.allowDiscount = data["allowDiscount"];
            if (data["printerIds"] && data["printerIds"].constructor === Array) {
                this.printerIds = [];
                for (let item of data["printerIds"])
                    this.printerIds.push(item);
            }
            if (data["comboGroupIds"] && data["comboGroupIds"].constructor === Array) {
                this.comboGroupIds = [];
                for (let item of data["comboGroupIds"])
                    this.comboGroupIds.push(item);
            }
            if (data["menuItemPriceLists"] && data["menuItemPriceLists"].constructor === Array) {
                this.menuItemPriceLists = [];
                for (let item of data["menuItemPriceLists"])
                    this.menuItemPriceLists.push(MenuItemPriceListDto.fromJS(item));
            }
            if (data["menuItemSaleTypes"] && data["menuItemSaleTypes"].constructor === Array) {
                this.menuItemSaleTypes = [];
                for (let item of data["menuItemSaleTypes"])
                    this.menuItemSaleTypes.push(MenuItemSaleTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreMenuItemConfigDDLDto {
        let result = new StoreMenuItemConfigDDLDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["openPrice"] = this.openPrice;
        data["allowDiscount"] = this.allowDiscount;
        if (this.printerIds && this.printerIds.constructor === Array) {
            data["printerIds"] = [];
            for (let item of this.printerIds)
                data["printerIds"].push(item);
        }
        if (this.comboGroupIds && this.comboGroupIds.constructor === Array) {
            data["comboGroupIds"] = [];
            for (let item of this.comboGroupIds)
                data["comboGroupIds"].push(item);
        }
        if (this.menuItemPriceLists && this.menuItemPriceLists.constructor === Array) {
            data["menuItemPriceLists"] = [];
            for (let item of this.menuItemPriceLists)
                data["menuItemPriceLists"].push(item.toJSON());
        }
        if (this.menuItemSaleTypes && this.menuItemSaleTypes.constructor === Array) {
            data["menuItemSaleTypes"] = [];
            for (let item of this.menuItemSaleTypes)
                data["menuItemSaleTypes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreMenuItemConfigDDLDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    printerIds: number[];
    comboGroupIds: number[];
    menuItemPriceLists: MenuItemPriceListDto[];
    menuItemSaleTypes: MenuItemSaleTypeDto[];
}

export class MenuItemSaleTypeDto implements IMenuItemSaleTypeDto {
    tenantId: number;
    menuItemId: number;
    saleTypeId: number;
    saleTypeName: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemSaleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.saleTypeId = data["saleTypeId"];
            this.saleTypeName = data["saleTypeName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemSaleTypeDto {
        let result = new MenuItemSaleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["saleTypeId"] = this.saleTypeId;
        data["saleTypeName"] = this.saleTypeName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemSaleTypeDto {
    tenantId: number;
    menuItemId: number;
    saleTypeId: number;
    saleTypeName: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedStoreMenuItemConfigList implements IPagedStoreMenuItemConfigList {
    currentPage: number;
    itemsCount: number;
    storeMenuItemConfigs: MenuItemConfigDto[];

    constructor(data?: IPagedStoreMenuItemConfigList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["storeMenuItemConfigs"] && data["storeMenuItemConfigs"].constructor === Array) {
                this.storeMenuItemConfigs = [];
                for (let item of data["storeMenuItemConfigs"])
                    this.storeMenuItemConfigs.push(MenuItemConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedStoreMenuItemConfigList {
        let result = new PagedStoreMenuItemConfigList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.storeMenuItemConfigs && this.storeMenuItemConfigs.constructor === Array) {
            data["storeMenuItemConfigs"] = [];
            for (let item of this.storeMenuItemConfigs)
                data["storeMenuItemConfigs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedStoreMenuItemConfigList {
    currentPage: number;
    itemsCount: number;
    storeMenuItemConfigs: MenuItemConfigDto[];
}

export class CreateStoreProductCategoryConfigDto implements ICreateStoreProductCategoryConfigDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    productCategoryId: number;
    storeIds: number[];

    constructor(data?: ICreateStoreProductCategoryConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.oldeEffectiveDate = data["oldeEffectiveDate"] ? moment(data["oldeEffectiveDate"].toString()) : <any>undefined;
            this.productCategoryId = data["productCategoryId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateStoreProductCategoryConfigDto {
        let result = new CreateStoreProductCategoryConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["oldeEffectiveDate"] = this.oldeEffectiveDate ? this.oldeEffectiveDate.toISOString() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateStoreProductCategoryConfigDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    productCategoryId: number;
    storeIds: number[];
}

export class StoreProductCategoryConfigDto implements IStoreProductCategoryConfigDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    productCategoryId: number;
    productCategoryName: string;
    storeId: number;
    storeName: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreProductCategoryConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.oldeEffectiveDate = data["oldeEffectiveDate"] ? moment(data["oldeEffectiveDate"].toString()) : <any>undefined;
            this.productCategoryId = data["productCategoryId"];
            this.productCategoryName = data["productCategoryName"];
            this.storeId = data["storeId"];
            this.storeName = data["storeName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreProductCategoryConfigDto {
        let result = new StoreProductCategoryConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["oldeEffectiveDate"] = this.oldeEffectiveDate ? this.oldeEffectiveDate.toISOString() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreProductCategoryConfigDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    oldeEffectiveDate: moment.Moment;
    productCategoryId: number;
    productCategoryName: string;
    storeId: number;
    storeName: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreProductCategoryConfigDDLDto implements IStoreProductCategoryConfigDDLDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;

    constructor(data?: IStoreProductCategoryConfigDDLDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreProductCategoryConfigDDLDto {
        let result = new StoreProductCategoryConfigDDLDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStoreProductCategoryConfigDDLDto {
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
}

export class PagedStoreProductCategoryConfigList implements IPagedStoreProductCategoryConfigList {
    currentPage: number;
    itemsCount: number;
    storeProductCategoryConfigs: StoreProductCategoryConfigDto[];

    constructor(data?: IPagedStoreProductCategoryConfigList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["storeProductCategoryConfigs"] && data["storeProductCategoryConfigs"].constructor === Array) {
                this.storeProductCategoryConfigs = [];
                for (let item of data["storeProductCategoryConfigs"])
                    this.storeProductCategoryConfigs.push(StoreProductCategoryConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedStoreProductCategoryConfigList {
        let result = new PagedStoreProductCategoryConfigList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.storeProductCategoryConfigs && this.storeProductCategoryConfigs.constructor === Array) {
            data["storeProductCategoryConfigs"] = [];
            for (let item of this.storeProductCategoryConfigs)
                data["storeProductCategoryConfigs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedStoreProductCategoryConfigList {
    currentPage: number;
    itemsCount: number;
    storeProductCategoryConfigs: StoreProductCategoryConfigDto[];
}

export class ListResultDtoOfStoreListItem implements IListResultDtoOfStoreListItem {
    items: StoreListItem[];

    constructor(data?: IListResultDtoOfStoreListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(StoreListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfStoreListItem {
        let result = new ListResultDtoOfStoreListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfStoreListItem {
    items: StoreListItem[];
}

export class CreateStoreInput implements ICreateStoreInput {
    currencyId: number;
    number: string;
    translations: StoreTranslationDto[];
    dayWorkingHoursIds: number[];
    inventoryManagersIds: number[];
    isWarehouse: boolean;
    closeShiftByCashier: boolean;
    storeGroupId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;

    constructor(data?: ICreateStoreInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            this.number = data["number"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(StoreTranslationDto.fromJS(item));
            }
            if (data["dayWorkingHoursIds"] && data["dayWorkingHoursIds"].constructor === Array) {
                this.dayWorkingHoursIds = [];
                for (let item of data["dayWorkingHoursIds"])
                    this.dayWorkingHoursIds.push(item);
            }
            if (data["inventoryManagersIds"] && data["inventoryManagersIds"].constructor === Array) {
                this.inventoryManagersIds = [];
                for (let item of data["inventoryManagersIds"])
                    this.inventoryManagersIds.push(item);
            }
            this.isWarehouse = data["isWarehouse"];
            this.closeShiftByCashier = data["closeShiftByCashier"];
            this.storeGroupId = data["storeGroupId"];
            this.tenantStoreGroupId = data["tenantStoreGroupId"];
            this.areaId = data["areaId"];
            this.regionId = data["regionId"];
            this.contractBegining = data["contractBegining"] ? moment(data["contractBegining"].toString()) : <any>undefined;
            this.contractEnding = data["contractEnding"] ? moment(data["contractEnding"].toString()) : <any>undefined;
            this.alertPeriod = data["alertPeriod"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    }

    static fromJS(data: any): CreateStoreInput {
        let result = new CreateStoreInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["number"] = this.number;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.dayWorkingHoursIds && this.dayWorkingHoursIds.constructor === Array) {
            data["dayWorkingHoursIds"] = [];
            for (let item of this.dayWorkingHoursIds)
                data["dayWorkingHoursIds"].push(item);
        }
        if (this.inventoryManagersIds && this.inventoryManagersIds.constructor === Array) {
            data["inventoryManagersIds"] = [];
            for (let item of this.inventoryManagersIds)
                data["inventoryManagersIds"].push(item);
        }
        data["isWarehouse"] = this.isWarehouse;
        data["closeShiftByCashier"] = this.closeShiftByCashier;
        data["storeGroupId"] = this.storeGroupId;
        data["tenantStoreGroupId"] = this.tenantStoreGroupId;
        data["areaId"] = this.areaId;
        data["regionId"] = this.regionId;
        data["contractBegining"] = this.contractBegining ? this.contractBegining.toISOString() : <any>undefined;
        data["contractEnding"] = this.contractEnding ? this.contractEnding.toISOString() : <any>undefined;
        data["alertPeriod"] = this.alertPeriod;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data; 
    }
}

export interface ICreateStoreInput {
    currencyId: number;
    number: string;
    translations: StoreTranslationDto[];
    dayWorkingHoursIds: number[];
    inventoryManagersIds: number[];
    isWarehouse: boolean;
    closeShiftByCashier: boolean;
    storeGroupId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;
}

export class UpdateStoreInput implements IUpdateStoreInput {
    id: number;
    currencyId: number;
    number: string;
    translations: StoreTranslationDto[];
    dayWorkingHoursIds: number[];
    inventoryManagersIds: number[];
    closeShiftByCashier: boolean;
    isWarehouse: boolean;
    storeGroupId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;

    constructor(data?: IUpdateStoreInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.currencyId = data["currencyId"];
            this.number = data["number"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(StoreTranslationDto.fromJS(item));
            }
            if (data["dayWorkingHoursIds"] && data["dayWorkingHoursIds"].constructor === Array) {
                this.dayWorkingHoursIds = [];
                for (let item of data["dayWorkingHoursIds"])
                    this.dayWorkingHoursIds.push(item);
            }
            if (data["inventoryManagersIds"] && data["inventoryManagersIds"].constructor === Array) {
                this.inventoryManagersIds = [];
                for (let item of data["inventoryManagersIds"])
                    this.inventoryManagersIds.push(item);
            }
            this.closeShiftByCashier = data["closeShiftByCashier"];
            this.isWarehouse = data["isWarehouse"];
            this.storeGroupId = data["storeGroupId"];
            this.tenantStoreGroupId = data["tenantStoreGroupId"];
            this.areaId = data["areaId"];
            this.regionId = data["regionId"];
            this.contractBegining = data["contractBegining"] ? moment(data["contractBegining"].toString()) : <any>undefined;
            this.contractEnding = data["contractEnding"] ? moment(data["contractEnding"].toString()) : <any>undefined;
            this.alertPeriod = data["alertPeriod"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    }

    static fromJS(data: any): UpdateStoreInput {
        let result = new UpdateStoreInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currencyId"] = this.currencyId;
        data["number"] = this.number;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.dayWorkingHoursIds && this.dayWorkingHoursIds.constructor === Array) {
            data["dayWorkingHoursIds"] = [];
            for (let item of this.dayWorkingHoursIds)
                data["dayWorkingHoursIds"].push(item);
        }
        if (this.inventoryManagersIds && this.inventoryManagersIds.constructor === Array) {
            data["inventoryManagersIds"] = [];
            for (let item of this.inventoryManagersIds)
                data["inventoryManagersIds"].push(item);
        }
        data["closeShiftByCashier"] = this.closeShiftByCashier;
        data["isWarehouse"] = this.isWarehouse;
        data["storeGroupId"] = this.storeGroupId;
        data["tenantStoreGroupId"] = this.tenantStoreGroupId;
        data["areaId"] = this.areaId;
        data["regionId"] = this.regionId;
        data["contractBegining"] = this.contractBegining ? this.contractBegining.toISOString() : <any>undefined;
        data["contractEnding"] = this.contractEnding ? this.contractEnding.toISOString() : <any>undefined;
        data["alertPeriod"] = this.alertPeriod;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data; 
    }
}

export interface IUpdateStoreInput {
    id: number;
    currencyId: number;
    number: string;
    translations: StoreTranslationDto[];
    dayWorkingHoursIds: number[];
    inventoryManagersIds: number[];
    closeShiftByCashier: boolean;
    isWarehouse: boolean;
    storeGroupId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;
}

export class OpenStoreDto implements IOpenStoreDto {
    id: number;
    openStoreDate: moment.Moment;
    timeZoneMinutes: number;

    constructor(data?: IOpenStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.openStoreDate = data["openStoreDate"] ? moment(data["openStoreDate"].toString()) : <any>undefined;
            this.timeZoneMinutes = data["timeZoneMinutes"];
        }
    }

    static fromJS(data: any): OpenStoreDto {
        let result = new OpenStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["openStoreDate"] = this.openStoreDate ? this.openStoreDate.toISOString() : <any>undefined;
        data["timeZoneMinutes"] = this.timeZoneMinutes;
        return data; 
    }
}

export interface IOpenStoreDto {
    id: number;
    openStoreDate: moment.Moment;
    timeZoneMinutes: number;
}

export class CreateWorkingHoursDto implements ICreateWorkingHoursDto {
    id: number;
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    daysWorkingHours: StoreDayWorkingHoursDto[];

    constructor(data?: ICreateWorkingHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.activeStartDate = data["activeStartDate"] ? moment(data["activeStartDate"].toString()) : <any>undefined;
            this.activeEndDate = data["activeEndDate"] ? moment(data["activeEndDate"].toString()) : <any>undefined;
            this.isActiveEndOfDay = data["isActiveEndOfDay"];
            this.isMustCloseOldShift = data["isMustCloseOldShift"];
            this.canCashierEndTheDayBeforeTime = data["canCashierEndTheDayBeforeTime"];
            this.startOfDay = data["startOfDay"];
            this.endOfDay = data["endOfDay"];
            if (data["daysWorkingHours"] && data["daysWorkingHours"].constructor === Array) {
                this.daysWorkingHours = [];
                for (let item of data["daysWorkingHours"])
                    this.daysWorkingHours.push(StoreDayWorkingHoursDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateWorkingHoursDto {
        let result = new CreateWorkingHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activeStartDate"] = this.activeStartDate ? this.activeStartDate.toISOString() : <any>undefined;
        data["activeEndDate"] = this.activeEndDate ? this.activeEndDate.toISOString() : <any>undefined;
        data["isActiveEndOfDay"] = this.isActiveEndOfDay;
        data["isMustCloseOldShift"] = this.isMustCloseOldShift;
        data["canCashierEndTheDayBeforeTime"] = this.canCashierEndTheDayBeforeTime;
        data["startOfDay"] = this.startOfDay;
        data["endOfDay"] = this.endOfDay;
        if (this.daysWorkingHours && this.daysWorkingHours.constructor === Array) {
            data["daysWorkingHours"] = [];
            for (let item of this.daysWorkingHours)
                data["daysWorkingHours"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateWorkingHoursDto {
    id: number;
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    daysWorkingHours: StoreDayWorkingHoursDto[];
}

export class StoreDayWorkingHoursDto implements IStoreDayWorkingHoursDto {
    id: number;
    dayOfWeekValue: number;
    dayOfWeekName: string;
    workingHoursStart: string;
    workingHoursEnd: string;
    storeWorkingHoursRuleId: number;

    constructor(data?: IStoreDayWorkingHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.dayOfWeekValue = data["dayOfWeekValue"];
            this.dayOfWeekName = data["dayOfWeekName"];
            this.workingHoursStart = data["workingHoursStart"];
            this.workingHoursEnd = data["workingHoursEnd"];
            this.storeWorkingHoursRuleId = data["storeWorkingHoursRuleId"];
        }
    }

    static fromJS(data: any): StoreDayWorkingHoursDto {
        let result = new StoreDayWorkingHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOfWeekValue"] = this.dayOfWeekValue;
        data["dayOfWeekName"] = this.dayOfWeekName;
        data["workingHoursStart"] = this.workingHoursStart;
        data["workingHoursEnd"] = this.workingHoursEnd;
        data["storeWorkingHoursRuleId"] = this.storeWorkingHoursRuleId;
        return data; 
    }
}

export interface IStoreDayWorkingHoursDto {
    id: number;
    dayOfWeekValue: number;
    dayOfWeekName: string;
    workingHoursStart: string;
    workingHoursEnd: string;
    storeWorkingHoursRuleId: number;
}

export class ListResultDtoOfStoreWorkingHoursRuleDto implements IListResultDtoOfStoreWorkingHoursRuleDto {
    items: StoreWorkingHoursRuleDto[];

    constructor(data?: IListResultDtoOfStoreWorkingHoursRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(StoreWorkingHoursRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfStoreWorkingHoursRuleDto {
        let result = new ListResultDtoOfStoreWorkingHoursRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfStoreWorkingHoursRuleDto {
    items: StoreWorkingHoursRuleDto[];
}

export class StoreWorkingHoursRuleDto implements IStoreWorkingHoursRuleDto {
    id: number;
    name: string;
    isActive: boolean;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    startOfDay: string;
    endOfDay: string;
    daysWorkingHours: StoreDayWorkingHoursDto[];

    constructor(data?: IStoreWorkingHoursRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.activeStartDate = data["activeStartDate"] ? moment(data["activeStartDate"].toString()) : <any>undefined;
            this.activeEndDate = data["activeEndDate"] ? moment(data["activeEndDate"].toString()) : <any>undefined;
            this.isActiveEndOfDay = data["isActiveEndOfDay"];
            this.isMustCloseOldShift = data["isMustCloseOldShift"];
            this.startOfDay = data["startOfDay"];
            this.endOfDay = data["endOfDay"];
            if (data["daysWorkingHours"] && data["daysWorkingHours"].constructor === Array) {
                this.daysWorkingHours = [];
                for (let item of data["daysWorkingHours"])
                    this.daysWorkingHours.push(StoreDayWorkingHoursDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreWorkingHoursRuleDto {
        let result = new StoreWorkingHoursRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["activeStartDate"] = this.activeStartDate ? this.activeStartDate.toISOString() : <any>undefined;
        data["activeEndDate"] = this.activeEndDate ? this.activeEndDate.toISOString() : <any>undefined;
        data["isActiveEndOfDay"] = this.isActiveEndOfDay;
        data["isMustCloseOldShift"] = this.isMustCloseOldShift;
        data["startOfDay"] = this.startOfDay;
        data["endOfDay"] = this.endOfDay;
        if (this.daysWorkingHours && this.daysWorkingHours.constructor === Array) {
            data["daysWorkingHours"] = [];
            for (let item of this.daysWorkingHours)
                data["daysWorkingHours"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreWorkingHoursRuleDto {
    id: number;
    name: string;
    isActive: boolean;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    startOfDay: string;
    endOfDay: string;
    daysWorkingHours: StoreDayWorkingHoursDto[];
}

export class StoreWorkingHoursWithMultipleShiftsDto implements IStoreWorkingHoursWithMultipleShiftsDto {
    id: number;
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    daysWorkingHours: StoreDayWorkingHourswithMultipleShiftsDto[];

    constructor(data?: IStoreWorkingHoursWithMultipleShiftsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.activeStartDate = data["activeStartDate"] ? moment(data["activeStartDate"].toString()) : <any>undefined;
            this.activeEndDate = data["activeEndDate"] ? moment(data["activeEndDate"].toString()) : <any>undefined;
            this.isActiveEndOfDay = data["isActiveEndOfDay"];
            this.isMustCloseOldShift = data["isMustCloseOldShift"];
            this.canCashierEndTheDayBeforeTime = data["canCashierEndTheDayBeforeTime"];
            this.startOfDay = data["startOfDay"];
            this.endOfDay = data["endOfDay"];
            if (data["daysWorkingHours"] && data["daysWorkingHours"].constructor === Array) {
                this.daysWorkingHours = [];
                for (let item of data["daysWorkingHours"])
                    this.daysWorkingHours.push(StoreDayWorkingHourswithMultipleShiftsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreWorkingHoursWithMultipleShiftsDto {
        let result = new StoreWorkingHoursWithMultipleShiftsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activeStartDate"] = this.activeStartDate ? this.activeStartDate.toISOString() : <any>undefined;
        data["activeEndDate"] = this.activeEndDate ? this.activeEndDate.toISOString() : <any>undefined;
        data["isActiveEndOfDay"] = this.isActiveEndOfDay;
        data["isMustCloseOldShift"] = this.isMustCloseOldShift;
        data["canCashierEndTheDayBeforeTime"] = this.canCashierEndTheDayBeforeTime;
        data["startOfDay"] = this.startOfDay;
        data["endOfDay"] = this.endOfDay;
        if (this.daysWorkingHours && this.daysWorkingHours.constructor === Array) {
            data["daysWorkingHours"] = [];
            for (let item of this.daysWorkingHours)
                data["daysWorkingHours"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStoreWorkingHoursWithMultipleShiftsDto {
    id: number;
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    daysWorkingHours: StoreDayWorkingHourswithMultipleShiftsDto[];
}

export class StoreDayWorkingHourswithMultipleShiftsDto implements IStoreDayWorkingHourswithMultipleShiftsDto {
    id: number;
    dayOfWeekValue: number;
    dayOfWeekName: string;
    shifts: StoreDayWorkingHoursShiftsDto[];
    storeWorkingHoursRuleId: number;

    constructor(data?: IStoreDayWorkingHourswithMultipleShiftsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.dayOfWeekValue = data["dayOfWeekValue"];
            this.dayOfWeekName = data["dayOfWeekName"];
            if (data["shifts"] && data["shifts"].constructor === Array) {
                this.shifts = [];
                for (let item of data["shifts"])
                    this.shifts.push(StoreDayWorkingHoursShiftsDto.fromJS(item));
            }
            this.storeWorkingHoursRuleId = data["storeWorkingHoursRuleId"];
        }
    }

    static fromJS(data: any): StoreDayWorkingHourswithMultipleShiftsDto {
        let result = new StoreDayWorkingHourswithMultipleShiftsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOfWeekValue"] = this.dayOfWeekValue;
        data["dayOfWeekName"] = this.dayOfWeekName;
        if (this.shifts && this.shifts.constructor === Array) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item.toJSON());
        }
        data["storeWorkingHoursRuleId"] = this.storeWorkingHoursRuleId;
        return data; 
    }
}

export interface IStoreDayWorkingHourswithMultipleShiftsDto {
    id: number;
    dayOfWeekValue: number;
    dayOfWeekName: string;
    shifts: StoreDayWorkingHoursShiftsDto[];
    storeWorkingHoursRuleId: number;
}

export class StoreDayWorkingHoursShiftsDto implements IStoreDayWorkingHoursShiftsDto {
    id: number;
    workingHoursStart: string;
    workingHoursEnd: string;

    constructor(data?: IStoreDayWorkingHoursShiftsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.workingHoursStart = data["workingHoursStart"];
            this.workingHoursEnd = data["workingHoursEnd"];
        }
    }

    static fromJS(data: any): StoreDayWorkingHoursShiftsDto {
        let result = new StoreDayWorkingHoursShiftsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workingHoursStart"] = this.workingHoursStart;
        data["workingHoursEnd"] = this.workingHoursEnd;
        return data; 
    }
}

export interface IStoreDayWorkingHoursShiftsDto {
    id: number;
    workingHoursStart: string;
    workingHoursEnd: string;
}

export class ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto implements IListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto {
    items: StoreDayWorkingHourswithMultipleShiftsDto[];

    constructor(data?: IListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(StoreDayWorkingHourswithMultipleShiftsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto {
        let result = new ListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfStoreDayWorkingHourswithMultipleShiftsDto {
    items: StoreDayWorkingHourswithMultipleShiftsDto[];
}

export class ListResultDtoOfSupervisorListItem implements IListResultDtoOfSupervisorListItem {
    items: SupervisorListItem[];

    constructor(data?: IListResultDtoOfSupervisorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SupervisorListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSupervisorListItem {
        let result = new ListResultDtoOfSupervisorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSupervisorListItem {
    items: SupervisorListItem[];
}

export class SupervisorListItem implements ISupervisorListItem {
    id: number;
    name: string;

    constructor(data?: ISupervisorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SupervisorListItem {
        let result = new SupervisorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ISupervisorListItem {
    id: number;
    name: string;
}

export class ListResultDtoOfCashierListItem implements IListResultDtoOfCashierListItem {
    items: CashierListItem[];

    constructor(data?: IListResultDtoOfCashierListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CashierListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCashierListItem {
        let result = new ListResultDtoOfCashierListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCashierListItem {
    items: CashierListItem[];
}

export class CashierListItem implements ICashierListItem {
    id: number;
    name: string;

    constructor(data?: ICashierListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CashierListItem {
        let result = new CashierListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICashierListItem {
    id: number;
    name: string;
}

export class ListResultDtoOfInventoryManagerListItem implements IListResultDtoOfInventoryManagerListItem {
    items: InventoryManagerListItem[];

    constructor(data?: IListResultDtoOfInventoryManagerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(InventoryManagerListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInventoryManagerListItem {
        let result = new ListResultDtoOfInventoryManagerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfInventoryManagerListItem {
    items: InventoryManagerListItem[];
}

export class InventoryManagerListItem implements IInventoryManagerListItem {
    id: number;
    name: string;

    constructor(data?: IInventoryManagerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): InventoryManagerListItem {
        let result = new InventoryManagerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IInventoryManagerListItem {
    id: number;
    name: string;
}

export class SupervisorShiftPaymentTransactionsDto implements ISupervisorShiftPaymentTransactionsDto {
    id: string;
    currency: string;
    tenderType: string;
    totalTransactionsValue: number;
    actualTransactionsValue: number;

    constructor(data?: ISupervisorShiftPaymentTransactionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.currency = data["currency"];
            this.tenderType = data["tenderType"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.actualTransactionsValue = data["actualTransactionsValue"];
        }
    }

    static fromJS(data: any): SupervisorShiftPaymentTransactionsDto {
        let result = new SupervisorShiftPaymentTransactionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currency"] = this.currency;
        data["tenderType"] = this.tenderType;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        return data; 
    }
}

export interface ISupervisorShiftPaymentTransactionsDto {
    id: string;
    currency: string;
    tenderType: string;
    totalTransactionsValue: number;
    actualTransactionsValue: number;
}

export class SupervisorStoreDto implements ISupervisorStoreDto {
    currencyId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISupervisorStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SupervisorStoreDto {
        let result = new SupervisorStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISupervisorStoreDto {
    currencyId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SupervisorShiftDto implements ISupervisorShiftDto {
    id: number;
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: SupervisorShiftDtoStatus;
    userId: number;
    storeShiftId: number;
    storeId: number;
    tenantId: number;
    supervisorShiftPaymentTransactionValues: SupervisorShiftPaymentTransactionsDto[];

    constructor(data?: ISupervisorShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.startedBy = data["startedBy"];
            this.endedBy = data["endedBy"];
            this.status = data["status"];
            this.userId = data["userId"];
            this.storeShiftId = data["storeShiftId"];
            this.storeId = data["storeId"];
            this.tenantId = data["tenantId"];
            if (data["supervisorShiftPaymentTransactionValues"] && data["supervisorShiftPaymentTransactionValues"].constructor === Array) {
                this.supervisorShiftPaymentTransactionValues = [];
                for (let item of data["supervisorShiftPaymentTransactionValues"])
                    this.supervisorShiftPaymentTransactionValues.push(SupervisorShiftPaymentTransactionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupervisorShiftDto {
        let result = new SupervisorShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["endedBy"] = this.endedBy;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["storeShiftId"] = this.storeShiftId;
        data["storeId"] = this.storeId;
        data["tenantId"] = this.tenantId;
        if (this.supervisorShiftPaymentTransactionValues && this.supervisorShiftPaymentTransactionValues.constructor === Array) {
            data["supervisorShiftPaymentTransactionValues"] = [];
            for (let item of this.supervisorShiftPaymentTransactionValues)
                data["supervisorShiftPaymentTransactionValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISupervisorShiftDto {
    id: number;
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: SupervisorShiftDtoStatus;
    userId: number;
    storeShiftId: number;
    storeId: number;
    tenantId: number;
    supervisorShiftPaymentTransactionValues: SupervisorShiftPaymentTransactionsDto[];
}

export class SupervisorDto implements ISupervisorDto {
    id: number;
    name: string;

    constructor(data?: ISupervisorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SupervisorDto {
        let result = new SupervisorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ISupervisorDto {
    id: number;
    name: string;
}

export class SyncResultOfDeliveryStreetTranslationRecord implements ISyncResultOfDeliveryStreetTranslationRecord {
    added: DeliveryStreetTranslationRecord[];
    updated: DeliveryStreetTranslationRecord[];
    deleted: DeliveryStreetTranslationRecord[];

    constructor(data?: ISyncResultOfDeliveryStreetTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeliveryStreetTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeliveryStreetTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeliveryStreetTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeliveryStreetTranslationRecord {
        let result = new SyncResultOfDeliveryStreetTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeliveryStreetTranslationRecord {
    added: DeliveryStreetTranslationRecord[];
    updated: DeliveryStreetTranslationRecord[];
    deleted: DeliveryStreetTranslationRecord[];
}

export class DeliveryStreetTranslationRecord implements IDeliveryStreetTranslationRecord {
    isSync: boolean;
    name: string;
    deliveryStreetId: number;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryStreetTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSync = data["isSync"];
            this.name = data["name"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryStreetTranslationRecord {
        let result = new DeliveryStreetTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSync"] = this.isSync;
        data["name"] = this.name;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryStreetTranslationRecord {
    isSync: boolean;
    name: string;
    deliveryStreetId: number;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfServiceChargeRecord implements ISyncResultOfServiceChargeRecord {
    added: ServiceChargeRecord[];
    updated: ServiceChargeRecord[];
    deleted: ServiceChargeRecord[];

    constructor(data?: ISyncResultOfServiceChargeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ServiceChargeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ServiceChargeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ServiceChargeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfServiceChargeRecord {
        let result = new SyncResultOfServiceChargeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfServiceChargeRecord {
    added: ServiceChargeRecord[];
    updated: ServiceChargeRecord[];
    deleted: ServiceChargeRecord[];
}

export class ServiceChargeRecord implements IServiceChargeRecord {
    amount: number;
    isPercentage: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IServiceChargeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.isPercentage = data["isPercentage"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceChargeRecord {
        let result = new ServiceChargeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["isPercentage"] = this.isPercentage;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceChargeRecord {
    amount: number;
    isPercentage: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfServiceChargeTranslationRecord implements ISyncResultOfServiceChargeTranslationRecord {
    added: ServiceChargeTranslationRecord[];
    updated: ServiceChargeTranslationRecord[];
    deleted: ServiceChargeTranslationRecord[];

    constructor(data?: ISyncResultOfServiceChargeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ServiceChargeTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ServiceChargeTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ServiceChargeTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfServiceChargeTranslationRecord {
        let result = new SyncResultOfServiceChargeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfServiceChargeTranslationRecord {
    added: ServiceChargeTranslationRecord[];
    updated: ServiceChargeTranslationRecord[];
    deleted: ServiceChargeTranslationRecord[];
}

export class ServiceChargeTranslationRecord implements IServiceChargeTranslationRecord {
    name: string;
    serviceChargeId: number;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IServiceChargeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.serviceChargeId = data["serviceChargeId"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceChargeTranslationRecord {
        let result = new ServiceChargeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serviceChargeId"] = this.serviceChargeId;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceChargeTranslationRecord {
    name: string;
    serviceChargeId: number;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfServiceChargeSaleTypeRecord implements ISyncResultOfServiceChargeSaleTypeRecord {
    added: ServiceChargeSaleTypeRecord[];
    updated: ServiceChargeSaleTypeRecord[];
    deleted: ServiceChargeSaleTypeRecord[];

    constructor(data?: ISyncResultOfServiceChargeSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ServiceChargeSaleTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ServiceChargeSaleTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ServiceChargeSaleTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfServiceChargeSaleTypeRecord {
        let result = new SyncResultOfServiceChargeSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfServiceChargeSaleTypeRecord {
    added: ServiceChargeSaleTypeRecord[];
    updated: ServiceChargeSaleTypeRecord[];
    deleted: ServiceChargeSaleTypeRecord[];
}

export class ServiceChargeSaleTypeRecord implements IServiceChargeSaleTypeRecord {
    saleTypeId: number;
    serviceChargeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IServiceChargeSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTypeId = data["saleTypeId"];
            this.serviceChargeId = data["serviceChargeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceChargeSaleTypeRecord {
        let result = new ServiceChargeSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTypeId"] = this.saleTypeId;
        data["serviceChargeId"] = this.serviceChargeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceChargeSaleTypeRecord {
    saleTypeId: number;
    serviceChargeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfSaleTypePriceListRecord implements ISyncResultOfSaleTypePriceListRecord {
    added: SaleTypePriceListRecord[];
    updated: SaleTypePriceListRecord[];
    deleted: SaleTypePriceListRecord[];

    constructor(data?: ISyncResultOfSaleTypePriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SaleTypePriceListRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SaleTypePriceListRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SaleTypePriceListRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSaleTypePriceListRecord {
        let result = new SyncResultOfSaleTypePriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSaleTypePriceListRecord {
    added: SaleTypePriceListRecord[];
    updated: SaleTypePriceListRecord[];
    deleted: SaleTypePriceListRecord[];
}

export class SaleTypePriceListRecord implements ISaleTypePriceListRecord {
    saleTypeId: number;
    priceListId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypePriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTypeId = data["saleTypeId"];
            this.priceListId = data["priceListId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypePriceListRecord {
        let result = new SaleTypePriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTypeId"] = this.saleTypeId;
        data["priceListId"] = this.priceListId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypePriceListRecord {
    saleTypeId: number;
    priceListId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfStoreRecord implements ISyncResultOfStoreRecord {
    added: StoreRecord[];
    updated: StoreRecord[];
    deleted: StoreRecord[];

    constructor(data?: ISyncResultOfStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreRecord {
        let result = new SyncResultOfStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreRecord {
    added: StoreRecord[];
    updated: StoreRecord[];
    deleted: StoreRecord[];
}

export class StoreRecord implements IStoreRecord {
    storeId: number;
    saleNatural: StoreRecordSaleNatural;
    tenantId: number;
    storeStatus: number;
    currencyId: number;
    activeShiftId: number;
    isStoreGroup: boolean;
    storeGroupParentId: number;
    storeGroupId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.saleNatural = data["saleNatural"];
            this.tenantId = data["tenantId"];
            this.storeStatus = data["storeStatus"];
            this.currencyId = data["currencyId"];
            this.activeShiftId = data["activeShiftId"];
            this.isStoreGroup = data["isStoreGroup"];
            this.storeGroupParentId = data["storeGroupParentId"];
            this.storeGroupId = data["storeGroupId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreRecord {
        let result = new StoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["saleNatural"] = this.saleNatural;
        data["tenantId"] = this.tenantId;
        data["storeStatus"] = this.storeStatus;
        data["currencyId"] = this.currencyId;
        data["activeShiftId"] = this.activeShiftId;
        data["isStoreGroup"] = this.isStoreGroup;
        data["storeGroupParentId"] = this.storeGroupParentId;
        data["storeGroupId"] = this.storeGroupId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreRecord {
    storeId: number;
    saleNatural: StoreRecordSaleNatural;
    tenantId: number;
    storeStatus: number;
    currencyId: number;
    activeShiftId: number;
    isStoreGroup: boolean;
    storeGroupParentId: number;
    storeGroupId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemPriceListRecord implements ISyncResultOfMenuItemPriceListRecord {
    added: MenuItemPriceListRecord[];
    updated: MenuItemPriceListRecord[];
    deleted: MenuItemPriceListRecord[];

    constructor(data?: ISyncResultOfMenuItemPriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemPriceListRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemPriceListRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemPriceListRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemPriceListRecord {
        let result = new SyncResultOfMenuItemPriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemPriceListRecord {
    added: MenuItemPriceListRecord[];
    updated: MenuItemPriceListRecord[];
    deleted: MenuItemPriceListRecord[];
}

export class MenuItemPriceListRecord implements IMenuItemPriceListRecord {
    menuItemId: number;
    menuItemConfigId: number;
    priceListId: number;
    price: number;
    unitOfMeasureId: number;
    factor: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemPriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.factor = data["factor"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemPriceListRecord {
        let result = new MenuItemPriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["factor"] = this.factor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemPriceListRecord {
    menuItemId: number;
    menuItemConfigId: number;
    priceListId: number;
    price: number;
    unitOfMeasureId: number;
    factor: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemSaleTypeRecord implements ISyncResultOfMenuItemSaleTypeRecord {
    added: MenuItemSaleTypeRecord[];
    updated: MenuItemSaleTypeRecord[];
    deleted: MenuItemSaleTypeRecord[];

    constructor(data?: ISyncResultOfMenuItemSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemSaleTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemSaleTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemSaleTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemSaleTypeRecord {
        let result = new SyncResultOfMenuItemSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemSaleTypeRecord {
    added: MenuItemSaleTypeRecord[];
    updated: MenuItemSaleTypeRecord[];
    deleted: MenuItemSaleTypeRecord[];
}

export class MenuItemSaleTypeRecord implements IMenuItemSaleTypeRecord {
    tenantId: number;
    menuItemId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.saleTypeId = data["saleTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemSaleTypeRecord {
        let result = new MenuItemSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["saleTypeId"] = this.saleTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemSaleTypeRecord {
    tenantId: number;
    menuItemId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemRecord implements ISyncResultOfMenuItemRecord {
    added: MenuItemRecord[];
    updated: MenuItemRecord[];
    deleted: MenuItemRecord[];

    constructor(data?: ISyncResultOfMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemRecord {
        let result = new SyncResultOfMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemRecord {
    added: MenuItemRecord[];
    updated: MenuItemRecord[];
    deleted: MenuItemRecord[];
}

export class MenuItemRecord implements IMenuItemRecord {
    tenantId: number;
    reportGroupId: number;
    mainGroupId: number;
    materialGroupId: number;
    productCategoryId: number;
    isHidden: boolean;
    imageId: string;
    openPrice: boolean;
    levelId: number;
    hasTobaccoTax: boolean;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isComboMealDefinitionItem: boolean;
    isShowInPlugIn: boolean;
    menuItemConfigId: number;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    menuItemConfigSummaries: MenuItemConfigSummaryRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.reportGroupId = data["reportGroupId"];
            this.mainGroupId = data["mainGroupId"];
            this.materialGroupId = data["materialGroupId"];
            this.productCategoryId = data["productCategoryId"];
            this.isHidden = data["isHidden"];
            this.imageId = data["imageId"];
            this.openPrice = data["openPrice"];
            this.levelId = data["levelId"];
            this.hasTobaccoTax = data["hasTobaccoTax"];
            this.itemCode = data["itemCode"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isComboMealDefinitionItem = data["isComboMealDefinitionItem"];
            this.isShowInPlugIn = data["isShowInPlugIn"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.isHoteSaleing = data["isHoteSaleing"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.numberOfCalories = data["numberOfCalories"];
            this.numberOfSteps = data["numberOfSteps"];
            this.allowDecimal = data["allowDecimal"];
            if (data["menuItemConfigSummaries"] && data["menuItemConfigSummaries"].constructor === Array) {
                this.menuItemConfigSummaries = [];
                for (let item of data["menuItemConfigSummaries"])
                    this.menuItemConfigSummaries.push(MenuItemConfigSummaryRecord.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemRecord {
        let result = new MenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["reportGroupId"] = this.reportGroupId;
        data["mainGroupId"] = this.mainGroupId;
        data["materialGroupId"] = this.materialGroupId;
        data["productCategoryId"] = this.productCategoryId;
        data["isHidden"] = this.isHidden;
        data["imageId"] = this.imageId;
        data["openPrice"] = this.openPrice;
        data["levelId"] = this.levelId;
        data["hasTobaccoTax"] = this.hasTobaccoTax;
        data["itemCode"] = this.itemCode;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isComboMealDefinitionItem"] = this.isComboMealDefinitionItem;
        data["isShowInPlugIn"] = this.isShowInPlugIn;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["isHoteSaleing"] = this.isHoteSaleing;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["numberOfCalories"] = this.numberOfCalories;
        data["numberOfSteps"] = this.numberOfSteps;
        data["allowDecimal"] = this.allowDecimal;
        if (this.menuItemConfigSummaries && this.menuItemConfigSummaries.constructor === Array) {
            data["menuItemConfigSummaries"] = [];
            for (let item of this.menuItemConfigSummaries)
                data["menuItemConfigSummaries"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemRecord {
    tenantId: number;
    reportGroupId: number;
    mainGroupId: number;
    materialGroupId: number;
    productCategoryId: number;
    isHidden: boolean;
    imageId: string;
    openPrice: boolean;
    levelId: number;
    hasTobaccoTax: boolean;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isComboMealDefinitionItem: boolean;
    isShowInPlugIn: boolean;
    menuItemConfigId: number;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    menuItemConfigSummaries: MenuItemConfigSummaryRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemConfigSummaryRecord implements IMenuItemConfigSummaryRecord {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    isBasic: boolean;
    menuItemId: number;
    menuItemConfigId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemConfigSummaryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.openPrice = data["openPrice"];
            this.allowDiscount = data["allowDiscount"];
            this.isBasic = data["isBasic"];
            this.menuItemId = data["menuItemId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemConfigSummaryRecord {
        let result = new MenuItemConfigSummaryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["openPrice"] = this.openPrice;
        data["allowDiscount"] = this.allowDiscount;
        data["isBasic"] = this.isBasic;
        data["menuItemId"] = this.menuItemId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemConfigSummaryRecord {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    isBasic: boolean;
    menuItemId: number;
    menuItemConfigId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemTranslationRecord implements ISyncResultOfMenuItemTranslationRecord {
    added: MenuItemTranslationRecord[];
    updated: MenuItemTranslationRecord[];
    deleted: MenuItemTranslationRecord[];

    constructor(data?: ISyncResultOfMenuItemTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemTranslationRecord {
        let result = new SyncResultOfMenuItemTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemTranslationRecord {
    added: MenuItemTranslationRecord[];
    updated: MenuItemTranslationRecord[];
    deleted: MenuItemTranslationRecord[];
}

export class MenuItemTranslationRecord implements IMenuItemTranslationRecord {
    languageId: number;
    tenantId: number;
    name: string;
    menuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.menuItemId = data["menuItemId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemTranslationRecord {
        let result = new MenuItemTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["menuItemId"] = this.menuItemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemTranslationRecord {
    languageId: number;
    tenantId: number;
    name: string;
    menuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfFileRecord implements ISyncResultOfFileRecord {
    added: FileRecord[];
    updated: FileRecord[];
    deleted: FileRecord[];

    constructor(data?: ISyncResultOfFileRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(FileRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(FileRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(FileRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfFileRecord {
        let result = new SyncResultOfFileRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfFileRecord {
    added: FileRecord[];
    updated: FileRecord[];
    deleted: FileRecord[];
}

export class FileRecord implements IFileRecord {
    fileId: string;
    bytes: string;

    constructor(data?: IFileRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.bytes = data["bytes"];
        }
    }

    static fromJS(data: any): FileRecord {
        let result = new FileRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["bytes"] = this.bytes;
        return data; 
    }
}

export interface IFileRecord {
    fileId: string;
    bytes: string;
}

export class SyncResultOfRawMaterialRecord implements ISyncResultOfRawMaterialRecord {
    added: RawMaterialRecord[];
    updated: RawMaterialRecord[];
    deleted: RawMaterialRecord[];

    constructor(data?: ISyncResultOfRawMaterialRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RawMaterialRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RawMaterialRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RawMaterialRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRawMaterialRecord {
        let result = new SyncResultOfRawMaterialRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRawMaterialRecord {
    added: RawMaterialRecord[];
    updated: RawMaterialRecord[];
    deleted: RawMaterialRecord[];
}

export class RawMaterialRecord implements IRawMaterialRecord {
    materialGroupId: number;
    reOrderLevel: number;
    maxQuantity: number;
    barCode: string;
    sellingPrice: number;
    itemCost: number;
    periodId: number;
    isBatch: boolean;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialGroupId = data["materialGroupId"];
            this.reOrderLevel = data["reOrderLevel"];
            this.maxQuantity = data["maxQuantity"];
            this.barCode = data["barCode"];
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
            this.periodId = data["periodId"];
            this.isBatch = data["isBatch"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialRecord {
        let result = new RawMaterialRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialGroupId"] = this.materialGroupId;
        data["reOrderLevel"] = this.reOrderLevel;
        data["maxQuantity"] = this.maxQuantity;
        data["barCode"] = this.barCode;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        data["periodId"] = this.periodId;
        data["isBatch"] = this.isBatch;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialRecord {
    materialGroupId: number;
    reOrderLevel: number;
    maxQuantity: number;
    barCode: string;
    sellingPrice: number;
    itemCost: number;
    periodId: number;
    isBatch: boolean;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfRawMaterialTranslationRecord implements ISyncResultOfRawMaterialTranslationRecord {
    added: RawMaterialTranslationRecord[];
    updated: RawMaterialTranslationRecord[];
    deleted: RawMaterialTranslationRecord[];

    constructor(data?: ISyncResultOfRawMaterialTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RawMaterialTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RawMaterialTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RawMaterialTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRawMaterialTranslationRecord {
        let result = new SyncResultOfRawMaterialTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRawMaterialTranslationRecord {
    added: RawMaterialTranslationRecord[];
    updated: RawMaterialTranslationRecord[];
    deleted: RawMaterialTranslationRecord[];
}

export class RawMaterialTranslationRecord implements IRawMaterialTranslationRecord {
    languageId: number;
    name: string;
    rawMaterialId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageId = data["languageId"];
            this.name = data["name"];
            this.rawMaterialId = data["rawMaterialId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialTranslationRecord {
        let result = new RawMaterialTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["rawMaterialId"] = this.rawMaterialId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialTranslationRecord {
    languageId: number;
    name: string;
    rawMaterialId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfRawMaterialSupplierRecord implements ISyncResultOfRawMaterialSupplierRecord {
    added: RawMaterialSupplierRecord[];
    updated: RawMaterialSupplierRecord[];
    deleted: RawMaterialSupplierRecord[];

    constructor(data?: ISyncResultOfRawMaterialSupplierRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RawMaterialSupplierRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RawMaterialSupplierRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RawMaterialSupplierRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRawMaterialSupplierRecord {
        let result = new SyncResultOfRawMaterialSupplierRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRawMaterialSupplierRecord {
    added: RawMaterialSupplierRecord[];
    updated: RawMaterialSupplierRecord[];
    deleted: RawMaterialSupplierRecord[];
}

export class RawMaterialSupplierRecord implements IRawMaterialSupplierRecord {
    rawMaterialId: number;
    supplierId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialSupplierRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawMaterialId = data["rawMaterialId"];
            this.supplierId = data["supplierId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialSupplierRecord {
        let result = new RawMaterialSupplierRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialId"] = this.rawMaterialId;
        data["supplierId"] = this.supplierId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialSupplierRecord {
    rawMaterialId: number;
    supplierId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfRawMaterialDetailRecord implements ISyncResultOfRawMaterialDetailRecord {
    added: RawMaterialDetailRecord[];
    updated: RawMaterialDetailRecord[];
    deleted: RawMaterialDetailRecord[];

    constructor(data?: ISyncResultOfRawMaterialDetailRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RawMaterialDetailRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RawMaterialDetailRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RawMaterialDetailRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRawMaterialDetailRecord {
        let result = new SyncResultOfRawMaterialDetailRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRawMaterialDetailRecord {
    added: RawMaterialDetailRecord[];
    updated: RawMaterialDetailRecord[];
    deleted: RawMaterialDetailRecord[];
}

export class RawMaterialDetailRecord implements IRawMaterialDetailRecord {
    rawMaterialId: number;
    quantity: number;
    rawMaterialComponentId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialDetailRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rawMaterialId = data["rawMaterialId"];
            this.quantity = data["quantity"];
            this.rawMaterialComponentId = data["rawMaterialComponentId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialDetailRecord {
        let result = new RawMaterialDetailRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialId"] = this.rawMaterialId;
        data["quantity"] = this.quantity;
        data["rawMaterialComponentId"] = this.rawMaterialComponentId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialDetailRecord {
    rawMaterialId: number;
    quantity: number;
    rawMaterialComponentId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDeviceRecord implements ISyncResultOfDeviceRecord {
    added: DeviceRecord[];
    updated: DeviceRecord[];
    deleted: DeviceRecord[];

    constructor(data?: ISyncResultOfDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeviceRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeviceRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeviceRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeviceRecord {
        let result = new SyncResultOfDeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeviceRecord {
    added: DeviceRecord[];
    updated: DeviceRecord[];
    deleted: DeviceRecord[];
}

export class DeviceRecord implements IDeviceRecord {
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    languageId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    tenantId: number;
    tableNumberAvilable: number;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.machineName = data["machineName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.connectorTypeId = data["connectorTypeId"];
            this.languageId = data["languageId"];
            this.assigningAuthenticationObj = data["assigningAuthenticationObj"];
            this.addPicture = data["addPicture"];
            this.changColorFont = data["changColorFont"];
            this.tenantId = data["tenantId"];
            this.tableNumberAvilable = data["tableNumberAvilable"];
            this.backupDeviceId = data["backupDeviceId"];
            this.kdsId = data["kdsId"];
            this.kdsIp = data["kdsIp"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceRecord {
        let result = new DeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineName"] = this.machineName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["connectorTypeId"] = this.connectorTypeId;
        data["languageId"] = this.languageId;
        data["assigningAuthenticationObj"] = this.assigningAuthenticationObj;
        data["addPicture"] = this.addPicture;
        data["changColorFont"] = this.changColorFont;
        data["tenantId"] = this.tenantId;
        data["tableNumberAvilable"] = this.tableNumberAvilable;
        data["backupDeviceId"] = this.backupDeviceId;
        data["kdsId"] = this.kdsId;
        data["kdsIp"] = this.kdsIp;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeviceRecord {
    machineName: string;
    deviceTypeId: number;
    connectorTypeId: number;
    languageId: number;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    tenantId: number;
    tableNumberAvilable: number;
    backupDeviceId: number;
    kdsId: string;
    kdsIp: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfAssetRecord implements ISyncResultOfAssetRecord {
    added: AssetRecord[];
    updated: AssetRecord[];
    deleted: AssetRecord[];

    constructor(data?: ISyncResultOfAssetRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(AssetRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(AssetRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(AssetRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfAssetRecord {
        let result = new SyncResultOfAssetRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfAssetRecord {
    added: AssetRecord[];
    updated: AssetRecord[];
    deleted: AssetRecord[];
}

export class AssetRecord implements IAssetRecord {
    id: number;
    advertisementId: number;
    tenantId: number;
    name: string;
    filePath: string;

    constructor(data?: IAssetRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.advertisementId = data["advertisementId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.filePath = data["filePath"];
        }
    }

    static fromJS(data: any): AssetRecord {
        let result = new AssetRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["advertisementId"] = this.advertisementId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["filePath"] = this.filePath;
        return data; 
    }
}

export interface IAssetRecord {
    id: number;
    advertisementId: number;
    tenantId: number;
    name: string;
    filePath: string;
}

export class SyncResultOfDeviceTableRecord implements ISyncResultOfDeviceTableRecord {
    added: DeviceTableRecord[];
    updated: DeviceTableRecord[];
    deleted: DeviceTableRecord[];

    constructor(data?: ISyncResultOfDeviceTableRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeviceTableRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeviceTableRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeviceTableRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeviceTableRecord {
        let result = new SyncResultOfDeviceTableRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeviceTableRecord {
    added: DeviceTableRecord[];
    updated: DeviceTableRecord[];
    deleted: DeviceTableRecord[];
}

export class DeviceTableRecord implements IDeviceTableRecord {
    tenantId: number;
    deviceId: number;
    pcId: number;
    tableId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeviceTableRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.pcId = data["pcId"];
            this.tableId = data["tableId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceTableRecord {
        let result = new DeviceTableRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["pcId"] = this.pcId;
        data["tableId"] = this.tableId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeviceTableRecord {
    tenantId: number;
    deviceId: number;
    pcId: number;
    tableId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDeviceCategoryRecord implements ISyncResultOfDeviceCategoryRecord {
    added: DeviceCategoryRecord[];
    updated: DeviceCategoryRecord[];
    deleted: DeviceCategoryRecord[];

    constructor(data?: ISyncResultOfDeviceCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeviceCategoryRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeviceCategoryRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeviceCategoryRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeviceCategoryRecord {
        let result = new SyncResultOfDeviceCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeviceCategoryRecord {
    added: DeviceCategoryRecord[];
    updated: DeviceCategoryRecord[];
    deleted: DeviceCategoryRecord[];
}

export class DeviceCategoryRecord implements IDeviceCategoryRecord {
    tenantId: number;
    deviceId: number;
    tenantDeviceId: number;
    pcId: number;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeviceCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.tenantDeviceId = data["tenantDeviceId"];
            this.pcId = data["pcId"];
            this.productCategoryId = data["productCategoryId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceCategoryRecord {
        let result = new DeviceCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["tenantDeviceId"] = this.tenantDeviceId;
        data["pcId"] = this.pcId;
        data["productCategoryId"] = this.productCategoryId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeviceCategoryRecord {
    tenantId: number;
    deviceId: number;
    tenantDeviceId: number;
    pcId: number;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfStoreTranslationRecord implements ISyncResultOfStoreTranslationRecord {
    added: StoreTranslationRecord[];
    updated: StoreTranslationRecord[];
    deleted: StoreTranslationRecord[];

    constructor(data?: ISyncResultOfStoreTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreTranslationRecord {
        let result = new SyncResultOfStoreTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreTranslationRecord {
    added: StoreTranslationRecord[];
    updated: StoreTranslationRecord[];
    deleted: StoreTranslationRecord[];
}

export class StoreTranslationRecord implements IStoreTranslationRecord {
    languageId: number;
    name: string;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageId = data["languageId"];
            this.name = data["name"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreTranslationRecord {
        let result = new StoreTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreTranslationRecord {
    languageId: number;
    name: string;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfStoreDevicecRecord implements ISyncResultOfStoreDevicecRecord {
    added: StoreDevicecRecord[];
    updated: StoreDevicecRecord[];
    deleted: StoreDevicecRecord[];

    constructor(data?: ISyncResultOfStoreDevicecRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreDevicecRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreDevicecRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreDevicecRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreDevicecRecord {
        let result = new SyncResultOfStoreDevicecRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreDevicecRecord {
    added: StoreDevicecRecord[];
    updated: StoreDevicecRecord[];
    deleted: StoreDevicecRecord[];
}

export class StoreDevicecRecord implements IStoreDevicecRecord {
    tenantId: number;
    deviceId: number;
    pcId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreDevicecRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.pcId = data["pcId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreDevicecRecord {
        let result = new StoreDevicecRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["pcId"] = this.pcId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreDevicecRecord {
    tenantId: number;
    deviceId: number;
    pcId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemDeviceRecord implements ISyncResultOfMenuItemDeviceRecord {
    added: MenuItemDeviceRecord[];
    updated: MenuItemDeviceRecord[];
    deleted: MenuItemDeviceRecord[];

    constructor(data?: ISyncResultOfMenuItemDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemDeviceRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemDeviceRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemDeviceRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemDeviceRecord {
        let result = new SyncResultOfMenuItemDeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemDeviceRecord {
    added: MenuItemDeviceRecord[];
    updated: MenuItemDeviceRecord[];
    deleted: MenuItemDeviceRecord[];
}

export class SyncResultOfDevicePCRecord implements ISyncResultOfDevicePCRecord {
    added: DevicePCRecord[];
    updated: DevicePCRecord[];
    deleted: DevicePCRecord[];

    constructor(data?: ISyncResultOfDevicePCRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DevicePCRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DevicePCRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DevicePCRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDevicePCRecord {
        let result = new SyncResultOfDevicePCRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDevicePCRecord {
    added: DevicePCRecord[];
    updated: DevicePCRecord[];
    deleted: DevicePCRecord[];
}

export class DevicePCRecord implements IDevicePCRecord {
    tenantId: number;
    deviceId: number;
    pcId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDevicePCRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.pcId = data["pcId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DevicePCRecord {
        let result = new DevicePCRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["pcId"] = this.pcId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDevicePCRecord {
    tenantId: number;
    deviceId: number;
    pcId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPCRecord implements ISyncResultOfPCRecord {
    added: PCRecord[];
    updated: PCRecord[];
    deleted: PCRecord[];

    constructor(data?: ISyncResultOfPCRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PCRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PCRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PCRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPCRecord {
        let result = new SyncResultOfPCRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPCRecord {
    added: PCRecord[];
    updated: PCRecord[];
    deleted: PCRecord[];
}

export class PCRecord implements IPCRecord {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    ipAddress: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPCRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pcId = data["pcId"];
            this.machineName = data["machineName"];
            this.saleTypeId = data["saleTypeId"];
            this.ipAddress = data["ipAddress"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PCRecord {
        let result = new PCRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcId"] = this.pcId;
        data["machineName"] = this.machineName;
        data["saleTypeId"] = this.saleTypeId;
        data["ipAddress"] = this.ipAddress;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPCRecord {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    ipAddress: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMaterialStockRecord implements ISyncResultOfMaterialStockRecord {
    added: MaterialStockRecord[];
    updated: MaterialStockRecord[];
    deleted: MaterialStockRecord[];

    constructor(data?: ISyncResultOfMaterialStockRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MaterialStockRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MaterialStockRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MaterialStockRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMaterialStockRecord {
        let result = new SyncResultOfMaterialStockRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMaterialStockRecord {
    added: MaterialStockRecord[];
    updated: MaterialStockRecord[];
    deleted: MaterialStockRecord[];
}

export class MaterialStockRecord implements IMaterialStockRecord {
    materialStockId: number;
    materialId: number;
    storeId: number;
    qty: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMaterialStockRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialStockId = data["materialStockId"];
            this.materialId = data["materialId"];
            this.storeId = data["storeId"];
            this.qty = data["qty"];
            this.price = data["price"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MaterialStockRecord {
        let result = new MaterialStockRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialStockId"] = this.materialStockId;
        data["materialId"] = this.materialId;
        data["storeId"] = this.storeId;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMaterialStockRecord {
    materialStockId: number;
    materialId: number;
    storeId: number;
    qty: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDiscountTypeRecord implements ISyncResultOfDiscountTypeRecord {
    added: DiscountTypeRecord[];
    updated: DiscountTypeRecord[];
    deleted: DiscountTypeRecord[];

    constructor(data?: ISyncResultOfDiscountTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DiscountTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DiscountTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DiscountTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDiscountTypeRecord {
        let result = new SyncResultOfDiscountTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDiscountTypeRecord {
    added: DiscountTypeRecord[];
    updated: DiscountTypeRecord[];
    deleted: DiscountTypeRecord[];
}

export class DiscountTypeRecord implements IDiscountTypeRecord {
    typeId: number;
    typeName: string;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    amount: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDiscountTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.isOnSpecificItem = data["isOnSpecificItem"];
            this.isOnTotalReceipt = data["isOnTotalReceipt"];
            this.amount = data["amount"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DiscountTypeRecord {
        let result = new DiscountTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["isOnSpecificItem"] = this.isOnSpecificItem;
        data["isOnTotalReceipt"] = this.isOnTotalReceipt;
        data["amount"] = this.amount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDiscountTypeRecord {
    typeId: number;
    typeName: string;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    amount: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDiscountTypeTranslationRecord implements ISyncResultOfDiscountTypeTranslationRecord {
    added: DiscountTypeTranslationRecord[];
    updated: DiscountTypeTranslationRecord[];
    deleted: DiscountTypeTranslationRecord[];

    constructor(data?: ISyncResultOfDiscountTypeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DiscountTypeTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DiscountTypeTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DiscountTypeTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDiscountTypeTranslationRecord {
        let result = new SyncResultOfDiscountTypeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDiscountTypeTranslationRecord {
    added: DiscountTypeTranslationRecord[];
    updated: DiscountTypeTranslationRecord[];
    deleted: DiscountTypeTranslationRecord[];
}

export class DiscountTypeTranslationRecord implements IDiscountTypeTranslationRecord {
    languageId: number;
    name: string;
    discountTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDiscountTypeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageId = data["languageId"];
            this.name = data["name"];
            this.discountTypeId = data["discountTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DiscountTypeTranslationRecord {
        let result = new DiscountTypeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["discountTypeId"] = this.discountTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDiscountTypeTranslationRecord {
    languageId: number;
    name: string;
    discountTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfRecipeRecord implements ISyncResultOfRecipeRecord {
    added: RecipeRecord[];
    updated: RecipeRecord[];
    deleted: RecipeRecord[];

    constructor(data?: ISyncResultOfRecipeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RecipeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RecipeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RecipeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRecipeRecord {
        let result = new SyncResultOfRecipeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRecipeRecord {
    added: RecipeRecord[];
    updated: RecipeRecord[];
    deleted: RecipeRecord[];
}

export class RecipeRecord implements IRecipeRecord {
    menuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeRecord {
        let result = new RecipeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeRecord {
    menuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfRecipeRawMaterialRecord implements ISyncResultOfRecipeRawMaterialRecord {
    added: RecipeRawMaterialRecord[];
    updated: RecipeRawMaterialRecord[];
    deleted: RecipeRawMaterialRecord[];

    constructor(data?: ISyncResultOfRecipeRawMaterialRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RecipeRawMaterialRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RecipeRawMaterialRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RecipeRawMaterialRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRecipeRawMaterialRecord {
        let result = new SyncResultOfRecipeRawMaterialRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRecipeRawMaterialRecord {
    added: RecipeRawMaterialRecord[];
    updated: RecipeRawMaterialRecord[];
    deleted: RecipeRawMaterialRecord[];
}

export class RecipeRawMaterialRecord implements IRecipeRawMaterialRecord {
    quantity: number;
    lossFactor: number;
    rawMaterialId: number;
    recipeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipeRawMaterialRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quantity = data["quantity"];
            this.lossFactor = data["lossFactor"];
            this.rawMaterialId = data["rawMaterialId"];
            this.recipeId = data["recipeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeRawMaterialRecord {
        let result = new RecipeRawMaterialRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["lossFactor"] = this.lossFactor;
        data["rawMaterialId"] = this.rawMaterialId;
        data["recipeId"] = this.recipeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeRawMaterialRecord {
    quantity: number;
    lossFactor: number;
    rawMaterialId: number;
    recipeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfRecipeSaleTypeRecord implements ISyncResultOfRecipeSaleTypeRecord {
    added: RecipeSaleTypeRecord[];
    updated: RecipeSaleTypeRecord[];
    deleted: RecipeSaleTypeRecord[];

    constructor(data?: ISyncResultOfRecipeSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RecipeSaleTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RecipeSaleTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RecipeSaleTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRecipeSaleTypeRecord {
        let result = new SyncResultOfRecipeSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRecipeSaleTypeRecord {
    added: RecipeSaleTypeRecord[];
    updated: RecipeSaleTypeRecord[];
    deleted: RecipeSaleTypeRecord[];
}

export class RecipeSaleTypeRecord implements IRecipeSaleTypeRecord {
    saleTypeId: number;
    recipeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipeSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTypeId = data["saleTypeId"];
            this.recipeId = data["recipeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeSaleTypeRecord {
        let result = new RecipeSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTypeId"] = this.saleTypeId;
        data["recipeId"] = this.recipeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeSaleTypeRecord {
    saleTypeId: number;
    recipeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfComboGroupRecord implements ISyncResultOfComboGroupRecord {
    added: ComboGroupRecord[];
    updated: ComboGroupRecord[];
    deleted: ComboGroupRecord[];

    constructor(data?: ISyncResultOfComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboGroupRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboGroupRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboGroupRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboGroupRecord {
        let result = new SyncResultOfComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboGroupRecord {
    added: ComboGroupRecord[];
    updated: ComboGroupRecord[];
    deleted: ComboGroupRecord[];
}

export class ComboGroupRecord implements IComboGroupRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboGroupRecord {
        let result = new ComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboGroupRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfComboGroupDetailRecord implements ISyncResultOfComboGroupDetailRecord {
    added: ComboGroupDetailRecord[];
    updated: ComboGroupDetailRecord[];
    deleted: ComboGroupDetailRecord[];

    constructor(data?: ISyncResultOfComboGroupDetailRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboGroupDetailRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboGroupDetailRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboGroupDetailRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboGroupDetailRecord {
        let result = new SyncResultOfComboGroupDetailRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboGroupDetailRecord {
    added: ComboGroupDetailRecord[];
    updated: ComboGroupDetailRecord[];
    deleted: ComboGroupDetailRecord[];
}

export class SyncResultOfPriceListComboGroupRecord implements ISyncResultOfPriceListComboGroupRecord {
    added: PriceListComboGroupRecord[];
    updated: PriceListComboGroupRecord[];
    deleted: PriceListComboGroupRecord[];

    constructor(data?: ISyncResultOfPriceListComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PriceListComboGroupRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PriceListComboGroupRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PriceListComboGroupRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPriceListComboGroupRecord {
        let result = new SyncResultOfPriceListComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPriceListComboGroupRecord {
    added: PriceListComboGroupRecord[];
    updated: PriceListComboGroupRecord[];
    deleted: PriceListComboGroupRecord[];
}

export class PriceListComboGroupRecord implements IPriceListComboGroupRecord {
    priceListId: number;
    languageId: number;
    price: number;
    comboGroupId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPriceListComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priceListId = data["priceListId"];
            this.languageId = data["languageId"];
            this.price = data["price"];
            this.comboGroupId = data["comboGroupId"];
            this.name = data["name"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PriceListComboGroupRecord {
        let result = new PriceListComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceListId"] = this.priceListId;
        data["languageId"] = this.languageId;
        data["price"] = this.price;
        data["comboGroupId"] = this.comboGroupId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPriceListComboGroupRecord {
    priceListId: number;
    languageId: number;
    price: number;
    comboGroupId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfSaleTypeComboGroupRecord implements ISyncResultOfSaleTypeComboGroupRecord {
    added: SaleTypeComboGroupRecord[];
    updated: SaleTypeComboGroupRecord[];
    deleted: SaleTypeComboGroupRecord[];

    constructor(data?: ISyncResultOfSaleTypeComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SaleTypeComboGroupRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SaleTypeComboGroupRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SaleTypeComboGroupRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSaleTypeComboGroupRecord {
        let result = new SyncResultOfSaleTypeComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSaleTypeComboGroupRecord {
    added: SaleTypeComboGroupRecord[];
    updated: SaleTypeComboGroupRecord[];
    deleted: SaleTypeComboGroupRecord[];
}

export class SaleTypeComboGroupRecord implements ISaleTypeComboGroupRecord {
    saleTypeId: number;
    comboGroupId: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTypeId = data["saleTypeId"];
            this.comboGroupId = data["comboGroupId"];
            this.price = data["price"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeComboGroupRecord {
        let result = new SaleTypeComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTypeId"] = this.saleTypeId;
        data["comboGroupId"] = this.comboGroupId;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeComboGroupRecord {
    saleTypeId: number;
    comboGroupId: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfComboGroupTranslationRecord implements ISyncResultOfComboGroupTranslationRecord {
    added: ComboGroupTranslationRecord[];
    updated: ComboGroupTranslationRecord[];
    deleted: ComboGroupTranslationRecord[];

    constructor(data?: ISyncResultOfComboGroupTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboGroupTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboGroupTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboGroupTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboGroupTranslationRecord {
        let result = new SyncResultOfComboGroupTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboGroupTranslationRecord {
    added: ComboGroupTranslationRecord[];
    updated: ComboGroupTranslationRecord[];
    deleted: ComboGroupTranslationRecord[];
}

export class ComboGroupTranslationRecord implements IComboGroupTranslationRecord {
    comboGroupId: number;
    languageId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboGroupTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboGroupId = data["comboGroupId"];
            this.languageId = data["languageId"];
            this.name = data["name"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboGroupTranslationRecord {
        let result = new ComboGroupTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboGroupId"] = this.comboGroupId;
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboGroupTranslationRecord {
    comboGroupId: number;
    languageId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemVariantRecord implements ISyncResultOfMenuItemVariantRecord {
    added: MenuItemVariantRecord[];
    updated: MenuItemVariantRecord[];
    deleted: MenuItemVariantRecord[];

    constructor(data?: ISyncResultOfMenuItemVariantRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemVariantRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemVariantRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemVariantRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemVariantRecord {
        let result = new SyncResultOfMenuItemVariantRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemVariantRecord {
    added: MenuItemVariantRecord[];
    updated: MenuItemVariantRecord[];
    deleted: MenuItemVariantRecord[];
}

export class MenuItemVariantRecord implements IMenuItemVariantRecord {
    menuItemId: number;
    variantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemVariantRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.variantId = data["variantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemVariantRecord {
        let result = new MenuItemVariantRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["variantId"] = this.variantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemVariantRecord {
    menuItemId: number;
    variantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemTaxRecord implements ISyncResultOfMenuItemTaxRecord {
    added: MenuItemTaxRecord[];
    updated: MenuItemTaxRecord[];
    deleted: MenuItemTaxRecord[];

    constructor(data?: ISyncResultOfMenuItemTaxRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemTaxRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemTaxRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemTaxRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemTaxRecord {
        let result = new SyncResultOfMenuItemTaxRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemTaxRecord {
    added: MenuItemTaxRecord[];
    updated: MenuItemTaxRecord[];
    deleted: MenuItemTaxRecord[];
}

export class MenuItemTaxRecord implements IMenuItemTaxRecord {
    menuItemId: number;
    taxId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemTaxRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.taxId = data["taxId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemTaxRecord {
        let result = new MenuItemTaxRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["taxId"] = this.taxId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemTaxRecord {
    menuItemId: number;
    taxId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfVariantValuePriceListRecord implements ISyncResultOfVariantValuePriceListRecord {
    added: VariantValuePriceListRecord[];
    updated: VariantValuePriceListRecord[];
    deleted: VariantValuePriceListRecord[];

    constructor(data?: ISyncResultOfVariantValuePriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(VariantValuePriceListRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(VariantValuePriceListRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(VariantValuePriceListRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfVariantValuePriceListRecord {
        let result = new SyncResultOfVariantValuePriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfVariantValuePriceListRecord {
    added: VariantValuePriceListRecord[];
    updated: VariantValuePriceListRecord[];
    deleted: VariantValuePriceListRecord[];
}

export class VariantValuePriceListRecord implements IVariantValuePriceListRecord {
    variantValueId: number;
    priceListId: number;
    price: number;
    factor: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantValuePriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variantValueId = data["variantValueId"];
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.factor = data["factor"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantValuePriceListRecord {
        let result = new VariantValuePriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantValueId"] = this.variantValueId;
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["factor"] = this.factor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantValuePriceListRecord {
    variantValueId: number;
    priceListId: number;
    price: number;
    factor: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfUserRecord implements ISyncResultOfUserRecord {
    added: UserRecord[];
    updated: UserRecord[];
    deleted: UserRecord[];

    constructor(data?: ISyncResultOfUserRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(UserRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(UserRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(UserRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfUserRecord {
        let result = new SyncResultOfUserRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfUserRecord {
    added: UserRecord[];
    updated: UserRecord[];
    deleted: UserRecord[];
}

export class UserRecord implements IUserRecord {
    id: number;
    userName: string;
    fullName: string;
    emailAddress: string;
    name: string;
    phoneNumber: string;
    surname: string;
    limitDiscount: number;
    pinCode: string;
    limitDiscountType: number;
    password: string;
    counterCode: string;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: IUserRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.userName = data["userName"];
            this.fullName = data["fullName"];
            this.emailAddress = data["emailAddress"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.surname = data["surname"];
            this.limitDiscount = data["limitDiscount"];
            this.pinCode = data["pinCode"];
            this.limitDiscountType = data["limitDiscountType"];
            this.password = data["password"];
            this.counterCode = data["counterCode"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): UserRecord {
        let result = new UserRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["surname"] = this.surname;
        data["limitDiscount"] = this.limitDiscount;
        data["pinCode"] = this.pinCode;
        data["limitDiscountType"] = this.limitDiscountType;
        data["password"] = this.password;
        data["counterCode"] = this.counterCode;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface IUserRecord {
    id: number;
    userName: string;
    fullName: string;
    emailAddress: string;
    name: string;
    phoneNumber: string;
    surname: string;
    limitDiscount: number;
    pinCode: string;
    limitDiscountType: number;
    password: string;
    counterCode: string;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class SyncResultOfPermissionRecord implements ISyncResultOfPermissionRecord {
    added: PermissionRecord[];
    updated: PermissionRecord[];
    deleted: PermissionRecord[];

    constructor(data?: ISyncResultOfPermissionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PermissionRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PermissionRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PermissionRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPermissionRecord {
        let result = new SyncResultOfPermissionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPermissionRecord {
    added: PermissionRecord[];
    updated: PermissionRecord[];
    deleted: PermissionRecord[];
}

export class PermissionRecord implements IPermissionRecord {
    id: number;
    name: string;
    roleId: number;
    userId: number;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: IPermissionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.roleId = data["roleId"];
            this.userId = data["userId"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): PermissionRecord {
        let result = new PermissionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface IPermissionRecord {
    id: number;
    name: string;
    roleId: number;
    userId: number;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class SyncResultOfUserRoleRecord implements ISyncResultOfUserRoleRecord {
    added: UserRoleRecord[];
    updated: UserRoleRecord[];
    deleted: UserRoleRecord[];

    constructor(data?: ISyncResultOfUserRoleRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(UserRoleRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(UserRoleRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(UserRoleRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfUserRoleRecord {
        let result = new SyncResultOfUserRoleRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfUserRoleRecord {
    added: UserRoleRecord[];
    updated: UserRoleRecord[];
    deleted: UserRoleRecord[];
}

export class UserRoleRecord implements IUserRoleRecord {
    id: number;
    roleId: number;
    userId: number;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: IUserRoleRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.roleId = data["roleId"];
            this.userId = data["userId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): UserRoleRecord {
        let result = new UserRoleRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface IUserRoleRecord {
    id: number;
    roleId: number;
    userId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class SyncResultOfRoleRecord implements ISyncResultOfRoleRecord {
    added: RoleRecord[];
    updated: RoleRecord[];
    deleted: RoleRecord[];

    constructor(data?: ISyncResultOfRoleRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(RoleRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(RoleRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(RoleRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfRoleRecord {
        let result = new SyncResultOfRoleRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfRoleRecord {
    added: RoleRecord[];
    updated: RoleRecord[];
    deleted: RoleRecord[];
}

export class RoleRecord implements IRoleRecord {
    id: number;
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: IRoleRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): RoleRecord {
        let result = new RoleRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface IRoleRecord {
    id: number;
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class SyncResultOfCodingPatternSettingsRecord implements ISyncResultOfCodingPatternSettingsRecord {
    added: CodingPatternSettingsRecord[];
    updated: CodingPatternSettingsRecord[];
    deleted: CodingPatternSettingsRecord[];

    constructor(data?: ISyncResultOfCodingPatternSettingsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CodingPatternSettingsRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CodingPatternSettingsRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CodingPatternSettingsRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCodingPatternSettingsRecord {
        let result = new SyncResultOfCodingPatternSettingsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCodingPatternSettingsRecord {
    added: CodingPatternSettingsRecord[];
    updated: CodingPatternSettingsRecord[];
    deleted: CodingPatternSettingsRecord[];
}

export class CodingPatternSettingsRecord implements ICodingPatternSettingsRecord {
    isUsed: boolean;
    key: string;
    startValue: number;
    incrementvalue: number;
    lastGeneratedValue: number;
    prefix: string;
    suffix: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICodingPatternSettingsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isUsed = data["isUsed"];
            this.key = data["key"];
            this.startValue = data["startValue"];
            this.incrementvalue = data["incrementvalue"];
            this.lastGeneratedValue = data["lastGeneratedValue"];
            this.prefix = data["prefix"];
            this.suffix = data["suffix"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CodingPatternSettingsRecord {
        let result = new CodingPatternSettingsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUsed"] = this.isUsed;
        data["key"] = this.key;
        data["startValue"] = this.startValue;
        data["incrementvalue"] = this.incrementvalue;
        data["lastGeneratedValue"] = this.lastGeneratedValue;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICodingPatternSettingsRecord {
    isUsed: boolean;
    key: string;
    startValue: number;
    incrementvalue: number;
    lastGeneratedValue: number;
    prefix: string;
    suffix: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDiscountTypeCustomerRecord implements ISyncResultOfDiscountTypeCustomerRecord {
    added: DiscountTypeCustomerRecord[];
    updated: DiscountTypeCustomerRecord[];
    deleted: DiscountTypeCustomerRecord[];

    constructor(data?: ISyncResultOfDiscountTypeCustomerRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DiscountTypeCustomerRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DiscountTypeCustomerRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DiscountTypeCustomerRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDiscountTypeCustomerRecord {
        let result = new SyncResultOfDiscountTypeCustomerRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDiscountTypeCustomerRecord {
    added: DiscountTypeCustomerRecord[];
    updated: DiscountTypeCustomerRecord[];
    deleted: DiscountTypeCustomerRecord[];
}

export class DiscountTypeCustomerRecord implements IDiscountTypeCustomerRecord {
    discountTypeId: number;
    customerId: string;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDiscountTypeCustomerRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountTypeId = data["discountTypeId"];
            this.customerId = data["customerId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DiscountTypeCustomerRecord {
        let result = new DiscountTypeCustomerRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountTypeId"] = this.discountTypeId;
        data["customerId"] = this.customerId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDiscountTypeCustomerRecord {
    discountTypeId: number;
    customerId: string;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemDiscountTypeRecord implements ISyncResultOfMenuItemDiscountTypeRecord {
    added: MenuItemDiscountTypeRecord[];
    updated: MenuItemDiscountTypeRecord[];
    deleted: MenuItemDiscountTypeRecord[];

    constructor(data?: ISyncResultOfMenuItemDiscountTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemDiscountTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemDiscountTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemDiscountTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemDiscountTypeRecord {
        let result = new SyncResultOfMenuItemDiscountTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemDiscountTypeRecord {
    added: MenuItemDiscountTypeRecord[];
    updated: MenuItemDiscountTypeRecord[];
    deleted: MenuItemDiscountTypeRecord[];
}

export class MenuItemDiscountTypeRecord implements IMenuItemDiscountTypeRecord {
    discountTypeId: number;
    menuItemId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemDiscountTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountTypeId = data["discountTypeId"];
            this.menuItemId = data["menuItemId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemDiscountTypeRecord {
        let result = new MenuItemDiscountTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountTypeId"] = this.discountTypeId;
        data["menuItemId"] = this.menuItemId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemDiscountTypeRecord {
    discountTypeId: number;
    menuItemId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfProductCategoryComboGroupRecord implements ISyncResultOfProductCategoryComboGroupRecord {
    added: ProductCategoryComboGroupRecord[];
    updated: ProductCategoryComboGroupRecord[];
    deleted: ProductCategoryComboGroupRecord[];

    constructor(data?: ISyncResultOfProductCategoryComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductCategoryComboGroupRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductCategoryComboGroupRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductCategoryComboGroupRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductCategoryComboGroupRecord {
        let result = new SyncResultOfProductCategoryComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductCategoryComboGroupRecord {
    added: ProductCategoryComboGroupRecord[];
    updated: ProductCategoryComboGroupRecord[];
    deleted: ProductCategoryComboGroupRecord[];
}

export class ProductCategoryComboGroupRecord implements IProductCategoryComboGroupRecord {
    comboGroupId: number;
    productCategoryId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryComboGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboGroupId = data["comboGroupId"];
            this.productCategoryId = data["productCategoryId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryComboGroupRecord {
        let result = new ProductCategoryComboGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboGroupId"] = this.comboGroupId;
        data["productCategoryId"] = this.productCategoryId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryComboGroupRecord {
    comboGroupId: number;
    productCategoryId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionRecord implements ISyncResultOfPromotionRecord {
    added: PromotionRecord[];
    updated: PromotionRecord[];
    deleted: PromotionRecord[];

    constructor(data?: ISyncResultOfPromotionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionRecord {
        let result = new SyncResultOfPromotionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionRecord {
    added: PromotionRecord[];
    updated: PromotionRecord[];
    deleted: PromotionRecord[];
}

export class PromotionRecord implements IPromotionRecord {
    itemId: number;
    itemType: number;
    highestValue: number;
    lowestValue: number;
    value: number;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    promotionType: number;
    valueType: number;
    validForDays: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.highestValue = data["highestValue"];
            this.lowestValue = data["lowestValue"];
            this.value = data["value"];
            this.isTotalInvoice = data["isTotalInvoice"];
            this.isNextInvoice = data["isNextInvoice"];
            this.invoiceAmount = data["invoiceAmount"];
            this.promotionType = data["promotionType"];
            this.valueType = data["valueType"];
            this.validForDays = data["validForDays"];
            this.name = data["name"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionRecord {
        let result = new PromotionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["highestValue"] = this.highestValue;
        data["lowestValue"] = this.lowestValue;
        data["value"] = this.value;
        data["isTotalInvoice"] = this.isTotalInvoice;
        data["isNextInvoice"] = this.isNextInvoice;
        data["invoiceAmount"] = this.invoiceAmount;
        data["promotionType"] = this.promotionType;
        data["valueType"] = this.valueType;
        data["validForDays"] = this.validForDays;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionRecord {
    itemId: number;
    itemType: number;
    highestValue: number;
    lowestValue: number;
    value: number;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    promotionType: number;
    valueType: number;
    validForDays: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionStoreRecord implements ISyncResultOfPromotionStoreRecord {
    added: PromotionStoreRecord[];
    updated: PromotionStoreRecord[];
    deleted: PromotionStoreRecord[];

    constructor(data?: ISyncResultOfPromotionStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionStoreRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionStoreRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionStoreRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionStoreRecord {
        let result = new SyncResultOfPromotionStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionStoreRecord {
    added: PromotionStoreRecord[];
    updated: PromotionStoreRecord[];
    deleted: PromotionStoreRecord[];
}

export class PromotionStoreRecord implements IPromotionStoreRecord {
    tenantId: number;
    storeType: number;
    promotionId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeType = data["storeType"];
            this.promotionId = data["promotionId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionStoreRecord {
        let result = new PromotionStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeType"] = this.storeType;
        data["promotionId"] = this.promotionId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionStoreRecord {
    tenantId: number;
    storeType: number;
    promotionId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionCodeRecord implements ISyncResultOfPromotionCodeRecord {
    added: PromotionCodeRecord[];
    updated: PromotionCodeRecord[];
    deleted: PromotionCodeRecord[];

    constructor(data?: ISyncResultOfPromotionCodeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionCodeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionCodeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionCodeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionCodeRecord {
        let result = new SyncResultOfPromotionCodeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionCodeRecord {
    added: PromotionCodeRecord[];
    updated: PromotionCodeRecord[];
    deleted: PromotionCodeRecord[];
}

export class PromotionCodeRecord implements IPromotionCodeRecord {
    code: string;
    promotionId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isTiming: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionCodeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.promotionId = data["promotionId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.multi = data["multi"];
            this.isTiming = data["isTiming"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionCodeRecord {
        let result = new PromotionCodeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["promotionId"] = this.promotionId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["multi"] = this.multi;
        data["isTiming"] = this.isTiming;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionCodeRecord {
    code: string;
    promotionId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isTiming: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionDetailsRecord implements ISyncResultOfPromotionDetailsRecord {
    added: PromotionDetailsRecord[];
    updated: PromotionDetailsRecord[];
    deleted: PromotionDetailsRecord[];

    constructor(data?: ISyncResultOfPromotionDetailsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionDetailsRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionDetailsRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionDetailsRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionDetailsRecord {
        let result = new SyncResultOfPromotionDetailsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionDetailsRecord {
    added: PromotionDetailsRecord[];
    updated: PromotionDetailsRecord[];
    deleted: PromotionDetailsRecord[];
}

export class PromotionDetailsRecord implements IPromotionDetailsRecord {
    itemId: number;
    itemType: number;
    quantity: number;
    isExcluded: boolean;
    promotionId: number;
    whre: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionDetailsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.isExcluded = data["isExcluded"];
            this.promotionId = data["promotionId"];
            this.whre = data["whre"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionDetailsRecord {
        let result = new PromotionDetailsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["isExcluded"] = this.isExcluded;
        data["promotionId"] = this.promotionId;
        data["whre"] = this.whre;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionDetailsRecord {
    itemId: number;
    itemType: number;
    quantity: number;
    isExcluded: boolean;
    promotionId: number;
    whre: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfProductStorePriceRecord implements ISyncResultOfProductStorePriceRecord {
    added: ProductStorePriceRecord[];
    updated: ProductStorePriceRecord[];
    deleted: ProductStorePriceRecord[];

    constructor(data?: ISyncResultOfProductStorePriceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductStorePriceRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductStorePriceRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductStorePriceRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductStorePriceRecord {
        let result = new SyncResultOfProductStorePriceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductStorePriceRecord {
    added: ProductStorePriceRecord[];
    updated: ProductStorePriceRecord[];
    deleted: ProductStorePriceRecord[];
}

export class ProductStorePriceRecord implements IProductStorePriceRecord {
    productId: number;
    unitOfMeasureId: number;
    storeId: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IProductStorePriceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.storeId = data["storeId"];
            this.price = data["price"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductStorePriceRecord {
        let result = new ProductStorePriceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["storeId"] = this.storeId;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductStorePriceRecord {
    productId: number;
    unitOfMeasureId: number;
    storeId: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SyncResultOfComboMealDefinitionRecord implements ISyncResultOfComboMealDefinitionRecord {
    added: ComboMealDefinitionRecord[];
    updated: ComboMealDefinitionRecord[];
    deleted: ComboMealDefinitionRecord[];

    constructor(data?: ISyncResultOfComboMealDefinitionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboMealDefinitionRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboMealDefinitionRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboMealDefinitionRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboMealDefinitionRecord {
        let result = new SyncResultOfComboMealDefinitionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboMealDefinitionRecord {
    added: ComboMealDefinitionRecord[];
    updated: ComboMealDefinitionRecord[];
    deleted: ComboMealDefinitionRecord[];
}

export class ComboMealDefinitionRecord implements IComboMealDefinitionRecord {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    order: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealDefinitionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.comboMealPackageId = data["comboMealPackageId"];
            this.menuItemId = data["menuItemId"];
            this.order = data["order"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealDefinitionRecord {
        let result = new ComboMealDefinitionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["comboMealPackageId"] = this.comboMealPackageId;
        data["menuItemId"] = this.menuItemId;
        data["order"] = this.order;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealDefinitionRecord {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    order: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfComboMealPackageItemPriceListRecord implements ISyncResultOfComboMealPackageItemPriceListRecord {
    added: ComboMealPackageItemPriceListRecord[];
    updated: ComboMealPackageItemPriceListRecord[];
    deleted: ComboMealPackageItemPriceListRecord[];

    constructor(data?: ISyncResultOfComboMealPackageItemPriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboMealPackageItemPriceListRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboMealPackageItemPriceListRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboMealPackageItemPriceListRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboMealPackageItemPriceListRecord {
        let result = new SyncResultOfComboMealPackageItemPriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboMealPackageItemPriceListRecord {
    added: ComboMealPackageItemPriceListRecord[];
    updated: ComboMealPackageItemPriceListRecord[];
    deleted: ComboMealPackageItemPriceListRecord[];
}

export class ComboMealPackageItemPriceListRecord implements IComboMealPackageItemPriceListRecord {
    id: number;
    priceListId: number;
    price: number;
    comboMealPackageItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: IComboMealPackageItemPriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.comboMealPackageItemId = data["comboMealPackageItemId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): ComboMealPackageItemPriceListRecord {
        let result = new ComboMealPackageItemPriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["comboMealPackageItemId"] = this.comboMealPackageItemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface IComboMealPackageItemPriceListRecord {
    id: number;
    priceListId: number;
    price: number;
    comboMealPackageItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class SyncResultOfComboMealPackageItemRecord implements ISyncResultOfComboMealPackageItemRecord {
    added: ComboMealPackageItemRecord[];
    updated: ComboMealPackageItemRecord[];
    deleted: ComboMealPackageItemRecord[];

    constructor(data?: ISyncResultOfComboMealPackageItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboMealPackageItemRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboMealPackageItemRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboMealPackageItemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboMealPackageItemRecord {
        let result = new SyncResultOfComboMealPackageItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboMealPackageItemRecord {
    added: ComboMealPackageItemRecord[];
    updated: ComboMealPackageItemRecord[];
    deleted: ComboMealPackageItemRecord[];
}

export class ComboMealPackageItemRecord implements IComboMealPackageItemRecord {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    quantity: number;
    unitOfMeasureId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealPackageItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.comboMealPackageId = data["comboMealPackageId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealPackageItemRecord {
        let result = new ComboMealPackageItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["comboMealPackageId"] = this.comboMealPackageId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealPackageItemRecord {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    quantity: number;
    unitOfMeasureId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfComboMealPackageRecord implements ISyncResultOfComboMealPackageRecord {
    added: ComboMealPackageRecord[];
    updated: ComboMealPackageRecord[];
    deleted: ComboMealPackageRecord[];

    constructor(data?: ISyncResultOfComboMealPackageRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboMealPackageRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboMealPackageRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboMealPackageRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboMealPackageRecord {
        let result = new SyncResultOfComboMealPackageRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboMealPackageRecord {
    added: ComboMealPackageRecord[];
    updated: ComboMealPackageRecord[];
    deleted: ComboMealPackageRecord[];
}

export class ComboMealPackageRecord implements IComboMealPackageRecord {
    tenantId: number;
    code: string;
    quantity: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealPackageRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.quantity = data["quantity"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealPackageRecord {
        let result = new ComboMealPackageRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealPackageRecord {
    tenantId: number;
    code: string;
    quantity: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfComboMealPackageTranslationRecord implements ISyncResultOfComboMealPackageTranslationRecord {
    added: ComboMealPackageTranslationRecord[];
    updated: ComboMealPackageTranslationRecord[];
    deleted: ComboMealPackageTranslationRecord[];

    constructor(data?: ISyncResultOfComboMealPackageTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ComboMealPackageTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ComboMealPackageTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ComboMealPackageTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfComboMealPackageTranslationRecord {
        let result = new SyncResultOfComboMealPackageTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfComboMealPackageTranslationRecord {
    added: ComboMealPackageTranslationRecord[];
    updated: ComboMealPackageTranslationRecord[];
    deleted: ComboMealPackageTranslationRecord[];
}

export class ComboMealPackageTranslationRecord implements IComboMealPackageTranslationRecord {
    languageId: number;
    tenantId: number;
    name: string;
    comboMealPackageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealPackageTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.comboMealPackageId = data["comboMealPackageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealPackageTranslationRecord {
        let result = new ComboMealPackageTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["comboMealPackageId"] = this.comboMealPackageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealPackageTranslationRecord {
    languageId: number;
    tenantId: number;
    name: string;
    comboMealPackageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfSaleTypeStoreRecord implements ISyncResultOfSaleTypeStoreRecord {
    added: SaleTypeStoreRecord[];
    updated: SaleTypeStoreRecord[];
    deleted: SaleTypeStoreRecord[];

    constructor(data?: ISyncResultOfSaleTypeStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SaleTypeStoreRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SaleTypeStoreRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SaleTypeStoreRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSaleTypeStoreRecord {
        let result = new SyncResultOfSaleTypeStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSaleTypeStoreRecord {
    added: SaleTypeStoreRecord[];
    updated: SaleTypeStoreRecord[];
    deleted: SaleTypeStoreRecord[];
}

export class SaleTypeStoreRecord implements ISaleTypeStoreRecord {
    tenantId: number;
    storeId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.saleTypeId = data["saleTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeStoreRecord {
        let result = new SaleTypeStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["saleTypeId"] = this.saleTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeStoreRecord {
    tenantId: number;
    storeId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionsFBRecord implements ISyncResultOfPromotionsFBRecord {
    added: PromotionsFBRecord[];
    updated: PromotionsFBRecord[];
    deleted: PromotionsFBRecord[];

    constructor(data?: ISyncResultOfPromotionsFBRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionsFBRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionsFBRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionsFBRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionsFBRecord {
        let result = new SyncResultOfPromotionsFBRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionsFBRecord {
    added: PromotionsFBRecord[];
    updated: PromotionsFBRecord[];
    deleted: PromotionsFBRecord[];
}

export class PromotionsFBRecord implements IPromotionsFBRecord {
    tenantId: number;
    promotionType: PromotionsFBRecordPromotionType;
    templateType: PromotionsFBRecordTemplateType;
    name: string;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionsFBRecordValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    validForDays: number;
    isShowInPlugIn: boolean;
    includeVat: boolean;
    promotionFBStores: PromotionFBStoresRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionsFBRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.promotionType = data["promotionType"];
            this.templateType = data["templateType"];
            this.name = data["name"];
            this.highestValue = data["highestValue"];
            this.lowestValue = data["lowestValue"];
            this.value = data["value"];
            this.valueType = data["valueType"];
            this.isTotalInvoice = data["isTotalInvoice"];
            this.isNextInvoice = data["isNextInvoice"];
            this.invoiceAmount = data["invoiceAmount"];
            this.validForDays = data["validForDays"];
            this.isShowInPlugIn = data["isShowInPlugIn"];
            this.includeVat = data["includeVat"];
            if (data["promotionFBStores"] && data["promotionFBStores"].constructor === Array) {
                this.promotionFBStores = [];
                for (let item of data["promotionFBStores"])
                    this.promotionFBStores.push(PromotionFBStoresRecord.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionsFBRecord {
        let result = new PromotionsFBRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["promotionType"] = this.promotionType;
        data["templateType"] = this.templateType;
        data["name"] = this.name;
        data["highestValue"] = this.highestValue;
        data["lowestValue"] = this.lowestValue;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["isTotalInvoice"] = this.isTotalInvoice;
        data["isNextInvoice"] = this.isNextInvoice;
        data["invoiceAmount"] = this.invoiceAmount;
        data["validForDays"] = this.validForDays;
        data["isShowInPlugIn"] = this.isShowInPlugIn;
        data["includeVat"] = this.includeVat;
        if (this.promotionFBStores && this.promotionFBStores.constructor === Array) {
            data["promotionFBStores"] = [];
            for (let item of this.promotionFBStores)
                data["promotionFBStores"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionsFBRecord {
    tenantId: number;
    promotionType: PromotionsFBRecordPromotionType;
    templateType: PromotionsFBRecordTemplateType;
    name: string;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionsFBRecordValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    validForDays: number;
    isShowInPlugIn: boolean;
    includeVat: boolean;
    promotionFBStores: PromotionFBStoresRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionFBStoresRecord implements IPromotionFBStoresRecord {
    promotionFBId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBStoresRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promotionFBId = data["promotionFBId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBStoresRecord {
        let result = new PromotionFBStoresRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionFBId"] = this.promotionFBId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBStoresRecord {
    promotionFBId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionFBItemRecord implements ISyncResultOfPromotionFBItemRecord {
    added: PromotionFBItemRecord[];
    updated: PromotionFBItemRecord[];
    deleted: PromotionFBItemRecord[];

    constructor(data?: ISyncResultOfPromotionFBItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionFBItemRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionFBItemRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionFBItemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionFBItemRecord {
        let result = new SyncResultOfPromotionFBItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionFBItemRecord {
    added: PromotionFBItemRecord[];
    updated: PromotionFBItemRecord[];
    deleted: PromotionFBItemRecord[];
}

export class PromotionFBItemRecord implements IPromotionFBItemRecord {
    tenantId: number;
    itemId: number;
    itemType: PromotionFBItemRecordItemType;
    promotionId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.promotionId = data["promotionId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBItemRecord {
        let result = new PromotionFBItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["promotionId"] = this.promotionId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBItemRecord {
    tenantId: number;
    itemId: number;
    itemType: PromotionFBItemRecordItemType;
    promotionId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionFBItemExcludedMenuItemRecord implements ISyncResultOfPromotionFBItemExcludedMenuItemRecord {
    added: PromotionFBItemExcludedMenuItemRecord[];
    updated: PromotionFBItemExcludedMenuItemRecord[];
    deleted: PromotionFBItemExcludedMenuItemRecord[];

    constructor(data?: ISyncResultOfPromotionFBItemExcludedMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionFBItemExcludedMenuItemRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionFBItemExcludedMenuItemRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionFBItemExcludedMenuItemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionFBItemExcludedMenuItemRecord {
        let result = new SyncResultOfPromotionFBItemExcludedMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionFBItemExcludedMenuItemRecord {
    added: PromotionFBItemExcludedMenuItemRecord[];
    updated: PromotionFBItemExcludedMenuItemRecord[];
    deleted: PromotionFBItemExcludedMenuItemRecord[];
}

export class PromotionFBItemExcludedMenuItemRecord implements IPromotionFBItemExcludedMenuItemRecord {
    tenantId: number;
    menuItemId: number;
    promotionFBItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBItemExcludedMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.promotionFBItemId = data["promotionFBItemId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBItemExcludedMenuItemRecord {
        let result = new PromotionFBItemExcludedMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["promotionFBItemId"] = this.promotionFBItemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBItemExcludedMenuItemRecord {
    tenantId: number;
    menuItemId: number;
    promotionFBItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionDetailsFBRecord implements ISyncResultOfPromotionDetailsFBRecord {
    added: PromotionDetailsFBRecord[];
    updated: PromotionDetailsFBRecord[];
    deleted: PromotionDetailsFBRecord[];

    constructor(data?: ISyncResultOfPromotionDetailsFBRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionDetailsFBRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionDetailsFBRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionDetailsFBRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionDetailsFBRecord {
        let result = new SyncResultOfPromotionDetailsFBRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionDetailsFBRecord {
    added: PromotionDetailsFBRecord[];
    updated: PromotionDetailsFBRecord[];
    deleted: PromotionDetailsFBRecord[];
}

export class PromotionDetailsFBRecord implements IPromotionDetailsFBRecord {
    tenantId: number;
    itemId: number;
    itemType: PromotionDetailsFBRecordItemType;
    quantity: number;
    promotionId: number;
    whre: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionDetailsFBRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.promotionId = data["promotionId"];
            this.whre = data["whre"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionDetailsFBRecord {
        let result = new PromotionDetailsFBRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["promotionId"] = this.promotionId;
        data["whre"] = this.whre;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionDetailsFBRecord {
    tenantId: number;
    itemId: number;
    itemType: PromotionDetailsFBRecordItemType;
    quantity: number;
    promotionId: number;
    whre: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionDetailsFBExcludedMenuItemRecord implements ISyncResultOfPromotionDetailsFBExcludedMenuItemRecord {
    added: PromotionDetailsFBExcludedMenuItemRecord[];
    updated: PromotionDetailsFBExcludedMenuItemRecord[];
    deleted: PromotionDetailsFBExcludedMenuItemRecord[];

    constructor(data?: ISyncResultOfPromotionDetailsFBExcludedMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionDetailsFBExcludedMenuItemRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionDetailsFBExcludedMenuItemRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionDetailsFBExcludedMenuItemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionDetailsFBExcludedMenuItemRecord {
        let result = new SyncResultOfPromotionDetailsFBExcludedMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionDetailsFBExcludedMenuItemRecord {
    added: PromotionDetailsFBExcludedMenuItemRecord[];
    updated: PromotionDetailsFBExcludedMenuItemRecord[];
    deleted: PromotionDetailsFBExcludedMenuItemRecord[];
}

export class PromotionDetailsFBExcludedMenuItemRecord implements IPromotionDetailsFBExcludedMenuItemRecord {
    tenantId: number;
    menuItemId: number;
    promotionDetailsFBId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionDetailsFBExcludedMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.promotionDetailsFBId = data["promotionDetailsFBId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionDetailsFBExcludedMenuItemRecord {
        let result = new PromotionDetailsFBExcludedMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["promotionDetailsFBId"] = this.promotionDetailsFBId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionDetailsFBExcludedMenuItemRecord {
    tenantId: number;
    menuItemId: number;
    promotionDetailsFBId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionCodesFBRecord implements ISyncResultOfPromotionCodesFBRecord {
    added: PromotionCodesFBRecord[];
    updated: PromotionCodesFBRecord[];
    deleted: PromotionCodesFBRecord[];

    constructor(data?: ISyncResultOfPromotionCodesFBRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionCodesFBRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionCodesFBRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionCodesFBRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionCodesFBRecord {
        let result = new SyncResultOfPromotionCodesFBRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionCodesFBRecord {
    added: PromotionCodesFBRecord[];
    updated: PromotionCodesFBRecord[];
    deleted: PromotionCodesFBRecord[];
}

export class PromotionCodesFBRecord implements IPromotionCodesFBRecord {
    code: string;
    tenantId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isTiming: boolean;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isActive: boolean;
    promotionFBId: number;
    iDuplicateQunatity: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionCodesFBRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.isTiming = data["isTiming"];
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.multi = data["multi"];
            this.isActive = data["isActive"];
            this.promotionFBId = data["promotionFBId"];
            this.iDuplicateQunatity = data["iDuplicateQunatity"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionCodesFBRecord {
        let result = new PromotionCodesFBRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["isTiming"] = this.isTiming;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["multi"] = this.multi;
        data["isActive"] = this.isActive;
        data["promotionFBId"] = this.promotionFBId;
        data["iDuplicateQunatity"] = this.iDuplicateQunatity;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionCodesFBRecord {
    code: string;
    tenantId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isTiming: boolean;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isActive: boolean;
    promotionFBId: number;
    iDuplicateQunatity: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionCodeSalesTypeRecord implements ISyncResultOfPromotionCodeSalesTypeRecord {
    added: PromotionCodeSalesTypeRecord[];
    updated: PromotionCodeSalesTypeRecord[];
    deleted: PromotionCodeSalesTypeRecord[];

    constructor(data?: ISyncResultOfPromotionCodeSalesTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionCodeSalesTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionCodeSalesTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionCodeSalesTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionCodeSalesTypeRecord {
        let result = new SyncResultOfPromotionCodeSalesTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionCodeSalesTypeRecord {
    added: PromotionCodeSalesTypeRecord[];
    updated: PromotionCodeSalesTypeRecord[];
    deleted: PromotionCodeSalesTypeRecord[];
}

export class PromotionCodeSalesTypeRecord implements IPromotionCodeSalesTypeRecord {
    tenantId: number;
    promotionCodeFBId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionCodeSalesTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.promotionCodeFBId = data["promotionCodeFBId"];
            this.saleTypeId = data["saleTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionCodeSalesTypeRecord {
        let result = new PromotionCodeSalesTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["promotionCodeFBId"] = this.promotionCodeFBId;
        data["saleTypeId"] = this.saleTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionCodeSalesTypeRecord {
    tenantId: number;
    promotionCodeFBId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfProductCategoryLevelRecord implements ISyncResultOfProductCategoryLevelRecord {
    added: ProductCategoryLevelRecord[];
    updated: ProductCategoryLevelRecord[];
    deleted: ProductCategoryLevelRecord[];

    constructor(data?: ISyncResultOfProductCategoryLevelRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductCategoryLevelRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductCategoryLevelRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductCategoryLevelRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductCategoryLevelRecord {
        let result = new SyncResultOfProductCategoryLevelRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductCategoryLevelRecord {
    added: ProductCategoryLevelRecord[];
    updated: ProductCategoryLevelRecord[];
    deleted: ProductCategoryLevelRecord[];
}

export class ProductCategoryLevelRecord implements IProductCategoryLevelRecord {
    levelId: number;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryLevelRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.levelId = data["levelId"];
            this.productCategoryId = data["productCategoryId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryLevelRecord {
        let result = new ProductCategoryLevelRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelId"] = this.levelId;
        data["productCategoryId"] = this.productCategoryId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryLevelRecord {
    levelId: number;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ExportDataInput implements IExportDataInput {
    lastDate: moment.Moment;
    userId: number;
    moduleIds: number[];
    exportSpecificModule: boolean;
    compressFile: boolean;

    constructor(data?: IExportDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lastDate = data["lastDate"] ? moment(data["lastDate"].toString()) : <any>undefined;
            this.userId = data["userId"];
            if (data["moduleIds"] && data["moduleIds"].constructor === Array) {
                this.moduleIds = [];
                for (let item of data["moduleIds"])
                    this.moduleIds.push(item);
            }
            this.exportSpecificModule = data["exportSpecificModule"];
            this.compressFile = data["compressFile"];
        }
    }

    static fromJS(data: any): ExportDataInput {
        let result = new ExportDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        if (this.moduleIds && this.moduleIds.constructor === Array) {
            data["moduleIds"] = [];
            for (let item of this.moduleIds)
                data["moduleIds"].push(item);
        }
        data["exportSpecificModule"] = this.exportSpecificModule;
        data["compressFile"] = this.compressFile;
        return data; 
    }
}

export interface IExportDataInput {
    lastDate: moment.Moment;
    userId: number;
    moduleIds: number[];
    exportSpecificModule: boolean;
    compressFile: boolean;
}

export class ExportDataResult implements IExportDataResult {
    dataJson: string;
    syncStatus: StatusMessage[];

    constructor(data?: IExportDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataJson = data["dataJson"];
            if (data["syncStatus"] && data["syncStatus"].constructor === Array) {
                this.syncStatus = [];
                for (let item of data["syncStatus"])
                    this.syncStatus.push(StatusMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportDataResult {
        let result = new ExportDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataJson"] = this.dataJson;
        if (this.syncStatus && this.syncStatus.constructor === Array) {
            data["syncStatus"] = [];
            for (let item of this.syncStatus)
                data["syncStatus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExportDataResult {
    dataJson: string;
    syncStatus: StatusMessage[];
}

export class BulkSyncPackage implements IBulkSyncPackage {
    generatedAt: moment.Moment;
    snapshotTime: moment.Moment;
    since: moment.Moment;
    includedModules: string[];
    abpLanguages: SyncResultOfLanguageRecord;
    primaryCategories: SyncResultOfPrimaryCategoryRecord;
    primaryCategoryTranslations: SyncResultOfPrimaryCategoryTranslationRecord;
    secondaryCategories: SyncResultOfSecondaryCategoryRecord;
    secondaryCategoryTranslations: SyncResultOfSecondaryCategoryTranslationRecord;
    productCategories: SyncResultOfProductCategoryRecord;
    productCategoryTranslations: SyncResultOfProductCategoryTranslationRecord;
    groups: SyncResultOfGroupRecord;
    groupTranslations: SyncResultOfGroupTranslationRecord;
    products: SyncResultOfProductRecord;
    productTranslations: SyncResultOfProductTranslationRecord;
    productStorePrices: SyncResultOfProductStorePriceRecord;
    taxes: SyncResultOfTaxRecord;
    taxTranslations: SyncResultOfTaxTranslationRecord;
    productTaxes: SyncResultOfProductTaxRecord;
    productSerials: SyncResultOfProductSerialRecord;
    customers: SyncResultOfCustomerRecord;
    tenderTypes: SyncResultOfTenderTypeRecord;
    tenderTypeTranslations: SyncResultOfTenderTypeTranslationRecord;
    offers: SyncResultOfOfferRecord;
    offerExcludes: SyncResultOfOfferExcludeRecord;
    offerDetails: SyncResultOfOfferDetailsRecord;
    offerIncludes: SyncResultOfOfferIncludesRecord;
    offerStores: SyncResultOfOfferStoreRecord;
    currencies: SyncResultOfCurrencyRecord;
    currencyTranslations: SyncResultOfCurrencyTranslationRecord;
    scaleConfigurations: ScaleConfigurationDTO;
    store: SyncResultOfStoreRecord;
    discountTypes: SyncResultOfDiscountTypeRecord;
    discountTypeTranslations: SyncResultOfDiscountTypeTranslationRecord;
    discountTypeCustomers: SyncResultOfDiscountTypeCustomerRecord;
    promotion: SyncResultOfPromotionRecord;
    promotionCode: SyncResultOfPromotionCodeRecord;
    promotionDetails: SyncResultOfPromotionDetailsRecord;
    promotionStore: SyncResultOfPromotionStoreRecord;
    tenderTypeMasters: SyncResultOfTenderTypeMasterDto;
    tenderTypeMasterTranslations: SyncResultOfTenderTypeMasterTranslationRecord;
    attributes: SyncResultOfAttributeRecord;
    attributeTranslations: SyncResultOfAttributeTranslationRecord;
    variants: SyncResultOfVariantRecord;
    variantTranslations: SyncResultOfVariantTranslationRecord;
    productVariants: SyncResultOfProductVariantRecord;
    productVariantTranslations: SyncResultOfProductVariantTranslationRecord;
    variantValues: SyncResultOfVariantValueRecord;
    variantValueTranslations: SyncResultOfVariantValueTranslationRecord;
    vendors: SyncResultOfVendorRecord;
    vendorTranslations: SyncResultOfVendorTranslationRecord;
    productVendors: SyncResultOfProductVendorRecord;
    productAttributes: SyncResultOfProductAttributeRecord;
    unitOfMeasures: SyncResultOfUnitOfMeasureRecord;
    unitOfMeasureTranslations: SyncResultOfUnitOfMeasureTranslationRecord;
    productUnitOfMeasureConversions: SyncResultOfProductUnitOfMeasureConversionRecord;
    productLots: SyncResultOfProductLotRecord;
    storeTranslations: SyncResultOfStoreTranslationRecord;
    storeWorkingHoursRule: SyncResultOfSyncStoreWorkingHoursRuleRecord;
    storeWorkingHour: SyncResultOfStoreWorkingHourRecord;
    storeGroupConfig: SyncResultOfStoreGroupConfigRecord;
    permission: SyncResultOfPermissionRecord;

    constructor(data?: IBulkSyncPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatedAt = data["generatedAt"] ? moment(data["generatedAt"].toString()) : <any>undefined;
            this.snapshotTime = data["snapshotTime"] ? moment(data["snapshotTime"].toString()) : <any>undefined;
            this.since = data["since"] ? moment(data["since"].toString()) : <any>undefined;
            if (data["includedModules"] && data["includedModules"].constructor === Array) {
                this.includedModules = [];
                for (let item of data["includedModules"])
                    this.includedModules.push(item);
            }
            this.abpLanguages = data["abpLanguages"] ? SyncResultOfLanguageRecord.fromJS(data["abpLanguages"]) : <any>undefined;
            this.primaryCategories = data["primaryCategories"] ? SyncResultOfPrimaryCategoryRecord.fromJS(data["primaryCategories"]) : <any>undefined;
            this.primaryCategoryTranslations = data["primaryCategoryTranslations"] ? SyncResultOfPrimaryCategoryTranslationRecord.fromJS(data["primaryCategoryTranslations"]) : <any>undefined;
            this.secondaryCategories = data["secondaryCategories"] ? SyncResultOfSecondaryCategoryRecord.fromJS(data["secondaryCategories"]) : <any>undefined;
            this.secondaryCategoryTranslations = data["secondaryCategoryTranslations"] ? SyncResultOfSecondaryCategoryTranslationRecord.fromJS(data["secondaryCategoryTranslations"]) : <any>undefined;
            this.productCategories = data["productCategories"] ? SyncResultOfProductCategoryRecord.fromJS(data["productCategories"]) : <any>undefined;
            this.productCategoryTranslations = data["productCategoryTranslations"] ? SyncResultOfProductCategoryTranslationRecord.fromJS(data["productCategoryTranslations"]) : <any>undefined;
            this.groups = data["groups"] ? SyncResultOfGroupRecord.fromJS(data["groups"]) : <any>undefined;
            this.groupTranslations = data["groupTranslations"] ? SyncResultOfGroupTranslationRecord.fromJS(data["groupTranslations"]) : <any>undefined;
            this.products = data["products"] ? SyncResultOfProductRecord.fromJS(data["products"]) : <any>undefined;
            this.productTranslations = data["productTranslations"] ? SyncResultOfProductTranslationRecord.fromJS(data["productTranslations"]) : <any>undefined;
            this.productStorePrices = data["productStorePrices"] ? SyncResultOfProductStorePriceRecord.fromJS(data["productStorePrices"]) : <any>undefined;
            this.taxes = data["taxes"] ? SyncResultOfTaxRecord.fromJS(data["taxes"]) : <any>undefined;
            this.taxTranslations = data["taxTranslations"] ? SyncResultOfTaxTranslationRecord.fromJS(data["taxTranslations"]) : <any>undefined;
            this.productTaxes = data["productTaxes"] ? SyncResultOfProductTaxRecord.fromJS(data["productTaxes"]) : <any>undefined;
            this.productSerials = data["productSerials"] ? SyncResultOfProductSerialRecord.fromJS(data["productSerials"]) : <any>undefined;
            this.customers = data["customers"] ? SyncResultOfCustomerRecord.fromJS(data["customers"]) : <any>undefined;
            this.tenderTypes = data["tenderTypes"] ? SyncResultOfTenderTypeRecord.fromJS(data["tenderTypes"]) : <any>undefined;
            this.tenderTypeTranslations = data["tenderTypeTranslations"] ? SyncResultOfTenderTypeTranslationRecord.fromJS(data["tenderTypeTranslations"]) : <any>undefined;
            this.offers = data["offers"] ? SyncResultOfOfferRecord.fromJS(data["offers"]) : <any>undefined;
            this.offerExcludes = data["offerExcludes"] ? SyncResultOfOfferExcludeRecord.fromJS(data["offerExcludes"]) : <any>undefined;
            this.offerDetails = data["offerDetails"] ? SyncResultOfOfferDetailsRecord.fromJS(data["offerDetails"]) : <any>undefined;
            this.offerIncludes = data["offerIncludes"] ? SyncResultOfOfferIncludesRecord.fromJS(data["offerIncludes"]) : <any>undefined;
            this.offerStores = data["offerStores"] ? SyncResultOfOfferStoreRecord.fromJS(data["offerStores"]) : <any>undefined;
            this.currencies = data["currencies"] ? SyncResultOfCurrencyRecord.fromJS(data["currencies"]) : <any>undefined;
            this.currencyTranslations = data["currencyTranslations"] ? SyncResultOfCurrencyTranslationRecord.fromJS(data["currencyTranslations"]) : <any>undefined;
            this.scaleConfigurations = data["scaleConfigurations"] ? ScaleConfigurationDTO.fromJS(data["scaleConfigurations"]) : <any>undefined;
            this.store = data["store"] ? SyncResultOfStoreRecord.fromJS(data["store"]) : <any>undefined;
            this.discountTypes = data["discountTypes"] ? SyncResultOfDiscountTypeRecord.fromJS(data["discountTypes"]) : <any>undefined;
            this.discountTypeTranslations = data["discountTypeTranslations"] ? SyncResultOfDiscountTypeTranslationRecord.fromJS(data["discountTypeTranslations"]) : <any>undefined;
            this.discountTypeCustomers = data["discountTypeCustomers"] ? SyncResultOfDiscountTypeCustomerRecord.fromJS(data["discountTypeCustomers"]) : <any>undefined;
            this.promotion = data["promotion"] ? SyncResultOfPromotionRecord.fromJS(data["promotion"]) : <any>undefined;
            this.promotionCode = data["promotionCode"] ? SyncResultOfPromotionCodeRecord.fromJS(data["promotionCode"]) : <any>undefined;
            this.promotionDetails = data["promotionDetails"] ? SyncResultOfPromotionDetailsRecord.fromJS(data["promotionDetails"]) : <any>undefined;
            this.promotionStore = data["promotionStore"] ? SyncResultOfPromotionStoreRecord.fromJS(data["promotionStore"]) : <any>undefined;
            this.tenderTypeMasters = data["tenderTypeMasters"] ? SyncResultOfTenderTypeMasterDto.fromJS(data["tenderTypeMasters"]) : <any>undefined;
            this.tenderTypeMasterTranslations = data["tenderTypeMasterTranslations"] ? SyncResultOfTenderTypeMasterTranslationRecord.fromJS(data["tenderTypeMasterTranslations"]) : <any>undefined;
            this.attributes = data["attributes"] ? SyncResultOfAttributeRecord.fromJS(data["attributes"]) : <any>undefined;
            this.attributeTranslations = data["attributeTranslations"] ? SyncResultOfAttributeTranslationRecord.fromJS(data["attributeTranslations"]) : <any>undefined;
            this.variants = data["variants"] ? SyncResultOfVariantRecord.fromJS(data["variants"]) : <any>undefined;
            this.variantTranslations = data["variantTranslations"] ? SyncResultOfVariantTranslationRecord.fromJS(data["variantTranslations"]) : <any>undefined;
            this.productVariants = data["productVariants"] ? SyncResultOfProductVariantRecord.fromJS(data["productVariants"]) : <any>undefined;
            this.productVariantTranslations = data["productVariantTranslations"] ? SyncResultOfProductVariantTranslationRecord.fromJS(data["productVariantTranslations"]) : <any>undefined;
            this.variantValues = data["variantValues"] ? SyncResultOfVariantValueRecord.fromJS(data["variantValues"]) : <any>undefined;
            this.variantValueTranslations = data["variantValueTranslations"] ? SyncResultOfVariantValueTranslationRecord.fromJS(data["variantValueTranslations"]) : <any>undefined;
            this.vendors = data["vendors"] ? SyncResultOfVendorRecord.fromJS(data["vendors"]) : <any>undefined;
            this.vendorTranslations = data["vendorTranslations"] ? SyncResultOfVendorTranslationRecord.fromJS(data["vendorTranslations"]) : <any>undefined;
            this.productVendors = data["productVendors"] ? SyncResultOfProductVendorRecord.fromJS(data["productVendors"]) : <any>undefined;
            this.productAttributes = data["productAttributes"] ? SyncResultOfProductAttributeRecord.fromJS(data["productAttributes"]) : <any>undefined;
            this.unitOfMeasures = data["unitOfMeasures"] ? SyncResultOfUnitOfMeasureRecord.fromJS(data["unitOfMeasures"]) : <any>undefined;
            this.unitOfMeasureTranslations = data["unitOfMeasureTranslations"] ? SyncResultOfUnitOfMeasureTranslationRecord.fromJS(data["unitOfMeasureTranslations"]) : <any>undefined;
            this.productUnitOfMeasureConversions = data["productUnitOfMeasureConversions"] ? SyncResultOfProductUnitOfMeasureConversionRecord.fromJS(data["productUnitOfMeasureConversions"]) : <any>undefined;
            this.productLots = data["productLots"] ? SyncResultOfProductLotRecord.fromJS(data["productLots"]) : <any>undefined;
            this.storeTranslations = data["storeTranslations"] ? SyncResultOfStoreTranslationRecord.fromJS(data["storeTranslations"]) : <any>undefined;
            this.storeWorkingHoursRule = data["storeWorkingHoursRule"] ? SyncResultOfSyncStoreWorkingHoursRuleRecord.fromJS(data["storeWorkingHoursRule"]) : <any>undefined;
            this.storeWorkingHour = data["storeWorkingHour"] ? SyncResultOfStoreWorkingHourRecord.fromJS(data["storeWorkingHour"]) : <any>undefined;
            this.storeGroupConfig = data["storeGroupConfig"] ? SyncResultOfStoreGroupConfigRecord.fromJS(data["storeGroupConfig"]) : <any>undefined;
            this.permission = data["permission"] ? SyncResultOfPermissionRecord.fromJS(data["permission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkSyncPackage {
        let result = new BulkSyncPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        data["snapshotTime"] = this.snapshotTime ? this.snapshotTime.toISOString() : <any>undefined;
        data["since"] = this.since ? this.since.toISOString() : <any>undefined;
        if (this.includedModules && this.includedModules.constructor === Array) {
            data["includedModules"] = [];
            for (let item of this.includedModules)
                data["includedModules"].push(item);
        }
        data["abpLanguages"] = this.abpLanguages ? this.abpLanguages.toJSON() : <any>undefined;
        data["primaryCategories"] = this.primaryCategories ? this.primaryCategories.toJSON() : <any>undefined;
        data["primaryCategoryTranslations"] = this.primaryCategoryTranslations ? this.primaryCategoryTranslations.toJSON() : <any>undefined;
        data["secondaryCategories"] = this.secondaryCategories ? this.secondaryCategories.toJSON() : <any>undefined;
        data["secondaryCategoryTranslations"] = this.secondaryCategoryTranslations ? this.secondaryCategoryTranslations.toJSON() : <any>undefined;
        data["productCategories"] = this.productCategories ? this.productCategories.toJSON() : <any>undefined;
        data["productCategoryTranslations"] = this.productCategoryTranslations ? this.productCategoryTranslations.toJSON() : <any>undefined;
        data["groups"] = this.groups ? this.groups.toJSON() : <any>undefined;
        data["groupTranslations"] = this.groupTranslations ? this.groupTranslations.toJSON() : <any>undefined;
        data["products"] = this.products ? this.products.toJSON() : <any>undefined;
        data["productTranslations"] = this.productTranslations ? this.productTranslations.toJSON() : <any>undefined;
        data["productStorePrices"] = this.productStorePrices ? this.productStorePrices.toJSON() : <any>undefined;
        data["taxes"] = this.taxes ? this.taxes.toJSON() : <any>undefined;
        data["taxTranslations"] = this.taxTranslations ? this.taxTranslations.toJSON() : <any>undefined;
        data["productTaxes"] = this.productTaxes ? this.productTaxes.toJSON() : <any>undefined;
        data["productSerials"] = this.productSerials ? this.productSerials.toJSON() : <any>undefined;
        data["customers"] = this.customers ? this.customers.toJSON() : <any>undefined;
        data["tenderTypes"] = this.tenderTypes ? this.tenderTypes.toJSON() : <any>undefined;
        data["tenderTypeTranslations"] = this.tenderTypeTranslations ? this.tenderTypeTranslations.toJSON() : <any>undefined;
        data["offers"] = this.offers ? this.offers.toJSON() : <any>undefined;
        data["offerExcludes"] = this.offerExcludes ? this.offerExcludes.toJSON() : <any>undefined;
        data["offerDetails"] = this.offerDetails ? this.offerDetails.toJSON() : <any>undefined;
        data["offerIncludes"] = this.offerIncludes ? this.offerIncludes.toJSON() : <any>undefined;
        data["offerStores"] = this.offerStores ? this.offerStores.toJSON() : <any>undefined;
        data["currencies"] = this.currencies ? this.currencies.toJSON() : <any>undefined;
        data["currencyTranslations"] = this.currencyTranslations ? this.currencyTranslations.toJSON() : <any>undefined;
        data["scaleConfigurations"] = this.scaleConfigurations ? this.scaleConfigurations.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["discountTypes"] = this.discountTypes ? this.discountTypes.toJSON() : <any>undefined;
        data["discountTypeTranslations"] = this.discountTypeTranslations ? this.discountTypeTranslations.toJSON() : <any>undefined;
        data["discountTypeCustomers"] = this.discountTypeCustomers ? this.discountTypeCustomers.toJSON() : <any>undefined;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["promotionCode"] = this.promotionCode ? this.promotionCode.toJSON() : <any>undefined;
        data["promotionDetails"] = this.promotionDetails ? this.promotionDetails.toJSON() : <any>undefined;
        data["promotionStore"] = this.promotionStore ? this.promotionStore.toJSON() : <any>undefined;
        data["tenderTypeMasters"] = this.tenderTypeMasters ? this.tenderTypeMasters.toJSON() : <any>undefined;
        data["tenderTypeMasterTranslations"] = this.tenderTypeMasterTranslations ? this.tenderTypeMasterTranslations.toJSON() : <any>undefined;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        data["attributeTranslations"] = this.attributeTranslations ? this.attributeTranslations.toJSON() : <any>undefined;
        data["variants"] = this.variants ? this.variants.toJSON() : <any>undefined;
        data["variantTranslations"] = this.variantTranslations ? this.variantTranslations.toJSON() : <any>undefined;
        data["productVariants"] = this.productVariants ? this.productVariants.toJSON() : <any>undefined;
        data["productVariantTranslations"] = this.productVariantTranslations ? this.productVariantTranslations.toJSON() : <any>undefined;
        data["variantValues"] = this.variantValues ? this.variantValues.toJSON() : <any>undefined;
        data["variantValueTranslations"] = this.variantValueTranslations ? this.variantValueTranslations.toJSON() : <any>undefined;
        data["vendors"] = this.vendors ? this.vendors.toJSON() : <any>undefined;
        data["vendorTranslations"] = this.vendorTranslations ? this.vendorTranslations.toJSON() : <any>undefined;
        data["productVendors"] = this.productVendors ? this.productVendors.toJSON() : <any>undefined;
        data["productAttributes"] = this.productAttributes ? this.productAttributes.toJSON() : <any>undefined;
        data["unitOfMeasures"] = this.unitOfMeasures ? this.unitOfMeasures.toJSON() : <any>undefined;
        data["unitOfMeasureTranslations"] = this.unitOfMeasureTranslations ? this.unitOfMeasureTranslations.toJSON() : <any>undefined;
        data["productUnitOfMeasureConversions"] = this.productUnitOfMeasureConversions ? this.productUnitOfMeasureConversions.toJSON() : <any>undefined;
        data["productLots"] = this.productLots ? this.productLots.toJSON() : <any>undefined;
        data["storeTranslations"] = this.storeTranslations ? this.storeTranslations.toJSON() : <any>undefined;
        data["storeWorkingHoursRule"] = this.storeWorkingHoursRule ? this.storeWorkingHoursRule.toJSON() : <any>undefined;
        data["storeWorkingHour"] = this.storeWorkingHour ? this.storeWorkingHour.toJSON() : <any>undefined;
        data["storeGroupConfig"] = this.storeGroupConfig ? this.storeGroupConfig.toJSON() : <any>undefined;
        data["permission"] = this.permission ? this.permission.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBulkSyncPackage {
    generatedAt: moment.Moment;
    snapshotTime: moment.Moment;
    since: moment.Moment;
    includedModules: string[];
    abpLanguages: SyncResultOfLanguageRecord;
    primaryCategories: SyncResultOfPrimaryCategoryRecord;
    primaryCategoryTranslations: SyncResultOfPrimaryCategoryTranslationRecord;
    secondaryCategories: SyncResultOfSecondaryCategoryRecord;
    secondaryCategoryTranslations: SyncResultOfSecondaryCategoryTranslationRecord;
    productCategories: SyncResultOfProductCategoryRecord;
    productCategoryTranslations: SyncResultOfProductCategoryTranslationRecord;
    groups: SyncResultOfGroupRecord;
    groupTranslations: SyncResultOfGroupTranslationRecord;
    products: SyncResultOfProductRecord;
    productTranslations: SyncResultOfProductTranslationRecord;
    productStorePrices: SyncResultOfProductStorePriceRecord;
    taxes: SyncResultOfTaxRecord;
    taxTranslations: SyncResultOfTaxTranslationRecord;
    productTaxes: SyncResultOfProductTaxRecord;
    productSerials: SyncResultOfProductSerialRecord;
    customers: SyncResultOfCustomerRecord;
    tenderTypes: SyncResultOfTenderTypeRecord;
    tenderTypeTranslations: SyncResultOfTenderTypeTranslationRecord;
    offers: SyncResultOfOfferRecord;
    offerExcludes: SyncResultOfOfferExcludeRecord;
    offerDetails: SyncResultOfOfferDetailsRecord;
    offerIncludes: SyncResultOfOfferIncludesRecord;
    offerStores: SyncResultOfOfferStoreRecord;
    currencies: SyncResultOfCurrencyRecord;
    currencyTranslations: SyncResultOfCurrencyTranslationRecord;
    scaleConfigurations: ScaleConfigurationDTO;
    store: SyncResultOfStoreRecord;
    discountTypes: SyncResultOfDiscountTypeRecord;
    discountTypeTranslations: SyncResultOfDiscountTypeTranslationRecord;
    discountTypeCustomers: SyncResultOfDiscountTypeCustomerRecord;
    promotion: SyncResultOfPromotionRecord;
    promotionCode: SyncResultOfPromotionCodeRecord;
    promotionDetails: SyncResultOfPromotionDetailsRecord;
    promotionStore: SyncResultOfPromotionStoreRecord;
    tenderTypeMasters: SyncResultOfTenderTypeMasterDto;
    tenderTypeMasterTranslations: SyncResultOfTenderTypeMasterTranslationRecord;
    attributes: SyncResultOfAttributeRecord;
    attributeTranslations: SyncResultOfAttributeTranslationRecord;
    variants: SyncResultOfVariantRecord;
    variantTranslations: SyncResultOfVariantTranslationRecord;
    productVariants: SyncResultOfProductVariantRecord;
    productVariantTranslations: SyncResultOfProductVariantTranslationRecord;
    variantValues: SyncResultOfVariantValueRecord;
    variantValueTranslations: SyncResultOfVariantValueTranslationRecord;
    vendors: SyncResultOfVendorRecord;
    vendorTranslations: SyncResultOfVendorTranslationRecord;
    productVendors: SyncResultOfProductVendorRecord;
    productAttributes: SyncResultOfProductAttributeRecord;
    unitOfMeasures: SyncResultOfUnitOfMeasureRecord;
    unitOfMeasureTranslations: SyncResultOfUnitOfMeasureTranslationRecord;
    productUnitOfMeasureConversions: SyncResultOfProductUnitOfMeasureConversionRecord;
    productLots: SyncResultOfProductLotRecord;
    storeTranslations: SyncResultOfStoreTranslationRecord;
    storeWorkingHoursRule: SyncResultOfSyncStoreWorkingHoursRuleRecord;
    storeWorkingHour: SyncResultOfStoreWorkingHourRecord;
    storeGroupConfig: SyncResultOfStoreGroupConfigRecord;
    permission: SyncResultOfPermissionRecord;
}

export class SyncResultOfLanguageRecord implements ISyncResultOfLanguageRecord {
    added: LanguageRecord[];
    updated: LanguageRecord[];
    deleted: LanguageRecord[];

    constructor(data?: ISyncResultOfLanguageRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(LanguageRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(LanguageRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(LanguageRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfLanguageRecord {
        let result = new SyncResultOfLanguageRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfLanguageRecord {
    added: LanguageRecord[];
    updated: LanguageRecord[];
    deleted: LanguageRecord[];
}

export class SyncResultOfPrimaryCategoryRecord implements ISyncResultOfPrimaryCategoryRecord {
    added: PrimaryCategoryRecord[];
    updated: PrimaryCategoryRecord[];
    deleted: PrimaryCategoryRecord[];

    constructor(data?: ISyncResultOfPrimaryCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PrimaryCategoryRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PrimaryCategoryRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PrimaryCategoryRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPrimaryCategoryRecord {
        let result = new SyncResultOfPrimaryCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPrimaryCategoryRecord {
    added: PrimaryCategoryRecord[];
    updated: PrimaryCategoryRecord[];
    deleted: PrimaryCategoryRecord[];
}

export class SyncResultOfPrimaryCategoryTranslationRecord implements ISyncResultOfPrimaryCategoryTranslationRecord {
    added: PrimaryCategoryTranslationRecord[];
    updated: PrimaryCategoryTranslationRecord[];
    deleted: PrimaryCategoryTranslationRecord[];

    constructor(data?: ISyncResultOfPrimaryCategoryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PrimaryCategoryTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PrimaryCategoryTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PrimaryCategoryTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPrimaryCategoryTranslationRecord {
        let result = new SyncResultOfPrimaryCategoryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPrimaryCategoryTranslationRecord {
    added: PrimaryCategoryTranslationRecord[];
    updated: PrimaryCategoryTranslationRecord[];
    deleted: PrimaryCategoryTranslationRecord[];
}

export class SyncResultOfSecondaryCategoryRecord implements ISyncResultOfSecondaryCategoryRecord {
    added: SecondaryCategoryRecord[];
    updated: SecondaryCategoryRecord[];
    deleted: SecondaryCategoryRecord[];

    constructor(data?: ISyncResultOfSecondaryCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SecondaryCategoryRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SecondaryCategoryRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SecondaryCategoryRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSecondaryCategoryRecord {
        let result = new SyncResultOfSecondaryCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSecondaryCategoryRecord {
    added: SecondaryCategoryRecord[];
    updated: SecondaryCategoryRecord[];
    deleted: SecondaryCategoryRecord[];
}

export class SyncResultOfSecondaryCategoryTranslationRecord implements ISyncResultOfSecondaryCategoryTranslationRecord {
    added: SecondaryCategoryTranslationRecord[];
    updated: SecondaryCategoryTranslationRecord[];
    deleted: SecondaryCategoryTranslationRecord[];

    constructor(data?: ISyncResultOfSecondaryCategoryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SecondaryCategoryTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SecondaryCategoryTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SecondaryCategoryTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSecondaryCategoryTranslationRecord {
        let result = new SyncResultOfSecondaryCategoryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSecondaryCategoryTranslationRecord {
    added: SecondaryCategoryTranslationRecord[];
    updated: SecondaryCategoryTranslationRecord[];
    deleted: SecondaryCategoryTranslationRecord[];
}

export class SyncResultOfProductCategoryRecord implements ISyncResultOfProductCategoryRecord {
    added: ProductCategoryRecord[];
    updated: ProductCategoryRecord[];
    deleted: ProductCategoryRecord[];

    constructor(data?: ISyncResultOfProductCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductCategoryRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductCategoryRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductCategoryRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductCategoryRecord {
        let result = new SyncResultOfProductCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductCategoryRecord {
    added: ProductCategoryRecord[];
    updated: ProductCategoryRecord[];
    deleted: ProductCategoryRecord[];
}

export class SyncResultOfProductCategoryTranslationRecord implements ISyncResultOfProductCategoryTranslationRecord {
    added: ProductCategoryTranslationRecord[];
    updated: ProductCategoryTranslationRecord[];
    deleted: ProductCategoryTranslationRecord[];

    constructor(data?: ISyncResultOfProductCategoryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductCategoryTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductCategoryTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductCategoryTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductCategoryTranslationRecord {
        let result = new SyncResultOfProductCategoryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductCategoryTranslationRecord {
    added: ProductCategoryTranslationRecord[];
    updated: ProductCategoryTranslationRecord[];
    deleted: ProductCategoryTranslationRecord[];
}

export class SyncResultOfGroupRecord implements ISyncResultOfGroupRecord {
    added: GroupRecord[];
    updated: GroupRecord[];
    deleted: GroupRecord[];

    constructor(data?: ISyncResultOfGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(GroupRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(GroupRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(GroupRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfGroupRecord {
        let result = new SyncResultOfGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfGroupRecord {
    added: GroupRecord[];
    updated: GroupRecord[];
    deleted: GroupRecord[];
}

export class SyncResultOfGroupTranslationRecord implements ISyncResultOfGroupTranslationRecord {
    added: GroupTranslationRecord[];
    updated: GroupTranslationRecord[];
    deleted: GroupTranslationRecord[];

    constructor(data?: ISyncResultOfGroupTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(GroupTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(GroupTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(GroupTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfGroupTranslationRecord {
        let result = new SyncResultOfGroupTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfGroupTranslationRecord {
    added: GroupTranslationRecord[];
    updated: GroupTranslationRecord[];
    deleted: GroupTranslationRecord[];
}

export class SyncResultOfProductRecord implements ISyncResultOfProductRecord {
    added: ProductRecord[];
    updated: ProductRecord[];
    deleted: ProductRecord[];

    constructor(data?: ISyncResultOfProductRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductRecord {
        let result = new SyncResultOfProductRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductRecord {
    added: ProductRecord[];
    updated: ProductRecord[];
    deleted: ProductRecord[];
}

export class SyncResultOfProductTranslationRecord implements ISyncResultOfProductTranslationRecord {
    added: ProductTranslationRecord[];
    updated: ProductTranslationRecord[];
    deleted: ProductTranslationRecord[];

    constructor(data?: ISyncResultOfProductTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductTranslationRecord {
        let result = new SyncResultOfProductTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductTranslationRecord {
    added: ProductTranslationRecord[];
    updated: ProductTranslationRecord[];
    deleted: ProductTranslationRecord[];
}

export class SyncResultOfTaxRecord implements ISyncResultOfTaxRecord {
    added: TaxRecord[];
    updated: TaxRecord[];
    deleted: TaxRecord[];

    constructor(data?: ISyncResultOfTaxRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TaxRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TaxRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TaxRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTaxRecord {
        let result = new SyncResultOfTaxRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTaxRecord {
    added: TaxRecord[];
    updated: TaxRecord[];
    deleted: TaxRecord[];
}

export class SyncResultOfTaxTranslationRecord implements ISyncResultOfTaxTranslationRecord {
    added: TaxTranslationRecord[];
    updated: TaxTranslationRecord[];
    deleted: TaxTranslationRecord[];

    constructor(data?: ISyncResultOfTaxTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TaxTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TaxTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TaxTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTaxTranslationRecord {
        let result = new SyncResultOfTaxTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTaxTranslationRecord {
    added: TaxTranslationRecord[];
    updated: TaxTranslationRecord[];
    deleted: TaxTranslationRecord[];
}

export class SyncResultOfProductTaxRecord implements ISyncResultOfProductTaxRecord {
    added: ProductTaxRecord[];
    updated: ProductTaxRecord[];
    deleted: ProductTaxRecord[];

    constructor(data?: ISyncResultOfProductTaxRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductTaxRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductTaxRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductTaxRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductTaxRecord {
        let result = new SyncResultOfProductTaxRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductTaxRecord {
    added: ProductTaxRecord[];
    updated: ProductTaxRecord[];
    deleted: ProductTaxRecord[];
}

export class SyncResultOfProductSerialRecord implements ISyncResultOfProductSerialRecord {
    added: ProductSerialRecord[];
    updated: ProductSerialRecord[];
    deleted: ProductSerialRecord[];

    constructor(data?: ISyncResultOfProductSerialRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductSerialRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductSerialRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductSerialRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductSerialRecord {
        let result = new SyncResultOfProductSerialRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductSerialRecord {
    added: ProductSerialRecord[];
    updated: ProductSerialRecord[];
    deleted: ProductSerialRecord[];
}

export class SyncResultOfCustomerRecord implements ISyncResultOfCustomerRecord {
    added: CustomerRecord[];
    updated: CustomerRecord[];
    deleted: CustomerRecord[];

    constructor(data?: ISyncResultOfCustomerRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CustomerRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CustomerRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CustomerRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCustomerRecord {
        let result = new SyncResultOfCustomerRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCustomerRecord {
    added: CustomerRecord[];
    updated: CustomerRecord[];
    deleted: CustomerRecord[];
}

export class SyncResultOfTenderTypeRecord implements ISyncResultOfTenderTypeRecord {
    added: TenderTypeRecord[];
    updated: TenderTypeRecord[];
    deleted: TenderTypeRecord[];

    constructor(data?: ISyncResultOfTenderTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TenderTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TenderTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TenderTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTenderTypeRecord {
        let result = new SyncResultOfTenderTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTenderTypeRecord {
    added: TenderTypeRecord[];
    updated: TenderTypeRecord[];
    deleted: TenderTypeRecord[];
}

export class SyncResultOfTenderTypeTranslationRecord implements ISyncResultOfTenderTypeTranslationRecord {
    added: TenderTypeTranslationRecord[];
    updated: TenderTypeTranslationRecord[];
    deleted: TenderTypeTranslationRecord[];

    constructor(data?: ISyncResultOfTenderTypeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TenderTypeTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TenderTypeTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TenderTypeTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTenderTypeTranslationRecord {
        let result = new SyncResultOfTenderTypeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTenderTypeTranslationRecord {
    added: TenderTypeTranslationRecord[];
    updated: TenderTypeTranslationRecord[];
    deleted: TenderTypeTranslationRecord[];
}

export class SyncResultOfOfferRecord implements ISyncResultOfOfferRecord {
    added: OfferRecord[];
    updated: OfferRecord[];
    deleted: OfferRecord[];

    constructor(data?: ISyncResultOfOfferRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(OfferRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(OfferRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(OfferRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfOfferRecord {
        let result = new SyncResultOfOfferRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfOfferRecord {
    added: OfferRecord[];
    updated: OfferRecord[];
    deleted: OfferRecord[];
}

export class SyncResultOfOfferExcludeRecord implements ISyncResultOfOfferExcludeRecord {
    added: OfferExcludeRecord[];
    updated: OfferExcludeRecord[];
    deleted: OfferExcludeRecord[];

    constructor(data?: ISyncResultOfOfferExcludeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(OfferExcludeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(OfferExcludeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(OfferExcludeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfOfferExcludeRecord {
        let result = new SyncResultOfOfferExcludeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfOfferExcludeRecord {
    added: OfferExcludeRecord[];
    updated: OfferExcludeRecord[];
    deleted: OfferExcludeRecord[];
}

export class SyncResultOfOfferDetailsRecord implements ISyncResultOfOfferDetailsRecord {
    added: OfferDetailsRecord[];
    updated: OfferDetailsRecord[];
    deleted: OfferDetailsRecord[];

    constructor(data?: ISyncResultOfOfferDetailsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(OfferDetailsRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(OfferDetailsRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(OfferDetailsRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfOfferDetailsRecord {
        let result = new SyncResultOfOfferDetailsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfOfferDetailsRecord {
    added: OfferDetailsRecord[];
    updated: OfferDetailsRecord[];
    deleted: OfferDetailsRecord[];
}

export class SyncResultOfOfferIncludesRecord implements ISyncResultOfOfferIncludesRecord {
    added: OfferIncludesRecord[];
    updated: OfferIncludesRecord[];
    deleted: OfferIncludesRecord[];

    constructor(data?: ISyncResultOfOfferIncludesRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(OfferIncludesRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(OfferIncludesRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(OfferIncludesRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfOfferIncludesRecord {
        let result = new SyncResultOfOfferIncludesRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfOfferIncludesRecord {
    added: OfferIncludesRecord[];
    updated: OfferIncludesRecord[];
    deleted: OfferIncludesRecord[];
}

export class SyncResultOfOfferStoreRecord implements ISyncResultOfOfferStoreRecord {
    added: OfferStoreRecord[];
    updated: OfferStoreRecord[];
    deleted: OfferStoreRecord[];

    constructor(data?: ISyncResultOfOfferStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(OfferStoreRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(OfferStoreRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(OfferStoreRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfOfferStoreRecord {
        let result = new SyncResultOfOfferStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfOfferStoreRecord {
    added: OfferStoreRecord[];
    updated: OfferStoreRecord[];
    deleted: OfferStoreRecord[];
}

export class SyncResultOfCurrencyRecord implements ISyncResultOfCurrencyRecord {
    added: CurrencyRecord[];
    updated: CurrencyRecord[];
    deleted: CurrencyRecord[];

    constructor(data?: ISyncResultOfCurrencyRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CurrencyRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CurrencyRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CurrencyRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCurrencyRecord {
        let result = new SyncResultOfCurrencyRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCurrencyRecord {
    added: CurrencyRecord[];
    updated: CurrencyRecord[];
    deleted: CurrencyRecord[];
}

export class SyncResultOfCurrencyTranslationRecord implements ISyncResultOfCurrencyTranslationRecord {
    added: CurrencyTranslationRecord[];
    updated: CurrencyTranslationRecord[];
    deleted: CurrencyTranslationRecord[];

    constructor(data?: ISyncResultOfCurrencyTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CurrencyTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CurrencyTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CurrencyTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCurrencyTranslationRecord {
        let result = new SyncResultOfCurrencyTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCurrencyTranslationRecord {
    added: CurrencyTranslationRecord[];
    updated: CurrencyTranslationRecord[];
    deleted: CurrencyTranslationRecord[];
}

export class SyncResultOfTenderTypeMasterDto implements ISyncResultOfTenderTypeMasterDto {
    added: TenderTypeMasterDto[];
    updated: TenderTypeMasterDto[];
    deleted: TenderTypeMasterDto[];

    constructor(data?: ISyncResultOfTenderTypeMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TenderTypeMasterDto.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TenderTypeMasterDto.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TenderTypeMasterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTenderTypeMasterDto {
        let result = new SyncResultOfTenderTypeMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTenderTypeMasterDto {
    added: TenderTypeMasterDto[];
    updated: TenderTypeMasterDto[];
    deleted: TenderTypeMasterDto[];
}

export class SyncResultOfTenderTypeMasterTranslationRecord implements ISyncResultOfTenderTypeMasterTranslationRecord {
    added: TenderTypeMasterTranslationRecord[];
    updated: TenderTypeMasterTranslationRecord[];
    deleted: TenderTypeMasterTranslationRecord[];

    constructor(data?: ISyncResultOfTenderTypeMasterTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TenderTypeMasterTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TenderTypeMasterTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TenderTypeMasterTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTenderTypeMasterTranslationRecord {
        let result = new SyncResultOfTenderTypeMasterTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTenderTypeMasterTranslationRecord {
    added: TenderTypeMasterTranslationRecord[];
    updated: TenderTypeMasterTranslationRecord[];
    deleted: TenderTypeMasterTranslationRecord[];
}

export class SyncResultOfAttributeRecord implements ISyncResultOfAttributeRecord {
    added: AttributeRecord[];
    updated: AttributeRecord[];
    deleted: AttributeRecord[];

    constructor(data?: ISyncResultOfAttributeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(AttributeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(AttributeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(AttributeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfAttributeRecord {
        let result = new SyncResultOfAttributeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfAttributeRecord {
    added: AttributeRecord[];
    updated: AttributeRecord[];
    deleted: AttributeRecord[];
}

export class SyncResultOfAttributeTranslationRecord implements ISyncResultOfAttributeTranslationRecord {
    added: AttributeTranslationRecord[];
    updated: AttributeTranslationRecord[];
    deleted: AttributeTranslationRecord[];

    constructor(data?: ISyncResultOfAttributeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(AttributeTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(AttributeTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(AttributeTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfAttributeTranslationRecord {
        let result = new SyncResultOfAttributeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfAttributeTranslationRecord {
    added: AttributeTranslationRecord[];
    updated: AttributeTranslationRecord[];
    deleted: AttributeTranslationRecord[];
}

export class SyncResultOfVariantRecord implements ISyncResultOfVariantRecord {
    added: VariantRecord[];
    updated: VariantRecord[];
    deleted: VariantRecord[];

    constructor(data?: ISyncResultOfVariantRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(VariantRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(VariantRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(VariantRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfVariantRecord {
        let result = new SyncResultOfVariantRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfVariantRecord {
    added: VariantRecord[];
    updated: VariantRecord[];
    deleted: VariantRecord[];
}

export class SyncResultOfVariantTranslationRecord implements ISyncResultOfVariantTranslationRecord {
    added: VariantTranslationRecord[];
    updated: VariantTranslationRecord[];
    deleted: VariantTranslationRecord[];

    constructor(data?: ISyncResultOfVariantTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(VariantTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(VariantTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(VariantTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfVariantTranslationRecord {
        let result = new SyncResultOfVariantTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfVariantTranslationRecord {
    added: VariantTranslationRecord[];
    updated: VariantTranslationRecord[];
    deleted: VariantTranslationRecord[];
}

export class SyncResultOfProductVariantRecord implements ISyncResultOfProductVariantRecord {
    added: ProductVariantRecord[];
    updated: ProductVariantRecord[];
    deleted: ProductVariantRecord[];

    constructor(data?: ISyncResultOfProductVariantRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductVariantRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductVariantRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductVariantRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductVariantRecord {
        let result = new SyncResultOfProductVariantRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductVariantRecord {
    added: ProductVariantRecord[];
    updated: ProductVariantRecord[];
    deleted: ProductVariantRecord[];
}

export class SyncResultOfProductVariantTranslationRecord implements ISyncResultOfProductVariantTranslationRecord {
    added: ProductVariantTranslationRecord[];
    updated: ProductVariantTranslationRecord[];
    deleted: ProductVariantTranslationRecord[];

    constructor(data?: ISyncResultOfProductVariantTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductVariantTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductVariantTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductVariantTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductVariantTranslationRecord {
        let result = new SyncResultOfProductVariantTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductVariantTranslationRecord {
    added: ProductVariantTranslationRecord[];
    updated: ProductVariantTranslationRecord[];
    deleted: ProductVariantTranslationRecord[];
}

export class SyncResultOfVariantValueRecord implements ISyncResultOfVariantValueRecord {
    added: VariantValueRecord[];
    updated: VariantValueRecord[];
    deleted: VariantValueRecord[];

    constructor(data?: ISyncResultOfVariantValueRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(VariantValueRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(VariantValueRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(VariantValueRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfVariantValueRecord {
        let result = new SyncResultOfVariantValueRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfVariantValueRecord {
    added: VariantValueRecord[];
    updated: VariantValueRecord[];
    deleted: VariantValueRecord[];
}

export class SyncResultOfVariantValueTranslationRecord implements ISyncResultOfVariantValueTranslationRecord {
    added: VariantValueTranslationRecord[];
    updated: VariantValueTranslationRecord[];
    deleted: VariantValueTranslationRecord[];

    constructor(data?: ISyncResultOfVariantValueTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(VariantValueTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(VariantValueTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(VariantValueTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfVariantValueTranslationRecord {
        let result = new SyncResultOfVariantValueTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfVariantValueTranslationRecord {
    added: VariantValueTranslationRecord[];
    updated: VariantValueTranslationRecord[];
    deleted: VariantValueTranslationRecord[];
}

export class SyncResultOfVendorRecord implements ISyncResultOfVendorRecord {
    added: VendorRecord[];
    updated: VendorRecord[];
    deleted: VendorRecord[];

    constructor(data?: ISyncResultOfVendorRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(VendorRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(VendorRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(VendorRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfVendorRecord {
        let result = new SyncResultOfVendorRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfVendorRecord {
    added: VendorRecord[];
    updated: VendorRecord[];
    deleted: VendorRecord[];
}

export class SyncResultOfVendorTranslationRecord implements ISyncResultOfVendorTranslationRecord {
    added: VendorTranslationRecord[];
    updated: VendorTranslationRecord[];
    deleted: VendorTranslationRecord[];

    constructor(data?: ISyncResultOfVendorTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(VendorTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(VendorTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(VendorTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfVendorTranslationRecord {
        let result = new SyncResultOfVendorTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfVendorTranslationRecord {
    added: VendorTranslationRecord[];
    updated: VendorTranslationRecord[];
    deleted: VendorTranslationRecord[];
}

export class SyncResultOfProductVendorRecord implements ISyncResultOfProductVendorRecord {
    added: ProductVendorRecord[];
    updated: ProductVendorRecord[];
    deleted: ProductVendorRecord[];

    constructor(data?: ISyncResultOfProductVendorRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductVendorRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductVendorRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductVendorRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductVendorRecord {
        let result = new SyncResultOfProductVendorRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductVendorRecord {
    added: ProductVendorRecord[];
    updated: ProductVendorRecord[];
    deleted: ProductVendorRecord[];
}

export class SyncResultOfProductAttributeRecord implements ISyncResultOfProductAttributeRecord {
    added: ProductAttributeRecord[];
    updated: ProductAttributeRecord[];
    deleted: ProductAttributeRecord[];

    constructor(data?: ISyncResultOfProductAttributeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductAttributeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductAttributeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductAttributeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductAttributeRecord {
        let result = new SyncResultOfProductAttributeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductAttributeRecord {
    added: ProductAttributeRecord[];
    updated: ProductAttributeRecord[];
    deleted: ProductAttributeRecord[];
}

export class SyncResultOfUnitOfMeasureRecord implements ISyncResultOfUnitOfMeasureRecord {
    added: UnitOfMeasureRecord[];
    updated: UnitOfMeasureRecord[];
    deleted: UnitOfMeasureRecord[];

    constructor(data?: ISyncResultOfUnitOfMeasureRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(UnitOfMeasureRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(UnitOfMeasureRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(UnitOfMeasureRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfUnitOfMeasureRecord {
        let result = new SyncResultOfUnitOfMeasureRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfUnitOfMeasureRecord {
    added: UnitOfMeasureRecord[];
    updated: UnitOfMeasureRecord[];
    deleted: UnitOfMeasureRecord[];
}

export class SyncResultOfUnitOfMeasureTranslationRecord implements ISyncResultOfUnitOfMeasureTranslationRecord {
    added: UnitOfMeasureTranslationRecord[];
    updated: UnitOfMeasureTranslationRecord[];
    deleted: UnitOfMeasureTranslationRecord[];

    constructor(data?: ISyncResultOfUnitOfMeasureTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(UnitOfMeasureTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(UnitOfMeasureTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(UnitOfMeasureTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfUnitOfMeasureTranslationRecord {
        let result = new SyncResultOfUnitOfMeasureTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfUnitOfMeasureTranslationRecord {
    added: UnitOfMeasureTranslationRecord[];
    updated: UnitOfMeasureTranslationRecord[];
    deleted: UnitOfMeasureTranslationRecord[];
}

export class SyncResultOfProductUnitOfMeasureConversionRecord implements ISyncResultOfProductUnitOfMeasureConversionRecord {
    added: ProductUnitOfMeasureConversionRecord[];
    updated: ProductUnitOfMeasureConversionRecord[];
    deleted: ProductUnitOfMeasureConversionRecord[];

    constructor(data?: ISyncResultOfProductUnitOfMeasureConversionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductUnitOfMeasureConversionRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductUnitOfMeasureConversionRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductUnitOfMeasureConversionRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductUnitOfMeasureConversionRecord {
        let result = new SyncResultOfProductUnitOfMeasureConversionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductUnitOfMeasureConversionRecord {
    added: ProductUnitOfMeasureConversionRecord[];
    updated: ProductUnitOfMeasureConversionRecord[];
    deleted: ProductUnitOfMeasureConversionRecord[];
}

export class SyncResultOfProductLotRecord implements ISyncResultOfProductLotRecord {
    added: ProductLotRecord[];
    updated: ProductLotRecord[];
    deleted: ProductLotRecord[];

    constructor(data?: ISyncResultOfProductLotRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductLotRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductLotRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductLotRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductLotRecord {
        let result = new SyncResultOfProductLotRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductLotRecord {
    added: ProductLotRecord[];
    updated: ProductLotRecord[];
    deleted: ProductLotRecord[];
}

export class SyncResultOfSyncStoreWorkingHoursRuleRecord implements ISyncResultOfSyncStoreWorkingHoursRuleRecord {
    added: SyncStoreWorkingHoursRuleRecord[];
    updated: SyncStoreWorkingHoursRuleRecord[];
    deleted: SyncStoreWorkingHoursRuleRecord[];

    constructor(data?: ISyncResultOfSyncStoreWorkingHoursRuleRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SyncStoreWorkingHoursRuleRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SyncStoreWorkingHoursRuleRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SyncStoreWorkingHoursRuleRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSyncStoreWorkingHoursRuleRecord {
        let result = new SyncResultOfSyncStoreWorkingHoursRuleRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSyncStoreWorkingHoursRuleRecord {
    added: SyncStoreWorkingHoursRuleRecord[];
    updated: SyncStoreWorkingHoursRuleRecord[];
    deleted: SyncStoreWorkingHoursRuleRecord[];
}

export class SyncResultOfStoreWorkingHourRecord implements ISyncResultOfStoreWorkingHourRecord {
    added: StoreWorkingHourRecord[];
    updated: StoreWorkingHourRecord[];
    deleted: StoreWorkingHourRecord[];

    constructor(data?: ISyncResultOfStoreWorkingHourRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreWorkingHourRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreWorkingHourRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreWorkingHourRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreWorkingHourRecord {
        let result = new SyncResultOfStoreWorkingHourRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreWorkingHourRecord {
    added: StoreWorkingHourRecord[];
    updated: StoreWorkingHourRecord[];
    deleted: StoreWorkingHourRecord[];
}

export class SyncResultOfStoreGroupConfigRecord implements ISyncResultOfStoreGroupConfigRecord {
    added: StoreGroupConfigRecord[];
    updated: StoreGroupConfigRecord[];
    deleted: StoreGroupConfigRecord[];

    constructor(data?: ISyncResultOfStoreGroupConfigRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreGroupConfigRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreGroupConfigRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreGroupConfigRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreGroupConfigRecord {
        let result = new SyncResultOfStoreGroupConfigRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreGroupConfigRecord {
    added: StoreGroupConfigRecord[];
    updated: StoreGroupConfigRecord[];
    deleted: StoreGroupConfigRecord[];
}

export class LanguageRecord implements ILanguageRecord {
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ILanguageRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LanguageRecord {
        let result = new LanguageRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILanguageRecord {
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PrimaryCategoryRecord implements IPrimaryCategoryRecord {
    code: string;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrimaryCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrimaryCategoryRecord {
        let result = new PrimaryCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrimaryCategoryRecord {
    code: string;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PrimaryCategoryTranslationRecord implements IPrimaryCategoryTranslationRecord {
    primaryCategoryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrimaryCategoryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.primaryCategoryId = data["primaryCategoryId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrimaryCategoryTranslationRecord {
        let result = new PrimaryCategoryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrimaryCategoryTranslationRecord {
    primaryCategoryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SecondaryCategoryRecord implements ISecondaryCategoryRecord {
    code: string;
    primaryCategoryId: number;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISecondaryCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCategoryRecord {
        let result = new SecondaryCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISecondaryCategoryRecord {
    code: string;
    primaryCategoryId: number;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SecondaryCategoryTranslationRecord implements ISecondaryCategoryTranslationRecord {
    secondaryCategoryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISecondaryCategoryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCategoryTranslationRecord {
        let result = new SecondaryCategoryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISecondaryCategoryTranslationRecord {
    secondaryCategoryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategoryRecord implements IProductCategoryRecord {
    code: string;
    secondaryCategoryId: number;
    parentId: number;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isLastLevel: boolean;
    imageId: string;
    isShowInPlugIn: boolean;
    productCategoryStores: ProductCategoryConfigRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.parentId = data["parentId"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isLastLevel = data["isLastLevel"];
            this.imageId = data["imageId"];
            this.isShowInPlugIn = data["isShowInPlugIn"];
            if (data["productCategoryStores"] && data["productCategoryStores"].constructor === Array) {
                this.productCategoryStores = [];
                for (let item of data["productCategoryStores"])
                    this.productCategoryStores.push(ProductCategoryConfigRecord.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryRecord {
        let result = new ProductCategoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["parentId"] = this.parentId;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isLastLevel"] = this.isLastLevel;
        data["imageId"] = this.imageId;
        data["isShowInPlugIn"] = this.isShowInPlugIn;
        if (this.productCategoryStores && this.productCategoryStores.constructor === Array) {
            data["productCategoryStores"] = [];
            for (let item of this.productCategoryStores)
                data["productCategoryStores"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryRecord {
    code: string;
    secondaryCategoryId: number;
    parentId: number;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isLastLevel: boolean;
    imageId: string;
    isShowInPlugIn: boolean;
    productCategoryStores: ProductCategoryConfigRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategoryTranslationRecord implements IProductCategoryTranslationRecord {
    productCategoryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCategoryId = data["productCategoryId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryTranslationRecord {
        let result = new ProductCategoryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategoryId"] = this.productCategoryId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryTranslationRecord {
    productCategoryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class GroupRecord implements IGroupRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GroupRecord {
        let result = new GroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGroupRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class GroupTranslationRecord implements IGroupTranslationRecord {
    groupId: number;
    name: string;
    description: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IGroupTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.groupId = data["groupId"];
            this.name = data["name"];
            this.description = data["description"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GroupTranslationRecord {
        let result = new GroupTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGroupTranslationRecord {
    groupId: number;
    name: string;
    description: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductRecord implements IProductRecord {
    code: string;
    price: number;
    priceIncludingVAT: number;
    isHidden: boolean;
    cost: number;
    isService: boolean;
    isPurchased: boolean;
    hasVariants: boolean;
    primaryCategoryId: number;
    groupId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    image: string;
    imageId: string;
    referenceNumber: string;
    saleLimit: number;
    purchaseLimit: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.isHidden = data["isHidden"];
            this.cost = data["cost"];
            this.isService = data["isService"];
            this.isPurchased = data["isPurchased"];
            this.hasVariants = data["hasVariants"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.groupId = data["groupId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.productCategoryId = data["productCategoryId"];
            this.image = data["image"];
            this.imageId = data["imageId"];
            this.referenceNumber = data["referenceNumber"];
            this.saleLimit = data["saleLimit"];
            this.purchaseLimit = data["purchaseLimit"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductRecord {
        let result = new ProductRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["isHidden"] = this.isHidden;
        data["cost"] = this.cost;
        data["isService"] = this.isService;
        data["isPurchased"] = this.isPurchased;
        data["hasVariants"] = this.hasVariants;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["groupId"] = this.groupId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["productCategoryId"] = this.productCategoryId;
        data["image"] = this.image;
        data["imageId"] = this.imageId;
        data["referenceNumber"] = this.referenceNumber;
        data["saleLimit"] = this.saleLimit;
        data["purchaseLimit"] = this.purchaseLimit;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductRecord {
    code: string;
    price: number;
    priceIncludingVAT: number;
    isHidden: boolean;
    cost: number;
    isService: boolean;
    isPurchased: boolean;
    hasVariants: boolean;
    primaryCategoryId: number;
    groupId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    image: string;
    imageId: string;
    referenceNumber: string;
    saleLimit: number;
    purchaseLimit: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductTranslationRecord implements IProductTranslationRecord {
    productId: number;
    name: string;
    description: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.name = data["name"];
            this.description = data["description"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductTranslationRecord {
        let result = new ProductTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductTranslationRecord {
    productId: number;
    name: string;
    description: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TaxRecord implements ITaxRecord {
    value: number;
    isVAT: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITaxRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.isVAT = data["isVAT"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaxRecord {
        let result = new TaxRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isVAT"] = this.isVAT;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITaxRecord {
    value: number;
    isVAT: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TaxTranslationRecord implements ITaxTranslationRecord {
    taxId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITaxTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taxId = data["taxId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaxTranslationRecord {
        let result = new TaxTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxId"] = this.taxId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITaxTranslationRecord {
    taxId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductTaxRecord implements IProductTaxRecord {
    productId: number;
    taxId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductTaxRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.taxId = data["taxId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductTaxRecord {
        let result = new ProductTaxRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["taxId"] = this.taxId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductTaxRecord {
    productId: number;
    taxId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductSerialRecord implements IProductSerialRecord {
    productId: number;
    isSold: boolean;
    serial: string;
    productVariantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductSerialRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.isSold = data["isSold"];
            this.serial = data["serial"];
            this.productVariantId = data["productVariantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductSerialRecord {
        let result = new ProductSerialRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["isSold"] = this.isSold;
        data["serial"] = this.serial;
        data["productVariantId"] = this.productVariantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductSerialRecord {
    productId: number;
    isSold: boolean;
    serial: string;
    productVariantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CustomerRecord implements ICustomerRecord {
    isSync: boolean;
    customerType: number;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    note: string;
    website: string;
    taxNumber: string;
    governorate: string;
    blockNo: string;
    commericalNumber: string;
    identificationSchemeId: string;
    buildingNumber: string;
    area: string;
    code: string;
    discountPrcnt: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ICustomerRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSync = data["isSync"];
            this.customerType = data["customerType"];
            this.cardNumber = data["cardNumber"];
            this.contactName = data["contactName"];
            this.address = data["address"];
            this.city = data["city"];
            this.country = data["country"];
            this.phone = data["phone"];
            this.cellPhone = data["cellPhone"];
            this.fax = data["fax"];
            this.currency = data["currency"];
            this.postalCode = data["postalCode"];
            this.email = data["email"];
            this.email2 = data["email2"];
            this.note = data["note"];
            this.website = data["website"];
            this.taxNumber = data["taxNumber"];
            this.governorate = data["governorate"];
            this.blockNo = data["blockNo"];
            this.commericalNumber = data["commericalNumber"];
            this.identificationSchemeId = data["identificationSchemeId"];
            this.buildingNumber = data["buildingNumber"];
            this.area = data["area"];
            this.code = data["code"];
            this.discountPrcnt = data["discountPrcnt"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomerRecord {
        let result = new CustomerRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSync"] = this.isSync;
        data["customerType"] = this.customerType;
        data["cardNumber"] = this.cardNumber;
        data["contactName"] = this.contactName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["fax"] = this.fax;
        data["currency"] = this.currency;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["note"] = this.note;
        data["website"] = this.website;
        data["taxNumber"] = this.taxNumber;
        data["governorate"] = this.governorate;
        data["blockNo"] = this.blockNo;
        data["commericalNumber"] = this.commericalNumber;
        data["identificationSchemeId"] = this.identificationSchemeId;
        data["buildingNumber"] = this.buildingNumber;
        data["area"] = this.area;
        data["code"] = this.code;
        data["discountPrcnt"] = this.discountPrcnt;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomerRecord {
    isSync: boolean;
    customerType: number;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    note: string;
    website: string;
    taxNumber: string;
    governorate: string;
    blockNo: string;
    commericalNumber: string;
    identificationSchemeId: string;
    buildingNumber: string;
    area: string;
    code: string;
    discountPrcnt: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class TenderTypeRecord implements ITenderTypeRecord {
    deliveryId: number;
    isSystemDefined: boolean;
    isLinkedWithPOSMachine: boolean;
    posMachine: number;
    preventCashRefund: boolean;
    masterId: number;
    isShowInPlugIn: boolean;
    srotTenderTypeConfigs: StoreTenderTypeConfigRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveryId = data["deliveryId"];
            this.isSystemDefined = data["isSystemDefined"];
            this.isLinkedWithPOSMachine = data["isLinkedWithPOSMachine"];
            this.posMachine = data["posMachine"];
            this.preventCashRefund = data["preventCashRefund"];
            this.masterId = data["masterId"];
            this.isShowInPlugIn = data["isShowInPlugIn"];
            if (data["srotTenderTypeConfigs"] && data["srotTenderTypeConfigs"].constructor === Array) {
                this.srotTenderTypeConfigs = [];
                for (let item of data["srotTenderTypeConfigs"])
                    this.srotTenderTypeConfigs.push(StoreTenderTypeConfigRecord.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeRecord {
        let result = new TenderTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["isSystemDefined"] = this.isSystemDefined;
        data["isLinkedWithPOSMachine"] = this.isLinkedWithPOSMachine;
        data["posMachine"] = this.posMachine;
        data["preventCashRefund"] = this.preventCashRefund;
        data["masterId"] = this.masterId;
        data["isShowInPlugIn"] = this.isShowInPlugIn;
        if (this.srotTenderTypeConfigs && this.srotTenderTypeConfigs.constructor === Array) {
            data["srotTenderTypeConfigs"] = [];
            for (let item of this.srotTenderTypeConfigs)
                data["srotTenderTypeConfigs"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeRecord {
    deliveryId: number;
    isSystemDefined: boolean;
    isLinkedWithPOSMachine: boolean;
    posMachine: number;
    preventCashRefund: boolean;
    masterId: number;
    isShowInPlugIn: boolean;
    srotTenderTypeConfigs: StoreTenderTypeConfigRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TenderTypeTranslationRecord implements ITenderTypeTranslationRecord {
    tenderTypeId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeId = data["tenderTypeId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeTranslationRecord {
        let result = new TenderTypeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeId"] = this.tenderTypeId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeTranslationRecord {
    tenderTypeId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferRecord implements IOfferRecord {
    from: moment.Moment;
    to: moment.Moment;
    discountPercent: number;
    discountAmmount: number;
    tenantId: number;
    isExclude: boolean;
    isInclude: boolean;
    offerType: OfferRecordOfferType;
    itemType: OfferRecordItemType;
    itemCode: string;
    itemId: number;
    numberOfItems: number;
    numberOfFreeItems: number;
    value: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.discountPercent = data["discountPercent"];
            this.discountAmmount = data["discountAmmount"];
            this.tenantId = data["tenantId"];
            this.isExclude = data["isExclude"];
            this.isInclude = data["isInclude"];
            this.offerType = data["offerType"];
            this.itemType = data["itemType"];
            this.itemCode = data["itemCode"];
            this.itemId = data["itemId"];
            this.numberOfItems = data["numberOfItems"];
            this.numberOfFreeItems = data["numberOfFreeItems"];
            this.value = data["value"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferRecord {
        let result = new OfferRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["discountPercent"] = this.discountPercent;
        data["discountAmmount"] = this.discountAmmount;
        data["tenantId"] = this.tenantId;
        data["isExclude"] = this.isExclude;
        data["isInclude"] = this.isInclude;
        data["offerType"] = this.offerType;
        data["itemType"] = this.itemType;
        data["itemCode"] = this.itemCode;
        data["itemId"] = this.itemId;
        data["numberOfItems"] = this.numberOfItems;
        data["numberOfFreeItems"] = this.numberOfFreeItems;
        data["value"] = this.value;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferRecord {
    from: moment.Moment;
    to: moment.Moment;
    discountPercent: number;
    discountAmmount: number;
    tenantId: number;
    isExclude: boolean;
    isInclude: boolean;
    offerType: OfferRecordOfferType;
    itemType: OfferRecordItemType;
    itemCode: string;
    itemId: number;
    numberOfItems: number;
    numberOfFreeItems: number;
    value: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferExcludeRecord implements IOfferExcludeRecord {
    itemCode: string;
    itemId: number;
    itemType: OfferExcludeRecordItemType;
    offerId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferExcludeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.offerId = data["offerId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferExcludeRecord {
        let result = new OfferExcludeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["offerId"] = this.offerId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferExcludeRecord {
    itemCode: string;
    itemId: number;
    itemType: OfferExcludeRecordItemType;
    offerId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferDetailsRecord implements IOfferDetailsRecord {
    itemCode: string;
    minQuantity: number;
    maxQuantity: number;
    itemId: number;
    offerId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferDetailsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.minQuantity = data["minQuantity"];
            this.maxQuantity = data["maxQuantity"];
            this.itemId = data["itemId"];
            this.offerId = data["offerId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferDetailsRecord {
        let result = new OfferDetailsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["itemId"] = this.itemId;
        data["offerId"] = this.offerId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferDetailsRecord {
    itemCode: string;
    minQuantity: number;
    maxQuantity: number;
    itemId: number;
    offerId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferIncludesRecord implements IOfferIncludesRecord {
    itemId: number;
    offerId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferIncludesRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
            this.offerId = data["offerId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferIncludesRecord {
        let result = new OfferIncludesRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["offerId"] = this.offerId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferIncludesRecord {
    itemId: number;
    offerId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferStoreRecord implements IOfferStoreRecord {
    tenantId: number;
    storeType: OfferStoreRecordStoreType;
    offerId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeType = data["storeType"];
            this.offerId = data["offerId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferStoreRecord {
        let result = new OfferStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeType"] = this.storeType;
        data["offerId"] = this.offerId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferStoreRecord {
    tenantId: number;
    storeType: OfferStoreRecordStoreType;
    offerId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CurrencyRecord implements ICurrencyRecord {
    code: string;
    tenantId: number;
    default: boolean;
    rate: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICurrencyRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            this.default = data["default"];
            this.rate = data["rate"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CurrencyRecord {
        let result = new CurrencyRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        data["default"] = this.default;
        data["rate"] = this.rate;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrencyRecord {
    code: string;
    tenantId: number;
    default: boolean;
    rate: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CurrencyTranslationRecord implements ICurrencyTranslationRecord {
    languageId: number;
    currencyId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICurrencyTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageId = data["languageId"];
            this.currencyId = data["currencyId"];
            this.name = data["name"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CurrencyTranslationRecord {
        let result = new CurrencyTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["currencyId"] = this.currencyId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrencyTranslationRecord {
    languageId: number;
    currencyId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TenderTypeMasterDto implements ITenderTypeMasterDto {
    showInClosingShift: boolean;
    nature: TenderTypeMasterDtoNature;
    tenderTypeIds: number[];
    translations: TenderTypeMasterTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.showInClosingShift = data["showInClosingShift"];
            this.nature = data["nature"];
            if (data["tenderTypeIds"] && data["tenderTypeIds"].constructor === Array) {
                this.tenderTypeIds = [];
                for (let item of data["tenderTypeIds"])
                    this.tenderTypeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeMasterTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeMasterDto {
        let result = new TenderTypeMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showInClosingShift"] = this.showInClosingShift;
        data["nature"] = this.nature;
        if (this.tenderTypeIds && this.tenderTypeIds.constructor === Array) {
            data["tenderTypeIds"] = [];
            for (let item of this.tenderTypeIds)
                data["tenderTypeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeMasterDto {
    showInClosingShift: boolean;
    nature: TenderTypeMasterDtoNature;
    tenderTypeIds: number[];
    translations: TenderTypeMasterTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TenderTypeMasterTranslationRecord implements ITenderTypeMasterTranslationRecord {
    tenderTypeMasterId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeMasterTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeMasterId = data["tenderTypeMasterId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeMasterTranslationRecord {
        let result = new TenderTypeMasterTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeMasterId"] = this.tenderTypeMasterId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeMasterTranslationRecord {
    tenderTypeMasterId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class AttributeRecord implements IAttributeRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IAttributeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AttributeRecord {
        let result = new AttributeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAttributeRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class AttributeTranslationRecord implements IAttributeTranslationRecord {
    attributeId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IAttributeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attributeId = data["attributeId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AttributeTranslationRecord {
        let result = new AttributeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeId"] = this.attributeId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAttributeTranslationRecord {
    attributeId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantRecord implements IVariantRecord {
    categoryId: number;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isModifier: boolean;
    isActive: boolean;
    pricingRule: VariantRecordPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.isRequired = data["isRequired"];
            this.minSelections = data["minSelections"];
            this.maxSelections = data["maxSelections"];
            this.allowMultipleQuantitiesPerModifier = data["allowMultipleQuantitiesPerModifier"];
            this.maxQtyPerModifier = data["maxQtyPerModifier"];
            this.isAdd = data["isAdd"];
            this.isModifier = data["isModifier"];
            this.isActive = data["isActive"];
            this.pricingRule = data["pricingRule"];
            this.pricingRuleFreeItemsCount = data["pricingRuleFreeItemsCount"];
            this.periorty = data["periorty"];
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantRecord {
        let result = new VariantRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["isRequired"] = this.isRequired;
        data["minSelections"] = this.minSelections;
        data["maxSelections"] = this.maxSelections;
        data["allowMultipleQuantitiesPerModifier"] = this.allowMultipleQuantitiesPerModifier;
        data["maxQtyPerModifier"] = this.maxQtyPerModifier;
        data["isAdd"] = this.isAdd;
        data["isModifier"] = this.isModifier;
        data["isActive"] = this.isActive;
        data["pricingRule"] = this.pricingRule;
        data["pricingRuleFreeItemsCount"] = this.pricingRuleFreeItemsCount;
        data["periorty"] = this.periorty;
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantRecord {
    categoryId: number;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isModifier: boolean;
    isActive: boolean;
    pricingRule: VariantRecordPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantTranslationRecord implements IVariantTranslationRecord {
    variantId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variantId = data["variantId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantTranslationRecord {
        let result = new VariantTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantId"] = this.variantId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantTranslationRecord {
    variantId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductVariantRecord implements IProductVariantRecord {
    productId: number;
    variantValue1Id: number;
    variantValue2Id: number;
    variantValue3Id: number;
    code: string;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductVariantRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.variantValue1Id = data["variantValue1Id"];
            this.variantValue2Id = data["variantValue2Id"];
            this.variantValue3Id = data["variantValue3Id"];
            this.code = data["code"];
            this.price = data["price"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductVariantRecord {
        let result = new ProductVariantRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["variantValue1Id"] = this.variantValue1Id;
        data["variantValue2Id"] = this.variantValue2Id;
        data["variantValue3Id"] = this.variantValue3Id;
        data["code"] = this.code;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductVariantRecord {
    productId: number;
    variantValue1Id: number;
    variantValue2Id: number;
    variantValue3Id: number;
    code: string;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductVariantTranslationRecord implements IProductVariantTranslationRecord {
    productVariantId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductVariantTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productVariantId = data["productVariantId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductVariantTranslationRecord {
        let result = new ProductVariantTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productVariantId"] = this.productVariantId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductVariantTranslationRecord {
    productVariantId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantValueRecord implements IVariantValueRecord {
    variantId: number;
    isDefault: boolean;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantValueRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variantId = data["variantId"];
            this.isDefault = data["isDefault"];
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantValueRecord {
        let result = new VariantValueRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantId"] = this.variantId;
        data["isDefault"] = this.isDefault;
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantValueRecord {
    variantId: number;
    isDefault: boolean;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantValueTranslationRecord implements IVariantValueTranslationRecord {
    variantValueId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantValueTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variantValueId = data["variantValueId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantValueTranslationRecord {
        let result = new VariantValueTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantValueId"] = this.variantValueId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantValueTranslationRecord {
    variantValueId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VendorRecord implements IVendorRecord {
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVendorRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VendorRecord {
        let result = new VendorRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVendorRecord {
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VendorTranslationRecord implements IVendorTranslationRecord {
    vendorId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVendorTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorId = data["vendorId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VendorTranslationRecord {
        let result = new VendorTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVendorTranslationRecord {
    vendorId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductVendorRecord implements IProductVendorRecord {
    vendorId: number;
    productId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductVendorRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorId = data["vendorId"];
            this.productId = data["productId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductVendorRecord {
        let result = new ProductVendorRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId;
        data["productId"] = this.productId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductVendorRecord {
    vendorId: number;
    productId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductAttributeRecord implements IProductAttributeRecord {
    productId: number;
    attributeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductAttributeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.attributeId = data["attributeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductAttributeRecord {
        let result = new ProductAttributeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["attributeId"] = this.attributeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductAttributeRecord {
    productId: number;
    attributeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UnitOfMeasureRecord implements IUnitOfMeasureRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUnitOfMeasureRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnitOfMeasureRecord {
        let result = new UnitOfMeasureRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUnitOfMeasureRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UnitOfMeasureTranslationRecord implements IUnitOfMeasureTranslationRecord {
    unitOfMeasureId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUnitOfMeasureTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnitOfMeasureTranslationRecord {
        let result = new UnitOfMeasureTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUnitOfMeasureTranslationRecord {
    unitOfMeasureId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductUnitOfMeasureConversionRecord implements IProductUnitOfMeasureConversionRecord {
    productId: number;
    unitOfMeasureId: number;
    baseUnitOfMeasureId: number;
    conversionFactor: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductUnitOfMeasureConversionRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.baseUnitOfMeasureId = data["baseUnitOfMeasureId"];
            this.conversionFactor = data["conversionFactor"];
            this.code = data["code"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductUnitOfMeasureConversionRecord {
        let result = new ProductUnitOfMeasureConversionRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["baseUnitOfMeasureId"] = this.baseUnitOfMeasureId;
        data["conversionFactor"] = this.conversionFactor;
        data["code"] = this.code;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductUnitOfMeasureConversionRecord {
    productId: number;
    unitOfMeasureId: number;
    baseUnitOfMeasureId: number;
    conversionFactor: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductLotRecord implements IProductLotRecord {
    storeId: number;
    productId: number;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    remainingQuantity: number;
    unitPurchasePrice: number;
    productVariantId: number;
    unitOfMeasureId: number;
    purchaseInvoiceId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductLotRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.productId = data["productId"];
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.quantity = data["quantity"];
            this.remainingQuantity = data["remainingQuantity"];
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.productVariantId = data["productVariantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.purchaseInvoiceId = data["purchaseInvoiceId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductLotRecord {
        let result = new ProductLotRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["productId"] = this.productId;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["remainingQuantity"] = this.remainingQuantity;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["productVariantId"] = this.productVariantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["purchaseInvoiceId"] = this.purchaseInvoiceId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductLotRecord {
    storeId: number;
    productId: number;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    remainingQuantity: number;
    unitPurchasePrice: number;
    productVariantId: number;
    unitOfMeasureId: number;
    purchaseInvoiceId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncStoreWorkingHoursRuleRecord implements ISyncStoreWorkingHoursRuleRecord {
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    tenantId: number;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISyncStoreWorkingHoursRuleRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.activeStartDate = data["activeStartDate"] ? moment(data["activeStartDate"].toString()) : <any>undefined;
            this.activeEndDate = data["activeEndDate"] ? moment(data["activeEndDate"].toString()) : <any>undefined;
            this.isActiveEndOfDay = data["isActiveEndOfDay"];
            this.isMustCloseOldShift = data["isMustCloseOldShift"];
            this.canCashierEndTheDayBeforeTime = data["canCashierEndTheDayBeforeTime"];
            this.startOfDay = data["startOfDay"];
            this.endOfDay = data["endOfDay"];
            this.tenantId = data["tenantId"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SyncStoreWorkingHoursRuleRecord {
        let result = new SyncStoreWorkingHoursRuleRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["activeStartDate"] = this.activeStartDate ? this.activeStartDate.toISOString() : <any>undefined;
        data["activeEndDate"] = this.activeEndDate ? this.activeEndDate.toISOString() : <any>undefined;
        data["isActiveEndOfDay"] = this.isActiveEndOfDay;
        data["isMustCloseOldShift"] = this.isMustCloseOldShift;
        data["canCashierEndTheDayBeforeTime"] = this.canCashierEndTheDayBeforeTime;
        data["startOfDay"] = this.startOfDay;
        data["endOfDay"] = this.endOfDay;
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISyncStoreWorkingHoursRuleRecord {
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    tenantId: number;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreWorkingHourRecord implements IStoreWorkingHourRecord {
    tenantId: number;
    ruleId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreWorkingHourRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.ruleId = data["ruleId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreWorkingHourRecord {
        let result = new StoreWorkingHourRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["ruleId"] = this.ruleId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreWorkingHourRecord {
    tenantId: number;
    ruleId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreGroupConfigRecord implements IStoreGroupConfigRecord {
    groupId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreGroupConfigRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.groupId = data["groupId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreGroupConfigRecord {
        let result = new StoreGroupConfigRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreGroupConfigRecord {
    groupId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategoryConfigRecord implements IProductCategoryConfigRecord {
    productCategoryId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryConfigRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCategoryId = data["productCategoryId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryConfigRecord {
        let result = new ProductCategoryConfigRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategoryId"] = this.productCategoryId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryConfigRecord {
    productCategoryId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreTenderTypeConfigRecord implements IStoreTenderTypeConfigRecord {
    tenderTypeId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreTenderTypeConfigRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeId = data["tenderTypeId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreTenderTypeConfigRecord {
        let result = new StoreTenderTypeConfigRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeId"] = this.tenderTypeId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreTenderTypeConfigRecord {
    tenderTypeId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TenderTypeMasterTranslationDto implements ITenderTypeMasterTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ITenderTypeMasterTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): TenderTypeMasterTranslationDto {
        let result = new TenderTypeMasterTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ITenderTypeMasterTranslationDto {
    name: string;
    languageId: number;
}

export class BulkSyncInput implements IBulkSyncInput {
    lastDate: moment.Moment;
    userId: number;
    storeId: number;

    constructor(data?: IBulkSyncInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lastDate = data["lastDate"] ? moment(data["lastDate"].toString()) : <any>undefined;
            this.userId = data["userId"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): BulkSyncInput {
        let result = new BulkSyncInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IBulkSyncInput {
    lastDate: moment.Moment;
    userId: number;
    storeId: number;
}

export class SyncResultOfTableRecord implements ISyncResultOfTableRecord {
    added: TableRecord[];
    updated: TableRecord[];
    deleted: TableRecord[];

    constructor(data?: ISyncResultOfTableRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TableRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TableRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TableRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTableRecord {
        let result = new SyncResultOfTableRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTableRecord {
    added: TableRecord[];
    updated: TableRecord[];
    deleted: TableRecord[];
}

export class TableRecord implements ITableRecord {
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    storeId: number;
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITableRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableNumber = data["tableNumber"];
            this.numberOfSeats = data["numberOfSeats"];
            this.cornerId = data["cornerId"];
            this.storeId = data["storeId"];
            this.code = data["code"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TableRecord {
        let result = new TableRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableNumber"] = this.tableNumber;
        data["numberOfSeats"] = this.numberOfSeats;
        data["cornerId"] = this.cornerId;
        data["storeId"] = this.storeId;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITableRecord {
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    storeId: number;
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfCornerRecord implements ISyncResultOfCornerRecord {
    added: CornerRecord[];
    updated: CornerRecord[];
    deleted: CornerRecord[];

    constructor(data?: ISyncResultOfCornerRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CornerRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CornerRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CornerRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCornerRecord {
        let result = new SyncResultOfCornerRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCornerRecord {
    added: CornerRecord[];
    updated: CornerRecord[];
    deleted: CornerRecord[];
}

export class CornerRecord implements ICornerRecord {
    tenantId: number;
    name: string;
    nameAr: string;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICornerRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.nameAr = data["nameAr"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CornerRecord {
        let result = new CornerRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["nameAr"] = this.nameAr;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICornerRecord {
    tenantId: number;
    name: string;
    nameAr: string;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfCornerTranslationRecord implements ISyncResultOfCornerTranslationRecord {
    added: CornerTranslationRecord[];
    updated: CornerTranslationRecord[];
    deleted: CornerTranslationRecord[];

    constructor(data?: ISyncResultOfCornerTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CornerTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CornerTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CornerTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCornerTranslationRecord {
        let result = new SyncResultOfCornerTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCornerTranslationRecord {
    added: CornerTranslationRecord[];
    updated: CornerTranslationRecord[];
    deleted: CornerTranslationRecord[];
}

export class CornerTranslationRecord implements ICornerTranslationRecord {
    cornerId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICornerTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cornerId = data["cornerId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CornerTranslationRecord {
        let result = new CornerTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cornerId"] = this.cornerId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICornerTranslationRecord {
    cornerId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfUserStoresRecord implements ISyncResultOfUserStoresRecord {
    added: UserStoresRecord[];
    updated: UserStoresRecord[];
    deleted: UserStoresRecord[];

    constructor(data?: ISyncResultOfUserStoresRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(UserStoresRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(UserStoresRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(UserStoresRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfUserStoresRecord {
        let result = new SyncResultOfUserStoresRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfUserStoresRecord {
    added: UserStoresRecord[];
    updated: UserStoresRecord[];
    deleted: UserStoresRecord[];
}

export class UserStoresRecord implements IUserStoresRecord {
    storeId: number;
    userId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUserStoresRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserStoresRecord {
        let result = new UserStoresRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserStoresRecord {
    storeId: number;
    userId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfStoreShiftsRecord implements ISyncResultOfStoreShiftsRecord {
    added: StoreShiftsRecord[];
    updated: StoreShiftsRecord[];
    deleted: StoreShiftsRecord[];

    constructor(data?: ISyncResultOfStoreShiftsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreShiftsRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreShiftsRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreShiftsRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreShiftsRecord {
        let result = new SyncResultOfStoreShiftsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreShiftsRecord {
    added: StoreShiftsRecord[];
    updated: StoreShiftsRecord[];
    deleted: StoreShiftsRecord[];
}

export class StoreShiftsRecord implements IStoreShiftsRecord {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    storeId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreShiftsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.startedBy = data["startedBy"];
            this.endedBy = data["endedBy"];
            this.storeId = data["storeId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreShiftsRecord {
        let result = new StoreShiftsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["endedBy"] = this.endedBy;
        data["storeId"] = this.storeId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreShiftsRecord {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    storeId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfSupervisorShiftsRecord implements ISyncResultOfSupervisorShiftsRecord {
    added: SupervisorShiftsRecord[];
    updated: SupervisorShiftsRecord[];
    deleted: SupervisorShiftsRecord[];

    constructor(data?: ISyncResultOfSupervisorShiftsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SupervisorShiftsRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SupervisorShiftsRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SupervisorShiftsRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSupervisorShiftsRecord {
        let result = new SyncResultOfSupervisorShiftsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSupervisorShiftsRecord {
    added: SupervisorShiftsRecord[];
    updated: SupervisorShiftsRecord[];
    deleted: SupervisorShiftsRecord[];
}

export class SupervisorShiftsRecord implements ISupervisorShiftsRecord {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: SupervisorShiftsRecordStatus;
    userId: number;
    storeShiftId: number;
    storeId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISupervisorShiftsRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.startedBy = data["startedBy"];
            this.endedBy = data["endedBy"];
            this.status = data["status"];
            this.userId = data["userId"];
            this.storeShiftId = data["storeShiftId"];
            this.storeId = data["storeId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SupervisorShiftsRecord {
        let result = new SupervisorShiftsRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["endedBy"] = this.endedBy;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["storeShiftId"] = this.storeShiftId;
        data["storeId"] = this.storeId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISupervisorShiftsRecord {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: SupervisorShiftsRecordStatus;
    userId: number;
    storeShiftId: number;
    storeId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPromotionFBAdditionalFreeItemRecord implements ISyncResultOfPromotionFBAdditionalFreeItemRecord {
    added: PromotionFBAdditionalFreeItemRecord[];
    updated: PromotionFBAdditionalFreeItemRecord[];
    deleted: PromotionFBAdditionalFreeItemRecord[];

    constructor(data?: ISyncResultOfPromotionFBAdditionalFreeItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PromotionFBAdditionalFreeItemRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PromotionFBAdditionalFreeItemRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PromotionFBAdditionalFreeItemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPromotionFBAdditionalFreeItemRecord {
        let result = new SyncResultOfPromotionFBAdditionalFreeItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPromotionFBAdditionalFreeItemRecord {
    added: PromotionFBAdditionalFreeItemRecord[];
    updated: PromotionFBAdditionalFreeItemRecord[];
    deleted: PromotionFBAdditionalFreeItemRecord[];
}

export class PromotionFBAdditionalFreeItemRecord implements IPromotionFBAdditionalFreeItemRecord {
    itemId: number;
    itemType: PromotionFBAdditionalFreeItemRecordItemType;
    quantity: number;
    price: number;
    promotionId: number;
    promotionFBAdditionalFreeItemsExcludedMenuItems: PromotionFBAdditionalFreeItemsExcludedMenuItemRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBAdditionalFreeItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.promotionId = data["promotionId"];
            if (data["promotionFBAdditionalFreeItemsExcludedMenuItems"] && data["promotionFBAdditionalFreeItemsExcludedMenuItems"].constructor === Array) {
                this.promotionFBAdditionalFreeItemsExcludedMenuItems = [];
                for (let item of data["promotionFBAdditionalFreeItemsExcludedMenuItems"])
                    this.promotionFBAdditionalFreeItemsExcludedMenuItems.push(PromotionFBAdditionalFreeItemsExcludedMenuItemRecord.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBAdditionalFreeItemRecord {
        let result = new PromotionFBAdditionalFreeItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["promotionId"] = this.promotionId;
        if (this.promotionFBAdditionalFreeItemsExcludedMenuItems && this.promotionFBAdditionalFreeItemsExcludedMenuItems.constructor === Array) {
            data["promotionFBAdditionalFreeItemsExcludedMenuItems"] = [];
            for (let item of this.promotionFBAdditionalFreeItemsExcludedMenuItems)
                data["promotionFBAdditionalFreeItemsExcludedMenuItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBAdditionalFreeItemRecord {
    itemId: number;
    itemType: PromotionFBAdditionalFreeItemRecordItemType;
    quantity: number;
    price: number;
    promotionId: number;
    promotionFBAdditionalFreeItemsExcludedMenuItems: PromotionFBAdditionalFreeItemsExcludedMenuItemRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionFBAdditionalFreeItemsExcludedMenuItemRecord implements IPromotionFBAdditionalFreeItemsExcludedMenuItemRecord {
    menuItemId: number;
    promotionFBAdditionalFreeItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBAdditionalFreeItemsExcludedMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.promotionFBAdditionalFreeItemId = data["promotionFBAdditionalFreeItemId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBAdditionalFreeItemsExcludedMenuItemRecord {
        let result = new PromotionFBAdditionalFreeItemsExcludedMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["promotionFBAdditionalFreeItemId"] = this.promotionFBAdditionalFreeItemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBAdditionalFreeItemsExcludedMenuItemRecord {
    menuItemId: number;
    promotionFBAdditionalFreeItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfStoreZoneRecord implements ISyncResultOfStoreZoneRecord {
    added: StoreZoneRecord[];
    updated: StoreZoneRecord[];
    deleted: StoreZoneRecord[];

    constructor(data?: ISyncResultOfStoreZoneRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreZoneRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreZoneRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreZoneRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreZoneRecord {
        let result = new SyncResultOfStoreZoneRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreZoneRecord {
    added: StoreZoneRecord[];
    updated: StoreZoneRecord[];
    deleted: StoreZoneRecord[];
}

export class StoreZoneRecord implements IStoreZoneRecord {
    storeId: number;
    deliveryZoneId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreZoneRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreZoneRecord {
        let result = new StoreZoneRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreZoneRecord {
    storeId: number;
    deliveryZoneId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfMenuItemStoreRecord implements ISyncResultOfMenuItemStoreRecord {
    added: MenuItemStoreRecord[];
    updated: MenuItemStoreRecord[];
    deleted: MenuItemStoreRecord[];

    constructor(data?: ISyncResultOfMenuItemStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(MenuItemStoreRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(MenuItemStoreRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(MenuItemStoreRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfMenuItemStoreRecord {
        let result = new SyncResultOfMenuItemStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfMenuItemStoreRecord {
    added: MenuItemStoreRecord[];
    updated: MenuItemStoreRecord[];
    deleted: MenuItemStoreRecord[];
}

export class MenuItemStoreRecord implements IMenuItemStoreRecord {
    tenantId: number;
    storeId: number;
    menuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemStoreRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.menuItemId = data["menuItemId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemStoreRecord {
        let result = new MenuItemStoreRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["menuItemId"] = this.menuItemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemStoreRecord {
    tenantId: number;
    storeId: number;
    menuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfProductCategoryConfigRecord implements ISyncResultOfProductCategoryConfigRecord {
    added: ProductCategoryConfigRecord[];
    updated: ProductCategoryConfigRecord[];
    deleted: ProductCategoryConfigRecord[];

    constructor(data?: ISyncResultOfProductCategoryConfigRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ProductCategoryConfigRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ProductCategoryConfigRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ProductCategoryConfigRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfProductCategoryConfigRecord {
        let result = new SyncResultOfProductCategoryConfigRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfProductCategoryConfigRecord {
    added: ProductCategoryConfigRecord[];
    updated: ProductCategoryConfigRecord[];
    deleted: ProductCategoryConfigRecord[];
}

export class SyncResultOfTenantDeviceRecord implements ISyncResultOfTenantDeviceRecord {
    added: TenantDeviceRecord[];
    updated: TenantDeviceRecord[];
    deleted: TenantDeviceRecord[];

    constructor(data?: ISyncResultOfTenantDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TenantDeviceRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TenantDeviceRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TenantDeviceRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTenantDeviceRecord {
        let result = new SyncResultOfTenantDeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTenantDeviceRecord {
    added: TenantDeviceRecord[];
    updated: TenantDeviceRecord[];
    deleted: TenantDeviceRecord[];
}

export class TenantDeviceRecord implements ITenantDeviceRecord {
    tenantId: number;
    clusterId: number;
    isCoordinator: boolean;
    ipAddress: string;
    deviceType: number;
    salesTypes: string;
    deviceName: string;
    isActive: boolean;
    macAddress: string;
    backupDeviceId: number;
    portNumber: string;
    isShowInPlugin: boolean;
    parentTenantDevices: ParentTenantDeviceRecord[];
    devices: ChildTenantDeviceRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenantDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.clusterId = data["clusterId"];
            this.isCoordinator = data["isCoordinator"];
            this.ipAddress = data["ipAddress"];
            this.deviceType = data["deviceType"];
            this.salesTypes = data["salesTypes"];
            this.deviceName = data["deviceName"];
            this.isActive = data["isActive"];
            this.macAddress = data["macAddress"];
            this.backupDeviceId = data["backupDeviceId"];
            this.portNumber = data["portNumber"];
            this.isShowInPlugin = data["isShowInPlugin"];
            if (data["parentTenantDevices"] && data["parentTenantDevices"].constructor === Array) {
                this.parentTenantDevices = [];
                for (let item of data["parentTenantDevices"])
                    this.parentTenantDevices.push(ParentTenantDeviceRecord.fromJS(item));
            }
            if (data["devices"] && data["devices"].constructor === Array) {
                this.devices = [];
                for (let item of data["devices"])
                    this.devices.push(ChildTenantDeviceRecord.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantDeviceRecord {
        let result = new TenantDeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["clusterId"] = this.clusterId;
        data["isCoordinator"] = this.isCoordinator;
        data["ipAddress"] = this.ipAddress;
        data["deviceType"] = this.deviceType;
        data["salesTypes"] = this.salesTypes;
        data["deviceName"] = this.deviceName;
        data["isActive"] = this.isActive;
        data["macAddress"] = this.macAddress;
        data["backupDeviceId"] = this.backupDeviceId;
        data["portNumber"] = this.portNumber;
        data["isShowInPlugin"] = this.isShowInPlugin;
        if (this.parentTenantDevices && this.parentTenantDevices.constructor === Array) {
            data["parentTenantDevices"] = [];
            for (let item of this.parentTenantDevices)
                data["parentTenantDevices"].push(item.toJSON());
        }
        if (this.devices && this.devices.constructor === Array) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantDeviceRecord {
    tenantId: number;
    clusterId: number;
    isCoordinator: boolean;
    ipAddress: string;
    deviceType: number;
    salesTypes: string;
    deviceName: string;
    isActive: boolean;
    macAddress: string;
    backupDeviceId: number;
    portNumber: string;
    isShowInPlugin: boolean;
    parentTenantDevices: ParentTenantDeviceRecord[];
    devices: ChildTenantDeviceRecord[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ParentTenantDeviceRecord implements IParentTenantDeviceRecord {
    deviceId: number;
    parentDeviceId: number;
    parentDevice: TenantDeviceRecord;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IParentTenantDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.parentDeviceId = data["parentDeviceId"];
            this.parentDevice = data["parentDevice"] ? TenantDeviceRecord.fromJS(data["parentDevice"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ParentTenantDeviceRecord {
        let result = new ParentTenantDeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["parentDeviceId"] = this.parentDeviceId;
        data["parentDevice"] = this.parentDevice ? this.parentDevice.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IParentTenantDeviceRecord {
    deviceId: number;
    parentDeviceId: number;
    parentDevice: TenantDeviceRecord;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ChildTenantDeviceRecord implements IChildTenantDeviceRecord {
    deviceId: number;
    childDeviceId: number;
    device: TenantDeviceRecord;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IChildTenantDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.childDeviceId = data["childDeviceId"];
            this.device = data["device"] ? TenantDeviceRecord.fromJS(data["device"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChildTenantDeviceRecord {
        let result = new ChildTenantDeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["childDeviceId"] = this.childDeviceId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChildTenantDeviceRecord {
    deviceId: number;
    childDeviceId: number;
    device: TenantDeviceRecord;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfReportGroupRecord implements ISyncResultOfReportGroupRecord {
    added: ReportGroupRecord[];
    updated: ReportGroupRecord[];
    deleted: ReportGroupRecord[];

    constructor(data?: ISyncResultOfReportGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ReportGroupRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ReportGroupRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ReportGroupRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfReportGroupRecord {
        let result = new SyncResultOfReportGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfReportGroupRecord {
    added: ReportGroupRecord[];
    updated: ReportGroupRecord[];
    deleted: ReportGroupRecord[];
}

export class ReportGroupRecord implements IReportGroupRecord {
    code: string;
    description: string;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IReportGroupRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.description = data["description"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReportGroupRecord {
        let result = new ReportGroupRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReportGroupRecord {
    code: string;
    description: string;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfReportGroupTranslationRecord implements ISyncResultOfReportGroupTranslationRecord {
    added: ReportGroupTranslationRecord[];
    updated: ReportGroupTranslationRecord[];
    deleted: ReportGroupTranslationRecord[];

    constructor(data?: ISyncResultOfReportGroupTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(ReportGroupTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(ReportGroupTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(ReportGroupTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfReportGroupTranslationRecord {
        let result = new SyncResultOfReportGroupTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfReportGroupTranslationRecord {
    added: ReportGroupTranslationRecord[];
    updated: ReportGroupTranslationRecord[];
    deleted: ReportGroupTranslationRecord[];
}

export class ReportGroupTranslationRecord implements IReportGroupTranslationRecord {
    reportGroupId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IReportGroupTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reportGroupId = data["reportGroupId"];
            this.name = data["name"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReportGroupTranslationRecord {
        let result = new ReportGroupTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportGroupId"] = this.reportGroupId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReportGroupTranslationRecord {
    reportGroupId: number;
    name: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ClusterRecord implements IClusterRecord {
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IClusterRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.enableCoordinatore = data["enableCoordinatore"];
            this.enableCloudeFallback = data["enableCloudeFallback"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ClusterRecord {
        let result = new ClusterRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["enableCoordinatore"] = this.enableCoordinatore;
        data["enableCloudeFallback"] = this.enableCloudeFallback;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IClusterRecord {
    tenantId: number;
    storeId: number;
    enableCoordinatore: boolean;
    enableCloudeFallback: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ReceiptCustomizationRecord implements IReceiptCustomizationRecord {
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IReceiptCustomizationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.printerType = data["printerType"];
            this.taxNumber = data["taxNumber"];
            this.phoneNumber = data["phoneNumber"];
            this.sellerName = data["sellerName"];
            this.hideFreeModifiers = data["hideFreeModifiers"];
            this.hideAllModifiers = data["hideAllModifiers"];
            this.headerTextAr = data["headerTextAr"];
            this.headerTextEn = data["headerTextEn"];
            this.headerFontSize = data["headerFontSize"];
            this.headerFontFamily = data["headerFontFamily"];
            this.headerIsBold = data["headerIsBold"];
            this.bodyFontSize = data["bodyFontSize"];
            this.bodyFontFamily = data["bodyFontFamily"];
            this.bodyIsBold = data["bodyIsBold"];
            this.grandTotalFontSize = data["grandTotalFontSize"];
            this.grandTotalFontFamily = data["grandTotalFontFamily"];
            this.grandTotalIsBold = data["grandTotalIsBold"];
            this.grandTotalShowKitchen = data["grandTotalShowKitchen"];
            this.paymentFontSize = data["paymentFontSize"];
            this.paymentFontFamily = data["paymentFontFamily"];
            this.paymentIsBold = data["paymentIsBold"];
            this.paymentShowKitchen = data["paymentShowKitchen"];
            this.invoiceNumberFontSize = data["invoiceNumberFontSize"];
            this.invoiceNumberFontFamily = data["invoiceNumberFontFamily"];
            this.invoiceNumberIsBold = data["invoiceNumberIsBold"];
            this.priceFontSize = data["priceFontSize"];
            this.priceFontFamily = data["priceFontFamily"];
            this.priceIsBold = data["priceIsBold"];
            this.totalFontSize = data["totalFontSize"];
            this.totalFontFamily = data["totalFontFamily"];
            this.totalIsBold = data["totalIsBold"];
            this.footerTextAr = data["footerTextAr"];
            this.footerTextEn = data["footerTextEn"];
            this.footerFontSize = data["footerFontSize"];
            this.footerFontFamily = data["footerFontFamily"];
            this.footerIsBold = data["footerIsBold"];
            this.isActive = data["isActive"];
            this.logo = data["logo"];
            this.kitchenPrenterLanguage = data["kitchenPrenterLanguage"];
            this.kitchenPrintEnglishAndArabic = data["kitchenPrintEnglishAndArabic"];
            this.kitchenShowQRCode = data["kitchenShowQRCode"];
            this.kitchenShowLogo = data["kitchenShowLogo"];
            this.kitchenPrintingCount = data["kitchenPrintingCount"];
            this.cashierPrenterLanguage = data["cashierPrenterLanguage"];
            this.cashierPrintEnglishAndArabic = data["cashierPrintEnglishAndArabic"];
            this.cashierShowQRCode = data["cashierShowQRCode"];
            this.cashierSalePrintingCount = data["cashierSalePrintingCount"];
            this.cashierRefundPrintingCount = data["cashierRefundPrintingCount"];
            this.controlPrenterLanguage = data["controlPrenterLanguage"];
            this.controlPrintEnglishAndArabic = data["controlPrintEnglishAndArabic"];
            this.controlShowQRCode = data["controlShowQRCode"];
            this.controlPrintingCount = data["controlPrintingCount"];
            this.orderControlPrenterLanguage = data["orderControlPrenterLanguage"];
            this.orderControlShowQRCode = data["orderControlShowQRCode"];
            this.orderControlPrintingCount = data["orderControlPrintingCount"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReceiptCustomizationRecord {
        let result = new ReceiptCustomizationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["printerType"] = this.printerType;
        data["taxNumber"] = this.taxNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["sellerName"] = this.sellerName;
        data["hideFreeModifiers"] = this.hideFreeModifiers;
        data["hideAllModifiers"] = this.hideAllModifiers;
        data["headerTextAr"] = this.headerTextAr;
        data["headerTextEn"] = this.headerTextEn;
        data["headerFontSize"] = this.headerFontSize;
        data["headerFontFamily"] = this.headerFontFamily;
        data["headerIsBold"] = this.headerIsBold;
        data["bodyFontSize"] = this.bodyFontSize;
        data["bodyFontFamily"] = this.bodyFontFamily;
        data["bodyIsBold"] = this.bodyIsBold;
        data["grandTotalFontSize"] = this.grandTotalFontSize;
        data["grandTotalFontFamily"] = this.grandTotalFontFamily;
        data["grandTotalIsBold"] = this.grandTotalIsBold;
        data["grandTotalShowKitchen"] = this.grandTotalShowKitchen;
        data["paymentFontSize"] = this.paymentFontSize;
        data["paymentFontFamily"] = this.paymentFontFamily;
        data["paymentIsBold"] = this.paymentIsBold;
        data["paymentShowKitchen"] = this.paymentShowKitchen;
        data["invoiceNumberFontSize"] = this.invoiceNumberFontSize;
        data["invoiceNumberFontFamily"] = this.invoiceNumberFontFamily;
        data["invoiceNumberIsBold"] = this.invoiceNumberIsBold;
        data["priceFontSize"] = this.priceFontSize;
        data["priceFontFamily"] = this.priceFontFamily;
        data["priceIsBold"] = this.priceIsBold;
        data["totalFontSize"] = this.totalFontSize;
        data["totalFontFamily"] = this.totalFontFamily;
        data["totalIsBold"] = this.totalIsBold;
        data["footerTextAr"] = this.footerTextAr;
        data["footerTextEn"] = this.footerTextEn;
        data["footerFontSize"] = this.footerFontSize;
        data["footerFontFamily"] = this.footerFontFamily;
        data["footerIsBold"] = this.footerIsBold;
        data["isActive"] = this.isActive;
        data["logo"] = this.logo;
        data["kitchenPrenterLanguage"] = this.kitchenPrenterLanguage;
        data["kitchenPrintEnglishAndArabic"] = this.kitchenPrintEnglishAndArabic;
        data["kitchenShowQRCode"] = this.kitchenShowQRCode;
        data["kitchenShowLogo"] = this.kitchenShowLogo;
        data["kitchenPrintingCount"] = this.kitchenPrintingCount;
        data["cashierPrenterLanguage"] = this.cashierPrenterLanguage;
        data["cashierPrintEnglishAndArabic"] = this.cashierPrintEnglishAndArabic;
        data["cashierShowQRCode"] = this.cashierShowQRCode;
        data["cashierSalePrintingCount"] = this.cashierSalePrintingCount;
        data["cashierRefundPrintingCount"] = this.cashierRefundPrintingCount;
        data["controlPrenterLanguage"] = this.controlPrenterLanguage;
        data["controlPrintEnglishAndArabic"] = this.controlPrintEnglishAndArabic;
        data["controlShowQRCode"] = this.controlShowQRCode;
        data["controlPrintingCount"] = this.controlPrintingCount;
        data["orderControlPrenterLanguage"] = this.orderControlPrenterLanguage;
        data["orderControlShowQRCode"] = this.orderControlShowQRCode;
        data["orderControlPrintingCount"] = this.orderControlPrintingCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReceiptCustomizationRecord {
    tenantId: number;
    storeId: number;
    printerType: number;
    taxNumber: string;
    phoneNumber: string;
    sellerName: string;
    hideFreeModifiers: boolean;
    hideAllModifiers: boolean;
    headerTextAr: string;
    headerTextEn: string;
    headerFontSize: number;
    headerFontFamily: string;
    headerIsBold: boolean;
    bodyFontSize: number;
    bodyFontFamily: string;
    bodyIsBold: boolean;
    grandTotalFontSize: number;
    grandTotalFontFamily: string;
    grandTotalIsBold: boolean;
    grandTotalShowKitchen: boolean;
    paymentFontSize: number;
    paymentFontFamily: string;
    paymentIsBold: boolean;
    paymentShowKitchen: boolean;
    invoiceNumberFontSize: number;
    invoiceNumberFontFamily: string;
    invoiceNumberIsBold: boolean;
    priceFontSize: number;
    priceFontFamily: string;
    priceIsBold: boolean;
    totalFontSize: number;
    totalFontFamily: string;
    totalIsBold: boolean;
    footerTextAr: string;
    footerTextEn: string;
    footerFontSize: number;
    footerFontFamily: string;
    footerIsBold: boolean;
    isActive: boolean;
    logo: string;
    kitchenPrenterLanguage: number;
    kitchenPrintEnglishAndArabic: boolean;
    kitchenShowQRCode: boolean;
    kitchenShowLogo: boolean;
    kitchenPrintingCount: number;
    cashierPrenterLanguage: number;
    cashierPrintEnglishAndArabic: boolean;
    cashierShowQRCode: boolean;
    cashierSalePrintingCount: number;
    cashierRefundPrintingCount: number;
    controlPrenterLanguage: number;
    controlPrintEnglishAndArabic: boolean;
    controlShowQRCode: boolean;
    controlPrintingCount: number;
    orderControlPrenterLanguage: number;
    orderControlShowQRCode: boolean;
    orderControlPrintingCount: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfUpSalesMenuItemRecord implements ISyncResultOfUpSalesMenuItemRecord {
    added: UpSalesMenuItemRecord[];
    updated: UpSalesMenuItemRecord[];
    deleted: UpSalesMenuItemRecord[];

    constructor(data?: ISyncResultOfUpSalesMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(UpSalesMenuItemRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(UpSalesMenuItemRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(UpSalesMenuItemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfUpSalesMenuItemRecord {
        let result = new SyncResultOfUpSalesMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfUpSalesMenuItemRecord {
    added: UpSalesMenuItemRecord[];
    updated: UpSalesMenuItemRecord[];
    deleted: UpSalesMenuItemRecord[];
}

export class UpSalesMenuItemRecord implements IUpSalesMenuItemRecord {
    tenantId: number;
    menuItemId: number;
    detailsMenuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUpSalesMenuItemRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.detailsMenuItemId = data["detailsMenuItemId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpSalesMenuItemRecord {
        let result = new UpSalesMenuItemRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["detailsMenuItemId"] = this.detailsMenuItemId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpSalesMenuItemRecord {
    tenantId: number;
    menuItemId: number;
    detailsMenuItemId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfLevelRecord implements ISyncResultOfLevelRecord {
    added: LevelRecord[];
    updated: LevelRecord[];
    deleted: LevelRecord[];

    constructor(data?: ISyncResultOfLevelRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(LevelRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(LevelRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(LevelRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfLevelRecord {
        let result = new SyncResultOfLevelRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfLevelRecord {
    added: LevelRecord[];
    updated: LevelRecord[];
    deleted: LevelRecord[];
}

export class LevelRecord implements ILevelRecord {
    code: string;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ILevelRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LevelRecord {
        let result = new LevelRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILevelRecord {
    code: string;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfLevelTranslationRecord implements ISyncResultOfLevelTranslationRecord {
    added: LevelTranslationRecord[];
    updated: LevelTranslationRecord[];
    deleted: LevelTranslationRecord[];

    constructor(data?: ISyncResultOfLevelTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(LevelTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(LevelTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(LevelTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfLevelTranslationRecord {
        let result = new SyncResultOfLevelTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfLevelTranslationRecord {
    added: LevelTranslationRecord[];
    updated: LevelTranslationRecord[];
    deleted: LevelTranslationRecord[];
}

export class LevelTranslationRecord implements ILevelTranslationRecord {
    levelId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ILevelTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.levelId = data["levelId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LevelTranslationRecord {
        let result = new LevelTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelId"] = this.levelId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILevelTranslationRecord {
    levelId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDeliveryRecord implements ISyncResultOfDeliveryRecord {
    added: DeliveryRecord[];
    updated: DeliveryRecord[];
    deleted: DeliveryRecord[];

    constructor(data?: ISyncResultOfDeliveryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeliveryRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeliveryRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeliveryRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeliveryRecord {
        let result = new SyncResultOfDeliveryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeliveryRecord {
    added: DeliveryRecord[];
    updated: DeliveryRecord[];
    deleted: DeliveryRecord[];
}

export class DeliveryRecord implements IDeliveryRecord {
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryRecord {
        let result = new DeliveryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryRecord {
    code: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDeliveryTranslationRecord implements ISyncResultOfDeliveryTranslationRecord {
    added: DeliveryTranslationRecord[];
    updated: DeliveryTranslationRecord[];
    deleted: DeliveryTranslationRecord[];

    constructor(data?: ISyncResultOfDeliveryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeliveryTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeliveryTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeliveryTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeliveryTranslationRecord {
        let result = new SyncResultOfDeliveryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeliveryTranslationRecord {
    added: DeliveryTranslationRecord[];
    updated: DeliveryTranslationRecord[];
    deleted: DeliveryTranslationRecord[];
}

export class DeliveryTranslationRecord implements IDeliveryTranslationRecord {
    deliveryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveryId = data["deliveryId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryTranslationRecord {
        let result = new DeliveryTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryTranslationRecord {
    deliveryId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfCustomerSaleTypeRecord implements ISyncResultOfCustomerSaleTypeRecord {
    added: CustomerSaleTypeRecord[];
    updated: CustomerSaleTypeRecord[];
    deleted: CustomerSaleTypeRecord[];

    constructor(data?: ISyncResultOfCustomerSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CustomerSaleTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CustomerSaleTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CustomerSaleTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCustomerSaleTypeRecord {
        let result = new SyncResultOfCustomerSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCustomerSaleTypeRecord {
    added: CustomerSaleTypeRecord[];
    updated: CustomerSaleTypeRecord[];
    deleted: CustomerSaleTypeRecord[];
}

export class CustomerSaleTypeRecord implements ICustomerSaleTypeRecord {
    customerId: string;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ICustomerSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.saleTypeId = data["saleTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomerSaleTypeRecord {
        let result = new CustomerSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["saleTypeId"] = this.saleTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomerSaleTypeRecord {
    customerId: string;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SyncResultOfCustomerAddressRecord implements ISyncResultOfCustomerAddressRecord {
    added: CustomerAddressRecord[];
    updated: CustomerAddressRecord[];
    deleted: CustomerAddressRecord[];

    constructor(data?: ISyncResultOfCustomerAddressRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(CustomerAddressRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(CustomerAddressRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(CustomerAddressRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfCustomerAddressRecord {
        let result = new SyncResultOfCustomerAddressRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfCustomerAddressRecord {
    added: CustomerAddressRecord[];
    updated: CustomerAddressRecord[];
    deleted: CustomerAddressRecord[];
}

export class CustomerAddressRecord implements ICustomerAddressRecord {
    isSync: boolean;
    address: string;
    link: string;
    deliveryZoneId: number;
    deliveryStreetId: number;
    city: string;
    tenantId: number;
    customerId: string;
    isSelected: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICustomerAddressRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSync = data["isSync"];
            this.address = data["address"];
            this.link = data["link"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.city = data["city"];
            this.tenantId = data["tenantId"];
            this.customerId = data["customerId"];
            this.isSelected = data["isSelected"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomerAddressRecord {
        let result = new CustomerAddressRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSync"] = this.isSync;
        data["address"] = this.address;
        data["link"] = this.link;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["city"] = this.city;
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["isSelected"] = this.isSelected;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomerAddressRecord {
    isSync: boolean;
    address: string;
    link: string;
    deliveryZoneId: number;
    deliveryStreetId: number;
    city: string;
    tenantId: number;
    customerId: string;
    isSelected: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDaysWorkingHourRecord implements ISyncResultOfDaysWorkingHourRecord {
    added: DaysWorkingHourRecord[];
    updated: DaysWorkingHourRecord[];
    deleted: DaysWorkingHourRecord[];

    constructor(data?: ISyncResultOfDaysWorkingHourRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DaysWorkingHourRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DaysWorkingHourRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DaysWorkingHourRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDaysWorkingHourRecord {
        let result = new SyncResultOfDaysWorkingHourRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDaysWorkingHourRecord {
    added: DaysWorkingHourRecord[];
    updated: DaysWorkingHourRecord[];
    deleted: DaysWorkingHourRecord[];
}

export class DaysWorkingHourRecord implements IDaysWorkingHourRecord {
    dayOfWeek: DaysWorkingHourRecordDayOfWeek;
    workingHoursStart: string;
    workingHoursEnd: string;
    storeWorkingHoursRuleId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDaysWorkingHourRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dayOfWeek = data["dayOfWeek"];
            this.workingHoursStart = data["workingHoursStart"];
            this.workingHoursEnd = data["workingHoursEnd"];
            this.storeWorkingHoursRuleId = data["storeWorkingHoursRuleId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DaysWorkingHourRecord {
        let result = new DaysWorkingHourRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["workingHoursStart"] = this.workingHoursStart;
        data["workingHoursEnd"] = this.workingHoursEnd;
        data["storeWorkingHoursRuleId"] = this.storeWorkingHoursRuleId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDaysWorkingHourRecord {
    dayOfWeek: DaysWorkingHourRecordDayOfWeek;
    workingHoursStart: string;
    workingHoursEnd: string;
    storeWorkingHoursRuleId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfTenderTypeSaleTypeRecord implements ISyncResultOfTenderTypeSaleTypeRecord {
    added: TenderTypeSaleTypeRecord[];
    updated: TenderTypeSaleTypeRecord[];
    deleted: TenderTypeSaleTypeRecord[];

    constructor(data?: ISyncResultOfTenderTypeSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(TenderTypeSaleTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(TenderTypeSaleTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(TenderTypeSaleTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfTenderTypeSaleTypeRecord {
        let result = new SyncResultOfTenderTypeSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfTenderTypeSaleTypeRecord {
    added: TenderTypeSaleTypeRecord[];
    updated: TenderTypeSaleTypeRecord[];
    deleted: TenderTypeSaleTypeRecord[];
}

export class TenderTypeSaleTypeRecord implements ITenderTypeSaleTypeRecord {
    tenderTypeId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ITenderTypeSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenderTypeId = data["tenderTypeId"];
            this.saleTypeId = data["saleTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeSaleTypeRecord {
        let result = new TenderTypeSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenderTypeId"] = this.tenderTypeId;
        data["saleTypeId"] = this.saleTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeSaleTypeRecord {
    tenderTypeId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class CustomProductRecord implements ICustomProductRecord {
    id: number;
    unitOfMeasureId: number;
    variantId: number;
    productCode: string;
    productName: string;
    productNameSec: string;
    productPrice: number;
    creationTime: moment.Moment;

    constructor(data?: ICustomProductRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.variantId = data["variantId"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productNameSec = data["productNameSec"];
            this.productPrice = data["productPrice"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomProductRecord {
        let result = new CustomProductRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["variantId"] = this.variantId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productNameSec"] = this.productNameSec;
        data["productPrice"] = this.productPrice;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICustomProductRecord {
    id: number;
    unitOfMeasureId: number;
    variantId: number;
    productCode: string;
    productName: string;
    productNameSec: string;
    productPrice: number;
    creationTime: moment.Moment;
}

export class CustomProductTaxRecord implements ICustomProductTaxRecord {
    productId: number;
    taxId: number;
    taxCreationTime: moment.Moment;
    productTaxCreationTime: moment.Moment;
    value: number;

    constructor(data?: ICustomProductTaxRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.taxId = data["taxId"];
            this.taxCreationTime = data["taxCreationTime"] ? moment(data["taxCreationTime"].toString()) : <any>undefined;
            this.productTaxCreationTime = data["productTaxCreationTime"] ? moment(data["productTaxCreationTime"].toString()) : <any>undefined;
            this.value = data["value"];
        }
    }

    static fromJS(data: any): CustomProductTaxRecord {
        let result = new CustomProductTaxRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["taxId"] = this.taxId;
        data["taxCreationTime"] = this.taxCreationTime ? this.taxCreationTime.toISOString() : <any>undefined;
        data["productTaxCreationTime"] = this.productTaxCreationTime ? this.productTaxCreationTime.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data; 
    }
}

export interface ICustomProductTaxRecord {
    productId: number;
    taxId: number;
    taxCreationTime: moment.Moment;
    productTaxCreationTime: moment.Moment;
    value: number;
}

export class SyncResultOfPriceListRecord implements ISyncResultOfPriceListRecord {
    added: PriceListRecord[];
    updated: PriceListRecord[];
    deleted: PriceListRecord[];

    constructor(data?: ISyncResultOfPriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PriceListRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PriceListRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PriceListRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPriceListRecord {
        let result = new SyncResultOfPriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPriceListRecord {
    added: PriceListRecord[];
    updated: PriceListRecord[];
    deleted: PriceListRecord[];
}

export class PriceListRecord implements IPriceListRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPriceListRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PriceListRecord {
        let result = new PriceListRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPriceListRecord {
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfPriceListTranslationRecord implements ISyncResultOfPriceListTranslationRecord {
    added: PriceListTranslationRecord[];
    updated: PriceListTranslationRecord[];
    deleted: PriceListTranslationRecord[];

    constructor(data?: ISyncResultOfPriceListTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(PriceListTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(PriceListTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(PriceListTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfPriceListTranslationRecord {
        let result = new SyncResultOfPriceListTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfPriceListTranslationRecord {
    added: PriceListTranslationRecord[];
    updated: PriceListTranslationRecord[];
    deleted: PriceListTranslationRecord[];
}

export class PriceListTranslationRecord implements IPriceListTranslationRecord {
    priceListId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPriceListTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priceListId = data["priceListId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PriceListTranslationRecord {
        let result = new PriceListTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceListId"] = this.priceListId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPriceListTranslationRecord {
    priceListId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfSaleTypeRecord implements ISyncResultOfSaleTypeRecord {
    added: SaleTypeRecord[];
    updated: SaleTypeRecord[];
    deleted: SaleTypeRecord[];

    constructor(data?: ISyncResultOfSaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SaleTypeRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SaleTypeRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SaleTypeRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSaleTypeRecord {
        let result = new SyncResultOfSaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSaleTypeRecord {
    added: SaleTypeRecord[];
    updated: SaleTypeRecord[];
    deleted: SaleTypeRecord[];
}

export class SaleTypeRecord implements ISaleTypeRecord {
    saleNatural: SaleTypeRecordSaleNatural;
    hasRoles: boolean;
    tenantId: number;
    isB2B: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleNatural = data["saleNatural"];
            this.hasRoles = data["hasRoles"];
            this.tenantId = data["tenantId"];
            this.isB2B = data["isB2B"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeRecord {
        let result = new SaleTypeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleNatural"] = this.saleNatural;
        data["hasRoles"] = this.hasRoles;
        data["tenantId"] = this.tenantId;
        data["isB2B"] = this.isB2B;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeRecord {
    saleNatural: SaleTypeRecordSaleNatural;
    hasRoles: boolean;
    tenantId: number;
    isB2B: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfSaleTypeTranslationRecord implements ISyncResultOfSaleTypeTranslationRecord {
    added: SaleTypeTranslationRecord[];
    updated: SaleTypeTranslationRecord[];
    deleted: SaleTypeTranslationRecord[];

    constructor(data?: ISyncResultOfSaleTypeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(SaleTypeTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(SaleTypeTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(SaleTypeTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfSaleTypeTranslationRecord {
        let result = new SyncResultOfSaleTypeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfSaleTypeTranslationRecord {
    added: SaleTypeTranslationRecord[];
    updated: SaleTypeTranslationRecord[];
    deleted: SaleTypeTranslationRecord[];
}

export class SaleTypeTranslationRecord implements ISaleTypeTranslationRecord {
    saleTypeId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTypeId = data["saleTypeId"];
            this.name = data["name"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeTranslationRecord {
        let result = new SaleTypeTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTypeId"] = this.saleTypeId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeTranslationRecord {
    saleTypeId: number;
    name: string;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDeliveryZoneRecord implements ISyncResultOfDeliveryZoneRecord {
    added: DeliveryZoneRecord[];
    updated: DeliveryZoneRecord[];
    deleted: DeliveryZoneRecord[];

    constructor(data?: ISyncResultOfDeliveryZoneRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeliveryZoneRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeliveryZoneRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeliveryZoneRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeliveryZoneRecord {
        let result = new SyncResultOfDeliveryZoneRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeliveryZoneRecord {
    added: DeliveryZoneRecord[];
    updated: DeliveryZoneRecord[];
    deleted: DeliveryZoneRecord[];
}

export class DeliveryZoneRecord implements IDeliveryZoneRecord {
    isSync: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryZoneRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSync = data["isSync"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryZoneRecord {
        let result = new DeliveryZoneRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSync"] = this.isSync;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryZoneRecord {
    isSync: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDeliveryZoneTranslationRecord implements ISyncResultOfDeliveryZoneTranslationRecord {
    added: DeliveryZoneTranslationRecord[];
    updated: DeliveryZoneTranslationRecord[];
    deleted: DeliveryZoneTranslationRecord[];

    constructor(data?: ISyncResultOfDeliveryZoneTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeliveryZoneTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeliveryZoneTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeliveryZoneTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeliveryZoneTranslationRecord {
        let result = new SyncResultOfDeliveryZoneTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeliveryZoneTranslationRecord {
    added: DeliveryZoneTranslationRecord[];
    updated: DeliveryZoneTranslationRecord[];
    deleted: DeliveryZoneTranslationRecord[];
}

export class DeliveryZoneTranslationRecord implements IDeliveryZoneTranslationRecord {
    isSync: boolean;
    name: string;
    deliveryZoneID: number;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryZoneTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSync = data["isSync"];
            this.name = data["name"];
            this.deliveryZoneID = data["deliveryZoneID"];
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryZoneTranslationRecord {
        let result = new DeliveryZoneTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSync"] = this.isSync;
        data["name"] = this.name;
        data["deliveryZoneID"] = this.deliveryZoneID;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryZoneTranslationRecord {
    isSync: boolean;
    name: string;
    deliveryZoneID: number;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfDeliveryStreetRecord implements ISyncResultOfDeliveryStreetRecord {
    added: DeliveryStreetRecord[];
    updated: DeliveryStreetRecord[];
    deleted: DeliveryStreetRecord[];

    constructor(data?: ISyncResultOfDeliveryStreetRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(DeliveryStreetRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(DeliveryStreetRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(DeliveryStreetRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfDeliveryStreetRecord {
        let result = new SyncResultOfDeliveryStreetRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfDeliveryStreetRecord {
    added: DeliveryStreetRecord[];
    updated: DeliveryStreetRecord[];
    deleted: DeliveryStreetRecord[];
}

export class DeliveryStreetRecord implements IDeliveryStreetRecord {
    isSync: boolean;
    deliveryZoneId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryStreetRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSync = data["isSync"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryStreetRecord {
        let result = new DeliveryStreetRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSync"] = this.isSync;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryStreetRecord {
    isSync: boolean;
    deliveryZoneId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfHappyHourRecord implements ISyncResultOfHappyHourRecord {
    added: HappyHourRecord[];
    updated: HappyHourRecord[];
    deleted: HappyHourRecord[];

    constructor(data?: ISyncResultOfHappyHourRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(HappyHourRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(HappyHourRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(HappyHourRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfHappyHourRecord {
        let result = new SyncResultOfHappyHourRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfHappyHourRecord {
    added: HappyHourRecord[];
    updated: HappyHourRecord[];
    deleted: HappyHourRecord[];
}

export class HappyHourRecord implements IHappyHourRecord {
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    tenantId: number;
    typeId: number;
    typeName: string;
    discountTypeFlag: boolean;
    discountValue: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IHappyHourRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            this.tenantId = data["tenantId"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.discountTypeFlag = data["discountTypeFlag"];
            this.discountValue = data["discountValue"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HappyHourRecord {
        let result = new HappyHourRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["tenantId"] = this.tenantId;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["discountTypeFlag"] = this.discountTypeFlag;
        data["discountValue"] = this.discountValue;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHappyHourRecord {
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    tenantId: number;
    typeId: number;
    typeName: string;
    discountTypeFlag: boolean;
    discountValue: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfHappyHourTranslationRecord implements ISyncResultOfHappyHourTranslationRecord {
    added: HappyHourTranslationRecord[];
    updated: HappyHourTranslationRecord[];
    deleted: HappyHourTranslationRecord[];

    constructor(data?: ISyncResultOfHappyHourTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(HappyHourTranslationRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(HappyHourTranslationRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(HappyHourTranslationRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfHappyHourTranslationRecord {
        let result = new SyncResultOfHappyHourTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfHappyHourTranslationRecord {
    added: HappyHourTranslationRecord[];
    updated: HappyHourTranslationRecord[];
    deleted: HappyHourTranslationRecord[];
}

export class HappyHourTranslationRecord implements IHappyHourTranslationRecord {
    name: string;
    happyHourId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IHappyHourTranslationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.happyHourId = data["happyHourId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HappyHourTranslationRecord {
        let result = new HappyHourTranslationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["happyHourId"] = this.happyHourId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHappyHourTranslationRecord {
    name: string;
    happyHourId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SyncResultOfStoreHappyHoursRecord implements ISyncResultOfStoreHappyHoursRecord {
    added: StoreHappyHoursRecord[];
    updated: StoreHappyHoursRecord[];
    deleted: StoreHappyHoursRecord[];

    constructor(data?: ISyncResultOfStoreHappyHoursRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["added"] && data["added"].constructor === Array) {
                this.added = [];
                for (let item of data["added"])
                    this.added.push(StoreHappyHoursRecord.fromJS(item));
            }
            if (data["updated"] && data["updated"].constructor === Array) {
                this.updated = [];
                for (let item of data["updated"])
                    this.updated.push(StoreHappyHoursRecord.fromJS(item));
            }
            if (data["deleted"] && data["deleted"].constructor === Array) {
                this.deleted = [];
                for (let item of data["deleted"])
                    this.deleted.push(StoreHappyHoursRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncResultOfStoreHappyHoursRecord {
        let result = new SyncResultOfStoreHappyHoursRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.added && this.added.constructor === Array) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item.toJSON());
        }
        if (this.updated && this.updated.constructor === Array) {
            data["updated"] = [];
            for (let item of this.updated)
                data["updated"].push(item.toJSON());
        }
        if (this.deleted && this.deleted.constructor === Array) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncResultOfStoreHappyHoursRecord {
    added: StoreHappyHoursRecord[];
    updated: StoreHappyHoursRecord[];
    deleted: StoreHappyHoursRecord[];
}

export class StoreHappyHoursRecord implements IStoreHappyHoursRecord {
    tenantId: number;
    happyHourId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreHappyHoursRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.happyHourId = data["happyHourId"];
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreHappyHoursRecord {
        let result = new StoreHappyHoursRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["happyHourId"] = this.happyHourId;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreHappyHoursRecord {
    tenantId: number;
    happyHourId: number;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TableDTO implements ITableDTO {
    id: number;
    numberOfSeats: number;
    cornerId: number;
    storeIds: number[];
    tableNumber: string;
    code: string;

    constructor(data?: ITableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.numberOfSeats = data["numberOfSeats"];
            this.cornerId = data["cornerId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.tableNumber = data["tableNumber"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): TableDTO {
        let result = new TableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberOfSeats"] = this.numberOfSeats;
        data["cornerId"] = this.cornerId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["tableNumber"] = this.tableNumber;
        data["code"] = this.code;
        return data; 
    }
}

export interface ITableDTO {
    id: number;
    numberOfSeats: number;
    cornerId: number;
    storeIds: number[];
    tableNumber: string;
    code: string;
}

export class ListResultDtoOfTableDTO implements IListResultDtoOfTableDTO {
    items: TableDTO[];

    constructor(data?: IListResultDtoOfTableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TableDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTableDTO {
        let result = new ListResultDtoOfTableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTableDTO {
    items: TableDTO[];
}

export class PagedTableList implements IPagedTableList {
    currentPage: number;
    itemsCount: number;
    tables: TableDTO[];

    constructor(data?: IPagedTableList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["tables"] && data["tables"].constructor === Array) {
                this.tables = [];
                for (let item of data["tables"])
                    this.tables.push(TableDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedTableList {
        let result = new PagedTableList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.tables && this.tables.constructor === Array) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedTableList {
    currentPage: number;
    itemsCount: number;
    tables: TableDTO[];
}

export class CreateTableInput implements ICreateTableInput {
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    storeIds: number[];
    code: string;

    constructor(data?: ICreateTableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableNumber = data["tableNumber"];
            this.numberOfSeats = data["numberOfSeats"];
            this.cornerId = data["cornerId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.code = data["code"];
        }
    }

    static fromJS(data: any): CreateTableInput {
        let result = new CreateTableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableNumber"] = this.tableNumber;
        data["numberOfSeats"] = this.numberOfSeats;
        data["cornerId"] = this.cornerId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["code"] = this.code;
        return data; 
    }
}

export interface ICreateTableInput {
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    storeIds: number[];
    code: string;
}

export class EditTableInput implements IEditTableInput {
    id: number;
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    storeIds: number[];
    code: string;

    constructor(data?: IEditTableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tableNumber = data["tableNumber"];
            this.numberOfSeats = data["numberOfSeats"];
            this.cornerId = data["cornerId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.code = data["code"];
        }
    }

    static fromJS(data: any): EditTableInput {
        let result = new EditTableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tableNumber"] = this.tableNumber;
        data["numberOfSeats"] = this.numberOfSeats;
        data["cornerId"] = this.cornerId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["code"] = this.code;
        return data; 
    }
}

export interface IEditTableInput {
    id: number;
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    storeIds: number[];
    code: string;
}

export class TaxDto implements ITaxDto {
    code: string;
    value: number;
    isVAT: boolean;
    translations: TaxTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.value = data["value"];
            this.isVAT = data["isVAT"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TaxTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaxDto {
        let result = new TaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        data["isVAT"] = this.isVAT;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITaxDto {
    code: string;
    value: number;
    isVAT: boolean;
    translations: TaxTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TaxTranslationDto implements ITaxTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ITaxTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): TaxTranslationDto {
        let result = new TaxTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ITaxTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfTaxListItem implements IListResultDtoOfTaxListItem {
    items: TaxListItem[];

    constructor(data?: IListResultDtoOfTaxListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TaxListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTaxListItem {
        let result = new ListResultDtoOfTaxListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTaxListItem {
    items: TaxListItem[];
}

export class TaxListItem implements ITaxListItem {
    id: number;
    isVAT: boolean;
    value: number;
    name: string;
    code: string;

    constructor(data?: ITaxListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isVAT = data["isVAT"];
            this.value = data["value"];
            this.name = data["name"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): TaxListItem {
        let result = new TaxListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isVAT"] = this.isVAT;
        data["value"] = this.value;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface ITaxListItem {
    id: number;
    isVAT: boolean;
    value: number;
    name: string;
    code: string;
}

export class CreateTaxInput implements ICreateTaxInput {
    code: string;
    value: number;
    isVAT: boolean;
    translations: TaxTranslationDto[];

    constructor(data?: ICreateTaxInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.value = data["value"];
            this.isVAT = data["isVAT"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TaxTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTaxInput {
        let result = new CreateTaxInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        data["isVAT"] = this.isVAT;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateTaxInput {
    code: string;
    value: number;
    isVAT: boolean;
    translations: TaxTranslationDto[];
}

export class UpdateTaxInput implements IUpdateTaxInput {
    id: number;
    code: string;
    value: number;
    isVAT: boolean;
    translations: TaxTranslationDto[];

    constructor(data?: IUpdateTaxInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.value = data["value"];
            this.isVAT = data["isVAT"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TaxTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTaxInput {
        let result = new UpdateTaxInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["value"] = this.value;
        data["isVAT"] = this.isVAT;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTaxInput {
    id: number;
    code: string;
    value: number;
    isVAT: boolean;
    translations: TaxTranslationDto[];
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[];

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[];
}

export class TenantListDto implements ITenantListDto {
    tenancyName: string;
    name: string;
    editionDisplayName: string;
    connectionString: string;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment;
    editionId: number;
    isInTrialPeriod: boolean;
    adminUserId: number;
    isParent: boolean;
    isStoreGroup: boolean;
    id: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.adminUserId = data["adminUserId"];
            this.isParent = data["isParent"];
            this.isStoreGroup = data["isStoreGroup"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["adminUserId"] = this.adminUserId;
        data["isParent"] = this.isParent;
        data["isStoreGroup"] = this.isStoreGroup;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantListDto {
    tenancyName: string;
    name: string;
    editionDisplayName: string;
    connectionString: string;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment;
    editionId: number;
    isInTrialPeriod: boolean;
    adminUserId: number;
    isParent: boolean;
    isStoreGroup: boolean;
    id: number;
}

export class ParentChildTenantListDto implements IParentChildTenantListDto {
    isParent: boolean;
    items: TenantListDto[];

    constructor(data?: IParentChildTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isParent = data["isParent"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParentChildTenantListDto {
        let result = new ParentChildTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isParent"] = this.isParent;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IParentChildTenantListDto {
    isParent: boolean;
    items: TenantListDto[];
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number;
    isActive: boolean;
    isStoreGroup: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    storeLimit: number;
    terminalLimit: number;
    tenantParentId: number;
    isParent: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.isStoreGroup = data["isStoreGroup"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.storeLimit = data["storeLimit"];
            this.terminalLimit = data["terminalLimit"];
            this.tenantParentId = data["tenantParentId"];
            this.isParent = data["isParent"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["isStoreGroup"] = this.isStoreGroup;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["storeLimit"] = this.storeLimit;
        data["terminalLimit"] = this.terminalLimit;
        data["tenantParentId"] = this.tenantParentId;
        data["isParent"] = this.isParent;
        return data; 
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number;
    isActive: boolean;
    isStoreGroup: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    storeLimit: number;
    terminalLimit: number;
    tenantParentId: number;
    isParent: boolean;
}

export class EntityDto implements IEntityDto {
    id: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDto {
    id: number;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    storeLimit: number;
    terminalLimit: number;
    tenantParentId: number;
    isParent: boolean;
    id: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.storeLimit = data["storeLimit"];
            this.terminalLimit = data["terminalLimit"];
            this.tenantParentId = data["tenantParentId"];
            this.isParent = data["isParent"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["storeLimit"] = this.storeLimit;
        data["terminalLimit"] = this.terminalLimit;
        data["tenantParentId"] = this.tenantParentId;
        data["isParent"] = this.isParent;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    storeLimit: number;
    terminalLimit: number;
    tenantParentId: number;
    isParent: boolean;
    id: number;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[] = [];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class ConnectionStringResponse implements IConnectionStringResponse {
    connectionString: string;

    constructor(data?: IConnectionStringResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
        }
    }

    static fromJS(data: any): ConnectionStringResponse {
        let result = new ConnectionStringResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        return data; 
    }
}

export interface IConnectionStringResponse {
    connectionString: string;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];
}

export class UpdateTenantPermissionsInput implements IUpdateTenantPermissionsInput {
    id: number;
    grantedPermissionNames: string[] = [];

    constructor(data?: IUpdateTenantPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTenantPermissionsInput {
        let result = new UpdateTenantPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateTenantPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class TenantInfoDto implements ITenantInfoDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    storeLimit: number;
    terminalLimit: number;
    tenantParentId: number;
    isParent: boolean;
    isStoreGroup: boolean;
    childrenTenants: TenantInfoDto[];
    id: number;

    constructor(data?: ITenantInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.storeLimit = data["storeLimit"];
            this.terminalLimit = data["terminalLimit"];
            this.tenantParentId = data["tenantParentId"];
            this.isParent = data["isParent"];
            this.isStoreGroup = data["isStoreGroup"];
            if (data["childrenTenants"] && data["childrenTenants"].constructor === Array) {
                this.childrenTenants = [];
                for (let item of data["childrenTenants"])
                    this.childrenTenants.push(TenantInfoDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantInfoDto {
        let result = new TenantInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["storeLimit"] = this.storeLimit;
        data["terminalLimit"] = this.terminalLimit;
        data["tenantParentId"] = this.tenantParentId;
        data["isParent"] = this.isParent;
        data["isStoreGroup"] = this.isStoreGroup;
        if (this.childrenTenants && this.childrenTenants.constructor === Array) {
            data["childrenTenants"] = [];
            for (let item of this.childrenTenants)
                data["childrenTenants"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantInfoDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    storeLimit: number;
    terminalLimit: number;
    tenantParentId: number;
    isParent: boolean;
    isStoreGroup: boolean;
    childrenTenants: TenantInfoDto[];
    id: number;
}

export class DetailedSummaryDto implements IDetailedSummaryDto {
    totalPurchase: number;
    totalSales: number;
    purchasedue: number;
    invoiceDue: number;
    currency: string;

    constructor(data?: IDetailedSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPurchase = data["totalPurchase"];
            this.totalSales = data["totalSales"];
            this.purchasedue = data["purchasedue"];
            this.invoiceDue = data["invoiceDue"];
            this.currency = data["currency"];
        }
    }

    static fromJS(data: any): DetailedSummaryDto {
        let result = new DetailedSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPurchase"] = this.totalPurchase;
        data["totalSales"] = this.totalSales;
        data["purchasedue"] = this.purchasedue;
        data["invoiceDue"] = this.invoiceDue;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IDetailedSummaryDto {
    totalPurchase: number;
    totalSales: number;
    purchasedue: number;
    invoiceDue: number;
    currency: string;
}

export class YearlyPurchaseAndsalesDto implements IYearlyPurchaseAndsalesDto {
    months: string[];
    sales: number[];
    purchase: number[];
    expenses: number[];

    constructor(data?: IYearlyPurchaseAndsalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["months"] && data["months"].constructor === Array) {
                this.months = [];
                for (let item of data["months"])
                    this.months.push(item);
            }
            if (data["sales"] && data["sales"].constructor === Array) {
                this.sales = [];
                for (let item of data["sales"])
                    this.sales.push(item);
            }
            if (data["purchase"] && data["purchase"].constructor === Array) {
                this.purchase = [];
                for (let item of data["purchase"])
                    this.purchase.push(item);
            }
            if (data["expenses"] && data["expenses"].constructor === Array) {
                this.expenses = [];
                for (let item of data["expenses"])
                    this.expenses.push(item);
            }
        }
    }

    static fromJS(data: any): YearlyPurchaseAndsalesDto {
        let result = new YearlyPurchaseAndsalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.months && this.months.constructor === Array) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        if (this.sales && this.sales.constructor === Array) {
            data["sales"] = [];
            for (let item of this.sales)
                data["sales"].push(item);
        }
        if (this.purchase && this.purchase.constructor === Array) {
            data["purchase"] = [];
            for (let item of this.purchase)
                data["purchase"].push(item);
        }
        if (this.expenses && this.expenses.constructor === Array) {
            data["expenses"] = [];
            for (let item of this.expenses)
                data["expenses"].push(item);
        }
        return data; 
    }
}

export interface IYearlyPurchaseAndsalesDto {
    months: string[];
    sales: number[];
    purchase: number[];
    expenses: number[];
}

export class ProductsSummaryDto implements IProductsSummaryDto {
    instock: number;
    outstock: number;
    totalProducts: number;

    constructor(data?: IProductsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.instock = data["instock"];
            this.outstock = data["outstock"];
            this.totalProducts = data["totalProducts"];
        }
    }

    static fromJS(data: any): ProductsSummaryDto {
        let result = new ProductsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instock"] = this.instock;
        data["outstock"] = this.outstock;
        data["totalProducts"] = this.totalProducts;
        return data; 
    }
}

export interface IProductsSummaryDto {
    instock: number;
    outstock: number;
    totalProducts: number;
}

export class DailySalesDto implements IDailySalesDto {
    labels: string[];
    sales: number[];

    constructor(data?: IDailySalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["labels"] && data["labels"].constructor === Array) {
                this.labels = [];
                for (let item of data["labels"])
                    this.labels.push(item);
            }
            if (data["sales"] && data["sales"].constructor === Array) {
                this.sales = [];
                for (let item of data["sales"])
                    this.sales.push(item);
            }
        }
    }

    static fromJS(data: any): DailySalesDto {
        let result = new DailySalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.labels && this.labels.constructor === Array) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        if (this.sales && this.sales.constructor === Array) {
            data["sales"] = [];
            for (let item of this.sales)
                data["sales"].push(item);
        }
        return data; 
    }
}

export interface IDailySalesDto {
    labels: string[];
    sales: number[];
}

export class PieChartSummaryDto implements IPieChartSummaryDto {
    sales: number;
    profitSales: number;
    purchases: number;
    expenses: number;
    date: string;

    constructor(data?: IPieChartSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sales = data["sales"];
            this.profitSales = data["profitSales"];
            this.purchases = data["purchases"];
            this.expenses = data["expenses"];
            this.date = data["date"];
        }
    }

    static fromJS(data: any): PieChartSummaryDto {
        let result = new PieChartSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sales"] = this.sales;
        data["profitSales"] = this.profitSales;
        data["purchases"] = this.purchases;
        data["expenses"] = this.expenses;
        data["date"] = this.date;
        return data; 
    }
}

export interface IPieChartSummaryDto {
    sales: number;
    profitSales: number;
    purchases: number;
    expenses: number;
    date: string;
}

export class TopSellingProductsDto implements ITopSellingProductsDto {
    topYearSellingProducts: TopSellingProducts[];
    topMonthsellingProduts: TopSellingProducts[];
    top5TrendingProducts: TopSellingProducts[];
    year: string;
    month: string;

    constructor(data?: ITopSellingProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["topYearSellingProducts"] && data["topYearSellingProducts"].constructor === Array) {
                this.topYearSellingProducts = [];
                for (let item of data["topYearSellingProducts"])
                    this.topYearSellingProducts.push(TopSellingProducts.fromJS(item));
            }
            if (data["topMonthsellingProduts"] && data["topMonthsellingProduts"].constructor === Array) {
                this.topMonthsellingProduts = [];
                for (let item of data["topMonthsellingProduts"])
                    this.topMonthsellingProduts.push(TopSellingProducts.fromJS(item));
            }
            if (data["top5TrendingProducts"] && data["top5TrendingProducts"].constructor === Array) {
                this.top5TrendingProducts = [];
                for (let item of data["top5TrendingProducts"])
                    this.top5TrendingProducts.push(TopSellingProducts.fromJS(item));
            }
            this.year = data["year"];
            this.month = data["month"];
        }
    }

    static fromJS(data: any): TopSellingProductsDto {
        let result = new TopSellingProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.topYearSellingProducts && this.topYearSellingProducts.constructor === Array) {
            data["topYearSellingProducts"] = [];
            for (let item of this.topYearSellingProducts)
                data["topYearSellingProducts"].push(item.toJSON());
        }
        if (this.topMonthsellingProduts && this.topMonthsellingProduts.constructor === Array) {
            data["topMonthsellingProduts"] = [];
            for (let item of this.topMonthsellingProduts)
                data["topMonthsellingProduts"].push(item.toJSON());
        }
        if (this.top5TrendingProducts && this.top5TrendingProducts.constructor === Array) {
            data["top5TrendingProducts"] = [];
            for (let item of this.top5TrendingProducts)
                data["top5TrendingProducts"].push(item.toJSON());
        }
        data["year"] = this.year;
        data["month"] = this.month;
        return data; 
    }
}

export interface ITopSellingProductsDto {
    topYearSellingProducts: TopSellingProducts[];
    topMonthsellingProduts: TopSellingProducts[];
    top5TrendingProducts: TopSellingProducts[];
    year: string;
    month: string;
}

export class TopSellingProducts implements ITopSellingProducts {
    name: string;
    quantity: number;

    constructor(data?: ITopSellingProducts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): TopSellingProducts {
        let result = new TopSellingProducts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        return data; 
    }
}

export interface ITopSellingProducts {
    name: string;
    quantity: number;
}

export class StoreExpiry implements IStoreExpiry {
    name: string;
    remainingQuantity: number;
    expiryDate: string;
    measure: string;
    store: string;

    constructor(data?: IStoreExpiry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.remainingQuantity = data["remainingQuantity"];
            this.expiryDate = data["expiryDate"];
            this.measure = data["measure"];
            this.store = data["store"];
        }
    }

    static fromJS(data: any): StoreExpiry {
        let result = new StoreExpiry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["remainingQuantity"] = this.remainingQuantity;
        data["expiryDate"] = this.expiryDate;
        data["measure"] = this.measure;
        data["store"] = this.store;
        return data; 
    }
}

export interface IStoreExpiry {
    name: string;
    remainingQuantity: number;
    expiryDate: string;
    measure: string;
    store: string;
}

export class ProductCategories implements IProductCategories {
    categoryName: string;
    productsCount: number;
    stockQuantity: number;
    worthSales: number;
    worthStock: number;

    constructor(data?: IProductCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryName = data["categoryName"];
            this.productsCount = data["productsCount"];
            this.stockQuantity = data["stockQuantity"];
            this.worthSales = data["worthSales"];
            this.worthStock = data["worthStock"];
        }
    }

    static fromJS(data: any): ProductCategories {
        let result = new ProductCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["productsCount"] = this.productsCount;
        data["stockQuantity"] = this.stockQuantity;
        data["worthSales"] = this.worthSales;
        data["worthStock"] = this.worthStock;
        return data; 
    }
}

export interface IProductCategories {
    categoryName: string;
    productsCount: number;
    stockQuantity: number;
    worthSales: number;
    worthStock: number;
}

export class DashboardAnalyticsOutput implements IDashboardAnalyticsOutput {
    currency: string;
    totalSales: number;
    totalCost: number;
    netProfit: number;
    grossMargin: number;
    transactions: number;
    averageOrderValue: number;
    totalDiscount: number;
    totalRefunds: number;
    prevTotalSales: number;
    prevTotalCost: number;
    prevNetProfit: number;
    prevTransactions: number;
    prevAverageOrderValue: number;
    prevTotalDiscount: number;
    dailyTrend: DailyAnalyticsPoint[];
    prevDailyTrend: DailyAnalyticsPoint[];
    storeSales: AnalyticsDimensionItem[];
    categorySales: AnalyticsDimensionItem[];
    paymentMethods: AnalyticsDimensionItem[];
    hourlyTransactions: AnalyticsDimensionItem[];
    cashierSales: AnalyticsDimensionItem[];
    topItems: TopItemAnalytics[];
    availableStores: AnalyticsFilterOption[];
    availableCashiers: AnalyticsFilterOption[];
    availableCategories: AnalyticsFilterOption[];

    constructor(data?: IDashboardAnalyticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currency = data["currency"];
            this.totalSales = data["totalSales"];
            this.totalCost = data["totalCost"];
            this.netProfit = data["netProfit"];
            this.grossMargin = data["grossMargin"];
            this.transactions = data["transactions"];
            this.averageOrderValue = data["averageOrderValue"];
            this.totalDiscount = data["totalDiscount"];
            this.totalRefunds = data["totalRefunds"];
            this.prevTotalSales = data["prevTotalSales"];
            this.prevTotalCost = data["prevTotalCost"];
            this.prevNetProfit = data["prevNetProfit"];
            this.prevTransactions = data["prevTransactions"];
            this.prevAverageOrderValue = data["prevAverageOrderValue"];
            this.prevTotalDiscount = data["prevTotalDiscount"];
            if (data["dailyTrend"] && data["dailyTrend"].constructor === Array) {
                this.dailyTrend = [];
                for (let item of data["dailyTrend"])
                    this.dailyTrend.push(DailyAnalyticsPoint.fromJS(item));
            }
            if (data["prevDailyTrend"] && data["prevDailyTrend"].constructor === Array) {
                this.prevDailyTrend = [];
                for (let item of data["prevDailyTrend"])
                    this.prevDailyTrend.push(DailyAnalyticsPoint.fromJS(item));
            }
            if (data["storeSales"] && data["storeSales"].constructor === Array) {
                this.storeSales = [];
                for (let item of data["storeSales"])
                    this.storeSales.push(AnalyticsDimensionItem.fromJS(item));
            }
            if (data["categorySales"] && data["categorySales"].constructor === Array) {
                this.categorySales = [];
                for (let item of data["categorySales"])
                    this.categorySales.push(AnalyticsDimensionItem.fromJS(item));
            }
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(AnalyticsDimensionItem.fromJS(item));
            }
            if (data["hourlyTransactions"] && data["hourlyTransactions"].constructor === Array) {
                this.hourlyTransactions = [];
                for (let item of data["hourlyTransactions"])
                    this.hourlyTransactions.push(AnalyticsDimensionItem.fromJS(item));
            }
            if (data["cashierSales"] && data["cashierSales"].constructor === Array) {
                this.cashierSales = [];
                for (let item of data["cashierSales"])
                    this.cashierSales.push(AnalyticsDimensionItem.fromJS(item));
            }
            if (data["topItems"] && data["topItems"].constructor === Array) {
                this.topItems = [];
                for (let item of data["topItems"])
                    this.topItems.push(TopItemAnalytics.fromJS(item));
            }
            if (data["availableStores"] && data["availableStores"].constructor === Array) {
                this.availableStores = [];
                for (let item of data["availableStores"])
                    this.availableStores.push(AnalyticsFilterOption.fromJS(item));
            }
            if (data["availableCashiers"] && data["availableCashiers"].constructor === Array) {
                this.availableCashiers = [];
                for (let item of data["availableCashiers"])
                    this.availableCashiers.push(AnalyticsFilterOption.fromJS(item));
            }
            if (data["availableCategories"] && data["availableCategories"].constructor === Array) {
                this.availableCategories = [];
                for (let item of data["availableCategories"])
                    this.availableCategories.push(AnalyticsFilterOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardAnalyticsOutput {
        let result = new DashboardAnalyticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["totalSales"] = this.totalSales;
        data["totalCost"] = this.totalCost;
        data["netProfit"] = this.netProfit;
        data["grossMargin"] = this.grossMargin;
        data["transactions"] = this.transactions;
        data["averageOrderValue"] = this.averageOrderValue;
        data["totalDiscount"] = this.totalDiscount;
        data["totalRefunds"] = this.totalRefunds;
        data["prevTotalSales"] = this.prevTotalSales;
        data["prevTotalCost"] = this.prevTotalCost;
        data["prevNetProfit"] = this.prevNetProfit;
        data["prevTransactions"] = this.prevTransactions;
        data["prevAverageOrderValue"] = this.prevAverageOrderValue;
        data["prevTotalDiscount"] = this.prevTotalDiscount;
        if (this.dailyTrend && this.dailyTrend.constructor === Array) {
            data["dailyTrend"] = [];
            for (let item of this.dailyTrend)
                data["dailyTrend"].push(item.toJSON());
        }
        if (this.prevDailyTrend && this.prevDailyTrend.constructor === Array) {
            data["prevDailyTrend"] = [];
            for (let item of this.prevDailyTrend)
                data["prevDailyTrend"].push(item.toJSON());
        }
        if (this.storeSales && this.storeSales.constructor === Array) {
            data["storeSales"] = [];
            for (let item of this.storeSales)
                data["storeSales"].push(item.toJSON());
        }
        if (this.categorySales && this.categorySales.constructor === Array) {
            data["categorySales"] = [];
            for (let item of this.categorySales)
                data["categorySales"].push(item.toJSON());
        }
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        if (this.hourlyTransactions && this.hourlyTransactions.constructor === Array) {
            data["hourlyTransactions"] = [];
            for (let item of this.hourlyTransactions)
                data["hourlyTransactions"].push(item.toJSON());
        }
        if (this.cashierSales && this.cashierSales.constructor === Array) {
            data["cashierSales"] = [];
            for (let item of this.cashierSales)
                data["cashierSales"].push(item.toJSON());
        }
        if (this.topItems && this.topItems.constructor === Array) {
            data["topItems"] = [];
            for (let item of this.topItems)
                data["topItems"].push(item.toJSON());
        }
        if (this.availableStores && this.availableStores.constructor === Array) {
            data["availableStores"] = [];
            for (let item of this.availableStores)
                data["availableStores"].push(item.toJSON());
        }
        if (this.availableCashiers && this.availableCashiers.constructor === Array) {
            data["availableCashiers"] = [];
            for (let item of this.availableCashiers)
                data["availableCashiers"].push(item.toJSON());
        }
        if (this.availableCategories && this.availableCategories.constructor === Array) {
            data["availableCategories"] = [];
            for (let item of this.availableCategories)
                data["availableCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDashboardAnalyticsOutput {
    currency: string;
    totalSales: number;
    totalCost: number;
    netProfit: number;
    grossMargin: number;
    transactions: number;
    averageOrderValue: number;
    totalDiscount: number;
    totalRefunds: number;
    prevTotalSales: number;
    prevTotalCost: number;
    prevNetProfit: number;
    prevTransactions: number;
    prevAverageOrderValue: number;
    prevTotalDiscount: number;
    dailyTrend: DailyAnalyticsPoint[];
    prevDailyTrend: DailyAnalyticsPoint[];
    storeSales: AnalyticsDimensionItem[];
    categorySales: AnalyticsDimensionItem[];
    paymentMethods: AnalyticsDimensionItem[];
    hourlyTransactions: AnalyticsDimensionItem[];
    cashierSales: AnalyticsDimensionItem[];
    topItems: TopItemAnalytics[];
    availableStores: AnalyticsFilterOption[];
    availableCashiers: AnalyticsFilterOption[];
    availableCategories: AnalyticsFilterOption[];
}

export class DailyAnalyticsPoint implements IDailyAnalyticsPoint {
    date: string;
    sales: number;
    cost: number;
    profit: number;
    transactions: number;

    constructor(data?: IDailyAnalyticsPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.sales = data["sales"];
            this.cost = data["cost"];
            this.profit = data["profit"];
            this.transactions = data["transactions"];
        }
    }

    static fromJS(data: any): DailyAnalyticsPoint {
        let result = new DailyAnalyticsPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["sales"] = this.sales;
        data["cost"] = this.cost;
        data["profit"] = this.profit;
        data["transactions"] = this.transactions;
        return data; 
    }
}

export interface IDailyAnalyticsPoint {
    date: string;
    sales: number;
    cost: number;
    profit: number;
    transactions: number;
}

export class AnalyticsDimensionItem implements IAnalyticsDimensionItem {
    label: string;
    value: number;
    secondaryValue: number;

    constructor(data?: IAnalyticsDimensionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
            this.secondaryValue = data["secondaryValue"];
        }
    }

    static fromJS(data: any): AnalyticsDimensionItem {
        let result = new AnalyticsDimensionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data; 
    }
}

export interface IAnalyticsDimensionItem {
    label: string;
    value: number;
    secondaryValue: number;
}

export class TopItemAnalytics implements ITopItemAnalytics {
    name: string;
    quantity: number;
    sales: number;
    cost: number;
    profit: number;

    constructor(data?: ITopItemAnalytics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.quantity = data["quantity"];
            this.sales = data["sales"];
            this.cost = data["cost"];
            this.profit = data["profit"];
        }
    }

    static fromJS(data: any): TopItemAnalytics {
        let result = new TopItemAnalytics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["sales"] = this.sales;
        data["cost"] = this.cost;
        data["profit"] = this.profit;
        return data; 
    }
}

export interface ITopItemAnalytics {
    name: string;
    quantity: number;
    sales: number;
    cost: number;
    profit: number;
}

export class AnalyticsFilterOption implements IAnalyticsFilterOption {
    value: string;
    label: string;

    constructor(data?: IAnalyticsFilterOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.label = data["label"];
        }
    }

    static fromJS(data: any): AnalyticsFilterOption {
        let result = new AnalyticsFilterOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data; 
    }
}

export interface IAnalyticsFilterOption {
    value: string;
    label: string;
}

export class ProductStockAlert implements IProductStockAlert {
    name: string;
    totalRemainingQuantity: number;
    unitOfMeasure: string;
    store: string;
    saleLimit: number;

    constructor(data?: IProductStockAlert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.totalRemainingQuantity = data["totalRemainingQuantity"];
            this.unitOfMeasure = data["unitOfMeasure"];
            this.store = data["store"];
            this.saleLimit = data["saleLimit"];
        }
    }

    static fromJS(data: any): ProductStockAlert {
        let result = new ProductStockAlert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalRemainingQuantity"] = this.totalRemainingQuantity;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["store"] = this.store;
        data["saleLimit"] = this.saleLimit;
        return data; 
    }
}

export interface IProductStockAlert {
    name: string;
    totalRemainingQuantity: number;
    unitOfMeasure: string;
    store: string;
    saleLimit: number;
}

export class PagedTenantDeviceList implements IPagedTenantDeviceList {
    currentPage: number;
    itemsCount: number;
    tenantDevices: TenantDeviceDto[];

    constructor(data?: IPagedTenantDeviceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["tenantDevices"] && data["tenantDevices"].constructor === Array) {
                this.tenantDevices = [];
                for (let item of data["tenantDevices"])
                    this.tenantDevices.push(TenantDeviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedTenantDeviceList {
        let result = new PagedTenantDeviceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.tenantDevices && this.tenantDevices.constructor === Array) {
            data["tenantDevices"] = [];
            for (let item of this.tenantDevices)
                data["tenantDevices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedTenantDeviceList {
    currentPage: number;
    itemsCount: number;
    tenantDevices: TenantDeviceDto[];
}

export class TenantDeviceSearchInput implements ITenantDeviceSearchInput {
    stores: number[];
    searchKey: string;
    presenceState: number;
    pageNumber: number;
    pageSize: number;
    deviceTypes: number[];
    tenantIds: number[];

    constructor(data?: ITenantDeviceSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(item);
            }
            this.searchKey = data["searchKey"];
            this.presenceState = data["presenceState"];
            this.pageNumber = data["pageNumber"];
            this.pageSize = data["pageSize"];
            if (data["deviceTypes"] && data["deviceTypes"].constructor === Array) {
                this.deviceTypes = [];
                for (let item of data["deviceTypes"])
                    this.deviceTypes.push(item);
            }
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
        }
    }

    static fromJS(data: any): TenantDeviceSearchInput {
        let result = new TenantDeviceSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        data["searchKey"] = this.searchKey;
        data["presenceState"] = this.presenceState;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (this.deviceTypes && this.deviceTypes.constructor === Array) {
            data["deviceTypes"] = [];
            for (let item of this.deviceTypes)
                data["deviceTypes"].push(item);
        }
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data; 
    }
}

export interface ITenantDeviceSearchInput {
    stores: number[];
    searchKey: string;
    presenceState: number;
    pageNumber: number;
    pageSize: number;
    deviceTypes: number[];
    tenantIds: number[];
}

export class PagedTenantDeviceGroupList implements IPagedTenantDeviceGroupList {
    currentPage: number;
    itemsCount: number;
    deviceGroups: TenantDeviceGroupDto[];

    constructor(data?: IPagedTenantDeviceGroupList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["deviceGroups"] && data["deviceGroups"].constructor === Array) {
                this.deviceGroups = [];
                for (let item of data["deviceGroups"])
                    this.deviceGroups.push(TenantDeviceGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedTenantDeviceGroupList {
        let result = new PagedTenantDeviceGroupList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.deviceGroups && this.deviceGroups.constructor === Array) {
            data["deviceGroups"] = [];
            for (let item of this.deviceGroups)
                data["deviceGroups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedTenantDeviceGroupList {
    currentPage: number;
    itemsCount: number;
    deviceGroups: TenantDeviceGroupDto[];
}

export class TenantDeviceGroupDto implements ITenantDeviceGroupDto {
    tenantName: string;
    tenantId: number;
    devices: TenantDeviceDto[];

    constructor(data?: ITenantDeviceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.tenantId = data["tenantId"];
            if (data["devices"] && data["devices"].constructor === Array) {
                this.devices = [];
                for (let item of data["devices"])
                    this.devices.push(TenantDeviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDeviceGroupDto {
        let result = new TenantDeviceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["tenantId"] = this.tenantId;
        if (this.devices && this.devices.constructor === Array) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantDeviceGroupDto {
    tenantName: string;
    tenantId: number;
    devices: TenantDeviceDto[];
}

export class PagedTenantDeviceHistoryGroupList implements IPagedTenantDeviceHistoryGroupList {
    currentPage: number;
    itemsCount: number;
    data: TenantDeviceHistoryGroupDto[];

    constructor(data?: IPagedTenantDeviceHistoryGroupList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(TenantDeviceHistoryGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedTenantDeviceHistoryGroupList {
        let result = new PagedTenantDeviceHistoryGroupList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedTenantDeviceHistoryGroupList {
    currentPage: number;
    itemsCount: number;
    data: TenantDeviceHistoryGroupDto[];
}

export class TenantDeviceHistoryGroupDto implements ITenantDeviceHistoryGroupDto {
    tenantName: string;
    tenantId: number;
    deviceHistories: DeviceHistoryDto[];

    constructor(data?: ITenantDeviceHistoryGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.tenantId = data["tenantId"];
            if (data["deviceHistories"] && data["deviceHistories"].constructor === Array) {
                this.deviceHistories = [];
                for (let item of data["deviceHistories"])
                    this.deviceHistories.push(DeviceHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDeviceHistoryGroupDto {
        let result = new TenantDeviceHistoryGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["tenantId"] = this.tenantId;
        if (this.deviceHistories && this.deviceHistories.constructor === Array) {
            data["deviceHistories"] = [];
            for (let item of this.deviceHistories)
                data["deviceHistories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITenantDeviceHistoryGroupDto {
    tenantName: string;
    tenantId: number;
    deviceHistories: DeviceHistoryDto[];
}

export class DeviceHistoryDto implements IDeviceHistoryDto {
    tenantId: number;
    deviceId: string;
    deviceName: string;
    ipAddress: string;
    tenantName: string;
    clusterName: string;
    lastSync: moment.Moment;
    syncTime: string;
    syncDate: string;

    constructor(data?: IDeviceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.deviceName = data["deviceName"];
            this.ipAddress = data["ipAddress"];
            this.tenantName = data["tenantName"];
            this.clusterName = data["clusterName"];
            this.lastSync = data["lastSync"] ? moment(data["lastSync"].toString()) : <any>undefined;
            this.syncTime = data["syncTime"];
            this.syncDate = data["syncDate"];
        }
    }

    static fromJS(data: any): DeviceHistoryDto {
        let result = new DeviceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["ipAddress"] = this.ipAddress;
        data["tenantName"] = this.tenantName;
        data["clusterName"] = this.clusterName;
        data["lastSync"] = this.lastSync ? this.lastSync.toISOString() : <any>undefined;
        data["syncTime"] = this.syncTime;
        data["syncDate"] = this.syncDate;
        return data; 
    }
}

export interface IDeviceHistoryDto {
    tenantId: number;
    deviceId: string;
    deviceName: string;
    ipAddress: string;
    tenantName: string;
    clusterName: string;
    lastSync: moment.Moment;
    syncTime: string;
    syncDate: string;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    captchaResponse: string;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType;
    gateway: RegisterTenantInputGateway;
    editionId: number;
    isStoreGroup: boolean;
    paymentId: string;
    storeLimit: number;
    terminalLimit: number;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.gateway = data["gateway"];
            this.editionId = data["editionId"];
            this.isStoreGroup = data["isStoreGroup"];
            this.paymentId = data["paymentId"];
            this.storeLimit = data["storeLimit"];
            this.terminalLimit = data["terminalLimit"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["gateway"] = this.gateway;
        data["editionId"] = this.editionId;
        data["isStoreGroup"] = this.isStoreGroup;
        data["paymentId"] = this.paymentId;
        data["storeLimit"] = this.storeLimit;
        data["terminalLimit"] = this.terminalLimit;
        return data; 
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    captchaResponse: string;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType;
    gateway: RegisterTenantInputGateway;
    editionId: number;
    isStoreGroup: boolean;
    paymentId: string;
    storeLimit: number;
    terminalLimit: number;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string;
    name: string;
    userName: string;
    emailAddress: string;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data; 
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string;
    name: string;
    userName: string;
    emailAddress: string;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[];
    editionsWithFeatures: EditionWithFeaturesDto[];
    tenantEditionId: number;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["allFeatures"] && data["allFeatures"].constructor === Array) {
                this.allFeatures = [];
                for (let item of data["allFeatures"])
                    this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (data["editionsWithFeatures"] && data["editionsWithFeatures"].constructor === Array) {
                this.editionsWithFeatures = [];
                for (let item of data["editionsWithFeatures"])
                    this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.tenantEditionId = data["tenantEditionId"];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures && this.allFeatures.constructor === Array) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (this.editionsWithFeatures && this.editionsWithFeatures.constructor === Array) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data; 
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[];
    editionsWithFeatures: EditionWithFeaturesDto[];
    tenantEditionId: number;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: IInputType;
    textHtmlColor: string;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : <any>undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data; 
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: IInputType;
    textHtmlColor: string;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[];

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[];
}

export class IInputType implements IIInputType {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIInputType {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
}

export class SyncPageInputDto implements ISyncPageInputDto {
    storeGroupId: number;
    syncPages: SyncPageDto[];

    constructor(data?: ISyncPageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeGroupId = data["storeGroupId"];
            if (data["syncPages"] && data["syncPages"].constructor === Array) {
                this.syncPages = [];
                for (let item of data["syncPages"])
                    this.syncPages.push(SyncPageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SyncPageInputDto {
        let result = new SyncPageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeGroupId"] = this.storeGroupId;
        if (this.syncPages && this.syncPages.constructor === Array) {
            data["syncPages"] = [];
            for (let item of this.syncPages)
                data["syncPages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISyncPageInputDto {
    storeGroupId: number;
    syncPages: SyncPageDto[];
}

export class SyncPageDto implements ISyncPageDto {
    id: number;
    pageName: string;
    isIgnoredUpdate: boolean;
    isIgnoredDelete: boolean;

    constructor(data?: ISyncPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.pageName = data["pageName"];
            this.isIgnoredUpdate = data["isIgnoredUpdate"];
            this.isIgnoredDelete = data["isIgnoredDelete"];
        }
    }

    static fromJS(data: any): SyncPageDto {
        let result = new SyncPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageName"] = this.pageName;
        data["isIgnoredUpdate"] = this.isIgnoredUpdate;
        data["isIgnoredDelete"] = this.isIgnoredDelete;
        return data; 
    }
}

export interface ISyncPageDto {
    id: number;
    pageName: string;
    isIgnoredUpdate: boolean;
    isIgnoredDelete: boolean;
}

export class SyncronizationResponseDto implements ISyncronizationResponseDto {
    errorCount: number;
    errorMessage: string;

    constructor(data?: ISyncronizationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.errorCount = data["errorCount"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): SyncronizationResponseDto {
        let result = new SyncronizationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCount"] = this.errorCount;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface ISyncronizationResponseDto {
    errorCount: number;
    errorMessage: string;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    isParent: boolean;
    userManagement: TenantUserManagementSettingsEditDto = new TenantUserManagementSettingsEditDto();
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: TenantBillingSettingsEditDto;
    zatca: TenantZATCASettingsEditDto;
    analytics: TenantAnalyticsSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : <any>undefined;
            this.isParent = data["isParent"];
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : <any>undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : <any>undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
            this.zatca = data["zatca"] ? TenantZATCASettingsEditDto.fromJS(data["zatca"]) : <any>undefined;
            this.analytics = data["analytics"] ? TenantAnalyticsSettingsEditDto.fromJS(data["analytics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["isParent"] = this.isParent;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["zatca"] = this.zatca ? this.zatca.toJSON() : <any>undefined;
        data["analytics"] = this.analytics ? this.analytics.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    isParent: boolean;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    zatca: TenantZATCASettingsEditDto;
    analytics: TenantAnalyticsSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        return data; 
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string;
    userName: string;
    password: string;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string;
    userName: string;
    password: string;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName: string;
    address: string;
    taxVatNo: string;
    salerName: string;
    telephone: string;
    email: string;
    nationalCompanyNumber: string;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
            this.salerName = data["salerName"];
            this.telephone = data["telephone"];
            this.email = data["email"];
            this.nationalCompanyNumber = data["nationalCompanyNumber"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        data["salerName"] = this.salerName;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["nationalCompanyNumber"] = this.nationalCompanyNumber;
        return data; 
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string;
    address: string;
    taxVatNo: string;
    salerName: string;
    telephone: string;
    email: string;
    nationalCompanyNumber: string;
}

export class TenantZATCASettingsEditDto implements ITenantZATCASettingsEditDto {
    commercialRegistrationNo: string;
    taxRegistrationNumber: string;
    companyName: string;
    street: string;
    buildingNumber: string;
    area: string;
    address: string;
    cityName: string;
    postalZone: string;
    otp: string;
    mode: string;
    isZATCAEnable: boolean;
    csr: string;
    csid: string;
    privateKey: string;
    branchName: string;
    invoiceType: string;
    businessCategory: string;
    serialNumber: string;
    secretKey: string;

    constructor(data?: ITenantZATCASettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commercialRegistrationNo = data["commercialRegistrationNo"];
            this.taxRegistrationNumber = data["taxRegistrationNumber"];
            this.companyName = data["companyName"];
            this.street = data["street"];
            this.buildingNumber = data["buildingNumber"];
            this.area = data["area"];
            this.address = data["address"];
            this.cityName = data["cityName"];
            this.postalZone = data["postalZone"];
            this.otp = data["otp"];
            this.mode = data["mode"];
            this.isZATCAEnable = data["isZATCAEnable"];
            this.csr = data["csr"];
            this.csid = data["csid"];
            this.privateKey = data["privateKey"];
            this.branchName = data["branchName"];
            this.invoiceType = data["invoiceType"];
            this.businessCategory = data["businessCategory"];
            this.serialNumber = data["serialNumber"];
            this.secretKey = data["secretKey"];
        }
    }

    static fromJS(data: any): TenantZATCASettingsEditDto {
        let result = new TenantZATCASettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commercialRegistrationNo"] = this.commercialRegistrationNo;
        data["taxRegistrationNumber"] = this.taxRegistrationNumber;
        data["companyName"] = this.companyName;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        data["area"] = this.area;
        data["address"] = this.address;
        data["cityName"] = this.cityName;
        data["postalZone"] = this.postalZone;
        data["otp"] = this.otp;
        data["mode"] = this.mode;
        data["isZATCAEnable"] = this.isZATCAEnable;
        data["csr"] = this.csr;
        data["csid"] = this.csid;
        data["privateKey"] = this.privateKey;
        data["branchName"] = this.branchName;
        data["invoiceType"] = this.invoiceType;
        data["businessCategory"] = this.businessCategory;
        data["serialNumber"] = this.serialNumber;
        data["secretKey"] = this.secretKey;
        return data; 
    }
}

export interface ITenantZATCASettingsEditDto {
    commercialRegistrationNo: string;
    taxRegistrationNumber: string;
    companyName: string;
    street: string;
    buildingNumber: string;
    area: string;
    address: string;
    cityName: string;
    postalZone: string;
    otp: string;
    mode: string;
    isZATCAEnable: boolean;
    csr: string;
    csid: string;
    privateKey: string;
    branchName: string;
    invoiceType: string;
    businessCategory: string;
    serialNumber: string;
    secretKey: string;
}

export class TenantAnalyticsSettingsEditDto implements ITenantAnalyticsSettingsEditDto {
    isEnabled: boolean;
    apiBaseUrl: string;
    frontendBaseUrl: string;
    email: string;
    accountId: string;
    authKey: string;

    constructor(data?: ITenantAnalyticsSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.apiBaseUrl = data["apiBaseUrl"];
            this.frontendBaseUrl = data["frontendBaseUrl"];
            this.email = data["email"];
            this.accountId = data["accountId"];
            this.authKey = data["authKey"];
        }
    }

    static fromJS(data: any): TenantAnalyticsSettingsEditDto {
        let result = new TenantAnalyticsSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["apiBaseUrl"] = this.apiBaseUrl;
        data["frontendBaseUrl"] = this.frontendBaseUrl;
        data["email"] = this.email;
        data["accountId"] = this.accountId;
        data["authKey"] = this.authKey;
        return data; 
    }
}

export interface ITenantAnalyticsSettingsEditDto {
    isEnabled: boolean;
    apiBaseUrl: string;
    frontendBaseUrl: string;
    email: string;
    accountId: string;
    authKey: string;
}

export class LogoDto implements ILogoDto {
    logo: string;

    constructor(data?: ILogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logo = data["logo"];
        }
    }

    static fromJS(data: any): LogoDto {
        let result = new LogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        return data; 
    }
}

export interface ILogoDto {
    logo: string;
}

export class IssueSsoTicketOutput implements IIssueSsoTicketOutput {
    redirectUrl: string;
    accessToken: string;

    constructor(data?: IIssueSsoTicketOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.redirectUrl = data["redirectUrl"];
            this.accessToken = data["accessToken"];
        }
    }

    static fromJS(data: any): IssueSsoTicketOutput {
        let result = new IssueSsoTicketOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectUrl"] = this.redirectUrl;
        data["accessToken"] = this.accessToken;
        return data; 
    }
}

export interface IIssueSsoTicketOutput {
    redirectUrl: string;
    accessToken: string;
}

export class TenantZatcaIntegrationDto implements ITenantZatcaIntegrationDto {
    tenantId: number;
    zatcaIntegrationTenantId: number;
    username: string;
    password: string;
    url: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenantZatcaIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.zatcaIntegrationTenantId = data["zatcaIntegrationTenantId"];
            this.username = data["username"];
            this.password = data["password"];
            this.url = data["url"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantZatcaIntegrationDto {
        let result = new TenantZatcaIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["zatcaIntegrationTenantId"] = this.zatcaIntegrationTenantId;
        data["username"] = this.username;
        data["password"] = this.password;
        data["url"] = this.url;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantZatcaIntegrationDto {
    tenantId: number;
    zatcaIntegrationTenantId: number;
    username: string;
    password: string;
    url: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfTenderTypeMasterListItem implements IListResultDtoOfTenderTypeMasterListItem {
    items: TenderTypeMasterListItem[];

    constructor(data?: IListResultDtoOfTenderTypeMasterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenderTypeMasterListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTenderTypeMasterListItem {
        let result = new ListResultDtoOfTenderTypeMasterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTenderTypeMasterListItem {
    items: TenderTypeMasterListItem[];
}

export class TenderTypeMasterListItem implements ITenderTypeMasterListItem {
    id: number;
    name: string;

    constructor(data?: ITenderTypeMasterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): TenderTypeMasterListItem {
        let result = new TenderTypeMasterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ITenderTypeMasterListItem {
    id: number;
    name: string;
}

export class CreateTenderTypeMasterInput implements ICreateTenderTypeMasterInput {
    showInClosingShift: boolean;
    nature: CreateTenderTypeMasterInputNature;
    tenderTypeIds: number[];
    translations: TenderTypeMasterTranslationDto[];

    constructor(data?: ICreateTenderTypeMasterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.showInClosingShift = data["showInClosingShift"];
            this.nature = data["nature"];
            if (data["tenderTypeIds"] && data["tenderTypeIds"].constructor === Array) {
                this.tenderTypeIds = [];
                for (let item of data["tenderTypeIds"])
                    this.tenderTypeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeMasterTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTenderTypeMasterInput {
        let result = new CreateTenderTypeMasterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showInClosingShift"] = this.showInClosingShift;
        data["nature"] = this.nature;
        if (this.tenderTypeIds && this.tenderTypeIds.constructor === Array) {
            data["tenderTypeIds"] = [];
            for (let item of this.tenderTypeIds)
                data["tenderTypeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateTenderTypeMasterInput {
    showInClosingShift: boolean;
    nature: CreateTenderTypeMasterInputNature;
    tenderTypeIds: number[];
    translations: TenderTypeMasterTranslationDto[];
}

export class UpdateTenderTypeMasterInput implements IUpdateTenderTypeMasterInput {
    id: number;
    showInClosingShift: boolean;
    nature: UpdateTenderTypeMasterInputNature;
    tenderTypeIds: number[];
    translations: TenderTypeMasterTranslationDto[];

    constructor(data?: IUpdateTenderTypeMasterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.showInClosingShift = data["showInClosingShift"];
            this.nature = data["nature"];
            if (data["tenderTypeIds"] && data["tenderTypeIds"].constructor === Array) {
                this.tenderTypeIds = [];
                for (let item of data["tenderTypeIds"])
                    this.tenderTypeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeMasterTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenderTypeMasterInput {
        let result = new UpdateTenderTypeMasterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showInClosingShift"] = this.showInClosingShift;
        data["nature"] = this.nature;
        if (this.tenderTypeIds && this.tenderTypeIds.constructor === Array) {
            data["tenderTypeIds"] = [];
            for (let item of this.tenderTypeIds)
                data["tenderTypeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenderTypeMasterInput {
    id: number;
    showInClosingShift: boolean;
    nature: UpdateTenderTypeMasterInputNature;
    tenderTypeIds: number[];
    translations: TenderTypeMasterTranslationDto[];
}

export class TenderTypeDto implements ITenderTypeDto {
    deliveryId: number;
    masterId: number;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    code: string;
    posMachine: number;
    translations: TenderTypeTranslationDto[];
    tenderTypeSaleTypes: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveryId = data["deliveryId"];
            this.masterId = data["masterId"];
            this.isLinkedWithPOSMachine = data["isLinkedWithPOSMachine"];
            this.preventCashRefund = data["preventCashRefund"];
            this.code = data["code"];
            this.posMachine = data["posMachine"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeTranslationDto.fromJS(item));
            }
            if (data["tenderTypeSaleTypes"] && data["tenderTypeSaleTypes"].constructor === Array) {
                this.tenderTypeSaleTypes = [];
                for (let item of data["tenderTypeSaleTypes"])
                    this.tenderTypeSaleTypes.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeDto {
        let result = new TenderTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["masterId"] = this.masterId;
        data["isLinkedWithPOSMachine"] = this.isLinkedWithPOSMachine;
        data["preventCashRefund"] = this.preventCashRefund;
        data["code"] = this.code;
        data["posMachine"] = this.posMachine;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.tenderTypeSaleTypes && this.tenderTypeSaleTypes.constructor === Array) {
            data["tenderTypeSaleTypes"] = [];
            for (let item of this.tenderTypeSaleTypes)
                data["tenderTypeSaleTypes"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeDto {
    deliveryId: number;
    masterId: number;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    code: string;
    posMachine: number;
    translations: TenderTypeTranslationDto[];
    tenderTypeSaleTypes: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TenderTypeTranslationDto implements ITenderTypeTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ITenderTypeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): TenderTypeTranslationDto {
        let result = new TenderTypeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ITenderTypeTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfTenderTypeListItem implements IListResultDtoOfTenderTypeListItem {
    items: TenderTypeListItem[];

    constructor(data?: IListResultDtoOfTenderTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenderTypeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTenderTypeListItem {
        let result = new ListResultDtoOfTenderTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTenderTypeListItem {
    items: TenderTypeListItem[];
}

export class TenderTypeListItem implements ITenderTypeListItem {
    id: number;
    isSystemDefined: boolean;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    name: string;
    code: string;
    posMachine: number;

    constructor(data?: ITenderTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isSystemDefined = data["isSystemDefined"];
            this.isLinkedWithPOSMachine = data["isLinkedWithPOSMachine"];
            this.preventCashRefund = data["preventCashRefund"];
            this.name = data["name"];
            this.code = data["code"];
            this.posMachine = data["posMachine"];
        }
    }

    static fromJS(data: any): TenderTypeListItem {
        let result = new TenderTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSystemDefined"] = this.isSystemDefined;
        data["isLinkedWithPOSMachine"] = this.isLinkedWithPOSMachine;
        data["preventCashRefund"] = this.preventCashRefund;
        data["name"] = this.name;
        data["code"] = this.code;
        data["posMachine"] = this.posMachine;
        return data; 
    }
}

export interface ITenderTypeListItem {
    id: number;
    isSystemDefined: boolean;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    name: string;
    code: string;
    posMachine: number;
}

export class CreateTenderTypeInput implements ICreateTenderTypeInput {
    deliveryId: number;
    masterId: number;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    code: string;
    posMachine: number;
    translations: TenderTypeTranslationDto[];
    tenderTypeSaleTypes: number[];
    storeIds: number[];

    constructor(data?: ICreateTenderTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveryId = data["deliveryId"];
            this.masterId = data["masterId"];
            this.isLinkedWithPOSMachine = data["isLinkedWithPOSMachine"];
            this.preventCashRefund = data["preventCashRefund"];
            this.code = data["code"];
            this.posMachine = data["posMachine"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeTranslationDto.fromJS(item));
            }
            if (data["tenderTypeSaleTypes"] && data["tenderTypeSaleTypes"].constructor === Array) {
                this.tenderTypeSaleTypes = [];
                for (let item of data["tenderTypeSaleTypes"])
                    this.tenderTypeSaleTypes.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTenderTypeInput {
        let result = new CreateTenderTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["masterId"] = this.masterId;
        data["isLinkedWithPOSMachine"] = this.isLinkedWithPOSMachine;
        data["preventCashRefund"] = this.preventCashRefund;
        data["code"] = this.code;
        data["posMachine"] = this.posMachine;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.tenderTypeSaleTypes && this.tenderTypeSaleTypes.constructor === Array) {
            data["tenderTypeSaleTypes"] = [];
            for (let item of this.tenderTypeSaleTypes)
                data["tenderTypeSaleTypes"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateTenderTypeInput {
    deliveryId: number;
    masterId: number;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    code: string;
    posMachine: number;
    translations: TenderTypeTranslationDto[];
    tenderTypeSaleTypes: number[];
    storeIds: number[];
}

export class UpdateTenderTypeInput implements IUpdateTenderTypeInput {
    id: number;
    deliveryId: number;
    masterId: number;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    code: string;
    posMachine: number;
    translations: TenderTypeTranslationDto[];
    tenderTypeSaleTypes: number[];
    storeIds: number[];

    constructor(data?: IUpdateTenderTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.deliveryId = data["deliveryId"];
            this.masterId = data["masterId"];
            this.isLinkedWithPOSMachine = data["isLinkedWithPOSMachine"];
            this.preventCashRefund = data["preventCashRefund"];
            this.code = data["code"];
            this.posMachine = data["posMachine"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeTranslationDto.fromJS(item));
            }
            if (data["tenderTypeSaleTypes"] && data["tenderTypeSaleTypes"].constructor === Array) {
                this.tenderTypeSaleTypes = [];
                for (let item of data["tenderTypeSaleTypes"])
                    this.tenderTypeSaleTypes.push(item);
            }
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTenderTypeInput {
        let result = new UpdateTenderTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deliveryId"] = this.deliveryId;
        data["masterId"] = this.masterId;
        data["isLinkedWithPOSMachine"] = this.isLinkedWithPOSMachine;
        data["preventCashRefund"] = this.preventCashRefund;
        data["code"] = this.code;
        data["posMachine"] = this.posMachine;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.tenderTypeSaleTypes && this.tenderTypeSaleTypes.constructor === Array) {
            data["tenderTypeSaleTypes"] = [];
            for (let item of this.tenderTypeSaleTypes)
                data["tenderTypeSaleTypes"].push(item);
        }
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateTenderTypeInput {
    id: number;
    deliveryId: number;
    masterId: number;
    isLinkedWithPOSMachine: boolean;
    preventCashRefund: boolean;
    code: string;
    posMachine: number;
    translations: TenderTypeTranslationDto[];
    tenderTypeSaleTypes: number[];
    storeIds: number[];
}

export class TerminalDto implements ITerminalDto {
    id: number;
    name: string;
    storeId: number;

    constructor(data?: ITerminalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): TerminalDto {
        let result = new TerminalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface ITerminalDto {
    id: number;
    name: string;
    storeId: number;
}

export class ListResultDtoOfTerminalListItem implements IListResultDtoOfTerminalListItem {
    items: TerminalListItem[];

    constructor(data?: IListResultDtoOfTerminalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TerminalListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTerminalListItem {
        let result = new ListResultDtoOfTerminalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTerminalListItem {
    items: TerminalListItem[];
}

export class TerminalListItem implements ITerminalListItem {
    id: number;
    name: string;

    constructor(data?: ITerminalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): TerminalListItem {
        let result = new TerminalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ITerminalListItem {
    id: number;
    name: string;
}

export class CreateTerminalInput implements ICreateTerminalInput {
    name: string;
    storeId: number;

    constructor(data?: ICreateTerminalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): CreateTerminalInput {
        let result = new CreateTerminalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface ICreateTerminalInput {
    name: string;
    storeId: number;
}

export class UpdateTerminalInput implements IUpdateTerminalInput {
    id: number;
    name: string;
    storeId: number;

    constructor(data?: IUpdateTerminalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): UpdateTerminalInput {
        let result = new UpdateTerminalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IUpdateTerminalInput {
    id: number;
    name: string;
    storeId: number;
}

export class ThemeDto implements IThemeDto {
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    isActive: boolean;
    deviceType: number;
    tenantId: number;
    pageName: string;
    fontSizeUnit: ThemeDtoFontSizeUnit;
    backGroundType: ThemeDtoBackGroundType;
    slidingTimeInterval: number;
    advertisementType: ThemeDtoAdvertisementType;
    logoPath: string;
    orderSummaryView: boolean;
    nearpayTerminalId: string;
    fontFamily: string;
    clusterId: number;
    tenantDeviceId: number;
    terminalId: string;
    themSettingImages: ThemSettingImageDto[];
    translations: ThemeSettingTranslationDto[];
    advertisements: AdvertisementDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.backgoundColor = data["backgoundColor"];
            this.forgroundColor = data["forgroundColor"];
            this.fontColor = data["fontColor"];
            this.fontSize = data["fontSize"];
            this.isActive = data["isActive"];
            this.deviceType = data["deviceType"];
            this.tenantId = data["tenantId"];
            this.pageName = data["pageName"];
            this.fontSizeUnit = data["fontSizeUnit"];
            this.backGroundType = data["backGroundType"];
            this.slidingTimeInterval = data["slidingTimeInterval"];
            this.advertisementType = data["advertisementType"];
            this.logoPath = data["logoPath"];
            this.orderSummaryView = data["orderSummaryView"];
            this.nearpayTerminalId = data["nearpayTerminalId"];
            this.fontFamily = data["fontFamily"];
            this.clusterId = data["clusterId"];
            this.tenantDeviceId = data["tenantDeviceId"];
            this.terminalId = data["terminalId"];
            if (data["themSettingImages"] && data["themSettingImages"].constructor === Array) {
                this.themSettingImages = [];
                for (let item of data["themSettingImages"])
                    this.themSettingImages.push(ThemSettingImageDto.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ThemeSettingTranslationDto.fromJS(item));
            }
            if (data["advertisements"] && data["advertisements"].constructor === Array) {
                this.advertisements = [];
                for (let item of data["advertisements"])
                    this.advertisements.push(AdvertisementDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThemeDto {
        let result = new ThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgoundColor"] = this.backgoundColor;
        data["forgroundColor"] = this.forgroundColor;
        data["fontColor"] = this.fontColor;
        data["fontSize"] = this.fontSize;
        data["isActive"] = this.isActive;
        data["deviceType"] = this.deviceType;
        data["tenantId"] = this.tenantId;
        data["pageName"] = this.pageName;
        data["fontSizeUnit"] = this.fontSizeUnit;
        data["backGroundType"] = this.backGroundType;
        data["slidingTimeInterval"] = this.slidingTimeInterval;
        data["advertisementType"] = this.advertisementType;
        data["logoPath"] = this.logoPath;
        data["orderSummaryView"] = this.orderSummaryView;
        data["nearpayTerminalId"] = this.nearpayTerminalId;
        data["fontFamily"] = this.fontFamily;
        data["clusterId"] = this.clusterId;
        data["tenantDeviceId"] = this.tenantDeviceId;
        data["terminalId"] = this.terminalId;
        if (this.themSettingImages && this.themSettingImages.constructor === Array) {
            data["themSettingImages"] = [];
            for (let item of this.themSettingImages)
                data["themSettingImages"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.advertisements && this.advertisements.constructor === Array) {
            data["advertisements"] = [];
            for (let item of this.advertisements)
                data["advertisements"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThemeDto {
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    isActive: boolean;
    deviceType: number;
    tenantId: number;
    pageName: string;
    fontSizeUnit: ThemeDtoFontSizeUnit;
    backGroundType: ThemeDtoBackGroundType;
    slidingTimeInterval: number;
    advertisementType: ThemeDtoAdvertisementType;
    logoPath: string;
    orderSummaryView: boolean;
    nearpayTerminalId: string;
    fontFamily: string;
    clusterId: number;
    tenantDeviceId: number;
    terminalId: string;
    themSettingImages: ThemSettingImageDto[];
    translations: ThemeSettingTranslationDto[];
    advertisements: AdvertisementDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ThemSettingImageDto implements IThemSettingImageDto {
    id: number;
    fileId: string;
    filePath: string;
    displayInterval: number;
    name: string;

    constructor(data?: IThemSettingImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.fileId = data["fileId"];
            this.filePath = data["filePath"];
            this.displayInterval = data["displayInterval"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ThemSettingImageDto {
        let result = new ThemSettingImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["filePath"] = this.filePath;
        data["displayInterval"] = this.displayInterval;
        data["name"] = this.name;
        return data; 
    }
}

export interface IThemSettingImageDto {
    id: number;
    fileId: string;
    filePath: string;
    displayInterval: number;
    name: string;
}

export class ThemeSettingTranslationDto implements IThemeSettingTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IThemeSettingTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): ThemeSettingTranslationDto {
        let result = new ThemeSettingTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IThemeSettingTranslationDto {
    name: string;
    languageId: number;
}

export class AdvertisementDto implements IAdvertisementDto {
    id: number;
    from: moment.Moment;
    to: moment.Moment;
    displayInterval: number;
    assets: AssetDto[];

    constructor(data?: IAdvertisementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.displayInterval = data["displayInterval"];
            if (data["assets"] && data["assets"].constructor === Array) {
                this.assets = [];
                for (let item of data["assets"])
                    this.assets.push(AssetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdvertisementDto {
        let result = new AdvertisementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["displayInterval"] = this.displayInterval;
        if (this.assets && this.assets.constructor === Array) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAdvertisementDto {
    id: number;
    from: moment.Moment;
    to: moment.Moment;
    displayInterval: number;
    assets: AssetDto[];
}

export class AssetDto implements IAssetDto {
    id: number;
    name: string;
    filePath: string;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.filePath = data["filePath"];
        }
    }

    static fromJS(data: any): AssetDto {
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["filePath"] = this.filePath;
        return data; 
    }
}

export interface IAssetDto {
    id: number;
    name: string;
    filePath: string;
}

export class ListResultDtoOfThemeListItem implements IListResultDtoOfThemeListItem {
    items: ThemeListItem[];

    constructor(data?: IListResultDtoOfThemeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ThemeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfThemeListItem {
        let result = new ListResultDtoOfThemeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfThemeListItem {
    items: ThemeListItem[];
}

export class ThemeListItem implements IThemeListItem {
    id: number;
    name: string;
    tenantId: number;
    tenantName: string;
    deviceType: number;
    isActive: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    pageName: string;
    fontSizeUnit: ThemeListItemFontSizeUnit;
    backGroundType: ThemeListItemBackGroundType;
    slidingTimeInterval: number;

    constructor(data?: IThemeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.deviceType = data["deviceType"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.pageName = data["pageName"];
            this.fontSizeUnit = data["fontSizeUnit"];
            this.backGroundType = data["backGroundType"];
            this.slidingTimeInterval = data["slidingTimeInterval"];
        }
    }

    static fromJS(data: any): ThemeListItem {
        let result = new ThemeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["deviceType"] = this.deviceType;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["pageName"] = this.pageName;
        data["fontSizeUnit"] = this.fontSizeUnit;
        data["backGroundType"] = this.backGroundType;
        data["slidingTimeInterval"] = this.slidingTimeInterval;
        return data; 
    }
}

export interface IThemeListItem {
    id: number;
    name: string;
    tenantId: number;
    tenantName: string;
    deviceType: number;
    isActive: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
    pageName: string;
    fontSizeUnit: ThemeListItemFontSizeUnit;
    backGroundType: ThemeListItemBackGroundType;
    slidingTimeInterval: number;
}

export class PagedThemeList implements IPagedThemeList {
    currentPage: number;
    itemsCount: number;
    themes: ThemeListItem[];

    constructor(data?: IPagedThemeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["themes"] && data["themes"].constructor === Array) {
                this.themes = [];
                for (let item of data["themes"])
                    this.themes.push(ThemeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedThemeList {
        let result = new PagedThemeList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.themes && this.themes.constructor === Array) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedThemeList {
    currentPage: number;
    itemsCount: number;
    themes: ThemeListItem[];
}

export class ThemeListItemDto implements IThemeListItemDto {
    id: number;
    name: string;
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    pageName: string;
    fontSizeUnit: ThemeListItemDtoFontSizeUnit;
    backGroundType: ThemeListItemDtoBackGroundType;
    slidingTimeInterval: number;

    constructor(data?: IThemeListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.backgoundColor = data["backgoundColor"];
            this.forgroundColor = data["forgroundColor"];
            this.fontColor = data["fontColor"];
            this.fontSize = data["fontSize"];
            this.pageName = data["pageName"];
            this.fontSizeUnit = data["fontSizeUnit"];
            this.backGroundType = data["backGroundType"];
            this.slidingTimeInterval = data["slidingTimeInterval"];
        }
    }

    static fromJS(data: any): ThemeListItemDto {
        let result = new ThemeListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["backgoundColor"] = this.backgoundColor;
        data["forgroundColor"] = this.forgroundColor;
        data["fontColor"] = this.fontColor;
        data["fontSize"] = this.fontSize;
        data["pageName"] = this.pageName;
        data["fontSizeUnit"] = this.fontSizeUnit;
        data["backGroundType"] = this.backGroundType;
        data["slidingTimeInterval"] = this.slidingTimeInterval;
        return data; 
    }
}

export interface IThemeListItemDto {
    id: number;
    name: string;
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    pageName: string;
    fontSizeUnit: ThemeListItemDtoFontSizeUnit;
    backGroundType: ThemeListItemDtoBackGroundType;
    slidingTimeInterval: number;
}

export class CreateThemeInput implements ICreateThemeInput {
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    isActive: boolean;
    deviceType: number;
    tenantId: number;
    pageName: string;
    fontSizeUnit: CreateThemeInputFontSizeUnit;
    backGroundType: CreateThemeInputBackGroundType;
    slidingTimeInterval: number;
    advertisementType: CreateThemeInputAdvertisementType;
    logoPath: string;
    orderSummaryView: boolean;
    nearpayTerminalId: string;
    fontFamily: string;
    clusterId: number;
    tenantDeviceId: number;
    translations: ThemeSettingTranslationDto[];
    images: ThemSettingImageDto[];
    terminalId: string;
    advertisements: AdvertisementDto[];

    constructor(data?: ICreateThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.backgoundColor = data["backgoundColor"];
            this.forgroundColor = data["forgroundColor"];
            this.fontColor = data["fontColor"];
            this.fontSize = data["fontSize"];
            this.isActive = data["isActive"];
            this.deviceType = data["deviceType"];
            this.tenantId = data["tenantId"];
            this.pageName = data["pageName"];
            this.fontSizeUnit = data["fontSizeUnit"];
            this.backGroundType = data["backGroundType"];
            this.slidingTimeInterval = data["slidingTimeInterval"];
            this.advertisementType = data["advertisementType"];
            this.logoPath = data["logoPath"];
            this.orderSummaryView = data["orderSummaryView"];
            this.nearpayTerminalId = data["nearpayTerminalId"];
            this.fontFamily = data["fontFamily"];
            this.clusterId = data["clusterId"];
            this.tenantDeviceId = data["tenantDeviceId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ThemeSettingTranslationDto.fromJS(item));
            }
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (let item of data["images"])
                    this.images.push(ThemSettingImageDto.fromJS(item));
            }
            this.terminalId = data["terminalId"];
            if (data["advertisements"] && data["advertisements"].constructor === Array) {
                this.advertisements = [];
                for (let item of data["advertisements"])
                    this.advertisements.push(AdvertisementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateThemeInput {
        let result = new CreateThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgoundColor"] = this.backgoundColor;
        data["forgroundColor"] = this.forgroundColor;
        data["fontColor"] = this.fontColor;
        data["fontSize"] = this.fontSize;
        data["isActive"] = this.isActive;
        data["deviceType"] = this.deviceType;
        data["tenantId"] = this.tenantId;
        data["pageName"] = this.pageName;
        data["fontSizeUnit"] = this.fontSizeUnit;
        data["backGroundType"] = this.backGroundType;
        data["slidingTimeInterval"] = this.slidingTimeInterval;
        data["advertisementType"] = this.advertisementType;
        data["logoPath"] = this.logoPath;
        data["orderSummaryView"] = this.orderSummaryView;
        data["nearpayTerminalId"] = this.nearpayTerminalId;
        data["fontFamily"] = this.fontFamily;
        data["clusterId"] = this.clusterId;
        data["tenantDeviceId"] = this.tenantDeviceId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["terminalId"] = this.terminalId;
        if (this.advertisements && this.advertisements.constructor === Array) {
            data["advertisements"] = [];
            for (let item of this.advertisements)
                data["advertisements"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateThemeInput {
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    isActive: boolean;
    deviceType: number;
    tenantId: number;
    pageName: string;
    fontSizeUnit: CreateThemeInputFontSizeUnit;
    backGroundType: CreateThemeInputBackGroundType;
    slidingTimeInterval: number;
    advertisementType: CreateThemeInputAdvertisementType;
    logoPath: string;
    orderSummaryView: boolean;
    nearpayTerminalId: string;
    fontFamily: string;
    clusterId: number;
    tenantDeviceId: number;
    translations: ThemeSettingTranslationDto[];
    images: ThemSettingImageDto[];
    terminalId: string;
    advertisements: AdvertisementDto[];
}

export class UpdateThemeInput implements IUpdateThemeInput {
    id: number;
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    isActive: boolean;
    deviceType: number;
    tenantId: number;
    pageName: string;
    fontSizeUnit: UpdateThemeInputFontSizeUnit;
    backGroundType: UpdateThemeInputBackGroundType;
    fontFamily: string;
    clusterId: number;
    terminalId: string;
    tenantDeviceId: number;
    slidingTimeInterval: number;
    translations: ThemeSettingTranslationDto[];
    images: ThemSettingImageDto[];
    advertisementType: UpdateThemeInputAdvertisementType;
    logoPath: string;
    orderSummaryView: boolean;
    nearpayTerminalId: string;
    advertisements: AdvertisementDto[];

    constructor(data?: IUpdateThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.backgoundColor = data["backgoundColor"];
            this.forgroundColor = data["forgroundColor"];
            this.fontColor = data["fontColor"];
            this.fontSize = data["fontSize"];
            this.isActive = data["isActive"];
            this.deviceType = data["deviceType"];
            this.tenantId = data["tenantId"];
            this.pageName = data["pageName"];
            this.fontSizeUnit = data["fontSizeUnit"];
            this.backGroundType = data["backGroundType"];
            this.fontFamily = data["fontFamily"];
            this.clusterId = data["clusterId"];
            this.terminalId = data["terminalId"];
            this.tenantDeviceId = data["tenantDeviceId"];
            this.slidingTimeInterval = data["slidingTimeInterval"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ThemeSettingTranslationDto.fromJS(item));
            }
            if (data["images"] && data["images"].constructor === Array) {
                this.images = [];
                for (let item of data["images"])
                    this.images.push(ThemSettingImageDto.fromJS(item));
            }
            this.advertisementType = data["advertisementType"];
            this.logoPath = data["logoPath"];
            this.orderSummaryView = data["orderSummaryView"];
            this.nearpayTerminalId = data["nearpayTerminalId"];
            if (data["advertisements"] && data["advertisements"].constructor === Array) {
                this.advertisements = [];
                for (let item of data["advertisements"])
                    this.advertisements.push(AdvertisementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateThemeInput {
        let result = new UpdateThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["backgoundColor"] = this.backgoundColor;
        data["forgroundColor"] = this.forgroundColor;
        data["fontColor"] = this.fontColor;
        data["fontSize"] = this.fontSize;
        data["isActive"] = this.isActive;
        data["deviceType"] = this.deviceType;
        data["tenantId"] = this.tenantId;
        data["pageName"] = this.pageName;
        data["fontSizeUnit"] = this.fontSizeUnit;
        data["backGroundType"] = this.backGroundType;
        data["fontFamily"] = this.fontFamily;
        data["clusterId"] = this.clusterId;
        data["terminalId"] = this.terminalId;
        data["tenantDeviceId"] = this.tenantDeviceId;
        data["slidingTimeInterval"] = this.slidingTimeInterval;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.images && this.images.constructor === Array) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["advertisementType"] = this.advertisementType;
        data["logoPath"] = this.logoPath;
        data["orderSummaryView"] = this.orderSummaryView;
        data["nearpayTerminalId"] = this.nearpayTerminalId;
        if (this.advertisements && this.advertisements.constructor === Array) {
            data["advertisements"] = [];
            for (let item of this.advertisements)
                data["advertisements"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateThemeInput {
    id: number;
    backgoundColor: string;
    forgroundColor: string;
    fontColor: string;
    fontSize: number;
    isActive: boolean;
    deviceType: number;
    tenantId: number;
    pageName: string;
    fontSizeUnit: UpdateThemeInputFontSizeUnit;
    backGroundType: UpdateThemeInputBackGroundType;
    fontFamily: string;
    clusterId: number;
    terminalId: string;
    tenantDeviceId: number;
    slidingTimeInterval: number;
    translations: ThemeSettingTranslationDto[];
    images: ThemSettingImageDto[];
    advertisementType: UpdateThemeInputAdvertisementType;
    logoPath: string;
    orderSummaryView: boolean;
    nearpayTerminalId: string;
    advertisements: AdvertisementDto[];
}

export class ListResultDtoOfThirdPartyIntegrationNameDto implements IListResultDtoOfThirdPartyIntegrationNameDto {
    items: ThirdPartyIntegrationNameDto[];

    constructor(data?: IListResultDtoOfThirdPartyIntegrationNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ThirdPartyIntegrationNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfThirdPartyIntegrationNameDto {
        let result = new ListResultDtoOfThirdPartyIntegrationNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfThirdPartyIntegrationNameDto {
    items: ThirdPartyIntegrationNameDto[];
}

export class ThirdPartyIntegrationNameDto implements IThirdPartyIntegrationNameDto {
    name: string;
    id: number;

    constructor(data?: IThirdPartyIntegrationNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThirdPartyIntegrationNameDto {
        let result = new ThirdPartyIntegrationNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThirdPartyIntegrationNameDto {
    name: string;
    id: number;
}

export class ListResultDtoOfThirdPartyIntegrationDto implements IListResultDtoOfThirdPartyIntegrationDto {
    items: ThirdPartyIntegrationDto[];

    constructor(data?: IListResultDtoOfThirdPartyIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ThirdPartyIntegrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfThirdPartyIntegrationDto {
        let result = new ListResultDtoOfThirdPartyIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfThirdPartyIntegrationDto {
    items: ThirdPartyIntegrationDto[];
}

export class ThirdPartyIntegrationDto implements IThirdPartyIntegrationDto {
    tenantId: number;
    thirdPartyIntegrationNameId: number;
    thirdPartyIntegrationName: string;
    id: number;

    constructor(data?: IThirdPartyIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.thirdPartyIntegrationNameId = data["thirdPartyIntegrationNameId"];
            this.thirdPartyIntegrationName = data["thirdPartyIntegrationName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThirdPartyIntegrationDto {
        let result = new ThirdPartyIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["thirdPartyIntegrationNameId"] = this.thirdPartyIntegrationNameId;
        data["thirdPartyIntegrationName"] = this.thirdPartyIntegrationName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThirdPartyIntegrationDto {
    tenantId: number;
    thirdPartyIntegrationNameId: number;
    thirdPartyIntegrationName: string;
    id: number;
}

export class CreateOrUpdateThirdPartyIntegrationInput implements ICreateOrUpdateThirdPartyIntegrationInput {
    tenantId: number;
    thirdPartyIntegrationNameIds: number[];

    constructor(data?: ICreateOrUpdateThirdPartyIntegrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["thirdPartyIntegrationNameIds"] && data["thirdPartyIntegrationNameIds"].constructor === Array) {
                this.thirdPartyIntegrationNameIds = [];
                for (let item of data["thirdPartyIntegrationNameIds"])
                    this.thirdPartyIntegrationNameIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateThirdPartyIntegrationInput {
        let result = new CreateOrUpdateThirdPartyIntegrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.thirdPartyIntegrationNameIds && this.thirdPartyIntegrationNameIds.constructor === Array) {
            data["thirdPartyIntegrationNameIds"] = [];
            for (let item of this.thirdPartyIntegrationNameIds)
                data["thirdPartyIntegrationNameIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateThirdPartyIntegrationInput {
    tenantId: number;
    thirdPartyIntegrationNameIds: number[];
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items: NameValueDto[];

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[];
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    pinCode: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    isDemo: boolean;
    tenancyName: string;
    selfServiceDeviceName: string;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.pinCode = data["pinCode"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.isDemo = data["isDemo"];
            this.tenancyName = data["tenancyName"];
            this.selfServiceDeviceName = data["selfServiceDeviceName"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["pinCode"] = this.pinCode;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["isDemo"] = this.isDemo;
        data["tenancyName"] = this.tenancyName;
        data["selfServiceDeviceName"] = this.selfServiceDeviceName;
        return data; 
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    pinCode: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    isDemo: boolean;
    tenancyName: string;
    selfServiceDeviceName: string;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    isValidSelfServiceName: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;
    userName: string;
    counterCode: string;
    tenantData: TenantListDto;
    userStoreIds: number[];
    roles: UserRoleDto[];

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            this.isValidSelfServiceName = data["isValidSelfServiceName"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
            this.userName = data["userName"];
            this.counterCode = data["counterCode"];
            this.tenantData = data["tenantData"] ? TenantListDto.fromJS(data["tenantData"]) : <any>undefined;
            if (data["userStoreIds"] && data["userStoreIds"].constructor === Array) {
                this.userStoreIds = [];
                for (let item of data["userStoreIds"])
                    this.userStoreIds.push(item);
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        data["isValidSelfServiceName"] = this.isValidSelfServiceName;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["userName"] = this.userName;
        data["counterCode"] = this.counterCode;
        data["tenantData"] = this.tenantData ? this.tenantData.toJSON() : <any>undefined;
        if (this.userStoreIds && this.userStoreIds.constructor === Array) {
            data["userStoreIds"] = [];
            for (let item of this.userStoreIds)
                data["userStoreIds"].push(item);
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    isValidSelfServiceName: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;
    userName: string;
    counterCode: string;
    tenantData: TenantListDto;
    userStoreIds: number[];
    roles: UserRoleDto[];
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number;
    roleName: string;
    roleDisplayName: string;
    isAssigned: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data; 
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string;
    roleDisplayName: string;
    isAssigned: boolean;
}

export class DeviceAuthModel implements IDeviceAuthModel {
    ipAddress: string;
    macAddress: string;
    clusterId: number;
    userNameOrEmailAddress: string;
    password: string;
    pinCode: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    isDemo: boolean;
    tenancyName: string;
    selfServiceDeviceName: string;

    constructor(data?: IDeviceAuthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ipAddress = data["ipAddress"];
            this.macAddress = data["macAddress"];
            this.clusterId = data["clusterId"];
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.pinCode = data["pinCode"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.isDemo = data["isDemo"];
            this.tenancyName = data["tenancyName"];
            this.selfServiceDeviceName = data["selfServiceDeviceName"];
        }
    }

    static fromJS(data: any): DeviceAuthModel {
        let result = new DeviceAuthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["macAddress"] = this.macAddress;
        data["clusterId"] = this.clusterId;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["pinCode"] = this.pinCode;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["isDemo"] = this.isDemo;
        data["tenancyName"] = this.tenancyName;
        data["selfServiceDeviceName"] = this.selfServiceDeviceName;
        return data; 
    }
}

export interface IDeviceAuthModel {
    ipAddress: string;
    macAddress: string;
    clusterId: number;
    userNameOrEmailAddress: string;
    password: string;
    pinCode: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    isDemo: boolean;
    tenancyName: string;
    selfServiceDeviceName: string;
}

export class DeviceAuthenticateResultModel implements IDeviceAuthenticateResultModel {
    deviceStoreId: number;
    deviceType: DeviceAuthenticateResultModelDeviceType;
    deviceName: string;
    deviceId: number;
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    isValidSelfServiceName: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;
    userName: string;
    counterCode: string;
    tenantData: TenantListDto;
    userStoreIds: number[];
    roles: UserRoleDto[];

    constructor(data?: IDeviceAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceStoreId = data["deviceStoreId"];
            this.deviceType = data["deviceType"];
            this.deviceName = data["deviceName"];
            this.deviceId = data["deviceId"];
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            this.isValidSelfServiceName = data["isValidSelfServiceName"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
            this.userName = data["userName"];
            this.counterCode = data["counterCode"];
            this.tenantData = data["tenantData"] ? TenantListDto.fromJS(data["tenantData"]) : <any>undefined;
            if (data["userStoreIds"] && data["userStoreIds"].constructor === Array) {
                this.userStoreIds = [];
                for (let item of data["userStoreIds"])
                    this.userStoreIds.push(item);
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceAuthenticateResultModel {
        let result = new DeviceAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceStoreId"] = this.deviceStoreId;
        data["deviceType"] = this.deviceType;
        data["deviceName"] = this.deviceName;
        data["deviceId"] = this.deviceId;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        data["isValidSelfServiceName"] = this.isValidSelfServiceName;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["userName"] = this.userName;
        data["counterCode"] = this.counterCode;
        data["tenantData"] = this.tenantData ? this.tenantData.toJSON() : <any>undefined;
        if (this.userStoreIds && this.userStoreIds.constructor === Array) {
            data["userStoreIds"] = [];
            for (let item of this.userStoreIds)
                data["userStoreIds"].push(item);
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceAuthenticateResultModel {
    deviceStoreId: number;
    deviceType: DeviceAuthenticateResultModelDeviceType;
    deviceName: string;
    deviceId: number;
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    isValidSelfServiceName: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;
    userName: string;
    counterCode: string;
    tenantData: TenantListDto;
    userStoreIds: number[];
    roles: UserRoleDto[];
}

export class ValueTupleOfBooleanAndString implements IValueTupleOfBooleanAndString {
    item1: boolean;
    item2: string;

    constructor(data?: IValueTupleOfBooleanAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfBooleanAndString {
        let result = new ValueTupleOfBooleanAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data; 
    }
}

export interface IValueTupleOfBooleanAndString {
    item1: boolean;
    item2: string;
}

export class ValidationResult implements IValidationResult {
    isValid: boolean;
    tenantId: number;
    storeId: number;
    deviceType: ValidationResultDeviceType;
    message: string;
    deviceName: string;
    ipAddress: string;
    deviceId: number;

    constructor(data?: IValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isValid = data["isValid"];
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.deviceType = data["deviceType"];
            this.message = data["message"];
            this.deviceName = data["deviceName"];
            this.ipAddress = data["ipAddress"];
            this.deviceId = data["deviceId"];
        }
    }

    static fromJS(data: any): ValidationResult {
        let result = new ValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["deviceType"] = this.deviceType;
        data["message"] = this.message;
        data["deviceName"] = this.deviceName;
        data["ipAddress"] = this.ipAddress;
        data["deviceId"] = this.deviceId;
        return data; 
    }
}

export interface IValidationResult {
    isValid: boolean;
    tenantId: number;
    storeId: number;
    deviceType: ValidationResultDeviceType;
    message: string;
    deviceName: string;
    ipAddress: string;
    deviceId: number;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string;
    clientId: string;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string;
    clientId: string;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string;
    singleSignIn: boolean;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string;
    singleSignIn: boolean;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string;
}

export class TransactionResult implements ITransactionResult {
    saleId: string;
    isUpload: boolean;
    certificateStauts: number;

    constructor(data?: ITransactionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleId = data["saleId"];
            this.isUpload = data["isUpload"];
            this.certificateStauts = data["certificateStauts"];
        }
    }

    static fromJS(data: any): TransactionResult {
        let result = new TransactionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleId"] = this.saleId;
        data["isUpload"] = this.isUpload;
        data["certificateStauts"] = this.certificateStauts;
        return data; 
    }
}

export interface ITransactionResult {
    saleId: string;
    isUpload: boolean;
    certificateStauts: number;
}

export class TransactionBackDto implements ITransactionBackDto {
    saleId: string;
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    isReturned: boolean;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    storeId: number;
    isCertificate: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionId: number;
    saleDetails: TransactionDetailBackDto[];
    salePaymentTransactions: SalePaymentTransactionsDto[];
    saleOffers: TransactionOfferDto[];
    zatcaIntegrationInvoices: ZatcaTransactionDto[];
    status: TransactionBackDtoStatus;
    notes: string;
    date: moment.Moment;
    discount: number;
    discountValue: number;
    discountTypeId: boolean;
    templateType: TransactionBackDtoTemplateType;
    paymentMethod: number;

    constructor(data?: ITransactionBackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleId = data["saleId"];
            this.id = data["id"];
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.salesManId = data["salesManId"];
            this.isReturned = data["isReturned"];
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.cashierId = data["cashierId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.storeId = data["storeId"];
            this.isCertificate = data["isCertificate"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionId = data["promotionId"];
            if (data["saleDetails"] && data["saleDetails"].constructor === Array) {
                this.saleDetails = [];
                for (let item of data["saleDetails"])
                    this.saleDetails.push(TransactionDetailBackDto.fromJS(item));
            }
            if (data["salePaymentTransactions"] && data["salePaymentTransactions"].constructor === Array) {
                this.salePaymentTransactions = [];
                for (let item of data["salePaymentTransactions"])
                    this.salePaymentTransactions.push(SalePaymentTransactionsDto.fromJS(item));
            }
            if (data["saleOffers"] && data["saleOffers"].constructor === Array) {
                this.saleOffers = [];
                for (let item of data["saleOffers"])
                    this.saleOffers.push(TransactionOfferDto.fromJS(item));
            }
            if (data["zatcaIntegrationInvoices"] && data["zatcaIntegrationInvoices"].constructor === Array) {
                this.zatcaIntegrationInvoices = [];
                for (let item of data["zatcaIntegrationInvoices"])
                    this.zatcaIntegrationInvoices.push(ZatcaTransactionDto.fromJS(item));
            }
            this.status = data["status"];
            this.notes = data["notes"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.discountTypeId = data["discountTypeId"];
            this.templateType = data["templateType"];
            this.paymentMethod = data["paymentMethod"];
        }
    }

    static fromJS(data: any): TransactionBackDto {
        let result = new TransactionBackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleId"] = this.saleId;
        data["id"] = this.id;
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["salesManId"] = this.salesManId;
        data["isReturned"] = this.isReturned;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["cashierId"] = this.cashierId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["storeId"] = this.storeId;
        data["isCertificate"] = this.isCertificate;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionId"] = this.promotionId;
        if (this.saleDetails && this.saleDetails.constructor === Array) {
            data["saleDetails"] = [];
            for (let item of this.saleDetails)
                data["saleDetails"].push(item.toJSON());
        }
        if (this.salePaymentTransactions && this.salePaymentTransactions.constructor === Array) {
            data["salePaymentTransactions"] = [];
            for (let item of this.salePaymentTransactions)
                data["salePaymentTransactions"].push(item.toJSON());
        }
        if (this.saleOffers && this.saleOffers.constructor === Array) {
            data["saleOffers"] = [];
            for (let item of this.saleOffers)
                data["saleOffers"].push(item.toJSON());
        }
        if (this.zatcaIntegrationInvoices && this.zatcaIntegrationInvoices.constructor === Array) {
            data["zatcaIntegrationInvoices"] = [];
            for (let item of this.zatcaIntegrationInvoices)
                data["zatcaIntegrationInvoices"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["discountTypeId"] = this.discountTypeId;
        data["templateType"] = this.templateType;
        data["paymentMethod"] = this.paymentMethod;
        return data; 
    }
}

export interface ITransactionBackDto {
    saleId: string;
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    isReturned: boolean;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    storeId: number;
    isCertificate: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionId: number;
    saleDetails: TransactionDetailBackDto[];
    salePaymentTransactions: SalePaymentTransactionsDto[];
    saleOffers: TransactionOfferDto[];
    zatcaIntegrationInvoices: ZatcaTransactionDto[];
    status: TransactionBackDtoStatus;
    notes: string;
    date: moment.Moment;
    discount: number;
    discountValue: number;
    discountTypeId: boolean;
    templateType: TransactionBackDtoTemplateType;
    paymentMethod: number;
}

export class TransactionDetailBackDto implements ITransactionDetailBackDto {
    productLotId: number;
    productVariantId: number;
    productId: number;
    quantity: number;
    price: number;
    orgPrice: number;
    vatPercentage: number;
    isVAT: boolean;
    discount: number;
    discountValue: number;
    notes: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    vat: number;
    unitOfMeasureId: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionCodeId: number;
    serials: TransactionDetailSerialDto[];
    offerId: number;
    offertype: TransactionDetailBackDtoOffertype;
    unitOfMeasureName: string;
    productVariantName: string;
    productName: string;
    includeVAT: boolean;
    discountTypeId: boolean;

    constructor(data?: ITransactionDetailBackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productLotId = data["productLotId"];
            this.productVariantId = data["productVariantId"];
            this.productId = data["productId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.orgPrice = data["orgPrice"];
            this.vatPercentage = data["vatPercentage"];
            this.isVAT = data["isVAT"];
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.notes = data["notes"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.vat = data["vat"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionCodeId = data["promotionCodeId"];
            if (data["serials"] && data["serials"].constructor === Array) {
                this.serials = [];
                for (let item of data["serials"])
                    this.serials.push(TransactionDetailSerialDto.fromJS(item));
            }
            this.offerId = data["offerId"];
            this.offertype = data["offertype"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.productVariantName = data["productVariantName"];
            this.productName = data["productName"];
            this.includeVAT = data["includeVAT"];
            this.discountTypeId = data["discountTypeId"];
        }
    }

    static fromJS(data: any): TransactionDetailBackDto {
        let result = new TransactionDetailBackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLotId"] = this.productLotId;
        data["productVariantId"] = this.productVariantId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["orgPrice"] = this.orgPrice;
        data["vatPercentage"] = this.vatPercentage;
        data["isVAT"] = this.isVAT;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["notes"] = this.notes;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["vat"] = this.vat;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionCodeId"] = this.promotionCodeId;
        if (this.serials && this.serials.constructor === Array) {
            data["serials"] = [];
            for (let item of this.serials)
                data["serials"].push(item.toJSON());
        }
        data["offerId"] = this.offerId;
        data["offertype"] = this.offertype;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["productVariantName"] = this.productVariantName;
        data["productName"] = this.productName;
        data["includeVAT"] = this.includeVAT;
        data["discountTypeId"] = this.discountTypeId;
        return data; 
    }
}

export interface ITransactionDetailBackDto {
    productLotId: number;
    productVariantId: number;
    productId: number;
    quantity: number;
    price: number;
    orgPrice: number;
    vatPercentage: number;
    isVAT: boolean;
    discount: number;
    discountValue: number;
    notes: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    vat: number;
    unitOfMeasureId: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionCodeId: number;
    serials: TransactionDetailSerialDto[];
    offerId: number;
    offertype: TransactionDetailBackDtoOffertype;
    unitOfMeasureName: string;
    productVariantName: string;
    productName: string;
    includeVAT: boolean;
    discountTypeId: boolean;
}

export class ResponseDtoOfTransactionBackDto implements IResponseDtoOfTransactionBackDto {
    status: boolean;
    data: TransactionBackDto;

    constructor(data?: IResponseDtoOfTransactionBackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.data = data["data"] ? TransactionBackDto.fromJS(data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseDtoOfTransactionBackDto {
        let result = new ResponseDtoOfTransactionBackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IResponseDtoOfTransactionBackDto {
    status: boolean;
    data: TransactionBackDto;
}

export class ZatcaTransactionResult implements IZatcaTransactionResult {
    encodedInvoice: string;
    invoiceHash: string;
    uuid: string;
    qrCode: string;

    constructor(data?: IZatcaTransactionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.encodedInvoice = data["encodedInvoice"];
            this.invoiceHash = data["invoiceHash"];
            this.uuid = data["uuid"];
            this.qrCode = data["qrCode"];
        }
    }

    static fromJS(data: any): ZatcaTransactionResult {
        let result = new ZatcaTransactionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encodedInvoice"] = this.encodedInvoice;
        data["invoiceHash"] = this.invoiceHash;
        data["uuid"] = this.uuid;
        data["qrCode"] = this.qrCode;
        return data; 
    }
}

export interface IZatcaTransactionResult {
    encodedInvoice: string;
    invoiceHash: string;
    uuid: string;
    qrCode: string;
}

export class SaleTransactionSyncDto implements ISaleTransactionSyncDto {
    id: string;
    saleId: string;
    saleTypeId: number;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    posResponseN90: POSResponseN90SyncDto[];
    posResponseA90: POSResponseA90SyncDto[];
    saleDetails: SaleTransactionDetailSyncDto[];
    salepaymentTransactions: SalePaymentTransactionsSyncDto[];
    saleTransactionsDiningTables: SaleTransactionDiningTableSyncDto[];
    zatcaTransaction: ZatcaTransactionDto[];
    saleTransactionAddresses: SaleTransactionAddressSyncDto[];
    status: number;
    notes: string;
    date: moment.Moment;
    terminalId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    happyHourId: number;
    templateType: number;
    additionalAllowns: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    storeId: number;

    constructor(data?: ISaleTransactionSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleId = data["saleId"];
            this.saleTypeId = data["saleTypeId"];
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.salesManId = data["salesManId"];
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.cashierId = data["cashierId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            if (data["posResponseN90"] && data["posResponseN90"].constructor === Array) {
                this.posResponseN90 = [];
                for (let item of data["posResponseN90"])
                    this.posResponseN90.push(POSResponseN90SyncDto.fromJS(item));
            }
            if (data["posResponseA90"] && data["posResponseA90"].constructor === Array) {
                this.posResponseA90 = [];
                for (let item of data["posResponseA90"])
                    this.posResponseA90.push(POSResponseA90SyncDto.fromJS(item));
            }
            if (data["saleDetails"] && data["saleDetails"].constructor === Array) {
                this.saleDetails = [];
                for (let item of data["saleDetails"])
                    this.saleDetails.push(SaleTransactionDetailSyncDto.fromJS(item));
            }
            if (data["salepaymentTransactions"] && data["salepaymentTransactions"].constructor === Array) {
                this.salepaymentTransactions = [];
                for (let item of data["salepaymentTransactions"])
                    this.salepaymentTransactions.push(SalePaymentTransactionsSyncDto.fromJS(item));
            }
            if (data["saleTransactionsDiningTables"] && data["saleTransactionsDiningTables"].constructor === Array) {
                this.saleTransactionsDiningTables = [];
                for (let item of data["saleTransactionsDiningTables"])
                    this.saleTransactionsDiningTables.push(SaleTransactionDiningTableSyncDto.fromJS(item));
            }
            if (data["zatcaTransaction"] && data["zatcaTransaction"].constructor === Array) {
                this.zatcaTransaction = [];
                for (let item of data["zatcaTransaction"])
                    this.zatcaTransaction.push(ZatcaTransactionDto.fromJS(item));
            }
            if (data["saleTransactionAddresses"] && data["saleTransactionAddresses"].constructor === Array) {
                this.saleTransactionAddresses = [];
                for (let item of data["saleTransactionAddresses"])
                    this.saleTransactionAddresses.push(SaleTransactionAddressSyncDto.fromJS(item));
            }
            this.status = data["status"];
            this.notes = data["notes"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.terminalId = data["terminalId"];
            this.discount = data["discount"];
            this.discountType = data["discountType"];
            this.discountValue = data["discountValue"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.happyHourId = data["happyHourId"];
            this.templateType = data["templateType"];
            this.additionalAllowns = data["additionalAllowns"];
            this.endOfDayId = data["endOfDayId"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            this.createdDeviceId = data["createdDeviceId"];
            this.lastModficationDeviceId = data["lastModficationDeviceId"];
            this.storeId = data["storeId"];
        }
    }

    static fromJS(data: any): SaleTransactionSyncDto {
        let result = new SaleTransactionSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleId"] = this.saleId;
        data["saleTypeId"] = this.saleTypeId;
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["salesManId"] = this.salesManId;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["cashierId"] = this.cashierId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        if (this.posResponseN90 && this.posResponseN90.constructor === Array) {
            data["posResponseN90"] = [];
            for (let item of this.posResponseN90)
                data["posResponseN90"].push(item.toJSON());
        }
        if (this.posResponseA90 && this.posResponseA90.constructor === Array) {
            data["posResponseA90"] = [];
            for (let item of this.posResponseA90)
                data["posResponseA90"].push(item.toJSON());
        }
        if (this.saleDetails && this.saleDetails.constructor === Array) {
            data["saleDetails"] = [];
            for (let item of this.saleDetails)
                data["saleDetails"].push(item.toJSON());
        }
        if (this.salepaymentTransactions && this.salepaymentTransactions.constructor === Array) {
            data["salepaymentTransactions"] = [];
            for (let item of this.salepaymentTransactions)
                data["salepaymentTransactions"].push(item.toJSON());
        }
        if (this.saleTransactionsDiningTables && this.saleTransactionsDiningTables.constructor === Array) {
            data["saleTransactionsDiningTables"] = [];
            for (let item of this.saleTransactionsDiningTables)
                data["saleTransactionsDiningTables"].push(item.toJSON());
        }
        if (this.zatcaTransaction && this.zatcaTransaction.constructor === Array) {
            data["zatcaTransaction"] = [];
            for (let item of this.zatcaTransaction)
                data["zatcaTransaction"].push(item.toJSON());
        }
        if (this.saleTransactionAddresses && this.saleTransactionAddresses.constructor === Array) {
            data["saleTransactionAddresses"] = [];
            for (let item of this.saleTransactionAddresses)
                data["saleTransactionAddresses"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["terminalId"] = this.terminalId;
        data["discount"] = this.discount;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["happyHourId"] = this.happyHourId;
        data["templateType"] = this.templateType;
        data["additionalAllowns"] = this.additionalAllowns;
        data["endOfDayId"] = this.endOfDayId;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        data["createdDeviceId"] = this.createdDeviceId;
        data["lastModficationDeviceId"] = this.lastModficationDeviceId;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface ISaleTransactionSyncDto {
    id: string;
    saleId: string;
    saleTypeId: number;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    salesManId: number;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    posResponseN90: POSResponseN90SyncDto[];
    posResponseA90: POSResponseA90SyncDto[];
    saleDetails: SaleTransactionDetailSyncDto[];
    salepaymentTransactions: SalePaymentTransactionsSyncDto[];
    saleTransactionsDiningTables: SaleTransactionDiningTableSyncDto[];
    zatcaTransaction: ZatcaTransactionDto[];
    saleTransactionAddresses: SaleTransactionAddressSyncDto[];
    status: number;
    notes: string;
    date: moment.Moment;
    terminalId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    happyHourId: number;
    templateType: number;
    additionalAllowns: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    storeId: number;
}

export class SaleTransactionDetailSyncDto implements ISaleTransactionDetailSyncDto {
    id: string;
    saleTransactionId: string;
    productLotId: number;
    menuItemId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    additionalAllowns: number;
    allownsReason: string;
    loyaltyDiscount: number;
    saleTransactionDetailVarients: SaleTransactionDetailVarientSyncDto[];
    saleTransactionDetailsComboMealsItems: SaleTransactionDetailsComboMealsItemSyncDto[];
    saleTransactionsDetialsPromotionItems: SaleTransactionsDetialsPromotionItemSyncDto[];

    constructor(data?: ISaleTransactionDetailSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionId = data["saleTransactionId"];
            this.productLotId = data["productLotId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.notes = data["notes"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.tenantId = data["tenantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.offerId = data["offerId"];
            this.additionalAllowns = data["additionalAllowns"];
            this.allownsReason = data["allownsReason"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            if (data["saleTransactionDetailVarients"] && data["saleTransactionDetailVarients"].constructor === Array) {
                this.saleTransactionDetailVarients = [];
                for (let item of data["saleTransactionDetailVarients"])
                    this.saleTransactionDetailVarients.push(SaleTransactionDetailVarientSyncDto.fromJS(item));
            }
            if (data["saleTransactionDetailsComboMealsItems"] && data["saleTransactionDetailsComboMealsItems"].constructor === Array) {
                this.saleTransactionDetailsComboMealsItems = [];
                for (let item of data["saleTransactionDetailsComboMealsItems"])
                    this.saleTransactionDetailsComboMealsItems.push(SaleTransactionDetailsComboMealsItemSyncDto.fromJS(item));
            }
            if (data["saleTransactionsDetialsPromotionItems"] && data["saleTransactionsDetialsPromotionItems"].constructor === Array) {
                this.saleTransactionsDetialsPromotionItems = [];
                for (let item of data["saleTransactionsDetialsPromotionItems"])
                    this.saleTransactionsDetialsPromotionItems.push(SaleTransactionsDetialsPromotionItemSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaleTransactionDetailSyncDto {
        let result = new SaleTransactionDetailSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionId"] = this.saleTransactionId;
        data["productLotId"] = this.productLotId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["notes"] = this.notes;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["tenantId"] = this.tenantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["offerId"] = this.offerId;
        data["additionalAllowns"] = this.additionalAllowns;
        data["allownsReason"] = this.allownsReason;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        if (this.saleTransactionDetailVarients && this.saleTransactionDetailVarients.constructor === Array) {
            data["saleTransactionDetailVarients"] = [];
            for (let item of this.saleTransactionDetailVarients)
                data["saleTransactionDetailVarients"].push(item.toJSON());
        }
        if (this.saleTransactionDetailsComboMealsItems && this.saleTransactionDetailsComboMealsItems.constructor === Array) {
            data["saleTransactionDetailsComboMealsItems"] = [];
            for (let item of this.saleTransactionDetailsComboMealsItems)
                data["saleTransactionDetailsComboMealsItems"].push(item.toJSON());
        }
        if (this.saleTransactionsDetialsPromotionItems && this.saleTransactionsDetialsPromotionItems.constructor === Array) {
            data["saleTransactionsDetialsPromotionItems"] = [];
            for (let item of this.saleTransactionsDetialsPromotionItems)
                data["saleTransactionsDetialsPromotionItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaleTransactionDetailSyncDto {
    id: string;
    saleTransactionId: string;
    productLotId: number;
    menuItemId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    additionalAllowns: number;
    allownsReason: string;
    loyaltyDiscount: number;
    saleTransactionDetailVarients: SaleTransactionDetailVarientSyncDto[];
    saleTransactionDetailsComboMealsItems: SaleTransactionDetailsComboMealsItemSyncDto[];
    saleTransactionsDetialsPromotionItems: SaleTransactionsDetialsPromotionItemSyncDto[];
}

export class SalePaymentTransactionsSyncDto implements ISalePaymentTransactionsSyncDto {
    tenantId: number;
    currencyId: number;
    tenderTypeId: number;
    saleTransactionId: string;
    value: number;
    id: string;

    constructor(data?: ISalePaymentTransactionsSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.currencyId = data["currencyId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.saleTransactionId = data["saleTransactionId"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalePaymentTransactionsSyncDto {
        let result = new SalePaymentTransactionsSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["currencyId"] = this.currencyId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["saleTransactionId"] = this.saleTransactionId;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISalePaymentTransactionsSyncDto {
    tenantId: number;
    currencyId: number;
    tenderTypeId: number;
    saleTransactionId: string;
    value: number;
    id: string;
}

export class SaleTransactionDiningTableSyncDto implements ISaleTransactionDiningTableSyncDto {
    id: string;
    tenantId: number;
    saleTransactionId: number;
    tableId: number;
    isSplit: boolean;
    numberOfSeats: number;

    constructor(data?: ISaleTransactionDiningTableSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.saleTransactionId = data["saleTransactionId"];
            this.tableId = data["tableId"];
            this.isSplit = data["isSplit"];
            this.numberOfSeats = data["numberOfSeats"];
        }
    }

    static fromJS(data: any): SaleTransactionDiningTableSyncDto {
        let result = new SaleTransactionDiningTableSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["saleTransactionId"] = this.saleTransactionId;
        data["tableId"] = this.tableId;
        data["isSplit"] = this.isSplit;
        data["numberOfSeats"] = this.numberOfSeats;
        return data; 
    }
}

export interface ISaleTransactionDiningTableSyncDto {
    id: string;
    tenantId: number;
    saleTransactionId: number;
    tableId: number;
    isSplit: boolean;
    numberOfSeats: number;
}

export class SaleTransactionAddressSyncDto implements ISaleTransactionAddressSyncDto {
    id: string;
    saleTransactionId: string;
    city: string;
    link: string;
    address: string;
    deliveryStreetId: number;
    deliveryZoneId: number;

    constructor(data?: ISaleTransactionAddressSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionId = data["saleTransactionId"];
            this.city = data["city"];
            this.link = data["link"];
            this.address = data["address"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.deliveryZoneId = data["deliveryZoneId"];
        }
    }

    static fromJS(data: any): SaleTransactionAddressSyncDto {
        let result = new SaleTransactionAddressSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionId"] = this.saleTransactionId;
        data["city"] = this.city;
        data["link"] = this.link;
        data["address"] = this.address;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["deliveryZoneId"] = this.deliveryZoneId;
        return data; 
    }
}

export interface ISaleTransactionAddressSyncDto {
    id: string;
    saleTransactionId: string;
    city: string;
    link: string;
    address: string;
    deliveryStreetId: number;
    deliveryZoneId: number;
}

export class SaleTransactionDetailVarientSyncDto implements ISaleTransactionDetailVarientSyncDto {
    tenantId: number;
    saleTransactionDetailId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;

    constructor(data?: ISaleTransactionDetailVarientSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.variantId = data["variantId"];
            this.variantValueId = data["variantValueId"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.quantity = data["quantity"];
            this.freeQty = data["freeQty"];
        }
    }

    static fromJS(data: any): SaleTransactionDetailVarientSyncDto {
        let result = new SaleTransactionDetailVarientSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["variantId"] = this.variantId;
        data["variantValueId"] = this.variantValueId;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["quantity"] = this.quantity;
        data["freeQty"] = this.freeQty;
        return data; 
    }
}

export interface ISaleTransactionDetailVarientSyncDto {
    tenantId: number;
    saleTransactionDetailId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
}

export class SaleTransactionDetailsComboMealsItemSyncDto implements ISaleTransactionDetailsComboMealsItemSyncDto {
    id: string;
    menuItemId: number;
    quantity: number;
    saleTransactionDetailId: string;
    price: number;
    tenantId: number;

    constructor(data?: ISaleTransactionDetailsComboMealsItemSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.price = data["price"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): SaleTransactionDetailsComboMealsItemSyncDto {
        let result = new SaleTransactionDetailsComboMealsItemSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ISaleTransactionDetailsComboMealsItemSyncDto {
    id: string;
    menuItemId: number;
    quantity: number;
    saleTransactionDetailId: string;
    price: number;
    tenantId: number;
}

export class SaleTransactionsDetialsPromotionItemSyncDto implements ISaleTransactionsDetialsPromotionItemSyncDto {
    id: string;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;

    constructor(data?: ISaleTransactionsDetialsPromotionItemSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludeVat = data["priceIncludeVat"];
        }
    }

    static fromJS(data: any): SaleTransactionsDetialsPromotionItemSyncDto {
        let result = new SaleTransactionsDetialsPromotionItemSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludeVat"] = this.priceIncludeVat;
        return data; 
    }
}

export interface ISaleTransactionsDetialsPromotionItemSyncDto {
    id: string;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
}

export class SaleNotificationSyncDto implements ISaleNotificationSyncDto {
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    status: number;
    tenantId: number;
    notes: string;
    isUploaded: boolean;
    isShift: boolean;
    saleTypeId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    date: moment.Moment;
    terminalId: number;
    happyHourId: number;
    templateType: number;
    isPrinted: boolean;
    additionalAllowns: number;
    endOfDayId: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    storeId: number;
    saleNotificationDetails: SaleNotificationDetailSyncDto[];
    salePaymentNotifications: SalePaymentNotificationSyncDto[];

    constructor(data?: ISaleNotificationSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.cashierId = data["cashierId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
            this.isUploaded = data["isUploaded"];
            this.isShift = data["isShift"];
            this.saleTypeId = data["saleTypeId"];
            this.discount = data["discount"];
            this.discountType = data["discountType"];
            this.discountValue = data["discountValue"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.terminalId = data["terminalId"];
            this.happyHourId = data["happyHourId"];
            this.templateType = data["templateType"];
            this.isPrinted = data["isPrinted"];
            this.additionalAllowns = data["additionalAllowns"];
            this.endOfDayId = data["endOfDayId"];
            this.createdDeviceId = data["createdDeviceId"];
            this.lastModficationDeviceId = data["lastModficationDeviceId"];
            this.storeId = data["storeId"];
            if (data["saleNotificationDetails"] && data["saleNotificationDetails"].constructor === Array) {
                this.saleNotificationDetails = [];
                for (let item of data["saleNotificationDetails"])
                    this.saleNotificationDetails.push(SaleNotificationDetailSyncDto.fromJS(item));
            }
            if (data["salePaymentNotifications"] && data["salePaymentNotifications"].constructor === Array) {
                this.salePaymentNotifications = [];
                for (let item of data["salePaymentNotifications"])
                    this.salePaymentNotifications.push(SalePaymentNotificationSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaleNotificationSyncDto {
        let result = new SaleNotificationSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["cashierId"] = this.cashierId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        data["isUploaded"] = this.isUploaded;
        data["isShift"] = this.isShift;
        data["saleTypeId"] = this.saleTypeId;
        data["discount"] = this.discount;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["terminalId"] = this.terminalId;
        data["happyHourId"] = this.happyHourId;
        data["templateType"] = this.templateType;
        data["isPrinted"] = this.isPrinted;
        data["additionalAllowns"] = this.additionalAllowns;
        data["endOfDayId"] = this.endOfDayId;
        data["createdDeviceId"] = this.createdDeviceId;
        data["lastModficationDeviceId"] = this.lastModficationDeviceId;
        data["storeId"] = this.storeId;
        if (this.saleNotificationDetails && this.saleNotificationDetails.constructor === Array) {
            data["saleNotificationDetails"] = [];
            for (let item of this.saleNotificationDetails)
                data["saleNotificationDetails"].push(item.toJSON());
        }
        if (this.salePaymentNotifications && this.salePaymentNotifications.constructor === Array) {
            data["salePaymentNotifications"] = [];
            for (let item of this.salePaymentNotifications)
                data["salePaymentNotifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaleNotificationSyncDto {
    id: string;
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    status: number;
    tenantId: number;
    notes: string;
    isUploaded: boolean;
    isShift: boolean;
    saleTypeId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    date: moment.Moment;
    terminalId: number;
    happyHourId: number;
    templateType: number;
    isPrinted: boolean;
    additionalAllowns: number;
    endOfDayId: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    storeId: number;
    saleNotificationDetails: SaleNotificationDetailSyncDto[];
    salePaymentNotifications: SalePaymentNotificationSyncDto[];
}

export class SaleNotificationDetailSyncDto implements ISaleNotificationDetailSyncDto {
    id: string;
    saleNotificationId: string;
    productLotId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    offerType: number;
    vat: number;
    vatBeforeDiscount: number;
    notes: string;
    comboGroupId: number;
    additionalAllowns: number;
    allownsReason: string;
    menuItemId: number;
    saleNotificationReasonDetails: SaleNotificationReasonDetailDto[];
    saleNotificationDetailVarients: SaleNotificationDetailVarientSyncDto[];
    saleNotificationDetailsComboMealsItemSyncDtos: SaleNotificationDetailsComboMealsItemSyncDto[];
    saleNotifcationsDetialsPromotionItems: SaleNotifcationsDetialsPromotionItemSyncDto[];

    constructor(data?: ISaleNotificationDetailSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleNotificationId = data["saleNotificationId"];
            this.productLotId = data["productLotId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.discount = data["discount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.tenantId = data["tenantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.offerId = data["offerId"];
            this.offerType = data["offerType"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.notes = data["notes"];
            this.comboGroupId = data["comboGroupId"];
            this.additionalAllowns = data["additionalAllowns"];
            this.allownsReason = data["allownsReason"];
            this.menuItemId = data["menuItemId"];
            if (data["saleNotificationReasonDetails"] && data["saleNotificationReasonDetails"].constructor === Array) {
                this.saleNotificationReasonDetails = [];
                for (let item of data["saleNotificationReasonDetails"])
                    this.saleNotificationReasonDetails.push(SaleNotificationReasonDetailDto.fromJS(item));
            }
            if (data["saleNotificationDetailVarients"] && data["saleNotificationDetailVarients"].constructor === Array) {
                this.saleNotificationDetailVarients = [];
                for (let item of data["saleNotificationDetailVarients"])
                    this.saleNotificationDetailVarients.push(SaleNotificationDetailVarientSyncDto.fromJS(item));
            }
            if (data["saleNotificationDetailsComboMealsItemSyncDtos"] && data["saleNotificationDetailsComboMealsItemSyncDtos"].constructor === Array) {
                this.saleNotificationDetailsComboMealsItemSyncDtos = [];
                for (let item of data["saleNotificationDetailsComboMealsItemSyncDtos"])
                    this.saleNotificationDetailsComboMealsItemSyncDtos.push(SaleNotificationDetailsComboMealsItemSyncDto.fromJS(item));
            }
            if (data["saleNotifcationsDetialsPromotionItems"] && data["saleNotifcationsDetialsPromotionItems"].constructor === Array) {
                this.saleNotifcationsDetialsPromotionItems = [];
                for (let item of data["saleNotifcationsDetialsPromotionItems"])
                    this.saleNotifcationsDetialsPromotionItems.push(SaleNotifcationsDetialsPromotionItemSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaleNotificationDetailSyncDto {
        let result = new SaleNotificationDetailSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleNotificationId"] = this.saleNotificationId;
        data["productLotId"] = this.productLotId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["discount"] = this.discount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["tenantId"] = this.tenantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["offerId"] = this.offerId;
        data["offerType"] = this.offerType;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["notes"] = this.notes;
        data["comboGroupId"] = this.comboGroupId;
        data["additionalAllowns"] = this.additionalAllowns;
        data["allownsReason"] = this.allownsReason;
        data["menuItemId"] = this.menuItemId;
        if (this.saleNotificationReasonDetails && this.saleNotificationReasonDetails.constructor === Array) {
            data["saleNotificationReasonDetails"] = [];
            for (let item of this.saleNotificationReasonDetails)
                data["saleNotificationReasonDetails"].push(item.toJSON());
        }
        if (this.saleNotificationDetailVarients && this.saleNotificationDetailVarients.constructor === Array) {
            data["saleNotificationDetailVarients"] = [];
            for (let item of this.saleNotificationDetailVarients)
                data["saleNotificationDetailVarients"].push(item.toJSON());
        }
        if (this.saleNotificationDetailsComboMealsItemSyncDtos && this.saleNotificationDetailsComboMealsItemSyncDtos.constructor === Array) {
            data["saleNotificationDetailsComboMealsItemSyncDtos"] = [];
            for (let item of this.saleNotificationDetailsComboMealsItemSyncDtos)
                data["saleNotificationDetailsComboMealsItemSyncDtos"].push(item.toJSON());
        }
        if (this.saleNotifcationsDetialsPromotionItems && this.saleNotifcationsDetialsPromotionItems.constructor === Array) {
            data["saleNotifcationsDetialsPromotionItems"] = [];
            for (let item of this.saleNotifcationsDetialsPromotionItems)
                data["saleNotifcationsDetialsPromotionItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaleNotificationDetailSyncDto {
    id: string;
    saleNotificationId: string;
    productLotId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    offerType: number;
    vat: number;
    vatBeforeDiscount: number;
    notes: string;
    comboGroupId: number;
    additionalAllowns: number;
    allownsReason: string;
    menuItemId: number;
    saleNotificationReasonDetails: SaleNotificationReasonDetailDto[];
    saleNotificationDetailVarients: SaleNotificationDetailVarientSyncDto[];
    saleNotificationDetailsComboMealsItemSyncDtos: SaleNotificationDetailsComboMealsItemSyncDto[];
    saleNotifcationsDetialsPromotionItems: SaleNotifcationsDetialsPromotionItemSyncDto[];
}

export class SalePaymentNotificationSyncDto implements ISalePaymentNotificationSyncDto {
    id: string;
    tenantId: number;
    currencyId: number;
    tenderTypeId: number;
    saleNotificationId: string;
    value: number;

    constructor(data?: ISalePaymentNotificationSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.currencyId = data["currencyId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.saleNotificationId = data["saleNotificationId"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): SalePaymentNotificationSyncDto {
        let result = new SalePaymentNotificationSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["currencyId"] = this.currencyId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["saleNotificationId"] = this.saleNotificationId;
        data["value"] = this.value;
        return data; 
    }
}

export interface ISalePaymentNotificationSyncDto {
    id: string;
    tenantId: number;
    currencyId: number;
    tenderTypeId: number;
    saleNotificationId: string;
    value: number;
}

export class SaleNotificationReasonDetailDto implements ISaleNotificationReasonDetailDto {
    saleNotificationDetailId: string;
    refundResonId: number;

    constructor(data?: ISaleNotificationReasonDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
            this.refundResonId = data["refundResonId"];
        }
    }

    static fromJS(data: any): SaleNotificationReasonDetailDto {
        let result = new SaleNotificationReasonDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        data["refundResonId"] = this.refundResonId;
        return data; 
    }
}

export interface ISaleNotificationReasonDetailDto {
    saleNotificationDetailId: string;
    refundResonId: number;
}

export class SaleNotificationDetailVarientSyncDto implements ISaleNotificationDetailVarientSyncDto {
    tenantId: number;
    saleNotificationDetailId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;

    constructor(data?: ISaleNotificationDetailVarientSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
            this.variantId = data["variantId"];
            this.variantValueId = data["variantValueId"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.quantity = data["quantity"];
            this.freeQty = data["freeQty"];
        }
    }

    static fromJS(data: any): SaleNotificationDetailVarientSyncDto {
        let result = new SaleNotificationDetailVarientSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        data["variantId"] = this.variantId;
        data["variantValueId"] = this.variantValueId;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["quantity"] = this.quantity;
        data["freeQty"] = this.freeQty;
        return data; 
    }
}

export interface ISaleNotificationDetailVarientSyncDto {
    tenantId: number;
    saleNotificationDetailId: string;
    variantId: number;
    variantValueId: number;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
}

export class SaleNotificationDetailsComboMealsItemSyncDto implements ISaleNotificationDetailsComboMealsItemSyncDto {
    id: string;
    tenantId: number;
    quantity: number;
    price: number;
    originalQuantity: number;
    menuItemId: number;
    saleNotificationDetailId: string;

    constructor(data?: ISaleNotificationDetailsComboMealsItemSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.originalQuantity = data["originalQuantity"];
            this.menuItemId = data["menuItemId"];
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
        }
    }

    static fromJS(data: any): SaleNotificationDetailsComboMealsItemSyncDto {
        let result = new SaleNotificationDetailsComboMealsItemSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["originalQuantity"] = this.originalQuantity;
        data["menuItemId"] = this.menuItemId;
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        return data; 
    }
}

export interface ISaleNotificationDetailsComboMealsItemSyncDto {
    id: string;
    tenantId: number;
    quantity: number;
    price: number;
    originalQuantity: number;
    menuItemId: number;
    saleNotificationDetailId: string;
}

export class SaleNotifcationsDetialsPromotionItemSyncDto implements ISaleNotifcationsDetialsPromotionItemSyncDto {
    id: string;
    saleNotificationDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;

    constructor(data?: ISaleNotifcationsDetialsPromotionItemSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludeVat = data["priceIncludeVat"];
        }
    }

    static fromJS(data: any): SaleNotifcationsDetialsPromotionItemSyncDto {
        let result = new SaleNotifcationsDetialsPromotionItemSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludeVat"] = this.priceIncludeVat;
        return data; 
    }
}

export interface ISaleNotifcationsDetialsPromotionItemSyncDto {
    id: string;
    saleNotificationDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
}

export class PagedTransactionList implements IPagedTransactionList {
    currentPage: number;
    itemsCount: number;
    transactions: TransactionDto[];

    constructor(data?: IPagedTransactionList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["transactions"] && data["transactions"].constructor === Array) {
                this.transactions = [];
                for (let item of data["transactions"])
                    this.transactions.push(TransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedTransactionList {
        let result = new PagedTransactionList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.transactions && this.transactions.constructor === Array) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedTransactionList {
    currentPage: number;
    itemsCount: number;
    transactions: TransactionDto[];
}

export class ListResultDtoOfTransactionTemplateListItem implements IListResultDtoOfTransactionTemplateListItem {
    items: TransactionTemplateListItem[];

    constructor(data?: IListResultDtoOfTransactionTemplateListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TransactionTemplateListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTransactionTemplateListItem {
        let result = new ListResultDtoOfTransactionTemplateListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTransactionTemplateListItem {
    items: TransactionTemplateListItem[];
}

export class TransactionTemplateListItem implements ITransactionTemplateListItem {
    id: number;
    name: string;
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];

    constructor(data?: ITransactionTemplateListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            if (data["detailTransactionTemplate"] && data["detailTransactionTemplate"].constructor === Array) {
                this.detailTransactionTemplate = [];
                for (let item of data["detailTransactionTemplate"])
                    this.detailTransactionTemplate.push(DetailTransactionTemplateDto.fromJS(item));
            }
            if (data["transactionTemplateTypeIds"] && data["transactionTemplateTypeIds"].constructor === Array) {
                this.transactionTemplateTypeIds = [];
                for (let item of data["transactionTemplateTypeIds"])
                    this.transactionTemplateTypeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TransactionTemplateTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionTemplateListItem {
        let result = new TransactionTemplateListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        if (this.detailTransactionTemplate && this.detailTransactionTemplate.constructor === Array) {
            data["detailTransactionTemplate"] = [];
            for (let item of this.detailTransactionTemplate)
                data["detailTransactionTemplate"].push(item.toJSON());
        }
        if (this.transactionTemplateTypeIds && this.transactionTemplateTypeIds.constructor === Array) {
            data["transactionTemplateTypeIds"] = [];
            for (let item of this.transactionTemplateTypeIds)
                data["transactionTemplateTypeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransactionTemplateListItem {
    id: number;
    name: string;
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];
}

export class DetailTransactionTemplateDto implements IDetailTransactionTemplateDto {
    id: number;
    detailTransactionId: number;
    mainTransactionId: number;
    materialId: number;
    materialName: string;
    transactionTemplateId: number;
    qty: number;
    price: number;
    originalQunatity: number;
    qtyReceive: number;
    lotNumber: number;
    restQunatity: number;
    discount: number;
    tax: number;
    notes: string;
    tenantId: number;
    addAndMinus: number;
    discountType: number;
    inventoryQuanity: number;
    purchaseQuantity: number;
    dueDate: moment.Moment;
    hasDueDate: boolean;
    rawMaterial: RawMaterialDto;
    productId: number;
    index: number;
    productName: string;
    productVariantName: string;
    unitOfMeasureName: string;
    product: ProductDto;
    products: GetProductOutput[];
    productList: ProductListItem[];
    productVariantId: number;
    unitOfMeasureId: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    barCode: string;
    stockQunatity: number;
    taxId: number;
    netAfterVat: number;
    itemCost: DetailTransactionTemplateDtoItemCost;
    primarycategories: PrimaryCategoryListItem[];
    secondarycategories: SecondaryCategoryListItem[];
    productcategories: ProductCategoryListItem[];
    variants: VariantListItem[];
    unitsOfMeasures: UnitOfMeasureListItem[];

    constructor(data?: IDetailTransactionTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.detailTransactionId = data["detailTransactionId"];
            this.mainTransactionId = data["mainTransactionId"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.qty = data["qty"];
            this.price = data["price"];
            this.originalQunatity = data["originalQunatity"];
            this.qtyReceive = data["qtyReceive"];
            this.lotNumber = data["lotNumber"];
            this.restQunatity = data["restQunatity"];
            this.discount = data["discount"];
            this.tax = data["tax"];
            this.notes = data["notes"];
            this.tenantId = data["tenantId"];
            this.addAndMinus = data["addAndMinus"];
            this.discountType = data["discountType"];
            this.inventoryQuanity = data["inventoryQuanity"];
            this.purchaseQuantity = data["purchaseQuantity"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.hasDueDate = data["hasDueDate"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterialDto.fromJS(data["rawMaterial"]) : <any>undefined;
            this.productId = data["productId"];
            this.index = data["index"];
            this.productName = data["productName"];
            this.productVariantName = data["productVariantName"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.product = data["product"] ? ProductDto.fromJS(data["product"]) : <any>undefined;
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(GetProductOutput.fromJS(item));
            }
            if (data["productList"] && data["productList"].constructor === Array) {
                this.productList = [];
                for (let item of data["productList"])
                    this.productList.push(ProductListItem.fromJS(item));
            }
            this.productVariantId = data["productVariantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.productCategoryId = data["productCategoryId"];
            this.barCode = data["barCode"];
            this.stockQunatity = data["stockQunatity"];
            this.taxId = data["taxId"];
            this.netAfterVat = data["netAfterVat"];
            this.itemCost = data["itemCost"];
            if (data["primarycategories"] && data["primarycategories"].constructor === Array) {
                this.primarycategories = [];
                for (let item of data["primarycategories"])
                    this.primarycategories.push(PrimaryCategoryListItem.fromJS(item));
            }
            if (data["secondarycategories"] && data["secondarycategories"].constructor === Array) {
                this.secondarycategories = [];
                for (let item of data["secondarycategories"])
                    this.secondarycategories.push(SecondaryCategoryListItem.fromJS(item));
            }
            if (data["productcategories"] && data["productcategories"].constructor === Array) {
                this.productcategories = [];
                for (let item of data["productcategories"])
                    this.productcategories.push(ProductCategoryListItem.fromJS(item));
            }
            if (data["variants"] && data["variants"].constructor === Array) {
                this.variants = [];
                for (let item of data["variants"])
                    this.variants.push(VariantListItem.fromJS(item));
            }
            if (data["unitsOfMeasures"] && data["unitsOfMeasures"].constructor === Array) {
                this.unitsOfMeasures = [];
                for (let item of data["unitsOfMeasures"])
                    this.unitsOfMeasures.push(UnitOfMeasureListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailTransactionTemplateDto {
        let result = new DetailTransactionTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["detailTransactionId"] = this.detailTransactionId;
        data["mainTransactionId"] = this.mainTransactionId;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["originalQunatity"] = this.originalQunatity;
        data["qtyReceive"] = this.qtyReceive;
        data["lotNumber"] = this.lotNumber;
        data["restQunatity"] = this.restQunatity;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["notes"] = this.notes;
        data["tenantId"] = this.tenantId;
        data["addAndMinus"] = this.addAndMinus;
        data["discountType"] = this.discountType;
        data["inventoryQuanity"] = this.inventoryQuanity;
        data["purchaseQuantity"] = this.purchaseQuantity;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["hasDueDate"] = this.hasDueDate;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["index"] = this.index;
        data["productName"] = this.productName;
        data["productVariantName"] = this.productVariantName;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.productList && this.productList.constructor === Array) {
            data["productList"] = [];
            for (let item of this.productList)
                data["productList"].push(item.toJSON());
        }
        data["productVariantId"] = this.productVariantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["productCategoryId"] = this.productCategoryId;
        data["barCode"] = this.barCode;
        data["stockQunatity"] = this.stockQunatity;
        data["taxId"] = this.taxId;
        data["netAfterVat"] = this.netAfterVat;
        data["itemCost"] = this.itemCost;
        if (this.primarycategories && this.primarycategories.constructor === Array) {
            data["primarycategories"] = [];
            for (let item of this.primarycategories)
                data["primarycategories"].push(item.toJSON());
        }
        if (this.secondarycategories && this.secondarycategories.constructor === Array) {
            data["secondarycategories"] = [];
            for (let item of this.secondarycategories)
                data["secondarycategories"].push(item.toJSON());
        }
        if (this.productcategories && this.productcategories.constructor === Array) {
            data["productcategories"] = [];
            for (let item of this.productcategories)
                data["productcategories"].push(item.toJSON());
        }
        if (this.variants && this.variants.constructor === Array) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        if (this.unitsOfMeasures && this.unitsOfMeasures.constructor === Array) {
            data["unitsOfMeasures"] = [];
            for (let item of this.unitsOfMeasures)
                data["unitsOfMeasures"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDetailTransactionTemplateDto {
    id: number;
    detailTransactionId: number;
    mainTransactionId: number;
    materialId: number;
    materialName: string;
    transactionTemplateId: number;
    qty: number;
    price: number;
    originalQunatity: number;
    qtyReceive: number;
    lotNumber: number;
    restQunatity: number;
    discount: number;
    tax: number;
    notes: string;
    tenantId: number;
    addAndMinus: number;
    discountType: number;
    inventoryQuanity: number;
    purchaseQuantity: number;
    dueDate: moment.Moment;
    hasDueDate: boolean;
    rawMaterial: RawMaterialDto;
    productId: number;
    index: number;
    productName: string;
    productVariantName: string;
    unitOfMeasureName: string;
    product: ProductDto;
    products: GetProductOutput[];
    productList: ProductListItem[];
    productVariantId: number;
    unitOfMeasureId: number;
    primaryCategoryId: number;
    secondaryCategoryId: number;
    productCategoryId: number;
    barCode: string;
    stockQunatity: number;
    taxId: number;
    netAfterVat: number;
    itemCost: DetailTransactionTemplateDtoItemCost;
    primarycategories: PrimaryCategoryListItem[];
    secondarycategories: SecondaryCategoryListItem[];
    productcategories: ProductCategoryListItem[];
    variants: VariantListItem[];
    unitsOfMeasures: UnitOfMeasureListItem[];
}

export class TransactionTemplateTranslationDto implements ITransactionTemplateTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: ITransactionTemplateTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): TransactionTemplateTranslationDto {
        let result = new TransactionTemplateTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface ITransactionTemplateTranslationDto {
    name: string;
    languageId: number;
}

export class TransactionTemplateDto implements ITransactionTemplateDto {
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITransactionTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["detailTransactionTemplate"] && data["detailTransactionTemplate"].constructor === Array) {
                this.detailTransactionTemplate = [];
                for (let item of data["detailTransactionTemplate"])
                    this.detailTransactionTemplate.push(DetailTransactionTemplateDto.fromJS(item));
            }
            if (data["transactionTemplateTypeIds"] && data["transactionTemplateTypeIds"].constructor === Array) {
                this.transactionTemplateTypeIds = [];
                for (let item of data["transactionTemplateTypeIds"])
                    this.transactionTemplateTypeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TransactionTemplateTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionTemplateDto {
        let result = new TransactionTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.detailTransactionTemplate && this.detailTransactionTemplate.constructor === Array) {
            data["detailTransactionTemplate"] = [];
            for (let item of this.detailTransactionTemplate)
                data["detailTransactionTemplate"].push(item.toJSON());
        }
        if (this.transactionTemplateTypeIds && this.transactionTemplateTypeIds.constructor === Array) {
            data["transactionTemplateTypeIds"] = [];
            for (let item of this.transactionTemplateTypeIds)
                data["transactionTemplateTypeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionTemplateDto {
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedTransactionTemplateList implements IPagedTransactionTemplateList {
    currentPage: number;
    itemsCount: number;
    transactionTemplates: TransactionTemplateListItem[];

    constructor(data?: IPagedTransactionTemplateList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["transactionTemplates"] && data["transactionTemplates"].constructor === Array) {
                this.transactionTemplates = [];
                for (let item of data["transactionTemplates"])
                    this.transactionTemplates.push(TransactionTemplateListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedTransactionTemplateList {
        let result = new PagedTransactionTemplateList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.transactionTemplates && this.transactionTemplates.constructor === Array) {
            data["transactionTemplates"] = [];
            for (let item of this.transactionTemplates)
                data["transactionTemplates"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedTransactionTemplateList {
    currentPage: number;
    itemsCount: number;
    transactionTemplates: TransactionTemplateListItem[];
}

export class CreateTransactionTemplateInput implements ICreateTransactionTemplateInput {
    tenantId: number;
    transactionTypeId: number;
    transactionTemplateId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];

    constructor(data?: ICreateTransactionTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.transactionTemplateId = data["transactionTemplateId"];
            if (data["detailTransactionTemplate"] && data["detailTransactionTemplate"].constructor === Array) {
                this.detailTransactionTemplate = [];
                for (let item of data["detailTransactionTemplate"])
                    this.detailTransactionTemplate.push(DetailTransactionTemplateDto.fromJS(item));
            }
            if (data["transactionTemplateTypeIds"] && data["transactionTemplateTypeIds"].constructor === Array) {
                this.transactionTemplateTypeIds = [];
                for (let item of data["transactionTemplateTypeIds"])
                    this.transactionTemplateTypeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TransactionTemplateTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTransactionTemplateInput {
        let result = new CreateTransactionTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionTemplateId"] = this.transactionTemplateId;
        if (this.detailTransactionTemplate && this.detailTransactionTemplate.constructor === Array) {
            data["detailTransactionTemplate"] = [];
            for (let item of this.detailTransactionTemplate)
                data["detailTransactionTemplate"].push(item.toJSON());
        }
        if (this.transactionTemplateTypeIds && this.transactionTemplateTypeIds.constructor === Array) {
            data["transactionTemplateTypeIds"] = [];
            for (let item of this.transactionTemplateTypeIds)
                data["transactionTemplateTypeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateTransactionTemplateInput {
    tenantId: number;
    transactionTypeId: number;
    transactionTemplateId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];
}

export class EditTransactionTemplateInput implements IEditTransactionTemplateInput {
    transactionTemplateId: number;
    transactionTypeId: number;
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];

    constructor(data?: IEditTransactionTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionTemplateId = data["transactionTemplateId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.tenantId = data["tenantId"];
            if (data["detailTransactionTemplate"] && data["detailTransactionTemplate"].constructor === Array) {
                this.detailTransactionTemplate = [];
                for (let item of data["detailTransactionTemplate"])
                    this.detailTransactionTemplate.push(DetailTransactionTemplateDto.fromJS(item));
            }
            if (data["transactionTemplateTypeIds"] && data["transactionTemplateTypeIds"].constructor === Array) {
                this.transactionTemplateTypeIds = [];
                for (let item of data["transactionTemplateTypeIds"])
                    this.transactionTemplateTypeIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TransactionTemplateTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditTransactionTemplateInput {
        let result = new EditTransactionTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["tenantId"] = this.tenantId;
        if (this.detailTransactionTemplate && this.detailTransactionTemplate.constructor === Array) {
            data["detailTransactionTemplate"] = [];
            for (let item of this.detailTransactionTemplate)
                data["detailTransactionTemplate"].push(item.toJSON());
        }
        if (this.transactionTemplateTypeIds && this.transactionTemplateTypeIds.constructor === Array) {
            data["transactionTemplateTypeIds"] = [];
            for (let item of this.transactionTemplateTypeIds)
                data["transactionTemplateTypeIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditTransactionTemplateInput {
    transactionTemplateId: number;
    transactionTypeId: number;
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplateDto[];
    transactionTemplateTypeIds: number[];
    translations: TransactionTemplateTranslationDto[];
}

export class ListResultDtoOfTransactionTypeListItem implements IListResultDtoOfTransactionTypeListItem {
    items: TransactionTypeListItem[];

    constructor(data?: IListResultDtoOfTransactionTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TransactionTypeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTransactionTypeListItem {
        let result = new ListResultDtoOfTransactionTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTransactionTypeListItem {
    items: TransactionTypeListItem[];
}

export class TransactionTypeListItem implements ITransactionTypeListItem {
    id: number;
    name: string;
    underRevision: boolean;
    roleIds: number[];
    roleTransactionType: RoleTransactionTypeDto[];

    constructor(data?: ITransactionTypeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.underRevision = data["underRevision"];
            if (data["roleIds"] && data["roleIds"].constructor === Array) {
                this.roleIds = [];
                for (let item of data["roleIds"])
                    this.roleIds.push(item);
            }
            if (data["roleTransactionType"] && data["roleTransactionType"].constructor === Array) {
                this.roleTransactionType = [];
                for (let item of data["roleTransactionType"])
                    this.roleTransactionType.push(RoleTransactionTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionTypeListItem {
        let result = new TransactionTypeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["underRevision"] = this.underRevision;
        if (this.roleIds && this.roleIds.constructor === Array) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (this.roleTransactionType && this.roleTransactionType.constructor === Array) {
            data["roleTransactionType"] = [];
            for (let item of this.roleTransactionType)
                data["roleTransactionType"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransactionTypeListItem {
    id: number;
    name: string;
    underRevision: boolean;
    roleIds: number[];
    roleTransactionType: RoleTransactionTypeDto[];
}

export class ProductLotLDetails implements IProductLotLDetails {
    lotId: number;
    productName: string;
    availableQuantity: number;
    unitOfMeasureName: string;
    expirationDate: string;

    constructor(data?: IProductLotLDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lotId = data["lotId"];
            this.productName = data["productName"];
            this.availableQuantity = data["availableQuantity"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.expirationDate = data["expirationDate"];
        }
    }

    static fromJS(data: any): ProductLotLDetails {
        let result = new ProductLotLDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotId"] = this.lotId;
        data["productName"] = this.productName;
        data["availableQuantity"] = this.availableQuantity;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["expirationDate"] = this.expirationDate;
        return data; 
    }
}

export interface IProductLotLDetails {
    lotId: number;
    productName: string;
    availableQuantity: number;
    unitOfMeasureName: string;
    expirationDate: string;
}

export class TransferMerchantdiseInput implements ITransferMerchantdiseInput {
    transferedLots: TransferedLotsDto[];
    transferedStoreId: number;

    constructor(data?: ITransferMerchantdiseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["transferedLots"] && data["transferedLots"].constructor === Array) {
                this.transferedLots = [];
                for (let item of data["transferedLots"])
                    this.transferedLots.push(TransferedLotsDto.fromJS(item));
            }
            this.transferedStoreId = data["transferedStoreId"];
        }
    }

    static fromJS(data: any): TransferMerchantdiseInput {
        let result = new TransferMerchantdiseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.transferedLots && this.transferedLots.constructor === Array) {
            data["transferedLots"] = [];
            for (let item of this.transferedLots)
                data["transferedLots"].push(item.toJSON());
        }
        data["transferedStoreId"] = this.transferedStoreId;
        return data; 
    }
}

export interface ITransferMerchantdiseInput {
    transferedLots: TransferedLotsDto[];
    transferedStoreId: number;
}

export class TransferedLotsDto implements ITransferedLotsDto {
    oldLotId: number;
    productName: string;
    transferedAmount: number;
    unitOfMeasure: string;

    constructor(data?: ITransferedLotsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.oldLotId = data["oldLotId"];
            this.productName = data["productName"];
            this.transferedAmount = data["transferedAmount"];
            this.unitOfMeasure = data["unitOfMeasure"];
        }
    }

    static fromJS(data: any): TransferedLotsDto {
        let result = new TransferedLotsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldLotId"] = this.oldLotId;
        data["productName"] = this.productName;
        data["transferedAmount"] = this.transferedAmount;
        data["unitOfMeasure"] = this.unitOfMeasure;
        return data; 
    }
}

export interface ITransferedLotsDto {
    oldLotId: number;
    productName: string;
    transferedAmount: number;
    unitOfMeasure: string;
}

export class UiCustomizationSettingsEditDto implements IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;

    constructor(data?: IUiCustomizationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layout = data["layout"] ? UiCustomizationLayoutSettingsEditDto.fromJS(data["layout"]) : <any>undefined;
            this.header = data["header"] ? UiCustomizationHeaderSettingsEditDto.fromJS(data["header"]) : <any>undefined;
            this.menu = data["menu"] ? UiCustomizationMenuSettingsEditDto.fromJS(data["menu"]) : <any>undefined;
            this.footer = data["footer"] ? UiCustomizationFooterSettingsEditDto.fromJS(data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiCustomizationSettingsEditDto {
        let result = new UiCustomizationSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;
}

export class UiCustomizationLayoutSettingsEditDto implements IUiCustomizationLayoutSettingsEditDto {
    layoutType: string;
    pageLoader: string;
    contentSkin: string;

    constructor(data?: IUiCustomizationLayoutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutType = data["layoutType"];
            this.pageLoader = data["pageLoader"];
            this.contentSkin = data["contentSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationLayoutSettingsEditDto {
        let result = new UiCustomizationLayoutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["pageLoader"] = this.pageLoader;
        data["contentSkin"] = this.contentSkin;
        return data; 
    }
}

export interface IUiCustomizationLayoutSettingsEditDto {
    layoutType: string;
    pageLoader: string;
    contentSkin: string;
}

export class UiCustomizationHeaderSettingsEditDto implements IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string;

    constructor(data?: IUiCustomizationHeaderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.desktopMinimizeMode = data["desktopMinimizeMode"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.dropdownSkinDesktop = data["dropdownSkinDesktop"];
            this.displaySubmenuArrowDesktop = data["displaySubmenuArrowDesktop"];
            this.dropdownSkin = data["dropdownSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationHeaderSettingsEditDto {
        let result = new UiCustomizationHeaderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["desktopMinimizeMode"] = this.desktopMinimizeMode;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["dropdownSkinDesktop"] = this.dropdownSkinDesktop;
        data["displaySubmenuArrowDesktop"] = this.displaySubmenuArrowDesktop;
        data["dropdownSkin"] = this.dropdownSkin;
        return data; 
    }
}

export interface IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string;
}

export class UiCustomizationMenuSettingsEditDto implements IUiCustomizationMenuSettingsEditDto {
    position: string;
    asideSkin: string;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string;
    dropdownSubmenuSkin: string;
    dropdownSubmenuArrow: boolean;

    constructor(data?: IUiCustomizationMenuSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.allowAsideHiding = data["allowAsideHiding"];
            this.defaultHiddenAside = data["defaultHiddenAside"];
            this.submenuToggle = data["submenuToggle"];
            this.dropdownSubmenuSkin = data["dropdownSubmenuSkin"];
            this.dropdownSubmenuArrow = data["dropdownSubmenuArrow"];
        }
    }

    static fromJS(data: any): UiCustomizationMenuSettingsEditDto {
        let result = new UiCustomizationMenuSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        data["dropdownSubmenuSkin"] = this.dropdownSubmenuSkin;
        data["dropdownSubmenuArrow"] = this.dropdownSubmenuArrow;
        return data; 
    }
}

export interface IUiCustomizationMenuSettingsEditDto {
    position: string;
    asideSkin: string;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string;
    dropdownSubmenuSkin: string;
    dropdownSubmenuArrow: boolean;
}

export class UiCustomizationFooterSettingsEditDto implements IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;

    constructor(data?: IUiCustomizationFooterSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    }

    static fromJS(data: any): UiCustomizationFooterSettingsEditDto {
        let result = new UiCustomizationFooterSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data; 
    }
}

export interface IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;
}

export class ListResultDtoOfUnitOfMeasureListItem implements IListResultDtoOfUnitOfMeasureListItem {
    items: UnitOfMeasureListItem[];

    constructor(data?: IListResultDtoOfUnitOfMeasureListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UnitOfMeasureListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUnitOfMeasureListItem {
        let result = new ListResultDtoOfUnitOfMeasureListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUnitOfMeasureListItem {
    items: UnitOfMeasureListItem[];
}

export class PagedUnitOfMeasureList implements IPagedUnitOfMeasureList {
    currentPage: number;
    itemsCount: number;
    unitOfMeasures: UnitOfMeasureListItem[];

    constructor(data?: IPagedUnitOfMeasureList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["unitOfMeasures"] && data["unitOfMeasures"].constructor === Array) {
                this.unitOfMeasures = [];
                for (let item of data["unitOfMeasures"])
                    this.unitOfMeasures.push(UnitOfMeasureListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedUnitOfMeasureList {
        let result = new PagedUnitOfMeasureList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.unitOfMeasures && this.unitOfMeasures.constructor === Array) {
            data["unitOfMeasures"] = [];
            for (let item of this.unitOfMeasures)
                data["unitOfMeasures"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedUnitOfMeasureList {
    currentPage: number;
    itemsCount: number;
    unitOfMeasures: UnitOfMeasureListItem[];
}

export class CreateUnitOfMeasureInput implements ICreateUnitOfMeasureInput {
    code: string;
    translations: UnitOfMeasureTranslationDto[];

    constructor(data?: ICreateUnitOfMeasureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(UnitOfMeasureTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUnitOfMeasureInput {
        let result = new CreateUnitOfMeasureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUnitOfMeasureInput {
    code: string;
    translations: UnitOfMeasureTranslationDto[];
}

export class UpdateUnitOfMeasureInput implements IUpdateUnitOfMeasureInput {
    id: number;
    code: string;
    translations: UnitOfMeasureTranslationDto[];

    constructor(data?: IUpdateUnitOfMeasureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(UnitOfMeasureTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUnitOfMeasureInput {
        let result = new UpdateUnitOfMeasureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateUnitOfMeasureInput {
    id: number;
    code: string;
    translations: UnitOfMeasureTranslationDto[];
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[];

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[];
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId: string;
    user: UserEditDto;
    roles: UserRoleDto[];
    userStores: number[];
    userDevices: number[];
    allOrganizationUnits: OrganizationUnitDto[];
    memberedOrganizationUnits: string[];

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
            if (data["userStores"] && data["userStores"].constructor === Array) {
                this.userStores = [];
                for (let item of data["userStores"])
                    this.userStores.push(item);
            }
            if (data["userDevices"] && data["userDevices"].constructor === Array) {
                this.userDevices = [];
                for (let item of data["userDevices"])
                    this.userDevices.push(item);
            }
            if (data["allOrganizationUnits"] && data["allOrganizationUnits"].constructor === Array) {
                this.allOrganizationUnits = [];
                for (let item of data["allOrganizationUnits"])
                    this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
            }
            if (data["memberedOrganizationUnits"] && data["memberedOrganizationUnits"].constructor === Array) {
                this.memberedOrganizationUnits = [];
                for (let item of data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.userStores && this.userStores.constructor === Array) {
            data["userStores"] = [];
            for (let item of this.userStores)
                data["userStores"].push(item);
        }
        if (this.userDevices && this.userDevices.constructor === Array) {
            data["userDevices"] = [];
            for (let item of this.userDevices)
                data["userDevices"].push(item);
        }
        if (this.allOrganizationUnits && this.allOrganizationUnits.constructor === Array) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (this.memberedOrganizationUnits && this.memberedOrganizationUnits.constructor === Array) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data; 
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string;
    user: UserEditDto;
    roles: UserRoleDto[];
    userStores: number[];
    userDevices: number[];
    allOrganizationUnits: OrganizationUnitDto[];
    memberedOrganizationUnits: string[];
}

export class UserEditDto implements IUserEditDto {
    id: number;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    isActive: boolean;
    isDefault: boolean;
    isEndShiftMessage: boolean;
    endShiftEmailAddress: string;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    limitDiscount: number;
    pinCode: string;
    code: string;
    counterCode: string;
    userStores: number[];
    userDevices: UserDeviceCreateDto[];
    limitDiscountType: number;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.isDefault = data["isDefault"];
            this.isEndShiftMessage = data["isEndShiftMessage"];
            this.endShiftEmailAddress = data["endShiftEmailAddress"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.limitDiscount = data["limitDiscount"];
            this.pinCode = data["pinCode"];
            this.code = data["code"];
            this.counterCode = data["counterCode"];
            if (data["userStores"] && data["userStores"].constructor === Array) {
                this.userStores = [];
                for (let item of data["userStores"])
                    this.userStores.push(item);
            }
            if (data["userDevices"] && data["userDevices"].constructor === Array) {
                this.userDevices = [];
                for (let item of data["userDevices"])
                    this.userDevices.push(UserDeviceCreateDto.fromJS(item));
            }
            this.limitDiscountType = data["limitDiscountType"];
        }
    }

    static fromJS(data: any): UserEditDto {
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["isEndShiftMessage"] = this.isEndShiftMessage;
        data["endShiftEmailAddress"] = this.endShiftEmailAddress;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["limitDiscount"] = this.limitDiscount;
        data["pinCode"] = this.pinCode;
        data["code"] = this.code;
        data["counterCode"] = this.counterCode;
        if (this.userStores && this.userStores.constructor === Array) {
            data["userStores"] = [];
            for (let item of this.userStores)
                data["userStores"].push(item);
        }
        if (this.userDevices && this.userDevices.constructor === Array) {
            data["userDevices"] = [];
            for (let item of this.userDevices)
                data["userDevices"].push(item.toJSON());
        }
        data["limitDiscountType"] = this.limitDiscountType;
        return data; 
    }
}

export interface IUserEditDto {
    id: number;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    isActive: boolean;
    isDefault: boolean;
    isEndShiftMessage: boolean;
    endShiftEmailAddress: string;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    limitDiscount: number;
    pinCode: string;
    code: string;
    counterCode: string;
    userStores: number[];
    userDevices: UserDeviceCreateDto[];
    limitDiscountType: number;
}

export class UserDeviceCreateDto implements IUserDeviceCreateDto {
    deviceId: number;
    deviceType: number;

    constructor(data?: IUserDeviceCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.deviceType = data["deviceType"];
        }
    }

    static fromJS(data: any): UserDeviceCreateDto {
        let result = new UserDeviceCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceType"] = this.deviceType;
        return data; 
    }
}

export interface IUserDeviceCreateDto {
    deviceId: number;
    deviceType: number;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[] = [];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user: UserEditDto = new UserEditDto();
    assignedRoleNames: string[] = [];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    userStores: number[];
    organizationUnits: number[];

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (data["assignedRoleNames"] && data["assignedRoleNames"].constructor === Array) {
                this.assignedRoleNames = [];
                for (let item of data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (data["userStores"] && data["userStores"].constructor === Array) {
                this.userStores = [];
                for (let item of data["userStores"])
                    this.userStores.push(item);
            }
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.assignedRoleNames && this.assignedRoleNames.constructor === Array) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (this.userStores && this.userStores.constructor === Array) {
            data["userStores"] = [];
            for (let item of this.userStores)
                data["userStores"].push(item);
        }
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    userStores: number[];
    organizationUnits: number[];
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName: string;
    usernameOrEmailAddress: string;
    password: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILinkToUserInput {
    tenancyName: string;
    usernameOrEmailAddress: string;
    password: string;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[];

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[];
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId: number;
    tenancyName: string;
    username: string;
    lastLoginTime: moment.Moment;
    id: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILinkedUserDto {
    tenantId: number;
    tenancyName: string;
    username: string;
    lastLoginTime: moment.Moment;
    id: number;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[];

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[];
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId: number;
    userId: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUnlinkUserInput {
    tenantId: number;
    userId: number;
}

export class UserLogInput implements IUserLogInput {
    tenantId: number;
    from: moment.Moment;
    to: moment.Moment;

    constructor(data?: IUserLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLogInput {
        let result = new UserLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserLogInput {
    tenantId: number;
    from: moment.Moment;
    to: moment.Moment;
}

export class PagedUserLogList implements IPagedUserLogList {
    currentPage: number;
    itemsCount: number;
    logs: UserLogDto[];

    constructor(data?: IPagedUserLogList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["logs"] && data["logs"].constructor === Array) {
                this.logs = [];
                for (let item of data["logs"])
                    this.logs.push(UserLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedUserLogList {
        let result = new PagedUserLogList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.logs && this.logs.constructor === Array) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedUserLogList {
    currentPage: number;
    itemsCount: number;
    logs: UserLogDto[];
}

export class UserLogDto implements IUserLogDto {
    userId: string;
    userName: string;
    type: string;
    tableName: string;
    dateTime: moment.Moment;
    oldValues: string;
    newValues: string;
    affectedColumns: string;
    primaryKey: string;
    values: string;
    id: number;

    constructor(data?: IUserLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.type = data["type"];
            this.tableName = data["tableName"];
            this.dateTime = data["dateTime"] ? moment(data["dateTime"].toString()) : <any>undefined;
            this.oldValues = data["oldValues"];
            this.newValues = data["newValues"];
            this.affectedColumns = data["affectedColumns"];
            this.primaryKey = data["primaryKey"];
            this.values = data["values"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLogDto {
        let result = new UserLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        data["affectedColumns"] = this.affectedColumns;
        data["primaryKey"] = this.primaryKey;
        data["values"] = this.values;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLogDto {
    userId: string;
    userName: string;
    type: string;
    tableName: string;
    dateTime: moment.Moment;
    oldValues: string;
    newValues: string;
    affectedColumns: string;
    primaryKey: string;
    values: string;
    id: number;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[];

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[];
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName: string;
    userNameOrEmail: string;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    result: string;
    creationTime: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string;
    userNameOrEmail: string;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    result: string;
    creationTime: moment.Moment;
}

export class VariantDto implements IVariantDto {
    code: string;
    categoryId: number;
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isActive: boolean;
    isModifier: boolean;
    pricingRule: VariantDtoPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    imageSrcUrl: string;
    translations: VariantTranslationDto[];
    values: VariantValueDto[];
    menuItemsIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.categoryId = data["categoryId"];
            this.isSingle = data["isSingle"];
            this.isRequired = data["isRequired"];
            this.minSelections = data["minSelections"];
            this.maxSelections = data["maxSelections"];
            this.allowMultipleQuantitiesPerModifier = data["allowMultipleQuantitiesPerModifier"];
            this.maxQtyPerModifier = data["maxQtyPerModifier"];
            this.isAdd = data["isAdd"];
            this.isActive = data["isActive"];
            this.isModifier = data["isModifier"];
            this.pricingRule = data["pricingRule"];
            this.pricingRuleFreeItemsCount = data["pricingRuleFreeItemsCount"];
            this.periorty = data["periorty"];
            this.imageSrcUrl = data["imageSrcUrl"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VariantTranslationDto.fromJS(item));
            }
            if (data["values"] && data["values"].constructor === Array) {
                this.values = [];
                for (let item of data["values"])
                    this.values.push(VariantValueDto.fromJS(item));
            }
            if (data["menuItemsIds"] && data["menuItemsIds"].constructor === Array) {
                this.menuItemsIds = [];
                for (let item of data["menuItemsIds"])
                    this.menuItemsIds.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantDto {
        let result = new VariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["categoryId"] = this.categoryId;
        data["isSingle"] = this.isSingle;
        data["isRequired"] = this.isRequired;
        data["minSelections"] = this.minSelections;
        data["maxSelections"] = this.maxSelections;
        data["allowMultipleQuantitiesPerModifier"] = this.allowMultipleQuantitiesPerModifier;
        data["maxQtyPerModifier"] = this.maxQtyPerModifier;
        data["isAdd"] = this.isAdd;
        data["isActive"] = this.isActive;
        data["isModifier"] = this.isModifier;
        data["pricingRule"] = this.pricingRule;
        data["pricingRuleFreeItemsCount"] = this.pricingRuleFreeItemsCount;
        data["periorty"] = this.periorty;
        data["imageSrcUrl"] = this.imageSrcUrl;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.values && this.values.constructor === Array) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (this.menuItemsIds && this.menuItemsIds.constructor === Array) {
            data["menuItemsIds"] = [];
            for (let item of this.menuItemsIds)
                data["menuItemsIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantDto {
    code: string;
    categoryId: number;
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isActive: boolean;
    isModifier: boolean;
    pricingRule: VariantDtoPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    imageSrcUrl: string;
    translations: VariantTranslationDto[];
    values: VariantValueDto[];
    menuItemsIds: number[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantTranslationDto implements IVariantTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IVariantTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): VariantTranslationDto {
        let result = new VariantTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IVariantTranslationDto {
    name: string;
    languageId: number;
}

export class VariantValueDto implements IVariantValueDto {
    id: number;
    variantId: number;
    rawMaterialId: number;
    qunatity: number;
    translations: VariantValueTranslationDto[];
    variantValuePriceList: VariantValuePriceListDto[];
    checked: boolean;
    isDefault: boolean;
    imageId: string;
    imageSrcUrl: string;

    constructor(data?: IVariantValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.variantId = data["variantId"];
            this.rawMaterialId = data["rawMaterialId"];
            this.qunatity = data["qunatity"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VariantValueTranslationDto.fromJS(item));
            }
            if (data["variantValuePriceList"] && data["variantValuePriceList"].constructor === Array) {
                this.variantValuePriceList = [];
                for (let item of data["variantValuePriceList"])
                    this.variantValuePriceList.push(VariantValuePriceListDto.fromJS(item));
            }
            this.checked = data["checked"];
            this.isDefault = data["isDefault"];
            this.imageId = data["imageId"];
            this.imageSrcUrl = data["imageSrcUrl"];
        }
    }

    static fromJS(data: any): VariantValueDto {
        let result = new VariantValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["variantId"] = this.variantId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["qunatity"] = this.qunatity;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.variantValuePriceList && this.variantValuePriceList.constructor === Array) {
            data["variantValuePriceList"] = [];
            for (let item of this.variantValuePriceList)
                data["variantValuePriceList"].push(item.toJSON());
        }
        data["checked"] = this.checked;
        data["isDefault"] = this.isDefault;
        data["imageId"] = this.imageId;
        data["imageSrcUrl"] = this.imageSrcUrl;
        return data; 
    }
}

export interface IVariantValueDto {
    id: number;
    variantId: number;
    rawMaterialId: number;
    qunatity: number;
    translations: VariantValueTranslationDto[];
    variantValuePriceList: VariantValuePriceListDto[];
    checked: boolean;
    isDefault: boolean;
    imageId: string;
    imageSrcUrl: string;
}

export class VariantValueTranslationDto implements IVariantValueTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IVariantValueTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): VariantValueTranslationDto {
        let result = new VariantValueTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IVariantValueTranslationDto {
    name: string;
    languageId: number;
}

export class VariantValuePriceListDto implements IVariantValuePriceListDto {
    tenantId: number;
    variantValueId: number;
    priceListId: number;
    price: number;
    factor: number;
    name: string;

    constructor(data?: IVariantValuePriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.variantValueId = data["variantValueId"];
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.factor = data["factor"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): VariantValuePriceListDto {
        let result = new VariantValuePriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["variantValueId"] = this.variantValueId;
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["factor"] = this.factor;
        data["name"] = this.name;
        return data; 
    }
}

export interface IVariantValuePriceListDto {
    tenantId: number;
    variantValueId: number;
    priceListId: number;
    price: number;
    factor: number;
    name: string;
}

export class ListResultDtoOfVariantListItem implements IListResultDtoOfVariantListItem {
    items: VariantListItem[];

    constructor(data?: IListResultDtoOfVariantListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VariantListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVariantListItem {
        let result = new ListResultDtoOfVariantListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfVariantListItem {
    items: VariantListItem[];
}

export class ListResultDtoOfVariantValueDto implements IListResultDtoOfVariantValueDto {
    items: VariantValueDto[];

    constructor(data?: IListResultDtoOfVariantValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VariantValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVariantValueDto {
        let result = new ListResultDtoOfVariantValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfVariantValueDto {
    items: VariantValueDto[];
}

export class CreateVariantInput implements ICreateVariantInput {
    code: string;
    categoryId: number;
    translations: VariantTranslationDto[];
    values: VariantValueDto[];
    menuItemsIds: number[];
    categoryIdList: number[];
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isActive: boolean;
    isModifier: boolean;
    pricingRule: CreateVariantInputPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;

    constructor(data?: ICreateVariantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.categoryId = data["categoryId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VariantTranslationDto.fromJS(item));
            }
            if (data["values"] && data["values"].constructor === Array) {
                this.values = [];
                for (let item of data["values"])
                    this.values.push(VariantValueDto.fromJS(item));
            }
            if (data["menuItemsIds"] && data["menuItemsIds"].constructor === Array) {
                this.menuItemsIds = [];
                for (let item of data["menuItemsIds"])
                    this.menuItemsIds.push(item);
            }
            if (data["categoryIdList"] && data["categoryIdList"].constructor === Array) {
                this.categoryIdList = [];
                for (let item of data["categoryIdList"])
                    this.categoryIdList.push(item);
            }
            this.isSingle = data["isSingle"];
            this.isRequired = data["isRequired"];
            this.minSelections = data["minSelections"];
            this.maxSelections = data["maxSelections"];
            this.allowMultipleQuantitiesPerModifier = data["allowMultipleQuantitiesPerModifier"];
            this.maxQtyPerModifier = data["maxQtyPerModifier"];
            this.isAdd = data["isAdd"];
            this.isActive = data["isActive"];
            this.isModifier = data["isModifier"];
            this.pricingRule = data["pricingRule"];
            this.pricingRuleFreeItemsCount = data["pricingRuleFreeItemsCount"];
            this.periorty = data["periorty"];
        }
    }

    static fromJS(data: any): CreateVariantInput {
        let result = new CreateVariantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["categoryId"] = this.categoryId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.values && this.values.constructor === Array) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (this.menuItemsIds && this.menuItemsIds.constructor === Array) {
            data["menuItemsIds"] = [];
            for (let item of this.menuItemsIds)
                data["menuItemsIds"].push(item);
        }
        if (this.categoryIdList && this.categoryIdList.constructor === Array) {
            data["categoryIdList"] = [];
            for (let item of this.categoryIdList)
                data["categoryIdList"].push(item);
        }
        data["isSingle"] = this.isSingle;
        data["isRequired"] = this.isRequired;
        data["minSelections"] = this.minSelections;
        data["maxSelections"] = this.maxSelections;
        data["allowMultipleQuantitiesPerModifier"] = this.allowMultipleQuantitiesPerModifier;
        data["maxQtyPerModifier"] = this.maxQtyPerModifier;
        data["isAdd"] = this.isAdd;
        data["isActive"] = this.isActive;
        data["isModifier"] = this.isModifier;
        data["pricingRule"] = this.pricingRule;
        data["pricingRuleFreeItemsCount"] = this.pricingRuleFreeItemsCount;
        data["periorty"] = this.periorty;
        return data; 
    }
}

export interface ICreateVariantInput {
    code: string;
    categoryId: number;
    translations: VariantTranslationDto[];
    values: VariantValueDto[];
    menuItemsIds: number[];
    categoryIdList: number[];
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isActive: boolean;
    isModifier: boolean;
    pricingRule: CreateVariantInputPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
}

export class UpdateVariantInput implements IUpdateVariantInput {
    id: number;
    code: string;
    categoryId: number;
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isActive: boolean;
    isModifier: boolean;
    pricingRule: UpdateVariantInputPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    translations: VariantTranslationDto[];
    values: VariantValueDto[];
    categoryIdList: number[];
    menuItemsIds: number[];

    constructor(data?: IUpdateVariantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.categoryId = data["categoryId"];
            this.isSingle = data["isSingle"];
            this.isRequired = data["isRequired"];
            this.minSelections = data["minSelections"];
            this.maxSelections = data["maxSelections"];
            this.allowMultipleQuantitiesPerModifier = data["allowMultipleQuantitiesPerModifier"];
            this.maxQtyPerModifier = data["maxQtyPerModifier"];
            this.isAdd = data["isAdd"];
            this.isActive = data["isActive"];
            this.isModifier = data["isModifier"];
            this.pricingRule = data["pricingRule"];
            this.pricingRuleFreeItemsCount = data["pricingRuleFreeItemsCount"];
            this.periorty = data["periorty"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VariantTranslationDto.fromJS(item));
            }
            if (data["values"] && data["values"].constructor === Array) {
                this.values = [];
                for (let item of data["values"])
                    this.values.push(VariantValueDto.fromJS(item));
            }
            if (data["categoryIdList"] && data["categoryIdList"].constructor === Array) {
                this.categoryIdList = [];
                for (let item of data["categoryIdList"])
                    this.categoryIdList.push(item);
            }
            if (data["menuItemsIds"] && data["menuItemsIds"].constructor === Array) {
                this.menuItemsIds = [];
                for (let item of data["menuItemsIds"])
                    this.menuItemsIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateVariantInput {
        let result = new UpdateVariantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["categoryId"] = this.categoryId;
        data["isSingle"] = this.isSingle;
        data["isRequired"] = this.isRequired;
        data["minSelections"] = this.minSelections;
        data["maxSelections"] = this.maxSelections;
        data["allowMultipleQuantitiesPerModifier"] = this.allowMultipleQuantitiesPerModifier;
        data["maxQtyPerModifier"] = this.maxQtyPerModifier;
        data["isAdd"] = this.isAdd;
        data["isActive"] = this.isActive;
        data["isModifier"] = this.isModifier;
        data["pricingRule"] = this.pricingRule;
        data["pricingRuleFreeItemsCount"] = this.pricingRuleFreeItemsCount;
        data["periorty"] = this.periorty;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.values && this.values.constructor === Array) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (this.categoryIdList && this.categoryIdList.constructor === Array) {
            data["categoryIdList"] = [];
            for (let item of this.categoryIdList)
                data["categoryIdList"].push(item);
        }
        if (this.menuItemsIds && this.menuItemsIds.constructor === Array) {
            data["menuItemsIds"] = [];
            for (let item of this.menuItemsIds)
                data["menuItemsIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateVariantInput {
    id: number;
    code: string;
    categoryId: number;
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isActive: boolean;
    isModifier: boolean;
    pricingRule: UpdateVariantInputPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    translations: VariantTranslationDto[];
    values: VariantValueDto[];
    categoryIdList: number[];
    menuItemsIds: number[];
}

export class ListResultDtoOfVariantValueListItem implements IListResultDtoOfVariantValueListItem {
    items: VariantValueListItem[];

    constructor(data?: IListResultDtoOfVariantValueListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VariantValueListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVariantValueListItem {
        let result = new ListResultDtoOfVariantValueListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfVariantValueListItem {
    items: VariantValueListItem[];
}

export class VariantValueListItem implements IVariantValueListItem {
    id: number;
    name: string;

    constructor(data?: IVariantValueListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): VariantValueListItem {
        let result = new VariantValueListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IVariantValueListItem {
    id: number;
    name: string;
}

export class ListResultDtoOfProductVariantListItem implements IListResultDtoOfProductVariantListItem {
    items: ProductVariantListItem[];

    constructor(data?: IListResultDtoOfProductVariantListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProductVariantListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProductVariantListItem {
        let result = new ListResultDtoOfProductVariantListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProductVariantListItem {
    items: ProductVariantListItem[];
}

export class PagedVariantList implements IPagedVariantList {
    currentPage: number;
    itemsCount: number;
    variants: VariantListItem[];

    constructor(data?: IPagedVariantList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["variants"] && data["variants"].constructor === Array) {
                this.variants = [];
                for (let item of data["variants"])
                    this.variants.push(VariantListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedVariantList {
        let result = new PagedVariantList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.variants && this.variants.constructor === Array) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedVariantList {
    currentPage: number;
    itemsCount: number;
    variants: VariantListItem[];
}

export class VendorDto implements IVendorDto {
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    rawMaterialIds: number[];
    translations: VendorTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.address = data["address"];
            this.legalName = data["legalName"];
            this.taxNumber = data["taxNumber"];
            this.tinElectronicAddress = data["tinElectronicAddress"];
            this.electronicAddressScheme = data["electronicAddressScheme"];
            this.legalRegistrationNumber = data["legalRegistrationNumber"];
            this.legalRegistrationType = data["legalRegistrationType"];
            this.registrationIssuingAuthority = data["registrationIssuingAuthority"];
            this.city = data["city"];
            this.emirate = data["emirate"];
            this.postalCode = data["postalCode"];
            this.countryCode = data["countryCode"];
            this.contactName = data["contactName"];
            this.cellPhone = data["cellPhone"];
            this.email = data["email"];
            this.fax = data["fax"];
            if (data["rawMaterialIds"] && data["rawMaterialIds"].constructor === Array) {
                this.rawMaterialIds = [];
                for (let item of data["rawMaterialIds"])
                    this.rawMaterialIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VendorTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VendorDto {
        let result = new VendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["address"] = this.address;
        data["legalName"] = this.legalName;
        data["taxNumber"] = this.taxNumber;
        data["tinElectronicAddress"] = this.tinElectronicAddress;
        data["electronicAddressScheme"] = this.electronicAddressScheme;
        data["legalRegistrationNumber"] = this.legalRegistrationNumber;
        data["legalRegistrationType"] = this.legalRegistrationType;
        data["registrationIssuingAuthority"] = this.registrationIssuingAuthority;
        data["city"] = this.city;
        data["emirate"] = this.emirate;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["contactName"] = this.contactName;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        if (this.rawMaterialIds && this.rawMaterialIds.constructor === Array) {
            data["rawMaterialIds"] = [];
            for (let item of this.rawMaterialIds)
                data["rawMaterialIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVendorDto {
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    rawMaterialIds: number[];
    translations: VendorTranslationDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VendorTranslationDto implements IVendorTranslationDto {
    name: string;
    languageId: number;

    constructor(data?: IVendorTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.languageId = data["languageId"];
        }
    }

    static fromJS(data: any): VendorTranslationDto {
        let result = new VendorTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        return data; 
    }
}

export interface IVendorTranslationDto {
    name: string;
    languageId: number;
}

export class ListResultDtoOfVendorListItem implements IListResultDtoOfVendorListItem {
    items: VendorListItem[];

    constructor(data?: IListResultDtoOfVendorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VendorListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVendorListItem {
        let result = new ListResultDtoOfVendorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfVendorListItem {
    items: VendorListItem[];
}

export class VendorListItem implements IVendorListItem {
    id: number;
    name: string;
    type: number;
    code: string;

    constructor(data?: IVendorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.type = data["type"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): VendorListItem {
        let result = new VendorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["code"] = this.code;
        return data; 
    }
}

export interface IVendorListItem {
    id: number;
    name: string;
    type: number;
    code: string;
}

export class PagedVendorList implements IPagedVendorList {
    currentPage: number;
    itemsCount: number;
    vendors: VendorListItem[];

    constructor(data?: IPagedVendorList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPage = data["currentPage"];
            this.itemsCount = data["itemsCount"];
            if (data["vendors"] && data["vendors"].constructor === Array) {
                this.vendors = [];
                for (let item of data["vendors"])
                    this.vendors.push(VendorListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedVendorList {
        let result = new PagedVendorList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["itemsCount"] = this.itemsCount;
        if (this.vendors && this.vendors.constructor === Array) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedVendorList {
    currentPage: number;
    itemsCount: number;
    vendors: VendorListItem[];
}

export class ListResultDtoOfVendorsAndStoresListItem implements IListResultDtoOfVendorsAndStoresListItem {
    items: VendorsAndStoresListItem[];

    constructor(data?: IListResultDtoOfVendorsAndStoresListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VendorsAndStoresListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVendorsAndStoresListItem {
        let result = new ListResultDtoOfVendorsAndStoresListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfVendorsAndStoresListItem {
    items: VendorsAndStoresListItem[];
}

export class VendorsAndStoresListItem implements IVendorsAndStoresListItem {
    id: number;
    name: string;
    type: string;

    constructor(data?: IVendorsAndStoresListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): VendorsAndStoresListItem {
        let result = new VendorsAndStoresListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IVendorsAndStoresListItem {
    id: number;
    name: string;
    type: string;
}

export class CreateVendorInput implements ICreateVendorInput {
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    storeIds: number[];
    rawMaterialIds: number[];
    translations: VendorTranslationDto[];

    constructor(data?: ICreateVendorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.address = data["address"];
            this.legalName = data["legalName"];
            this.taxNumber = data["taxNumber"];
            this.tinElectronicAddress = data["tinElectronicAddress"];
            this.electronicAddressScheme = data["electronicAddressScheme"];
            this.legalRegistrationNumber = data["legalRegistrationNumber"];
            this.legalRegistrationType = data["legalRegistrationType"];
            this.registrationIssuingAuthority = data["registrationIssuingAuthority"];
            this.city = data["city"];
            this.emirate = data["emirate"];
            this.postalCode = data["postalCode"];
            this.countryCode = data["countryCode"];
            this.contactName = data["contactName"];
            this.cellPhone = data["cellPhone"];
            this.email = data["email"];
            this.fax = data["fax"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["rawMaterialIds"] && data["rawMaterialIds"].constructor === Array) {
                this.rawMaterialIds = [];
                for (let item of data["rawMaterialIds"])
                    this.rawMaterialIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VendorTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateVendorInput {
        let result = new CreateVendorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["address"] = this.address;
        data["legalName"] = this.legalName;
        data["taxNumber"] = this.taxNumber;
        data["tinElectronicAddress"] = this.tinElectronicAddress;
        data["electronicAddressScheme"] = this.electronicAddressScheme;
        data["legalRegistrationNumber"] = this.legalRegistrationNumber;
        data["legalRegistrationType"] = this.legalRegistrationType;
        data["registrationIssuingAuthority"] = this.registrationIssuingAuthority;
        data["city"] = this.city;
        data["emirate"] = this.emirate;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["contactName"] = this.contactName;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.rawMaterialIds && this.rawMaterialIds.constructor === Array) {
            data["rawMaterialIds"] = [];
            for (let item of this.rawMaterialIds)
                data["rawMaterialIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateVendorInput {
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    storeIds: number[];
    rawMaterialIds: number[];
    translations: VendorTranslationDto[];
}

export class UpdateVendorInput implements IUpdateVendorInput {
    id: number;
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    storeIds: number[];
    rawMaterialIds: number[];
    translations: VendorTranslationDto[];

    constructor(data?: IUpdateVendorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.address = data["address"];
            this.legalName = data["legalName"];
            this.taxNumber = data["taxNumber"];
            this.tinElectronicAddress = data["tinElectronicAddress"];
            this.electronicAddressScheme = data["electronicAddressScheme"];
            this.legalRegistrationNumber = data["legalRegistrationNumber"];
            this.legalRegistrationType = data["legalRegistrationType"];
            this.registrationIssuingAuthority = data["registrationIssuingAuthority"];
            this.city = data["city"];
            this.emirate = data["emirate"];
            this.postalCode = data["postalCode"];
            this.countryCode = data["countryCode"];
            this.contactName = data["contactName"];
            this.cellPhone = data["cellPhone"];
            this.email = data["email"];
            this.fax = data["fax"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            if (data["rawMaterialIds"] && data["rawMaterialIds"].constructor === Array) {
                this.rawMaterialIds = [];
                for (let item of data["rawMaterialIds"])
                    this.rawMaterialIds.push(item);
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VendorTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateVendorInput {
        let result = new UpdateVendorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["address"] = this.address;
        data["legalName"] = this.legalName;
        data["taxNumber"] = this.taxNumber;
        data["tinElectronicAddress"] = this.tinElectronicAddress;
        data["electronicAddressScheme"] = this.electronicAddressScheme;
        data["legalRegistrationNumber"] = this.legalRegistrationNumber;
        data["legalRegistrationType"] = this.legalRegistrationType;
        data["registrationIssuingAuthority"] = this.registrationIssuingAuthority;
        data["city"] = this.city;
        data["emirate"] = this.emirate;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["contactName"] = this.contactName;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (this.rawMaterialIds && this.rawMaterialIds.constructor === Array) {
            data["rawMaterialIds"] = [];
            for (let item of this.rawMaterialIds)
                data["rawMaterialIds"].push(item);
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateVendorInput {
    id: number;
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    storeIds: number[];
    rawMaterialIds: number[];
    translations: VendorTranslationDto[];
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines: string[];

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["latestWebLogLines"] && data["latestWebLogLines"].constructor === Array) {
                this.latestWebLogLines = [];
                for (let item of data["latestWebLogLines"])
                    this.latestWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.latestWebLogLines && this.latestWebLogLines.constructor === Array) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data; 
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[];
}

export class ZatcaCertificate implements IZatcaCertificate {
    csr: string;
    csid: string;
    privateKey: string;
    secretKey: string;
    mode: number;
    otp: string;
    tenantId: number;
    processorId: string;
    machineName: string;
    businessCategory: string;
    branchName: string;
    deviceID: string;
    invoiceType: string;
    serialNumber: string;
    storeId: number;
    store: Store;
    zatcaTransactions: ZatcaTransaction[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IZatcaCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.csr = data["csr"];
            this.csid = data["csid"];
            this.privateKey = data["privateKey"];
            this.secretKey = data["secretKey"];
            this.mode = data["mode"];
            this.otp = data["otp"];
            this.tenantId = data["tenantId"];
            this.processorId = data["processorId"];
            this.machineName = data["machineName"];
            this.businessCategory = data["businessCategory"];
            this.branchName = data["branchName"];
            this.deviceID = data["deviceID"];
            this.invoiceType = data["invoiceType"];
            this.serialNumber = data["serialNumber"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            if (data["zatcaTransactions"] && data["zatcaTransactions"].constructor === Array) {
                this.zatcaTransactions = [];
                for (let item of data["zatcaTransactions"])
                    this.zatcaTransactions.push(ZatcaTransaction.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ZatcaCertificate {
        let result = new ZatcaCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["csr"] = this.csr;
        data["csid"] = this.csid;
        data["privateKey"] = this.privateKey;
        data["secretKey"] = this.secretKey;
        data["mode"] = this.mode;
        data["otp"] = this.otp;
        data["tenantId"] = this.tenantId;
        data["processorId"] = this.processorId;
        data["machineName"] = this.machineName;
        data["businessCategory"] = this.businessCategory;
        data["branchName"] = this.branchName;
        data["deviceID"] = this.deviceID;
        data["invoiceType"] = this.invoiceType;
        data["serialNumber"] = this.serialNumber;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (this.zatcaTransactions && this.zatcaTransactions.constructor === Array) {
            data["zatcaTransactions"] = [];
            for (let item of this.zatcaTransactions)
                data["zatcaTransactions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IZatcaCertificate {
    csr: string;
    csid: string;
    privateKey: string;
    secretKey: string;
    mode: number;
    otp: string;
    tenantId: number;
    processorId: string;
    machineName: string;
    businessCategory: string;
    branchName: string;
    deviceID: string;
    invoiceType: string;
    serialNumber: string;
    storeId: number;
    store: Store;
    zatcaTransactions: ZatcaTransaction[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class Store implements IStore {
    storeStatus: StoreStatus;
    currencyId: number;
    number: string;
    currency: Currency;
    activeShiftId: number;
    tenantId: number;
    isWarehouse: boolean;
    closeShiftByCashier: boolean;
    isStoreGroup: boolean;
    storeGroupParentId: number;
    storeGroupId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;
    storeGroup: Store;
    storeGroupParent: Store;
    region: Region;
    area: Area;
    translations: StoreTranslation[];
    shifts: StoreShift[];
    productLots: ProductLot[];
    storeWorkingHoursRules: StoreWorkingHours[];
    inventoryManagers: InventoryManager[];
    storeDevicecs: StoreDevicecs[];
    storeHappyHours: StoreHappyHours[];
    storeGroupChildrens: Store[];
    storesChildrens: Store[];
    zatcaCertificates: ZatcaCertificate[];
    saleTypeStores: SaleTypeStore[];
    rawMaterialStoreGroups: RawMaterialStoreGroup[];
    recipeStores: RecipeStore[];
    menuItemStores: MenuItemStore[];
    rawMaterialConfigStores: RawMaterialConfigStore[];
    menuItemConfigSummaries: MenuItemConfigSummary[];
    storeMenuItemConfigs: StoreMenuItemConfig[];
    tableStores: TableStore[];
    cornerStores: CornerStore[];
    productStorePrices: ProductStorePrice[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    storeZones: StoreZone[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeStatus = data["storeStatus"];
            this.currencyId = data["currencyId"];
            this.number = data["number"];
            this.currency = data["currency"] ? Currency.fromJS(data["currency"]) : <any>undefined;
            this.activeShiftId = data["activeShiftId"];
            this.tenantId = data["tenantId"];
            this.isWarehouse = data["isWarehouse"];
            this.closeShiftByCashier = data["closeShiftByCashier"];
            this.isStoreGroup = data["isStoreGroup"];
            this.storeGroupParentId = data["storeGroupParentId"];
            this.storeGroupId = data["storeGroupId"];
            this.tenantStoreGroupId = data["tenantStoreGroupId"];
            this.areaId = data["areaId"];
            this.regionId = data["regionId"];
            this.contractBegining = data["contractBegining"] ? moment(data["contractBegining"].toString()) : <any>undefined;
            this.contractEnding = data["contractEnding"] ? moment(data["contractEnding"].toString()) : <any>undefined;
            this.alertPeriod = data["alertPeriod"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.storeGroup = data["storeGroup"] ? Store.fromJS(data["storeGroup"]) : <any>undefined;
            this.storeGroupParent = data["storeGroupParent"] ? Store.fromJS(data["storeGroupParent"]) : <any>undefined;
            this.region = data["region"] ? Region.fromJS(data["region"]) : <any>undefined;
            this.area = data["area"] ? Area.fromJS(data["area"]) : <any>undefined;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(StoreTranslation.fromJS(item));
            }
            if (data["shifts"] && data["shifts"].constructor === Array) {
                this.shifts = [];
                for (let item of data["shifts"])
                    this.shifts.push(StoreShift.fromJS(item));
            }
            if (data["productLots"] && data["productLots"].constructor === Array) {
                this.productLots = [];
                for (let item of data["productLots"])
                    this.productLots.push(ProductLot.fromJS(item));
            }
            if (data["storeWorkingHoursRules"] && data["storeWorkingHoursRules"].constructor === Array) {
                this.storeWorkingHoursRules = [];
                for (let item of data["storeWorkingHoursRules"])
                    this.storeWorkingHoursRules.push(StoreWorkingHours.fromJS(item));
            }
            if (data["inventoryManagers"] && data["inventoryManagers"].constructor === Array) {
                this.inventoryManagers = [];
                for (let item of data["inventoryManagers"])
                    this.inventoryManagers.push(InventoryManager.fromJS(item));
            }
            if (data["storeDevicecs"] && data["storeDevicecs"].constructor === Array) {
                this.storeDevicecs = [];
                for (let item of data["storeDevicecs"])
                    this.storeDevicecs.push(StoreDevicecs.fromJS(item));
            }
            if (data["storeHappyHours"] && data["storeHappyHours"].constructor === Array) {
                this.storeHappyHours = [];
                for (let item of data["storeHappyHours"])
                    this.storeHappyHours.push(StoreHappyHours.fromJS(item));
            }
            if (data["storeGroupChildrens"] && data["storeGroupChildrens"].constructor === Array) {
                this.storeGroupChildrens = [];
                for (let item of data["storeGroupChildrens"])
                    this.storeGroupChildrens.push(Store.fromJS(item));
            }
            if (data["storesChildrens"] && data["storesChildrens"].constructor === Array) {
                this.storesChildrens = [];
                for (let item of data["storesChildrens"])
                    this.storesChildrens.push(Store.fromJS(item));
            }
            if (data["zatcaCertificates"] && data["zatcaCertificates"].constructor === Array) {
                this.zatcaCertificates = [];
                for (let item of data["zatcaCertificates"])
                    this.zatcaCertificates.push(ZatcaCertificate.fromJS(item));
            }
            if (data["saleTypeStores"] && data["saleTypeStores"].constructor === Array) {
                this.saleTypeStores = [];
                for (let item of data["saleTypeStores"])
                    this.saleTypeStores.push(SaleTypeStore.fromJS(item));
            }
            if (data["rawMaterialStoreGroups"] && data["rawMaterialStoreGroups"].constructor === Array) {
                this.rawMaterialStoreGroups = [];
                for (let item of data["rawMaterialStoreGroups"])
                    this.rawMaterialStoreGroups.push(RawMaterialStoreGroup.fromJS(item));
            }
            if (data["recipeStores"] && data["recipeStores"].constructor === Array) {
                this.recipeStores = [];
                for (let item of data["recipeStores"])
                    this.recipeStores.push(RecipeStore.fromJS(item));
            }
            if (data["menuItemStores"] && data["menuItemStores"].constructor === Array) {
                this.menuItemStores = [];
                for (let item of data["menuItemStores"])
                    this.menuItemStores.push(MenuItemStore.fromJS(item));
            }
            if (data["rawMaterialConfigStores"] && data["rawMaterialConfigStores"].constructor === Array) {
                this.rawMaterialConfigStores = [];
                for (let item of data["rawMaterialConfigStores"])
                    this.rawMaterialConfigStores.push(RawMaterialConfigStore.fromJS(item));
            }
            if (data["menuItemConfigSummaries"] && data["menuItemConfigSummaries"].constructor === Array) {
                this.menuItemConfigSummaries = [];
                for (let item of data["menuItemConfigSummaries"])
                    this.menuItemConfigSummaries.push(MenuItemConfigSummary.fromJS(item));
            }
            if (data["storeMenuItemConfigs"] && data["storeMenuItemConfigs"].constructor === Array) {
                this.storeMenuItemConfigs = [];
                for (let item of data["storeMenuItemConfigs"])
                    this.storeMenuItemConfigs.push(StoreMenuItemConfig.fromJS(item));
            }
            if (data["tableStores"] && data["tableStores"].constructor === Array) {
                this.tableStores = [];
                for (let item of data["tableStores"])
                    this.tableStores.push(TableStore.fromJS(item));
            }
            if (data["cornerStores"] && data["cornerStores"].constructor === Array) {
                this.cornerStores = [];
                for (let item of data["cornerStores"])
                    this.cornerStores.push(CornerStore.fromJS(item));
            }
            if (data["productStorePrices"] && data["productStorePrices"].constructor === Array) {
                this.productStorePrices = [];
                for (let item of data["productStorePrices"])
                    this.productStorePrices.push(ProductStorePrice.fromJS(item));
            }
            if (data["recipeTransactionSummaries"] && data["recipeTransactionSummaries"].constructor === Array) {
                this.recipeTransactionSummaries = [];
                for (let item of data["recipeTransactionSummaries"])
                    this.recipeTransactionSummaries.push(RecipeTransactionSummary.fromJS(item));
            }
            if (data["storeZones"] && data["storeZones"].constructor === Array) {
                this.storeZones = [];
                for (let item of data["storeZones"])
                    this.storeZones.push(StoreZone.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Store {
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeStatus"] = this.storeStatus;
        data["currencyId"] = this.currencyId;
        data["number"] = this.number;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["activeShiftId"] = this.activeShiftId;
        data["tenantId"] = this.tenantId;
        data["isWarehouse"] = this.isWarehouse;
        data["closeShiftByCashier"] = this.closeShiftByCashier;
        data["isStoreGroup"] = this.isStoreGroup;
        data["storeGroupParentId"] = this.storeGroupParentId;
        data["storeGroupId"] = this.storeGroupId;
        data["tenantStoreGroupId"] = this.tenantStoreGroupId;
        data["areaId"] = this.areaId;
        data["regionId"] = this.regionId;
        data["contractBegining"] = this.contractBegining ? this.contractBegining.toISOString() : <any>undefined;
        data["contractEnding"] = this.contractEnding ? this.contractEnding.toISOString() : <any>undefined;
        data["alertPeriod"] = this.alertPeriod;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["storeGroup"] = this.storeGroup ? this.storeGroup.toJSON() : <any>undefined;
        data["storeGroupParent"] = this.storeGroupParent ? this.storeGroupParent.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.shifts && this.shifts.constructor === Array) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item.toJSON());
        }
        if (this.productLots && this.productLots.constructor === Array) {
            data["productLots"] = [];
            for (let item of this.productLots)
                data["productLots"].push(item.toJSON());
        }
        if (this.storeWorkingHoursRules && this.storeWorkingHoursRules.constructor === Array) {
            data["storeWorkingHoursRules"] = [];
            for (let item of this.storeWorkingHoursRules)
                data["storeWorkingHoursRules"].push(item.toJSON());
        }
        if (this.inventoryManagers && this.inventoryManagers.constructor === Array) {
            data["inventoryManagers"] = [];
            for (let item of this.inventoryManagers)
                data["inventoryManagers"].push(item.toJSON());
        }
        if (this.storeDevicecs && this.storeDevicecs.constructor === Array) {
            data["storeDevicecs"] = [];
            for (let item of this.storeDevicecs)
                data["storeDevicecs"].push(item.toJSON());
        }
        if (this.storeHappyHours && this.storeHappyHours.constructor === Array) {
            data["storeHappyHours"] = [];
            for (let item of this.storeHappyHours)
                data["storeHappyHours"].push(item.toJSON());
        }
        if (this.storeGroupChildrens && this.storeGroupChildrens.constructor === Array) {
            data["storeGroupChildrens"] = [];
            for (let item of this.storeGroupChildrens)
                data["storeGroupChildrens"].push(item.toJSON());
        }
        if (this.storesChildrens && this.storesChildrens.constructor === Array) {
            data["storesChildrens"] = [];
            for (let item of this.storesChildrens)
                data["storesChildrens"].push(item.toJSON());
        }
        if (this.zatcaCertificates && this.zatcaCertificates.constructor === Array) {
            data["zatcaCertificates"] = [];
            for (let item of this.zatcaCertificates)
                data["zatcaCertificates"].push(item.toJSON());
        }
        if (this.saleTypeStores && this.saleTypeStores.constructor === Array) {
            data["saleTypeStores"] = [];
            for (let item of this.saleTypeStores)
                data["saleTypeStores"].push(item.toJSON());
        }
        if (this.rawMaterialStoreGroups && this.rawMaterialStoreGroups.constructor === Array) {
            data["rawMaterialStoreGroups"] = [];
            for (let item of this.rawMaterialStoreGroups)
                data["rawMaterialStoreGroups"].push(item.toJSON());
        }
        if (this.recipeStores && this.recipeStores.constructor === Array) {
            data["recipeStores"] = [];
            for (let item of this.recipeStores)
                data["recipeStores"].push(item.toJSON());
        }
        if (this.menuItemStores && this.menuItemStores.constructor === Array) {
            data["menuItemStores"] = [];
            for (let item of this.menuItemStores)
                data["menuItemStores"].push(item.toJSON());
        }
        if (this.rawMaterialConfigStores && this.rawMaterialConfigStores.constructor === Array) {
            data["rawMaterialConfigStores"] = [];
            for (let item of this.rawMaterialConfigStores)
                data["rawMaterialConfigStores"].push(item.toJSON());
        }
        if (this.menuItemConfigSummaries && this.menuItemConfigSummaries.constructor === Array) {
            data["menuItemConfigSummaries"] = [];
            for (let item of this.menuItemConfigSummaries)
                data["menuItemConfigSummaries"].push(item.toJSON());
        }
        if (this.storeMenuItemConfigs && this.storeMenuItemConfigs.constructor === Array) {
            data["storeMenuItemConfigs"] = [];
            for (let item of this.storeMenuItemConfigs)
                data["storeMenuItemConfigs"].push(item.toJSON());
        }
        if (this.tableStores && this.tableStores.constructor === Array) {
            data["tableStores"] = [];
            for (let item of this.tableStores)
                data["tableStores"].push(item.toJSON());
        }
        if (this.cornerStores && this.cornerStores.constructor === Array) {
            data["cornerStores"] = [];
            for (let item of this.cornerStores)
                data["cornerStores"].push(item.toJSON());
        }
        if (this.productStorePrices && this.productStorePrices.constructor === Array) {
            data["productStorePrices"] = [];
            for (let item of this.productStorePrices)
                data["productStorePrices"].push(item.toJSON());
        }
        if (this.recipeTransactionSummaries && this.recipeTransactionSummaries.constructor === Array) {
            data["recipeTransactionSummaries"] = [];
            for (let item of this.recipeTransactionSummaries)
                data["recipeTransactionSummaries"].push(item.toJSON());
        }
        if (this.storeZones && this.storeZones.constructor === Array) {
            data["storeZones"] = [];
            for (let item of this.storeZones)
                data["storeZones"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStore {
    storeStatus: StoreStatus;
    currencyId: number;
    number: string;
    currency: Currency;
    activeShiftId: number;
    tenantId: number;
    isWarehouse: boolean;
    closeShiftByCashier: boolean;
    isStoreGroup: boolean;
    storeGroupParentId: number;
    storeGroupId: number;
    tenantStoreGroupId: number;
    areaId: number;
    regionId: number;
    contractBegining: moment.Moment;
    contractEnding: moment.Moment;
    alertPeriod: number;
    longitude: number;
    latitude: number;
    storeGroup: Store;
    storeGroupParent: Store;
    region: Region;
    area: Area;
    translations: StoreTranslation[];
    shifts: StoreShift[];
    productLots: ProductLot[];
    storeWorkingHoursRules: StoreWorkingHours[];
    inventoryManagers: InventoryManager[];
    storeDevicecs: StoreDevicecs[];
    storeHappyHours: StoreHappyHours[];
    storeGroupChildrens: Store[];
    storesChildrens: Store[];
    zatcaCertificates: ZatcaCertificate[];
    saleTypeStores: SaleTypeStore[];
    rawMaterialStoreGroups: RawMaterialStoreGroup[];
    recipeStores: RecipeStore[];
    menuItemStores: MenuItemStore[];
    rawMaterialConfigStores: RawMaterialConfigStore[];
    menuItemConfigSummaries: MenuItemConfigSummary[];
    storeMenuItemConfigs: StoreMenuItemConfig[];
    tableStores: TableStore[];
    cornerStores: CornerStore[];
    productStorePrices: ProductStorePrice[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    storeZones: StoreZone[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ZatcaTransaction implements IZatcaTransaction {
    qrCode: string;
    uuid: string;
    invoiceHash: string;
    tenantId: number;
    encodedInvoice: string;
    icvuuid: number;
    invoiceTypeCode: string;
    statusId: number;
    notValidReason: string;
    reportingStatusId: number;
    reportingStatus: string;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    zatcaCertificateId: string;
    zatcaCertificate: ZatcaCertificate;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IZatcaTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCode = data["qrCode"];
            this.uuid = data["uuid"];
            this.invoiceHash = data["invoiceHash"];
            this.tenantId = data["tenantId"];
            this.encodedInvoice = data["encodedInvoice"];
            this.icvuuid = data["icvuuid"];
            this.invoiceTypeCode = data["invoiceTypeCode"];
            this.statusId = data["statusId"];
            this.notValidReason = data["notValidReason"];
            this.reportingStatusId = data["reportingStatusId"];
            this.reportingStatus = data["reportingStatus"];
            this.saleTransactionId = data["saleTransactionId"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.zatcaCertificateId = data["zatcaCertificateId"];
            this.zatcaCertificate = data["zatcaCertificate"] ? ZatcaCertificate.fromJS(data["zatcaCertificate"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ZatcaTransaction {
        let result = new ZatcaTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        data["uuid"] = this.uuid;
        data["invoiceHash"] = this.invoiceHash;
        data["tenantId"] = this.tenantId;
        data["encodedInvoice"] = this.encodedInvoice;
        data["icvuuid"] = this.icvuuid;
        data["invoiceTypeCode"] = this.invoiceTypeCode;
        data["statusId"] = this.statusId;
        data["notValidReason"] = this.notValidReason;
        data["reportingStatusId"] = this.reportingStatusId;
        data["reportingStatus"] = this.reportingStatus;
        data["saleTransactionId"] = this.saleTransactionId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["zatcaCertificateId"] = this.zatcaCertificateId;
        data["zatcaCertificate"] = this.zatcaCertificate ? this.zatcaCertificate.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IZatcaTransaction {
    qrCode: string;
    uuid: string;
    invoiceHash: string;
    tenantId: number;
    encodedInvoice: string;
    icvuuid: number;
    invoiceTypeCode: string;
    statusId: number;
    notValidReason: string;
    reportingStatusId: number;
    reportingStatus: string;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    zatcaCertificateId: string;
    zatcaCertificate: ZatcaCertificate;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class Currency implements ICurrency {
    code: string;
    translations: CurrencyTranslation[];
    stores: Store[];
    tenantId: number;
    default: boolean;
    rate: number = 0;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CurrencyTranslation.fromJS(item));
            }
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(Store.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.default = data["default"];
            this.rate = data["rate"] !== undefined ? data["rate"] : 0;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Currency {
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["default"] = this.default;
        data["rate"] = this.rate;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrency {
    code: string;
    translations: CurrencyTranslation[];
    stores: Store[];
    tenantId: number;
    default: boolean;
    rate: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Region implements IRegion {
    code: string;
    tenantId: number;
    translations: RegionTranslation[];
    areas: Area[];
    stores: Store[];
    regionStoreGroups: RegionStoreGroup[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RegionTranslation.fromJS(item));
            }
            if (data["areas"] && data["areas"].constructor === Array) {
                this.areas = [];
                for (let item of data["areas"])
                    this.areas.push(Area.fromJS(item));
            }
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(Store.fromJS(item));
            }
            if (data["regionStoreGroups"] && data["regionStoreGroups"].constructor === Array) {
                this.regionStoreGroups = [];
                for (let item of data["regionStoreGroups"])
                    this.regionStoreGroups.push(RegionStoreGroup.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Region {
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.areas && this.areas.constructor === Array) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        if (this.regionStoreGroups && this.regionStoreGroups.constructor === Array) {
            data["regionStoreGroups"] = [];
            for (let item of this.regionStoreGroups)
                data["regionStoreGroups"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegion {
    code: string;
    tenantId: number;
    translations: RegionTranslation[];
    areas: Area[];
    stores: Store[];
    regionStoreGroups: RegionStoreGroup[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Area implements IArea {
    code: string;
    tenantId: number;
    regionId: number;
    region: Region;
    translations: AreaTranslation[];
    storeGroupAreas: StoreGroupArea[];
    stores: Store[];
    salesOrderUrls: SalesOrderUrl[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            this.regionId = data["regionId"];
            this.region = data["region"] ? Region.fromJS(data["region"]) : <any>undefined;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AreaTranslation.fromJS(item));
            }
            if (data["storeGroupAreas"] && data["storeGroupAreas"].constructor === Array) {
                this.storeGroupAreas = [];
                for (let item of data["storeGroupAreas"])
                    this.storeGroupAreas.push(StoreGroupArea.fromJS(item));
            }
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(Store.fromJS(item));
            }
            if (data["salesOrderUrls"] && data["salesOrderUrls"].constructor === Array) {
                this.salesOrderUrls = [];
                for (let item of data["salesOrderUrls"])
                    this.salesOrderUrls.push(SalesOrderUrl.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Area {
        let result = new Area();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        data["regionId"] = this.regionId;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeGroupAreas && this.storeGroupAreas.constructor === Array) {
            data["storeGroupAreas"] = [];
            for (let item of this.storeGroupAreas)
                data["storeGroupAreas"].push(item.toJSON());
        }
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        if (this.salesOrderUrls && this.salesOrderUrls.constructor === Array) {
            data["salesOrderUrls"] = [];
            for (let item of this.salesOrderUrls)
                data["salesOrderUrls"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IArea {
    code: string;
    tenantId: number;
    regionId: number;
    region: Region;
    translations: AreaTranslation[];
    storeGroupAreas: StoreGroupArea[];
    stores: Store[];
    salesOrderUrls: SalesOrderUrl[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreTranslation implements IStoreTranslation {
    storeId: number;
    store: Store;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreTranslation {
        let result = new StoreTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreTranslation {
    storeId: number;
    store: Store;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreShift implements IStoreShift {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    storeId: number;
    store: Store;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.startedBy = data["startedBy"];
            this.endedBy = data["endedBy"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreShift {
        let result = new StoreShift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["endedBy"] = this.endedBy;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreShift {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    storeId: number;
    store: Store;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductLot implements IProductLot {
    storeId: number;
    store: Store;
    productId: number;
    product: Product;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    remainingQuantity: number;
    unitPurchasePrice: number;
    productVariantId: number;
    productVariant: ProductVariant;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    purchaseInvoiceId: number;
    purchaseInvoice: PurchaseInvoice;
    tenantId: number;
    discountTypeId: number;
    discountAmount: number;
    vat: number;
    productLotChildId: number;
    productLotChild: ProductLot;
    isReturn: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductLot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.lotNumber = data["lotNumber"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.quantity = data["quantity"];
            this.remainingQuantity = data["remainingQuantity"];
            this.unitPurchasePrice = data["unitPurchasePrice"];
            this.productVariantId = data["productVariantId"];
            this.productVariant = data["productVariant"] ? ProductVariant.fromJS(data["productVariant"]) : <any>undefined;
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.purchaseInvoiceId = data["purchaseInvoiceId"];
            this.purchaseInvoice = data["purchaseInvoice"] ? PurchaseInvoice.fromJS(data["purchaseInvoice"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.vat = data["vat"];
            this.productLotChildId = data["productLotChildId"];
            this.productLotChild = data["productLotChild"] ? ProductLot.fromJS(data["productLotChild"]) : <any>undefined;
            this.isReturn = data["isReturn"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductLot {
        let result = new ProductLot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["remainingQuantity"] = this.remainingQuantity;
        data["unitPurchasePrice"] = this.unitPurchasePrice;
        data["productVariantId"] = this.productVariantId;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["purchaseInvoiceId"] = this.purchaseInvoiceId;
        data["purchaseInvoice"] = this.purchaseInvoice ? this.purchaseInvoice.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["vat"] = this.vat;
        data["productLotChildId"] = this.productLotChildId;
        data["productLotChild"] = this.productLotChild ? this.productLotChild.toJSON() : <any>undefined;
        data["isReturn"] = this.isReturn;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductLot {
    storeId: number;
    store: Store;
    productId: number;
    product: Product;
    lotNumber: string;
    expirationDate: moment.Moment;
    quantity: number;
    remainingQuantity: number;
    unitPurchasePrice: number;
    productVariantId: number;
    productVariant: ProductVariant;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    purchaseInvoiceId: number;
    purchaseInvoice: PurchaseInvoice;
    tenantId: number;
    discountTypeId: number;
    discountAmount: number;
    vat: number;
    productLotChildId: number;
    productLotChild: ProductLot;
    isReturn: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreWorkingHours implements IStoreWorkingHours {
    tenantId: number;
    ruleId: number;
    storeId: number;
    store: Store;
    rule: StoreWorkingHoursRule;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreWorkingHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.ruleId = data["ruleId"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.rule = data["rule"] ? StoreWorkingHoursRule.fromJS(data["rule"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreWorkingHours {
        let result = new StoreWorkingHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["ruleId"] = this.ruleId;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["rule"] = this.rule ? this.rule.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreWorkingHours {
    tenantId: number;
    ruleId: number;
    storeId: number;
    store: Store;
    rule: StoreWorkingHoursRule;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class InventoryManager implements IInventoryManager {
    storeId: number;
    store: Store;
    userId: number;
    user: User;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IInventoryManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InventoryManager {
        let result = new InventoryManager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInventoryManager {
    storeId: number;
    store: Store;
    userId: number;
    user: User;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreDevicecs implements IStoreDevicecs {
    tenantId: number;
    deviceId: number;
    device: Device;
    pc: PC;
    store: Store;
    storeId: number;
    pcId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreDevicecs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.device = data["device"] ? Device.fromJS(data["device"]) : <any>undefined;
            this.pc = data["pc"] ? PC.fromJS(data["pc"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.pcId = data["pcId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreDevicecs {
        let result = new StoreDevicecs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["pc"] = this.pc ? this.pc.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["pcId"] = this.pcId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreDevicecs {
    tenantId: number;
    deviceId: number;
    device: Device;
    pc: PC;
    store: Store;
    storeId: number;
    pcId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreHappyHours implements IStoreHappyHours {
    tenantId: number;
    happyHourId: number;
    happyHour: HappyHour;
    store: Store;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreHappyHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.happyHourId = data["happyHourId"];
            this.happyHour = data["happyHour"] ? HappyHour.fromJS(data["happyHour"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreHappyHours {
        let result = new StoreHappyHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["happyHourId"] = this.happyHourId;
        data["happyHour"] = this.happyHour ? this.happyHour.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreHappyHours {
    tenantId: number;
    happyHourId: number;
    happyHour: HappyHour;
    store: Store;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTypeStore implements ISaleTypeStore {
    tenantId: number;
    storeId: number;
    saleTypeId: number;
    saleType: SaleType;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeStore {
        let result = new SaleTypeStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeStore {
    tenantId: number;
    storeId: number;
    saleTypeId: number;
    saleType: SaleType;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RawMaterialStoreGroup implements IRawMaterialStoreGroup {
    tenantId: number;
    storeGroupId: number;
    rawMaterialId: number;
    storeGroup: Store;
    rawMaterial: RawMaterial;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialStoreGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeGroupId = data["storeGroupId"];
            this.rawMaterialId = data["rawMaterialId"];
            this.storeGroup = data["storeGroup"] ? Store.fromJS(data["storeGroup"]) : <any>undefined;
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialStoreGroup {
        let result = new RawMaterialStoreGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeGroupId"] = this.storeGroupId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["storeGroup"] = this.storeGroup ? this.storeGroup.toJSON() : <any>undefined;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialStoreGroup {
    tenantId: number;
    storeGroupId: number;
    rawMaterialId: number;
    storeGroup: Store;
    rawMaterial: RawMaterial;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RecipeStore implements IRecipeStore {
    tenantId: number;
    storeId: number;
    recipeId: number;
    store: Store;
    recipe: Recipe;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipeStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.recipeId = data["recipeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.recipe = data["recipe"] ? Recipe.fromJS(data["recipe"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeStore {
        let result = new RecipeStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["recipeId"] = this.recipeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeStore {
    tenantId: number;
    storeId: number;
    recipeId: number;
    store: Store;
    recipe: Recipe;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemStore implements IMenuItemStore {
    tenantId: number;
    storeId: number;
    menuItemId: number;
    menuItem: MenuItem;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemStore {
        let result = new MenuItemStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemStore {
    tenantId: number;
    storeId: number;
    menuItemId: number;
    menuItem: MenuItem;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RawMaterialConfigStore implements IRawMaterialConfigStore {
    tenantId: number;
    storeId: number;
    rawMaterialConfigId: number;
    store: Store;
    rawMaterialConfig: RawMaterialConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialConfigStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.rawMaterialConfigId = data["rawMaterialConfigId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.rawMaterialConfig = data["rawMaterialConfig"] ? RawMaterialConfig.fromJS(data["rawMaterialConfig"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialConfigStore {
        let result = new RawMaterialConfigStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["rawMaterialConfigId"] = this.rawMaterialConfigId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["rawMaterialConfig"] = this.rawMaterialConfig ? this.rawMaterialConfig.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialConfigStore {
    tenantId: number;
    storeId: number;
    rawMaterialConfigId: number;
    store: Store;
    rawMaterialConfig: RawMaterialConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemConfigSummary implements IMenuItemConfigSummary {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    isBasic: boolean;
    menuItemId: number;
    menuItemConfigId: number;
    storeId: number;
    store: Store;
    menuItemConfig: MenuItemConfig;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemConfigSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.openPrice = data["openPrice"];
            this.allowDiscount = data["allowDiscount"];
            this.isBasic = data["isBasic"];
            this.menuItemId = data["menuItemId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.menuItemConfig = data["menuItemConfig"] ? MenuItemConfig.fromJS(data["menuItemConfig"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemConfigSummary {
        let result = new MenuItemConfigSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["openPrice"] = this.openPrice;
        data["allowDiscount"] = this.allowDiscount;
        data["isBasic"] = this.isBasic;
        data["menuItemId"] = this.menuItemId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["menuItemConfig"] = this.menuItemConfig ? this.menuItemConfig.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemConfigSummary {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    isBasic: boolean;
    menuItemId: number;
    menuItemConfigId: number;
    storeId: number;
    store: Store;
    menuItemConfig: MenuItemConfig;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreMenuItemConfig implements IStoreMenuItemConfig {
    tenantId: number;
    menuItemConfigId: number;
    storeId: number;
    menuItemConfig: MenuItemConfig;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreMenuItemConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.storeId = data["storeId"];
            this.menuItemConfig = data["menuItemConfig"] ? MenuItemConfig.fromJS(data["menuItemConfig"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreMenuItemConfig {
        let result = new StoreMenuItemConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["storeId"] = this.storeId;
        data["menuItemConfig"] = this.menuItemConfig ? this.menuItemConfig.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreMenuItemConfig {
    tenantId: number;
    menuItemConfigId: number;
    storeId: number;
    menuItemConfig: MenuItemConfig;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TableStore implements ITableStore {
    tenantId: number;
    storeId: number;
    store: Store;
    tableId: number;
    table: Table;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITableStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.tableId = data["tableId"];
            this.table = data["table"] ? Table.fromJS(data["table"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TableStore {
        let result = new TableStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["tableId"] = this.tableId;
        data["table"] = this.table ? this.table.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITableStore {
    tenantId: number;
    storeId: number;
    store: Store;
    tableId: number;
    table: Table;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CornerStore implements ICornerStore {
    tenantId: number;
    storeId: number;
    store: Store;
    cornerId: number;
    corner: Corner;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICornerStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.cornerId = data["cornerId"];
            this.corner = data["corner"] ? Corner.fromJS(data["corner"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CornerStore {
        let result = new CornerStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["cornerId"] = this.cornerId;
        data["corner"] = this.corner ? this.corner.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICornerStore {
    tenantId: number;
    storeId: number;
    store: Store;
    cornerId: number;
    corner: Corner;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductStorePrice implements IProductStorePrice {
    tenantId: number;
    productId: number;
    product: Product;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    storeId: number;
    store: Store;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IProductStorePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.price = data["price"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductStorePrice {
        let result = new ProductStorePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductStorePrice {
    tenantId: number;
    productId: number;
    product: Product;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    storeId: number;
    store: Store;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class RecipeTransactionSummary implements IRecipeTransactionSummary {
    tenantId: number;
    transactionId: string;
    storeId: number;
    rawMaterialId: number;
    unitOfMeasureId: number;
    date: moment.Moment;
    transactionType: RecipeTransactionSummaryTransactionType;
    qty: number;
    cost: number;
    factor: number;
    menuItemId: number;
    productCategoryId: number;
    saleTypeId: number;
    menuItem: MenuItem;
    saleType: SaleType;
    productCategory: ProductCategory;
    rawMaterial: RawMaterial;
    store: Store;
    unitOfMeasure: UnitOfMeasure;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IRecipeTransactionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.transactionId = data["transactionId"];
            this.storeId = data["storeId"];
            this.rawMaterialId = data["rawMaterialId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.transactionType = data["transactionType"];
            this.qty = data["qty"];
            this.cost = data["cost"];
            this.factor = data["factor"];
            this.menuItemId = data["menuItemId"];
            this.productCategoryId = data["productCategoryId"];
            this.saleTypeId = data["saleTypeId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.productCategory = data["productCategory"] ? ProductCategory.fromJS(data["productCategory"]) : <any>undefined;
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeTransactionSummary {
        let result = new RecipeTransactionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["transactionId"] = this.transactionId;
        data["storeId"] = this.storeId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["transactionType"] = this.transactionType;
        data["qty"] = this.qty;
        data["cost"] = this.cost;
        data["factor"] = this.factor;
        data["menuItemId"] = this.menuItemId;
        data["productCategoryId"] = this.productCategoryId;
        data["saleTypeId"] = this.saleTypeId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeTransactionSummary {
    tenantId: number;
    transactionId: string;
    storeId: number;
    rawMaterialId: number;
    unitOfMeasureId: number;
    date: moment.Moment;
    transactionType: RecipeTransactionSummaryTransactionType;
    qty: number;
    cost: number;
    factor: number;
    menuItemId: number;
    productCategoryId: number;
    saleTypeId: number;
    menuItem: MenuItem;
    saleType: SaleType;
    productCategory: ProductCategory;
    rawMaterial: RawMaterial;
    store: Store;
    unitOfMeasure: UnitOfMeasure;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class StoreZone implements IStoreZone {
    tenantId: number;
    deliveryZoneId: number;
    deliveryZone: DeliveryZone;
    store: Store;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.deliveryZone = data["deliveryZone"] ? DeliveryZone.fromJS(data["deliveryZone"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreZone {
        let result = new StoreZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["deliveryZone"] = this.deliveryZone ? this.deliveryZone.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreZone {
    tenantId: number;
    deliveryZoneId: number;
    deliveryZone: DeliveryZone;
    store: Store;
    storeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTransaction implements ISaleTransaction {
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    saleTypeId: number;
    saleType: SaleType;
    salesManId: number;
    salesMan: User;
    customer: Customer;
    refSaleTransactionId: string;
    refSaleTransaction: SaleTransaction;
    cashierId: number;
    isCertificate: number;
    cashier: User;
    cashierShiftId: number;
    cashierShift: CashierShift;
    subTotal: number;
    vat: number;
    total: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    terminalId: number;
    promotionId: number;
    promotion: PromotionCodeFB;
    additionalAllowns: number;
    version: number;
    status: SaleTransactionStatus;
    templateType: SaleTransactionTemplateType;
    posResponseA90: POSResponseA90[];
    posResponseN90: POSResponseN90[];
    saleDetails: SaleTransactionDetail[];
    salepaymentTransactions: SalepaymentTransactions[];
    saleTransactionsDiningTables: SaleTransactionsDiningTable[];
    date: moment.Moment;
    saleOffers: SaleTransactionOffer[];
    tenantId: number;
    notes: string;
    discount: number;
    discountType: number;
    discountValue: number;
    happyHourId: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    endOfDay: EndOfDayDetail;
    happyHour: HappyHour;
    zatcaTransaction: ZatcaTransaction[];
    saleNotifications: SaleNotification[];
    saleTransactionAddresses: SaleTransactionAddress[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.salesManId = data["salesManId"];
            this.salesMan = data["salesMan"] ? User.fromJS(data["salesMan"]) : <any>undefined;
            this.customer = data["customer"] ? Customer.fromJS(data["customer"]) : <any>undefined;
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.refSaleTransaction = data["refSaleTransaction"] ? SaleTransaction.fromJS(data["refSaleTransaction"]) : <any>undefined;
            this.cashierId = data["cashierId"];
            this.isCertificate = data["isCertificate"];
            this.cashier = data["cashier"] ? User.fromJS(data["cashier"]) : <any>undefined;
            this.cashierShiftId = data["cashierShiftId"];
            this.cashierShift = data["cashierShift"] ? CashierShift.fromJS(data["cashierShift"]) : <any>undefined;
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.terminalId = data["terminalId"];
            this.promotionId = data["promotionId"];
            this.promotion = data["promotion"] ? PromotionCodeFB.fromJS(data["promotion"]) : <any>undefined;
            this.additionalAllowns = data["additionalAllowns"];
            this.version = data["version"];
            this.status = data["status"];
            this.templateType = data["templateType"];
            if (data["posResponseA90"] && data["posResponseA90"].constructor === Array) {
                this.posResponseA90 = [];
                for (let item of data["posResponseA90"])
                    this.posResponseA90.push(POSResponseA90.fromJS(item));
            }
            if (data["posResponseN90"] && data["posResponseN90"].constructor === Array) {
                this.posResponseN90 = [];
                for (let item of data["posResponseN90"])
                    this.posResponseN90.push(POSResponseN90.fromJS(item));
            }
            if (data["saleDetails"] && data["saleDetails"].constructor === Array) {
                this.saleDetails = [];
                for (let item of data["saleDetails"])
                    this.saleDetails.push(SaleTransactionDetail.fromJS(item));
            }
            if (data["salepaymentTransactions"] && data["salepaymentTransactions"].constructor === Array) {
                this.salepaymentTransactions = [];
                for (let item of data["salepaymentTransactions"])
                    this.salepaymentTransactions.push(SalepaymentTransactions.fromJS(item));
            }
            if (data["saleTransactionsDiningTables"] && data["saleTransactionsDiningTables"].constructor === Array) {
                this.saleTransactionsDiningTables = [];
                for (let item of data["saleTransactionsDiningTables"])
                    this.saleTransactionsDiningTables.push(SaleTransactionsDiningTable.fromJS(item));
            }
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            if (data["saleOffers"] && data["saleOffers"].constructor === Array) {
                this.saleOffers = [];
                for (let item of data["saleOffers"])
                    this.saleOffers.push(SaleTransactionOffer.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
            this.discount = data["discount"];
            this.discountType = data["discountType"];
            this.discountValue = data["discountValue"];
            this.happyHourId = data["happyHourId"];
            this.endOfDayId = data["endOfDayId"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            this.createdDeviceId = data["createdDeviceId"];
            this.lastModficationDeviceId = data["lastModficationDeviceId"];
            this.endOfDay = data["endOfDay"] ? EndOfDayDetail.fromJS(data["endOfDay"]) : <any>undefined;
            this.happyHour = data["happyHour"] ? HappyHour.fromJS(data["happyHour"]) : <any>undefined;
            if (data["zatcaTransaction"] && data["zatcaTransaction"].constructor === Array) {
                this.zatcaTransaction = [];
                for (let item of data["zatcaTransaction"])
                    this.zatcaTransaction.push(ZatcaTransaction.fromJS(item));
            }
            if (data["saleNotifications"] && data["saleNotifications"].constructor === Array) {
                this.saleNotifications = [];
                for (let item of data["saleNotifications"])
                    this.saleNotifications.push(SaleNotification.fromJS(item));
            }
            if (data["saleTransactionAddresses"] && data["saleTransactionAddresses"].constructor === Array) {
                this.saleTransactionAddresses = [];
                for (let item of data["saleTransactionAddresses"])
                    this.saleTransactionAddresses.push(SaleTransactionAddress.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransaction {
        let result = new SaleTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["salesManId"] = this.salesManId;
        data["salesMan"] = this.salesMan ? this.salesMan.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["refSaleTransaction"] = this.refSaleTransaction ? this.refSaleTransaction.toJSON() : <any>undefined;
        data["cashierId"] = this.cashierId;
        data["isCertificate"] = this.isCertificate;
        data["cashier"] = this.cashier ? this.cashier.toJSON() : <any>undefined;
        data["cashierShiftId"] = this.cashierShiftId;
        data["cashierShift"] = this.cashierShift ? this.cashierShift.toJSON() : <any>undefined;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["terminalId"] = this.terminalId;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["additionalAllowns"] = this.additionalAllowns;
        data["version"] = this.version;
        data["status"] = this.status;
        data["templateType"] = this.templateType;
        if (this.posResponseA90 && this.posResponseA90.constructor === Array) {
            data["posResponseA90"] = [];
            for (let item of this.posResponseA90)
                data["posResponseA90"].push(item.toJSON());
        }
        if (this.posResponseN90 && this.posResponseN90.constructor === Array) {
            data["posResponseN90"] = [];
            for (let item of this.posResponseN90)
                data["posResponseN90"].push(item.toJSON());
        }
        if (this.saleDetails && this.saleDetails.constructor === Array) {
            data["saleDetails"] = [];
            for (let item of this.saleDetails)
                data["saleDetails"].push(item.toJSON());
        }
        if (this.salepaymentTransactions && this.salepaymentTransactions.constructor === Array) {
            data["salepaymentTransactions"] = [];
            for (let item of this.salepaymentTransactions)
                data["salepaymentTransactions"].push(item.toJSON());
        }
        if (this.saleTransactionsDiningTables && this.saleTransactionsDiningTables.constructor === Array) {
            data["saleTransactionsDiningTables"] = [];
            for (let item of this.saleTransactionsDiningTables)
                data["saleTransactionsDiningTables"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (this.saleOffers && this.saleOffers.constructor === Array) {
            data["saleOffers"] = [];
            for (let item of this.saleOffers)
                data["saleOffers"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        data["discount"] = this.discount;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["happyHourId"] = this.happyHourId;
        data["endOfDayId"] = this.endOfDayId;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        data["createdDeviceId"] = this.createdDeviceId;
        data["lastModficationDeviceId"] = this.lastModficationDeviceId;
        data["endOfDay"] = this.endOfDay ? this.endOfDay.toJSON() : <any>undefined;
        data["happyHour"] = this.happyHour ? this.happyHour.toJSON() : <any>undefined;
        if (this.zatcaTransaction && this.zatcaTransaction.constructor === Array) {
            data["zatcaTransaction"] = [];
            for (let item of this.zatcaTransaction)
                data["zatcaTransaction"].push(item.toJSON());
        }
        if (this.saleNotifications && this.saleNotifications.constructor === Array) {
            data["saleNotifications"] = [];
            for (let item of this.saleNotifications)
                data["saleNotifications"].push(item.toJSON());
        }
        if (this.saleTransactionAddresses && this.saleTransactionAddresses.constructor === Array) {
            data["saleTransactionAddresses"] = [];
            for (let item of this.saleTransactionAddresses)
                data["saleTransactionAddresses"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransaction {
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    saleTypeId: number;
    saleType: SaleType;
    salesManId: number;
    salesMan: User;
    customer: Customer;
    refSaleTransactionId: string;
    refSaleTransaction: SaleTransaction;
    cashierId: number;
    isCertificate: number;
    cashier: User;
    cashierShiftId: number;
    cashierShift: CashierShift;
    subTotal: number;
    vat: number;
    total: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    terminalId: number;
    promotionId: number;
    promotion: PromotionCodeFB;
    additionalAllowns: number;
    version: number;
    status: SaleTransactionStatus;
    templateType: SaleTransactionTemplateType;
    posResponseA90: POSResponseA90[];
    posResponseN90: POSResponseN90[];
    saleDetails: SaleTransactionDetail[];
    salepaymentTransactions: SalepaymentTransactions[];
    saleTransactionsDiningTables: SaleTransactionsDiningTable[];
    date: moment.Moment;
    saleOffers: SaleTransactionOffer[];
    tenantId: number;
    notes: string;
    discount: number;
    discountType: number;
    discountValue: number;
    happyHourId: number;
    endOfDayId: number;
    loyaltyDiscount: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    endOfDay: EndOfDayDetail;
    happyHour: HappyHour;
    zatcaTransaction: ZatcaTransaction[];
    saleNotifications: SaleNotification[];
    saleTransactionAddresses: SaleTransactionAddress[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class CurrencyTranslation implements ICurrencyTranslation {
    currencyId: number;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICurrencyTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CurrencyTranslation {
        let result = new CurrencyTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrencyTranslation {
    currencyId: number;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RegionTranslation implements IRegionTranslation {
    name: string;
    regionId: number;
    region: Region;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRegionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.regionId = data["regionId"];
            this.region = data["region"] ? Region.fromJS(data["region"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionTranslation {
        let result = new RegionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["regionId"] = this.regionId;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegionTranslation {
    name: string;
    regionId: number;
    region: Region;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RegionStoreGroup implements IRegionStoreGroup {
    tenantId: number;
    tenantStoreGroupId: number;
    regionId: number;
    region: Region;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRegionStoreGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenantStoreGroupId = data["tenantStoreGroupId"];
            this.regionId = data["regionId"];
            this.region = data["region"] ? Region.fromJS(data["region"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionStoreGroup {
        let result = new RegionStoreGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantStoreGroupId"] = this.tenantStoreGroupId;
        data["regionId"] = this.regionId;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegionStoreGroup {
    tenantId: number;
    tenantStoreGroupId: number;
    regionId: number;
    region: Region;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class AreaTranslation implements IAreaTranslation {
    name: string;
    areaId: number;
    tenantStoreGroupId: number;
    area: Area;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IAreaTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.areaId = data["areaId"];
            this.tenantStoreGroupId = data["tenantStoreGroupId"];
            this.area = data["area"] ? Area.fromJS(data["area"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AreaTranslation {
        let result = new AreaTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["areaId"] = this.areaId;
        data["tenantStoreGroupId"] = this.tenantStoreGroupId;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAreaTranslation {
    name: string;
    areaId: number;
    tenantStoreGroupId: number;
    area: Area;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreGroupArea implements IStoreGroupArea {
    tenantId: number;
    storeGroupId: number;
    areaId: number;
    area: Area;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreGroupArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeGroupId = data["storeGroupId"];
            this.areaId = data["areaId"];
            this.area = data["area"] ? Area.fromJS(data["area"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreGroupArea {
        let result = new StoreGroupArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeGroupId"] = this.storeGroupId;
        data["areaId"] = this.areaId;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreGroupArea {
    tenantId: number;
    storeGroupId: number;
    areaId: number;
    area: Area;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SalesOrderUrl implements ISalesOrderUrl {
    tenantId: number;
    url: string;
    thirdPartyBusinessCentralId: string;
    thirdPartyBusinessCentral: ThirdPartyBusinessCentral;
    areaId: number;
    area: Area;
    encryptionKey: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISalesOrderUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.url = data["url"];
            this.thirdPartyBusinessCentralId = data["thirdPartyBusinessCentralId"];
            this.thirdPartyBusinessCentral = data["thirdPartyBusinessCentral"] ? ThirdPartyBusinessCentral.fromJS(data["thirdPartyBusinessCentral"]) : <any>undefined;
            this.areaId = data["areaId"];
            this.area = data["area"] ? Area.fromJS(data["area"]) : <any>undefined;
            this.encryptionKey = data["encryptionKey"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesOrderUrl {
        let result = new SalesOrderUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["url"] = this.url;
        data["thirdPartyBusinessCentralId"] = this.thirdPartyBusinessCentralId;
        data["thirdPartyBusinessCentral"] = this.thirdPartyBusinessCentral ? this.thirdPartyBusinessCentral.toJSON() : <any>undefined;
        data["areaId"] = this.areaId;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["encryptionKey"] = this.encryptionKey;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISalesOrderUrl {
    tenantId: number;
    url: string;
    thirdPartyBusinessCentralId: string;
    thirdPartyBusinessCentral: ThirdPartyBusinessCentral;
    areaId: number;
    area: Area;
    encryptionKey: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class ApplicationLanguage implements IApplicationLanguage {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IApplicationLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguage {
        let result = new ApplicationLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicationLanguage {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Product implements IProduct {
    code: string;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    cost: number;
    isService: boolean;
    isPurchased: boolean;
    hasVariants: boolean;
    isHidden: boolean;
    purchaseLimit: number;
    saleLimit: number;
    primaryCategoryId: number;
    primaryCategory: PrimaryCategory;
    secondaryCategoryId: number;
    secondaryCategory: SecondaryCategory;
    productCategoryId: number;
    productCategory: ProductCategory;
    groupId: number;
    group: Group;
    image: string;
    tenantId: number;
    imageId: string;
    vendors: ProductVendor[];
    productVariants: ProductVariant[];
    productTaxes: ProductTax[];
    attributes: ProductAttribute[];
    translations: ProductTranslation[];
    unitsOfMeasureConversions: ProductUnitOfMeasureConversion[];
    productLots: ProductLot[];
    productSerials: ProductSerials[];
    productStorePrices: ProductStorePrice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.referenceNumber = data["referenceNumber"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.cost = data["cost"];
            this.isService = data["isService"];
            this.isPurchased = data["isPurchased"];
            this.hasVariants = data["hasVariants"];
            this.isHidden = data["isHidden"];
            this.purchaseLimit = data["purchaseLimit"];
            this.saleLimit = data["saleLimit"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.primaryCategory = data["primaryCategory"] ? PrimaryCategory.fromJS(data["primaryCategory"]) : <any>undefined;
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.secondaryCategory = data["secondaryCategory"] ? SecondaryCategory.fromJS(data["secondaryCategory"]) : <any>undefined;
            this.productCategoryId = data["productCategoryId"];
            this.productCategory = data["productCategory"] ? ProductCategory.fromJS(data["productCategory"]) : <any>undefined;
            this.groupId = data["groupId"];
            this.group = data["group"] ? Group.fromJS(data["group"]) : <any>undefined;
            this.image = data["image"];
            this.tenantId = data["tenantId"];
            this.imageId = data["imageId"];
            if (data["vendors"] && data["vendors"].constructor === Array) {
                this.vendors = [];
                for (let item of data["vendors"])
                    this.vendors.push(ProductVendor.fromJS(item));
            }
            if (data["productVariants"] && data["productVariants"].constructor === Array) {
                this.productVariants = [];
                for (let item of data["productVariants"])
                    this.productVariants.push(ProductVariant.fromJS(item));
            }
            if (data["productTaxes"] && data["productTaxes"].constructor === Array) {
                this.productTaxes = [];
                for (let item of data["productTaxes"])
                    this.productTaxes.push(ProductTax.fromJS(item));
            }
            if (data["attributes"] && data["attributes"].constructor === Array) {
                this.attributes = [];
                for (let item of data["attributes"])
                    this.attributes.push(ProductAttribute.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductTranslation.fromJS(item));
            }
            if (data["unitsOfMeasureConversions"] && data["unitsOfMeasureConversions"].constructor === Array) {
                this.unitsOfMeasureConversions = [];
                for (let item of data["unitsOfMeasureConversions"])
                    this.unitsOfMeasureConversions.push(ProductUnitOfMeasureConversion.fromJS(item));
            }
            if (data["productLots"] && data["productLots"].constructor === Array) {
                this.productLots = [];
                for (let item of data["productLots"])
                    this.productLots.push(ProductLot.fromJS(item));
            }
            if (data["productSerials"] && data["productSerials"].constructor === Array) {
                this.productSerials = [];
                for (let item of data["productSerials"])
                    this.productSerials.push(ProductSerials.fromJS(item));
            }
            if (data["productStorePrices"] && data["productStorePrices"].constructor === Array) {
                this.productStorePrices = [];
                for (let item of data["productStorePrices"])
                    this.productStorePrices.push(ProductStorePrice.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Product {
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["referenceNumber"] = this.referenceNumber;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["cost"] = this.cost;
        data["isService"] = this.isService;
        data["isPurchased"] = this.isPurchased;
        data["hasVariants"] = this.hasVariants;
        data["isHidden"] = this.isHidden;
        data["purchaseLimit"] = this.purchaseLimit;
        data["saleLimit"] = this.saleLimit;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["primaryCategory"] = this.primaryCategory ? this.primaryCategory.toJSON() : <any>undefined;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["secondaryCategory"] = this.secondaryCategory ? this.secondaryCategory.toJSON() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["image"] = this.image;
        data["tenantId"] = this.tenantId;
        data["imageId"] = this.imageId;
        if (this.vendors && this.vendors.constructor === Array) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item.toJSON());
        }
        if (this.productVariants && this.productVariants.constructor === Array) {
            data["productVariants"] = [];
            for (let item of this.productVariants)
                data["productVariants"].push(item.toJSON());
        }
        if (this.productTaxes && this.productTaxes.constructor === Array) {
            data["productTaxes"] = [];
            for (let item of this.productTaxes)
                data["productTaxes"].push(item.toJSON());
        }
        if (this.attributes && this.attributes.constructor === Array) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.unitsOfMeasureConversions && this.unitsOfMeasureConversions.constructor === Array) {
            data["unitsOfMeasureConversions"] = [];
            for (let item of this.unitsOfMeasureConversions)
                data["unitsOfMeasureConversions"].push(item.toJSON());
        }
        if (this.productLots && this.productLots.constructor === Array) {
            data["productLots"] = [];
            for (let item of this.productLots)
                data["productLots"].push(item.toJSON());
        }
        if (this.productSerials && this.productSerials.constructor === Array) {
            data["productSerials"] = [];
            for (let item of this.productSerials)
                data["productSerials"].push(item.toJSON());
        }
        if (this.productStorePrices && this.productStorePrices.constructor === Array) {
            data["productStorePrices"] = [];
            for (let item of this.productStorePrices)
                data["productStorePrices"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProduct {
    code: string;
    referenceNumber: string;
    price: number;
    priceIncludingVAT: number;
    cost: number;
    isService: boolean;
    isPurchased: boolean;
    hasVariants: boolean;
    isHidden: boolean;
    purchaseLimit: number;
    saleLimit: number;
    primaryCategoryId: number;
    primaryCategory: PrimaryCategory;
    secondaryCategoryId: number;
    secondaryCategory: SecondaryCategory;
    productCategoryId: number;
    productCategory: ProductCategory;
    groupId: number;
    group: Group;
    image: string;
    tenantId: number;
    imageId: string;
    vendors: ProductVendor[];
    productVariants: ProductVariant[];
    productTaxes: ProductTax[];
    attributes: ProductAttribute[];
    translations: ProductTranslation[];
    unitsOfMeasureConversions: ProductUnitOfMeasureConversion[];
    productLots: ProductLot[];
    productSerials: ProductSerials[];
    productStorePrices: ProductStorePrice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductVariant implements IProductVariant {
    productId: number;
    product: Product;
    variantValue1Id: number;
    variantValue1: VariantValue;
    variantValue2Id: number;
    variantValue2: VariantValue;
    variantValue3Id: number;
    variantValue3: VariantValue;
    code: string;
    price: number;
    translations: ProductVariantTranslation[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.variantValue1Id = data["variantValue1Id"];
            this.variantValue1 = data["variantValue1"] ? VariantValue.fromJS(data["variantValue1"]) : <any>undefined;
            this.variantValue2Id = data["variantValue2Id"];
            this.variantValue2 = data["variantValue2"] ? VariantValue.fromJS(data["variantValue2"]) : <any>undefined;
            this.variantValue3Id = data["variantValue3Id"];
            this.variantValue3 = data["variantValue3"] ? VariantValue.fromJS(data["variantValue3"]) : <any>undefined;
            this.code = data["code"];
            this.price = data["price"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductVariantTranslation.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductVariant {
        let result = new ProductVariant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["variantValue1Id"] = this.variantValue1Id;
        data["variantValue1"] = this.variantValue1 ? this.variantValue1.toJSON() : <any>undefined;
        data["variantValue2Id"] = this.variantValue2Id;
        data["variantValue2"] = this.variantValue2 ? this.variantValue2.toJSON() : <any>undefined;
        data["variantValue3Id"] = this.variantValue3Id;
        data["variantValue3"] = this.variantValue3 ? this.variantValue3.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["price"] = this.price;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductVariant {
    productId: number;
    product: Product;
    variantValue1Id: number;
    variantValue1: VariantValue;
    variantValue2Id: number;
    variantValue2: VariantValue;
    variantValue3Id: number;
    variantValue3: VariantValue;
    code: string;
    price: number;
    translations: ProductVariantTranslation[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UnitOfMeasure implements IUnitOfMeasure {
    code: string;
    tenantId: number;
    translations: UnitOfMeasureTranslation[];
    productUnitOfMeasureConversions: ProductUnitOfMeasureConversion[];
    comboGroupDetails: ComboGroupDetail[];
    productStorePrices: ProductStorePrice[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUnitOfMeasure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(UnitOfMeasureTranslation.fromJS(item));
            }
            if (data["productUnitOfMeasureConversions"] && data["productUnitOfMeasureConversions"].constructor === Array) {
                this.productUnitOfMeasureConversions = [];
                for (let item of data["productUnitOfMeasureConversions"])
                    this.productUnitOfMeasureConversions.push(ProductUnitOfMeasureConversion.fromJS(item));
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetail.fromJS(item));
            }
            if (data["productStorePrices"] && data["productStorePrices"].constructor === Array) {
                this.productStorePrices = [];
                for (let item of data["productStorePrices"])
                    this.productStorePrices.push(ProductStorePrice.fromJS(item));
            }
            if (data["recipeTransactionSummaries"] && data["recipeTransactionSummaries"].constructor === Array) {
                this.recipeTransactionSummaries = [];
                for (let item of data["recipeTransactionSummaries"])
                    this.recipeTransactionSummaries.push(RecipeTransactionSummary.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnitOfMeasure {
        let result = new UnitOfMeasure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.productUnitOfMeasureConversions && this.productUnitOfMeasureConversions.constructor === Array) {
            data["productUnitOfMeasureConversions"] = [];
            for (let item of this.productUnitOfMeasureConversions)
                data["productUnitOfMeasureConversions"].push(item.toJSON());
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        if (this.productStorePrices && this.productStorePrices.constructor === Array) {
            data["productStorePrices"] = [];
            for (let item of this.productStorePrices)
                data["productStorePrices"].push(item.toJSON());
        }
        if (this.recipeTransactionSummaries && this.recipeTransactionSummaries.constructor === Array) {
            data["recipeTransactionSummaries"] = [];
            for (let item of this.recipeTransactionSummaries)
                data["recipeTransactionSummaries"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUnitOfMeasure {
    code: string;
    tenantId: number;
    translations: UnitOfMeasureTranslation[];
    productUnitOfMeasureConversions: ProductUnitOfMeasureConversion[];
    comboGroupDetails: ComboGroupDetail[];
    productStorePrices: ProductStorePrice[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PurchaseInvoice implements IPurchaseInvoice {
    invoiceNumber: string;
    code: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    vendor: Vendor;
    purchaseTotal: number;
    productLots: ProductLot[];
    tenantId: number;
    discountTypeId: number;
    discountAmount: number;
    approvalStatus: PurchaseInvoiceApprovalStatus;
    pendingProducts: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPurchaseInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.invoiceNumber = data["invoiceNumber"];
            this.code = data["code"];
            this.purchaseDate = data["purchaseDate"] ? moment(data["purchaseDate"].toString()) : <any>undefined;
            this.vendorId = data["vendorId"];
            this.vendor = data["vendor"] ? Vendor.fromJS(data["vendor"]) : <any>undefined;
            this.purchaseTotal = data["purchaseTotal"];
            if (data["productLots"] && data["productLots"].constructor === Array) {
                this.productLots = [];
                for (let item of data["productLots"])
                    this.productLots.push(ProductLot.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.discountTypeId = data["discountTypeId"];
            this.discountAmount = data["discountAmount"];
            this.approvalStatus = data["approvalStatus"];
            this.pendingProducts = data["pendingProducts"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PurchaseInvoice {
        let result = new PurchaseInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["code"] = this.code;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["purchaseTotal"] = this.purchaseTotal;
        if (this.productLots && this.productLots.constructor === Array) {
            data["productLots"] = [];
            for (let item of this.productLots)
                data["productLots"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["discountTypeId"] = this.discountTypeId;
        data["discountAmount"] = this.discountAmount;
        data["approvalStatus"] = this.approvalStatus;
        data["pendingProducts"] = this.pendingProducts;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPurchaseInvoice {
    invoiceNumber: string;
    code: string;
    purchaseDate: moment.Moment;
    vendorId: number;
    vendor: Vendor;
    purchaseTotal: number;
    productLots: ProductLot[];
    tenantId: number;
    discountTypeId: number;
    discountAmount: number;
    approvalStatus: PurchaseInvoiceApprovalStatus;
    pendingProducts: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreWorkingHoursRule implements IStoreWorkingHoursRule {
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    tenantId: number;
    isActive: boolean;
    daysWorkingHours: StoreDayWorkingHours[];
    stores: StoreWorkingHours[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreWorkingHoursRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.activeStartDate = data["activeStartDate"] ? moment(data["activeStartDate"].toString()) : <any>undefined;
            this.activeEndDate = data["activeEndDate"] ? moment(data["activeEndDate"].toString()) : <any>undefined;
            this.isActiveEndOfDay = data["isActiveEndOfDay"];
            this.isMustCloseOldShift = data["isMustCloseOldShift"];
            this.canCashierEndTheDayBeforeTime = data["canCashierEndTheDayBeforeTime"];
            this.startOfDay = data["startOfDay"];
            this.endOfDay = data["endOfDay"];
            this.tenantId = data["tenantId"];
            this.isActive = data["isActive"];
            if (data["daysWorkingHours"] && data["daysWorkingHours"].constructor === Array) {
                this.daysWorkingHours = [];
                for (let item of data["daysWorkingHours"])
                    this.daysWorkingHours.push(StoreDayWorkingHours.fromJS(item));
            }
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(StoreWorkingHours.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreWorkingHoursRule {
        let result = new StoreWorkingHoursRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["activeStartDate"] = this.activeStartDate ? this.activeStartDate.toISOString() : <any>undefined;
        data["activeEndDate"] = this.activeEndDate ? this.activeEndDate.toISOString() : <any>undefined;
        data["isActiveEndOfDay"] = this.isActiveEndOfDay;
        data["isMustCloseOldShift"] = this.isMustCloseOldShift;
        data["canCashierEndTheDayBeforeTime"] = this.canCashierEndTheDayBeforeTime;
        data["startOfDay"] = this.startOfDay;
        data["endOfDay"] = this.endOfDay;
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        if (this.daysWorkingHours && this.daysWorkingHours.constructor === Array) {
            data["daysWorkingHours"] = [];
            for (let item of this.daysWorkingHours)
                data["daysWorkingHours"].push(item.toJSON());
        }
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreWorkingHoursRule {
    name: string;
    activeStartDate: moment.Moment;
    activeEndDate: moment.Moment;
    isActiveEndOfDay: boolean;
    isMustCloseOldShift: boolean;
    canCashierEndTheDayBeforeTime: boolean;
    startOfDay: string;
    endOfDay: string;
    tenantId: number;
    isActive: boolean;
    daysWorkingHours: StoreDayWorkingHours[];
    stores: StoreWorkingHours[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class User implements IUser {
    profilePictureId: string;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: moment.Moment;
    signInToken: string;
    googleAuthenticatorKey: string;
    isEndShiftMessage: boolean;
    endShiftEmailAddress: string;
    limitDiscount: number;
    limitDiscountType: number;
    stores: UserStores[];
    userDevices: UserDevices[];
    pinCode: string;
    code: string;
    counterCode: string;
    isDefault: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string;
    tokens: UserToken[];
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string;
    userName: string;
    tenantId: number;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string;
    password: string;
    emailConfirmationCode: string;
    passwordResetCode: string;
    lockoutEndDateUtc: moment.Moment;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[];
    roles: UserRole[];
    claims: UserClaim[];
    permissions: UserPermissionSetting[];
    settings: Setting[];
    isEmailConfirmed: boolean;
    isActive: boolean;
    lastLoginTime: moment.Moment;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.signInTokenExpireTimeUtc = data["signInTokenExpireTimeUtc"] ? moment(data["signInTokenExpireTimeUtc"].toString()) : <any>undefined;
            this.signInToken = data["signInToken"];
            this.googleAuthenticatorKey = data["googleAuthenticatorKey"];
            this.isEndShiftMessage = data["isEndShiftMessage"];
            this.endShiftEmailAddress = data["endShiftEmailAddress"];
            this.limitDiscount = data["limitDiscount"];
            this.limitDiscountType = data["limitDiscountType"];
            if (data["stores"] && data["stores"].constructor === Array) {
                this.stores = [];
                for (let item of data["stores"])
                    this.stores.push(UserStores.fromJS(item));
            }
            if (data["userDevices"] && data["userDevices"].constructor === Array) {
                this.userDevices = [];
                for (let item of data["userDevices"])
                    this.userDevices.push(UserDevices.fromJS(item));
            }
            this.pinCode = data["pinCode"];
            this.code = data["code"];
            this.counterCode = data["counterCode"];
            this.isDefault = data["isDefault"];
            this.normalizedUserName = data["normalizedUserName"];
            this.normalizedEmailAddress = data["normalizedEmailAddress"];
            this.concurrencyStamp = data["concurrencyStamp"];
            if (data["tokens"] && data["tokens"].constructor === Array) {
                this.tokens = [];
                for (let item of data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : <any>undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = data["authenticationSource"];
            this.userName = data["userName"];
            this.tenantId = data["tenantId"];
            this.emailAddress = data["emailAddress"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.fullName = data["fullName"];
            this.password = data["password"];
            this.emailConfirmationCode = data["emailConfirmationCode"];
            this.passwordResetCode = data["passwordResetCode"];
            this.lockoutEndDateUtc = data["lockoutEndDateUtc"] ? moment(data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = data["accessFailedCount"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.securityStamp = data["securityStamp"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            if (data["logins"] && data["logins"].constructor === Array) {
                this.logins = [];
                for (let item of data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (data["claims"] && data["claims"].constructor === Array) {
                this.claims = [];
                for (let item of data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (data["settings"] && data["settings"].constructor === Array) {
                this.settings = [];
                for (let item of data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.isActive = data["isActive"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): User {
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : <any>undefined;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["isEndShiftMessage"] = this.isEndShiftMessage;
        data["endShiftEmailAddress"] = this.endShiftEmailAddress;
        data["limitDiscount"] = this.limitDiscount;
        data["limitDiscountType"] = this.limitDiscountType;
        if (this.stores && this.stores.constructor === Array) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        if (this.userDevices && this.userDevices.constructor === Array) {
            data["userDevices"] = [];
            for (let item of this.userDevices)
                data["userDevices"].push(item.toJSON());
        }
        data["pinCode"] = this.pinCode;
        data["code"] = this.code;
        data["counterCode"] = this.counterCode;
        data["isDefault"] = this.isDefault;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (this.tokens && this.tokens.constructor === Array) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (this.logins && this.logins.constructor === Array) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.claims && this.claims.constructor === Array) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.settings && this.settings.constructor === Array) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUser {
    profilePictureId: string;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: moment.Moment;
    signInToken: string;
    googleAuthenticatorKey: string;
    isEndShiftMessage: boolean;
    endShiftEmailAddress: string;
    limitDiscount: number;
    limitDiscountType: number;
    stores: UserStores[];
    userDevices: UserDevices[];
    pinCode: string;
    code: string;
    counterCode: string;
    isDefault: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string;
    tokens: UserToken[];
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string;
    userName: string;
    tenantId: number;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string;
    password: string;
    emailConfirmationCode: string;
    passwordResetCode: string;
    lockoutEndDateUtc: moment.Moment;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[];
    roles: UserRole[];
    claims: UserClaim[];
    permissions: UserPermissionSetting[];
    settings: Setting[];
    isEmailConfirmed: boolean;
    isActive: boolean;
    lastLoginTime: moment.Moment;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Device implements IDevice {
    tenantId: number;
    deviceId: number;
    deviceTypeId: number;
    connectorTypeId: number;
    languageId: number;
    backupDeviceId: number;
    machineName: string;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    kdsId: string;
    kdsIp: string;
    addressIp: string;
    isCentral: boolean;
    coordinatorId: string;
    coordinatorIp: string;
    deviceSaleTypes: DeviceSaleType[];
    devicePC: DevicePC[];
    deviceTables: DeviceTables[];
    deviceCategories: DeviceCategory[];
    storeDevicecs: StoreDevicecs[];
    menuItemDevices: MenuItemDevice[];
    userDevices: UserDevices[];
    tableNumberAvilable: number;
    backupDevice: Device;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.deviceTypeId = data["deviceTypeId"];
            this.connectorTypeId = data["connectorTypeId"];
            this.languageId = data["languageId"];
            this.backupDeviceId = data["backupDeviceId"];
            this.machineName = data["machineName"];
            this.assigningAuthenticationObj = data["assigningAuthenticationObj"];
            this.addPicture = data["addPicture"];
            this.changColorFont = data["changColorFont"];
            this.kdsId = data["kdsId"];
            this.kdsIp = data["kdsIp"];
            this.addressIp = data["addressIp"];
            this.isCentral = data["isCentral"];
            this.coordinatorId = data["coordinatorId"];
            this.coordinatorIp = data["coordinatorIp"];
            if (data["deviceSaleTypes"] && data["deviceSaleTypes"].constructor === Array) {
                this.deviceSaleTypes = [];
                for (let item of data["deviceSaleTypes"])
                    this.deviceSaleTypes.push(DeviceSaleType.fromJS(item));
            }
            if (data["devicePC"] && data["devicePC"].constructor === Array) {
                this.devicePC = [];
                for (let item of data["devicePC"])
                    this.devicePC.push(DevicePC.fromJS(item));
            }
            if (data["deviceTables"] && data["deviceTables"].constructor === Array) {
                this.deviceTables = [];
                for (let item of data["deviceTables"])
                    this.deviceTables.push(DeviceTables.fromJS(item));
            }
            if (data["deviceCategories"] && data["deviceCategories"].constructor === Array) {
                this.deviceCategories = [];
                for (let item of data["deviceCategories"])
                    this.deviceCategories.push(DeviceCategory.fromJS(item));
            }
            if (data["storeDevicecs"] && data["storeDevicecs"].constructor === Array) {
                this.storeDevicecs = [];
                for (let item of data["storeDevicecs"])
                    this.storeDevicecs.push(StoreDevicecs.fromJS(item));
            }
            if (data["menuItemDevices"] && data["menuItemDevices"].constructor === Array) {
                this.menuItemDevices = [];
                for (let item of data["menuItemDevices"])
                    this.menuItemDevices.push(MenuItemDevice.fromJS(item));
            }
            if (data["userDevices"] && data["userDevices"].constructor === Array) {
                this.userDevices = [];
                for (let item of data["userDevices"])
                    this.userDevices.push(UserDevices.fromJS(item));
            }
            this.tableNumberAvilable = data["tableNumberAvilable"];
            this.backupDevice = data["backupDevice"] ? Device.fromJS(data["backupDevice"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Device {
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["connectorTypeId"] = this.connectorTypeId;
        data["languageId"] = this.languageId;
        data["backupDeviceId"] = this.backupDeviceId;
        data["machineName"] = this.machineName;
        data["assigningAuthenticationObj"] = this.assigningAuthenticationObj;
        data["addPicture"] = this.addPicture;
        data["changColorFont"] = this.changColorFont;
        data["kdsId"] = this.kdsId;
        data["kdsIp"] = this.kdsIp;
        data["addressIp"] = this.addressIp;
        data["isCentral"] = this.isCentral;
        data["coordinatorId"] = this.coordinatorId;
        data["coordinatorIp"] = this.coordinatorIp;
        if (this.deviceSaleTypes && this.deviceSaleTypes.constructor === Array) {
            data["deviceSaleTypes"] = [];
            for (let item of this.deviceSaleTypes)
                data["deviceSaleTypes"].push(item.toJSON());
        }
        if (this.devicePC && this.devicePC.constructor === Array) {
            data["devicePC"] = [];
            for (let item of this.devicePC)
                data["devicePC"].push(item.toJSON());
        }
        if (this.deviceTables && this.deviceTables.constructor === Array) {
            data["deviceTables"] = [];
            for (let item of this.deviceTables)
                data["deviceTables"].push(item.toJSON());
        }
        if (this.deviceCategories && this.deviceCategories.constructor === Array) {
            data["deviceCategories"] = [];
            for (let item of this.deviceCategories)
                data["deviceCategories"].push(item.toJSON());
        }
        if (this.storeDevicecs && this.storeDevicecs.constructor === Array) {
            data["storeDevicecs"] = [];
            for (let item of this.storeDevicecs)
                data["storeDevicecs"].push(item.toJSON());
        }
        if (this.menuItemDevices && this.menuItemDevices.constructor === Array) {
            data["menuItemDevices"] = [];
            for (let item of this.menuItemDevices)
                data["menuItemDevices"].push(item.toJSON());
        }
        if (this.userDevices && this.userDevices.constructor === Array) {
            data["userDevices"] = [];
            for (let item of this.userDevices)
                data["userDevices"].push(item.toJSON());
        }
        data["tableNumberAvilable"] = this.tableNumberAvilable;
        data["backupDevice"] = this.backupDevice ? this.backupDevice.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDevice {
    tenantId: number;
    deviceId: number;
    deviceTypeId: number;
    connectorTypeId: number;
    languageId: number;
    backupDeviceId: number;
    machineName: string;
    assigningAuthenticationObj: string;
    addPicture: string;
    changColorFont: string;
    kdsId: string;
    kdsIp: string;
    addressIp: string;
    isCentral: boolean;
    coordinatorId: string;
    coordinatorIp: string;
    deviceSaleTypes: DeviceSaleType[];
    devicePC: DevicePC[];
    deviceTables: DeviceTables[];
    deviceCategories: DeviceCategory[];
    storeDevicecs: StoreDevicecs[];
    menuItemDevices: MenuItemDevice[];
    userDevices: UserDevices[];
    tableNumberAvilable: number;
    backupDevice: Device;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PC implements IPC {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    saleType: SaleType;
    ipAddress: string;
    tenantId: number;
    devicePC: DevicePC[];
    deviceTables: DeviceTables[];
    deviceCategories: DeviceCategory[];
    storeDevicecs: StoreDevicecs[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPC) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pcId = data["pcId"];
            this.machineName = data["machineName"];
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.ipAddress = data["ipAddress"];
            this.tenantId = data["tenantId"];
            if (data["devicePC"] && data["devicePC"].constructor === Array) {
                this.devicePC = [];
                for (let item of data["devicePC"])
                    this.devicePC.push(DevicePC.fromJS(item));
            }
            if (data["deviceTables"] && data["deviceTables"].constructor === Array) {
                this.deviceTables = [];
                for (let item of data["deviceTables"])
                    this.deviceTables.push(DeviceTables.fromJS(item));
            }
            if (data["deviceCategories"] && data["deviceCategories"].constructor === Array) {
                this.deviceCategories = [];
                for (let item of data["deviceCategories"])
                    this.deviceCategories.push(DeviceCategory.fromJS(item));
            }
            if (data["storeDevicecs"] && data["storeDevicecs"].constructor === Array) {
                this.storeDevicecs = [];
                for (let item of data["storeDevicecs"])
                    this.storeDevicecs.push(StoreDevicecs.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PC {
        let result = new PC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcId"] = this.pcId;
        data["machineName"] = this.machineName;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["ipAddress"] = this.ipAddress;
        data["tenantId"] = this.tenantId;
        if (this.devicePC && this.devicePC.constructor === Array) {
            data["devicePC"] = [];
            for (let item of this.devicePC)
                data["devicePC"].push(item.toJSON());
        }
        if (this.deviceTables && this.deviceTables.constructor === Array) {
            data["deviceTables"] = [];
            for (let item of this.deviceTables)
                data["deviceTables"].push(item.toJSON());
        }
        if (this.deviceCategories && this.deviceCategories.constructor === Array) {
            data["deviceCategories"] = [];
            for (let item of this.deviceCategories)
                data["deviceCategories"].push(item.toJSON());
        }
        if (this.storeDevicecs && this.storeDevicecs.constructor === Array) {
            data["storeDevicecs"] = [];
            for (let item of this.storeDevicecs)
                data["storeDevicecs"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPC {
    pcId: number;
    machineName: string;
    saleTypeId: number;
    saleType: SaleType;
    ipAddress: string;
    tenantId: number;
    devicePC: DevicePC[];
    deviceTables: DeviceTables[];
    deviceCategories: DeviceCategory[];
    storeDevicecs: StoreDevicecs[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class HappyHour implements IHappyHour {
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    tenantId: number;
    typeId: number;
    typeName: string;
    discountTypeFlag: boolean;
    discountValue: number;
    translations: HappyHourTranslation[];
    storeHappyHours: StoreHappyHours[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IHappyHour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateFrom = data["dateFrom"] ? moment(data["dateFrom"].toString()) : <any>undefined;
            this.timeFrom = data["timeFrom"];
            this.timeTo = data["timeTo"];
            this.tenantId = data["tenantId"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.discountTypeFlag = data["discountTypeFlag"];
            this.discountValue = data["discountValue"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(HappyHourTranslation.fromJS(item));
            }
            if (data["storeHappyHours"] && data["storeHappyHours"].constructor === Array) {
                this.storeHappyHours = [];
                for (let item of data["storeHappyHours"])
                    this.storeHappyHours.push(StoreHappyHours.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HappyHour {
        let result = new HappyHour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["tenantId"] = this.tenantId;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["discountTypeFlag"] = this.discountTypeFlag;
        data["discountValue"] = this.discountValue;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.storeHappyHours && this.storeHappyHours.constructor === Array) {
            data["storeHappyHours"] = [];
            for (let item of this.storeHappyHours)
                data["storeHappyHours"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHappyHour {
    dateFrom: moment.Moment;
    timeFrom: string;
    timeTo: string;
    tenantId: number;
    typeId: number;
    typeName: string;
    discountTypeFlag: boolean;
    discountValue: number;
    translations: HappyHourTranslation[];
    storeHappyHours: StoreHappyHours[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleType implements ISaleType {
    code: string;
    tenantId: number;
    hasRoles: boolean;
    saleNatural: SaleTypeSaleNatural;
    imageId: string;
    saleTypeStores: SaleTypeStore[];
    translations: SaleTypeTranslation[];
    saleTypePriceLists: SaleTypePriceList[];
    saleTypeComboGroups: SaleTypeComboGroup[];
    serviceCharges: ServiceChargeSaleType[];
    menuItemSaleTypes: MenuItemSaleType[];
    saleTypesRoles: SaleTypesRoles[];
    recipeRawMaterialSaleTypes: RecipeRawMaterialSaleType[];
    rawMaterialDetailSaleTypes: RawMaterialDetailSaleType[];
    customerSaleTypes: CustomerSaleType[];
    tenderTypeSaleTypes: TenderTypeSaleType[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            this.hasRoles = data["hasRoles"];
            this.saleNatural = data["saleNatural"];
            this.imageId = data["imageId"];
            if (data["saleTypeStores"] && data["saleTypeStores"].constructor === Array) {
                this.saleTypeStores = [];
                for (let item of data["saleTypeStores"])
                    this.saleTypeStores.push(SaleTypeStore.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SaleTypeTranslation.fromJS(item));
            }
            if (data["saleTypePriceLists"] && data["saleTypePriceLists"].constructor === Array) {
                this.saleTypePriceLists = [];
                for (let item of data["saleTypePriceLists"])
                    this.saleTypePriceLists.push(SaleTypePriceList.fromJS(item));
            }
            if (data["saleTypeComboGroups"] && data["saleTypeComboGroups"].constructor === Array) {
                this.saleTypeComboGroups = [];
                for (let item of data["saleTypeComboGroups"])
                    this.saleTypeComboGroups.push(SaleTypeComboGroup.fromJS(item));
            }
            if (data["serviceCharges"] && data["serviceCharges"].constructor === Array) {
                this.serviceCharges = [];
                for (let item of data["serviceCharges"])
                    this.serviceCharges.push(ServiceChargeSaleType.fromJS(item));
            }
            if (data["menuItemSaleTypes"] && data["menuItemSaleTypes"].constructor === Array) {
                this.menuItemSaleTypes = [];
                for (let item of data["menuItemSaleTypes"])
                    this.menuItemSaleTypes.push(MenuItemSaleType.fromJS(item));
            }
            if (data["saleTypesRoles"] && data["saleTypesRoles"].constructor === Array) {
                this.saleTypesRoles = [];
                for (let item of data["saleTypesRoles"])
                    this.saleTypesRoles.push(SaleTypesRoles.fromJS(item));
            }
            if (data["recipeRawMaterialSaleTypes"] && data["recipeRawMaterialSaleTypes"].constructor === Array) {
                this.recipeRawMaterialSaleTypes = [];
                for (let item of data["recipeRawMaterialSaleTypes"])
                    this.recipeRawMaterialSaleTypes.push(RecipeRawMaterialSaleType.fromJS(item));
            }
            if (data["rawMaterialDetailSaleTypes"] && data["rawMaterialDetailSaleTypes"].constructor === Array) {
                this.rawMaterialDetailSaleTypes = [];
                for (let item of data["rawMaterialDetailSaleTypes"])
                    this.rawMaterialDetailSaleTypes.push(RawMaterialDetailSaleType.fromJS(item));
            }
            if (data["customerSaleTypes"] && data["customerSaleTypes"].constructor === Array) {
                this.customerSaleTypes = [];
                for (let item of data["customerSaleTypes"])
                    this.customerSaleTypes.push(CustomerSaleType.fromJS(item));
            }
            if (data["tenderTypeSaleTypes"] && data["tenderTypeSaleTypes"].constructor === Array) {
                this.tenderTypeSaleTypes = [];
                for (let item of data["tenderTypeSaleTypes"])
                    this.tenderTypeSaleTypes.push(TenderTypeSaleType.fromJS(item));
            }
            if (data["recipeTransactionSummaries"] && data["recipeTransactionSummaries"].constructor === Array) {
                this.recipeTransactionSummaries = [];
                for (let item of data["recipeTransactionSummaries"])
                    this.recipeTransactionSummaries.push(RecipeTransactionSummary.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleType {
        let result = new SaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        data["hasRoles"] = this.hasRoles;
        data["saleNatural"] = this.saleNatural;
        data["imageId"] = this.imageId;
        if (this.saleTypeStores && this.saleTypeStores.constructor === Array) {
            data["saleTypeStores"] = [];
            for (let item of this.saleTypeStores)
                data["saleTypeStores"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.saleTypePriceLists && this.saleTypePriceLists.constructor === Array) {
            data["saleTypePriceLists"] = [];
            for (let item of this.saleTypePriceLists)
                data["saleTypePriceLists"].push(item.toJSON());
        }
        if (this.saleTypeComboGroups && this.saleTypeComboGroups.constructor === Array) {
            data["saleTypeComboGroups"] = [];
            for (let item of this.saleTypeComboGroups)
                data["saleTypeComboGroups"].push(item.toJSON());
        }
        if (this.serviceCharges && this.serviceCharges.constructor === Array) {
            data["serviceCharges"] = [];
            for (let item of this.serviceCharges)
                data["serviceCharges"].push(item.toJSON());
        }
        if (this.menuItemSaleTypes && this.menuItemSaleTypes.constructor === Array) {
            data["menuItemSaleTypes"] = [];
            for (let item of this.menuItemSaleTypes)
                data["menuItemSaleTypes"].push(item.toJSON());
        }
        if (this.saleTypesRoles && this.saleTypesRoles.constructor === Array) {
            data["saleTypesRoles"] = [];
            for (let item of this.saleTypesRoles)
                data["saleTypesRoles"].push(item.toJSON());
        }
        if (this.recipeRawMaterialSaleTypes && this.recipeRawMaterialSaleTypes.constructor === Array) {
            data["recipeRawMaterialSaleTypes"] = [];
            for (let item of this.recipeRawMaterialSaleTypes)
                data["recipeRawMaterialSaleTypes"].push(item.toJSON());
        }
        if (this.rawMaterialDetailSaleTypes && this.rawMaterialDetailSaleTypes.constructor === Array) {
            data["rawMaterialDetailSaleTypes"] = [];
            for (let item of this.rawMaterialDetailSaleTypes)
                data["rawMaterialDetailSaleTypes"].push(item.toJSON());
        }
        if (this.customerSaleTypes && this.customerSaleTypes.constructor === Array) {
            data["customerSaleTypes"] = [];
            for (let item of this.customerSaleTypes)
                data["customerSaleTypes"].push(item.toJSON());
        }
        if (this.tenderTypeSaleTypes && this.tenderTypeSaleTypes.constructor === Array) {
            data["tenderTypeSaleTypes"] = [];
            for (let item of this.tenderTypeSaleTypes)
                data["tenderTypeSaleTypes"].push(item.toJSON());
        }
        if (this.recipeTransactionSummaries && this.recipeTransactionSummaries.constructor === Array) {
            data["recipeTransactionSummaries"] = [];
            for (let item of this.recipeTransactionSummaries)
                data["recipeTransactionSummaries"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleType {
    code: string;
    tenantId: number;
    hasRoles: boolean;
    saleNatural: SaleTypeSaleNatural;
    imageId: string;
    saleTypeStores: SaleTypeStore[];
    translations: SaleTypeTranslation[];
    saleTypePriceLists: SaleTypePriceList[];
    saleTypeComboGroups: SaleTypeComboGroup[];
    serviceCharges: ServiceChargeSaleType[];
    menuItemSaleTypes: MenuItemSaleType[];
    saleTypesRoles: SaleTypesRoles[];
    recipeRawMaterialSaleTypes: RecipeRawMaterialSaleType[];
    rawMaterialDetailSaleTypes: RawMaterialDetailSaleType[];
    customerSaleTypes: CustomerSaleType[];
    tenderTypeSaleTypes: TenderTypeSaleType[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RawMaterial implements IRawMaterial {
    tenantId: number;
    translations: RawMaterialTranslation[];
    materialGroupId: number;
    materialGroup: SecondaryCategory;
    reOrderLevel: number;
    maxQuantity: number;
    barCode: string;
    sellingPrice: number;
    itemCost: RawMaterialItemCost;
    period: Period;
    periodId: number;
    isBatch: boolean;
    suppliers: RawMaterialSupplier[];
    inventoryUnitOfMeasure: UnitOfMeasure;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasure: UnitOfMeasure;
    productUnitOfMeasureId: number;
    purchaseUnitOfMeasure: UnitOfMeasure;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    hasDueDate: boolean;
    referenceMaterialId: number;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    isRecipe: boolean;
    rawMaterialDetail: RawMaterialDetail[];
    rawMaterialComponent: RawMaterialDetail[];
    materialStocks: MaterialStock[];
    relatedRawMaterials: RawMaterial[];
    currentMaterial: RawMaterial;
    entryMaterialStocks: EntryMaterialStock[];
    storeRawMaterialConfigs: RawMaterialConfig[];
    rawMaterialStoreGroups: RawMaterialStoreGroup[];
    variantValues: VariantValue[];
    detailTransactions: DetailTransactionEntity[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RawMaterialTranslation.fromJS(item));
            }
            this.materialGroupId = data["materialGroupId"];
            this.materialGroup = data["materialGroup"] ? SecondaryCategory.fromJS(data["materialGroup"]) : <any>undefined;
            this.reOrderLevel = data["reOrderLevel"];
            this.maxQuantity = data["maxQuantity"];
            this.barCode = data["barCode"];
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
            this.period = data["period"] ? Period.fromJS(data["period"]) : <any>undefined;
            this.periodId = data["periodId"];
            this.isBatch = data["isBatch"];
            if (data["suppliers"] && data["suppliers"].constructor === Array) {
                this.suppliers = [];
                for (let item of data["suppliers"])
                    this.suppliers.push(RawMaterialSupplier.fromJS(item));
            }
            this.inventoryUnitOfMeasure = data["inventoryUnitOfMeasure"] ? UnitOfMeasure.fromJS(data["inventoryUnitOfMeasure"]) : <any>undefined;
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasure = data["productUnitOfMeasure"] ? UnitOfMeasure.fromJS(data["productUnitOfMeasure"]) : <any>undefined;
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.purchaseUnitOfMeasure = data["purchaseUnitOfMeasure"] ? UnitOfMeasure.fromJS(data["purchaseUnitOfMeasure"]) : <any>undefined;
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.hasDueDate = data["hasDueDate"];
            this.referenceMaterialId = data["referenceMaterialId"];
            this.reOrderQuantity = data["reOrderQuantity"];
            this.warningAlertQuantity = data["warningAlertQuantity"];
            this.isRecipe = data["isRecipe"];
            if (data["rawMaterialDetail"] && data["rawMaterialDetail"].constructor === Array) {
                this.rawMaterialDetail = [];
                for (let item of data["rawMaterialDetail"])
                    this.rawMaterialDetail.push(RawMaterialDetail.fromJS(item));
            }
            if (data["rawMaterialComponent"] && data["rawMaterialComponent"].constructor === Array) {
                this.rawMaterialComponent = [];
                for (let item of data["rawMaterialComponent"])
                    this.rawMaterialComponent.push(RawMaterialDetail.fromJS(item));
            }
            if (data["materialStocks"] && data["materialStocks"].constructor === Array) {
                this.materialStocks = [];
                for (let item of data["materialStocks"])
                    this.materialStocks.push(MaterialStock.fromJS(item));
            }
            if (data["relatedRawMaterials"] && data["relatedRawMaterials"].constructor === Array) {
                this.relatedRawMaterials = [];
                for (let item of data["relatedRawMaterials"])
                    this.relatedRawMaterials.push(RawMaterial.fromJS(item));
            }
            this.currentMaterial = data["currentMaterial"] ? RawMaterial.fromJS(data["currentMaterial"]) : <any>undefined;
            if (data["entryMaterialStocks"] && data["entryMaterialStocks"].constructor === Array) {
                this.entryMaterialStocks = [];
                for (let item of data["entryMaterialStocks"])
                    this.entryMaterialStocks.push(EntryMaterialStock.fromJS(item));
            }
            if (data["storeRawMaterialConfigs"] && data["storeRawMaterialConfigs"].constructor === Array) {
                this.storeRawMaterialConfigs = [];
                for (let item of data["storeRawMaterialConfigs"])
                    this.storeRawMaterialConfigs.push(RawMaterialConfig.fromJS(item));
            }
            if (data["rawMaterialStoreGroups"] && data["rawMaterialStoreGroups"].constructor === Array) {
                this.rawMaterialStoreGroups = [];
                for (let item of data["rawMaterialStoreGroups"])
                    this.rawMaterialStoreGroups.push(RawMaterialStoreGroup.fromJS(item));
            }
            if (data["variantValues"] && data["variantValues"].constructor === Array) {
                this.variantValues = [];
                for (let item of data["variantValues"])
                    this.variantValues.push(VariantValue.fromJS(item));
            }
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransactionEntity.fromJS(item));
            }
            if (data["recipeTransactionSummaries"] && data["recipeTransactionSummaries"].constructor === Array) {
                this.recipeTransactionSummaries = [];
                for (let item of data["recipeTransactionSummaries"])
                    this.recipeTransactionSummaries.push(RecipeTransactionSummary.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterial {
        let result = new RawMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["materialGroupId"] = this.materialGroupId;
        data["materialGroup"] = this.materialGroup ? this.materialGroup.toJSON() : <any>undefined;
        data["reOrderLevel"] = this.reOrderLevel;
        data["maxQuantity"] = this.maxQuantity;
        data["barCode"] = this.barCode;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["periodId"] = this.periodId;
        data["isBatch"] = this.isBatch;
        if (this.suppliers && this.suppliers.constructor === Array) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        data["inventoryUnitOfMeasure"] = this.inventoryUnitOfMeasure ? this.inventoryUnitOfMeasure.toJSON() : <any>undefined;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasure"] = this.productUnitOfMeasure ? this.productUnitOfMeasure.toJSON() : <any>undefined;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["purchaseUnitOfMeasure"] = this.purchaseUnitOfMeasure ? this.purchaseUnitOfMeasure.toJSON() : <any>undefined;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["hasDueDate"] = this.hasDueDate;
        data["referenceMaterialId"] = this.referenceMaterialId;
        data["reOrderQuantity"] = this.reOrderQuantity;
        data["warningAlertQuantity"] = this.warningAlertQuantity;
        data["isRecipe"] = this.isRecipe;
        if (this.rawMaterialDetail && this.rawMaterialDetail.constructor === Array) {
            data["rawMaterialDetail"] = [];
            for (let item of this.rawMaterialDetail)
                data["rawMaterialDetail"].push(item.toJSON());
        }
        if (this.rawMaterialComponent && this.rawMaterialComponent.constructor === Array) {
            data["rawMaterialComponent"] = [];
            for (let item of this.rawMaterialComponent)
                data["rawMaterialComponent"].push(item.toJSON());
        }
        if (this.materialStocks && this.materialStocks.constructor === Array) {
            data["materialStocks"] = [];
            for (let item of this.materialStocks)
                data["materialStocks"].push(item.toJSON());
        }
        if (this.relatedRawMaterials && this.relatedRawMaterials.constructor === Array) {
            data["relatedRawMaterials"] = [];
            for (let item of this.relatedRawMaterials)
                data["relatedRawMaterials"].push(item.toJSON());
        }
        data["currentMaterial"] = this.currentMaterial ? this.currentMaterial.toJSON() : <any>undefined;
        if (this.entryMaterialStocks && this.entryMaterialStocks.constructor === Array) {
            data["entryMaterialStocks"] = [];
            for (let item of this.entryMaterialStocks)
                data["entryMaterialStocks"].push(item.toJSON());
        }
        if (this.storeRawMaterialConfigs && this.storeRawMaterialConfigs.constructor === Array) {
            data["storeRawMaterialConfigs"] = [];
            for (let item of this.storeRawMaterialConfigs)
                data["storeRawMaterialConfigs"].push(item.toJSON());
        }
        if (this.rawMaterialStoreGroups && this.rawMaterialStoreGroups.constructor === Array) {
            data["rawMaterialStoreGroups"] = [];
            for (let item of this.rawMaterialStoreGroups)
                data["rawMaterialStoreGroups"].push(item.toJSON());
        }
        if (this.variantValues && this.variantValues.constructor === Array) {
            data["variantValues"] = [];
            for (let item of this.variantValues)
                data["variantValues"].push(item.toJSON());
        }
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        if (this.recipeTransactionSummaries && this.recipeTransactionSummaries.constructor === Array) {
            data["recipeTransactionSummaries"] = [];
            for (let item of this.recipeTransactionSummaries)
                data["recipeTransactionSummaries"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterial {
    tenantId: number;
    translations: RawMaterialTranslation[];
    materialGroupId: number;
    materialGroup: SecondaryCategory;
    reOrderLevel: number;
    maxQuantity: number;
    barCode: string;
    sellingPrice: number;
    itemCost: RawMaterialItemCost;
    period: Period;
    periodId: number;
    isBatch: boolean;
    suppliers: RawMaterialSupplier[];
    inventoryUnitOfMeasure: UnitOfMeasure;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasure: UnitOfMeasure;
    productUnitOfMeasureId: number;
    purchaseUnitOfMeasure: UnitOfMeasure;
    purchaseUnitOfMeasureId: number;
    purchaseUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    hasDueDate: boolean;
    referenceMaterialId: number;
    reOrderQuantity: number;
    warningAlertQuantity: number;
    isRecipe: boolean;
    rawMaterialDetail: RawMaterialDetail[];
    rawMaterialComponent: RawMaterialDetail[];
    materialStocks: MaterialStock[];
    relatedRawMaterials: RawMaterial[];
    currentMaterial: RawMaterial;
    entryMaterialStocks: EntryMaterialStock[];
    storeRawMaterialConfigs: RawMaterialConfig[];
    rawMaterialStoreGroups: RawMaterialStoreGroup[];
    variantValues: VariantValue[];
    detailTransactions: DetailTransactionEntity[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Recipe implements IRecipe {
    tenantId: number;
    translations: RecipeTranslation[];
    recipeRawMaterials: RecipeRawMaterial[];
    menuItem: MenuItem;
    menuItemId: number;
    lossFactor: number;
    recipeCode: string;
    recipeStores: RecipeStore[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(RecipeTranslation.fromJS(item));
            }
            if (data["recipeRawMaterials"] && data["recipeRawMaterials"].constructor === Array) {
                this.recipeRawMaterials = [];
                for (let item of data["recipeRawMaterials"])
                    this.recipeRawMaterials.push(RecipeRawMaterial.fromJS(item));
            }
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.menuItemId = data["menuItemId"];
            this.lossFactor = data["lossFactor"];
            this.recipeCode = data["recipeCode"];
            if (data["recipeStores"] && data["recipeStores"].constructor === Array) {
                this.recipeStores = [];
                for (let item of data["recipeStores"])
                    this.recipeStores.push(RecipeStore.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Recipe {
        let result = new Recipe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.recipeRawMaterials && this.recipeRawMaterials.constructor === Array) {
            data["recipeRawMaterials"] = [];
            for (let item of this.recipeRawMaterials)
                data["recipeRawMaterials"].push(item.toJSON());
        }
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["menuItemId"] = this.menuItemId;
        data["lossFactor"] = this.lossFactor;
        data["recipeCode"] = this.recipeCode;
        if (this.recipeStores && this.recipeStores.constructor === Array) {
            data["recipeStores"] = [];
            for (let item of this.recipeStores)
                data["recipeStores"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipe {
    tenantId: number;
    translations: RecipeTranslation[];
    recipeRawMaterials: RecipeRawMaterial[];
    menuItem: MenuItem;
    menuItemId: number;
    lossFactor: number;
    recipeCode: string;
    recipeStores: RecipeStore[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItem implements IMenuItem {
    levelId: number;
    tenantId: number;
    reportGroupId: number;
    productCategoryId: number;
    deviceId: number;
    periodId: number;
    imageId: string;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    isComboMealDefinitionItem: boolean;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    preperingExpectedTime: number;
    mainGroup: PrimaryCategory;
    materialGroup: SecondaryCategory;
    productCategory: ProductCategory;
    reportGroup: ReportGroup;
    level: Level;
    upSalesMenuItems: UpSalesMenuItems[];
    translations: MenuItemTranslation[];
    menuItemPriceLists: MenuItemPriceList[];
    comboGroupDetails: ComboGroupDetail[];
    menuItemSaleTypes: MenuItemSaleType[];
    menuItemTaxes: MenuItemTax[];
    menuItemVariants: MenuItemVariant[];
    menuItemDevices: MenuItemDevice[];
    menuItemDiscountTypes: MenuItemDiscountType[];
    comboMealPackageItems: ComboMealPackageItem[];
    comboMealDefinitions: ComboMealDefinition[];
    saleTransactionDetailsComboMealsItems: SaleTransactionDetailsComboMealsItem[];
    saleNotificationDetailsComboMealsItems: SaleNotificationDetailsComboMealsItem[];
    promotioncConditions: PromotionFBItemExcludedMenuItem[];
    promotionFBItems: PromotionDetailsFBExcludedMenuItem[];
    menuItemStores: MenuItemStore[];
    menuItemConfigs: MenuItemConfig[];
    menuItemConfigSummaries: MenuItemConfigSummary[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.levelId = data["levelId"];
            this.tenantId = data["tenantId"];
            this.reportGroupId = data["reportGroupId"];
            this.productCategoryId = data["productCategoryId"];
            this.deviceId = data["deviceId"];
            this.periodId = data["periodId"];
            this.imageId = data["imageId"];
            this.allowDiscount = data["allowDiscount"];
            this.openPrice = data["openPrice"];
            this.sellable = data["sellable"];
            this.cost = data["cost"];
            this.itemCode = data["itemCode"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.isHidden = data["isHidden"];
            this.hasTobaccoTax = data["hasTobaccoTax"];
            this.isHoteSaleing = data["isHoteSaleing"];
            this.barcode1 = data["barcode1"];
            this.barcode2 = data["barcode2"];
            this.isComboMealDefinitionItem = data["isComboMealDefinitionItem"];
            this.numberOfCalories = data["numberOfCalories"];
            this.numberOfSteps = data["numberOfSteps"];
            this.allowDecimal = data["allowDecimal"];
            this.preperingExpectedTime = data["preperingExpectedTime"];
            this.mainGroup = data["mainGroup"] ? PrimaryCategory.fromJS(data["mainGroup"]) : <any>undefined;
            this.materialGroup = data["materialGroup"] ? SecondaryCategory.fromJS(data["materialGroup"]) : <any>undefined;
            this.productCategory = data["productCategory"] ? ProductCategory.fromJS(data["productCategory"]) : <any>undefined;
            this.reportGroup = data["reportGroup"] ? ReportGroup.fromJS(data["reportGroup"]) : <any>undefined;
            this.level = data["level"] ? Level.fromJS(data["level"]) : <any>undefined;
            if (data["upSalesMenuItems"] && data["upSalesMenuItems"].constructor === Array) {
                this.upSalesMenuItems = [];
                for (let item of data["upSalesMenuItems"])
                    this.upSalesMenuItems.push(UpSalesMenuItems.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(MenuItemTranslation.fromJS(item));
            }
            if (data["menuItemPriceLists"] && data["menuItemPriceLists"].constructor === Array) {
                this.menuItemPriceLists = [];
                for (let item of data["menuItemPriceLists"])
                    this.menuItemPriceLists.push(MenuItemPriceList.fromJS(item));
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetail.fromJS(item));
            }
            if (data["menuItemSaleTypes"] && data["menuItemSaleTypes"].constructor === Array) {
                this.menuItemSaleTypes = [];
                for (let item of data["menuItemSaleTypes"])
                    this.menuItemSaleTypes.push(MenuItemSaleType.fromJS(item));
            }
            if (data["menuItemTaxes"] && data["menuItemTaxes"].constructor === Array) {
                this.menuItemTaxes = [];
                for (let item of data["menuItemTaxes"])
                    this.menuItemTaxes.push(MenuItemTax.fromJS(item));
            }
            if (data["menuItemVariants"] && data["menuItemVariants"].constructor === Array) {
                this.menuItemVariants = [];
                for (let item of data["menuItemVariants"])
                    this.menuItemVariants.push(MenuItemVariant.fromJS(item));
            }
            if (data["menuItemDevices"] && data["menuItemDevices"].constructor === Array) {
                this.menuItemDevices = [];
                for (let item of data["menuItemDevices"])
                    this.menuItemDevices.push(MenuItemDevice.fromJS(item));
            }
            if (data["menuItemDiscountTypes"] && data["menuItemDiscountTypes"].constructor === Array) {
                this.menuItemDiscountTypes = [];
                for (let item of data["menuItemDiscountTypes"])
                    this.menuItemDiscountTypes.push(MenuItemDiscountType.fromJS(item));
            }
            if (data["comboMealPackageItems"] && data["comboMealPackageItems"].constructor === Array) {
                this.comboMealPackageItems = [];
                for (let item of data["comboMealPackageItems"])
                    this.comboMealPackageItems.push(ComboMealPackageItem.fromJS(item));
            }
            if (data["comboMealDefinitions"] && data["comboMealDefinitions"].constructor === Array) {
                this.comboMealDefinitions = [];
                for (let item of data["comboMealDefinitions"])
                    this.comboMealDefinitions.push(ComboMealDefinition.fromJS(item));
            }
            if (data["saleTransactionDetailsComboMealsItems"] && data["saleTransactionDetailsComboMealsItems"].constructor === Array) {
                this.saleTransactionDetailsComboMealsItems = [];
                for (let item of data["saleTransactionDetailsComboMealsItems"])
                    this.saleTransactionDetailsComboMealsItems.push(SaleTransactionDetailsComboMealsItem.fromJS(item));
            }
            if (data["saleNotificationDetailsComboMealsItems"] && data["saleNotificationDetailsComboMealsItems"].constructor === Array) {
                this.saleNotificationDetailsComboMealsItems = [];
                for (let item of data["saleNotificationDetailsComboMealsItems"])
                    this.saleNotificationDetailsComboMealsItems.push(SaleNotificationDetailsComboMealsItem.fromJS(item));
            }
            if (data["promotioncConditions"] && data["promotioncConditions"].constructor === Array) {
                this.promotioncConditions = [];
                for (let item of data["promotioncConditions"])
                    this.promotioncConditions.push(PromotionFBItemExcludedMenuItem.fromJS(item));
            }
            if (data["promotionFBItems"] && data["promotionFBItems"].constructor === Array) {
                this.promotionFBItems = [];
                for (let item of data["promotionFBItems"])
                    this.promotionFBItems.push(PromotionDetailsFBExcludedMenuItem.fromJS(item));
            }
            if (data["menuItemStores"] && data["menuItemStores"].constructor === Array) {
                this.menuItemStores = [];
                for (let item of data["menuItemStores"])
                    this.menuItemStores.push(MenuItemStore.fromJS(item));
            }
            if (data["menuItemConfigs"] && data["menuItemConfigs"].constructor === Array) {
                this.menuItemConfigs = [];
                for (let item of data["menuItemConfigs"])
                    this.menuItemConfigs.push(MenuItemConfig.fromJS(item));
            }
            if (data["menuItemConfigSummaries"] && data["menuItemConfigSummaries"].constructor === Array) {
                this.menuItemConfigSummaries = [];
                for (let item of data["menuItemConfigSummaries"])
                    this.menuItemConfigSummaries.push(MenuItemConfigSummary.fromJS(item));
            }
            if (data["recipeTransactionSummaries"] && data["recipeTransactionSummaries"].constructor === Array) {
                this.recipeTransactionSummaries = [];
                for (let item of data["recipeTransactionSummaries"])
                    this.recipeTransactionSummaries.push(RecipeTransactionSummary.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItem {
        let result = new MenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelId"] = this.levelId;
        data["tenantId"] = this.tenantId;
        data["reportGroupId"] = this.reportGroupId;
        data["productCategoryId"] = this.productCategoryId;
        data["deviceId"] = this.deviceId;
        data["periodId"] = this.periodId;
        data["imageId"] = this.imageId;
        data["allowDiscount"] = this.allowDiscount;
        data["openPrice"] = this.openPrice;
        data["sellable"] = this.sellable;
        data["cost"] = this.cost;
        data["itemCode"] = this.itemCode;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["isHidden"] = this.isHidden;
        data["hasTobaccoTax"] = this.hasTobaccoTax;
        data["isHoteSaleing"] = this.isHoteSaleing;
        data["barcode1"] = this.barcode1;
        data["barcode2"] = this.barcode2;
        data["isComboMealDefinitionItem"] = this.isComboMealDefinitionItem;
        data["numberOfCalories"] = this.numberOfCalories;
        data["numberOfSteps"] = this.numberOfSteps;
        data["allowDecimal"] = this.allowDecimal;
        data["preperingExpectedTime"] = this.preperingExpectedTime;
        data["mainGroup"] = this.mainGroup ? this.mainGroup.toJSON() : <any>undefined;
        data["materialGroup"] = this.materialGroup ? this.materialGroup.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["reportGroup"] = this.reportGroup ? this.reportGroup.toJSON() : <any>undefined;
        data["level"] = this.level ? this.level.toJSON() : <any>undefined;
        if (this.upSalesMenuItems && this.upSalesMenuItems.constructor === Array) {
            data["upSalesMenuItems"] = [];
            for (let item of this.upSalesMenuItems)
                data["upSalesMenuItems"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemPriceLists && this.menuItemPriceLists.constructor === Array) {
            data["menuItemPriceLists"] = [];
            for (let item of this.menuItemPriceLists)
                data["menuItemPriceLists"].push(item.toJSON());
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        if (this.menuItemSaleTypes && this.menuItemSaleTypes.constructor === Array) {
            data["menuItemSaleTypes"] = [];
            for (let item of this.menuItemSaleTypes)
                data["menuItemSaleTypes"].push(item.toJSON());
        }
        if (this.menuItemTaxes && this.menuItemTaxes.constructor === Array) {
            data["menuItemTaxes"] = [];
            for (let item of this.menuItemTaxes)
                data["menuItemTaxes"].push(item.toJSON());
        }
        if (this.menuItemVariants && this.menuItemVariants.constructor === Array) {
            data["menuItemVariants"] = [];
            for (let item of this.menuItemVariants)
                data["menuItemVariants"].push(item.toJSON());
        }
        if (this.menuItemDevices && this.menuItemDevices.constructor === Array) {
            data["menuItemDevices"] = [];
            for (let item of this.menuItemDevices)
                data["menuItemDevices"].push(item.toJSON());
        }
        if (this.menuItemDiscountTypes && this.menuItemDiscountTypes.constructor === Array) {
            data["menuItemDiscountTypes"] = [];
            for (let item of this.menuItemDiscountTypes)
                data["menuItemDiscountTypes"].push(item.toJSON());
        }
        if (this.comboMealPackageItems && this.comboMealPackageItems.constructor === Array) {
            data["comboMealPackageItems"] = [];
            for (let item of this.comboMealPackageItems)
                data["comboMealPackageItems"].push(item.toJSON());
        }
        if (this.comboMealDefinitions && this.comboMealDefinitions.constructor === Array) {
            data["comboMealDefinitions"] = [];
            for (let item of this.comboMealDefinitions)
                data["comboMealDefinitions"].push(item.toJSON());
        }
        if (this.saleTransactionDetailsComboMealsItems && this.saleTransactionDetailsComboMealsItems.constructor === Array) {
            data["saleTransactionDetailsComboMealsItems"] = [];
            for (let item of this.saleTransactionDetailsComboMealsItems)
                data["saleTransactionDetailsComboMealsItems"].push(item.toJSON());
        }
        if (this.saleNotificationDetailsComboMealsItems && this.saleNotificationDetailsComboMealsItems.constructor === Array) {
            data["saleNotificationDetailsComboMealsItems"] = [];
            for (let item of this.saleNotificationDetailsComboMealsItems)
                data["saleNotificationDetailsComboMealsItems"].push(item.toJSON());
        }
        if (this.promotioncConditions && this.promotioncConditions.constructor === Array) {
            data["promotioncConditions"] = [];
            for (let item of this.promotioncConditions)
                data["promotioncConditions"].push(item.toJSON());
        }
        if (this.promotionFBItems && this.promotionFBItems.constructor === Array) {
            data["promotionFBItems"] = [];
            for (let item of this.promotionFBItems)
                data["promotionFBItems"].push(item.toJSON());
        }
        if (this.menuItemStores && this.menuItemStores.constructor === Array) {
            data["menuItemStores"] = [];
            for (let item of this.menuItemStores)
                data["menuItemStores"].push(item.toJSON());
        }
        if (this.menuItemConfigs && this.menuItemConfigs.constructor === Array) {
            data["menuItemConfigs"] = [];
            for (let item of this.menuItemConfigs)
                data["menuItemConfigs"].push(item.toJSON());
        }
        if (this.menuItemConfigSummaries && this.menuItemConfigSummaries.constructor === Array) {
            data["menuItemConfigSummaries"] = [];
            for (let item of this.menuItemConfigSummaries)
                data["menuItemConfigSummaries"].push(item.toJSON());
        }
        if (this.recipeTransactionSummaries && this.recipeTransactionSummaries.constructor === Array) {
            data["recipeTransactionSummaries"] = [];
            for (let item of this.recipeTransactionSummaries)
                data["recipeTransactionSummaries"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItem {
    levelId: number;
    tenantId: number;
    reportGroupId: number;
    productCategoryId: number;
    deviceId: number;
    periodId: number;
    imageId: string;
    allowDiscount: boolean;
    openPrice: boolean;
    sellable: boolean;
    cost: number;
    itemCode: string;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    isHidden: boolean;
    hasTobaccoTax: boolean;
    isHoteSaleing: boolean;
    barcode1: string;
    barcode2: string;
    isComboMealDefinitionItem: boolean;
    numberOfCalories: string;
    numberOfSteps: string;
    allowDecimal: boolean;
    preperingExpectedTime: number;
    mainGroup: PrimaryCategory;
    materialGroup: SecondaryCategory;
    productCategory: ProductCategory;
    reportGroup: ReportGroup;
    level: Level;
    upSalesMenuItems: UpSalesMenuItems[];
    translations: MenuItemTranslation[];
    menuItemPriceLists: MenuItemPriceList[];
    comboGroupDetails: ComboGroupDetail[];
    menuItemSaleTypes: MenuItemSaleType[];
    menuItemTaxes: MenuItemTax[];
    menuItemVariants: MenuItemVariant[];
    menuItemDevices: MenuItemDevice[];
    menuItemDiscountTypes: MenuItemDiscountType[];
    comboMealPackageItems: ComboMealPackageItem[];
    comboMealDefinitions: ComboMealDefinition[];
    saleTransactionDetailsComboMealsItems: SaleTransactionDetailsComboMealsItem[];
    saleNotificationDetailsComboMealsItems: SaleNotificationDetailsComboMealsItem[];
    promotioncConditions: PromotionFBItemExcludedMenuItem[];
    promotionFBItems: PromotionDetailsFBExcludedMenuItem[];
    menuItemStores: MenuItemStore[];
    menuItemConfigs: MenuItemConfig[];
    menuItemConfigSummaries: MenuItemConfigSummary[];
    recipeTransactionSummaries: RecipeTransactionSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RawMaterialConfig implements IRawMaterialConfig {
    tenantId: number;
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: RawMaterialConfigItemCost;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    rawMaterial: RawMaterial;
    period: Period;
    purchaseUnitOfMeasure: UnitOfMeasure;
    inventoryUnitOfMeasure: UnitOfMeasure;
    productUnitOfMeasure: UnitOfMeasure;
    rawMaterialConfigStores: RawMaterialConfigStore[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.rawMaterialId = data["rawMaterialId"];
            this.periodId = data["periodId"];
            this.purchaseUnitOfMeasureId = data["purchaseUnitOfMeasureId"];
            this.inventoryUnitOfMeasureId = data["inventoryUnitOfMeasureId"];
            this.productUnitOfMeasureId = data["productUnitOfMeasureId"];
            this.isHidden = data["isHidden"];
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.sellingPrice = data["sellingPrice"];
            this.itemCost = data["itemCost"];
            this.isRecipe = data["isRecipe"];
            this.purchaseUnitOfMeasureFactor = data["purchaseUnitOfMeasureFactor"];
            this.inventoryUnitOfMeasureFactor = data["inventoryUnitOfMeasureFactor"];
            this.productUnitOfMeasureFactor = data["productUnitOfMeasureFactor"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.period = data["period"] ? Period.fromJS(data["period"]) : <any>undefined;
            this.purchaseUnitOfMeasure = data["purchaseUnitOfMeasure"] ? UnitOfMeasure.fromJS(data["purchaseUnitOfMeasure"]) : <any>undefined;
            this.inventoryUnitOfMeasure = data["inventoryUnitOfMeasure"] ? UnitOfMeasure.fromJS(data["inventoryUnitOfMeasure"]) : <any>undefined;
            this.productUnitOfMeasure = data["productUnitOfMeasure"] ? UnitOfMeasure.fromJS(data["productUnitOfMeasure"]) : <any>undefined;
            if (data["rawMaterialConfigStores"] && data["rawMaterialConfigStores"].constructor === Array) {
                this.rawMaterialConfigStores = [];
                for (let item of data["rawMaterialConfigStores"])
                    this.rawMaterialConfigStores.push(RawMaterialConfigStore.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialConfig {
        let result = new RawMaterialConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["periodId"] = this.periodId;
        data["purchaseUnitOfMeasureId"] = this.purchaseUnitOfMeasureId;
        data["inventoryUnitOfMeasureId"] = this.inventoryUnitOfMeasureId;
        data["productUnitOfMeasureId"] = this.productUnitOfMeasureId;
        data["isHidden"] = this.isHidden;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sellingPrice"] = this.sellingPrice;
        data["itemCost"] = this.itemCost;
        data["isRecipe"] = this.isRecipe;
        data["purchaseUnitOfMeasureFactor"] = this.purchaseUnitOfMeasureFactor;
        data["inventoryUnitOfMeasureFactor"] = this.inventoryUnitOfMeasureFactor;
        data["productUnitOfMeasureFactor"] = this.productUnitOfMeasureFactor;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["purchaseUnitOfMeasure"] = this.purchaseUnitOfMeasure ? this.purchaseUnitOfMeasure.toJSON() : <any>undefined;
        data["inventoryUnitOfMeasure"] = this.inventoryUnitOfMeasure ? this.inventoryUnitOfMeasure.toJSON() : <any>undefined;
        data["productUnitOfMeasure"] = this.productUnitOfMeasure ? this.productUnitOfMeasure.toJSON() : <any>undefined;
        if (this.rawMaterialConfigStores && this.rawMaterialConfigStores.constructor === Array) {
            data["rawMaterialConfigStores"] = [];
            for (let item of this.rawMaterialConfigStores)
                data["rawMaterialConfigStores"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialConfig {
    tenantId: number;
    rawMaterialId: number;
    periodId: number;
    purchaseUnitOfMeasureId: number;
    inventoryUnitOfMeasureId: number;
    productUnitOfMeasureId: number;
    isHidden: boolean;
    effectiveDate: moment.Moment;
    sellingPrice: number;
    itemCost: RawMaterialConfigItemCost;
    isRecipe: boolean;
    purchaseUnitOfMeasureFactor: number;
    inventoryUnitOfMeasureFactor: number;
    productUnitOfMeasureFactor: number;
    rawMaterial: RawMaterial;
    period: Period;
    purchaseUnitOfMeasure: UnitOfMeasure;
    inventoryUnitOfMeasure: UnitOfMeasure;
    productUnitOfMeasure: UnitOfMeasure;
    rawMaterialConfigStores: RawMaterialConfigStore[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemConfig implements IMenuItemConfig {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    menuItemId: number;
    menuItem: MenuItem;
    menuItemPriceLists: MenuItemPriceList[];
    menuItemDevices: MenuItemDevice[];
    comboGroupDetails: ComboGroupDetail[];
    storeMenuItemConfigs: StoreMenuItemConfig[];
    menuItemConfigSummaries: MenuItemConfigSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.openPrice = data["openPrice"];
            this.allowDiscount = data["allowDiscount"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            if (data["menuItemPriceLists"] && data["menuItemPriceLists"].constructor === Array) {
                this.menuItemPriceLists = [];
                for (let item of data["menuItemPriceLists"])
                    this.menuItemPriceLists.push(MenuItemPriceList.fromJS(item));
            }
            if (data["menuItemDevices"] && data["menuItemDevices"].constructor === Array) {
                this.menuItemDevices = [];
                for (let item of data["menuItemDevices"])
                    this.menuItemDevices.push(MenuItemDevice.fromJS(item));
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetail.fromJS(item));
            }
            if (data["storeMenuItemConfigs"] && data["storeMenuItemConfigs"].constructor === Array) {
                this.storeMenuItemConfigs = [];
                for (let item of data["storeMenuItemConfigs"])
                    this.storeMenuItemConfigs.push(StoreMenuItemConfig.fromJS(item));
            }
            if (data["menuItemConfigSummaries"] && data["menuItemConfigSummaries"].constructor === Array) {
                this.menuItemConfigSummaries = [];
                for (let item of data["menuItemConfigSummaries"])
                    this.menuItemConfigSummaries.push(MenuItemConfigSummary.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemConfig {
        let result = new MenuItemConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["openPrice"] = this.openPrice;
        data["allowDiscount"] = this.allowDiscount;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        if (this.menuItemPriceLists && this.menuItemPriceLists.constructor === Array) {
            data["menuItemPriceLists"] = [];
            for (let item of this.menuItemPriceLists)
                data["menuItemPriceLists"].push(item.toJSON());
        }
        if (this.menuItemDevices && this.menuItemDevices.constructor === Array) {
            data["menuItemDevices"] = [];
            for (let item of this.menuItemDevices)
                data["menuItemDevices"].push(item.toJSON());
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        if (this.storeMenuItemConfigs && this.storeMenuItemConfigs.constructor === Array) {
            data["storeMenuItemConfigs"] = [];
            for (let item of this.storeMenuItemConfigs)
                data["storeMenuItemConfigs"].push(item.toJSON());
        }
        if (this.menuItemConfigSummaries && this.menuItemConfigSummaries.constructor === Array) {
            data["menuItemConfigSummaries"] = [];
            for (let item of this.menuItemConfigSummaries)
                data["menuItemConfigSummaries"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemConfig {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    openPrice: boolean;
    allowDiscount: boolean;
    menuItemId: number;
    menuItem: MenuItem;
    menuItemPriceLists: MenuItemPriceList[];
    menuItemDevices: MenuItemDevice[];
    comboGroupDetails: ComboGroupDetail[];
    storeMenuItemConfigs: StoreMenuItemConfig[];
    menuItemConfigSummaries: MenuItemConfigSummary[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Table implements ITable {
    tenantId: number;
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    corner: Corner;
    code: string;
    tableStores: TableStore[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tableNumber = data["tableNumber"];
            this.numberOfSeats = data["numberOfSeats"];
            this.cornerId = data["cornerId"];
            this.corner = data["corner"] ? Corner.fromJS(data["corner"]) : <any>undefined;
            this.code = data["code"];
            if (data["tableStores"] && data["tableStores"].constructor === Array) {
                this.tableStores = [];
                for (let item of data["tableStores"])
                    this.tableStores.push(TableStore.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Table {
        let result = new Table();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tableNumber"] = this.tableNumber;
        data["numberOfSeats"] = this.numberOfSeats;
        data["cornerId"] = this.cornerId;
        data["corner"] = this.corner ? this.corner.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (this.tableStores && this.tableStores.constructor === Array) {
            data["tableStores"] = [];
            for (let item of this.tableStores)
                data["tableStores"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITable {
    tenantId: number;
    tableNumber: string;
    numberOfSeats: number;
    cornerId: number;
    corner: Corner;
    code: string;
    tableStores: TableStore[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Corner implements ICorner {
    tenantId: number;
    tables: Table[];
    translations: CornerTranslation[];
    cornerStores: CornerStore[];
    cornerStoreDevices: CornerStoreDevice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICorner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["tables"] && data["tables"].constructor === Array) {
                this.tables = [];
                for (let item of data["tables"])
                    this.tables.push(Table.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(CornerTranslation.fromJS(item));
            }
            if (data["cornerStores"] && data["cornerStores"].constructor === Array) {
                this.cornerStores = [];
                for (let item of data["cornerStores"])
                    this.cornerStores.push(CornerStore.fromJS(item));
            }
            if (data["cornerStoreDevices"] && data["cornerStoreDevices"].constructor === Array) {
                this.cornerStoreDevices = [];
                for (let item of data["cornerStoreDevices"])
                    this.cornerStoreDevices.push(CornerStoreDevice.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Corner {
        let result = new Corner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.tables && this.tables.constructor === Array) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.cornerStores && this.cornerStores.constructor === Array) {
            data["cornerStores"] = [];
            for (let item of this.cornerStores)
                data["cornerStores"].push(item.toJSON());
        }
        if (this.cornerStoreDevices && this.cornerStoreDevices.constructor === Array) {
            data["cornerStoreDevices"] = [];
            for (let item of this.cornerStoreDevices)
                data["cornerStoreDevices"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICorner {
    tenantId: number;
    tables: Table[];
    translations: CornerTranslation[];
    cornerStores: CornerStore[];
    cornerStoreDevices: CornerStoreDevice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategory implements IProductCategory {
    code: string;
    secondaryCategoryId: number;
    secondaryCategory: SecondaryCategory;
    parentId: number;
    isLastLevel: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    products: Product[];
    variants: Variant[];
    menuItems: MenuItem[];
    productCategoryComboGroups: ProductCategoryComboGroup[];
    deviceCategories: DeviceCategory[];
    translations: ProductCategoryTranslation[];
    levels: ProductCategoryLevel[];
    productCategoryStores: StoreProductCategoryConfig[];
    tenantId: number;
    recipeTransactionSummaries: RecipeTransactionSummary[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.secondaryCategory = data["secondaryCategory"] ? SecondaryCategory.fromJS(data["secondaryCategory"]) : <any>undefined;
            this.parentId = data["parentId"];
            this.isLastLevel = data["isLastLevel"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(Product.fromJS(item));
            }
            if (data["variants"] && data["variants"].constructor === Array) {
                this.variants = [];
                for (let item of data["variants"])
                    this.variants.push(Variant.fromJS(item));
            }
            if (data["menuItems"] && data["menuItems"].constructor === Array) {
                this.menuItems = [];
                for (let item of data["menuItems"])
                    this.menuItems.push(MenuItem.fromJS(item));
            }
            if (data["productCategoryComboGroups"] && data["productCategoryComboGroups"].constructor === Array) {
                this.productCategoryComboGroups = [];
                for (let item of data["productCategoryComboGroups"])
                    this.productCategoryComboGroups.push(ProductCategoryComboGroup.fromJS(item));
            }
            if (data["deviceCategories"] && data["deviceCategories"].constructor === Array) {
                this.deviceCategories = [];
                for (let item of data["deviceCategories"])
                    this.deviceCategories.push(DeviceCategory.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ProductCategoryTranslation.fromJS(item));
            }
            if (data["levels"] && data["levels"].constructor === Array) {
                this.levels = [];
                for (let item of data["levels"])
                    this.levels.push(ProductCategoryLevel.fromJS(item));
            }
            if (data["productCategoryStores"] && data["productCategoryStores"].constructor === Array) {
                this.productCategoryStores = [];
                for (let item of data["productCategoryStores"])
                    this.productCategoryStores.push(StoreProductCategoryConfig.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            if (data["recipeTransactionSummaries"] && data["recipeTransactionSummaries"].constructor === Array) {
                this.recipeTransactionSummaries = [];
                for (let item of data["recipeTransactionSummaries"])
                    this.recipeTransactionSummaries.push(RecipeTransactionSummary.fromJS(item));
            }
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategory {
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["secondaryCategory"] = this.secondaryCategory ? this.secondaryCategory.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["isLastLevel"] = this.isLastLevel;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.variants && this.variants.constructor === Array) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        if (this.menuItems && this.menuItems.constructor === Array) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        if (this.productCategoryComboGroups && this.productCategoryComboGroups.constructor === Array) {
            data["productCategoryComboGroups"] = [];
            for (let item of this.productCategoryComboGroups)
                data["productCategoryComboGroups"].push(item.toJSON());
        }
        if (this.deviceCategories && this.deviceCategories.constructor === Array) {
            data["deviceCategories"] = [];
            for (let item of this.deviceCategories)
                data["deviceCategories"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.levels && this.levels.constructor === Array) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        if (this.productCategoryStores && this.productCategoryStores.constructor === Array) {
            data["productCategoryStores"] = [];
            for (let item of this.productCategoryStores)
                data["productCategoryStores"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        if (this.recipeTransactionSummaries && this.recipeTransactionSummaries.constructor === Array) {
            data["recipeTransactionSummaries"] = [];
            for (let item of this.recipeTransactionSummaries)
                data["recipeTransactionSummaries"].push(item.toJSON());
        }
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategory {
    code: string;
    secondaryCategoryId: number;
    secondaryCategory: SecondaryCategory;
    parentId: number;
    isLastLevel: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    products: Product[];
    variants: Variant[];
    menuItems: MenuItem[];
    productCategoryComboGroups: ProductCategoryComboGroup[];
    deviceCategories: DeviceCategory[];
    translations: ProductCategoryTranslation[];
    levels: ProductCategoryLevel[];
    productCategoryStores: StoreProductCategoryConfig[];
    tenantId: number;
    recipeTransactionSummaries: RecipeTransactionSummary[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeliveryZone implements IDeliveryZone {
    tenantId: number;
    translations: DeliveryZoneTranslation[];
    deliveryStreets: DeliveryStreet[];
    customerAddress: CustomerAddress[];
    storeZones: StoreZone[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryZoneTranslation.fromJS(item));
            }
            if (data["deliveryStreets"] && data["deliveryStreets"].constructor === Array) {
                this.deliveryStreets = [];
                for (let item of data["deliveryStreets"])
                    this.deliveryStreets.push(DeliveryStreet.fromJS(item));
            }
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddress.fromJS(item));
            }
            if (data["storeZones"] && data["storeZones"].constructor === Array) {
                this.storeZones = [];
                for (let item of data["storeZones"])
                    this.storeZones.push(StoreZone.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryZone {
        let result = new DeliveryZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.deliveryStreets && this.deliveryStreets.constructor === Array) {
            data["deliveryStreets"] = [];
            for (let item of this.deliveryStreets)
                data["deliveryStreets"].push(item.toJSON());
        }
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        if (this.storeZones && this.storeZones.constructor === Array) {
            data["storeZones"] = [];
            for (let item of this.storeZones)
                data["storeZones"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryZone {
    tenantId: number;
    translations: DeliveryZoneTranslation[];
    deliveryStreets: DeliveryStreet[];
    customerAddress: CustomerAddress[];
    storeZones: StoreZone[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Customer implements ICustomer {
    code: string;
    customerType: CustomerType;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    website: string;
    note: string;
    taxNumber: string;
    commericalNumber: string;
    buildingNumber: string;
    tenantId: number;
    accountId: string;
    identificationSchemeID: string;
    area: string;
    governorate: string;
    blockNo: string;
    isUpload: boolean;
    discountPrcnt: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    account: Account;
    customerAddress: CustomerAddress[];
    customerSaleTypes: CustomerSaleType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.customerType = data["customerType"];
            this.cardNumber = data["cardNumber"];
            this.contactName = data["contactName"];
            this.address = data["address"];
            this.city = data["city"];
            this.country = data["country"];
            this.phone = data["phone"];
            this.cellPhone = data["cellPhone"];
            this.fax = data["fax"];
            this.currency = data["currency"];
            this.postalCode = data["postalCode"];
            this.email = data["email"];
            this.email2 = data["email2"];
            this.website = data["website"];
            this.note = data["note"];
            this.taxNumber = data["taxNumber"];
            this.commericalNumber = data["commericalNumber"];
            this.buildingNumber = data["buildingNumber"];
            this.tenantId = data["tenantId"];
            this.accountId = data["accountId"];
            this.identificationSchemeID = data["identificationSchemeID"];
            this.area = data["area"];
            this.governorate = data["governorate"];
            this.blockNo = data["blockNo"];
            this.isUpload = data["isUpload"];
            this.discountPrcnt = data["discountPrcnt"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.account = data["account"] ? Account.fromJS(data["account"]) : <any>undefined;
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddress.fromJS(item));
            }
            if (data["customerSaleTypes"] && data["customerSaleTypes"].constructor === Array) {
                this.customerSaleTypes = [];
                for (let item of data["customerSaleTypes"])
                    this.customerSaleTypes.push(CustomerSaleType.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Customer {
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["customerType"] = this.customerType;
        data["cardNumber"] = this.cardNumber;
        data["contactName"] = this.contactName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["fax"] = this.fax;
        data["currency"] = this.currency;
        data["postalCode"] = this.postalCode;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["website"] = this.website;
        data["note"] = this.note;
        data["taxNumber"] = this.taxNumber;
        data["commericalNumber"] = this.commericalNumber;
        data["buildingNumber"] = this.buildingNumber;
        data["tenantId"] = this.tenantId;
        data["accountId"] = this.accountId;
        data["identificationSchemeID"] = this.identificationSchemeID;
        data["area"] = this.area;
        data["governorate"] = this.governorate;
        data["blockNo"] = this.blockNo;
        data["isUpload"] = this.isUpload;
        data["discountPrcnt"] = this.discountPrcnt;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        if (this.customerSaleTypes && this.customerSaleTypes.constructor === Array) {
            data["customerSaleTypes"] = [];
            for (let item of this.customerSaleTypes)
                data["customerSaleTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomer {
    code: string;
    customerType: CustomerType;
    cardNumber: string;
    contactName: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    cellPhone: string;
    fax: string;
    currency: number;
    postalCode: string;
    email: string;
    email2: string;
    website: string;
    note: string;
    taxNumber: string;
    commericalNumber: string;
    buildingNumber: string;
    tenantId: number;
    accountId: string;
    identificationSchemeID: string;
    area: string;
    governorate: string;
    blockNo: string;
    isUpload: boolean;
    discountPrcnt: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    account: Account;
    customerAddress: CustomerAddress[];
    customerSaleTypes: CustomerSaleType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class CashierShift implements ICashierShift {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: CashierShiftStatus;
    userId: number;
    user: User;
    supervisorShiftId: number;
    supervisorShift: SupervisorShift;
    storeId: number;
    store: Store;
    endOfDayDetailId: number;
    endOfDayDetail: EndOfDayDetail;
    saleTransactions: SaleTransaction[];
    cashierShiftPaymentTransactionValues: CashierShiftPaymentTransactionValues[];
    masterCashInOuts: MasterCashInOut[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICashierShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.startedBy = data["startedBy"];
            this.endedBy = data["endedBy"];
            this.status = data["status"];
            this.userId = data["userId"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            this.supervisorShiftId = data["supervisorShiftId"];
            this.supervisorShift = data["supervisorShift"] ? SupervisorShift.fromJS(data["supervisorShift"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.endOfDayDetailId = data["endOfDayDetailId"];
            this.endOfDayDetail = data["endOfDayDetail"] ? EndOfDayDetail.fromJS(data["endOfDayDetail"]) : <any>undefined;
            if (data["saleTransactions"] && data["saleTransactions"].constructor === Array) {
                this.saleTransactions = [];
                for (let item of data["saleTransactions"])
                    this.saleTransactions.push(SaleTransaction.fromJS(item));
            }
            if (data["cashierShiftPaymentTransactionValues"] && data["cashierShiftPaymentTransactionValues"].constructor === Array) {
                this.cashierShiftPaymentTransactionValues = [];
                for (let item of data["cashierShiftPaymentTransactionValues"])
                    this.cashierShiftPaymentTransactionValues.push(CashierShiftPaymentTransactionValues.fromJS(item));
            }
            if (data["masterCashInOuts"] && data["masterCashInOuts"].constructor === Array) {
                this.masterCashInOuts = [];
                for (let item of data["masterCashInOuts"])
                    this.masterCashInOuts.push(MasterCashInOut.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CashierShift {
        let result = new CashierShift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["endedBy"] = this.endedBy;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["supervisorShiftId"] = this.supervisorShiftId;
        data["supervisorShift"] = this.supervisorShift ? this.supervisorShift.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["endOfDayDetailId"] = this.endOfDayDetailId;
        data["endOfDayDetail"] = this.endOfDayDetail ? this.endOfDayDetail.toJSON() : <any>undefined;
        if (this.saleTransactions && this.saleTransactions.constructor === Array) {
            data["saleTransactions"] = [];
            for (let item of this.saleTransactions)
                data["saleTransactions"].push(item.toJSON());
        }
        if (this.cashierShiftPaymentTransactionValues && this.cashierShiftPaymentTransactionValues.constructor === Array) {
            data["cashierShiftPaymentTransactionValues"] = [];
            for (let item of this.cashierShiftPaymentTransactionValues)
                data["cashierShiftPaymentTransactionValues"].push(item.toJSON());
        }
        if (this.masterCashInOuts && this.masterCashInOuts.constructor === Array) {
            data["masterCashInOuts"] = [];
            for (let item of this.masterCashInOuts)
                data["masterCashInOuts"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICashierShift {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: CashierShiftStatus;
    userId: number;
    user: User;
    supervisorShiftId: number;
    supervisorShift: SupervisorShift;
    storeId: number;
    store: Store;
    endOfDayDetailId: number;
    endOfDayDetail: EndOfDayDetail;
    saleTransactions: SaleTransaction[];
    cashierShiftPaymentTransactionValues: CashierShiftPaymentTransactionValues[];
    masterCashInOuts: MasterCashInOut[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionCodeFB implements IPromotionCodeFB {
    code: string;
    tenantId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isTiming: boolean;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isActive: boolean;
    iDuplicateQunatity: boolean;
    promotionFBId: number;
    promotionFB: PromotionFB;
    promotionCodeSalestypes: PromotionCodeSalestype[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionCodeFB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.isTiming = data["isTiming"];
            this.fromTime = data["fromTime"];
            this.toTime = data["toTime"];
            this.multi = data["multi"];
            this.isActive = data["isActive"];
            this.iDuplicateQunatity = data["iDuplicateQunatity"];
            this.promotionFBId = data["promotionFBId"];
            this.promotionFB = data["promotionFB"] ? PromotionFB.fromJS(data["promotionFB"]) : <any>undefined;
            if (data["promotionCodeSalestypes"] && data["promotionCodeSalestypes"].constructor === Array) {
                this.promotionCodeSalestypes = [];
                for (let item of data["promotionCodeSalestypes"])
                    this.promotionCodeSalestypes.push(PromotionCodeSalestype.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionCodeFB {
        let result = new PromotionCodeFB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["isTiming"] = this.isTiming;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["multi"] = this.multi;
        data["isActive"] = this.isActive;
        data["iDuplicateQunatity"] = this.iDuplicateQunatity;
        data["promotionFBId"] = this.promotionFBId;
        data["promotionFB"] = this.promotionFB ? this.promotionFB.toJSON() : <any>undefined;
        if (this.promotionCodeSalestypes && this.promotionCodeSalestypes.constructor === Array) {
            data["promotionCodeSalestypes"] = [];
            for (let item of this.promotionCodeSalestypes)
                data["promotionCodeSalestypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionCodeFB {
    code: string;
    tenantId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    isTiming: boolean;
    fromTime: string;
    toTime: string;
    multi: boolean;
    isActive: boolean;
    iDuplicateQunatity: boolean;
    promotionFBId: number;
    promotionFB: PromotionFB;
    promotionCodeSalestypes: PromotionCodeSalestype[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class POSResponseA90 implements IPOSResponseA90 {
    ret: string;
    bufferLength: string;
    ecrNo: string;
    receiptNo: string;
    amount: string;
    rspCode: string;
    cardnumber_PAN: string;
    expiryDate: string;
    cardType: string;
    approvalNo: string;
    transDate: string;
    transTime: string;
    rrn: string;
    tid: string;
    merchantNameAr: string;
    merchantNameEn: string;
    addressAr: string;
    addressEn: string;
    cityAr: string;
    cityEn: string;
    startdate: string;
    startTime: string;
    idData: string;
    cardTypeAr: string;
    cardTypeEn: string;
    txnTypeAr: string;
    txnTypeEn: string;
    txnTypeTxtAr: string;
    txAmntAr: string;
    txAmntAr2: string;
    txAmntEn: string;
    txnTypeTxtEn: string;
    txnAmount: string;
    rspDataAra: string;
    rspDataEn: string;
    rspTxtDataAr: string;
    rspTxtDataEn: string;
    sign1Ar: string;
    sign1En: string;
    sign: string;
    sign2Ar: string;
    sign2En: string;
    authCodeAr: string;
    authCodeEn: string;
    authCodeTxtAr: string;
    authCodeTxtEn: string;
    endDate: string;
    endTime: string;
    retailerAr: string;
    retailerEn: string;
    footer1Ar: string;
    footer1En: string;
    footer2Ar: string;
    footer2En: string;
    emvData: string;
    campaignAr: string;
    campaignEn: string;
    tenantId: number;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IPOSResponseA90) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ret = data["ret"];
            this.bufferLength = data["bufferLength"];
            this.ecrNo = data["ecrNo"];
            this.receiptNo = data["receiptNo"];
            this.amount = data["amount"];
            this.rspCode = data["rspCode"];
            this.cardnumber_PAN = data["cardnumber_PAN"];
            this.expiryDate = data["expiryDate"];
            this.cardType = data["cardType"];
            this.approvalNo = data["approvalNo"];
            this.transDate = data["transDate"];
            this.transTime = data["transTime"];
            this.rrn = data["rrn"];
            this.tid = data["tid"];
            this.merchantNameAr = data["merchantNameAr"];
            this.merchantNameEn = data["merchantNameEn"];
            this.addressAr = data["addressAr"];
            this.addressEn = data["addressEn"];
            this.cityAr = data["cityAr"];
            this.cityEn = data["cityEn"];
            this.startdate = data["startdate"];
            this.startTime = data["startTime"];
            this.idData = data["idData"];
            this.cardTypeAr = data["cardTypeAr"];
            this.cardTypeEn = data["cardTypeEn"];
            this.txnTypeAr = data["txnTypeAr"];
            this.txnTypeEn = data["txnTypeEn"];
            this.txnTypeTxtAr = data["txnTypeTxtAr"];
            this.txAmntAr = data["txAmntAr"];
            this.txAmntAr2 = data["txAmntAr2"];
            this.txAmntEn = data["txAmntEn"];
            this.txnTypeTxtEn = data["txnTypeTxtEn"];
            this.txnAmount = data["txnAmount"];
            this.rspDataAra = data["rspDataAra"];
            this.rspDataEn = data["rspDataEn"];
            this.rspTxtDataAr = data["rspTxtDataAr"];
            this.rspTxtDataEn = data["rspTxtDataEn"];
            this.sign1Ar = data["sign1Ar"];
            this.sign1En = data["sign1En"];
            this.sign = data["sign"];
            this.sign2Ar = data["sign2Ar"];
            this.sign2En = data["sign2En"];
            this.authCodeAr = data["authCodeAr"];
            this.authCodeEn = data["authCodeEn"];
            this.authCodeTxtAr = data["authCodeTxtAr"];
            this.authCodeTxtEn = data["authCodeTxtEn"];
            this.endDate = data["endDate"];
            this.endTime = data["endTime"];
            this.retailerAr = data["retailerAr"];
            this.retailerEn = data["retailerEn"];
            this.footer1Ar = data["footer1Ar"];
            this.footer1En = data["footer1En"];
            this.footer2Ar = data["footer2Ar"];
            this.footer2En = data["footer2En"];
            this.emvData = data["emvData"];
            this.campaignAr = data["campaignAr"];
            this.campaignEn = data["campaignEn"];
            this.tenantId = data["tenantId"];
            this.saleTransactionId = data["saleTransactionId"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): POSResponseA90 {
        let result = new POSResponseA90();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ret"] = this.ret;
        data["bufferLength"] = this.bufferLength;
        data["ecrNo"] = this.ecrNo;
        data["receiptNo"] = this.receiptNo;
        data["amount"] = this.amount;
        data["rspCode"] = this.rspCode;
        data["cardnumber_PAN"] = this.cardnumber_PAN;
        data["expiryDate"] = this.expiryDate;
        data["cardType"] = this.cardType;
        data["approvalNo"] = this.approvalNo;
        data["transDate"] = this.transDate;
        data["transTime"] = this.transTime;
        data["rrn"] = this.rrn;
        data["tid"] = this.tid;
        data["merchantNameAr"] = this.merchantNameAr;
        data["merchantNameEn"] = this.merchantNameEn;
        data["addressAr"] = this.addressAr;
        data["addressEn"] = this.addressEn;
        data["cityAr"] = this.cityAr;
        data["cityEn"] = this.cityEn;
        data["startdate"] = this.startdate;
        data["startTime"] = this.startTime;
        data["idData"] = this.idData;
        data["cardTypeAr"] = this.cardTypeAr;
        data["cardTypeEn"] = this.cardTypeEn;
        data["txnTypeAr"] = this.txnTypeAr;
        data["txnTypeEn"] = this.txnTypeEn;
        data["txnTypeTxtAr"] = this.txnTypeTxtAr;
        data["txAmntAr"] = this.txAmntAr;
        data["txAmntAr2"] = this.txAmntAr2;
        data["txAmntEn"] = this.txAmntEn;
        data["txnTypeTxtEn"] = this.txnTypeTxtEn;
        data["txnAmount"] = this.txnAmount;
        data["rspDataAra"] = this.rspDataAra;
        data["rspDataEn"] = this.rspDataEn;
        data["rspTxtDataAr"] = this.rspTxtDataAr;
        data["rspTxtDataEn"] = this.rspTxtDataEn;
        data["sign1Ar"] = this.sign1Ar;
        data["sign1En"] = this.sign1En;
        data["sign"] = this.sign;
        data["sign2Ar"] = this.sign2Ar;
        data["sign2En"] = this.sign2En;
        data["authCodeAr"] = this.authCodeAr;
        data["authCodeEn"] = this.authCodeEn;
        data["authCodeTxtAr"] = this.authCodeTxtAr;
        data["authCodeTxtEn"] = this.authCodeTxtEn;
        data["endDate"] = this.endDate;
        data["endTime"] = this.endTime;
        data["retailerAr"] = this.retailerAr;
        data["retailerEn"] = this.retailerEn;
        data["footer1Ar"] = this.footer1Ar;
        data["footer1En"] = this.footer1En;
        data["footer2Ar"] = this.footer2Ar;
        data["footer2En"] = this.footer2En;
        data["emvData"] = this.emvData;
        data["campaignAr"] = this.campaignAr;
        data["campaignEn"] = this.campaignEn;
        data["tenantId"] = this.tenantId;
        data["saleTransactionId"] = this.saleTransactionId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPOSResponseA90 {
    ret: string;
    bufferLength: string;
    ecrNo: string;
    receiptNo: string;
    amount: string;
    rspCode: string;
    cardnumber_PAN: string;
    expiryDate: string;
    cardType: string;
    approvalNo: string;
    transDate: string;
    transTime: string;
    rrn: string;
    tid: string;
    merchantNameAr: string;
    merchantNameEn: string;
    addressAr: string;
    addressEn: string;
    cityAr: string;
    cityEn: string;
    startdate: string;
    startTime: string;
    idData: string;
    cardTypeAr: string;
    cardTypeEn: string;
    txnTypeAr: string;
    txnTypeEn: string;
    txnTypeTxtAr: string;
    txAmntAr: string;
    txAmntAr2: string;
    txAmntEn: string;
    txnTypeTxtEn: string;
    txnAmount: string;
    rspDataAra: string;
    rspDataEn: string;
    rspTxtDataAr: string;
    rspTxtDataEn: string;
    sign1Ar: string;
    sign1En: string;
    sign: string;
    sign2Ar: string;
    sign2En: string;
    authCodeAr: string;
    authCodeEn: string;
    authCodeTxtAr: string;
    authCodeTxtEn: string;
    endDate: string;
    endTime: string;
    retailerAr: string;
    retailerEn: string;
    footer1Ar: string;
    footer1En: string;
    footer2Ar: string;
    footer2En: string;
    emvData: string;
    campaignAr: string;
    campaignEn: string;
    tenantId: number;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class POSResponseN90 implements IPOSResponseN90 {
    ret: string;
    bankId: string;
    merchantID: string;
    terminalID: string;
    mcc: string;
    stan: string;
    version: string;
    rrn: string;
    pan: string;
    cardExpiryDate: string;
    additionalData: string;
    retailerRetailerNameEng: string;
    retailerRetailerNameArb: string;
    retaileraddress_eng_1: string;
    retaileraddress_eng_2: string;
    retaileraddress_arb_1: string;
    retaileraddress_arb_2: string;
    retailerdownload_phone: string;
    performanceStartDateTime: string;
    performanceEndDateTime: string;
    cardSchemeID: string;
    cardSchemeArabic: string;
    cardSchemeEnglish: string;
    applicationLabelArabic: string;
    applicationLabelEnglish: string;
    transactionTypeArabic: string;
    transactionTypeEnglish: string;
    amountsArabicCurrency: string;
    amountsEnglishCurrency: string;
    amountArabicName: string;
    amountEnglishName: string;
    amountValue: number;
    resultArabic: string;
    resultEnglish: string;
    approvalCodeArabic: string;
    approvalCodeEnglish: string;
    approvalCodeCode: string;
    emvTagsPosEntryMode: string;
    emvTagsResponseCode: string;
    emvTagsTerminalStatusCode: string;
    emvTagsAID: string;
    emvTagsTVR: string;
    emvTagsTSI: string;
    emvTagsCVR: string;
    emvTagsACI: string;
    emvTagsAC: string;
    qrCodeData: string;
    campaignText: string;
    tenantId: number;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IPOSResponseN90) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ret = data["ret"];
            this.bankId = data["bankId"];
            this.merchantID = data["merchantID"];
            this.terminalID = data["terminalID"];
            this.mcc = data["mcc"];
            this.stan = data["stan"];
            this.version = data["version"];
            this.rrn = data["rrn"];
            this.pan = data["pan"];
            this.cardExpiryDate = data["cardExpiryDate"];
            this.additionalData = data["additionalData"];
            this.retailerRetailerNameEng = data["retailerRetailerNameEng"];
            this.retailerRetailerNameArb = data["retailerRetailerNameArb"];
            this.retaileraddress_eng_1 = data["retaileraddress_eng_1"];
            this.retaileraddress_eng_2 = data["retaileraddress_eng_2"];
            this.retaileraddress_arb_1 = data["retaileraddress_arb_1"];
            this.retaileraddress_arb_2 = data["retaileraddress_arb_2"];
            this.retailerdownload_phone = data["retailerdownload_phone"];
            this.performanceStartDateTime = data["performanceStartDateTime"];
            this.performanceEndDateTime = data["performanceEndDateTime"];
            this.cardSchemeID = data["cardSchemeID"];
            this.cardSchemeArabic = data["cardSchemeArabic"];
            this.cardSchemeEnglish = data["cardSchemeEnglish"];
            this.applicationLabelArabic = data["applicationLabelArabic"];
            this.applicationLabelEnglish = data["applicationLabelEnglish"];
            this.transactionTypeArabic = data["transactionTypeArabic"];
            this.transactionTypeEnglish = data["transactionTypeEnglish"];
            this.amountsArabicCurrency = data["amountsArabicCurrency"];
            this.amountsEnglishCurrency = data["amountsEnglishCurrency"];
            this.amountArabicName = data["amountArabicName"];
            this.amountEnglishName = data["amountEnglishName"];
            this.amountValue = data["amountValue"];
            this.resultArabic = data["resultArabic"];
            this.resultEnglish = data["resultEnglish"];
            this.approvalCodeArabic = data["approvalCodeArabic"];
            this.approvalCodeEnglish = data["approvalCodeEnglish"];
            this.approvalCodeCode = data["approvalCodeCode"];
            this.emvTagsPosEntryMode = data["emvTagsPosEntryMode"];
            this.emvTagsResponseCode = data["emvTagsResponseCode"];
            this.emvTagsTerminalStatusCode = data["emvTagsTerminalStatusCode"];
            this.emvTagsAID = data["emvTagsAID"];
            this.emvTagsTVR = data["emvTagsTVR"];
            this.emvTagsTSI = data["emvTagsTSI"];
            this.emvTagsCVR = data["emvTagsCVR"];
            this.emvTagsACI = data["emvTagsACI"];
            this.emvTagsAC = data["emvTagsAC"];
            this.qrCodeData = data["qrCodeData"];
            this.campaignText = data["campaignText"];
            this.tenantId = data["tenantId"];
            this.saleTransactionId = data["saleTransactionId"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): POSResponseN90 {
        let result = new POSResponseN90();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ret"] = this.ret;
        data["bankId"] = this.bankId;
        data["merchantID"] = this.merchantID;
        data["terminalID"] = this.terminalID;
        data["mcc"] = this.mcc;
        data["stan"] = this.stan;
        data["version"] = this.version;
        data["rrn"] = this.rrn;
        data["pan"] = this.pan;
        data["cardExpiryDate"] = this.cardExpiryDate;
        data["additionalData"] = this.additionalData;
        data["retailerRetailerNameEng"] = this.retailerRetailerNameEng;
        data["retailerRetailerNameArb"] = this.retailerRetailerNameArb;
        data["retaileraddress_eng_1"] = this.retaileraddress_eng_1;
        data["retaileraddress_eng_2"] = this.retaileraddress_eng_2;
        data["retaileraddress_arb_1"] = this.retaileraddress_arb_1;
        data["retaileraddress_arb_2"] = this.retaileraddress_arb_2;
        data["retailerdownload_phone"] = this.retailerdownload_phone;
        data["performanceStartDateTime"] = this.performanceStartDateTime;
        data["performanceEndDateTime"] = this.performanceEndDateTime;
        data["cardSchemeID"] = this.cardSchemeID;
        data["cardSchemeArabic"] = this.cardSchemeArabic;
        data["cardSchemeEnglish"] = this.cardSchemeEnglish;
        data["applicationLabelArabic"] = this.applicationLabelArabic;
        data["applicationLabelEnglish"] = this.applicationLabelEnglish;
        data["transactionTypeArabic"] = this.transactionTypeArabic;
        data["transactionTypeEnglish"] = this.transactionTypeEnglish;
        data["amountsArabicCurrency"] = this.amountsArabicCurrency;
        data["amountsEnglishCurrency"] = this.amountsEnglishCurrency;
        data["amountArabicName"] = this.amountArabicName;
        data["amountEnglishName"] = this.amountEnglishName;
        data["amountValue"] = this.amountValue;
        data["resultArabic"] = this.resultArabic;
        data["resultEnglish"] = this.resultEnglish;
        data["approvalCodeArabic"] = this.approvalCodeArabic;
        data["approvalCodeEnglish"] = this.approvalCodeEnglish;
        data["approvalCodeCode"] = this.approvalCodeCode;
        data["emvTagsPosEntryMode"] = this.emvTagsPosEntryMode;
        data["emvTagsResponseCode"] = this.emvTagsResponseCode;
        data["emvTagsTerminalStatusCode"] = this.emvTagsTerminalStatusCode;
        data["emvTagsAID"] = this.emvTagsAID;
        data["emvTagsTVR"] = this.emvTagsTVR;
        data["emvTagsTSI"] = this.emvTagsTSI;
        data["emvTagsCVR"] = this.emvTagsCVR;
        data["emvTagsACI"] = this.emvTagsACI;
        data["emvTagsAC"] = this.emvTagsAC;
        data["qrCodeData"] = this.qrCodeData;
        data["campaignText"] = this.campaignText;
        data["tenantId"] = this.tenantId;
        data["saleTransactionId"] = this.saleTransactionId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPOSResponseN90 {
    ret: string;
    bankId: string;
    merchantID: string;
    terminalID: string;
    mcc: string;
    stan: string;
    version: string;
    rrn: string;
    pan: string;
    cardExpiryDate: string;
    additionalData: string;
    retailerRetailerNameEng: string;
    retailerRetailerNameArb: string;
    retaileraddress_eng_1: string;
    retaileraddress_eng_2: string;
    retaileraddress_arb_1: string;
    retaileraddress_arb_2: string;
    retailerdownload_phone: string;
    performanceStartDateTime: string;
    performanceEndDateTime: string;
    cardSchemeID: string;
    cardSchemeArabic: string;
    cardSchemeEnglish: string;
    applicationLabelArabic: string;
    applicationLabelEnglish: string;
    transactionTypeArabic: string;
    transactionTypeEnglish: string;
    amountsArabicCurrency: string;
    amountsEnglishCurrency: string;
    amountArabicName: string;
    amountEnglishName: string;
    amountValue: number;
    resultArabic: string;
    resultEnglish: string;
    approvalCodeArabic: string;
    approvalCodeEnglish: string;
    approvalCodeCode: string;
    emvTagsPosEntryMode: string;
    emvTagsResponseCode: string;
    emvTagsTerminalStatusCode: string;
    emvTagsAID: string;
    emvTagsTVR: string;
    emvTagsTSI: string;
    emvTagsCVR: string;
    emvTagsACI: string;
    emvTagsAC: string;
    qrCodeData: string;
    campaignText: string;
    tenantId: number;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SaleTransactionDetail implements ISaleTransactionDetail {
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    productLotId: number;
    menuItemId: number;
    productLot: ProductLot;
    menuItem: MenuItem;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    promotion: PromotionCodeFB;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    offer: Offer;
    additionalAllowns: number;
    allownsReason: string;
    offerType: SaleTransactionDetailOfferType;
    loyaltyDiscount: number;
    unitOfMeasure: UnitOfMeasure;
    serials: SaleTransactionDetailSerial[];
    saleTransactionDetailVarients: SaleTransactionDetailVarient[];
    saleTransactionDetailsComboMealsItems: SaleTransactionDetailsComboMealsItem[];
    saleTransactionsDetialsPromotionItems: SaleTransactionsDetialsPromotionItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransactionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTransactionId = data["saleTransactionId"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.productLotId = data["productLotId"];
            this.menuItemId = data["menuItemId"];
            this.productLot = data["productLot"] ? ProductLot.fromJS(data["productLot"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.discount = data["discount"];
            this.discountValue = data["discountValue"];
            this.notes = data["notes"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.promotion = data["promotion"] ? PromotionCodeFB.fromJS(data["promotion"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.offerId = data["offerId"];
            this.offer = data["offer"] ? Offer.fromJS(data["offer"]) : <any>undefined;
            this.additionalAllowns = data["additionalAllowns"];
            this.allownsReason = data["allownsReason"];
            this.offerType = data["offerType"];
            this.loyaltyDiscount = data["loyaltyDiscount"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            if (data["serials"] && data["serials"].constructor === Array) {
                this.serials = [];
                for (let item of data["serials"])
                    this.serials.push(SaleTransactionDetailSerial.fromJS(item));
            }
            if (data["saleTransactionDetailVarients"] && data["saleTransactionDetailVarients"].constructor === Array) {
                this.saleTransactionDetailVarients = [];
                for (let item of data["saleTransactionDetailVarients"])
                    this.saleTransactionDetailVarients.push(SaleTransactionDetailVarient.fromJS(item));
            }
            if (data["saleTransactionDetailsComboMealsItems"] && data["saleTransactionDetailsComboMealsItems"].constructor === Array) {
                this.saleTransactionDetailsComboMealsItems = [];
                for (let item of data["saleTransactionDetailsComboMealsItems"])
                    this.saleTransactionDetailsComboMealsItems.push(SaleTransactionDetailsComboMealsItem.fromJS(item));
            }
            if (data["saleTransactionsDetialsPromotionItems"] && data["saleTransactionsDetialsPromotionItems"].constructor === Array) {
                this.saleTransactionsDetialsPromotionItems = [];
                for (let item of data["saleTransactionsDetialsPromotionItems"])
                    this.saleTransactionsDetialsPromotionItems.push(SaleTransactionsDetialsPromotionItem.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionDetail {
        let result = new SaleTransactionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTransactionId"] = this.saleTransactionId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["productLotId"] = this.productLotId;
        data["menuItemId"] = this.menuItemId;
        data["productLot"] = this.productLot ? this.productLot.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["discount"] = this.discount;
        data["discountValue"] = this.discountValue;
        data["notes"] = this.notes;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["offerId"] = this.offerId;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["additionalAllowns"] = this.additionalAllowns;
        data["allownsReason"] = this.allownsReason;
        data["offerType"] = this.offerType;
        data["loyaltyDiscount"] = this.loyaltyDiscount;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        if (this.serials && this.serials.constructor === Array) {
            data["serials"] = [];
            for (let item of this.serials)
                data["serials"].push(item.toJSON());
        }
        if (this.saleTransactionDetailVarients && this.saleTransactionDetailVarients.constructor === Array) {
            data["saleTransactionDetailVarients"] = [];
            for (let item of this.saleTransactionDetailVarients)
                data["saleTransactionDetailVarients"].push(item.toJSON());
        }
        if (this.saleTransactionDetailsComboMealsItems && this.saleTransactionDetailsComboMealsItems.constructor === Array) {
            data["saleTransactionDetailsComboMealsItems"] = [];
            for (let item of this.saleTransactionDetailsComboMealsItems)
                data["saleTransactionDetailsComboMealsItems"].push(item.toJSON());
        }
        if (this.saleTransactionsDetialsPromotionItems && this.saleTransactionsDetialsPromotionItems.constructor === Array) {
            data["saleTransactionsDetialsPromotionItems"] = [];
            for (let item of this.saleTransactionsDetialsPromotionItems)
                data["saleTransactionsDetialsPromotionItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionDetail {
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    productLotId: number;
    menuItemId: number;
    productLot: ProductLot;
    menuItem: MenuItem;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    discountValue: number;
    notes: string;
    vat: number;
    vatBeforeDiscount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    promotion: PromotionCodeFB;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    offer: Offer;
    additionalAllowns: number;
    allownsReason: string;
    offerType: SaleTransactionDetailOfferType;
    loyaltyDiscount: number;
    unitOfMeasure: UnitOfMeasure;
    serials: SaleTransactionDetailSerial[];
    saleTransactionDetailVarients: SaleTransactionDetailVarient[];
    saleTransactionDetailsComboMealsItems: SaleTransactionDetailsComboMealsItem[];
    saleTransactionsDetialsPromotionItems: SaleTransactionsDetialsPromotionItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SalepaymentTransactions implements ISalepaymentTransactions {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeId: number;
    tenderType: TenderType;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    value: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISalepaymentTransactions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.currencyId = data["currencyId"];
            this.currency = data["currency"] ? Currency.fromJS(data["currency"]) : <any>undefined;
            this.tenderTypeId = data["tenderTypeId"];
            this.tenderType = data["tenderType"] ? TenderType.fromJS(data["tenderType"]) : <any>undefined;
            this.saleTransactionId = data["saleTransactionId"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.value = data["value"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalepaymentTransactions {
        let result = new SalepaymentTransactions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["tenderTypeId"] = this.tenderTypeId;
        data["tenderType"] = this.tenderType ? this.tenderType.toJSON() : <any>undefined;
        data["saleTransactionId"] = this.saleTransactionId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISalepaymentTransactions {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeId: number;
    tenderType: TenderType;
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    value: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SaleTransactionsDiningTable implements ISaleTransactionsDiningTable {
    tenantId: number;
    saleTransactionId: number;
    tableId: number;
    numberOfSeats: number;
    isSplit: boolean;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransactionsDiningTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTransactionId = data["saleTransactionId"];
            this.tableId = data["tableId"];
            this.numberOfSeats = data["numberOfSeats"];
            this.isSplit = data["isSplit"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionsDiningTable {
        let result = new SaleTransactionsDiningTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTransactionId"] = this.saleTransactionId;
        data["tableId"] = this.tableId;
        data["numberOfSeats"] = this.numberOfSeats;
        data["isSplit"] = this.isSplit;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionsDiningTable {
    tenantId: number;
    saleTransactionId: number;
    tableId: number;
    numberOfSeats: number;
    isSplit: boolean;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SaleTransactionOffer implements ISaleTransactionOffer {
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    offerId: number;
    price: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransactionOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTransactionId = data["saleTransactionId"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.offerId = data["offerId"];
            this.price = data["price"];
            this.offer = data["offer"] ? Offer.fromJS(data["offer"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionOffer {
        let result = new SaleTransactionOffer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTransactionId"] = this.saleTransactionId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["offerId"] = this.offerId;
        data["price"] = this.price;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionOffer {
    saleTransactionId: string;
    saleTransaction: SaleTransaction;
    offerId: number;
    price: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class EndOfDayDetail implements IEndOfDayDetail {
    date: moment.Moment;
    actualStartedOn: moment.Moment;
    actualEndedOn: moment.Moment;
    startOfDayTiming: string;
    endOfDayTiming: string;
    startOfDayDate: moment.Moment;
    endOfDayDate: moment.Moment;
    tenantId: number;
    status: EndOfDayDetailStatus;
    storeId: number;
    store: Store;
    cashierShifts: CashierShift[];
    invocies: SaleTransaction[];
    reurns: SaleNotification[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IEndOfDayDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.actualStartedOn = data["actualStartedOn"] ? moment(data["actualStartedOn"].toString()) : <any>undefined;
            this.actualEndedOn = data["actualEndedOn"] ? moment(data["actualEndedOn"].toString()) : <any>undefined;
            this.startOfDayTiming = data["startOfDayTiming"];
            this.endOfDayTiming = data["endOfDayTiming"];
            this.startOfDayDate = data["startOfDayDate"] ? moment(data["startOfDayDate"].toString()) : <any>undefined;
            this.endOfDayDate = data["endOfDayDate"] ? moment(data["endOfDayDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.status = data["status"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            if (data["cashierShifts"] && data["cashierShifts"].constructor === Array) {
                this.cashierShifts = [];
                for (let item of data["cashierShifts"])
                    this.cashierShifts.push(CashierShift.fromJS(item));
            }
            if (data["invocies"] && data["invocies"].constructor === Array) {
                this.invocies = [];
                for (let item of data["invocies"])
                    this.invocies.push(SaleTransaction.fromJS(item));
            }
            if (data["reurns"] && data["reurns"].constructor === Array) {
                this.reurns = [];
                for (let item of data["reurns"])
                    this.reurns.push(SaleNotification.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EndOfDayDetail {
        let result = new EndOfDayDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["actualStartedOn"] = this.actualStartedOn ? this.actualStartedOn.toISOString() : <any>undefined;
        data["actualEndedOn"] = this.actualEndedOn ? this.actualEndedOn.toISOString() : <any>undefined;
        data["startOfDayTiming"] = this.startOfDayTiming;
        data["endOfDayTiming"] = this.endOfDayTiming;
        data["startOfDayDate"] = this.startOfDayDate ? this.startOfDayDate.toISOString() : <any>undefined;
        data["endOfDayDate"] = this.endOfDayDate ? this.endOfDayDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (this.cashierShifts && this.cashierShifts.constructor === Array) {
            data["cashierShifts"] = [];
            for (let item of this.cashierShifts)
                data["cashierShifts"].push(item.toJSON());
        }
        if (this.invocies && this.invocies.constructor === Array) {
            data["invocies"] = [];
            for (let item of this.invocies)
                data["invocies"].push(item.toJSON());
        }
        if (this.reurns && this.reurns.constructor === Array) {
            data["reurns"] = [];
            for (let item of this.reurns)
                data["reurns"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEndOfDayDetail {
    date: moment.Moment;
    actualStartedOn: moment.Moment;
    actualEndedOn: moment.Moment;
    startOfDayTiming: string;
    endOfDayTiming: string;
    startOfDayDate: moment.Moment;
    endOfDayDate: moment.Moment;
    tenantId: number;
    status: EndOfDayDetailStatus;
    storeId: number;
    store: Store;
    cashierShifts: CashierShift[];
    invocies: SaleTransaction[];
    reurns: SaleNotification[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleNotification implements ISaleNotification {
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    status: number;
    tenantId: number;
    notes: string;
    isUploaded: boolean;
    isShift: boolean;
    saleTypeId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    promotion: PromotionCodeFB;
    date: moment.Moment;
    terminalId: number;
    happyHourId: number;
    templateType: number;
    isPrinted: boolean;
    additionalAllowns: number;
    endOfDayId: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    endOfDay: EndOfDayDetail;
    customer: Customer;
    saleNotificationDetails: SaleNotificationDetail[];
    salePaymentNotifications: SalePaymentNotification[];
    saleTransaction: SaleTransaction;
    saleType: SaleType;
    cashierShift: CashierShift;
    cashier: User;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.recieptNumber = data["recieptNumber"];
            this.refRecieptNumber = data["refRecieptNumber"];
            this.customerId = data["customerId"];
            this.refSaleTransactionId = data["refSaleTransactionId"];
            this.cashierId = data["cashierId"];
            this.cashierShiftId = data["cashierShiftId"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.total = data["total"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.notes = data["notes"];
            this.isUploaded = data["isUploaded"];
            this.isShift = data["isShift"];
            this.saleTypeId = data["saleTypeId"];
            this.discount = data["discount"];
            this.discountType = data["discountType"];
            this.discountValue = data["discountValue"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.promotion = data["promotion"] ? PromotionCodeFB.fromJS(data["promotion"]) : <any>undefined;
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.terminalId = data["terminalId"];
            this.happyHourId = data["happyHourId"];
            this.templateType = data["templateType"];
            this.isPrinted = data["isPrinted"];
            this.additionalAllowns = data["additionalAllowns"];
            this.endOfDayId = data["endOfDayId"];
            this.createdDeviceId = data["createdDeviceId"];
            this.lastModficationDeviceId = data["lastModficationDeviceId"];
            this.endOfDay = data["endOfDay"] ? EndOfDayDetail.fromJS(data["endOfDay"]) : <any>undefined;
            this.customer = data["customer"] ? Customer.fromJS(data["customer"]) : <any>undefined;
            if (data["saleNotificationDetails"] && data["saleNotificationDetails"].constructor === Array) {
                this.saleNotificationDetails = [];
                for (let item of data["saleNotificationDetails"])
                    this.saleNotificationDetails.push(SaleNotificationDetail.fromJS(item));
            }
            if (data["salePaymentNotifications"] && data["salePaymentNotifications"].constructor === Array) {
                this.salePaymentNotifications = [];
                for (let item of data["salePaymentNotifications"])
                    this.salePaymentNotifications.push(SalePaymentNotification.fromJS(item));
            }
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.cashierShift = data["cashierShift"] ? CashierShift.fromJS(data["cashierShift"]) : <any>undefined;
            this.cashier = data["cashier"] ? User.fromJS(data["cashier"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleNotification {
        let result = new SaleNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recieptNumber"] = this.recieptNumber;
        data["refRecieptNumber"] = this.refRecieptNumber;
        data["customerId"] = this.customerId;
        data["refSaleTransactionId"] = this.refSaleTransactionId;
        data["cashierId"] = this.cashierId;
        data["cashierShiftId"] = this.cashierShiftId;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["total"] = this.total;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["notes"] = this.notes;
        data["isUploaded"] = this.isUploaded;
        data["isShift"] = this.isShift;
        data["saleTypeId"] = this.saleTypeId;
        data["discount"] = this.discount;
        data["discountType"] = this.discountType;
        data["discountValue"] = this.discountValue;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["terminalId"] = this.terminalId;
        data["happyHourId"] = this.happyHourId;
        data["templateType"] = this.templateType;
        data["isPrinted"] = this.isPrinted;
        data["additionalAllowns"] = this.additionalAllowns;
        data["endOfDayId"] = this.endOfDayId;
        data["createdDeviceId"] = this.createdDeviceId;
        data["lastModficationDeviceId"] = this.lastModficationDeviceId;
        data["endOfDay"] = this.endOfDay ? this.endOfDay.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (this.saleNotificationDetails && this.saleNotificationDetails.constructor === Array) {
            data["saleNotificationDetails"] = [];
            for (let item of this.saleNotificationDetails)
                data["saleNotificationDetails"].push(item.toJSON());
        }
        if (this.salePaymentNotifications && this.salePaymentNotifications.constructor === Array) {
            data["salePaymentNotifications"] = [];
            for (let item of this.salePaymentNotifications)
                data["salePaymentNotifications"].push(item.toJSON());
        }
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["cashierShift"] = this.cashierShift ? this.cashierShift.toJSON() : <any>undefined;
        data["cashier"] = this.cashier ? this.cashier.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleNotification {
    recieptNumber: string;
    refRecieptNumber: string;
    customerId: string;
    refSaleTransactionId: string;
    cashierId: number;
    cashierShiftId: number;
    subTotal: number;
    vat: number;
    total: number;
    status: number;
    tenantId: number;
    notes: string;
    isUploaded: boolean;
    isShift: boolean;
    saleTypeId: number;
    discount: number;
    discountType: number;
    discountValue: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    promotion: PromotionCodeFB;
    date: moment.Moment;
    terminalId: number;
    happyHourId: number;
    templateType: number;
    isPrinted: boolean;
    additionalAllowns: number;
    endOfDayId: number;
    createdDeviceId: number;
    lastModficationDeviceId: number;
    endOfDay: EndOfDayDetail;
    customer: Customer;
    saleNotificationDetails: SaleNotificationDetail[];
    salePaymentNotifications: SalePaymentNotification[];
    saleTransaction: SaleTransaction;
    saleType: SaleType;
    cashierShift: CashierShift;
    cashier: User;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SaleTransactionAddress implements ISaleTransactionAddress {
    tenantId: number;
    saleTransactionId: string;
    city: string;
    link: string;
    address: string;
    deliveryStreetId: number;
    deliveryZoneId: number;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransactionAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTransactionId = data["saleTransactionId"];
            this.city = data["city"];
            this.link = data["link"];
            this.address = data["address"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.saleTransaction = data["saleTransaction"] ? SaleTransaction.fromJS(data["saleTransaction"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionAddress {
        let result = new SaleTransactionAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTransactionId"] = this.saleTransactionId;
        data["city"] = this.city;
        data["link"] = this.link;
        data["address"] = this.address;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["saleTransaction"] = this.saleTransaction ? this.saleTransaction.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionAddress {
    tenantId: number;
    saleTransactionId: string;
    city: string;
    link: string;
    address: string;
    deliveryStreetId: number;
    deliveryZoneId: number;
    saleTransaction: SaleTransaction;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class ThirdPartyBusinessCentral implements IThirdPartyBusinessCentral {
    grantType: string;
    clientId: string;
    clientSecret: string;
    scope: string;
    tenantId: number;
    authUrl: string;
    salesOrderUrls: SalesOrderUrl[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IThirdPartyBusinessCentral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.grantType = data["grantType"];
            this.clientId = data["clientId"];
            this.clientSecret = data["clientSecret"];
            this.scope = data["scope"];
            this.tenantId = data["tenantId"];
            this.authUrl = data["authUrl"];
            if (data["salesOrderUrls"] && data["salesOrderUrls"].constructor === Array) {
                this.salesOrderUrls = [];
                for (let item of data["salesOrderUrls"])
                    this.salesOrderUrls.push(SalesOrderUrl.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThirdPartyBusinessCentral {
        let result = new ThirdPartyBusinessCentral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["scope"] = this.scope;
        data["tenantId"] = this.tenantId;
        data["authUrl"] = this.authUrl;
        if (this.salesOrderUrls && this.salesOrderUrls.constructor === Array) {
            data["salesOrderUrls"] = [];
            for (let item of this.salesOrderUrls)
                data["salesOrderUrls"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThirdPartyBusinessCentral {
    grantType: string;
    clientId: string;
    clientSecret: string;
    scope: string;
    tenantId: number;
    authUrl: string;
    salesOrderUrls: SalesOrderUrl[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class PrimaryCategory implements IPrimaryCategory {
    code: string;
    translations: PrimaryCategoryTranslation[];
    tenantId: number;
    secondaryCategories: SecondaryCategory[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrimaryCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PrimaryCategoryTranslation.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            if (data["secondaryCategories"] && data["secondaryCategories"].constructor === Array) {
                this.secondaryCategories = [];
                for (let item of data["secondaryCategories"])
                    this.secondaryCategories.push(SecondaryCategory.fromJS(item));
            }
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrimaryCategory {
        let result = new PrimaryCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        if (this.secondaryCategories && this.secondaryCategories.constructor === Array) {
            data["secondaryCategories"] = [];
            for (let item of this.secondaryCategories)
                data["secondaryCategories"].push(item.toJSON());
        }
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrimaryCategory {
    code: string;
    translations: PrimaryCategoryTranslation[];
    tenantId: number;
    secondaryCategories: SecondaryCategory[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SecondaryCategory implements ISecondaryCategory {
    code: string;
    primaryCategoryId: number;
    primaryCategory: PrimaryCategory;
    translations: SecondaryCategoryTranslation[];
    productCategories: ProductCategory[];
    rawMaterials: RawMaterial[];
    products: Product[];
    menuItems: MenuItem[];
    tenantId: number;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISecondaryCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.primaryCategoryId = data["primaryCategoryId"];
            this.primaryCategory = data["primaryCategory"] ? PrimaryCategory.fromJS(data["primaryCategory"]) : <any>undefined;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SecondaryCategoryTranslation.fromJS(item));
            }
            if (data["productCategories"] && data["productCategories"].constructor === Array) {
                this.productCategories = [];
                for (let item of data["productCategories"])
                    this.productCategories.push(ProductCategory.fromJS(item));
            }
            if (data["rawMaterials"] && data["rawMaterials"].constructor === Array) {
                this.rawMaterials = [];
                for (let item of data["rawMaterials"])
                    this.rawMaterials.push(RawMaterial.fromJS(item));
            }
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(Product.fromJS(item));
            }
            if (data["menuItems"] && data["menuItems"].constructor === Array) {
                this.menuItems = [];
                for (let item of data["menuItems"])
                    this.menuItems.push(MenuItem.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCategory {
        let result = new SecondaryCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["primaryCategory"] = this.primaryCategory ? this.primaryCategory.toJSON() : <any>undefined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.productCategories && this.productCategories.constructor === Array) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item.toJSON());
        }
        if (this.rawMaterials && this.rawMaterials.constructor === Array) {
            data["rawMaterials"] = [];
            for (let item of this.rawMaterials)
                data["rawMaterials"].push(item.toJSON());
        }
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.menuItems && this.menuItems.constructor === Array) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISecondaryCategory {
    code: string;
    primaryCategoryId: number;
    primaryCategory: PrimaryCategory;
    translations: SecondaryCategoryTranslation[];
    productCategories: ProductCategory[];
    rawMaterials: RawMaterial[];
    products: Product[];
    menuItems: MenuItem[];
    tenantId: number;
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Group implements IGroup {
    tenantId: number;
    translations: GroupTranslation[];
    products: Product[];
    storeGroupConfigs: StoreGroupConfig[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(GroupTranslation.fromJS(item));
            }
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(Product.fromJS(item));
            }
            if (data["storeGroupConfigs"] && data["storeGroupConfigs"].constructor === Array) {
                this.storeGroupConfigs = [];
                for (let item of data["storeGroupConfigs"])
                    this.storeGroupConfigs.push(StoreGroupConfig.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Group {
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.storeGroupConfigs && this.storeGroupConfigs.constructor === Array) {
            data["storeGroupConfigs"] = [];
            for (let item of this.storeGroupConfigs)
                data["storeGroupConfigs"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGroup {
    tenantId: number;
    translations: GroupTranslation[];
    products: Product[];
    storeGroupConfigs: StoreGroupConfig[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductVendor implements IProductVendor {
    vendorId: number;
    vendor: Vendor;
    productId: number;
    product: Product;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorId = data["vendorId"];
            this.vendor = data["vendor"] ? Vendor.fromJS(data["vendor"]) : <any>undefined;
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductVendor {
        let result = new ProductVendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductVendor {
    vendorId: number;
    vendor: Vendor;
    productId: number;
    product: Product;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductTax implements IProductTax {
    productId: number;
    product: Product;
    taxId: number;
    tax: Tax;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductTax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.taxId = data["taxId"];
            this.tax = data["tax"] ? Tax.fromJS(data["tax"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductTax {
        let result = new ProductTax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["taxId"] = this.taxId;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductTax {
    productId: number;
    product: Product;
    taxId: number;
    tax: Tax;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductAttribute implements IProductAttribute {
    productId: number;
    product: Product;
    attributeId: number;
    attribute: Attribute;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.attributeId = data["attributeId"];
            this.attribute = data["attribute"] ? Attribute.fromJS(data["attribute"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductAttribute {
        let result = new ProductAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["attributeId"] = this.attributeId;
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductAttribute {
    productId: number;
    product: Product;
    attributeId: number;
    attribute: Attribute;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductTranslation implements IProductTranslation {
    productId: number;
    product: Product;
    name: string;
    description: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.name = data["name"];
            this.description = data["description"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductTranslation {
        let result = new ProductTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductTranslation {
    productId: number;
    product: Product;
    name: string;
    description: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductUnitOfMeasureConversion implements IProductUnitOfMeasureConversion {
    product: Product;
    productId: number;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    baseUnitOfMeasureId: number;
    baseUnitOfMeasure: UnitOfMeasure;
    conversionFactor: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductUnitOfMeasureConversion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.productId = data["productId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.baseUnitOfMeasureId = data["baseUnitOfMeasureId"];
            this.baseUnitOfMeasure = data["baseUnitOfMeasure"] ? UnitOfMeasure.fromJS(data["baseUnitOfMeasure"]) : <any>undefined;
            this.conversionFactor = data["conversionFactor"];
            this.code = data["code"];
            this.price = data["price"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductUnitOfMeasureConversion {
        let result = new ProductUnitOfMeasureConversion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["baseUnitOfMeasureId"] = this.baseUnitOfMeasureId;
        data["baseUnitOfMeasure"] = this.baseUnitOfMeasure ? this.baseUnitOfMeasure.toJSON() : <any>undefined;
        data["conversionFactor"] = this.conversionFactor;
        data["code"] = this.code;
        data["price"] = this.price;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductUnitOfMeasureConversion {
    product: Product;
    productId: number;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    baseUnitOfMeasureId: number;
    baseUnitOfMeasure: UnitOfMeasure;
    conversionFactor: number;
    code: string;
    price: number;
    priceIncludingVAT: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductSerials implements IProductSerials {
    productId: number;
    product: Product;
    isSold: boolean;
    serial: string;
    tenantId: number;
    productVariant: ProductVariant;
    productVariantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductSerials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.isSold = data["isSold"];
            this.serial = data["serial"];
            this.tenantId = data["tenantId"];
            this.productVariant = data["productVariant"] ? ProductVariant.fromJS(data["productVariant"]) : <any>undefined;
            this.productVariantId = data["productVariantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductSerials {
        let result = new ProductSerials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["isSold"] = this.isSold;
        data["serial"] = this.serial;
        data["tenantId"] = this.tenantId;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        data["productVariantId"] = this.productVariantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductSerials {
    productId: number;
    product: Product;
    isSold: boolean;
    serial: string;
    tenantId: number;
    productVariant: ProductVariant;
    productVariantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantValue implements IVariantValue {
    variant: Variant;
    variantId: number;
    tenantId: number;
    qunatity: number;
    rawMaterialId: number;
    isDefault: boolean;
    imageId: string;
    translations: VariantValueTranslation[];
    variantValuePriceList: VariantValuePriceList[];
    rawMaterial: RawMaterial;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variant = data["variant"] ? Variant.fromJS(data["variant"]) : <any>undefined;
            this.variantId = data["variantId"];
            this.tenantId = data["tenantId"];
            this.qunatity = data["qunatity"];
            this.rawMaterialId = data["rawMaterialId"];
            this.isDefault = data["isDefault"];
            this.imageId = data["imageId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VariantValueTranslation.fromJS(item));
            }
            if (data["variantValuePriceList"] && data["variantValuePriceList"].constructor === Array) {
                this.variantValuePriceList = [];
                for (let item of data["variantValuePriceList"])
                    this.variantValuePriceList.push(VariantValuePriceList.fromJS(item));
            }
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantValue {
        let result = new VariantValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["variantId"] = this.variantId;
        data["tenantId"] = this.tenantId;
        data["qunatity"] = this.qunatity;
        data["rawMaterialId"] = this.rawMaterialId;
        data["isDefault"] = this.isDefault;
        data["imageId"] = this.imageId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.variantValuePriceList && this.variantValuePriceList.constructor === Array) {
            data["variantValuePriceList"] = [];
            for (let item of this.variantValuePriceList)
                data["variantValuePriceList"].push(item.toJSON());
        }
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantValue {
    variant: Variant;
    variantId: number;
    tenantId: number;
    qunatity: number;
    rawMaterialId: number;
    isDefault: boolean;
    imageId: string;
    translations: VariantValueTranslation[];
    variantValuePriceList: VariantValuePriceList[];
    rawMaterial: RawMaterial;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductVariantTranslation implements IProductVariantTranslation {
    productVariantId: number;
    productVariant: ProductVariant;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductVariantTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productVariantId = data["productVariantId"];
            this.productVariant = data["productVariant"] ? ProductVariant.fromJS(data["productVariant"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductVariantTranslation {
        let result = new ProductVariantTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productVariantId"] = this.productVariantId;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductVariantTranslation {
    productVariantId: number;
    productVariant: ProductVariant;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UnitOfMeasureTranslation implements IUnitOfMeasureTranslation {
    unitOfMeasure: UnitOfMeasure;
    unitOfMeasureId: number;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUnitOfMeasureTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnitOfMeasureTranslation {
        let result = new UnitOfMeasureTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUnitOfMeasureTranslation {
    unitOfMeasure: UnitOfMeasure;
    unitOfMeasureId: number;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboGroupDetail implements IComboGroupDetail {
    tenantId: number;
    comboGroup: ComboGroup;
    comboGroupId: number;
    menuItem: MenuItem;
    menuItemId: number;
    unitOfMeasure: UnitOfMeasure;
    unitOfMeasureId: number;
    menuItemConfigId: number;
    menuItemConfig: MenuItemConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboGroupDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.comboGroup = data["comboGroup"] ? ComboGroup.fromJS(data["comboGroup"]) : <any>undefined;
            this.comboGroupId = data["comboGroupId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.menuItemId = data["menuItemId"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.menuItemConfig = data["menuItemConfig"] ? MenuItemConfig.fromJS(data["menuItemConfig"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboGroupDetail {
        let result = new ComboGroupDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["comboGroup"] = this.comboGroup ? this.comboGroup.toJSON() : <any>undefined;
        data["comboGroupId"] = this.comboGroupId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["menuItemId"] = this.menuItemId;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["menuItemConfig"] = this.menuItemConfig ? this.menuItemConfig.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboGroupDetail {
    tenantId: number;
    comboGroup: ComboGroup;
    comboGroupId: number;
    menuItem: MenuItem;
    menuItemId: number;
    unitOfMeasure: UnitOfMeasure;
    unitOfMeasureId: number;
    menuItemConfigId: number;
    menuItemConfig: MenuItemConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Vendor implements IVendor {
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    tenantId: number;
    translations: VendorTranslation[];
    products: ProductVendor[];
    mainTransactions: MainTransaction[];
    purchaseInvoices: PurchaseInvoice[];
    rawMaterialSuppliers: RawMaterialSupplier[];
    vendorStores: VendorStores[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.address = data["address"];
            this.legalName = data["legalName"];
            this.taxNumber = data["taxNumber"];
            this.tinElectronicAddress = data["tinElectronicAddress"];
            this.electronicAddressScheme = data["electronicAddressScheme"];
            this.legalRegistrationNumber = data["legalRegistrationNumber"];
            this.legalRegistrationType = data["legalRegistrationType"];
            this.registrationIssuingAuthority = data["registrationIssuingAuthority"];
            this.city = data["city"];
            this.emirate = data["emirate"];
            this.postalCode = data["postalCode"];
            this.countryCode = data["countryCode"];
            this.contactName = data["contactName"];
            this.cellPhone = data["cellPhone"];
            this.email = data["email"];
            this.fax = data["fax"];
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VendorTranslation.fromJS(item));
            }
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(ProductVendor.fromJS(item));
            }
            if (data["mainTransactions"] && data["mainTransactions"].constructor === Array) {
                this.mainTransactions = [];
                for (let item of data["mainTransactions"])
                    this.mainTransactions.push(MainTransaction.fromJS(item));
            }
            if (data["purchaseInvoices"] && data["purchaseInvoices"].constructor === Array) {
                this.purchaseInvoices = [];
                for (let item of data["purchaseInvoices"])
                    this.purchaseInvoices.push(PurchaseInvoice.fromJS(item));
            }
            if (data["rawMaterialSuppliers"] && data["rawMaterialSuppliers"].constructor === Array) {
                this.rawMaterialSuppliers = [];
                for (let item of data["rawMaterialSuppliers"])
                    this.rawMaterialSuppliers.push(RawMaterialSupplier.fromJS(item));
            }
            if (data["vendorStores"] && data["vendorStores"].constructor === Array) {
                this.vendorStores = [];
                for (let item of data["vendorStores"])
                    this.vendorStores.push(VendorStores.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Vendor {
        let result = new Vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["address"] = this.address;
        data["legalName"] = this.legalName;
        data["taxNumber"] = this.taxNumber;
        data["tinElectronicAddress"] = this.tinElectronicAddress;
        data["electronicAddressScheme"] = this.electronicAddressScheme;
        data["legalRegistrationNumber"] = this.legalRegistrationNumber;
        data["legalRegistrationType"] = this.legalRegistrationType;
        data["registrationIssuingAuthority"] = this.registrationIssuingAuthority;
        data["city"] = this.city;
        data["emirate"] = this.emirate;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["contactName"] = this.contactName;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.mainTransactions && this.mainTransactions.constructor === Array) {
            data["mainTransactions"] = [];
            for (let item of this.mainTransactions)
                data["mainTransactions"].push(item.toJSON());
        }
        if (this.purchaseInvoices && this.purchaseInvoices.constructor === Array) {
            data["purchaseInvoices"] = [];
            for (let item of this.purchaseInvoices)
                data["purchaseInvoices"].push(item.toJSON());
        }
        if (this.rawMaterialSuppliers && this.rawMaterialSuppliers.constructor === Array) {
            data["rawMaterialSuppliers"] = [];
            for (let item of this.rawMaterialSuppliers)
                data["rawMaterialSuppliers"].push(item.toJSON());
        }
        if (this.vendorStores && this.vendorStores.constructor === Array) {
            data["vendorStores"] = [];
            for (let item of this.vendorStores)
                data["vendorStores"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVendor {
    code: string;
    address: string;
    legalName: string;
    taxNumber: string;
    tinElectronicAddress: string;
    electronicAddressScheme: string;
    legalRegistrationNumber: string;
    legalRegistrationType: string;
    registrationIssuingAuthority: string;
    city: string;
    emirate: string;
    postalCode: string;
    countryCode: string;
    contactName: string;
    cellPhone: string;
    email: string;
    fax: string;
    tenantId: number;
    translations: VendorTranslation[];
    products: ProductVendor[];
    mainTransactions: MainTransaction[];
    purchaseInvoices: PurchaseInvoice[];
    rawMaterialSuppliers: RawMaterialSupplier[];
    vendorStores: VendorStores[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreDayWorkingHours implements IStoreDayWorkingHours {
    dayOfWeek: StoreDayWorkingHoursDayOfWeek;
    workingHoursStart: string;
    workingHoursEnd: string;
    storeWorkingHoursRuleId: number;
    storeWorkingHoursRule: StoreWorkingHoursRule;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreDayWorkingHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dayOfWeek = data["dayOfWeek"];
            this.workingHoursStart = data["workingHoursStart"];
            this.workingHoursEnd = data["workingHoursEnd"];
            this.storeWorkingHoursRuleId = data["storeWorkingHoursRuleId"];
            this.storeWorkingHoursRule = data["storeWorkingHoursRule"] ? StoreWorkingHoursRule.fromJS(data["storeWorkingHoursRule"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreDayWorkingHours {
        let result = new StoreDayWorkingHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["workingHoursStart"] = this.workingHoursStart;
        data["workingHoursEnd"] = this.workingHoursEnd;
        data["storeWorkingHoursRuleId"] = this.storeWorkingHoursRuleId;
        data["storeWorkingHoursRule"] = this.storeWorkingHoursRule ? this.storeWorkingHoursRule.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreDayWorkingHours {
    dayOfWeek: StoreDayWorkingHoursDayOfWeek;
    workingHoursStart: string;
    workingHoursEnd: string;
    storeWorkingHoursRuleId: number;
    storeWorkingHoursRule: StoreWorkingHoursRule;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UserStores implements IUserStores {
    storeId: number;
    store: Store;
    userId: number;
    user: User;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUserStores) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserStores {
        let result = new UserStores();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserStores {
    storeId: number;
    store: Store;
    userId: number;
    user: User;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UserDevices implements IUserDevices {
    deviceId: number;
    userId: number;
    user: User;
    tenantId: number;
    deviceType: number;
    isInstalled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUserDevices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.userId = data["userId"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.deviceType = data["deviceType"];
            this.isInstalled = data["isInstalled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserDevices {
        let result = new UserDevices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["deviceType"] = this.deviceType;
        data["isInstalled"] = this.isInstalled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserDevices {
    deviceId: number;
    userId: number;
    user: User;
    tenantId: number;
    deviceType: number;
    isInstalled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId: number;
    userId: number;
    loginProvider: string;
    name: string;
    value: string;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.name = data["name"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserToken {
    tenantId: number;
    userId: number;
    loginProvider: string;
    name: string;
    value: string;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.providerKey = data["providerKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLogin {
    tenantId: number;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.roleId = data["roleId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserRole {
    tenantId: number;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number;
    userId: number;
    claimType: string;
    claimValue: string;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserClaim {
    tenantId: number;
    userId: number;
    claimType: string;
    claimValue: string;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number;
    userId: number;
    name: string;
    value: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.value = data["value"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Setting {
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISetting {
    tenantId: number;
    userId: number;
    name: string;
    value: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeviceSaleType implements IDeviceSaleType {
    tenantId: number;
    deviceId: number;
    saleTypeId: number;
    device: Device;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeviceSaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.saleTypeId = data["saleTypeId"];
            this.device = data["device"] ? Device.fromJS(data["device"]) : <any>undefined;
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceSaleType {
        let result = new DeviceSaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["saleTypeId"] = this.saleTypeId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeviceSaleType {
    tenantId: number;
    deviceId: number;
    saleTypeId: number;
    device: Device;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DevicePC implements IDevicePC {
    tenantId: number;
    deviceId: number;
    pcId: number;
    device: Device;
    pc: PC;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDevicePC) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.pcId = data["pcId"];
            this.device = data["device"] ? Device.fromJS(data["device"]) : <any>undefined;
            this.pc = data["pc"] ? PC.fromJS(data["pc"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DevicePC {
        let result = new DevicePC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["pcId"] = this.pcId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["pc"] = this.pc ? this.pc.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDevicePC {
    tenantId: number;
    deviceId: number;
    pcId: number;
    device: Device;
    pc: PC;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeviceTables implements IDeviceTables {
    tenantId: number;
    deviceId: number;
    pcId: number;
    tableId: number;
    device: Device;
    pc: PC;
    table: Table;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeviceTables) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.pcId = data["pcId"];
            this.tableId = data["tableId"];
            this.device = data["device"] ? Device.fromJS(data["device"]) : <any>undefined;
            this.pc = data["pc"] ? PC.fromJS(data["pc"]) : <any>undefined;
            this.table = data["table"] ? Table.fromJS(data["table"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceTables {
        let result = new DeviceTables();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["pcId"] = this.pcId;
        data["tableId"] = this.tableId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["pc"] = this.pc ? this.pc.toJSON() : <any>undefined;
        data["table"] = this.table ? this.table.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeviceTables {
    tenantId: number;
    deviceId: number;
    pcId: number;
    tableId: number;
    device: Device;
    pc: PC;
    table: Table;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeviceCategory implements IDeviceCategory {
    tenantDeviceId: number;
    tenantId: number;
    pcId: number;
    pc: PC;
    device: Device;
    productCategory: ProductCategory;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeviceCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantDeviceId = data["tenantDeviceId"];
            this.tenantId = data["tenantId"];
            this.pcId = data["pcId"];
            this.pc = data["pc"] ? PC.fromJS(data["pc"]) : <any>undefined;
            this.device = data["device"] ? Device.fromJS(data["device"]) : <any>undefined;
            this.productCategory = data["productCategory"] ? ProductCategory.fromJS(data["productCategory"]) : <any>undefined;
            this.productCategoryId = data["productCategoryId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeviceCategory {
        let result = new DeviceCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantDeviceId"] = this.tenantDeviceId;
        data["tenantId"] = this.tenantId;
        data["pcId"] = this.pcId;
        data["pc"] = this.pc ? this.pc.toJSON() : <any>undefined;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeviceCategory {
    tenantDeviceId: number;
    tenantId: number;
    pcId: number;
    pc: PC;
    device: Device;
    productCategory: ProductCategory;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemDevice implements IMenuItemDevice {
    tenantDeviceId: number;
    deviceId: number;
    menuItemId: number;
    tenantId: number;
    device: Device;
    menuItem: MenuItem;
    menuItemConfigId: number;
    menuItemConfig: MenuItemConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantDeviceId = data["tenantDeviceId"];
            this.deviceId = data["deviceId"];
            this.menuItemId = data["menuItemId"];
            this.tenantId = data["tenantId"];
            this.device = data["device"] ? Device.fromJS(data["device"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.menuItemConfigId = data["menuItemConfigId"];
            this.menuItemConfig = data["menuItemConfig"] ? MenuItemConfig.fromJS(data["menuItemConfig"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemDevice {
        let result = new MenuItemDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantDeviceId"] = this.tenantDeviceId;
        data["deviceId"] = this.deviceId;
        data["menuItemId"] = this.menuItemId;
        data["tenantId"] = this.tenantId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["menuItemConfig"] = this.menuItemConfig ? this.menuItemConfig.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemDevice {
    tenantDeviceId: number;
    deviceId: number;
    menuItemId: number;
    tenantId: number;
    device: Device;
    menuItem: MenuItem;
    menuItemConfigId: number;
    menuItemConfig: MenuItemConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class HappyHourTranslation implements IHappyHourTranslation {
    name: string;
    happyHourId: number;
    happyHour: HappyHour;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IHappyHourTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.happyHourId = data["happyHourId"];
            this.happyHour = data["happyHour"] ? HappyHour.fromJS(data["happyHour"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HappyHourTranslation {
        let result = new HappyHourTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["happyHourId"] = this.happyHourId;
        data["happyHour"] = this.happyHour ? this.happyHour.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHappyHourTranslation {
    name: string;
    happyHourId: number;
    happyHour: HappyHour;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTypeTranslation implements ISaleTypeTranslation {
    name: string;
    saleTypeId: number;
    saleType: SaleType;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeTranslation {
        let result = new SaleTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeTranslation {
    name: string;
    saleTypeId: number;
    saleType: SaleType;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTypePriceList implements ISaleTypePriceList {
    tenantId: number;
    saleType: SaleType;
    priceList: PriceList;
    saleTypeId: number;
    priceListId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypePriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.priceList = data["priceList"] ? PriceList.fromJS(data["priceList"]) : <any>undefined;
            this.saleTypeId = data["saleTypeId"];
            this.priceListId = data["priceListId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypePriceList {
        let result = new SaleTypePriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["saleTypeId"] = this.saleTypeId;
        data["priceListId"] = this.priceListId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypePriceList {
    tenantId: number;
    saleType: SaleType;
    priceList: PriceList;
    saleTypeId: number;
    priceListId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTypeComboGroup implements ISaleTypeComboGroup {
    tenantId: number;
    saleType: SaleType;
    comboGroup: ComboGroup;
    comboGroupId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypeComboGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.comboGroup = data["comboGroup"] ? ComboGroup.fromJS(data["comboGroup"]) : <any>undefined;
            this.comboGroupId = data["comboGroupId"];
            this.saleTypeId = data["saleTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypeComboGroup {
        let result = new SaleTypeComboGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["comboGroup"] = this.comboGroup ? this.comboGroup.toJSON() : <any>undefined;
        data["comboGroupId"] = this.comboGroupId;
        data["saleTypeId"] = this.saleTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypeComboGroup {
    tenantId: number;
    saleType: SaleType;
    comboGroup: ComboGroup;
    comboGroupId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ServiceChargeSaleType implements IServiceChargeSaleType {
    saleTypeId: number;
    serviceChargeId: number;
    serviceCharge: ServiceCharge;
    saleType: SaleType;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IServiceChargeSaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTypeId = data["saleTypeId"];
            this.serviceChargeId = data["serviceChargeId"];
            this.serviceCharge = data["serviceCharge"] ? ServiceCharge.fromJS(data["serviceCharge"]) : <any>undefined;
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceChargeSaleType {
        let result = new ServiceChargeSaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTypeId"] = this.saleTypeId;
        data["serviceChargeId"] = this.serviceChargeId;
        data["serviceCharge"] = this.serviceCharge ? this.serviceCharge.toJSON() : <any>undefined;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceChargeSaleType {
    saleTypeId: number;
    serviceChargeId: number;
    serviceCharge: ServiceCharge;
    saleType: SaleType;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemSaleType implements IMenuItemSaleType {
    tenantId: number;
    menuItem: MenuItem;
    saleType: SaleType;
    menuItemId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemSaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.menuItemId = data["menuItemId"];
            this.saleTypeId = data["saleTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemSaleType {
        let result = new MenuItemSaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["menuItemId"] = this.menuItemId;
        data["saleTypeId"] = this.saleTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemSaleType {
    tenantId: number;
    menuItem: MenuItem;
    saleType: SaleType;
    menuItemId: number;
    saleTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTypesRoles implements ISaleTypesRoles {
    tenantId: number;
    saleTypeId: number;
    roleId: number;
    saleType: SaleType;
    role: Role;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTypesRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTypeId = data["saleTypeId"];
            this.roleId = data["roleId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.role = data["role"] ? Role.fromJS(data["role"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTypesRoles {
        let result = new SaleTypesRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTypeId"] = this.saleTypeId;
        data["roleId"] = this.roleId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTypesRoles {
    tenantId: number;
    saleTypeId: number;
    roleId: number;
    saleType: SaleType;
    role: Role;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RecipeRawMaterialSaleType implements IRecipeRawMaterialSaleType {
    tenantId: number;
    saleTypeId: number;
    recipeRawMaterialId: number;
    saleType: SaleType;
    recipeRawMaterial: RecipeRawMaterial;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipeRawMaterialSaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTypeId = data["saleTypeId"];
            this.recipeRawMaterialId = data["recipeRawMaterialId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.recipeRawMaterial = data["recipeRawMaterial"] ? RecipeRawMaterial.fromJS(data["recipeRawMaterial"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeRawMaterialSaleType {
        let result = new RecipeRawMaterialSaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTypeId"] = this.saleTypeId;
        data["recipeRawMaterialId"] = this.recipeRawMaterialId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["recipeRawMaterial"] = this.recipeRawMaterial ? this.recipeRawMaterial.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeRawMaterialSaleType {
    tenantId: number;
    saleTypeId: number;
    recipeRawMaterialId: number;
    saleType: SaleType;
    recipeRawMaterial: RecipeRawMaterial;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RawMaterialDetailSaleType implements IRawMaterialDetailSaleType {
    tenantId: number;
    saleTypeId: number;
    saleType: SaleType;
    rawMaterialDetailId: number;
    rawMaterialDetail: RawMaterialDetail;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialDetailSaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.rawMaterialDetailId = data["rawMaterialDetailId"];
            this.rawMaterialDetail = data["rawMaterialDetail"] ? RawMaterialDetail.fromJS(data["rawMaterialDetail"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialDetailSaleType {
        let result = new RawMaterialDetailSaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["rawMaterialDetailId"] = this.rawMaterialDetailId;
        data["rawMaterialDetail"] = this.rawMaterialDetail ? this.rawMaterialDetail.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialDetailSaleType {
    tenantId: number;
    saleTypeId: number;
    saleType: SaleType;
    rawMaterialDetailId: number;
    rawMaterialDetail: RawMaterialDetail;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CustomerSaleType implements ICustomerSaleType {
    tenantId: number;
    customerId: string;
    customer: Customer;
    saleTypeId: number;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ICustomerSaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.customerId = data["customerId"];
            this.customer = data["customer"] ? Customer.fromJS(data["customer"]) : <any>undefined;
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomerSaleType {
        let result = new CustomerSaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomerSaleType {
    tenantId: number;
    customerId: string;
    customer: Customer;
    saleTypeId: number;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class TenderTypeSaleType implements ITenderTypeSaleType {
    tenantId: number;
    tenderTypeId: number;
    tenderType: TenderType;
    saleTypeId: number;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ITenderTypeSaleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.tenderType = data["tenderType"] ? TenderType.fromJS(data["tenderType"]) : <any>undefined;
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeSaleType {
        let result = new TenderTypeSaleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["tenderType"] = this.tenderType ? this.tenderType.toJSON() : <any>undefined;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeSaleType {
    tenantId: number;
    tenderTypeId: number;
    tenderType: TenderType;
    saleTypeId: number;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class RawMaterialTranslation implements IRawMaterialTranslation {
    name: string;
    rawMaterialId: number;
    rawMaterial: RawMaterial;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialTranslation {
        let result = new RawMaterialTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialTranslation {
    name: string;
    rawMaterialId: number;
    rawMaterial: RawMaterial;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Period implements IPeriod {
    tenantId: number;
    periodType: PeriodType;
    code: string;
    translations: PeriodTranslation[];
    rawMaterials: RawMaterial[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.periodType = data["periodType"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PeriodTranslation.fromJS(item));
            }
            if (data["rawMaterials"] && data["rawMaterials"].constructor === Array) {
                this.rawMaterials = [];
                for (let item of data["rawMaterials"])
                    this.rawMaterials.push(RawMaterial.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Period {
        let result = new Period();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["periodType"] = this.periodType;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.rawMaterials && this.rawMaterials.constructor === Array) {
            data["rawMaterials"] = [];
            for (let item of this.rawMaterials)
                data["rawMaterials"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPeriod {
    tenantId: number;
    periodType: PeriodType;
    code: string;
    translations: PeriodTranslation[];
    rawMaterials: RawMaterial[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RawMaterialSupplier implements IRawMaterialSupplier {
    tenantId: number;
    rawMaterial: RawMaterial;
    rawMaterialId: number;
    supplier: Vendor;
    supplierId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.rawMaterialId = data["rawMaterialId"];
            this.supplier = data["supplier"] ? Vendor.fromJS(data["supplier"]) : <any>undefined;
            this.supplierId = data["supplierId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialSupplier {
        let result = new RawMaterialSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["rawMaterialId"] = this.rawMaterialId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data["supplierId"] = this.supplierId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialSupplier {
    tenantId: number;
    rawMaterial: RawMaterial;
    rawMaterialId: number;
    supplier: Vendor;
    supplierId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RawMaterialDetail implements IRawMaterialDetail {
    tenantId: number;
    rawMaterialId: number;
    rawMaterial: RawMaterial;
    quantity: number;
    lossFactor: number;
    rawMaterialComponentId: number;
    rawMaterialComponent: RawMaterial;
    rawMaterialDetailSaleTypes: RawMaterialDetailSaleType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRawMaterialDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.quantity = data["quantity"];
            this.lossFactor = data["lossFactor"];
            this.rawMaterialComponentId = data["rawMaterialComponentId"];
            this.rawMaterialComponent = data["rawMaterialComponent"] ? RawMaterial.fromJS(data["rawMaterialComponent"]) : <any>undefined;
            if (data["rawMaterialDetailSaleTypes"] && data["rawMaterialDetailSaleTypes"].constructor === Array) {
                this.rawMaterialDetailSaleTypes = [];
                for (let item of data["rawMaterialDetailSaleTypes"])
                    this.rawMaterialDetailSaleTypes.push(RawMaterialDetailSaleType.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RawMaterialDetail {
        let result = new RawMaterialDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["lossFactor"] = this.lossFactor;
        data["rawMaterialComponentId"] = this.rawMaterialComponentId;
        data["rawMaterialComponent"] = this.rawMaterialComponent ? this.rawMaterialComponent.toJSON() : <any>undefined;
        if (this.rawMaterialDetailSaleTypes && this.rawMaterialDetailSaleTypes.constructor === Array) {
            data["rawMaterialDetailSaleTypes"] = [];
            for (let item of this.rawMaterialDetailSaleTypes)
                data["rawMaterialDetailSaleTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRawMaterialDetail {
    tenantId: number;
    rawMaterialId: number;
    rawMaterial: RawMaterial;
    quantity: number;
    lossFactor: number;
    rawMaterialComponentId: number;
    rawMaterialComponent: RawMaterial;
    rawMaterialDetailSaleTypes: RawMaterialDetailSaleType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MaterialStock implements IMaterialStock {
    materialStockId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    storeId: number;
    qty: number;
    loseQuantity: number;
    price: number;
    tenantId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMaterialStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialStockId = data["materialStockId"];
            this.materialId = data["materialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.qty = data["qty"];
            this.loseQuantity = data["loseQuantity"];
            this.price = data["price"];
            this.tenantId = data["tenantId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MaterialStock {
        let result = new MaterialStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialStockId"] = this.materialStockId;
        data["materialId"] = this.materialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["qty"] = this.qty;
        data["loseQuantity"] = this.loseQuantity;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMaterialStock {
    materialStockId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    storeId: number;
    qty: number;
    loseQuantity: number;
    price: number;
    tenantId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class EntryMaterialStock implements IEntryMaterialStock {
    tenantId: number;
    materialStockId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    storeId: number;
    store: Store;
    stockPeriodClosingDateId: number;
    stockPeriodClosingDate: StockPeriodClosingDate;
    qty: number;
    actualQty: number;
    finalQty: number;
    price: number;
    variant: number;
    date: moment.Moment;
    expectedBalance: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IEntryMaterialStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.materialStockId = data["materialStockId"];
            this.materialId = data["materialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.stockPeriodClosingDateId = data["stockPeriodClosingDateId"];
            this.stockPeriodClosingDate = data["stockPeriodClosingDate"] ? StockPeriodClosingDate.fromJS(data["stockPeriodClosingDate"]) : <any>undefined;
            this.qty = data["qty"];
            this.actualQty = data["actualQty"];
            this.finalQty = data["finalQty"];
            this.price = data["price"];
            this.variant = data["variant"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.expectedBalance = data["expectedBalance"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntryMaterialStock {
        let result = new EntryMaterialStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["materialStockId"] = this.materialStockId;
        data["materialId"] = this.materialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["stockPeriodClosingDateId"] = this.stockPeriodClosingDateId;
        data["stockPeriodClosingDate"] = this.stockPeriodClosingDate ? this.stockPeriodClosingDate.toJSON() : <any>undefined;
        data["qty"] = this.qty;
        data["actualQty"] = this.actualQty;
        data["finalQty"] = this.finalQty;
        data["price"] = this.price;
        data["variant"] = this.variant;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["expectedBalance"] = this.expectedBalance;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntryMaterialStock {
    tenantId: number;
    materialStockId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    storeId: number;
    store: Store;
    stockPeriodClosingDateId: number;
    stockPeriodClosingDate: StockPeriodClosingDate;
    qty: number;
    actualQty: number;
    finalQty: number;
    price: number;
    variant: number;
    date: moment.Moment;
    expectedBalance: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DetailTransactionEntity implements IDetailTransactionEntity {
    detailTransactionId: number;
    mainTransactionId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    qty: number;
    lotNumber: number;
    originalQunatity: number;
    qtyReceive: number;
    discount: number;
    price: number;
    tax: number;
    taxId: number;
    netAfterVat: number;
    notes: string;
    dueDate: moment.Moment;
    unitType: DetailTransactionEntityUnitType;
    tenantId: number;
    mainTransaction: MainTransaction;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    productLotId: number;
    productLot: ProductLot;
    productId: number;
    product: Product;
    productVariantId: number;
    unitOfMeasureId: number;
    productVariant: ProductVariant;
    unitOfMeasure: UnitOfMeasure;
    taxType: Tax;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDetailTransactionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailTransactionId = data["detailTransactionId"];
            this.mainTransactionId = data["mainTransactionId"];
            this.materialId = data["materialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.qty = data["qty"];
            this.lotNumber = data["lotNumber"];
            this.originalQunatity = data["originalQunatity"];
            this.qtyReceive = data["qtyReceive"];
            this.discount = data["discount"];
            this.price = data["price"];
            this.tax = data["tax"];
            this.taxId = data["taxId"];
            this.netAfterVat = data["netAfterVat"];
            this.notes = data["notes"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.unitType = data["unitType"];
            this.tenantId = data["tenantId"];
            this.mainTransaction = data["mainTransaction"] ? MainTransaction.fromJS(data["mainTransaction"]) : <any>undefined;
            this.transactionTemplateId = data["transactionTemplateId"];
            this.transactionTemplate = data["transactionTemplate"] ? TransactionTemplate.fromJS(data["transactionTemplate"]) : <any>undefined;
            this.productLotId = data["productLotId"];
            this.productLot = data["productLot"] ? ProductLot.fromJS(data["productLot"]) : <any>undefined;
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.productVariantId = data["productVariantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.productVariant = data["productVariant"] ? ProductVariant.fromJS(data["productVariant"]) : <any>undefined;
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.taxType = data["taxType"] ? Tax.fromJS(data["taxType"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DetailTransactionEntity {
        let result = new DetailTransactionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailTransactionId"] = this.detailTransactionId;
        data["mainTransactionId"] = this.mainTransactionId;
        data["materialId"] = this.materialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["qty"] = this.qty;
        data["lotNumber"] = this.lotNumber;
        data["originalQunatity"] = this.originalQunatity;
        data["qtyReceive"] = this.qtyReceive;
        data["discount"] = this.discount;
        data["price"] = this.price;
        data["tax"] = this.tax;
        data["taxId"] = this.taxId;
        data["netAfterVat"] = this.netAfterVat;
        data["notes"] = this.notes;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["unitType"] = this.unitType;
        data["tenantId"] = this.tenantId;
        data["mainTransaction"] = this.mainTransaction ? this.mainTransaction.toJSON() : <any>undefined;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["transactionTemplate"] = this.transactionTemplate ? this.transactionTemplate.toJSON() : <any>undefined;
        data["productLotId"] = this.productLotId;
        data["productLot"] = this.productLot ? this.productLot.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productVariantId"] = this.productVariantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["taxType"] = this.taxType ? this.taxType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDetailTransactionEntity {
    detailTransactionId: number;
    mainTransactionId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    qty: number;
    lotNumber: number;
    originalQunatity: number;
    qtyReceive: number;
    discount: number;
    price: number;
    tax: number;
    taxId: number;
    netAfterVat: number;
    notes: string;
    dueDate: moment.Moment;
    unitType: DetailTransactionEntityUnitType;
    tenantId: number;
    mainTransaction: MainTransaction;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    productLotId: number;
    productLot: ProductLot;
    productId: number;
    product: Product;
    productVariantId: number;
    unitOfMeasureId: number;
    productVariant: ProductVariant;
    unitOfMeasure: UnitOfMeasure;
    taxType: Tax;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RecipeTranslation implements IRecipeTranslation {
    recipeId: number;
    recipe: Recipe;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.recipeId = data["recipeId"];
            this.recipe = data["recipe"] ? Recipe.fromJS(data["recipe"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeTranslation {
        let result = new RecipeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeId"] = this.recipeId;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeTranslation {
    recipeId: number;
    recipe: Recipe;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RecipeRawMaterial implements IRecipeRawMaterial {
    tenantId: number;
    quantity: number;
    lossFactor: number;
    rawMaterialId: number;
    rawMaterial: RawMaterial;
    recipe: Recipe;
    recipeId: number;
    recipeRawMaterialSaleTypes: RecipeRawMaterialSaleType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRecipeRawMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.quantity = data["quantity"];
            this.lossFactor = data["lossFactor"];
            this.rawMaterialId = data["rawMaterialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.recipe = data["recipe"] ? Recipe.fromJS(data["recipe"]) : <any>undefined;
            this.recipeId = data["recipeId"];
            if (data["recipeRawMaterialSaleTypes"] && data["recipeRawMaterialSaleTypes"].constructor === Array) {
                this.recipeRawMaterialSaleTypes = [];
                for (let item of data["recipeRawMaterialSaleTypes"])
                    this.recipeRawMaterialSaleTypes.push(RecipeRawMaterialSaleType.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RecipeRawMaterial {
        let result = new RecipeRawMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["quantity"] = this.quantity;
        data["lossFactor"] = this.lossFactor;
        data["rawMaterialId"] = this.rawMaterialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : <any>undefined;
        data["recipeId"] = this.recipeId;
        if (this.recipeRawMaterialSaleTypes && this.recipeRawMaterialSaleTypes.constructor === Array) {
            data["recipeRawMaterialSaleTypes"] = [];
            for (let item of this.recipeRawMaterialSaleTypes)
                data["recipeRawMaterialSaleTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRecipeRawMaterial {
    tenantId: number;
    quantity: number;
    lossFactor: number;
    rawMaterialId: number;
    rawMaterial: RawMaterial;
    recipe: Recipe;
    recipeId: number;
    recipeRawMaterialSaleTypes: RecipeRawMaterialSaleType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ReportGroup implements IReportGroup {
    tenantId: number;
    code: string;
    translations: ReportGroupTranslation[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IReportGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ReportGroupTranslation.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReportGroup {
        let result = new ReportGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReportGroup {
    tenantId: number;
    code: string;
    translations: ReportGroupTranslation[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Level implements ILevel {
    code: string;
    translations: LevelTranslation[];
    tenantId: number;
    menuItems: MenuItem[];
    categories: ProductCategoryLevel[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ILevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(LevelTranslation.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            if (data["menuItems"] && data["menuItems"].constructor === Array) {
                this.menuItems = [];
                for (let item of data["menuItems"])
                    this.menuItems.push(MenuItem.fromJS(item));
            }
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(ProductCategoryLevel.fromJS(item));
            }
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Level {
        let result = new Level();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        if (this.menuItems && this.menuItems.constructor === Array) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILevel {
    code: string;
    translations: LevelTranslation[];
    tenantId: number;
    menuItems: MenuItem[];
    categories: ProductCategoryLevel[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UpSalesMenuItems implements IUpSalesMenuItems {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    detailsMenuItemId: number;
    detailsMenuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IUpSalesMenuItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.detailsMenuItemId = data["detailsMenuItemId"];
            this.detailsMenuItem = data["detailsMenuItem"] ? MenuItem.fromJS(data["detailsMenuItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpSalesMenuItems {
        let result = new UpSalesMenuItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["detailsMenuItemId"] = this.detailsMenuItemId;
        data["detailsMenuItem"] = this.detailsMenuItem ? this.detailsMenuItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpSalesMenuItems {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    detailsMenuItemId: number;
    detailsMenuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemTranslation implements IMenuItemTranslation {
    name: string;
    menuItem: MenuItem;
    menuItemId: number;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.menuItemId = data["menuItemId"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemTranslation {
        let result = new MenuItemTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["menuItemId"] = this.menuItemId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemTranslation {
    name: string;
    menuItem: MenuItem;
    menuItemId: number;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemPriceList implements IMenuItemPriceList {
    tenantId: number;
    menuItem: MenuItem;
    priceList: PriceList;
    menuItemId: number;
    priceListId: number;
    price: number;
    unitOfMeasure: UnitOfMeasure;
    unitOfMeasureId: number;
    menuItemConfigId: number;
    factor: number;
    menuItemConfig: MenuItemConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemPriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.priceList = data["priceList"] ? PriceList.fromJS(data["priceList"]) : <any>undefined;
            this.menuItemId = data["menuItemId"];
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.menuItemConfigId = data["menuItemConfigId"];
            this.factor = data["factor"];
            this.menuItemConfig = data["menuItemConfig"] ? MenuItemConfig.fromJS(data["menuItemConfig"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemPriceList {
        let result = new MenuItemPriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["menuItemId"] = this.menuItemId;
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["menuItemConfigId"] = this.menuItemConfigId;
        data["factor"] = this.factor;
        data["menuItemConfig"] = this.menuItemConfig ? this.menuItemConfig.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemPriceList {
    tenantId: number;
    menuItem: MenuItem;
    priceList: PriceList;
    menuItemId: number;
    priceListId: number;
    price: number;
    unitOfMeasure: UnitOfMeasure;
    unitOfMeasureId: number;
    menuItemConfigId: number;
    factor: number;
    menuItemConfig: MenuItemConfig;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemTax implements IMenuItemTax {
    menuItemId: number;
    menuItem: MenuItem;
    taxId: number;
    tax: Tax;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemTax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.taxId = data["taxId"];
            this.tax = data["tax"] ? Tax.fromJS(data["tax"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemTax {
        let result = new MenuItemTax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["taxId"] = this.taxId;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemTax {
    menuItemId: number;
    menuItem: MenuItem;
    taxId: number;
    tax: Tax;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemVariant implements IMenuItemVariant {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    variantId: number;
    variant: Variant;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.variantId = data["variantId"];
            this.variant = data["variant"] ? Variant.fromJS(data["variant"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemVariant {
        let result = new MenuItemVariant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["variantId"] = this.variantId;
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemVariant {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    variantId: number;
    variant: Variant;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MenuItemDiscountType implements IMenuItemDiscountType {
    discountTypeId: number;
    discountType: DiscountType;
    menuItemId: number;
    menuItem: MenuItem;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMenuItemDiscountType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountTypeId = data["discountTypeId"];
            this.discountType = data["discountType"] ? DiscountType.fromJS(data["discountType"]) : <any>undefined;
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MenuItemDiscountType {
        let result = new MenuItemDiscountType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountTypeId"] = this.discountTypeId;
        data["discountType"] = this.discountType ? this.discountType.toJSON() : <any>undefined;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMenuItemDiscountType {
    discountTypeId: number;
    discountType: DiscountType;
    menuItemId: number;
    menuItem: MenuItem;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboMealPackageItem implements IComboMealPackageItem {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    quantity: number;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    comboMealPackage: ComboMealPackage;
    menuItem: MenuItem;
    comboMealPackageItemPriceLists: ComboMealPackageItemPriceList[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealPackageItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.comboMealPackageId = data["comboMealPackageId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.comboMealPackage = data["comboMealPackage"] ? ComboMealPackage.fromJS(data["comboMealPackage"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            if (data["comboMealPackageItemPriceLists"] && data["comboMealPackageItemPriceLists"].constructor === Array) {
                this.comboMealPackageItemPriceLists = [];
                for (let item of data["comboMealPackageItemPriceLists"])
                    this.comboMealPackageItemPriceLists.push(ComboMealPackageItemPriceList.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealPackageItem {
        let result = new ComboMealPackageItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["comboMealPackageId"] = this.comboMealPackageId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["comboMealPackage"] = this.comboMealPackage ? this.comboMealPackage.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        if (this.comboMealPackageItemPriceLists && this.comboMealPackageItemPriceLists.constructor === Array) {
            data["comboMealPackageItemPriceLists"] = [];
            for (let item of this.comboMealPackageItemPriceLists)
                data["comboMealPackageItemPriceLists"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealPackageItem {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    quantity: number;
    unitOfMeasureId: number;
    unitOfMeasure: UnitOfMeasure;
    comboMealPackage: ComboMealPackage;
    menuItem: MenuItem;
    comboMealPackageItemPriceLists: ComboMealPackageItemPriceList[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboMealDefinition implements IComboMealDefinition {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    comboMealPackage: ComboMealPackage;
    menuItem: MenuItem;
    order: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.comboMealPackageId = data["comboMealPackageId"];
            this.menuItemId = data["menuItemId"];
            this.comboMealPackage = data["comboMealPackage"] ? ComboMealPackage.fromJS(data["comboMealPackage"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.order = data["order"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealDefinition {
        let result = new ComboMealDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["comboMealPackageId"] = this.comboMealPackageId;
        data["menuItemId"] = this.menuItemId;
        data["comboMealPackage"] = this.comboMealPackage ? this.comboMealPackage.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealDefinition {
    tenantId: number;
    comboMealPackageId: number;
    menuItemId: number;
    comboMealPackage: ComboMealPackage;
    menuItem: MenuItem;
    order: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTransactionDetailsComboMealsItem implements ISaleTransactionDetailsComboMealsItem {
    tenantId: number;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    saleTransactionDetail: SaleTransactionDetail;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransactionDetailsComboMealsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.saleTransactionDetail = data["saleTransactionDetail"] ? SaleTransactionDetail.fromJS(data["saleTransactionDetail"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionDetailsComboMealsItem {
        let result = new SaleTransactionDetailsComboMealsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["saleTransactionDetail"] = this.saleTransactionDetail ? this.saleTransactionDetail.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionDetailsComboMealsItem {
    tenantId: number;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    saleTransactionDetail: SaleTransactionDetail;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SaleNotificationDetailsComboMealsItem implements ISaleNotificationDetailsComboMealsItem {
    tenantId: number;
    quantity: number;
    price: number;
    originalQuantity: number;
    menuItemId: number;
    menuItem: MenuItem;
    saleNotificationDetailId: string;
    saleNotificationDetail: SaleNotificationDetail;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleNotificationDetailsComboMealsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.originalQuantity = data["originalQuantity"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
            this.saleNotificationDetail = data["saleNotificationDetail"] ? SaleNotificationDetail.fromJS(data["saleNotificationDetail"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleNotificationDetailsComboMealsItem {
        let result = new SaleNotificationDetailsComboMealsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["originalQuantity"] = this.originalQuantity;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        data["saleNotificationDetail"] = this.saleNotificationDetail ? this.saleNotificationDetail.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleNotificationDetailsComboMealsItem {
    tenantId: number;
    quantity: number;
    price: number;
    originalQuantity: number;
    menuItemId: number;
    menuItem: MenuItem;
    saleNotificationDetailId: string;
    saleNotificationDetail: SaleNotificationDetail;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class PromotionFBItemExcludedMenuItem implements IPromotionFBItemExcludedMenuItem {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    promotionFBItemId: number;
    promotionFBItem: PromotionFBItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBItemExcludedMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.promotionFBItemId = data["promotionFBItemId"];
            this.promotionFBItem = data["promotionFBItem"] ? PromotionFBItem.fromJS(data["promotionFBItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBItemExcludedMenuItem {
        let result = new PromotionFBItemExcludedMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["promotionFBItemId"] = this.promotionFBItemId;
        data["promotionFBItem"] = this.promotionFBItem ? this.promotionFBItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBItemExcludedMenuItem {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    promotionFBItemId: number;
    promotionFBItem: PromotionFBItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionDetailsFBExcludedMenuItem implements IPromotionDetailsFBExcludedMenuItem {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    promotionDetailsFBId: number;
    promotionDetailsFB: PromotionDetailsFB;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionDetailsFBExcludedMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.promotionDetailsFBId = data["promotionDetailsFBId"];
            this.promotionDetailsFB = data["promotionDetailsFB"] ? PromotionDetailsFB.fromJS(data["promotionDetailsFB"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionDetailsFBExcludedMenuItem {
        let result = new PromotionDetailsFBExcludedMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["promotionDetailsFBId"] = this.promotionDetailsFBId;
        data["promotionDetailsFB"] = this.promotionDetailsFB ? this.promotionDetailsFB.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionDetailsFBExcludedMenuItem {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    promotionDetailsFBId: number;
    promotionDetailsFB: PromotionDetailsFB;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CornerTranslation implements ICornerTranslation {
    name: string;
    cornerId: number;
    corner: Corner;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICornerTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.cornerId = data["cornerId"];
            this.corner = data["corner"] ? Corner.fromJS(data["corner"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CornerTranslation {
        let result = new CornerTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cornerId"] = this.cornerId;
        data["corner"] = this.corner ? this.corner.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICornerTranslation {
    name: string;
    cornerId: number;
    corner: Corner;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CornerStoreDevice implements ICornerStoreDevice {
    tenantId: number;
    deviceId: number;
    cornerId: number;
    storeId: number;
    device: Device;
    corner: Corner;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICornerStoreDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.deviceId = data["deviceId"];
            this.cornerId = data["cornerId"];
            this.storeId = data["storeId"];
            this.device = data["device"] ? Device.fromJS(data["device"]) : <any>undefined;
            this.corner = data["corner"] ? Corner.fromJS(data["corner"]) : <any>undefined;
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CornerStoreDevice {
        let result = new CornerStoreDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["deviceId"] = this.deviceId;
        data["cornerId"] = this.cornerId;
        data["storeId"] = this.storeId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["corner"] = this.corner ? this.corner.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICornerStoreDevice {
    tenantId: number;
    deviceId: number;
    cornerId: number;
    storeId: number;
    device: Device;
    corner: Corner;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Variant implements IVariant {
    code: string;
    category: ProductCategory;
    categoryId: number;
    tenantId: number;
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isModifier: boolean;
    isActive: boolean;
    pricingRule: VariantPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    imageId: string;
    translations: VariantTranslation[];
    values: VariantValue[];
    menuItemVariants: MenuItemVariant[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.category = data["category"] ? ProductCategory.fromJS(data["category"]) : <any>undefined;
            this.categoryId = data["categoryId"];
            this.tenantId = data["tenantId"];
            this.isSingle = data["isSingle"];
            this.isRequired = data["isRequired"];
            this.minSelections = data["minSelections"];
            this.maxSelections = data["maxSelections"];
            this.allowMultipleQuantitiesPerModifier = data["allowMultipleQuantitiesPerModifier"];
            this.maxQtyPerModifier = data["maxQtyPerModifier"];
            this.isAdd = data["isAdd"];
            this.isModifier = data["isModifier"];
            this.isActive = data["isActive"];
            this.pricingRule = data["pricingRule"];
            this.pricingRuleFreeItemsCount = data["pricingRuleFreeItemsCount"];
            this.periorty = data["periorty"];
            this.imageId = data["imageId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(VariantTranslation.fromJS(item));
            }
            if (data["values"] && data["values"].constructor === Array) {
                this.values = [];
                for (let item of data["values"])
                    this.values.push(VariantValue.fromJS(item));
            }
            if (data["menuItemVariants"] && data["menuItemVariants"].constructor === Array) {
                this.menuItemVariants = [];
                for (let item of data["menuItemVariants"])
                    this.menuItemVariants.push(MenuItemVariant.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Variant {
        let result = new Variant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["categoryId"] = this.categoryId;
        data["tenantId"] = this.tenantId;
        data["isSingle"] = this.isSingle;
        data["isRequired"] = this.isRequired;
        data["minSelections"] = this.minSelections;
        data["maxSelections"] = this.maxSelections;
        data["allowMultipleQuantitiesPerModifier"] = this.allowMultipleQuantitiesPerModifier;
        data["maxQtyPerModifier"] = this.maxQtyPerModifier;
        data["isAdd"] = this.isAdd;
        data["isModifier"] = this.isModifier;
        data["isActive"] = this.isActive;
        data["pricingRule"] = this.pricingRule;
        data["pricingRuleFreeItemsCount"] = this.pricingRuleFreeItemsCount;
        data["periorty"] = this.periorty;
        data["imageId"] = this.imageId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.values && this.values.constructor === Array) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (this.menuItemVariants && this.menuItemVariants.constructor === Array) {
            data["menuItemVariants"] = [];
            for (let item of this.menuItemVariants)
                data["menuItemVariants"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariant {
    code: string;
    category: ProductCategory;
    categoryId: number;
    tenantId: number;
    isSingle: boolean;
    isRequired: boolean;
    minSelections: number;
    maxSelections: number;
    allowMultipleQuantitiesPerModifier: boolean;
    maxQtyPerModifier: number;
    isAdd: boolean;
    isModifier: boolean;
    isActive: boolean;
    pricingRule: VariantPricingRule;
    pricingRuleFreeItemsCount: number;
    periorty: number;
    imageId: string;
    translations: VariantTranslation[];
    values: VariantValue[];
    menuItemVariants: MenuItemVariant[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategoryComboGroup implements IProductCategoryComboGroup {
    tenantId: number;
    productCategory: ProductCategory;
    comboGroup: ComboGroup;
    comboGroupId: number;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryComboGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.productCategory = data["productCategory"] ? ProductCategory.fromJS(data["productCategory"]) : <any>undefined;
            this.comboGroup = data["comboGroup"] ? ComboGroup.fromJS(data["comboGroup"]) : <any>undefined;
            this.comboGroupId = data["comboGroupId"];
            this.productCategoryId = data["productCategoryId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryComboGroup {
        let result = new ProductCategoryComboGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["comboGroup"] = this.comboGroup ? this.comboGroup.toJSON() : <any>undefined;
        data["comboGroupId"] = this.comboGroupId;
        data["productCategoryId"] = this.productCategoryId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryComboGroup {
    tenantId: number;
    productCategory: ProductCategory;
    comboGroup: ComboGroup;
    comboGroupId: number;
    productCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategoryTranslation implements IProductCategoryTranslation {
    productCategoryId: number;
    productCategory: ProductCategory;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCategoryId = data["productCategoryId"];
            this.productCategory = data["productCategory"] ? ProductCategory.fromJS(data["productCategory"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryTranslation {
        let result = new ProductCategoryTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategoryId"] = this.productCategoryId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryTranslation {
    productCategoryId: number;
    productCategory: ProductCategory;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ProductCategoryLevel implements IProductCategoryLevel {
    tenantId: number;
    levelId: number;
    productCategoryId: number;
    level: Level;
    category: ProductCategory;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IProductCategoryLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.levelId = data["levelId"];
            this.productCategoryId = data["productCategoryId"];
            this.level = data["level"] ? Level.fromJS(data["level"]) : <any>undefined;
            this.category = data["category"] ? ProductCategory.fromJS(data["category"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryLevel {
        let result = new ProductCategoryLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["levelId"] = this.levelId;
        data["productCategoryId"] = this.productCategoryId;
        data["level"] = this.level ? this.level.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProductCategoryLevel {
    tenantId: number;
    levelId: number;
    productCategoryId: number;
    level: Level;
    category: ProductCategory;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreProductCategoryConfig implements IStoreProductCategoryConfig {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    productCategoryId: number;
    productCategory: ProductCategory;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreProductCategoryConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.isHidden = data["isHidden"];
            this.startUsageDate = data["startUsageDate"] ? moment(data["startUsageDate"].toString()) : <any>undefined;
            this.endUsageDate = data["endUsageDate"] ? moment(data["endUsageDate"].toString()) : <any>undefined;
            this.effectiveDate = data["effectiveDate"] ? moment(data["effectiveDate"].toString()) : <any>undefined;
            this.productCategoryId = data["productCategoryId"];
            this.productCategory = data["productCategory"] ? ProductCategory.fromJS(data["productCategory"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreProductCategoryConfig {
        let result = new StoreProductCategoryConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isHidden"] = this.isHidden;
        data["startUsageDate"] = this.startUsageDate ? this.startUsageDate.toISOString() : <any>undefined;
        data["endUsageDate"] = this.endUsageDate ? this.endUsageDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreProductCategoryConfig {
    tenantId: number;
    isHidden: boolean;
    startUsageDate: moment.Moment;
    endUsageDate: moment.Moment;
    effectiveDate: moment.Moment;
    productCategoryId: number;
    productCategory: ProductCategory;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeliveryZoneTranslation implements IDeliveryZoneTranslation {
    name: string;
    deliveryZone: DeliveryZone;
    deliveryZoneID: number;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryZoneTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.deliveryZone = data["deliveryZone"] ? DeliveryZone.fromJS(data["deliveryZone"]) : <any>undefined;
            this.deliveryZoneID = data["deliveryZoneID"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryZoneTranslation {
        let result = new DeliveryZoneTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["deliveryZone"] = this.deliveryZone ? this.deliveryZone.toJSON() : <any>undefined;
        data["deliveryZoneID"] = this.deliveryZoneID;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryZoneTranslation {
    name: string;
    deliveryZone: DeliveryZone;
    deliveryZoneID: number;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeliveryStreet implements IDeliveryStreet {
    tenantId: number;
    translations: DeliveryStreetTranslation[];
    customerAddress: CustomerAddress[];
    deliveryZone: DeliveryZone;
    deliveryZoneId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryStreet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryStreetTranslation.fromJS(item));
            }
            if (data["customerAddress"] && data["customerAddress"].constructor === Array) {
                this.customerAddress = [];
                for (let item of data["customerAddress"])
                    this.customerAddress.push(CustomerAddress.fromJS(item));
            }
            this.deliveryZone = data["deliveryZone"] ? DeliveryZone.fromJS(data["deliveryZone"]) : <any>undefined;
            this.deliveryZoneId = data["deliveryZoneId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryStreet {
        let result = new DeliveryStreet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.customerAddress && this.customerAddress.constructor === Array) {
            data["customerAddress"] = [];
            for (let item of this.customerAddress)
                data["customerAddress"].push(item.toJSON());
        }
        data["deliveryZone"] = this.deliveryZone ? this.deliveryZone.toJSON() : <any>undefined;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryStreet {
    tenantId: number;
    translations: DeliveryStreetTranslation[];
    customerAddress: CustomerAddress[];
    deliveryZone: DeliveryZone;
    deliveryZoneId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CustomerAddress implements ICustomerAddress {
    address: string;
    link: string;
    deliveryZoneId: number;
    deliveryStreetId: number;
    city: string;
    tenantId: number;
    customerId: string;
    customer: Customer;
    deliveryZone: DeliveryZone;
    deliveryStreet: DeliveryStreet;
    isSelected: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICustomerAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.link = data["link"];
            this.deliveryZoneId = data["deliveryZoneId"];
            this.deliveryStreetId = data["deliveryStreetId"];
            this.city = data["city"];
            this.tenantId = data["tenantId"];
            this.customerId = data["customerId"];
            this.customer = data["customer"] ? Customer.fromJS(data["customer"]) : <any>undefined;
            this.deliveryZone = data["deliveryZone"] ? DeliveryZone.fromJS(data["deliveryZone"]) : <any>undefined;
            this.deliveryStreet = data["deliveryStreet"] ? DeliveryStreet.fromJS(data["deliveryStreet"]) : <any>undefined;
            this.isSelected = data["isSelected"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomerAddress {
        let result = new CustomerAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["link"] = this.link;
        data["deliveryZoneId"] = this.deliveryZoneId;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["city"] = this.city;
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["deliveryZone"] = this.deliveryZone ? this.deliveryZone.toJSON() : <any>undefined;
        data["deliveryStreet"] = this.deliveryStreet ? this.deliveryStreet.toJSON() : <any>undefined;
        data["isSelected"] = this.isSelected;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomerAddress {
    address: string;
    link: string;
    deliveryZoneId: number;
    deliveryStreetId: number;
    city: string;
    tenantId: number;
    customerId: string;
    customer: Customer;
    deliveryZone: DeliveryZone;
    deliveryStreet: DeliveryStreet;
    isSelected: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Account implements IAccount {
    accountName: string;
    tenantId: number;
    customers: Customer[];
    pointTransactions: PointTransaction[];
    schemas: SchemaAccount[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountName = data["accountName"];
            this.tenantId = data["tenantId"];
            if (data["customers"] && data["customers"].constructor === Array) {
                this.customers = [];
                for (let item of data["customers"])
                    this.customers.push(Customer.fromJS(item));
            }
            if (data["pointTransactions"] && data["pointTransactions"].constructor === Array) {
                this.pointTransactions = [];
                for (let item of data["pointTransactions"])
                    this.pointTransactions.push(PointTransaction.fromJS(item));
            }
            if (data["schemas"] && data["schemas"].constructor === Array) {
                this.schemas = [];
                for (let item of data["schemas"])
                    this.schemas.push(SchemaAccount.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Account {
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["tenantId"] = this.tenantId;
        if (this.customers && this.customers.constructor === Array) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (this.pointTransactions && this.pointTransactions.constructor === Array) {
            data["pointTransactions"] = [];
            for (let item of this.pointTransactions)
                data["pointTransactions"].push(item.toJSON());
        }
        if (this.schemas && this.schemas.constructor === Array) {
            data["schemas"] = [];
            for (let item of this.schemas)
                data["schemas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAccount {
    accountName: string;
    tenantId: number;
    customers: Customer[];
    pointTransactions: PointTransaction[];
    schemas: SchemaAccount[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SupervisorShift implements ISupervisorShift {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: SupervisorShiftStatus;
    userId: number;
    user: User;
    storeShiftId: number;
    storeShift: StoreShift;
    storeId: number;
    store: Store;
    tenantId: number;
    supervisorShiftPaymentTransactionValues: SupervisorShiftPaymentTransactionValues[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISupervisorShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startedOn = data["startedOn"] ? moment(data["startedOn"].toString()) : <any>undefined;
            this.endedOn = data["endedOn"] ? moment(data["endedOn"].toString()) : <any>undefined;
            this.startedBy = data["startedBy"];
            this.endedBy = data["endedBy"];
            this.status = data["status"];
            this.userId = data["userId"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            this.storeShiftId = data["storeShiftId"];
            this.storeShift = data["storeShift"] ? StoreShift.fromJS(data["storeShift"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            if (data["supervisorShiftPaymentTransactionValues"] && data["supervisorShiftPaymentTransactionValues"].constructor === Array) {
                this.supervisorShiftPaymentTransactionValues = [];
                for (let item of data["supervisorShiftPaymentTransactionValues"])
                    this.supervisorShiftPaymentTransactionValues.push(SupervisorShiftPaymentTransactionValues.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SupervisorShift {
        let result = new SupervisorShift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["endedBy"] = this.endedBy;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["storeShiftId"] = this.storeShiftId;
        data["storeShift"] = this.storeShift ? this.storeShift.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        if (this.supervisorShiftPaymentTransactionValues && this.supervisorShiftPaymentTransactionValues.constructor === Array) {
            data["supervisorShiftPaymentTransactionValues"] = [];
            for (let item of this.supervisorShiftPaymentTransactionValues)
                data["supervisorShiftPaymentTransactionValues"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISupervisorShift {
    startedOn: moment.Moment;
    endedOn: moment.Moment;
    startedBy: number;
    endedBy: number;
    status: SupervisorShiftStatus;
    userId: number;
    user: User;
    storeShiftId: number;
    storeShift: StoreShift;
    storeId: number;
    store: Store;
    tenantId: number;
    supervisorShiftPaymentTransactionValues: SupervisorShiftPaymentTransactionValues[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CashierShiftPaymentTransactionValues implements ICashierShiftPaymentTransactionValues {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeId: number;
    tenderType: TenderType;
    cashierTransactionsValue: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierShiftId: number;
    cashierShift: CashierShift;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ICashierShiftPaymentTransactionValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.currencyId = data["currencyId"];
            this.currency = data["currency"] ? Currency.fromJS(data["currency"]) : <any>undefined;
            this.tenderTypeId = data["tenderTypeId"];
            this.tenderType = data["tenderType"] ? TenderType.fromJS(data["tenderType"]) : <any>undefined;
            this.cashierTransactionsValue = data["cashierTransactionsValue"];
            this.actualTransactionsValue = data["actualTransactionsValue"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.cashierShiftId = data["cashierShiftId"];
            this.cashierShift = data["cashierShift"] ? CashierShift.fromJS(data["cashierShift"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CashierShiftPaymentTransactionValues {
        let result = new CashierShiftPaymentTransactionValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["tenderTypeId"] = this.tenderTypeId;
        data["tenderType"] = this.tenderType ? this.tenderType.toJSON() : <any>undefined;
        data["cashierTransactionsValue"] = this.cashierTransactionsValue;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["cashierShiftId"] = this.cashierShiftId;
        data["cashierShift"] = this.cashierShift ? this.cashierShift.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICashierShiftPaymentTransactionValues {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeId: number;
    tenderType: TenderType;
    cashierTransactionsValue: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierShiftId: number;
    cashierShift: CashierShift;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class MasterCashInOut implements IMasterCashInOut {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeMasterId: number;
    tenderTypeMaster: TenderTypeMaster;
    cashierTransactionsValue: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierShiftId: number;
    cashierShift: CashierShift;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: IMasterCashInOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.currencyId = data["currencyId"];
            this.currency = data["currency"] ? Currency.fromJS(data["currency"]) : <any>undefined;
            this.tenderTypeMasterId = data["tenderTypeMasterId"];
            this.tenderTypeMaster = data["tenderTypeMaster"] ? TenderTypeMaster.fromJS(data["tenderTypeMaster"]) : <any>undefined;
            this.cashierTransactionsValue = data["cashierTransactionsValue"];
            this.actualTransactionsValue = data["actualTransactionsValue"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.cashierShiftId = data["cashierShiftId"];
            this.cashierShift = data["cashierShift"] ? CashierShift.fromJS(data["cashierShift"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MasterCashInOut {
        let result = new MasterCashInOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["tenderTypeMasterId"] = this.tenderTypeMasterId;
        data["tenderTypeMaster"] = this.tenderTypeMaster ? this.tenderTypeMaster.toJSON() : <any>undefined;
        data["cashierTransactionsValue"] = this.cashierTransactionsValue;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["cashierShiftId"] = this.cashierShiftId;
        data["cashierShift"] = this.cashierShift ? this.cashierShift.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMasterCashInOut {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeMasterId: number;
    tenderTypeMaster: TenderTypeMaster;
    cashierTransactionsValue: number;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    cashierShiftId: number;
    cashierShift: CashierShift;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class PromotionFB implements IPromotionFB {
    tenantId: number;
    promotionType: PromotionFBPromotionType;
    templateType: PromotionFBTemplateType;
    name: string;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionFBValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    validForDays: number;
    includeVat: boolean;
    promotionFBStores: PromotionFBStore[];
    promotioncConditions: PromotionDetailsFB[];
    promotioncAdditionalFreeItems: PromotionFBAdditionalFreeItem[];
    menuItems: PromotionFBItem[];
    promotionCodes: PromotionCodeFB[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.promotionType = data["promotionType"];
            this.templateType = data["templateType"];
            this.name = data["name"];
            this.highestValue = data["highestValue"];
            this.lowestValue = data["lowestValue"];
            this.value = data["value"];
            this.valueType = data["valueType"];
            this.isTotalInvoice = data["isTotalInvoice"];
            this.isNextInvoice = data["isNextInvoice"];
            this.invoiceAmount = data["invoiceAmount"];
            this.validForDays = data["validForDays"];
            this.includeVat = data["includeVat"];
            if (data["promotionFBStores"] && data["promotionFBStores"].constructor === Array) {
                this.promotionFBStores = [];
                for (let item of data["promotionFBStores"])
                    this.promotionFBStores.push(PromotionFBStore.fromJS(item));
            }
            if (data["promotioncConditions"] && data["promotioncConditions"].constructor === Array) {
                this.promotioncConditions = [];
                for (let item of data["promotioncConditions"])
                    this.promotioncConditions.push(PromotionDetailsFB.fromJS(item));
            }
            if (data["promotioncAdditionalFreeItems"] && data["promotioncAdditionalFreeItems"].constructor === Array) {
                this.promotioncAdditionalFreeItems = [];
                for (let item of data["promotioncAdditionalFreeItems"])
                    this.promotioncAdditionalFreeItems.push(PromotionFBAdditionalFreeItem.fromJS(item));
            }
            if (data["menuItems"] && data["menuItems"].constructor === Array) {
                this.menuItems = [];
                for (let item of data["menuItems"])
                    this.menuItems.push(PromotionFBItem.fromJS(item));
            }
            if (data["promotionCodes"] && data["promotionCodes"].constructor === Array) {
                this.promotionCodes = [];
                for (let item of data["promotionCodes"])
                    this.promotionCodes.push(PromotionCodeFB.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFB {
        let result = new PromotionFB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["promotionType"] = this.promotionType;
        data["templateType"] = this.templateType;
        data["name"] = this.name;
        data["highestValue"] = this.highestValue;
        data["lowestValue"] = this.lowestValue;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["isTotalInvoice"] = this.isTotalInvoice;
        data["isNextInvoice"] = this.isNextInvoice;
        data["invoiceAmount"] = this.invoiceAmount;
        data["validForDays"] = this.validForDays;
        data["includeVat"] = this.includeVat;
        if (this.promotionFBStores && this.promotionFBStores.constructor === Array) {
            data["promotionFBStores"] = [];
            for (let item of this.promotionFBStores)
                data["promotionFBStores"].push(item.toJSON());
        }
        if (this.promotioncConditions && this.promotioncConditions.constructor === Array) {
            data["promotioncConditions"] = [];
            for (let item of this.promotioncConditions)
                data["promotioncConditions"].push(item.toJSON());
        }
        if (this.promotioncAdditionalFreeItems && this.promotioncAdditionalFreeItems.constructor === Array) {
            data["promotioncAdditionalFreeItems"] = [];
            for (let item of this.promotioncAdditionalFreeItems)
                data["promotioncAdditionalFreeItems"].push(item.toJSON());
        }
        if (this.menuItems && this.menuItems.constructor === Array) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        if (this.promotionCodes && this.promotionCodes.constructor === Array) {
            data["promotionCodes"] = [];
            for (let item of this.promotionCodes)
                data["promotionCodes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFB {
    tenantId: number;
    promotionType: PromotionFBPromotionType;
    templateType: PromotionFBTemplateType;
    name: string;
    highestValue: number;
    lowestValue: number;
    value: number;
    valueType: PromotionFBValueType;
    isTotalInvoice: boolean;
    isNextInvoice: boolean;
    invoiceAmount: number;
    validForDays: number;
    includeVat: boolean;
    promotionFBStores: PromotionFBStore[];
    promotioncConditions: PromotionDetailsFB[];
    promotioncAdditionalFreeItems: PromotionFBAdditionalFreeItem[];
    menuItems: PromotionFBItem[];
    promotionCodes: PromotionCodeFB[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionCodeSalestype implements IPromotionCodeSalestype {
    tenantId: number;
    promotionCodeFBId: number;
    promotionCodeFB: PromotionCodeFB;
    saleTypeId: number;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionCodeSalestype) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.promotionCodeFBId = data["promotionCodeFBId"];
            this.promotionCodeFB = data["promotionCodeFB"] ? PromotionCodeFB.fromJS(data["promotionCodeFB"]) : <any>undefined;
            this.saleTypeId = data["saleTypeId"];
            this.saleType = data["saleType"] ? SaleType.fromJS(data["saleType"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionCodeSalestype {
        let result = new PromotionCodeSalestype();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["promotionCodeFBId"] = this.promotionCodeFBId;
        data["promotionCodeFB"] = this.promotionCodeFB ? this.promotionCodeFB.toJSON() : <any>undefined;
        data["saleTypeId"] = this.saleTypeId;
        data["saleType"] = this.saleType ? this.saleType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionCodeSalestype {
    tenantId: number;
    promotionCodeFBId: number;
    promotionCodeFB: PromotionCodeFB;
    saleTypeId: number;
    saleType: SaleType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Offer implements IOffer {
    from: moment.Moment;
    to: moment.Moment;
    discountPercent: number;
    discountAmmount: number;
    tenantId: number;
    isExclude: boolean;
    isInclude: boolean;
    offerType: OfferType2;
    itemType: OfferItemType;
    itemCode: string;
    offerDetails: OfferDetail[];
    offerExcludes: OfferExclude[];
    offerIncludes: OfferInclude[];
    itemId: number;
    numberOfItems: number;
    numberOfFreeItems: number;
    value: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.discountPercent = data["discountPercent"];
            this.discountAmmount = data["discountAmmount"];
            this.tenantId = data["tenantId"];
            this.isExclude = data["isExclude"];
            this.isInclude = data["isInclude"];
            this.offerType = data["offerType"];
            this.itemType = data["itemType"];
            this.itemCode = data["itemCode"];
            if (data["offerDetails"] && data["offerDetails"].constructor === Array) {
                this.offerDetails = [];
                for (let item of data["offerDetails"])
                    this.offerDetails.push(OfferDetail.fromJS(item));
            }
            if (data["offerExcludes"] && data["offerExcludes"].constructor === Array) {
                this.offerExcludes = [];
                for (let item of data["offerExcludes"])
                    this.offerExcludes.push(OfferExclude.fromJS(item));
            }
            if (data["offerIncludes"] && data["offerIncludes"].constructor === Array) {
                this.offerIncludes = [];
                for (let item of data["offerIncludes"])
                    this.offerIncludes.push(OfferInclude.fromJS(item));
            }
            this.itemId = data["itemId"];
            this.numberOfItems = data["numberOfItems"];
            this.numberOfFreeItems = data["numberOfFreeItems"];
            this.value = data["value"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Offer {
        let result = new Offer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["discountPercent"] = this.discountPercent;
        data["discountAmmount"] = this.discountAmmount;
        data["tenantId"] = this.tenantId;
        data["isExclude"] = this.isExclude;
        data["isInclude"] = this.isInclude;
        data["offerType"] = this.offerType;
        data["itemType"] = this.itemType;
        data["itemCode"] = this.itemCode;
        if (this.offerDetails && this.offerDetails.constructor === Array) {
            data["offerDetails"] = [];
            for (let item of this.offerDetails)
                data["offerDetails"].push(item.toJSON());
        }
        if (this.offerExcludes && this.offerExcludes.constructor === Array) {
            data["offerExcludes"] = [];
            for (let item of this.offerExcludes)
                data["offerExcludes"].push(item.toJSON());
        }
        if (this.offerIncludes && this.offerIncludes.constructor === Array) {
            data["offerIncludes"] = [];
            for (let item of this.offerIncludes)
                data["offerIncludes"].push(item.toJSON());
        }
        data["itemId"] = this.itemId;
        data["numberOfItems"] = this.numberOfItems;
        data["numberOfFreeItems"] = this.numberOfFreeItems;
        data["value"] = this.value;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOffer {
    from: moment.Moment;
    to: moment.Moment;
    discountPercent: number;
    discountAmmount: number;
    tenantId: number;
    isExclude: boolean;
    isInclude: boolean;
    offerType: OfferType2;
    itemType: OfferItemType;
    itemCode: string;
    offerDetails: OfferDetail[];
    offerExcludes: OfferExclude[];
    offerIncludes: OfferInclude[];
    itemId: number;
    numberOfItems: number;
    numberOfFreeItems: number;
    value: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTransactionDetailSerial implements ISaleTransactionDetailSerial {
    saleTransactionDetailId: string;
    serialId: number;
    serial: ProductSerials;
    saleTransactionDetail: SaleTransactionDetail;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransactionDetailSerial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.serialId = data["serialId"];
            this.serial = data["serial"] ? ProductSerials.fromJS(data["serial"]) : <any>undefined;
            this.saleTransactionDetail = data["saleTransactionDetail"] ? SaleTransactionDetail.fromJS(data["saleTransactionDetail"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionDetailSerial {
        let result = new SaleTransactionDetailSerial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["serialId"] = this.serialId;
        data["serial"] = this.serial ? this.serial.toJSON() : <any>undefined;
        data["saleTransactionDetail"] = this.saleTransactionDetail ? this.saleTransactionDetail.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionDetailSerial {
    saleTransactionDetailId: string;
    serialId: number;
    serial: ProductSerials;
    saleTransactionDetail: SaleTransactionDetail;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SaleTransactionDetailVarient implements ISaleTransactionDetailVarient {
    tenantId: number;
    saleTransactionDetailId: string;
    variantId: number;
    variantValueId: number;
    saleTransactionDetail: SaleTransactionDetail;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleTransactionDetailVarient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.variantId = data["variantId"];
            this.variantValueId = data["variantValueId"];
            this.saleTransactionDetail = data["saleTransactionDetail"] ? SaleTransactionDetail.fromJS(data["saleTransactionDetail"]) : <any>undefined;
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.quantity = data["quantity"];
            this.freeQty = data["freeQty"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionDetailVarient {
        let result = new SaleTransactionDetailVarient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["variantId"] = this.variantId;
        data["variantValueId"] = this.variantValueId;
        data["saleTransactionDetail"] = this.saleTransactionDetail ? this.saleTransactionDetail.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["quantity"] = this.quantity;
        data["freeQty"] = this.freeQty;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionDetailVarient {
    tenantId: number;
    saleTransactionDetailId: string;
    variantId: number;
    variantValueId: number;
    saleTransactionDetail: SaleTransactionDetail;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleTransactionsDetialsPromotionItem implements ISaleTransactionsDetialsPromotionItem {
    tenantId: number;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
    saleTransactionDetail: SaleTransactionDetail;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleTransactionsDetialsPromotionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleTransactionDetailId = data["saleTransactionDetailId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludeVat = data["priceIncludeVat"];
            this.saleTransactionDetail = data["saleTransactionDetail"] ? SaleTransactionDetail.fromJS(data["saleTransactionDetail"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleTransactionsDetialsPromotionItem {
        let result = new SaleTransactionsDetialsPromotionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleTransactionDetailId"] = this.saleTransactionDetailId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludeVat"] = this.priceIncludeVat;
        data["saleTransactionDetail"] = this.saleTransactionDetail ? this.saleTransactionDetail.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleTransactionsDetialsPromotionItem {
    tenantId: number;
    saleTransactionDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
    saleTransactionDetail: SaleTransactionDetail;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class TenderType implements ITenderType {
    deliveryId: number;
    masterId: number;
    master: TenderTypeMaster;
    tenantId: number;
    preventCashRefund: boolean;
    isSystemDefined: boolean;
    isLinkedWithPOSMachine: boolean;
    posMachine: TenderTypePosMachine;
    code: string;
    translations: TenderTypeTranslation[];
    salepaymentTransactions: SalepaymentTransactions[];
    tenderTypeSaleTypes: TenderTypeSaleType[];
    srotTenderTypeConfigs: StoreTenderTypeConfig[];
    delivery: Delivery;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveryId = data["deliveryId"];
            this.masterId = data["masterId"];
            this.master = data["master"] ? TenderTypeMaster.fromJS(data["master"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.preventCashRefund = data["preventCashRefund"];
            this.isSystemDefined = data["isSystemDefined"];
            this.isLinkedWithPOSMachine = data["isLinkedWithPOSMachine"];
            this.posMachine = data["posMachine"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeTranslation.fromJS(item));
            }
            if (data["salepaymentTransactions"] && data["salepaymentTransactions"].constructor === Array) {
                this.salepaymentTransactions = [];
                for (let item of data["salepaymentTransactions"])
                    this.salepaymentTransactions.push(SalepaymentTransactions.fromJS(item));
            }
            if (data["tenderTypeSaleTypes"] && data["tenderTypeSaleTypes"].constructor === Array) {
                this.tenderTypeSaleTypes = [];
                for (let item of data["tenderTypeSaleTypes"])
                    this.tenderTypeSaleTypes.push(TenderTypeSaleType.fromJS(item));
            }
            if (data["srotTenderTypeConfigs"] && data["srotTenderTypeConfigs"].constructor === Array) {
                this.srotTenderTypeConfigs = [];
                for (let item of data["srotTenderTypeConfigs"])
                    this.srotTenderTypeConfigs.push(StoreTenderTypeConfig.fromJS(item));
            }
            this.delivery = data["delivery"] ? Delivery.fromJS(data["delivery"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderType {
        let result = new TenderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["masterId"] = this.masterId;
        data["master"] = this.master ? this.master.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["preventCashRefund"] = this.preventCashRefund;
        data["isSystemDefined"] = this.isSystemDefined;
        data["isLinkedWithPOSMachine"] = this.isLinkedWithPOSMachine;
        data["posMachine"] = this.posMachine;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.salepaymentTransactions && this.salepaymentTransactions.constructor === Array) {
            data["salepaymentTransactions"] = [];
            for (let item of this.salepaymentTransactions)
                data["salepaymentTransactions"].push(item.toJSON());
        }
        if (this.tenderTypeSaleTypes && this.tenderTypeSaleTypes.constructor === Array) {
            data["tenderTypeSaleTypes"] = [];
            for (let item of this.tenderTypeSaleTypes)
                data["tenderTypeSaleTypes"].push(item.toJSON());
        }
        if (this.srotTenderTypeConfigs && this.srotTenderTypeConfigs.constructor === Array) {
            data["srotTenderTypeConfigs"] = [];
            for (let item of this.srotTenderTypeConfigs)
                data["srotTenderTypeConfigs"].push(item.toJSON());
        }
        data["delivery"] = this.delivery ? this.delivery.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderType {
    deliveryId: number;
    masterId: number;
    master: TenderTypeMaster;
    tenantId: number;
    preventCashRefund: boolean;
    isSystemDefined: boolean;
    isLinkedWithPOSMachine: boolean;
    posMachine: TenderTypePosMachine;
    code: string;
    translations: TenderTypeTranslation[];
    salepaymentTransactions: SalepaymentTransactions[];
    tenderTypeSaleTypes: TenderTypeSaleType[];
    srotTenderTypeConfigs: StoreTenderTypeConfig[];
    delivery: Delivery;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleNotificationDetail implements ISaleNotificationDetail {
    saleNotificationId: string;
    productLotId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    promotion: PromotionCodeFB;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    offerType: number;
    vat: number;
    vatBeforeDiscount: number;
    notes: string;
    comboGroupId: number;
    additionalAllowns: number;
    allownsReason: string;
    menuItemId: number;
    menuItem: MenuItem;
    saleNotification: SaleNotification;
    unitOfMeasure: UnitOfMeasure;
    saleNotificationDetailsComboMealsItems: SaleNotificationDetailsComboMealsItem[];
    saleNotificationDetailVarients: SaleNotificationDetailVarient[];
    saleNotificationReasonDetails: SaleNotificationReasonDetail[];
    saleNotifcationsDetialsPromotionItems: SaleNotifcationsDetialsPromotionItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleNotificationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleNotificationId = data["saleNotificationId"];
            this.productLotId = data["productLotId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.priceIncludeVAT = data["priceIncludeVAT"];
            this.discount = data["discount"];
            this.promotionCode = data["promotionCode"];
            this.promotionType = data["promotionType"];
            this.promotionValue = data["promotionValue"];
            this.promotionAmount = data["promotionAmount"];
            this.promotionCodeId = data["promotionCodeId"];
            this.promotion = data["promotion"] ? PromotionCodeFB.fromJS(data["promotion"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.offerId = data["offerId"];
            this.offerType = data["offerType"];
            this.vat = data["vat"];
            this.vatBeforeDiscount = data["vatBeforeDiscount"];
            this.notes = data["notes"];
            this.comboGroupId = data["comboGroupId"];
            this.additionalAllowns = data["additionalAllowns"];
            this.allownsReason = data["allownsReason"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.saleNotification = data["saleNotification"] ? SaleNotification.fromJS(data["saleNotification"]) : <any>undefined;
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            if (data["saleNotificationDetailsComboMealsItems"] && data["saleNotificationDetailsComboMealsItems"].constructor === Array) {
                this.saleNotificationDetailsComboMealsItems = [];
                for (let item of data["saleNotificationDetailsComboMealsItems"])
                    this.saleNotificationDetailsComboMealsItems.push(SaleNotificationDetailsComboMealsItem.fromJS(item));
            }
            if (data["saleNotificationDetailVarients"] && data["saleNotificationDetailVarients"].constructor === Array) {
                this.saleNotificationDetailVarients = [];
                for (let item of data["saleNotificationDetailVarients"])
                    this.saleNotificationDetailVarients.push(SaleNotificationDetailVarient.fromJS(item));
            }
            if (data["saleNotificationReasonDetails"] && data["saleNotificationReasonDetails"].constructor === Array) {
                this.saleNotificationReasonDetails = [];
                for (let item of data["saleNotificationReasonDetails"])
                    this.saleNotificationReasonDetails.push(SaleNotificationReasonDetail.fromJS(item));
            }
            if (data["saleNotifcationsDetialsPromotionItems"] && data["saleNotifcationsDetialsPromotionItems"].constructor === Array) {
                this.saleNotifcationsDetialsPromotionItems = [];
                for (let item of data["saleNotifcationsDetialsPromotionItems"])
                    this.saleNotifcationsDetialsPromotionItems.push(SaleNotifcationsDetialsPromotionItem.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleNotificationDetail {
        let result = new SaleNotificationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleNotificationId"] = this.saleNotificationId;
        data["productLotId"] = this.productLotId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["priceIncludeVAT"] = this.priceIncludeVAT;
        data["discount"] = this.discount;
        data["promotionCode"] = this.promotionCode;
        data["promotionType"] = this.promotionType;
        data["promotionValue"] = this.promotionValue;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionCodeId"] = this.promotionCodeId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["offerId"] = this.offerId;
        data["offerType"] = this.offerType;
        data["vat"] = this.vat;
        data["vatBeforeDiscount"] = this.vatBeforeDiscount;
        data["notes"] = this.notes;
        data["comboGroupId"] = this.comboGroupId;
        data["additionalAllowns"] = this.additionalAllowns;
        data["allownsReason"] = this.allownsReason;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["saleNotification"] = this.saleNotification ? this.saleNotification.toJSON() : <any>undefined;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        if (this.saleNotificationDetailsComboMealsItems && this.saleNotificationDetailsComboMealsItems.constructor === Array) {
            data["saleNotificationDetailsComboMealsItems"] = [];
            for (let item of this.saleNotificationDetailsComboMealsItems)
                data["saleNotificationDetailsComboMealsItems"].push(item.toJSON());
        }
        if (this.saleNotificationDetailVarients && this.saleNotificationDetailVarients.constructor === Array) {
            data["saleNotificationDetailVarients"] = [];
            for (let item of this.saleNotificationDetailVarients)
                data["saleNotificationDetailVarients"].push(item.toJSON());
        }
        if (this.saleNotificationReasonDetails && this.saleNotificationReasonDetails.constructor === Array) {
            data["saleNotificationReasonDetails"] = [];
            for (let item of this.saleNotificationReasonDetails)
                data["saleNotificationReasonDetails"].push(item.toJSON());
        }
        if (this.saleNotifcationsDetialsPromotionItems && this.saleNotifcationsDetialsPromotionItems.constructor === Array) {
            data["saleNotifcationsDetialsPromotionItems"] = [];
            for (let item of this.saleNotifcationsDetialsPromotionItems)
                data["saleNotifcationsDetialsPromotionItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleNotificationDetail {
    saleNotificationId: string;
    productLotId: number;
    quantity: number;
    price: number;
    priceIncludeVAT: number;
    discount: number;
    promotionCode: string;
    promotionType: number;
    promotionValue: number;
    promotionAmount: number;
    promotionCodeId: number;
    promotion: PromotionCodeFB;
    tenantId: number;
    unitOfMeasureId: number;
    offerId: number;
    offerType: number;
    vat: number;
    vatBeforeDiscount: number;
    notes: string;
    comboGroupId: number;
    additionalAllowns: number;
    allownsReason: string;
    menuItemId: number;
    menuItem: MenuItem;
    saleNotification: SaleNotification;
    unitOfMeasure: UnitOfMeasure;
    saleNotificationDetailsComboMealsItems: SaleNotificationDetailsComboMealsItem[];
    saleNotificationDetailVarients: SaleNotificationDetailVarient[];
    saleNotificationReasonDetails: SaleNotificationReasonDetail[];
    saleNotifcationsDetialsPromotionItems: SaleNotifcationsDetialsPromotionItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class SalePaymentNotification implements ISalePaymentNotification {
    id: string;
    tenantId: number;
    currencyId: number;
    tenderTypeId: number;
    saleNotificationId: string;
    value: number;
    saleNotification: SaleNotification;
    tenderType: TenderType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: ISalePaymentNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.currencyId = data["currencyId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.saleNotificationId = data["saleNotificationId"];
            this.value = data["value"];
            this.saleNotification = data["saleNotification"] ? SaleNotification.fromJS(data["saleNotification"]) : <any>undefined;
            this.tenderType = data["tenderType"] ? TenderType.fromJS(data["tenderType"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): SalePaymentNotification {
        let result = new SalePaymentNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["currencyId"] = this.currencyId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["saleNotificationId"] = this.saleNotificationId;
        data["value"] = this.value;
        data["saleNotification"] = this.saleNotification ? this.saleNotification.toJSON() : <any>undefined;
        data["tenderType"] = this.tenderType ? this.tenderType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface ISalePaymentNotification {
    id: string;
    tenantId: number;
    currencyId: number;
    tenderTypeId: number;
    saleNotificationId: string;
    value: number;
    saleNotification: SaleNotification;
    tenderType: TenderType;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class PrimaryCategoryTranslation implements IPrimaryCategoryTranslation {
    primaryCategoryId: number;
    primaryCategory: PrimaryCategory;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrimaryCategoryTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.primaryCategoryId = data["primaryCategoryId"];
            this.primaryCategory = data["primaryCategory"] ? PrimaryCategory.fromJS(data["primaryCategory"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrimaryCategoryTranslation {
        let result = new PrimaryCategoryTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryCategoryId"] = this.primaryCategoryId;
        data["primaryCategory"] = this.primaryCategory ? this.primaryCategory.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrimaryCategoryTranslation {
    primaryCategoryId: number;
    primaryCategory: PrimaryCategory;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SecondaryCategoryTranslation implements ISecondaryCategoryTranslation {
    secondaryCategoryId: number;
    secondaryCategory: SecondaryCategory;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISecondaryCategoryTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCategoryId = data["secondaryCategoryId"];
            this.secondaryCategory = data["secondaryCategory"] ? SecondaryCategory.fromJS(data["secondaryCategory"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCategoryTranslation {
        let result = new SecondaryCategoryTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCategoryId"] = this.secondaryCategoryId;
        data["secondaryCategory"] = this.secondaryCategory ? this.secondaryCategory.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISecondaryCategoryTranslation {
    secondaryCategoryId: number;
    secondaryCategory: SecondaryCategory;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class GroupTranslation implements IGroupTranslation {
    groupId: number;
    group: Group;
    name: string;
    description: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IGroupTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.groupId = data["groupId"];
            this.group = data["group"] ? Group.fromJS(data["group"]) : <any>undefined;
            this.name = data["name"];
            this.description = data["description"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GroupTranslation {
        let result = new GroupTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGroupTranslation {
    groupId: number;
    group: Group;
    name: string;
    description: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreGroupConfig implements IStoreGroupConfig {
    tenantId: number;
    groupId: number;
    group: Group;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreGroupConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.groupId = data["groupId"];
            this.group = data["group"] ? Group.fromJS(data["group"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreGroupConfig {
        let result = new StoreGroupConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreGroupConfig {
    tenantId: number;
    groupId: number;
    group: Group;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Tax implements ITax {
    code: string;
    value: number;
    isVAT: boolean;
    taxProducts: ProductTax[];
    menuItemTaxes: MenuItemTax[];
    translations: TaxTranslation[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.value = data["value"];
            this.isVAT = data["isVAT"];
            if (data["taxProducts"] && data["taxProducts"].constructor === Array) {
                this.taxProducts = [];
                for (let item of data["taxProducts"])
                    this.taxProducts.push(ProductTax.fromJS(item));
            }
            if (data["menuItemTaxes"] && data["menuItemTaxes"].constructor === Array) {
                this.menuItemTaxes = [];
                for (let item of data["menuItemTaxes"])
                    this.menuItemTaxes.push(MenuItemTax.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TaxTranslation.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Tax {
        let result = new Tax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        data["isVAT"] = this.isVAT;
        if (this.taxProducts && this.taxProducts.constructor === Array) {
            data["taxProducts"] = [];
            for (let item of this.taxProducts)
                data["taxProducts"].push(item.toJSON());
        }
        if (this.menuItemTaxes && this.menuItemTaxes.constructor === Array) {
            data["menuItemTaxes"] = [];
            for (let item of this.menuItemTaxes)
                data["menuItemTaxes"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITax {
    code: string;
    value: number;
    isVAT: boolean;
    taxProducts: ProductTax[];
    menuItemTaxes: MenuItemTax[];
    translations: TaxTranslation[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Attribute implements IAttribute {
    translations: AttributeTranslation[];
    products: ProductAttribute[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(AttributeTranslation.fromJS(item));
            }
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(ProductAttribute.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Attribute {
        let result = new Attribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAttribute {
    translations: AttributeTranslation[];
    products: ProductAttribute[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantValueTranslation implements IVariantValueTranslation {
    variantValueId: number;
    variantValue: VariantValue;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantValueTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variantValueId = data["variantValueId"];
            this.variantValue = data["variantValue"] ? VariantValue.fromJS(data["variantValue"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantValueTranslation {
        let result = new VariantValueTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantValueId"] = this.variantValueId;
        data["variantValue"] = this.variantValue ? this.variantValue.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantValueTranslation {
    variantValueId: number;
    variantValue: VariantValue;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantValuePriceList implements IVariantValuePriceList {
    tenantId: number;
    variantValue: VariantValue;
    priceList: PriceList;
    variantValueId: number;
    priceListId: number;
    price: number;
    factor: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantValuePriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.variantValue = data["variantValue"] ? VariantValue.fromJS(data["variantValue"]) : <any>undefined;
            this.priceList = data["priceList"] ? PriceList.fromJS(data["priceList"]) : <any>undefined;
            this.variantValueId = data["variantValueId"];
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.factor = data["factor"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantValuePriceList {
        let result = new VariantValuePriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["variantValue"] = this.variantValue ? this.variantValue.toJSON() : <any>undefined;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["variantValueId"] = this.variantValueId;
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["factor"] = this.factor;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantValuePriceList {
    tenantId: number;
    variantValue: VariantValue;
    priceList: PriceList;
    variantValueId: number;
    priceListId: number;
    price: number;
    factor: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboGroup implements IComboGroup {
    tenantId: number;
    translations: ComboGroupTranslation[];
    saleTypeComboGroups: SaleTypeComboGroup[];
    productCategoryComboGroups: ProductCategoryComboGroup[];
    priceListComboGroups: PriceListComboGroup[];
    comboGroupDetails: ComboGroupDetail[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboGroupTranslation.fromJS(item));
            }
            if (data["saleTypeComboGroups"] && data["saleTypeComboGroups"].constructor === Array) {
                this.saleTypeComboGroups = [];
                for (let item of data["saleTypeComboGroups"])
                    this.saleTypeComboGroups.push(SaleTypeComboGroup.fromJS(item));
            }
            if (data["productCategoryComboGroups"] && data["productCategoryComboGroups"].constructor === Array) {
                this.productCategoryComboGroups = [];
                for (let item of data["productCategoryComboGroups"])
                    this.productCategoryComboGroups.push(ProductCategoryComboGroup.fromJS(item));
            }
            if (data["priceListComboGroups"] && data["priceListComboGroups"].constructor === Array) {
                this.priceListComboGroups = [];
                for (let item of data["priceListComboGroups"])
                    this.priceListComboGroups.push(PriceListComboGroup.fromJS(item));
            }
            if (data["comboGroupDetails"] && data["comboGroupDetails"].constructor === Array) {
                this.comboGroupDetails = [];
                for (let item of data["comboGroupDetails"])
                    this.comboGroupDetails.push(ComboGroupDetail.fromJS(item));
            }
            this.imageId = data["imageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboGroup {
        let result = new ComboGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.saleTypeComboGroups && this.saleTypeComboGroups.constructor === Array) {
            data["saleTypeComboGroups"] = [];
            for (let item of this.saleTypeComboGroups)
                data["saleTypeComboGroups"].push(item.toJSON());
        }
        if (this.productCategoryComboGroups && this.productCategoryComboGroups.constructor === Array) {
            data["productCategoryComboGroups"] = [];
            for (let item of this.productCategoryComboGroups)
                data["productCategoryComboGroups"].push(item.toJSON());
        }
        if (this.priceListComboGroups && this.priceListComboGroups.constructor === Array) {
            data["priceListComboGroups"] = [];
            for (let item of this.priceListComboGroups)
                data["priceListComboGroups"].push(item.toJSON());
        }
        if (this.comboGroupDetails && this.comboGroupDetails.constructor === Array) {
            data["comboGroupDetails"] = [];
            for (let item of this.comboGroupDetails)
                data["comboGroupDetails"].push(item.toJSON());
        }
        data["imageId"] = this.imageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboGroup {
    tenantId: number;
    translations: ComboGroupTranslation[];
    saleTypeComboGroups: SaleTypeComboGroup[];
    productCategoryComboGroups: ProductCategoryComboGroup[];
    priceListComboGroups: PriceListComboGroup[];
    comboGroupDetails: ComboGroupDetail[];
    imageId: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VendorTranslation implements IVendorTranslation {
    vendorId: number;
    vendor: Vendor;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVendorTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorId = data["vendorId"];
            this.vendor = data["vendor"] ? Vendor.fromJS(data["vendor"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VendorTranslation {
        let result = new VendorTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVendorTranslation {
    vendorId: number;
    vendor: Vendor;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class MainTransaction implements IMainTransaction {
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    fromStore: Store;
    toStore: Store;
    supplier: Vendor;
    transactionTemplate: TransactionTemplate;
    transactionTemplateId: number;
    notes: string;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    receiveNumber: string;
    supplierId: number;
    saleTypeId: number;
    status: number;
    menuItemId: number;
    quantity: number;
    parentId: number;
    tenantId: number;
    isRevision: number;
    netAfterVat: number;
    netBeforVat: number;
    totalVat: number;
    documentNumber: string;
    reviewDate: moment.Moment;
    detailTransactions: DetailTransactionEntity[];
    transactionType: TransactionType;
    currencyId: number;
    currencyRate: number;
    currency: Currency;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMainTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mainTransactionId = data["mainTransactionId"];
            this.fromStoreId = data["fromStoreId"];
            this.toStoreId = data["toStoreId"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.fromStore = data["fromStore"] ? Store.fromJS(data["fromStore"]) : <any>undefined;
            this.toStore = data["toStore"] ? Store.fromJS(data["toStore"]) : <any>undefined;
            this.supplier = data["supplier"] ? Vendor.fromJS(data["supplier"]) : <any>undefined;
            this.transactionTemplate = data["transactionTemplate"] ? TransactionTemplate.fromJS(data["transactionTemplate"]) : <any>undefined;
            this.transactionTemplateId = data["transactionTemplateId"];
            this.notes = data["notes"];
            this.code = data["code"];
            this.fromStoreTpypeId = data["fromStoreTpypeId"];
            this.toStoreTpypeId = data["toStoreTpypeId"];
            this.transactionTypeId = data["transactionTypeId"];
            this.receiveNumber = data["receiveNumber"];
            this.supplierId = data["supplierId"];
            this.saleTypeId = data["saleTypeId"];
            this.status = data["status"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.parentId = data["parentId"];
            this.tenantId = data["tenantId"];
            this.isRevision = data["isRevision"];
            this.netAfterVat = data["netAfterVat"];
            this.netBeforVat = data["netBeforVat"];
            this.totalVat = data["totalVat"];
            this.documentNumber = data["documentNumber"];
            this.reviewDate = data["reviewDate"] ? moment(data["reviewDate"].toString()) : <any>undefined;
            if (data["detailTransactions"] && data["detailTransactions"].constructor === Array) {
                this.detailTransactions = [];
                for (let item of data["detailTransactions"])
                    this.detailTransactions.push(DetailTransactionEntity.fromJS(item));
            }
            this.transactionType = data["transactionType"] ? TransactionType.fromJS(data["transactionType"]) : <any>undefined;
            this.currencyId = data["currencyId"];
            this.currencyRate = data["currencyRate"];
            this.currency = data["currency"] ? Currency.fromJS(data["currency"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MainTransaction {
        let result = new MainTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainTransactionId"] = this.mainTransactionId;
        data["fromStoreId"] = this.fromStoreId;
        data["toStoreId"] = this.toStoreId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["fromStore"] = this.fromStore ? this.fromStore.toJSON() : <any>undefined;
        data["toStore"] = this.toStore ? this.toStore.toJSON() : <any>undefined;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data["transactionTemplate"] = this.transactionTemplate ? this.transactionTemplate.toJSON() : <any>undefined;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["notes"] = this.notes;
        data["code"] = this.code;
        data["fromStoreTpypeId"] = this.fromStoreTpypeId;
        data["toStoreTpypeId"] = this.toStoreTpypeId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["receiveNumber"] = this.receiveNumber;
        data["supplierId"] = this.supplierId;
        data["saleTypeId"] = this.saleTypeId;
        data["status"] = this.status;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["parentId"] = this.parentId;
        data["tenantId"] = this.tenantId;
        data["isRevision"] = this.isRevision;
        data["netAfterVat"] = this.netAfterVat;
        data["netBeforVat"] = this.netBeforVat;
        data["totalVat"] = this.totalVat;
        data["documentNumber"] = this.documentNumber;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : <any>undefined;
        if (this.detailTransactions && this.detailTransactions.constructor === Array) {
            data["detailTransactions"] = [];
            for (let item of this.detailTransactions)
                data["detailTransactions"].push(item.toJSON());
        }
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["currencyId"] = this.currencyId;
        data["currencyRate"] = this.currencyRate;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMainTransaction {
    mainTransactionId: number;
    fromStoreId: number;
    toStoreId: number;
    date: moment.Moment;
    fromStore: Store;
    toStore: Store;
    supplier: Vendor;
    transactionTemplate: TransactionTemplate;
    transactionTemplateId: number;
    notes: string;
    code: string;
    fromStoreTpypeId: number;
    toStoreTpypeId: number;
    transactionTypeId: number;
    receiveNumber: string;
    supplierId: number;
    saleTypeId: number;
    status: number;
    menuItemId: number;
    quantity: number;
    parentId: number;
    tenantId: number;
    isRevision: number;
    netAfterVat: number;
    netBeforVat: number;
    totalVat: number;
    documentNumber: string;
    reviewDate: moment.Moment;
    detailTransactions: DetailTransactionEntity[];
    transactionType: TransactionType;
    currencyId: number;
    currencyRate: number;
    currency: Currency;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VendorStores implements IVendorStores {
    tenantId: number;
    vendorId: number;
    vendor: Vendor;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVendorStores) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.vendorId = data["vendorId"];
            this.vendor = data["vendor"] ? Vendor.fromJS(data["vendor"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VendorStores {
        let result = new VendorStores();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVendorStores {
    tenantId: number;
    vendorId: number;
    vendor: Vendor;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PriceList implements IPriceList {
    tenantId: number;
    code: string;
    translations: PriceListTranslation[];
    saleTypePriceLists: SaleTypePriceList[];
    priceListComboGroups: PriceListComboGroup[];
    menuItemPriceLists: MenuItemPriceList[];
    variantValuePriceLists: VariantValuePriceList[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PriceListTranslation.fromJS(item));
            }
            if (data["saleTypePriceLists"] && data["saleTypePriceLists"].constructor === Array) {
                this.saleTypePriceLists = [];
                for (let item of data["saleTypePriceLists"])
                    this.saleTypePriceLists.push(SaleTypePriceList.fromJS(item));
            }
            if (data["priceListComboGroups"] && data["priceListComboGroups"].constructor === Array) {
                this.priceListComboGroups = [];
                for (let item of data["priceListComboGroups"])
                    this.priceListComboGroups.push(PriceListComboGroup.fromJS(item));
            }
            if (data["menuItemPriceLists"] && data["menuItemPriceLists"].constructor === Array) {
                this.menuItemPriceLists = [];
                for (let item of data["menuItemPriceLists"])
                    this.menuItemPriceLists.push(MenuItemPriceList.fromJS(item));
            }
            if (data["variantValuePriceLists"] && data["variantValuePriceLists"].constructor === Array) {
                this.variantValuePriceLists = [];
                for (let item of data["variantValuePriceLists"])
                    this.variantValuePriceLists.push(VariantValuePriceList.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PriceList {
        let result = new PriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.saleTypePriceLists && this.saleTypePriceLists.constructor === Array) {
            data["saleTypePriceLists"] = [];
            for (let item of this.saleTypePriceLists)
                data["saleTypePriceLists"].push(item.toJSON());
        }
        if (this.priceListComboGroups && this.priceListComboGroups.constructor === Array) {
            data["priceListComboGroups"] = [];
            for (let item of this.priceListComboGroups)
                data["priceListComboGroups"].push(item.toJSON());
        }
        if (this.menuItemPriceLists && this.menuItemPriceLists.constructor === Array) {
            data["menuItemPriceLists"] = [];
            for (let item of this.menuItemPriceLists)
                data["menuItemPriceLists"].push(item.toJSON());
        }
        if (this.variantValuePriceLists && this.variantValuePriceLists.constructor === Array) {
            data["variantValuePriceLists"] = [];
            for (let item of this.variantValuePriceLists)
                data["variantValuePriceLists"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPriceList {
    tenantId: number;
    code: string;
    translations: PriceListTranslation[];
    saleTypePriceLists: SaleTypePriceList[];
    priceListComboGroups: PriceListComboGroup[];
    menuItemPriceLists: MenuItemPriceList[];
    variantValuePriceLists: VariantValuePriceList[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ServiceCharge implements IServiceCharge {
    saleTypes: ServiceChargeSaleType[];
    translations: ServiceChargeTranslation[];
    amount: number;
    tenantId: number;
    isPercentage: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IServiceCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["saleTypes"] && data["saleTypes"].constructor === Array) {
                this.saleTypes = [];
                for (let item of data["saleTypes"])
                    this.saleTypes.push(ServiceChargeSaleType.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ServiceChargeTranslation.fromJS(item));
            }
            this.amount = data["amount"];
            this.tenantId = data["tenantId"];
            this.isPercentage = data["isPercentage"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceCharge {
        let result = new ServiceCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.saleTypes && this.saleTypes.constructor === Array) {
            data["saleTypes"] = [];
            for (let item of this.saleTypes)
                data["saleTypes"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["tenantId"] = this.tenantId;
        data["isPercentage"] = this.isPercentage;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceCharge {
    saleTypes: ServiceChargeSaleType[];
    translations: ServiceChargeTranslation[];
    amount: number;
    tenantId: number;
    isPercentage: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Role implements IRole {
    saleTypesRoles: SaleTypesRoles[];
    normalizedName: string;
    claims: RoleClaim[];
    concurrencyStamp: string;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    tenantId: number;
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    permissions: RolePermissionSetting[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["saleTypesRoles"] && data["saleTypesRoles"].constructor === Array) {
                this.saleTypesRoles = [];
                for (let item of data["saleTypesRoles"])
                    this.saleTypesRoles.push(SaleTypesRoles.fromJS(item));
            }
            this.normalizedName = data["normalizedName"];
            if (data["claims"] && data["claims"].constructor === Array) {
                this.claims = [];
                for (let item of data["claims"])
                    this.claims.push(RoleClaim.fromJS(item));
            }
            this.concurrencyStamp = data["concurrencyStamp"];
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : <any>undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(RolePermissionSetting.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Role {
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.saleTypesRoles && this.saleTypesRoles.constructor === Array) {
            data["saleTypesRoles"] = [];
            for (let item of this.saleTypesRoles)
                data["saleTypesRoles"].push(item.toJSON());
        }
        data["normalizedName"] = this.normalizedName;
        if (this.claims && this.claims.constructor === Array) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRole {
    saleTypesRoles: SaleTypesRoles[];
    normalizedName: string;
    claims: RoleClaim[];
    concurrencyStamp: string;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    tenantId: number;
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    permissions: RolePermissionSetting[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PeriodTranslation implements IPeriodTranslation {
    periodId: number;
    period: Period;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPeriodTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.periodId = data["periodId"];
            this.period = data["period"] ? Period.fromJS(data["period"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PeriodTranslation {
        let result = new PeriodTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodId"] = this.periodId;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPeriodTranslation {
    periodId: number;
    period: Period;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StockPeriodClosingDate implements IStockPeriodClosingDate {
    tenantId: number;
    storeId: number;
    store: Store;
    stockPeriodId: number;
    stockPeriod: StockPeriod;
    date: moment.Moment;
    status: StockPeriodClosingDateStatus;
    periodType: StockPeriodClosingDatePeriodType;
    entryMaterialStocks: EntryMaterialStock[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStockPeriodClosingDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.stockPeriodId = data["stockPeriodId"];
            this.stockPeriod = data["stockPeriod"] ? StockPeriod.fromJS(data["stockPeriod"]) : <any>undefined;
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.status = data["status"];
            this.periodType = data["periodType"];
            if (data["entryMaterialStocks"] && data["entryMaterialStocks"].constructor === Array) {
                this.entryMaterialStocks = [];
                for (let item of data["entryMaterialStocks"])
                    this.entryMaterialStocks.push(EntryMaterialStock.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StockPeriodClosingDate {
        let result = new StockPeriodClosingDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["stockPeriodId"] = this.stockPeriodId;
        data["stockPeriod"] = this.stockPeriod ? this.stockPeriod.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["periodType"] = this.periodType;
        if (this.entryMaterialStocks && this.entryMaterialStocks.constructor === Array) {
            data["entryMaterialStocks"] = [];
            for (let item of this.entryMaterialStocks)
                data["entryMaterialStocks"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStockPeriodClosingDate {
    tenantId: number;
    storeId: number;
    store: Store;
    stockPeriodId: number;
    stockPeriod: StockPeriod;
    date: moment.Moment;
    status: StockPeriodClosingDateStatus;
    periodType: StockPeriodClosingDatePeriodType;
    entryMaterialStocks: EntryMaterialStock[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TransactionTemplate implements ITransactionTemplate {
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplate[];
    translations: TransactionTemplateTranslation[];
    transactionTemplateTypes: TransactionTemplateType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITransactionTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["detailTransactionTemplate"] && data["detailTransactionTemplate"].constructor === Array) {
                this.detailTransactionTemplate = [];
                for (let item of data["detailTransactionTemplate"])
                    this.detailTransactionTemplate.push(DetailTransactionTemplate.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TransactionTemplateTranslation.fromJS(item));
            }
            if (data["transactionTemplateTypes"] && data["transactionTemplateTypes"].constructor === Array) {
                this.transactionTemplateTypes = [];
                for (let item of data["transactionTemplateTypes"])
                    this.transactionTemplateTypes.push(TransactionTemplateType.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionTemplate {
        let result = new TransactionTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.detailTransactionTemplate && this.detailTransactionTemplate.constructor === Array) {
            data["detailTransactionTemplate"] = [];
            for (let item of this.detailTransactionTemplate)
                data["detailTransactionTemplate"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.transactionTemplateTypes && this.transactionTemplateTypes.constructor === Array) {
            data["transactionTemplateTypes"] = [];
            for (let item of this.transactionTemplateTypes)
                data["transactionTemplateTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionTemplate {
    tenantId: number;
    detailTransactionTemplate: DetailTransactionTemplate[];
    translations: TransactionTemplateTranslation[];
    transactionTemplateTypes: TransactionTemplateType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ReportGroupTranslation implements IReportGroupTranslation {
    reportGroupId: number;
    reportGroup: ReportGroup;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IReportGroupTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reportGroupId = data["reportGroupId"];
            this.reportGroup = data["reportGroup"] ? ReportGroup.fromJS(data["reportGroup"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReportGroupTranslation {
        let result = new ReportGroupTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportGroupId"] = this.reportGroupId;
        data["reportGroup"] = this.reportGroup ? this.reportGroup.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReportGroupTranslation {
    reportGroupId: number;
    reportGroup: ReportGroup;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class LevelTranslation implements ILevelTranslation {
    levelId: number;
    level: Level;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ILevelTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.levelId = data["levelId"];
            this.level = data["level"] ? Level.fromJS(data["level"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LevelTranslation {
        let result = new LevelTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelId"] = this.levelId;
        data["level"] = this.level ? this.level.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILevelTranslation {
    levelId: number;
    level: Level;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DiscountType implements IDiscountType {
    typeId: number;
    typeName: string;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    amount: number;
    translations: DiscountTypeTranslation[];
    menuItemDiscountTypes: MenuItemDiscountType[];
    discountTypeCustomers: DiscountTypeCustomer[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDiscountType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.isOnSpecificItem = data["isOnSpecificItem"];
            this.isOnTotalReceipt = data["isOnTotalReceipt"];
            this.amount = data["amount"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DiscountTypeTranslation.fromJS(item));
            }
            if (data["menuItemDiscountTypes"] && data["menuItemDiscountTypes"].constructor === Array) {
                this.menuItemDiscountTypes = [];
                for (let item of data["menuItemDiscountTypes"])
                    this.menuItemDiscountTypes.push(MenuItemDiscountType.fromJS(item));
            }
            if (data["discountTypeCustomers"] && data["discountTypeCustomers"].constructor === Array) {
                this.discountTypeCustomers = [];
                for (let item of data["discountTypeCustomers"])
                    this.discountTypeCustomers.push(DiscountTypeCustomer.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DiscountType {
        let result = new DiscountType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["isOnSpecificItem"] = this.isOnSpecificItem;
        data["isOnTotalReceipt"] = this.isOnTotalReceipt;
        data["amount"] = this.amount;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.menuItemDiscountTypes && this.menuItemDiscountTypes.constructor === Array) {
            data["menuItemDiscountTypes"] = [];
            for (let item of this.menuItemDiscountTypes)
                data["menuItemDiscountTypes"].push(item.toJSON());
        }
        if (this.discountTypeCustomers && this.discountTypeCustomers.constructor === Array) {
            data["discountTypeCustomers"] = [];
            for (let item of this.discountTypeCustomers)
                data["discountTypeCustomers"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDiscountType {
    typeId: number;
    typeName: string;
    isOnSpecificItem: boolean;
    isOnTotalReceipt: boolean;
    amount: number;
    translations: DiscountTypeTranslation[];
    menuItemDiscountTypes: MenuItemDiscountType[];
    discountTypeCustomers: DiscountTypeCustomer[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboMealPackage implements IComboMealPackage {
    tenantId: number;
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslation[];
    comboMealPackageItems: ComboMealPackageItem[];
    comboMealDefinitions: ComboMealDefinition[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.quantity = data["quantity"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ComboMealPackageTranslation.fromJS(item));
            }
            if (data["comboMealPackageItems"] && data["comboMealPackageItems"].constructor === Array) {
                this.comboMealPackageItems = [];
                for (let item of data["comboMealPackageItems"])
                    this.comboMealPackageItems.push(ComboMealPackageItem.fromJS(item));
            }
            if (data["comboMealDefinitions"] && data["comboMealDefinitions"].constructor === Array) {
                this.comboMealDefinitions = [];
                for (let item of data["comboMealDefinitions"])
                    this.comboMealDefinitions.push(ComboMealDefinition.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealPackage {
        let result = new ComboMealPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.comboMealPackageItems && this.comboMealPackageItems.constructor === Array) {
            data["comboMealPackageItems"] = [];
            for (let item of this.comboMealPackageItems)
                data["comboMealPackageItems"].push(item.toJSON());
        }
        if (this.comboMealDefinitions && this.comboMealDefinitions.constructor === Array) {
            data["comboMealDefinitions"] = [];
            for (let item of this.comboMealDefinitions)
                data["comboMealDefinitions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealPackage {
    tenantId: number;
    code: string;
    quantity: number;
    translations: ComboMealPackageTranslation[];
    comboMealPackageItems: ComboMealPackageItem[];
    comboMealDefinitions: ComboMealDefinition[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboMealPackageItemPriceList implements IComboMealPackageItemPriceList {
    tenantId: number;
    priceListId: number;
    price: number;
    comboMealPackageItemId: number;
    priceList: PriceList;
    comboMealPackageItem: ComboMealPackageItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealPackageItemPriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.priceListId = data["priceListId"];
            this.price = data["price"];
            this.comboMealPackageItemId = data["comboMealPackageItemId"];
            this.priceList = data["priceList"] ? PriceList.fromJS(data["priceList"]) : <any>undefined;
            this.comboMealPackageItem = data["comboMealPackageItem"] ? ComboMealPackageItem.fromJS(data["comboMealPackageItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealPackageItemPriceList {
        let result = new ComboMealPackageItemPriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["comboMealPackageItemId"] = this.comboMealPackageItemId;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["comboMealPackageItem"] = this.comboMealPackageItem ? this.comboMealPackageItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealPackageItemPriceList {
    tenantId: number;
    priceListId: number;
    price: number;
    comboMealPackageItemId: number;
    priceList: PriceList;
    comboMealPackageItem: ComboMealPackageItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionFBItem implements IPromotionFBItem {
    id: number;
    tenantId: number;
    itemId: number;
    itemType: PromotionFBItemItemType;
    promotionId: number;
    promotion: PromotionFB;
    excludedMenuItems: PromotionFBItemExcludedMenuItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;

    constructor(data?: IPromotionFBItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.promotionId = data["promotionId"];
            this.promotion = data["promotion"] ? PromotionFB.fromJS(data["promotion"]) : <any>undefined;
            if (data["excludedMenuItems"] && data["excludedMenuItems"].constructor === Array) {
                this.excludedMenuItems = [];
                for (let item of data["excludedMenuItems"])
                    this.excludedMenuItems.push(PromotionFBItemExcludedMenuItem.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): PromotionFBItem {
        let result = new PromotionFBItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        if (this.excludedMenuItems && this.excludedMenuItems.constructor === Array) {
            data["excludedMenuItems"] = [];
            for (let item of this.excludedMenuItems)
                data["excludedMenuItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }
}

export interface IPromotionFBItem {
    id: number;
    tenantId: number;
    itemId: number;
    itemType: PromotionFBItemItemType;
    promotionId: number;
    promotion: PromotionFB;
    excludedMenuItems: PromotionFBItemExcludedMenuItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
}

export class PromotionDetailsFB implements IPromotionDetailsFB {
    tenantId: number;
    itemId: number;
    itemType: PromotionDetailsFBItemType;
    quantity: number;
    whre: string;
    promotionId: number;
    promotion: PromotionFB;
    excludedMenuItems: PromotionDetailsFBExcludedMenuItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionDetailsFB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.whre = data["whre"];
            this.promotionId = data["promotionId"];
            this.promotion = data["promotion"] ? PromotionFB.fromJS(data["promotion"]) : <any>undefined;
            if (data["excludedMenuItems"] && data["excludedMenuItems"].constructor === Array) {
                this.excludedMenuItems = [];
                for (let item of data["excludedMenuItems"])
                    this.excludedMenuItems.push(PromotionDetailsFBExcludedMenuItem.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionDetailsFB {
        let result = new PromotionDetailsFB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["whre"] = this.whre;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        if (this.excludedMenuItems && this.excludedMenuItems.constructor === Array) {
            data["excludedMenuItems"] = [];
            for (let item of this.excludedMenuItems)
                data["excludedMenuItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionDetailsFB {
    tenantId: number;
    itemId: number;
    itemType: PromotionDetailsFBItemType;
    quantity: number;
    whre: string;
    promotionId: number;
    promotion: PromotionFB;
    excludedMenuItems: PromotionDetailsFBExcludedMenuItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class VariantTranslation implements IVariantTranslation {
    variantId: number;
    variant: Variant;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IVariantTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.variantId = data["variantId"];
            this.variant = data["variant"] ? Variant.fromJS(data["variant"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VariantTranslation {
        let result = new VariantTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantId"] = this.variantId;
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVariantTranslation {
    variantId: number;
    variant: Variant;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeliveryStreetTranslation implements IDeliveryStreetTranslation {
    name: string;
    deliveryStreet: DeliveryStreet;
    deliveryStreetId: number;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryStreetTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.deliveryStreet = data["deliveryStreet"] ? DeliveryStreet.fromJS(data["deliveryStreet"]) : <any>undefined;
            this.deliveryStreetId = data["deliveryStreetId"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryStreetTranslation {
        let result = new DeliveryStreetTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["deliveryStreet"] = this.deliveryStreet ? this.deliveryStreet.toJSON() : <any>undefined;
        data["deliveryStreetId"] = this.deliveryStreetId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryStreetTranslation {
    name: string;
    deliveryStreet: DeliveryStreet;
    deliveryStreetId: number;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PointTransaction implements IPointTransaction {
    tenantId: number;
    amount: number;
    remain: number;
    expirationDate: moment.Moment;
    accountId: string;
    account: Account;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPointTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.amount = data["amount"];
            this.remain = data["remain"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.accountId = data["accountId"];
            this.account = data["account"] ? Account.fromJS(data["account"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PointTransaction {
        let result = new PointTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["amount"] = this.amount;
        data["remain"] = this.remain;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPointTransaction {
    tenantId: number;
    amount: number;
    remain: number;
    expirationDate: moment.Moment;
    accountId: string;
    account: Account;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SchemaAccount implements ISchemaAccount {
    tenantId: number;
    accountId: string;
    account: Account;
    eligibleDate: moment.Moment;
    points: number;
    schemaId: number;
    schema: Schema;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISchemaAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.accountId = data["accountId"];
            this.account = data["account"] ? Account.fromJS(data["account"]) : <any>undefined;
            this.eligibleDate = data["eligibleDate"] ? moment(data["eligibleDate"].toString()) : <any>undefined;
            this.points = data["points"];
            this.schemaId = data["schemaId"];
            this.schema = data["schema"] ? Schema.fromJS(data["schema"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SchemaAccount {
        let result = new SchemaAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["eligibleDate"] = this.eligibleDate ? this.eligibleDate.toISOString() : <any>undefined;
        data["points"] = this.points;
        data["schemaId"] = this.schemaId;
        data["schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISchemaAccount {
    tenantId: number;
    accountId: string;
    account: Account;
    eligibleDate: moment.Moment;
    points: number;
    schemaId: number;
    schema: Schema;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SupervisorShiftPaymentTransactionValues implements ISupervisorShiftPaymentTransactionValues {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeId: number;
    tenderType: TenderType;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    supervisorShiftId: number;
    supervisorShift: SupervisorShift;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISupervisorShiftPaymentTransactionValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.currencyId = data["currencyId"];
            this.currency = data["currency"] ? Currency.fromJS(data["currency"]) : <any>undefined;
            this.tenderTypeId = data["tenderTypeId"];
            this.tenderType = data["tenderType"] ? TenderType.fromJS(data["tenderType"]) : <any>undefined;
            this.actualTransactionsValue = data["actualTransactionsValue"];
            this.totalTransactionsValue = data["totalTransactionsValue"];
            this.supervisorShiftId = data["supervisorShiftId"];
            this.supervisorShift = data["supervisorShift"] ? SupervisorShift.fromJS(data["supervisorShift"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SupervisorShiftPaymentTransactionValues {
        let result = new SupervisorShiftPaymentTransactionValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["tenderTypeId"] = this.tenderTypeId;
        data["tenderType"] = this.tenderType ? this.tenderType.toJSON() : <any>undefined;
        data["actualTransactionsValue"] = this.actualTransactionsValue;
        data["totalTransactionsValue"] = this.totalTransactionsValue;
        data["supervisorShiftId"] = this.supervisorShiftId;
        data["supervisorShift"] = this.supervisorShift ? this.supervisorShift.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISupervisorShiftPaymentTransactionValues {
    tenantId: number;
    currencyId: number;
    currency: Currency;
    tenderTypeId: number;
    tenderType: TenderType;
    actualTransactionsValue: number;
    totalTransactionsValue: number;
    supervisorShiftId: number;
    supervisorShift: SupervisorShift;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class TenderTypeMaster implements ITenderTypeMaster {
    showInClosingShift: boolean;
    nature: TenderTypeMasterNature;
    translations: TenderTypeMasterTranslation[];
    tenderTypes: TenderType[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeMaster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.showInClosingShift = data["showInClosingShift"];
            this.nature = data["nature"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TenderTypeMasterTranslation.fromJS(item));
            }
            if (data["tenderTypes"] && data["tenderTypes"].constructor === Array) {
                this.tenderTypes = [];
                for (let item of data["tenderTypes"])
                    this.tenderTypes.push(TenderType.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeMaster {
        let result = new TenderTypeMaster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showInClosingShift"] = this.showInClosingShift;
        data["nature"] = this.nature;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.tenderTypes && this.tenderTypes.constructor === Array) {
            data["tenderTypes"] = [];
            for (let item of this.tenderTypes)
                data["tenderTypes"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeMaster {
    showInClosingShift: boolean;
    nature: TenderTypeMasterNature;
    translations: TenderTypeMasterTranslation[];
    tenderTypes: TenderType[];
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionFBStore implements IPromotionFBStore {
    tenantId: number;
    storeType: PromotionFBStoreStoreType;
    promotionFBId: number;
    promotionFB: PromotionFB;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.storeType = data["storeType"];
            this.promotionFBId = data["promotionFBId"];
            this.promotionFB = data["promotionFB"] ? PromotionFB.fromJS(data["promotionFB"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBStore {
        let result = new PromotionFBStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storeType"] = this.storeType;
        data["promotionFBId"] = this.promotionFBId;
        data["promotionFB"] = this.promotionFB ? this.promotionFB.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBStore {
    tenantId: number;
    storeType: PromotionFBStoreStoreType;
    promotionFBId: number;
    promotionFB: PromotionFB;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionFBAdditionalFreeItem implements IPromotionFBAdditionalFreeItem {
    tenantId: number;
    itemId: number;
    itemType: PromotionFBAdditionalFreeItemItemType;
    quantity: number;
    price: number;
    promotionId: number;
    promotion: PromotionFB;
    excludedMenuItems: PromotionFBAdditionalFreeItemsExcludedMenuItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBAdditionalFreeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.promotionId = data["promotionId"];
            this.promotion = data["promotion"] ? PromotionFB.fromJS(data["promotion"]) : <any>undefined;
            if (data["excludedMenuItems"] && data["excludedMenuItems"].constructor === Array) {
                this.excludedMenuItems = [];
                for (let item of data["excludedMenuItems"])
                    this.excludedMenuItems.push(PromotionFBAdditionalFreeItemsExcludedMenuItem.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBAdditionalFreeItem {
        let result = new PromotionFBAdditionalFreeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        if (this.excludedMenuItems && this.excludedMenuItems.constructor === Array) {
            data["excludedMenuItems"] = [];
            for (let item of this.excludedMenuItems)
                data["excludedMenuItems"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBAdditionalFreeItem {
    tenantId: number;
    itemId: number;
    itemType: PromotionFBAdditionalFreeItemItemType;
    quantity: number;
    price: number;
    promotionId: number;
    promotion: PromotionFB;
    excludedMenuItems: PromotionFBAdditionalFreeItemsExcludedMenuItem[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferDetail implements IOfferDetail {
    itemCode: string;
    minQuantity: number;
    maxQuantity: number;
    itemId: number;
    offerId: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.minQuantity = data["minQuantity"];
            this.maxQuantity = data["maxQuantity"];
            this.itemId = data["itemId"];
            this.offerId = data["offerId"];
            this.offer = data["offer"] ? Offer.fromJS(data["offer"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferDetail {
        let result = new OfferDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["itemId"] = this.itemId;
        data["offerId"] = this.offerId;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferDetail {
    itemCode: string;
    minQuantity: number;
    maxQuantity: number;
    itemId: number;
    offerId: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferExclude implements IOfferExclude {
    itemCode: string;
    itemId: number;
    itemType: OfferExcludeItemType;
    offerId: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferExclude) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.itemId = data["itemId"];
            this.itemType = data["itemType"];
            this.offerId = data["offerId"];
            this.offer = data["offer"] ? Offer.fromJS(data["offer"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferExclude {
        let result = new OfferExclude();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["offerId"] = this.offerId;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferExclude {
    itemCode: string;
    itemId: number;
    itemType: OfferExcludeItemType;
    offerId: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class OfferInclude implements IOfferInclude {
    itemId: number;
    offerId: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOfferInclude) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemId = data["itemId"];
            this.offerId = data["offerId"];
            this.offer = data["offer"] ? Offer.fromJS(data["offer"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OfferInclude {
        let result = new OfferInclude();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["offerId"] = this.offerId;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOfferInclude {
    itemId: number;
    offerId: number;
    offer: Offer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TenderTypeTranslation implements ITenderTypeTranslation {
    name: string;
    tenderTypeId: number;
    tenderType: TenderType;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.tenderTypeId = data["tenderTypeId"];
            this.tenderType = data["tenderType"] ? TenderType.fromJS(data["tenderType"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeTranslation {
        let result = new TenderTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tenderTypeId"] = this.tenderTypeId;
        data["tenderType"] = this.tenderType ? this.tenderType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeTranslation {
    name: string;
    tenderTypeId: number;
    tenderType: TenderType;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StoreTenderTypeConfig implements IStoreTenderTypeConfig {
    tenantId: number;
    tenderTypeId: number;
    tenderType: TenderType;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStoreTenderTypeConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenderTypeId = data["tenderTypeId"];
            this.tenderType = data["tenderType"] ? TenderType.fromJS(data["tenderType"]) : <any>undefined;
            this.storeId = data["storeId"];
            this.store = data["store"] ? Store.fromJS(data["store"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StoreTenderTypeConfig {
        let result = new StoreTenderTypeConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["tenderType"] = this.tenderType ? this.tenderType.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStoreTenderTypeConfig {
    tenantId: number;
    tenderTypeId: number;
    tenderType: TenderType;
    storeId: number;
    store: Store;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Delivery implements IDelivery {
    tenantId: number;
    code: string;
    translations: DeliveryTranslation[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDelivery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(DeliveryTranslation.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Delivery {
        let result = new Delivery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDelivery {
    tenantId: number;
    code: string;
    translations: DeliveryTranslation[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleNotificationDetailVarient implements ISaleNotificationDetailVarient {
    tenantId: number;
    saleNotificationDetailId: string;
    variantId: number;
    variantValueId: number;
    saleNotificationDetail: SaleNotificationDetail;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleNotificationDetailVarient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
            this.variantId = data["variantId"];
            this.variantValueId = data["variantValueId"];
            this.saleNotificationDetail = data["saleNotificationDetail"] ? SaleNotificationDetail.fromJS(data["saleNotificationDetail"]) : <any>undefined;
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludingVAT = data["priceIncludingVAT"];
            this.quantity = data["quantity"];
            this.freeQty = data["freeQty"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleNotificationDetailVarient {
        let result = new SaleNotificationDetailVarient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        data["variantId"] = this.variantId;
        data["variantValueId"] = this.variantValueId;
        data["saleNotificationDetail"] = this.saleNotificationDetail ? this.saleNotificationDetail.toJSON() : <any>undefined;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludingVAT"] = this.priceIncludingVAT;
        data["quantity"] = this.quantity;
        data["freeQty"] = this.freeQty;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleNotificationDetailVarient {
    tenantId: number;
    saleNotificationDetailId: string;
    variantId: number;
    variantValueId: number;
    saleNotificationDetail: SaleNotificationDetail;
    price: number;
    vat: number;
    priceIncludingVAT: number;
    quantity: number;
    freeQty: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleNotificationReasonDetail implements ISaleNotificationReasonDetail {
    tenantId: number;
    saleNotificationDetailId: string;
    refundResonId: number;
    refundReson: RefundReson;
    saleNotificationDetail: SaleNotificationDetail;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISaleNotificationReasonDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
            this.refundResonId = data["refundResonId"];
            this.refundReson = data["refundReson"] ? RefundReson.fromJS(data["refundReson"]) : <any>undefined;
            this.saleNotificationDetail = data["saleNotificationDetail"] ? SaleNotificationDetail.fromJS(data["saleNotificationDetail"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleNotificationReasonDetail {
        let result = new SaleNotificationReasonDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        data["refundResonId"] = this.refundResonId;
        data["refundReson"] = this.refundReson ? this.refundReson.toJSON() : <any>undefined;
        data["saleNotificationDetail"] = this.saleNotificationDetail ? this.saleNotificationDetail.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleNotificationReasonDetail {
    tenantId: number;
    saleNotificationDetailId: string;
    refundResonId: number;
    refundReson: RefundReson;
    saleNotificationDetail: SaleNotificationDetail;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SaleNotifcationsDetialsPromotionItem implements ISaleNotifcationsDetialsPromotionItem {
    tenantId: number;
    saleNotificationDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
    saleNotificationDetail: SaleNotificationDetail;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;

    constructor(data?: ISaleNotifcationsDetialsPromotionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.saleNotificationDetailId = data["saleNotificationDetailId"];
            this.menuItemId = data["menuItemId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.priceIncludeVat = data["priceIncludeVat"];
            this.saleNotificationDetail = data["saleNotificationDetail"] ? SaleNotificationDetail.fromJS(data["saleNotificationDetail"]) : <any>undefined;
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleNotifcationsDetialsPromotionItem {
        let result = new SaleNotifcationsDetialsPromotionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["saleNotificationDetailId"] = this.saleNotificationDetailId;
        data["menuItemId"] = this.menuItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["priceIncludeVat"] = this.priceIncludeVat;
        data["saleNotificationDetail"] = this.saleNotificationDetail ? this.saleNotificationDetail.toJSON() : <any>undefined;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISaleNotifcationsDetialsPromotionItem {
    tenantId: number;
    saleNotificationDetailId: string;
    menuItemId: number;
    quantity: number;
    price: number;
    vat: number;
    priceIncludeVat: number;
    saleNotificationDetail: SaleNotificationDetail;
    menuItem: MenuItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: string;
}

export class TaxTranslation implements ITaxTranslation {
    taxId: number;
    tax: Tax;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITaxTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taxId = data["taxId"];
            this.tax = data["tax"] ? Tax.fromJS(data["tax"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaxTranslation {
        let result = new TaxTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxId"] = this.taxId;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITaxTranslation {
    taxId: number;
    tax: Tax;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class AttributeTranslation implements IAttributeTranslation {
    attributeId: number;
    attribute: Attribute;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IAttributeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attributeId = data["attributeId"];
            this.attribute = data["attribute"] ? Attribute.fromJS(data["attribute"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AttributeTranslation {
        let result = new AttributeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeId"] = this.attributeId;
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAttributeTranslation {
    attributeId: number;
    attribute: Attribute;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboGroupTranslation implements IComboGroupTranslation {
    comboGroupId: number;
    comboGroup: ComboGroup;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboGroupTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboGroupId = data["comboGroupId"];
            this.comboGroup = data["comboGroup"] ? ComboGroup.fromJS(data["comboGroup"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboGroupTranslation {
        let result = new ComboGroupTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboGroupId"] = this.comboGroupId;
        data["comboGroup"] = this.comboGroup ? this.comboGroup.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboGroupTranslation {
    comboGroupId: number;
    comboGroup: ComboGroup;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PriceListComboGroup implements IPriceListComboGroup {
    tenantId: number;
    priceList: PriceList;
    priceListId: number;
    comboGroup: ComboGroup;
    comboGroupId: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPriceListComboGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.priceList = data["priceList"] ? PriceList.fromJS(data["priceList"]) : <any>undefined;
            this.priceListId = data["priceListId"];
            this.comboGroup = data["comboGroup"] ? ComboGroup.fromJS(data["comboGroup"]) : <any>undefined;
            this.comboGroupId = data["comboGroupId"];
            this.price = data["price"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PriceListComboGroup {
        let result = new PriceListComboGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["priceListId"] = this.priceListId;
        data["comboGroup"] = this.comboGroup ? this.comboGroup.toJSON() : <any>undefined;
        data["comboGroupId"] = this.comboGroupId;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPriceListComboGroup {
    tenantId: number;
    priceList: PriceList;
    priceListId: number;
    comboGroup: ComboGroup;
    comboGroupId: number;
    price: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TransactionType implements ITransactionType {
    tenantId: number;
    value: number;
    roleTransactionType: RoleTransactionType[];
    translations: TransactionTypeTranslation[];
    transactionTemplateTypes: TransactionTemplateType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITransactionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.value = data["value"];
            if (data["roleTransactionType"] && data["roleTransactionType"].constructor === Array) {
                this.roleTransactionType = [];
                for (let item of data["roleTransactionType"])
                    this.roleTransactionType.push(RoleTransactionType.fromJS(item));
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(TransactionTypeTranslation.fromJS(item));
            }
            if (data["transactionTemplateTypes"] && data["transactionTemplateTypes"].constructor === Array) {
                this.transactionTemplateTypes = [];
                for (let item of data["transactionTemplateTypes"])
                    this.transactionTemplateTypes.push(TransactionTemplateType.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionType {
        let result = new TransactionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["value"] = this.value;
        if (this.roleTransactionType && this.roleTransactionType.constructor === Array) {
            data["roleTransactionType"] = [];
            for (let item of this.roleTransactionType)
                data["roleTransactionType"].push(item.toJSON());
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.transactionTemplateTypes && this.transactionTemplateTypes.constructor === Array) {
            data["transactionTemplateTypes"] = [];
            for (let item of this.transactionTemplateTypes)
                data["transactionTemplateTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionType {
    tenantId: number;
    value: number;
    roleTransactionType: RoleTransactionType[];
    translations: TransactionTypeTranslation[];
    transactionTemplateTypes: TransactionTemplateType[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PriceListTranslation implements IPriceListTranslation {
    priceListId: number;
    priceList: PriceList;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPriceListTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priceListId = data["priceListId"];
            this.priceList = data["priceList"] ? PriceList.fromJS(data["priceList"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PriceListTranslation {
        let result = new PriceListTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceListId"] = this.priceListId;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPriceListTranslation {
    priceListId: number;
    priceList: PriceList;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ServiceChargeTranslation implements IServiceChargeTranslation {
    serviceCharge: ServiceCharge;
    serviceChargeId: number;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IServiceChargeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceCharge = data["serviceCharge"] ? ServiceCharge.fromJS(data["serviceCharge"]) : <any>undefined;
            this.serviceChargeId = data["serviceChargeId"];
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceChargeTranslation {
        let result = new ServiceChargeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCharge"] = this.serviceCharge ? this.serviceCharge.toJSON() : <any>undefined;
        data["serviceChargeId"] = this.serviceChargeId;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceChargeTranslation {
    serviceCharge: ServiceCharge;
    serviceChargeId: number;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RoleClaim implements IRoleClaim {
    tenantId: number;
    roleId: number;
    claimType: string;
    claimValue: string;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.roleId = data["roleId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleClaim {
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleClaim {
    tenantId: number;
    roleId: number;
    claimType: string;
    claimValue: string;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RolePermissionSetting implements IRolePermissionSetting {
    roleId: number;
    tenantId: number;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRolePermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RolePermissionSetting {
        let result = new RolePermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRolePermissionSetting {
    roleId: number;
    tenantId: number;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class StockPeriod implements IStockPeriod {
    tenantId: number;
    periodType: StockPeriodPeriodType;
    from: moment.Moment;
    to: moment.Moment;
    stockPeriodClosingDates: StockPeriodClosingDate[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IStockPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.periodType = data["periodType"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            if (data["stockPeriodClosingDates"] && data["stockPeriodClosingDates"].constructor === Array) {
                this.stockPeriodClosingDates = [];
                for (let item of data["stockPeriodClosingDates"])
                    this.stockPeriodClosingDates.push(StockPeriodClosingDate.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StockPeriod {
        let result = new StockPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["periodType"] = this.periodType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (this.stockPeriodClosingDates && this.stockPeriodClosingDates.constructor === Array) {
            data["stockPeriodClosingDates"] = [];
            for (let item of this.stockPeriodClosingDates)
                data["stockPeriodClosingDates"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStockPeriod {
    tenantId: number;
    periodType: StockPeriodPeriodType;
    from: moment.Moment;
    to: moment.Moment;
    stockPeriodClosingDates: StockPeriodClosingDate[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DetailTransactionTemplate implements IDetailTransactionTemplate {
    detailTransactionId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    qty: number;
    lotNumber: number;
    originalQunatity: number;
    qtyReceive: number;
    discount: number;
    price: number;
    tax: number;
    notes: string;
    dueDate: moment.Moment;
    tenantId: number;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    productLotId: number;
    productLot: ProductLot;
    productId: number;
    product: Product;
    productVariantId: number;
    unitOfMeasureId: number;
    productVariant: ProductVariant;
    unitOfMeasure: UnitOfMeasure;
    taxId: number;
    netAfterVat: number;
    taxType: Tax;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDetailTransactionTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailTransactionId = data["detailTransactionId"];
            this.materialId = data["materialId"];
            this.rawMaterial = data["rawMaterial"] ? RawMaterial.fromJS(data["rawMaterial"]) : <any>undefined;
            this.qty = data["qty"];
            this.lotNumber = data["lotNumber"];
            this.originalQunatity = data["originalQunatity"];
            this.qtyReceive = data["qtyReceive"];
            this.discount = data["discount"];
            this.price = data["price"];
            this.tax = data["tax"];
            this.notes = data["notes"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.transactionTemplate = data["transactionTemplate"] ? TransactionTemplate.fromJS(data["transactionTemplate"]) : <any>undefined;
            this.productLotId = data["productLotId"];
            this.productLot = data["productLot"] ? ProductLot.fromJS(data["productLot"]) : <any>undefined;
            this.productId = data["productId"];
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>undefined;
            this.productVariantId = data["productVariantId"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.productVariant = data["productVariant"] ? ProductVariant.fromJS(data["productVariant"]) : <any>undefined;
            this.unitOfMeasure = data["unitOfMeasure"] ? UnitOfMeasure.fromJS(data["unitOfMeasure"]) : <any>undefined;
            this.taxId = data["taxId"];
            this.netAfterVat = data["netAfterVat"];
            this.taxType = data["taxType"] ? Tax.fromJS(data["taxType"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DetailTransactionTemplate {
        let result = new DetailTransactionTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailTransactionId"] = this.detailTransactionId;
        data["materialId"] = this.materialId;
        data["rawMaterial"] = this.rawMaterial ? this.rawMaterial.toJSON() : <any>undefined;
        data["qty"] = this.qty;
        data["lotNumber"] = this.lotNumber;
        data["originalQunatity"] = this.originalQunatity;
        data["qtyReceive"] = this.qtyReceive;
        data["discount"] = this.discount;
        data["price"] = this.price;
        data["tax"] = this.tax;
        data["notes"] = this.notes;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["transactionTemplate"] = this.transactionTemplate ? this.transactionTemplate.toJSON() : <any>undefined;
        data["productLotId"] = this.productLotId;
        data["productLot"] = this.productLot ? this.productLot.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productVariantId"] = this.productVariantId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["productVariant"] = this.productVariant ? this.productVariant.toJSON() : <any>undefined;
        data["unitOfMeasure"] = this.unitOfMeasure ? this.unitOfMeasure.toJSON() : <any>undefined;
        data["taxId"] = this.taxId;
        data["netAfterVat"] = this.netAfterVat;
        data["taxType"] = this.taxType ? this.taxType.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDetailTransactionTemplate {
    detailTransactionId: number;
    materialId: number;
    rawMaterial: RawMaterial;
    qty: number;
    lotNumber: number;
    originalQunatity: number;
    qtyReceive: number;
    discount: number;
    price: number;
    tax: number;
    notes: string;
    dueDate: moment.Moment;
    tenantId: number;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    productLotId: number;
    productLot: ProductLot;
    productId: number;
    product: Product;
    productVariantId: number;
    unitOfMeasureId: number;
    productVariant: ProductVariant;
    unitOfMeasure: UnitOfMeasure;
    taxId: number;
    netAfterVat: number;
    taxType: Tax;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TransactionTemplateTranslation implements ITransactionTemplateTranslation {
    name: string;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITransactionTemplateTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.transactionTemplate = data["transactionTemplate"] ? TransactionTemplate.fromJS(data["transactionTemplate"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionTemplateTranslation {
        let result = new TransactionTemplateTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["transactionTemplate"] = this.transactionTemplate ? this.transactionTemplate.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionTemplateTranslation {
    name: string;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TransactionTemplateType implements ITransactionTemplateType {
    tenantId: number;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    transactionType: TransactionType;
    transactionTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITransactionTemplateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.transactionTemplateId = data["transactionTemplateId"];
            this.transactionTemplate = data["transactionTemplate"] ? TransactionTemplate.fromJS(data["transactionTemplate"]) : <any>undefined;
            this.transactionType = data["transactionType"] ? TransactionType.fromJS(data["transactionType"]) : <any>undefined;
            this.transactionTypeId = data["transactionTypeId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionTemplateType {
        let result = new TransactionTemplateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["transactionTemplateId"] = this.transactionTemplateId;
        data["transactionTemplate"] = this.transactionTemplate ? this.transactionTemplate.toJSON() : <any>undefined;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionTemplateType {
    tenantId: number;
    transactionTemplateId: number;
    transactionTemplate: TransactionTemplate;
    transactionType: TransactionType;
    transactionTypeId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DiscountTypeTranslation implements IDiscountTypeTranslation {
    name: string;
    discountTypeId: number;
    discountType: DiscountType;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDiscountTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.discountTypeId = data["discountTypeId"];
            this.discountType = data["discountType"] ? DiscountType.fromJS(data["discountType"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DiscountTypeTranslation {
        let result = new DiscountTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["discountTypeId"] = this.discountTypeId;
        data["discountType"] = this.discountType ? this.discountType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDiscountTypeTranslation {
    name: string;
    discountTypeId: number;
    discountType: DiscountType;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DiscountTypeCustomer implements IDiscountTypeCustomer {
    discountTypeId: number;
    discountType: DiscountType;
    customerId: string;
    customer: Customer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDiscountTypeCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountTypeId = data["discountTypeId"];
            this.discountType = data["discountType"] ? DiscountType.fromJS(data["discountType"]) : <any>undefined;
            this.customerId = data["customerId"];
            this.customer = data["customer"] ? Customer.fromJS(data["customer"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DiscountTypeCustomer {
        let result = new DiscountTypeCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountTypeId"] = this.discountTypeId;
        data["discountType"] = this.discountType ? this.discountType.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDiscountTypeCustomer {
    discountTypeId: number;
    discountType: DiscountType;
    customerId: string;
    customer: Customer;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ComboMealPackageTranslation implements IComboMealPackageTranslation {
    name: string;
    comboMealPackageId: number;
    comboMealPackage: ComboMealPackage;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IComboMealPackageTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.comboMealPackageId = data["comboMealPackageId"];
            this.comboMealPackage = data["comboMealPackage"] ? ComboMealPackage.fromJS(data["comboMealPackage"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboMealPackageTranslation {
        let result = new ComboMealPackageTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["comboMealPackageId"] = this.comboMealPackageId;
        data["comboMealPackage"] = this.comboMealPackage ? this.comboMealPackage.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboMealPackageTranslation {
    name: string;
    comboMealPackageId: number;
    comboMealPackage: ComboMealPackage;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Schema implements ISchema {
    tenantId: number;
    clubId: number;
    club: Club;
    translations: SchemaTranslation[];
    minPoints: number;
    maxPoints: number;
    pointUser: number;
    moneySystem: number;
    moneyUser: number;
    pointSystem: number;
    pointExpirationDays: number;
    activeDays: number;
    schemas: SchemaAccount[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISchema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.clubId = data["clubId"];
            this.club = data["club"] ? Club.fromJS(data["club"]) : <any>undefined;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(SchemaTranslation.fromJS(item));
            }
            this.minPoints = data["minPoints"];
            this.maxPoints = data["maxPoints"];
            this.pointUser = data["pointUser"];
            this.moneySystem = data["moneySystem"];
            this.moneyUser = data["moneyUser"];
            this.pointSystem = data["pointSystem"];
            this.pointExpirationDays = data["pointExpirationDays"];
            this.activeDays = data["activeDays"];
            if (data["schemas"] && data["schemas"].constructor === Array) {
                this.schemas = [];
                for (let item of data["schemas"])
                    this.schemas.push(SchemaAccount.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Schema {
        let result = new Schema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["clubId"] = this.clubId;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["minPoints"] = this.minPoints;
        data["maxPoints"] = this.maxPoints;
        data["pointUser"] = this.pointUser;
        data["moneySystem"] = this.moneySystem;
        data["moneyUser"] = this.moneyUser;
        data["pointSystem"] = this.pointSystem;
        data["pointExpirationDays"] = this.pointExpirationDays;
        data["activeDays"] = this.activeDays;
        if (this.schemas && this.schemas.constructor === Array) {
            data["schemas"] = [];
            for (let item of this.schemas)
                data["schemas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISchema {
    tenantId: number;
    clubId: number;
    club: Club;
    translations: SchemaTranslation[];
    minPoints: number;
    maxPoints: number;
    pointUser: number;
    moneySystem: number;
    moneyUser: number;
    pointSystem: number;
    pointExpirationDays: number;
    activeDays: number;
    schemas: SchemaAccount[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TenderTypeMasterTranslation implements ITenderTypeMasterTranslation {
    name: string;
    tenderTypeMasterId: number;
    tenderTypeMaster: TenderTypeMaster;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITenderTypeMasterTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.tenderTypeMasterId = data["tenderTypeMasterId"];
            this.tenderTypeMaster = data["tenderTypeMaster"] ? TenderTypeMaster.fromJS(data["tenderTypeMaster"]) : <any>undefined;
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenderTypeMasterTranslation {
        let result = new TenderTypeMasterTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tenderTypeMasterId"] = this.tenderTypeMasterId;
        data["tenderTypeMaster"] = this.tenderTypeMaster ? this.tenderTypeMaster.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenderTypeMasterTranslation {
    name: string;
    tenderTypeMasterId: number;
    tenderTypeMaster: TenderTypeMaster;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PromotionFBAdditionalFreeItemsExcludedMenuItem implements IPromotionFBAdditionalFreeItemsExcludedMenuItem {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    promotionFBAdditionalFreeItemId: number;
    promotionFBAdditionalFreeItem: PromotionFBAdditionalFreeItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPromotionFBAdditionalFreeItemsExcludedMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.menuItemId = data["menuItemId"];
            this.menuItem = data["menuItem"] ? MenuItem.fromJS(data["menuItem"]) : <any>undefined;
            this.promotionFBAdditionalFreeItemId = data["promotionFBAdditionalFreeItemId"];
            this.promotionFBAdditionalFreeItem = data["promotionFBAdditionalFreeItem"] ? PromotionFBAdditionalFreeItem.fromJS(data["promotionFBAdditionalFreeItem"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PromotionFBAdditionalFreeItemsExcludedMenuItem {
        let result = new PromotionFBAdditionalFreeItemsExcludedMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["menuItemId"] = this.menuItemId;
        data["menuItem"] = this.menuItem ? this.menuItem.toJSON() : <any>undefined;
        data["promotionFBAdditionalFreeItemId"] = this.promotionFBAdditionalFreeItemId;
        data["promotionFBAdditionalFreeItem"] = this.promotionFBAdditionalFreeItem ? this.promotionFBAdditionalFreeItem.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPromotionFBAdditionalFreeItemsExcludedMenuItem {
    tenantId: number;
    menuItemId: number;
    menuItem: MenuItem;
    promotionFBAdditionalFreeItemId: number;
    promotionFBAdditionalFreeItem: PromotionFBAdditionalFreeItem;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class DeliveryTranslation implements IDeliveryTranslation {
    deliveryId: number;
    delivery: Delivery;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IDeliveryTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveryId = data["deliveryId"];
            this.delivery = data["delivery"] ? Delivery.fromJS(data["delivery"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeliveryTranslation {
        let result = new DeliveryTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["delivery"] = this.delivery ? this.delivery.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeliveryTranslation {
    deliveryId: number;
    delivery: Delivery;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RefundReson implements IRefundReson {
    code: string;
    description: string;
    tenantId: number;
    saleNotificationReasonDetails: SaleNotificationReasonDetail[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRefundReson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.description = data["description"];
            this.tenantId = data["tenantId"];
            if (data["saleNotificationReasonDetails"] && data["saleNotificationReasonDetails"].constructor === Array) {
                this.saleNotificationReasonDetails = [];
                for (let item of data["saleNotificationReasonDetails"])
                    this.saleNotificationReasonDetails.push(SaleNotificationReasonDetail.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RefundReson {
        let result = new RefundReson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        if (this.saleNotificationReasonDetails && this.saleNotificationReasonDetails.constructor === Array) {
            data["saleNotificationReasonDetails"] = [];
            for (let item of this.saleNotificationReasonDetails)
                data["saleNotificationReasonDetails"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRefundReson {
    code: string;
    description: string;
    tenantId: number;
    saleNotificationReasonDetails: SaleNotificationReasonDetail[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RoleTransactionType implements IRoleTransactionType {
    roleId: number;
    role: Role;
    transactionTypeId: number;
    transactionType: TransactionType;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRoleTransactionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.role = data["role"] ? Role.fromJS(data["role"]) : <any>undefined;
            this.transactionTypeId = data["transactionTypeId"];
            this.transactionType = data["transactionType"] ? TransactionType.fromJS(data["transactionType"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleTransactionType {
        let result = new RoleTransactionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleTransactionType {
    roleId: number;
    role: Role;
    transactionTypeId: number;
    transactionType: TransactionType;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TransactionTypeTranslation implements ITransactionTypeTranslation {
    name: string;
    transactionTypeId: number;
    transactionType: TransactionType;
    tenantId: number;
    language: ApplicationLanguage;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITransactionTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.transactionTypeId = data["transactionTypeId"];
            this.transactionType = data["transactionType"] ? TransactionType.fromJS(data["transactionType"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionTypeTranslation {
        let result = new TransactionTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionTypeTranslation {
    name: string;
    transactionTypeId: number;
    transactionType: TransactionType;
    tenantId: number;
    language: ApplicationLanguage;
    languageId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class Club implements IClub {
    tenantId: number;
    translations: ClubTranslation[];
    schemas: Schema[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IClub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ClubTranslation.fromJS(item));
            }
            if (data["schemas"] && data["schemas"].constructor === Array) {
                this.schemas = [];
                for (let item of data["schemas"])
                    this.schemas.push(Schema.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Club {
        let result = new Club();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (this.schemas && this.schemas.constructor === Array) {
            data["schemas"] = [];
            for (let item of this.schemas)
                data["schemas"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IClub {
    tenantId: number;
    translations: ClubTranslation[];
    schemas: Schema[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SchemaTranslation implements ISchemaTranslation {
    schemaId: number;
    schema: Schema;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISchemaTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schemaId = data["schemaId"];
            this.schema = data["schema"] ? Schema.fromJS(data["schema"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SchemaTranslation {
        let result = new SchemaTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaId"] = this.schemaId;
        data["schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISchemaTranslation {
    schemaId: number;
    schema: Schema;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ClubTranslation implements IClubTranslation {
    clubId: number;
    club: Club;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IClubTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clubId = data["clubId"];
            this.club = data["club"] ? Club.fromJS(data["club"]) : <any>undefined;
            this.name = data["name"];
            this.language = data["language"] ? ApplicationLanguage.fromJS(data["language"]) : <any>undefined;
            this.languageId = data["languageId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ClubTranslation {
        let result = new ClubTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IClubTranslation {
    clubId: number;
    club: Club;
    name: string;
    language: ApplicationLanguage;
    languageId: number;
    tenantId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ZatcaCertificateUpdate implements IZatcaCertificateUpdate {
    id: string;
    processorId: string;

    constructor(data?: IZatcaCertificateUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.processorId = data["processorId"];
        }
    }

    static fromJS(data: any): ZatcaCertificateUpdate {
        let result = new ZatcaCertificateUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processorId"] = this.processorId;
        return data; 
    }
}

export interface IZatcaCertificateUpdate {
    id: string;
    processorId: string;
}

export class CreateZatcaTransactionInput implements ICreateZatcaTransactionInput {
    id: string;
    notes: string;
    receiptNumber: string;
    totalPrice: number;
    discountValue: number;
    totalPriceAfterDiscount: number;
    totalVatValue: number;
    totalPriceWithVat: number;
    issueDate: string;
    issueTime: string;
    invoiceType: string;
    invoiceTypeCodeId: number;
    invoiceTypeCodeName: string;
    qrCode: string;
    statusId: number;
    mode: number;
    templateType: number;
    paymentMethod: number;
    customerType: string;
    customerId: string;
    returnedFromTransactionId: string;
    customerCode: string;
    zatcaInvoiceItems: ZatcaTransactionItemsDto[];
    zatcaInvoiceDiscounts: ZatcaTransactionDiscountDto[];
    customerParty: CustomerParty;
    creationTime: moment.Moment;

    constructor(data?: ICreateZatcaTransactionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.notes = data["notes"];
            this.receiptNumber = data["receiptNumber"];
            this.totalPrice = data["totalPrice"];
            this.discountValue = data["discountValue"];
            this.totalPriceAfterDiscount = data["totalPriceAfterDiscount"];
            this.totalVatValue = data["totalVatValue"];
            this.totalPriceWithVat = data["totalPriceWithVat"];
            this.issueDate = data["issueDate"];
            this.issueTime = data["issueTime"];
            this.invoiceType = data["invoiceType"];
            this.invoiceTypeCodeId = data["invoiceTypeCodeId"];
            this.invoiceTypeCodeName = data["invoiceTypeCodeName"];
            this.qrCode = data["qrCode"];
            this.statusId = data["statusId"];
            this.mode = data["mode"];
            this.templateType = data["templateType"];
            this.paymentMethod = data["paymentMethod"];
            this.customerType = data["customerType"];
            this.customerId = data["customerId"];
            this.returnedFromTransactionId = data["returnedFromTransactionId"];
            this.customerCode = data["customerCode"];
            if (data["zatcaInvoiceItems"] && data["zatcaInvoiceItems"].constructor === Array) {
                this.zatcaInvoiceItems = [];
                for (let item of data["zatcaInvoiceItems"])
                    this.zatcaInvoiceItems.push(ZatcaTransactionItemsDto.fromJS(item));
            }
            if (data["zatcaInvoiceDiscounts"] && data["zatcaInvoiceDiscounts"].constructor === Array) {
                this.zatcaInvoiceDiscounts = [];
                for (let item of data["zatcaInvoiceDiscounts"])
                    this.zatcaInvoiceDiscounts.push(ZatcaTransactionDiscountDto.fromJS(item));
            }
            this.customerParty = data["customerParty"] ? CustomerParty.fromJS(data["customerParty"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateZatcaTransactionInput {
        let result = new CreateZatcaTransactionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["receiptNumber"] = this.receiptNumber;
        data["totalPrice"] = this.totalPrice;
        data["discountValue"] = this.discountValue;
        data["totalPriceAfterDiscount"] = this.totalPriceAfterDiscount;
        data["totalVatValue"] = this.totalVatValue;
        data["totalPriceWithVat"] = this.totalPriceWithVat;
        data["issueDate"] = this.issueDate;
        data["issueTime"] = this.issueTime;
        data["invoiceType"] = this.invoiceType;
        data["invoiceTypeCodeId"] = this.invoiceTypeCodeId;
        data["invoiceTypeCodeName"] = this.invoiceTypeCodeName;
        data["qrCode"] = this.qrCode;
        data["statusId"] = this.statusId;
        data["mode"] = this.mode;
        data["templateType"] = this.templateType;
        data["paymentMethod"] = this.paymentMethod;
        data["customerType"] = this.customerType;
        data["customerId"] = this.customerId;
        data["returnedFromTransactionId"] = this.returnedFromTransactionId;
        data["customerCode"] = this.customerCode;
        if (this.zatcaInvoiceItems && this.zatcaInvoiceItems.constructor === Array) {
            data["zatcaInvoiceItems"] = [];
            for (let item of this.zatcaInvoiceItems)
                data["zatcaInvoiceItems"].push(item.toJSON());
        }
        if (this.zatcaInvoiceDiscounts && this.zatcaInvoiceDiscounts.constructor === Array) {
            data["zatcaInvoiceDiscounts"] = [];
            for (let item of this.zatcaInvoiceDiscounts)
                data["zatcaInvoiceDiscounts"].push(item.toJSON());
        }
        data["customerParty"] = this.customerParty ? this.customerParty.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICreateZatcaTransactionInput {
    id: string;
    notes: string;
    receiptNumber: string;
    totalPrice: number;
    discountValue: number;
    totalPriceAfterDiscount: number;
    totalVatValue: number;
    totalPriceWithVat: number;
    issueDate: string;
    issueTime: string;
    invoiceType: string;
    invoiceTypeCodeId: number;
    invoiceTypeCodeName: string;
    qrCode: string;
    statusId: number;
    mode: number;
    templateType: number;
    paymentMethod: number;
    customerType: string;
    customerId: string;
    returnedFromTransactionId: string;
    customerCode: string;
    zatcaInvoiceItems: ZatcaTransactionItemsDto[];
    zatcaInvoiceDiscounts: ZatcaTransactionDiscountDto[];
    customerParty: CustomerParty;
    creationTime: moment.Moment;
}

export class ZatcaTransactionItemsDto implements IZatcaTransactionItemsDto {
    productName: string;
    productPrice: number;
    productQuantity: number;
    totalPrice: number;
    discountValue: number;
    totalPriceAfterDiscount: number;
    vatPercentage: number;
    vatValue: number;
    totalWithVat: number;
    id: string;

    constructor(data?: IZatcaTransactionItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productName = data["productName"];
            this.productPrice = data["productPrice"];
            this.productQuantity = data["productQuantity"];
            this.totalPrice = data["totalPrice"];
            this.discountValue = data["discountValue"];
            this.totalPriceAfterDiscount = data["totalPriceAfterDiscount"];
            this.vatPercentage = data["vatPercentage"];
            this.vatValue = data["vatValue"];
            this.totalWithVat = data["totalWithVat"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ZatcaTransactionItemsDto {
        let result = new ZatcaTransactionItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productPrice"] = this.productPrice;
        data["productQuantity"] = this.productQuantity;
        data["totalPrice"] = this.totalPrice;
        data["discountValue"] = this.discountValue;
        data["totalPriceAfterDiscount"] = this.totalPriceAfterDiscount;
        data["vatPercentage"] = this.vatPercentage;
        data["vatValue"] = this.vatValue;
        data["totalWithVat"] = this.totalWithVat;
        data["id"] = this.id;
        return data; 
    }
}

export interface IZatcaTransactionItemsDto {
    productName: string;
    productPrice: number;
    productQuantity: number;
    totalPrice: number;
    discountValue: number;
    totalPriceAfterDiscount: number;
    vatPercentage: number;
    vatValue: number;
    totalWithVat: number;
    id: string;
}

export class ZatcaTransactionDiscountDto implements IZatcaTransactionDiscountDto {
    reason: string;
    value: number;
    id: string;

    constructor(data?: IZatcaTransactionDiscountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reason = data["reason"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ZatcaTransactionDiscountDto {
        let result = new ZatcaTransactionDiscountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface IZatcaTransactionDiscountDto {
    reason: string;
    value: number;
    id: string;
}

export class CustomerParty implements ICustomerParty {
    commercialRegistrationNo: string;
    taxRegistrationNumber: string;
    companyName: string;
    street: string;
    buildingNumber: string;
    area: string;
    cityName: string;
    postalZone: string;
    identificationSchemeID: string;
    streetName: string;
    additionalStreetName: string;
    blockNo: string;
    governorate: string;
    country: string;

    constructor(data?: ICustomerParty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commercialRegistrationNo = data["commercialRegistrationNo"];
            this.taxRegistrationNumber = data["taxRegistrationNumber"];
            this.companyName = data["companyName"];
            this.street = data["street"];
            this.buildingNumber = data["buildingNumber"];
            this.area = data["area"];
            this.cityName = data["cityName"];
            this.postalZone = data["postalZone"];
            this.identificationSchemeID = data["identificationSchemeID"];
            this.streetName = data["streetName"];
            this.additionalStreetName = data["additionalStreetName"];
            this.blockNo = data["blockNo"];
            this.governorate = data["governorate"];
            this.country = data["country"];
        }
    }

    static fromJS(data: any): CustomerParty {
        let result = new CustomerParty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commercialRegistrationNo"] = this.commercialRegistrationNo;
        data["taxRegistrationNumber"] = this.taxRegistrationNumber;
        data["companyName"] = this.companyName;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        data["area"] = this.area;
        data["cityName"] = this.cityName;
        data["postalZone"] = this.postalZone;
        data["identificationSchemeID"] = this.identificationSchemeID;
        data["streetName"] = this.streetName;
        data["additionalStreetName"] = this.additionalStreetName;
        data["blockNo"] = this.blockNo;
        data["governorate"] = this.governorate;
        data["country"] = this.country;
        return data; 
    }
}

export interface ICustomerParty {
    commercialRegistrationNo: string;
    taxRegistrationNumber: string;
    companyName: string;
    street: string;
    buildingNumber: string;
    area: string;
    cityName: string;
    postalZone: string;
    identificationSchemeID: string;
    streetName: string;
    additionalStreetName: string;
    blockNo: string;
    governorate: string;
    country: string;
}

export class ValueTupleOfResultAndInvoiceTypeCodeAndInt32 implements IValueTupleOfResultAndInvoiceTypeCodeAndInt32 {
    item1: Result;
    item2: InvoiceTypeCode;
    item3: number;

    constructor(data?: IValueTupleOfResultAndInvoiceTypeCodeAndInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"] ? Result.fromJS(data["item1"]) : <any>undefined;
            this.item2 = data["item2"] ? InvoiceTypeCode.fromJS(data["item2"]) : <any>undefined;
            this.item3 = data["item3"];
        }
    }

    static fromJS(data: any): ValueTupleOfResultAndInvoiceTypeCodeAndInt32 {
        let result = new ValueTupleOfResultAndInvoiceTypeCodeAndInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3;
        return data; 
    }
}

export interface IValueTupleOfResultAndInvoiceTypeCodeAndInt32 {
    item1: Result;
    item2: InvoiceTypeCode;
    item3: number;
}

export class Result implements IResult {
    operation: string;
    isValid: boolean;
    errorMessage: string;
    resultedValue: string;
    lstSteps: Result[];
    singedXML: string;
    singedXMLFileName: string;
    singedXMLFileNameFullPath: string;
    invoiceHash: string;
    uuid: string;
    encodedInvoice: string;
    pih: string;
    qrCode: string;
    lineExtensionAmount: string;
    taxExclusiveAmount: string;
    taxInclusiveAmount: string;
    allowanceTotalAmount: string;
    chargeTotalAmount: string;
    payableAmount: string;
    prepaidAmount: string;
    taxAmount: string;
    singedXMLFileNameShortPath: string;
    normalXMLFileNameFullPath: string;
    normalXMLFileNameShortPath: string;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.operation = data["operation"];
            this.isValid = data["isValid"];
            this.errorMessage = data["errorMessage"];
            this.resultedValue = data["resultedValue"];
            if (data["lstSteps"] && data["lstSteps"].constructor === Array) {
                this.lstSteps = [];
                for (let item of data["lstSteps"])
                    this.lstSteps.push(Result.fromJS(item));
            }
            this.singedXML = data["singedXML"];
            this.singedXMLFileName = data["singedXMLFileName"];
            this.singedXMLFileNameFullPath = data["singedXMLFileNameFullPath"];
            this.invoiceHash = data["invoiceHash"];
            this.uuid = data["uuid"];
            this.encodedInvoice = data["encodedInvoice"];
            this.pih = data["pih"];
            this.qrCode = data["qrCode"];
            this.lineExtensionAmount = data["lineExtensionAmount"];
            this.taxExclusiveAmount = data["taxExclusiveAmount"];
            this.taxInclusiveAmount = data["taxInclusiveAmount"];
            this.allowanceTotalAmount = data["allowanceTotalAmount"];
            this.chargeTotalAmount = data["chargeTotalAmount"];
            this.payableAmount = data["payableAmount"];
            this.prepaidAmount = data["prepaidAmount"];
            this.taxAmount = data["taxAmount"];
            this.singedXMLFileNameShortPath = data["singedXMLFileNameShortPath"];
            this.normalXMLFileNameFullPath = data["normalXMLFileNameFullPath"];
            this.normalXMLFileNameShortPath = data["normalXMLFileNameShortPath"];
        }
    }

    static fromJS(data: any): Result {
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operation"] = this.operation;
        data["isValid"] = this.isValid;
        data["errorMessage"] = this.errorMessage;
        data["resultedValue"] = this.resultedValue;
        if (this.lstSteps && this.lstSteps.constructor === Array) {
            data["lstSteps"] = [];
            for (let item of this.lstSteps)
                data["lstSteps"].push(item.toJSON());
        }
        data["singedXML"] = this.singedXML;
        data["singedXMLFileName"] = this.singedXMLFileName;
        data["singedXMLFileNameFullPath"] = this.singedXMLFileNameFullPath;
        data["invoiceHash"] = this.invoiceHash;
        data["uuid"] = this.uuid;
        data["encodedInvoice"] = this.encodedInvoice;
        data["pih"] = this.pih;
        data["qrCode"] = this.qrCode;
        data["lineExtensionAmount"] = this.lineExtensionAmount;
        data["taxExclusiveAmount"] = this.taxExclusiveAmount;
        data["taxInclusiveAmount"] = this.taxInclusiveAmount;
        data["allowanceTotalAmount"] = this.allowanceTotalAmount;
        data["chargeTotalAmount"] = this.chargeTotalAmount;
        data["payableAmount"] = this.payableAmount;
        data["prepaidAmount"] = this.prepaidAmount;
        data["taxAmount"] = this.taxAmount;
        data["singedXMLFileNameShortPath"] = this.singedXMLFileNameShortPath;
        data["normalXMLFileNameFullPath"] = this.normalXMLFileNameFullPath;
        data["normalXMLFileNameShortPath"] = this.normalXMLFileNameShortPath;
        return data; 
    }
}

export interface IResult {
    operation: string;
    isValid: boolean;
    errorMessage: string;
    resultedValue: string;
    lstSteps: Result[];
    singedXML: string;
    singedXMLFileName: string;
    singedXMLFileNameFullPath: string;
    invoiceHash: string;
    uuid: string;
    encodedInvoice: string;
    pih: string;
    qrCode: string;
    lineExtensionAmount: string;
    taxExclusiveAmount: string;
    taxInclusiveAmount: string;
    allowanceTotalAmount: string;
    chargeTotalAmount: string;
    payableAmount: string;
    prepaidAmount: string;
    taxAmount: string;
    singedXMLFileNameShortPath: string;
    normalXMLFileNameFullPath: string;
    normalXMLFileNameShortPath: string;
}

export class InvoiceTypeCode implements IInvoiceTypeCode {
    id: number;
    name: string;

    constructor(data?: IInvoiceTypeCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): InvoiceTypeCode {
        let result = new InvoiceTypeCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IInvoiceTypeCode {
    id: number;
    name: string;
}

export class GetZatcaTransactionListOutput implements IGetZatcaTransactionListOutput {
    zatcaTransactionDDL: ZatcaTransactionDropList[];

    constructor(data?: IGetZatcaTransactionListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["zatcaTransactionDDL"] && data["zatcaTransactionDDL"].constructor === Array) {
                this.zatcaTransactionDDL = [];
                for (let item of data["zatcaTransactionDDL"])
                    this.zatcaTransactionDDL.push(ZatcaTransactionDropList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetZatcaTransactionListOutput {
        let result = new GetZatcaTransactionListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.zatcaTransactionDDL && this.zatcaTransactionDDL.constructor === Array) {
            data["zatcaTransactionDDL"] = [];
            for (let item of this.zatcaTransactionDDL)
                data["zatcaTransactionDDL"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetZatcaTransactionListOutput {
    zatcaTransactionDDL: ZatcaTransactionDropList[];
}

export class ZatcaTransactionDropList implements IZatcaTransactionDropList {
    id: string;
    text: string;

    constructor(data?: IZatcaTransactionDropList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.text = data["text"];
        }
    }

    static fromJS(data: any): ZatcaTransactionDropList {
        let result = new ZatcaTransactionDropList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data; 
    }
}

export interface IZatcaTransactionDropList {
    id: string;
    text: string;
}

export class ValueTupleOfStringAndBoolean implements IValueTupleOfStringAndBoolean {
    item1: string;
    item2: boolean;

    constructor(data?: IValueTupleOfStringAndBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfStringAndBoolean {
        let result = new ValueTupleOfStringAndBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data; 
    }
}

export interface IValueTupleOfStringAndBoolean {
    item1: string;
    item2: boolean;
}

export class ZATCATenantSettingsDto implements IZATCATenantSettingsDto {
    commercialRegistrationNo: string;
    taxRegistrationNumber: string;
    branchName: string;
    companyName: string;
    street: string;
    buildingNumber: string;
    area: string;
    address: string;
    cityName: string;
    postalZone: string;
    otp: string;
    invoiceType: string;
    businessCategory: string;
    serialNumber: string;
    tenantId: string;

    constructor(data?: IZATCATenantSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commercialRegistrationNo = data["commercialRegistrationNo"];
            this.taxRegistrationNumber = data["taxRegistrationNumber"];
            this.branchName = data["branchName"];
            this.companyName = data["companyName"];
            this.street = data["street"];
            this.buildingNumber = data["buildingNumber"];
            this.area = data["area"];
            this.address = data["address"];
            this.cityName = data["cityName"];
            this.postalZone = data["postalZone"];
            this.otp = data["otp"];
            this.invoiceType = data["invoiceType"];
            this.businessCategory = data["businessCategory"];
            this.serialNumber = data["serialNumber"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): ZATCATenantSettingsDto {
        let result = new ZATCATenantSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commercialRegistrationNo"] = this.commercialRegistrationNo;
        data["taxRegistrationNumber"] = this.taxRegistrationNumber;
        data["branchName"] = this.branchName;
        data["companyName"] = this.companyName;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        data["area"] = this.area;
        data["address"] = this.address;
        data["cityName"] = this.cityName;
        data["postalZone"] = this.postalZone;
        data["otp"] = this.otp;
        data["invoiceType"] = this.invoiceType;
        data["businessCategory"] = this.businessCategory;
        data["serialNumber"] = this.serialNumber;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IZATCATenantSettingsDto {
    commercialRegistrationNo: string;
    taxRegistrationNumber: string;
    branchName: string;
    companyName: string;
    street: string;
    buildingNumber: string;
    area: string;
    address: string;
    cityName: string;
    postalZone: string;
    otp: string;
    invoiceType: string;
    businessCategory: string;
    serialNumber: string;
    tenantId: string;
}

export class CertificateResponse implements ICertificateResponse {
    errorMessage: string;
    isSuccess: boolean;
    csr: string;
    privateKey: string;
    csid: string;
    secretKey: string;
    businessCategory: string;
    branchName: string;
    invoiceType: string;

    constructor(data?: ICertificateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.errorMessage = data["errorMessage"];
            this.isSuccess = data["isSuccess"];
            this.csr = data["csr"];
            this.privateKey = data["privateKey"];
            this.csid = data["csid"];
            this.secretKey = data["secretKey"];
            this.businessCategory = data["businessCategory"];
            this.branchName = data["branchName"];
            this.invoiceType = data["invoiceType"];
        }
    }

    static fromJS(data: any): CertificateResponse {
        let result = new CertificateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        data["csr"] = this.csr;
        data["privateKey"] = this.privateKey;
        data["csid"] = this.csid;
        data["secretKey"] = this.secretKey;
        data["businessCategory"] = this.businessCategory;
        data["branchName"] = this.branchName;
        data["invoiceType"] = this.invoiceType;
        return data; 
    }
}

export interface ICertificateResponse {
    errorMessage: string;
    isSuccess: boolean;
    csr: string;
    privateKey: string;
    csid: string;
    secretKey: string;
    businessCategory: string;
    branchName: string;
    invoiceType: string;
}

export class UploadZatcaXmlInput implements IUploadZatcaXmlInput {
    storeId: number;
    zipBase64: string;

    constructor(data?: IUploadZatcaXmlInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeId = data["storeId"];
            this.zipBase64 = data["zipBase64"];
        }
    }

    static fromJS(data: any): UploadZatcaXmlInput {
        let result = new UploadZatcaXmlInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["zipBase64"] = this.zipBase64;
        return data; 
    }
}

export interface IUploadZatcaXmlInput {
    storeId: number;
    zipBase64: string;
}

export class UploadZatcaXmlOutput implements IUploadZatcaXmlOutput {
    acceptedUuids: string[];
    errors: string[];

    constructor(data?: IUploadZatcaXmlOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["acceptedUuids"] && data["acceptedUuids"].constructor === Array) {
                this.acceptedUuids = [];
                for (let item of data["acceptedUuids"])
                    this.acceptedUuids.push(item);
            }
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): UploadZatcaXmlOutput {
        let result = new UploadZatcaXmlOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.acceptedUuids && this.acceptedUuids.constructor === Array) {
            data["acceptedUuids"] = [];
            for (let item of this.acceptedUuids)
                data["acceptedUuids"].push(item);
        }
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }
}

export interface IUploadZatcaXmlOutput {
    acceptedUuids: string[];
    errors: string[];
}

export class PagedZatcaTransactionResultRequestDto implements IPagedZatcaTransactionResultRequestDto {
    tenantIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    zatcaTransactionStatus: number;
    zatcaReportingStatus: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
    sorting: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IPagedZatcaTransactionResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (let item of data["tenantIds"])
                    this.tenantIds.push(item);
            }
            this.regionId = data["regionId"];
            this.areaId = data["areaId"];
            if (data["storeIds"] && data["storeIds"].constructor === Array) {
                this.storeIds = [];
                for (let item of data["storeIds"])
                    this.storeIds.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.zatcaTransactionStatus = data["zatcaTransactionStatus"];
            this.zatcaReportingStatus = data["zatcaReportingStatus"];
            this.isEndOfDay = data["isEndOfDay"];
            this.isCSVFile = data["isCSVFile"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): PagedZatcaTransactionResultRequestDto {
        let result = new PagedZatcaTransactionResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["regionId"] = this.regionId;
        data["areaId"] = this.areaId;
        if (this.storeIds && this.storeIds.constructor === Array) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["zatcaTransactionStatus"] = this.zatcaTransactionStatus;
        data["zatcaReportingStatus"] = this.zatcaReportingStatus;
        data["isEndOfDay"] = this.isEndOfDay;
        data["isCSVFile"] = this.isCSVFile;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface IPagedZatcaTransactionResultRequestDto {
    tenantIds: number[];
    regionId: number;
    areaId: number;
    storeIds: number[];
    fromDate: moment.Moment;
    toDate: moment.Moment;
    zatcaTransactionStatus: number;
    zatcaReportingStatus: number;
    isEndOfDay: boolean;
    isCSVFile: boolean;
    sorting: string;
    skipCount: number;
    maxResultCount: number;
}

export class ZatcaTransactionPagedResultDto implements IZatcaTransactionPagedResultDto {
    totalWithoutVatReported: number;
    totalVatReported: number;
    totalWithVatReported: number;
    totalWithoutVatNotReported: number;
    totalVatNotReported: number;
    totalWithVatNotReported: number;
    totalCount: number;
    items: ZatcaTransactionReportDto[];

    constructor(data?: IZatcaTransactionPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalWithoutVatReported = data["totalWithoutVatReported"];
            this.totalVatReported = data["totalVatReported"];
            this.totalWithVatReported = data["totalWithVatReported"];
            this.totalWithoutVatNotReported = data["totalWithoutVatNotReported"];
            this.totalVatNotReported = data["totalVatNotReported"];
            this.totalWithVatNotReported = data["totalWithVatNotReported"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ZatcaTransactionReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZatcaTransactionPagedResultDto {
        let result = new ZatcaTransactionPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWithoutVatReported"] = this.totalWithoutVatReported;
        data["totalVatReported"] = this.totalVatReported;
        data["totalWithVatReported"] = this.totalWithVatReported;
        data["totalWithoutVatNotReported"] = this.totalWithoutVatNotReported;
        data["totalVatNotReported"] = this.totalVatNotReported;
        data["totalWithVatNotReported"] = this.totalWithVatNotReported;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IZatcaTransactionPagedResultDto {
    totalWithoutVatReported: number;
    totalVatReported: number;
    totalWithVatReported: number;
    totalWithoutVatNotReported: number;
    totalVatNotReported: number;
    totalWithVatNotReported: number;
    totalCount: number;
    items: ZatcaTransactionReportDto[];
}

export class ZatcaTransactionReportDto implements IZatcaTransactionReportDto {
    storeCode: string;
    storeName: string;
    date: moment.Moment;
    dateTxt: string;
    recieptNumber: string;
    subTotal: number;
    vat: number;
    discount: number;
    total: number;
    tenantId: number;
    invoiceTypeCode: string;
    statusId: number;
    reportingStatusId: number;
    tenantName: string;
    id: string;

    constructor(data?: IZatcaTransactionReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.storeCode = data["storeCode"];
            this.storeName = data["storeName"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.dateTxt = data["dateTxt"];
            this.recieptNumber = data["recieptNumber"];
            this.subTotal = data["subTotal"];
            this.vat = data["vat"];
            this.discount = data["discount"];
            this.total = data["total"];
            this.tenantId = data["tenantId"];
            this.invoiceTypeCode = data["invoiceTypeCode"];
            this.statusId = data["statusId"];
            this.reportingStatusId = data["reportingStatusId"];
            this.tenantName = data["tenantName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ZatcaTransactionReportDto {
        let result = new ZatcaTransactionReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateTxt"] = this.dateTxt;
        data["recieptNumber"] = this.recieptNumber;
        data["subTotal"] = this.subTotal;
        data["vat"] = this.vat;
        data["discount"] = this.discount;
        data["total"] = this.total;
        data["tenantId"] = this.tenantId;
        data["invoiceTypeCode"] = this.invoiceTypeCode;
        data["statusId"] = this.statusId;
        data["reportingStatusId"] = this.reportingStatusId;
        data["tenantName"] = this.tenantName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IZatcaTransactionReportDto {
    storeCode: string;
    storeName: string;
    date: moment.Moment;
    dateTxt: string;
    recieptNumber: string;
    subTotal: number;
    vat: number;
    discount: number;
    total: number;
    tenantId: number;
    invoiceTypeCode: string;
    statusId: number;
    reportingStatusId: number;
    tenantName: string;
    id: string;
}

export enum TransactionType2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum IncomeStatisticsDateInterval {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum IncomeStatisticsDateInterval2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum ItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum State {
    _0 = 0, 
    _1 = 1, 
}

export enum WorkFlowType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum WorkFlowType2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CloseShiftMethod {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DatePeriod {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum DatePeriod2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum MaterRecipeType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum SalesSummaryDatePeriod {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum TenantsAsyncTables {
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
    _10 = 10, 
    _11 = 11, 
    _12 = 12, 
    _13 = 13, 
    _14 = 14, 
    _15 = 15, 
    _16 = 16, 
    _17 = 17, 
    _18 = 18, 
    _19 = 19, 
    _20 = 20, 
    _21 = 21, 
    _22 = 22, 
    _23 = 23, 
    _24 = 24, 
    _25 = 25, 
    _26 = 26, 
    _27 = 27, 
    _28 = 28, 
    _29 = 29, 
    _30 = 30, 
    _31 = 31, 
    _32 = 32, 
    _33 = 33, 
    _34 = 34, 
    _35 = 35, 
    _36 = 36, 
    _37 = 37, 
    _38 = 38, 
    _39 = 39, 
    _40 = 40, 
    _41 = 41, 
    _42 = 42, 
    _43 = 43, 
    _44 = 44, 
    _45 = 45, 
    _46 = 46, 
    _47 = 47, 
    _48 = 48, 
    _49 = 49, 
    _50 = 50, 
    _51 = 51, 
    _52 = 52, 
    _53 = 53, 
    _54 = 54, 
    _55 = 55, 
    _56 = 56, 
    _57 = 57, 
    _58 = 58, 
    _59 = 59, 
    _60 = 60, 
    _61 = 61, 
}

export enum DefaultTimezoneScope {
    _1 = 1, 
    _2 = 2, 
    _4 = 4, 
    _7 = 7, 
}

export enum WorkFlowType3 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum Anonymous {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum Anonymous2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum IsTenantAvailableOutputState {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum ApprovalWorkflowListItemTransactionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum ApprovalWorkflowDtoTransactionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum SaveApprovalWorkflowInputTransactionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
}

export enum DetailTransactionItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DetailTransactionUnitType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RawMaterialDtoItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FriendDtoState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoSide {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReceiverReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum TenantDeviceDtoPresenceState {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum EndOfDayInfoDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum DetailTransactionIntegrationDtoItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DetailTransactionIntegrationDtoUnitType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum MaterialListItemItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CheckInstallResponseInfoMessage {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum Login_InputDtoUserType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum UserResponseInfoMessage {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
}

export enum CashierShiftMobileStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum UserNotificationState {
    _0 = 0, 
    _1 = 1, 
}

export enum TenantNotificationSeverity {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum OfferDtoOfferType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferDtoItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferExcludeDtoItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum WorkFlowTypeItemDtoType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export class AdditionalData implements IAdditionalData {
    paypal: { [key: string] : string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (let key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        return data; 
    }
}

export interface IAdditionalData {
    paypal: { [key: string] : string; };
}

export enum CreatePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreatePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum CreatePaymentDtoSubscriptionPaymentGatewayType {
    _1 = 1, 
}

export enum ExecutePaymentDtoGateway {
    _1 = 1, 
}

export enum ExecutePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum ExecutePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum PromotionDtoPromotionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum PromotionDtoItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum PromotionDtoValueType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum PromotionDetailsDtoItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum PromotionFBDtoPromotionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum PromotionFBDtoTemplateType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum PromotionFBDtoValueType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum PromotionDetailsFBDtoItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum PromotionFBAdditionalFreeItemDtoItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum PromotionFBItemDtoItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum RawMaterialListItemItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ValueTupleOfRawMaterialListItemAndPeriodTypeItem2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreateRawMaterialInputItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UpdateRawMaterialInputItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CompareSalesInputDatePeriod {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum CustomerSalesDTOStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _6 = 6, 
}

export enum SupervisorShiftDetailsDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum CashierShiftDetailDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum OfferDetailReportInputOfferType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RawMaterialRecipeReportDtoMaterRecipeType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ProductCardDtoOperationType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum ProductMovementDtoOperationType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum PromotionByTimeReportFilterDtoTimeUnits {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum ShortOverReportInputCloseShiftMethod {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ShortOverDetailsReportInputCloseShiftMethod {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum SaleDtoTemplateType {
    _1 = 1, 
    _2 = 2, 
}

export enum TransactionDtoStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _6 = 6, 
}

export enum TransactionDtoTemplateType {
    _1 = 1, 
    _2 = 2, 
}

export enum TransactionDetailDtoOffertype {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferDetailReportDtoOfferTypeValue {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferDetailReportDtoItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum SaleTypeDTOSaleNatural {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateSaleTypeInputSaleNatural {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum EditSaleTypeInputSaleNatural {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum TenantLoginInfoDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum SupervisorShiftDtoStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum StoreRecordSaleNatural {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum PromotionsFBRecordPromotionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum PromotionsFBRecordTemplateType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum PromotionsFBRecordValueType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum PromotionFBItemRecordItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum PromotionDetailsFBRecordItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum OfferRecordOfferType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferRecordItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferExcludeRecordItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferStoreRecordStoreType {
    _0 = 0, 
    _1 = 1, 
}

export enum TenderTypeMasterDtoNature {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum VariantRecordPricingRule {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum SupervisorShiftsRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum PromotionFBAdditionalFreeItemRecordItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum DaysWorkingHourRecordDayOfWeek {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum SaleTypeRecordSaleNatural {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RegisterTenantInputSubscriptionStartType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RegisterTenantInputGateway {
    _1 = 1, 
}

export enum CreateTenderTypeMasterInputNature {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum UpdateTenderTypeMasterInputNature {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum ThemeDtoFontSizeUnit {
    _1 = 1, 
    _2 = 2, 
}

export enum ThemeDtoBackGroundType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ThemeDtoAdvertisementType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ThemeListItemFontSizeUnit {
    _1 = 1, 
    _2 = 2, 
}

export enum ThemeListItemBackGroundType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ThemeListItemDtoFontSizeUnit {
    _1 = 1, 
    _2 = 2, 
}

export enum ThemeListItemDtoBackGroundType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateThemeInputFontSizeUnit {
    _1 = 1, 
    _2 = 2, 
}

export enum CreateThemeInputBackGroundType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateThemeInputAdvertisementType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UpdateThemeInputFontSizeUnit {
    _1 = 1, 
    _2 = 2, 
}

export enum UpdateThemeInputBackGroundType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UpdateThemeInputAdvertisementType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum DeviceAuthenticateResultModelDeviceType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
    _10 = 10, 
    _11 = 11, 
    _12 = 12, 
    _13 = 13, 
    _14 = 14, 
    _15 = 15, 
}

export enum ValidationResultDeviceType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
    _10 = 10, 
    _11 = 11, 
    _12 = 12, 
    _13 = 13, 
    _14 = 14, 
    _15 = 15, 
}

export enum TransactionBackDtoStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _6 = 6, 
}

export enum TransactionBackDtoTemplateType {
    _1 = 1, 
    _2 = 2, 
}

export enum TransactionDetailBackDtoOffertype {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum DetailTransactionTemplateDtoItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum VariantDtoPricingRule {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreateVariantInputPricingRule {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum UpdateVariantInputPricingRule {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StoreStatus {
    _0 = 0, 
    _1 = 1, 
}

export enum RecipeTransactionSummaryTransactionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum SaleTransactionStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _6 = 6, 
}

export enum SaleTransactionTemplateType {
    _1 = 1, 
    _2 = 2, 
}

export enum PurchaseInvoiceApprovalStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum SaleTypeSaleNatural {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RawMaterialItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum RawMaterialConfigItemCost {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CustomerType {
    _1 = 1, 
    _2 = 2, 
}

export enum CashierShiftStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum SaleTransactionDetailOfferType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum EndOfDayDetailStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum StoreDayWorkingHoursDayOfWeek {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum PeriodType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum DetailTransactionEntityUnitType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum VariantPricingRule {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum SupervisorShiftStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum PromotionFBPromotionType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum PromotionFBTemplateType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum PromotionFBValueType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum OfferType2 {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum OfferItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum TenderTypePosMachine {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StockPeriodClosingDateStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StockPeriodClosingDatePeriodType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum PromotionFBItemItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum PromotionDetailsFBItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum TenderTypeMasterNature {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum PromotionFBStoreStoreType {
    _0 = 0, 
    _1 = 1, 
}

export enum PromotionFBAdditionalFreeItemItemType {
    _0 = 0, 
    _1 = 1, 
}

export enum OfferExcludeItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum StockPeriodPeriodType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = function() { 
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob); 
        }
    });
}


// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxies.ts